
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("2hRE7", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1502V"));

});
parcelRegister("1502V", function(module, exports) {
$parcel$export(module.exports, "Children", () => $0c964b402516ee80$export$dca3b0875bd9a954, (v) => $0c964b402516ee80$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $0c964b402516ee80$export$16fa2f45be04daa8, (v) => $0c964b402516ee80$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $0c964b402516ee80$export$ffb0004e005737fa, (v) => $0c964b402516ee80$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $0c964b402516ee80$export$e2c29f18771995cb, (v) => $0c964b402516ee80$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $0c964b402516ee80$export$221d75b3f55bb0bd, (v) => $0c964b402516ee80$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $0c964b402516ee80$export$5f8d39834fd61797, (v) => $0c964b402516ee80$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $0c964b402516ee80$export$74bf444e3cd11ea5, (v) => $0c964b402516ee80$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0c964b402516ee80$export$ae55be85d98224ed, (v) => $0c964b402516ee80$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $0c964b402516ee80$export$3ba232387fd5d6dd, (v) => $0c964b402516ee80$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $0c964b402516ee80$export$e530037191fcd5d7, (v) => $0c964b402516ee80$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $0c964b402516ee80$export$fd42f52fd3ae1109, (v) => $0c964b402516ee80$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $0c964b402516ee80$export$c8a8987d4410bf2d, (v) => $0c964b402516ee80$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $0c964b402516ee80$export$d38cd72104c1f0e9, (v) => $0c964b402516ee80$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $0c964b402516ee80$export$7d1e3a5e95ceca43, (v) => $0c964b402516ee80$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $0c964b402516ee80$export$257a8862b851cb5b, (v) => $0c964b402516ee80$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $0c964b402516ee80$export$a8257692ac88316c, (v) => $0c964b402516ee80$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $0c964b402516ee80$export$488013bae63b21da, (v) => $0c964b402516ee80$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $0c964b402516ee80$export$7c73462e0d25e514, (v) => $0c964b402516ee80$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $0c964b402516ee80$export$7568632d0d33d16d, (v) => $0c964b402516ee80$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $0c964b402516ee80$export$88948ce120ea2619, (v) => $0c964b402516ee80$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $0c964b402516ee80$export$35808ee640e87ca7, (v) => $0c964b402516ee80$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $0c964b402516ee80$export$fae74005e78b1a27, (v) => $0c964b402516ee80$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $0c964b402516ee80$export$dc8fbce3eb94dc1e, (v) => $0c964b402516ee80$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $0c964b402516ee80$export$6a7bc4e911dc01cf, (v) => $0c964b402516ee80$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $0c964b402516ee80$export$6d9c69b0de29b591, (v) => $0c964b402516ee80$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $0c964b402516ee80$export$f680877a34711e37, (v) => $0c964b402516ee80$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $0c964b402516ee80$export$d5a552a76deda3c2, (v) => $0c964b402516ee80$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $0c964b402516ee80$export$aaabe4eda9ed9969, (v) => $0c964b402516ee80$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $0c964b402516ee80$export$e5c5a5f917a5871c, (v) => $0c964b402516ee80$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $0c964b402516ee80$export$1538c33de8887b59, (v) => $0c964b402516ee80$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $0c964b402516ee80$export$13e3392192263954, (v) => $0c964b402516ee80$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $0c964b402516ee80$export$b8f5890fc79d6aca, (v) => $0c964b402516ee80$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $0c964b402516ee80$export$60241385465d0a34, (v) => $0c964b402516ee80$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $0c964b402516ee80$export$306c0aa65ff9ec16, (v) => $0c964b402516ee80$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $0c964b402516ee80$export$7b286972b8d8ccbf, (v) => $0c964b402516ee80$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $0c964b402516ee80$export$83d89fbfd8236492, (v) => $0c964b402516ee80$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0c964b402516ee80$export$dca3b0875bd9a954;
var $0c964b402516ee80$export$16fa2f45be04daa8;
var $0c964b402516ee80$export$ffb0004e005737fa;
var $0c964b402516ee80$export$e2c29f18771995cb;
var $0c964b402516ee80$export$221d75b3f55bb0bd;
var $0c964b402516ee80$export$5f8d39834fd61797;
var $0c964b402516ee80$export$74bf444e3cd11ea5;
var $0c964b402516ee80$export$ae55be85d98224ed;
var $0c964b402516ee80$export$3ba232387fd5d6dd;
var $0c964b402516ee80$export$e530037191fcd5d7;
var $0c964b402516ee80$export$fd42f52fd3ae1109;
var $0c964b402516ee80$export$c8a8987d4410bf2d;
var $0c964b402516ee80$export$d38cd72104c1f0e9;
var $0c964b402516ee80$export$7d1e3a5e95ceca43;
var $0c964b402516ee80$export$257a8862b851cb5b;
var $0c964b402516ee80$export$a8257692ac88316c;
var $0c964b402516ee80$export$488013bae63b21da;
var $0c964b402516ee80$export$7c73462e0d25e514;
var $0c964b402516ee80$export$7568632d0d33d16d;
var $0c964b402516ee80$export$88948ce120ea2619;
var $0c964b402516ee80$export$35808ee640e87ca7;
var $0c964b402516ee80$export$fae74005e78b1a27;
var $0c964b402516ee80$export$dc8fbce3eb94dc1e;
var $0c964b402516ee80$export$6a7bc4e911dc01cf;
var $0c964b402516ee80$export$6d9c69b0de29b591;
var $0c964b402516ee80$export$f680877a34711e37;
var $0c964b402516ee80$export$d5a552a76deda3c2;
var $0c964b402516ee80$export$aaabe4eda9ed9969;
var $0c964b402516ee80$export$e5c5a5f917a5871c;
var $0c964b402516ee80$export$1538c33de8887b59;
var $0c964b402516ee80$export$13e3392192263954;
var $0c964b402516ee80$export$b8f5890fc79d6aca;
var $0c964b402516ee80$export$60241385465d0a34;
var $0c964b402516ee80$export$306c0aa65ff9ec16;
var $0c964b402516ee80$export$7b286972b8d8ccbf;
var $0c964b402516ee80$export$83d89fbfd8236492;
'use strict';
var $0c964b402516ee80$var$l = Symbol.for("react.element"), $0c964b402516ee80$var$n = Symbol.for("react.portal"), $0c964b402516ee80$var$p = Symbol.for("react.fragment"), $0c964b402516ee80$var$q = Symbol.for("react.strict_mode"), $0c964b402516ee80$var$r = Symbol.for("react.profiler"), $0c964b402516ee80$var$t = Symbol.for("react.provider"), $0c964b402516ee80$var$u = Symbol.for("react.context"), $0c964b402516ee80$var$v = Symbol.for("react.forward_ref"), $0c964b402516ee80$var$w = Symbol.for("react.suspense"), $0c964b402516ee80$var$x = Symbol.for("react.memo"), $0c964b402516ee80$var$y = Symbol.for("react.lazy"), $0c964b402516ee80$var$z = Symbol.iterator;
function $0c964b402516ee80$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0c964b402516ee80$var$z && a[$0c964b402516ee80$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0c964b402516ee80$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0c964b402516ee80$var$C = Object.assign, $0c964b402516ee80$var$D = {};
function $0c964b402516ee80$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0c964b402516ee80$var$D;
    this.updater = e || $0c964b402516ee80$var$B;
}
$0c964b402516ee80$var$E.prototype.isReactComponent = {};
$0c964b402516ee80$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$0c964b402516ee80$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $0c964b402516ee80$var$F() {}
$0c964b402516ee80$var$F.prototype = $0c964b402516ee80$var$E.prototype;
function $0c964b402516ee80$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0c964b402516ee80$var$D;
    this.updater = e || $0c964b402516ee80$var$B;
}
var $0c964b402516ee80$var$H = $0c964b402516ee80$var$G.prototype = new $0c964b402516ee80$var$F;
$0c964b402516ee80$var$H.constructor = $0c964b402516ee80$var$G;
$0c964b402516ee80$var$C($0c964b402516ee80$var$H, $0c964b402516ee80$var$E.prototype);
$0c964b402516ee80$var$H.isPureReactComponent = !0;
var $0c964b402516ee80$var$I = Array.isArray, $0c964b402516ee80$var$J = Object.prototype.hasOwnProperty, $0c964b402516ee80$var$K = {
    current: null
}, $0c964b402516ee80$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0c964b402516ee80$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$0c964b402516ee80$var$J.call(b, d) && !$0c964b402516ee80$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $0c964b402516ee80$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $0c964b402516ee80$var$K.current
    };
}
function $0c964b402516ee80$var$N(a, b) {
    return {
        $$typeof: $0c964b402516ee80$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $0c964b402516ee80$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0c964b402516ee80$var$l;
}
function $0c964b402516ee80$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $0c964b402516ee80$var$P = /\/+/g;
function $0c964b402516ee80$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $0c964b402516ee80$var$escape("" + a.key) : b.toString(36);
}
function $0c964b402516ee80$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $0c964b402516ee80$var$l:
                case $0c964b402516ee80$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $0c964b402516ee80$var$Q(h, 0) : d, $0c964b402516ee80$var$I(c) ? (e = "", null != a && (e = a.replace($0c964b402516ee80$var$P, "$&/") + "/"), $0c964b402516ee80$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($0c964b402516ee80$var$O(c) && (c = $0c964b402516ee80$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($0c964b402516ee80$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($0c964b402516ee80$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $0c964b402516ee80$var$Q(k, g);
        h += $0c964b402516ee80$var$R(k, b, e, f, c);
    }
    else if (f = $0c964b402516ee80$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $0c964b402516ee80$var$Q(k, g++), h += $0c964b402516ee80$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $0c964b402516ee80$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $0c964b402516ee80$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $0c964b402516ee80$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $0c964b402516ee80$var$U = {
    current: null
}, $0c964b402516ee80$var$V = {
    transition: null
}, $0c964b402516ee80$var$W = {
    ReactCurrentDispatcher: $0c964b402516ee80$var$U,
    ReactCurrentBatchConfig: $0c964b402516ee80$var$V,
    ReactCurrentOwner: $0c964b402516ee80$var$K
};
function $0c964b402516ee80$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$0c964b402516ee80$export$dca3b0875bd9a954 = {
    map: $0c964b402516ee80$var$S,
    forEach: function(a, b, e) {
        $0c964b402516ee80$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $0c964b402516ee80$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $0c964b402516ee80$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$0c964b402516ee80$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$0c964b402516ee80$export$16fa2f45be04daa8 = $0c964b402516ee80$var$E;
$0c964b402516ee80$export$ffb0004e005737fa = $0c964b402516ee80$var$p;
$0c964b402516ee80$export$e2c29f18771995cb = $0c964b402516ee80$var$r;
$0c964b402516ee80$export$221d75b3f55bb0bd = $0c964b402516ee80$var$G;
$0c964b402516ee80$export$5f8d39834fd61797 = $0c964b402516ee80$var$q;
$0c964b402516ee80$export$74bf444e3cd11ea5 = $0c964b402516ee80$var$w;
$0c964b402516ee80$export$ae55be85d98224ed = $0c964b402516ee80$var$W;
$0c964b402516ee80$export$3ba232387fd5d6dd = $0c964b402516ee80$var$X;
$0c964b402516ee80$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $0c964b402516ee80$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $0c964b402516ee80$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$0c964b402516ee80$var$J.call(b, f) && !$0c964b402516ee80$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $0c964b402516ee80$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$0c964b402516ee80$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $0c964b402516ee80$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $0c964b402516ee80$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$0c964b402516ee80$export$c8a8987d4410bf2d = $0c964b402516ee80$var$M;
$0c964b402516ee80$export$d38cd72104c1f0e9 = function(a) {
    var b = $0c964b402516ee80$var$M.bind(null, a);
    b.type = a;
    return b;
};
$0c964b402516ee80$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0c964b402516ee80$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $0c964b402516ee80$var$v,
        render: a
    };
};
$0c964b402516ee80$export$a8257692ac88316c = $0c964b402516ee80$var$O;
$0c964b402516ee80$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $0c964b402516ee80$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $0c964b402516ee80$var$T
    };
};
$0c964b402516ee80$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $0c964b402516ee80$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$0c964b402516ee80$export$7568632d0d33d16d = function(a) {
    var b = $0c964b402516ee80$var$V.transition;
    $0c964b402516ee80$var$V.transition = {};
    try {
        a();
    } finally{
        $0c964b402516ee80$var$V.transition = b;
    }
};
$0c964b402516ee80$export$88948ce120ea2619 = $0c964b402516ee80$var$X;
$0c964b402516ee80$export$35808ee640e87ca7 = function(a, b) {
    return $0c964b402516ee80$var$U.current.useCallback(a, b);
};
$0c964b402516ee80$export$fae74005e78b1a27 = function(a) {
    return $0c964b402516ee80$var$U.current.useContext(a);
};
$0c964b402516ee80$export$dc8fbce3eb94dc1e = function() {};
$0c964b402516ee80$export$6a7bc4e911dc01cf = function(a) {
    return $0c964b402516ee80$var$U.current.useDeferredValue(a);
};
$0c964b402516ee80$export$6d9c69b0de29b591 = function(a, b) {
    return $0c964b402516ee80$var$U.current.useEffect(a, b);
};
$0c964b402516ee80$export$f680877a34711e37 = function() {
    return $0c964b402516ee80$var$U.current.useId();
};
$0c964b402516ee80$export$d5a552a76deda3c2 = function(a, b, e) {
    return $0c964b402516ee80$var$U.current.useImperativeHandle(a, b, e);
};
$0c964b402516ee80$export$aaabe4eda9ed9969 = function(a, b) {
    return $0c964b402516ee80$var$U.current.useInsertionEffect(a, b);
};
$0c964b402516ee80$export$e5c5a5f917a5871c = function(a, b) {
    return $0c964b402516ee80$var$U.current.useLayoutEffect(a, b);
};
$0c964b402516ee80$export$1538c33de8887b59 = function(a, b) {
    return $0c964b402516ee80$var$U.current.useMemo(a, b);
};
$0c964b402516ee80$export$13e3392192263954 = function(a, b, e) {
    return $0c964b402516ee80$var$U.current.useReducer(a, b, e);
};
$0c964b402516ee80$export$b8f5890fc79d6aca = function(a) {
    return $0c964b402516ee80$var$U.current.useRef(a);
};
$0c964b402516ee80$export$60241385465d0a34 = function(a) {
    return $0c964b402516ee80$var$U.current.useState(a);
};
$0c964b402516ee80$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $0c964b402516ee80$var$U.current.useSyncExternalStore(a, b, e);
};
$0c964b402516ee80$export$7b286972b8d8ccbf = function() {
    return $0c964b402516ee80$var$U.current.useTransition();
};
$0c964b402516ee80$export$83d89fbfd8236492 = "18.3.1";

});


parcelRegister("507zh", function(module, exports) {
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $3a42d2aab3654c46$export$ae55be85d98224ed, (v) => $3a42d2aab3654c46$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $3a42d2aab3654c46$export$d39a5bbd09211389, (v) => $3a42d2aab3654c46$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $3a42d2aab3654c46$export$882461b6382ed46c, (v) => $3a42d2aab3654c46$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $3a42d2aab3654c46$export$466bfc07425424d5, (v) => $3a42d2aab3654c46$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $3a42d2aab3654c46$export$cd75ccfd720a3cd4, (v) => $3a42d2aab3654c46$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $3a42d2aab3654c46$export$fa8d919ba61d84db, (v) => $3a42d2aab3654c46$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $3a42d2aab3654c46$export$757ceba2d55c277e, (v) => $3a42d2aab3654c46$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $3a42d2aab3654c46$export$b3890eb0ae9dca99, (v) => $3a42d2aab3654c46$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $3a42d2aab3654c46$export$502457920280e6be, (v) => $3a42d2aab3654c46$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $3a42d2aab3654c46$export$c78a37762a8d58e1, (v) => $3a42d2aab3654c46$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $3a42d2aab3654c46$export$dc54d992c10e8a18, (v) => $3a42d2aab3654c46$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $3a42d2aab3654c46$export$83d89fbfd8236492, (v) => $3a42d2aab3654c46$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3a42d2aab3654c46$export$ae55be85d98224ed;
var $3a42d2aab3654c46$export$d39a5bbd09211389;
var $3a42d2aab3654c46$export$882461b6382ed46c;
var $3a42d2aab3654c46$export$466bfc07425424d5;
var $3a42d2aab3654c46$export$cd75ccfd720a3cd4;
var $3a42d2aab3654c46$export$fa8d919ba61d84db;
var $3a42d2aab3654c46$export$757ceba2d55c277e;
var $3a42d2aab3654c46$export$b3890eb0ae9dca99;
var $3a42d2aab3654c46$export$502457920280e6be;
var $3a42d2aab3654c46$export$c78a37762a8d58e1;
var $3a42d2aab3654c46$export$dc54d992c10e8a18;
var $3a42d2aab3654c46$export$83d89fbfd8236492;
'use strict';
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $2hRE7 = parcelRequire("2hRE7");

var $iZu5g = parcelRequire("iZu5g");
function $3a42d2aab3654c46$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $3a42d2aab3654c46$var$da = new Set, $3a42d2aab3654c46$var$ea = {};
function $3a42d2aab3654c46$var$fa(a, b) {
    $3a42d2aab3654c46$var$ha(a, b);
    $3a42d2aab3654c46$var$ha(a + "Capture", b);
}
function $3a42d2aab3654c46$var$ha(a, b) {
    $3a42d2aab3654c46$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$3a42d2aab3654c46$var$da.add(b[a]);
}
var $3a42d2aab3654c46$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $3a42d2aab3654c46$var$ja = Object.prototype.hasOwnProperty, $3a42d2aab3654c46$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $3a42d2aab3654c46$var$la = {}, $3a42d2aab3654c46$var$ma = {};
function $3a42d2aab3654c46$var$na(a) {
    if ($3a42d2aab3654c46$var$ja.call($3a42d2aab3654c46$var$ma, a)) return !0;
    if ($3a42d2aab3654c46$var$ja.call($3a42d2aab3654c46$var$la, a)) return !1;
    if ($3a42d2aab3654c46$var$ka.test(a)) return $3a42d2aab3654c46$var$ma[a] = !0;
    $3a42d2aab3654c46$var$la[a] = !0;
    return !1;
}
function $3a42d2aab3654c46$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $3a42d2aab3654c46$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $3a42d2aab3654c46$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $3a42d2aab3654c46$var$qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $3a42d2aab3654c46$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $3a42d2aab3654c46$var$t[a] = new $3a42d2aab3654c46$var$qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $3a42d2aab3654c46$var$t[b] = new $3a42d2aab3654c46$var$qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $3a42d2aab3654c46$var$t[a] = new $3a42d2aab3654c46$var$qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $3a42d2aab3654c46$var$t[a] = new $3a42d2aab3654c46$var$qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $3a42d2aab3654c46$var$t[a] = new $3a42d2aab3654c46$var$qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $3a42d2aab3654c46$var$t[a] = new $3a42d2aab3654c46$var$qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $3a42d2aab3654c46$var$t[a] = new $3a42d2aab3654c46$var$qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $3a42d2aab3654c46$var$t[a] = new $3a42d2aab3654c46$var$qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $3a42d2aab3654c46$var$t[a] = new $3a42d2aab3654c46$var$qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $3a42d2aab3654c46$var$ra = /[\-:]([a-z])/g;
function $3a42d2aab3654c46$var$ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($3a42d2aab3654c46$var$ra, $3a42d2aab3654c46$var$ta);
    $3a42d2aab3654c46$var$t[b] = new $3a42d2aab3654c46$var$qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($3a42d2aab3654c46$var$ra, $3a42d2aab3654c46$var$ta);
    $3a42d2aab3654c46$var$t[b] = new $3a42d2aab3654c46$var$qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($3a42d2aab3654c46$var$ra, $3a42d2aab3654c46$var$ta);
    $3a42d2aab3654c46$var$t[b] = new $3a42d2aab3654c46$var$qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $3a42d2aab3654c46$var$t[a] = new $3a42d2aab3654c46$var$qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$3a42d2aab3654c46$var$t.xlinkHref = new $3a42d2aab3654c46$var$qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $3a42d2aab3654c46$var$t[a] = new $3a42d2aab3654c46$var$qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $3a42d2aab3654c46$var$ua(a, b, c, d) {
    var e = $3a42d2aab3654c46$var$t.hasOwnProperty(b) ? $3a42d2aab3654c46$var$t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $3a42d2aab3654c46$var$pa(b, c, e, d) && (c = null), d || null === e ? $3a42d2aab3654c46$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $3a42d2aab3654c46$var$va = $2hRE7.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $3a42d2aab3654c46$var$wa = Symbol.for("react.element"), $3a42d2aab3654c46$var$xa = Symbol.for("react.portal"), $3a42d2aab3654c46$var$ya = Symbol.for("react.fragment"), $3a42d2aab3654c46$var$za = Symbol.for("react.strict_mode"), $3a42d2aab3654c46$var$Aa = Symbol.for("react.profiler"), $3a42d2aab3654c46$var$Ba = Symbol.for("react.provider"), $3a42d2aab3654c46$var$Ca = Symbol.for("react.context"), $3a42d2aab3654c46$var$Da = Symbol.for("react.forward_ref"), $3a42d2aab3654c46$var$Ea = Symbol.for("react.suspense"), $3a42d2aab3654c46$var$Fa = Symbol.for("react.suspense_list"), $3a42d2aab3654c46$var$Ga = Symbol.for("react.memo"), $3a42d2aab3654c46$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $3a42d2aab3654c46$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $3a42d2aab3654c46$var$Ja = Symbol.iterator;
function $3a42d2aab3654c46$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $3a42d2aab3654c46$var$Ja && a[$3a42d2aab3654c46$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $3a42d2aab3654c46$var$u = Object.assign, $3a42d2aab3654c46$var$La;
function $3a42d2aab3654c46$var$Ma(a) {
    if (void 0 === $3a42d2aab3654c46$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $3a42d2aab3654c46$var$La = b && b[1] || "";
    }
    return "\n" + $3a42d2aab3654c46$var$La + a;
}
var $3a42d2aab3654c46$var$Na = !1;
function $3a42d2aab3654c46$var$Oa(a, b) {
    if (!a || $3a42d2aab3654c46$var$Na) return "";
    $3a42d2aab3654c46$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $3a42d2aab3654c46$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $3a42d2aab3654c46$var$Ma(a) : "";
}
function $3a42d2aab3654c46$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $3a42d2aab3654c46$var$Ma(a.type);
        case 16:
            return $3a42d2aab3654c46$var$Ma("Lazy");
        case 13:
            return $3a42d2aab3654c46$var$Ma("Suspense");
        case 19:
            return $3a42d2aab3654c46$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $3a42d2aab3654c46$var$Oa(a.type, !1), a;
        case 11:
            return a = $3a42d2aab3654c46$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $3a42d2aab3654c46$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $3a42d2aab3654c46$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $3a42d2aab3654c46$var$ya:
            return "Fragment";
        case $3a42d2aab3654c46$var$xa:
            return "Portal";
        case $3a42d2aab3654c46$var$Aa:
            return "Profiler";
        case $3a42d2aab3654c46$var$za:
            return "StrictMode";
        case $3a42d2aab3654c46$var$Ea:
            return "Suspense";
        case $3a42d2aab3654c46$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $3a42d2aab3654c46$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $3a42d2aab3654c46$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $3a42d2aab3654c46$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $3a42d2aab3654c46$var$Ga:
            return b = a.displayName || null, null !== b ? b : $3a42d2aab3654c46$var$Qa(a.type) || "Memo";
        case $3a42d2aab3654c46$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $3a42d2aab3654c46$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $3a42d2aab3654c46$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $3a42d2aab3654c46$var$Qa(b);
        case 8:
            return b === $3a42d2aab3654c46$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $3a42d2aab3654c46$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $3a42d2aab3654c46$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $3a42d2aab3654c46$var$Ua(a) {
    var b = $3a42d2aab3654c46$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $3a42d2aab3654c46$var$Va(a) {
    a._valueTracker || (a._valueTracker = $3a42d2aab3654c46$var$Ua(a));
}
function $3a42d2aab3654c46$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $3a42d2aab3654c46$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $3a42d2aab3654c46$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $3a42d2aab3654c46$var$Ya(a, b) {
    var c = b.checked;
    return $3a42d2aab3654c46$var$u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $3a42d2aab3654c46$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $3a42d2aab3654c46$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $3a42d2aab3654c46$var$$a(a, b) {
    b = b.checked;
    null != b && $3a42d2aab3654c46$var$ua(a, "checked", b, !1);
}
function $3a42d2aab3654c46$var$ab(a, b) {
    $3a42d2aab3654c46$var$$a(a, b);
    var c = $3a42d2aab3654c46$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $3a42d2aab3654c46$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $3a42d2aab3654c46$var$bb(a, b.type, $3a42d2aab3654c46$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $3a42d2aab3654c46$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $3a42d2aab3654c46$var$bb(a, b, c) {
    if ("number" !== b || $3a42d2aab3654c46$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $3a42d2aab3654c46$var$db = Array.isArray;
function $3a42d2aab3654c46$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $3a42d2aab3654c46$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $3a42d2aab3654c46$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($3a42d2aab3654c46$var$p(91));
    return $3a42d2aab3654c46$var$u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $3a42d2aab3654c46$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($3a42d2aab3654c46$var$p(92));
            if ($3a42d2aab3654c46$var$db(c)) {
                if (1 < c.length) throw Error($3a42d2aab3654c46$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $3a42d2aab3654c46$var$Sa(c)
    };
}
function $3a42d2aab3654c46$var$hb(a, b) {
    var c = $3a42d2aab3654c46$var$Sa(b.value), d = $3a42d2aab3654c46$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $3a42d2aab3654c46$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $3a42d2aab3654c46$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $3a42d2aab3654c46$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $3a42d2aab3654c46$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $3a42d2aab3654c46$var$mb, $3a42d2aab3654c46$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $3a42d2aab3654c46$var$mb = $3a42d2aab3654c46$var$mb || document.createElement("div");
        $3a42d2aab3654c46$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $3a42d2aab3654c46$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $3a42d2aab3654c46$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $3a42d2aab3654c46$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $3a42d2aab3654c46$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($3a42d2aab3654c46$var$pb).forEach(function(a) {
    $3a42d2aab3654c46$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $3a42d2aab3654c46$var$pb[b] = $3a42d2aab3654c46$var$pb[a];
    });
});
function $3a42d2aab3654c46$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $3a42d2aab3654c46$var$pb.hasOwnProperty(a) && $3a42d2aab3654c46$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $3a42d2aab3654c46$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $3a42d2aab3654c46$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $3a42d2aab3654c46$var$tb = $3a42d2aab3654c46$var$u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $3a42d2aab3654c46$var$ub(a, b) {
    if (b) {
        if ($3a42d2aab3654c46$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($3a42d2aab3654c46$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($3a42d2aab3654c46$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($3a42d2aab3654c46$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($3a42d2aab3654c46$var$p(62));
    }
}
function $3a42d2aab3654c46$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $3a42d2aab3654c46$var$wb = null;
function $3a42d2aab3654c46$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $3a42d2aab3654c46$var$yb = null, $3a42d2aab3654c46$var$zb = null, $3a42d2aab3654c46$var$Ab = null;
function $3a42d2aab3654c46$var$Bb(a) {
    if (a = $3a42d2aab3654c46$var$Cb(a)) {
        if ("function" !== typeof $3a42d2aab3654c46$var$yb) throw Error($3a42d2aab3654c46$var$p(280));
        var b = a.stateNode;
        b && (b = $3a42d2aab3654c46$var$Db(b), $3a42d2aab3654c46$var$yb(a.stateNode, a.type, b));
    }
}
function $3a42d2aab3654c46$var$Eb(a) {
    $3a42d2aab3654c46$var$zb ? $3a42d2aab3654c46$var$Ab ? $3a42d2aab3654c46$var$Ab.push(a) : $3a42d2aab3654c46$var$Ab = [
        a
    ] : $3a42d2aab3654c46$var$zb = a;
}
function $3a42d2aab3654c46$var$Fb() {
    if ($3a42d2aab3654c46$var$zb) {
        var a = $3a42d2aab3654c46$var$zb, b = $3a42d2aab3654c46$var$Ab;
        $3a42d2aab3654c46$var$Ab = $3a42d2aab3654c46$var$zb = null;
        $3a42d2aab3654c46$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$3a42d2aab3654c46$var$Bb(b[a]);
    }
}
function $3a42d2aab3654c46$var$Gb(a, b) {
    return a(b);
}
function $3a42d2aab3654c46$var$Hb() {}
var $3a42d2aab3654c46$var$Ib = !1;
function $3a42d2aab3654c46$var$Jb(a, b, c) {
    if ($3a42d2aab3654c46$var$Ib) return a(b, c);
    $3a42d2aab3654c46$var$Ib = !0;
    try {
        return $3a42d2aab3654c46$var$Gb(a, b, c);
    } finally{
        if ($3a42d2aab3654c46$var$Ib = !1, null !== $3a42d2aab3654c46$var$zb || null !== $3a42d2aab3654c46$var$Ab) $3a42d2aab3654c46$var$Hb(), $3a42d2aab3654c46$var$Fb();
    }
}
function $3a42d2aab3654c46$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $3a42d2aab3654c46$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($3a42d2aab3654c46$var$p(231, b, typeof c));
    return c;
}
var $3a42d2aab3654c46$var$Lb = !1;
if ($3a42d2aab3654c46$var$ia) try {
    var $3a42d2aab3654c46$var$Mb = {};
    Object.defineProperty($3a42d2aab3654c46$var$Mb, "passive", {
        get: function() {
            $3a42d2aab3654c46$var$Lb = !0;
        }
    });
    window.addEventListener("test", $3a42d2aab3654c46$var$Mb, $3a42d2aab3654c46$var$Mb);
    window.removeEventListener("test", $3a42d2aab3654c46$var$Mb, $3a42d2aab3654c46$var$Mb);
} catch (a) {
    $3a42d2aab3654c46$var$Lb = !1;
}
function $3a42d2aab3654c46$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $3a42d2aab3654c46$var$Ob = !1, $3a42d2aab3654c46$var$Pb = null, $3a42d2aab3654c46$var$Qb = !1, $3a42d2aab3654c46$var$Rb = null, $3a42d2aab3654c46$var$Sb = {
    onError: function(a) {
        $3a42d2aab3654c46$var$Ob = !0;
        $3a42d2aab3654c46$var$Pb = a;
    }
};
function $3a42d2aab3654c46$var$Tb(a, b, c, d, e, f, g, h, k) {
    $3a42d2aab3654c46$var$Ob = !1;
    $3a42d2aab3654c46$var$Pb = null;
    $3a42d2aab3654c46$var$Nb.apply($3a42d2aab3654c46$var$Sb, arguments);
}
function $3a42d2aab3654c46$var$Ub(a, b, c, d, e, f, g, h, k) {
    $3a42d2aab3654c46$var$Tb.apply(this, arguments);
    if ($3a42d2aab3654c46$var$Ob) {
        if ($3a42d2aab3654c46$var$Ob) {
            var l = $3a42d2aab3654c46$var$Pb;
            $3a42d2aab3654c46$var$Ob = !1;
            $3a42d2aab3654c46$var$Pb = null;
        } else throw Error($3a42d2aab3654c46$var$p(198));
        $3a42d2aab3654c46$var$Qb || ($3a42d2aab3654c46$var$Qb = !0, $3a42d2aab3654c46$var$Rb = l);
    }
}
function $3a42d2aab3654c46$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $3a42d2aab3654c46$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $3a42d2aab3654c46$var$Xb(a) {
    if ($3a42d2aab3654c46$var$Vb(a) !== a) throw Error($3a42d2aab3654c46$var$p(188));
}
function $3a42d2aab3654c46$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $3a42d2aab3654c46$var$Vb(a);
        if (null === b) throw Error($3a42d2aab3654c46$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $3a42d2aab3654c46$var$Xb(e), a;
                if (f === d) return $3a42d2aab3654c46$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($3a42d2aab3654c46$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($3a42d2aab3654c46$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($3a42d2aab3654c46$var$p(190));
    }
    if (3 !== c.tag) throw Error($3a42d2aab3654c46$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $3a42d2aab3654c46$var$Zb(a) {
    a = $3a42d2aab3654c46$var$Yb(a);
    return null !== a ? $3a42d2aab3654c46$var$$b(a) : null;
}
function $3a42d2aab3654c46$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $3a42d2aab3654c46$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $3a42d2aab3654c46$var$ac = $iZu5g.unstable_scheduleCallback, $3a42d2aab3654c46$var$bc = $iZu5g.unstable_cancelCallback, $3a42d2aab3654c46$var$cc = $iZu5g.unstable_shouldYield, $3a42d2aab3654c46$var$dc = $iZu5g.unstable_requestPaint, $3a42d2aab3654c46$var$A = $iZu5g.unstable_now, $3a42d2aab3654c46$var$ec = $iZu5g.unstable_getCurrentPriorityLevel, $3a42d2aab3654c46$var$fc = $iZu5g.unstable_ImmediatePriority, $3a42d2aab3654c46$var$gc = $iZu5g.unstable_UserBlockingPriority, $3a42d2aab3654c46$var$hc = $iZu5g.unstable_NormalPriority, $3a42d2aab3654c46$var$ic = $iZu5g.unstable_LowPriority, $3a42d2aab3654c46$var$jc = $iZu5g.unstable_IdlePriority, $3a42d2aab3654c46$var$kc = null, $3a42d2aab3654c46$var$lc = null, $3a42d2aab3654c46$var$B = null, $3a42d2aab3654c46$var$mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function $3a42d2aab3654c46$var$nc(a, b) {
    if ($3a42d2aab3654c46$var$lc && "function" === typeof $3a42d2aab3654c46$var$lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = $3a42d2aab3654c46$var$fc;
                break;
            case 4:
                d = $3a42d2aab3654c46$var$gc;
                break;
            case 16:
                d = $3a42d2aab3654c46$var$hc;
                break;
            case 536870912:
                d = $3a42d2aab3654c46$var$jc;
                break;
            default:
                d = $3a42d2aab3654c46$var$hc;
        }
        $3a42d2aab3654c46$var$lc.onCommitFiberRoot($3a42d2aab3654c46$var$kc, a, d, c);
    } catch (e) {}
}
function $3a42d2aab3654c46$var$oc(a) {
    $3a42d2aab3654c46$var$B = a;
}
function $3a42d2aab3654c46$var$pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = $3a42d2aab3654c46$var$qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function $3a42d2aab3654c46$var$rc() {
    null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markCommitStopped && $3a42d2aab3654c46$var$B.markCommitStopped();
}
function $3a42d2aab3654c46$var$sc(a) {
    null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markComponentRenderStarted && $3a42d2aab3654c46$var$B.markComponentRenderStarted(a);
}
function $3a42d2aab3654c46$var$tc() {
    null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markComponentRenderStopped && $3a42d2aab3654c46$var$B.markComponentRenderStopped();
}
function $3a42d2aab3654c46$var$uc(a) {
    null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markComponentLayoutEffectUnmountStarted && $3a42d2aab3654c46$var$B.markComponentLayoutEffectUnmountStarted(a);
}
function $3a42d2aab3654c46$var$vc() {
    null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markComponentLayoutEffectUnmountStopped && $3a42d2aab3654c46$var$B.markComponentLayoutEffectUnmountStopped();
}
function $3a42d2aab3654c46$var$wc(a) {
    null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markRenderStarted && $3a42d2aab3654c46$var$B.markRenderStarted(a);
}
function $3a42d2aab3654c46$var$xc() {
    null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markRenderStopped && $3a42d2aab3654c46$var$B.markRenderStopped();
}
function $3a42d2aab3654c46$var$yc(a, b) {
    null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markStateUpdateScheduled && $3a42d2aab3654c46$var$B.markStateUpdateScheduled(a, b);
}
var $3a42d2aab3654c46$var$Ac = Math.clz32 ? Math.clz32 : $3a42d2aab3654c46$var$zc, $3a42d2aab3654c46$var$Bc = Math.log, $3a42d2aab3654c46$var$Cc = Math.LN2;
function $3a42d2aab3654c46$var$zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($3a42d2aab3654c46$var$Bc(a) / $3a42d2aab3654c46$var$Cc | 0) | 0;
}
function $3a42d2aab3654c46$var$qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var $3a42d2aab3654c46$var$Dc = 64, $3a42d2aab3654c46$var$Ec = 4194304;
function $3a42d2aab3654c46$var$Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $3a42d2aab3654c46$var$Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $3a42d2aab3654c46$var$Fc(h) : (f &= g, 0 !== f && (d = $3a42d2aab3654c46$var$Fc(f)));
    } else g = c & ~e, 0 !== g ? d = $3a42d2aab3654c46$var$Fc(g) : 0 !== f && (d = $3a42d2aab3654c46$var$Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $3a42d2aab3654c46$var$Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $3a42d2aab3654c46$var$Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $3a42d2aab3654c46$var$Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $3a42d2aab3654c46$var$Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $3a42d2aab3654c46$var$Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $3a42d2aab3654c46$var$Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $3a42d2aab3654c46$var$Kc() {
    var a = $3a42d2aab3654c46$var$Dc;
    $3a42d2aab3654c46$var$Dc <<= 1;
    0 === ($3a42d2aab3654c46$var$Dc & 4194240) && ($3a42d2aab3654c46$var$Dc = 64);
    return a;
}
function $3a42d2aab3654c46$var$Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $3a42d2aab3654c46$var$Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $3a42d2aab3654c46$var$Ac(b);
    a[b] = c;
}
function $3a42d2aab3654c46$var$Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $3a42d2aab3654c46$var$Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $3a42d2aab3654c46$var$Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $3a42d2aab3654c46$var$Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function $3a42d2aab3654c46$var$Pc(a, b, c) {
    if ($3a42d2aab3654c46$var$mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - $3a42d2aab3654c46$var$Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function $3a42d2aab3654c46$var$Qc(a, b) {
    if ($3a42d2aab3654c46$var$mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - $3a42d2aab3654c46$var$Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var b = a.alternate;
            null !== b && d.has(b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var $3a42d2aab3654c46$var$E = 0;
function $3a42d2aab3654c46$var$Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $3a42d2aab3654c46$var$Sc, $3a42d2aab3654c46$var$Tc, $3a42d2aab3654c46$var$Uc, $3a42d2aab3654c46$var$Vc, $3a42d2aab3654c46$var$Wc, $3a42d2aab3654c46$var$Xc = !1, $3a42d2aab3654c46$var$Yc = [], $3a42d2aab3654c46$var$Zc = null, $3a42d2aab3654c46$var$$c = null, $3a42d2aab3654c46$var$ad = null, $3a42d2aab3654c46$var$bd = new Map, $3a42d2aab3654c46$var$cd = new Map, $3a42d2aab3654c46$var$dd = [], $3a42d2aab3654c46$var$ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $3a42d2aab3654c46$var$fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $3a42d2aab3654c46$var$Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $3a42d2aab3654c46$var$$c = null;
            break;
        case "mouseover":
        case "mouseout":
            $3a42d2aab3654c46$var$ad = null;
            break;
        case "pointerover":
        case "pointerout":
            $3a42d2aab3654c46$var$bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $3a42d2aab3654c46$var$cd.delete(b.pointerId);
    }
}
function $3a42d2aab3654c46$var$gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $3a42d2aab3654c46$var$Cb(b), null !== b && $3a42d2aab3654c46$var$Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $3a42d2aab3654c46$var$hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $3a42d2aab3654c46$var$Zc = $3a42d2aab3654c46$var$gd($3a42d2aab3654c46$var$Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $3a42d2aab3654c46$var$$c = $3a42d2aab3654c46$var$gd($3a42d2aab3654c46$var$$c, a, b, c, d, e), !0;
        case "mouseover":
            return $3a42d2aab3654c46$var$ad = $3a42d2aab3654c46$var$gd($3a42d2aab3654c46$var$ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $3a42d2aab3654c46$var$bd.set(f, $3a42d2aab3654c46$var$gd($3a42d2aab3654c46$var$bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $3a42d2aab3654c46$var$cd.set(f, $3a42d2aab3654c46$var$gd($3a42d2aab3654c46$var$cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $3a42d2aab3654c46$var$id(a) {
    var b = $3a42d2aab3654c46$var$jd(a.target);
    if (null !== b) {
        var c = $3a42d2aab3654c46$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $3a42d2aab3654c46$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $3a42d2aab3654c46$var$Wc(a.priority, function() {
                        $3a42d2aab3654c46$var$Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $3a42d2aab3654c46$var$kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $3a42d2aab3654c46$var$ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $3a42d2aab3654c46$var$wb = d;
            c.target.dispatchEvent(d);
            $3a42d2aab3654c46$var$wb = null;
        } else return b = $3a42d2aab3654c46$var$Cb(c), null !== b && $3a42d2aab3654c46$var$Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $3a42d2aab3654c46$var$md(a, b, c) {
    $3a42d2aab3654c46$var$kd(a) && c.delete(b);
}
function $3a42d2aab3654c46$var$nd() {
    $3a42d2aab3654c46$var$Xc = !1;
    null !== $3a42d2aab3654c46$var$Zc && $3a42d2aab3654c46$var$kd($3a42d2aab3654c46$var$Zc) && ($3a42d2aab3654c46$var$Zc = null);
    null !== $3a42d2aab3654c46$var$$c && $3a42d2aab3654c46$var$kd($3a42d2aab3654c46$var$$c) && ($3a42d2aab3654c46$var$$c = null);
    null !== $3a42d2aab3654c46$var$ad && $3a42d2aab3654c46$var$kd($3a42d2aab3654c46$var$ad) && ($3a42d2aab3654c46$var$ad = null);
    $3a42d2aab3654c46$var$bd.forEach($3a42d2aab3654c46$var$md);
    $3a42d2aab3654c46$var$cd.forEach($3a42d2aab3654c46$var$md);
}
function $3a42d2aab3654c46$var$od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $3a42d2aab3654c46$var$Xc || ($3a42d2aab3654c46$var$Xc = !0, $iZu5g.unstable_scheduleCallback($iZu5g.unstable_NormalPriority, $3a42d2aab3654c46$var$nd)));
}
function $3a42d2aab3654c46$var$pd(a) {
    function b(b) {
        return $3a42d2aab3654c46$var$od(b, a);
    }
    if (0 < $3a42d2aab3654c46$var$Yc.length) {
        $3a42d2aab3654c46$var$od($3a42d2aab3654c46$var$Yc[0], a);
        for(var c = 1; c < $3a42d2aab3654c46$var$Yc.length; c++){
            var d = $3a42d2aab3654c46$var$Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $3a42d2aab3654c46$var$Zc && $3a42d2aab3654c46$var$od($3a42d2aab3654c46$var$Zc, a);
    null !== $3a42d2aab3654c46$var$$c && $3a42d2aab3654c46$var$od($3a42d2aab3654c46$var$$c, a);
    null !== $3a42d2aab3654c46$var$ad && $3a42d2aab3654c46$var$od($3a42d2aab3654c46$var$ad, a);
    $3a42d2aab3654c46$var$bd.forEach(b);
    $3a42d2aab3654c46$var$cd.forEach(b);
    for(c = 0; c < $3a42d2aab3654c46$var$dd.length; c++)d = $3a42d2aab3654c46$var$dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $3a42d2aab3654c46$var$dd.length && (c = $3a42d2aab3654c46$var$dd[0], null === c.blockedOn);)$3a42d2aab3654c46$var$id(c), null === c.blockedOn && $3a42d2aab3654c46$var$dd.shift();
}
var $3a42d2aab3654c46$var$qd = $3a42d2aab3654c46$var$va.ReactCurrentBatchConfig, $3a42d2aab3654c46$var$rd = !0;
function $3a42d2aab3654c46$var$sd(a, b, c, d) {
    var e = $3a42d2aab3654c46$var$E, f = $3a42d2aab3654c46$var$qd.transition;
    $3a42d2aab3654c46$var$qd.transition = null;
    try {
        $3a42d2aab3654c46$var$E = 1, $3a42d2aab3654c46$var$td(a, b, c, d);
    } finally{
        $3a42d2aab3654c46$var$E = e, $3a42d2aab3654c46$var$qd.transition = f;
    }
}
function $3a42d2aab3654c46$var$ud(a, b, c, d) {
    var e = $3a42d2aab3654c46$var$E, f = $3a42d2aab3654c46$var$qd.transition;
    $3a42d2aab3654c46$var$qd.transition = null;
    try {
        $3a42d2aab3654c46$var$E = 4, $3a42d2aab3654c46$var$td(a, b, c, d);
    } finally{
        $3a42d2aab3654c46$var$E = e, $3a42d2aab3654c46$var$qd.transition = f;
    }
}
function $3a42d2aab3654c46$var$td(a, b, c, d) {
    if ($3a42d2aab3654c46$var$rd) {
        var e = $3a42d2aab3654c46$var$ld(a, b, c, d);
        if (null === e) $3a42d2aab3654c46$var$vd(a, b, d, $3a42d2aab3654c46$var$wd, c), $3a42d2aab3654c46$var$fd(a, d);
        else if ($3a42d2aab3654c46$var$hd(e, a, b, c, d)) d.stopPropagation();
        else if ($3a42d2aab3654c46$var$fd(a, d), b & 4 && -1 < $3a42d2aab3654c46$var$ed.indexOf(a)) {
            for(; null !== e;){
                var f = $3a42d2aab3654c46$var$Cb(e);
                null !== f && $3a42d2aab3654c46$var$Sc(f);
                f = $3a42d2aab3654c46$var$ld(a, b, c, d);
                null === f && $3a42d2aab3654c46$var$vd(a, b, d, $3a42d2aab3654c46$var$wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $3a42d2aab3654c46$var$vd(a, b, d, null, c);
    }
}
var $3a42d2aab3654c46$var$wd = null;
function $3a42d2aab3654c46$var$ld(a, b, c, d) {
    $3a42d2aab3654c46$var$wd = null;
    a = $3a42d2aab3654c46$var$xb(d);
    a = $3a42d2aab3654c46$var$jd(a);
    if (null !== a) {
        if (b = $3a42d2aab3654c46$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $3a42d2aab3654c46$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $3a42d2aab3654c46$var$wd = a;
    return null;
}
function $3a42d2aab3654c46$var$xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($3a42d2aab3654c46$var$ec()){
                case $3a42d2aab3654c46$var$fc:
                    return 1;
                case $3a42d2aab3654c46$var$gc:
                    return 4;
                case $3a42d2aab3654c46$var$hc:
                case $3a42d2aab3654c46$var$ic:
                    return 16;
                case $3a42d2aab3654c46$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $3a42d2aab3654c46$var$yd = null, $3a42d2aab3654c46$var$zd = null, $3a42d2aab3654c46$var$Ad = null;
function $3a42d2aab3654c46$var$Bd() {
    if ($3a42d2aab3654c46$var$Ad) return $3a42d2aab3654c46$var$Ad;
    var a, b = $3a42d2aab3654c46$var$zd, c = b.length, d, e = "value" in $3a42d2aab3654c46$var$yd ? $3a42d2aab3654c46$var$yd.value : $3a42d2aab3654c46$var$yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $3a42d2aab3654c46$var$Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $3a42d2aab3654c46$var$Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $3a42d2aab3654c46$var$Dd() {
    return !0;
}
function $3a42d2aab3654c46$var$Ed() {
    return !1;
}
function $3a42d2aab3654c46$var$Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $3a42d2aab3654c46$var$Dd : $3a42d2aab3654c46$var$Ed;
        this.isPropagationStopped = $3a42d2aab3654c46$var$Ed;
        return this;
    }
    $3a42d2aab3654c46$var$u(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $3a42d2aab3654c46$var$Dd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $3a42d2aab3654c46$var$Dd);
        },
        persist: function() {},
        isPersistent: $3a42d2aab3654c46$var$Dd
    });
    return b;
}
var $3a42d2aab3654c46$var$Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $3a42d2aab3654c46$var$Hd = $3a42d2aab3654c46$var$Fd($3a42d2aab3654c46$var$Gd), $3a42d2aab3654c46$var$Id = $3a42d2aab3654c46$var$u({}, $3a42d2aab3654c46$var$Gd, {
    view: 0,
    detail: 0
}), $3a42d2aab3654c46$var$Jd = $3a42d2aab3654c46$var$Fd($3a42d2aab3654c46$var$Id), $3a42d2aab3654c46$var$Kd, $3a42d2aab3654c46$var$Ld, $3a42d2aab3654c46$var$Md, $3a42d2aab3654c46$var$Od = $3a42d2aab3654c46$var$u({}, $3a42d2aab3654c46$var$Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $3a42d2aab3654c46$var$Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $3a42d2aab3654c46$var$Md && ($3a42d2aab3654c46$var$Md && "mousemove" === a.type ? ($3a42d2aab3654c46$var$Kd = a.screenX - $3a42d2aab3654c46$var$Md.screenX, $3a42d2aab3654c46$var$Ld = a.screenY - $3a42d2aab3654c46$var$Md.screenY) : $3a42d2aab3654c46$var$Ld = $3a42d2aab3654c46$var$Kd = 0, $3a42d2aab3654c46$var$Md = a);
        return $3a42d2aab3654c46$var$Kd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $3a42d2aab3654c46$var$Ld;
    }
}), $3a42d2aab3654c46$var$Pd = $3a42d2aab3654c46$var$Fd($3a42d2aab3654c46$var$Od), $3a42d2aab3654c46$var$Qd = $3a42d2aab3654c46$var$u({}, $3a42d2aab3654c46$var$Od, {
    dataTransfer: 0
}), $3a42d2aab3654c46$var$Rd = $3a42d2aab3654c46$var$Fd($3a42d2aab3654c46$var$Qd), $3a42d2aab3654c46$var$Sd = $3a42d2aab3654c46$var$u({}, $3a42d2aab3654c46$var$Id, {
    relatedTarget: 0
}), $3a42d2aab3654c46$var$Td = $3a42d2aab3654c46$var$Fd($3a42d2aab3654c46$var$Sd), $3a42d2aab3654c46$var$Ud = $3a42d2aab3654c46$var$u({}, $3a42d2aab3654c46$var$Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3a42d2aab3654c46$var$Vd = $3a42d2aab3654c46$var$Fd($3a42d2aab3654c46$var$Ud), $3a42d2aab3654c46$var$Wd = $3a42d2aab3654c46$var$u({}, $3a42d2aab3654c46$var$Gd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $3a42d2aab3654c46$var$Xd = $3a42d2aab3654c46$var$Fd($3a42d2aab3654c46$var$Wd), $3a42d2aab3654c46$var$Yd = $3a42d2aab3654c46$var$u({}, $3a42d2aab3654c46$var$Gd, {
    data: 0
}), $3a42d2aab3654c46$var$Zd = $3a42d2aab3654c46$var$Fd($3a42d2aab3654c46$var$Yd), $3a42d2aab3654c46$var$$d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $3a42d2aab3654c46$var$ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $3a42d2aab3654c46$var$be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $3a42d2aab3654c46$var$ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $3a42d2aab3654c46$var$be[a]) ? !!b[a] : !1;
}
function $3a42d2aab3654c46$var$Nd() {
    return $3a42d2aab3654c46$var$ce;
}
var $3a42d2aab3654c46$var$de = $3a42d2aab3654c46$var$u({}, $3a42d2aab3654c46$var$Id, {
    key: function(a) {
        if (a.key) {
            var b = $3a42d2aab3654c46$var$$d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $3a42d2aab3654c46$var$Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $3a42d2aab3654c46$var$ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $3a42d2aab3654c46$var$Nd,
    charCode: function(a) {
        return "keypress" === a.type ? $3a42d2aab3654c46$var$Cd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $3a42d2aab3654c46$var$Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $3a42d2aab3654c46$var$ee = $3a42d2aab3654c46$var$Fd($3a42d2aab3654c46$var$de), $3a42d2aab3654c46$var$fe = $3a42d2aab3654c46$var$u({}, $3a42d2aab3654c46$var$Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $3a42d2aab3654c46$var$ge = $3a42d2aab3654c46$var$Fd($3a42d2aab3654c46$var$fe), $3a42d2aab3654c46$var$he = $3a42d2aab3654c46$var$u({}, $3a42d2aab3654c46$var$Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $3a42d2aab3654c46$var$Nd
}), $3a42d2aab3654c46$var$ie = $3a42d2aab3654c46$var$Fd($3a42d2aab3654c46$var$he), $3a42d2aab3654c46$var$je = $3a42d2aab3654c46$var$u({}, $3a42d2aab3654c46$var$Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3a42d2aab3654c46$var$ke = $3a42d2aab3654c46$var$Fd($3a42d2aab3654c46$var$je), $3a42d2aab3654c46$var$le = $3a42d2aab3654c46$var$u({}, $3a42d2aab3654c46$var$Od, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $3a42d2aab3654c46$var$me = $3a42d2aab3654c46$var$Fd($3a42d2aab3654c46$var$le), $3a42d2aab3654c46$var$ne = [
    9,
    13,
    27,
    32
], $3a42d2aab3654c46$var$oe = $3a42d2aab3654c46$var$ia && "CompositionEvent" in window, $3a42d2aab3654c46$var$pe = null;
$3a42d2aab3654c46$var$ia && "documentMode" in document && ($3a42d2aab3654c46$var$pe = document.documentMode);
var $3a42d2aab3654c46$var$qe = $3a42d2aab3654c46$var$ia && "TextEvent" in window && !$3a42d2aab3654c46$var$pe, $3a42d2aab3654c46$var$re = $3a42d2aab3654c46$var$ia && (!$3a42d2aab3654c46$var$oe || $3a42d2aab3654c46$var$pe && 8 < $3a42d2aab3654c46$var$pe && 11 >= $3a42d2aab3654c46$var$pe), $3a42d2aab3654c46$var$se = String.fromCharCode(32), $3a42d2aab3654c46$var$te = !1;
function $3a42d2aab3654c46$var$ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $3a42d2aab3654c46$var$ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $3a42d2aab3654c46$var$ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $3a42d2aab3654c46$var$we = !1;
function $3a42d2aab3654c46$var$xe(a, b) {
    switch(a){
        case "compositionend":
            return $3a42d2aab3654c46$var$ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            $3a42d2aab3654c46$var$te = !0;
            return $3a42d2aab3654c46$var$se;
        case "textInput":
            return a = b.data, a === $3a42d2aab3654c46$var$se && $3a42d2aab3654c46$var$te ? null : a;
        default:
            return null;
    }
}
function $3a42d2aab3654c46$var$ye(a, b) {
    if ($3a42d2aab3654c46$var$we) return "compositionend" === a || !$3a42d2aab3654c46$var$oe && $3a42d2aab3654c46$var$ue(a, b) ? (a = $3a42d2aab3654c46$var$Bd(), $3a42d2aab3654c46$var$Ad = $3a42d2aab3654c46$var$zd = $3a42d2aab3654c46$var$yd = null, $3a42d2aab3654c46$var$we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $3a42d2aab3654c46$var$re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $3a42d2aab3654c46$var$ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $3a42d2aab3654c46$var$Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$3a42d2aab3654c46$var$ze[a.type] : "textarea" === b ? !0 : !1;
}
function $3a42d2aab3654c46$var$Be(a, b, c, d) {
    $3a42d2aab3654c46$var$Eb(d);
    b = $3a42d2aab3654c46$var$Ce(b, "onChange");
    0 < b.length && (c = new $3a42d2aab3654c46$var$Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $3a42d2aab3654c46$var$De = null, $3a42d2aab3654c46$var$Ee = null;
function $3a42d2aab3654c46$var$Fe(a) {
    $3a42d2aab3654c46$var$Ge(a, 0);
}
function $3a42d2aab3654c46$var$He(a) {
    var b = $3a42d2aab3654c46$var$Ie(a);
    if ($3a42d2aab3654c46$var$Wa(b)) return a;
}
function $3a42d2aab3654c46$var$Je(a, b) {
    if ("change" === a) return b;
}
var $3a42d2aab3654c46$var$Ke = !1;
if ($3a42d2aab3654c46$var$ia) {
    var $3a42d2aab3654c46$var$Le;
    if ($3a42d2aab3654c46$var$ia) {
        var $3a42d2aab3654c46$var$Me = "oninput" in document;
        if (!$3a42d2aab3654c46$var$Me) {
            var $3a42d2aab3654c46$var$Ne = document.createElement("div");
            $3a42d2aab3654c46$var$Ne.setAttribute("oninput", "return;");
            $3a42d2aab3654c46$var$Me = "function" === typeof $3a42d2aab3654c46$var$Ne.oninput;
        }
        $3a42d2aab3654c46$var$Le = $3a42d2aab3654c46$var$Me;
    } else $3a42d2aab3654c46$var$Le = !1;
    $3a42d2aab3654c46$var$Ke = $3a42d2aab3654c46$var$Le && (!document.documentMode || 9 < document.documentMode);
}
function $3a42d2aab3654c46$var$Oe() {
    $3a42d2aab3654c46$var$De && ($3a42d2aab3654c46$var$De.detachEvent("onpropertychange", $3a42d2aab3654c46$var$Pe), $3a42d2aab3654c46$var$Ee = $3a42d2aab3654c46$var$De = null);
}
function $3a42d2aab3654c46$var$Pe(a) {
    if ("value" === a.propertyName && $3a42d2aab3654c46$var$He($3a42d2aab3654c46$var$Ee)) {
        var b = [];
        $3a42d2aab3654c46$var$Be(b, $3a42d2aab3654c46$var$Ee, a, $3a42d2aab3654c46$var$xb(a));
        $3a42d2aab3654c46$var$Jb($3a42d2aab3654c46$var$Fe, b);
    }
}
function $3a42d2aab3654c46$var$Qe(a, b, c) {
    "focusin" === a ? ($3a42d2aab3654c46$var$Oe(), $3a42d2aab3654c46$var$De = b, $3a42d2aab3654c46$var$Ee = c, $3a42d2aab3654c46$var$De.attachEvent("onpropertychange", $3a42d2aab3654c46$var$Pe)) : "focusout" === a && $3a42d2aab3654c46$var$Oe();
}
function $3a42d2aab3654c46$var$Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $3a42d2aab3654c46$var$He($3a42d2aab3654c46$var$Ee);
}
function $3a42d2aab3654c46$var$Se(a, b) {
    if ("click" === a) return $3a42d2aab3654c46$var$He(b);
}
function $3a42d2aab3654c46$var$Te(a, b) {
    if ("input" === a || "change" === a) return $3a42d2aab3654c46$var$He(b);
}
function $3a42d2aab3654c46$var$Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $3a42d2aab3654c46$var$Ve = "function" === typeof Object.is ? Object.is : $3a42d2aab3654c46$var$Ue;
function $3a42d2aab3654c46$var$We(a, b) {
    if ($3a42d2aab3654c46$var$Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$3a42d2aab3654c46$var$ja.call(b, e) || !$3a42d2aab3654c46$var$Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function $3a42d2aab3654c46$var$Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $3a42d2aab3654c46$var$Ye(a, b) {
    var c = $3a42d2aab3654c46$var$Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $3a42d2aab3654c46$var$Xe(c);
    }
}
function $3a42d2aab3654c46$var$Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $3a42d2aab3654c46$var$Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $3a42d2aab3654c46$var$$e() {
    for(var a = window, b = $3a42d2aab3654c46$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $3a42d2aab3654c46$var$Xa(a.document);
    }
    return b;
}
function $3a42d2aab3654c46$var$af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $3a42d2aab3654c46$var$bf(a) {
    var b = $3a42d2aab3654c46$var$$e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $3a42d2aab3654c46$var$Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && $3a42d2aab3654c46$var$af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $3a42d2aab3654c46$var$Ye(c, f);
                var g = $3a42d2aab3654c46$var$Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $3a42d2aab3654c46$var$cf = $3a42d2aab3654c46$var$ia && "documentMode" in document && 11 >= document.documentMode, $3a42d2aab3654c46$var$df = null, $3a42d2aab3654c46$var$ef = null, $3a42d2aab3654c46$var$ff = null, $3a42d2aab3654c46$var$gf = !1;
function $3a42d2aab3654c46$var$hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $3a42d2aab3654c46$var$gf || null == $3a42d2aab3654c46$var$df || $3a42d2aab3654c46$var$df !== $3a42d2aab3654c46$var$Xa(d) || (d = $3a42d2aab3654c46$var$df, "selectionStart" in d && $3a42d2aab3654c46$var$af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $3a42d2aab3654c46$var$ff && $3a42d2aab3654c46$var$We($3a42d2aab3654c46$var$ff, d) || ($3a42d2aab3654c46$var$ff = d, d = $3a42d2aab3654c46$var$Ce($3a42d2aab3654c46$var$ef, "onSelect"), 0 < d.length && (b = new $3a42d2aab3654c46$var$Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $3a42d2aab3654c46$var$df)));
}
function $3a42d2aab3654c46$var$jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $3a42d2aab3654c46$var$kf = {
    animationend: $3a42d2aab3654c46$var$jf("Animation", "AnimationEnd"),
    animationiteration: $3a42d2aab3654c46$var$jf("Animation", "AnimationIteration"),
    animationstart: $3a42d2aab3654c46$var$jf("Animation", "AnimationStart"),
    transitionend: $3a42d2aab3654c46$var$jf("Transition", "TransitionEnd")
}, $3a42d2aab3654c46$var$lf = {}, $3a42d2aab3654c46$var$mf = {};
$3a42d2aab3654c46$var$ia && ($3a42d2aab3654c46$var$mf = document.createElement("div").style, "AnimationEvent" in window || (delete $3a42d2aab3654c46$var$kf.animationend.animation, delete $3a42d2aab3654c46$var$kf.animationiteration.animation, delete $3a42d2aab3654c46$var$kf.animationstart.animation), "TransitionEvent" in window || delete $3a42d2aab3654c46$var$kf.transitionend.transition);
function $3a42d2aab3654c46$var$nf(a) {
    if ($3a42d2aab3654c46$var$lf[a]) return $3a42d2aab3654c46$var$lf[a];
    if (!$3a42d2aab3654c46$var$kf[a]) return a;
    var b = $3a42d2aab3654c46$var$kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $3a42d2aab3654c46$var$mf) return $3a42d2aab3654c46$var$lf[a] = b[c];
    return a;
}
var $3a42d2aab3654c46$var$of = $3a42d2aab3654c46$var$nf("animationend"), $3a42d2aab3654c46$var$pf = $3a42d2aab3654c46$var$nf("animationiteration"), $3a42d2aab3654c46$var$qf = $3a42d2aab3654c46$var$nf("animationstart"), $3a42d2aab3654c46$var$rf = $3a42d2aab3654c46$var$nf("transitionend"), $3a42d2aab3654c46$var$sf = new Map, $3a42d2aab3654c46$var$tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $3a42d2aab3654c46$var$uf(a, b) {
    $3a42d2aab3654c46$var$sf.set(a, b);
    $3a42d2aab3654c46$var$fa(b, [
        a
    ]);
}
for(var $3a42d2aab3654c46$var$vf = 0; $3a42d2aab3654c46$var$vf < $3a42d2aab3654c46$var$tf.length; $3a42d2aab3654c46$var$vf++){
    var $3a42d2aab3654c46$var$wf = $3a42d2aab3654c46$var$tf[$3a42d2aab3654c46$var$vf], $3a42d2aab3654c46$var$xf = $3a42d2aab3654c46$var$wf.toLowerCase(), $3a42d2aab3654c46$var$yf = $3a42d2aab3654c46$var$wf[0].toUpperCase() + $3a42d2aab3654c46$var$wf.slice(1);
    $3a42d2aab3654c46$var$uf($3a42d2aab3654c46$var$xf, "on" + $3a42d2aab3654c46$var$yf);
}
$3a42d2aab3654c46$var$uf($3a42d2aab3654c46$var$of, "onAnimationEnd");
$3a42d2aab3654c46$var$uf($3a42d2aab3654c46$var$pf, "onAnimationIteration");
$3a42d2aab3654c46$var$uf($3a42d2aab3654c46$var$qf, "onAnimationStart");
$3a42d2aab3654c46$var$uf("dblclick", "onDoubleClick");
$3a42d2aab3654c46$var$uf("focusin", "onFocus");
$3a42d2aab3654c46$var$uf("focusout", "onBlur");
$3a42d2aab3654c46$var$uf($3a42d2aab3654c46$var$rf, "onTransitionEnd");
$3a42d2aab3654c46$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$3a42d2aab3654c46$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$3a42d2aab3654c46$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$3a42d2aab3654c46$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$3a42d2aab3654c46$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$3a42d2aab3654c46$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$3a42d2aab3654c46$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$3a42d2aab3654c46$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$3a42d2aab3654c46$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$3a42d2aab3654c46$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $3a42d2aab3654c46$var$zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $3a42d2aab3654c46$var$Af = new Set("cancel close invalid load scroll toggle".split(" ").concat($3a42d2aab3654c46$var$zf));
function $3a42d2aab3654c46$var$Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $3a42d2aab3654c46$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $3a42d2aab3654c46$var$Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $3a42d2aab3654c46$var$Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $3a42d2aab3654c46$var$Bf(e, h, l);
                f = k;
            }
        }
    }
    if ($3a42d2aab3654c46$var$Qb) throw a = $3a42d2aab3654c46$var$Rb, $3a42d2aab3654c46$var$Qb = !1, $3a42d2aab3654c46$var$Rb = null, a;
}
function $3a42d2aab3654c46$var$F(a, b) {
    var c = b[$3a42d2aab3654c46$var$Cf];
    void 0 === c && (c = b[$3a42d2aab3654c46$var$Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($3a42d2aab3654c46$var$Df(b, a, 2, !1), c.add(d));
}
function $3a42d2aab3654c46$var$Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $3a42d2aab3654c46$var$Df(c, a, d, b);
}
var $3a42d2aab3654c46$var$Ff = "_reactListening" + Math.random().toString(36).slice(2);
function $3a42d2aab3654c46$var$Gf(a) {
    if (!a[$3a42d2aab3654c46$var$Ff]) {
        a[$3a42d2aab3654c46$var$Ff] = !0;
        $3a42d2aab3654c46$var$da.forEach(function(b) {
            "selectionchange" !== b && ($3a42d2aab3654c46$var$Af.has(b) || $3a42d2aab3654c46$var$Ef(b, !1, a), $3a42d2aab3654c46$var$Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$3a42d2aab3654c46$var$Ff] || (b[$3a42d2aab3654c46$var$Ff] = !0, $3a42d2aab3654c46$var$Ef("selectionchange", !1, b));
    }
}
function $3a42d2aab3654c46$var$Df(a, b, c, d) {
    switch($3a42d2aab3654c46$var$xd(b)){
        case 1:
            var e = $3a42d2aab3654c46$var$sd;
            break;
        case 4:
            e = $3a42d2aab3654c46$var$ud;
            break;
        default:
            e = $3a42d2aab3654c46$var$td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$3a42d2aab3654c46$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $3a42d2aab3654c46$var$vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $3a42d2aab3654c46$var$jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $3a42d2aab3654c46$var$Jb(function() {
        var d = f, e = $3a42d2aab3654c46$var$xb(c), g = [];
        a: {
            var h = $3a42d2aab3654c46$var$sf.get(a);
            if (void 0 !== h) {
                var k = $3a42d2aab3654c46$var$Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $3a42d2aab3654c46$var$Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $3a42d2aab3654c46$var$ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $3a42d2aab3654c46$var$Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $3a42d2aab3654c46$var$Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $3a42d2aab3654c46$var$Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $3a42d2aab3654c46$var$Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $3a42d2aab3654c46$var$Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $3a42d2aab3654c46$var$ie;
                        break;
                    case $3a42d2aab3654c46$var$of:
                    case $3a42d2aab3654c46$var$pf:
                    case $3a42d2aab3654c46$var$qf:
                        k = $3a42d2aab3654c46$var$Vd;
                        break;
                    case $3a42d2aab3654c46$var$rf:
                        k = $3a42d2aab3654c46$var$ke;
                        break;
                    case "scroll":
                        k = $3a42d2aab3654c46$var$Jd;
                        break;
                    case "wheel":
                        k = $3a42d2aab3654c46$var$me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $3a42d2aab3654c46$var$Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $3a42d2aab3654c46$var$ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = $3a42d2aab3654c46$var$Kb(y, x), null != D && w.push($3a42d2aab3654c46$var$Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $3a42d2aab3654c46$var$wb && (m = c.relatedTarget || c.fromElement) && ($3a42d2aab3654c46$var$jd(m) || m[$3a42d2aab3654c46$var$If])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $3a42d2aab3654c46$var$jd(m) : null, null !== m && (C = $3a42d2aab3654c46$var$Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $3a42d2aab3654c46$var$Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $3a42d2aab3654c46$var$ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : $3a42d2aab3654c46$var$Ie(k);
                        v = null == m ? h : $3a42d2aab3654c46$var$Ie(m);
                        h = new w(D, y + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        $3a42d2aab3654c46$var$jd(e) === d && (w = new w(x, y + "enter", m, c, e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = $3a42d2aab3654c46$var$Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = $3a42d2aab3654c46$var$Jf(D))v++;
                            for(; 0 < y - v;)w = $3a42d2aab3654c46$var$Jf(w), y--;
                            for(; 0 < v - y;)x = $3a42d2aab3654c46$var$Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = $3a42d2aab3654c46$var$Jf(w);
                                x = $3a42d2aab3654c46$var$Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $3a42d2aab3654c46$var$Kf(g, h, k, w, !1);
                        null !== m && null !== C && $3a42d2aab3654c46$var$Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $3a42d2aab3654c46$var$Ie(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var ca = $3a42d2aab3654c46$var$Je;
                else if ($3a42d2aab3654c46$var$Ae(h)) {
                    if ($3a42d2aab3654c46$var$Ke) ca = $3a42d2aab3654c46$var$Te;
                    else {
                        ca = $3a42d2aab3654c46$var$Re;
                        var R = $3a42d2aab3654c46$var$Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (ca = $3a42d2aab3654c46$var$Se);
                if (ca && (ca = ca(a, d))) {
                    $3a42d2aab3654c46$var$Be(g, ca, c, e);
                    break a;
                }
                R && R(a, h, d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && $3a42d2aab3654c46$var$bb(h, "number", h.value);
            }
            R = d ? $3a42d2aab3654c46$var$Ie(d) : window;
            switch(a){
                case "focusin":
                    if ($3a42d2aab3654c46$var$Ae(R) || "true" === R.contentEditable) $3a42d2aab3654c46$var$df = R, $3a42d2aab3654c46$var$ef = d, $3a42d2aab3654c46$var$ff = null;
                    break;
                case "focusout":
                    $3a42d2aab3654c46$var$ff = $3a42d2aab3654c46$var$ef = $3a42d2aab3654c46$var$df = null;
                    break;
                case "mousedown":
                    $3a42d2aab3654c46$var$gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $3a42d2aab3654c46$var$gf = !1;
                    $3a42d2aab3654c46$var$hf(g, c, e);
                    break;
                case "selectionchange":
                    if ($3a42d2aab3654c46$var$cf) break;
                case "keydown":
                case "keyup":
                    $3a42d2aab3654c46$var$hf(g, c, e);
            }
            var sa;
            if ($3a42d2aab3654c46$var$oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else $3a42d2aab3654c46$var$we ? $3a42d2aab3654c46$var$ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && ($3a42d2aab3654c46$var$re && "ko" !== c.locale && ($3a42d2aab3654c46$var$we || "onCompositionStart" !== V ? "onCompositionEnd" === V && $3a42d2aab3654c46$var$we && (sa = $3a42d2aab3654c46$var$Bd()) : ($3a42d2aab3654c46$var$yd = e, $3a42d2aab3654c46$var$zd = "value" in $3a42d2aab3654c46$var$yd ? $3a42d2aab3654c46$var$yd.value : $3a42d2aab3654c46$var$yd.textContent, $3a42d2aab3654c46$var$we = !0)), R = $3a42d2aab3654c46$var$Ce(d, V), 0 < R.length && (V = new $3a42d2aab3654c46$var$Zd(V, a, null, c, e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = $3a42d2aab3654c46$var$ve(c), null !== sa && (V.data = sa))));
            if (sa = $3a42d2aab3654c46$var$qe ? $3a42d2aab3654c46$var$xe(a, c) : $3a42d2aab3654c46$var$ye(a, c)) d = $3a42d2aab3654c46$var$Ce(d, "onBeforeInput"), 0 < d.length && (e = new $3a42d2aab3654c46$var$Zd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = sa);
        }
        $3a42d2aab3654c46$var$Ge(g, b);
    });
}
function $3a42d2aab3654c46$var$Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $3a42d2aab3654c46$var$Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $3a42d2aab3654c46$var$Kb(a, c), null != f && d.unshift($3a42d2aab3654c46$var$Hf(a, f, e)), f = $3a42d2aab3654c46$var$Kb(a, b), null != f && d.push($3a42d2aab3654c46$var$Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $3a42d2aab3654c46$var$Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $3a42d2aab3654c46$var$Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $3a42d2aab3654c46$var$Kb(c, f), null != k && g.unshift($3a42d2aab3654c46$var$Hf(c, k, h))) : e || (k = $3a42d2aab3654c46$var$Kb(c, f), null != k && g.push($3a42d2aab3654c46$var$Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $3a42d2aab3654c46$var$Lf = /\r\n?/g, $3a42d2aab3654c46$var$Mf = /\u0000|\uFFFD/g;
function $3a42d2aab3654c46$var$Nf(a) {
    return ("string" === typeof a ? a : "" + a).replace($3a42d2aab3654c46$var$Lf, "\n").replace($3a42d2aab3654c46$var$Mf, "");
}
function $3a42d2aab3654c46$var$Of(a, b, c) {
    b = $3a42d2aab3654c46$var$Nf(b);
    if ($3a42d2aab3654c46$var$Nf(a) !== b && c) throw Error($3a42d2aab3654c46$var$p(425));
}
function $3a42d2aab3654c46$var$Pf() {}
var $3a42d2aab3654c46$var$Qf = null, $3a42d2aab3654c46$var$Rf = null;
function $3a42d2aab3654c46$var$Sf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $3a42d2aab3654c46$var$Tf = "function" === typeof setTimeout ? setTimeout : void 0, $3a42d2aab3654c46$var$Uf = "function" === typeof clearTimeout ? clearTimeout : void 0, $3a42d2aab3654c46$var$Vf = "function" === typeof Promise ? Promise : void 0, $3a42d2aab3654c46$var$Xf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $3a42d2aab3654c46$var$Vf ? function(a) {
    return $3a42d2aab3654c46$var$Vf.resolve(null).then(a).catch($3a42d2aab3654c46$var$Wf);
} : $3a42d2aab3654c46$var$Tf;
function $3a42d2aab3654c46$var$Wf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $3a42d2aab3654c46$var$Yf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $3a42d2aab3654c46$var$pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $3a42d2aab3654c46$var$pd(b);
}
function $3a42d2aab3654c46$var$Zf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $3a42d2aab3654c46$var$$f(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $3a42d2aab3654c46$var$ag = Math.random().toString(36).slice(2), $3a42d2aab3654c46$var$bg = "__reactFiber$" + $3a42d2aab3654c46$var$ag, $3a42d2aab3654c46$var$cg = "__reactProps$" + $3a42d2aab3654c46$var$ag, $3a42d2aab3654c46$var$If = "__reactContainer$" + $3a42d2aab3654c46$var$ag, $3a42d2aab3654c46$var$Cf = "__reactEvents$" + $3a42d2aab3654c46$var$ag, $3a42d2aab3654c46$var$dg = "__reactListeners$" + $3a42d2aab3654c46$var$ag, $3a42d2aab3654c46$var$eg = "__reactHandles$" + $3a42d2aab3654c46$var$ag;
function $3a42d2aab3654c46$var$jd(a) {
    var b = a[$3a42d2aab3654c46$var$bg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$3a42d2aab3654c46$var$If] || c[$3a42d2aab3654c46$var$bg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $3a42d2aab3654c46$var$$f(a); null !== a;){
                if (c = a[$3a42d2aab3654c46$var$bg]) return c;
                a = $3a42d2aab3654c46$var$$f(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $3a42d2aab3654c46$var$Cb(a) {
    a = a[$3a42d2aab3654c46$var$bg] || a[$3a42d2aab3654c46$var$If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $3a42d2aab3654c46$var$Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($3a42d2aab3654c46$var$p(33));
}
function $3a42d2aab3654c46$var$Db(a) {
    return a[$3a42d2aab3654c46$var$cg] || null;
}
var $3a42d2aab3654c46$var$fg = [], $3a42d2aab3654c46$var$gg = -1;
function $3a42d2aab3654c46$var$hg(a) {
    return {
        current: a
    };
}
function $3a42d2aab3654c46$var$G(a) {
    0 > $3a42d2aab3654c46$var$gg || (a.current = $3a42d2aab3654c46$var$fg[$3a42d2aab3654c46$var$gg], $3a42d2aab3654c46$var$fg[$3a42d2aab3654c46$var$gg] = null, $3a42d2aab3654c46$var$gg--);
}
function $3a42d2aab3654c46$var$H(a, b) {
    $3a42d2aab3654c46$var$gg++;
    $3a42d2aab3654c46$var$fg[$3a42d2aab3654c46$var$gg] = a.current;
    a.current = b;
}
var $3a42d2aab3654c46$var$ig = {}, $3a42d2aab3654c46$var$I = $3a42d2aab3654c46$var$hg($3a42d2aab3654c46$var$ig), $3a42d2aab3654c46$var$jg = $3a42d2aab3654c46$var$hg(!1), $3a42d2aab3654c46$var$kg = $3a42d2aab3654c46$var$ig;
function $3a42d2aab3654c46$var$lg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $3a42d2aab3654c46$var$ig;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $3a42d2aab3654c46$var$mg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $3a42d2aab3654c46$var$ng() {
    $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$jg);
    $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$I);
}
function $3a42d2aab3654c46$var$og(a, b, c) {
    if ($3a42d2aab3654c46$var$I.current !== $3a42d2aab3654c46$var$ig) throw Error($3a42d2aab3654c46$var$p(168));
    $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$I, b);
    $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$jg, c);
}
function $3a42d2aab3654c46$var$pg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($3a42d2aab3654c46$var$p(108, $3a42d2aab3654c46$var$Ra(a) || "Unknown", e));
    return $3a42d2aab3654c46$var$u({}, c, d);
}
function $3a42d2aab3654c46$var$qg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $3a42d2aab3654c46$var$ig;
    $3a42d2aab3654c46$var$kg = $3a42d2aab3654c46$var$I.current;
    $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$I, a);
    $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$jg, $3a42d2aab3654c46$var$jg.current);
    return !0;
}
function $3a42d2aab3654c46$var$rg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($3a42d2aab3654c46$var$p(169));
    c ? (a = $3a42d2aab3654c46$var$pg(a, b, $3a42d2aab3654c46$var$kg), d.__reactInternalMemoizedMergedChildContext = a, $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$jg), $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$I), $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$I, a)) : $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$jg);
    $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$jg, c);
}
var $3a42d2aab3654c46$var$sg = null, $3a42d2aab3654c46$var$tg = !1, $3a42d2aab3654c46$var$ug = !1;
function $3a42d2aab3654c46$var$vg(a) {
    null === $3a42d2aab3654c46$var$sg ? $3a42d2aab3654c46$var$sg = [
        a
    ] : $3a42d2aab3654c46$var$sg.push(a);
}
function $3a42d2aab3654c46$var$wg(a) {
    $3a42d2aab3654c46$var$tg = !0;
    $3a42d2aab3654c46$var$vg(a);
}
function $3a42d2aab3654c46$var$xg() {
    if (!$3a42d2aab3654c46$var$ug && null !== $3a42d2aab3654c46$var$sg) {
        $3a42d2aab3654c46$var$ug = !0;
        var a = 0, b = $3a42d2aab3654c46$var$E;
        try {
            var c = $3a42d2aab3654c46$var$sg;
            for($3a42d2aab3654c46$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $3a42d2aab3654c46$var$sg = null;
            $3a42d2aab3654c46$var$tg = !1;
        } catch (e) {
            throw null !== $3a42d2aab3654c46$var$sg && ($3a42d2aab3654c46$var$sg = $3a42d2aab3654c46$var$sg.slice(a + 1)), $3a42d2aab3654c46$var$ac($3a42d2aab3654c46$var$fc, $3a42d2aab3654c46$var$xg), e;
        } finally{
            $3a42d2aab3654c46$var$E = b, $3a42d2aab3654c46$var$ug = !1;
        }
    }
    return null;
}
var $3a42d2aab3654c46$var$yg = [], $3a42d2aab3654c46$var$zg = 0, $3a42d2aab3654c46$var$Ag = null, $3a42d2aab3654c46$var$Bg = 0, $3a42d2aab3654c46$var$Cg = [], $3a42d2aab3654c46$var$Dg = 0, $3a42d2aab3654c46$var$Eg = null, $3a42d2aab3654c46$var$Fg = 1, $3a42d2aab3654c46$var$Gg = "";
function $3a42d2aab3654c46$var$Hg(a, b) {
    $3a42d2aab3654c46$var$yg[$3a42d2aab3654c46$var$zg++] = $3a42d2aab3654c46$var$Bg;
    $3a42d2aab3654c46$var$yg[$3a42d2aab3654c46$var$zg++] = $3a42d2aab3654c46$var$Ag;
    $3a42d2aab3654c46$var$Ag = a;
    $3a42d2aab3654c46$var$Bg = b;
}
function $3a42d2aab3654c46$var$Ig(a, b, c) {
    $3a42d2aab3654c46$var$Cg[$3a42d2aab3654c46$var$Dg++] = $3a42d2aab3654c46$var$Fg;
    $3a42d2aab3654c46$var$Cg[$3a42d2aab3654c46$var$Dg++] = $3a42d2aab3654c46$var$Gg;
    $3a42d2aab3654c46$var$Cg[$3a42d2aab3654c46$var$Dg++] = $3a42d2aab3654c46$var$Eg;
    $3a42d2aab3654c46$var$Eg = a;
    var d = $3a42d2aab3654c46$var$Fg;
    a = $3a42d2aab3654c46$var$Gg;
    var e = 32 - $3a42d2aab3654c46$var$Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $3a42d2aab3654c46$var$Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $3a42d2aab3654c46$var$Fg = 1 << 32 - $3a42d2aab3654c46$var$Ac(b) + e | c << e | d;
        $3a42d2aab3654c46$var$Gg = f + a;
    } else $3a42d2aab3654c46$var$Fg = 1 << f | c << e | d, $3a42d2aab3654c46$var$Gg = a;
}
function $3a42d2aab3654c46$var$Jg(a) {
    null !== a.return && ($3a42d2aab3654c46$var$Hg(a, 1), $3a42d2aab3654c46$var$Ig(a, 1, 0));
}
function $3a42d2aab3654c46$var$Kg(a) {
    for(; a === $3a42d2aab3654c46$var$Ag;)$3a42d2aab3654c46$var$Ag = $3a42d2aab3654c46$var$yg[--$3a42d2aab3654c46$var$zg], $3a42d2aab3654c46$var$yg[$3a42d2aab3654c46$var$zg] = null, $3a42d2aab3654c46$var$Bg = $3a42d2aab3654c46$var$yg[--$3a42d2aab3654c46$var$zg], $3a42d2aab3654c46$var$yg[$3a42d2aab3654c46$var$zg] = null;
    for(; a === $3a42d2aab3654c46$var$Eg;)$3a42d2aab3654c46$var$Eg = $3a42d2aab3654c46$var$Cg[--$3a42d2aab3654c46$var$Dg], $3a42d2aab3654c46$var$Cg[$3a42d2aab3654c46$var$Dg] = null, $3a42d2aab3654c46$var$Gg = $3a42d2aab3654c46$var$Cg[--$3a42d2aab3654c46$var$Dg], $3a42d2aab3654c46$var$Cg[$3a42d2aab3654c46$var$Dg] = null, $3a42d2aab3654c46$var$Fg = $3a42d2aab3654c46$var$Cg[--$3a42d2aab3654c46$var$Dg], $3a42d2aab3654c46$var$Cg[$3a42d2aab3654c46$var$Dg] = null;
}
var $3a42d2aab3654c46$var$Lg = null, $3a42d2aab3654c46$var$Mg = null, $3a42d2aab3654c46$var$J = !1, $3a42d2aab3654c46$var$Ng = null;
function $3a42d2aab3654c46$var$Og(a, b) {
    var c = $3a42d2aab3654c46$var$Pg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $3a42d2aab3654c46$var$Qg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $3a42d2aab3654c46$var$Lg = a, $3a42d2aab3654c46$var$Mg = $3a42d2aab3654c46$var$Zf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $3a42d2aab3654c46$var$Lg = a, $3a42d2aab3654c46$var$Mg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $3a42d2aab3654c46$var$Eg ? {
                id: $3a42d2aab3654c46$var$Fg,
                overflow: $3a42d2aab3654c46$var$Gg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $3a42d2aab3654c46$var$Pg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $3a42d2aab3654c46$var$Lg = a, $3a42d2aab3654c46$var$Mg = null, !0) : !1;
        default:
            return !1;
    }
}
function $3a42d2aab3654c46$var$Rg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $3a42d2aab3654c46$var$Sg(a) {
    if ($3a42d2aab3654c46$var$J) {
        var b = $3a42d2aab3654c46$var$Mg;
        if (b) {
            var c = b;
            if (!$3a42d2aab3654c46$var$Qg(a, b)) {
                if ($3a42d2aab3654c46$var$Rg(a)) throw Error($3a42d2aab3654c46$var$p(418));
                b = $3a42d2aab3654c46$var$Zf(c.nextSibling);
                var d = $3a42d2aab3654c46$var$Lg;
                b && $3a42d2aab3654c46$var$Qg(a, b) ? $3a42d2aab3654c46$var$Og(d, c) : (a.flags = a.flags & -4097 | 2, $3a42d2aab3654c46$var$J = !1, $3a42d2aab3654c46$var$Lg = a);
            }
        } else {
            if ($3a42d2aab3654c46$var$Rg(a)) throw Error($3a42d2aab3654c46$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $3a42d2aab3654c46$var$J = !1;
            $3a42d2aab3654c46$var$Lg = a;
        }
    }
}
function $3a42d2aab3654c46$var$Tg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $3a42d2aab3654c46$var$Lg = a;
}
function $3a42d2aab3654c46$var$Ug(a) {
    if (a !== $3a42d2aab3654c46$var$Lg) return !1;
    if (!$3a42d2aab3654c46$var$J) return $3a42d2aab3654c46$var$Tg(a), $3a42d2aab3654c46$var$J = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$3a42d2aab3654c46$var$Sf(a.type, a.memoizedProps));
    if (b && (b = $3a42d2aab3654c46$var$Mg)) {
        if ($3a42d2aab3654c46$var$Rg(a)) throw $3a42d2aab3654c46$var$Vg(), Error($3a42d2aab3654c46$var$p(418));
        for(; b;)$3a42d2aab3654c46$var$Og(a, b), b = $3a42d2aab3654c46$var$Zf(b.nextSibling);
    }
    $3a42d2aab3654c46$var$Tg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($3a42d2aab3654c46$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $3a42d2aab3654c46$var$Mg = $3a42d2aab3654c46$var$Zf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $3a42d2aab3654c46$var$Mg = null;
        }
    } else $3a42d2aab3654c46$var$Mg = $3a42d2aab3654c46$var$Lg ? $3a42d2aab3654c46$var$Zf(a.stateNode.nextSibling) : null;
    return !0;
}
function $3a42d2aab3654c46$var$Vg() {
    for(var a = $3a42d2aab3654c46$var$Mg; a;)a = $3a42d2aab3654c46$var$Zf(a.nextSibling);
}
function $3a42d2aab3654c46$var$Wg() {
    $3a42d2aab3654c46$var$Mg = $3a42d2aab3654c46$var$Lg = null;
    $3a42d2aab3654c46$var$J = !1;
}
function $3a42d2aab3654c46$var$Xg(a) {
    null === $3a42d2aab3654c46$var$Ng ? $3a42d2aab3654c46$var$Ng = [
        a
    ] : $3a42d2aab3654c46$var$Ng.push(a);
}
var $3a42d2aab3654c46$var$Yg = $3a42d2aab3654c46$var$va.ReactCurrentBatchConfig;
function $3a42d2aab3654c46$var$Zg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($3a42d2aab3654c46$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($3a42d2aab3654c46$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($3a42d2aab3654c46$var$p(284));
        if (!c._owner) throw Error($3a42d2aab3654c46$var$p(290, a));
    }
    return a;
}
function $3a42d2aab3654c46$var$$g(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($3a42d2aab3654c46$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $3a42d2aab3654c46$var$ah(a) {
    var b = a._init;
    return b(a._payload);
}
function $3a42d2aab3654c46$var$bh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $3a42d2aab3654c46$var$ch(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $3a42d2aab3654c46$var$dh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $3a42d2aab3654c46$var$ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $3a42d2aab3654c46$var$Ha && $3a42d2aab3654c46$var$ah(f) === b.type)) return d = e(b, c.props), d.ref = $3a42d2aab3654c46$var$Zg(a, b, c), d.return = a, d;
        d = $3a42d2aab3654c46$var$eh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $3a42d2aab3654c46$var$Zg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $3a42d2aab3654c46$var$fh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $3a42d2aab3654c46$var$gh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $3a42d2aab3654c46$var$dh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $3a42d2aab3654c46$var$wa:
                    return c = $3a42d2aab3654c46$var$eh(b.type, b.key, b.props, null, a.mode, c), c.ref = $3a42d2aab3654c46$var$Zg(a, null, b), c.return = a, c;
                case $3a42d2aab3654c46$var$xa:
                    return b = $3a42d2aab3654c46$var$fh(b, a.mode, c), b.return = a, b;
                case $3a42d2aab3654c46$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($3a42d2aab3654c46$var$db(b) || $3a42d2aab3654c46$var$Ka(b)) return b = $3a42d2aab3654c46$var$gh(b, a.mode, c, null), b.return = a, b;
            $3a42d2aab3654c46$var$$g(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $3a42d2aab3654c46$var$wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case $3a42d2aab3654c46$var$xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $3a42d2aab3654c46$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($3a42d2aab3654c46$var$db(c) || $3a42d2aab3654c46$var$Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $3a42d2aab3654c46$var$$g(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $3a42d2aab3654c46$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $3a42d2aab3654c46$var$xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $3a42d2aab3654c46$var$Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if ($3a42d2aab3654c46$var$db(d) || $3a42d2aab3654c46$var$Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $3a42d2aab3654c46$var$$g(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), $3a42d2aab3654c46$var$J && $3a42d2aab3654c46$var$Hg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            $3a42d2aab3654c46$var$J && $3a42d2aab3654c46$var$Hg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $3a42d2aab3654c46$var$J && $3a42d2aab3654c46$var$Hg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $3a42d2aab3654c46$var$Ka(h);
        if ("function" !== typeof l) throw Error($3a42d2aab3654c46$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($3a42d2aab3654c46$var$p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), $3a42d2aab3654c46$var$J && $3a42d2aab3654c46$var$Hg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            $3a42d2aab3654c46$var$J && $3a42d2aab3654c46$var$Hg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $3a42d2aab3654c46$var$J && $3a42d2aab3654c46$var$Hg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $3a42d2aab3654c46$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $3a42d2aab3654c46$var$wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $3a42d2aab3654c46$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $3a42d2aab3654c46$var$Ha && $3a42d2aab3654c46$var$ah(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $3a42d2aab3654c46$var$Zg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $3a42d2aab3654c46$var$ya ? (d = $3a42d2aab3654c46$var$gh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $3a42d2aab3654c46$var$eh(f.type, f.key, f.props, null, a.mode, h), h.ref = $3a42d2aab3654c46$var$Zg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $3a42d2aab3654c46$var$xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $3a42d2aab3654c46$var$fh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $3a42d2aab3654c46$var$Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($3a42d2aab3654c46$var$db(f)) return m(a, d, f, h);
            if ($3a42d2aab3654c46$var$Ka(f)) return w(a, d, f, h);
            $3a42d2aab3654c46$var$$g(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $3a42d2aab3654c46$var$dh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $3a42d2aab3654c46$var$hh = $3a42d2aab3654c46$var$bh(!0), $3a42d2aab3654c46$var$ih = $3a42d2aab3654c46$var$bh(!1), $3a42d2aab3654c46$var$jh = $3a42d2aab3654c46$var$hg(null), $3a42d2aab3654c46$var$kh = null, $3a42d2aab3654c46$var$lh = null, $3a42d2aab3654c46$var$mh = null;
function $3a42d2aab3654c46$var$nh() {
    $3a42d2aab3654c46$var$mh = $3a42d2aab3654c46$var$lh = $3a42d2aab3654c46$var$kh = null;
}
function $3a42d2aab3654c46$var$oh(a) {
    var b = $3a42d2aab3654c46$var$jh.current;
    $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$jh);
    a._currentValue = b;
}
function $3a42d2aab3654c46$var$ph(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $3a42d2aab3654c46$var$qh(a, b) {
    $3a42d2aab3654c46$var$kh = a;
    $3a42d2aab3654c46$var$mh = $3a42d2aab3654c46$var$lh = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($3a42d2aab3654c46$var$rh = !0), a.firstContext = null);
}
function $3a42d2aab3654c46$var$sh(a) {
    var b = a._currentValue;
    if ($3a42d2aab3654c46$var$mh !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $3a42d2aab3654c46$var$lh) {
            if (null === $3a42d2aab3654c46$var$kh) throw Error($3a42d2aab3654c46$var$p(308));
            $3a42d2aab3654c46$var$lh = a;
            $3a42d2aab3654c46$var$kh.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $3a42d2aab3654c46$var$lh = $3a42d2aab3654c46$var$lh.next = a;
    }
    return b;
}
var $3a42d2aab3654c46$var$th = null;
function $3a42d2aab3654c46$var$uh(a) {
    null === $3a42d2aab3654c46$var$th ? $3a42d2aab3654c46$var$th = [
        a
    ] : $3a42d2aab3654c46$var$th.push(a);
}
function $3a42d2aab3654c46$var$vh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $3a42d2aab3654c46$var$uh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $3a42d2aab3654c46$var$wh(a, d);
}
function $3a42d2aab3654c46$var$wh(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $3a42d2aab3654c46$var$xh = !1;
function $3a42d2aab3654c46$var$yh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $3a42d2aab3654c46$var$zh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $3a42d2aab3654c46$var$Ah(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $3a42d2aab3654c46$var$Bh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($3a42d2aab3654c46$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $3a42d2aab3654c46$var$wh(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $3a42d2aab3654c46$var$uh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $3a42d2aab3654c46$var$wh(a, c);
}
function $3a42d2aab3654c46$var$Ch(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $3a42d2aab3654c46$var$Oc(a, c);
    }
}
function $3a42d2aab3654c46$var$Dh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $3a42d2aab3654c46$var$Eh(a, b, c, d) {
    var e = a.updateQueue;
    $3a42d2aab3654c46$var$xh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = $3a42d2aab3654c46$var$u({}, q, r);
                            break a;
                        case 2:
                            $3a42d2aab3654c46$var$xh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $3a42d2aab3654c46$var$Fh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $3a42d2aab3654c46$var$Gh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($3a42d2aab3654c46$var$p(191, e));
            e.call(d);
        }
    }
}
var $3a42d2aab3654c46$var$Hh = {}, $3a42d2aab3654c46$var$Ih = $3a42d2aab3654c46$var$hg($3a42d2aab3654c46$var$Hh), $3a42d2aab3654c46$var$Jh = $3a42d2aab3654c46$var$hg($3a42d2aab3654c46$var$Hh), $3a42d2aab3654c46$var$Kh = $3a42d2aab3654c46$var$hg($3a42d2aab3654c46$var$Hh);
function $3a42d2aab3654c46$var$Lh(a) {
    if (a === $3a42d2aab3654c46$var$Hh) throw Error($3a42d2aab3654c46$var$p(174));
    return a;
}
function $3a42d2aab3654c46$var$Mh(a, b) {
    $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$Kh, b);
    $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$Jh, a);
    $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$Ih, $3a42d2aab3654c46$var$Hh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $3a42d2aab3654c46$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $3a42d2aab3654c46$var$kb(b, a);
    }
    $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$Ih);
    $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$Ih, b);
}
function $3a42d2aab3654c46$var$Nh() {
    $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$Ih);
    $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$Jh);
    $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$Kh);
}
function $3a42d2aab3654c46$var$Oh(a) {
    $3a42d2aab3654c46$var$Lh($3a42d2aab3654c46$var$Kh.current);
    var b = $3a42d2aab3654c46$var$Lh($3a42d2aab3654c46$var$Ih.current);
    var c = $3a42d2aab3654c46$var$kb(b, a.type);
    b !== c && ($3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$Jh, a), $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$Ih, c));
}
function $3a42d2aab3654c46$var$Ph(a) {
    $3a42d2aab3654c46$var$Jh.current === a && ($3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$Ih), $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$Jh));
}
var $3a42d2aab3654c46$var$L = $3a42d2aab3654c46$var$hg(0);
function $3a42d2aab3654c46$var$Qh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $3a42d2aab3654c46$var$Rh = [];
function $3a42d2aab3654c46$var$Sh() {
    for(var a = 0; a < $3a42d2aab3654c46$var$Rh.length; a++)$3a42d2aab3654c46$var$Rh[a]._workInProgressVersionPrimary = null;
    $3a42d2aab3654c46$var$Rh.length = 0;
}
var $3a42d2aab3654c46$var$Th = $3a42d2aab3654c46$var$va.ReactCurrentDispatcher, $3a42d2aab3654c46$var$Uh = $3a42d2aab3654c46$var$va.ReactCurrentBatchConfig, $3a42d2aab3654c46$var$Vh = 0, $3a42d2aab3654c46$var$M = null, $3a42d2aab3654c46$var$N = null, $3a42d2aab3654c46$var$O = null, $3a42d2aab3654c46$var$Wh = !1, $3a42d2aab3654c46$var$Xh = !1, $3a42d2aab3654c46$var$Yh = 0, $3a42d2aab3654c46$var$Zh = 0;
function $3a42d2aab3654c46$var$P() {
    throw Error($3a42d2aab3654c46$var$p(321));
}
function $3a42d2aab3654c46$var$$h(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$3a42d2aab3654c46$var$Ve(a[c], b[c])) return !1;
    return !0;
}
function $3a42d2aab3654c46$var$ai(a, b, c, d, e, f) {
    $3a42d2aab3654c46$var$Vh = f;
    $3a42d2aab3654c46$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $3a42d2aab3654c46$var$Th.current = null === a || null === a.memoizedState ? $3a42d2aab3654c46$var$bi : $3a42d2aab3654c46$var$ci;
    a = c(d, e);
    if ($3a42d2aab3654c46$var$Xh) {
        f = 0;
        do {
            $3a42d2aab3654c46$var$Xh = !1;
            $3a42d2aab3654c46$var$Yh = 0;
            if (25 <= f) throw Error($3a42d2aab3654c46$var$p(301));
            f += 1;
            $3a42d2aab3654c46$var$O = $3a42d2aab3654c46$var$N = null;
            b.updateQueue = null;
            $3a42d2aab3654c46$var$Th.current = $3a42d2aab3654c46$var$di;
            a = c(d, e);
        }while ($3a42d2aab3654c46$var$Xh);
    }
    $3a42d2aab3654c46$var$Th.current = $3a42d2aab3654c46$var$ei;
    b = null !== $3a42d2aab3654c46$var$N && null !== $3a42d2aab3654c46$var$N.next;
    $3a42d2aab3654c46$var$Vh = 0;
    $3a42d2aab3654c46$var$O = $3a42d2aab3654c46$var$N = $3a42d2aab3654c46$var$M = null;
    $3a42d2aab3654c46$var$Wh = !1;
    if (b) throw Error($3a42d2aab3654c46$var$p(300));
    return a;
}
function $3a42d2aab3654c46$var$fi() {
    var a = 0 !== $3a42d2aab3654c46$var$Yh;
    $3a42d2aab3654c46$var$Yh = 0;
    return a;
}
function $3a42d2aab3654c46$var$gi() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $3a42d2aab3654c46$var$O ? $3a42d2aab3654c46$var$M.memoizedState = $3a42d2aab3654c46$var$O = a : $3a42d2aab3654c46$var$O = $3a42d2aab3654c46$var$O.next = a;
    return $3a42d2aab3654c46$var$O;
}
function $3a42d2aab3654c46$var$hi() {
    if (null === $3a42d2aab3654c46$var$N) {
        var a = $3a42d2aab3654c46$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $3a42d2aab3654c46$var$N.next;
    var b = null === $3a42d2aab3654c46$var$O ? $3a42d2aab3654c46$var$M.memoizedState : $3a42d2aab3654c46$var$O.next;
    if (null !== b) $3a42d2aab3654c46$var$O = b, $3a42d2aab3654c46$var$N = a;
    else {
        if (null === a) throw Error($3a42d2aab3654c46$var$p(310));
        $3a42d2aab3654c46$var$N = a;
        a = {
            memoizedState: $3a42d2aab3654c46$var$N.memoizedState,
            baseState: $3a42d2aab3654c46$var$N.baseState,
            baseQueue: $3a42d2aab3654c46$var$N.baseQueue,
            queue: $3a42d2aab3654c46$var$N.queue,
            next: null
        };
        null === $3a42d2aab3654c46$var$O ? $3a42d2aab3654c46$var$M.memoizedState = $3a42d2aab3654c46$var$O = a : $3a42d2aab3654c46$var$O = $3a42d2aab3654c46$var$O.next = a;
    }
    return $3a42d2aab3654c46$var$O;
}
function $3a42d2aab3654c46$var$ii(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $3a42d2aab3654c46$var$ji(a) {
    var b = $3a42d2aab3654c46$var$hi(), c = b.queue;
    if (null === c) throw Error($3a42d2aab3654c46$var$p(311));
    c.lastRenderedReducer = a;
    var d = $3a42d2aab3654c46$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($3a42d2aab3654c46$var$Vh & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $3a42d2aab3654c46$var$M.lanes |= n;
                $3a42d2aab3654c46$var$Fh |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $3a42d2aab3654c46$var$Ve(d, b.memoizedState) || ($3a42d2aab3654c46$var$rh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $3a42d2aab3654c46$var$M.lanes |= f, $3a42d2aab3654c46$var$Fh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $3a42d2aab3654c46$var$ki(a) {
    var b = $3a42d2aab3654c46$var$hi(), c = b.queue;
    if (null === c) throw Error($3a42d2aab3654c46$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $3a42d2aab3654c46$var$Ve(f, b.memoizedState) || ($3a42d2aab3654c46$var$rh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $3a42d2aab3654c46$var$li() {}
function $3a42d2aab3654c46$var$mi(a, b) {
    var c = $3a42d2aab3654c46$var$M, d = $3a42d2aab3654c46$var$hi(), e = b(), f = !$3a42d2aab3654c46$var$Ve(d.memoizedState, e);
    f && (d.memoizedState = e, $3a42d2aab3654c46$var$rh = !0);
    d = d.queue;
    $3a42d2aab3654c46$var$ni($3a42d2aab3654c46$var$oi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $3a42d2aab3654c46$var$O && $3a42d2aab3654c46$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $3a42d2aab3654c46$var$pi(9, $3a42d2aab3654c46$var$qi.bind(null, c, d, e, b), void 0, null);
        if (null === $3a42d2aab3654c46$var$Q) throw Error($3a42d2aab3654c46$var$p(349));
        0 !== ($3a42d2aab3654c46$var$Vh & 30) || $3a42d2aab3654c46$var$ri(c, b, e);
    }
    return e;
}
function $3a42d2aab3654c46$var$ri(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $3a42d2aab3654c46$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $3a42d2aab3654c46$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $3a42d2aab3654c46$var$qi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $3a42d2aab3654c46$var$si(b) && $3a42d2aab3654c46$var$ti(a);
}
function $3a42d2aab3654c46$var$oi(a, b, c) {
    return c(function() {
        $3a42d2aab3654c46$var$si(b) && $3a42d2aab3654c46$var$ti(a);
    });
}
function $3a42d2aab3654c46$var$si(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$3a42d2aab3654c46$var$Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function $3a42d2aab3654c46$var$ti(a) {
    var b = $3a42d2aab3654c46$var$wh(a, 1);
    null !== b && $3a42d2aab3654c46$var$ui(b, a, 1, -1);
}
function $3a42d2aab3654c46$var$vi(a) {
    var b = $3a42d2aab3654c46$var$gi();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $3a42d2aab3654c46$var$ii,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $3a42d2aab3654c46$var$wi.bind(null, $3a42d2aab3654c46$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $3a42d2aab3654c46$var$pi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $3a42d2aab3654c46$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $3a42d2aab3654c46$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $3a42d2aab3654c46$var$xi() {
    return $3a42d2aab3654c46$var$hi().memoizedState;
}
function $3a42d2aab3654c46$var$Ai(a, b, c, d) {
    var e = $3a42d2aab3654c46$var$gi();
    $3a42d2aab3654c46$var$M.flags |= a;
    e.memoizedState = $3a42d2aab3654c46$var$pi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $3a42d2aab3654c46$var$Bi(a, b, c, d) {
    var e = $3a42d2aab3654c46$var$hi();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $3a42d2aab3654c46$var$N) {
        var g = $3a42d2aab3654c46$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $3a42d2aab3654c46$var$$h(d, g.deps)) {
            e.memoizedState = $3a42d2aab3654c46$var$pi(b, c, f, d);
            return;
        }
    }
    $3a42d2aab3654c46$var$M.flags |= a;
    e.memoizedState = $3a42d2aab3654c46$var$pi(1 | b, c, f, d);
}
function $3a42d2aab3654c46$var$Ci(a, b) {
    return $3a42d2aab3654c46$var$Ai(8390656, 8, a, b);
}
function $3a42d2aab3654c46$var$ni(a, b) {
    return $3a42d2aab3654c46$var$Bi(2048, 8, a, b);
}
function $3a42d2aab3654c46$var$Di(a, b) {
    return $3a42d2aab3654c46$var$Bi(4, 2, a, b);
}
function $3a42d2aab3654c46$var$Ei(a, b) {
    return $3a42d2aab3654c46$var$Bi(4, 4, a, b);
}
function $3a42d2aab3654c46$var$Fi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $3a42d2aab3654c46$var$Gi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $3a42d2aab3654c46$var$Bi(4, 4, $3a42d2aab3654c46$var$Fi.bind(null, b, a), c);
}
function $3a42d2aab3654c46$var$Hi() {}
function $3a42d2aab3654c46$var$Ii(a, b) {
    var c = $3a42d2aab3654c46$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $3a42d2aab3654c46$var$$h(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3a42d2aab3654c46$var$Ji(a, b) {
    var c = $3a42d2aab3654c46$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $3a42d2aab3654c46$var$$h(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3a42d2aab3654c46$var$Ki(a, b, c) {
    if (0 === ($3a42d2aab3654c46$var$Vh & 21)) return a.baseState && (a.baseState = !1, $3a42d2aab3654c46$var$rh = !0), a.memoizedState = c;
    $3a42d2aab3654c46$var$Ve(c, b) || (c = $3a42d2aab3654c46$var$Kc(), $3a42d2aab3654c46$var$M.lanes |= c, $3a42d2aab3654c46$var$Fh |= c, a.baseState = !0);
    return b;
}
function $3a42d2aab3654c46$var$Li(a, b) {
    var c = $3a42d2aab3654c46$var$E;
    $3a42d2aab3654c46$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $3a42d2aab3654c46$var$Uh.transition;
    $3a42d2aab3654c46$var$Uh.transition = {};
    try {
        a(!1), b();
    } finally{
        $3a42d2aab3654c46$var$E = c, $3a42d2aab3654c46$var$Uh.transition = d;
    }
}
function $3a42d2aab3654c46$var$Mi() {
    return $3a42d2aab3654c46$var$hi().memoizedState;
}
function $3a42d2aab3654c46$var$Ni(a, b, c) {
    var d = $3a42d2aab3654c46$var$Oi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3a42d2aab3654c46$var$Pi(a)) $3a42d2aab3654c46$var$Qi(b, c);
    else if (c = $3a42d2aab3654c46$var$vh(a, b, c, d), null !== c) {
        var e = $3a42d2aab3654c46$var$Ri();
        $3a42d2aab3654c46$var$ui(c, a, d, e);
        $3a42d2aab3654c46$var$Si(c, b, d);
    }
    $3a42d2aab3654c46$var$yc(a, d);
}
function $3a42d2aab3654c46$var$wi(a, b, c) {
    var d = $3a42d2aab3654c46$var$Oi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3a42d2aab3654c46$var$Pi(a)) $3a42d2aab3654c46$var$Qi(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($3a42d2aab3654c46$var$Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $3a42d2aab3654c46$var$uh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $3a42d2aab3654c46$var$vh(a, b, e, d);
        null !== c && (e = $3a42d2aab3654c46$var$Ri(), $3a42d2aab3654c46$var$ui(c, a, d, e), $3a42d2aab3654c46$var$Si(c, b, d));
    }
    $3a42d2aab3654c46$var$yc(a, d);
}
function $3a42d2aab3654c46$var$Pi(a) {
    var b = a.alternate;
    return a === $3a42d2aab3654c46$var$M || null !== b && b === $3a42d2aab3654c46$var$M;
}
function $3a42d2aab3654c46$var$Qi(a, b) {
    $3a42d2aab3654c46$var$Xh = $3a42d2aab3654c46$var$Wh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $3a42d2aab3654c46$var$Si(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $3a42d2aab3654c46$var$Oc(a, c);
    }
}
var $3a42d2aab3654c46$var$ei = {
    readContext: $3a42d2aab3654c46$var$sh,
    useCallback: $3a42d2aab3654c46$var$P,
    useContext: $3a42d2aab3654c46$var$P,
    useEffect: $3a42d2aab3654c46$var$P,
    useImperativeHandle: $3a42d2aab3654c46$var$P,
    useInsertionEffect: $3a42d2aab3654c46$var$P,
    useLayoutEffect: $3a42d2aab3654c46$var$P,
    useMemo: $3a42d2aab3654c46$var$P,
    useReducer: $3a42d2aab3654c46$var$P,
    useRef: $3a42d2aab3654c46$var$P,
    useState: $3a42d2aab3654c46$var$P,
    useDebugValue: $3a42d2aab3654c46$var$P,
    useDeferredValue: $3a42d2aab3654c46$var$P,
    useTransition: $3a42d2aab3654c46$var$P,
    useMutableSource: $3a42d2aab3654c46$var$P,
    useSyncExternalStore: $3a42d2aab3654c46$var$P,
    useId: $3a42d2aab3654c46$var$P,
    unstable_isNewReconciler: !1
}, $3a42d2aab3654c46$var$bi = {
    readContext: $3a42d2aab3654c46$var$sh,
    useCallback: function(a, b) {
        $3a42d2aab3654c46$var$gi().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $3a42d2aab3654c46$var$sh,
    useEffect: $3a42d2aab3654c46$var$Ci,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $3a42d2aab3654c46$var$Ai(4194308, 4, $3a42d2aab3654c46$var$Fi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $3a42d2aab3654c46$var$Ai(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $3a42d2aab3654c46$var$Ai(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $3a42d2aab3654c46$var$gi();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $3a42d2aab3654c46$var$gi();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $3a42d2aab3654c46$var$Ni.bind(null, $3a42d2aab3654c46$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $3a42d2aab3654c46$var$gi();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $3a42d2aab3654c46$var$vi,
    useDebugValue: $3a42d2aab3654c46$var$Hi,
    useDeferredValue: function(a) {
        return $3a42d2aab3654c46$var$gi().memoizedState = a;
    },
    useTransition: function() {
        var a = $3a42d2aab3654c46$var$vi(!1), b = a[0];
        a = $3a42d2aab3654c46$var$Li.bind(null, a[1]);
        $3a42d2aab3654c46$var$gi().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $3a42d2aab3654c46$var$M, e = $3a42d2aab3654c46$var$gi();
        if ($3a42d2aab3654c46$var$J) {
            if (void 0 === c) throw Error($3a42d2aab3654c46$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $3a42d2aab3654c46$var$Q) throw Error($3a42d2aab3654c46$var$p(349));
            0 !== ($3a42d2aab3654c46$var$Vh & 30) || $3a42d2aab3654c46$var$ri(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $3a42d2aab3654c46$var$Ci($3a42d2aab3654c46$var$oi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $3a42d2aab3654c46$var$pi(9, $3a42d2aab3654c46$var$qi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $3a42d2aab3654c46$var$gi(), b = $3a42d2aab3654c46$var$Q.identifierPrefix;
        if ($3a42d2aab3654c46$var$J) {
            var c = $3a42d2aab3654c46$var$Gg;
            var d = $3a42d2aab3654c46$var$Fg;
            c = (d & ~(1 << 32 - $3a42d2aab3654c46$var$Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $3a42d2aab3654c46$var$Yh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $3a42d2aab3654c46$var$Zh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $3a42d2aab3654c46$var$ci = {
    readContext: $3a42d2aab3654c46$var$sh,
    useCallback: $3a42d2aab3654c46$var$Ii,
    useContext: $3a42d2aab3654c46$var$sh,
    useEffect: $3a42d2aab3654c46$var$ni,
    useImperativeHandle: $3a42d2aab3654c46$var$Gi,
    useInsertionEffect: $3a42d2aab3654c46$var$Di,
    useLayoutEffect: $3a42d2aab3654c46$var$Ei,
    useMemo: $3a42d2aab3654c46$var$Ji,
    useReducer: $3a42d2aab3654c46$var$ji,
    useRef: $3a42d2aab3654c46$var$xi,
    useState: function() {
        return $3a42d2aab3654c46$var$ji($3a42d2aab3654c46$var$ii);
    },
    useDebugValue: $3a42d2aab3654c46$var$Hi,
    useDeferredValue: function(a) {
        var b = $3a42d2aab3654c46$var$hi();
        return $3a42d2aab3654c46$var$Ki(b, $3a42d2aab3654c46$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $3a42d2aab3654c46$var$ji($3a42d2aab3654c46$var$ii)[0], b = $3a42d2aab3654c46$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $3a42d2aab3654c46$var$li,
    useSyncExternalStore: $3a42d2aab3654c46$var$mi,
    useId: $3a42d2aab3654c46$var$Mi,
    unstable_isNewReconciler: !1
}, $3a42d2aab3654c46$var$di = {
    readContext: $3a42d2aab3654c46$var$sh,
    useCallback: $3a42d2aab3654c46$var$Ii,
    useContext: $3a42d2aab3654c46$var$sh,
    useEffect: $3a42d2aab3654c46$var$ni,
    useImperativeHandle: $3a42d2aab3654c46$var$Gi,
    useInsertionEffect: $3a42d2aab3654c46$var$Di,
    useLayoutEffect: $3a42d2aab3654c46$var$Ei,
    useMemo: $3a42d2aab3654c46$var$Ji,
    useReducer: $3a42d2aab3654c46$var$ki,
    useRef: $3a42d2aab3654c46$var$xi,
    useState: function() {
        return $3a42d2aab3654c46$var$ki($3a42d2aab3654c46$var$ii);
    },
    useDebugValue: $3a42d2aab3654c46$var$Hi,
    useDeferredValue: function(a) {
        var b = $3a42d2aab3654c46$var$hi();
        return null === $3a42d2aab3654c46$var$N ? b.memoizedState = a : $3a42d2aab3654c46$var$Ki(b, $3a42d2aab3654c46$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $3a42d2aab3654c46$var$ki($3a42d2aab3654c46$var$ii)[0], b = $3a42d2aab3654c46$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $3a42d2aab3654c46$var$li,
    useSyncExternalStore: $3a42d2aab3654c46$var$mi,
    useId: $3a42d2aab3654c46$var$Mi,
    unstable_isNewReconciler: !1
}, $3a42d2aab3654c46$var$Ti = $iZu5g.unstable_now, $3a42d2aab3654c46$var$Ui = 0, $3a42d2aab3654c46$var$Vi = -1, $3a42d2aab3654c46$var$Wi = -1, $3a42d2aab3654c46$var$Xi = -1, $3a42d2aab3654c46$var$Yi = !1, $3a42d2aab3654c46$var$Zi = !1;
function $3a42d2aab3654c46$var$$i(a, b) {
    if (0 <= $3a42d2aab3654c46$var$Wi) {
        var c = $3a42d2aab3654c46$var$Ti() - $3a42d2aab3654c46$var$Wi;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        $3a42d2aab3654c46$var$Wi = -1;
    }
}
function $3a42d2aab3654c46$var$aj(a) {
    if (0 <= $3a42d2aab3654c46$var$Vi) {
        var b = $3a42d2aab3654c46$var$Ti() - $3a42d2aab3654c46$var$Vi;
        $3a42d2aab3654c46$var$Vi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function $3a42d2aab3654c46$var$bj(a) {
    if (0 <= $3a42d2aab3654c46$var$Xi) {
        var b = $3a42d2aab3654c46$var$Ti() - $3a42d2aab3654c46$var$Xi;
        $3a42d2aab3654c46$var$Xi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function $3a42d2aab3654c46$var$cj() {
    $3a42d2aab3654c46$var$Vi = $3a42d2aab3654c46$var$Ti();
}
function $3a42d2aab3654c46$var$dj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function $3a42d2aab3654c46$var$ej(a, b) {
    if (a && a.defaultProps) {
        b = $3a42d2aab3654c46$var$u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $3a42d2aab3654c46$var$fj(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $3a42d2aab3654c46$var$u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $3a42d2aab3654c46$var$gj = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $3a42d2aab3654c46$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $3a42d2aab3654c46$var$Ri(), e = $3a42d2aab3654c46$var$Oi(a), f = $3a42d2aab3654c46$var$Ah(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $3a42d2aab3654c46$var$Bh(a, f, e);
        null !== b && ($3a42d2aab3654c46$var$ui(b, a, e, d), $3a42d2aab3654c46$var$Ch(b, a, e));
        $3a42d2aab3654c46$var$yc(a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $3a42d2aab3654c46$var$Ri(), e = $3a42d2aab3654c46$var$Oi(a), f = $3a42d2aab3654c46$var$Ah(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $3a42d2aab3654c46$var$Bh(a, f, e);
        null !== b && ($3a42d2aab3654c46$var$ui(b, a, e, d), $3a42d2aab3654c46$var$Ch(b, a, e));
        $3a42d2aab3654c46$var$yc(a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $3a42d2aab3654c46$var$Ri(), d = $3a42d2aab3654c46$var$Oi(a), e = $3a42d2aab3654c46$var$Ah(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $3a42d2aab3654c46$var$Bh(a, e, d);
        null !== b && ($3a42d2aab3654c46$var$ui(b, a, d, c), $3a42d2aab3654c46$var$Ch(b, a, d));
        null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markForceUpdateScheduled && $3a42d2aab3654c46$var$B.markForceUpdateScheduled(a, d);
    }
};
function $3a42d2aab3654c46$var$hj(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$3a42d2aab3654c46$var$We(c, d) || !$3a42d2aab3654c46$var$We(e, f) : !0;
}
function $3a42d2aab3654c46$var$ij(a, b, c) {
    var d = !1, e = $3a42d2aab3654c46$var$ig;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $3a42d2aab3654c46$var$sh(f) : (e = $3a42d2aab3654c46$var$mg(b) ? $3a42d2aab3654c46$var$kg : $3a42d2aab3654c46$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $3a42d2aab3654c46$var$lg(a, e) : $3a42d2aab3654c46$var$ig);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $3a42d2aab3654c46$var$gj;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $3a42d2aab3654c46$var$jj(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $3a42d2aab3654c46$var$gj.enqueueReplaceState(b, b.state, null);
}
function $3a42d2aab3654c46$var$kj(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $3a42d2aab3654c46$var$yh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $3a42d2aab3654c46$var$sh(f) : (f = $3a42d2aab3654c46$var$mg(b) ? $3a42d2aab3654c46$var$kg : $3a42d2aab3654c46$var$I.current, e.context = $3a42d2aab3654c46$var$lg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($3a42d2aab3654c46$var$fj(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $3a42d2aab3654c46$var$gj.enqueueReplaceState(e, e.state, null), $3a42d2aab3654c46$var$Eh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $3a42d2aab3654c46$var$lj(a, b) {
    try {
        var c = "", d = b;
        do c += $3a42d2aab3654c46$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $3a42d2aab3654c46$var$mj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $3a42d2aab3654c46$var$nj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $3a42d2aab3654c46$var$oj = "function" === typeof WeakMap ? WeakMap : Map;
function $3a42d2aab3654c46$var$pj(a, b, c) {
    c = $3a42d2aab3654c46$var$Ah(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $3a42d2aab3654c46$var$qj || ($3a42d2aab3654c46$var$qj = !0, $3a42d2aab3654c46$var$rj = d);
        $3a42d2aab3654c46$var$nj(a, b);
    };
    return c;
}
function $3a42d2aab3654c46$var$sj(a, b, c) {
    c = $3a42d2aab3654c46$var$Ah(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $3a42d2aab3654c46$var$nj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $3a42d2aab3654c46$var$nj(a, b);
        "function" !== typeof d && (null === $3a42d2aab3654c46$var$tj ? $3a42d2aab3654c46$var$tj = new Set([
            this
        ]) : $3a42d2aab3654c46$var$tj.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $3a42d2aab3654c46$var$uj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $3a42d2aab3654c46$var$oj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = $3a42d2aab3654c46$var$vj.bind(null, a, b, c), $3a42d2aab3654c46$var$mc && $3a42d2aab3654c46$var$wj(a, c), b.then(d, d));
}
function $3a42d2aab3654c46$var$xj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $3a42d2aab3654c46$var$yj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $3a42d2aab3654c46$var$Ah(-1, 1), b.tag = 2, $3a42d2aab3654c46$var$Bh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $3a42d2aab3654c46$var$zj = $3a42d2aab3654c46$var$va.ReactCurrentOwner, $3a42d2aab3654c46$var$rh = !1;
function $3a42d2aab3654c46$var$Aj(a, b, c, d) {
    b.child = null === a ? $3a42d2aab3654c46$var$ih(b, null, c, d) : $3a42d2aab3654c46$var$hh(b, a.child, c, d);
}
function $3a42d2aab3654c46$var$Bj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $3a42d2aab3654c46$var$qh(b, e);
    $3a42d2aab3654c46$var$sc(b);
    d = $3a42d2aab3654c46$var$ai(a, b, c, d, f, e);
    c = $3a42d2aab3654c46$var$fi();
    $3a42d2aab3654c46$var$tc();
    if (null !== a && !$3a42d2aab3654c46$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $3a42d2aab3654c46$var$Cj(a, b, e);
    $3a42d2aab3654c46$var$J && c && $3a42d2aab3654c46$var$Jg(b);
    b.flags |= 1;
    $3a42d2aab3654c46$var$Aj(a, b, d, e);
    return b.child;
}
function $3a42d2aab3654c46$var$Dj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$3a42d2aab3654c46$var$Ej(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $3a42d2aab3654c46$var$Fj(a, b, f, d, e);
        a = $3a42d2aab3654c46$var$eh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $3a42d2aab3654c46$var$We;
        if (c(g, d) && a.ref === b.ref) return $3a42d2aab3654c46$var$Cj(a, b, e);
    }
    b.flags |= 1;
    a = $3a42d2aab3654c46$var$ch(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $3a42d2aab3654c46$var$Fj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($3a42d2aab3654c46$var$We(f, d) && a.ref === b.ref) {
            if ($3a42d2aab3654c46$var$rh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($3a42d2aab3654c46$var$rh = !0);
            else return b.lanes = a.lanes, $3a42d2aab3654c46$var$Cj(a, b, e);
        }
    }
    return $3a42d2aab3654c46$var$Gj(a, b, c, d, e);
}
function $3a42d2aab3654c46$var$Hj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$Ij, $3a42d2aab3654c46$var$Jj), $3a42d2aab3654c46$var$Jj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$Ij, $3a42d2aab3654c46$var$Jj), $3a42d2aab3654c46$var$Jj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$Ij, $3a42d2aab3654c46$var$Jj);
            $3a42d2aab3654c46$var$Jj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$Ij, $3a42d2aab3654c46$var$Jj), $3a42d2aab3654c46$var$Jj |= d;
    $3a42d2aab3654c46$var$Aj(a, b, e, c);
    return b.child;
}
function $3a42d2aab3654c46$var$Kj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $3a42d2aab3654c46$var$Gj(a, b, c, d, e) {
    var f = $3a42d2aab3654c46$var$mg(c) ? $3a42d2aab3654c46$var$kg : $3a42d2aab3654c46$var$I.current;
    f = $3a42d2aab3654c46$var$lg(b, f);
    $3a42d2aab3654c46$var$qh(b, e);
    $3a42d2aab3654c46$var$sc(b);
    c = $3a42d2aab3654c46$var$ai(a, b, c, d, f, e);
    d = $3a42d2aab3654c46$var$fi();
    $3a42d2aab3654c46$var$tc();
    if (null !== a && !$3a42d2aab3654c46$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $3a42d2aab3654c46$var$Cj(a, b, e);
    $3a42d2aab3654c46$var$J && d && $3a42d2aab3654c46$var$Jg(b);
    b.flags |= 1;
    $3a42d2aab3654c46$var$Aj(a, b, c, e);
    return b.child;
}
function $3a42d2aab3654c46$var$Lj(a, b, c, d, e) {
    if ($3a42d2aab3654c46$var$mg(c)) {
        var f = !0;
        $3a42d2aab3654c46$var$qg(b);
    } else f = !1;
    $3a42d2aab3654c46$var$qh(b, e);
    if (null === b.stateNode) $3a42d2aab3654c46$var$Mj(a, b), $3a42d2aab3654c46$var$ij(b, c, d), $3a42d2aab3654c46$var$kj(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $3a42d2aab3654c46$var$sh(l) : (l = $3a42d2aab3654c46$var$mg(c) ? $3a42d2aab3654c46$var$kg : $3a42d2aab3654c46$var$I.current, l = $3a42d2aab3654c46$var$lg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $3a42d2aab3654c46$var$jj(b, g, d, l);
        $3a42d2aab3654c46$var$xh = !1;
        var r = b.memoizedState;
        g.state = r;
        $3a42d2aab3654c46$var$Eh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $3a42d2aab3654c46$var$jg.current || $3a42d2aab3654c46$var$xh ? ("function" === typeof n && ($3a42d2aab3654c46$var$fj(b, c, n, d), k = b.memoizedState), (h = $3a42d2aab3654c46$var$xh || $3a42d2aab3654c46$var$hj(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $3a42d2aab3654c46$var$zh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $3a42d2aab3654c46$var$ej(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $3a42d2aab3654c46$var$sh(k) : (k = $3a42d2aab3654c46$var$mg(c) ? $3a42d2aab3654c46$var$kg : $3a42d2aab3654c46$var$I.current, k = $3a42d2aab3654c46$var$lg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $3a42d2aab3654c46$var$jj(b, g, d, k);
        $3a42d2aab3654c46$var$xh = !1;
        r = b.memoizedState;
        g.state = r;
        $3a42d2aab3654c46$var$Eh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || $3a42d2aab3654c46$var$jg.current || $3a42d2aab3654c46$var$xh ? ("function" === typeof z && ($3a42d2aab3654c46$var$fj(b, c, z, d), m = b.memoizedState), (l = $3a42d2aab3654c46$var$xh || $3a42d2aab3654c46$var$hj(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $3a42d2aab3654c46$var$Nj(a, b, c, d, f, e);
}
function $3a42d2aab3654c46$var$Nj(a, b, c, d, e, f) {
    $3a42d2aab3654c46$var$Kj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $3a42d2aab3654c46$var$rg(b, c, !1), $3a42d2aab3654c46$var$Cj(a, b, f);
    d = b.stateNode;
    $3a42d2aab3654c46$var$zj.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        $3a42d2aab3654c46$var$Wi = -1;
    } else $3a42d2aab3654c46$var$sc(b), h = d.render(), $3a42d2aab3654c46$var$tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = $3a42d2aab3654c46$var$hh(b, a.child, null, f), b.child = $3a42d2aab3654c46$var$hh(b, null, g, f)) : $3a42d2aab3654c46$var$Aj(a, b, h, f);
    b.memoizedState = d.state;
    e && $3a42d2aab3654c46$var$rg(b, c, !0);
    return b.child;
}
function $3a42d2aab3654c46$var$Oj(a) {
    var b = a.stateNode;
    b.pendingContext ? $3a42d2aab3654c46$var$og(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $3a42d2aab3654c46$var$og(a, b.context, !1);
    $3a42d2aab3654c46$var$Mh(a, b.containerInfo);
}
function $3a42d2aab3654c46$var$Rj(a, b, c, d, e) {
    $3a42d2aab3654c46$var$Wg();
    $3a42d2aab3654c46$var$Xg(e);
    b.flags |= 256;
    $3a42d2aab3654c46$var$Aj(a, b, c, d);
    return b.child;
}
var $3a42d2aab3654c46$var$Sj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $3a42d2aab3654c46$var$Tj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $3a42d2aab3654c46$var$Uj(a, b, c) {
    var d = b.pendingProps, e = $3a42d2aab3654c46$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$L, e & 1);
    if (null === a) {
        $3a42d2aab3654c46$var$Sg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = $3a42d2aab3654c46$var$Vj(g, d, 0, null), a = $3a42d2aab3654c46$var$gh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $3a42d2aab3654c46$var$Tj(c), b.memoizedState = $3a42d2aab3654c46$var$Sj, a) : $3a42d2aab3654c46$var$Wj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $3a42d2aab3654c46$var$Xj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = $3a42d2aab3654c46$var$ch(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $3a42d2aab3654c46$var$ch(h, f) : (f = $3a42d2aab3654c46$var$gh(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $3a42d2aab3654c46$var$Tj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $3a42d2aab3654c46$var$Sj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $3a42d2aab3654c46$var$ch(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $3a42d2aab3654c46$var$Wj(a, b) {
    b = $3a42d2aab3654c46$var$Vj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $3a42d2aab3654c46$var$Yj(a, b, c, d) {
    null !== d && $3a42d2aab3654c46$var$Xg(d);
    $3a42d2aab3654c46$var$hh(b, a.child, null, c);
    a = $3a42d2aab3654c46$var$Wj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $3a42d2aab3654c46$var$Xj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $3a42d2aab3654c46$var$mj(Error($3a42d2aab3654c46$var$p(422))), $3a42d2aab3654c46$var$Yj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $3a42d2aab3654c46$var$Vj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $3a42d2aab3654c46$var$gh(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $3a42d2aab3654c46$var$hh(b, a.child, null, g);
        b.child.memoizedState = $3a42d2aab3654c46$var$Tj(g);
        b.memoizedState = $3a42d2aab3654c46$var$Sj;
        return f;
    }
    if (0 === (b.mode & 1)) return $3a42d2aab3654c46$var$Yj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($3a42d2aab3654c46$var$p(419));
        d = $3a42d2aab3654c46$var$mj(f, d, void 0);
        return $3a42d2aab3654c46$var$Yj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($3a42d2aab3654c46$var$rh || h) {
        d = $3a42d2aab3654c46$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $3a42d2aab3654c46$var$wh(a, e), $3a42d2aab3654c46$var$ui(d, a, e, -1));
        }
        $3a42d2aab3654c46$var$Zj();
        d = $3a42d2aab3654c46$var$mj(Error($3a42d2aab3654c46$var$p(421)));
        return $3a42d2aab3654c46$var$Yj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $3a42d2aab3654c46$var$ak.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $3a42d2aab3654c46$var$Mg = $3a42d2aab3654c46$var$Zf(e.nextSibling);
    $3a42d2aab3654c46$var$Lg = b;
    $3a42d2aab3654c46$var$J = !0;
    $3a42d2aab3654c46$var$Ng = null;
    null !== a && ($3a42d2aab3654c46$var$Cg[$3a42d2aab3654c46$var$Dg++] = $3a42d2aab3654c46$var$Fg, $3a42d2aab3654c46$var$Cg[$3a42d2aab3654c46$var$Dg++] = $3a42d2aab3654c46$var$Gg, $3a42d2aab3654c46$var$Cg[$3a42d2aab3654c46$var$Dg++] = $3a42d2aab3654c46$var$Eg, $3a42d2aab3654c46$var$Fg = a.id, $3a42d2aab3654c46$var$Gg = a.overflow, $3a42d2aab3654c46$var$Eg = b);
    b = $3a42d2aab3654c46$var$Wj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $3a42d2aab3654c46$var$bk(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $3a42d2aab3654c46$var$ph(a.return, b, c);
}
function $3a42d2aab3654c46$var$ck(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $3a42d2aab3654c46$var$dk(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $3a42d2aab3654c46$var$Aj(a, b, d.children, c);
    d = $3a42d2aab3654c46$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $3a42d2aab3654c46$var$bk(a, c, b);
            else if (19 === a.tag) $3a42d2aab3654c46$var$bk(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $3a42d2aab3654c46$var$Qh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $3a42d2aab3654c46$var$ck(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $3a42d2aab3654c46$var$Qh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $3a42d2aab3654c46$var$ck(b, !0, c, null, f);
            break;
        case "together":
            $3a42d2aab3654c46$var$ck(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $3a42d2aab3654c46$var$Mj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $3a42d2aab3654c46$var$Cj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $3a42d2aab3654c46$var$Wi = -1;
    $3a42d2aab3654c46$var$Fh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($3a42d2aab3654c46$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $3a42d2aab3654c46$var$ch(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $3a42d2aab3654c46$var$ch(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $3a42d2aab3654c46$var$ek(a, b, c) {
    switch(b.tag){
        case 3:
            $3a42d2aab3654c46$var$Oj(b);
            $3a42d2aab3654c46$var$Wg();
            break;
        case 5:
            $3a42d2aab3654c46$var$Oh(b);
            break;
        case 1:
            $3a42d2aab3654c46$var$mg(b.type) && $3a42d2aab3654c46$var$qg(b);
            break;
        case 4:
            $3a42d2aab3654c46$var$Mh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$jh, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$L, $3a42d2aab3654c46$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $3a42d2aab3654c46$var$Uj(a, b, c);
                $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$L, $3a42d2aab3654c46$var$L.current & 1);
                a = $3a42d2aab3654c46$var$Cj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$L, $3a42d2aab3654c46$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $3a42d2aab3654c46$var$dk(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$L, $3a42d2aab3654c46$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $3a42d2aab3654c46$var$Hj(a, b, c);
    }
    return $3a42d2aab3654c46$var$Cj(a, b, c);
}
var $3a42d2aab3654c46$var$fk, $3a42d2aab3654c46$var$gk, $3a42d2aab3654c46$var$hk, $3a42d2aab3654c46$var$ik;
$3a42d2aab3654c46$var$fk = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$3a42d2aab3654c46$var$gk = function() {};
$3a42d2aab3654c46$var$hk = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $3a42d2aab3654c46$var$Lh($3a42d2aab3654c46$var$Ih.current);
        var f = null;
        switch(c){
            case "input":
                e = $3a42d2aab3654c46$var$Ya(a, e);
                d = $3a42d2aab3654c46$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $3a42d2aab3654c46$var$u({}, e, {
                    value: void 0
                });
                d = $3a42d2aab3654c46$var$u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $3a42d2aab3654c46$var$fb(a, e);
                d = $3a42d2aab3654c46$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $3a42d2aab3654c46$var$Pf);
        }
        $3a42d2aab3654c46$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($3a42d2aab3654c46$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($3a42d2aab3654c46$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $3a42d2aab3654c46$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$3a42d2aab3654c46$var$ik = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $3a42d2aab3654c46$var$jk(a, b) {
    if (!$3a42d2aab3654c46$var$J) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $3a42d2aab3654c46$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $3a42d2aab3654c46$var$kk(a, b, c) {
    var d = b.pendingProps;
    $3a42d2aab3654c46$var$Kg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $3a42d2aab3654c46$var$S(b), null;
        case 1:
            return $3a42d2aab3654c46$var$mg(b.type) && $3a42d2aab3654c46$var$ng(), $3a42d2aab3654c46$var$S(b), null;
        case 3:
            d = b.stateNode;
            $3a42d2aab3654c46$var$Nh();
            $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$jg);
            $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$I);
            $3a42d2aab3654c46$var$Sh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $3a42d2aab3654c46$var$Ug(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $3a42d2aab3654c46$var$Ng && ($3a42d2aab3654c46$var$lk($3a42d2aab3654c46$var$Ng), $3a42d2aab3654c46$var$Ng = null));
            $3a42d2aab3654c46$var$gk(a, b);
            $3a42d2aab3654c46$var$S(b);
            return null;
        case 5:
            $3a42d2aab3654c46$var$Ph(b);
            var e = $3a42d2aab3654c46$var$Lh($3a42d2aab3654c46$var$Kh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $3a42d2aab3654c46$var$hk(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($3a42d2aab3654c46$var$p(166));
                    $3a42d2aab3654c46$var$S(b);
                    return null;
                }
                a = $3a42d2aab3654c46$var$Lh($3a42d2aab3654c46$var$Ih.current);
                if ($3a42d2aab3654c46$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[$3a42d2aab3654c46$var$bg] = b;
                    d[$3a42d2aab3654c46$var$cg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            $3a42d2aab3654c46$var$F("cancel", d);
                            $3a42d2aab3654c46$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $3a42d2aab3654c46$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $3a42d2aab3654c46$var$zf.length; e++)$3a42d2aab3654c46$var$F($3a42d2aab3654c46$var$zf[e], d);
                            break;
                        case "source":
                            $3a42d2aab3654c46$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $3a42d2aab3654c46$var$F("error", d);
                            $3a42d2aab3654c46$var$F("load", d);
                            break;
                        case "details":
                            $3a42d2aab3654c46$var$F("toggle", d);
                            break;
                        case "input":
                            $3a42d2aab3654c46$var$Za(d, c);
                            $3a42d2aab3654c46$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            $3a42d2aab3654c46$var$F("invalid", d);
                            break;
                        case "textarea":
                            $3a42d2aab3654c46$var$gb(d, c), $3a42d2aab3654c46$var$F("invalid", d);
                    }
                    $3a42d2aab3654c46$var$ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && $3a42d2aab3654c46$var$Of(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && $3a42d2aab3654c46$var$Of(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : $3a42d2aab3654c46$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $3a42d2aab3654c46$var$F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            $3a42d2aab3654c46$var$Va(d);
                            $3a42d2aab3654c46$var$cb(d, c, !0);
                            break;
                        case "textarea":
                            $3a42d2aab3654c46$var$Va(d);
                            $3a42d2aab3654c46$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = $3a42d2aab3654c46$var$Pf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $3a42d2aab3654c46$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$3a42d2aab3654c46$var$bg] = b;
                    a[$3a42d2aab3654c46$var$cg] = d;
                    $3a42d2aab3654c46$var$fk(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $3a42d2aab3654c46$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $3a42d2aab3654c46$var$F("cancel", a);
                                $3a42d2aab3654c46$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $3a42d2aab3654c46$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $3a42d2aab3654c46$var$zf.length; e++)$3a42d2aab3654c46$var$F($3a42d2aab3654c46$var$zf[e], a);
                                e = d;
                                break;
                            case "source":
                                $3a42d2aab3654c46$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $3a42d2aab3654c46$var$F("error", a);
                                $3a42d2aab3654c46$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $3a42d2aab3654c46$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $3a42d2aab3654c46$var$Za(a, d);
                                e = $3a42d2aab3654c46$var$Ya(a, d);
                                $3a42d2aab3654c46$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $3a42d2aab3654c46$var$u({}, d, {
                                    value: void 0
                                });
                                $3a42d2aab3654c46$var$F("invalid", a);
                                break;
                            case "textarea":
                                $3a42d2aab3654c46$var$gb(a, d);
                                e = $3a42d2aab3654c46$var$fb(a, d);
                                $3a42d2aab3654c46$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $3a42d2aab3654c46$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $3a42d2aab3654c46$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $3a42d2aab3654c46$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $3a42d2aab3654c46$var$ob(a, k) : "number" === typeof k && $3a42d2aab3654c46$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($3a42d2aab3654c46$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $3a42d2aab3654c46$var$F("scroll", a) : null != k && $3a42d2aab3654c46$var$ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $3a42d2aab3654c46$var$Va(a);
                                $3a42d2aab3654c46$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $3a42d2aab3654c46$var$Va(a);
                                $3a42d2aab3654c46$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $3a42d2aab3654c46$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $3a42d2aab3654c46$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $3a42d2aab3654c46$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $3a42d2aab3654c46$var$Pf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $3a42d2aab3654c46$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $3a42d2aab3654c46$var$ik(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($3a42d2aab3654c46$var$p(166));
                a = $3a42d2aab3654c46$var$Lh($3a42d2aab3654c46$var$Kh.current);
                $3a42d2aab3654c46$var$Lh($3a42d2aab3654c46$var$Ih.current);
                if ($3a42d2aab3654c46$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[$3a42d2aab3654c46$var$bg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = $3a42d2aab3654c46$var$Lg, null !== f) switch(f.tag){
                            case 3:
                                $3a42d2aab3654c46$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && $3a42d2aab3654c46$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[$3a42d2aab3654c46$var$bg] = b, b.stateNode = d;
            }
            $3a42d2aab3654c46$var$S(b);
            return null;
        case 13:
            $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($3a42d2aab3654c46$var$J && null !== $3a42d2aab3654c46$var$Mg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $3a42d2aab3654c46$var$Vg(), $3a42d2aab3654c46$var$Wg(), b.flags |= 98560, f = !1;
                else if (f = $3a42d2aab3654c46$var$Ug(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($3a42d2aab3654c46$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($3a42d2aab3654c46$var$p(317));
                        f[$3a42d2aab3654c46$var$bg] = b;
                        $3a42d2aab3654c46$var$S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else $3a42d2aab3654c46$var$Wg(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, $3a42d2aab3654c46$var$S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== $3a42d2aab3654c46$var$Ng && ($3a42d2aab3654c46$var$lk($3a42d2aab3654c46$var$Ng), $3a42d2aab3654c46$var$Ng = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && $3a42d2aab3654c46$var$dj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($3a42d2aab3654c46$var$L.current & 1) ? 0 === $3a42d2aab3654c46$var$T && ($3a42d2aab3654c46$var$T = 3) : $3a42d2aab3654c46$var$Zj()));
            null !== b.updateQueue && (b.flags |= 4);
            $3a42d2aab3654c46$var$S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return $3a42d2aab3654c46$var$Nh(), $3a42d2aab3654c46$var$gk(a, b), null === a && $3a42d2aab3654c46$var$Gf(b.stateNode.containerInfo), $3a42d2aab3654c46$var$S(b), null;
        case 10:
            return $3a42d2aab3654c46$var$oh(b.type._context), $3a42d2aab3654c46$var$S(b), null;
        case 17:
            return $3a42d2aab3654c46$var$mg(b.type) && $3a42d2aab3654c46$var$ng(), $3a42d2aab3654c46$var$S(b), null;
        case 19:
            $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$L);
            f = b.memoizedState;
            if (null === f) return $3a42d2aab3654c46$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $3a42d2aab3654c46$var$jk(f, !1);
                else {
                    if (0 !== $3a42d2aab3654c46$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $3a42d2aab3654c46$var$Qh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $3a42d2aab3654c46$var$jk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$L, $3a42d2aab3654c46$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $3a42d2aab3654c46$var$A() > $3a42d2aab3654c46$var$mk && (b.flags |= 128, d = !0, $3a42d2aab3654c46$var$jk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $3a42d2aab3654c46$var$Qh(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $3a42d2aab3654c46$var$jk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$3a42d2aab3654c46$var$J) return $3a42d2aab3654c46$var$S(b), null;
                    } else 2 * $3a42d2aab3654c46$var$A() - f.renderingStartTime > $3a42d2aab3654c46$var$mk && 1073741824 !== c && (b.flags |= 128, d = !0, $3a42d2aab3654c46$var$jk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $3a42d2aab3654c46$var$A(), b.sibling = null, a = $3a42d2aab3654c46$var$L.current, $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$L, d ? a & 1 | 2 : a & 1), b;
            $3a42d2aab3654c46$var$S(b);
            return null;
        case 22:
        case 23:
            return $3a42d2aab3654c46$var$nk(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($3a42d2aab3654c46$var$Jj & 1073741824) && ($3a42d2aab3654c46$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $3a42d2aab3654c46$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($3a42d2aab3654c46$var$p(156, b.tag));
}
function $3a42d2aab3654c46$var$ok(a, b) {
    $3a42d2aab3654c46$var$Kg(b);
    switch(b.tag){
        case 1:
            return $3a42d2aab3654c46$var$mg(b.type) && $3a42d2aab3654c46$var$ng(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $3a42d2aab3654c46$var$dj(b), b) : null;
        case 3:
            return $3a42d2aab3654c46$var$Nh(), $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$jg), $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$I), $3a42d2aab3654c46$var$Sh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $3a42d2aab3654c46$var$Ph(b), null;
        case 13:
            $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($3a42d2aab3654c46$var$p(340));
                $3a42d2aab3654c46$var$Wg();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $3a42d2aab3654c46$var$dj(b), b) : null;
        case 19:
            return $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$L), null;
        case 4:
            return $3a42d2aab3654c46$var$Nh(), null;
        case 10:
            return $3a42d2aab3654c46$var$oh(b.type._context), null;
        case 22:
        case 23:
            return $3a42d2aab3654c46$var$nk(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $3a42d2aab3654c46$var$pk = !1, $3a42d2aab3654c46$var$qk = !1, $3a42d2aab3654c46$var$rk = "function" === typeof WeakSet ? WeakSet : Set, $3a42d2aab3654c46$var$U = null, $3a42d2aab3654c46$var$sk = null, $3a42d2aab3654c46$var$tk = null;
function $3a42d2aab3654c46$var$uk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        $3a42d2aab3654c46$var$cj(), b.componentWillUnmount();
    } finally{
        $3a42d2aab3654c46$var$aj(a);
    }
    else b.componentWillUnmount();
}
function $3a42d2aab3654c46$var$vk(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                $3a42d2aab3654c46$var$cj(), c(null);
            } finally{
                $3a42d2aab3654c46$var$aj(a);
            }
            else c(null);
        } catch (d) {
            $3a42d2aab3654c46$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $3a42d2aab3654c46$var$wk(a, b, c) {
    try {
        c();
    } catch (d) {
        $3a42d2aab3654c46$var$W(a, b, d);
    }
}
var $3a42d2aab3654c46$var$xk = !1;
function $3a42d2aab3654c46$var$yk(a, b) {
    $3a42d2aab3654c46$var$Qf = $3a42d2aab3654c46$var$rd;
    a = $3a42d2aab3654c46$var$$e();
    if ($3a42d2aab3654c46$var$af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $3a42d2aab3654c46$var$Rf = {
        focusedElem: a,
        selectionRange: c
    };
    $3a42d2aab3654c46$var$rd = !1;
    for($3a42d2aab3654c46$var$U = b; null !== $3a42d2aab3654c46$var$U;)if (b = $3a42d2aab3654c46$var$U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $3a42d2aab3654c46$var$U = a;
    else for(; null !== $3a42d2aab3654c46$var$U;){
        b = $3a42d2aab3654c46$var$U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $3a42d2aab3654c46$var$ej(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($3a42d2aab3654c46$var$p(163));
            }
        } catch (D) {
            $3a42d2aab3654c46$var$W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $3a42d2aab3654c46$var$U = a;
            break;
        }
        $3a42d2aab3654c46$var$U = b.return;
    }
    m = $3a42d2aab3654c46$var$xk;
    $3a42d2aab3654c46$var$xk = !1;
    return m;
}
function $3a42d2aab3654c46$var$zk(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markComponentPassiveEffectUnmountStarted && $3a42d2aab3654c46$var$B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && $3a42d2aab3654c46$var$uc(b), $3a42d2aab3654c46$var$wk(b, c, f), 0 !== (a & 8) ? null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markComponentPassiveEffectUnmountStopped && $3a42d2aab3654c46$var$B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && $3a42d2aab3654c46$var$vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function $3a42d2aab3654c46$var$Ak(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markComponentPassiveEffectMountStarted && $3a42d2aab3654c46$var$B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markComponentLayoutEffectMountStarted && $3a42d2aab3654c46$var$B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markComponentPassiveEffectMountStopped && $3a42d2aab3654c46$var$B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markComponentLayoutEffectMountStopped && $3a42d2aab3654c46$var$B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function $3a42d2aab3654c46$var$Bk(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                $3a42d2aab3654c46$var$cj(), b(c);
            } finally{
                $3a42d2aab3654c46$var$aj(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function $3a42d2aab3654c46$var$Ck(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $3a42d2aab3654c46$var$Ck(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$3a42d2aab3654c46$var$bg], delete b[$3a42d2aab3654c46$var$cg], delete b[$3a42d2aab3654c46$var$Cf], delete b[$3a42d2aab3654c46$var$dg], delete b[$3a42d2aab3654c46$var$eg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $3a42d2aab3654c46$var$Dk(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $3a42d2aab3654c46$var$Ek(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $3a42d2aab3654c46$var$Dk(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $3a42d2aab3654c46$var$Fk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $3a42d2aab3654c46$var$Pf));
    else if (4 !== d && (a = a.child, null !== a)) for($3a42d2aab3654c46$var$Fk(a, b, c), a = a.sibling; null !== a;)$3a42d2aab3654c46$var$Fk(a, b, c), a = a.sibling;
}
function $3a42d2aab3654c46$var$Gk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($3a42d2aab3654c46$var$Gk(a, b, c), a = a.sibling; null !== a;)$3a42d2aab3654c46$var$Gk(a, b, c), a = a.sibling;
}
var $3a42d2aab3654c46$var$X = null, $3a42d2aab3654c46$var$Hk = !1;
function $3a42d2aab3654c46$var$Ik(a, b, c) {
    for(c = c.child; null !== c;)$3a42d2aab3654c46$var$Jk(a, b, c), c = c.sibling;
}
function $3a42d2aab3654c46$var$Jk(a, b, c) {
    if ($3a42d2aab3654c46$var$lc && "function" === typeof $3a42d2aab3654c46$var$lc.onCommitFiberUnmount) try {
        $3a42d2aab3654c46$var$lc.onCommitFiberUnmount($3a42d2aab3654c46$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $3a42d2aab3654c46$var$qk || $3a42d2aab3654c46$var$vk(c, b);
        case 6:
            var d = $3a42d2aab3654c46$var$X, e = $3a42d2aab3654c46$var$Hk;
            $3a42d2aab3654c46$var$X = null;
            $3a42d2aab3654c46$var$Ik(a, b, c);
            $3a42d2aab3654c46$var$X = d;
            $3a42d2aab3654c46$var$Hk = e;
            null !== $3a42d2aab3654c46$var$X && ($3a42d2aab3654c46$var$Hk ? (a = $3a42d2aab3654c46$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $3a42d2aab3654c46$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $3a42d2aab3654c46$var$X && ($3a42d2aab3654c46$var$Hk ? (a = $3a42d2aab3654c46$var$X, c = c.stateNode, 8 === a.nodeType ? $3a42d2aab3654c46$var$Yf(a.parentNode, c) : 1 === a.nodeType && $3a42d2aab3654c46$var$Yf(a, c), $3a42d2aab3654c46$var$pd(a)) : $3a42d2aab3654c46$var$Yf($3a42d2aab3654c46$var$X, c.stateNode));
            break;
        case 4:
            d = $3a42d2aab3654c46$var$X;
            e = $3a42d2aab3654c46$var$Hk;
            $3a42d2aab3654c46$var$X = c.stateNode.containerInfo;
            $3a42d2aab3654c46$var$Hk = !0;
            $3a42d2aab3654c46$var$Ik(a, b, c);
            $3a42d2aab3654c46$var$X = d;
            $3a42d2aab3654c46$var$Hk = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$3a42d2aab3654c46$var$qk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $3a42d2aab3654c46$var$wk(c, b, g) : 0 !== (f & 4) && ($3a42d2aab3654c46$var$uc(c), c.mode & 2 ? ($3a42d2aab3654c46$var$cj(), $3a42d2aab3654c46$var$wk(c, b, g), $3a42d2aab3654c46$var$aj(c)) : $3a42d2aab3654c46$var$wk(c, b, g), $3a42d2aab3654c46$var$vc()));
                    e = e.next;
                }while (e !== d);
            }
            $3a42d2aab3654c46$var$Ik(a, b, c);
            break;
        case 1:
            if (!$3a42d2aab3654c46$var$qk && ($3a42d2aab3654c46$var$vk(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                $3a42d2aab3654c46$var$uk(c, d);
            } catch (h) {
                $3a42d2aab3654c46$var$W(c, b, h);
            }
            $3a42d2aab3654c46$var$Ik(a, b, c);
            break;
        case 21:
            $3a42d2aab3654c46$var$Ik(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($3a42d2aab3654c46$var$qk = (d = $3a42d2aab3654c46$var$qk) || null !== c.memoizedState, $3a42d2aab3654c46$var$Ik(a, b, c), $3a42d2aab3654c46$var$qk = d) : $3a42d2aab3654c46$var$Ik(a, b, c);
            break;
        default:
            $3a42d2aab3654c46$var$Ik(a, b, c);
    }
}
function $3a42d2aab3654c46$var$Kk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $3a42d2aab3654c46$var$rk);
        b.forEach(function(b) {
            var d = $3a42d2aab3654c46$var$Lk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if ($3a42d2aab3654c46$var$mc) {
                    if (null !== $3a42d2aab3654c46$var$sk && null !== $3a42d2aab3654c46$var$tk) $3a42d2aab3654c46$var$wj($3a42d2aab3654c46$var$tk, $3a42d2aab3654c46$var$sk);
                    else throw Error($3a42d2aab3654c46$var$p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function $3a42d2aab3654c46$var$Mk(a, b, c) {
    $3a42d2aab3654c46$var$sk = c;
    $3a42d2aab3654c46$var$tk = a;
    $3a42d2aab3654c46$var$Nk(b, a);
    $3a42d2aab3654c46$var$tk = $3a42d2aab3654c46$var$sk = null;
}
function $3a42d2aab3654c46$var$Ok(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $3a42d2aab3654c46$var$X = h.stateNode;
                        $3a42d2aab3654c46$var$Hk = !1;
                        break a;
                    case 3:
                        $3a42d2aab3654c46$var$X = h.stateNode.containerInfo;
                        $3a42d2aab3654c46$var$Hk = !0;
                        break a;
                    case 4:
                        $3a42d2aab3654c46$var$X = h.stateNode.containerInfo;
                        $3a42d2aab3654c46$var$Hk = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $3a42d2aab3654c46$var$X) throw Error($3a42d2aab3654c46$var$p(160));
            $3a42d2aab3654c46$var$Jk(f, g, e);
            $3a42d2aab3654c46$var$X = null;
            $3a42d2aab3654c46$var$Hk = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $3a42d2aab3654c46$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$3a42d2aab3654c46$var$Nk(b, a), b = b.sibling;
}
function $3a42d2aab3654c46$var$Nk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $3a42d2aab3654c46$var$Ok(b, a);
            $3a42d2aab3654c46$var$Pk(a);
            if (d & 4) {
                try {
                    $3a42d2aab3654c46$var$zk(3, a, a.return), $3a42d2aab3654c46$var$Ak(3, a);
                } catch (m) {
                    $3a42d2aab3654c46$var$W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        $3a42d2aab3654c46$var$cj(), $3a42d2aab3654c46$var$zk(5, a, a.return);
                    } catch (m) {
                        $3a42d2aab3654c46$var$W(a, a.return, m);
                    }
                    $3a42d2aab3654c46$var$aj(a);
                } else try {
                    $3a42d2aab3654c46$var$zk(5, a, a.return);
                } catch (m) {
                    $3a42d2aab3654c46$var$W(a, a.return, m);
                }
            }
            break;
        case 1:
            $3a42d2aab3654c46$var$Ok(b, a);
            $3a42d2aab3654c46$var$Pk(a);
            d & 512 && null !== c && $3a42d2aab3654c46$var$vk(c, c.return);
            break;
        case 5:
            $3a42d2aab3654c46$var$Ok(b, a);
            $3a42d2aab3654c46$var$Pk(a);
            d & 512 && null !== c && $3a42d2aab3654c46$var$vk(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $3a42d2aab3654c46$var$ob(e, "");
                } catch (m) {
                    $3a42d2aab3654c46$var$W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $3a42d2aab3654c46$var$$a(e, f);
                    $3a42d2aab3654c46$var$vb(h, g);
                    var l = $3a42d2aab3654c46$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? $3a42d2aab3654c46$var$sb(e, q) : "dangerouslySetInnerHTML" === n ? $3a42d2aab3654c46$var$nb(e, q) : "children" === n ? $3a42d2aab3654c46$var$ob(e, q) : $3a42d2aab3654c46$var$ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            $3a42d2aab3654c46$var$ab(e, f);
                            break;
                        case "textarea":
                            $3a42d2aab3654c46$var$hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? $3a42d2aab3654c46$var$eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? $3a42d2aab3654c46$var$eb(e, !!f.multiple, f.defaultValue, !0) : $3a42d2aab3654c46$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$3a42d2aab3654c46$var$cg] = f;
                } catch (m) {
                    $3a42d2aab3654c46$var$W(a, a.return, m);
                }
            }
            break;
        case 6:
            $3a42d2aab3654c46$var$Ok(b, a);
            $3a42d2aab3654c46$var$Pk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($3a42d2aab3654c46$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    $3a42d2aab3654c46$var$W(a, a.return, m);
                }
            }
            break;
        case 3:
            $3a42d2aab3654c46$var$Ok(b, a);
            $3a42d2aab3654c46$var$Pk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $3a42d2aab3654c46$var$pd(b.containerInfo);
            } catch (m) {
                $3a42d2aab3654c46$var$W(a, a.return, m);
            }
            break;
        case 4:
            $3a42d2aab3654c46$var$Ok(b, a);
            $3a42d2aab3654c46$var$Pk(a);
            break;
        case 13:
            $3a42d2aab3654c46$var$Ok(b, a);
            $3a42d2aab3654c46$var$Pk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($3a42d2aab3654c46$var$Qk = $3a42d2aab3654c46$var$A()));
            d & 4 && $3a42d2aab3654c46$var$Kk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($3a42d2aab3654c46$var$qk = (l = $3a42d2aab3654c46$var$qk) || n, $3a42d2aab3654c46$var$Ok(b, a), $3a42d2aab3654c46$var$qk = l) : $3a42d2aab3654c46$var$Ok(b, a);
            $3a42d2aab3654c46$var$Pk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for($3a42d2aab3654c46$var$U = a, n = a.child; null !== n;){
                    for(q = $3a42d2aab3654c46$var$U = n; null !== $3a42d2aab3654c46$var$U;){
                        r = $3a42d2aab3654c46$var$U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    $3a42d2aab3654c46$var$cj(), $3a42d2aab3654c46$var$zk(4, r, r.return);
                                } finally{
                                    $3a42d2aab3654c46$var$aj(r);
                                }
                                else $3a42d2aab3654c46$var$zk(4, r, r.return);
                                break;
                            case 1:
                                $3a42d2aab3654c46$var$vk(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        $3a42d2aab3654c46$var$uk(c, d);
                                    } catch (m) {
                                        $3a42d2aab3654c46$var$W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                $3a42d2aab3654c46$var$vk(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $3a42d2aab3654c46$var$Rk(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, $3a42d2aab3654c46$var$U = z) : $3a42d2aab3654c46$var$Rk(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $3a42d2aab3654c46$var$rb("display", g));
                            } catch (m) {
                                $3a42d2aab3654c46$var$W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            $3a42d2aab3654c46$var$W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $3a42d2aab3654c46$var$Ok(b, a);
            $3a42d2aab3654c46$var$Pk(a);
            d & 4 && $3a42d2aab3654c46$var$Kk(a);
            break;
        case 21:
            break;
        default:
            $3a42d2aab3654c46$var$Ok(b, a), $3a42d2aab3654c46$var$Pk(a);
    }
}
function $3a42d2aab3654c46$var$Pk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($3a42d2aab3654c46$var$Dk(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($3a42d2aab3654c46$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($3a42d2aab3654c46$var$ob(e, ""), d.flags &= -33);
                    var f = $3a42d2aab3654c46$var$Ek(a);
                    $3a42d2aab3654c46$var$Gk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $3a42d2aab3654c46$var$Ek(a);
                    $3a42d2aab3654c46$var$Fk(a, h, g);
                    break;
                default:
                    throw Error($3a42d2aab3654c46$var$p(161));
            }
        } catch (k) {
            $3a42d2aab3654c46$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $3a42d2aab3654c46$var$Sk(a, b, c) {
    $3a42d2aab3654c46$var$sk = c;
    $3a42d2aab3654c46$var$tk = b;
    $3a42d2aab3654c46$var$U = a;
    $3a42d2aab3654c46$var$Tk(a, b, c);
    $3a42d2aab3654c46$var$tk = $3a42d2aab3654c46$var$sk = null;
}
function $3a42d2aab3654c46$var$Tk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $3a42d2aab3654c46$var$U;){
        var e = $3a42d2aab3654c46$var$U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $3a42d2aab3654c46$var$pk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $3a42d2aab3654c46$var$qk;
                h = $3a42d2aab3654c46$var$pk;
                var l = $3a42d2aab3654c46$var$qk;
                $3a42d2aab3654c46$var$pk = g;
                if (($3a42d2aab3654c46$var$qk = k) && !l) for($3a42d2aab3654c46$var$U = e; null !== $3a42d2aab3654c46$var$U;)g = $3a42d2aab3654c46$var$U, k = g.child, 22 === g.tag && null !== g.memoizedState ? $3a42d2aab3654c46$var$Uk(e) : null !== k ? (k.return = g, $3a42d2aab3654c46$var$U = k) : $3a42d2aab3654c46$var$Uk(e);
                for(; null !== f;)$3a42d2aab3654c46$var$U = f, $3a42d2aab3654c46$var$Tk(f, b, c), f = f.sibling;
                $3a42d2aab3654c46$var$U = e;
                $3a42d2aab3654c46$var$pk = h;
                $3a42d2aab3654c46$var$qk = l;
            }
            $3a42d2aab3654c46$var$Vk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $3a42d2aab3654c46$var$U = f) : $3a42d2aab3654c46$var$Vk(a, b, c);
    }
}
function $3a42d2aab3654c46$var$Vk(a) {
    for(; null !== $3a42d2aab3654c46$var$U;){
        var b = $3a42d2aab3654c46$var$U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!$3a42d2aab3654c46$var$qk) {
                            if (b.mode & 2) try {
                                $3a42d2aab3654c46$var$cj(), $3a42d2aab3654c46$var$Ak(5, b);
                            } finally{
                                $3a42d2aab3654c46$var$aj(b);
                            }
                            else $3a42d2aab3654c46$var$Ak(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$3a42d2aab3654c46$var$qk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    $3a42d2aab3654c46$var$cj(), d.componentDidMount();
                                } finally{
                                    $3a42d2aab3654c46$var$aj(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : $3a42d2aab3654c46$var$ej(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    $3a42d2aab3654c46$var$cj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    $3a42d2aab3654c46$var$aj(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && $3a42d2aab3654c46$var$Gh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            $3a42d2aab3654c46$var$Gh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = $3a42d2aab3654c46$var$Ui;
                        c = null === c ? "mount" : "update";
                        $3a42d2aab3654c46$var$Yi && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        $3a42d2aab3654c46$var$Wk(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && $3a42d2aab3654c46$var$pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($3a42d2aab3654c46$var$p(163));
                }
                $3a42d2aab3654c46$var$qk || b.flags & 512 && $3a42d2aab3654c46$var$Bk(b);
            } catch (v) {
                $3a42d2aab3654c46$var$W(b, b.return, v);
            }
        }
        if (b === a) {
            $3a42d2aab3654c46$var$U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $3a42d2aab3654c46$var$U = k;
            break;
        }
        $3a42d2aab3654c46$var$U = b.return;
    }
}
function $3a42d2aab3654c46$var$Rk(a) {
    for(; null !== $3a42d2aab3654c46$var$U;){
        var b = $3a42d2aab3654c46$var$U;
        if (b === a) {
            $3a42d2aab3654c46$var$U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $3a42d2aab3654c46$var$U = c;
            break;
        }
        $3a42d2aab3654c46$var$U = b.return;
    }
}
function $3a42d2aab3654c46$var$Uk(a) {
    for(; null !== $3a42d2aab3654c46$var$U;){
        var b = $3a42d2aab3654c46$var$U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        $3a42d2aab3654c46$var$cj();
                        var c = b.return;
                        try {
                            $3a42d2aab3654c46$var$Ak(4, b);
                        } catch (l) {
                            $3a42d2aab3654c46$var$W(b, c, l);
                        }
                    } finally{
                        $3a42d2aab3654c46$var$aj(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            $3a42d2aab3654c46$var$Ak(4, b);
                        } catch (l) {
                            $3a42d2aab3654c46$var$W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            $3a42d2aab3654c46$var$W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        $3a42d2aab3654c46$var$Bk(b);
                    } catch (l) {
                        $3a42d2aab3654c46$var$W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        $3a42d2aab3654c46$var$Bk(b);
                    } catch (l) {
                        $3a42d2aab3654c46$var$W(b, h, l);
                    }
            }
        } catch (l) {
            $3a42d2aab3654c46$var$W(b, b.return, l);
        }
        if (b === a) {
            $3a42d2aab3654c46$var$U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $3a42d2aab3654c46$var$U = k;
            break;
        }
        $3a42d2aab3654c46$var$U = b.return;
    }
}
var $3a42d2aab3654c46$var$Xk = Math.ceil, $3a42d2aab3654c46$var$Yk = $3a42d2aab3654c46$var$va.ReactCurrentDispatcher, $3a42d2aab3654c46$var$Zk = $3a42d2aab3654c46$var$va.ReactCurrentOwner, $3a42d2aab3654c46$var$$k = $3a42d2aab3654c46$var$va.ReactCurrentBatchConfig, $3a42d2aab3654c46$var$K = 0, $3a42d2aab3654c46$var$Q = null, $3a42d2aab3654c46$var$Y = null, $3a42d2aab3654c46$var$Z = 0, $3a42d2aab3654c46$var$Jj = 0, $3a42d2aab3654c46$var$Ij = $3a42d2aab3654c46$var$hg(0), $3a42d2aab3654c46$var$T = 0, $3a42d2aab3654c46$var$al = null, $3a42d2aab3654c46$var$Fh = 0, $3a42d2aab3654c46$var$bl = 0, $3a42d2aab3654c46$var$cl = 0, $3a42d2aab3654c46$var$dl = null, $3a42d2aab3654c46$var$el = null, $3a42d2aab3654c46$var$Qk = 0, $3a42d2aab3654c46$var$mk = Infinity, $3a42d2aab3654c46$var$fl = null, $3a42d2aab3654c46$var$qj = !1, $3a42d2aab3654c46$var$rj = null, $3a42d2aab3654c46$var$tj = null, $3a42d2aab3654c46$var$gl = !1, $3a42d2aab3654c46$var$hl = null, $3a42d2aab3654c46$var$il = 0, $3a42d2aab3654c46$var$jl = [], $3a42d2aab3654c46$var$kl = 0, $3a42d2aab3654c46$var$ll = null, $3a42d2aab3654c46$var$ml = -1, $3a42d2aab3654c46$var$nl = 0;
function $3a42d2aab3654c46$var$Ri() {
    return 0 !== ($3a42d2aab3654c46$var$K & 6) ? $3a42d2aab3654c46$var$A() : -1 !== $3a42d2aab3654c46$var$ml ? $3a42d2aab3654c46$var$ml : $3a42d2aab3654c46$var$ml = $3a42d2aab3654c46$var$A();
}
function $3a42d2aab3654c46$var$Oi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($3a42d2aab3654c46$var$K & 2) && 0 !== $3a42d2aab3654c46$var$Z) return $3a42d2aab3654c46$var$Z & -$3a42d2aab3654c46$var$Z;
    if (null !== $3a42d2aab3654c46$var$Yg.transition) return 0 === $3a42d2aab3654c46$var$nl && ($3a42d2aab3654c46$var$nl = $3a42d2aab3654c46$var$Kc()), $3a42d2aab3654c46$var$nl;
    a = $3a42d2aab3654c46$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $3a42d2aab3654c46$var$xd(a.type);
    return a;
}
function $3a42d2aab3654c46$var$ui(a, b, c, d) {
    if (50 < $3a42d2aab3654c46$var$kl) throw $3a42d2aab3654c46$var$kl = 0, $3a42d2aab3654c46$var$ll = null, Error($3a42d2aab3654c46$var$p(185));
    $3a42d2aab3654c46$var$Mc(a, c, d);
    if (0 === ($3a42d2aab3654c46$var$K & 2) || a !== $3a42d2aab3654c46$var$Q) $3a42d2aab3654c46$var$mc && $3a42d2aab3654c46$var$Pc(a, b, c), a === $3a42d2aab3654c46$var$Q && (0 === ($3a42d2aab3654c46$var$K & 2) && ($3a42d2aab3654c46$var$bl |= c), 4 === $3a42d2aab3654c46$var$T && $3a42d2aab3654c46$var$ol(a, $3a42d2aab3654c46$var$Z)), $3a42d2aab3654c46$var$pl(a, d), 1 === c && 0 === $3a42d2aab3654c46$var$K && 0 === (b.mode & 1) && ($3a42d2aab3654c46$var$mk = $3a42d2aab3654c46$var$A() + 500, $3a42d2aab3654c46$var$tg && $3a42d2aab3654c46$var$xg());
}
function $3a42d2aab3654c46$var$pl(a, b) {
    var c = a.callbackNode;
    $3a42d2aab3654c46$var$Ic(a, b);
    var d = $3a42d2aab3654c46$var$Gc(a, a === $3a42d2aab3654c46$var$Q ? $3a42d2aab3654c46$var$Z : 0);
    if (0 === d) null !== c && $3a42d2aab3654c46$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $3a42d2aab3654c46$var$bc(c);
        if (1 === b) 0 === a.tag ? $3a42d2aab3654c46$var$wg($3a42d2aab3654c46$var$ql.bind(null, a)) : $3a42d2aab3654c46$var$vg($3a42d2aab3654c46$var$ql.bind(null, a)), $3a42d2aab3654c46$var$Xf(function() {
            0 === ($3a42d2aab3654c46$var$K & 6) && $3a42d2aab3654c46$var$xg();
        }), c = null;
        else {
            switch($3a42d2aab3654c46$var$Rc(d)){
                case 1:
                    c = $3a42d2aab3654c46$var$fc;
                    break;
                case 4:
                    c = $3a42d2aab3654c46$var$gc;
                    break;
                case 16:
                    c = $3a42d2aab3654c46$var$hc;
                    break;
                case 536870912:
                    c = $3a42d2aab3654c46$var$jc;
                    break;
                default:
                    c = $3a42d2aab3654c46$var$hc;
            }
            c = $3a42d2aab3654c46$var$rl(c, $3a42d2aab3654c46$var$sl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $3a42d2aab3654c46$var$sl(a, b) {
    $3a42d2aab3654c46$var$Zi = $3a42d2aab3654c46$var$Yi = !1;
    $3a42d2aab3654c46$var$ml = -1;
    $3a42d2aab3654c46$var$nl = 0;
    if (0 !== ($3a42d2aab3654c46$var$K & 6)) throw Error($3a42d2aab3654c46$var$p(327));
    var c = a.callbackNode;
    if ($3a42d2aab3654c46$var$tl() && a.callbackNode !== c) return null;
    var d = $3a42d2aab3654c46$var$Gc(a, a === $3a42d2aab3654c46$var$Q ? $3a42d2aab3654c46$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $3a42d2aab3654c46$var$ul(a, d);
    else {
        b = d;
        var e = $3a42d2aab3654c46$var$K;
        $3a42d2aab3654c46$var$K |= 2;
        var f = $3a42d2aab3654c46$var$vl();
        if ($3a42d2aab3654c46$var$Q !== a || $3a42d2aab3654c46$var$Z !== b) {
            if ($3a42d2aab3654c46$var$mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && ($3a42d2aab3654c46$var$wj(a, $3a42d2aab3654c46$var$Z), g.clear());
                $3a42d2aab3654c46$var$Qc(a, b);
            }
            $3a42d2aab3654c46$var$fl = null;
            $3a42d2aab3654c46$var$mk = $3a42d2aab3654c46$var$A() + 500;
            $3a42d2aab3654c46$var$wl(a, b);
        }
        $3a42d2aab3654c46$var$wc(b);
        for(;;)try {
            $3a42d2aab3654c46$var$xl();
            break;
        } catch (h) {
            $3a42d2aab3654c46$var$yl(a, h);
        }
        $3a42d2aab3654c46$var$nh();
        $3a42d2aab3654c46$var$Yk.current = f;
        $3a42d2aab3654c46$var$K = e;
        null !== $3a42d2aab3654c46$var$Y ? (null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markRenderYielded && $3a42d2aab3654c46$var$B.markRenderYielded(), b = 0) : ($3a42d2aab3654c46$var$xc(), $3a42d2aab3654c46$var$Q = null, $3a42d2aab3654c46$var$Z = 0, b = $3a42d2aab3654c46$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $3a42d2aab3654c46$var$Jc(a), 0 !== e && (d = e, b = $3a42d2aab3654c46$var$zl(a, e)));
        if (1 === b) throw c = $3a42d2aab3654c46$var$al, $3a42d2aab3654c46$var$wl(a, 0), $3a42d2aab3654c46$var$ol(a, d), $3a42d2aab3654c46$var$pl(a, $3a42d2aab3654c46$var$A()), c;
        if (6 === b) $3a42d2aab3654c46$var$ol(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$3a42d2aab3654c46$var$Al(e) && (b = $3a42d2aab3654c46$var$ul(a, d), 2 === b && (f = $3a42d2aab3654c46$var$Jc(a), 0 !== f && (d = f, b = $3a42d2aab3654c46$var$zl(a, f))), 1 === b)) throw c = $3a42d2aab3654c46$var$al, $3a42d2aab3654c46$var$wl(a, 0), $3a42d2aab3654c46$var$ol(a, d), $3a42d2aab3654c46$var$pl(a, $3a42d2aab3654c46$var$A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($3a42d2aab3654c46$var$p(345));
                case 2:
                    $3a42d2aab3654c46$var$Cl(a, $3a42d2aab3654c46$var$el, $3a42d2aab3654c46$var$fl);
                    break;
                case 3:
                    $3a42d2aab3654c46$var$ol(a, d);
                    if ((d & 130023424) === d && (b = $3a42d2aab3654c46$var$Qk + 500 - $3a42d2aab3654c46$var$A(), 10 < b)) {
                        if (0 !== $3a42d2aab3654c46$var$Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $3a42d2aab3654c46$var$Ri();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $3a42d2aab3654c46$var$Tf($3a42d2aab3654c46$var$Cl.bind(null, a, $3a42d2aab3654c46$var$el, $3a42d2aab3654c46$var$fl), b);
                        break;
                    }
                    $3a42d2aab3654c46$var$Cl(a, $3a42d2aab3654c46$var$el, $3a42d2aab3654c46$var$fl);
                    break;
                case 4:
                    $3a42d2aab3654c46$var$ol(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $3a42d2aab3654c46$var$Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $3a42d2aab3654c46$var$A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $3a42d2aab3654c46$var$Xk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $3a42d2aab3654c46$var$Tf($3a42d2aab3654c46$var$Cl.bind(null, a, $3a42d2aab3654c46$var$el, $3a42d2aab3654c46$var$fl), d);
                        break;
                    }
                    $3a42d2aab3654c46$var$Cl(a, $3a42d2aab3654c46$var$el, $3a42d2aab3654c46$var$fl);
                    break;
                case 5:
                    $3a42d2aab3654c46$var$Cl(a, $3a42d2aab3654c46$var$el, $3a42d2aab3654c46$var$fl);
                    break;
                default:
                    throw Error($3a42d2aab3654c46$var$p(329));
            }
        }
    }
    $3a42d2aab3654c46$var$pl(a, $3a42d2aab3654c46$var$A());
    return a.callbackNode === c ? $3a42d2aab3654c46$var$sl.bind(null, a) : null;
}
function $3a42d2aab3654c46$var$zl(a, b) {
    var c = $3a42d2aab3654c46$var$dl;
    a.current.memoizedState.isDehydrated && ($3a42d2aab3654c46$var$wl(a, b).flags |= 256);
    a = $3a42d2aab3654c46$var$ul(a, b);
    2 !== a && (b = $3a42d2aab3654c46$var$el, $3a42d2aab3654c46$var$el = c, null !== b && $3a42d2aab3654c46$var$lk(b));
    return a;
}
function $3a42d2aab3654c46$var$lk(a) {
    null === $3a42d2aab3654c46$var$el ? $3a42d2aab3654c46$var$el = a : $3a42d2aab3654c46$var$el.push.apply($3a42d2aab3654c46$var$el, a);
}
function $3a42d2aab3654c46$var$Al(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$3a42d2aab3654c46$var$Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $3a42d2aab3654c46$var$ol(a, b) {
    b &= ~$3a42d2aab3654c46$var$cl;
    b &= ~$3a42d2aab3654c46$var$bl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $3a42d2aab3654c46$var$Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $3a42d2aab3654c46$var$ql(a) {
    $3a42d2aab3654c46$var$Yi = $3a42d2aab3654c46$var$Zi;
    $3a42d2aab3654c46$var$Zi = !1;
    if (0 !== ($3a42d2aab3654c46$var$K & 6)) throw Error($3a42d2aab3654c46$var$p(327));
    $3a42d2aab3654c46$var$tl();
    var b = $3a42d2aab3654c46$var$Gc(a, 0);
    if (0 === (b & 1)) return $3a42d2aab3654c46$var$pl(a, $3a42d2aab3654c46$var$A()), null;
    var c = $3a42d2aab3654c46$var$ul(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $3a42d2aab3654c46$var$Jc(a);
        0 !== d && (b = d, c = $3a42d2aab3654c46$var$zl(a, d));
    }
    if (1 === c) throw c = $3a42d2aab3654c46$var$al, $3a42d2aab3654c46$var$wl(a, 0), $3a42d2aab3654c46$var$ol(a, b), $3a42d2aab3654c46$var$pl(a, $3a42d2aab3654c46$var$A()), c;
    if (6 === c) throw Error($3a42d2aab3654c46$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $3a42d2aab3654c46$var$Cl(a, $3a42d2aab3654c46$var$el, $3a42d2aab3654c46$var$fl);
    $3a42d2aab3654c46$var$pl(a, $3a42d2aab3654c46$var$A());
    return null;
}
function $3a42d2aab3654c46$var$Dl(a, b) {
    var c = $3a42d2aab3654c46$var$K;
    $3a42d2aab3654c46$var$K |= 1;
    try {
        return a(b);
    } finally{
        $3a42d2aab3654c46$var$K = c, 0 === $3a42d2aab3654c46$var$K && ($3a42d2aab3654c46$var$mk = $3a42d2aab3654c46$var$A() + 500, $3a42d2aab3654c46$var$tg && $3a42d2aab3654c46$var$xg());
    }
}
function $3a42d2aab3654c46$var$El(a) {
    null !== $3a42d2aab3654c46$var$hl && 0 === $3a42d2aab3654c46$var$hl.tag && 0 === ($3a42d2aab3654c46$var$K & 6) && $3a42d2aab3654c46$var$tl();
    var b = $3a42d2aab3654c46$var$K;
    $3a42d2aab3654c46$var$K |= 1;
    var c = $3a42d2aab3654c46$var$$k.transition, d = $3a42d2aab3654c46$var$E;
    try {
        if ($3a42d2aab3654c46$var$$k.transition = null, $3a42d2aab3654c46$var$E = 1, a) return a();
    } finally{
        $3a42d2aab3654c46$var$E = d, $3a42d2aab3654c46$var$$k.transition = c, $3a42d2aab3654c46$var$K = b, 0 === ($3a42d2aab3654c46$var$K & 6) && $3a42d2aab3654c46$var$xg();
    }
}
function $3a42d2aab3654c46$var$nk() {
    $3a42d2aab3654c46$var$Jj = $3a42d2aab3654c46$var$Ij.current;
    $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$Ij);
}
function $3a42d2aab3654c46$var$wl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $3a42d2aab3654c46$var$Uf(c));
    if (null !== $3a42d2aab3654c46$var$Y) for(c = $3a42d2aab3654c46$var$Y.return; null !== c;){
        var d = c;
        $3a42d2aab3654c46$var$Kg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $3a42d2aab3654c46$var$ng();
                break;
            case 3:
                $3a42d2aab3654c46$var$Nh();
                $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$jg);
                $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$I);
                $3a42d2aab3654c46$var$Sh();
                break;
            case 5:
                $3a42d2aab3654c46$var$Ph(d);
                break;
            case 4:
                $3a42d2aab3654c46$var$Nh();
                break;
            case 13:
                $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$L);
                break;
            case 19:
                $3a42d2aab3654c46$var$G($3a42d2aab3654c46$var$L);
                break;
            case 10:
                $3a42d2aab3654c46$var$oh(d.type._context);
                break;
            case 22:
            case 23:
                $3a42d2aab3654c46$var$nk();
        }
        c = c.return;
    }
    $3a42d2aab3654c46$var$Q = a;
    $3a42d2aab3654c46$var$Y = a = $3a42d2aab3654c46$var$ch(a.current, null);
    $3a42d2aab3654c46$var$Z = $3a42d2aab3654c46$var$Jj = b;
    $3a42d2aab3654c46$var$T = 0;
    $3a42d2aab3654c46$var$al = null;
    $3a42d2aab3654c46$var$cl = $3a42d2aab3654c46$var$bl = $3a42d2aab3654c46$var$Fh = 0;
    $3a42d2aab3654c46$var$el = $3a42d2aab3654c46$var$dl = null;
    if (null !== $3a42d2aab3654c46$var$th) {
        for(b = 0; b < $3a42d2aab3654c46$var$th.length; b++)if (c = $3a42d2aab3654c46$var$th[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $3a42d2aab3654c46$var$th = null;
    }
    return a;
}
function $3a42d2aab3654c46$var$yl(a, b) {
    do {
        var c = $3a42d2aab3654c46$var$Y;
        try {
            $3a42d2aab3654c46$var$nh();
            $3a42d2aab3654c46$var$Th.current = $3a42d2aab3654c46$var$ei;
            if ($3a42d2aab3654c46$var$Wh) {
                for(var d = $3a42d2aab3654c46$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $3a42d2aab3654c46$var$Wh = !1;
            }
            $3a42d2aab3654c46$var$Vh = 0;
            $3a42d2aab3654c46$var$O = $3a42d2aab3654c46$var$N = $3a42d2aab3654c46$var$M = null;
            $3a42d2aab3654c46$var$Xh = !1;
            $3a42d2aab3654c46$var$Yh = 0;
            $3a42d2aab3654c46$var$Zk.current = null;
            if (null === c || null === c.return) {
                $3a42d2aab3654c46$var$T = 1;
                $3a42d2aab3654c46$var$al = b;
                $3a42d2aab3654c46$var$Y = null;
                break;
            }
            c.mode & 2 && $3a42d2aab3654c46$var$$i(c, !0);
            $3a42d2aab3654c46$var$tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markComponentSuspended && $3a42d2aab3654c46$var$B.markComponentSuspended(c, f, $3a42d2aab3654c46$var$Z);
            } else null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markComponentErrored && $3a42d2aab3654c46$var$B.markComponentErrored(c, b, $3a42d2aab3654c46$var$Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = $3a42d2aab3654c46$var$Z;
                k.flags |= 32768;
                $3a42d2aab3654c46$var$mc && $3a42d2aab3654c46$var$wj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = $3a42d2aab3654c46$var$xj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        $3a42d2aab3654c46$var$yj(z, h, k, g, b);
                        z.mode & 1 && $3a42d2aab3654c46$var$uj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $3a42d2aab3654c46$var$uj(g, l, b);
                            $3a42d2aab3654c46$var$Zj();
                            break a;
                        }
                        f = Error($3a42d2aab3654c46$var$p(426));
                    }
                } else if ($3a42d2aab3654c46$var$J && k.mode & 1) {
                    var C = $3a42d2aab3654c46$var$xj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $3a42d2aab3654c46$var$yj(C, h, k, g, b);
                        $3a42d2aab3654c46$var$Xg($3a42d2aab3654c46$var$lj(f, k));
                        break a;
                    }
                }
                g = f = $3a42d2aab3654c46$var$lj(f, k);
                4 !== $3a42d2aab3654c46$var$T && ($3a42d2aab3654c46$var$T = 2);
                null === $3a42d2aab3654c46$var$dl ? $3a42d2aab3654c46$var$dl = [
                    g
                ] : $3a42d2aab3654c46$var$dl.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = $3a42d2aab3654c46$var$pj(g, f, b);
                            $3a42d2aab3654c46$var$Dh(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === $3a42d2aab3654c46$var$tj || !$3a42d2aab3654c46$var$tj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = $3a42d2aab3654c46$var$sj(g, k, b);
                                $3a42d2aab3654c46$var$Dh(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            $3a42d2aab3654c46$var$Fl(c);
        } catch (ca) {
            b = ca;
            $3a42d2aab3654c46$var$Y === c && null !== c && ($3a42d2aab3654c46$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $3a42d2aab3654c46$var$vl() {
    var a = $3a42d2aab3654c46$var$Yk.current;
    $3a42d2aab3654c46$var$Yk.current = $3a42d2aab3654c46$var$ei;
    return null === a ? $3a42d2aab3654c46$var$ei : a;
}
function $3a42d2aab3654c46$var$Zj() {
    if (0 === $3a42d2aab3654c46$var$T || 3 === $3a42d2aab3654c46$var$T || 2 === $3a42d2aab3654c46$var$T) $3a42d2aab3654c46$var$T = 4;
    null === $3a42d2aab3654c46$var$Q || 0 === ($3a42d2aab3654c46$var$Fh & 268435455) && 0 === ($3a42d2aab3654c46$var$bl & 268435455) || $3a42d2aab3654c46$var$ol($3a42d2aab3654c46$var$Q, $3a42d2aab3654c46$var$Z);
}
function $3a42d2aab3654c46$var$ul(a, b) {
    var c = $3a42d2aab3654c46$var$K;
    $3a42d2aab3654c46$var$K |= 2;
    var d = $3a42d2aab3654c46$var$vl();
    if ($3a42d2aab3654c46$var$Q !== a || $3a42d2aab3654c46$var$Z !== b) {
        if ($3a42d2aab3654c46$var$mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && ($3a42d2aab3654c46$var$wj(a, $3a42d2aab3654c46$var$Z), e.clear());
            $3a42d2aab3654c46$var$Qc(a, b);
        }
        $3a42d2aab3654c46$var$fl = null;
        $3a42d2aab3654c46$var$wl(a, b);
    }
    $3a42d2aab3654c46$var$wc(b);
    for(;;)try {
        $3a42d2aab3654c46$var$Gl();
        break;
    } catch (f) {
        $3a42d2aab3654c46$var$yl(a, f);
    }
    $3a42d2aab3654c46$var$nh();
    $3a42d2aab3654c46$var$K = c;
    $3a42d2aab3654c46$var$Yk.current = d;
    if (null !== $3a42d2aab3654c46$var$Y) throw Error($3a42d2aab3654c46$var$p(261));
    $3a42d2aab3654c46$var$xc();
    $3a42d2aab3654c46$var$Q = null;
    $3a42d2aab3654c46$var$Z = 0;
    return $3a42d2aab3654c46$var$T;
}
function $3a42d2aab3654c46$var$Gl() {
    for(; null !== $3a42d2aab3654c46$var$Y;)$3a42d2aab3654c46$var$Hl($3a42d2aab3654c46$var$Y);
}
function $3a42d2aab3654c46$var$xl() {
    for(; null !== $3a42d2aab3654c46$var$Y && !$3a42d2aab3654c46$var$cc();)$3a42d2aab3654c46$var$Hl($3a42d2aab3654c46$var$Y);
}
function $3a42d2aab3654c46$var$Hl(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? ($3a42d2aab3654c46$var$Wi = $3a42d2aab3654c46$var$Ti(), 0 > a.actualStartTime && (a.actualStartTime = $3a42d2aab3654c46$var$Ti()), b = $3a42d2aab3654c46$var$Il(b, a, $3a42d2aab3654c46$var$Jj), $3a42d2aab3654c46$var$$i(a, !0)) : b = $3a42d2aab3654c46$var$Il(b, a, $3a42d2aab3654c46$var$Jj);
    a.memoizedProps = a.pendingProps;
    null === b ? $3a42d2aab3654c46$var$Fl(a) : $3a42d2aab3654c46$var$Y = b;
    $3a42d2aab3654c46$var$Zk.current = null;
}
function $3a42d2aab3654c46$var$Fl(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = $3a42d2aab3654c46$var$kk(c, b, $3a42d2aab3654c46$var$Jj);
            else {
                var d = b;
                $3a42d2aab3654c46$var$Wi = $3a42d2aab3654c46$var$Ti();
                0 > d.actualStartTime && (d.actualStartTime = $3a42d2aab3654c46$var$Ti());
                c = $3a42d2aab3654c46$var$kk(c, b, $3a42d2aab3654c46$var$Jj);
                $3a42d2aab3654c46$var$$i(b, !1);
            }
            if (null !== c) {
                $3a42d2aab3654c46$var$Y = c;
                return;
            }
        } else {
            c = $3a42d2aab3654c46$var$ok(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $3a42d2aab3654c46$var$Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $3a42d2aab3654c46$var$$i(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $3a42d2aab3654c46$var$T = 6;
                $3a42d2aab3654c46$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $3a42d2aab3654c46$var$Y = b;
            return;
        }
        $3a42d2aab3654c46$var$Y = b = a;
    }while (null !== b);
    0 === $3a42d2aab3654c46$var$T && ($3a42d2aab3654c46$var$T = 5);
}
function $3a42d2aab3654c46$var$Cl(a, b, c) {
    var d = $3a42d2aab3654c46$var$E, e = $3a42d2aab3654c46$var$$k.transition;
    try {
        $3a42d2aab3654c46$var$$k.transition = null, $3a42d2aab3654c46$var$E = 1, $3a42d2aab3654c46$var$Jl(a, b, c, d);
    } finally{
        $3a42d2aab3654c46$var$$k.transition = e, $3a42d2aab3654c46$var$E = d;
    }
    return null;
}
function $3a42d2aab3654c46$var$Jl(a, b, c, d) {
    do $3a42d2aab3654c46$var$tl();
    while (null !== $3a42d2aab3654c46$var$hl);
    if (0 !== ($3a42d2aab3654c46$var$K & 6)) throw Error($3a42d2aab3654c46$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markCommitStarted && $3a42d2aab3654c46$var$B.markCommitStarted(e);
    if (null === c) return $3a42d2aab3654c46$var$rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($3a42d2aab3654c46$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $3a42d2aab3654c46$var$Nc(a, f);
    a === $3a42d2aab3654c46$var$Q && ($3a42d2aab3654c46$var$Y = $3a42d2aab3654c46$var$Q = null, $3a42d2aab3654c46$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $3a42d2aab3654c46$var$gl || ($3a42d2aab3654c46$var$gl = !0, $3a42d2aab3654c46$var$rl($3a42d2aab3654c46$var$hc, function() {
        $3a42d2aab3654c46$var$tl();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $3a42d2aab3654c46$var$$k.transition;
        $3a42d2aab3654c46$var$$k.transition = null;
        var g = $3a42d2aab3654c46$var$E;
        $3a42d2aab3654c46$var$E = 1;
        var h = $3a42d2aab3654c46$var$K;
        $3a42d2aab3654c46$var$K |= 4;
        $3a42d2aab3654c46$var$Zk.current = null;
        $3a42d2aab3654c46$var$yk(a, c);
        $3a42d2aab3654c46$var$Ui = $3a42d2aab3654c46$var$Ti();
        $3a42d2aab3654c46$var$Mk(a, c, e);
        $3a42d2aab3654c46$var$bf($3a42d2aab3654c46$var$Rf);
        $3a42d2aab3654c46$var$rd = !!$3a42d2aab3654c46$var$Qf;
        $3a42d2aab3654c46$var$Rf = $3a42d2aab3654c46$var$Qf = null;
        a.current = c;
        null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markLayoutEffectsStarted && $3a42d2aab3654c46$var$B.markLayoutEffectsStarted(e);
        $3a42d2aab3654c46$var$Sk(c, a, e);
        null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markLayoutEffectsStopped && $3a42d2aab3654c46$var$B.markLayoutEffectsStopped();
        $3a42d2aab3654c46$var$dc();
        $3a42d2aab3654c46$var$K = h;
        $3a42d2aab3654c46$var$E = g;
        $3a42d2aab3654c46$var$$k.transition = f;
    } else a.current = c, $3a42d2aab3654c46$var$Ui = $3a42d2aab3654c46$var$Ti();
    $3a42d2aab3654c46$var$gl && ($3a42d2aab3654c46$var$gl = !1, $3a42d2aab3654c46$var$hl = a, $3a42d2aab3654c46$var$il = e);
    f = a.pendingLanes;
    0 === f && ($3a42d2aab3654c46$var$tj = null);
    $3a42d2aab3654c46$var$nc(c.stateNode, d);
    $3a42d2aab3654c46$var$mc && a.memoizedUpdaters.clear();
    $3a42d2aab3654c46$var$pl(a, $3a42d2aab3654c46$var$A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($3a42d2aab3654c46$var$qj) throw $3a42d2aab3654c46$var$qj = !1, a = $3a42d2aab3654c46$var$rj, $3a42d2aab3654c46$var$rj = null, a;
    0 !== ($3a42d2aab3654c46$var$il & 1) && 0 !== a.tag && $3a42d2aab3654c46$var$tl();
    f = a.pendingLanes;
    0 !== (f & 1) ? ($3a42d2aab3654c46$var$Zi = !0, a === $3a42d2aab3654c46$var$ll ? $3a42d2aab3654c46$var$kl++ : ($3a42d2aab3654c46$var$kl = 0, $3a42d2aab3654c46$var$ll = a)) : $3a42d2aab3654c46$var$kl = 0;
    $3a42d2aab3654c46$var$xg();
    $3a42d2aab3654c46$var$rc();
    return null;
}
function $3a42d2aab3654c46$var$tl() {
    if (null !== $3a42d2aab3654c46$var$hl) {
        var a = $3a42d2aab3654c46$var$Rc($3a42d2aab3654c46$var$il), b = $3a42d2aab3654c46$var$$k.transition, c = $3a42d2aab3654c46$var$E;
        try {
            $3a42d2aab3654c46$var$$k.transition = null;
            $3a42d2aab3654c46$var$E = 16 > a ? 16 : a;
            if (null === $3a42d2aab3654c46$var$hl) var d = !1;
            else {
                a = $3a42d2aab3654c46$var$hl;
                var e = $3a42d2aab3654c46$var$il;
                $3a42d2aab3654c46$var$hl = null;
                $3a42d2aab3654c46$var$il = 0;
                if (0 !== ($3a42d2aab3654c46$var$K & 6)) throw Error($3a42d2aab3654c46$var$p(331));
                null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markPassiveEffectsStarted && $3a42d2aab3654c46$var$B.markPassiveEffectsStarted(e);
                e = $3a42d2aab3654c46$var$K;
                $3a42d2aab3654c46$var$K |= 4;
                for($3a42d2aab3654c46$var$U = a.current; null !== $3a42d2aab3654c46$var$U;){
                    var f = $3a42d2aab3654c46$var$U, g = f.child;
                    if (0 !== ($3a42d2aab3654c46$var$U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($3a42d2aab3654c46$var$U = l; null !== $3a42d2aab3654c46$var$U;){
                                    var n = $3a42d2aab3654c46$var$U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? ($3a42d2aab3654c46$var$Xi = $3a42d2aab3654c46$var$Ti(), $3a42d2aab3654c46$var$zk(8, q, f), $3a42d2aab3654c46$var$bj(q)) : $3a42d2aab3654c46$var$zk(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, $3a42d2aab3654c46$var$U = r;
                                    else for(; null !== $3a42d2aab3654c46$var$U;){
                                        n = $3a42d2aab3654c46$var$U;
                                        var z = n.sibling, m = n.return;
                                        $3a42d2aab3654c46$var$Ck(n);
                                        if (n === l) {
                                            $3a42d2aab3654c46$var$U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            $3a42d2aab3654c46$var$U = z;
                                            break;
                                        }
                                        $3a42d2aab3654c46$var$U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            $3a42d2aab3654c46$var$U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $3a42d2aab3654c46$var$U = g;
                    else b: for(; null !== $3a42d2aab3654c46$var$U;){
                        f = $3a42d2aab3654c46$var$U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? ($3a42d2aab3654c46$var$Xi = $3a42d2aab3654c46$var$Ti(), $3a42d2aab3654c46$var$zk(9, k, k.return), $3a42d2aab3654c46$var$bj(k)) : $3a42d2aab3654c46$var$zk(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            $3a42d2aab3654c46$var$U = y;
                            break b;
                        }
                        $3a42d2aab3654c46$var$U = f.return;
                    }
                }
                var v = a.current;
                for($3a42d2aab3654c46$var$U = v; null !== $3a42d2aab3654c46$var$U;){
                    g = $3a42d2aab3654c46$var$U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, $3a42d2aab3654c46$var$U = D;
                    else b: for(g = v; null !== $3a42d2aab3654c46$var$U;){
                        h = $3a42d2aab3654c46$var$U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        $3a42d2aab3654c46$var$Xi = $3a42d2aab3654c46$var$Ti();
                                        try {
                                            $3a42d2aab3654c46$var$Ak(9, l);
                                        } finally{
                                            $3a42d2aab3654c46$var$bj(l);
                                        }
                                    } else $3a42d2aab3654c46$var$Ak(9, l);
                            }
                        } catch (Pj) {
                            $3a42d2aab3654c46$var$W(h, h.return, Pj);
                        }
                        if (h === g) {
                            $3a42d2aab3654c46$var$U = null;
                            break b;
                        }
                        var ca = h.sibling;
                        if (null !== ca) {
                            ca.return = h.return;
                            $3a42d2aab3654c46$var$U = ca;
                            break b;
                        }
                        $3a42d2aab3654c46$var$U = h.return;
                    }
                }
                v = $3a42d2aab3654c46$var$jl;
                $3a42d2aab3654c46$var$jl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Bl = V.id, yi = V.onPostCommit;
                            ca = $3a42d2aab3654c46$var$Ui;
                            var zi = null === R.alternate ? "mount" : "update";
                            $3a42d2aab3654c46$var$Yi && (zi = "nested-update");
                            "function" === typeof yi && yi(Bl, zi, sa, ca);
                            var lb = R.return;
                            b: for(; null !== lb;){
                                switch(lb.tag){
                                    case 3:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                lb = lb.return;
                            }
                    }
                }
                null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markPassiveEffectsStopped && $3a42d2aab3654c46$var$B.markPassiveEffectsStopped();
                $3a42d2aab3654c46$var$K = e;
                $3a42d2aab3654c46$var$xg();
                if ($3a42d2aab3654c46$var$lc && "function" === typeof $3a42d2aab3654c46$var$lc.onPostCommitFiberRoot) try {
                    $3a42d2aab3654c46$var$lc.onPostCommitFiberRoot($3a42d2aab3654c46$var$kc, a);
                } catch (Pj) {}
                var Qj = a.current.stateNode;
                Qj.effectDuration = 0;
                Qj.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            $3a42d2aab3654c46$var$E = c, $3a42d2aab3654c46$var$$k.transition = b;
        }
    }
    return !1;
}
function $3a42d2aab3654c46$var$Wk(a) {
    $3a42d2aab3654c46$var$jl.push(a);
    $3a42d2aab3654c46$var$gl || ($3a42d2aab3654c46$var$gl = !0, $3a42d2aab3654c46$var$rl($3a42d2aab3654c46$var$hc, function() {
        $3a42d2aab3654c46$var$tl();
        return null;
    }));
}
function $3a42d2aab3654c46$var$Kl(a, b, c) {
    b = $3a42d2aab3654c46$var$lj(c, b);
    b = $3a42d2aab3654c46$var$pj(a, b, 1);
    a = $3a42d2aab3654c46$var$Bh(a, b, 1);
    b = $3a42d2aab3654c46$var$Ri();
    null !== a && ($3a42d2aab3654c46$var$Mc(a, 1, b), $3a42d2aab3654c46$var$pl(a, b));
}
function $3a42d2aab3654c46$var$W(a, b, c) {
    if (3 === a.tag) $3a42d2aab3654c46$var$Kl(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $3a42d2aab3654c46$var$Kl(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $3a42d2aab3654c46$var$tj || !$3a42d2aab3654c46$var$tj.has(d))) {
                a = $3a42d2aab3654c46$var$lj(c, a);
                a = $3a42d2aab3654c46$var$sj(b, a, 1);
                b = $3a42d2aab3654c46$var$Bh(b, a, 1);
                a = $3a42d2aab3654c46$var$Ri();
                null !== b && ($3a42d2aab3654c46$var$Mc(b, 1, a), $3a42d2aab3654c46$var$pl(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $3a42d2aab3654c46$var$vj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $3a42d2aab3654c46$var$Ri();
    a.pingedLanes |= a.suspendedLanes & c;
    $3a42d2aab3654c46$var$Q === a && ($3a42d2aab3654c46$var$Z & c) === c && (4 === $3a42d2aab3654c46$var$T || 3 === $3a42d2aab3654c46$var$T && ($3a42d2aab3654c46$var$Z & 130023424) === $3a42d2aab3654c46$var$Z && 500 > $3a42d2aab3654c46$var$A() - $3a42d2aab3654c46$var$Qk ? $3a42d2aab3654c46$var$wl(a, 0) : $3a42d2aab3654c46$var$cl |= c);
    $3a42d2aab3654c46$var$pl(a, b);
}
function $3a42d2aab3654c46$var$Ll(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $3a42d2aab3654c46$var$Ec, $3a42d2aab3654c46$var$Ec <<= 1, 0 === ($3a42d2aab3654c46$var$Ec & 130023424) && ($3a42d2aab3654c46$var$Ec = 4194304)));
    var c = $3a42d2aab3654c46$var$Ri();
    a = $3a42d2aab3654c46$var$wh(a, b);
    null !== a && ($3a42d2aab3654c46$var$Mc(a, b, c), $3a42d2aab3654c46$var$pl(a, c));
}
function $3a42d2aab3654c46$var$ak(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $3a42d2aab3654c46$var$Ll(a, c);
}
function $3a42d2aab3654c46$var$Lk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($3a42d2aab3654c46$var$p(314));
    }
    null !== d && d.delete(b);
    $3a42d2aab3654c46$var$Ll(a, c);
}
var $3a42d2aab3654c46$var$Il;
$3a42d2aab3654c46$var$Il = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $3a42d2aab3654c46$var$jg.current) $3a42d2aab3654c46$var$rh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $3a42d2aab3654c46$var$rh = !1, $3a42d2aab3654c46$var$ek(a, b, c);
            $3a42d2aab3654c46$var$rh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $3a42d2aab3654c46$var$rh = !1, $3a42d2aab3654c46$var$J && 0 !== (b.flags & 1048576) && $3a42d2aab3654c46$var$Ig(b, $3a42d2aab3654c46$var$Bg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $3a42d2aab3654c46$var$Mj(a, b);
            a = b.pendingProps;
            var e = $3a42d2aab3654c46$var$lg(b, $3a42d2aab3654c46$var$I.current);
            $3a42d2aab3654c46$var$qh(b, c);
            $3a42d2aab3654c46$var$sc(b);
            e = $3a42d2aab3654c46$var$ai(null, b, d, a, e, c);
            var f = $3a42d2aab3654c46$var$fi();
            $3a42d2aab3654c46$var$tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $3a42d2aab3654c46$var$mg(d) ? (f = !0, $3a42d2aab3654c46$var$qg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $3a42d2aab3654c46$var$yh(b), e.updater = $3a42d2aab3654c46$var$gj, b.stateNode = e, e._reactInternals = b, $3a42d2aab3654c46$var$kj(b, d, a, c), b = $3a42d2aab3654c46$var$Nj(null, b, d, !0, f, c)) : (b.tag = 0, $3a42d2aab3654c46$var$J && f && $3a42d2aab3654c46$var$Jg(b), $3a42d2aab3654c46$var$Aj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $3a42d2aab3654c46$var$Mj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $3a42d2aab3654c46$var$Ml(d);
                a = $3a42d2aab3654c46$var$ej(d, a);
                switch(e){
                    case 0:
                        b = $3a42d2aab3654c46$var$Gj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $3a42d2aab3654c46$var$Lj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $3a42d2aab3654c46$var$Bj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $3a42d2aab3654c46$var$Dj(null, b, d, $3a42d2aab3654c46$var$ej(d.type, a), c);
                        break a;
                }
                throw Error($3a42d2aab3654c46$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3a42d2aab3654c46$var$ej(d, e), $3a42d2aab3654c46$var$Gj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3a42d2aab3654c46$var$ej(d, e), $3a42d2aab3654c46$var$Lj(a, b, d, e, c);
        case 3:
            a: {
                $3a42d2aab3654c46$var$Oj(b);
                if (null === a) throw Error($3a42d2aab3654c46$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $3a42d2aab3654c46$var$zh(a, b);
                $3a42d2aab3654c46$var$Eh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $3a42d2aab3654c46$var$lj(Error($3a42d2aab3654c46$var$p(423)), b);
                        b = $3a42d2aab3654c46$var$Rj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $3a42d2aab3654c46$var$lj(Error($3a42d2aab3654c46$var$p(424)), b);
                        b = $3a42d2aab3654c46$var$Rj(a, b, d, c, e);
                        break a;
                    } else for($3a42d2aab3654c46$var$Mg = $3a42d2aab3654c46$var$Zf(b.stateNode.containerInfo.firstChild), $3a42d2aab3654c46$var$Lg = b, $3a42d2aab3654c46$var$J = !0, $3a42d2aab3654c46$var$Ng = null, c = $3a42d2aab3654c46$var$ih(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $3a42d2aab3654c46$var$Wg();
                    if (d === e) {
                        b = $3a42d2aab3654c46$var$Cj(a, b, c);
                        break a;
                    }
                    $3a42d2aab3654c46$var$Aj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $3a42d2aab3654c46$var$Oh(b), null === a && $3a42d2aab3654c46$var$Sg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $3a42d2aab3654c46$var$Sf(d, e) ? g = null : null !== f && $3a42d2aab3654c46$var$Sf(d, f) && (b.flags |= 32), $3a42d2aab3654c46$var$Kj(a, b), $3a42d2aab3654c46$var$Aj(a, b, g, c), b.child;
        case 6:
            return null === a && $3a42d2aab3654c46$var$Sg(b), null;
        case 13:
            return $3a42d2aab3654c46$var$Uj(a, b, c);
        case 4:
            return $3a42d2aab3654c46$var$Mh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $3a42d2aab3654c46$var$hh(b, null, d, c) : $3a42d2aab3654c46$var$Aj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3a42d2aab3654c46$var$ej(d, e), $3a42d2aab3654c46$var$Bj(a, b, d, e, c);
        case 7:
            return $3a42d2aab3654c46$var$Aj(a, b, b.pendingProps, c), b.child;
        case 8:
            return $3a42d2aab3654c46$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, $3a42d2aab3654c46$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $3a42d2aab3654c46$var$H($3a42d2aab3654c46$var$jh, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($3a42d2aab3654c46$var$Ve(f.value, g)) {
                        if (f.children === e.children && !$3a42d2aab3654c46$var$jg.current) {
                            b = $3a42d2aab3654c46$var$Cj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $3a42d2aab3654c46$var$Ah(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $3a42d2aab3654c46$var$ph(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($3a42d2aab3654c46$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $3a42d2aab3654c46$var$ph(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $3a42d2aab3654c46$var$Aj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $3a42d2aab3654c46$var$qh(b, c), e = $3a42d2aab3654c46$var$sh(e), $3a42d2aab3654c46$var$sc(b), d = d(e), $3a42d2aab3654c46$var$tc(), b.flags |= 1, $3a42d2aab3654c46$var$Aj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $3a42d2aab3654c46$var$ej(d, b.pendingProps), e = $3a42d2aab3654c46$var$ej(d.type, e), $3a42d2aab3654c46$var$Dj(a, b, d, e, c);
        case 15:
            return $3a42d2aab3654c46$var$Fj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3a42d2aab3654c46$var$ej(d, e), $3a42d2aab3654c46$var$Mj(a, b), b.tag = 1, $3a42d2aab3654c46$var$mg(d) ? (a = !0, $3a42d2aab3654c46$var$qg(b)) : a = !1, $3a42d2aab3654c46$var$qh(b, c), $3a42d2aab3654c46$var$ij(b, d, e), $3a42d2aab3654c46$var$kj(b, d, e, c), $3a42d2aab3654c46$var$Nj(null, b, d, !0, a, c);
        case 19:
            return $3a42d2aab3654c46$var$dk(a, b, c);
        case 22:
            return $3a42d2aab3654c46$var$Hj(a, b, c);
    }
    throw Error($3a42d2aab3654c46$var$p(156, b.tag));
};
function $3a42d2aab3654c46$var$wj(a, b) {
    $3a42d2aab3654c46$var$mc && a.memoizedUpdaters.forEach(function(c) {
        $3a42d2aab3654c46$var$Pc(a, c, b);
    });
}
function $3a42d2aab3654c46$var$rl(a, b) {
    return $3a42d2aab3654c46$var$ac(a, b);
}
function $3a42d2aab3654c46$var$Nl(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function $3a42d2aab3654c46$var$Pg(a, b, c, d) {
    return new $3a42d2aab3654c46$var$Nl(a, b, c, d);
}
function $3a42d2aab3654c46$var$Ej(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $3a42d2aab3654c46$var$Ml(a) {
    if ("function" === typeof a) return $3a42d2aab3654c46$var$Ej(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $3a42d2aab3654c46$var$Da) return 11;
        if (a === $3a42d2aab3654c46$var$Ga) return 14;
    }
    return 2;
}
function $3a42d2aab3654c46$var$ch(a, b) {
    var c = a.alternate;
    null === c ? (c = $3a42d2aab3654c46$var$Pg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function $3a42d2aab3654c46$var$eh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $3a42d2aab3654c46$var$Ej(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $3a42d2aab3654c46$var$ya:
            return $3a42d2aab3654c46$var$gh(c.children, e, f, b);
        case $3a42d2aab3654c46$var$za:
            g = 8;
            e |= 8;
            break;
        case $3a42d2aab3654c46$var$Aa:
            return a = $3a42d2aab3654c46$var$Pg(12, c, b, e | 2), a.elementType = $3a42d2aab3654c46$var$Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case $3a42d2aab3654c46$var$Ea:
            return a = $3a42d2aab3654c46$var$Pg(13, c, b, e), a.elementType = $3a42d2aab3654c46$var$Ea, a.lanes = f, a;
        case $3a42d2aab3654c46$var$Fa:
            return a = $3a42d2aab3654c46$var$Pg(19, c, b, e), a.elementType = $3a42d2aab3654c46$var$Fa, a.lanes = f, a;
        case $3a42d2aab3654c46$var$Ia:
            return $3a42d2aab3654c46$var$Vj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $3a42d2aab3654c46$var$Ba:
                    g = 10;
                    break a;
                case $3a42d2aab3654c46$var$Ca:
                    g = 9;
                    break a;
                case $3a42d2aab3654c46$var$Da:
                    g = 11;
                    break a;
                case $3a42d2aab3654c46$var$Ga:
                    g = 14;
                    break a;
                case $3a42d2aab3654c46$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($3a42d2aab3654c46$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $3a42d2aab3654c46$var$Pg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $3a42d2aab3654c46$var$gh(a, b, c, d) {
    a = $3a42d2aab3654c46$var$Pg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $3a42d2aab3654c46$var$Vj(a, b, c, d) {
    a = $3a42d2aab3654c46$var$Pg(22, a, d, b);
    a.elementType = $3a42d2aab3654c46$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $3a42d2aab3654c46$var$dh(a, b, c) {
    a = $3a42d2aab3654c46$var$Pg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $3a42d2aab3654c46$var$fh(a, b, c) {
    b = $3a42d2aab3654c46$var$Pg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $3a42d2aab3654c46$var$Ol(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $3a42d2aab3654c46$var$Lc(0);
    this.expirationTimes = $3a42d2aab3654c46$var$Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $3a42d2aab3654c46$var$Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function $3a42d2aab3654c46$var$Pl(a, b, c, d, e, f, g, h, k) {
    a = new $3a42d2aab3654c46$var$Ol(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    $3a42d2aab3654c46$var$mc && (b |= 2);
    f = $3a42d2aab3654c46$var$Pg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $3a42d2aab3654c46$var$yh(f);
    return a;
}
function $3a42d2aab3654c46$var$Ql(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $3a42d2aab3654c46$var$xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $3a42d2aab3654c46$var$Rl(a) {
    if (!a) return $3a42d2aab3654c46$var$ig;
    a = a._reactInternals;
    a: {
        if ($3a42d2aab3654c46$var$Vb(a) !== a || 1 !== a.tag) throw Error($3a42d2aab3654c46$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($3a42d2aab3654c46$var$mg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($3a42d2aab3654c46$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($3a42d2aab3654c46$var$mg(c)) return $3a42d2aab3654c46$var$pg(a, c, b);
    }
    return b;
}
function $3a42d2aab3654c46$var$Sl(a, b, c, d, e, f, g, h, k) {
    a = $3a42d2aab3654c46$var$Pl(c, d, !0, a, e, f, g, h, k);
    a.context = $3a42d2aab3654c46$var$Rl(null);
    c = a.current;
    d = $3a42d2aab3654c46$var$Ri();
    e = $3a42d2aab3654c46$var$Oi(c);
    f = $3a42d2aab3654c46$var$Ah(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $3a42d2aab3654c46$var$Bh(c, f, e);
    a.current.lanes = e;
    $3a42d2aab3654c46$var$Mc(a, e, d);
    $3a42d2aab3654c46$var$pl(a, d);
    return a;
}
function $3a42d2aab3654c46$var$Tl(a, b, c, d) {
    var e = b.current, f = $3a42d2aab3654c46$var$Ri(), g = $3a42d2aab3654c46$var$Oi(e);
    null !== $3a42d2aab3654c46$var$B && "function" === typeof $3a42d2aab3654c46$var$B.markRenderScheduled && $3a42d2aab3654c46$var$B.markRenderScheduled(g);
    c = $3a42d2aab3654c46$var$Rl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $3a42d2aab3654c46$var$Ah(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $3a42d2aab3654c46$var$Bh(e, b, g);
    null !== a && ($3a42d2aab3654c46$var$ui(a, e, g, f), $3a42d2aab3654c46$var$Ch(a, e, g));
    return g;
}
function $3a42d2aab3654c46$var$Ul(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $3a42d2aab3654c46$var$Vl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $3a42d2aab3654c46$var$Wl(a, b) {
    $3a42d2aab3654c46$var$Vl(a, b);
    (a = a.alternate) && $3a42d2aab3654c46$var$Vl(a, b);
}
function $3a42d2aab3654c46$var$Xl() {
    return null;
}
var $3a42d2aab3654c46$var$Yl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $3a42d2aab3654c46$var$Zl(a) {
    this._internalRoot = a;
}
$3a42d2aab3654c46$var$$l.prototype.render = $3a42d2aab3654c46$var$Zl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($3a42d2aab3654c46$var$p(409));
    $3a42d2aab3654c46$var$Tl(a, b, null, null);
};
$3a42d2aab3654c46$var$$l.prototype.unmount = $3a42d2aab3654c46$var$Zl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $3a42d2aab3654c46$var$El(function() {
            $3a42d2aab3654c46$var$Tl(null, a, null, null);
        });
        b[$3a42d2aab3654c46$var$If] = null;
    }
};
function $3a42d2aab3654c46$var$$l(a) {
    this._internalRoot = a;
}
$3a42d2aab3654c46$var$$l.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $3a42d2aab3654c46$var$Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $3a42d2aab3654c46$var$dd.length && 0 !== b && b < $3a42d2aab3654c46$var$dd[c].priority; c++);
        $3a42d2aab3654c46$var$dd.splice(c, 0, a);
        0 === c && $3a42d2aab3654c46$var$id(a);
    }
};
function $3a42d2aab3654c46$var$am(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $3a42d2aab3654c46$var$bm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $3a42d2aab3654c46$var$cm() {}
function $3a42d2aab3654c46$var$dm(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $3a42d2aab3654c46$var$Ul(g);
                f.call(a);
            };
        }
        var g = $3a42d2aab3654c46$var$Sl(b, d, a, 0, null, !1, !1, "", $3a42d2aab3654c46$var$cm);
        a._reactRootContainer = g;
        a[$3a42d2aab3654c46$var$If] = g.current;
        $3a42d2aab3654c46$var$Gf(8 === a.nodeType ? a.parentNode : a);
        $3a42d2aab3654c46$var$El();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $3a42d2aab3654c46$var$Ul(k);
            h.call(a);
        };
    }
    var k = $3a42d2aab3654c46$var$Pl(a, 0, !1, null, null, !1, !1, "", $3a42d2aab3654c46$var$cm);
    a._reactRootContainer = k;
    a[$3a42d2aab3654c46$var$If] = k.current;
    $3a42d2aab3654c46$var$Gf(8 === a.nodeType ? a.parentNode : a);
    $3a42d2aab3654c46$var$El(function() {
        $3a42d2aab3654c46$var$Tl(b, k, c, d);
    });
    return k;
}
function $3a42d2aab3654c46$var$em(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $3a42d2aab3654c46$var$Ul(g);
                h.call(a);
            };
        }
        $3a42d2aab3654c46$var$Tl(b, g, a, e);
    } else g = $3a42d2aab3654c46$var$dm(c, b, a, e, d);
    return $3a42d2aab3654c46$var$Ul(g);
}
$3a42d2aab3654c46$var$Sc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $3a42d2aab3654c46$var$Fc(b.pendingLanes);
                0 !== c && ($3a42d2aab3654c46$var$Oc(b, c | 1), $3a42d2aab3654c46$var$pl(b, $3a42d2aab3654c46$var$A()), 0 === ($3a42d2aab3654c46$var$K & 6) && ($3a42d2aab3654c46$var$mk = $3a42d2aab3654c46$var$A() + 500, $3a42d2aab3654c46$var$xg()));
            }
            break;
        case 13:
            $3a42d2aab3654c46$var$El(function() {
                var b = $3a42d2aab3654c46$var$wh(a, 1);
                if (null !== b) {
                    var c = $3a42d2aab3654c46$var$Ri();
                    $3a42d2aab3654c46$var$ui(b, a, 1, c);
                }
            }), $3a42d2aab3654c46$var$Wl(a, 1);
    }
};
$3a42d2aab3654c46$var$Tc = function(a) {
    if (13 === a.tag) {
        var b = $3a42d2aab3654c46$var$wh(a, 134217728);
        if (null !== b) {
            var c = $3a42d2aab3654c46$var$Ri();
            $3a42d2aab3654c46$var$ui(b, a, 134217728, c);
        }
        $3a42d2aab3654c46$var$Wl(a, 134217728);
    }
};
$3a42d2aab3654c46$var$Uc = function(a) {
    if (13 === a.tag) {
        var b = $3a42d2aab3654c46$var$Oi(a), c = $3a42d2aab3654c46$var$wh(a, b);
        if (null !== c) {
            var d = $3a42d2aab3654c46$var$Ri();
            $3a42d2aab3654c46$var$ui(c, a, b, d);
        }
        $3a42d2aab3654c46$var$Wl(a, b);
    }
};
$3a42d2aab3654c46$var$Vc = function() {
    return $3a42d2aab3654c46$var$E;
};
$3a42d2aab3654c46$var$Wc = function(a, b) {
    var c = $3a42d2aab3654c46$var$E;
    try {
        return $3a42d2aab3654c46$var$E = a, b();
    } finally{
        $3a42d2aab3654c46$var$E = c;
    }
};
$3a42d2aab3654c46$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $3a42d2aab3654c46$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $3a42d2aab3654c46$var$Db(d);
                        if (!e) throw Error($3a42d2aab3654c46$var$p(90));
                        $3a42d2aab3654c46$var$Wa(d);
                        $3a42d2aab3654c46$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $3a42d2aab3654c46$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $3a42d2aab3654c46$var$eb(a, !!c.multiple, b, !1);
    }
};
$3a42d2aab3654c46$var$Gb = $3a42d2aab3654c46$var$Dl;
$3a42d2aab3654c46$var$Hb = $3a42d2aab3654c46$var$El;
var $3a42d2aab3654c46$var$fm = {
    usingClientEntryPoint: !1,
    Events: [
        $3a42d2aab3654c46$var$Cb,
        $3a42d2aab3654c46$var$Ie,
        $3a42d2aab3654c46$var$Db,
        $3a42d2aab3654c46$var$Eb,
        $3a42d2aab3654c46$var$Fb,
        $3a42d2aab3654c46$var$Dl
    ]
}, $3a42d2aab3654c46$var$gm = {
    findFiberByHostInstance: $3a42d2aab3654c46$var$jd,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = $3a42d2aab3654c46$var$u({}, a, {
            getLaneLabelMap: $3a42d2aab3654c46$var$pc,
            injectProfilingHooks: $3a42d2aab3654c46$var$oc
        }), $3a42d2aab3654c46$var$kc = b.inject(a), $3a42d2aab3654c46$var$lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: $3a42d2aab3654c46$var$gm.bundleType,
    version: $3a42d2aab3654c46$var$gm.version,
    rendererPackageName: $3a42d2aab3654c46$var$gm.rendererPackageName,
    rendererConfig: $3a42d2aab3654c46$var$gm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $3a42d2aab3654c46$var$va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $3a42d2aab3654c46$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $3a42d2aab3654c46$var$gm.findFiberByHostInstance || $3a42d2aab3654c46$var$Xl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
});
$3a42d2aab3654c46$export$ae55be85d98224ed = $3a42d2aab3654c46$var$fm;
$3a42d2aab3654c46$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$3a42d2aab3654c46$var$am(b)) throw Error($3a42d2aab3654c46$var$p(200));
    return $3a42d2aab3654c46$var$Ql(a, b, null, c);
};
$3a42d2aab3654c46$export$882461b6382ed46c = function(a, b) {
    if (!$3a42d2aab3654c46$var$am(a)) throw Error($3a42d2aab3654c46$var$p(299));
    var c = !1, d = "", e = $3a42d2aab3654c46$var$Yl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $3a42d2aab3654c46$var$Pl(a, 1, !1, null, null, c, !1, d, e);
    a[$3a42d2aab3654c46$var$If] = b.current;
    $3a42d2aab3654c46$var$Gf(8 === a.nodeType ? a.parentNode : a);
    return new $3a42d2aab3654c46$var$Zl(b);
};
$3a42d2aab3654c46$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($3a42d2aab3654c46$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($3a42d2aab3654c46$var$p(268, a));
    }
    a = $3a42d2aab3654c46$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$3a42d2aab3654c46$export$cd75ccfd720a3cd4 = function(a) {
    return $3a42d2aab3654c46$var$El(a);
};
$3a42d2aab3654c46$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$3a42d2aab3654c46$var$bm(b)) throw Error($3a42d2aab3654c46$var$p(200));
    return $3a42d2aab3654c46$var$em(null, a, b, !0, c);
};
$3a42d2aab3654c46$export$757ceba2d55c277e = function(a, b, c) {
    if (!$3a42d2aab3654c46$var$am(a)) throw Error($3a42d2aab3654c46$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $3a42d2aab3654c46$var$Yl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $3a42d2aab3654c46$var$Sl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$3a42d2aab3654c46$var$If] = b.current;
    $3a42d2aab3654c46$var$Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $3a42d2aab3654c46$var$$l(b);
};
$3a42d2aab3654c46$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$3a42d2aab3654c46$var$bm(b)) throw Error($3a42d2aab3654c46$var$p(200));
    return $3a42d2aab3654c46$var$em(null, a, b, !1, c);
};
$3a42d2aab3654c46$export$502457920280e6be = function(a) {
    if (!$3a42d2aab3654c46$var$bm(a)) throw Error($3a42d2aab3654c46$var$p(40));
    return a._reactRootContainer ? ($3a42d2aab3654c46$var$El(function() {
        $3a42d2aab3654c46$var$em(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$3a42d2aab3654c46$var$If] = null;
        });
    }), !0) : !1;
};
$3a42d2aab3654c46$export$c78a37762a8d58e1 = $3a42d2aab3654c46$var$Dl;
$3a42d2aab3654c46$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$3a42d2aab3654c46$var$bm(c)) throw Error($3a42d2aab3654c46$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($3a42d2aab3654c46$var$p(38));
    return $3a42d2aab3654c46$var$em(a, b, c, !1, d);
};
$3a42d2aab3654c46$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

});
parcelRegister("iZu5g", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2SRUA"));

});
parcelRegister("2SRUA", function(module, exports) {
$parcel$export(module.exports, "unstable_now", () => $219a71aa785d70ab$export$c4744153514ff05d, (v) => $219a71aa785d70ab$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $219a71aa785d70ab$export$3e506c1ccc9cc1a7, (v) => $219a71aa785d70ab$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $219a71aa785d70ab$export$e26fe2ed2fa76875, (v) => $219a71aa785d70ab$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $219a71aa785d70ab$export$502329bbf4b505b1, (v) => $219a71aa785d70ab$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $219a71aa785d70ab$export$6e3807111c4874c4, (v) => $219a71aa785d70ab$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $219a71aa785d70ab$export$c27134553091fb3a, (v) => $219a71aa785d70ab$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $219a71aa785d70ab$export$33ee1acdc04fd2a2, (v) => $219a71aa785d70ab$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $219a71aa785d70ab$export$b00a404bbd5edef2, (v) => $219a71aa785d70ab$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $219a71aa785d70ab$export$8352ce38b91d0c62, (v) => $219a71aa785d70ab$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $219a71aa785d70ab$export$d66a1c1c77bd778b, (v) => $219a71aa785d70ab$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $219a71aa785d70ab$export$d3dfb8e4810cb555, (v) => $219a71aa785d70ab$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $219a71aa785d70ab$export$839f9183b0465a69, (v) => $219a71aa785d70ab$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $219a71aa785d70ab$export$72fdf0e06517287b, (v) => $219a71aa785d70ab$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $219a71aa785d70ab$export$4b844e58a3e414b4, (v) => $219a71aa785d70ab$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $219a71aa785d70ab$export$816d2913ae6b83b1, (v) => $219a71aa785d70ab$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $219a71aa785d70ab$export$61bcfe829111a1d0, (v) => $219a71aa785d70ab$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $219a71aa785d70ab$export$7ee8c9beb337bc3f, (v) => $219a71aa785d70ab$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $219a71aa785d70ab$export$b5836b71941fa3ed, (v) => $219a71aa785d70ab$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $219a71aa785d70ab$export$cf845f2c119da08a, (v) => $219a71aa785d70ab$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $219a71aa785d70ab$export$c4744153514ff05d;
var $219a71aa785d70ab$export$3e506c1ccc9cc1a7;
var $219a71aa785d70ab$export$e26fe2ed2fa76875;
var $219a71aa785d70ab$export$502329bbf4b505b1;
var $219a71aa785d70ab$export$6e3807111c4874c4;
var $219a71aa785d70ab$export$c27134553091fb3a;
var $219a71aa785d70ab$export$33ee1acdc04fd2a2;
var $219a71aa785d70ab$export$b00a404bbd5edef2;
var $219a71aa785d70ab$export$8352ce38b91d0c62;
var $219a71aa785d70ab$export$d66a1c1c77bd778b;
var $219a71aa785d70ab$export$d3dfb8e4810cb555;
var $219a71aa785d70ab$export$839f9183b0465a69;
var $219a71aa785d70ab$export$72fdf0e06517287b;
var $219a71aa785d70ab$export$4b844e58a3e414b4;
var $219a71aa785d70ab$export$816d2913ae6b83b1;
var $219a71aa785d70ab$export$61bcfe829111a1d0;
var $219a71aa785d70ab$export$7ee8c9beb337bc3f;
var $219a71aa785d70ab$export$b5836b71941fa3ed;
var $219a71aa785d70ab$export$cf845f2c119da08a;
'use strict';
function $219a71aa785d70ab$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $219a71aa785d70ab$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $219a71aa785d70ab$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $219a71aa785d70ab$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $219a71aa785d70ab$var$g(C, c)) n < e && 0 > $219a71aa785d70ab$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $219a71aa785d70ab$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $219a71aa785d70ab$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $219a71aa785d70ab$var$l = performance;
    $219a71aa785d70ab$export$c4744153514ff05d = function() {
        return $219a71aa785d70ab$var$l.now();
    };
} else {
    var $219a71aa785d70ab$var$p = Date, $219a71aa785d70ab$var$q = $219a71aa785d70ab$var$p.now();
    $219a71aa785d70ab$export$c4744153514ff05d = function() {
        return $219a71aa785d70ab$var$p.now() - $219a71aa785d70ab$var$q;
    };
}
var $219a71aa785d70ab$var$r = [], $219a71aa785d70ab$var$t = [], $219a71aa785d70ab$var$u = 1, $219a71aa785d70ab$var$v = null, $219a71aa785d70ab$var$y = 3, $219a71aa785d70ab$var$z = !1, $219a71aa785d70ab$var$A = !1, $219a71aa785d70ab$var$B = !1, $219a71aa785d70ab$var$D = "function" === typeof setTimeout ? setTimeout : null, $219a71aa785d70ab$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $219a71aa785d70ab$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $219a71aa785d70ab$var$G(a) {
    for(var b = $219a71aa785d70ab$var$h($219a71aa785d70ab$var$t); null !== b;){
        if (null === b.callback) $219a71aa785d70ab$var$k($219a71aa785d70ab$var$t);
        else if (b.startTime <= a) $219a71aa785d70ab$var$k($219a71aa785d70ab$var$t), b.sortIndex = b.expirationTime, $219a71aa785d70ab$var$f($219a71aa785d70ab$var$r, b);
        else break;
        b = $219a71aa785d70ab$var$h($219a71aa785d70ab$var$t);
    }
}
function $219a71aa785d70ab$var$H(a) {
    $219a71aa785d70ab$var$B = !1;
    $219a71aa785d70ab$var$G(a);
    if (!$219a71aa785d70ab$var$A) {
        if (null !== $219a71aa785d70ab$var$h($219a71aa785d70ab$var$r)) $219a71aa785d70ab$var$A = !0, $219a71aa785d70ab$var$I($219a71aa785d70ab$var$J);
        else {
            var b = $219a71aa785d70ab$var$h($219a71aa785d70ab$var$t);
            null !== b && $219a71aa785d70ab$var$K($219a71aa785d70ab$var$H, b.startTime - a);
        }
    }
}
function $219a71aa785d70ab$var$J(a, b) {
    $219a71aa785d70ab$var$A = !1;
    $219a71aa785d70ab$var$B && ($219a71aa785d70ab$var$B = !1, $219a71aa785d70ab$var$E($219a71aa785d70ab$var$L), $219a71aa785d70ab$var$L = -1);
    $219a71aa785d70ab$var$z = !0;
    var c = $219a71aa785d70ab$var$y;
    try {
        $219a71aa785d70ab$var$G(b);
        for($219a71aa785d70ab$var$v = $219a71aa785d70ab$var$h($219a71aa785d70ab$var$r); null !== $219a71aa785d70ab$var$v && (!($219a71aa785d70ab$var$v.expirationTime > b) || a && !$219a71aa785d70ab$var$M());){
            var d = $219a71aa785d70ab$var$v.callback;
            if ("function" === typeof d) {
                $219a71aa785d70ab$var$v.callback = null;
                $219a71aa785d70ab$var$y = $219a71aa785d70ab$var$v.priorityLevel;
                var e = d($219a71aa785d70ab$var$v.expirationTime <= b);
                b = $219a71aa785d70ab$export$c4744153514ff05d();
                "function" === typeof e ? $219a71aa785d70ab$var$v.callback = e : $219a71aa785d70ab$var$v === $219a71aa785d70ab$var$h($219a71aa785d70ab$var$r) && $219a71aa785d70ab$var$k($219a71aa785d70ab$var$r);
                $219a71aa785d70ab$var$G(b);
            } else $219a71aa785d70ab$var$k($219a71aa785d70ab$var$r);
            $219a71aa785d70ab$var$v = $219a71aa785d70ab$var$h($219a71aa785d70ab$var$r);
        }
        if (null !== $219a71aa785d70ab$var$v) var w = !0;
        else {
            var m = $219a71aa785d70ab$var$h($219a71aa785d70ab$var$t);
            null !== m && $219a71aa785d70ab$var$K($219a71aa785d70ab$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $219a71aa785d70ab$var$v = null, $219a71aa785d70ab$var$y = c, $219a71aa785d70ab$var$z = !1;
    }
}
var $219a71aa785d70ab$var$N = !1, $219a71aa785d70ab$var$O = null, $219a71aa785d70ab$var$L = -1, $219a71aa785d70ab$var$P = 5, $219a71aa785d70ab$var$Q = -1;
function $219a71aa785d70ab$var$M() {
    return $219a71aa785d70ab$export$c4744153514ff05d() - $219a71aa785d70ab$var$Q < $219a71aa785d70ab$var$P ? !1 : !0;
}
function $219a71aa785d70ab$var$R() {
    if (null !== $219a71aa785d70ab$var$O) {
        var a = $219a71aa785d70ab$export$c4744153514ff05d();
        $219a71aa785d70ab$var$Q = a;
        var b = !0;
        try {
            b = $219a71aa785d70ab$var$O(!0, a);
        } finally{
            b ? $219a71aa785d70ab$var$S() : ($219a71aa785d70ab$var$N = !1, $219a71aa785d70ab$var$O = null);
        }
    } else $219a71aa785d70ab$var$N = !1;
}
var $219a71aa785d70ab$var$S;
if ("function" === typeof $219a71aa785d70ab$var$F) $219a71aa785d70ab$var$S = function() {
    $219a71aa785d70ab$var$F($219a71aa785d70ab$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $219a71aa785d70ab$var$T = new MessageChannel, $219a71aa785d70ab$var$U = $219a71aa785d70ab$var$T.port2;
    $219a71aa785d70ab$var$T.port1.onmessage = $219a71aa785d70ab$var$R;
    $219a71aa785d70ab$var$S = function() {
        $219a71aa785d70ab$var$U.postMessage(null);
    };
} else $219a71aa785d70ab$var$S = function() {
    $219a71aa785d70ab$var$D($219a71aa785d70ab$var$R, 0);
};
function $219a71aa785d70ab$var$I(a) {
    $219a71aa785d70ab$var$O = a;
    $219a71aa785d70ab$var$N || ($219a71aa785d70ab$var$N = !0, $219a71aa785d70ab$var$S());
}
function $219a71aa785d70ab$var$K(a, b) {
    $219a71aa785d70ab$var$L = $219a71aa785d70ab$var$D(function() {
        a($219a71aa785d70ab$export$c4744153514ff05d());
    }, b);
}
$219a71aa785d70ab$export$3e506c1ccc9cc1a7 = 5;
$219a71aa785d70ab$export$e26fe2ed2fa76875 = 1;
$219a71aa785d70ab$export$502329bbf4b505b1 = 4;
$219a71aa785d70ab$export$6e3807111c4874c4 = 3;
$219a71aa785d70ab$export$c27134553091fb3a = null;
$219a71aa785d70ab$export$33ee1acdc04fd2a2 = 2;
$219a71aa785d70ab$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$219a71aa785d70ab$export$8352ce38b91d0c62 = function() {
    $219a71aa785d70ab$var$A || $219a71aa785d70ab$var$z || ($219a71aa785d70ab$var$A = !0, $219a71aa785d70ab$var$I($219a71aa785d70ab$var$J));
};
$219a71aa785d70ab$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $219a71aa785d70ab$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$219a71aa785d70ab$export$d3dfb8e4810cb555 = function() {
    return $219a71aa785d70ab$var$y;
};
$219a71aa785d70ab$export$839f9183b0465a69 = function() {
    return $219a71aa785d70ab$var$h($219a71aa785d70ab$var$r);
};
$219a71aa785d70ab$export$72fdf0e06517287b = function(a) {
    switch($219a71aa785d70ab$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $219a71aa785d70ab$var$y;
    }
    var c = $219a71aa785d70ab$var$y;
    $219a71aa785d70ab$var$y = b;
    try {
        return a();
    } finally{
        $219a71aa785d70ab$var$y = c;
    }
};
$219a71aa785d70ab$export$4b844e58a3e414b4 = function() {};
$219a71aa785d70ab$export$816d2913ae6b83b1 = function() {};
$219a71aa785d70ab$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $219a71aa785d70ab$var$y;
    $219a71aa785d70ab$var$y = a;
    try {
        return b();
    } finally{
        $219a71aa785d70ab$var$y = c;
    }
};
$219a71aa785d70ab$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $219a71aa785d70ab$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $219a71aa785d70ab$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $219a71aa785d70ab$var$f($219a71aa785d70ab$var$t, a), null === $219a71aa785d70ab$var$h($219a71aa785d70ab$var$r) && a === $219a71aa785d70ab$var$h($219a71aa785d70ab$var$t) && ($219a71aa785d70ab$var$B ? ($219a71aa785d70ab$var$E($219a71aa785d70ab$var$L), $219a71aa785d70ab$var$L = -1) : $219a71aa785d70ab$var$B = !0, $219a71aa785d70ab$var$K($219a71aa785d70ab$var$H, c - d))) : (a.sortIndex = e, $219a71aa785d70ab$var$f($219a71aa785d70ab$var$r, a), $219a71aa785d70ab$var$A || $219a71aa785d70ab$var$z || ($219a71aa785d70ab$var$A = !0, $219a71aa785d70ab$var$I($219a71aa785d70ab$var$J)));
    return a;
};
$219a71aa785d70ab$export$b5836b71941fa3ed = $219a71aa785d70ab$var$M;
$219a71aa785d70ab$export$cf845f2c119da08a = function(a) {
    var b = $219a71aa785d70ab$var$y;
    return function() {
        var c = $219a71aa785d70ab$var$y;
        $219a71aa785d70ab$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $219a71aa785d70ab$var$y = c;
        }
    };
};

});



parcelRegister("2zYso", function(module, exports) {
$parcel$export(module.exports, "Buffer", () => $1e0dbf22a532ebe3$export$a143d493d941bafc, (v) => $1e0dbf22a532ebe3$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $1e0dbf22a532ebe3$export$e4cf37d7f6fb9e0a, (v) => $1e0dbf22a532ebe3$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $1e0dbf22a532ebe3$export$f99ded8fe4b79145, (v) => $1e0dbf22a532ebe3$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $1e0dbf22a532ebe3$export$599f31c3813fae4d, (v) => $1e0dbf22a532ebe3$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $1e0dbf22a532ebe3$export$a143d493d941bafc;
var $1e0dbf22a532ebe3$export$e4cf37d7f6fb9e0a;
var $1e0dbf22a532ebe3$export$f99ded8fe4b79145;
var $1e0dbf22a532ebe3$export$599f31c3813fae4d;
'use strict';

var $b5qIH = parcelRequire("b5qIH");

var $h7Uje = parcelRequire("h7Uje");
const $1e0dbf22a532ebe3$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$1e0dbf22a532ebe3$export$a143d493d941bafc = $1e0dbf22a532ebe3$var$Buffer;
$1e0dbf22a532ebe3$export$e4cf37d7f6fb9e0a = $1e0dbf22a532ebe3$var$SlowBuffer;
$1e0dbf22a532ebe3$export$f99ded8fe4b79145 = 50;
const $1e0dbf22a532ebe3$var$K_MAX_LENGTH = 0x7fffffff;
$1e0dbf22a532ebe3$export$599f31c3813fae4d = $1e0dbf22a532ebe3$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $1e0dbf22a532ebe3$var$Buffer.TYPED_ARRAY_SUPPORT = $1e0dbf22a532ebe3$var$typedArraySupport();
if (!$1e0dbf22a532ebe3$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $1e0dbf22a532ebe3$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($1e0dbf22a532ebe3$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$1e0dbf22a532ebe3$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($1e0dbf22a532ebe3$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$1e0dbf22a532ebe3$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $1e0dbf22a532ebe3$var$createBuffer(length) {
    if (length > $1e0dbf22a532ebe3$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $1e0dbf22a532ebe3$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $1e0dbf22a532ebe3$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $1e0dbf22a532ebe3$var$allocUnsafe(arg);
    }
    return $1e0dbf22a532ebe3$var$from(arg, encodingOrOffset, length);
}
$1e0dbf22a532ebe3$var$Buffer.poolSize = 8192; // not used by this implementation
function $1e0dbf22a532ebe3$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $1e0dbf22a532ebe3$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $1e0dbf22a532ebe3$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($1e0dbf22a532ebe3$var$isInstance(value, ArrayBuffer) || value && $1e0dbf22a532ebe3$var$isInstance(value.buffer, ArrayBuffer)) return $1e0dbf22a532ebe3$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($1e0dbf22a532ebe3$var$isInstance(value, SharedArrayBuffer) || value && $1e0dbf22a532ebe3$var$isInstance(value.buffer, SharedArrayBuffer))) return $1e0dbf22a532ebe3$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $1e0dbf22a532ebe3$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $1e0dbf22a532ebe3$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $1e0dbf22a532ebe3$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $1e0dbf22a532ebe3$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $1e0dbf22a532ebe3$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($1e0dbf22a532ebe3$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($1e0dbf22a532ebe3$var$Buffer, Uint8Array);
function $1e0dbf22a532ebe3$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $1e0dbf22a532ebe3$var$alloc(size, fill, encoding) {
    $1e0dbf22a532ebe3$var$assertSize(size);
    if (size <= 0) return $1e0dbf22a532ebe3$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $1e0dbf22a532ebe3$var$createBuffer(size).fill(fill, encoding) : $1e0dbf22a532ebe3$var$createBuffer(size).fill(fill);
    return $1e0dbf22a532ebe3$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $1e0dbf22a532ebe3$var$Buffer.alloc = function(size, fill, encoding) {
    return $1e0dbf22a532ebe3$var$alloc(size, fill, encoding);
};
function $1e0dbf22a532ebe3$var$allocUnsafe(size) {
    $1e0dbf22a532ebe3$var$assertSize(size);
    return $1e0dbf22a532ebe3$var$createBuffer(size < 0 ? 0 : $1e0dbf22a532ebe3$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $1e0dbf22a532ebe3$var$Buffer.allocUnsafe = function(size) {
    return $1e0dbf22a532ebe3$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $1e0dbf22a532ebe3$var$Buffer.allocUnsafeSlow = function(size) {
    return $1e0dbf22a532ebe3$var$allocUnsafe(size);
};
function $1e0dbf22a532ebe3$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$1e0dbf22a532ebe3$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $1e0dbf22a532ebe3$var$byteLength(string, encoding) | 0;
    let buf = $1e0dbf22a532ebe3$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $1e0dbf22a532ebe3$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $1e0dbf22a532ebe3$var$checked(array.length) | 0;
    const buf = $1e0dbf22a532ebe3$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $1e0dbf22a532ebe3$var$fromArrayView(arrayView) {
    if ($1e0dbf22a532ebe3$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $1e0dbf22a532ebe3$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $1e0dbf22a532ebe3$var$fromArrayLike(arrayView);
}
function $1e0dbf22a532ebe3$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $1e0dbf22a532ebe3$var$Buffer.prototype);
    return buf;
}
function $1e0dbf22a532ebe3$var$fromObject(obj) {
    if ($1e0dbf22a532ebe3$var$Buffer.isBuffer(obj)) {
        const len = $1e0dbf22a532ebe3$var$checked(obj.length) | 0;
        const buf = $1e0dbf22a532ebe3$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $1e0dbf22a532ebe3$var$numberIsNaN(obj.length)) return $1e0dbf22a532ebe3$var$createBuffer(0);
        return $1e0dbf22a532ebe3$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $1e0dbf22a532ebe3$var$fromArrayLike(obj.data);
}
function $1e0dbf22a532ebe3$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $1e0dbf22a532ebe3$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $1e0dbf22a532ebe3$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $1e0dbf22a532ebe3$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $1e0dbf22a532ebe3$var$Buffer.alloc(+length);
}
$1e0dbf22a532ebe3$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $1e0dbf22a532ebe3$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$1e0dbf22a532ebe3$var$Buffer.compare = function compare(a, b) {
    if ($1e0dbf22a532ebe3$var$isInstance(a, Uint8Array)) a = $1e0dbf22a532ebe3$var$Buffer.from(a, a.offset, a.byteLength);
    if ($1e0dbf22a532ebe3$var$isInstance(b, Uint8Array)) b = $1e0dbf22a532ebe3$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$1e0dbf22a532ebe3$var$Buffer.isBuffer(a) || !$1e0dbf22a532ebe3$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$1e0dbf22a532ebe3$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$1e0dbf22a532ebe3$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $1e0dbf22a532ebe3$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $1e0dbf22a532ebe3$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($1e0dbf22a532ebe3$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$1e0dbf22a532ebe3$var$Buffer.isBuffer(buf)) buf = $1e0dbf22a532ebe3$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$1e0dbf22a532ebe3$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $1e0dbf22a532ebe3$var$byteLength(string, encoding) {
    if ($1e0dbf22a532ebe3$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $1e0dbf22a532ebe3$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $1e0dbf22a532ebe3$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $1e0dbf22a532ebe3$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $1e0dbf22a532ebe3$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$1e0dbf22a532ebe3$var$Buffer.byteLength = $1e0dbf22a532ebe3$var$byteLength;
function $1e0dbf22a532ebe3$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $1e0dbf22a532ebe3$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $1e0dbf22a532ebe3$var$utf8Slice(this, start, end);
        case 'ascii':
            return $1e0dbf22a532ebe3$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $1e0dbf22a532ebe3$var$latin1Slice(this, start, end);
        case 'base64':
            return $1e0dbf22a532ebe3$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $1e0dbf22a532ebe3$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$1e0dbf22a532ebe3$var$Buffer.prototype._isBuffer = true;
function $1e0dbf22a532ebe3$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$1e0dbf22a532ebe3$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$1e0dbf22a532ebe3$var$swap(this, i, i + 1);
    return this;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $1e0dbf22a532ebe3$var$swap(this, i, i + 3);
        $1e0dbf22a532ebe3$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $1e0dbf22a532ebe3$var$swap(this, i, i + 7);
        $1e0dbf22a532ebe3$var$swap(this, i + 1, i + 6);
        $1e0dbf22a532ebe3$var$swap(this, i + 2, i + 5);
        $1e0dbf22a532ebe3$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $1e0dbf22a532ebe3$var$utf8Slice(this, 0, length);
    return $1e0dbf22a532ebe3$var$slowToString.apply(this, arguments);
};
$1e0dbf22a532ebe3$var$Buffer.prototype.toLocaleString = $1e0dbf22a532ebe3$var$Buffer.prototype.toString;
$1e0dbf22a532ebe3$var$Buffer.prototype.equals = function equals(b) {
    if (!$1e0dbf22a532ebe3$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $1e0dbf22a532ebe3$var$Buffer.compare(this, b) === 0;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $1e0dbf22a532ebe3$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($1e0dbf22a532ebe3$var$customInspectSymbol) $1e0dbf22a532ebe3$var$Buffer.prototype[$1e0dbf22a532ebe3$var$customInspectSymbol] = $1e0dbf22a532ebe3$var$Buffer.prototype.inspect;
$1e0dbf22a532ebe3$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($1e0dbf22a532ebe3$var$isInstance(target, Uint8Array)) target = $1e0dbf22a532ebe3$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$1e0dbf22a532ebe3$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $1e0dbf22a532ebe3$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset; // Coerce to Number.
    if ($1e0dbf22a532ebe3$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $1e0dbf22a532ebe3$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($1e0dbf22a532ebe3$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $1e0dbf22a532ebe3$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $1e0dbf22a532ebe3$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $1e0dbf22a532ebe3$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$1e0dbf22a532ebe3$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $1e0dbf22a532ebe3$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$1e0dbf22a532ebe3$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $1e0dbf22a532ebe3$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $1e0dbf22a532ebe3$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($1e0dbf22a532ebe3$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $1e0dbf22a532ebe3$var$utf8Write(buf, string, offset, length) {
    return $1e0dbf22a532ebe3$var$blitBuffer($1e0dbf22a532ebe3$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $1e0dbf22a532ebe3$var$asciiWrite(buf, string, offset, length) {
    return $1e0dbf22a532ebe3$var$blitBuffer($1e0dbf22a532ebe3$var$asciiToBytes(string), buf, offset, length);
}
function $1e0dbf22a532ebe3$var$base64Write(buf, string, offset, length) {
    return $1e0dbf22a532ebe3$var$blitBuffer($1e0dbf22a532ebe3$var$base64ToBytes(string), buf, offset, length);
}
function $1e0dbf22a532ebe3$var$ucs2Write(buf, string, offset, length) {
    return $1e0dbf22a532ebe3$var$blitBuffer($1e0dbf22a532ebe3$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$1e0dbf22a532ebe3$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $1e0dbf22a532ebe3$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $1e0dbf22a532ebe3$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $1e0dbf22a532ebe3$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $1e0dbf22a532ebe3$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $1e0dbf22a532ebe3$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$1e0dbf22a532ebe3$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $1e0dbf22a532ebe3$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $b5qIH.fromByteArray(buf);
    else return $b5qIH.fromByteArray(buf.slice(start, end));
}
function $1e0dbf22a532ebe3$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $1e0dbf22a532ebe3$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $1e0dbf22a532ebe3$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $1e0dbf22a532ebe3$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $1e0dbf22a532ebe3$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $1e0dbf22a532ebe3$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $1e0dbf22a532ebe3$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $1e0dbf22a532ebe3$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $1e0dbf22a532ebe3$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $1e0dbf22a532ebe3$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $1e0dbf22a532ebe3$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$1e0dbf22a532ebe3$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $1e0dbf22a532ebe3$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $1e0dbf22a532ebe3$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$1e0dbf22a532ebe3$var$Buffer.prototype.readUintLE = $1e0dbf22a532ebe3$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.readUintBE = $1e0dbf22a532ebe3$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.readUint8 = $1e0dbf22a532ebe3$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$1e0dbf22a532ebe3$var$Buffer.prototype.readUint16LE = $1e0dbf22a532ebe3$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.readUint16BE = $1e0dbf22a532ebe3$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$1e0dbf22a532ebe3$var$Buffer.prototype.readUint32LE = $1e0dbf22a532ebe3$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.readUint32BE = $1e0dbf22a532ebe3$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$1e0dbf22a532ebe3$var$Buffer.prototype.readBigUInt64LE = $1e0dbf22a532ebe3$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $1e0dbf22a532ebe3$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1e0dbf22a532ebe3$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$1e0dbf22a532ebe3$var$Buffer.prototype.readBigUInt64BE = $1e0dbf22a532ebe3$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $1e0dbf22a532ebe3$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1e0dbf22a532ebe3$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$1e0dbf22a532ebe3$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$1e0dbf22a532ebe3$var$Buffer.prototype.readBigInt64LE = $1e0dbf22a532ebe3$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $1e0dbf22a532ebe3$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1e0dbf22a532ebe3$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$1e0dbf22a532ebe3$var$Buffer.prototype.readBigInt64BE = $1e0dbf22a532ebe3$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $1e0dbf22a532ebe3$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1e0dbf22a532ebe3$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$1e0dbf22a532ebe3$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, 4, this.length);
    return $h7Uje.read(this, offset, true, 23, 4);
};
$1e0dbf22a532ebe3$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, 4, this.length);
    return $h7Uje.read(this, offset, false, 23, 4);
};
$1e0dbf22a532ebe3$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, 8, this.length);
    return $h7Uje.read(this, offset, true, 52, 8);
};
$1e0dbf22a532ebe3$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkOffset(offset, 8, this.length);
    return $h7Uje.read(this, offset, false, 52, 8);
};
function $1e0dbf22a532ebe3$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$1e0dbf22a532ebe3$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$1e0dbf22a532ebe3$var$Buffer.prototype.writeUintLE = $1e0dbf22a532ebe3$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $1e0dbf22a532ebe3$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.writeUintBE = $1e0dbf22a532ebe3$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $1e0dbf22a532ebe3$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.writeUint8 = $1e0dbf22a532ebe3$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.writeUint16LE = $1e0dbf22a532ebe3$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.writeUint16BE = $1e0dbf22a532ebe3$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.writeUint32LE = $1e0dbf22a532ebe3$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.writeUint32BE = $1e0dbf22a532ebe3$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $1e0dbf22a532ebe3$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $1e0dbf22a532ebe3$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $1e0dbf22a532ebe3$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $1e0dbf22a532ebe3$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$1e0dbf22a532ebe3$var$Buffer.prototype.writeBigUInt64LE = $1e0dbf22a532ebe3$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $1e0dbf22a532ebe3$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$1e0dbf22a532ebe3$var$Buffer.prototype.writeBigUInt64BE = $1e0dbf22a532ebe3$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $1e0dbf22a532ebe3$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$1e0dbf22a532ebe3$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $1e0dbf22a532ebe3$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $1e0dbf22a532ebe3$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$1e0dbf22a532ebe3$var$Buffer.prototype.writeBigInt64LE = $1e0dbf22a532ebe3$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $1e0dbf22a532ebe3$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$1e0dbf22a532ebe3$var$Buffer.prototype.writeBigInt64BE = $1e0dbf22a532ebe3$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $1e0dbf22a532ebe3$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $1e0dbf22a532ebe3$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $1e0dbf22a532ebe3$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
    $h7Uje.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$1e0dbf22a532ebe3$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $1e0dbf22a532ebe3$var$writeFloat(this, value, offset, true, noAssert);
};
$1e0dbf22a532ebe3$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $1e0dbf22a532ebe3$var$writeFloat(this, value, offset, false, noAssert);
};
function $1e0dbf22a532ebe3$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1e0dbf22a532ebe3$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157e+308);
    $h7Uje.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$1e0dbf22a532ebe3$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $1e0dbf22a532ebe3$var$writeDouble(this, value, offset, true, noAssert);
};
$1e0dbf22a532ebe3$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $1e0dbf22a532ebe3$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$1e0dbf22a532ebe3$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$1e0dbf22a532ebe3$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$1e0dbf22a532ebe3$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$1e0dbf22a532ebe3$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $1e0dbf22a532ebe3$var$Buffer.isBuffer(val) ? val : $1e0dbf22a532ebe3$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $1e0dbf22a532ebe3$var$errors = {};
function $1e0dbf22a532ebe3$var$E(sym, getMessage, Base) {
    $1e0dbf22a532ebe3$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack; // eslint-disable-line no-unused-expressions
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$1e0dbf22a532ebe3$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$1e0dbf22a532ebe3$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$1e0dbf22a532ebe3$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $1e0dbf22a532ebe3$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $1e0dbf22a532ebe3$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $1e0dbf22a532ebe3$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $1e0dbf22a532ebe3$var$checkBounds(buf, offset, byteLength) {
    $1e0dbf22a532ebe3$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $1e0dbf22a532ebe3$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $1e0dbf22a532ebe3$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $1e0dbf22a532ebe3$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $1e0dbf22a532ebe3$var$checkBounds(buf, offset, byteLength);
}
function $1e0dbf22a532ebe3$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $1e0dbf22a532ebe3$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $1e0dbf22a532ebe3$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $1e0dbf22a532ebe3$var$validateNumber(value, type);
        throw new $1e0dbf22a532ebe3$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $1e0dbf22a532ebe3$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $1e0dbf22a532ebe3$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $1e0dbf22a532ebe3$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $1e0dbf22a532ebe3$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($1e0dbf22a532ebe3$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $1e0dbf22a532ebe3$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $1e0dbf22a532ebe3$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $1e0dbf22a532ebe3$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $1e0dbf22a532ebe3$var$base64ToBytes(str) {
    return $b5qIH.toByteArray($1e0dbf22a532ebe3$var$base64clean(str));
}
function $1e0dbf22a532ebe3$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $1e0dbf22a532ebe3$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $1e0dbf22a532ebe3$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $1e0dbf22a532ebe3$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $1e0dbf22a532ebe3$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $1e0dbf22a532ebe3$var$BufferBigIntNotDefined : fn;
}
function $1e0dbf22a532ebe3$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("b5qIH", function(module, exports) {
$parcel$export(module.exports, "toByteArray", () => $8124e36292151a6f$export$d622b2ad8d90c771, (v) => $8124e36292151a6f$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $8124e36292151a6f$export$6100ba28696e12de, (v) => $8124e36292151a6f$export$6100ba28696e12de = v);
var $8124e36292151a6f$export$a48f0734ac7c2329;
var $8124e36292151a6f$export$d622b2ad8d90c771;
var $8124e36292151a6f$export$6100ba28696e12de;
'use strict';
$8124e36292151a6f$export$a48f0734ac7c2329 = $8124e36292151a6f$var$byteLength;
$8124e36292151a6f$export$d622b2ad8d90c771 = $8124e36292151a6f$var$toByteArray;
$8124e36292151a6f$export$6100ba28696e12de = $8124e36292151a6f$var$fromByteArray;
var $8124e36292151a6f$var$lookup = [];
var $8124e36292151a6f$var$revLookup = [];
var $8124e36292151a6f$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $8124e36292151a6f$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $8124e36292151a6f$var$i = 0, $8124e36292151a6f$var$len = $8124e36292151a6f$var$code.length; $8124e36292151a6f$var$i < $8124e36292151a6f$var$len; ++$8124e36292151a6f$var$i){
    $8124e36292151a6f$var$lookup[$8124e36292151a6f$var$i] = $8124e36292151a6f$var$code[$8124e36292151a6f$var$i];
    $8124e36292151a6f$var$revLookup[$8124e36292151a6f$var$code.charCodeAt($8124e36292151a6f$var$i)] = $8124e36292151a6f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8124e36292151a6f$var$revLookup['-'.charCodeAt(0)] = 62;
$8124e36292151a6f$var$revLookup['_'.charCodeAt(0)] = 63;
function $8124e36292151a6f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8124e36292151a6f$var$byteLength(b64) {
    var lens = $8124e36292151a6f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8124e36292151a6f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8124e36292151a6f$var$toByteArray(b64) {
    var tmp;
    var lens = $8124e36292151a6f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8124e36292151a6f$var$Arr($8124e36292151a6f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8124e36292151a6f$var$revLookup[b64.charCodeAt(i)] << 18 | $8124e36292151a6f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8124e36292151a6f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8124e36292151a6f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8124e36292151a6f$var$revLookup[b64.charCodeAt(i)] << 2 | $8124e36292151a6f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8124e36292151a6f$var$revLookup[b64.charCodeAt(i)] << 10 | $8124e36292151a6f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8124e36292151a6f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8124e36292151a6f$var$tripletToBase64(num) {
    return $8124e36292151a6f$var$lookup[num >> 18 & 0x3F] + $8124e36292151a6f$var$lookup[num >> 12 & 0x3F] + $8124e36292151a6f$var$lookup[num >> 6 & 0x3F] + $8124e36292151a6f$var$lookup[num & 0x3F];
}
function $8124e36292151a6f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8124e36292151a6f$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $8124e36292151a6f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8124e36292151a6f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8124e36292151a6f$var$lookup[tmp >> 2] + $8124e36292151a6f$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8124e36292151a6f$var$lookup[tmp >> 10] + $8124e36292151a6f$var$lookup[tmp >> 4 & 0x3F] + $8124e36292151a6f$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("h7Uje", function(module, exports) {
$parcel$export(module.exports, "read", () => $c77ec4ef5c691835$export$aafa59e2e03f2942, (v) => $c77ec4ef5c691835$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $c77ec4ef5c691835$export$68d8715fc104d294, (v) => $c77ec4ef5c691835$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $c77ec4ef5c691835$export$aafa59e2e03f2942;
var $c77ec4ef5c691835$export$68d8715fc104d294;
$c77ec4ef5c691835$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$c77ec4ef5c691835$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("2cRRf", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $lPNTa = parcelRequire("lPNTa");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $iNgsu = parcelRequire("iNgsu");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $iNgsu.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $lPNTa.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $iNgsu.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $iNgsu.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("lPNTa", function(module, exports) {
/*! https://mths.be/punycode v1.4.1 by @mathias */ (function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("iNgsu", function(module, exports) {
'use strict';

var $dGZBW = parcelRequire("dGZBW");

var $2tp8N = parcelRequire("2tp8N");

var $48ugx = parcelRequire("48ugx");
module.exports = {
    formats: $48ugx,
    parse: $2tp8N,
    stringify: $dGZBW
};

});
parcelRegister("dGZBW", function(module, exports) {
'use strict';

var $gszqG = parcelRequire("gszqG");

var $cXiBO = parcelRequire("cXiBO");

var $48ugx = parcelRequire("48ugx");
var $9f7efd4146b7f884$var$has = Object.prototype.hasOwnProperty;
var $9f7efd4146b7f884$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $9f7efd4146b7f884$var$isArray = Array.isArray;
var $9f7efd4146b7f884$var$push = Array.prototype.push;
var $9f7efd4146b7f884$var$pushToArray = function(arr, valueOrArray) {
    $9f7efd4146b7f884$var$push.apply(arr, $9f7efd4146b7f884$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $9f7efd4146b7f884$var$toISO = Date.prototype.toISOString;
var $9f7efd4146b7f884$var$defaultFormat = $48ugx.default;
var $9f7efd4146b7f884$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $cXiBO.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $9f7efd4146b7f884$var$defaultFormat,
    formatter: $48ugx.formatters[$9f7efd4146b7f884$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $9f7efd4146b7f884$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $9f7efd4146b7f884$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $9f7efd4146b7f884$var$sentinel = {};
var $9f7efd4146b7f884$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($9f7efd4146b7f884$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($9f7efd4146b7f884$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $9f7efd4146b7f884$var$isArray(obj)) obj = $cXiBO.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return formatter(encoder && !encodeValuesOnly ? encoder(prefix, $9f7efd4146b7f884$var$defaults.encoder, charset, 'key', format) : prefix);
        obj = '';
    }
    if ($9f7efd4146b7f884$var$isNonNullishPrimitive(obj) || $cXiBO.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $9f7efd4146b7f884$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $9f7efd4146b7f884$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $9f7efd4146b7f884$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $cXiBO.maybeMap(obj, function(v) {
            return v == null ? v : encoder(v);
        });
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($9f7efd4146b7f884$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $9f7efd4146b7f884$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $9f7efd4146b7f884$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $9f7efd4146b7f884$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $gszqG();
        valueSideChannel.set($9f7efd4146b7f884$var$sentinel, sideChannel);
        $9f7efd4146b7f884$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $9f7efd4146b7f884$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $9f7efd4146b7f884$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $9f7efd4146b7f884$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $9f7efd4146b7f884$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $48ugx.default;
    if (typeof opts.format !== 'undefined') {
        if (!$9f7efd4146b7f884$var$has.call($48ugx.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $48ugx.formatters[format];
    var filter = $9f7efd4146b7f884$var$defaults.filter;
    if (typeof opts.filter === 'function' || $9f7efd4146b7f884$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $9f7efd4146b7f884$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $9f7efd4146b7f884$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $9f7efd4146b7f884$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $9f7efd4146b7f884$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $9f7efd4146b7f884$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $9f7efd4146b7f884$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $9f7efd4146b7f884$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $9f7efd4146b7f884$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $9f7efd4146b7f884$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $9f7efd4146b7f884$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $9f7efd4146b7f884$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $9f7efd4146b7f884$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $9f7efd4146b7f884$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $9f7efd4146b7f884$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $9f7efd4146b7f884$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($9f7efd4146b7f884$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $9f7efd4146b7f884$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $gszqG();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (typeof key === 'undefined' || key === null) continue;
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $9f7efd4146b7f884$var$pushToArray(keys, $9f7efd4146b7f884$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B' + options.delimiter;
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93' + options.delimiter;
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("gszqG", function(module, exports) {
'use strict';

var $9rLhz = parcelRequire("9rLhz");

var $5MLAp = parcelRequire("5MLAp");

var $hx0gc = parcelRequire("hx0gc");

var $grlxE = parcelRequire("grlxE");

var $63MHc = parcelRequire("63MHc");
var $bfbabe6bb9331849$var$makeChannel = $63MHc || $grlxE || $hx0gc;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) {
                var keyDesc = key && Object(key) === key ? 'the given object key' : $5MLAp(key);
                throw new $9rLhz('Side channel does not contain ' + keyDesc);
            }
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $bfbabe6bb9331849$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    return channel;
};

});
parcelRegister("9rLhz", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("5MLAp", function(module, exports) {
var $4366590e95f73058$var$hasMap = typeof Map === 'function' && Map.prototype;
var $4366590e95f73058$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $4366590e95f73058$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $4366590e95f73058$var$mapSize = $4366590e95f73058$var$hasMap && $4366590e95f73058$var$mapSizeDescriptor && typeof $4366590e95f73058$var$mapSizeDescriptor.get === 'function' ? $4366590e95f73058$var$mapSizeDescriptor.get : null;
var $4366590e95f73058$var$mapForEach = $4366590e95f73058$var$hasMap && Map.prototype.forEach;
var $4366590e95f73058$var$hasSet = typeof Set === 'function' && Set.prototype;
var $4366590e95f73058$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $4366590e95f73058$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $4366590e95f73058$var$setSize = $4366590e95f73058$var$hasSet && $4366590e95f73058$var$setSizeDescriptor && typeof $4366590e95f73058$var$setSizeDescriptor.get === 'function' ? $4366590e95f73058$var$setSizeDescriptor.get : null;
var $4366590e95f73058$var$setForEach = $4366590e95f73058$var$hasSet && Set.prototype.forEach;
var $4366590e95f73058$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $4366590e95f73058$var$weakMapHas = $4366590e95f73058$var$hasWeakMap ? WeakMap.prototype.has : null;
var $4366590e95f73058$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $4366590e95f73058$var$weakSetHas = $4366590e95f73058$var$hasWeakSet ? WeakSet.prototype.has : null;
var $4366590e95f73058$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $4366590e95f73058$var$weakRefDeref = $4366590e95f73058$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $4366590e95f73058$var$booleanValueOf = Boolean.prototype.valueOf;
var $4366590e95f73058$var$objectToString = Object.prototype.toString;
var $4366590e95f73058$var$functionToString = Function.prototype.toString;
var $4366590e95f73058$var$$match = String.prototype.match;
var $4366590e95f73058$var$$slice = String.prototype.slice;
var $4366590e95f73058$var$$replace = String.prototype.replace;
var $4366590e95f73058$var$$toUpperCase = String.prototype.toUpperCase;
var $4366590e95f73058$var$$toLowerCase = String.prototype.toLowerCase;
var $4366590e95f73058$var$$test = RegExp.prototype.test;
var $4366590e95f73058$var$$concat = Array.prototype.concat;
var $4366590e95f73058$var$$join = Array.prototype.join;
var $4366590e95f73058$var$$arrSlice = Array.prototype.slice;
var $4366590e95f73058$var$$floor = Math.floor;
var $4366590e95f73058$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $4366590e95f73058$var$gOPS = Object.getOwnPropertySymbols;
var $4366590e95f73058$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $4366590e95f73058$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $4366590e95f73058$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $4366590e95f73058$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $4366590e95f73058$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $4366590e95f73058$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $4366590e95f73058$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $4366590e95f73058$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$4366590e95f73058$var$$floor(-num) : $4366590e95f73058$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $4366590e95f73058$var$$slice.call(str, intStr.length + 1);
            return $4366590e95f73058$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $4366590e95f73058$var$$replace.call($4366590e95f73058$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $4366590e95f73058$var$$replace.call(str, sepRegex, '$&_');
}

var $a5Qi3 = parcelRequire("a5Qi3");
var $4366590e95f73058$var$inspectCustom = $a5Qi3.custom;
var $4366590e95f73058$var$inspectSymbol = $4366590e95f73058$var$isSymbol($4366590e95f73058$var$inspectCustom) ? $4366590e95f73058$var$inspectCustom : null;
var $4366590e95f73058$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $4366590e95f73058$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($4366590e95f73058$var$has(opts, 'quoteStyle') && !$4366590e95f73058$var$has($4366590e95f73058$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($4366590e95f73058$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $4366590e95f73058$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($4366590e95f73058$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($4366590e95f73058$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $4366590e95f73058$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $4366590e95f73058$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $4366590e95f73058$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $4366590e95f73058$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $4366590e95f73058$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($4366590e95f73058$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $4366590e95f73058$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($4366590e95f73058$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$4366590e95f73058$var$isRegExp(obj)) {
        var name = $4366590e95f73058$var$nameOf(obj);
        var keys = $4366590e95f73058$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $4366590e95f73058$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($4366590e95f73058$var$isSymbol(obj)) {
        var symString = $4366590e95f73058$var$hasShammedSymbols ? $4366590e95f73058$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $4366590e95f73058$var$symToString.call(obj);
        return typeof obj === 'object' && !$4366590e95f73058$var$hasShammedSymbols ? $4366590e95f73058$var$markBoxed(symString) : symString;
    }
    if ($4366590e95f73058$var$isElement(obj)) {
        var s = '<' + $4366590e95f73058$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $4366590e95f73058$var$wrapQuotes($4366590e95f73058$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $4366590e95f73058$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($4366590e95f73058$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $4366590e95f73058$var$arrObjKeys(obj, inspect);
        if (indent && !$4366590e95f73058$var$singleLineValues(xs)) return '[' + $4366590e95f73058$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $4366590e95f73058$var$$join.call(xs, ', ') + ' ]';
    }
    if ($4366590e95f73058$var$isError(obj)) {
        var parts = $4366590e95f73058$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$4366590e95f73058$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $4366590e95f73058$var$$join.call($4366590e95f73058$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $4366590e95f73058$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($4366590e95f73058$var$inspectSymbol && typeof obj[$4366590e95f73058$var$inspectSymbol] === 'function' && $a5Qi3) return $a5Qi3(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($4366590e95f73058$var$isMap(obj)) {
        var mapParts = [];
        if ($4366590e95f73058$var$mapForEach) $4366590e95f73058$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $4366590e95f73058$var$collectionOf('Map', $4366590e95f73058$var$mapSize.call(obj), mapParts, indent);
    }
    if ($4366590e95f73058$var$isSet(obj)) {
        var setParts = [];
        if ($4366590e95f73058$var$setForEach) $4366590e95f73058$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $4366590e95f73058$var$collectionOf('Set', $4366590e95f73058$var$setSize.call(obj), setParts, indent);
    }
    if ($4366590e95f73058$var$isWeakMap(obj)) return $4366590e95f73058$var$weakCollectionOf('WeakMap');
    if ($4366590e95f73058$var$isWeakSet(obj)) return $4366590e95f73058$var$weakCollectionOf('WeakSet');
    if ($4366590e95f73058$var$isWeakRef(obj)) return $4366590e95f73058$var$weakCollectionOf('WeakRef');
    if ($4366590e95f73058$var$isNumber(obj)) return $4366590e95f73058$var$markBoxed(inspect(Number(obj)));
    if ($4366590e95f73058$var$isBigInt(obj)) return $4366590e95f73058$var$markBoxed(inspect($4366590e95f73058$var$bigIntValueOf.call(obj)));
    if ($4366590e95f73058$var$isBoolean(obj)) return $4366590e95f73058$var$markBoxed($4366590e95f73058$var$booleanValueOf.call(obj));
    if ($4366590e95f73058$var$isString(obj)) return $4366590e95f73058$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$4366590e95f73058$var$isDate(obj) && !$4366590e95f73058$var$isRegExp(obj)) {
        var ys = $4366590e95f73058$var$arrObjKeys(obj, inspect);
        var isPlainObject = $4366590e95f73058$var$gPO ? $4366590e95f73058$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $4366590e95f73058$var$toStringTag && Object(obj) === obj && $4366590e95f73058$var$toStringTag in obj ? $4366590e95f73058$var$$slice.call($4366590e95f73058$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $4366590e95f73058$var$$join.call($4366590e95f73058$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $4366590e95f73058$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $4366590e95f73058$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $4366590e95f73058$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $4366590e95f73058$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $4366590e95f73058$var$quote(s) {
    return $4366590e95f73058$var$$replace.call(String(s), /"/g, '&quot;');
}
function $4366590e95f73058$var$canTrustToString(obj) {
    return !$4366590e95f73058$var$toStringTag || !(typeof obj === 'object' && ($4366590e95f73058$var$toStringTag in obj || typeof obj[$4366590e95f73058$var$toStringTag] !== 'undefined'));
}
function $4366590e95f73058$var$isArray(obj) {
    return $4366590e95f73058$var$toStr(obj) === '[object Array]' && $4366590e95f73058$var$canTrustToString(obj);
}
function $4366590e95f73058$var$isDate(obj) {
    return $4366590e95f73058$var$toStr(obj) === '[object Date]' && $4366590e95f73058$var$canTrustToString(obj);
}
function $4366590e95f73058$var$isRegExp(obj) {
    return $4366590e95f73058$var$toStr(obj) === '[object RegExp]' && $4366590e95f73058$var$canTrustToString(obj);
}
function $4366590e95f73058$var$isError(obj) {
    return $4366590e95f73058$var$toStr(obj) === '[object Error]' && $4366590e95f73058$var$canTrustToString(obj);
}
function $4366590e95f73058$var$isString(obj) {
    return $4366590e95f73058$var$toStr(obj) === '[object String]' && $4366590e95f73058$var$canTrustToString(obj);
}
function $4366590e95f73058$var$isNumber(obj) {
    return $4366590e95f73058$var$toStr(obj) === '[object Number]' && $4366590e95f73058$var$canTrustToString(obj);
}
function $4366590e95f73058$var$isBoolean(obj) {
    return $4366590e95f73058$var$toStr(obj) === '[object Boolean]' && $4366590e95f73058$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $4366590e95f73058$var$isSymbol(obj) {
    if ($4366590e95f73058$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$4366590e95f73058$var$symToString) return false;
    try {
        $4366590e95f73058$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $4366590e95f73058$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$4366590e95f73058$var$bigIntValueOf) return false;
    try {
        $4366590e95f73058$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $4366590e95f73058$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $4366590e95f73058$var$has(obj, key) {
    return $4366590e95f73058$var$hasOwn.call(obj, key);
}
function $4366590e95f73058$var$toStr(obj) {
    return $4366590e95f73058$var$objectToString.call(obj);
}
function $4366590e95f73058$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $4366590e95f73058$var$$match.call($4366590e95f73058$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $4366590e95f73058$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $4366590e95f73058$var$isMap(x) {
    if (!$4366590e95f73058$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $4366590e95f73058$var$mapSize.call(x);
        try {
            $4366590e95f73058$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4366590e95f73058$var$isWeakMap(x) {
    if (!$4366590e95f73058$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $4366590e95f73058$var$weakMapHas.call(x, $4366590e95f73058$var$weakMapHas);
        try {
            $4366590e95f73058$var$weakSetHas.call(x, $4366590e95f73058$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4366590e95f73058$var$isWeakRef(x) {
    if (!$4366590e95f73058$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $4366590e95f73058$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $4366590e95f73058$var$isSet(x) {
    if (!$4366590e95f73058$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $4366590e95f73058$var$setSize.call(x);
        try {
            $4366590e95f73058$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4366590e95f73058$var$isWeakSet(x) {
    if (!$4366590e95f73058$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $4366590e95f73058$var$weakSetHas.call(x, $4366590e95f73058$var$weakSetHas);
        try {
            $4366590e95f73058$var$weakMapHas.call(x, $4366590e95f73058$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4366590e95f73058$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $4366590e95f73058$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $4366590e95f73058$var$inspectString($4366590e95f73058$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $4366590e95f73058$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $4366590e95f73058$var$$replace.call($4366590e95f73058$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $4366590e95f73058$var$lowbyte);
    return $4366590e95f73058$var$wrapQuotes(s, 'single', opts);
}
function $4366590e95f73058$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $4366590e95f73058$var$$toUpperCase.call(n.toString(16));
}
function $4366590e95f73058$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $4366590e95f73058$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $4366590e95f73058$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $4366590e95f73058$var$indentedJoin(entries, indent) : $4366590e95f73058$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $4366590e95f73058$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($4366590e95f73058$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $4366590e95f73058$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $4366590e95f73058$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $4366590e95f73058$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $4366590e95f73058$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $4366590e95f73058$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $4366590e95f73058$var$arrObjKeys(obj, inspect) {
    var isArr = $4366590e95f73058$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $4366590e95f73058$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $4366590e95f73058$var$gOPS === 'function' ? $4366590e95f73058$var$gOPS(obj) : [];
    var symMap;
    if ($4366590e95f73058$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$4366590e95f73058$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($4366590e95f73058$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($4366590e95f73058$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $4366590e95f73058$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($4366590e95f73058$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("a5Qi3", function(module, exports) {
"use strict";

});


parcelRegister("hx0gc", function(module, exports) {
'use strict';

var $5MLAp = parcelRequire("5MLAp");

var $9rLhz = parcelRequire("9rLhz");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $cc35b87290b39ff5$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $cc35b87290b39ff5$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $cc35b87290b39ff5$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $cc35b87290b39ff5$var$listSet = function(objects, key, value) {
    var node = $cc35b87290b39ff5$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $cc35b87290b39ff5$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$cc35b87290b39ff5$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $cc35b87290b39ff5$var$listDelete = function(objects, key) {
    if (objects) return $cc35b87290b39ff5$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $9rLhz('Side channel does not contain ' + $5MLAp(key));
        },
        'delete': function(key) {
            var deletedNode = $cc35b87290b39ff5$var$listDelete($o, key);
            if (deletedNode && $o && !$o.next) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $cc35b87290b39ff5$var$listGet($o, key);
        },
        has: function(key) {
            return $cc35b87290b39ff5$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $cc35b87290b39ff5$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    return channel;
};

});

parcelRegister("grlxE", function(module, exports) {
'use strict';

var $8k6tP = parcelRequire("8k6tP");

var $1wNjU = parcelRequire("1wNjU");

var $5MLAp = parcelRequire("5MLAp");

var $9rLhz = parcelRequire("9rLhz");
var $bf7fe0b97e016050$var$$Map = $8k6tP('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $bf7fe0b97e016050$var$$mapGet = $1wNjU('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $bf7fe0b97e016050$var$$mapSet = $1wNjU('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $bf7fe0b97e016050$var$$mapHas = $1wNjU('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $bf7fe0b97e016050$var$$mapDelete = $1wNjU('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $bf7fe0b97e016050$var$$mapSize = $1wNjU('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$bf7fe0b97e016050$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $9rLhz('Side channel does not contain ' + $5MLAp(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $bf7fe0b97e016050$var$$mapDelete($m, key);
                if ($bf7fe0b97e016050$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $bf7fe0b97e016050$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $bf7fe0b97e016050$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $bf7fe0b97e016050$var$$Map();
            $bf7fe0b97e016050$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("8k6tP", function(module, exports) {
'use strict';
var $60f537c85c382dba$var$undefined1;

var $1wEU2 = parcelRequire("1wEU2");

var $dNE2E = parcelRequire("dNE2E");

var $9CYAj = parcelRequire("9CYAj");

var $9DDjU = parcelRequire("9DDjU");

var $1FsWw = parcelRequire("1FsWw");

var $4hu1o = parcelRequire("4hu1o");

var $9rLhz = parcelRequire("9rLhz");

var $X1W8h = parcelRequire("X1W8h");

var $6QMIV = parcelRequire("6QMIV");

var $arL25 = parcelRequire("arL25");

var $8AqtS = parcelRequire("8AqtS");

var $e6at5 = parcelRequire("e6at5");

var $f9bcO = parcelRequire("f9bcO");

var $1uQMG = parcelRequire("1uQMG");

var $ePDG4 = parcelRequire("ePDG4");
var $60f537c85c382dba$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $60f537c85c382dba$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $60f537c85c382dba$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $kKqS1 = parcelRequire("kKqS1");

var $fO8kA = parcelRequire("fO8kA");
var $60f537c85c382dba$var$throwTypeError = function() {
    throw new $9rLhz();
};
var $60f537c85c382dba$var$ThrowTypeError = $kKqS1 ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $60f537c85c382dba$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $kKqS1(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $60f537c85c382dba$var$throwTypeError;
        }
    }
}() : $60f537c85c382dba$var$throwTypeError;

var $60f537c85c382dba$var$hasSymbols = (parcelRequire("4FS3e"))();

var $9cG1G = parcelRequire("9cG1G");

var $ciH8v = parcelRequire("ciH8v");

var $8tjFi = parcelRequire("8tjFi");

var $j7f4s = parcelRequire("j7f4s");

var $lFAGP = parcelRequire("lFAGP");
var $60f537c85c382dba$var$needsEval = {};
var $60f537c85c382dba$var$TypedArray = typeof Uint8Array === 'undefined' || !$9cG1G ? undefined : $9cG1G(Uint8Array);
var $60f537c85c382dba$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $60f537c85c382dba$var$hasSymbols && $9cG1G ? $9cG1G([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $60f537c85c382dba$var$needsEval,
    '%AsyncGenerator%': $60f537c85c382dba$var$needsEval,
    '%AsyncGeneratorFunction%': $60f537c85c382dba$var$needsEval,
    '%AsyncIteratorPrototype%': $60f537c85c382dba$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $dNE2E,
    '%eval%': eval,
    '%EvalError%': $9CYAj,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $60f537c85c382dba$var$$Function,
    '%GeneratorFunction%': $60f537c85c382dba$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $60f537c85c382dba$var$hasSymbols && $9cG1G ? $9cG1G($9cG1G([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$60f537c85c382dba$var$hasSymbols || !$9cG1G ? undefined : $9cG1G(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $1wEU2,
    '%Object.getOwnPropertyDescriptor%': $kKqS1,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $9DDjU,
    '%ReferenceError%': $1FsWw,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$60f537c85c382dba$var$hasSymbols || !$9cG1G ? undefined : $9cG1G(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $60f537c85c382dba$var$hasSymbols && $9cG1G ? $9cG1G(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $60f537c85c382dba$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $4hu1o,
    '%ThrowTypeError%': $60f537c85c382dba$var$ThrowTypeError,
    '%TypedArray%': $60f537c85c382dba$var$TypedArray,
    '%TypeError%': $9rLhz,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $X1W8h,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $lFAGP,
    '%Function.prototype.apply%': $j7f4s,
    '%Object.defineProperty%': $fO8kA,
    '%Object.getPrototypeOf%': $ciH8v,
    '%Math.abs%': $6QMIV,
    '%Math.floor%': $arL25,
    '%Math.max%': $8AqtS,
    '%Math.min%': $e6at5,
    '%Math.pow%': $f9bcO,
    '%Math.round%': $1uQMG,
    '%Math.sign%': $ePDG4,
    '%Reflect.getPrototypeOf%': $8tjFi
};
if ($9cG1G) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $60f537c85c382dba$var$errorProto = $9cG1G($9cG1G(e));
    $60f537c85c382dba$var$INTRINSICS['%Error.prototype%'] = $60f537c85c382dba$var$errorProto;
}
var $60f537c85c382dba$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $60f537c85c382dba$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $60f537c85c382dba$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $60f537c85c382dba$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $9cG1G) value = $9cG1G(gen.prototype);
    }
    $60f537c85c382dba$var$INTRINSICS[name] = value;
    return value;
};
var $60f537c85c382dba$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $9dkFD = parcelRequire("9dkFD");

var $casgO = parcelRequire("casgO");
var $60f537c85c382dba$var$$concat = $9dkFD.call($lFAGP, Array.prototype.concat);
var $60f537c85c382dba$var$$spliceApply = $9dkFD.call($j7f4s, Array.prototype.splice);
var $60f537c85c382dba$var$$replace = $9dkFD.call($lFAGP, String.prototype.replace);
var $60f537c85c382dba$var$$strSlice = $9dkFD.call($lFAGP, String.prototype.slice);
var $60f537c85c382dba$var$$exec = $9dkFD.call($lFAGP, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $60f537c85c382dba$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $60f537c85c382dba$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $60f537c85c382dba$var$stringToPath = function stringToPath(string) {
    var first = $60f537c85c382dba$var$$strSlice(string, 0, 1);
    var last = $60f537c85c382dba$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $4hu1o('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $4hu1o('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $60f537c85c382dba$var$$replace(string, $60f537c85c382dba$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $60f537c85c382dba$var$$replace(subString, $60f537c85c382dba$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $60f537c85c382dba$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($casgO($60f537c85c382dba$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $60f537c85c382dba$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($casgO($60f537c85c382dba$var$INTRINSICS, intrinsicName)) {
        var value = $60f537c85c382dba$var$INTRINSICS[intrinsicName];
        if (value === $60f537c85c382dba$var$needsEval) value = $60f537c85c382dba$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $9rLhz('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $4hu1o('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $9rLhz('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $9rLhz('"allowMissing" argument must be a boolean');
    if ($60f537c85c382dba$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $4hu1o('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $60f537c85c382dba$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $60f537c85c382dba$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $60f537c85c382dba$var$$spliceApply(parts, $60f537c85c382dba$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $60f537c85c382dba$var$$strSlice(part, 0, 1);
        var last = $60f537c85c382dba$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $4hu1o('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($casgO($60f537c85c382dba$var$INTRINSICS, intrinsicRealName)) value = $60f537c85c382dba$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $9rLhz('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($kKqS1 && i + 1 >= parts.length) {
                var desc = $kKqS1(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $casgO(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $60f537c85c382dba$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("1wEU2", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("dNE2E", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("9CYAj", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9DDjU", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("1FsWw", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("4hu1o", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("X1W8h", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("6QMIV", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("arL25", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("8AqtS", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("e6at5", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("f9bcO", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("1uQMG", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("ePDG4", function(module, exports) {
'use strict';

var $ji1x9 = parcelRequire("ji1x9");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($ji1x9(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("ji1x9", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("kKqS1", function(module, exports) {
'use strict';

var $216nQ = parcelRequire("216nQ");
var $f1acf262f71aca48$require$$gOPD = $216nQ;
if ($f1acf262f71aca48$require$$gOPD) try {
    $f1acf262f71aca48$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $f1acf262f71aca48$require$$gOPD = null;
}
module.exports = $f1acf262f71aca48$require$$gOPD;

});
parcelRegister("216nQ", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("fO8kA", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $b821fce02271395f$var$$defineProperty = Object.defineProperty || false;
if ($b821fce02271395f$var$$defineProperty) try {
    $b821fce02271395f$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $b821fce02271395f$var$$defineProperty = false;
}
module.exports = $b821fce02271395f$var$$defineProperty;

});

parcelRegister("4FS3e", function(module, exports) {
'use strict';
var $3674eb366c83ae5e$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $iiPi5 = parcelRequire("iiPi5");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $3674eb366c83ae5e$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $3674eb366c83ae5e$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $iiPi5();
};

});
parcelRegister("iiPi5", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("9cG1G", function(module, exports) {
'use strict';

var $8tjFi = parcelRequire("8tjFi");

var $ciH8v = parcelRequire("ciH8v");

var $lEbok = parcelRequire("lEbok");
/** @type {import('.')} */ module.exports = $8tjFi ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $8tjFi(O);
} : $ciH8v ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $ciH8v(O);
} : $lEbok ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $lEbok(O);
} : null;

});
parcelRegister("8tjFi", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("ciH8v", function(module, exports) {
'use strict';

var $1wEU2 = parcelRequire("1wEU2");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $1wEU2.getPrototypeOf || null;

});

parcelRegister("lEbok", function(module, exports) {
'use strict';

var $cx98Z = parcelRequire("cx98Z");

var $kKqS1 = parcelRequire("kKqS1");
var $fc262b824c123a3a$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $fc262b824c123a3a$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $fc262b824c123a3a$var$desc = !!$fc262b824c123a3a$var$hasProtoAccessor && $kKqS1 && $kKqS1(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $fc262b824c123a3a$var$$Object = Object;
var $fc262b824c123a3a$var$$getPrototypeOf = $fc262b824c123a3a$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $fc262b824c123a3a$var$desc && typeof $fc262b824c123a3a$var$desc.get === 'function' ? $cx98Z([
    $fc262b824c123a3a$var$desc.get
]) : typeof $fc262b824c123a3a$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $fc262b824c123a3a$var$$getPrototypeOf(value == null ? value : $fc262b824c123a3a$var$$Object(value));
} : false;

});
parcelRegister("cx98Z", function(module, exports) {
'use strict';

var $9dkFD = parcelRequire("9dkFD");

var $9rLhz = parcelRequire("9rLhz");

var $lFAGP = parcelRequire("lFAGP");

var $2ntjQ = parcelRequire("2ntjQ");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $9rLhz('a function is required');
    return $2ntjQ($9dkFD, $lFAGP, args);
};

});
parcelRegister("9dkFD", function(module, exports) {
'use strict';

var $fOVFs = parcelRequire("fOVFs");
module.exports = Function.prototype.bind || $fOVFs;

});
parcelRegister("fOVFs", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $b84842208821a948$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $b84842208821a948$var$toStr = Object.prototype.toString;
var $b84842208821a948$var$max = Math.max;
var $b84842208821a948$var$funcType = '[object Function]';
var $b84842208821a948$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $b84842208821a948$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $b84842208821a948$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $b84842208821a948$var$toStr.apply(target) !== $b84842208821a948$var$funcType) throw new TypeError($b84842208821a948$var$ERROR_MESSAGE + target);
    var args = $b84842208821a948$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $b84842208821a948$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $b84842208821a948$var$concatty(args, arguments));
    };
    var boundLength = $b84842208821a948$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $b84842208821a948$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("lFAGP", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("2ntjQ", function(module, exports) {
'use strict';

var $9dkFD = parcelRequire("9dkFD");

var $j7f4s = parcelRequire("j7f4s");

var $lFAGP = parcelRequire("lFAGP");

var $b9CAO = parcelRequire("b9CAO");
/** @type {import('./actualApply')} */ module.exports = $b9CAO || $9dkFD.call($lFAGP, $j7f4s);

});
parcelRegister("j7f4s", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("b9CAO", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("casgO", function(module, exports) {
'use strict';
var $8dbc590fa0803e23$var$call = Function.prototype.call;
var $8dbc590fa0803e23$var$$hasOwn = Object.prototype.hasOwnProperty;

var $9dkFD = parcelRequire("9dkFD");
/** @type {import('.')} */ module.exports = $9dkFD.call($8dbc590fa0803e23$var$call, $8dbc590fa0803e23$var$$hasOwn);

});


parcelRegister("1wNjU", function(module, exports) {
'use strict';

var $8k6tP = parcelRequire("8k6tP");

var $cx98Z = parcelRequire("cx98Z");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $11cf098d62c58d30$var$$indexOf = $cx98Z([
    $8k6tP('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $8k6tP(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $11cf098d62c58d30$var$$indexOf(name, '.prototype.') > -1) return $cx98Z(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("63MHc", function(module, exports) {
'use strict';

var $8k6tP = parcelRequire("8k6tP");

var $1wNjU = parcelRequire("1wNjU");

var $5MLAp = parcelRequire("5MLAp");

var $grlxE = parcelRequire("grlxE");

var $9rLhz = parcelRequire("9rLhz");
var $4698cbdd4b651b0c$var$$WeakMap = $8k6tP('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $4698cbdd4b651b0c$var$$weakMapGet = $1wNjU('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $4698cbdd4b651b0c$var$$weakMapSet = $1wNjU('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $4698cbdd4b651b0c$var$$weakMapHas = $1wNjU('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $4698cbdd4b651b0c$var$$weakMapDelete = $1wNjU('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $4698cbdd4b651b0c$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $9rLhz('Side channel does not contain ' + $5MLAp(key));
        },
        'delete': function(key) {
            if ($4698cbdd4b651b0c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $4698cbdd4b651b0c$var$$weakMapDelete($wm, key);
            } else if ($grlxE) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($4698cbdd4b651b0c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $4698cbdd4b651b0c$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($4698cbdd4b651b0c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $4698cbdd4b651b0c$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($4698cbdd4b651b0c$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $4698cbdd4b651b0c$var$$WeakMap();
                $4698cbdd4b651b0c$var$$weakMapSet($wm, key, value);
            } else if ($grlxE) {
                if (!$m) $m = $grlxE();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $grlxE;

});


parcelRegister("cXiBO", function(module, exports) {
'use strict';

var $48ugx = parcelRequire("48ugx");

var $gszqG = parcelRequire("gszqG");

var $fO8kA = parcelRequire("fO8kA");
var $96e96e13070a2b29$var$has = Object.prototype.hasOwnProperty;
var $96e96e13070a2b29$var$isArray = Array.isArray;
// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var $96e96e13070a2b29$var$overflowChannel = $gszqG();
var $96e96e13070a2b29$var$markOverflow = function markOverflow(obj, maxIndex) {
    $96e96e13070a2b29$var$overflowChannel.set(obj, maxIndex);
    return obj;
};
var $96e96e13070a2b29$var$isOverflow = function isOverflow(obj) {
    return $96e96e13070a2b29$var$overflowChannel.has(obj);
};
var $96e96e13070a2b29$var$getMaxIndex = function getMaxIndex(obj) {
    return $96e96e13070a2b29$var$overflowChannel.get(obj);
};
var $96e96e13070a2b29$var$setMaxIndex = function setMaxIndex(obj, maxIndex) {
    $96e96e13070a2b29$var$overflowChannel.set(obj, maxIndex);
};
var $96e96e13070a2b29$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    return array;
}();
var $96e96e13070a2b29$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($96e96e13070a2b29$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted[compacted.length] = obj[j];
            item.obj[item.prop] = compacted;
        }
    }
};
var $96e96e13070a2b29$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $96e96e13070a2b29$var$setProperty = function setProperty(obj, key, value) {
    if (key === '__proto__' && $fO8kA) $fO8kA(obj, key, {
        configurable: true,
        enumerable: true,
        value: value,
        writable: true
    });
    else obj[key] = value;
};
var $96e96e13070a2b29$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($96e96e13070a2b29$var$isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex >= options.arrayLimit) {
                if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                return $96e96e13070a2b29$var$markOverflow($96e96e13070a2b29$var$arrayToObject(target.concat(source), options), nextIndex);
            }
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if ($96e96e13070a2b29$var$isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = $96e96e13070a2b29$var$getMaxIndex(target) + 1;
                target[newIndex] = source;
                $96e96e13070a2b29$var$setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge) return [
                target,
                source
            ];
            else if (options && (options.plainObjects || options.allowPrototypes) || !$96e96e13070a2b29$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') {
        if ($96e96e13070a2b29$var$isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects ? {
                __proto__: null,
                0: target
            } : {
                0: target
            };
            for(var m = 0; m < sourceKeys.length; m++){
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return $96e96e13070a2b29$var$markOverflow(result, $96e96e13070a2b29$var$getMaxIndex(source) + 1);
        }
        var combined = [
            target
        ].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            return $96e96e13070a2b29$var$markOverflow($96e96e13070a2b29$var$arrayToObject(combined, options), combined.length - 1);
        }
        return combined;
    }
    var mergeTarget = target;
    if ($96e96e13070a2b29$var$isArray(target) && !$96e96e13070a2b29$var$isArray(source)) mergeTarget = $96e96e13070a2b29$var$arrayToObject(target, options);
    if ($96e96e13070a2b29$var$isArray(target) && $96e96e13070a2b29$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($96e96e13070a2b29$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target[target.length] = item;
            } else target[i] = item;
        });
        if (options && typeof options.arrayLimit === 'number' && target.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            return $96e96e13070a2b29$var$markOverflow($96e96e13070a2b29$var$arrayToObject(target, options), target.length - 1);
        }
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($96e96e13070a2b29$var$has.call(acc, key)) $96e96e13070a2b29$var$setProperty(acc, key, merge(acc[key], value, options));
        else $96e96e13070a2b29$var$setProperty(acc, key, value);
        if ($96e96e13070a2b29$var$isOverflow(source) && !$96e96e13070a2b29$var$isOverflow(acc)) $96e96e13070a2b29$var$markOverflow(acc, $96e96e13070a2b29$var$getMaxIndex(source));
        if ($96e96e13070a2b29$var$isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > $96e96e13070a2b29$var$getMaxIndex(acc)) $96e96e13070a2b29$var$setMaxIndex(acc, keyNum);
        }
        return acc;
    }, mergeTarget);
};
var $96e96e13070a2b29$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        $96e96e13070a2b29$var$setProperty(acc, key, source[key]);
        return acc;
    }, target);
};
var $96e96e13070a2b29$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $96e96e13070a2b29$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $96e96e13070a2b29$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $96e96e13070a2b29$var$limit){
        var segment = string.length >= $96e96e13070a2b29$var$limit ? string.slice(j, j + $96e96e13070a2b29$var$limit) : string;
        if (j + $96e96e13070a2b29$var$limit < string.length) {
            var last = segment.charCodeAt(segment.length - 1);
            if (last >= 0xD800 && last <= 0xDBFF) {
                segment = segment.slice(0, -1);
                j -= 1;
            }
        }
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $48ugx.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $96e96e13070a2b29$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $96e96e13070a2b29$var$hexTable[0xC0 | c >> 6] + $96e96e13070a2b29$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $96e96e13070a2b29$var$hexTable[0xE0 | c >> 12] + $96e96e13070a2b29$var$hexTable[0x80 | c >> 6 & 0x3F] + $96e96e13070a2b29$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $96e96e13070a2b29$var$hexTable[0xF0 | c >> 18] + $96e96e13070a2b29$var$hexTable[0x80 | c >> 12 & 0x3F] + $96e96e13070a2b29$var$hexTable[0x80 | c >> 6 & 0x3F] + $96e96e13070a2b29$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $96e96e13070a2b29$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = $gszqG();
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && !refs.has(val)) {
                queue[queue.length] = {
                    obj: obj,
                    prop: key
                };
                refs.set(val, true);
            }
        }
    }
    $96e96e13070a2b29$var$compactQueue(queue);
    return value;
};
var $96e96e13070a2b29$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $96e96e13070a2b29$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $96e96e13070a2b29$var$combine = function combine(a, b, arrayLimit, plainObjects, throwOnLimitExceeded) {
    // If 'a' is already an overflow object, add to it
    if ($96e96e13070a2b29$var$isOverflow(a)) {
        if (throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        var newIndex = $96e96e13070a2b29$var$getMaxIndex(a) + 1;
        a[newIndex] = b;
        $96e96e13070a2b29$var$setMaxIndex(a, newIndex);
        return a;
    }
    var result = [].concat(a, b);
    if (result.length > arrayLimit) {
        if (throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        return $96e96e13070a2b29$var$markOverflow($96e96e13070a2b29$var$arrayToObject(result, {
            plainObjects: plainObjects
        }), result.length - 1);
    }
    return result;
};
var $96e96e13070a2b29$var$maybeMap = function maybeMap(val, fn) {
    if ($96e96e13070a2b29$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped[mapped.length] = fn(val[i]);
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $96e96e13070a2b29$var$arrayToObject,
    assign: $96e96e13070a2b29$var$assign,
    combine: $96e96e13070a2b29$var$combine,
    compact: $96e96e13070a2b29$var$compact,
    decode: $96e96e13070a2b29$var$decode,
    encode: $96e96e13070a2b29$var$encode,
    isBuffer: $96e96e13070a2b29$var$isBuffer,
    isOverflow: $96e96e13070a2b29$var$isOverflow,
    isRegExp: $96e96e13070a2b29$var$isRegExp,
    markOverflow: $96e96e13070a2b29$var$markOverflow,
    maybeMap: $96e96e13070a2b29$var$maybeMap,
    merge: $96e96e13070a2b29$var$merge
};

});
parcelRegister("48ugx", function(module, exports) {
'use strict';
var $302f62ea9c833456$var$replace = String.prototype.replace;
var $302f62ea9c833456$var$percentTwenties = /%20/g;
var $302f62ea9c833456$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $302f62ea9c833456$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $302f62ea9c833456$var$replace.call(value, $302f62ea9c833456$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $302f62ea9c833456$var$Format.RFC1738,
    RFC3986: $302f62ea9c833456$var$Format.RFC3986
};

});



parcelRegister("2tp8N", function(module, exports) {
'use strict';

var $cXiBO = parcelRequire("cXiBO");
var $1cd1caa7bf2f0ee4$var$has = Object.prototype.hasOwnProperty;
var $1cd1caa7bf2f0ee4$var$isArray = Array.isArray;
var $1cd1caa7bf2f0ee4$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $cXiBO.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $1cd1caa7bf2f0ee4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $1cd1caa7bf2f0ee4$var$parseArrayValue = function(val, options, currentArrayLength, isFlatArrayValue) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        if (isFlatArrayValue && options.throwOnLimitExceeded) {
            var commaCount = 0;
            var commaIndex = val.indexOf(',');
            while(commaIndex > -1){
                commaCount += 1;
                if (commaCount >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                commaIndex = val.indexOf(',', commaIndex + 1);
            }
        }
        return val.split(',');
    }
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $1cd1caa7bf2f0ee4$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $1cd1caa7bf2f0ee4$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $1cd1caa7bf2f0ee4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded && typeof limit !== 'undefined' ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && typeof limit !== 'undefined' && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $1cd1caa7bf2f0ee4$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $1cd1caa7bf2f0ee4$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $1cd1caa7bf2f0ee4$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $1cd1caa7bf2f0ee4$var$defaults.decoder, charset, 'key');
            if (key !== null) val = $cXiBO.maybeMap($1cd1caa7bf2f0ee4$var$parseArrayValue(part.slice(pos + 1), options, $1cd1caa7bf2f0ee4$var$isArray(obj[key]) ? obj[key].length : 0, part.indexOf('[]=') === -1), function(encodedVal) {
                return options.decoder(encodedVal, $1cd1caa7bf2f0ee4$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $1cd1caa7bf2f0ee4$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $1cd1caa7bf2f0ee4$var$isArray(val) ? [
            val
        ] : val;
        if (options.comma && $1cd1caa7bf2f0ee4$var$isArray(val) && val.length > options.arrayLimit) val = $cXiBO.combine([], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        if (key !== null) {
            var existing = $1cd1caa7bf2f0ee4$var$has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || part.indexOf('[]=') > -1)) obj[key] = $cXiBO.combine(obj[key], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
            else if (!existing || options.duplicates === 'last') obj[key] = val;
        }
    }
    return obj;
};
var $1cd1caa7bf2f0ee4$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $1cd1caa7bf2f0ee4$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) {
            if ($cXiBO.isOverflow(leaf)) // leaf is already an overflow object, preserve it
            obj = leaf;
            else obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $cXiBO.combine([], leaf, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        } else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            else if (isValidArrayIndex) {
                obj[index] = leaf;
                $cXiBO.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
// Split a key like "a[b][c[]]" into ['a', '[b]', '[c[]]'] while preserving
// qs parse semantics for depth/prototype guards.
var $1cd1caa7bf2f0ee4$var$splitKeyIntoSegments = function splitKeyIntoSegments(originalKey, options) {
    var key = options.allowDots ? originalKey.replace(/\.([^.[]+)/g, '[$1]') : originalKey;
    // depth <= 0 keeps the whole key as one segment
    if (options.depth <= 0) {
        if (!options.plainObjects && $1cd1caa7bf2f0ee4$var$has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) return;
        }
        return [
            key
        ];
    }
    var segments = [];
    // parent before the first '[' (may be empty if key starts with '[')
    var first = key.indexOf('[');
    var parent = first >= 0 ? key.slice(0, first) : key;
    if (parent) {
        if (!options.plainObjects && $1cd1caa7bf2f0ee4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        segments[segments.length] = parent;
    }
    var n = key.length;
    var open = first;
    var collected = 0;
    while(open >= 0 && collected < options.depth){
        var level = 1;
        var i = open + 1;
        var close = -1;
        // balance nested '[' and ']' inside this bracket group using a nesting level counter
        while(i < n && close < 0){
            var cu = key.charCodeAt(i);
            if (cu === 0x5B) level += 1;
            else if (cu === 0x5D) {
                level -= 1;
                if (level === 0) close = i; // found matching close; loop will exit by condition
            }
            i += 1;
        }
        if (close < 0) {
            // Unterminated group: wrap the raw remainder in one bracket pair so it stays
            // a single literal segment (e.g. "[[]b" -> "[[]b]"); we do not infer missing ']'.
            segments[segments.length] = '[' + key.slice(open) + ']';
            return segments;
        }
        var seg = key.slice(open, close + 1);
        // prototype guard for the content of this group
        var content = seg.slice(1, -1);
        if (!options.plainObjects && $1cd1caa7bf2f0ee4$var$has.call(Object.prototype, content) && !options.allowPrototypes) return;
        segments[segments.length] = seg;
        collected += 1;
        // find the next '[' after this balanced group
        open = key.indexOf('[', close + 1);
    }
    if (open >= 0) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        segments[segments.length] = '[' + key.slice(open) + ']';
    }
    return segments;
};
var $1cd1caa7bf2f0ee4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    var keys = $1cd1caa7bf2f0ee4$var$splitKeyIntoSegments(givenKey, options);
    if (!keys) return;
    return $1cd1caa7bf2f0ee4$var$parseObject(keys, val, options, valuesParsed);
};
var $1cd1caa7bf2f0ee4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $1cd1caa7bf2f0ee4$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $1cd1caa7bf2f0ee4$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $1cd1caa7bf2f0ee4$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $1cd1caa7bf2f0ee4$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $1cd1caa7bf2f0ee4$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $1cd1caa7bf2f0ee4$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $1cd1caa7bf2f0ee4$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $1cd1caa7bf2f0ee4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $1cd1caa7bf2f0ee4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $1cd1caa7bf2f0ee4$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $1cd1caa7bf2f0ee4$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $1cd1caa7bf2f0ee4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $cXiBO.isRegExp(opts.delimiter) ? opts.delimiter : $1cd1caa7bf2f0ee4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $1cd1caa7bf2f0ee4$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $1cd1caa7bf2f0ee4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $1cd1caa7bf2f0ee4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $1cd1caa7bf2f0ee4$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $1cd1caa7bf2f0ee4$var$defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : $1cd1caa7bf2f0ee4$var$defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $1cd1caa7bf2f0ee4$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $1cd1caa7bf2f0ee4$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $1cd1caa7bf2f0ee4$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $1cd1caa7bf2f0ee4$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $cXiBO.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $cXiBO.compact(obj);
};

});



parcelRegister("9jhip", function(module, exports) {
"use strict";
var $6c734e0842a04288$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6c734e0842a04288$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6c734e0842a04288$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("5fEzF")).Diagnostics;
    }
});

var $fAnch = parcelRequire("fAnch");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $fAnch.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("70MRu")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("9gHhI")).Storage;
    }
});

$6c734e0842a04288$var$__exportStar((parcelRequire("92Jw6")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("bXMPn")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("eaGtC")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("hr0tr")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("5fEzF")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("7KNqC")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("iYjmb")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("eAXjp")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("4kaV5")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("eDZlc")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("kR4KX")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("70MRu")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("eRaH0")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("5v47R")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("2YqNV")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("iywen")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("jNoHg")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("ea2NT")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("1jFdy")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("9haUI")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("buDI8")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("hOzoK")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("ahxuL")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("gFVsp")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("gxEb4")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("g9vxL")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("l8r2G")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("bbhke")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("2hwxs")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("fKIfQ")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("z52jv")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("1qAwP")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("9gHhI")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("fpLE0")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("cvntC")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("9V8Q1")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("eU1zn")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("kn547")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("ci35n")), module.exports);

$6c734e0842a04288$var$__exportStar((parcelRequire("7tGnM")), module.exports);
Object.assign((0, (parcelRequire("92Jw6"))._getStatsigGlobal)(), {
    Log: (parcelRequire("70MRu")).Log,
    SDK_VERSION: (parcelRequire("l8r2G")).SDK_VERSION
});

});
parcelRegister("92Jw6", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $69579ba4929362d4$var$_a, $69579ba4929362d4$var$_b, $69579ba4929362d4$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $70MRu = parcelRequire("70MRu");
const $69579ba4929362d4$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $69579ba4929362d4$var$statsigGlobal;
    } catch (e) {
        return $69579ba4929362d4$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $69579ba4929362d4$var$_getStatsigGlobal;
const $69579ba4929362d4$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $69579ba4929362d4$var$_getStatsigGlobalFlag;
const $69579ba4929362d4$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $70MRu.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $69579ba4929362d4$var$_getInstance;
const $69579ba4929362d4$var$GLOBAL_KEY = '__STATSIG__';
const $69579ba4929362d4$var$_window = typeof window !== 'undefined' ? window : {};
const $69579ba4929362d4$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $69579ba4929362d4$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $69579ba4929362d4$var$statsigGlobal = ($69579ba4929362d4$var$_c = ($69579ba4929362d4$var$_b = ($69579ba4929362d4$var$_a = $69579ba4929362d4$var$_window[$69579ba4929362d4$var$GLOBAL_KEY]) !== null && $69579ba4929362d4$var$_a !== void 0 ? $69579ba4929362d4$var$_a : $69579ba4929362d4$var$_global[$69579ba4929362d4$var$GLOBAL_KEY]) !== null && $69579ba4929362d4$var$_b !== void 0 ? $69579ba4929362d4$var$_b : $69579ba4929362d4$var$_globalThis[$69579ba4929362d4$var$GLOBAL_KEY]) !== null && $69579ba4929362d4$var$_c !== void 0 ? $69579ba4929362d4$var$_c : {
    instance: module.exports._getInstance
};
$69579ba4929362d4$var$_window[$69579ba4929362d4$var$GLOBAL_KEY] = $69579ba4929362d4$var$statsigGlobal;
$69579ba4929362d4$var$_global[$69579ba4929362d4$var$GLOBAL_KEY] = $69579ba4929362d4$var$statsigGlobal;
$69579ba4929362d4$var$_globalThis[$69579ba4929362d4$var$GLOBAL_KEY] = $69579ba4929362d4$var$statsigGlobal;

});
parcelRegister("70MRu", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $51ae6f66707e7281$var$DEBUG = ' DEBUG ';
const $51ae6f66707e7281$var$_INFO = '  INFO ';
const $51ae6f66707e7281$var$_WARN = '  WARN ';
const $51ae6f66707e7281$var$ERROR = ' ERROR ';
function $51ae6f66707e7281$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $51ae6f66707e7281$var$Log {
    static info(...args) {
        if ($51ae6f66707e7281$var$Log.level >= module.exports.LogLevel.Info) console.info($51ae6f66707e7281$var$_INFO, ...$51ae6f66707e7281$var$addTag(args));
    }
    static debug(...args) {
        if ($51ae6f66707e7281$var$Log.level >= module.exports.LogLevel.Debug) console.debug($51ae6f66707e7281$var$DEBUG, ...$51ae6f66707e7281$var$addTag(args));
    }
    static warn(...args) {
        if ($51ae6f66707e7281$var$Log.level >= module.exports.LogLevel.Warn) console.warn($51ae6f66707e7281$var$_WARN, ...$51ae6f66707e7281$var$addTag(args));
    }
    static error(...args) {
        if ($51ae6f66707e7281$var$Log.level >= module.exports.LogLevel.Error) console.error($51ae6f66707e7281$var$ERROR, ...$51ae6f66707e7281$var$addTag(args));
    }
}
module.exports.Log = $51ae6f66707e7281$var$Log;
$51ae6f66707e7281$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("5fEzF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $3d2dd3ad424f5fd7$var$MARKER_MAP = new Map();
const $3d2dd3ad424f5fd7$var$ACT_START = 'start';
const $3d2dd3ad424f5fd7$var$ACT_END = 'end';
const $3d2dd3ad424f5fd7$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $3d2dd3ad424f5fd7$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $3d2dd3ad424f5fd7$var$_addMarker(sdkKey, $3d2dd3ad424f5fd7$var$_createMarker({}, $3d2dd3ad424f5fd7$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $3d2dd3ad424f5fd7$var$_addMarker(sdkKey, $3d2dd3ad424f5fd7$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $3d2dd3ad424f5fd7$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $3d2dd3ad424f5fd7$var$_addMarker(sdkKey, $3d2dd3ad424f5fd7$var$_createMarker(data, $3d2dd3ad424f5fd7$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $3d2dd3ad424f5fd7$var$_addMarker(sdkKey, $3d2dd3ad424f5fd7$var$_createMarker(data, $3d2dd3ad424f5fd7$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $3d2dd3ad424f5fd7$var$_addMarker(sdkKey, $3d2dd3ad424f5fd7$var$_createMarker({}, $3d2dd3ad424f5fd7$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $3d2dd3ad424f5fd7$var$_addMarker(sdkKey, $3d2dd3ad424f5fd7$var$_createMarker(data, $3d2dd3ad424f5fd7$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $3d2dd3ad424f5fd7$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $3d2dd3ad424f5fd7$var$_safeGetField(e, 'code'),
            name: $3d2dd3ad424f5fd7$var$_safeGetField(e, 'name'),
            message: $3d2dd3ad424f5fd7$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $3d2dd3ad424f5fd7$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $3d2dd3ad424f5fd7$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $3d2dd3ad424f5fd7$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $3d2dd3ad424f5fd7$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $3d2dd3ad424f5fd7$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $3d2dd3ad424f5fd7$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $3d2dd3ad424f5fd7$var$MARKER_MAP.set(sdkKey, markers);
}
function $3d2dd3ad424f5fd7$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("fAnch", function(module, exports) {
"use strict";
var $b58c3648fb6169a3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $bXMPn = parcelRequire("bXMPn");

var $eDZlc = parcelRequire("eDZlc");

var $70MRu = parcelRequire("70MRu");

var $5v47R = parcelRequire("5v47R");

var $ea2NT = parcelRequire("ea2NT");

var $g9vxL = parcelRequire("g9vxL");

var $bbhke = parcelRequire("bbhke");

var $9gHhI = parcelRequire("9gHhI");

var $9V8Q1 = parcelRequire("9V8Q1");

var $kn547 = parcelRequire("kn547");
const $b58c3648fb6169a3$var$DEFAULT_QUEUE_SIZE = 100;
const $b58c3648fb6169a3$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $b58c3648fb6169a3$var$MAX_DEDUPER_KEYS = 1000;
const $b58c3648fb6169a3$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $b58c3648fb6169a3$var$MAX_FAILED_LOGS = 500;
const $b58c3648fb6169a3$var$QUICK_FLUSH_WINDOW_MS = 200;
const $b58c3648fb6169a3$var$EVENT_LOGGER_MAP = {};
class $b58c3648fb6169a3$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $b58c3648fb6169a3$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $b58c3648fb6169a3$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs();
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        if (this._loggingEnabled === 'disabled' && loggingEnabled !== 'disabled') {
            // load any pre consented events into memory
            const storageKey = this._getStorageKey();
            const events = (0, $9gHhI._getObjectFromStorage)(storageKey);
            if (events) this._queue.push(...events);
            $9gHhI.Storage.removeItem(storageKey);
        }
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $b58c3648fb6169a3$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $ea2NT._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $b58c3648fb6169a3$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $kn547._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $b58c3648fb6169a3$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $b58c3648fb6169a3$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs();
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $b58c3648fb6169a3$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $b58c3648fb6169a3$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $b58c3648fb6169a3$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $b58c3648fb6169a3$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$b58c3648fb6169a3$var$EventLogger._safeFlushAndForget(this._sdkKey), $b58c3648fb6169a3$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $ea2NT._isServerEnv)()) return false;
        if (!(0, $g9vxL._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $bXMPn._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $b58c3648fb6169a3$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $b58c3648fb6169a3$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $b58c3648fb6169a3$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $kn547._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $70MRu.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $70MRu.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $b58c3648fb6169a3$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$5v47R.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $b58c3648fb6169a3$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            const savedEvents = this._getFailedLogsFromStorage(storageKey);
            (0, $9gHhI._setObjectInStorage)(storageKey, [
                ...savedEvents,
                ...events
            ]);
        } catch (_a) {
            $70MRu.Log.warn('Unable to save failed logs to storage');
        }
    }
    _getFailedLogsFromStorage(storageKey) {
        let savedEvents = [];
        try {
            const retrieved = (0, $9gHhI._getObjectFromStorage)(storageKey);
            if (Array.isArray(retrieved)) savedEvents = retrieved;
            return savedEvents;
        } catch (_a) {
            return [];
        }
    }
    _retryFailedLogs() {
        const storageKey = this._getStorageKey();
        (()=>$b58c3648fb6169a3$var$__awaiter(this, void 0, void 0, function*() {
                if (!$9gHhI.Storage.isReady()) yield $9gHhI.Storage.isReadyResolver();
                const events = (0, $9gHhI._getObjectFromStorage)(storageKey);
                if (!events) return;
                $9gHhI.Storage.removeItem(storageKey);
                yield this._sendEvents(events);
            }))().catch(()=>{
            $70MRu.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $eDZlc._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $70MRu.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $ea2NT._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $b58c3648fb6169a3$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $b58c3648fb6169a3$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $b58c3648fb6169a3$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $bbhke.LoggingEnabledOption.disabled : $bbhke.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $70MRu.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $b58c3648fb6169a3$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $9V8Q1.UrlConfiguration($5v47R.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
}
module.exports.EventLogger = $b58c3648fb6169a3$var$EventLogger;

});
parcelRegister("bXMPn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $eDZlc = parcelRequire("eDZlc");
function $8b5b148e60184ed3$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $eDZlc._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $8b5b148e60184ed3$var$_getUserStorageKey;
function $8b5b148e60184ed3$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $8b5b148e60184ed3$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $eDZlc._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $8b5b148e60184ed3$var$_getStorageKey;

});
parcelRegister("eDZlc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $cvntC = parcelRequire("cvntC");
const $aa944a41b56a95b4$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $aa944a41b56a95b4$var$_DJB2;
const $aa944a41b56a95b4$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $aa944a41b56a95b4$var$_DJB2Object;
const $aa944a41b56a95b4$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $cvntC._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $aa944a41b56a95b4$var$_getSortedObject;

});
parcelRegister("cvntC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $91aa974230986220$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $91aa974230986220$var$_typeOf;
function $91aa974230986220$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $91aa974230986220$var$_isTypeMatch;

});



parcelRegister("5v47R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("ea2NT", function(module, exports) {

var $2M83v = parcelRequire("2M83v");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $a4f42c9c7bf176b6$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $a4f42c9c7bf176b6$var$_getWindowSafe;
const $a4f42c9c7bf176b6$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $a4f42c9c7bf176b6$var$_getDocumentSafe;
const $a4f42c9c7bf176b6$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $2M83v !== 'undefined' && $2M83v.versions != null && $2M83v.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $a4f42c9c7bf176b6$var$_isServerEnv;
const $a4f42c9c7bf176b6$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $a4f42c9c7bf176b6$var$_addWindowEventListenerSafe;
const $a4f42c9c7bf176b6$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $a4f42c9c7bf176b6$var$_addDocumentEventListenerSafe;
const $a4f42c9c7bf176b6$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $a4f42c9c7bf176b6$var$_getCurrentPageUrlSafe;
const $a4f42c9c7bf176b6$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $a4f42c9c7bf176b6$var$_getUnloadEvent;

});
parcelRegister("2M83v", function(module, exports) {
// shim for using process in browser
var $205650249034e5b8$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $205650249034e5b8$var$cachedSetTimeout;
var $205650249034e5b8$var$cachedClearTimeout;
function $205650249034e5b8$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $205650249034e5b8$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $205650249034e5b8$var$cachedSetTimeout = setTimeout;
        else $205650249034e5b8$var$cachedSetTimeout = $205650249034e5b8$var$defaultSetTimout;
    } catch (e) {
        $205650249034e5b8$var$cachedSetTimeout = $205650249034e5b8$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $205650249034e5b8$var$cachedClearTimeout = clearTimeout;
        else $205650249034e5b8$var$cachedClearTimeout = $205650249034e5b8$var$defaultClearTimeout;
    } catch (e) {
        $205650249034e5b8$var$cachedClearTimeout = $205650249034e5b8$var$defaultClearTimeout;
    }
})();
function $205650249034e5b8$var$runTimeout(fun) {
    if ($205650249034e5b8$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($205650249034e5b8$var$cachedSetTimeout === $205650249034e5b8$var$defaultSetTimout || !$205650249034e5b8$var$cachedSetTimeout) && setTimeout) {
        $205650249034e5b8$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $205650249034e5b8$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $205650249034e5b8$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $205650249034e5b8$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $205650249034e5b8$var$runClearTimeout(marker) {
    if ($205650249034e5b8$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($205650249034e5b8$var$cachedClearTimeout === $205650249034e5b8$var$defaultClearTimeout || !$205650249034e5b8$var$cachedClearTimeout) && clearTimeout) {
        $205650249034e5b8$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $205650249034e5b8$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $205650249034e5b8$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $205650249034e5b8$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $205650249034e5b8$var$queue = [];
var $205650249034e5b8$var$draining = false;
var $205650249034e5b8$var$currentQueue;
var $205650249034e5b8$var$queueIndex = -1;
function $205650249034e5b8$var$cleanUpNextTick() {
    if (!$205650249034e5b8$var$draining || !$205650249034e5b8$var$currentQueue) return;
    $205650249034e5b8$var$draining = false;
    if ($205650249034e5b8$var$currentQueue.length) $205650249034e5b8$var$queue = $205650249034e5b8$var$currentQueue.concat($205650249034e5b8$var$queue);
    else $205650249034e5b8$var$queueIndex = -1;
    if ($205650249034e5b8$var$queue.length) $205650249034e5b8$var$drainQueue();
}
function $205650249034e5b8$var$drainQueue() {
    if ($205650249034e5b8$var$draining) return;
    var timeout = $205650249034e5b8$var$runTimeout($205650249034e5b8$var$cleanUpNextTick);
    $205650249034e5b8$var$draining = true;
    var len = $205650249034e5b8$var$queue.length;
    while(len){
        $205650249034e5b8$var$currentQueue = $205650249034e5b8$var$queue;
        $205650249034e5b8$var$queue = [];
        while(++$205650249034e5b8$var$queueIndex < len)if ($205650249034e5b8$var$currentQueue) $205650249034e5b8$var$currentQueue[$205650249034e5b8$var$queueIndex].run();
        $205650249034e5b8$var$queueIndex = -1;
        len = $205650249034e5b8$var$queue.length;
    }
    $205650249034e5b8$var$currentQueue = null;
    $205650249034e5b8$var$draining = false;
    $205650249034e5b8$var$runClearTimeout(timeout);
}
$205650249034e5b8$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $205650249034e5b8$var$queue.push(new $205650249034e5b8$var$Item(fun, args));
    if ($205650249034e5b8$var$queue.length === 1 && !$205650249034e5b8$var$draining) $205650249034e5b8$var$runTimeout($205650249034e5b8$var$drainQueue);
};
// v8 likes predictible objects
function $205650249034e5b8$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$205650249034e5b8$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$205650249034e5b8$var$process.title = 'browser';
$205650249034e5b8$var$process.browser = true;
$205650249034e5b8$var$process.env = {};
$205650249034e5b8$var$process.argv = [];
$205650249034e5b8$var$process.version = ''; // empty string to avoid regexp issues
$205650249034e5b8$var$process.versions = {};
function $205650249034e5b8$var$noop() {}
$205650249034e5b8$var$process.on = $205650249034e5b8$var$noop;
$205650249034e5b8$var$process.addListener = $205650249034e5b8$var$noop;
$205650249034e5b8$var$process.once = $205650249034e5b8$var$noop;
$205650249034e5b8$var$process.off = $205650249034e5b8$var$noop;
$205650249034e5b8$var$process.removeListener = $205650249034e5b8$var$noop;
$205650249034e5b8$var$process.removeAllListeners = $205650249034e5b8$var$noop;
$205650249034e5b8$var$process.emit = $205650249034e5b8$var$noop;
$205650249034e5b8$var$process.prependListener = $205650249034e5b8$var$noop;
$205650249034e5b8$var$process.prependOnceListener = $205650249034e5b8$var$noop;
$205650249034e5b8$var$process.listeners = function(name) {
    return [];
};
$205650249034e5b8$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$205650249034e5b8$var$process.cwd = function() {
    return '/';
};
$205650249034e5b8$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$205650249034e5b8$var$process.umask = function() {
    return 0;
};

});


parcelRegister("g9vxL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $bc25f480aacc694b$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $bc25f480aacc694b$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $bc25f480aacc694b$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $bc25f480aacc694b$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $bc25f480aacc694b$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $bc25f480aacc694b$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $bc25f480aacc694b$var$GATE_EXPOSURE_NAME || eventName === $bc25f480aacc694b$var$CONFIG_EXPOSURE_NAME || eventName === $bc25f480aacc694b$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $bc25f480aacc694b$var$_isExposureEvent;
const $bc25f480aacc694b$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $bc25f480aacc694b$var$_createExposure($bc25f480aacc694b$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $bc25f480aacc694b$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $bc25f480aacc694b$var$_createGateExposure;
function $bc25f480aacc694b$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $bc25f480aacc694b$var$_mapExposures;
const $bc25f480aacc694b$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $bc25f480aacc694b$var$_createExposure($bc25f480aacc694b$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $bc25f480aacc694b$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $bc25f480aacc694b$var$_createConfigExposure;
const $bc25f480aacc694b$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $bc25f480aacc694b$var$_createExposure($bc25f480aacc694b$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $bc25f480aacc694b$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $bc25f480aacc694b$var$_createLayerParameterExposure;
const $bc25f480aacc694b$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("bbhke", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("9gHhI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $70MRu = parcelRequire("70MRu");

var $ea2NT = parcelRequire("ea2NT");
const $6bf72f2648faa8b5$var$inMemoryStore = {};
const $6bf72f2648faa8b5$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$6bf72f2648faa8b5$var$inMemoryStore[key] ? $6bf72f2648faa8b5$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $6bf72f2648faa8b5$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $6bf72f2648faa8b5$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($6bf72f2648faa8b5$var$inMemoryStore)
};
let $6bf72f2648faa8b5$var$_localStorageProvider = null;
try {
    const win = (0, $ea2NT._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $6bf72f2648faa8b5$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $70MRu.Log.warn('Failed to setup localStorageProvider.');
}
let $6bf72f2648faa8b5$var$_main = $6bf72f2648faa8b5$var$_localStorageProvider !== null && $6bf72f2648faa8b5$var$_localStorageProvider !== void 0 ? $6bf72f2648faa8b5$var$_localStorageProvider : $6bf72f2648faa8b5$var$_inMemoryProvider;
let $6bf72f2648faa8b5$var$_current = $6bf72f2648faa8b5$var$_main;
function $6bf72f2648faa8b5$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($6bf72f2648faa8b5$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$6bf72f2648faa8b5$var$_current.isReady(),
    isReadyResolver: ()=>$6bf72f2648faa8b5$var$_current.isReadyResolver(),
    getProviderName: ()=>$6bf72f2648faa8b5$var$_current.getProviderName(),
    getItem: (key)=>$6bf72f2648faa8b5$var$_inMemoryBreaker(()=>$6bf72f2648faa8b5$var$_current.getItem(key)),
    setItem: (key, value)=>$6bf72f2648faa8b5$var$_inMemoryBreaker(()=>$6bf72f2648faa8b5$var$_current.setItem(key, value)),
    removeItem: (key)=>$6bf72f2648faa8b5$var$_current.removeItem(key),
    getAllKeys: ()=>$6bf72f2648faa8b5$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $6bf72f2648faa8b5$var$_main = newProvider;
        $6bf72f2648faa8b5$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $6bf72f2648faa8b5$var$_current = $6bf72f2648faa8b5$var$_inMemoryProvider;
        else $6bf72f2648faa8b5$var$_current = $6bf72f2648faa8b5$var$_main;
    }
};
function $6bf72f2648faa8b5$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $70MRu.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $6bf72f2648faa8b5$var$_getObjectFromStorage;
function $6bf72f2648faa8b5$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $6bf72f2648faa8b5$var$_setObjectInStorage;

});

parcelRegister("9V8Q1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $eDZlc = parcelRequire("eDZlc");

var $5v47R = parcelRequire("5v47R");
const $73904af5301e7893$var$ENDPOINT_DNS_KEY_MAP = {
    [$5v47R.Endpoint._initialize]: 'i',
    [$5v47R.Endpoint._rgstr]: 'e',
    [$5v47R.Endpoint._download_config_specs]: 'd'
};
class $73904af5301e7893$var$UrlConfiguration {
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $eDZlc._DJB2)(this.customUrl + fallbacks);
    }
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $73904af5301e7893$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $5v47R.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
}
module.exports.UrlConfiguration = $73904af5301e7893$var$UrlConfiguration;

});

parcelRegister("kn547", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $ea2NT = parcelRequire("ea2NT");
const $ed49e288deae4af3$var$FOREGROUND = 'foreground';
const $ed49e288deae4af3$var$BACKGROUND = 'background';
const $ed49e288deae4af3$var$LISTENERS = [];
let $ed49e288deae4af3$var$current = $ed49e288deae4af3$var$FOREGROUND;
let $ed49e288deae4af3$var$isUnloading = false;
const $ed49e288deae4af3$var$_isCurrentlyVisible = ()=>{
    return $ed49e288deae4af3$var$current === $ed49e288deae4af3$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $ed49e288deae4af3$var$_isCurrentlyVisible;
const $ed49e288deae4af3$var$_isUnloading = ()=>$ed49e288deae4af3$var$isUnloading;
module.exports._isUnloading = $ed49e288deae4af3$var$_isUnloading;
const $ed49e288deae4af3$var$_subscribeToVisiblityChanged = (listener)=>{
    $ed49e288deae4af3$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $ed49e288deae4af3$var$_subscribeToVisiblityChanged;
const $ed49e288deae4af3$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $ed49e288deae4af3$var$current) return;
    $ed49e288deae4af3$var$current = visibility;
    $ed49e288deae4af3$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $ed49e288deae4af3$var$_notifyVisibilityChanged;
(0, $ea2NT._addWindowEventListenerSafe)('focus', ()=>{
    $ed49e288deae4af3$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($ed49e288deae4af3$var$FOREGROUND);
});
(0, $ea2NT._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($ed49e288deae4af3$var$BACKGROUND));
(0, $ea2NT._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $ed49e288deae4af3$var$FOREGROUND : $ed49e288deae4af3$var$BACKGROUND);
});
(0, $ea2NT._addWindowEventListenerSafe)((0, $ea2NT._getUnloadEvent)(), ()=>{
    $ed49e288deae4af3$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($ed49e288deae4af3$var$BACKGROUND);
});

});


parcelRegister("l8r2G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.30.2';
let $f62f525796722ba9$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$f62f525796722ba9$var$metadata,
    add: (additions)=>{
        $f62f525796722ba9$var$metadata = Object.assign(Object.assign({}, $f62f525796722ba9$var$metadata), additions);
    }
};

});

parcelRegister("eaGtC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hr0tr", function(module, exports) {
"use strict";
var $cb15535fa017793d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $70MRu = parcelRequire("70MRu");

var $hOzoK = parcelRequire("hOzoK");

var $1qAwP = parcelRequire("1qAwP");

var $9gHhI = parcelRequire("9gHhI");

var $fpLE0 = parcelRequire("fpLE0");
const $cb15535fa017793d$var$CACHE_LIMIT = 10;
const $cb15535fa017793d$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $cb15535fa017793d$var$DataAdapterCore {
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $1qAwP._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $1qAwP._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $cb15535fa017793d$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $hOzoK.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $cb15535fa017793d$var$__awaiter(this, void 0, void 0, function*() {
            if (!$9gHhI.Storage.isReady()) yield $9gHhI.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $70MRu.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $cb15535fa017793d$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $1qAwP._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $cb15535fa017793d$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $70MRu.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $fpLE0._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $hOzoK.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $cb15535fa017793d$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $cb15535fa017793d$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $70MRu.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $9gHhI.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($9gHhI.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $fpLE0._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $cb15535fa017793d$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $9gHhI.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $9gHhI._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $cb15535fa017793d$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $9gHhI.Storage.removeItem(evictable);
        }
        (0, $9gHhI._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $cb15535fa017793d$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $cb15535fa017793d$var$InMemoryCache();
    }
}
module.exports.DataAdapterCore = $cb15535fa017793d$var$DataAdapterCore;
function $cb15535fa017793d$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $1qAwP._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $cb15535fa017793d$var$_makeDataAdapterResult;
class $cb15535fa017793d$var$InMemoryCache {
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $70MRu.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $cb15535fa017793d$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
    constructor(){
        this._data = {};
    }
}
function $cb15535fa017793d$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("hOzoK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $bXMPn = parcelRequire("bXMPn");

var $70MRu = parcelRequire("70MRu");

var $ea2NT = parcelRequire("ea2NT");

var $9gHhI = parcelRequire("9gHhI");

var $eU1zn = parcelRequire("eU1zn");
const $cf8290812a53299e$var$PROMISE_MAP = {};
const $cf8290812a53299e$var$COOKIE_ENABLED_MAP = {};
const $cf8290812a53299e$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($cf8290812a53299e$var$DISABLED_MAP[sdkKey]) return null;
        if ($cf8290812a53299e$var$PROMISE_MAP[sdkKey] != null) return $cf8290812a53299e$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $cf8290812a53299e$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $cf8290812a53299e$var$PROMISE_MAP[sdkKey] = stableID;
            $cf8290812a53299e$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $cf8290812a53299e$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $eU1zn.getUUID)();
        $cf8290812a53299e$var$_persistToStorage(stableID, sdkKey);
        $cf8290812a53299e$var$_persistToCookie(stableID, sdkKey);
        $cf8290812a53299e$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $cf8290812a53299e$var$PROMISE_MAP[sdkKey] = override;
        $cf8290812a53299e$var$_persistToStorage(override, sdkKey);
        $cf8290812a53299e$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $cf8290812a53299e$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $cf8290812a53299e$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $cf8290812a53299e$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $bXMPn._getStorageKey)(sdkKey)}`;
}
function $cf8290812a53299e$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $cf8290812a53299e$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $9gHhI._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $70MRu.Log.warn('Failed to save StableID to storage');
    }
}
function $cf8290812a53299e$var$_loadFromStorage(sdkKey) {
    const storageKey = $cf8290812a53299e$var$_getStableIDStorageKey(sdkKey);
    return (0, $9gHhI._getObjectFromStorage)(storageKey);
}
function $cf8290812a53299e$var$_loadFromCookie(sdkKey) {
    if (!$cf8290812a53299e$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $ea2NT._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $cf8290812a53299e$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $cf8290812a53299e$var$_persistToCookie(stableID, sdkKey) {
    if (!$cf8290812a53299e$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $ea2NT._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$cf8290812a53299e$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $cf8290812a53299e$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $bXMPn._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $cf8290812a53299e$var$getCookieName;

});
parcelRegister("eU1zn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $ad97835be4886060$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $ad97835be4886060$var$getUUID;

});


parcelRegister("1qAwP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $eDZlc = parcelRequire("eDZlc");

var $70MRu = parcelRequire("70MRu");
function $10a48df3df761db8$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $70MRu.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $10a48df3df761db8$var$_normalizeUser;
function $10a48df3df761db8$var$_getFullUserHash(user) {
    return user ? (0, $eDZlc._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $10a48df3df761db8$var$_getFullUserHash;

});

parcelRegister("fpLE0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $70MRu = parcelRequire("70MRu");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $b38e25fb0146cd7e$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $70MRu.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $b38e25fb0146cd7e$var$_typedJsonParse;

});


parcelRegister("7KNqC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iYjmb", function(module, exports) {
"use strict";
var $dcfcd87199bf3fd4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $70MRu = parcelRequire("70MRu");

var $1jFdy = parcelRequire("1jFdy");

var $l8r2G = parcelRequire("l8r2G");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $dcfcd87199bf3fd4$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $dcfcd87199bf3fd4$var$ErrorBoundary {
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $dcfcd87199bf3fd4$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $dcfcd87199bf3fd4$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $70MRu.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$dcfcd87199bf3fd4$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($dcfcd87199bf3fd4$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $dcfcd87199bf3fd4$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $1jFdy.SDKType._get(this._sdkKey);
                    const statsigMetadata = $l8r2G.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $dcfcd87199bf3fd4$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $dcfcd87199bf3fd4$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
}
module.exports.ErrorBoundary = $dcfcd87199bf3fd4$var$ErrorBoundary;
function $dcfcd87199bf3fd4$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $dcfcd87199bf3fd4$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $dcfcd87199bf3fd4$var$UNKNOWN_ERROR;
    }
}
function $dcfcd87199bf3fd4$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $dcfcd87199bf3fd4$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("1jFdy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $0f5789bff75121ab$var$SDK_CLIENT = {};
let $0f5789bff75121ab$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $0f5789bff75121ab$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($0f5789bff75121ab$var$suffix !== null && $0f5789bff75121ab$var$suffix !== void 0 ? $0f5789bff75121ab$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $0f5789bff75121ab$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$0f5789bff75121ab$var$suffix || $0f5789bff75121ab$var$suffix === '-react') $0f5789bff75121ab$var$suffix = '-' + binding;
    }
};

});


parcelRegister("eAXjp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4kaV5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kR4KX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eRaH0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $ad0e4f3e43fe640a$var$EXIST_KEYS = new Set([]);
const $ad0e4f3e43fe640a$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $ad0e4f3e43fe640a$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($ad0e4f3e43fe640a$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($ad0e4f3e43fe640a$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $ad0e4f3e43fe640a$var$createMemoKey;

});

parcelRegister("2YqNV", function(module, exports) {
"use strict";
var $22a5fa1bfa2a966d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $92Jw6 = parcelRequire("92Jw6");

var $92Jw6 = parcelRequire("92Jw6");

var $5fEzF = parcelRequire("5fEzF");

var $70MRu = parcelRequire("70MRu");

var $5v47R = parcelRequire("5v47R");

var $f0gNb = parcelRequire("f0gNb");

var $7tGnM = parcelRequire("7tGnM");

var $1jFdy = parcelRequire("1jFdy");

var $ea2NT = parcelRequire("ea2NT");

var $9haUI = parcelRequire("9haUI");

var $hOzoK = parcelRequire("hOzoK");

var $gFVsp = parcelRequire("gFVsp");

var $l8r2G = parcelRequire("l8r2G");

var $bbhke = parcelRequire("bbhke");

var $kn547 = parcelRequire("kn547");
const $22a5fa1bfa2a966d$var$DEFAULT_TIMEOUT_MS = 10000;
const $22a5fa1bfa2a966d$var$BACKOFF_BASE_MS = 500;
const $22a5fa1bfa2a966d$var$BACKOFF_MAX_MS = 30000;
const $22a5fa1bfa2a966d$var$RATE_LIMIT_WINDOW_MS = 1000;
const $22a5fa1bfa2a966d$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $22a5fa1bfa2a966d$var$LEAK_RATE = $22a5fa1bfa2a966d$var$RATE_LIMIT_MAX_REQ_COUNT / $22a5fa1bfa2a966d$var$RATE_LIMIT_WINDOW_MS;
const $22a5fa1bfa2a966d$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $22a5fa1bfa2a966d$var$NetworkCore {
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$22a5fa1bfa2a966d$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $22a5fa1bfa2a966d$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $22a5fa1bfa2a966d$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$22a5fa1bfa2a966d$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $70MRu.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $kn547._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $22a5fa1bfa2a966d$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $22a5fa1bfa2a966d$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $22a5fa1bfa2a966d$var$_getErrorMessage(error);
                const timedOut = $22a5fa1bfa2a966d$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $22a5fa1bfa2a966d$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$22a5fa1bfa2a966d$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $gFVsp.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $70MRu.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $22a5fa1bfa2a966d$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $bbhke.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $bbhke.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $22a5fa1bfa2a966d$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $22a5fa1bfa2a966d$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $5v47R.Endpoint._initialize || args.urlConfig.endpoint === $5v47R.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$5v47R.NetworkParam.SdkKey]: args.sdkKey,
            [$5v47R.NetworkParam.SdkType]: $1jFdy.SDKType._get(args.sdkKey),
            [$5v47R.NetworkParam.SdkVersion]: $l8r2G.SDK_VERSION,
            [$5v47R.NetworkParam.Time]: String(Date.now()),
            [$5v47R.NetworkParam.SessionID]: $9haUI.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $ea2NT._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $92Jw6._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$5v47R.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $70MRu.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $22a5fa1bfa2a966d$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$22a5fa1bfa2a966d$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($70MRu.Log.error);
                writer.close().catch($70MRu.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$5v47R.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $70MRu.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $22a5fa1bfa2a966d$var$_populateRequestBody(result, args.data);
        return result;
    }
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $22a5fa1bfa2a966d$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $f0gNb.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
}
module.exports.NetworkCore = $22a5fa1bfa2a966d$var$NetworkCore;
const $22a5fa1bfa2a966d$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $70MRu.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $22a5fa1bfa2a966d$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $hOzoK.StableID.get(sdkKey);
    const sessionID = $9haUI.SessionID.get(sdkKey);
    const sdkType = $1jFdy.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $l8r2G.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $22a5fa1bfa2a966d$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $92Jw6._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $7tGnM.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $bbhke.LogEventCompressionMode.Disabled:
            return false;
        case $bbhke.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $bbhke.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $22a5fa1bfa2a966d$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $22a5fa1bfa2a966d$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $22a5fa1bfa2a966d$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $5v47R.Endpoint._initialize) return;
    $5fEzF.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $22a5fa1bfa2a966d$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $5v47R.Endpoint._initialize) return;
    $5fEzF.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $5fEzF.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $22a5fa1bfa2a966d$var$_exponentialBackoff(attempt) {
    return $22a5fa1bfa2a966d$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($22a5fa1bfa2a966d$var$BACKOFF_BASE_MS * (attempt * attempt), $22a5fa1bfa2a966d$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("f0gNb", function(module, exports) {
"use strict";
var $aec3e1b8dc8745ba$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $24B2X = parcelRequire("24B2X");

var $eDZlc = parcelRequire("eDZlc");

var $70MRu = parcelRequire("70MRu");

var $9gHhI = parcelRequire("9gHhI");
const $aec3e1b8dc8745ba$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $aec3e1b8dc8745ba$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $aec3e1b8dc8745ba$var$NetworkFallbackResolver {
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $aec3e1b8dc8745ba$var$DEFAULT_TTL_MS;
        $aec3e1b8dc8745ba$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $aec3e1b8dc8745ba$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $aec3e1b8dc8745ba$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $aec3e1b8dc8745ba$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$aec3e1b8dc8745ba$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $aec3e1b8dc8745ba$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $aec3e1b8dc8745ba$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $aec3e1b8dc8745ba$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $aec3e1b8dc8745ba$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $24B2X._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $aec3e1b8dc8745ba$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
}
module.exports.NetworkFallbackResolver = $aec3e1b8dc8745ba$var$NetworkFallbackResolver;
function $aec3e1b8dc8745ba$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $aec3e1b8dc8745ba$var$_isDomainFailure;
function $aec3e1b8dc8745ba$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $eDZlc._DJB2)(sdkKey)}`;
}
function $aec3e1b8dc8745ba$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $aec3e1b8dc8745ba$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $9gHhI.Storage.removeItem(hashKey);
        return;
    }
    $9gHhI.Storage.setItem(hashKey, JSON.stringify(info));
}
function $aec3e1b8dc8745ba$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $aec3e1b8dc8745ba$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $9gHhI.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $70MRu.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $aec3e1b8dc8745ba$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("24B2X", function(module, exports) {
"use strict";
var $1828b12c95d039ab$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $1828b12c95d039ab$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $1828b12c95d039ab$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $1828b12c95d039ab$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $1828b12c95d039ab$var$MAX_START_LOOKUP = 200;
function $1828b12c95d039ab$var$_fetchTxtRecords(networkFunc) {
    return $1828b12c95d039ab$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($1828b12c95d039ab$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $1828b12c95d039ab$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $1828b12c95d039ab$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $1828b12c95d039ab$var$_fetchTxtRecords;
function $1828b12c95d039ab$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $1828b12c95d039ab$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $1828b12c95d039ab$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("7tGnM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $571c1e1b54f74507$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $571c1e1b54f74507$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $571c1e1b54f74507$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("9haUI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $92Jw6 = parcelRequire("92Jw6");

var $bXMPn = parcelRequire("bXMPn");

var $70MRu = parcelRequire("70MRu");

var $9gHhI = parcelRequire("9gHhI");

var $eU1zn = parcelRequire("eU1zn");
const $6c0e2ad96e8bf504$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $6c0e2ad96e8bf504$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $6c0e2ad96e8bf504$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($6c0e2ad96e8bf504$var$PROMISE_MAP[sdkKey] == null) $6c0e2ad96e8bf504$var$PROMISE_MAP[sdkKey] = $6c0e2ad96e8bf504$var$_loadSession(sdkKey);
        const session = $6c0e2ad96e8bf504$var$PROMISE_MAP[sdkKey];
        return $6c0e2ad96e8bf504$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $6c0e2ad96e8bf504$var$PROMISE_MAP[sdkKey] = $6c0e2ad96e8bf504$var$_overrideSessionId(override, sdkKey);
    }
};
function $6c0e2ad96e8bf504$var$_loadSession(sdkKey) {
    let data = $6c0e2ad96e8bf504$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $eU1zn.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $6c0e2ad96e8bf504$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $6c0e2ad96e8bf504$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($6c0e2ad96e8bf504$var$_isIdle(data) || $6c0e2ad96e8bf504$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $eU1zn.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $6c0e2ad96e8bf504$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $6c0e2ad96e8bf504$var$_createSessionTimeout(sdkKey, $6c0e2ad96e8bf504$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $6c0e2ad96e8bf504$var$_createSessionTimeout(sdkKey, $6c0e2ad96e8bf504$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $6c0e2ad96e8bf504$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $92Jw6._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $6c0e2ad96e8bf504$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $6c0e2ad96e8bf504$var$MAX_SESSION_IDLE_TIME;
}
function $6c0e2ad96e8bf504$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $6c0e2ad96e8bf504$var$MAX_SESSION_AGE;
}
function $6c0e2ad96e8bf504$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $bXMPn._getStorageKey)(sdkKey)}`;
}
function $6c0e2ad96e8bf504$var$_persistToStorage(session, sdkKey) {
    const storageKey = $6c0e2ad96e8bf504$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $9gHhI._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $70MRu.Log.warn('Failed to save SessionID');
    }
}
function $6c0e2ad96e8bf504$var$_loadFromStorage(sdkKey) {
    const storageKey = $6c0e2ad96e8bf504$var$_getSessionIDStorageKey(sdkKey);
    return (0, $9gHhI._getObjectFromStorage)(storageKey);
}

});

parcelRegister("gFVsp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("iywen", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jNoHg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("buDI8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $85e14cd041b1b6e5$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $85e14cd041b1b6e5$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $85e14cd041b1b6e5$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $85e14cd041b1b6e5$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $85e14cd041b1b6e5$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $85e14cd041b1b6e5$var$_fastApproxSizeOf;

});

parcelRegister("ahxuL", function(module, exports) {
"use strict";
var $77c5795e0af690ca$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $92Jw6 = parcelRequire("92Jw6");

var $92Jw6 = parcelRequire("92Jw6");

var $iYjmb = parcelRequire("iYjmb");

var $fAnch = parcelRequire("fAnch");

var $70MRu = parcelRequire("70MRu");

var $eRaH0 = parcelRequire("eRaH0");

var $ea2NT = parcelRequire("ea2NT");

var $9haUI = parcelRequire("9haUI");

var $hOzoK = parcelRequire("hOzoK");

var $bbhke = parcelRequire("bbhke");

var $9gHhI = parcelRequire("9gHhI");
const $77c5795e0af690ca$var$MAX_MEMO_CACHE_SIZE = 3000;
class $77c5795e0af690ca$var$StatsigClientBase {
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $9gHhI.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $hOzoK.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($bbhke.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $77c5795e0af690ca$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $70MRu.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $eRaH0.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $77c5795e0af690ca$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($70MRu.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $9gHhI.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $9haUI.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $9gHhI.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $hOzoK.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $hOzoK.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $fAnch.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $iYjmb.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $9gHhI.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $77c5795e0af690ca$var$_assignGlobalInstance(sdkKey, this);
    }
}
module.exports.StatsigClientBase = $77c5795e0af690ca$var$StatsigClientBase;
function $77c5795e0af690ca$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $ea2NT._isServerEnv)()) return;
    const statsigGlobal = (0, $92Jw6._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $70MRu.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("gxEb4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("2hwxs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fKIfQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $70MRu = parcelRequire("70MRu");

var $cvntC = parcelRequire("cvntC");
function $b77d7ae8ce7fdf6f$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $b77d7ae8ce7fdf6f$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $b77d7ae8ce7fdf6f$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $b77d7ae8ce7fdf6f$var$_makeFeatureGate;
function $b77d7ae8ce7fdf6f$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $b77d7ae8ce7fdf6f$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $b77d7ae8ce7fdf6f$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $b77d7ae8ce7fdf6f$var$_makeDynamicConfig;
function $b77d7ae8ce7fdf6f$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $b77d7ae8ce7fdf6f$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $b77d7ae8ce7fdf6f$var$_makeExperiment;
function $b77d7ae8ce7fdf6f$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $b77d7ae8ce7fdf6f$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $b77d7ae8ce7fdf6f$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $b77d7ae8ce7fdf6f$var$_makeLayer;
function $b77d7ae8ce7fdf6f$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $b77d7ae8ce7fdf6f$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $b77d7ae8ce7fdf6f$var$_mergeOverride;
function $b77d7ae8ce7fdf6f$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $cvntC._isTypeMatch)(found, fallback)) {
            $70MRu.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $b77d7ae8ce7fdf6f$var$_makeTypedGet;

});

parcelRegister("z52jv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ci35n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $8f298f36bad9692a$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $8f298f36bad9692a$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("1HmhQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e8671975c51e54d$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $7FIrY = parcelRequire("7FIrY");

var $kzZXs = parcelRequire("kzZXs");

var $juSGQ = parcelRequire("juSGQ");

var $h74Lv = parcelRequire("h74Lv");

var $bFY7G = parcelRequire("bFY7G");

var $4FAuJ = parcelRequire("4FAuJ");

var $9w0mX = parcelRequire("9w0mX");

var $5R84o = parcelRequire("5R84o");

var $8mvxw = parcelRequire("8mvxw");

var $iXjMy = parcelRequire("iXjMy");

var $lBkat = parcelRequire("lBkat");

var $4bfii = parcelRequire("4bfii");

var $9tfAe = parcelRequire("9tfAe");

var $BiRQc = parcelRequire("BiRQc");

var $b8WdK = parcelRequire("b8WdK");

var $gPO6w = parcelRequire("gPO6w");

var $31szT = parcelRequire("31szT");

var $lP8ic = parcelRequire("lP8ic");

var $6HSOG = parcelRequire("6HSOG");

var $hEhuo = parcelRequire("hEhuo");

var $9QtDp = parcelRequire("9QtDp");

var $7IjZo = parcelRequire("7IjZo");

var $lPBf7 = parcelRequire("lPBf7");

var $c6Gao = parcelRequire("c6Gao");

var $2V09K = parcelRequire("2V09K");

var $6kvwZ = parcelRequire("6kvwZ");

var $3itWI = parcelRequire("3itWI");

var $7zKr7 = parcelRequire("7zKr7");

var $et0BU = parcelRequire("et0BU");

var $7avGr = parcelRequire("7avGr");

var $jtDq6 = parcelRequire("jtDq6");

var $jPZoT = parcelRequire("jPZoT");

var $XQNUr = parcelRequire("XQNUr");

var $9jx9x = parcelRequire("9jx9x");

var $eiuru = parcelRequire("eiuru");

var $6TQrT = parcelRequire("6TQrT");

var $2U91m = parcelRequire("2U91m");

var $eXLaM = parcelRequire("eXLaM");

var $bQFSn = parcelRequire("bQFSn");
const $1e8671975c51e54d$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $1e8671975c51e54d$export$2e2bcd8739ae039 {
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $et0BU.TestSupport).isGeminiVREnvironment() && !(0, $et0BU.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $et0BU.TestSupport).isGeminiVREnvironment() && !(0, $et0BU.TestSupport).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties. They are not part of the public
   * API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get task() {
        return this._task;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties.
   * They are not part of the public API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get _productInfo() {
        return this._internalProductInfo;
    }
    constructor(productInfo, settings = {}){
        this._apdexEvent = void 0;
        this._context = void 0;
        this._eventDelayQueue = void 0;
        this._historyReplaceFn = void 0;
        this._orgInfo = void 0;
        this._pageVisibility = void 0;
        this._internalProductInfo = void 0;
        this._safeSessionStorage = void 0;
        this._sessionTracking = void 0;
        this._tabTracking = void 0;
        this._tenantInfo = void 0;
        this._testingCache = void 0;
        this._uiViewedAttributes = void 0;
        this._uiViewedEvent = void 0;
        this._userInfo = void 0;
        this._originTracing = void 0;
        this._task = void 0;
        this._pageLoadId = void 0;
        this._workspaceInfo = void 0;
        this._collaborationContextInfo = void 0;
        this._aliases = void 0;
        this._groups = void 0;
        this._eventProcessor = void 0;
        this._logger = void 0;
        this._embeddedContext = void 0;
        this._crossProductInteractionTracking = void 0;
        this._useStargate = (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        };
        this._changeInternalUserId = (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        };
        this._createSubproductGetter = (subproduct)=>(0, $8mvxw.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        this._createEmbeddedProductGetter = (embeddedProduct)=>(0, $8mvxw.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        this._getLastScreenEvent = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($1e8671975c51e54d$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch  {
                this._safeSessionStorage.removeItem($1e8671975c51e54d$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        };
        this._setLastScreenEvent = (event)=>{
            this._safeSessionStorage.setItem($1e8671975c51e54d$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        };
        this._shouldEventBeDelayed = (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        };
        this._fireEvent = (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $juSGQ.eventType).UI:
                case (0, $juSGQ.eventType).OPERATIONAL:
                case (0, $juSGQ.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $juSGQ.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $juSGQ.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        };
        this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        };
        this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        };
        this._processEvent = (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        };
        this.setEmbeddedProduct = (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        };
        this.clearEmbeddedProduct = ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        };
        this.setSubproduct = (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        };
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            const keys = Object.keys(capturedOriginTraces);
            keys.forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            keys.forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (keys.length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        };
        this.setTenantInfo = (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $juSGQ.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $31szT.isType)((0, $juSGQ.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $6HSOG.objectValues)((0, $juSGQ.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearTenantInfo = ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setOrgInfo = (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        };
        this.clearOrgInfo = ()=>{
            this._orgInfo = {};
        };
        this.setWorkspaceInfo = (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        };
        this.clearWorkspaceInfo = ()=>{
            this._workspaceInfo = {};
        };
        this.setCollaborationContextInfo = (collaborationContextAri)=>{
            if (!collaborationContextAri) throw new Error('Missing collaborationContextAri');
            this._collaborationContextInfo = {
                collaborationContextAri: collaborationContextAri
            };
        };
        this.clearCollaborationContextInfo = ()=>{
            this._collaborationContextInfo = {};
        };
        this.setUserInfo = (userIdType, userId)=>{
            (0, $jPZoT.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearUserInfo = ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setAlias = (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $31szT.isType)((0, $juSGQ.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $6HSOG.objectValues)((0, $juSGQ.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        };
        this.clearAlias = ()=>{
            this._aliases = {};
        };
        this.setGroup = (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $31szT.isType)((0, $juSGQ.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $6HSOG.objectValues)((0, $juSGQ.groupType))}]`);
            this._groups[groupsKeyType] = group;
        };
        this.clearGroup = ()=>{
            this._groups = {};
        };
        this.getAnonymousId = ()=>this._userInfo.anonymousId;
        this.getCurrentSessionId = ()=>this._sessionTracking.getCurrentSessionId();
        this.setUIViewedAttributes = (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = {
                ...uiViewedAttributes
            };
        };
        this.getUIViewedAttributes = ()=>{
            return this._uiViewedAttributes;
        };
        this.clearUIViewedAttributes = ()=>{
            this._uiViewedAttributes = {};
        };
        this.appendUIViewedAttributes = (attributes)=>{
            if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
            else this._uiViewedAttributes = {
                ...this._uiViewedAttributes,
                ...attributes
            };
        };
        this.sendIdentifyEvent = (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $juSGQ.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        };
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ this.sendPageEvent = (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        };
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ this.sendScreenEvent = (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $eiuru.validateScreenEvent)(screenName);
            (0, $jtDq6.validateContainers)(screenContainers);
            const builtEvent = (0, $5R84o.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = {
                name: screenName,
                ...builtEvent
            };
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $eXLaM.default)(callback, builtEventWithName));
        };
        this.sendTrackEvent = (event, callback)=>{
            (0, $6TQrT.validateTrackEvent)(event);
            const builtEvent = (0, $bFY7G.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $juSGQ.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $4FAuJ.buildActionName)(event), builtEvent, this._context, (0, $eXLaM.default)(callback, builtEvent));
        };
        this.sendUIEvent = (event, callback)=>{
            (0, $2U91m.validateUIEvent)(event);
            const builtEvent = (0, $bFY7G.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $juSGQ.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $4FAuJ.buildActionName)(event), builtEvent, this._context, (0, $eXLaM.default)(callback, builtEvent));
        };
        this.sendOperationalEvent = (event, callback)=>{
            (0, $XQNUr.validateOperationalEvent)(event);
            const builtEvent = (0, $bFY7G.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $juSGQ.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $4FAuJ.buildActionName)(event), builtEvent, this._context, (0, $eXLaM.default)(callback, builtEvent));
        };
        this.startUIViewedEvent = (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = this.createUIViewedEvent(callback);
            this._uiViewedEvent.start();
        };
        this.stopUIViewedEvent = ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        };
        this.resetUIViewedTimers = ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        };
        this.signalUserActive = ()=>{
            let uiViewedEvent = this._uiViewedEvent || this.createUIViewedEvent(null);
            uiViewedEvent.signalUserActive();
        };
        this.createUIViewedEvent = (callback)=>{
            return new (0, $7zKr7.default)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
        };
        this.startApdexEvent = (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        };
        this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
        this.stopApdexEvent = (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        };
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        this.startLowPriorityEventDelay = (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        };
        this.stopLowPriorityEventDelay = ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        };
        this.onEvent = (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $juSGQ.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $juSGQ.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $juSGQ.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $juSGQ.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $juSGQ.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $6HSOG.objectValues)((0, $juSGQ.eventType))}]`);
        };
        this.setResponseCallback = (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $31szT.isType)((0, $juSGQ.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $6HSOG.objectValues)((0, $juSGQ.envType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $juSGQ.originType).WEB;
        else if (!(0, $31szT.isType)((0, $juSGQ.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $6HSOG.objectValues)((0, $juSGQ.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $juSGQ.originType).WEB ? (0, $juSGQ.platformType).WEB : (0, $juSGQ.platformType).DESKTOP;
        else (0, $9jx9x.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        // Auto-detect Oasis perimeter (e.g. FedRAMP Moderate) when the consumer hasn't explicitly provided a perimeter.
        if (!productInfo.perimeter) try {
            if ((0, $7FIrY.isFedrampModerate)()) productInfo.perimeter = (0, $juSGQ.perimeterType).FEDRAMP_MODERATE;
        } catch (e) {
            this._logger.warn('Failed to auto-detect perimeter: %s', e instanceof Error ? e.message : String(e));
        }
        // Default to commercial perimeter if not explicitly provided and not auto-detected.
        if (!productInfo.perimeter) productInfo.perimeter = (0, $juSGQ.perimeterType).COMMERCIAL;
        if (!(0, $31szT.isType)((0, $juSGQ.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be a perimeterType: [${(0, $6HSOG.objectValues)((0, $juSGQ.perimeterType))}]`);
        // Auto-detect Oasis Isolated Cloud (IC) environment when the consumer hasn't explicitly provided an `ic` value.
        if (!productInfo.ic) try {
            const icId = (0, $kzZXs.isolationContextId)();
            if (icId && icId.length > 0) productInfo.ic = icId;
        } catch (e) {
            this._logger.warn('Failed to auto-detect isolation context: %s', e instanceof Error ? e.message : String(e));
        }
        this._internalProductInfo = {
            ...productInfo,
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        };
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo?.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $b8WdK.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $gPO6w.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $9w0mX.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $c6Gao.default)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = (0, $7IjZo.selectHost)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride,
            apiHost: settings.apiHost
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts,
            maxQueueSize: settings.maxQueueSize
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $bQFSn.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $BiRQc.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $9tfAe.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: (0, $lP8ic.LoggingResponseCallback).getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings?.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $9QtDp.default)();
        this._tabTracking = new (0, $2V09K.default)();
        this._sessionTracking = new (0, $lPBf7.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $6kvwZ.default)();
        this._originTracing = new (0, $hEhuo.default)();
        this._eventProcessor.setOriginTracingClient(this._originTracing);
        // Init Apdex
        this._apdexEvent = new (0, $h74Lv.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $lBkat.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $4bfii.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $3itWI.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = (0, $7avGr.default)();
        this._workspaceInfo = {};
        this._collaborationContextInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $iXjMy.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
}

});
parcelRegister("7FIrY", function(module, exports) {
$parcel$export(module.exports, "isFedrampModerate", () => $32580d5a9f6d1d8b$export$104cb891a6e90b3a);

var $jigJt = parcelRequire("jigJt");

var $1KkKa = parcelRequire("1KkKa");
function $32580d5a9f6d1d8b$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext?.isInFedramp ?? false;
    const atlCtxCookieValues = (0, $1KkKa.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $jigJt.FEDRAMP_MODERATE);
}

});
parcelRegister("jigJt", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $84a3a96d713b766b$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $84a3a96d713b766b$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $84a3a96d713b766b$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $84a3a96d713b766b$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $84a3a96d713b766b$export$a0ffa0598c95dfb7);
const $84a3a96d713b766b$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $84a3a96d713b766b$export$f005e2e9f707cb5f = 'commercial';
const $84a3a96d713b766b$export$17b81a3d6c98013c = 'isolated-cloud';
const $84a3a96d713b766b$export$a739cd5aac835909 = 'staging';
const $84a3a96d713b766b$export$42dd0cdd351a4a9 = 'prod';
const $84a3a96d713b766b$export$404582bc18fe4d9e = 'dev';
const $84a3a96d713b766b$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $84a3a96d713b766b$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $84a3a96d713b766b$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $84a3a96d713b766b$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $84a3a96d713b766b$export$b61e047ddcc35726 = 'GCP';
const $84a3a96d713b766b$export$1baf17f3e645a2b2 = 'AWS';

});

parcelRegister("1KkKa", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $1ee4a58f5860703e$export$3fa7b7af96286cc9);

var $jigJt = parcelRequire("jigJt");

var $1VYdG = parcelRequire("1VYdG");
function $1ee4a58f5860703e$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = (0, $1VYdG.getRawCookieValue)((0, $jigJt.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = (0, $1VYdG.getRawCookieValue)((0, $jigJt.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = (0, $1VYdG.getRawCookieValue)((0, $jigJt.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});
parcelRegister("1VYdG", function(module, exports) {
$parcel$export(module.exports, "getRawCookieValue", () => $d3a3a1b35f8aaefd$export$aa09aab30a92256c);
function $d3a3a1b35f8aaefd$export$aa09aab30a92256c(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}

});



parcelRegister("kzZXs", function(module, exports) {
$parcel$export(module.exports, "isolationContextId", () => $ea8231985be3ea17$export$839b022803d38d4d);

var $1KkKa = parcelRequire("1KkKa");

var $deE7Q = parcelRequire("deE7Q");
function $ea8231985be3ea17$export$839b022803d38d4d() {
    if (typeof document === 'undefined') // @ts-ignore
    return (0, $deE7Q.isIsolatedCloud)() ? globalThis.ssrContext?.icName : undefined;
    const atlCtxCookieValues = (0, $1KkKa.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icId;
}

});
parcelRegister("deE7Q", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $614796e381deca70$export$9186ccba8effc5de);

var $15lzc = parcelRequire("15lzc");

var $1KkKa = parcelRequire("1KkKa");
function $614796e381deca70$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext?.isInIC ?? false;
    const atlCtxCookieValues = (0, $1KkKa.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $15lzc.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}

});
parcelRegister("15lzc", function(module, exports) {
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $f6d70cc37a54cc55$export$d8347b4aae768c2d);

var $jigJt = parcelRequire("jigJt");
const $f6d70cc37a54cc55$export$d8347b4aae768c2d = [
    (0, $jigJt.COMMERCIAL)
];

});



parcelRegister("juSGQ", function(module, exports) {
$parcel$export(module.exports, "envType", () => $a88937366139f4e9$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $a88937366139f4e9$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $a88937366139f4e9$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $a88937366139f4e9$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $a88937366139f4e9$export$496f06ac2a964da2);
$parcel$export(module.exports, "productEmbedType", () => $a88937366139f4e9$export$f49776dca27a2e7c);
$parcel$export(module.exports, "userType", () => $a88937366139f4e9$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $a88937366139f4e9$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $a88937366139f4e9$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $a88937366139f4e9$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $a88937366139f4e9$export$62a500c02dc63ee);
$parcel$export(module.exports, "perimeterType", () => $a88937366139f4e9$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $a88937366139f4e9$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $a88937366139f4e9$export$e73680b18d9b7c6e);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.


var $a88937366139f4e9$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $a88937366139f4e9$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $a88937366139f4e9$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
	 *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
	 */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $a88937366139f4e9$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $a88937366139f4e9$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $a88937366139f4e9$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var $a88937366139f4e9$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $a88937366139f4e9$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $a88937366139f4e9$export$809831be6c4c6227 = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
const $a88937366139f4e9$export$19c579398ad213e7 = Object.freeze([
    "web",
    "mobileWeb"
]);
var $a88937366139f4e9$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
var $a88937366139f4e9$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var $a88937366139f4e9$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var $a88937366139f4e9$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var $a88937366139f4e9$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("h74Lv", function(module, exports) {
$parcel$export(module.exports, "default", () => $af524be35158088a$export$2e2bcd8739ae039);

var $juSGQ = parcelRequire("juSGQ");

var $31szT = parcelRequire("31szT");

var $9QtDp = parcelRequire("9QtDp");

var $l0vJa = parcelRequire("l0vJa");
class $af524be35158088a$export$2e2bcd8739ae039 {
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent({
            ...event,
            ...apdexFields,
            ...visibilityFields
        }, callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
    constructor(onEvent, pageVisibility){
        this._isActiveEvents = void 0;
        this._onEvent = void 0;
        this._pageVisibility = void 0;
        this._performance = void 0;
        this._startedEvents = void 0;
        this._threshold = void 0;
        this._wasPreviouslyHidden = void 0;
        this._getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
        this._getEventTimingByName = (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        };
        this._getApdexFields = (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return {
                ...apdexTimings,
                apdex: apdexScore
            };
        };
        this._getApdexTimings = (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        };
        this._getStartTime = (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $juSGQ.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        };
        this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
        this._cleanApdexState = (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        };
        this._getVisibilityFields = (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $juSGQ.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $juSGQ.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        };
        this._calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        };
        this._validateStartEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        };
        this._validateStopEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $31szT.isType)((0, $juSGQ.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $juSGQ.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        };
        this._shouldSendEvent = (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        };
        this._sendEvent = (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: {
                    ...event.additionalAttributes,
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                }
            }, callback);
        };
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $9QtDp.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $l0vJa.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
}

});
parcelRegister("31szT", function(module, exports) {
$parcel$export(module.exports, "isType", () => $ebe68abebc87ba01$export$26b9f946b448f23e);
function $ebe68abebc87ba01$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}

});

parcelRegister("9QtDp", function(module, exports) {
$parcel$export(module.exports, "default", () => $1227a3095657c5da$export$2e2bcd8739ae039);
class $1227a3095657c5da$export$2e2bcd8739ae039 {
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
    constructor(){
        this._callbacks = void 0;
        this._hidden = void 0;
        this._isHidden = void 0;
        this._visibilityChange = void 0;
        this._bindEventListeners = ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        };
        this._handleVisibilityChange = ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        };
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
}

});

parcelRegister("l0vJa", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1c9afa9d2d76e04$export$2e2bcd8739ae039);
class $c1c9afa9d2d76e04$export$2e2bcd8739ae039 {
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
    constructor(){
        this._performance = void 0;
        this._performance = window.performance;
    }
}

});


parcelRegister("bFY7G", function(module, exports) {
$parcel$export(module.exports, "buildActionEvent", () => $bfc918c4efdedcc2$export$7bf451af4a8e3dd9);

var $dHnwJ = parcelRequire("dHnwJ");

var $507hb = parcelRequire("507hb");

var $hMAhB = parcelRequire("hMAhB");

var $gNyND = parcelRequire("gNyND");

var $6u4r9 = parcelRequire("6u4r9");

var $6exDj = parcelRequire("6exDj");

var $1eXcd = parcelRequire("1eXcd");

var $atbeo = parcelRequire("atbeo");

var $3QJTu = parcelRequire("3QJTu");

var $hdSk6 = parcelRequire("hdSk6");

var $jl8dD = parcelRequire("jl8dD");
function $bfc918c4efdedcc2$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, aliases, groups) {
    const productFields = (0, $1eXcd.buildProductFields)(productInfo, (0, $jl8dD.extractProductOverrides)(event));
    const tenantFields = (0, $atbeo.buildTenantFields)(tenantInfo);
    const orgFields = (0, $6exDj.buildOrgFields)(orgInfo);
    const workspaceFields = (0, $hdSk6.buildWorkspaceFields)(workspaceInfo);
    const collaborationContextFields = (0, $hMAhB.buildCollaborationContextFields)(collaborationContextInfo);
    const userFields = (0, $3QJTu.buildUserFields)(userInfo);
    const actionFields = (0, $dHnwJ.buildActionFields)(event, actionEventType);
    return {
        ...productFields,
        ...tenantFields,
        ...orgFields,
        ...userFields,
        ...actionFields,
        ...(0, $gNyND.buildEventOverrides)(event),
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...collaborationContextFields,
        ...(0, $507hb.buildAliases)(aliases),
        ...(0, $6u4r9.buildGroups)(groups)
    };
}

});
parcelRegister("dHnwJ", function(module, exports) {
$parcel$export(module.exports, "buildActionFields", () => $69ae0eb55561278f$export$655ecf7241feac42);

var $2gCVW = parcelRequire("2gCVW");
function $69ae0eb55561278f$export$655ecf7241feac42(event, actionEventType) {
    return {
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType,
        ...(0, $2gCVW.buildContainersWithName)(event.containers)
    };
}

});
parcelRegister("2gCVW", function(module, exports) {
$parcel$export(module.exports, "buildContainersWithName", () => $3478dee6735a216c$export$f045f238d77c002a);

var $2ReuD = parcelRequire("2ReuD");

var $acQfi = parcelRequire("acQfi");

var $eo150 = parcelRequire("eo150");
function $3478dee6735a216c$export$f045f238d77c002a(containers) {
    if ((0, $eo150.isNotEmptyObject)(containers)) {
        const validContainers = (0, $acQfi.filterAndBuildContainers)(containers);
        return (0, $2ReuD.buildAttributesWithName)('containers', validContainers);
    }
    return undefined;
}

});
parcelRegister("2ReuD", function(module, exports) {
$parcel$export(module.exports, "buildAttributesWithName", () => $1a6766da55ab1e55$export$55b70947967d0b50);

var $eo150 = parcelRequire("eo150");
function $1a6766da55ab1e55$export$55b70947967d0b50(name, attrObject) {
    return (0, $eo150.isNotEmptyObject)(attrObject) ? {
        [name]: attrObject
    } : undefined;
}

});
parcelRegister("eo150", function(module, exports) {
$parcel$export(module.exports, "isNotEmptyObject", () => $0a026912fe6849cb$export$e0287cc73292b477);

var $5BeP1 = parcelRequire("5BeP1");
function $0a026912fe6849cb$export$e0287cc73292b477(obj) {
    return (0, $5BeP1.isPlainObject)(obj) && Object.keys(obj).length > 0;
}

});
parcelRegister("5BeP1", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", () => $19f1e793a05a1037$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $19f1e793a05a1037$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $19f1e793a05a1037$var$isObjectObject(o) {
    return $19f1e793a05a1037$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $19f1e793a05a1037$export$53b83ca8eaab0383(o) {
    if ($19f1e793a05a1037$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($19f1e793a05a1037$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});



parcelRegister("acQfi", function(module, exports) {
$parcel$export(module.exports, "filterAndBuildContainers", () => $2ac2b83767de6a62$export$3f5115a568819c1a);
function $2ac2b83767de6a62$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}

});



parcelRegister("507hb", function(module, exports) {
$parcel$export(module.exports, "buildAliases", () => $a8ceb81b35740ca0$export$2c4ef8ee173bbcaa);

var $eo150 = parcelRequire("eo150");
function $a8ceb81b35740ca0$export$2c4ef8ee173bbcaa(aliases) {
    if ((0, $eo150.isNotEmptyObject)(aliases)) return {
        aliases: aliases
    };
    return undefined;
}

});

parcelRegister("hMAhB", function(module, exports) {
$parcel$export(module.exports, "buildCollaborationContextFields", () => $b501f8fae021e894$export$d138783ff9effae1);
function $b501f8fae021e894$export$d138783ff9effae1(collaborationContextInfo) {
    return {
        collaborationContextAri: collaborationContextInfo.collaborationContextAri
    };
}

});

parcelRegister("gNyND", function(module, exports) {
$parcel$export(module.exports, "buildEventOverrides", () => $b75b73f8aca55104$export$469803cc371327c2);
function $b75b73f8aca55104$export$469803cc371327c2(event) {
    let result = {};
    if (event.anonymousId) result.anonymousId = event.anonymousId;
    if (event.excludedProperties) result.excludedProperties = event.excludedProperties;
    if (event.userConsents) result.userConsents = event.userConsents;
    return result;
}

});

parcelRegister("6u4r9", function(module, exports) {
$parcel$export(module.exports, "buildGroups", () => $edf5cb2587b7077c$export$680f59e10d3eb269);

var $eo150 = parcelRequire("eo150");
function $edf5cb2587b7077c$export$680f59e10d3eb269(groups) {
    if ((0, $eo150.isNotEmptyObject)(groups)) return {
        groups: groups
    };
    return undefined;
}

});

parcelRegister("6exDj", function(module, exports) {
$parcel$export(module.exports, "buildOrgFields", () => $6e69df446a91a786$export$19ccbe55c9aa75d5);
function $6e69df446a91a786$export$19ccbe55c9aa75d5(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}

});

parcelRegister("1eXcd", function(module, exports) {
$parcel$export(module.exports, "buildProductFields", () => $402b6f5a7697950c$export$bd1896e45d2ef8e8);

var $K9Iqj = parcelRequire("K9Iqj");
function $402b6f5a7697950c$export$bd1896e45d2ef8e8(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = (0, $K9Iqj.getProductField)(productInfo.env, overrides.env);
    const product = (0, $K9Iqj.getProductField)(productInfo.product, overrides.product);
    const subproduct = (0, $K9Iqj.getProductField)(productInfo.subproduct(), overrides.subproduct);
    const version = (0, $K9Iqj.getProductField)(productInfo.version, overrides.version);
    const origin = (0, $K9Iqj.getProductField)(productInfo.origin, overrides.origin);
    const platform = (0, $K9Iqj.getProductField)(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    const cdp = productInfo.cdp;
    const csp = productInfo.csp;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic,
        cdp: cdp,
        csp: csp
    };
}

});
parcelRegister("K9Iqj", function(module, exports) {
$parcel$export(module.exports, "getProductField", () => $8eb949814db3bc58$export$690c718dc8037b2e);
function $8eb949814db3bc58$export$690c718dc8037b2e(field, override) {
    return override === undefined ? field : override;
}

});


parcelRegister("atbeo", function(module, exports) {
$parcel$export(module.exports, "buildTenantFields", () => $5a992508093807ca$export$ab02ab56ae59d840);
function $5a992508093807ca$export$ab02ab56ae59d840(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}

});

parcelRegister("3QJTu", function(module, exports) {
$parcel$export(module.exports, "buildUserFields", () => $f5c577a74cec801e$export$4557a3fdd8921d68);
function $f5c577a74cec801e$export$4557a3fdd8921d68(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}

});

parcelRegister("hdSk6", function(module, exports) {
$parcel$export(module.exports, "buildWorkspaceFields", () => $c625ac4894419c8c$export$73c41604cd4b31da);
function $c625ac4894419c8c$export$73c41604cd4b31da(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}

});

parcelRegister("jl8dD", function(module, exports) {
$parcel$export(module.exports, "extractProductOverrides", () => $05a4abcef97261e4$export$e3d99b4bfec06f6e);
function $05a4abcef97261e4$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}

});


parcelRegister("4FAuJ", function(module, exports) {
$parcel$export(module.exports, "buildActionName", () => $1090b5879063be24$export$9c5623a792efc9b0);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $1090b5879063be24$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}

});

parcelRegister("9w0mX", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $2c1b50987b1840dd$export$3a7fe28f9bf4f3d9);

var $1gzkE = parcelRequire("1gzkE");
const $2c1b50987b1840dd$var$libraryVersion = "0.0.0-use.local";
function $2c1b50987b1840dd$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return (0, $1gzkE.validationMode).QUIET;
    if (environment.includes('prod')) return (0, $1gzkE.validationMode).QUIET;
    return (0, $1gzkE.validationMode).COMPLETE;
}
function $2c1b50987b1840dd$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $2c1b50987b1840dd$var$libraryVersion
            },
            validationMode: $2c1b50987b1840dd$var$getDefaultValidationMode(productInfo)
        }
    };
}

});
parcelRegister("1gzkE", function(module, exports) {
$parcel$export(module.exports, "validationMode", () => $54fde6aaaec3e3a2$export$fbd92247fb4d6159);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $54fde6aaaec3e3a2$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});

});


parcelRegister("5R84o", function(module, exports) {
$parcel$export(module.exports, "buildScreenEvent", () => $0a5ad243d0dae438$export$c7d9a5f56acc4b19);

var $juSGQ = parcelRequire("juSGQ");

var $507hb = parcelRequire("507hb");

var $2ReuD = parcelRequire("2ReuD");

var $hMAhB = parcelRequire("hMAhB");

var $2gCVW = parcelRequire("2gCVW");

var $gNyND = parcelRequire("gNyND");

var $6u4r9 = parcelRequire("6u4r9");

var $bGzTK = parcelRequire("bGzTK");

var $6exDj = parcelRequire("6exDj");

var $1eXcd = parcelRequire("1eXcd");

var $atbeo = parcelRequire("atbeo");

var $3QJTu = parcelRequire("3QJTu");

var $hdSk6 = parcelRequire("hdSk6");
function $0a5ad243d0dae438$var$buildAttributes(attributes) {
    return (0, $2ReuD.buildAttributesWithName)('attributes', attributes);
}
function $0a5ad243d0dae438$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return (0, $2ReuD.buildAttributesWithName)('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $0a5ad243d0dae438$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, event, containers, aliases, groups) {
    const productFields = (0, $1eXcd.buildProductFields)(productInfo);
    const tenantFields = (0, $atbeo.buildTenantFields)(tenantInfo);
    const userFields = (0, $3QJTu.buildUserFields)(userInfo);
    const orgFields = (0, $6exDj.buildOrgFields)(orgInfo);
    const workspaceFields = (0, $hdSk6.buildWorkspaceFields)(workspaceInfo);
    const collaborationContextFields = (0, $hMAhB.buildCollaborationContextFields)(collaborationContextInfo);
    return {
        eventType: (0, $juSGQ.eventType).SCREEN,
        ...productFields,
        ...tenantFields,
        ...userFields,
        ...orgFields,
        ...(0, $bGzTK.buildLocationFields)(event),
        ...$0a5ad243d0dae438$var$buildAttributes(attributes),
        ...$0a5ad243d0dae438$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
        ...(0, $2gCVW.buildContainersWithName)(containers),
        ...(0, $gNyND.buildEventOverrides)(event),
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...collaborationContextFields,
        ...(0, $507hb.buildAliases)(aliases),
        ...(0, $6u4r9.buildGroups)(groups)
    };
}

});
parcelRegister("bGzTK", function(module, exports) {
$parcel$export(module.exports, "buildLocationFields", () => $14cd63f708b429b1$export$6dfd201add24e54d);
function $14cd63f708b429b1$export$6dfd201add24e54d(event) {
    const payload = typeof event === 'object' ? event : undefined;
    return {
        title: '',
        path: typeof payload?.path === 'string' ? payload.path : '',
        url: typeof payload?.url === 'string' ? payload.url : '',
        referrer: '',
        search: ''
    };
}

});


parcelRegister("8mvxw", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cc076981593a49f$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $1cc076981593a49f$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $1cc076981593a49f$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($1cc076981593a49f$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("iXjMy", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9e9910971878771$export$2e2bcd8739ae039);

var $8Fd9N = parcelRequire("8Fd9N");

var $jqVis = parcelRequire("jqVis");

var $gAfN8 = parcelRequire("gAfN8");

var $juSGQ = parcelRequire("juSGQ");

var $3KzJL = parcelRequire("3KzJL");
const $a9e9910971878771$var$isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, $jqVis.URL_QUERY_PARAM_INTERACTION_SESSION);
};
class $a9e9910971878771$export$2e2bcd8739ae039 {
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
   * Validates the cross product interaction session parameters parsed from the URL (if present)
   * If the Base64-encoded URL does not decode into a valid JSON object
   *
   * This method must be called out of the constructor, as the sendEventCallback we expect here
   * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
   */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: 'corrupted',
            actionSubject: 'interactionSession',
            attributes: {
                url: this.urlValidation.url
            },
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
    constructor(options){
        this.analyticsCrossProductInteractionClient = void 0;
        this.isEnabled = void 0;
        this.urlValidation = void 0;
        this.sendEventCallback = void 0;
        this.validProduct = false;
        this.isEnabled = options.perimeter !== (0, $juSGQ.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $gAfN8.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, $3KzJL.default)($a9e9910971878771$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, $jqVis.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, $jqVis.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch  {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $8Fd9N.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
}

});
parcelRegister("8Fd9N", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f87cfe54d241056$export$2e2bcd8739ae039);

var $25T3r = parcelRequire("25T3r");

var $7FIrY = parcelRequire("7FIrY");

var $6oQI4 = parcelRequire("6oQI4");

var $2zaIp = parcelRequire("2zaIp");

var $jFsha = parcelRequire("jFsha");
const $9f87cfe54d241056$export$b9dd752fb13352ce = 'interactionSession.source';
const $9f87cfe54d241056$export$e04e3c50573f9af7 = 'interactionSession.bridge';
class $9f87cfe54d241056$export$2e2bcd8739ae039 {
    constructor(interactionSessionOptions, bridge, interactionSource){
        this.safeSessionStorage = void 0;
        this.interactionSessionTracking = void 0;
        this.isEnabled = void 0;
        this.getCurrentInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
        this.getPreviousInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
        this.getBridge = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($9f87cfe54d241056$export$e04e3c50573f9af7) : null;
        this.getInteractionSource = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($9f87cfe54d241056$export$b9dd752fb13352ce) : null;
        const shouldDisable = (0, $6oQI4.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $25T3r.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $7FIrY.isFedrampModerate)();
        this.isEnabled = !shouldDisable;
        if (this.isEnabled) {
            // Get singleton interaction session tracking instance
            this.interactionSessionTracking = (0, $2zaIp.default).getInstance();
            let isValidPersistedId = false;
            if (this.interactionSessionTracking) {
                if (interactionSessionOptions) {
                    this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                    isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
                }
            }
            this.safeSessionStorage = new (0, $jFsha.default)();
            // Store other interaction session parameters directly in session storage if ID has been validated
            if (isValidPersistedId) {
                bridge && this.safeSessionStorage.setItem($9f87cfe54d241056$export$e04e3c50573f9af7, bridge);
                interactionSource && this.safeSessionStorage.setItem($9f87cfe54d241056$export$b9dd752fb13352ce, interactionSource);
            }
        }
    }
}

});
parcelRegister("25T3r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $TOFPI = parcelRequire("TOFPI");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function() {
        return $TOFPI.isEnvironmentBlockEnabled;
    }
});
Object.defineProperty(module.exports, "isFeatureEnabled", {
    enumerable: true,
    get: function() {
        return $TOFPI.isFeatureEnabled;
    }
});

});
parcelRegister("TOFPI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAuditState = module.exports.configureAuditState = module.exports.shouldEnableForAudit = module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $7FIrY = parcelRequire("7FIrY");
var $deE7Q = parcelRequire("deE7Q");

var $5QPx4 = parcelRequire("5QPx4");

var $9xc8p = parcelRequire("9xc8p");

var $bCHTv = parcelRequire("bCHTv");
const $0a7c71ea67aff66e$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX = "aem-audit";
function $0a7c71ea67aff66e$var$isEnvironmentBlockEnabled(environmentBlockName) {
    const boundaryKey = $0a7c71ea67aff66e$var$getBoundaryKey();
    return (0, $5QPx4.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabled = $0a7c71ea67aff66e$var$isEnvironmentBlockEnabled;
function $0a7c71ea67aff66e$var$isFeatureEnabled(environmentBlockName, featureName, offeringPredicates) {
    const override = (0, $9xc8p.getFeatureOverride)(environmentBlockName, featureName);
    if (override !== null) return override;
    const boundaryKey = $0a7c71ea67aff66e$var$getBoundaryKey();
    const aemResult = (0, $5QPx4.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
    if (!aemResult) {
        if ((0, $bCHTv.isSSR)()) return false; // SSR: fallback to standard AEM resolution
        const metadata = (0, $5QPx4.getFeatureAvailabilityMetadataForBoundary)(environmentBlockName, featureName, boundaryKey);
        if (metadata && metadata.auditPhase) return $0a7c71ea67aff66e$var$shouldEnableForAudit(metadata.auditPhase, environmentBlockName, featureName);
        return false; // fallback to default behavior when not in audit state
    }
    const predicate = offeringPredicates ? offeringPredicates[boundaryKey] : undefined;
    return predicate ? predicate() : true;
}
module.exports.isFeatureEnabled = $0a7c71ea67aff66e$var$isFeatureEnabled;
/**
 * Determines whether a feature that is not enabled via standard AEM resolution
 * should be enabled due to an active audit phase.
 *
 * This function should only be called for excluded features in browser contexts that have an active
 * audit phase. It applies the following rules:
 *
 * | Phase            | Environment | localStorage key set? | Result  |
 * | ---------------- | ----------- | --------------------- | ------- |
 * | internal-audit   | non-prod    | any                   | true    |
 * | internal-audit   | prod        | any                   | false   |
 * | external-audit   | non-prod    | any                   | true    |
 * | external-audit   | prod        | yes ("true")          | true    |
 * | external-audit   | prod        | no                    | false   |
 *
 * In SSR contexts (no window/localStorage), this falls back to false
 * for any case that would require a localStorage check.
 */ function $0a7c71ea67aff66e$var$shouldEnableForAudit(auditPhase, environmentBlockName, featureName) {
    const envType = (0, $bCHTv.getEnvironmentType)();
    if (envType === "non-prod") return true;
    if (auditPhase === $5QPx4.UnderAuditPhase.EXTERNAL_AUDIT && !(0, $bCHTv.isSSR)() && localStorage.getItem(`${$0a7c71ea67aff66e$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`) === "true") return true;
    return false;
}
module.exports.shouldEnableForAudit = $0a7c71ea67aff66e$var$shouldEnableForAudit;
function $0a7c71ea67aff66e$var$getBoundaryKey() {
    if ((0, $7FIrY.isFedrampModerate)()) return $5QPx4.FED_MOD_KEY;
    if ((0, $deE7Q.isIsolatedCloud)()) return $5QPx4.ISOLATED_CLOUD_COMMERCIAL_KEY;
    return $5QPx4.COMMERCIAL_KEY;
}
function $0a7c71ea67aff66e$var$configureAuditState(environmentBlockName, featureName, value) {
    localStorage.setItem(`${$0a7c71ea67aff66e$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`, value);
}
module.exports.configureAuditState = $0a7c71ea67aff66e$var$configureAuditState;
function $0a7c71ea67aff66e$var$clearAuditState(environmentBlockName, featureName) {
    localStorage.removeItem(`${$0a7c71ea67aff66e$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`);
}
module.exports.clearAuditState = $0a7c71ea67aff66e$var$clearAuditState;
// Register global API on window for browser dev tools usage
if (typeof window !== "undefined") window.__AEM_FEATURE_JS__ = {
    checkFeature: $0a7c71ea67aff66e$var$isFeatureEnabled,
    overrideFeature: $9xc8p.overrideFeature,
    clearFeatureOverride: $9xc8p.clearFeatureOverride,
    clearAllOverrides: $9xc8p.clearAllOverrides,
    configureAuditState: $0a7c71ea67aff66e$var$configureAuditState,
    clearAuditState: $0a7c71ea67aff66e$var$clearAuditState
};

});
parcelRegister("5QPx4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

var $ia0kN = parcelRequire("ia0kN");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $ia0kN.isEnvironmentBlockEnabledForBoundary;
    }
});

var $ia0kN = parcelRequire("ia0kN");
Object.defineProperty(module.exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $ia0kN.isFeatureEnabledForBoundary;
    }
});

var $ia0kN = parcelRequire("ia0kN");
Object.defineProperty(module.exports, "getFeatureAvailabilityMetadataForBoundary", {
    enumerable: true,
    get: function() {
        return $ia0kN.getFeatureAvailabilityMetadataForBoundary;
    }
});

var $3MXkL = parcelRequire("3MXkL");
Object.defineProperty(module.exports, "BOUNDARY_KEYS_LIST", {
    enumerable: true,
    get: function() {
        return $3MXkL.BOUNDARY_KEYS_LIST;
    }
});
Object.defineProperty(module.exports, "UnderAuditPhase", {
    enumerable: true,
    get: function() {
        return $3MXkL.UnderAuditPhase;
    }
});
Object.defineProperty(module.exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $3MXkL.COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function() {
        return $3MXkL.FED_MOD_KEY;
    }
});
Object.defineProperty(module.exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $3MXkL.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});

});
parcelRegister("ia0kN", function(module, exports) {
"use strict";
var $d3896b957efdc518$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

const $d3896b957efdc518$var$sdk_data_json_1 = $d3896b957efdc518$var$__importDefault((parcelRequire("02IPl")));
const $d3896b957efdc518$var$aemEnvironmentBlockData = $d3896b957efdc518$var$sdk_data_json_1.default;
// Build reverse map: offeringId -> offeringShortKeyId, derived from compositionKeyMap (offeringShortKeyId -> offeringId)
const $d3896b957efdc518$var$offeringToOfferingShortKeyId = Object.fromEntries(Object.entries($d3896b957efdc518$var$aemEnvironmentBlockData.compositionKeyMap).map(([offeringShortKeyId, offeringId])=>[
        offeringId,
        offeringShortKeyId
    ]));
/**
 * Translates a full offering ID (BoundaryKey) to its short SDK key name.
 * Falls back to the original key if no mapping exists.
 */ function $d3896b957efdc518$var$toofferingShortKeyId(boundaryKey) {
    const mapped = $d3896b957efdc518$var$offeringToOfferingShortKeyId[boundaryKey];
    return mapped !== undefined && mapped !== null ? mapped : boundaryKey;
}
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function $d3896b957efdc518$var$isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return $d3896b957efdc518$var$environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabledForBoundary = $d3896b957efdc518$var$isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function $d3896b957efdc518$var$isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if ($d3896b957efdc518$var$environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        const environmentBlockData = $d3896b957efdc518$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        const feature = environmentBlockData.features[featureName];
        if (!feature) return false;
        return feature.compositions[$d3896b957efdc518$var$toofferingShortKeyId(boundaryKey)] === true;
    }
    return false;
}
module.exports.isFeatureEnabledForBoundary = $d3896b957efdc518$var$isFeatureEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns the availability metadata for the feature in the given boundary, or undefined if none
 */ function $d3896b957efdc518$var$getFeatureAvailabilityMetadataForBoundary(environmentBlockName, featureName, boundaryKey) {
    const block = $d3896b957efdc518$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return undefined;
    const feature = block.features[featureName];
    if (!feature) return undefined;
    return feature.availabilityMetadata && feature.availabilityMetadata[$d3896b957efdc518$var$toofferingShortKeyId(boundaryKey)];
}
module.exports.getFeatureAvailabilityMetadataForBoundary = $d3896b957efdc518$var$getFeatureAvailabilityMetadataForBoundary;
function $d3896b957efdc518$var$environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    const block = $d3896b957efdc518$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return false;
    return block.compositions[$d3896b957efdc518$var$toofferingShortKeyId(boundaryKey)] === true;
}

});
parcelRegister("02IPl", function(module, exports) {
module.exports = JSON.parse("{\"compositionKeyMap\":{\"cc\":\"commercial-cloud\",\"ic\":\"isolated-cloud-commercial\",\"fm\":\"fedramp-moderate\"},\"environmentBlocks\":{\"adminhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"admin-hub-threat-detection-system-for-custom-domains\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-access-requests\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-beta-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-collections-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-discover-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-enterprise-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-add-app-standalone-apps-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-product\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-admin-insights\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-ai-enabled-apps\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-api-token-controls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-app-requests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-app-updates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-apps-discovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-audit-log\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-authentication-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-automations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-backup-and-restore\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-billing-console\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-billing-preview\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-byok\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-cart\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-cmk-encryption\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-code-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-connected-emoji\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-connected-sources\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-connector-protection\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-contacts\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-custom-domain-email-notification\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-custom-domains\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-classifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-residency\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-security-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-data-transfer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-delta-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-disaster-recovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-discover-apps-shadow-it\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-discover-new-products\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-enable-user-merge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-encryption\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-environments\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-experiment-controls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-external-user-security\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-footprint\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-freeze-windows\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-alerts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-detections\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-help\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-hippa-compliance\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-jsm-scim\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-link-bitbucket\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-llm\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-login-customisation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-managed-accounts-export\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-marketplace-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-mcp-settings\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-mobile-app-policy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-nested-side-navigation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-org-audit-logs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-org-create\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-org-deletion\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-org-transfer\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-performance-monitoring\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-platform-usage\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-insights-workflow-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-insights\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-product-recommendation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-product-urls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-release-tracks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-revamped-organization-overview\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-rovo-access\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-rovo-chat-protection\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-insights\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-rovo-mcp-server\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-settings\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-saml-sso\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-sandbox\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-security-checklist\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-sensitive-data-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-signup\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-site-rename\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-site-transfer\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-system-health\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-team-site-assignment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-teams\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-teamwork-graph-cli\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-units\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-use-available-apps\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-access-invites\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-user-access-settings\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-connected-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-counts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-last-active-timestamp\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-workspaces-table-plans\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"core-adminhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"assets\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"assets-data-manager\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"assets-recent-items\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"assets-reports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"assets-rovo-search\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"core-assets\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"atlassian-analytics-3p-data-source-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-dashboard-pdf-png-exports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-templates\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-charts\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-comments\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-commerce-sentry\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-cross-product-interaction-client\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-dashboard-subscriptions\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboard-templates\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-lake-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-shares\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-jira-align-enterprise-insights-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"core-atlassian-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"bitbucket\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"bitbucket-development-events-and-status\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-merge-queue\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-slack-app\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-ssh-key-validation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"pipelines\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"chat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"compass\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"confluence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"ccma\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-anonymous-access\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-comment-and-header-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-company-hub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-content-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-content-manager\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-databases\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"internal-audit\"}}},\"confluence-editing-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-edition-awareness\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-editor-offline-storage\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-embedded-pages\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-employee-directory\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-forge-apps-sidebar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-inline-comments-in-edit-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-inspect-permissions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-invitations\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-loom-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-mission-control\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-mobile-app\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-page-analytics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-pages-blogs-folders\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-premium-onboarding\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-presenter-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-public-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-questions-native-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-questions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-recap\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-server\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-share-to-slack-button\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-single-space-guests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-slack-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-slides\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-smart-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-space-analytics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-team-calendars\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-update-page-owners\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-whiteboards\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"internal-audit\"}}},\"core-confluence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-service-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"dx\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"feedback\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"focus\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"asks-and-planning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"goals\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"guard-premium\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"home\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"home-org-chart-analytics-pipeline\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-status-backend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"jira\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-jira\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"issue-transition-customisation-for-srb\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jcma-x2c\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jcma\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-admin-oauth-credentials\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-ai-issue-classification\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-ai-snippet\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-ai-upsell-in-editor-free\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-apps-menu\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-atlassian-vs-code-extension\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-audit-log\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-backlogs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-boards-and-views\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-calendar-view\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-company-managed-projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-components\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-dashboard-public-sharing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-demux\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-development-hub\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab-druid-metric-cards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-devinfo-async-pull-request-icon\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-devops-toolchain\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-edition-awareness\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-figma-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-forms\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-github-for-jira\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-github-workflows\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-goals-nav\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-import-work-sidebar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-in-product-help\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-insights\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-invite-people\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-issue\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-jpd-nav-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-jpd-roadmap-on-timeline-cross-sell\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-loom-banner\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-marketplace-sidebar-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-mobile-app\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-next-best-task\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-oasis-reports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-opsgenie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-plans\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-issue-navigator\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-theme-unsplash\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-quickstart-pages\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-releases\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-roadmap-in-nav\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-share\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-site-optimiser\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-slack\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-smart-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-smart-related-issues\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-devops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-cycle-time\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-deployment-frequency\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-spreadsheets-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-synced-blocks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-team-managed-projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-unsplash\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-whiteboards-backlog-experiment\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-work-item-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-work-suggestions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-workflow-configuration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-your-work-dashboard\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"modern-issue-transition-connect-app-fields\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"jira-align\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-product-discovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-jira-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-service-management-help-center\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-ai-ops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-ai-services\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-alert-notifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-approvals\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-assets-vertical\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-automation-playbook\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-boysenberry\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-canned-responses\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-change-ai-risk-assessment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-calendar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management-deployment-vendors\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-change-risk-assessment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-change-risk-reporter-configuration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-chat-ops-ic-custom-apps\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"jsm-chat-ops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-chat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-cloud-megatron\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-csat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-csm-functionality\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-customer-access-internal-account\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-customer-notifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-customer-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-gating\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-tracking\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-developer-escalations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-email-requests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-embeddable-widget\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-entity-migration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-err-governance-api\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-accounts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-single-sign-on\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-user-provisioning\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-forms\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-halp-admin-panel\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-help-center-change-password\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-password-login\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-help-center-rovo-agent\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-virtual-agent\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-incident-conference-calls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-incident-management-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-issue\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-journey-builder\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-knowledge-base\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-multi-language-support\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-on-call-schedule\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-ops-genie-reporting\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-opsgenie-conference-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-opsgenie-devops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-portal-only-account-scim\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-post-incident-reviews\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-queues\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-related-issues\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-reports-operations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-request-intake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-shield\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-sla-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-status-page-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-surveys\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-templates-and-views\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-virtual-service-agent\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-workforce\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"loom\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"loom-ai-evaluation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"rovo\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"rovo-ai-app-availability\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-atlassian-intelligence-app-availability\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-generative-ai-editor\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-machine-learning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-natural-language-in-automation-rule-creation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-projects\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-smart-features-based-on-machine-learning-tecton-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-editor-ai-panels\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"rovo-dev\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"rovo-dev-agents\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-dev-code-assist\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"statuspage\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"studio\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"talent\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"teams\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"teams-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"teams-profile-media-token-fetch\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"teams-third-party-invites\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"user-provided-banners-on-profile-pictures\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"trello\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"trello-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"core-anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"atlassian-cli\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-new-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-visualization-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"atlassian-visualization-platform-kamino\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-manifold\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-rovo-skills\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"central-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"ai-3p-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-managed-objects\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-safety\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"collaboration-graph\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"gen-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"knowledge-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"knowledge-discovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"machine-learning-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"commerce-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"commerce-platform-self-serve\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-commerce-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-customer-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-support-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"ecosystem-forge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-ecosystem-forge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"dac-get-help-widget\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"developer-atlassian-community\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"docs-atlassian-com\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ecosystem-oauth\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"expression-playground\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"forge-cli\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"forge-remote-capabilities\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-storage-service-rockmelon\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"forge-system-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-ui-ic-cdn-auth\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}}}},\"editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"block-service\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"real-time-presence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"experience-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"core-experience-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"gasv3\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-gasv3\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"growth-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"bxp-signup\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-growth-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"identity\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-identity\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-mail-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-virality\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"learning-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"marketplace\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"marketplace-app-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-app-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-atlassian-labs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-audit-logs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"marketplace-self-service-purchase-provision-install\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"agc-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"commercial-cloud-to-agc\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"data-center-to-agc\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"migration-link-fixing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"migrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"brie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-migrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"data-center-to-cloud-migration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"media-migration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"navigation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-navigation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"navigation-home-entry-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"navigation-identity-ic-routing\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"navigation-switcher-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"navigation-switcher-rovo-scas-visibility\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"notifications-fpn-link\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"post-office\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-post-office\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"product-integrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-product-integrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"external-user-directory-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"google-workspace-apps-integrations\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"sign-in-with-slack-usage-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"search-townsquare-tab\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"smartlinks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-smartlinks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"user-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"user-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-platform-deployer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"automation-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"automation-platform-actions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-automation-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-branches\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-conditions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-event-processing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-frontend\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"automation-platform-natural-language-rule-builder\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-rule-builder\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-triggers\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"core-automation-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"bifrost\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-bifrost\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"build-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"cell-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"cloud-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"cloud-security\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"compliance-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"consent-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"consenthub\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"core-network-automation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-core-network-automation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"core-network-automation-cna-theia\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-core-network-automation-cna-theia\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"core-network-automation-l2\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-core-network-automation-l2\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"cross-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-cross-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-data-lake-layer2\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"data-access-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-access-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-classification-governance-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-classification-governance-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-depot-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-depot-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-exchange-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"aqui\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"eureka\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"kamino\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"shipyard\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"topic-osb\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-exchange-platform-l3\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-exchange-platform-l3\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"ers-import\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"ers\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"sql\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-platform-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-platform-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-store-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-store-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"core-data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"decisions-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-decisions-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"experimentation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"detection-and-response-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"disaster-recovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"edge-cloudfront\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"encryption-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cryptor\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"environment-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"flight-deck-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"golden-ami\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"incident-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"internal-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"airlock-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"internal-edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-internal-edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"internal-edge-httpbin\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-internal-edge-httpbin\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"job-execution-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-job-execution-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"kitt-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"kitt-fleet\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"media-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-media-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"media-cdn-delivery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"messaging-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"micros-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"network-fabric\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-network-fabric\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"observability-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"sentry-opsgenie-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"tracing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"pollinator\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-pollinator\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"pollinator-l2\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-pollinator-l2\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"provisioning\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-provisioning\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"resiliency-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"secrets\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"security-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"service-to-service-fabric\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"slauth-auth-slack-notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"sliver\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"staff-authentication-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"streamhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-streamhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"targeting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-targeting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"flock\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"tenant-catalogue-service-record\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-catalogue-service-record\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"tenant-context\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-context\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"tenant-lifecycle\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"tenant-passivation-removal\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"vdi\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"workplace-technology-solutions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}}}}");

});


parcelRegister("3MXkL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
module.exports.COMMERCIAL_KEY = "commercial-cloud";
module.exports.FED_MOD_KEY = "fedramp-moderate";
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-cloud-commercial";
module.exports.BOUNDARY_KEYS_LIST = [
    module.exports.COMMERCIAL_KEY,
    module.exports.FED_MOD_KEY,
    module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY
];
var $2c23e143f0e83123$var$UnderAuditPhase;
(function(UnderAuditPhase) {
    UnderAuditPhase["INTERNAL_AUDIT"] = "internal-audit";
    UnderAuditPhase["EXTERNAL_AUDIT"] = "external-audit";
})($2c23e143f0e83123$var$UnderAuditPhase || (module.exports.UnderAuditPhase = $2c23e143f0e83123$var$UnderAuditPhase = {}));

});


parcelRegister("9xc8p", function(module, exports) {
"use strict";
/**
 * Manages feature overrides stored in browser localStorage.
 * No-ops when not in a browser context.
 *
 * localStorage key: "AEM_FEATURE_OVERRIDES"
 * localStorage value: JSON-encoded string mapping "{environmentBlockName}::{featureName}" to boolean
 *
 * Example:
 *   "AEM_FEATURE_OVERRIDES": "{\"confluence::my_feature\":true,\"jira::other_feature\":false}"
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllOverrides = module.exports.clearFeatureOverride = module.exports.overrideFeature = module.exports.getFeatureOverride = module.exports.STORAGE_KEY = void 0;
module.exports.STORAGE_KEY = "AEM_FEATURE_OVERRIDES";
function $6f109bceb936d316$var$buildKey(environmentBlockName, featureName) {
    return `${environmentBlockName}::${featureName}`;
}
function $6f109bceb936d316$var$isBrowserEnvironment() {
    return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}
function $6f109bceb936d316$var$getOverridesMap() {
    const featureOverrideValue = window.localStorage.getItem(module.exports.STORAGE_KEY);
    if (featureOverrideValue) try {
        return JSON.parse(featureOverrideValue);
    } catch (e) {
        console.warn("Failed to parse AEM_FEATURE_OVERRIDES from localStorage", e);
    }
    return {};
}
function $6f109bceb936d316$var$setOverridesMap(map) {
    window.localStorage.setItem(module.exports.STORAGE_KEY, JSON.stringify(map));
}
/**
 * Returns the override value for a feature if one exists, or null if no override is set.
 * Returns null in non-browser environments.
 */ function $6f109bceb936d316$var$getFeatureOverride(environmentBlockName, featureName) {
    if (!$6f109bceb936d316$var$isBrowserEnvironment()) return null;
    const map = $6f109bceb936d316$var$getOverridesMap();
    const key = $6f109bceb936d316$var$buildKey(environmentBlockName, featureName);
    if (key in map) return map[key];
    return null;
}
module.exports.getFeatureOverride = $6f109bceb936d316$var$getFeatureOverride;
/**
 * Sets a feature override in localStorage.
 */ function $6f109bceb936d316$var$overrideFeature(environmentBlockName, featureName, value) {
    if (!$6f109bceb936d316$var$isBrowserEnvironment()) return;
    const map = $6f109bceb936d316$var$getOverridesMap();
    map[$6f109bceb936d316$var$buildKey(environmentBlockName, featureName)] = value;
    $6f109bceb936d316$var$setOverridesMap(map);
}
module.exports.overrideFeature = $6f109bceb936d316$var$overrideFeature;
/**
 * Removes a single feature override from localStorage. Removes the key entirely if no overrides are left.
 */ function $6f109bceb936d316$var$clearFeatureOverride(environmentBlockName, featureName) {
    if (!$6f109bceb936d316$var$isBrowserEnvironment()) return;
    const map = $6f109bceb936d316$var$getOverridesMap();
    delete map[$6f109bceb936d316$var$buildKey(environmentBlockName, featureName)];
    if (Object.keys(map).length === 0) window.localStorage.removeItem(module.exports.STORAGE_KEY);
    else $6f109bceb936d316$var$setOverridesMap(map);
}
module.exports.clearFeatureOverride = $6f109bceb936d316$var$clearFeatureOverride;
/**
 * Clears all feature overrides from localStorage.
 */ function $6f109bceb936d316$var$clearAllOverrides() {
    if (!$6f109bceb936d316$var$isBrowserEnvironment()) return;
    window.localStorage.removeItem(module.exports.STORAGE_KEY);
}
module.exports.clearAllOverrides = $6f109bceb936d316$var$clearAllOverrides;

});

parcelRegister("bCHTv", function(module, exports) {

var $2M83v = parcelRequire("2M83v");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEnvironmentType = module.exports.isSSR = void 0;
/** Returns true when running in a server-side rendering context (no browser window). */ function $87654acf91da91b3$var$isSSR() {
    return typeof window === "undefined" || typeof document === "undefined" || Boolean(typeof $2M83v !== "undefined" && $2M83v && $2M83v.env && undefined); // see https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/7377575ff0ec8a6f78257788b224e37c2bae8f66/platform/packages/editor/editor-common/src/core-utils/is-ssr.ts#lines-6
}
module.exports.isSSR = $87654acf91da91b3$var$isSSR;
/**
 * Returns the current environment type.
 * Defaults to "prod" in unknown cases.
 *
 * In SSR contexts, reads from globalThis.ssrContext.environmentType.
 * In browser contexts, infers from window.location.hostname.
 */ function $87654acf91da91b3$var$getEnvironmentType() {
    // 1. SSR: Use ssrContext if available
    if (typeof window === "undefined") {
        // @ts-expect-error — ssrContext in globalThis type
        const ssrContext = globalThis.ssrContext;
        if (ssrContext && ssrContext.environmentType) {
            const type = ssrContext.environmentType;
            if (type === "dev") return "non-prod";
            if (type === "staging") return "non-prod";
            if (type === "prod") return "prod";
        }
        return "prod";
    }
    // 2. Browser: Use hostname-based detection with all patterns
    const host = window.location.hostname.toLowerCase();
    if (!host) // default to prod if no location available
    return "prod";
    // Exact matches
    if (host === "localhost" || host === "127.0.0.1") return "non-prod";
    // Staging patterns
    if (host.endsWith(".jira-dev.com") || host.includes(".stg.") || host.includes(".staging.")) return "non-prod";
    // Development patterns
    if (host.includes(".dev.") || host.includes(".ddev.")) return "non-prod";
    if (host.endsWith(".atlassian.net") || host.endsWith(".atlassian-us-gov-mod.com") || host.endsWith(".atlassian.com")) return "prod";
    return "prod";
}
module.exports.getEnvironmentType = $87654acf91da91b3$var$getEnvironmentType;

});



parcelRegister("6oQI4", function(module, exports) {
$parcel$export(module.exports, "fg", () => $13646f6151759b62$export$b40ec24ac8275656);

var $6gKT9 = parcelRequire("6gKT9");
function $13646f6151759b62$export$b40ec24ac8275656(name) {
    return (0, $6gKT9.resolveBooleanFlag)(name);
}

});
parcelRegister("6gKT9", function(module, exports) {
$parcel$export(module.exports, "resolveBooleanFlag", () => $c39190ab366cb9d6$export$6333b6aff9fc6275);

var $3ihMw = parcelRequire("3ihMw");

var $7tgXC = parcelRequire("7tgXC");

var $ezo7d = parcelRequire("ezo7d");

var $9dUA6 = parcelRequire("9dUA6");

var $b2g2S = parcelRequire("b2g2S");

var $2IOnA = parcelRequire("2IOnA");
const $c39190ab366cb9d6$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $ezo7d.ENV_ENABLE_PLATFORM_FF) || (0, $9dUA6.ENV_STORYBOOK_ENABLE_PLATFORM_FF);
function $c39190ab366cb9d6$export$6333b6aff9fc6275(flagKey) {
    if ($c39190ab366cb9d6$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $7tgXC.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $2IOnA.pkgName), flagKey);
        return true;
    }
    try {
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if ((0, $b2g2S.globalVar)[0, $2IOnA.PFF_GLOBAL_KEY]?.booleanResolver === undefined || (0, $b2g2S.globalVar)[0, $2IOnA.PFF_GLOBAL_KEY]?.booleanResolver === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $3ihMw.default).checkGate(flagKey);
        const result = (0, $b2g2S.globalVar)[0, $2IOnA.PFF_GLOBAL_KEY]?.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("3ihMw", function(module, exports) {
$parcel$export(module.exports, "default", () => $a85bd94626da4562$export$2e2bcd8739ae039);

var $2H8GS = parcelRequire("2H8GS");

var $c6EKY = parcelRequire("c6EKY");



var $a85bd94626da4562$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $a85bd94626da4562$var$FeatureGates {
    static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
}
$a85bd94626da4562$var$_FeatureGates = $a85bd94626da4562$var$FeatureGates;
$a85bd94626da4562$var$FeatureGates.client = new (0, $2H8GS.Client)();
$a85bd94626da4562$var$FeatureGates.hasCheckGateErrorOccurred = false;
$a85bd94626da4562$var$FeatureGates.hasGetExperimentValueErrorOccurred = false;
$a85bd94626da4562$var$FeatureGates.checkGate = (gateName, options)=>{
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$a85bd94626da4562$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $a85bd94626da4562$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $a85bd94626da4562$var$_FeatureGates.client.checkGate(gateName, options);
};
$a85bd94626da4562$var$FeatureGates.getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$a85bd94626da4562$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $a85bd94626da4562$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $a85bd94626da4562$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
};
$a85bd94626da4562$var$FeatureGates.initializeCalled = $a85bd94626da4562$var$_FeatureGates.client.initializeCalled.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.initializeCompleted = $a85bd94626da4562$var$_FeatureGates.client.initializeCompleted.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.waitUntilInitializeCompleted = $a85bd94626da4562$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.initialize = $a85bd94626da4562$var$_FeatureGates.client.initialize.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.initializeWithProvider = $a85bd94626da4562$var$_FeatureGates.client.initializeWithProvider.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.initializeFromValues = $a85bd94626da4562$var$_FeatureGates.client.initializeFromValues.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.manuallyLogGateExposure = $a85bd94626da4562$var$_FeatureGates.client.manuallyLogGateExposure.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.getExperiment = $a85bd94626da4562$var$_FeatureGates.client.getExperiment.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.manuallyLogExperimentExposure = $a85bd94626da4562$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.manuallyLogLayerExposure = $a85bd94626da4562$var$_FeatureGates.client.manuallyLogLayerExposure.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.shutdownStatsig = $a85bd94626da4562$var$_FeatureGates.client.shutdownStatsig.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.overrideGate = $a85bd94626da4562$var$_FeatureGates.client.overrideGate.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.clearGateOverride = $a85bd94626da4562$var$_FeatureGates.client.clearGateOverride.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.overrideConfig = $a85bd94626da4562$var$_FeatureGates.client.overrideConfig.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.clearConfigOverride = $a85bd94626da4562$var$_FeatureGates.client.clearConfigOverride.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.setOverrides = $a85bd94626da4562$var$_FeatureGates.client.setOverrides.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.getOverrides = $a85bd94626da4562$var$_FeatureGates.client.getOverrides.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.clearAllOverrides = $a85bd94626da4562$var$_FeatureGates.client.clearAllOverrides.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.isCurrentUser = $a85bd94626da4562$var$_FeatureGates.client.isCurrentUser.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.onGateUpdated = $a85bd94626da4562$var$_FeatureGates.client.onGateUpdated.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.onExperimentValueUpdated = $a85bd94626da4562$var$_FeatureGates.client.onExperimentValueUpdated.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.onAnyUpdated = $a85bd94626da4562$var$_FeatureGates.client.onAnyUpdated.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.updateUser = $a85bd94626da4562$var$_FeatureGates.client.updateUser.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.updateUserWithProvider = $a85bd94626da4562$var$_FeatureGates.client.updateUserWithProvider.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.updateUserWithValues = $a85bd94626da4562$var$_FeatureGates.client.updateUserWithValues.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.getPackageVersion = $a85bd94626da4562$var$_FeatureGates.client.getPackageVersion.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.getTargetApp = $a85bd94626da4562$var$_FeatureGates.client.getTargetApp.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.getLayer = $a85bd94626da4562$var$_FeatureGates.client.getLayer.bind($a85bd94626da4562$var$_FeatureGates.client);
$a85bd94626da4562$var$FeatureGates.getLayerValue = $a85bd94626da4562$var$_FeatureGates.client.getLayerValue.bind($a85bd94626da4562$var$_FeatureGates.client);
let $a85bd94626da4562$var$boundFGJS = $a85bd94626da4562$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $a85bd94626da4562$var$FeatureGates;
    else {
        $a85bd94626da4562$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = $a85bd94626da4562$var$boundFGJS?.getPackageVersion?.() || '4.10.0 or earlier';
        if (boundVersion !== (0, $c6EKY.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $c6EKY.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $a85bd94626da4562$export$2e2bcd8739ae039 = $a85bd94626da4562$var$boundFGJS;

});
parcelRegister("2H8GS", function(module, exports) {
$parcel$export(module.exports, "Client", () => $2e67a931e60e537b$export$1f2bb630327ac4b6);

var $60WtX = parcelRequire("60WtX");

var $fiNMp = parcelRequire("fiNMp");

var $Qdnig = parcelRequire("Qdnig");

var $lIQDR = parcelRequire("lIQDR");

var $51gLi = parcelRequire("51gLi");

var $bhQZl = parcelRequire("bhQZl");

var $gRZcq = parcelRequire("gRZcq");

var $eXX32 = parcelRequire("eXX32");

var $280qg = parcelRequire("280qg");

var $3U8Dd = parcelRequire("3U8Dd");

var $0UFqB = parcelRequire("0UFqB");

var $gelW8 = parcelRequire("gelW8");

var $ft6hZ = parcelRequire("ft6hZ");

var $69kmA = parcelRequire("69kmA");

var $c6EKY = parcelRequire("c6EKY");
const $2e67a931e60e537b$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $2e67a931e60e537b$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
class $2e67a931e60e537b$export$1f2bb630327ac4b6 {
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $eXX32.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $gelW8.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
   * @description
   * This method initializes the client using the provider given to call to fetch the bootstrap values.
   * If the client is initialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param provider {Provider}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $eXX32.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $gelW8.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, $c6EKY.CLIENT_VERSION));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if (this.initCompleted || this.initWithDefaults) {
                this.assertInitialized(this.statsigClient);
                this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                this.statsigValuesUpdated();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        this.initOptions.analyticsWebClient?.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: this.initOptions.targetApp,
                clientVersion: (0, $c6EKY.CLIENT_VERSION),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if (this.initOptions.environment !== (0, $69kmA.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const clientOptionsWithDefaults = (0, $eXX32.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $gelW8.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
   * This method updates the user using a network call to fetch the new set of values.
   * @param fetchOptions {FetcherOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        const fetchOptionsWithDefaults = (0, $eXX32.getOptionsWithDefaults)(fetchOptions);
        const initializeValuesProducer = ()=>(0, $gRZcq.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
   * This method updates the user using the provider given on initialisation to get the new set of
   * values.
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
   * This method updates the user given a new set of bootstrap values obtained from one of the
   * server-side SDKs.
   *
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @param initializeValues {Record<string,unknown>}
   */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        this.assertInitialized(this.statsigClient);
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    async waitUntilInitializeCompleted() {
        if (!this.initPromise) throw new Error('The client must be initialized before you can wait until initialized.');
        if (this.initCompleted) return;
        await this.initPromise;
    }
    /**
   * Returns the value for a feature gate. Returns false if there are errors.
   * @param {string} gateName - The name of the feature gate.
   * @param {Object} options
   * @param {boolean} options.fireGateExposure
   *        Whether or not to fire the exposure event for the gate. Defaults to true.
   *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
   *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   */ checkGate(gateName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireGateExposure: fireGateExposure = true } = options;
            return this.statsigClient.checkGate(gateName, {
                disableExposureLog: !fireGateExposure
            });
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    isGateExist(gateName) {
        try {
            this.assertInitialized(this.statsigClient);
            const gate = this.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    isExperimentExist(experimentName) {
        try {
            this.assertInitialized(this.statsigClient);
            const config = this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
   * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
   * <code>options.fireGateExposure</code> is false.
   * @param gateName
   */ manuallyLogGateExposure(gateName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.checkGate(gateName);
    }
    /**
   * Returns the entire config for a given experiment.
   *
   * @param {string} experimentName - The name of the experiment
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns The config for an experiment
   * @example
   * ```ts
   * const experimentConfig = client.getExperiment('example-experiment-name');
   * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
   * ```
   */ getExperiment(experimentName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            return (0, $Qdnig.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: !fireExperimentExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $Qdnig.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $51gLi.EvaluationReason).Error
            });
        }
    }
    /**
   * Returns the value of a given parameter in an experiment config.
   *
   * @template T
   * @param {string} experimentName - The name of the experiment
   * @param {string} parameterName - The name of the parameter to fetch from the experiment config
   * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
   * if the returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the
   * expected type. If this function returns false, then the default value will be returned
   * instead. This can be set to protect your code from unexpected values being set remotely. By
   * default, this will be done by asserting that the default value and value are the same primitive
   * type.
   * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
   * default value.
   * @example
   ``` ts
   type ValidColor = 'blue' | 'red' | 'yellow';
   type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
  	 const isValidColor: ValidColorTypeCheck =
  		(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
  	 const buttonColor: ValidColor = client.getExperimentValue(
  		'example-experiment-name',
  		'backgroundColor',
  		'yellow',
  		{
  				typeGuard: isValidColor
  		}
   );
   ```
  */ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
   * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
   * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
   * @param experimentName
   */ manuallyLogExperimentExposure(experimentName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getExperiment(experimentName);
    }
    /**
   * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
   * @param layerName
   * @param parameterName
   */ manuallyLogLayerExposure(layerName, parameterName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getLayer(layerName)?.get(parameterName);
    }
    shutdownStatsig() {
        this.assertInitialized(this.statsigClient);
        this.statsigClient.shutdown();
    }
    /**
   * Adds a new override for the given gate.
   *
   * This method is additive, meaning you can call it multiple times with different gate names to
   * build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearGateOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} gateName
   * @param {boolean} value
   */ overrideGate(gateName, value) {
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) this.statsigClient?.updateUserSync(this.user, {
            disableBackgroundCacheRefresh: true
        });
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given gate.
   */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
   * Adds a new override for the given config (or experiment).
   *
   * This method is additive, meaning you can call it multiple times with different experiment
   * names to build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearConfigOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} experimentName
   * @param {object} values
   */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given experiment.
   * @param {string} experimentName
   */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
   * Set overrides for gates, experiments and layers in batch.
   *
   * Note that these overrides are **not** additive and will completely replace any that have been
   * added via prior calls to {@link Client.overrideConfig} or
   * {@link Client.overrideGate}.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearAllOverrides} after your tests are completed to remove this
   * localStorage entry.
   */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
   * @returns The current overrides for gates, configs (including experiments) and layers.
   */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
   * Clears overrides for all gates, configs (including experiments) and layers.
   */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
   * Returns whether the given identifiers and customAttributes align with the current
   * set that is being used by the client.
   *
   * If this method returns false, then the {@link Client.updateUser},
   * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
   * methods can be used to re-align these values.
   *
   * @param identifiers
   * @param customAttributes
   * @returns a flag indicating whether the clients current configuration aligns with the given values
   */ isCurrentUser(identifiers, customAttributes) {
        return (0, $gelW8.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $gelW8.shallowEquals)(this.currentAttributes, customAttributes);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current checkGate value
   * @param gateName
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure: fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current experiment value
   * @param experimentName
   * @param parameterName
   * @param defaultValue
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
   * Subscribe so on any update the callback will be called.
   * NOTE: The callback will be called whenever the values are updated even if the values have not
   * changed.
   * @param callback
   * @returns off function to unsubscribe from updates
   */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
   * This method initializes the client using a network call to fetch the bootstrap values for the
   * given user.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @private
   */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions
        };
        if (clientOptions.localMode) {
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            return;
        }
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $gRZcq.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $gRZcq.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...baseClientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            await provider.setProfile(baseClientOptions, identifiers, customAttributes);
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = provider.getClientSdkKey().then((value)=>fromValuesClientOptions.sdkKey = value);
            const experimentValuesPromise = provider.getExperimentValues();
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
   * This method initializes the client using a set of boostrap values obtained from one of the
   * server-side SDKs.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @param initializeValues
   * @private
   */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        const newClientOptions = (0, $280qg.migrateInitializationOptions)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $2e67a931e60e537b$var$DEFAULT_CLIENT_KEY;
        if (!newClientOptions.networkConfig?.logEventUrl) newClientOptions.networkConfig = {
            ...newClientOptions.networkConfig,
            logEventUrl: $2e67a931e60e537b$var$DEFAULT_EVENT_LOGGING_API
        };
        if (newClientOptions.perimeter === (0, $69kmA.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey: sdkKey, environment: environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter, ...restClientOptions } = newClientOptions;
        const frontendUser = (0, $ft6hZ.toStatsigUser)(identifiers, customAttributes);
        this.user = (0, $bhQZl.deepAssign)({}, initializeValues.user, frontendUser);
        const statsigOptions = {
            ...restClientOptions,
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter,
            logEventCompressionMode: (0, $60WtX.LogEventCompressionMode).Forced
        };
        // Statsig validates the provided stableId against their own cookie, so we either need
        // to update the cookie to match, or disable the validation completely.
        if (identifiers.stableId) (0, $60WtX.StableID).setOverride(identifiers.stableId, sdkKey);
        else statsigOptions.disableStableID = true;
        try {
            this.statsigClient = new (0, $60WtX.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, $60WtX.StatsigClient)($2e67a931e60e537b$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
   * This method updates the user for this client with the bootstrap values returned from a given
   * Promise.
   * It uses the customAttributes from fetching experiment values to update the Statsig user but
   * uses the customAttributes from given input to check if the user has changed.
   *
   * @param {Identifiers} identifiers
   * @param {CustomAttributes} customAttributes
   * @param {Promise<InitializeValues>} getInitializeValues
   * @private
   */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            this.initPromise = originalInitPromise;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
   * This method updates the user on the nested Statsig client
   *
   * @param identifiers
   * @param customAttributes
   * @param initializeValuesPromise
   * @private
   */ async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            const frontendUser = (0, $ft6hZ.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
            user = (0, $bhQZl.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
        } catch (err) {
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            this.initOptions.updateUserCompletionCallback?.(false, errMsg);
            throw err;
        }
        let success = true;
        let errorMessage = null;
        try {
            this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
            this.user = user;
            if (this.user) await this.statsigClient.updateUserAsync(this.user);
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        this.initOptions?.updateUserCompletionCallback?.(success, errorMessage);
        if (success) {
            this.currentIdentifiers = identifiers;
            this.currentAttributes = customAttributes;
            this.subscriptions.anyUpdated();
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
   * @returns string version of the current package in semver style.
   */ getPackageVersion() {
        return 0, $c6EKY.CLIENT_VERSION;
    }
    /**
   * Returns the `targetApp` value that was provided during client initialization.
   * This identifies the product/app context (e.g., `'confluence_web'`, `'jira_web'`).
   *
   * Returns `undefined` if `initialize` has never been called.
   *
   * @returns The targetApp string, or undefined if initialize has never been called.
   */ getTargetApp() {
        return this.initOptions?.targetApp;
    }
    /**
   * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
   *
   * @param {string} layerName - The name of the layer
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns A layer
   * @example
   * ```ts
   * const layer = client.getLayer('example-layer-name');
   * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
   * ```
   */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireLayerExposure: fireLayerExposure = true } = options;
            return (0, $lIQDR.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $lIQDR.Layer).fromLayer((0, $60WtX._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
   * Returns the value of a given parameter in a layer config.
   *
   * @template T
   * @param {string} layerName - The name of the layer
   * @param {string} parameterName - The name of the parameter to fetch from the layer config
   * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
   * returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
   * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
   * @example
   * ``` ts
   * type ValidColor = 'blue' | 'red' | 'yellow';
   * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
   *
   * const isValidColor: ValidColorTypeCheck =
   *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
   *
   * const buttonColor: ValidColor = client.getLayerValue(
   *    'example-layer-name',
   *    'backgroundColor',
   *    'yellow',
   *    {
   *        typeGuard: isValidColor
   *    }
   * );
   * ```
   */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    constructor({ localStorageKey: localStorageKey = (0, $0UFqB.LOCAL_STORAGE_KEY), overrideAdapter: overrideAdapter } = {}){
        this.statsigClient = void 0;
        this.user = void 0;
        this.initOptions = void 0;
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ this.initWithDefaults = false;
        this.currentIdentifiers = void 0;
        this.currentAttributes = void 0;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.provider = void 0;
        this.subscriptions = new (0, $fiNMp.default)();
        this.dataAdapter = new (0, $3U8Dd.NoFetchDataAdapter)();
        this.overrideAdapter = void 0;
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ this.statsigValuesUpdated = ()=>{
            if (this.user) // Trigger a reset of the memoize cache
            this.statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
            this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = overrideAdapter || new (0, $0UFqB.PersistentOverrideAdapter)(localStorageKey);
    }
}

});
parcelRegister("60WtX", function(module, exports) {
"use strict";
var $46101b8080937f75$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $46101b8080937f75$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $46101b8080937f75$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $cymOT = parcelRequire("cymOT");
module.exports.StatsigClient = $cymOT.default;

$46101b8080937f75$var$__exportStar((parcelRequire("9jhip")), module.exports);
const $46101b8080937f75$var$__STATSIG__ = Object.assign((0, (parcelRequire("9jhip"))._getStatsigGlobal)(), {
    StatsigClient: $cymOT.default
});
module.exports.default = $46101b8080937f75$var$__STATSIG__;

});
parcelRegister("cymOT", function(module, exports) {
"use strict";
var $923a5c8d41325404$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9jhip = parcelRequire("9jhip");

var $2S0gW = parcelRequire("2S0gW");

var $1ad9i = parcelRequire("1ad9i");

var $bQg5i = parcelRequire("bQg5i");

var $7hatl = parcelRequire("7hatl");
class $923a5c8d41325404$var$StatsigClient extends $9jhip.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $9jhip._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $923a5c8d41325404$var$StatsigClient) return instance;
        $9jhip.Log.warn((0, $9jhip._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $923a5c8d41325404$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $9jhip.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $923a5c8d41325404$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $9jhip.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $9jhip.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $923a5c8d41325404$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $923a5c8d41325404$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $9jhip.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $9jhip.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $9jhip.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $9jhip.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($9jhip.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $9jhip.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $9jhip.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $9jhip.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = {};
        try {
            user = JSON.parse(JSON.stringify(this._user));
        } catch (_a) {
            $9jhip.Log.error('Failed to parse user');
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $9jhip.StatsigSession.get(this._sdkKey),
            stableID: $9jhip.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $923a5c8d41325404$var$__awaiter(this, void 0, void 0, function*() {
            if (!$9jhip.Storage.isReady()) yield $9jhip.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $9jhip.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $9jhip.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $9jhip._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$9jhip.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$9jhip.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $9jhip.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $9jhip._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $9jhip._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $9jhip._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $9jhip._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $9jhip._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $9jhip._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $9jhip._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $9jhip._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $9jhip._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $9jhip._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $bQg5i._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $bQg5i._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $9jhip.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $1ad9i.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $7hatl.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($9jhip.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($9jhip.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($9jhip.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($9jhip.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($9jhip.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($9jhip.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $2S0gW.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $9jhip.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
}
module.exports.default = $923a5c8d41325404$var$StatsigClient;

});
parcelRegister("2S0gW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9jhip = parcelRequire("9jhip");

var $9nVLu = parcelRequire("9nVLu");

var $as141 = parcelRequire("as141");
class $2170d5f5a537d343$var$EvaluationStore {
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $9jhip._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $9jhip._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $as141.V2InitializeContainer(values);
        else this._values = new $9nVLu.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $9jhip.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $9jhip.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $9jhip._getFullUserHash)(userForComparison) !== (0, $9jhip._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
}
module.exports.default = $2170d5f5a537d343$var$EvaluationStore;

});
parcelRegister("9nVLu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $9jhip = parcelRequire("9jhip");
class $01c36783f3c42911$var$V1InitializeContainer {
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $9jhip._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
    constructor(_values){
        this._values = _values;
    }
}
module.exports.V1InitializeContainer = $01c36783f3c42911$var$V1InitializeContainer;

});

parcelRegister("as141", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $9jhip = parcelRequire("9jhip");
class $79bd58269b9a775c$var$V2InitializeContainer {
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $9jhip._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
    constructor(_values){
        this._values = _values;
    }
}
module.exports.V2InitializeContainer = $79bd58269b9a775c$var$V2InitializeContainer;

});


parcelRegister("1ad9i", function(module, exports) {
"use strict";
var $0d90ecb858e887dc$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9jhip = parcelRequire("9jhip");

var $2j1UE = parcelRequire("2j1UE");
class $0d90ecb858e887dc$var$StatsigNetwork extends $9jhip.NetworkCore {
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $0d90ecb858e887dc$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $9jhip._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $0d90ecb858e887dc$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $2j1UE._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $9jhip.UrlConfiguration($9jhip.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
}
module.exports.default = $0d90ecb858e887dc$var$StatsigNetwork;

});
parcelRegister("2j1UE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $9jhip = parcelRequire("9jhip");
const $1aded6f4c4429ed1$var$MAX_DELTAS_SORT_DEPTH = 2;
function $1aded6f4c4429ed1$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $9jhip._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $1aded6f4c4429ed1$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $1aded6f4c4429ed1$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $9jhip._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $1aded6f4c4429ed1$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $1aded6f4c4429ed1$var$_resolveDeltasResponse;
function $1aded6f4c4429ed1$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $1aded6f4c4429ed1$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $1aded6f4c4429ed1$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $1aded6f4c4429ed1$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $1aded6f4c4429ed1$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $1aded6f4c4429ed1$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("bQg5i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $9jhip = parcelRequire("9jhip");
const $89f1070bd59f6bf0$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $89f1070bd59f6bf0$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $89f1070bd59f6bf0$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $9jhip._isTypeMatch)(value, fallback);
}
function $89f1070bd59f6bf0$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $89f1070bd59f6bf0$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $89f1070bd59f6bf0$var$_shouldLogExposure(options) ? undefined : $89f1070bd59f6bf0$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $89f1070bd59f6bf0$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $89f1070bd59f6bf0$var$_shouldLogExposure(options) ? undefined : $89f1070bd59f6bf0$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($89f1070bd59f6bf0$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $89f1070bd59f6bf0$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $89f1070bd59f6bf0$var$_shouldLogExposure(options) ? undefined : $89f1070bd59f6bf0$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($89f1070bd59f6bf0$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $89f1070bd59f6bf0$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $89f1070bd59f6bf0$var$_shouldLogExposure(options) ? undefined : $89f1070bd59f6bf0$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($89f1070bd59f6bf0$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $89f1070bd59f6bf0$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $9jhip._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $89f1070bd59f6bf0$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $89f1070bd59f6bf0$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $89f1070bd59f6bf0$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $89f1070bd59f6bf0$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $89f1070bd59f6bf0$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $89f1070bd59f6bf0$var$_makeParamStoreGetter;

});

parcelRegister("7hatl", function(module, exports) {
"use strict";
var $54c23e805c749738$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $9jhip = parcelRequire("9jhip");

var $1ad9i = parcelRequire("1ad9i");
class $54c23e805c749738$var$StatsigEvaluationsDataAdapter extends $9jhip.DataAdapterCore {
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $1ad9i.default) this._network = network;
        else this._network = new $1ad9i.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $9jhip._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $9jhip._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $9jhip.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $54c23e805c749738$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $9jhip._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$9jhip.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $9jhip._getFullUserHash)(user);
    }
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
}
module.exports.StatsigEvaluationsDataAdapter = $54c23e805c749738$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("fiNMp", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d465d678f410a14$export$2e2bcd8739ae039);

var $5Asmi = parcelRequire("5Asmi");
const $1d465d678f410a14$export$a66cbd9b2289cd78 = '@all-features';
class $1d465d678f410a14$export$2e2bcd8739ae039 {
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, {
            ...options,
            fireGateExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, {
            ...options,
            fireExperimentExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on($1d465d678f410a14$export$a66cbd9b2289cd78, callback);
        return ()=>{
            this.emitter.off($1d465d678f410a14$export$a66cbd9b2289cd78, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit($1d465d678f410a14$export$a66cbd9b2289cd78);
        this.emitter.eventNames().filter((name)=>name !== $1d465d678f410a14$export$a66cbd9b2289cd78).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
    constructor(){
        this.emitter = void 0;
        this.eventToValue = new Map();
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($5Asmi)))();
    }
}

});
parcelRegister("5Asmi", function(module, exports) {
'use strict';
var $41164ffbe2892e67$var$has = Object.prototype.hasOwnProperty, $41164ffbe2892e67$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $41164ffbe2892e67$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $41164ffbe2892e67$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $41164ffbe2892e67$var$Events().__proto__) $41164ffbe2892e67$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $41164ffbe2892e67$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $41164ffbe2892e67$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $41164ffbe2892e67$var$EE(fn, context || emitter, once), evt = $41164ffbe2892e67$var$prefix ? $41164ffbe2892e67$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $41164ffbe2892e67$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $41164ffbe2892e67$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $41164ffbe2892e67$var$EventEmitter() {
    this._events = new $41164ffbe2892e67$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $41164ffbe2892e67$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($41164ffbe2892e67$var$has.call(events, name)) names.push($41164ffbe2892e67$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $41164ffbe2892e67$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $41164ffbe2892e67$var$prefix ? $41164ffbe2892e67$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $41164ffbe2892e67$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $41164ffbe2892e67$var$prefix ? $41164ffbe2892e67$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $41164ffbe2892e67$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $41164ffbe2892e67$var$prefix ? $41164ffbe2892e67$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $41164ffbe2892e67$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $41164ffbe2892e67$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $41164ffbe2892e67$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $41164ffbe2892e67$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $41164ffbe2892e67$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $41164ffbe2892e67$var$prefix ? $41164ffbe2892e67$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $41164ffbe2892e67$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $41164ffbe2892e67$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $41164ffbe2892e67$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $41164ffbe2892e67$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $41164ffbe2892e67$var$prefix ? $41164ffbe2892e67$var$prefix + event : event;
        if (this._events[evt]) $41164ffbe2892e67$var$clearEvent(this, evt);
    } else {
        this._events = new $41164ffbe2892e67$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$41164ffbe2892e67$var$EventEmitter.prototype.off = $41164ffbe2892e67$var$EventEmitter.prototype.removeListener;
$41164ffbe2892e67$var$EventEmitter.prototype.addListener = $41164ffbe2892e67$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$41164ffbe2892e67$var$EventEmitter.prefixed = $41164ffbe2892e67$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$41164ffbe2892e67$var$EventEmitter.EventEmitter = $41164ffbe2892e67$var$EventEmitter;
module.exports = $41164ffbe2892e67$var$EventEmitter;

});


parcelRegister("Qdnig", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $ca6aa09cc5a7e09f$export$6dc24881a3d96325);

var $aeEkY = parcelRequire("aeEkY");

var $jGxFj = parcelRequire("jGxFj");
class $ca6aa09cc5a7e09f$export$6dc24881a3d96325 {
    static fromExperiment(experiment) {
        const config = new $ca6aa09cc5a7e09f$export$6dc24881a3d96325(experiment.name, experiment.value, experiment.ruleID, (0, $aeEkY.migrateEvaluationDetails)(experiment.details), (0, $jGxFj.migrateSecondaryExposures)(experiment.__evaluation?.secondary_exposures ?? []), experiment.groupName ?? undefined);
        config.experiment = experiment;
        return config;
    }
    get(key, defaultValue, typeGuard) {
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            this._onDefaultValueFallback?.(this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        this._onDefaultValueFallback?.(this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = void 0;
        this._name = void 0;
        this._ruleID = void 0;
        /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ this._secondaryExposures = void 0;
        this._allocatedExperimentName = void 0;
        this._evaluationDetails = void 0;
        this._onDefaultValueFallback = void 0;
        this.experiment = void 0;
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
}

});
parcelRegister("aeEkY", function(module, exports) {
$parcel$export(module.exports, "migrateEvaluationDetails", () => $5b724305454b2ca0$export$18ad168d3dbac899);

var $51gLi = parcelRequire("51gLi");
const $5b724305454b2ca0$var$evaluationReasonMappings = Object.entries((0, $51gLi.EvaluationReason)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const $5b724305454b2ca0$export$18ad168d3dbac899 = (details)=>{
    const reasonLower = details.reason.toLowerCase();
    return {
        reason: $5b724305454b2ca0$var$evaluationReasonMappings.find(([key])=>reasonLower.includes(key))?.[1] ?? (0, $51gLi.EvaluationReason).Unknown,
        time: details.receivedAt ?? Date.now()
    };
};

});
parcelRegister("51gLi", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $0f0f21cb292c60bf$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
const $0f0f21cb292c60bf$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
};

});


parcelRegister("jGxFj", function(module, exports) {
$parcel$export(module.exports, "migrateSecondaryExposures", () => $eca08c83b0a4c655$export$55fd683752d01e67);
const $eca08c83b0a4c655$export$55fd683752d01e67 = (secondaryExposures)=>{
    return secondaryExposures.map((exposure)=>{
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});


parcelRegister("lIQDR", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $4dbc5fee110f74af$export$936d0764594b6eb3);

var $aeEkY = parcelRequire("aeEkY");

var $jGxFj = parcelRequire("jGxFj");
class $4dbc5fee110f74af$export$936d0764594b6eb3 {
    static fromLayer(layer) {
        const value = new $4dbc5fee110f74af$export$936d0764594b6eb3(layer.name, layer.__value, layer.ruleID, (0, $aeEkY.migrateEvaluationDetails)(layer.details), (_layer, parameterName)=>layer.get(parameterName), (0, $jGxFj.migrateSecondaryExposures)(layer.__evaluation?.secondary_exposures ?? []), (0, $jGxFj.migrateSecondaryExposures)(layer.__evaluation?.undelegated_secondary_exposures ?? []), layer.__evaluation?.allocated_experiment_name, layer.__evaluation?.explicit_parameters);
        return value;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val ?? defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        this._logParameterFunction?.(this, parameterName);
    }
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._name = void 0;
        this._value = void 0;
        this._ruleID = void 0;
        /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ this._secondaryExposures = void 0;
        /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ this._undelegatedSecondaryExposures = void 0;
        this._allocatedExperimentName = void 0;
        this._explicitParameters = void 0;
        this._evaluationDetails = void 0;
        this._logParameterFunction = void 0;
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue ?? {}));
        this._ruleID = ruleID ?? '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
}

});

parcelRegister("bhQZl", function(module, exports) {
$parcel$export(module.exports, "deepAssign", () => $45f50c2867a07bae$export$1148cb79ceecd5fa);
/**
 * Deeply merges source objects into the target object.
 * Handles nested objects, but arrays are not handled (replaced).
 */ function $45f50c2867a07bae$export$1148cb79ceecd5fa(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if (source === undefined || source === null) return $45f50c2867a07bae$export$1148cb79ceecd5fa(target, ...sources);
    for (const [key, src] of Object.entries(source)){
        const dst = target[key];
        const srcIsObj = src && typeof src === 'object' && !Array.isArray(src);
        const dstIsObj = dst && typeof dst === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $45f50c2867a07bae$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $45f50c2867a07bae$export$1148cb79ceecd5fa(target, ...sources);
}

});

parcelRegister("gRZcq", function(module, exports) {
$parcel$export(module.exports, "default", () => $9931c75000e1e4d4$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $69kmA = parcelRequire("69kmA");

var $c6EKY = parcelRequire("c6EKY");

var $hckcd = parcelRequire("hckcd");
const $9931c75000e1e4d4$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $9931c75000e1e4d4$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
const $9931c75000e1e4d4$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
const $9931c75000e1e4d4$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $9931c75000e1e4d4$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $9931c75000e1e4d4$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $9931c75000e1e4d4$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
const $9931c75000e1e4d4$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
const $9931c75000e1e4d4$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
const $9931c75000e1e4d4$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $9931c75000e1e4d4$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $hckcd.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $hckcd.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter, isolationContextId = null) {
        if (useGatewayUrl) return $9931c75000e1e4d4$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $69kmA.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $69kmA.FeatureGateEnvironment).Production:
                return $9931c75000e1e4d4$export$18c93900db9358a4;
            case (0, $69kmA.FeatureGateEnvironment).Staging:
                return $9931c75000e1e4d4$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $69kmA.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $69kmA.FeatureGateEnvironment).Development:
                return $9931c75000e1e4d4$export$f058dbf75c3bc647;
            case (0, $69kmA.FeatureGateEnvironment).Staging:
                const apiUrl = this.getApiUrl(isolationContextId);
                if (apiUrl !== null) return apiUrl;
                return $9931c75000e1e4d4$export$942ba04389b0d5a2;
            default:
                const prodApiUrl = this.getApiUrl(isolationContextId);
                if (prodApiUrl !== null) return prodApiUrl;
                return $9931c75000e1e4d4$export$250a58ecde616daa;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $9931c75000e1e4d4$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $9931c75000e1e4d4$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $c6EKY.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
    static getApiUrl(isolationContextId) {
        const window1 = this.getWindowLocation();
        if (window1 === undefined) {
            //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
            if (!isolationContextId) return null;
            return $9931c75000e1e4d4$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
        }
        const { protocol: protocol, hostname: hostname } = window1;
        // Match last subdomain fragment before oasis-stg.com
        const oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
        if (oasisMatch) return `${protocol}//api.${oasisMatch[1]}.${$9931c75000e1e4d4$export$cb3cd156f70d7e94}`;
        // Match last subdomain fragment before atlassian-isolated.net
        const isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
        if (isolatedMatch) return `${protocol}//api.${isolatedMatch[1]}.${$9931c75000e1e4d4$export$921fbc6cdfd4eee0}`;
        return null;
    }
    static getWindowLocation() {
        if (typeof window !== 'undefined' && window.location) return window.location;
        return undefined;
    }
}

});
parcelRegister("69kmA", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $2c0a18ba3c6ca061$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $2c0a18ba3c6ca061$export$c42b7bbc5e7ba555);
const $2c0a18ba3c6ca061$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
const $2c0a18ba3c6ca061$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
const $2c0a18ba3c6ca061$export$42f4885608027d0c = 'non_boolean';

});

parcelRegister("c6EKY", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $98e2b497a2c1fcfc$export$a59f8d67326bd1cb);
/// <reference types="node" />
const $98e2b497a2c1fcfc$export$a59f8d67326bd1cb = "0.0.0-use.local";

});

parcelRegister("hckcd", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $246f2d34dcfd5f24$export$286baf652d0b1206);
class $246f2d34dcfd5f24$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("eXX32", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $a7748c4de595ebe0$export$d119b37e5f788b43);

var $fHonK = parcelRequire("fHonK");

var $69kmA = parcelRequire("69kmA");
const $a7748c4de595ebe0$export$d119b37e5f788b43 = (options)=>({
        /**
	 * If more federal PerimeterTypes are added in the future, this should be updated so
	 * that isFedRamp() === true always returns the strictest perimeter.
	 */ perimeter: (0, $fHonK.isFedRamp)() ? (0, $69kmA.PerimeterType).FEDRAMP_MODERATE : (0, $69kmA.PerimeterType).COMMERCIAL,
        ...options
    });

});
parcelRegister("fHonK", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $e74bfe3f11fdd49d$export$64d6499adf9b2e51);

var $iNepN = parcelRequire("iNepN");
function $e74bfe3f11fdd49d$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $iNepN.FEDRAMP_MODERATE);
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("iNepN", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $cfd2091684ae89c9$export$ce553301d55c2fd8);
const $cfd2091684ae89c9$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $cfd2091684ae89c9$export$f005e2e9f707cb5f = 'commercial';
const $cfd2091684ae89c9$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $cfd2091684ae89c9$export$a739cd5aac835909 = 'stg';
const $cfd2091684ae89c9$export$42dd0cdd351a4a9 = 'prod';
const $cfd2091684ae89c9$export$404582bc18fe4d9e = 'dev';

});



parcelRegister("280qg", function(module, exports) {
$parcel$export(module.exports, "migrateInitializationOptions", () => $08985dd29bc1f6da$export$202946b690d26d22);
const $08985dd29bc1f6da$export$202946b690d26d22 = (options)=>{
    const { api: api, disableCurrentPageLogging: disableCurrentPageLogging, loggingIntervalMillis: loggingIntervalMillis, loggingBufferMaxSize: loggingBufferMaxSize, localMode: localMode, eventLoggingApi: eventLoggingApi, eventLoggingApiForRetries: eventLoggingApiForRetries, disableLocalStorage: disableLocalStorage, ignoreWindowUndefined: ignoreWindowUndefined, disableAllLogging: disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging, ...rest } = options;
    return {
        ...rest,
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    };
};

});

parcelRegister("3U8Dd", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $0163d55f70a3d671$export$55fffef3474104af);

var $60WtX = parcelRequire("60WtX");
class $0163d55f70a3d671$export$55fffef3474104af extends (0, $60WtX.DataAdapterCore) {
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, $60WtX.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $60WtX._getFullUserHash)(user)
        };
    }
    getDataSync(user) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $60WtX._getFullUserHash)(user)
        };
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, $60WtX._getStorageKey)(this._getSdkKey(), user);
        return `${0, $60WtX.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = {
            ...this
        };
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
    constructor(){
        super('NoFetchDataAdapter', 'nofetch');
        this.bootstrapResult = null;
    }
}

});

parcelRegister("0UFqB", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $f2e794be63c68a8b$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $f2e794be63c68a8b$export$bcb28fbac1def494);

var $9jhip = parcelRequire("9jhip");
const $f2e794be63c68a8b$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const $f2e794be63c68a8b$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
const $f2e794be63c68a8b$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const $f2e794be63c68a8b$var$makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const $f2e794be63c68a8b$var$djb2MapKey = (hash, kind)=>kind + ':' + hash;
class $f2e794be63c68a8b$export$bcb28fbac1def494 {
    parseStoredOverrides(localStorageKey) {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return $f2e794be63c68a8b$var$makeEmptyStore();
            return JSON.parse(json);
        } catch  {
            return $f2e794be63c68a8b$var$makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = $f2e794be63c68a8b$var$makeEmptyStore();
        for (const overrides of allOverrides){
            for (const [name, value] of Object.entries(overrides.gates ?? {}))merged.gates[name] = value;
            for (const [name, value] of Object.entries(overrides.configs ?? {}))merged.configs[name] = value;
            for (const [name, value] of Object.entries(overrides.layers ?? {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($f2e794be63c68a8b$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // Clear data from legacy local storage key now we've read from it.
        // This prevents things being stuck in there that are always read but never written to.
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.removeItem($f2e794be63c68a8b$var$LEGACY_LOCAL_STORAGE_KEY);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, $9jhip._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = {
            ...$f2e794be63c68a8b$var$makeEmptyStore(),
            ...overrides
        };
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set($f2e794be63c68a8b$var$djb2MapKey((0, $9jhip._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set($f2e794be63c68a8b$var$djb2MapKey((0, $9jhip._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete($f2e794be63c68a8b$var$djb2MapKey((0, $9jhip._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        const overridden = this._overrides.gates[current.name] ?? this._djb2Map.get($f2e794be63c68a8b$var$djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            details: {
                ...current.details,
                reason: $f2e794be63c68a8b$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($f2e794be63c68a8b$var$djb2MapKey((0, $9jhip._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($f2e794be63c68a8b$var$djb2MapKey((0, $9jhip._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($f2e794be63c68a8b$var$djb2MapKey((0, $9jhip._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($f2e794be63c68a8b$var$djb2MapKey((0, $9jhip._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set($f2e794be63c68a8b$var$djb2MapKey((0, $9jhip._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete($f2e794be63c68a8b$var$djb2MapKey((0, $9jhip._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = $f2e794be63c68a8b$var$makeEmptyStore();
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            window.localStorage.removeItem(this._localStorageKey);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getLayerOverride(current, _user) {
        const overridden = this._overrides.layers[current.name] ?? this._djb2Map.get($f2e794be63c68a8b$var$djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return {
            ...current,
            __value: overridden,
            get: (0, $9jhip._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $f2e794be63c68a8b$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    _getConfigOverride(current, lookup) {
        const overridden = lookup[current.name] ?? this._djb2Map.get($f2e794be63c68a8b$var$djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            get: (0, $9jhip._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $f2e794be63c68a8b$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    constructor(localStorageKey){
        this._overrides = void 0;
        this._localStorageKey = void 0;
        this._djb2Map = void 0;
        this._overrides = $f2e794be63c68a8b$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
}

});

parcelRegister("gelW8", function(module, exports) {
$parcel$export(module.exports, "shallowEquals", () => $aab0577abebd600e$export$fa1c2bbf4100b8bc);
const $aab0577abebd600e$export$fa1c2bbf4100b8bc = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};

});

parcelRegister("ft6hZ", function(module, exports) {
$parcel$export(module.exports, "toStatsigUser", () => $8ffeb86f42257f97$export$3dad1db244472f32);
const $8ffeb86f42257f97$export$3dad1db244472f32 = (identifiers, customAttributes)=>{
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    const { stableId: stableId, ...otherIdentifiers } = identifiers;
    const user = {
        customIDs: {
            ...otherIdentifiers,
            ...stableId !== undefined ? {
                stableID: stableId
            } : {}
        },
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};

});



parcelRegister("7tgXC", function(module, exports) {
$parcel$export(module.exports, "debug", () => $5eef67acbc9066c0$export$1c9f709888824e05);
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $5eef67acbc9066c0$var$TESTS_MODE = globalThis?.process?.env?.JEST_WORKER_ID !== undefined;
const $5eef67acbc9066c0$var$DEBUG_MODE = !$5eef67acbc9066c0$var$TESTS_MODE && globalThis?.process?.env?.NODE_ENV !== 'production';
const $5eef67acbc9066c0$export$1c9f709888824e05 = (...args)=>{
    if (!$5eef67acbc9066c0$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

});

parcelRegister("ezo7d", function(module, exports) {
$parcel$export(module.exports, "ENV_ENABLE_PLATFORM_FF", () => $4f282ec651e266fc$export$b574c24e1e6490f5);

var $2IOnA = parcelRequire("2IOnA");
const $4f282ec651e266fc$export$b574c24e1e6490f5 = (0, $2IOnA.hasProcessEnv) ? false : false;

});
parcelRegister("2IOnA", function(module, exports) {
$parcel$export(module.exports, "PFF_GLOBAL_KEY", () => $15e850736011da95$export$7e41b1b2bdee3f98);
$parcel$export(module.exports, "pkgName", () => $15e850736011da95$export$407f05df8e3ce9f3);
$parcel$export(module.exports, "hasProcessEnv", () => $15e850736011da95$export$75f4a1454eff2805);

var $2M83v = parcelRequire("2M83v");
const $15e850736011da95$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $15e850736011da95$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
const $15e850736011da95$export$75f4a1454eff2805 = typeof $2M83v !== 'undefined' && typeof $2M83v.env !== 'undefined';

});


parcelRegister("9dUA6", function(module, exports) {
$parcel$export(module.exports, "ENV_STORYBOOK_ENABLE_PLATFORM_FF", () => $2b108a65edea6846$export$92f8b531feaeb23d);

var $2IOnA = parcelRequire("2IOnA");
const $2b108a65edea6846$export$92f8b531feaeb23d = (0, $2IOnA.hasProcessEnv) ? false : false;

});

parcelRegister("b2g2S", function(module, exports) {
$parcel$export(module.exports, "globalVar", () => $e650a3614d3a65b3$export$54ea85357b4e0159);

var $2IOnA = parcelRequire("2IOnA");
const $e650a3614d3a65b3$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $e650a3614d3a65b3$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$e650a3614d3a65b3$export$54ea85357b4e0159[0, $2IOnA.PFF_GLOBAL_KEY] = $e650a3614d3a65b3$export$54ea85357b4e0159[0, $2IOnA.PFF_GLOBAL_KEY] || $e650a3614d3a65b3$var$DEFAULT_PFF_GLOBAL;

});



parcelRegister("2zaIp", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce039c4f0d297108$export$2e2bcd8739ae039);

var $al68F = parcelRequire("al68F");
const $ce039c4f0d297108$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $ce039c4f0d297108$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($ce039c4f0d297108$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$ce039c4f0d297108$export$7bc189309d2ad463];
            else {
                // Initialise InteractionSessionTracking on global window object
                window[$ce039c4f0d297108$export$7bc189309d2ad463] = new (0, $al68F.default)();
                interactionSessionTracking = window[$ce039c4f0d297108$export$7bc189309d2ad463];
            }
        } catch (error) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}

});
parcelRegister("al68F", function(module, exports) {
$parcel$export(module.exports, "default", () => $264022ee45d17faf$export$2e2bcd8739ae039);

var $jFsha = parcelRequire("jFsha");
const $264022ee45d17faf$var$INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
const $264022ee45d17faf$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
const $264022ee45d17faf$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
const $264022ee45d17faf$export$285f6bddd927a06d = 1800000; // 30 minutes
const $264022ee45d17faf$export$d050a4cab1b9f734 = 86400000; // 24 hours
const $264022ee45d17faf$export$a92e915d70316eb2 = 5000; // 5 seconds
const $264022ee45d17faf$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $264022ee45d17faf$var$INTEGER_REGEX = /^\d+$/;
const $264022ee45d17faf$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
class $264022ee45d17faf$export$2e2bcd8739ae039 {
    getCurrentInteractionSessionId() {
        try {
            const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this.getCurrentSessionParams();
            // If we have an existing valid session we can return the sessionId straight away
            if (isValidSession) {
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return sessionId;
            }
            // To generate a new session ID we must ensure analytics is ready
            if (this.analyticsReady) {
                // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                // into issues of calls attempting to read the session ID before a valid expiry had been set
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return this.generateNewSessionId();
            }
        } catch (err) {
        // Silently swallow exception
        }
        return null;
    }
    getPreviousInteractionSessionId() {
        return this.safeSessionStorage.getItem($264022ee45d17faf$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
    }
    setInteractionSessionId(persistedSessionId) {
        if (this.validateSessionId(persistedSessionId)) {
            const currentSessionId = this.safeSessionStorage.getItem($264022ee45d17faf$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            // If we are already on the required session ID, just return true and make no changes
            // This can happen if the persisted session ID in options is the same as the current session ID
            // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
            // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
            if (currentSessionId === persistedSessionId) return false;
            // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
            // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
            this.debouncedUpdateSessionExpiry(0);
            this.safeSessionStorage.setItem($264022ee45d17faf$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
            this.safeSessionStorage.removeItem($264022ee45d17faf$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            document.dispatchEvent(new Event($264022ee45d17faf$export$5d4c4eab0863aae3));
            return true;
        }
        return false;
    }
    // Must be called with a valid sendEvent function for other methods to work
    setAnalyticsCallback(sendEventCallback) {
        if (this.analyticsReady) // If we already have a valid callback, don't over-write it
        return;
        if (sendEventCallback && typeof sendEventCallback === 'function') {
            this.sendEventCallback = sendEventCallback;
            this.analyticsReady = true;
        } else this.analyticsReady = false;
    }
    validateSessionId(sessionId) {
        // Check if persisted session ID can parse as valid Unix timestamp
        if (sessionId && $264022ee45d17faf$var$INTEGER_REGEX.test(sessionId)) {
            const sessionAge = Date.now() - parseInt(sessionId, 10);
            // Validate that timestamp is not a future time, and is also within the TTL
            if (sessionAge >= 0 && sessionAge <= $264022ee45d17faf$export$d050a4cab1b9f734) return true;
        }
        return false;
    }
    /*
   * This function retrieves the current session ID and expiry from SessionStorage
   * It runs the necessary checks to ensure the session ID is valid and within expiry
   *
   * It returns the values along with a `validSession` boolean
   */ getCurrentSessionParams() {
        const sessionId = this.safeSessionStorage.getItem($264022ee45d17faf$var$INTERACTION_SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this.safeSessionStorage.getItem($264022ee45d17faf$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
   * This function sends a GASv3 analytics event indicating the interaction session has started or renewed
   * It requires this.sendEventCallback to be set via Analytics Web Client to a valid operational event sender function
   *
   * Note that Analytics Web Client's callback function will make its own call to getCurrentInteractionSessionId to retrieve the session ID
   * to attach to the event, so a valid session ID/expiry must be retrievable from SessionStorage before this function is called to avoid infinite loops.
   *
   * This is not an ideal solution but it works with the current architecture of Analytics Web Client.
   */ sendInteractionSessionEvent(action) {
        this.sendEventCallback && this.sendEventCallback({
            action: action,
            actionSubject: 'interactionSession',
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
    constructor(){
        this.safeSessionStorage = void 0;
        this.sessionExpiryTime = void 0;
        this.sessionExpiryDebounce = void 0;
        this.sessionExpiryDebounceThresholdPercentage = void 0;
        this.sessionExpiryDebounceTimer = void 0;
        this.analyticsReady = false;
        // This callback function will be called whenever a new session ID is generated
        // It expects a function that sends an operational analytics event, with
        // the first parameter being set to the action ('started' or 'renewed'), and the second parameter being
        // an InteractionSession object containing the new session ID and previous session ID.
        this.sendEventCallback = void 0;
        this.generateNewSessionId = ()=>{
            if (!this.analyticsReady) return null;
            const currentSessionId = this.safeSessionStorage.getItem($264022ee45d17faf$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            const newSessionId = Date.now().toString();
            this.safeSessionStorage.setItem($264022ee45d17faf$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            const { isValidSession: isValidSession } = this.getCurrentSessionParams();
            if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
            // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
            return null;
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                this.safeSessionStorage.setItem($264022ee45d17faf$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                this.sendInteractionSessionEvent('renewed');
            } else this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event($264022ee45d17faf$export$5d4c4eab0863aae3));
            return newSessionId;
        };
        this.updateSessionExpiry = ()=>{
            const expiry = Date.now() + this.sessionExpiryTime;
            this.safeSessionStorage.setItem($264022ee45d17faf$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this.debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { updateSessionExpiry: updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this.sessionExpiryDebounceThresholdPercentage * this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (this.sessionExpiryDebounceTimer) clearTimeout(this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this.sessionExpiryDebounceTimer = setTimeout(()=>{
                    updateSessionExpiry();
                }, this.sessionExpiryDebounce);
            }
        };
        this.sessionExpiryTime = $264022ee45d17faf$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $264022ee45d17faf$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $264022ee45d17faf$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $jFsha.default)();
    }
}

});
parcelRegister("jFsha", function(module, exports) {
$parcel$export(module.exports, "default", () => $2848e4ef15441b76$export$2e2bcd8739ae039);

var $lgcUk = parcelRequire("lgcUk");

var $8NE1T = parcelRequire("8NE1T");
class $2848e4ef15441b76$export$2e2bcd8739ae039 extends (0, $8NE1T.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = window.sessionStorage || (0, $lgcUk.default);
        } catch (err) {
            storageToUse = (0, $lgcUk.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("lgcUk", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9668c0a0106359d$export$2e2bcd8739ae039);

var $7y7Gt = parcelRequire("7y7Gt");
// eslint-disable-next-line import/no-anonymous-default-export
const $f9668c0a0106359d$var$inmemorystorage = new (0, $7y7Gt.InMemoryStore)();
var $f9668c0a0106359d$export$2e2bcd8739ae039 = $f9668c0a0106359d$var$inmemorystorage;

});
parcelRegister("7y7Gt", function(module, exports) {
$parcel$export(module.exports, "InMemoryStore", () => $848267f48347451b$export$90e3e001bcac59c7);
class $848267f48347451b$export$90e3e001bcac59c7 {
    constructor(){
        this.data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this.data[key] = value;
            this.length = Object.keys(this.data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this.data) return this.data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this.data) delete this.data[key];
            this.length = Object.keys(this.data).length;
            return null;
        };
        this.clear = ()=>{
            this.data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this.data)[index];
    }
}

});


parcelRegister("8NE1T", function(module, exports) {
$parcel$export(module.exports, "default", () => $7040b55291049056$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $bvz0L = parcelRequire("bvz0L");

var $lgcUk = parcelRequire("lgcUk");

var $01Jk4 = parcelRequire("01Jk4");
const $7040b55291049056$export$41c06fdd37b7e9a5 = 'awc';
const $7040b55291049056$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
class $7040b55291049056$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.prefix = void 0;
        this.store = void 0;
        this.options = void 0;
        this.getStore = ()=>this.store;
        this.getItem = (key)=>this.store.getItem(this.createKey(key));
        this.removeItem = (key)=>this.store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this.store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this.store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this.store === (0, $lgcUk.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this.store || {});
            let inMemoryStorage;
            if ((0, $01Jk4.isSupported)(window[$7040b55291049056$export$770aa8bc07b3de03])) inMemoryStorage = window[$7040b55291049056$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $lgcUk.default);
                if (!window[$7040b55291049056$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$7040b55291049056$export$770aa8bc07b3de03] = (0, $lgcUk.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this.store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this.store = inMemoryStorage;
        };
        this.clear = ()=>this.store.clear();
        this.key = (index)=>this.store.key(index);
        this.getPrefix = ()=>this.prefix;
        this.createKey = (key)=>{
            if (this.prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($7040b55291049056$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $bvz0L.envType).PROD) prefixes.push(options.envPrefix);
        this.prefix = prefixes.join('-');
        if ((0, $01Jk4.isSupported)(storageToUse)) this.store = storageToUse;
        else this.swapToInMemory();
    }
}

});
parcelRegister("bvz0L", function(module, exports) {
$parcel$export(module.exports, "envType", () => $5278b7a9b5bc97ff$export$56ac8ebc9870b1b9);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // This type has been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $5278b7a9b5bc97ff$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});

});

parcelRegister("01Jk4", function(module, exports) {
$parcel$export(module.exports, "isSupported", () => $777fdde3fa0ef445$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ function $777fdde3fa0ef445$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});






parcelRegister("jqVis", function(module, exports) {
$parcel$export(module.exports, "URL_QUERY_PARAM_INTERACTION_SESSION", () => $1b1a336b91d42173$export$81d16f1428ce0486);
const $1b1a336b91d42173$export$81d16f1428ce0486 = 'xpis';
const $1b1a336b91d42173$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    let partialUrl = false;
    let urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch  {
        urlObj = new URL(url, 'http://localhost/');
        partialUrl = true;
    }
    urlObj.searchParams.set($1b1a336b91d42173$export$81d16f1428ce0486, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};

});

parcelRegister("gAfN8", function(module, exports) {
$parcel$export(module.exports, "validProducts", () => $d63d06ac7bf4707e$export$b1e8b4360a046e61);
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
const $d63d06ac7bf4707e$export$b1e8b4360a046e61 = [
    'jira',
    'confluence',
    'townsquare',
    'loom',
    'atlassianStudio',
    'bitbucket',
    'admin',
    'mercury',
    'talent',
    'trello',
    'analyticsVisualizationPlatform'
];

});

parcelRegister("3KzJL", function(module, exports) {
$parcel$export(module.exports, "default", () => $d01000404c0523ee$export$2e2bcd8739ae039);

var $9QkBj = parcelRequire("9QkBj");

var $lBkat = parcelRequire("lBkat");

var $hvSyg = parcelRequire("hvSyg");
const $d01000404c0523ee$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = (0, $lBkat.defaultHistoryReplaceFn))=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $9QkBj.parseUrl)(removedFragmentURL);
    const captureParams = (0, $hvSyg.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $hvSyg.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $9QkBj.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d01000404c0523ee$export$2e2bcd8739ae039 = $d01000404c0523ee$var$urlParamExtractor;

});
parcelRegister("9QkBj", function(module, exports) {
$parcel$export(module.exports, "extract", () => $72a8f345e122154f$export$f9380c9a627682d3, (v) => $72a8f345e122154f$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $72a8f345e122154f$export$98e6a39c04603d36, (v) => $72a8f345e122154f$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $72a8f345e122154f$export$fac44ee5b035f737, (v) => $72a8f345e122154f$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $72a8f345e122154f$export$7a5253c0f62e0150, (v) => $72a8f345e122154f$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $72a8f345e122154f$export$a8c1621ea79325d3, (v) => $72a8f345e122154f$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $72a8f345e122154f$export$357523c63a2253b9, (v) => $72a8f345e122154f$export$357523c63a2253b9 = v);
var $72a8f345e122154f$export$f9380c9a627682d3;
var $72a8f345e122154f$export$98e6a39c04603d36;
var $72a8f345e122154f$export$fac44ee5b035f737;
var $72a8f345e122154f$export$7a5253c0f62e0150;
var $72a8f345e122154f$export$a8c1621ea79325d3;
var $72a8f345e122154f$export$357523c63a2253b9;
var $72a8f345e122154f$export$44c361b8ec72ef7f;
'use strict';

var $2HNMt = parcelRequire("2HNMt");

var $8iQqy = parcelRequire("8iQqy");

var $dqWYQ = parcelRequire("dqWYQ");

var $4dnls = parcelRequire("4dnls");
const $72a8f345e122154f$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $72a8f345e122154f$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $72a8f345e122154f$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $72a8f345e122154f$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $72a8f345e122154f$var$encode(key, options),
                            '[',
                            $72a8f345e122154f$var$encode(index, options),
                            ']=',
                            $72a8f345e122154f$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $72a8f345e122154f$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $72a8f345e122154f$var$encode(key, options),
                            '[]=',
                            $72a8f345e122154f$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $72a8f345e122154f$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $72a8f345e122154f$var$encode(key, options),
                            ':list=',
                            $72a8f345e122154f$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $72a8f345e122154f$var$encode(key, options),
                                keyValueSep,
                                $72a8f345e122154f$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $72a8f345e122154f$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $72a8f345e122154f$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $72a8f345e122154f$var$encode(key, options),
                            '=',
                            $72a8f345e122154f$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $72a8f345e122154f$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $72a8f345e122154f$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $72a8f345e122154f$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$72a8f345e122154f$var$decode(item, options)) : value === null ? value : $72a8f345e122154f$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $72a8f345e122154f$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$72a8f345e122154f$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $72a8f345e122154f$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $72a8f345e122154f$var$encode(value, options) {
    if (options.encode) return options.strict ? $2HNMt(value) : encodeURIComponent(value);
    return value;
}
function $72a8f345e122154f$var$decode(value, options) {
    if (options.decode) return $8iQqy(value);
    return value;
}
function $72a8f345e122154f$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $72a8f345e122154f$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $72a8f345e122154f$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $72a8f345e122154f$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $72a8f345e122154f$var$extract(input) {
    input = $72a8f345e122154f$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $72a8f345e122154f$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $72a8f345e122154f$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $72a8f345e122154f$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $72a8f345e122154f$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $dqWYQ(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $72a8f345e122154f$var$decode(value, options);
        formatter($72a8f345e122154f$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $72a8f345e122154f$var$parseValue(value[k], options);
        else ret[key] = $72a8f345e122154f$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $72a8f345e122154f$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$72a8f345e122154f$export$f9380c9a627682d3 = $72a8f345e122154f$var$extract;
$72a8f345e122154f$export$98e6a39c04603d36 = $72a8f345e122154f$var$parse;
$72a8f345e122154f$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $72a8f345e122154f$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $72a8f345e122154f$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $72a8f345e122154f$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $72a8f345e122154f$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $72a8f345e122154f$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $72a8f345e122154f$var$encode(key, options) + '=' + $72a8f345e122154f$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$72a8f345e122154f$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $dqWYQ(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $72a8f345e122154f$var$parse($72a8f345e122154f$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $72a8f345e122154f$var$decode(hash, options)
    } : {});
};
$72a8f345e122154f$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$72a8f345e122154f$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $72a8f345e122154f$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $72a8f345e122154f$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $72a8f345e122154f$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $72a8f345e122154f$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $72a8f345e122154f$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$72a8f345e122154f$var$encodeFragmentIdentifier] ? $72a8f345e122154f$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$72a8f345e122154f$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$72a8f345e122154f$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $72a8f345e122154f$export$7a5253c0f62e0150(input, options);
    return $72a8f345e122154f$export$a8c1621ea79325d3({
        url: url,
        query: $4dnls(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$72a8f345e122154f$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $72a8f345e122154f$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("2HNMt", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("8iQqy", function(module, exports) {
'use strict';
var $60b8ac214d63a6ad$var$token = '%[a-f0-9]{2}';
var $60b8ac214d63a6ad$var$singleMatcher = new RegExp('(' + $60b8ac214d63a6ad$var$token + ')|([^%]+?)', 'gi');
var $60b8ac214d63a6ad$var$multiMatcher = new RegExp('(' + $60b8ac214d63a6ad$var$token + ')+', 'gi');
function $60b8ac214d63a6ad$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $60b8ac214d63a6ad$var$decodeComponents(left), $60b8ac214d63a6ad$var$decodeComponents(right));
}
function $60b8ac214d63a6ad$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($60b8ac214d63a6ad$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $60b8ac214d63a6ad$var$decodeComponents(tokens, i).join('');
            tokens = input.match($60b8ac214d63a6ad$var$singleMatcher) || [];
        }
        return input;
    }
}
function $60b8ac214d63a6ad$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $60b8ac214d63a6ad$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $60b8ac214d63a6ad$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $60b8ac214d63a6ad$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $60b8ac214d63a6ad$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("dqWYQ", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("4dnls", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("lBkat", function(module, exports) {
$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $2d8730f51d9c2d49$export$600dd5bf1b049f11);
const $2d8730f51d9c2d49$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);

});

parcelRegister("hvSyg", function(module, exports) {
$parcel$export(module.exports, "mapKeys", () => $f47780cdf930fdfd$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $f47780cdf930fdfd$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $f47780cdf930fdfd$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $f47780cdf930fdfd$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $f47780cdf930fdfd$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $f47780cdf930fdfd$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $f47780cdf930fdfd$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $f47780cdf930fdfd$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $f47780cdf930fdfd$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $f47780cdf930fdfd$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $f47780cdf930fdfd$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $f47780cdf930fdfd$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $f47780cdf930fdfd$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$f47780cdf930fdfd$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $f47780cdf930fdfd$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});



parcelRegister("4bfii", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8ecb29112ffff98$export$2e2bcd8739ae039);

var $e2zrW = parcelRequire("e2zrW");

var $iJGJ6 = parcelRequire("iJGJ6");

var $hQcGi = parcelRequire("hQcGi");
class $d8ecb29112ffff98$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        this.delayQueue = void 0;
        this.delayTimeout = void 0;
        this.delayCallback = void 0;
        this.isDelaying = void 0;
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        };
        this.startLowPriorityEventDelay = (timeout = (0, $e2zrW.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $e2zrW.MAX_DELAY_TIMEOUT)) : (0, $e2zrW.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $hQcGi.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        };
        this.stopLowPriorityEventDelay = (reason = (0, $hQcGi.StopLowPriorityEventDelayReason).MANUAL)=>{
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            this.delayCallback?.(reason);
            this.delayCallback = undefined;
        };
        this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
        this.isDelaying = false;
        this.delayQueue = new (0, $iJGJ6.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("e2zrW", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", () => $694e39bde27472d4$export$cf090d5281b5ae06);
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", () => $694e39bde27472d4$export$8575e30be0feb909);
const $694e39bde27472d4$export$cf090d5281b5ae06 = 10000;
const $694e39bde27472d4$export$8575e30be0feb909 = 30000;

});

parcelRegister("iJGJ6", function(module, exports) {
$parcel$export(module.exports, "default", () => $8aa00996859d4a71$export$2e2bcd8739ae039);

var $4FAuJ = parcelRequire("4FAuJ");

var $hvSyg = parcelRequire("hvSyg");

var $hjXQQ = parcelRequire("hjXQQ");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $8aa00996859d4a71$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $8aa00996859d4a71$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $8aa00996859d4a71$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        this.compressor = void 0;
        this.eventArgs = void 0;
        this.flushBatchTimeout = void 0;
        this.processFn = void 0;
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        };
        this.size = ()=>this.eventArgs.length;
        this.startFlush = ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        };
        this.cancelFlush = ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        };
        this.flushNextBatch = ()=>{
            const batch = this.eventArgs.splice(0, $8aa00996859d4a71$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $8aa00996859d4a71$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        };
        this.compressEventArgs = (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $hvSyg.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $hvSyg.equals)(group.userInfo, args.userInfo) && (0, $hvSyg.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $4FAuJ.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        };
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $hjXQQ.default)(compressionRules);
    }
}

});
parcelRegister("hjXQQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdf49639128a0d36$export$2e2bcd8739ae039);
/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ 
var $dHnwJ = parcelRequire("dHnwJ");

var $hvSyg = parcelRequire("hvSyg");

var $aiG4R = parcelRequire("aiG4R");
class $cdf49639128a0d36$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        this.compressionRules = void 0;
        this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
        this.compress = (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        };
        this.createGroups = (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $dHnwJ.buildActionFields)(event, event.eventType);
                    contextFields = (0, $hvSyg.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $hvSyg.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []);
        this.compressGroup = (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>({
                        ...actionFields,
                        ...group.contextFields
                    }));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        };
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $aiG4R.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("aiG4R", function(module, exports) {
$parcel$export(module.exports, "CompressionRule", () => $40886613d71daa09$export$89b3253ddfd2e6e8);

var $9FBzP = parcelRequire("9FBzP");

var $hvSyg = parcelRequire("hvSyg");

var $8QZSB = parcelRequire("8QZSB");

var $82Rdv = parcelRequire("82Rdv");
class $40886613d71daa09$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        this.compressFn = void 0;
        this.predicate = void 0;
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ this.canCompress = (event)=>{
            try {
                return event && (0, $9FBzP.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        };
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ this.compress = (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $hvSyg.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $82Rdv.validateActionEventType)(event.eventType);
                (0, $8QZSB.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        };
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("9FBzP", function(module, exports) {
$parcel$export(module.exports, "isActionEventType", () => $7a59873307b54453$export$d19cebda16f7579a);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $juSGQ = parcelRequire("juSGQ");
function $7a59873307b54453$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $juSGQ.eventType).OPERATIONAL:
        case (0, $juSGQ.eventType).TRACK:
        case (0, $juSGQ.eventType).UI:
            return true;
        default:
            return false;
    }
}

});

parcelRegister("8QZSB", function(module, exports) {
$parcel$export(module.exports, "validateActionEvent", () => $a23b2bdaa8507e1f$export$e0c121325c66ed4c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $jtDq6 = parcelRequire("jtDq6");
function $a23b2bdaa8507e1f$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    (0, $jtDq6.validateContainers)(event.containers);
}

});
parcelRegister("jtDq6", function(module, exports) {
$parcel$export(module.exports, "validateContainers", () => $bf20e5f5f7ca4e8f$export$e63ea5d8477971d3);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $9lC0S = parcelRequire("9lC0S");
function $bf20e5f5f7ca4e8f$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>(0, $9lC0S.validateContainersObject)(container));
}

});
parcelRegister("9lC0S", function(module, exports) {
$parcel$export(module.exports, "validateContainersObject", () => $e8de21a35e17a1a7$export$df8ff30e3c960006);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $5BeP1 = parcelRequire("5BeP1");
function $e8de21a35e17a1a7$export$df8ff30e3c960006(container) {
    if (!(0, $5BeP1.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}

});



parcelRegister("82Rdv", function(module, exports) {
$parcel$export(module.exports, "validateActionEventType", () => $4bd3af3b2c07e239$export$4a8d7476662aebcc);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $juSGQ = parcelRequire("juSGQ");

var $9FBzP = parcelRequire("9FBzP");
const $4bd3af3b2c07e239$var$actionEventTypes = Object.freeze([
    (0, $juSGQ.eventType).OPERATIONAL,
    (0, $juSGQ.eventType).TRACK,
    (0, $juSGQ.eventType).UI
]);
function $4bd3af3b2c07e239$export$4a8d7476662aebcc(type) {
    if (!(0, $9FBzP.isActionEventType)(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$4bd3af3b2c07e239$var$actionEventTypes}]`);
    return true;
}

});




parcelRegister("hQcGi", function(module, exports) {
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $eaa93537aa486588$export$fa6e3729c21cb8f);
var $eaa93537aa486588$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("9tfAe", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd5c17c26a3e147a$export$2e2bcd8739ae039);

var $fQIzY = parcelRequire("fQIzY");

var $2n2nJ = parcelRequire("2n2nJ");

var $7avGr = parcelRequire("7avGr");

var $agQKt = parcelRequire("agQKt");

var $bl1Kz = parcelRequire("bl1Kz");

var $4UAZD = parcelRequire("4UAZD");

var $LpwjR = parcelRequire("LpwjR");

var $ePnPr = parcelRequire("ePnPr");

var $8xDw1 = parcelRequire("8xDw1");

var $9gfXY = parcelRequire("9gfXY");

var $dqbkU = parcelRequire("dqbkU");

var $7h22H = parcelRequire("7h22H");

var $5GxeR = parcelRequire("5GxeR");

var $dEgKJ = parcelRequire("dEgKJ");

var $69bzU = parcelRequire("69bzU");

var $7tyuh = parcelRequire("7tyuh");
class $fd5c17c26a3e147a$var$AnalyticsAPIResponse {
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
    constructor(success, validationErrors, message, code, validationReports){
        this.success = void 0;
        this.validationErrors = void 0;
        this.message = void 0;
        this.code = void 0;
        this.validationReports = void 0;
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
}
class $fd5c17c26a3e147a$var$Message {
    constructor(error){
        this.error = void 0;
        this.error = error;
    }
}
class $fd5c17c26a3e147a$var$EventValidationReport {
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    constructor(messageId, results){
        this.messageId = void 0;
        this.results = void 0;
        this.messageId = messageId;
        this.results = results;
    }
}
class $fd5c17c26a3e147a$export$2e2bcd8739ae039 {
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $69bzU.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $69bzU.SegmentEventTypes).TRACK,
            properties: (0, $5GxeR.prepareEventProperties)(builtEvent),
            event: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $69bzU.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $69bzU.SegmentEventTypes).PAGE,
            properties: (0, $5GxeR.prepareEventProperties)(builtEvent),
            name: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $69bzU.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $69bzU.SegmentEventTypes).IDENTIFY,
            traits: (0, $5GxeR.prepareEventProperties)(builtEvent)
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $7h22H.prepareEventContext)(context);
        const segmentContext = (0, $4UAZD.buildContext)(clonedContext, overrides);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, $7avGr.default)()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    applyExclusions(item) {
        const msg = item.msg;
        const properties = msg.properties;
        const traits = msg.traits;
        const excluded = msg.context?.excludedProperties;
        if (!excluded) return;
        if (excluded.anonymousId === true) msg.anonymousId = undefined;
        if (excluded.interactionSession === true) {
            if (properties) properties.interactionSession = undefined;
        }
        if (excluded.sessionId === true) {
            if (properties) properties.sessionId = undefined;
        }
        if (excluded.pageLoadId === true) {
            if (properties) properties.pageLoadId = undefined;
        }
        if (excluded.tabId === true) {
            if (properties) properties.tabId = undefined;
        }
        if (excluded.taskSessions === true) {
            if (properties) properties.taskSessions = undefined;
        }
        if (excluded.userId === true) {
            msg.userId = undefined;
            if (properties) properties.userIdType = undefined;
        }
        if (excluded.xid === true) {
            if (properties) properties.xid = undefined;
            if (traits) traits.xid = undefined;
        }
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo?.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === 'props') continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch  {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $fd5c17c26a3e147a$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $fd5c17c26a3e147a$var$Message(responseObject.message?.error || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $fd5c17c26a3e147a$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, // In case 'error' were to be undefined we'll convert it to null.
            analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $agQKt.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    /** @internal Used by AnalyticsWebClient to wire up origin tracing cleanup. */ setOriginTracingClient(client) {
        this.originTracingClient = client;
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
    constructor(options){
        this.user = void 0;
        this.options = void 0;
        this.resilienceQueue = void 0;
        this.gasv3BatchUrl = void 0;
        this.metrics = void 0;
        this.xidPromiseCallback = void 0;
        this.responseCallback = void 0;
        this.metadataClient = void 0;
        this.useUrlFromMetadata = void 0;
        this.lastSendEventsError = void 0;
        this.lastUrlFallbackError = void 0;
        this.originTracingClient = null;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        this.sendEvents = async (items, callback)=>{
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = {
                ...metricsPayload,
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: this.lastSendEventsError?.message || null,
                // Temporary back-compat
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: metadataInfo?.props || null,
                metadataClientMetrics: this.metadataClient?.metrics || null
            };
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                this.applyExclusions(item);
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $dEgKJ.sendEvents)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                this.originTracingClient?.cleanupOriginParameters(items);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $8xDw1.FetchError) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $dqbkU.LastError)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, $69bzU.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, $dqbkU.LastError)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        };
        this.options = {
            ...options,
            requestTimeout: options.requestTimeout || (0, $LpwjR.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        };
        this.user = new (0, $7tyuh.default)(this.options?.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $2n2nJ.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $fQIzY.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
}
class $fd5c17c26a3e147a$var$BatchInterceptor {
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                analyticsAPIResponse.validationReports?.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new (0, $ePnPr.EventResponse)(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new (0, $bl1Kz.AnalyticsResponse)(success, statusCode, (0, $9gfXY.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = analyticsAPIResponse.message?.error !== null ? analyticsAPIResponse.message.error : (0, $9gfXY.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $9gfXY.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $9gfXY.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new (0, $ePnPr.EventResponse)(item.msg.messageId, [], item.msg));
                });
                return new (0, $bl1Kz.AnalyticsResponse)(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error?.message) {
            const match = error.message.match($fd5c17c26a3e147a$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new (0, $ePnPr.EventResponse)(item.msg.messageId, [], item.msg));
                });
                return new (0, $bl1Kz.AnalyticsResponse)(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new (0, $ePnPr.EventResponse)(item.msg.messageId, [], item.msg));
        });
        return new (0, $bl1Kz.AnalyticsResponse)(false, -1, (0, $9gfXY.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}
$fd5c17c26a3e147a$var$BatchInterceptor.http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;

});
parcelRegister("fQIzY", function(module, exports) {
$parcel$export(module.exports, "default", () => $34c9aa37bf8f9b3d$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $fPqxy = parcelRequire("fPqxy");

var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$34c9aa37bf8f9b3d$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $fPqxy.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("fPqxy", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", () => $1365caad98bc3054$export$d219df4fe04c04a7);
$parcel$export(module.exports, "default", () => $1365caad98bc3054$export$2e2bcd8739ae039);

var $gbb0O = parcelRequire("gbb0O");

var $dFygM = parcelRequire("dFygM");

var $bzPIp = parcelRequire("bzPIp");

var $WP9XC = parcelRequire("WP9XC");

var $hpJxk = parcelRequire("hpJxk");

var $2n2nJ = parcelRequire("2n2nJ");

var $9XrmY = parcelRequire("9XrmY");

var $n3mSe = parcelRequire("n3mSe");

var $gr9S5 = parcelRequire("gr9S5");

var $iV3yc = parcelRequire("iV3yc");
const $1365caad98bc3054$var$ONE_MINUTE = 60000;
const $1365caad98bc3054$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $1365caad98bc3054$var$ONE_MINUTE,
    minRetryDelay: $1365caad98bc3054$var$ONE_MINUTE,
    maxRetryDelay: $1365caad98bc3054$var$ONE_MINUTE
};
const $1365caad98bc3054$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // The maximum number of events that can be stored in the resilience queue (IndexedDB/memory).
    // This limit is per product and is enforced by the EventCountGuard in the resilience layer.
    maxQueueSize: 8000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $1365caad98bc3054$export$2e2bcd8739ae039 {
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $WP9XC.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $iV3yc.NetworkStatusEnum).OFFLINE) {
            done((0, $gr9S5.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $hpJxk.CallbackProcessingErrorName)) {
                done((0, $gr9S5.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $gbb0O.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $dFygM.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $WP9XC.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $gr9S5.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $gr9S5.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $gr9S5.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || $1365caad98bc3054$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : $1365caad98bc3054$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || $1365caad98bc3054$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || $1365caad98bc3054$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || $1365caad98bc3054$export$d219df4fe04c04a7.flushWaitMs,
            maxQueueSize: options?.maxQueueSize || $1365caad98bc3054$export$d219df4fe04c04a7.maxQueueSize,
            maxAttempts: options?.maxAttempts || $1365caad98bc3054$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || $1365caad98bc3054$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || $1365caad98bc3054$export$d219df4fe04c04a7.minRetryDelay
        };
    }
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = void 0;
        this.resilience = void 0;
        this.batchFlushCallback = void 0;
        this.options = void 0;
        this.scheduler = void 0;
        this.longPollingScheduler = void 0;
        this.metricsCollector = void 0;
        this.networkStatus = void 0;
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $bzPIp.default)(product, {
            logger: logger,
            maxAttempts: options?.maxAttempts,
            maxEventLimit: options?.maxQueueSize || $1365caad98bc3054$export$d219df4fe04c04a7.maxQueueSize
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $n3mSe.default)({
            ...this.options,
            waitInterval: options?.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }, this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $n3mSe.default)({
            ...$1365caad98bc3054$var$LONG_POLLING_OPTIONS,
            waitInterval: $1365caad98bc3054$var$LONG_POLLING_OPTIONS.flushWaitMs
        }, this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $2n2nJ.default)();
        this.networkStatus = new (0, $9XrmY.default)((status)=>{
            if (status === (0, $iV3yc.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
}

});
parcelRegister("gbb0O", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ef23d9890c088e7$export$2e2bcd8739ae039);

var $cCEpa = parcelRequire("cCEpa");

var $jqOUC = parcelRequire("jqOUC");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $5ef23d9890c088e7$var$validSuffixs = Object.values((0, $cCEpa.LocalStorageKeySuffix));
var $5ef23d9890c088e7$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $5ef23d9890c088e7$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $cCEpa.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $jqOUC.createLocalStorageKeys)(prefix, id);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(queue);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimStart);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("cCEpa", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKeySuffix", () => $637c81b510de6fcb$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $637c81b510de6fcb$export$8bb2c1fb2b1765a9);
var $637c81b510de6fcb$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $637c81b510de6fcb$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("jqOUC", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageKeys", () => $eafa21130b0b7d8a$export$8433d54f767cbec5);

var $cCEpa = parcelRequire("cCEpa");
const $eafa21130b0b7d8a$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $cCEpa.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $cCEpa.LocalStorageKeySuffix).ACK}`,
        [(0, $cCEpa.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $cCEpa.LocalStorageKeySuffix).QUEUE}`,
        [(0, $cCEpa.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $cCEpa.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $cCEpa.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $cCEpa.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $cCEpa.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $cCEpa.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("dFygM", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac271ac4fead914e$export$2e2bcd8739ae039);

var $7avGr = parcelRequire("7avGr");

var $cCEpa = parcelRequire("cCEpa");

var $jqOUC = parcelRequire("jqOUC");
const $ac271ac4fead914e$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $ac271ac4fead914e$var$findOtherQueues = (queuePrefix)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $cCEpa.LocalStorageKeySuffix).ACK) try {
                // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $cCEpa.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch  {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch  {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $ac271ac4fead914e$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(ack, start.toString());
    await $ac271ac4fead914e$var$promisedSetTimeout((0, $cCEpa.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $cCEpa.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $ac271ac4fead914e$var$promisedSetTimeout((0, $cCEpa.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $cCEpa.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $ac271ac4fead914e$var$reclaim(options, callback);
};
const $ac271ac4fead914e$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = {
            ...item,
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        };
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $ac271ac4fead914e$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $ac271ac4fead914e$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $ac271ac4fead914e$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.queue);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.inProgress);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimEnd);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.ack);
};
var $ac271ac4fead914e$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, $7avGr.default)();
    const queuesToReclaim = $ac271ac4fead914e$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$ac271ac4fead914e$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $jqOUC.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});
parcelRegister("7avGr", function(module, exports) {
$parcel$export(module.exports, "default", () => $20791235a86c8eed$export$2e2bcd8739ae039);
// UUID v4 generator with fallback for non-secure contexts
function $20791235a86c8eed$export$2e2bcd8739ae039() {
    const g = globalThis;
    try {
        if (g.crypto && typeof g.crypto.randomUUID === 'function') return g.crypto.randomUUID();
    } catch  {
    // ignore and fallback
    }
    // Fallback to Math.random-based v4 UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.floor(Math.random() * 16);
        const v = c === 'x' ? r : r & 0x3 | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
        return v.toString(16);
    });
}

});


parcelRegister("bzPIp", function(module, exports) {
$parcel$export(module.exports, "default", () => $41491b422e3b7614$export$2e2bcd8739ae039);

var $1u4Ks = parcelRequire("1u4Ks");
var $41491b422e3b7614$export$2e2bcd8739ae039 = (0, $1u4Ks.default);

});
parcelRegister("1u4Ks", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f94300ea3641056$export$2e2bcd8739ae039);

var $WP9XC = parcelRequire("WP9XC");

var $fajSt = parcelRequire("fajSt");

var $9dgpd = parcelRequire("9dgpd");

var $f5c01 = parcelRequire("f5c01");

var $cS0PM = parcelRequire("cS0PM");

var $gXEDC = parcelRequire("gXEDC");
class $6f94300ea3641056$export$2e2bcd8739ae039 {
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $cS0PM.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $9dgpd.default))) options.logger?.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
        }
        return new (0, $gXEDC.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $WP9XC.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $WP9XC.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $f5c01.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $WP9XC.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $gXEDC.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $WP9XC.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
    constructor(namespace, options = {}){
        this.resilience = void 0;
        this.options = void 0;
        this.namespace = void 0;
        this.namespace = namespace;
        this.options = (0, $fajSt.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
}

});
parcelRegister("WP9XC", function(module, exports) {
$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $430edf403dbcfa6c$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $430edf403dbcfa6c$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $430edf403dbcfa6c$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $430edf403dbcfa6c$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $430edf403dbcfa6c$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $430edf403dbcfa6c$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $430edf403dbcfa6c$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $430edf403dbcfa6c$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $430edf403dbcfa6c$export$7710d69e6f450f20);
const $430edf403dbcfa6c$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $430edf403dbcfa6c$export$8cad224051643259 = 'analytics-web-client';
const $430edf403dbcfa6c$export$3d8420be07b276ab = 'analytics-resilience';
const $430edf403dbcfa6c$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $430edf403dbcfa6c$export$89d9c1ff8ac91862 = 'timeAdded';
const $430edf403dbcfa6c$export$a37d385bcd713809 = 'retryAttempts';
const $430edf403dbcfa6c$export$6d8635fed0e4b14d = 15000;
var $430edf403dbcfa6c$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $430edf403dbcfa6c$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("fajSt", function(module, exports) {
$parcel$export(module.exports, "createOptionsWithDefaults", () => $eff42fad80d22905$export$ddc6718318090f71);

var $wjnTI = parcelRequire("wjnTI");
const $eff42fad80d22905$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $wjnTI.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $wjnTI.EVENT_COUNT_LIMIT)
    });

});
parcelRegister("wjnTI", function(module, exports) {
$parcel$export(module.exports, "GET_ITEM_COUNT", () => $9751e3122c3b3329$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $9751e3122c3b3329$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $9751e3122c3b3329$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $9751e3122c3b3329$export$1188664dfff364c8);
const $9751e3122c3b3329$export$b6df3d334cec060f = 7;
const $9751e3122c3b3329$export$14ef152a03a4b6ee = 60000;
const $9751e3122c3b3329$export$da9ab7b2fd5998e8 = 10;
const $9751e3122c3b3329$export$1188664dfff364c8 = 8000;

});


parcelRegister("9dgpd", function(module, exports) {
$parcel$export(module.exports, "default", () => $680a07b407dd2002$export$2e2bcd8739ae039);
const $680a07b407dd2002$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $680a07b407dd2002$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $680a07b407dd2002$export$2e2bcd8739ae039.prototype);
        this.name = $680a07b407dd2002$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("f5c01", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $0063a5c5d8111080$export$74101021e0969375);

var $rE0e3 = parcelRequire("rE0e3");

var $hpJxk = parcelRequire("hpJxk");

var $fsUTp = parcelRequire("fsUTp");
const $0063a5c5d8111080$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $rE0e3.AbandonWriteErrorName) || errorWithName.name === (0, $hpJxk.CallbackProcessingErrorName) || errorWithName.name === (0, $fsUTp.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("rE0e3", function(module, exports) {
$parcel$export(module.exports, "AbandonWriteErrorName", () => $31dddb955dbf490d$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $31dddb955dbf490d$export$2e2bcd8739ae039);
const $31dddb955dbf490d$export$ba95206613c96b28 = 'AbandonWriteError';
class $31dddb955dbf490d$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $31dddb955dbf490d$export$2e2bcd8739ae039.prototype);
        this.name = $31dddb955dbf490d$export$ba95206613c96b28;
    }
}

});

parcelRegister("hpJxk", function(module, exports) {
$parcel$export(module.exports, "CallbackProcessingErrorName", () => $69adb7f6b0bc371f$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $69adb7f6b0bc371f$export$2e2bcd8739ae039);
const $69adb7f6b0bc371f$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $69adb7f6b0bc371f$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $69adb7f6b0bc371f$export$2e2bcd8739ae039.prototype);
        this.name = $69adb7f6b0bc371f$export$a409c8de90e11e14;
    }
}

});

parcelRegister("fsUTp", function(module, exports) {
$parcel$export(module.exports, "InvalidPolicyErrorName", () => $ddd05b6b3b82f59f$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $ddd05b6b3b82f59f$export$2e2bcd8739ae039);
const $ddd05b6b3b82f59f$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $ddd05b6b3b82f59f$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $ddd05b6b3b82f59f$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("cS0PM", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8ac5f282867f1e6$export$2e2bcd8739ae039);

var $aPYsr = parcelRequire("aPYsr");

var $WP9XC = parcelRequire("WP9XC");

var $fZn3L = parcelRequire("fZn3L");

var $fajSt = parcelRequire("fajSt");

var $wjnTI = parcelRequire("wjnTI");

var $hpJxk = parcelRequire("hpJxk");

var $fsUTp = parcelRequire("fsUTp");

var $9dgpd = parcelRequire("9dgpd");

var $f5c01 = parcelRequire("f5c01");

var $4LRVo = parcelRequire("4LRVo");

var $1xXZ1 = parcelRequire("1xXZ1");

var $lOepC = parcelRequire("lOepC");
class $b8ac5f282867f1e6$export$2e2bcd8739ae039 {
    storeType() {
        return (0, $WP9XC.StoreType).INDEXEDDB;
    }
    constructor(_namespace, _options = {}){
        this.db = void 0;
        this.logger = void 0;
        this.globalEventLimitGuard = void 0;
        this.options = void 0;
        this.namespace = void 0;
        this.startDB = async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $9dgpd.default)());
                    }, (0, $WP9XC.INDEXEDDB_TIMEOUT));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $WP9XC.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $WP9XC.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $WP9XC.TIME_TO_PROCESS_AFTER_INDEX), (0, $WP9XC.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $WP9XC.RETRY_INDEX), (0, $WP9XC.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $WP9XC.TIME_ADDED_INDEX), (0, $WP9XC.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $WP9XC.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $9dgpd.default)());
                    };
                    try {
                        await (0, $lOepC.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $9dgpd.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $9dgpd.default)());
                }
            });
        };
        this.addItem = async (item, options = {}, policy = (0, $WP9XC.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $fZn3L.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $WP9XC.GuardPolicy).IGNORE) throw new (0, $fsUTp.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $f5c01.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.bulkAddItem = async (itemOptions, policy = (0, $WP9XC.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map(({ item: item, ...options })=>(0, $fZn3L.convertToItemWrapper)(item, namespace, options));
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $f5c01.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.getItems = async (count = (0, $wjnTI.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $wjnTI.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $WP9XC.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = {
                            ...cursor.value
                        };
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $wjnTI.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $1xXZ1.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $1xXZ1.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $aPYsr.commitTransaction)(transaction, this.logger);
            return getResult;
        };
        this.deleteItems = async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $aPYsr.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        this.getItemCount = async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $WP9XC.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $lOepC.requestToPromise)(request);
            await (0, $aPYsr.commitTransaction)(transaction, this.logger);
            return event.target.result;
        };
        this.processItems = async (processFn, count = (0, $wjnTI.GET_ITEM_COUNT))=>{
            const { items: items, ...partialResult } = await this.getItems(count);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $hpJxk.default)(error);
            }
        };
        this.deleteItem = async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $lOepC.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        };
        this.getObjectStoreAndTransaction = async (mode)=>{
            const transaction = (await this.db).transaction((0, $WP9XC.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $WP9XC.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        };
        this.options = (0, $fajSt.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $9dgpd.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $4LRVo.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
}

});
parcelRegister("aPYsr", function(module, exports) {
$parcel$export(module.exports, "commitTransaction", () => $8d85af169fc9f375$export$feab8418f018df89);

var $5E7ga = parcelRequire("5E7ga");
const $8d85af169fc9f375$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return (0, $5E7ga.transactionToPromise)(transaction);
};

});
parcelRegister("5E7ga", function(module, exports) {
$parcel$export(module.exports, "transactionToPromise", () => $694b6b72e0f472c4$export$2a5213bce1720b42);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $694b6b72e0f472c4$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};

});


parcelRegister("fZn3L", function(module, exports) {
$parcel$export(module.exports, "convertToItemWrapper", () => $ddc5bb377e8b7966$export$aec476f33d77be11);

var $7avGr = parcelRequire("7avGr");
const $ddc5bb377e8b7966$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, $7avGr.default)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });

});

parcelRegister("4LRVo", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7fd2aa91d315e4c$export$2e2bcd8739ae039);

var $aPYsr = parcelRequire("aPYsr");

var $WP9XC = parcelRequire("WP9XC");

var $rE0e3 = parcelRequire("rE0e3");

var $lOepC = parcelRequire("lOepC");
class $d7fd2aa91d315e4c$export$2e2bcd8739ae039 {
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $WP9XC.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $WP9XC.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $WP9XC.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $WP9XC.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $lOepC.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $aPYsr.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $rE0e3.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $WP9XC.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $lOepC.requestToPromise)(request);
        return event.target.result;
    }
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        this.eventLimit = void 0;
        this.namespace = void 0;
        this.logger = void 0;
        this.deleteItemHandler = void 0;
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ this.deleteOldestNEvents = async (objectStore, count)=>{
            const productTimeAddedIndex = objectStore.index((0, $WP9XC.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $lOepC.requestToPromise)(getAllRequest);
            const result = event?.target?.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
}

});
parcelRegister("lOepC", function(module, exports) {
$parcel$export(module.exports, "requestToPromise", () => $04f22c9f0d248d08$export$85ceed0783e42041);
// Not to be used on cursors or other requests that may call onsuccess multiple times.
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $04f22c9f0d248d08$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};

});


parcelRegister("1xXZ1", function(module, exports) {
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $c6824f72bd7dae4b$export$342d941b6f724995);
const $c6824f72bd7dae4b$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});


parcelRegister("gXEDC", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c8679fd319ff38e$export$2e2bcd8739ae039);

var $WP9XC = parcelRequire("WP9XC");

var $fZn3L = parcelRequire("fZn3L");

var $fajSt = parcelRequire("fajSt");

var $wjnTI = parcelRequire("wjnTI");

var $hpJxk = parcelRequire("hpJxk");

var $fsUTp = parcelRequire("fsUTp");

var $hwC2R = parcelRequire("hwC2R");
class $9c8679fd319ff38e$export$2e2bcd8739ae039 {
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $WP9XC.GuardPolicy).ABANDON) {
        if (policy === (0, $WP9XC.GuardPolicy).IGNORE) throw new (0, $fsUTp.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $fZn3L.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $WP9XC.GuardPolicy).ABANDON) {
        const items = itemOptions.map(({ item: item, ...addOptions })=>(0, $fZn3L.convertToItemWrapper)(item, this.namespace, addOptions));
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $WP9XC.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $wjnTI.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $wjnTI.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $wjnTI.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push({
                    ...wrappedItem
                });
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $wjnTI.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $hpJxk.default)(error);
        }
    }
    storeType() {
        return (0, $WP9XC.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
    constructor(namespace, options = {}){
        this.memoryStore = void 0;
        this.options = void 0;
        this.globalEventLimitGuard = void 0;
        this.namespace = void 0;
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $fajSt.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $hwC2R.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
}

});
parcelRegister("hwC2R", function(module, exports) {
$parcel$export(module.exports, "default", () => $14f43b9a70815a1a$export$2e2bcd8739ae039);

var $WP9XC = parcelRequire("WP9XC");

var $rE0e3 = parcelRequire("rE0e3");
class $14f43b9a70815a1a$export$2e2bcd8739ae039 {
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $rE0e3.default)((0, $WP9XC.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
    constructor(eventLimit, memoryItemHandlers){
        this.eventLimit = void 0;
        this.memoryItemHandlers = void 0;
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $WP9XC.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $WP9XC.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $WP9XC.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
}

});




parcelRegister("2n2nJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bee0d8d8f88f2d96$export$2e2bcd8739ae039);

var $5inlg = parcelRequire("5inlg");
let $bee0d8d8f88f2d96$var$cachedMetricsClient = null;
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$bee0d8d8f88f2d96$export$2e2bcd8739ae039 = ()=>{
    if (!$bee0d8d8f88f2d96$var$cachedMetricsClient) $bee0d8d8f88f2d96$var$cachedMetricsClient = new (0, $5inlg.MetricsCollector)();
    return $bee0d8d8f88f2d96$var$cachedMetricsClient;
};

});
parcelRegister("5inlg", function(module, exports) {
$parcel$export(module.exports, "MetricsCollector", () => $be8e67fba912fdc6$export$4b62ee5120ab50a8);

var $iV3yc = parcelRequire("iV3yc");
class $be8e67fba912fdc6$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        this.itemsDiscardedByRetry = 0;
        // Number of events created by the product in current tab.
        this.eventCount = 0;
        // Number of events discarded due to reaching queue max size.
        this.itemsDiscardedByOverflow = 0;
        // Will be used in the future when we get more resilience mechanisms
        this.resilienceMechanism = (0, $iV3yc.ResilienceMechanism).INDEXEDDB;
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        this.localstorageNumberOfQueuesPurged = 0;
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        this.localstorageNumberOfFullReclaims = 0;
        // Queue was found but not all events were able to be put into resilienceDb.
        this.localstorageNumberOfPartialReclaims = 0;
        // Reclaim failed for a queue and reclaim was abandonded.
        this.localstorageNumberOfFailedReclaims = 0;
    }
}

});
parcelRegister("iV3yc", function(module, exports) {
$parcel$export(module.exports, "ResilienceMechanism", () => $d28ea69024011727$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $d28ea69024011727$export$ee138fa712d11b84);
var $d28ea69024011727$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $d28ea69024011727$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});



parcelRegister("9XrmY", function(module, exports) {
$parcel$export(module.exports, "default", () => $540d329de5d5aab5$export$2e2bcd8739ae039);

var $iV3yc = parcelRequire("iV3yc");
class $540d329de5d5aab5$export$2e2bcd8739ae039 {
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $iV3yc.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $iV3yc.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $iV3yc.NetworkStatusEnum).ONLINE;
        return (0, $iV3yc.NetworkStatusEnum).OFFLINE;
    }
    constructor(networkChangeCallback){
        this._networkChangeCallback = void 0;
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $iV3yc.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $iV3yc.NetworkStatusEnum).ONLINE));
        }
    }
}

});

parcelRegister("n3mSe", function(module, exports) {
$parcel$export(module.exports, "default", () => $506fb0b5b96ccb3f$export$2e2bcd8739ae039);

var $4ifeT = parcelRequire("4ifeT");

var $gr9S5 = parcelRequire("gr9S5");
const $506fb0b5b96ccb3f$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $506fb0b5b96ccb3f$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $506fb0b5b96ccb3f$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        this.callback = void 0;
        this.failureCount = void 0;
        this.operationInFlight = void 0;
        this.options = void 0;
        this.queuedSchedule = void 0;
        this.scheduledTimeout = void 0;
        this.callbackTimer = void 0;
        this.schedule = ({ immediate: immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = 1;
                else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Calculate backoff for normal or failure scenario
            } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
        };
        this.stop = ()=>{
            this.clearTimeout();
            this.queuedSchedule = 0;
        };
        this.getFailureCount = ()=>this.failureCount;
        this.getCallbackStatus = ()=>{
            return this.callbackTimer.getCallbackStatus();
        };
        this.clearTimeout = ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        };
        this.run = ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $gr9S5.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        };
        this.done = (state)=>{
            this.operationInFlight = false;
            if (state === (0, $gr9S5.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $4ifeT.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $gr9S5.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        };
        this.processQueuedSchedule = ()=>{
            if (this.queuedSchedule !== 0) {
                const immediate = this.queuedSchedule === 1;
                this.queuedSchedule = 0;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        };
        this.calculateBackoff = ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage, waitInterval: waitInterval } = this.options;
            // Helper for deviation based on a single random sample
            const jitter = (base, symmetric)=>{
                if (!backoffJitterPercentage || base <= 0) return 0;
                const r = (Math.random() - 0.5) * 2;
                const frac = symmetric ? r : Math.abs(r);
                return Math.floor(frac * backoffJitterPercentage * base);
            };
            // No failures: wait interval with positive-only jitter
            if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
            // Failures: exponential backoff with symmetric jitter
            const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
            const withJitter = base + jitter(base, true);
            return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
        };
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $506fb0b5b96ccb3f$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $506fb0b5b96ccb3f$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $506fb0b5b96ccb3f$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $506fb0b5b96ccb3f$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $506fb0b5b96ccb3f$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $506fb0b5b96ccb3f$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = 0;
        this.callbackTimer = new (0, $4ifeT.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("4ifeT", function(module, exports) {
$parcel$export(module.exports, "CallbackStatus", () => $5d7fa128dc22e61a$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $5d7fa128dc22e61a$export$590a718599f8f8b3);
var $5d7fa128dc22e61a$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $5d7fa128dc22e61a$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $5d7fa128dc22e61a$export$590a718599f8f8b3 {
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case "idle":
            case "timedOut":
            case "completed":
                if (event === "execute") this.callbackStatus = "running";
                break;
            case "running":
                switch(event){
                    case "complete":
                        this.callbackStatus = "completed";
                        break;
                    case "timeout":
                        this.callbackStatus = "timedOut";
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, "execute");
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, "timeout");
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== "timedOut") {
                this.transitionCallbackStatus(this.callbackStatus, "complete");
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
    constructor(timeoutPeriod){
        // Milliseconds to wait
        this.timeoutPeriod = void 0;
        // Tracks the settimeout; so that we can clear the timeout
        this.timeoutHandle = undefined;
        this.callbackStatus = "idle";
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
}

});

parcelRegister("gr9S5", function(module, exports) {
$parcel$export(module.exports, "DoneState", () => $ce85ee572987a045$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $ce85ee572987a045$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("agQKt", function(module, exports) {
$parcel$export(module.exports, "attachXidToMultipleEvents", () => $7a524e7ccff86292$export$c21270cab66ab290);

var $3wnRi = parcelRequire("3wnRi");
async function $7a524e7ccff86292$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>(0, $3wnRi.attachXidToSingleEvent)(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("3wnRi", function(module, exports) {
$parcel$export(module.exports, "attachXidToSingleEvent", () => $8f89ef2cf4127d14$export$c9c3aaf655d6f275);

var $69bzU = parcelRequire("69bzU");
function $8f89ef2cf4127d14$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $69bzU.SegmentEventTypes).PAGE || item.msg.type === (0, $69bzU.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = {
            ...item.msg.properties,
            xid: xid
        };
    } else if (item.msg.traits && item.msg.type === (0, $69bzU.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = {
            ...item.msg.traits,
            xid: xid
        };
    }
    return item;
}

});
parcelRegister("69bzU", function(module, exports) {
$parcel$export(module.exports, "SegmentEventTypes", () => $56b1fcbd875ee866$export$ddf929981dc6feb3);
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", () => $56b1fcbd875ee866$export$96f086dcf574a9e2);
var $56b1fcbd875ee866$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $56b1fcbd875ee866$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $56b1fcbd875ee866$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
const $56b1fcbd875ee866$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];

});



parcelRegister("bl1Kz", function(module, exports) {
$parcel$export(module.exports, "AnalyticsResponse", () => $91370196b9e64f9d$export$133650fcdde1b226);
class $91370196b9e64f9d$export$133650fcdde1b226 {
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
    constructor(success, statusCode, message, eventResponseList){
        this.success = void 0;
        this.statusCode = void 0;
        this.message = void 0;
        this.eventResponseList = void 0;
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
}

});

parcelRegister("4UAZD", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $574ae150faddf416$export$3a7fe28f9bf4f3d9);

var $79l3e = parcelRequire("79l3e");
// Shallow removal of all falsey properties from an object, returning a new object.
const $574ae150faddf416$var$removeFalseyProperties = (obj)=>{
    const result = {};
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) // If the value is not strictly true, map it to undefined
        {
            if (obj[key]) result[key] = obj[key];
        }
    }
    return result;
};
const $574ae150faddf416$export$3a7fe28f9bf4f3d9 = (context, overrides)=>{
    const result = {
        ...context.context,
        userAgent: navigator.userAgent
    };
    // use nestedRemoveUndefinedValues to strip undefined properties before
    // spreading the override object since we want properties that explicitly
    // set to 'undefined' to not overwrite any values, just like properties
    // that are 'undefined' because they're not set at all will.
    if (overrides?.excludedProperties) result.excludedProperties = {
        ...result.excludedProperties,
        ...(0, $79l3e.nestedRemoveUndefinedValues)(overrides.excludedProperties, '$.excludedProperties')
    };
    if (overrides?.userConsents) result.userConsents = {
        ...result.userConsents,
        ...(0, $79l3e.nestedRemoveUndefinedValues)(overrides.userConsents, '$.userConsents')
    };
    // Remove any falsey properties since we only want to have exclusions
    // that were explicitly declared as excluded.
    if (result.excludedProperties) result.excludedProperties = $574ae150faddf416$var$removeFalseyProperties(result.excludedProperties);
    return result;
};

});
parcelRegister("79l3e", function(module, exports) {
$parcel$export(module.exports, "nestedRemoveUndefinedValues", () => $54b4e0c0a952df93$export$2250ccecd1e040fd);
const $54b4e0c0a952df93$export$2250ccecd1e040fd = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

});


parcelRegister("LpwjR", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $d04a8b1800fc64ac$export$9175ce0e1c95daf2);
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", () => $d04a8b1800fc64ac$export$8fddcd1eff390364);
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", () => $d04a8b1800fc64ac$export$92ed669a3d41dad3);
$parcel$export(module.exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", () => $d04a8b1800fc64ac$export$6649d5c857717efe);
$parcel$export(module.exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", () => $d04a8b1800fc64ac$export$33e7628d3b2c0e2);
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", () => $d04a8b1800fc64ac$export$6f1c008dd0c3b67e);
const $d04a8b1800fc64ac$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $d04a8b1800fc64ac$export$8fddcd1eff390364 = 60000; // 60 seconds
const $d04a8b1800fc64ac$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $d04a8b1800fc64ac$export$6649d5c857717efe = 5000; // 5 seconds
const $d04a8b1800fc64ac$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
const $d04a8b1800fc64ac$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("ePnPr", function(module, exports) {
$parcel$export(module.exports, "EventResponse", () => $64ff8700485f2f1b$export$51e0b986fdbf3840);
class $64ff8700485f2f1b$export$51e0b986fdbf3840 {
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
    constructor(messageId, results, segmentEvent){
        this.messageId = void 0;
        this.results = void 0;
        this.segmentEvent = void 0;
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
}

});

parcelRegister("8xDw1", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $208d6e09236e31b5$export$26e841bcf1aeb894);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
class $208d6e09236e31b5$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = void 0;
        this.statusText = void 0;
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}

});

parcelRegister("9gfXY", function(module, exports) {
$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $cc1681188ea594c1$export$ba118f9de1e5ac63);
const $cc1681188ea594c1$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("dqbkU", function(module, exports) {
$parcel$export(module.exports, "LastError", () => $1649a3d6e49b5000$export$a63e16b3351b8c36);

var $8xDw1 = parcelRequire("8xDw1");
class $1649a3d6e49b5000$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = void 0;
        this.message = void 0;
        this.statusCode = void 0;
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof (0, $8xDw1.FetchError) ? error.statusCode : null;
    }
}

});

parcelRegister("7h22H", function(module, exports) {
$parcel$export(module.exports, "prepareEventContext", () => $0c25bcdf772da1d1$export$6b26e26d40264200);
// @ts-ignore

var $cWKPS = parcelRequire("cWKPS");

var $79l3e = parcelRequire("79l3e");
const $0c25bcdf772da1d1$export$6b26e26d40264200 = (context)=>{
    const propertiesWithoutUndefined = (0, $79l3e.nestedRemoveUndefinedValues)(context, '$.context');
    return (0, (/*@__PURE__*/$parcel$interopDefault($cWKPS)))(propertiesWithoutUndefined);
};

});
parcelRegister("cWKPS", function(module, exports) {
'use strict';

var $iV6f3 = parcelRequire("iV6f3");
/**
 * Expose `traverse`.
 */ module.exports = $96cf3b6f1aa74a12$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $96cf3b6f1aa74a12$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $96cf3b6f1aa74a12$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $96cf3b6f1aa74a12$var$traverseArray(input, strict);
    else if ($iV6f3.is(input, strict)) return $iV6f3.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $96cf3b6f1aa74a12$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $96cf3b6f1aa74a12$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $96cf3b6f1aa74a12$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $96cf3b6f1aa74a12$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("iV6f3", function(module, exports) {
$parcel$export(module.exports, "parse", () => $dc62645649b7218a$export$98e6a39c04603d36, (v) => $dc62645649b7218a$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "is", () => $dc62645649b7218a$export$226b3eccf92c9ed9, (v) => $dc62645649b7218a$export$226b3eccf92c9ed9 = v);
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $dc62645649b7218a$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $dc62645649b7218a$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $dc62645649b7218a$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$dc62645649b7218a$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $dc62645649b7218a$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$dc62645649b7218a$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $dc62645649b7218a$var$matcher.test(string);
};

});



parcelRegister("5GxeR", function(module, exports) {
$parcel$export(module.exports, "prepareEventProperties", () => $89fef9001f775648$export$44d22e5fb02cc68e);
// @ts-ignore

var $cWKPS = parcelRequire("cWKPS");

var $79l3e = parcelRequire("79l3e");
const $89fef9001f775648$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = (0, $79l3e.nestedRemoveUndefinedValues)(properties, '$.properties');
    // Remove any override properties that shouldn't be included in the event body
    delete propertiesWithoutUndefined.excludedProperties;
    delete propertiesWithoutUndefined.userConsents;
    return (0, (/*@__PURE__*/$parcel$interopDefault($cWKPS)))(propertiesWithoutUndefined);
};

});

parcelRegister("dEgKJ", function(module, exports) {
$parcel$export(module.exports, "sendEvents", () => $8876a01d7b38316e$export$8e8f0180c1b41fad);

var $aLoS2 = parcelRequire("aLoS2");

var $8xDw1 = parcelRequire("8xDw1");
const $8876a01d7b38316e$export$8e8f0180c1b41fad = async (options)=>{
    const signal = $8876a01d7b38316e$var$createOrGetAbortController(options)?.signal;
    const corsOptions = $8876a01d7b38316e$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, {
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal,
        ...corsOptions
    });
    if (response.status !== 200) throw new (0, $8xDw1.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    try {
        let responseBody = await response.clone().json();
        if (responseBody.success === true) return response;
    } catch  {}
    throw new (0, $8xDw1.FetchError)('Invalid HTTP Response (Invalid response body)', 200, 'Invalid response body');
};
const $8876a01d7b38316e$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $8876a01d7b38316e$var$getCorsForUrl = (0, $aLoS2.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});
parcelRegister("aLoS2", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d6195f75a344905$export$2e2bcd8739ae039);
var $7d6195f75a344905$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $7d6195f75a344905$var$isEqual(first, second) {
    if (first === second) return true;
    if ($7d6195f75a344905$var$safeIsNaN(first) && $7d6195f75a344905$var$safeIsNaN(second)) return true;
    return false;
}
function $7d6195f75a344905$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$7d6195f75a344905$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $7d6195f75a344905$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $7d6195f75a344905$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("7tyuh", function(module, exports) {
$parcel$export(module.exports, "default", () => $199882ef86a980b2$export$2e2bcd8739ae039);

var $6png6 = parcelRequire("6png6");

var $6WGyt = parcelRequire("6WGyt");

var $fbsHh = parcelRequire("fbsHh");

var $1a2cY = parcelRequire("1a2cY");

var $7avGr = parcelRequire("7avGr");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $199882ef86a980b2$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $199882ef86a980b2$var$SAFE = 'SAFE';
const $199882ef86a980b2$var$UNSAFE = 'UNSAFE';
const $199882ef86a980b2$var$NOT_FOUND = 'NOT_FOUND';
const $199882ef86a980b2$var$COOKIE = 'COOKIE';
const $199882ef86a980b2$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $199882ef86a980b2$export$2e2bcd8739ae039 {
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $6WGyt.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $6WGyt.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $199882ef86a980b2$var$LOCAL_STORAGE ? this.store.getItem((0, $6WGyt.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $6WGyt.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $199882ef86a980b2$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $199882ef86a980b2$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch  {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $199882ef86a980b2$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($199882ef86a980b2$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $6png6.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $199882ef86a980b2$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $199882ef86a980b2$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $199882ef86a980b2$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $199882ef86a980b2$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($199882ef86a980b2$var$COOKIE);
        switch(cookieValue.type){
            case $199882ef86a980b2$var$SAFE:
            case $199882ef86a980b2$var$UNSAFE:
                this.store.setItem((0, $6WGyt.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $199882ef86a980b2$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : ()=>{
            return (0, $7avGr.default)();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
    constructor(disableCookiePersistence){
        this.store = void 0;
        this.cookie = void 0;
        this.userId = void 0;
        this.lastAnonymousIdCookieUpdate = void 0;
        this.store = new (0, $1a2cY.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $fbsHh.default)(disableCookiePersistence);
    }
}

});
parcelRegister("6png6", function(module, exports) {
$parcel$export(module.exports, "default", () => $4aa71e942b3ee21d$export$2e2bcd8739ae039);

var $llP29 = parcelRequire("llP29");

var $hXMVA = parcelRequire("hXMVA");

var $4NMsf = parcelRequire("4NMsf");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $4aa71e942b3ee21d$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $4aa71e942b3ee21d$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4NMsf.default)(2, arguments);
    var dateLeft = (0, $llP29.default)(dirtyDateLeft);
    var dateRight = (0, $llP29.default)(dirtyDateRight);
    var sign = $4aa71e942b3ee21d$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $hXMVA.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($4aa71e942b3ee21d$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("llP29", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8b32562d2427ab3$export$2e2bcd8739ae039);

var $kl0Zn = parcelRequire("kl0Zn");

var $4NMsf = parcelRequire("4NMsf");
function $f8b32562d2427ab3$export$2e2bcd8739ae039(argument) {
    (0, $4NMsf.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $kl0Zn.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("kl0Zn", function(module, exports) {
$parcel$export(module.exports, "default", () => $ece6893067e34688$export$2e2bcd8739ae039);
function $ece6893067e34688$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $ece6893067e34688$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ece6893067e34688$export$2e2bcd8739ae039(o);
}

});

parcelRegister("4NMsf", function(module, exports) {
$parcel$export(module.exports, "default", () => $37f15315fc614e2c$export$2e2bcd8739ae039);
function $37f15315fc614e2c$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("hXMVA", function(module, exports) {
$parcel$export(module.exports, "default", () => $d13de66753f50b40$export$2e2bcd8739ae039);

var $35nTK = parcelRequire("35nTK");

var $iueHw = parcelRequire("iueHw");

var $4NMsf = parcelRequire("4NMsf");
var $d13de66753f50b40$var$MILLISECONDS_IN_DAY = 86400000;
function $d13de66753f50b40$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4NMsf.default)(2, arguments);
    var startOfDayLeft = (0, $iueHw.default)(dirtyDateLeft);
    var startOfDayRight = (0, $iueHw.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $35nTK.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $35nTK.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $d13de66753f50b40$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("35nTK", function(module, exports) {
$parcel$export(module.exports, "default", () => $23f4606384bffb4a$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $23f4606384bffb4a$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("iueHw", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7566ea08bd19e9d$export$2e2bcd8739ae039);

var $llP29 = parcelRequire("llP29");

var $4NMsf = parcelRequire("4NMsf");
function $d7566ea08bd19e9d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4NMsf.default)(1, arguments);
    var date = (0, $llP29.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("6WGyt", function(module, exports) {
$parcel$export(module.exports, "AWCCookiesKeys", () => $e8774e11cb66deb3$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $e8774e11cb66deb3$export$d4cb17942ea57c95);
var $e8774e11cb66deb3$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $e8774e11cb66deb3$var$CookieSchema {
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
    constructor(key, options){
        this.key = void 0;
        this.options = void 0;
        this.key = key;
        this.options = options;
    }
}
const $e8774e11cb66deb3$var$isSecure = ()=>{
    try {
        return globalThis && globalThis.location && globalThis.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $e8774e11cb66deb3$export$d4cb17942ea57c95 = {
    ["AWC_TLD_TEST"]: new $e8774e11cb66deb3$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $e8774e11cb66deb3$var$isSecure(),
        path: '/'
    }),
    ["AWC_ANALYTICS_DEBUG"]: new $e8774e11cb66deb3$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $e8774e11cb66deb3$var$isSecure(),
        path: '/'
    }),
    ["AJS_ANONYMOUS_ID"]: new $e8774e11cb66deb3$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $e8774e11cb66deb3$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("fbsHh", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b6ebf2dbc144278$export$2e2bcd8739ae039);

var $eWNrv = parcelRequire("eWNrv");

var $6WGyt = parcelRequire("6WGyt");

var $jGr7d = parcelRequire("jGr7d");

var $h7h8C = parcelRequire("h7h8C");
class $2b6ebf2dbc144278$export$2e2bcd8739ae039 {
    set(name, value, options) {
        // no-op
        if (!(0, $6WGyt.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $6WGyt.AllAnalyticsCookies)[name].getKey(), value, {
            ...(0, $6WGyt.AllAnalyticsCookies)[name].getAttributes(),
            // Function is memoized so we only calculate this once per page load
            domain: (0, $h7h8C.getTld)(),
            ...options
        });
    }
    get(name) {
        if (!(0, $6WGyt.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $6WGyt.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $6WGyt.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $6WGyt.AllAnalyticsCookies)[name].getKey(), {
            ...options
        });
    }
    constructor(disableCookiePersistence){
        this.cookieLike = void 0;
        this.cookieLike = (0, $h7h8C.canUseCookie)(disableCookiePersistence) ? (0, $eWNrv.default) : new (0, $jGr7d.default)();
    }
}

});
parcelRegister("eWNrv", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae1cd5c2df40e93c$export$2e2bcd8739ae039);
/*! js-cookie v3.0.8 | MIT */ function $ae1cd5c2df40e93c$var$assign(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source){
            if (key === '__proto__') continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $ae1cd5c2df40e93c$var$defaultConverter = {
    read: function(value) {
        if (value[0] === '"') value = value.slice(1, -1);
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
function $ae1cd5c2df40e93c$var$init(converter, defaultAttributes) {
    function set(name, value, attributes) {
        if (typeof document === 'undefined') return;
        attributes = $ae1cd5c2df40e93c$var$assign({}, defaultAttributes, attributes);
        if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
        if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
        name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var stringifiedAttributes = '';
        for(var attributeName in attributes){
            if (!attributes[attributeName]) continue;
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) continue;
            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }
        return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
    }
    function get(name) {
        if (typeof document === 'undefined' || arguments.length && !name) return;
        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.
        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var jar = {};
        for(var i = 0; i < cookies.length; i++){
            var parts = cookies[i].split('=');
            var value = parts.slice(1).join('=');
            try {
                var found = decodeURIComponent(parts[0]);
                if (!(found in jar)) jar[found] = converter.read(value, found);
                if (name === found) break;
            } catch (_e) {
            // Do nothing...
            }
        }
        return name ? jar[name] : jar;
    }
    return Object.create({
        set: set,
        get: get,
        remove: function(name, attributes) {
            set(name, '', $ae1cd5c2df40e93c$var$assign({}, attributes, {
                expires: -1
            }));
        },
        withAttributes: function(attributes) {
            return $ae1cd5c2df40e93c$var$init(this.converter, $ae1cd5c2df40e93c$var$assign({}, this.attributes, attributes));
        },
        withConverter: function(converter) {
            return $ae1cd5c2df40e93c$var$init($ae1cd5c2df40e93c$var$assign({}, this.converter, converter), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(defaultAttributes)
        },
        converter: {
            value: Object.freeze(converter)
        }
    });
}
var $ae1cd5c2df40e93c$export$2e2bcd8739ae039 = $ae1cd5c2df40e93c$var$init($ae1cd5c2df40e93c$var$defaultConverter, {
    path: '/'
});

});

parcelRegister("jGr7d", function(module, exports) {
$parcel$export(module.exports, "default", () => $61afbbe05b6df834$export$2e2bcd8739ae039);

var $1a2cY = parcelRequire("1a2cY");
class $61afbbe05b6df834$export$2e2bcd8739ae039 {
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
    constructor(){
        this.safeStorage = void 0;
        this.safeStorage = new (0, $1a2cY.default)({
            useStoragePrefix: false
        });
    }
}

});
parcelRegister("1a2cY", function(module, exports) {
$parcel$export(module.exports, "default", () => $92c7a785dda66647$export$2e2bcd8739ae039);

var $fCfI9 = parcelRequire("fCfI9");

var $9xKv4 = parcelRequire("9xKv4");
class $92c7a785dda66647$export$2e2bcd8739ae039 extends (0, $9xKv4.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.localStorage || (0, $fCfI9.default);
        } catch (err) {
            storageToUse = (0, $fCfI9.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("fCfI9", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb997c392278301d$export$2e2bcd8739ae039);

var $fPsY9 = parcelRequire("fPsY9");
// eslint-disable-next-line import/no-anonymous-default-export
const $cb997c392278301d$var$inmemorystorage = new (0, $fPsY9.InMemoryStore)();
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$cb997c392278301d$export$2e2bcd8739ae039 = $cb997c392278301d$var$inmemorystorage;

});
parcelRegister("fPsY9", function(module, exports) {
$parcel$export(module.exports, "InMemoryStore", () => $8320749dff78ace7$export$90e3e001bcac59c7);
class $8320749dff78ace7$export$90e3e001bcac59c7 {
    constructor(){
        this._data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        };
        this.clear = ()=>{
            this._data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this._data)[index];
    }
}

});


parcelRegister("9xKv4", function(module, exports) {
$parcel$export(module.exports, "default", () => $01b4212a3dc0caf3$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $juSGQ = parcelRequire("juSGQ");

var $fCfI9 = parcelRequire("fCfI9");

var $6W7Rd = parcelRequire("6W7Rd");
const $01b4212a3dc0caf3$export$41c06fdd37b7e9a5 = 'awc';
const $01b4212a3dc0caf3$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
class $01b4212a3dc0caf3$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this._prefix = void 0;
        this._store = void 0;
        this.options = void 0;
        this.getStore = ()=>this._store;
        this.getItem = (key)=>this._store.getItem(this.createKey(key));
        this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this._store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this._store === (0, $fCfI9.default) || typeof globalThis === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ((0, $6W7Rd.isSupported)(globalThis[$01b4212a3dc0caf3$export$770aa8bc07b3de03])) inMemoryStorage = globalThis[$01b4212a3dc0caf3$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $fCfI9.default);
                if (!globalThis[$01b4212a3dc0caf3$export$770aa8bc07b3de03]) // If not already attached to globalThis then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                globalThis[$01b4212a3dc0caf3$export$770aa8bc07b3de03] = (0, $fCfI9.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        };
        this.clear = ()=>this._store.clear();
        this.key = (index)=>this._store.key(index);
        this.getPrefix = ()=>this._prefix;
        this.createKey = (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($01b4212a3dc0caf3$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $juSGQ.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ((0, $6W7Rd.isSupported)(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});
parcelRegister("6W7Rd", function(module, exports) {
$parcel$export(module.exports, "isSupported", () => $380f52461be0d957$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $380f52461be0d957$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});




parcelRegister("h7h8C", function(module, exports) {
$parcel$export(module.exports, "canUseCookie", () => $d35ac9d40be64356$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $d35ac9d40be64356$export$de6821eed3d5f32d);

var $eWNrv = parcelRequire("eWNrv");

var $aLoS2 = parcelRequire("aLoS2");

var $6WGyt = parcelRequire("6WGyt");
const $d35ac9d40be64356$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $d35ac9d40be64356$export$eb80e1beaa8dacf8 = (0, $6WGyt.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $d35ac9d40be64356$export$19164982d36535d8 = 'tld_test';
const $d35ac9d40be64356$export$de6821eed3d5f32d = (0, $aLoS2.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, $eWNrv.default).set($d35ac9d40be64356$export$eb80e1beaa8dacf8, $d35ac9d40be64356$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, $eWNrv.default).get($d35ac9d40be64356$export$eb80e1beaa8dacf8) === $d35ac9d40be64356$export$19164982d36535d8) {
            (0, $eWNrv.default).remove($d35ac9d40be64356$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});




parcelRegister("BiRQc", function(module, exports) {
$parcel$export(module.exports, "MetadataClient", () => $a58ccbebc8d1421a$export$1ac223ae496131c9);

var $iBJyZ = parcelRequire("iBJyZ");

var $9XrmY = parcelRequire("9XrmY");

var $fPqxy = parcelRequire("fPqxy");

var $n3mSe = parcelRequire("n3mSe");

var $gr9S5 = parcelRequire("gr9S5");

var $iV3yc = parcelRequire("iV3yc");

var $et0BU = parcelRequire("et0BU");

var $LpwjR = parcelRequire("LpwjR");

var $8xDw1 = parcelRequire("8xDw1");

var $8CUny = parcelRequire("8CUny");

var $2IOsq = parcelRequire("2IOsq");

var $69bzU = parcelRequire("69bzU");
var $a58ccbebc8d1421a$var$_MetadataClient;
class $a58ccbebc8d1421a$export$1ac223ae496131c9 {
    /**
   * Starts the metadata client. This will start the scheduler and begin
   * fetching metadata.
   *
   * @param allowRestart - If false, the client will not be restarted if it has already been stopped
   *						 by a call to stop().
   */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $a58ccbebc8d1421a$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        this._fetchAbortController?.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $9XrmY.default)((status)=>{
            if (status === (0, $iV3yc.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        if ((0, $et0BU.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        this._fetchAbortController?.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $8CUny.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $LpwjR.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $2IOsq.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $8xDw1.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $69bzU.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        if (this._userInfo?.userId === userInfo?.userId && this._userInfo?.userIdType === userInfo?.userIdType) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        if (this._tenantInfo?.tenantId === tenantInfo?.tenantId && this._tenantInfo?.tenantIdType === tenantInfo?.tenantIdType) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        if (this._networkStatus?.getNetworkStatus() === (0, $iV3yc.NetworkStatusEnum).OFFLINE) {
            done((0, $gr9S5.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $gr9S5.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch  {
            done((0, $gr9S5.DoneState).ERROR);
        }
    }
    /**
   * Schedules a refresh of the metadata when the user or tenant info changes. There is
   * a short delay to allow for multiple changes to be batched together, such as when the
   * callers sets the user info and tenant info in quick succession.
   */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $LpwjR.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || (0, $fPqxy.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : (0, $fPqxy.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            maxRetryDelay: options?.maxRetryDelay || (0, $fPqxy.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || (0, $fPqxy.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = void 0;
        this._tenantInfo = void 0;
        this._url = void 0;
        this._metadataHost = void 0;
        this._product = void 0;
        this._metadataInfo = void 0;
        this._requestStatus = void 0;
        this._lastFetchRequestCount = void 0;
        this._options = void 0;
        this._scheduler = void 0;
        this._networkStatus = void 0;
        this._lastErrorReason = void 0;
        this._fetchAbortController = void 0;
        this._hasBeenStopped = void 0;
        this._isEnabled = void 0;
        this._propertyChangeRefreshTimeout = void 0;
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $iBJyZ.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            minRetryDelay: (0, $LpwjR.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, $LpwjR.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, $n3mSe.default)({
            ...this._options,
            waitInterval: (0, $LpwjR.DEFAULT_METADATA_REFRESH_INTERVAL)
        }, this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
}
$a58ccbebc8d1421a$var$_MetadataClient = $a58ccbebc8d1421a$export$1ac223ae496131c9;
$a58ccbebc8d1421a$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY = 1;
$a58ccbebc8d1421a$export$1ac223ae496131c9.Factory = (apiHostProtocol, apiHost, product)=>{
    return new $a58ccbebc8d1421a$var$_MetadataClient(apiHostProtocol, apiHost, product);
};

});
parcelRegister("iBJyZ", function(module, exports) {
$parcel$export(module.exports, "isStargateProxyPath", () => $f01a9eb62f02b357$export$83a9dd8d74be72c);

var $7IjZo = parcelRequire("7IjZo");
function $f01a9eb62f02b357$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === (0, $7IjZo.stargateProxyUrl)();
}

});
parcelRegister("7IjZo", function(module, exports) {
$parcel$export(module.exports, "STARGATE_PROXY_PATH", () => $100d2a4dda1c5d76$export$5df9262e102d0c32);
$parcel$export(module.exports, "stargateProxyUrl", () => $100d2a4dda1c5d76$export$78e02cfb66671ad0);
$parcel$export(module.exports, "selectHost", () => $100d2a4dda1c5d76$export$18c0b81944902eae);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $juSGQ = parcelRequire("juSGQ");

const $100d2a4dda1c5d76$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $100d2a4dda1c5d76$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $100d2a4dda1c5d76$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $100d2a4dda1c5d76$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $100d2a4dda1c5d76$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $100d2a4dda1c5d76$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $100d2a4dda1c5d76$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $100d2a4dda1c5d76$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $100d2a4dda1c5d76$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
/**
 * Returns the full Stargate proxy URL (host + proxy path) for the current host.
 *
 * This is the default endpoint for Commercial, FedRAMP Moderate (with Stargate),
 * and Oasis IC environments. Using the first-party proxy works around browser
 * restrictions with third-party cookies.
 *
 * In non-browser environments (e.g. SSR) where `window` is not defined, the host
 * portion is omitted and the function returns only `STARGATE_PROXY_PATH`
 * (i.e. `/gateway/api/gasv3/api/v1`).
 */ function $100d2a4dda1c5d76$export$78e02cfb66671ad0() {
    return (typeof window !== 'undefined' ? window.location.host : '') + $100d2a4dda1c5d76$export$5df9262e102d0c32;
}
const $100d2a4dda1c5d76$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $juSGQ.envType).LOCAL || env === (0, $juSGQ.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $juSGQ.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $juSGQ.envType).PROD ? $100d2a4dda1c5d76$var$FEDRAMP_PROD_HOST : $100d2a4dda1c5d76$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $juSGQ.envType).PROD ? $100d2a4dda1c5d76$var$STARGATE_FEDRAMP_PROD_HOST : $100d2a4dda1c5d76$var$STARGATE_FEDRAMP_STAGING_HOST;
    return $100d2a4dda1c5d76$export$78e02cfb66671ad0();
};
const $100d2a4dda1c5d76$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $juSGQ.envType).PROD ? $100d2a4dda1c5d76$var$PROD_HOST : $100d2a4dda1c5d76$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $juSGQ.envType).PROD ? $100d2a4dda1c5d76$var$STARGATE_PROD_HOST : $100d2a4dda1c5d76$var$STARGATE_STAGING_HOST;
    return $100d2a4dda1c5d76$export$78e02cfb66671ad0();
};
function $100d2a4dda1c5d76$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride, apiHost: apiHost }) {
    // If the caller has explicitly set an apiHost, use it as the endpoint.
    if (apiHost) return apiHost;
    // When running inside an IC, events are routed through the Stargate proxy.
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true. Legacy URLs are not supported in IC environments.');
        return $100d2a4dda1c5d76$export$78e02cfb66671ad0();
    }
    if (perimeter === (0, $juSGQ.perimeterType).FEDRAMP_MODERATE) return $100d2a4dda1c5d76$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $100d2a4dda1c5d76$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});


parcelRegister("et0BU", function(module, exports) {
$parcel$export(module.exports, "TestSupport", () => $838aac1178bfaea9$export$44b578549c42d779);
class $838aac1178bfaea9$export$44b578549c42d779 {
    static isGeminiVREnvironment() {
        try {
            for(const k in globalThis){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($838aac1178bfaea9$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($838aac1178bfaea9$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($838aac1178bfaea9$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty($838aac1178bfaea9$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) return globalThis[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) {
            const value = globalThis[propertyName];
            if (typeof value === 'boolean') return value;
        }
        return undefined;
    }
}
$838aac1178bfaea9$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
$838aac1178bfaea9$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
$838aac1178bfaea9$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';
$838aac1178bfaea9$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY = '__awc_synthetic_flag_override__';

});

parcelRegister("8CUny", function(module, exports) {
$parcel$export(module.exports, "fetchMetadata", () => $c033b0ade90f04f2$export$55b0d0261469055);

var $aLoS2 = parcelRequire("aLoS2");

var $8xDw1 = parcelRequire("8xDw1");
const $c033b0ade90f04f2$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    const requestAbortController = $c033b0ade90f04f2$var$createRequestAbortController(timeout, signal);
    const corsOptions = $c033b0ade90f04f2$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${params.userInfo?.userId || ''}`,
        userIdType: `${params.userInfo?.userIdType || ''}`,
        tenantId: `${params.tenantInfo?.tenantId || ''}`,
        tenantIdType: `${params.tenantInfo?.tenantIdType || ''}`
    }).toString();
    const response = await fetch(metadataUrl, {
        method: 'GET',
        signal: requestAbortController.signal,
        ...corsOptions
    });
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $8xDw1.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $c033b0ade90f04f2$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal?.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $c033b0ade90f04f2$var$getCorsForUrl = (0, $aLoS2.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("2IOsq", function(module, exports) {
$parcel$export(module.exports, "MetadataResponse", () => $1f3a4fb5d214b91c$export$4b1a5e5486cc0d80);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
class $1f3a4fb5d214b91c$export$4b1a5e5486cc0d80 {
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json?.url) ? json.url.trim() : '';
        return new $1f3a4fb5d214b91c$export$4b1a5e5486cc0d80(json?.props || null, url.startsWith('http') ? url : null);
    }
    constructor(props, url){
        this.props = void 0;
        this.url = void 0;
        this.props = props;
        this.url = url;
    }
}

});


parcelRegister("b8WdK", function(module, exports) {
$parcel$export(module.exports, "isFirstParty", () => $0f65407b3aaf5367$export$f56713ced121eb91);

var $juSGQ = parcelRequire("juSGQ");
const $0f65407b3aaf5367$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $juSGQ.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};

});

parcelRegister("gPO6w", function(module, exports) {
$parcel$export(module.exports, "isThirdParty", () => $dc3bc1ed9d7fd956$export$ab34f90cc32c8960);

var $juSGQ = parcelRequire("juSGQ");
const $dc3bc1ed9d7fd956$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $juSGQ.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("lP8ic", function(module, exports) {
$parcel$export(module.exports, "LoggingResponseCallback", () => $3086907353d1d5fe$export$48361b6ed38f1b0);
class $3086907353d1d5fe$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $3086907353d1d5fe$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}

});

parcelRegister("6HSOG", function(module, exports) {
$parcel$export(module.exports, "objectValues", () => $a7f4fa28eff44c7f$export$ad1854f4a08c15f8);
function $a7f4fa28eff44c7f$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}

});

parcelRegister("hEhuo", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbdb30cecae06bb3$export$2e2bcd8739ae039);

var $juSGQ = parcelRequire("juSGQ");

var $3KzJL = parcelRequire("3KzJL");
class $dbdb30cecae06bb3$export$2e2bcd8739ae039 {
    /** Executes and clears any pending origin param cleanup. No-op if nothing is pending. */ _cleanupOriginParams() {
        if (this.pendingCleanup) {
            const cleanup = this.pendingCleanup;
            this.pendingCleanup = null;
            cleanup();
        }
    }
    /**
   * Designed to be invoked after a successful flush with the batch of flushed events.
   */ cleanupOriginParameters(events) {
        try {
            if (this.pendingCleanup) {
                const hasOriginLanded = events.some((item)=>'event' in item.msg && item.msg.event === $dbdb30cecae06bb3$export$2e2bcd8739ae039.messageEvent);
                if (hasOriginLanded) this._cleanupOriginParams();
            }
        } catch  {
        // Silently ignore cleanup errors to avoid disrupting the flush cycle
        }
    }
    constructor(){
        this._originStore = void 0;
        this.pendingCleanup = null;
        this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $juSGQ.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture params WITHOUT removing from URL (explicit no-op required because
            // urlParamExtractor defaults to calling history.replaceState if omitted)
            const paramExtractorReplace = ()=>{};
            const capturedURLParams = (0, $3KzJL.default)(isCaptureParam, paramExtractorReplace);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const capturedOriginTraces = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            if (Object.keys(capturedOriginTraces).length > 0) this.pendingCleanup = ()=>{
                (0, $3KzJL.default)(isCaptureParam, historyReplaceFn);
            };
            return capturedOriginTraces;
        };
        this._originStore = {};
    }
}
$dbdb30cecae06bb3$export$2e2bcd8739ae039.messageEvent = 'origin landed';

});

parcelRegister("lPBf7", function(module, exports) {
$parcel$export(module.exports, "default", () => $03ff060a74ebc1c1$export$2e2bcd8739ae039);

var $6oQI4 = parcelRequire("6oQI4");

var $6gLle = parcelRequire("6gLle");

var $1a2cY = parcelRequire("1a2cY");
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const $03ff060a74ebc1c1$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $03ff060a74ebc1c1$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $03ff060a74ebc1c1$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $03ff060a74ebc1c1$export$285f6bddd927a06d = 1800000;
const $03ff060a74ebc1c1$export$a92e915d70316eb2 = 5000;
const $03ff060a74ebc1c1$export$de43760b2dc10c19 = 0.9;
class $03ff060a74ebc1c1$export$2e2bcd8739ae039 {
    /*
   * This function retrieves the current session ID and expiry from SessionStorage
   * It runs the necessary checks to ensure the session ID is valid and within expiry
   *
   * It returns the values along with a `validSession` boolean
   */ _getCurrentSessionParams() {
        const sessionId = this._safeLocalStorage.getItem($03ff060a74ebc1c1$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($03ff060a74ebc1c1$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        // REGEX test: Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (sessionId && !Number.isNaN(sessionExpiry) && $03ff060a74ebc1c1$var$ONLY_NUMBERS_REGEX.test(sessionId) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
   * Session ID SHOULD always be a timestamp, however due to new Browser Storage Controls key classifications, it is
   * technically possible that writing Session ID to local storage is intercepted by BSC, in which case we can potentially
   * read a null value from storage, in which case we will return empty String
   */ getCurrentSessionId() {
        const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this._getCurrentSessionParams();
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        // If we have an existing valid session we can return the sessionId straight away
        if (isValidSession) return sessionId;
        else return this._generateNewSessionId();
    }
    constructor(options = {}){
        this._safeLocalStorage = void 0;
        this._sessionExpiryTime = void 0;
        this._sessionExpiryDebounce = void 0;
        this._sessionExpiryDebounceThresholdPercentage = void 0;
        this._sessionExpiryDebounceTimer = void 0;
        this._onNewSessionStarted = void 0;
        this._generateNewSessionId = ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($03ff060a74ebc1c1$var$SESSION_ID_STORAGE_KEY, newSessionId);
            if ((0, $6oQI4.fg)('awc_session_id_early_exit')) {
                // If session is not valid at this point, something has gone wrong with Local Storage access
                // Calling the callback may result in possible recursion errors (see HOT-304742). Feature
                // gating roll-out of this early exit condition
                const { isValidSession: isValidSession } = this._getCurrentSessionParams();
                if (!isValidSession) return '';
            }
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        };
        this._updateSessionExpiry = ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($03ff060a74ebc1c1$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        };
        this._sessionExpiryTime = options.sessionExpiryTime || $03ff060a74ebc1c1$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $03ff060a74ebc1c1$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $03ff060a74ebc1c1$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : (0, $6gLle.NOOP);
        this._safeLocalStorage = new (0, $1a2cY.default)();
    }
}

});
parcelRegister("6gLle", function(module, exports) {
$parcel$export(module.exports, "NOOP", () => $b083c0d32a6a758f$export$5702a91a6f42969f);
// 90% of expiry
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $b083c0d32a6a758f$export$5702a91a6f42969f = ()=>{};

});


parcelRegister("c6Gao", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2d8ce4ed303d065$export$2e2bcd8739ae039);

var $fCfI9 = parcelRequire("fCfI9");

var $9xKv4 = parcelRequire("9xKv4");
class $f2d8ce4ed303d065$export$2e2bcd8739ae039 extends (0, $9xKv4.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.sessionStorage || (0, $fCfI9.default);
        } catch (err) {
            storageToUse = (0, $fCfI9.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("2V09K", function(module, exports) {
$parcel$export(module.exports, "default", () => $49316c77314a8de7$export$2e2bcd8739ae039);

var $c6Gao = parcelRequire("c6Gao");

var $7avGr = parcelRequire("7avGr");
const $49316c77314a8de7$var$STORAGE_KEY = 'tab.id';
class $49316c77314a8de7$export$2e2bcd8739ae039 {
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($49316c77314a8de7$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
    constructor(){
        this._safeSessionStorage = void 0;
        this._generateNewTabId = ()=>{
            const newTabId = (0, $7avGr.default)();
            this._safeSessionStorage.setItem($49316c77314a8de7$var$STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new (0, $c6Gao.default)();
    }
}

});

parcelRegister("6kvwZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $95f63a51883d738c$export$2e2bcd8739ae039);

var $9QkBj = parcelRequire("9QkBj");

var $juSGQ = parcelRequire("juSGQ");

var $hvSyg = parcelRequire("hvSyg");

var $c6Gao = parcelRequire("c6Gao");

var $3KzJL = parcelRequire("3KzJL");

var $7avGr = parcelRequire("7avGr");
const $95f63a51883d738c$var$STORAGE_KEY = 'taskSessions';
const $95f63a51883d738c$var$INIT_KEY = 'taskSessionsInit';
const $95f63a51883d738c$var$AWC_PARAM_PREFIX = 'awc.';
const $95f63a51883d738c$var$TASK_SESSION_RELOAD_TIME = 3000;
class $95f63a51883d738c$export$2e2bcd8739ae039 {
    constructor(){
        this._safeSessionStorage = void 0;
        this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($95f63a51883d738c$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($95f63a51883d738c$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($95f63a51883d738c$var$INIT_KEY) || '0', 10) < currentTimestamp - $95f63a51883d738c$var$TASK_SESSION_RELOAD_TIME;
        this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($95f63a51883d738c$var$AWC_PARAM_PREFIX)[1];
        this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($95f63a51883d738c$var$AWC_PARAM_PREFIX);
        this.getAllTaskSessions = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($95f63a51883d738c$var$STORAGE_KEY) || '');
            } catch  {
                return {};
            }
        };
        this._writeToSessionStorage = (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($95f63a51883d738c$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch  {}
        };
        this._appendTaskSessions = (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        };
        this._safelyRemoveKey = (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        };
        this.createTaskSession = (taskSessionName)=>{
            const taskSessionId = (0, $7avGr.default)();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        };
        this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        };
        this.completeTaskSession = (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        };
        this.formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $9QkBj.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $hvSyg.pick)(currentState, includedTaskSessions) : (0, $hvSyg.omit)(currentState, Object.values((0, $juSGQ.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = {
                ...(0, $hvSyg.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$95f63a51883d738c$var$AWC_PARAM_PREFIX + taskSessionName),
                ...query
            };
            return `${url}?${(0, $9QkBj.stringify)(queryWithTaskSessions)}`;
        };
        this.stripQueryParameters = ()=>{
            const extractedTaskSessions = (0, $hvSyg.mapKeys)((0, $3KzJL.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        };
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $c6Gao.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($95f63a51883d738c$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch  {}
    }
}

});

parcelRegister("3itWI", function(module, exports) {
$parcel$export(module.exports, "default", () => $629fca6a7cc08052$export$2e2bcd8739ae039);

var $eWNrv = parcelRequire("eWNrv");

var $6WGyt = parcelRequire("6WGyt");

var $et0BU = parcelRequire("et0BU");
const $629fca6a7cc08052$var$MAX_CACHE_SIZE = 100;
const $629fca6a7cc08052$var$COOKIE_NAME = (0, $6WGyt.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $629fca6a7cc08052$var$DEBUG_TAG = 'synthetic';
class $629fca6a7cc08052$var$TestingCache {
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch  {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                } catch  {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= $629fca6a7cc08052$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes($629fca6a7cc08052$var$DEBUG_TAG)) event.tags.push($629fca6a7cc08052$var$DEBUG_TAG);
        } else event.tags = [
            $629fca6a7cc08052$var$DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, $et0BU.TestSupport).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, $eWNrv.default).get($629fca6a7cc08052$var$COOKIE_NAME) || 'false') === true;
        } catch  {
            (0, $eWNrv.default).remove($629fca6a7cc08052$var$COOKIE_NAME);
        }
        return false;
    }
    constructor(syntheticFlagOverride, enableTestingCache){
        this._isDebugCookieEnabled = void 0;
        this._syntheticFlagOverride = void 0;
        this._enableTestingCache = void 0;
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = $629fca6a7cc08052$var$TestingCache.getDebugCookie();
        this.bind();
    }
}
var $629fca6a7cc08052$export$2e2bcd8739ae039 = $629fca6a7cc08052$var$TestingCache;

});

parcelRegister("7zKr7", function(module, exports) {
$parcel$export(module.exports, "default", () => $1dd07516274505d3$export$2e2bcd8739ae039);

var $juSGQ = parcelRequire("juSGQ");

var $ksLeK = parcelRequire("ksLeK");

var $1a2cY = parcelRequire("1a2cY");
const $1dd07516274505d3$var$DEFAULT_DELAY = 2000; // 2 seconds
const $1dd07516274505d3$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $1dd07516274505d3$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $1dd07516274505d3$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
var $1dd07516274505d3$var$SendEventDecision = /*#__PURE__*/ function(SendEventDecision) {
    SendEventDecision[SendEventDecision["FocusLost"] = 0] = "FocusLost";
    SendEventDecision[SendEventDecision["UserOrTenantIncomplete"] = 1] = "UserOrTenantIncomplete";
    SendEventDecision[SendEventDecision["MalformedUiViewedRateLimited"] = 2] = "MalformedUiViewedRateLimited";
    SendEventDecision[SendEventDecision["EligibleToSend"] = 3] = "EligibleToSend";
    SendEventDecision[SendEventDecision["UiViewedRateLimited"] = 4] = "UiViewedRateLimited";
    return SendEventDecision;
}($1dd07516274505d3$var$SendEventDecision || {});
class $1dd07516274505d3$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        this._blurListener = void 0;
        this._delay = void 0;
        this._focusListener = void 0;
        this._getContext = void 0;
        this._intervalId = void 0;
        this._onEvent = void 0;
        this._product = void 0;
        this._productInfo = void 0;
        this._safeLocalStorage = void 0;
        this._storageKey = void 0;
        this._malformedEventStorageKey = void 0;
        this._throttle = void 0;
        this.start = ()=>{
            this._startInterval();
            this._bindEventListeners();
        };
        this.stop = ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        };
        this.resetTimers = ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        };
        this.signalUserActive = ()=>{
            this._sendUserActiveEvents();
        };
        this._bindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        };
        this._unbindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        };
        this._startInterval = ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleDwellTimerTriggered, this._delay);
        };
        this._stopInterval = ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        };
        this._getProductKey = (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        };
        this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._parseLocalStorageData = (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch  {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        };
        this._getMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        };
        this._setMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        };
        this._handleDwellTimerTriggered = ()=>{
            const document = (0, $ksLeK.getDocument)();
            if (document && !document.hasFocus()) return;
            this._sendUserActiveEvents();
        };
        this._sendUserActiveEvents = ()=>{
            const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
            this._sendEvent(this._product, context, false);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        };
        this._sendEvent = (product, context, isEmbeddedProduct)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const sendEventDecision = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(sendEventDecision){
                case 3:
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case 1:
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        };
        this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $juSGQ.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return 1;
                return 2;
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return 3;
            return 4;
        };
        this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: 'ui',
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = {
                    ...event.attributes,
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                };
            }
            if (lastScreenEvent) event.attributes = {
                ...event.attributes,
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            };
            return event;
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $1dd07516274505d3$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $1dd07516274505d3$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $1dd07516274505d3$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $1dd07516274505d3$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $1a2cY.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});
parcelRegister("ksLeK", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $42be136191a695f9$export$f65ca476c09acec0);
const $42be136191a695f9$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("jPZoT", function(module, exports) {
$parcel$export(module.exports, "validateIdentifyEvent", () => $6267b6d13b9a0f2b$export$c16a4e16aa4026c0);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $juSGQ = parcelRequire("juSGQ");

var $31szT = parcelRequire("31szT");

var $6HSOG = parcelRequire("6HSOG");
function $6267b6d13b9a0f2b$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $31szT.isType)((0, $juSGQ.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $6HSOG.objectValues)((0, $juSGQ.userType))}]`);
}

});

parcelRegister("XQNUr", function(module, exports) {
$parcel$export(module.exports, "validateOperationalEvent", () => $c317a729a12cbd08$export$1e561554275607ef);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $8QZSB = parcelRequire("8QZSB");
function $c317a729a12cbd08$export$1e561554275607ef(event) {
    (0, $8QZSB.validateActionEvent)(event);
}

});

parcelRegister("9jx9x", function(module, exports) {
$parcel$export(module.exports, "validatePlatform", () => $00e355b0bc4b43d7$export$801b46c35394d316);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $juSGQ = parcelRequire("juSGQ");

var $31szT = parcelRequire("31szT");

var $6HSOG = parcelRequire("6HSOG");
function $00e355b0bc4b43d7$export$801b46c35394d316(productInfo) {
    if (!(0, $31szT.isType)((0, $juSGQ.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $6HSOG.objectValues)((0, $juSGQ.platformType))}]`);
    if (productInfo.origin === (0, $juSGQ.originType).DESKTOP && !(0, $31szT.isType)((0, $juSGQ.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $juSGQ.originType).WEB && !(0, $31szT.isType)((0, $juSGQ.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});

parcelRegister("eiuru", function(module, exports) {
$parcel$export(module.exports, "validateScreenEvent", () => $0970f87891474336$export$dc993432a592dc27);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ function $0970f87891474336$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}

});

parcelRegister("6TQrT", function(module, exports) {
$parcel$export(module.exports, "validateTrackEvent", () => $36d9bb54c5137077$export$8c014fd74b0c8b99);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $8QZSB = parcelRequire("8QZSB");
function $36d9bb54c5137077$export$8c014fd74b0c8b99(event) {
    (0, $8QZSB.validateActionEvent)(event);
}

});

parcelRegister("2U91m", function(module, exports) {
$parcel$export(module.exports, "validateUIEvent", () => $4a516d7496c14f49$export$e5bac0930c812e90);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $8QZSB = parcelRequire("8QZSB");
function $4a516d7496c14f49$export$e5bac0930c812e90(event) {
    (0, $8QZSB.validateActionEvent)(event);
}

});

parcelRegister("eXLaM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c761e16cce6b4fd2$export$2e2bcd8739ae039);
function $c761e16cce6b4fd2$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("bQFSn", function(module, exports) {
$parcel$export(module.exports, "XIDPromise", () => $0ec033b7b6a2032a$export$fbe53bbbe682bcdd);

var $2o6gj = parcelRequire("2o6gj");
const $0ec033b7b6a2032a$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $2o6gj.createTimeoutXid)()), (0, $2o6gj.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $2o6gj.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("2o6gj", function(module, exports) {
$parcel$export(module.exports, "XID_TIMEOUT", () => $db3a14af61f81af2$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $db3a14af61f81af2$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $db3a14af61f81af2$export$fa341d0c750d705b);

var $2mh1T = parcelRequire("2mh1T");
const $db3a14af61f81af2$export$545bcbd53afabfa3 = 5000;
const $db3a14af61f81af2$export$af4087e36d63846 = ()=>[
        {
            type: (0, $2mh1T.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $2mh1T.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $db3a14af61f81af2$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $2mh1T.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $2mh1T.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("2mh1T", function(module, exports) {
$parcel$export(module.exports, "XIDItemType", () => $5ea9e8185206fac5$export$92ca0438bcb0d396);
var $5ea9e8185206fac5$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $5ea9e8185206fac5$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("3g9wx", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $25fa40f5c09592d1$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $25fa40f5c09592d1$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $25fa40f5c09592d1$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $25fa40f5c09592d1$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $25fa40f5c09592d1$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $25fa40f5c09592d1$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $25fa40f5c09592d1$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $25fa40f5c09592d1$export$afc72e2116322959);
$parcel$export(module.exports, "__spreadArrays", () => $25fa40f5c09592d1$export$6388937ca91ccae8);
$parcel$export(module.exports, "__spreadArray", () => $25fa40f5c09592d1$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $25fa40f5c09592d1$var$extendStatics = function(d, b) {
    $25fa40f5c09592d1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $25fa40f5c09592d1$var$extendStatics(d, b);
};
function $25fa40f5c09592d1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $25fa40f5c09592d1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $25fa40f5c09592d1$export$18ce0697a983be9b = function() {
    $25fa40f5c09592d1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $25fa40f5c09592d1$export$18ce0697a983be9b.apply(this, arguments);
};
function $25fa40f5c09592d1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $25fa40f5c09592d1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $25fa40f5c09592d1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $25fa40f5c09592d1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $25fa40f5c09592d1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $25fa40f5c09592d1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $25fa40f5c09592d1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $25fa40f5c09592d1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $25fa40f5c09592d1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $25fa40f5c09592d1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $25fa40f5c09592d1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $25fa40f5c09592d1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $25fa40f5c09592d1$export$45d3717a4c69092e(o, m, p);
}
function $25fa40f5c09592d1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $25fa40f5c09592d1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $25fa40f5c09592d1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($25fa40f5c09592d1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $25fa40f5c09592d1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $25fa40f5c09592d1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $25fa40f5c09592d1$export$10c90e4f7922046c(v) {
    return this instanceof $25fa40f5c09592d1$export$10c90e4f7922046c ? (this.v = v, this) : new $25fa40f5c09592d1$export$10c90e4f7922046c(v);
}
function $25fa40f5c09592d1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $25fa40f5c09592d1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $25fa40f5c09592d1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $25fa40f5c09592d1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $25fa40f5c09592d1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $25fa40f5c09592d1$export$19a8beecd37a4c45 === "function" ? $25fa40f5c09592d1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $25fa40f5c09592d1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $25fa40f5c09592d1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $25fa40f5c09592d1$var$ownKeys = function(o) {
    $25fa40f5c09592d1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $25fa40f5c09592d1$var$ownKeys(o);
};
function $25fa40f5c09592d1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $25fa40f5c09592d1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $25fa40f5c09592d1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $25fa40f5c09592d1$var$__setModuleDefault(result, mod);
    return result;
}
function $25fa40f5c09592d1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $25fa40f5c09592d1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $25fa40f5c09592d1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $25fa40f5c09592d1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $25fa40f5c09592d1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $25fa40f5c09592d1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $25fa40f5c09592d1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $25fa40f5c09592d1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $25fa40f5c09592d1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $25fa40f5c09592d1$export$2e2bcd8739ae039 = {
    __extends: $25fa40f5c09592d1$export$a8ba968b8961cb8a,
    __assign: $25fa40f5c09592d1$export$18ce0697a983be9b,
    __rest: $25fa40f5c09592d1$export$3c9a16f847548506,
    __decorate: $25fa40f5c09592d1$export$29e00dfd3077644b,
    __param: $25fa40f5c09592d1$export$d5ad3fd78186038f,
    __esDecorate: $25fa40f5c09592d1$export$3a84e1ae4e97e9b0,
    __runInitializers: $25fa40f5c09592d1$export$d831c04e792af3d,
    __propKey: $25fa40f5c09592d1$export$6a2a36740a146cb8,
    __setFunctionName: $25fa40f5c09592d1$export$d1a06452d3489bc7,
    __metadata: $25fa40f5c09592d1$export$f1db080c865becb9,
    __awaiter: $25fa40f5c09592d1$export$1050f835b63b671e,
    __generator: $25fa40f5c09592d1$export$67ebef60e6f28a6,
    __createBinding: $25fa40f5c09592d1$export$45d3717a4c69092e,
    __exportStar: $25fa40f5c09592d1$export$f33643c0debef087,
    __values: $25fa40f5c09592d1$export$19a8beecd37a4c45,
    __read: $25fa40f5c09592d1$export$8d051b38c9118094,
    __spread: $25fa40f5c09592d1$export$afc72e2116322959,
    __spreadArrays: $25fa40f5c09592d1$export$6388937ca91ccae8,
    __spreadArray: $25fa40f5c09592d1$export$1216008129fb82ed,
    __await: $25fa40f5c09592d1$export$10c90e4f7922046c,
    __asyncGenerator: $25fa40f5c09592d1$export$e427f37a30a4de9b,
    __asyncDelegator: $25fa40f5c09592d1$export$bbd80228419bb833,
    __asyncValues: $25fa40f5c09592d1$export$e3b29a3d6162315f,
    __makeTemplateObject: $25fa40f5c09592d1$export$4fb47efe1390b86f,
    __importStar: $25fa40f5c09592d1$export$c21735bcef00d192,
    __importDefault: $25fa40f5c09592d1$export$da59b14a69baef04,
    __classPrivateFieldGet: $25fa40f5c09592d1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $25fa40f5c09592d1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $25fa40f5c09592d1$export$81fdc39f203e4e04,
    __addDisposableResource: $25fa40f5c09592d1$export$88ac25d8e944e405,
    __disposeResources: $25fa40f5c09592d1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $25fa40f5c09592d1$export$889dfb5d17574b0b
};

});

parcelRegister("l1TqZ", function(module, exports) {
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("kN795")).default);

var $kN795 = parcelRequire("kN795");

var $jctCf = parcelRequire("jctCf");

var $3g9wx = parcelRequire("3g9wx");

var $cKFfd = parcelRequire("cKFfd");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $jctCf.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $3g9wx.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $kN795.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $kN795.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $cKFfd.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $3g9wx.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $3g9wx.__assign)({}, context, next(context));
        else context = (0, $3g9wx.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $3g9wx.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $kN795.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $kN795.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $kN795.default).of() : rightLink.request(operation) || (0, $kN795.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $kN795.default).of() : rightLink.request(operation, forward) || (0, $kN795.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $kN795.default).of();
        }) || (0, $kN795.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $kN795.default).of();
        }) || (0, $kN795.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $jctCf.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $kN795.default).of();
}

});
parcelRegister("kN795", function(module, exports) {
$parcel$export(module.exports, "default", () => $f22ded35cf128859$export$2e2bcd8739ae039);

var $2724P = parcelRequire("2724P");
var $f22ded35cf128859$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($2724P)));
var $f22ded35cf128859$export$2e2bcd8739ae039 = $f22ded35cf128859$export$77cea355fa80b5f4;

});
parcelRegister("2724P", function(module, exports) {

module.exports = (parcelRequire("lhpQ9")).Observable;

});
parcelRegister("lhpQ9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $f7df3ad0609f5b77$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f7df3ad0609f5b77$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f7df3ad0609f5b77$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f7df3ad0609f5b77$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f7df3ad0609f5b77$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $f7df3ad0609f5b77$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $f7df3ad0609f5b77$var$hasSymbol = function(name) {
    return $f7df3ad0609f5b77$var$hasSymbols() && Boolean(Symbol[name]);
};
var $f7df3ad0609f5b77$var$getSymbol = function(name) {
    return $f7df3ad0609f5b77$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($f7df3ad0609f5b77$var$hasSymbols() && !$f7df3ad0609f5b77$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $f7df3ad0609f5b77$var$SymbolIterator = $f7df3ad0609f5b77$var$getSymbol('iterator');
var $f7df3ad0609f5b77$var$SymbolObservable = $f7df3ad0609f5b77$var$getSymbol('observable');
var $f7df3ad0609f5b77$var$SymbolSpecies = $f7df3ad0609f5b77$var$getSymbol('species'); // === Abstract Operations ===
function $f7df3ad0609f5b77$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $f7df3ad0609f5b77$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$f7df3ad0609f5b77$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $f7df3ad0609f5b77$var$Observable;
}
function $f7df3ad0609f5b77$var$isObservable(x) {
    return x instanceof $f7df3ad0609f5b77$var$Observable; // SPEC: Brand check
}
function $f7df3ad0609f5b77$var$hostReportError(e) {
    if ($f7df3ad0609f5b77$var$hostReportError.log) $f7df3ad0609f5b77$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $f7df3ad0609f5b77$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $f7df3ad0609f5b77$var$hostReportError(e);
        }
    });
}
function $f7df3ad0609f5b77$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $f7df3ad0609f5b77$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $f7df3ad0609f5b77$var$hostReportError(e);
    }
}
function $f7df3ad0609f5b77$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $f7df3ad0609f5b77$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $f7df3ad0609f5b77$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $f7df3ad0609f5b77$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $f7df3ad0609f5b77$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $f7df3ad0609f5b77$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $f7df3ad0609f5b77$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $f7df3ad0609f5b77$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $f7df3ad0609f5b77$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $f7df3ad0609f5b77$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $f7df3ad0609f5b77$var$enqueue(function() {
            return $f7df3ad0609f5b77$var$flushSubscription(subscription);
        });
        return;
    }
    $f7df3ad0609f5b77$var$notifySubscription(subscription, type, value);
}
var $f7df3ad0609f5b77$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $f7df3ad0609f5b77$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $f7df3ad0609f5b77$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $f7df3ad0609f5b77$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $f7df3ad0609f5b77$var$closeSubscription(this);
                    $f7df3ad0609f5b77$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $f7df3ad0609f5b77$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $f7df3ad0609f5b77$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $f7df3ad0609f5b77$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $f7df3ad0609f5b77$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $f7df3ad0609f5b77$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $f7df3ad0609f5b77$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $f7df3ad0609f5b77$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $f7df3ad0609f5b77$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $f7df3ad0609f5b77$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $f7df3ad0609f5b77$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f7df3ad0609f5b77$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f7df3ad0609f5b77$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f7df3ad0609f5b77$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $f7df3ad0609f5b77$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $f7df3ad0609f5b77$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $f7df3ad0609f5b77$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $f7df3ad0609f5b77$var$getMethod(x, $f7df3ad0609f5b77$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($f7df3ad0609f5b77$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($f7df3ad0609f5b77$var$hasSymbol('iterator')) {
                    method = $f7df3ad0609f5b77$var$getMethod(x, $f7df3ad0609f5b77$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $f7df3ad0609f5b77$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $f7df3ad0609f5b77$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $f7df3ad0609f5b77$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $f7df3ad0609f5b77$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $f7df3ad0609f5b77$var$Observable;
if ($f7df3ad0609f5b77$var$hasSymbols()) Object.defineProperty($f7df3ad0609f5b77$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $f7df3ad0609f5b77$var$SymbolObservable,
        hostReportError: $f7df3ad0609f5b77$var$hostReportError
    },
    configurable: true
});

});



parcelRegister("jctCf", function(module, exports) {
$parcel$export(module.exports, "InvariantError", () => $dfa61c65effa6e96$export$cea12affaee22fe8);

var $3g9wx = parcelRequire("3g9wx");

var $2M83v = parcelRequire("2M83v");
var $dfa61c65effa6e96$var$genericMessage = "Invariant Violation";
var $dfa61c65effa6e96$var$_a = Object.setPrototypeOf, $dfa61c65effa6e96$var$setPrototypeOf = $dfa61c65effa6e96$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $dfa61c65effa6e96$var$_a;
var $dfa61c65effa6e96$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $3g9wx.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $dfa61c65effa6e96$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $dfa61c65effa6e96$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $dfa61c65effa6e96$var$genericMessage;
        $dfa61c65effa6e96$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $dfa61c65effa6e96$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $dfa61c65effa6e96$export$cea12affaee22fe8(message);
}
function $dfa61c65effa6e96$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $dfa61c65effa6e96$var$wrapConsoleMethod("warn");
    invariant.error = $dfa61c65effa6e96$var$wrapConsoleMethod("error");
})($dfa61c65effa6e96$export$f5708dca728d7177 || ($dfa61c65effa6e96$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $dfa61c65effa6e96$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $2M83v === "object") $dfa61c65effa6e96$export$e54fe5b0f43758f7 = $2M83v;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($dfa61c65effa6e96$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $dfa61c65effa6e96$var$invariant$1 = $dfa61c65effa6e96$export$f5708dca728d7177;
var $dfa61c65effa6e96$export$2e2bcd8739ae039 = $dfa61c65effa6e96$var$invariant$1;

});

parcelRegister("cKFfd", function(module, exports) {
$parcel$export(module.exports, "argumentsObjectFromField", () => $9489c637d7e43c86$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $9489c637d7e43c86$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $9489c637d7e43c86$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $9489c637d7e43c86$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "shouldInclude", () => $9489c637d7e43c86$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $9489c637d7e43c86$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $9489c637d7e43c86$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getOperationDefinition", () => $9489c637d7e43c86$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $9489c637d7e43c86$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $9489c637d7e43c86$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getMainDefinition", () => $9489c637d7e43c86$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $9489c637d7e43c86$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $9489c637d7e43c86$export$84c19026e616569e);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $9489c637d7e43c86$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $9489c637d7e43c86$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $9489c637d7e43c86$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $9489c637d7e43c86$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $9489c637d7e43c86$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $9489c637d7e43c86$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $9489c637d7e43c86$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $9489c637d7e43c86$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $9489c637d7e43c86$export$160070228be94b08);

var $cRbCO = parcelRequire("cRbCO");

var $lsTsW = parcelRequire("lsTsW");

var $3g9wx = parcelRequire("3g9wx");

var $glwNQ = parcelRequire("glwNQ");

var $1a8Re = parcelRequire("1a8Re");

var $2M83v = parcelRequire("2M83v");
function $9489c637d7e43c86$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $9489c637d7e43c86$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $9489c637d7e43c86$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $9489c637d7e43c86$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $9489c637d7e43c86$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $9489c637d7e43c86$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $9489c637d7e43c86$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $9489c637d7e43c86$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $9489c637d7e43c86$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $9489c637d7e43c86$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $9489c637d7e43c86$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $9489c637d7e43c86$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($9489c637d7e43c86$var$isIntValue(value) || $9489c637d7e43c86$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($9489c637d7e43c86$var$isBooleanValue(value) || $9489c637d7e43c86$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($9489c637d7e43c86$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $9489c637d7e43c86$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($9489c637d7e43c86$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($9489c637d7e43c86$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $9489c637d7e43c86$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($9489c637d7e43c86$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($9489c637d7e43c86$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $lsTsW.InvariantError)(17);
}
function $9489c637d7e43c86$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $9489c637d7e43c86$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $9489c637d7e43c86$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $9489c637d7e43c86$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $9489c637d7e43c86$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $9489c637d7e43c86$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($glwNQ)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($9489c637d7e43c86$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $9489c637d7e43c86$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $9489c637d7e43c86$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $9489c637d7e43c86$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $9489c637d7e43c86$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $9489c637d7e43c86$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $9489c637d7e43c86$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $9489c637d7e43c86$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $3g9wx.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $9489c637d7e43c86$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $9489c637d7e43c86$var$defaultValueFromVariable(node) {
    throw new (0, $lsTsW.InvariantError)(18);
}
function $9489c637d7e43c86$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $9489c637d7e43c86$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $9489c637d7e43c86$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $9489c637d7e43c86$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $9489c637d7e43c86$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $9489c637d7e43c86$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $9489c637d7e43c86$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $9489c637d7e43c86$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $lsTsW.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $9489c637d7e43c86$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $cRbCO.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $9489c637d7e43c86$export$2dafb573e282fe8d(names, doc) {
    return $9489c637d7e43c86$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $9489c637d7e43c86$export$8d1e9e5bbfa5d09a(document) {
    return document && $9489c637d7e43c86$export$2dafb573e282fe8d([
        'client'
    ], document) && $9489c637d7e43c86$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $9489c637d7e43c86$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $9489c637d7e43c86$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($9489c637d7e43c86$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $lsTsW.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $lsTsW.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $lsTsW.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $9489c637d7e43c86$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $lsTsW.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $lsTsW.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, document), {
        definitions: (0, $3g9wx.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $9489c637d7e43c86$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $9489c637d7e43c86$export$a92e7a440b22bdf0(doc) {
    $9489c637d7e43c86$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $lsTsW.invariant)(mutationDef, 1);
    return mutationDef;
}
function $9489c637d7e43c86$export$a7d0d8111d2386df(doc) {
    (0, $lsTsW.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $lsTsW.InvariantError)(3);
        return definition;
    });
    (0, $lsTsW.invariant)(operations.length <= 1, 4);
    return doc;
}
function $9489c637d7e43c86$export$7a5b1fa979d2c158(doc) {
    $9489c637d7e43c86$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $9489c637d7e43c86$export$78a8e95d8d43ad7f(document) {
    var def = $9489c637d7e43c86$export$7a5b1fa979d2c158(document);
    (0, $lsTsW.invariant)(def, 5);
    return def;
}
function $9489c637d7e43c86$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $9489c637d7e43c86$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $9489c637d7e43c86$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $9489c637d7e43c86$export$7a5b1fa979d2c158(doc);
    (0, $lsTsW.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $9489c637d7e43c86$export$772111caef41b3f5(doc) {
    (0, $lsTsW.invariant)(doc.kind === 'Document', 7);
    (0, $lsTsW.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $lsTsW.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $9489c637d7e43c86$export$f431198736b7f96d(queryDoc) {
    $9489c637d7e43c86$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $lsTsW.InvariantError)(10);
}
function $9489c637d7e43c86$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $9489c637d7e43c86$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $9489c637d7e43c86$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $9489c637d7e43c86$export$e6e34fd1f2686227.apply(void 0, (0, $3g9wx.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $9489c637d7e43c86$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $9489c637d7e43c86$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $9489c637d7e43c86$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $9489c637d7e43c86$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $9489c637d7e43c86$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $9489c637d7e43c86$var$nullIfDocIsEmpty(doc) {
    return $9489c637d7e43c86$var$isEmpty($9489c637d7e43c86$export$7a5b1fa979d2c158(doc) || $9489c637d7e43c86$export$772111caef41b3f5(doc), $9489c637d7e43c86$export$193789b4c8246dd4($9489c637d7e43c86$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $9489c637d7e43c86$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $9489c637d7e43c86$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $9489c637d7e43c86$var$nullIfDocIsEmpty((0, $cRbCO.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($9489c637d7e43c86$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $9489c637d7e43c86$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($9489c637d7e43c86$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $9489c637d7e43c86$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $9489c637d7e43c86$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $9489c637d7e43c86$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $9489c637d7e43c86$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $9489c637d7e43c86$export$43b332f87950a467(doc) {
    return (0, $cRbCO.visit)($9489c637d7e43c86$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $9489c637d7e43c86$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($9489c637d7e43c86$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, node), {
                    selections: (0, $3g9wx.__spreadArrays)(selections, [
                        $9489c637d7e43c86$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $9489c637d7e43c86$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $9489c637d7e43c86$export$74985f3324559867(doc) {
    return $9489c637d7e43c86$export$e5ae0530da5fe96c([
        $9489c637d7e43c86$var$connectionRemoveConfig
    ], $9489c637d7e43c86$export$a7d0d8111d2386df(doc));
}
function $9489c637d7e43c86$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $9489c637d7e43c86$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $9489c637d7e43c86$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$9489c637d7e43c86$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($9489c637d7e43c86$var$getDirectiveMatcher(directives)) || nestedCheck && $9489c637d7e43c86$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $9489c637d7e43c86$export$deed3420cb5d2e1d(directives, doc) {
    $9489c637d7e43c86$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $9489c637d7e43c86$var$nullIfDocIsEmpty((0, $cRbCO.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $9489c637d7e43c86$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($9489c637d7e43c86$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $9489c637d7e43c86$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $9489c637d7e43c86$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $9489c637d7e43c86$var$getArgumentMatcher(config);
    return $9489c637d7e43c86$var$nullIfDocIsEmpty((0, $cRbCO.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $9489c637d7e43c86$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $9489c637d7e43c86$var$nullIfDocIsEmpty((0, $cRbCO.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $9489c637d7e43c86$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($9489c637d7e43c86$export$fb56ad75dd311c12(selection) || $9489c637d7e43c86$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $9489c637d7e43c86$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $9489c637d7e43c86$export$57c368c23873f32b(document) {
    var definition = $9489c637d7e43c86$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $cRbCO.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $9489c637d7e43c86$export$8eae69e876ee321e(document) {
    $9489c637d7e43c86$export$a7d0d8111d2386df(document);
    var modifiedDoc = $9489c637d7e43c86$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $cRbCO.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $9489c637d7e43c86$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $9489c637d7e43c86$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $9489c637d7e43c86$var$toString = Object.prototype.toString;
function $9489c637d7e43c86$export$629a2bd3f5a49ecc(value) {
    return $9489c637d7e43c86$var$cloneDeepHelper(value, new Map());
}
function $9489c637d7e43c86$var$cloneDeepHelper(val, seen) {
    switch($9489c637d7e43c86$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $9489c637d7e43c86$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $9489c637d7e43c86$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $9489c637d7e43c86$export$4bd44a2aa29d3d6e() {
    if (typeof $2M83v !== 'undefined' && "production") return "production";
    return 'development';
}
function $9489c637d7e43c86$export$f0cb0fda19c18b37(env) {
    return $9489c637d7e43c86$export$4bd44a2aa29d3d6e() === env;
}
function $9489c637d7e43c86$export$f15d00aa73aafac4() {
    return $9489c637d7e43c86$export$f0cb0fda19c18b37('production') === true;
}
function $9489c637d7e43c86$export$df77466336fe5355() {
    return $9489c637d7e43c86$export$f0cb0fda19c18b37('development') === true;
}
function $9489c637d7e43c86$export$410cbc2864fa25b5() {
    return $9489c637d7e43c86$export$f0cb0fda19c18b37('test') === true;
}
function $9489c637d7e43c86$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $9489c637d7e43c86$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $9489c637d7e43c86$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $9489c637d7e43c86$var$deepFreeze(o[prop]);
    });
    return o;
}
function $9489c637d7e43c86$export$7f9c177735b71f18(obj) {
    if ($9489c637d7e43c86$export$df77466336fe5355() || $9489c637d7e43c86$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $9489c637d7e43c86$var$deepFreeze(obj);
    }
    return obj;
}
var $9489c637d7e43c86$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $9489c637d7e43c86$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $9489c637d7e43c86$export$160070228be94b08(sources);
}
function $9489c637d7e43c86$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $9489c637d7e43c86$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $9489c637d7e43c86$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $9489c637d7e43c86$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $9489c637d7e43c86$var$mergeHelper(target, source, pastCopies) {
    if ($9489c637d7e43c86$var$isObject(source) && $9489c637d7e43c86$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $9489c637d7e43c86$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($9489c637d7e43c86$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $9489c637d7e43c86$var$mergeHelper($9489c637d7e43c86$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $9489c637d7e43c86$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $3g9wx.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $9489c637d7e43c86$var$haveWarned = Object.create({});
function $9489c637d7e43c86$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$9489c637d7e43c86$export$f15d00aa73aafac4() && !$9489c637d7e43c86$var$haveWarned[msg]) {
        if (!$9489c637d7e43c86$export$410cbc2864fa25b5()) $9489c637d7e43c86$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $9489c637d7e43c86$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("cRbCO", function(module, exports) {
$parcel$export(module.exports, "BREAK", () => $95c373bf3b8ebc30$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $95c373bf3b8ebc30$export$bf638b60ea8b89b7);

var $gjwnY = parcelRequire("gjwnY");

var $fSkCz = parcelRequire("fSkCz");
var $95c373bf3b8ebc30$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $95c373bf3b8ebc30$export$a89c95c098ac2a58 = Object.freeze({});
function $95c373bf3b8ebc30$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $95c373bf3b8ebc30$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $fSkCz.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $gjwnY.default)(node), "."));
            var visitFn = $95c373bf3b8ebc30$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $95c373bf3b8ebc30$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $fSkCz.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $95c373bf3b8ebc30$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $95c373bf3b8ebc30$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $95c373bf3b8ebc30$export$a89c95c098ac2a58) skipping[i] = $95c373bf3b8ebc30$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $95c373bf3b8ebc30$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $95c373bf3b8ebc30$export$a89c95c098ac2a58) skipping[i] = $95c373bf3b8ebc30$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $95c373bf3b8ebc30$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("gjwnY", function(module, exports) {
$parcel$export(module.exports, "default", () => $be078ace24a16c98$export$2e2bcd8739ae039);

var $b0lrK = parcelRequire("b0lrK");
function $be078ace24a16c98$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $be078ace24a16c98$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $be078ace24a16c98$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $be078ace24a16c98$var$_typeof(obj);
}
var $be078ace24a16c98$var$MAX_ARRAY_LENGTH = 10;
var $be078ace24a16c98$var$MAX_RECURSIVE_DEPTH = 2;
function $be078ace24a16c98$export$2e2bcd8739ae039(value) {
    return $be078ace24a16c98$var$formatValue(value, []);
}
function $be078ace24a16c98$var$formatValue(value, seenValues) {
    switch($be078ace24a16c98$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $be078ace24a16c98$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $be078ace24a16c98$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $be078ace24a16c98$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $be078ace24a16c98$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $be078ace24a16c98$var$formatArray(value, seenValues);
    return $be078ace24a16c98$var$formatObject(value, seenValues);
}
function $be078ace24a16c98$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $be078ace24a16c98$var$MAX_RECURSIVE_DEPTH) return '[' + $be078ace24a16c98$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $be078ace24a16c98$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $be078ace24a16c98$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $be078ace24a16c98$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($be078ace24a16c98$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($be078ace24a16c98$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $be078ace24a16c98$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $b0lrK.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $be078ace24a16c98$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("b0lrK", function(module, exports) {
$parcel$export(module.exports, "default", () => $803054a13ed856de$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $803054a13ed856de$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $803054a13ed856de$export$2e2bcd8739ae039 = $803054a13ed856de$var$nodejsCustomInspectSymbol;

});


parcelRegister("fSkCz", function(module, exports) {
$parcel$export(module.exports, "Location", () => $b8ebe51af1e93090$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $b8ebe51af1e93090$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $b8ebe51af1e93090$export$8ee0fc9ee280b4ee);

var $cb9Jl = parcelRequire("cb9Jl");
var $b8ebe51af1e93090$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $cb9Jl.default)($b8ebe51af1e93090$export$18a2be9195644f38);
var $b8ebe51af1e93090$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $cb9Jl.default)($b8ebe51af1e93090$export$50792b0e93539fde);
function $b8ebe51af1e93090$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("cb9Jl", function(module, exports) {
$parcel$export(module.exports, "default", () => $8dde0f5fd396dc53$export$2e2bcd8739ae039);

var $0IHUe = parcelRequire("0IHUe");

var $b0lrK = parcelRequire("b0lrK");
function $8dde0f5fd396dc53$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $0IHUe.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $b0lrK.default) classObject.prototype[0, $b0lrK.default] = fn;
}

});
parcelRegister("0IHUe", function(module, exports) {
$parcel$export(module.exports, "default", () => $0022ae1ccd0f083c$export$2e2bcd8739ae039);
function $0022ae1ccd0f083c$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("lsTsW", function(module, exports) {
$parcel$export(module.exports, "InvariantError", () => $fa073cda081b66c8$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $fa073cda081b66c8$export$f5708dca728d7177);

var $3g9wx = parcelRequire("3g9wx");

var $2M83v = parcelRequire("2M83v");
var $fa073cda081b66c8$var$genericMessage = "Invariant Violation";
var $fa073cda081b66c8$var$_a = Object.setPrototypeOf, $fa073cda081b66c8$var$setPrototypeOf = $fa073cda081b66c8$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $fa073cda081b66c8$var$_a;
var $fa073cda081b66c8$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $3g9wx.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $fa073cda081b66c8$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $fa073cda081b66c8$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $fa073cda081b66c8$var$genericMessage;
        $fa073cda081b66c8$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $fa073cda081b66c8$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $fa073cda081b66c8$export$cea12affaee22fe8(message);
}
function $fa073cda081b66c8$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $fa073cda081b66c8$var$wrapConsoleMethod("warn");
    invariant.error = $fa073cda081b66c8$var$wrapConsoleMethod("error");
})($fa073cda081b66c8$export$f5708dca728d7177 || ($fa073cda081b66c8$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $fa073cda081b66c8$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $2M83v === "object") $fa073cda081b66c8$export$e54fe5b0f43758f7 = $2M83v;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($fa073cda081b66c8$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $fa073cda081b66c8$var$invariant$1 = $fa073cda081b66c8$export$f5708dca728d7177;
var $fa073cda081b66c8$export$2e2bcd8739ae039 = $fa073cda081b66c8$var$invariant$1;

});

parcelRegister("glwNQ", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("1a8Re", function(module, exports) {
$parcel$export(module.exports, "equal", () => $0d8d988ade66440c$export$411ce8e5a71e3069);
var $0d8d988ade66440c$var$_a = Object.prototype, $0d8d988ade66440c$var$toString = $0d8d988ade66440c$var$_a.toString, $0d8d988ade66440c$var$hasOwnProperty = $0d8d988ade66440c$var$_a.hasOwnProperty;
var $0d8d988ade66440c$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $0d8d988ade66440c$export$411ce8e5a71e3069(a, b) {
    try {
        return $0d8d988ade66440c$var$check(a, b);
    } finally{
        $0d8d988ade66440c$var$previousComparisons.clear();
    }
}
function $0d8d988ade66440c$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $0d8d988ade66440c$var$toString.call(a);
    var bTag = $0d8d988ade66440c$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($0d8d988ade66440c$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$0d8d988ade66440c$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$0d8d988ade66440c$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($0d8d988ade66440c$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$0d8d988ade66440c$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $0d8d988ade66440c$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $0d8d988ade66440c$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $0d8d988ade66440c$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $0d8d988ade66440c$export$2e2bcd8739ae039 = $0d8d988ade66440c$export$411ce8e5a71e3069;

});



parcelRegister("9YhYD", function(module, exports) {
$parcel$export(module.exports, "default", () => $01df9b820eada9a4$export$2e2bcd8739ae039);
/* global window */ 
var $cPR03 = parcelRequire("cPR03");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $cPR03.default)(root);
var $01df9b820eada9a4$export$2e2bcd8739ae039 = result;

});
parcelRegister("cPR03", function(module, exports) {
$parcel$export(module.exports, "default", () => $95835c20e2abac67$export$2e2bcd8739ae039);
function $95835c20e2abac67$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("3Y1mv", function(module, exports) {

let $2e38082955c1c6bd$var$load = (parcelRequire("eSjtV"))(5);
module.exports = $2e38082955c1c6bd$var$load("4sSc7").then(()=>parcelRequire('dT547'));

});
parcelRegister("eSjtV", function(module, exports) {
"use strict";


let $ad45387e0d85c7d8$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("1LjFM")).shardUrl((parcelRequire("kW81H")).resolve(id), maxShards));
    };
module.exports = $ad45387e0d85c7d8$var$load;

});
parcelRegister("1LjFM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $148970d532cab72c$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $148970d532cab72c$var$getDomainShardIndex;
module.exports.shardUrl = $148970d532cab72c$var$shardUrl;
module.exports.shardUrlUnchecked = $148970d532cab72c$var$shardUrlUnchecked;
const $148970d532cab72c$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $148970d532cab72c$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $148970d532cab72c$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $148970d532cab72c$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $148970d532cab72c$var$removeTrailingShard(subdomain) {
    if (!$148970d532cab72c$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $148970d532cab72c$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$148970d532cab72c$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $148970d532cab72c$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $148970d532cab72c$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $148970d532cab72c$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $148970d532cab72c$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $148970d532cab72c$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $148970d532cab72c$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$148970d532cab72c$var$globalKeyName]) return url;
    return $148970d532cab72c$var$shardUrlUnchecked(url, maxShards);
}
const $148970d532cab72c$var$domainShardingKey = module.exports.domainShardingKey = $148970d532cab72c$var$globalKeyName;

});

parcelRegister("kW81H", function(module, exports) {
$parcel$export(module.exports, "register", () => $f3df734ced12461b$export$6503ec6e8aabbaf, (v) => $f3df734ced12461b$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $f3df734ced12461b$export$f7ad0328861e2f03, (v) => $f3df734ced12461b$export$f7ad0328861e2f03 = v);
var $f3df734ced12461b$export$6503ec6e8aabbaf;
var $f3df734ced12461b$export$f7ad0328861e2f03;
"use strict";
var $f3df734ced12461b$var$mapping = new Map();
function $f3df734ced12461b$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f3df734ced12461b$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f3df734ced12461b$var$resolve(id) {
    var resolved = $f3df734ced12461b$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f3df734ced12461b$export$6503ec6e8aabbaf = $f3df734ced12461b$var$register;
$f3df734ced12461b$export$f7ad0328861e2f03 = $f3df734ced12461b$var$resolve;

});



parcelRegister("hlQDR", function(module, exports) {

let $ca1d3b67f3c3a5a8$var$load = (parcelRequire("eSjtV"))(5);
module.exports = $ca1d3b67f3c3a5a8$var$load("a0y6A").then(()=>parcelRequire('jciKP'));

});

parcelRegister("lIz8L", function(module, exports) {

let $fcf8f72bac24d50d$var$load = (parcelRequire("eSjtV"))(5);
module.exports = $fcf8f72bac24d50d$var$load("lYDRh").then(()=>parcelRequire('zFyEX'));

});

parcelRegister("cq9aL", function(module, exports) {

let $90af073d7609a9a0$var$load = (parcelRequire("eSjtV"))(5);
module.exports = $90af073d7609a9a0$var$load("knPTc").then(()=>parcelRequire('eqvx9'));

});

parcelRegister("3xo4s", function(module, exports) {

let $2937202b3f2ed185$var$load = (parcelRequire("eSjtV"))(5);
module.exports = $2937202b3f2ed185$var$load("i7dFd").then(()=>parcelRequire('5vfcg'));

});

parcelRegister("bQ0TW", function(module, exports) {
'use strict';

var $b2BSK = parcelRequire("b2BSK");

var $9kbnH = parcelRequire("9kbnH");

var $aH9Fg = parcelRequire("aH9Fg");

var $5Mcad = parcelRequire("5Mcad");

var $lBgv6 = parcelRequire("lBgv6");

var $fRIad = parcelRequire("fRIad");

var $5eMli = parcelRequire("5eMli");

var $fcNlB = parcelRequire("fcNlB");

var $83mO0 = parcelRequire("83mO0");
var $89e53fffb512c4bf$var$loadQuery = $83mO0.loadQuery;

var $e5do4 = parcelRequire("e5do4");

var $kf4EO = parcelRequire("kf4EO");

var $ciDJ8 = parcelRequire("ciDJ8");

var $5Xv8M = parcelRequire("5Xv8M");

var $6yaQf = parcelRequire("6yaQf");

var $jbd9B = parcelRequire("jbd9B");

var $5RMmF = parcelRequire("5RMmF");

var $b91lf = parcelRequire("b91lf");

var $e5uIp = parcelRequire("e5uIp");

var $83Owo = parcelRequire("83Owo");

var $aReUR = parcelRequire("aReUR");

var $4beU6 = parcelRequire("4beU6");

var $1G3Wj = parcelRequire("1G3Wj");

var $bLLs1 = parcelRequire("bLLs1");

var $4JLoB = parcelRequire("4JLoB");

var $5ohfX = parcelRequire("5ohfX");
module.exports = {
    ConnectionHandler: $5ohfX.ConnectionHandler,
    QueryRenderer: $lBgv6,
    LocalQueryRenderer: $aH9Fg,
    MutationTypes: $5ohfX.MutationTypes,
    RangeOperations: $5ohfX.RangeOperations,
    ReactRelayContext: $b2BSK,
    applyOptimisticMutation: $5ohfX.applyOptimisticMutation,
    commitLocalUpdate: $5ohfX.commitLocalUpdate,
    commitMutation: $5ohfX.commitMutation,
    createFragmentContainer: $9kbnH.createContainer,
    createPaginationContainer: $5Mcad.createContainer,
    createRefetchContainer: $fRIad.createContainer,
    fetchQuery_DEPRECATED: $5ohfX.fetchQuery_DEPRECATED,
    graphql: $5ohfX.graphql,
    readInlineData: $5ohfX.readInlineData,
    requestSubscription: $5ohfX.requestSubscription,
    EntryPointContainer: $5eMli,
    RelayEnvironmentProvider: $kf4EO,
    ProfilerContext: $e5do4,
    fetchQuery: $5ohfX.fetchQuery,
    loadQuery: $89e53fffb512c4bf$var$loadQuery,
    loadEntryPoint: $fcNlB,
    useClientQuery: $ciDJ8,
    useFragment: $6yaQf,
    useLazyLoadQuery: $jbd9B,
    useEntryPointLoader: $5Xv8M,
    useQueryLoader: $aReUR,
    useMutation: $5RMmF,
    usePaginationFragment: $b91lf,
    usePreloadedQuery: $83Owo,
    useRefetchableFragment: $4beU6,
    usePrefetchableForwardPaginationFragment: $e5uIp,
    useRelayEnvironment: $1G3Wj,
    useSubscribeToInvalidationState: $bLLs1,
    useSubscription: $4JLoB
};

});
parcelRegister("b2BSK", function(module, exports) {
'use strict';

var $2hRE7 = parcelRequire("2hRE7");

var $5ohfX = parcelRequire("5ohfX");
var $809d442dee4d45cf$var$createRelayContext = $5ohfX.__internal.createRelayContext;
module.exports = $809d442dee4d45cf$var$createRelayContext($2hRE7);

});
parcelRegister("5ohfX", function(module, exports) {
/**
 * Relay v20.1.1
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("l6RnD"));

});
parcelRegister("l6RnD", function(module, exports) {
'use strict';

var $ldlEm = parcelRequire("ldlEm");
var $f5e390ba33d85bfc$var$isErrorResult = $ldlEm.isErrorResult, $f5e390ba33d85bfc$var$isValueResult = $ldlEm.isValueResult;

var $1QcxJ = parcelRequire("1QcxJ");

var $a0Lua = parcelRequire("a0Lua");

var $aPPZ4 = parcelRequire("aPPZ4");

var $6ePL7 = parcelRequire("6ePL7");

var $fScQ6 = parcelRequire("fScQ6");

var $2tOos = parcelRequire("2tOos");

var $bF36F = parcelRequire("bF36F");

var $dPcgp = parcelRequire("dPcgp");

var $8EWAO = parcelRequire("8EWAO");

var $h6dVp = parcelRequire("h6dVp");

var $gKwfV = parcelRequire("gKwfV");

var $eB3Lq = parcelRequire("eB3Lq");

var $fiaVl = parcelRequire("fiaVl");

var $5HXMu = parcelRequire("5HXMu");

var $iEOHk = parcelRequire("iEOHk");

var $jtlLI = parcelRequire("jtlLI");

var $e8h4i = parcelRequire("e8h4i");
var $f5e390ba33d85bfc$var$generateClientID = $e8h4i.generateClientID, $f5e390ba33d85bfc$var$generateUniqueClientID = $e8h4i.generateUniqueClientID, $f5e390ba33d85bfc$var$isClientID = $e8h4i.isClientID;

var $6kBJo = parcelRequire("6kBJo");

var $jwKci = parcelRequire("jwKci");

var $EXH5b = parcelRequire("EXH5b");

var $geBjh = parcelRequire("geBjh");

var $mzzfX = parcelRequire("mzzfX");
var $f5e390ba33d85bfc$var$isSuspenseSentinel = $mzzfX.isSuspenseSentinel, $f5e390ba33d85bfc$var$suspenseSentinel = $mzzfX.suspenseSentinel;

var $alzKh = parcelRequire("alzKh");

var $14hz1 = parcelRequire("14hz1");

var $8g71t = parcelRequire("8g71t");

var $8bN82 = parcelRequire("8bN82");

var $3pXrs = parcelRequire("3pXrs");

var $2yWF2 = parcelRequire("2yWF2");

var $5AfVC = parcelRequire("5AfVC");

var $ew5WD = parcelRequire("ew5WD");

var $4Am9m = parcelRequire("4Am9m");

var $kyCh1 = parcelRequire("kyCh1");

var $3axLc = parcelRequire("3axLc");

var $aqnmy = parcelRequire("aqnmy");

var $qW3rR = parcelRequire("qW3rR");

var $z7Nhe = parcelRequire("z7Nhe");

var $c8rrR = parcelRequire("c8rrR");

var $u9izA = parcelRequire("u9izA");

var $6N0I9 = parcelRequire("6N0I9");

var $0CevU = parcelRequire("0CevU");

var $kXuaj = parcelRequire("kXuaj");

var $iG0Ae = parcelRequire("iG0Ae");

var $j7ILL = parcelRequire("j7ILL");

var $gJjI0 = parcelRequire("gJjI0");

var $7dH9M = parcelRequire("7dH9M");

var $hE0vQ = parcelRequire("hE0vQ");

var $32s8z = parcelRequire("32s8z");
var $f5e390ba33d85bfc$var$handlePotentialSnapshotErrors = $32s8z.handlePotentialSnapshotErrors;

var $4dDWw = parcelRequire("4dDWw");

var $P3fo7 = parcelRequire("P3fo7");

var $7g2Xq = parcelRequire("7g2Xq");

var $gSH3f = parcelRequire("gSH3f");

var $25jNY = parcelRequire("25jNY");

var $drt2N = parcelRequire("drt2N");

var $1K5RO = parcelRequire("1K5RO");

var $gGE2x = parcelRequire("gGE2x");

var $5iHPe = parcelRequire("5iHPe");

var $fAAFv = parcelRequire("fAAFv");
var $f5e390ba33d85bfc$var$hasCycle = $fAAFv.hasCycle, $f5e390ba33d85bfc$var$stableCopy = $fAAFv.stableCopy;

var $glUrg = parcelRequire("glUrg");
var $f5e390ba33d85bfc$var$mapStr, $f5e390ba33d85bfc$var$setStr, $f5e390ba33d85bfc$var$promiseStr, $f5e390ba33d85bfc$var$objStr;
module.exports = {
    Environment: $8bN82,
    Network: $8EWAO,
    Observable: $h6dVp,
    QueryResponseCache: $gKwfV,
    RecordSource: $kyCh1,
    Record: $2yWF2,
    ReplaySubject: $5iHPe,
    Store: $ew5WD,
    areEqualSelectors: $5AfVC.areEqualSelectors,
    createFragmentSpecResolver: $6kBJo,
    createNormalizationSelector: $5AfVC.createNormalizationSelector,
    createOperationDescriptor: $3pXrs.createOperationDescriptor,
    createReaderSelector: $5AfVC.createReaderSelector,
    createRequestDescriptor: $3pXrs.createRequestDescriptor,
    getArgumentValues: $3axLc.getArgumentValues,
    getDataIDsFromFragment: $5AfVC.getDataIDsFromFragment,
    getDataIDsFromObject: $5AfVC.getDataIDsFromObject,
    getNode: $iEOHk.getNode,
    getFragment: $iEOHk.getFragment,
    getInlineDataFragment: $iEOHk.getInlineDataFragment,
    getModuleComponentKey: $3axLc.getModuleComponentKey,
    getModuleOperationKey: $3axLc.getModuleOperationKey,
    getPaginationFragment: $iEOHk.getPaginationFragment,
    getPluralSelector: $5AfVC.getPluralSelector,
    getRefetchableFragment: $iEOHk.getRefetchableFragment,
    getRequest: $iEOHk.getRequest,
    getRequestIdentifier: $7dH9M,
    getSelector: $5AfVC.getSelector,
    getSelectorsFromObject: $5AfVC.getSelectorsFromObject,
    getSingularSelector: $5AfVC.getSingularSelector,
    getStorageKey: $3axLc.getStorageKey,
    getVariablesFromFragment: $5AfVC.getVariablesFromFragment,
    getVariablesFromObject: $5AfVC.getVariablesFromObject,
    getVariablesFromPluralFragment: $5AfVC.getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: $5AfVC.getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: $f5e390ba33d85bfc$var$handlePotentialSnapshotErrors,
    graphql: $iEOHk.graphql,
    isErrorResult: $f5e390ba33d85bfc$var$isErrorResult,
    isValueResult: $f5e390ba33d85bfc$var$isValueResult,
    isFragment: $iEOHk.isFragment,
    isInlineDataFragment: $iEOHk.isInlineDataFragment,
    isSuspenseSentinel: $f5e390ba33d85bfc$var$isSuspenseSentinel,
    suspenseSentinel: $f5e390ba33d85bfc$var$suspenseSentinel,
    isRequest: $iEOHk.isRequest,
    readInlineData: $14hz1,
    readFragment: $aqnmy.readFragment,
    MutationTypes: $dPcgp.MutationTypes,
    RangeOperations: $dPcgp.RangeOperations,
    DefaultHandlerProvider: $6ePL7,
    ConnectionHandler: $1QcxJ,
    MutationHandlers: $aPPZ4,
    VIEWER_ID: $qW3rR.VIEWER_ID,
    VIEWER_TYPE: $qW3rR.VIEWER_TYPE,
    applyOptimisticMutation: $fScQ6,
    commitLocalUpdate: $2tOos,
    commitMutation: $bF36F,
    fetchQuery: $eB3Lq,
    fetchQuery_DEPRECATED: $fiaVl,
    isRelayModernEnvironment: $geBjh,
    requestSubscription: $z7Nhe,
    ConnectionInterface: $a0Lua,
    PreloadableQueryRegistry: $jtlLI,
    RelayProfiler: $gGE2x,
    createPayloadFor3DField: $c8rrR,
    RelayConcreteNode: $gSH3f,
    RelayError: $drt2N,
    RelayFeatureFlags: $1K5RO,
    DEFAULT_HANDLE_KEY: $25jNY.DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: $3axLc.FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: $3axLc.FRAGMENT_OWNER_KEY,
    ID_KEY: $3axLc.ID_KEY,
    REF_KEY: $3axLc.REF_KEY,
    REFS_KEY: $3axLc.REFS_KEY,
    ROOT_ID: $3axLc.ROOT_ID,
    ROOT_TYPE: $3axLc.ROOT_TYPE,
    TYPENAME_KEY: $3axLc.TYPENAME_KEY,
    deepFreeze: $u9izA,
    generateClientID: $f5e390ba33d85bfc$var$generateClientID,
    generateUniqueClientID: $f5e390ba33d85bfc$var$generateUniqueClientID,
    getRelayHandleKey: $gJjI0,
    isClientID: $f5e390ba33d85bfc$var$isClientID,
    isPromise: $4dDWw,
    isScalarAndEqual: $P3fo7,
    recycleNodesInto: $7g2Xq,
    stableCopy: $f5e390ba33d85bfc$var$stableCopy,
    hasCycle: $f5e390ba33d85bfc$var$hasCycle,
    getFragmentIdentifier: $6N0I9,
    getRefetchMetadata: $j7ILL,
    getPaginationMetadata: $0CevU,
    getPaginationVariables: $kXuaj,
    getPendingOperationsForFragment: $iG0Ae,
    getValueAtPath: $hE0vQ,
    __internal: {
        ResolverFragments: $aqnmy,
        OperationTracker: $4Am9m,
        createRelayContext: $jwKci,
        createRelayLoggingContext: $EXH5b,
        getOperationVariables: $8g71t.getOperationVariables,
        getLocalVariables: $8g71t.getLocalVariables,
        fetchQuery: $5HXMu.fetchQuery,
        fetchQueryDeduped: $5HXMu.fetchQueryDeduped,
        getPromiseForActiveRequest: $5HXMu.getPromiseForActiveRequest,
        getObservableForActiveRequest: $5HXMu.getObservableForActiveRequest,
        normalizeResponse: $alzKh,
        withProvidedVariables: $glUrg
    }
};

});
parcelRegister("ldlEm", function(module, exports) {
'use strict';

var $d7379 = parcelRequire("d7379");

var $b9azl = parcelRequire("b9azl");
var $f71b9b175fa65f14$var$observeFragment = $b9azl.observeFragment;

var $bH4mt = parcelRequire("bH4mt");
var $f71b9b175fa65f14$var$observeQuery = $bH4mt.observeQuery;

var $bMjUk = parcelRequire("bMjUk");
var $f71b9b175fa65f14$var$waitForFragmentData = $bMjUk.waitForFragmentData;
function $f71b9b175fa65f14$var$isValueResult(input) {
    return input.ok === true;
}
function $f71b9b175fa65f14$var$isErrorResult(input) {
    return input.ok === false;
}
module.exports = {
    resolverDataInjector: $d7379,
    isValueResult: $f71b9b175fa65f14$var$isValueResult,
    isErrorResult: $f71b9b175fa65f14$var$isErrorResult,
    observeQuery: $f71b9b175fa65f14$var$observeQuery,
    observeFragment: $f71b9b175fa65f14$var$observeFragment,
    waitForFragmentData: $f71b9b175fa65f14$var$waitForFragmentData
};

});
parcelRegister("d7379", function(module, exports) {
'use strict';

var $aqnmy = parcelRequire("aqnmy");
var $98be5843abf7fbed$var$readFragment = $aqnmy.readFragment;

var $1etGW = parcelRequire("1etGW");
function $98be5843abf7fbed$var$resolverDataInjector(fragment, _resolverFn, fieldName, isRequiredField) {
    var resolverFn = _resolverFn;
    return function(fragmentKey, args, resolverContext) {
        var data = $98be5843abf7fbed$var$readFragment(fragment, fragmentKey);
        if (fieldName != null) {
            if (data == null) {
                if (isRequiredField === true) $1etGW(false);
                else return resolverFn(null, args, resolverContext);
            }
            if (fieldName in data) {
                if (isRequiredField === true) !(data[fieldName] != null) && $1etGW(false);
                return resolverFn(data[fieldName], args, resolverContext);
            } else $1etGW(false);
        } else return resolverFn(null, args, resolverContext);
    };
}
module.exports = $98be5843abf7fbed$var$resolverDataInjector;

});
parcelRegister("aqnmy", function(module, exports) {
'use strict';

var $iEOHk = parcelRequire("iEOHk");
var $796e74796f7b7293$var$getFragment = $iEOHk.getFragment;

var $32s8z = parcelRequire("32s8z");
var $796e74796f7b7293$var$eventShouldThrow = $32s8z.eventShouldThrow;

var $5AfVC = parcelRequire("5AfVC");
var $796e74796f7b7293$var$getSelector = $5AfVC.getSelector;

var $1etGW = parcelRequire("1etGW");
var $796e74796f7b7293$var$contextStack = [];
function $796e74796f7b7293$var$withResolverContext(context, cb) {
    $796e74796f7b7293$var$contextStack.push(context);
    try {
        return cb();
    } finally{
        $796e74796f7b7293$var$contextStack.pop();
    }
}
function $796e74796f7b7293$var$readFragment(fragmentInput, fragmentKey) {
    if (!$796e74796f7b7293$var$contextStack.length) throw new Error('readFragment should be called only from within a Relay Resolver function.');
    var context = $796e74796f7b7293$var$contextStack[$796e74796f7b7293$var$contextStack.length - 1];
    var fragmentNode = $796e74796f7b7293$var$getFragment(fragmentInput);
    var fragmentSelector = $796e74796f7b7293$var$getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && $1etGW(false);
    !(fragmentSelector.kind === 'SingularReaderSelector') && $1etGW(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData, fieldErrors = _context$getDataForRe.fieldErrors;
    if (isMissingData || fieldErrors != null && fieldErrors.some($796e74796f7b7293$var$eventShouldThrow)) throw $796e74796f7b7293$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL;
    return data;
}
var $796e74796f7b7293$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = {};
module.exports = {
    readFragment: $796e74796f7b7293$var$readFragment,
    withResolverContext: $796e74796f7b7293$var$withResolverContext,
    RESOLVER_FRAGMENT_ERRORED_SENTINEL: $796e74796f7b7293$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL
};

});
parcelRegister("iEOHk", function(module, exports) {
'use strict';

var $gSH3f = parcelRequire("gSH3f");

var $1etGW = parcelRequire("1etGW");
parcelRequire("4j8bN");
function $d95349f9cabd59f0$var$graphql(strings) {
    $1etGW(false);
}
function $d95349f9cabd59f0$var$getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === 'function') node = node();
    else if (node["default"]) node = node["default"];
    return node;
}
function $d95349f9cabd59f0$var$isFragment(node) {
    var fragment = $d95349f9cabd59f0$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $gSH3f.FRAGMENT;
}
function $d95349f9cabd59f0$var$isRequest(node) {
    var request = $d95349f9cabd59f0$var$getNode(node);
    return typeof request === 'object' && request !== null && request.kind === $gSH3f.REQUEST;
}
function $d95349f9cabd59f0$var$isUpdatableQuery(node) {
    var updatableQuery = $d95349f9cabd59f0$var$getNode(node);
    return typeof updatableQuery === 'object' && updatableQuery !== null && updatableQuery.kind === $gSH3f.UPDATABLE_QUERY;
}
function $d95349f9cabd59f0$var$isInlineDataFragment(node) {
    var fragment = $d95349f9cabd59f0$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $gSH3f.INLINE_DATA_FRAGMENT;
}
function $d95349f9cabd59f0$var$getFragment(taggedNode) {
    var fragment = $d95349f9cabd59f0$var$getNode(taggedNode);
    !$d95349f9cabd59f0$var$isFragment(fragment) && $1etGW(false);
    return fragment;
}
function $d95349f9cabd59f0$var$getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = $d95349f9cabd59f0$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || typeof refetch !== 'object' || connection === null || typeof connection !== 'object') return null;
    return fragment;
}
function $d95349f9cabd59f0$var$getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = $d95349f9cabd59f0$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || typeof refetch !== 'object') return null;
    return fragment;
}
function $d95349f9cabd59f0$var$getRequest(taggedNode) {
    var request = $d95349f9cabd59f0$var$getNode(taggedNode);
    !$d95349f9cabd59f0$var$isRequest(request) && $1etGW(false);
    return request;
}
function $d95349f9cabd59f0$var$getUpdatableQuery(taggedNode) {
    var updatableQuery = $d95349f9cabd59f0$var$getNode(taggedNode);
    !$d95349f9cabd59f0$var$isUpdatableQuery(updatableQuery) && $1etGW(false);
    return updatableQuery;
}
function $d95349f9cabd59f0$var$getInlineDataFragment(taggedNode) {
    var fragment = $d95349f9cabd59f0$var$getNode(taggedNode);
    !$d95349f9cabd59f0$var$isInlineDataFragment(fragment) && $1etGW(false);
    return fragment;
}
module.exports = {
    getFragment: $d95349f9cabd59f0$var$getFragment,
    getNode: $d95349f9cabd59f0$var$getNode,
    getPaginationFragment: $d95349f9cabd59f0$var$getPaginationFragment,
    getRefetchableFragment: $d95349f9cabd59f0$var$getRefetchableFragment,
    getRequest: $d95349f9cabd59f0$var$getRequest,
    getUpdatableQuery: $d95349f9cabd59f0$var$getUpdatableQuery,
    getInlineDataFragment: $d95349f9cabd59f0$var$getInlineDataFragment,
    graphql: $d95349f9cabd59f0$var$graphql,
    isFragment: $d95349f9cabd59f0$var$isFragment,
    isRequest: $d95349f9cabd59f0$var$isRequest,
    isUpdatableQuery: $d95349f9cabd59f0$var$isUpdatableQuery,
    isInlineDataFragment: $d95349f9cabd59f0$var$isInlineDataFragment
};

});
parcelRegister("gSH3f", function(module, exports) {
'use strict';
var $c4a31594803017b3$var$RelayConcreteNode = {
    ACTOR_CHANGE: 'ActorChange',
    CATCH_FIELD: 'CatchField',
    CONDITION: 'Condition',
    CLIENT_COMPONENT: 'ClientComponent',
    CLIENT_EDGE_TO_SERVER_OBJECT: 'ClientEdgeToServerObject',
    CLIENT_EDGE_TO_CLIENT_OBJECT: 'ClientEdgeToClientObject',
    CLIENT_EXTENSION: 'ClientExtension',
    DEFER: 'Defer',
    CONNECTION: 'Connection',
    FRAGMENT: 'Fragment',
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_DATA_FRAGMENT_SPREAD: 'InlineDataFragmentSpread',
    INLINE_DATA_FRAGMENT: 'InlineDataFragment',
    INLINE_FRAGMENT: 'InlineFragment',
    LINKED_FIELD: 'LinkedField',
    LINKED_HANDLE: 'LinkedHandle',
    LITERAL: 'Literal',
    LIST_VALUE: 'ListValue',
    LOCAL_ARGUMENT: 'LocalArgument',
    MODULE_IMPORT: 'ModuleImport',
    ALIASED_FRAGMENT_SPREAD: 'AliasedFragmentSpread',
    ALIASED_INLINE_FRAGMENT_SPREAD: 'AliasedInlineFragmentSpread',
    RELAY_RESOLVER: 'RelayResolver',
    RELAY_LIVE_RESOLVER: 'RelayLiveResolver',
    REQUIRED_FIELD: 'RequiredField',
    OBJECT_VALUE: 'ObjectValue',
    OPERATION: 'Operation',
    REQUEST: 'Request',
    ROOT_ARGUMENT: 'RootArgument',
    SCALAR_FIELD: 'ScalarField',
    SCALAR_HANDLE: 'ScalarHandle',
    SPLIT_OPERATION: 'SplitOperation',
    STREAM: 'Stream',
    TYPE_DISCRIMINATOR: 'TypeDiscriminator',
    UPDATABLE_QUERY: 'UpdatableQuery',
    VARIABLE: 'Variable'
};
module.exports = $c4a31594803017b3$var$RelayConcreteNode;

});

parcelRegister("1etGW", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $0e5e2161aafece92$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $0e5e2161aafece92$var$invariant;

});

parcelRegister("4j8bN", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $2qdHe = parcelRequire("2qdHe");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function $322f49f6cefb4113$var$printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var $322f49f6cefb4113$var$warning = $2qdHe;
module.exports = $322f49f6cefb4113$var$warning;

});
parcelRegister("2qdHe", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $1c38a24c26125dbf$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $1c38a24c26125dbf$var$emptyFunction = function emptyFunction() {};
$1c38a24c26125dbf$var$emptyFunction.thatReturns = $1c38a24c26125dbf$var$makeEmptyFunction;
$1c38a24c26125dbf$var$emptyFunction.thatReturnsFalse = $1c38a24c26125dbf$var$makeEmptyFunction(false);
$1c38a24c26125dbf$var$emptyFunction.thatReturnsTrue = $1c38a24c26125dbf$var$makeEmptyFunction(true);
$1c38a24c26125dbf$var$emptyFunction.thatReturnsNull = $1c38a24c26125dbf$var$makeEmptyFunction(null);
$1c38a24c26125dbf$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$1c38a24c26125dbf$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $1c38a24c26125dbf$var$emptyFunction;

});



parcelRegister("32s8z", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $2367627d38367ad2$var$_interopRequireDefault = $9Ew61.default;

var $2367627d38367ad2$var$_objectSpread2 = $2367627d38367ad2$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $2367627d38367ad2$var$_createForOfIteratorHelper2 = $2367627d38367ad2$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $1etGW = parcelRequire("1etGW");
function $2367627d38367ad2$var$handleFieldErrors(environment, fieldErrors, loggingContext) {
    var _iterator = (0, $2367627d38367ad2$var$_createForOfIteratorHelper2["default"])(fieldErrors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var fieldError = _step.value;
            environment.relayFieldLogger((0, $2367627d38367ad2$var$_objectSpread2["default"])((0, $2367627d38367ad2$var$_objectSpread2["default"])({}, fieldError), {}, {
                uiContext: loggingContext
            }));
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var _iterator2 = (0, $2367627d38367ad2$var$_createForOfIteratorHelper2["default"])(fieldErrors), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _fieldError = _step2.value;
            if ($2367627d38367ad2$var$eventShouldThrow(_fieldError)) switch(_fieldError.kind){
                case 'relay_resolver.error':
                    throw new Error("Relay: Resolver error at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'. Message: ").concat(_fieldError.error.message));
                case 'relay_field_payload.error':
                    throw new Error("Relay: Unexpected response payload - check server logs for details.");
                case 'missing_expected_data.throw':
                    throw new Error("Relay: Missing expected data at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.throw':
                    throw new Error("Relay: Missing @required value at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.log':
                case 'missing_expected_data.log':
                    break;
                default:
                    _fieldError.kind;
                    $1etGW(false);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $2367627d38367ad2$var$eventShouldThrow(event) {
    switch(event.kind){
        case 'relay_resolver.error':
        case 'relay_field_payload.error':
            return event.shouldThrow && !event.handled;
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
            return !event.handled;
        case 'missing_required_field.log':
        case 'missing_expected_data.log':
            return false;
        default:
            event.kind;
            throw new Error('Relay: Unexpected event kind');
    }
}
function $2367627d38367ad2$var$handlePotentialSnapshotErrors(environment, fieldErrors, loggingContext) {
    if (fieldErrors != null) $2367627d38367ad2$var$handleFieldErrors(environment, fieldErrors, loggingContext);
}
module.exports = {
    handlePotentialSnapshotErrors: $2367627d38367ad2$var$handlePotentialSnapshotErrors,
    eventShouldThrow: $2367627d38367ad2$var$eventShouldThrow
};

});
parcelRegister("9Ew61", function(module, exports) {
function $7070bf1ee8c34230$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $7070bf1ee8c34230$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7lyjq", function(module, exports) {

var $2bxFr = parcelRequire("2bxFr");
function $55951c4c8966cc1f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $55951c4c8966cc1f$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $55951c4c8966cc1f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2bxFr(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $55951c4c8966cc1f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $55951c4c8966cc1f$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2bxFr", function(module, exports) {

var $cic30 = parcelRequire("cic30");
function $1976b97d25cee36f$var$_defineProperty(e, r, t) {
    return (r = $cic30(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $1976b97d25cee36f$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cic30", function(module, exports) {

var $fAAER = parcelRequire("fAAER");
var $8f3082daa453549a$var$_typeof = $fAAER.default;

var $aIQbl = parcelRequire("aIQbl");
function $8f3082daa453549a$var$toPropertyKey(t) {
    var i = $aIQbl(t, "string");
    return "symbol" == $8f3082daa453549a$var$_typeof(i) ? i : i + "";
}
module.exports = $8f3082daa453549a$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fAAER", function(module, exports) {
function $b596a754dc1e0f2c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $b596a754dc1e0f2c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b596a754dc1e0f2c$var$_typeof(o);
}
module.exports = $b596a754dc1e0f2c$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aIQbl", function(module, exports) {

var $fAAER = parcelRequire("fAAER");
var $7ce67db52ac91d0d$var$_typeof = $fAAER.default;
function $7ce67db52ac91d0d$var$toPrimitive(t, r) {
    if ("object" != $7ce67db52ac91d0d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7ce67db52ac91d0d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $7ce67db52ac91d0d$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("cZ3zG", function(module, exports) {

var $g41bw = parcelRequire("g41bw");
function $973df46408782db4$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $g41bw(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports = $973df46408782db4$var$_createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("g41bw", function(module, exports) {

var $jByQg = parcelRequire("jByQg");
function $bb1df05581b5343a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $jByQg(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $jByQg(r, a) : void 0;
    }
}
module.exports = $bb1df05581b5343a$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jByQg", function(module, exports) {
function $e45c7feba03d8c31$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $e45c7feba03d8c31$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("5AfVC", function(module, exports) {
'use strict';

var $8g71t = parcelRequire("8g71t");
var $410cab9948d4c9d0$var$getFragmentVariables = $8g71t.getFragmentVariables;

var $3axLc = parcelRequire("3axLc");
var $410cab9948d4c9d0$var$CLIENT_EDGE_TRAVERSAL_PATH = $3axLc.CLIENT_EDGE_TRAVERSAL_PATH, $410cab9948d4c9d0$var$FRAGMENT_OWNER_KEY = $3axLc.FRAGMENT_OWNER_KEY, $410cab9948d4c9d0$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $3axLc.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, $410cab9948d4c9d0$var$FRAGMENTS_KEY = $3axLc.FRAGMENTS_KEY, $410cab9948d4c9d0$var$ID_KEY = $3axLc.ID_KEY;

var $4MrjW = parcelRequire("4MrjW");

var $1etGW = parcelRequire("1etGW");
parcelRequire("4j8bN");
function $410cab9948d4c9d0$var$getSingularSelector(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $1etGW(false);
    var dataID = item[$410cab9948d4c9d0$var$ID_KEY];
    var fragments = item[$410cab9948d4c9d0$var$FRAGMENTS_KEY];
    var mixedOwner = item[$410cab9948d4c9d0$var$FRAGMENT_OWNER_KEY];
    var mixedClientEdgeTraversalPath = item[$410cab9948d4c9d0$var$CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === 'string' && typeof fragments === 'object' && fragments !== null && typeof fragments[fragment.name] === 'object' && fragments[fragment.name] !== null && typeof mixedOwner === 'object' && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = $410cab9948d4c9d0$var$getFragmentVariables(fragment, owner.variables, argumentVariables);
        var isWithinUnmatchedTypeRefinement = argumentVariables[$410cab9948d4c9d0$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
        return $410cab9948d4c9d0$var$createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
function $410cab9948d4c9d0$var$getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? $410cab9948d4c9d0$var$getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: 'PluralReaderSelector',
        selectors: selectors
    };
}
function $410cab9948d4c9d0$var$getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $1etGW(false);
        return $410cab9948d4c9d0$var$getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && $1etGW(false);
        return $410cab9948d4c9d0$var$getSingularSelector(fragment, item);
    }
}
function $410cab9948d4c9d0$var$getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = $410cab9948d4c9d0$var$getSelector(fragment, item);
    }
    return selectors;
}
function $410cab9948d4c9d0$var$getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = $410cab9948d4c9d0$var$getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function $410cab9948d4c9d0$var$getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $1etGW(false);
        return $410cab9948d4c9d0$var$getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && $1etGW(false);
        return $410cab9948d4c9d0$var$getDataID(fragment, item);
    }
}
function $410cab9948d4c9d0$var$getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? $410cab9948d4c9d0$var$getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
function $410cab9948d4c9d0$var$getDataID(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $1etGW(false);
    var dataID = item[$410cab9948d4c9d0$var$ID_KEY];
    if (typeof dataID === 'string') return dataID;
    return null;
}
function $410cab9948d4c9d0$var$getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = $410cab9948d4c9d0$var$getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function $410cab9948d4c9d0$var$getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && $1etGW(false);
        return $410cab9948d4c9d0$var$getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && $1etGW(false);
        return $410cab9948d4c9d0$var$getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function $410cab9948d4c9d0$var$getVariablesFromSingularFragment(fragment, item) {
    var selector = $410cab9948d4c9d0$var$getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function $410cab9948d4c9d0$var$getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = $410cab9948d4c9d0$var$getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function $410cab9948d4c9d0$var$areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && $4MrjW(thisSelector.variables, thatSelector.variables) && $410cab9948d4c9d0$var$areEqualOwners(thisSelector.owner, thatSelector.owner) && thisSelector.isWithinUnmatchedTypeRefinement === thatSelector.isWithinUnmatchedTypeRefinement && $410cab9948d4c9d0$var$areEqualClientEdgeTraversalPaths(thisSelector.clientEdgeTraversalPath, thatSelector.clientEdgeTraversalPath);
}
function $410cab9948d4c9d0$var$areEqualOwners(thisOwner, thatOwner) {
    if (thisOwner === thatOwner) return true;
    else return thisOwner.identifier === thatOwner.identifier && $4MrjW(thisOwner.cacheConfig, thatOwner.cacheConfig);
}
function $410cab9948d4c9d0$var$areEqualClientEdgeTraversalPaths(thisPath, thatPath) {
    if (thisPath === thatPath) return true;
    if (thisPath == null || thatPath == null || thisPath.length !== thatPath.length) return false;
    var idx = thisPath.length;
    while(idx--){
        var a = thisPath[idx];
        var b = thatPath[idx];
        if (a === b) continue;
        if (a == null || b == null || a.clientEdgeDestinationID !== b.clientEdgeDestinationID || a.readerClientEdge !== b.readerClientEdge) return false;
    }
    return true;
}
function $410cab9948d4c9d0$var$areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === 'SingularReaderSelector' && b.kind === 'SingularReaderSelector') return $410cab9948d4c9d0$var$areEqualSingularSelectors(a, b);
    else if (a.kind === 'PluralReaderSelector' && b.kind === 'PluralReaderSelector') return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return $410cab9948d4c9d0$var$areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function $410cab9948d4c9d0$var$createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        kind: 'SingularReaderSelector',
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        node: fragment,
        variables: variables,
        owner: request
    };
}
function $410cab9948d4c9d0$var$createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: $410cab9948d4c9d0$var$areEqualSelectors,
    createReaderSelector: $410cab9948d4c9d0$var$createReaderSelector,
    createNormalizationSelector: $410cab9948d4c9d0$var$createNormalizationSelector,
    getDataIDsFromFragment: $410cab9948d4c9d0$var$getDataIDsFromFragment,
    getDataIDsFromObject: $410cab9948d4c9d0$var$getDataIDsFromObject,
    getSingularSelector: $410cab9948d4c9d0$var$getSingularSelector,
    getPluralSelector: $410cab9948d4c9d0$var$getPluralSelector,
    getSelector: $410cab9948d4c9d0$var$getSelector,
    getSelectorsFromObject: $410cab9948d4c9d0$var$getSelectorsFromObject,
    getVariablesFromSingularFragment: $410cab9948d4c9d0$var$getVariablesFromSingularFragment,
    getVariablesFromPluralFragment: $410cab9948d4c9d0$var$getVariablesFromPluralFragment,
    getVariablesFromFragment: $410cab9948d4c9d0$var$getVariablesFromFragment,
    getVariablesFromObject: $410cab9948d4c9d0$var$getVariablesFromObject
};

});
parcelRegister("8g71t", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $603543f270a2327c$var$_interopRequireDefault = $9Ew61.default;

var $603543f270a2327c$var$_objectSpread2 = $603543f270a2327c$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $3axLc = parcelRequire("3axLc");
var $603543f270a2327c$var$getArgumentValues = $3axLc.getArgumentValues;

var $1etGW = parcelRequire("1etGW");
function $603543f270a2327c$var$getFragmentVariables(fragment, rootVariables, argumentVariables) {
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, $603543f270a2327c$var$_objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case 'LocalArgument':
                variables[definition.name] = definition.defaultValue;
                break;
            case 'RootArgument':
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                $1etGW(false);
        }
    });
    return variables || argumentVariables;
}
function $603543f270a2327c$var$getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function $603543f270a2327c$var$getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, $603543f270a2327c$var$_objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? $603543f270a2327c$var$getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getLocalVariables: $603543f270a2327c$var$getLocalVariables,
    getFragmentVariables: $603543f270a2327c$var$getFragmentVariables,
    getOperationVariables: $603543f270a2327c$var$getOperationVariables
};

});
parcelRegister("3axLc", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $24ec7e5900aa8bc1$var$_interopRequireDefault = $9Ew61.default;

var $24ec7e5900aa8bc1$var$_toConsumableArray2 = $24ec7e5900aa8bc1$var$_interopRequireDefault((parcelRequire("4Ika6")));

var $gJjI0 = parcelRequire("gJjI0");

var $gSH3f = parcelRequire("gSH3f");

var $1K5RO = parcelRequire("1K5RO");

var $fAAFv = parcelRequire("fAAFv");
var $24ec7e5900aa8bc1$var$stableCopy = $fAAFv.stableCopy;

var $1etGW = parcelRequire("1etGW");
var $24ec7e5900aa8bc1$var$VARIABLE = $gSH3f.VARIABLE, $24ec7e5900aa8bc1$var$LITERAL = $gSH3f.LITERAL, $24ec7e5900aa8bc1$var$OBJECT_VALUE = $gSH3f.OBJECT_VALUE, $24ec7e5900aa8bc1$var$LIST_VALUE = $gSH3f.LIST_VALUE;
var $24ec7e5900aa8bc1$var$ERRORS_KEY = '__errors';
var $24ec7e5900aa8bc1$var$MODULE_COMPONENT_KEY_PREFIX = '__module_component_';
var $24ec7e5900aa8bc1$var$MODULE_OPERATION_KEY_PREFIX = '__module_operation_';
var $24ec7e5900aa8bc1$var$RELAY_READ_TIME_RESOLVER_KEY_PREFIX = '$r:';
function $24ec7e5900aa8bc1$var$getArgumentValue(arg, variables) {
    if (arg.kind === $24ec7e5900aa8bc1$var$VARIABLE) return $24ec7e5900aa8bc1$var$getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === $24ec7e5900aa8bc1$var$LITERAL) return arg.value;
    else if (arg.kind === $24ec7e5900aa8bc1$var$OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = $24ec7e5900aa8bc1$var$getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === $24ec7e5900aa8bc1$var$LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push($24ec7e5900aa8bc1$var$getArgumentValue(item, variables));
        });
        return _value;
    }
}
function $24ec7e5900aa8bc1$var$getArgumentValues(args, variables, isWithinUnmatchedTypeRefinement) {
    var values = {};
    if (isWithinUnmatchedTypeRefinement) values[$24ec7e5900aa8bc1$var$RelayStoreUtils.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = true;
    if (args) args.forEach(function(arg) {
        values[arg.name] = $24ec7e5900aa8bc1$var$getArgumentValue(arg, variables);
    });
    return values;
}
function $24ec7e5900aa8bc1$var$getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = $gJjI0(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, $24ec7e5900aa8bc1$var$_toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return $24ec7e5900aa8bc1$var$formatStorageKey(handleName, $24ec7e5900aa8bc1$var$getArgumentValues(filterArgs, variables));
}
function $24ec7e5900aa8bc1$var$getStorageKey(field, variables) {
    if (field.storageKey) return field.storageKey;
    var args = $24ec7e5900aa8bc1$var$getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? $24ec7e5900aa8bc1$var$formatStorageKey(name, $24ec7e5900aa8bc1$var$getArgumentValues(args, variables)) : name;
}
function $24ec7e5900aa8bc1$var$getReadTimeResolverStorageKey(field, variables) {
    var storageKey = $24ec7e5900aa8bc1$var$getStorageKey(field, variables);
    return $1K5RO.ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX ? '$r:' + storageKey : storageKey;
}
function $24ec7e5900aa8bc1$var$getArguments(field) {
    if (field.kind === 'RelayResolver' || field.kind === 'RelayLiveResolver') {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === 'undefined' ? undefined : field.args;
    return args;
}
function $24ec7e5900aa8bc1$var$getStableStorageKey(name, args) {
    return $24ec7e5900aa8bc1$var$formatStorageKey(name, $24ec7e5900aa8bc1$var$stableCopy(args));
}
function $24ec7e5900aa8bc1$var$formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ':' + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'undefined'));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(','), ")");
}
function $24ec7e5900aa8bc1$var$getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && $1etGW(false);
    return $24ec7e5900aa8bc1$var$stableCopy(variables[name]);
}
function $24ec7e5900aa8bc1$var$getModuleComponentKey(documentName) {
    return "".concat($24ec7e5900aa8bc1$var$MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function $24ec7e5900aa8bc1$var$getModuleOperationKey(documentName) {
    return "".concat($24ec7e5900aa8bc1$var$MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
var $24ec7e5900aa8bc1$var$RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: '__actorIdentifier',
    CLIENT_EDGE_TRAVERSAL_PATH: '__clientEdgeTraversalPath',
    FRAGMENTS_KEY: '__fragments',
    FRAGMENT_OWNER_KEY: '__fragmentOwner',
    FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: '$isWithinUnmatchedTypeRefinement',
    FRAGMENT_PROP_NAME_KEY: '__fragmentPropName',
    MODULE_COMPONENT_KEY: '__module_component',
    ERRORS_KEY: $24ec7e5900aa8bc1$var$ERRORS_KEY,
    ID_KEY: '__id',
    REF_KEY: '__ref',
    REFS_KEY: '__refs',
    ROOT_ID: 'client:root',
    ROOT_TYPE: '__Root',
    TYPENAME_KEY: '__typename',
    INVALIDATED_AT_KEY: '__invalidated_at',
    RELAY_RESOLVER_VALUE_KEY: '__resolverValue',
    RELAY_RESOLVER_INVALIDATION_KEY: '__resolverValueMayBeInvalid',
    RELAY_RESOLVER_SNAPSHOT_KEY: '__resolverSnapshot',
    RELAY_RESOLVER_ERROR_KEY: '__resolverError',
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: '__resolverOutputTypeRecordIDs',
    RELAY_READ_TIME_RESOLVER_KEY_PREFIX: $24ec7e5900aa8bc1$var$RELAY_READ_TIME_RESOLVER_KEY_PREFIX,
    formatStorageKey: $24ec7e5900aa8bc1$var$formatStorageKey,
    getArgumentValue: $24ec7e5900aa8bc1$var$getArgumentValue,
    getArgumentValues: $24ec7e5900aa8bc1$var$getArgumentValues,
    getHandleStorageKey: $24ec7e5900aa8bc1$var$getHandleStorageKey,
    getStorageKey: $24ec7e5900aa8bc1$var$getStorageKey,
    getReadTimeResolverStorageKey: $24ec7e5900aa8bc1$var$getReadTimeResolverStorageKey,
    getStableStorageKey: $24ec7e5900aa8bc1$var$getStableStorageKey,
    getModuleComponentKey: $24ec7e5900aa8bc1$var$getModuleComponentKey,
    getModuleOperationKey: $24ec7e5900aa8bc1$var$getModuleOperationKey
};
module.exports = $24ec7e5900aa8bc1$var$RelayStoreUtils;

});
parcelRegister("4Ika6", function(module, exports) {

var $98ULQ = parcelRequire("98ULQ");

var $akDDv = parcelRequire("akDDv");

var $g41bw = parcelRequire("g41bw");

var $dTJ9h = parcelRequire("dTJ9h");
function $36eae93fe90ba0c7$var$_toConsumableArray(r) {
    return $98ULQ(r) || $akDDv(r) || $g41bw(r) || $dTJ9h();
}
module.exports = $36eae93fe90ba0c7$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("98ULQ", function(module, exports) {

var $jByQg = parcelRequire("jByQg");
function $6a80e5e1d98892da$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $jByQg(r);
}
module.exports = $6a80e5e1d98892da$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("akDDv", function(module, exports) {
function $785a848be86b0deb$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $785a848be86b0deb$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dTJ9h", function(module, exports) {
function $a1e36f05d7790af8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $a1e36f05d7790af8$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gJjI0", function(module, exports) {
'use strict';

var $25jNY = parcelRequire("25jNY");
var $c2e023153266c532$var$DEFAULT_HANDLE_KEY = $25jNY.DEFAULT_HANDLE_KEY;

var $1etGW = parcelRequire("1etGW");
function $c2e023153266c532$var$getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== $c2e023153266c532$var$DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && $1etGW(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = $c2e023153266c532$var$getRelayHandleKey;

});
parcelRegister("25jNY", function(module, exports) {
'use strict';
module.exports = {
    DEFAULT_HANDLE_KEY: ''
};

});


parcelRegister("1K5RO", function(module, exports) {
'use strict';
var $144ea35b8deea7f5$var$RelayFeatureFlags = {
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    LOG_MISSING_RECORDS_IN_PROD: false,
    ENABLE_STORE_ID_COLLISION_LOGGING: false,
    ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS: false,
    ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION: false,
    ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES: false,
    ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE: false,
    PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION: false,
    MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD: false,
    ENABLE_CYLE_DETECTION_IN_VARIABLES: false,
    ENABLE_ACTIVITY_COMPATIBILITY: false,
    ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX: true,
    ENABLE_USE_PAGINATION_IS_LOADING_FIX: false,
    DISALLOW_NESTED_UPDATES: false,
    ENABLE_TYPENAME_PREFIXED_DATA_ID: false,
    ENABLE_UI_CONTEXT_ON_RELAY_LOGGER: false,
    CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES: false
};
module.exports = $144ea35b8deea7f5$var$RelayFeatureFlags;

});

parcelRegister("fAAFv", function(module, exports) {
'use strict';
function $b596a96a1e942795$var$stableCopy(value) {
    if (!value || typeof value !== 'object') return value;
    if (Array.isArray(value)) return value.map($b596a96a1e942795$var$stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = $b596a96a1e942795$var$stableCopy(value[keys[i]]);
    return stable;
}
function $b596a96a1e942795$var$hasCycle(value) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    if (!value || typeof value !== 'object') return false;
    if (parents.has(value)) return true;
    var newParents = new Set(parents);
    newParents.add(value);
    var children = Array.isArray(value) ? value : Object.values(value);
    return children.some(function(v) {
        return $b596a96a1e942795$var$hasCycle(v, newParents);
    });
}
module.exports = {
    stableCopy: $b596a96a1e942795$var$stableCopy,
    hasCycle: $b596a96a1e942795$var$hasCycle
};

});



parcelRegister("4MrjW", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var $37b0d6727658d014$var$aStackPool = [];
var $37b0d6727658d014$var$bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function $37b0d6727658d014$var$areEqual(a, b) {
    var aStack = $37b0d6727658d014$var$aStackPool.length ? $37b0d6727658d014$var$aStackPool.pop() : [];
    var bStack = $37b0d6727658d014$var$bStackPool.length ? $37b0d6727658d014$var$bStackPool.pop() : [];
    var result = $37b0d6727658d014$var$eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    $37b0d6727658d014$var$aStackPool.push(aStack);
    $37b0d6727658d014$var$bStackPool.push(bStack);
    return result;
}
function $37b0d6727658d014$var$eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if (typeof a != 'object' || typeof b != 'object') return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case '[object String]':
            return a == String(b);
        case '[object Number]':
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case '[object Date]':
        case '[object Boolean]':
            return +a == +b;
        case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === '[object Array]') {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!$37b0d6727658d014$var$eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!$37b0d6727658d014$var$eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = $37b0d6727658d014$var$areEqual;

});




parcelRegister("b9azl", function(module, exports) {
"use strict";

var $9Ew61 = parcelRequire("9Ew61");
var $81d8bbc38079be4a$var$_interopRequireDefault = $9Ew61.default;

var $diyzN = parcelRequire("diyzN");
var $81d8bbc38079be4a$require$_asyncToGenerator = $diyzN.default;

var $81d8bbc38079be4a$var$_createForOfIteratorHelper2 = $81d8bbc38079be4a$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $h6dVp = parcelRequire("h6dVp");

var $5HXMu = parcelRequire("5HXMu");
var $81d8bbc38079be4a$var$getObservableForActiveRequest = $5HXMu.getObservableForActiveRequest;

var $iEOHk = parcelRequire("iEOHk");
var $81d8bbc38079be4a$var$getFragment = $iEOHk.getFragment;

var $32s8z = parcelRequire("32s8z");
var $81d8bbc38079be4a$var$handlePotentialSnapshotErrors = $32s8z.handlePotentialSnapshotErrors;

var $5AfVC = parcelRequire("5AfVC");
var $81d8bbc38079be4a$var$getSelector = $5AfVC.getSelector;

var $1etGW = parcelRequire("1etGW");
function $81d8bbc38079be4a$var$waitForFragmentData(_x, _x2, _x3) {
    return $81d8bbc38079be4a$var$_waitForFragmentData.apply(this, arguments);
}
function $81d8bbc38079be4a$var$_waitForFragmentData() {
    $81d8bbc38079be4a$var$_waitForFragmentData = $81d8bbc38079be4a$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $81d8bbc38079be4a$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $81d8bbc38079be4a$var$_waitForFragmentData.apply(this, arguments);
}
function $81d8bbc38079be4a$var$observeFragment(environment, fragment, fragmentRef) {
    var _fragmentNode$metadat;
    var fragmentNode = $81d8bbc38079be4a$var$getFragment(fragment);
    var fragmentSelector = $81d8bbc38079be4a$var$getSelector(fragmentNode, fragmentRef);
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.hasClientEdges) == null) && $1etGW(false);
    !(fragmentSelector != null) && $1etGW(false);
    switch(fragmentSelector.kind){
        case 'SingularReaderSelector':
            return $81d8bbc38079be4a$var$observeSingularSelector(environment, fragment, fragmentSelector);
        case 'PluralReaderSelector':
            return $81d8bbc38079be4a$var$observePluralSelector(environment, fragment, fragmentSelector);
    }
    $1etGW(false);
}
function $81d8bbc38079be4a$var$observeSingularSelector(environment, fragmentNode, fragmentSelector) {
    var snapshot = environment.lookup(fragmentSelector);
    return $h6dVp.create(function(sink) {
        sink.next($81d8bbc38079be4a$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, snapshot));
        var subscription = environment.subscribe(snapshot, function(nextSnapshot) {
            sink.next($81d8bbc38079be4a$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, nextSnapshot));
        });
        return function() {
            return subscription.dispose();
        };
    });
}
function $81d8bbc38079be4a$var$observePluralSelector(environment, fragmentNode, fragmentSelector) {
    var snapshots = fragmentSelector.selectors.map(function(selector) {
        return environment.lookup(selector);
    });
    return $h6dVp.create(function(sink) {
        var states = snapshots.map(function(snapshot, index) {
            return $81d8bbc38079be4a$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.selectors[index].owner, snapshot);
        });
        sink.next($81d8bbc38079be4a$var$mergeFragmentStates(states));
        var subscriptions = snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                states[index] = $81d8bbc38079be4a$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.selectors[index].owner, latestSnapshot);
                sink.next($81d8bbc38079be4a$var$mergeFragmentStates(states));
            });
        });
        return function() {
            return subscriptions.forEach(function(subscription) {
                return subscription.dispose();
            });
        };
    });
}
function $81d8bbc38079be4a$var$snapshotToFragmentState(environment, fragmentNode, owner, snapshot) {
    var missingLiveResolverFields = snapshot.missingLiveResolverFields != null && snapshot.missingLiveResolverFields.length > 0;
    var missingClientEdges = snapshot.missingClientEdges != null && snapshot.missingClientEdges.length > 0;
    if (missingLiveResolverFields || missingClientEdges) return {
        state: 'loading'
    };
    if (snapshot.isMissingData) {
        if ($81d8bbc38079be4a$var$getObservableForActiveRequest(environment, owner) != null || environment.getOperationTracker().getPendingOperationsAffectingOwner(owner) != null) return {
            state: 'loading'
        };
    }
    try {
        $81d8bbc38079be4a$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
    } catch (error) {
        return {
            error: error,
            state: 'error'
        };
    }
    !(snapshot.data != null) && $1etGW(false);
    return {
        state: 'ok',
        value: snapshot.data
    };
}
function $81d8bbc38079be4a$var$mergeFragmentStates(states) {
    var value = [];
    var _iterator = (0, $81d8bbc38079be4a$var$_createForOfIteratorHelper2["default"])(states), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var state = _step.value;
            if (state.state === 'ok') value.push(state.value);
            else return state;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return {
        state: 'ok',
        value: value
    };
}
module.exports = {
    observeFragment: $81d8bbc38079be4a$var$observeFragment,
    waitForFragmentData: $81d8bbc38079be4a$var$waitForFragmentData
};

});
parcelRegister("diyzN", function(module, exports) {
function $9ae7c6ed78f32307$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $9ae7c6ed78f32307$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $9ae7c6ed78f32307$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $9ae7c6ed78f32307$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $9ae7c6ed78f32307$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("h6dVp", function(module, exports) {
'use strict';

var $4dDWw = parcelRequire("4dDWw");
var $c72dcc69b81902d7$var$hostReportError = $c72dcc69b81902d7$var$swallowError;
var $c72dcc69b81902d7$var$RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        $c72dcc69b81902d7$var$hostReportError = callback;
    };
    RelayObservable.from = function from(obj) {
        return $c72dcc69b81902d7$var$isObservable(obj) ? $c72dcc69b81902d7$var$fromObservable(obj) : $4dDWw(obj) ? $c72dcc69b81902d7$var$fromPromise(obj) : $c72dcc69b81902d7$var$fromValue(obj);
    };
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    };
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        $c72dcc69b81902d7$var$hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both('start'),
                next: both('next'),
                error: both('error'),
                complete: both('complete'),
                unsubscribe: both('unsubscribe')
            });
        });
    };
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    };
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current;
            current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto.subscribe = function subscribe(observer) {
        return $c72dcc69b81902d7$var$_subscribe(this._source, observer);
    };
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    };
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    };
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    };
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}();
function $c72dcc69b81902d7$var$isObservable(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.subscribe === 'function';
}
function $c72dcc69b81902d7$var$fromObservable(obj) {
    return obj instanceof $c72dcc69b81902d7$var$RelayObservable ? obj : $c72dcc69b81902d7$var$RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function $c72dcc69b81902d7$var$fromPromise(promise) {
    return $c72dcc69b81902d7$var$RelayObservable.create(function(sink) {
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function $c72dcc69b81902d7$var$fromValue(value) {
    return $c72dcc69b81902d7$var$RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function $c72dcc69b81902d7$var$_subscribe(source, observer) {
    var closed = false;
    var cleanup;
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, 'closed', {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                $c72dcc69b81902d7$var$hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    $c72dcc69b81902d7$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        $c72dcc69b81902d7$var$hostReportError(error, true);
    }
    if (closed) return subscription;
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                $c72dcc69b81902d7$var$hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                $c72dcc69b81902d7$var$hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    $c72dcc69b81902d7$var$hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    $c72dcc69b81902d7$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    if (closed) doCleanup();
    return subscription;
}
function $c72dcc69b81902d7$var$swallowError(_error, _isUncaughtThrownError) {}
module.exports = $c72dcc69b81902d7$var$RelayObservable;

});
parcelRegister("4dDWw", function(module, exports) {
'use strict';
function $31275c22be5bc0e6$var$isPromise(p) {
    return p != null && typeof p === 'object' && typeof p.then === 'function';
}
module.exports = $31275c22be5bc0e6$var$isPromise;

});


parcelRegister("5HXMu", function(module, exports) {
'use strict';

var $h6dVp = parcelRequire("h6dVp");

var $5iHPe = parcelRequire("5iHPe");

var $1etGW = parcelRequire("1etGW");
var $427f572ecac837d5$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $427f572ecac837d5$var$requestCachesByEnvironment = $427f572ecac837d5$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $427f572ecac837d5$var$fetchQuery(environment, operation) {
    return $427f572ecac837d5$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
function $427f572ecac837d5$var$fetchQueryDeduped(environment, identifier, fetchFn) {
    return $h6dVp.create(function(sink) {
        var requestCache = $427f572ecac837d5$var$getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new $5iHPe(),
                    subjectForInFlightStatus: new $5iHPe(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = $427f572ecac837d5$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = $427f572ecac837d5$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = $427f572ecac837d5$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = $427f572ecac837d5$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && $1etGW(false);
        return $427f572ecac837d5$var$getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
function $427f572ecac837d5$var$getObservableForCachedRequest(requestCache, cachedRequest) {
    return $h6dVp.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
function $427f572ecac837d5$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return $h6dVp.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
function $427f572ecac837d5$var$getPromiseForActiveRequest(environment, request) {
    var requestCache = $427f572ecac837d5$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        $427f572ecac837d5$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    return promise;
}
function $427f572ecac837d5$var$getObservableForActiveRequest(environment, request) {
    var requestCache = $427f572ecac837d5$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return $427f572ecac837d5$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
function $427f572ecac837d5$var$getRequestCache(environment) {
    var cached = $427f572ecac837d5$var$requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    $427f572ecac837d5$var$requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
function $427f572ecac837d5$var$getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && $1etGW(false);
    return cached;
}
module.exports = {
    fetchQuery: $427f572ecac837d5$var$fetchQuery,
    fetchQueryDeduped: $427f572ecac837d5$var$fetchQueryDeduped,
    getPromiseForActiveRequest: $427f572ecac837d5$var$getPromiseForActiveRequest,
    getObservableForActiveRequest: $427f572ecac837d5$var$getObservableForActiveRequest
};

});
parcelRegister("5iHPe", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $3dc0a0f74b271225$var$_interopRequireDefault = $9Ew61.default;

var $3dc0a0f74b271225$var$_createForOfIteratorHelper2 = $3dc0a0f74b271225$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $3dc0a0f74b271225$var$_defineProperty2 = $3dc0a0f74b271225$var$_interopRequireDefault((parcelRequire("2bxFr")));

var $h6dVp = parcelRequire("h6dVp");

var $1etGW = parcelRequire("1etGW");
var $3dc0a0f74b271225$var$RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, $3dc0a0f74b271225$var$_defineProperty2["default"])(this, "_complete", false);
        (0, $3dc0a0f74b271225$var$_defineProperty2["default"])(this, "_events", []);
        (0, $3dc0a0f74b271225$var$_defineProperty2["default"])(this, "_sinks", new Set());
        (0, $3dc0a0f74b271225$var$_defineProperty2["default"])(this, "_subscription", []);
        this._observable = $h6dVp.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case 'complete':
                        sink.complete();
                        break;
                    case 'error':
                        sink.error(event.error);
                        break;
                    case 'next':
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        $1etGW(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'complete'
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'error',
            error: _error
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            kind: 'next',
            data: data
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, $3dc0a0f74b271225$var$_createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
module.exports = $3dc0a0f74b271225$var$RelayReplaySubject;

});



parcelRegister("bH4mt", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $883717f2a3602577$var$_interopRequireDefault = $9Ew61.default;

var $883717f2a3602577$var$_defineProperty2 = $883717f2a3602577$var$_interopRequireDefault((parcelRequire("2bxFr")));

var $b9azl = parcelRequire("b9azl");
var $883717f2a3602577$var$observeFragment = $b9azl.observeFragment;

var $3pXrs = parcelRequire("3pXrs");
var $883717f2a3602577$var$createOperationDescriptor = $3pXrs.createOperationDescriptor;
function $883717f2a3602577$var$observeQuery(environment, gqlQuery, variables) {
    var operation = $883717f2a3602577$var$createOperationDescriptor(gqlQuery, variables);
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $883717f2a3602577$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    var fragmentNode = operation.request.node.fragment;
    return $883717f2a3602577$var$observeFragment(environment, fragmentNode, rootFragmentRef);
}
module.exports = {
    observeQuery: $883717f2a3602577$var$observeQuery
};

});
parcelRegister("3pXrs", function(module, exports) {
'use strict';
parcelRequire("u9izA");

var $7dH9M = parcelRequire("7dH9M");

var $1K5RO = parcelRequire("1K5RO");

var $fAAFv = parcelRequire("fAAFv");
var $27d1d0d3633bd96e$var$hasCycle = $fAAFv.hasCycle;

var $8g71t = parcelRequire("8g71t");
var $27d1d0d3633bd96e$var$getOperationVariables = $8g71t.getOperationVariables;

var $5AfVC = parcelRequire("5AfVC");
var $27d1d0d3633bd96e$var$createNormalizationSelector = $5AfVC.createNormalizationSelector, $27d1d0d3633bd96e$var$createReaderSelector = $5AfVC.createReaderSelector;

var $3axLc = parcelRequire("3axLc");
var $27d1d0d3633bd96e$var$ROOT_ID = $3axLc.ROOT_ID;

var $1etGW = parcelRequire("1etGW");
function $27d1d0d3633bd96e$var$createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $27d1d0d3633bd96e$var$ROOT_ID;
    var operation = request.operation;
    var operationVariables = $27d1d0d3633bd96e$var$getOperationVariables(operation, request.params.providedVariables, variables);
    if ($1K5RO.ENABLE_CYLE_DETECTION_IN_VARIABLES) !!$27d1d0d3633bd96e$var$hasCycle(operationVariables) && $1etGW(false);
    var requestDescriptor = $27d1d0d3633bd96e$var$createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: $27d1d0d3633bd96e$var$createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: $27d1d0d3633bd96e$var$createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function $27d1d0d3633bd96e$var$createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: $7dH9M(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
module.exports = {
    createOperationDescriptor: $27d1d0d3633bd96e$var$createOperationDescriptor,
    createRequestDescriptor: $27d1d0d3633bd96e$var$createRequestDescriptor
};

});
parcelRegister("u9izA", function(module, exports) {
'use strict';
function $05aa03f535c233d6$var$deepFreeze(object) {
    if (!$05aa03f535c233d6$var$shouldBeFrozen(object)) return object;
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && typeof property === 'object' && !Object.isFrozen(property)) $05aa03f535c233d6$var$deepFreeze(property);
    });
    return object;
}
function $05aa03f535c233d6$var$shouldBeFrozen(value) {
    return value != null && (Array.isArray(value) || typeof value === 'object' && value.constructor === Object);
}
module.exports = $05aa03f535c233d6$var$deepFreeze;

});

parcelRegister("7dH9M", function(module, exports) {
'use strict';

var $fAAFv = parcelRequire("fAAFv");
var $541b39586d366dbc$var$stableCopy = $fAAFv.stableCopy;

var $1etGW = parcelRequire("1etGW");
function $541b39586d366dbc$var$getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && $1etGW(false);
    return requestID + JSON.stringify($541b39586d366dbc$var$stableCopy(variables));
}
module.exports = $541b39586d366dbc$var$getRequestIdentifier;

});



parcelRegister("bMjUk", function(module, exports) {
"use strict";

var $diyzN = parcelRequire("diyzN");
var $89339ea2def43c1b$require$_asyncToGenerator = $diyzN.default;

var $b9azl = parcelRequire("b9azl");
var $89339ea2def43c1b$var$observeFragment = $b9azl.observeFragment;
function $89339ea2def43c1b$var$waitForFragmentData(_x, _x2, _x3) {
    return $89339ea2def43c1b$var$_waitForFragmentData.apply(this, arguments);
}
function $89339ea2def43c1b$var$_waitForFragmentData() {
    $89339ea2def43c1b$var$_waitForFragmentData = $89339ea2def43c1b$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $89339ea2def43c1b$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $89339ea2def43c1b$var$_waitForFragmentData.apply(this, arguments);
}
module.exports = {
    waitForFragmentData: $89339ea2def43c1b$var$waitForFragmentData
};

});


parcelRegister("1QcxJ", function(module, exports) {
'use strict';

var $e8h4i = parcelRequire("e8h4i");
var $15746093713f848e$var$generateClientID = $e8h4i.generateClientID;

var $3axLc = parcelRequire("3axLc");
var $15746093713f848e$var$getStableStorageKey = $3axLc.getStableStorageKey;

var $gJjI0 = parcelRequire("gJjI0");

var $a0Lua = parcelRequire("a0Lua");

var $1etGW = parcelRequire("1etGW");
parcelRequire("4j8bN");
var $15746093713f848e$var$CONNECTION = 'connection';
var $15746093713f848e$var$NEXT_EDGE_INDEX = '__connection_next_edge_index';
function $15746093713f848e$var$update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = $a0Lua.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey, undefined, record.getErrors(payload.fieldKey));
        return;
    }
    var clientConnectionID = $15746093713f848e$var$generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, $15746093713f848e$var$NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return $15746093713f848e$var$buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create($15746093713f848e$var$generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return $15746093713f848e$var$buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                var _clientPageInfo;
                var clientEndCursor = (_clientPageInfo = clientPageInfo) === null || _clientPageInfo === void 0 ? void 0 : _clientPageInfo.getValue(END_CURSOR);
                var serverEndCursor = serverPageInfo === null || serverPageInfo === void 0 ? void 0 : serverPageInfo.getValue(END_CURSOR);
                var isAddingEdgesAfterCurrentPage = clientPageInfo && args.after === clientEndCursor;
                var isFillingOutCurrentPage = clientPageInfo && clientEndCursor === serverEndCursor;
                if (isAddingEdgesAfterCurrentPage || isFillingOutCurrentPage) {
                    var nodeIDs = new Set();
                    $15746093713f848e$var$mergeEdges(prevEdges, nextEdges, nodeIDs);
                    $15746093713f848e$var$mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    $15746093713f848e$var$mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    $15746093713f848e$var$mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else nextEdges = prevEdges;
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === 'string') clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === 'string') clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
function $15746093713f848e$var$getConnection(record, key, filters) {
    var handleKey = $gJjI0($15746093713f848e$var$CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
function $15746093713f848e$var$getConnectionID(recordID, key, filters) {
    var handleKey = $gJjI0($15746093713f848e$var$CONNECTION, key, null);
    var storageKey = $15746093713f848e$var$getStableStorageKey(handleKey, filters);
    return $15746093713f848e$var$generateClientID(recordID, storageKey);
}
function $15746093713f848e$var$insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = $a0Lua.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $15746093713f848e$var$createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = $a0Lua.get(), NODE = _ConnectionInterface$3.NODE;
    var edgeID = $15746093713f848e$var$generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue('cursor') == null) edge.setValue(null, 'cursor');
    return edge;
}
function $15746093713f848e$var$insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = $a0Lua.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $15746093713f848e$var$deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = $a0Lua.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
function $15746093713f848e$var$buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = $a0Lua.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue($15746093713f848e$var$NEXT_EDGE_INDEX);
    !(typeof edgeIndex === 'number') && $1etGW(false);
    var edgeID = $15746093713f848e$var$generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue('cursor') == null) connectionEdge.setValue(null, 'cursor');
    connection.setValue(edgeIndex + 1, $15746093713f848e$var$NEXT_EDGE_INDEX);
    return connectionEdge;
}
function $15746093713f848e$var$mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = $a0Lua.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
module.exports = {
    buildConnectionEdge: $15746093713f848e$var$buildConnectionEdge,
    createEdge: $15746093713f848e$var$createEdge,
    deleteNode: $15746093713f848e$var$deleteNode,
    getConnection: $15746093713f848e$var$getConnection,
    getConnectionID: $15746093713f848e$var$getConnectionID,
    insertEdgeAfter: $15746093713f848e$var$insertEdgeAfter,
    insertEdgeBefore: $15746093713f848e$var$insertEdgeBefore,
    update: $15746093713f848e$var$update
};

});
parcelRegister("e8h4i", function(module, exports) {
'use strict';

var $1K5RO = parcelRequire("1K5RO");

var $cD1hi = parcelRequire("cD1hi");
var $a49f0d7776b2fd52$var$intern = $cD1hi.intern;
var $a49f0d7776b2fd52$var$PREFIX = 'client:';
function $a49f0d7776b2fd52$var$generateClientID(id, storageKey, index) {
    var internedId = $1K5RO.STRING_INTERN_LEVEL <= 0 ? id : $a49f0d7776b2fd52$var$intern(id, $1K5RO.MAX_DATA_ID_LENGTH);
    var key = internedId + ':' + storageKey;
    if (index != null) key += ':' + index;
    if (key.indexOf($a49f0d7776b2fd52$var$PREFIX) !== 0) key = $a49f0d7776b2fd52$var$PREFIX + key;
    return key;
}
function $a49f0d7776b2fd52$var$isClientID(id) {
    return id.indexOf($a49f0d7776b2fd52$var$PREFIX) === 0;
}
var $a49f0d7776b2fd52$var$localID = 0;
function $a49f0d7776b2fd52$var$generateUniqueClientID() {
    return "".concat($a49f0d7776b2fd52$var$PREFIX, "local:").concat($a49f0d7776b2fd52$var$localID++);
}
function $a49f0d7776b2fd52$var$generateClientObjectClientID(typename, localId, index) {
    var key = "".concat($a49f0d7776b2fd52$var$PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ':' + index;
    return key;
}
module.exports = {
    generateClientID: $a49f0d7776b2fd52$var$generateClientID,
    generateClientObjectClientID: $a49f0d7776b2fd52$var$generateClientObjectClientID,
    generateUniqueClientID: $a49f0d7776b2fd52$var$generateUniqueClientID,
    isClientID: $a49f0d7776b2fd52$var$isClientID
};

});
parcelRegister("cD1hi", function(module, exports) {
'use strict';
var $931a1e5ba005eb27$var$internTable = new Map();
var $931a1e5ba005eb27$var$nextIndex = 1;
var $931a1e5ba005eb27$var$digits = $931a1e5ba005eb27$var$initDigitTable();
var $931a1e5ba005eb27$var$INTERN_PREFIX = '\t';
var $931a1e5ba005eb27$var$ESCAPE_PREFIX = '\v';
function $931a1e5ba005eb27$var$initDigitTable() {
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
function $931a1e5ba005eb27$var$escape(str) {
    if (str[0] === $931a1e5ba005eb27$var$INTERN_PREFIX && $931a1e5ba005eb27$var$digits.has(str[1]) || str[0] === $931a1e5ba005eb27$var$ESCAPE_PREFIX) return $931a1e5ba005eb27$var$ESCAPE_PREFIX + str;
    return str;
}
function $931a1e5ba005eb27$var$intern(str, limit) {
    if (limit == null || str.length < limit) return $931a1e5ba005eb27$var$escape(str);
    var internedString = $931a1e5ba005eb27$var$internTable.get(str);
    if (internedString != null) return internedString;
    internedString = $931a1e5ba005eb27$var$INTERN_PREFIX + $931a1e5ba005eb27$var$nextIndex++;
    $931a1e5ba005eb27$var$internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: $931a1e5ba005eb27$var$intern
};

});


parcelRegister("a0Lua", function(module, exports) {
'use strict';
var $749ebd2368a07c32$var$CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var $749ebd2368a07c32$var$config = {
    CURSOR: 'cursor',
    EDGES: 'edges',
    END_CURSOR: 'endCursor',
    HAS_NEXT_PAGE: 'hasNextPage',
    HAS_PREV_PAGE: 'hasPreviousPage',
    NODE: 'node',
    PAGE_INFO_TYPE: 'PageInfo',
    PAGE_INFO: 'pageInfo',
    START_CURSOR: 'startCursor'
};
var $749ebd2368a07c32$var$ConnectionInterface = {
    inject: function inject(newConfig) {
        $749ebd2368a07c32$var$config = newConfig;
    },
    get: function get() {
        return $749ebd2368a07c32$var$config;
    },
    isConnectionCall: function isConnectionCall(call) {
        return $749ebd2368a07c32$var$CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
module.exports = $749ebd2368a07c32$var$ConnectionInterface;

});


parcelRegister("aPPZ4", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $7e36fdc04b2b0010$var$_interopRequireDefault = $9Ew61.default;

var $7e36fdc04b2b0010$var$_createForOfIteratorHelper2 = $7e36fdc04b2b0010$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $1QcxJ = parcelRequire("1QcxJ");

var $a0Lua = parcelRequire("a0Lua");

var $1etGW = parcelRequire("1etGW");
parcelRequire("4j8bN");
var $7e36fdc04b2b0010$var$DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === 'string') store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === 'string') store["delete"](id);
            });
        }
    }
};
var $7e36fdc04b2b0010$var$DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $1etGW(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === 'string') {
                var _iterator = (0, $7e36fdc04b2b0010$var$_createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        $1QcxJ.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var $7e36fdc04b2b0010$var$AppendEdgeHandler = {
    update: $7e36fdc04b2b0010$var$edgeUpdater($1QcxJ.insertEdgeAfter)
};
var $7e36fdc04b2b0010$var$PrependEdgeHandler = {
    update: $7e36fdc04b2b0010$var$edgeUpdater($1QcxJ.insertEdgeBefore)
};
var $7e36fdc04b2b0010$var$AppendNodeHandler = {
    update: $7e36fdc04b2b0010$var$nodeUpdater($1QcxJ.insertEdgeAfter)
};
var $7e36fdc04b2b0010$var$PrependNodeHandler = {
    update: $7e36fdc04b2b0010$var$nodeUpdater($1QcxJ.insertEdgeBefore)
};
function $7e36fdc04b2b0010$var$edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $1etGW(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = $a0Lua.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, $7e36fdc04b2b0010$var$_createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord('node');
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, $7e36fdc04b2b0010$var$_createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $1QcxJ.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && $1etGW(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function $7e36fdc04b2b0010$var$nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && $1etGW(false);
        !(edgeTypeName != null) && $1etGW(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = $a0Lua.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, $7e36fdc04b2b0010$var$_createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, $7e36fdc04b2b0010$var$_createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $1QcxJ.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && $1etGW(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
module.exports = {
    AppendEdgeHandler: $7e36fdc04b2b0010$var$AppendEdgeHandler,
    DeleteRecordHandler: $7e36fdc04b2b0010$var$DeleteRecordHandler,
    PrependEdgeHandler: $7e36fdc04b2b0010$var$PrependEdgeHandler,
    AppendNodeHandler: $7e36fdc04b2b0010$var$AppendNodeHandler,
    PrependNodeHandler: $7e36fdc04b2b0010$var$PrependNodeHandler,
    DeleteEdgeHandler: $7e36fdc04b2b0010$var$DeleteEdgeHandler
};

});

parcelRegister("6ePL7", function(module, exports) {
'use strict';

var $1QcxJ = parcelRequire("1QcxJ");

var $aPPZ4 = parcelRequire("aPPZ4");

var $1etGW = parcelRequire("1etGW");
function $48ac33210d152c8b$var$RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case 'connection':
            return $1QcxJ;
        case 'deleteRecord':
            return $aPPZ4.DeleteRecordHandler;
        case 'deleteEdge':
            return $aPPZ4.DeleteEdgeHandler;
        case 'appendEdge':
            return $aPPZ4.AppendEdgeHandler;
        case 'prependEdge':
            return $aPPZ4.PrependEdgeHandler;
        case 'appendNode':
            return $aPPZ4.AppendNodeHandler;
        case 'prependNode':
            return $aPPZ4.PrependNodeHandler;
    }
    $1etGW(false);
}
module.exports = $48ac33210d152c8b$var$RelayDefaultHandlerProvider;

});

parcelRegister("fScQ6", function(module, exports) {
'use strict';

var $iEOHk = parcelRequire("iEOHk");
var $b8e5dbc822d54080$var$getRequest = $iEOHk.getRequest;

var $geBjh = parcelRequire("geBjh");

var $3pXrs = parcelRequire("3pXrs");
var $b8e5dbc822d54080$var$createOperationDescriptor = $3pXrs.createOperationDescriptor;

var $dPcgp = parcelRequire("dPcgp");

var $1etGW = parcelRequire("1etGW");
function $b8e5dbc822d54080$var$applyOptimisticMutation(environment, config) {
    !$geBjh(environment) && $1etGW(false);
    var mutation = $b8e5dbc822d54080$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = $b8e5dbc822d54080$var$createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = $dPcgp.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
module.exports = $b8e5dbc822d54080$var$applyOptimisticMutation;

});
parcelRegister("geBjh", function(module, exports) {
'use strict';
function $bd1ae5264f2f9c5b$var$isRelayModernEnvironment(environment) {
    return Boolean(environment && environment['@@RelayModernEnvironment']);
}
module.exports = $bd1ae5264f2f9c5b$var$isRelayModernEnvironment;

});

parcelRegister("dPcgp", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $a1098d11c3506fdb$var$_interopRequireDefault = $9Ew61.default;

var $a1098d11c3506fdb$var$_createForOfIteratorHelper2 = $a1098d11c3506fdb$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $1QcxJ = parcelRequire("1QcxJ");
parcelRequire("4j8bN");
var $a1098d11c3506fdb$var$MutationTypes = Object.freeze({
    RANGE_ADD: 'RANGE_ADD',
    RANGE_DELETE: 'RANGE_DELETE',
    NODE_DELETE: 'NODE_DELETE'
});
var $a1098d11c3506fdb$var$RangeOperations = Object.freeze({
    APPEND: 'append',
    PREPEND: 'prepend'
});
function $a1098d11c3506fdb$var$convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case 'NODE_DELETE':
                var nodeDeleteResult = $a1098d11c3506fdb$var$nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case 'RANGE_ADD':
                var rangeAddResult = $a1098d11c3506fdb$var$rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case 'RANGE_DELETE':
                var rangeDeleteResult = $a1098d11c3506fdb$var$rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function $a1098d11c3506fdb$var$nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = $a1098d11c3506fdb$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === 'string') store["delete"](id);
        });
    };
}
function $a1098d11c3506fdb$var$rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = $a1098d11c3506fdb$var$getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, $a1098d11c3506fdb$var$_createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = $1QcxJ.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = $1QcxJ.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case 'append':
                        $1QcxJ.insertEdgeAfter(connection, clientEdge);
                        break;
                    case 'prepend':
                        $1QcxJ.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function $a1098d11c3506fdb$var$rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = $a1098d11c3506fdb$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, $a1098d11c3506fdb$var$_createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && typeof deletedIDField === 'object') deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && typeof idObject === 'object' && typeof idObject.id === 'string') deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === 'string') deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === 'string' && typeof deletedIDField === 'object') {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === 'string') deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === 'string') deleteIDs.push(id);
            });
        }
        $a1098d11c3506fdb$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function $a1098d11c3506fdb$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, $a1098d11c3506fdb$var$_createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = $1QcxJ.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                $1QcxJ.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $a1098d11c3506fdb$var$getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === 'LinkedField') return request.fragment.selections[0].name;
    return null;
}
module.exports = {
    MutationTypes: $a1098d11c3506fdb$var$MutationTypes,
    RangeOperations: $a1098d11c3506fdb$var$RangeOperations,
    convert: $a1098d11c3506fdb$var$convert
};

});


parcelRegister("2tOos", function(module, exports) {
'use strict';
function $1ce56146d341e46f$var$commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
module.exports = $1ce56146d341e46f$var$commitLocalUpdate;

});

parcelRegister("bF36F", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $87d5eeee3aa991cc$var$_interopRequireDefault = $9Ew61.default;

var $87d5eeee3aa991cc$var$_toConsumableArray2 = $87d5eeee3aa991cc$var$_interopRequireDefault((parcelRequire("4Ika6")));

var $iEOHk = parcelRequire("iEOHk");
var $87d5eeee3aa991cc$var$getRequest = $iEOHk.getRequest;

var $e8h4i = parcelRequire("e8h4i");
var $87d5eeee3aa991cc$var$generateUniqueClientID = $e8h4i.generateUniqueClientID;

var $geBjh = parcelRequire("geBjh");

var $3pXrs = parcelRequire("3pXrs");
var $87d5eeee3aa991cc$var$createOperationDescriptor = $3pXrs.createOperationDescriptor;

var $dPcgp = parcelRequire("dPcgp");
parcelRequire("fxUUh");

var $1etGW = parcelRequire("1etGW");
parcelRequire("4j8bN");
function $87d5eeee3aa991cc$var$commitMutation(environment, config) {
    !$geBjh(environment) && $1etGW(false);
    var mutation = $87d5eeee3aa991cc$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    if (mutation.kind !== 'Request') throw new Error('commitMutation: Expected mutation to be of type request');
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = $87d5eeee3aa991cc$var$createOperationDescriptor(mutation, variables, cacheConfig, $87d5eeee3aa991cc$var$generateUniqueClientID());
    if (typeof optimisticResponse === 'function') optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = $dPcgp.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, $87d5eeee3aa991cc$var$_toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, $87d5eeee3aa991cc$var$_toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
module.exports = $87d5eeee3aa991cc$var$commitMutation;

});
parcelRegister("fxUUh", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $b51614904ac26181$var$_interopRequireDefault = $9Ew61.default;

var $b51614904ac26181$var$_objectSpread2 = $b51614904ac26181$var$_interopRequireDefault((parcelRequire("7lyjq")));
parcelRequire("4j8bN");
var $b51614904ac26181$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $b51614904ac26181$var$validateMutation = function validateMutation() {};
var $b51614904ac26181$var$addFieldToDiff, $b51614904ac26181$var$validateSelections, $b51614904ac26181$var$validateSelection, $b51614904ac26181$var$validateModuleImport, $b51614904ac26181$var$validateAbstractKey, $b51614904ac26181$var$validateField, $b51614904ac26181$var$validateOptimisticResponse;
module.exports = $b51614904ac26181$var$validateMutation;

});


parcelRegister("8EWAO", function(module, exports) {
'use strict';

var $glUrg = parcelRequire("glUrg");

var $7DvLu = parcelRequire("7DvLu");
var $64df8276f74cb269$var$convertFetch = $7DvLu.convertFetch;

var $1etGW = parcelRequire("1etGW");
function $64df8276f74cb269$var$create(fetchFn, subscribe) {
    var observeFetch = $64df8276f74cb269$var$convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = $glUrg(variables, request.providedVariables);
        if (request.operationKind === 'subscription') {
            !subscribe && $1etGW(false);
            !!uploadables && $1etGW(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && $1etGW(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
module.exports = {
    create: $64df8276f74cb269$var$create
};

});
parcelRegister("glUrg", function(module, exports) {
'use strict';
parcelRequire("4MrjW");
parcelRequire("4j8bN");
var $be7a63172347d272$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $be7a63172347d272$var$debugCache = $be7a63172347d272$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $be7a63172347d272$var$withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            if (!$be7a63172347d272$var$debugCache.has(providerFunction)) {
                $be7a63172347d272$var$debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = $be7a63172347d272$var$debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
$be7a63172347d272$var$withProvidedVariables.tests_only_resetDebugCache = undefined;
module.exports = $be7a63172347d272$var$withProvidedVariables;

});

parcelRegister("7DvLu", function(module, exports) {
'use strict';

var $h6dVp = parcelRequire("h6dVp");
function $58f4d0c25b19d6d3$var$convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        if (result instanceof Error) return $h6dVp.create(function(sink) {
            return sink.error(result);
        });
        return $h6dVp.from(result);
    };
}
module.exports = {
    convertFetch: $58f4d0c25b19d6d3$var$convertFetch
};

});


parcelRegister("gKwfV", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $c319f68cb15b7c1c$var$_interopRequireDefault = $9Ew61.default;

var $c319f68cb15b7c1c$var$_objectSpread2 = $c319f68cb15b7c1c$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $fAAFv = parcelRequire("fAAFv");
var $c319f68cb15b7c1c$var$stableCopy = $fAAFv.stableCopy;

var $1etGW = parcelRequire("1etGW");
var $c319f68cb15b7c1c$var$RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && $1etGW(false);
        !(ttl > 0) && $1etGW(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = $c319f68cb15b7c1c$var$getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!$c319f68cb15b7c1c$var$isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, $c319f68cb15b7c1c$var$_objectSpread2["default"])((0, $c319f68cb15b7c1c$var$_objectSpread2["default"])({}, payload), {}, {
                extensions: (0, $c319f68cb15b7c1c$var$_objectSpread2["default"])((0, $c319f68cb15b7c1c$var$_objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, $c319f68cb15b7c1c$var$_objectSpread2["default"])((0, $c319f68cb15b7c1c$var$_objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, $c319f68cb15b7c1c$var$_objectSpread2["default"])((0, $c319f68cb15b7c1c$var$_objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = $c319f68cb15b7c1c$var$getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey);
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function $c319f68cb15b7c1c$var$getCacheKey(queryID, variables) {
    return JSON.stringify($c319f68cb15b7c1c$var$stableCopy({
        queryID: queryID,
        variables: variables
    }));
}
function $c319f68cb15b7c1c$var$isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
module.exports = $c319f68cb15b7c1c$var$RelayQueryResponseCache;

});

parcelRegister("eB3Lq", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $aa0770d208c3d343$var$_interopRequireDefault = $9Ew61.default;

var $aa0770d208c3d343$var$_objectSpread2 = $aa0770d208c3d343$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $h6dVp = parcelRequire("h6dVp");

var $3pXrs = parcelRequire("3pXrs");
var $aa0770d208c3d343$var$createOperationDescriptor = $3pXrs.createOperationDescriptor;

var $32s8z = parcelRequire("32s8z");
var $aa0770d208c3d343$var$handlePotentialSnapshotErrors = $32s8z.handlePotentialSnapshotErrors;

var $5HXMu = parcelRequire("5HXMu");

var $iEOHk = parcelRequire("iEOHk");
var $aa0770d208c3d343$var$getRequest = $iEOHk.getRequest;

var $1etGW = parcelRequire("1etGW");
function $aa0770d208c3d343$var$fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = $aa0770d208c3d343$var$getRequest(query);
    !(queryNode.params.operationKind === 'query') && $1etGW(false);
    var networkCacheConfig = (0, $aa0770d208c3d343$var$_objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = $aa0770d208c3d343$var$createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'network-only';
    function readData(snapshot) {
        $aa0770d208c3d343$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
        return snapshot.data;
    }
    switch(fetchPolicy){
        case 'network-only':
            return $aa0770d208c3d343$var$getNetworkObservable(environment, operation).map(readData);
        case 'store-or-network':
            if (environment.check(operation).status === 'available') return $h6dVp.from(environment.lookup(operation.fragment)).map(readData);
            return $aa0770d208c3d343$var$getNetworkObservable(environment, operation).map(readData);
        default:
            fetchPolicy;
            throw new Error('fetchQuery: Invalid fetchPolicy ' + fetchPolicy);
    }
}
function $aa0770d208c3d343$var$getNetworkObservable(environment, operation) {
    return $5HXMu.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
module.exports = $aa0770d208c3d343$var$fetchQuery;

});

parcelRegister("fiaVl", function(module, exports) {
'use strict';

var $3pXrs = parcelRequire("3pXrs");
var $b22102bd069c88b9$var$createOperationDescriptor = $3pXrs.createOperationDescriptor;

var $iEOHk = parcelRequire("iEOHk");
var $b22102bd069c88b9$var$getRequest = $iEOHk.getRequest;
function $b22102bd069c88b9$var$fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = $b22102bd069c88b9$var$getRequest(taggedNode);
    if (query.params.operationKind !== 'query') throw new Error('fetchQuery: Expected query operation');
    var operation = $b22102bd069c88b9$var$createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
module.exports = $b22102bd069c88b9$var$fetchQuery_DEPRECATED;

});

parcelRegister("jtlLI", function(module, exports) {
'use strict';
var $e2d19c925255ecd6$var$PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var $e2d19c925255ecd6$var$preloadableQueryRegistry = new $e2d19c925255ecd6$var$PreloadableQueryRegistry();
module.exports = $e2d19c925255ecd6$var$preloadableQueryRegistry;

});

parcelRegister("6kBJo", function(module, exports) {
'use strict';

var $aQVKw = parcelRequire("aQVKw");
parcelRequire("4j8bN");
function $49c1e0f1f03bfa35$var$createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new $aQVKw(context, fragments, props, callback, rootIsQueryRenderer);
}
module.exports = $49c1e0f1f03bfa35$var$createFragmentSpecResolver;

});
parcelRegister("aQVKw", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $7e6b8e892c31f16f$var$_interopRequireDefault = $9Ew61.default;

var $7e6b8e892c31f16f$var$_objectSpread2 = $7e6b8e892c31f16f$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $7e6b8e892c31f16f$var$_defineProperty2 = $7e6b8e892c31f16f$var$_interopRequireDefault((parcelRequire("2bxFr")));

var $iG0Ae = parcelRequire("iG0Ae");

var $32s8z = parcelRequire("32s8z");
var $7e6b8e892c31f16f$var$handlePotentialSnapshotErrors = $32s8z.handlePotentialSnapshotErrors;

var $P3fo7 = parcelRequire("P3fo7");

var $7g2Xq = parcelRequire("7g2Xq");

var $1K5RO = parcelRequire("1K5RO");

var $3pXrs = parcelRequire("3pXrs");
var $7e6b8e892c31f16f$var$createRequestDescriptor = $3pXrs.createRequestDescriptor;

var $5AfVC = parcelRequire("5AfVC");
var $7e6b8e892c31f16f$var$areEqualSelectors = $5AfVC.areEqualSelectors, $7e6b8e892c31f16f$var$createReaderSelector = $5AfVC.createReaderSelector, $7e6b8e892c31f16f$var$getSelectorsFromObject = $5AfVC.getSelectorsFromObject;

var $4MrjW = parcelRequire("4MrjW");

var $1etGW = parcelRequire("1etGW");
parcelRequire("4j8bN");
var $7e6b8e892c31f16f$var$RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, $7e6b8e892c31f16f$var$_defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === 'function') _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) $7e6b8e892c31f16f$var$disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, $7e6b8e892c31f16f$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !$P3fo7(_nextItem, prevItem)) {
                        nextData = nextData || (0, $7e6b8e892c31f16f$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if ($1K5RO.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = $7e6b8e892c31f16f$var$getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === 'PluralReaderSelector') {
                if (resolver == null) resolver = new $7e6b8e892c31f16f$var$SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(resolver instanceof $7e6b8e892c31f16f$var$SelectorListResolver) && $1etGW(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new $7e6b8e892c31f16f$var$SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(resolver instanceof $7e6b8e892c31f16f$var$SelectorResolver) && $1etGW(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
var $7e6b8e892c31f16f$var$SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, $7e6b8e892c31f16f$var$_defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._fieldErrors = snapshot.fieldErrors;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._fieldErrors = _snapshot.fieldErrors;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if ($1K5RO.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        if (this._isMissingData === true) {
            var pendingOperationsResult = $iG0Ae(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: 'suspense.fragment',
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        $7e6b8e892c31f16f$var$handlePotentialSnapshotErrors(this._environment, this._fieldErrors);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && $7e6b8e892c31f16f$var$areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = $7g2Xq(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._fieldErrors = snapshot.fieldErrors;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if ($4MrjW(variables, this._selector.variables)) return;
        var requestDescriptor = $7e6b8e892c31f16f$var$createRequestDescriptor(request, variables);
        var selector = $7e6b8e892c31f16f$var$createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
var $7e6b8e892c31f16f$var$SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, $7e6b8e892c31f16f$var$_defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach($7e6b8e892c31f16f$var$disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new $7e6b8e892c31f16f$var$SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function $7e6b8e892c31f16f$var$disposeCallback(disposable) {
    disposable && disposable.dispose();
}
module.exports = $7e6b8e892c31f16f$var$RelayModernFragmentSpecResolver;

});
parcelRegister("iG0Ae", function(module, exports) {
'use strict';

var $5HXMu = parcelRequire("5HXMu");
var $d98c9a10b90e05af$var$getPromiseForActiveRequest = $5HXMu.getPromiseForActiveRequest;
function $d98c9a10b90e05af$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = $d98c9a10b90e05af$var$getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var operationTracker = environment.getOperationTracker();
        var result = operationTracker.getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(',')) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = 'Unknown pending operation';
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    promise.displayName = promiseDisplayName;
    environment.__log({
        name: 'pendingoperation.found',
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
module.exports = $d98c9a10b90e05af$var$getPendingOperationsForFragment;

});

parcelRegister("P3fo7", function(module, exports) {
'use strict';
function $0997485c28f69e0e$var$isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || typeof valueA !== 'object');
}
module.exports = $0997485c28f69e0e$var$isScalarAndEqual;

});

parcelRegister("7g2Xq", function(module, exports) {
'use strict';
function $548c52541412aa37$var$recycleNodesInto(prevData, nextData) {
    return $548c52541412aa37$var$recycleNodesIntoImpl(prevData, nextData, true);
}
function $548c52541412aa37$var$recycleNodesIntoImpl(prevData, nextData, canMutate) {
    if (prevData === nextData || typeof prevData !== 'object' || !prevData || prevData.constructor !== Object && !Array.isArray(prevData) || typeof nextData !== 'object' || !nextData || nextData.constructor !== Object && !Array.isArray(nextData)) return nextData;
    var canRecycle = false;
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) {
        var canMutateNext = canMutate && !Object.isFrozen(nextArray);
        canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
            var prevValue = prevArray[ii];
            var nextValue = $548c52541412aa37$var$recycleNodesIntoImpl(prevValue, nextItem, canMutateNext);
            if (nextValue !== nextArray[ii] && canMutateNext) nextArray[ii] = nextValue;
            return wasEqual && nextValue === prevArray[ii];
        }, true) && prevArray.length === nextArray.length;
    } else if (!prevArray && !nextArray) {
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        var _canMutateNext = canMutate && !Object.isFrozen(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = $548c52541412aa37$var$recycleNodesIntoImpl(prevValue, nextObject[key], _canMutateNext);
            if (nextValue !== nextObject[key] && _canMutateNext) nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = $548c52541412aa37$var$recycleNodesInto;

});



parcelRegister("jwKci", function(module, exports) {
'use strict';

var $1etGW = parcelRequire("1etGW");
var $e374d74e07ea9498$var$relayContext;
var $e374d74e07ea9498$var$firstReact;
function $e374d74e07ea9498$var$createRelayContext(react) {
    if (!$e374d74e07ea9498$var$relayContext) {
        $e374d74e07ea9498$var$relayContext = react.createContext(null);
        $e374d74e07ea9498$var$firstReact = react;
    }
    !(react === $e374d74e07ea9498$var$firstReact) && $1etGW(false);
    return $e374d74e07ea9498$var$relayContext;
}
module.exports = $e374d74e07ea9498$var$createRelayContext;

});

parcelRegister("EXH5b", function(module, exports) {
'use strict';

var $1etGW = parcelRequire("1etGW");
var $07b20a80af2ad91a$var$relayLoggingContext;
var $07b20a80af2ad91a$var$firstReact;
function $07b20a80af2ad91a$var$createRelayLoggingContext(react) {
    if (!$07b20a80af2ad91a$var$relayLoggingContext) {
        $07b20a80af2ad91a$var$relayLoggingContext = react.createContext(null);
        $07b20a80af2ad91a$var$firstReact = react;
    }
    !(react === $07b20a80af2ad91a$var$firstReact) && $1etGW(false);
    return $07b20a80af2ad91a$var$relayLoggingContext;
}
module.exports = $07b20a80af2ad91a$var$createRelayLoggingContext;

});

parcelRegister("mzzfX", function(module, exports) {
'use strict';
var $043da52efa9716e6$var$LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function $043da52efa9716e6$var$suspenseSentinel() {
    return $043da52efa9716e6$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function $043da52efa9716e6$var$isSuspenseSentinel(value) {
    return value === $043da52efa9716e6$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: $043da52efa9716e6$var$isSuspenseSentinel,
    suspenseSentinel: $043da52efa9716e6$var$suspenseSentinel
};

});

parcelRegister("alzKh", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $788797dd5dbb3077$var$_interopRequireDefault = $9Ew61.default;

var $788797dd5dbb3077$var$_objectSpread2 = $788797dd5dbb3077$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $788797dd5dbb3077$var$_RelayModernRecord = $788797dd5dbb3077$var$_interopRequireDefault((parcelRequire("2yWF2")));

var $788797dd5dbb3077$var$_RelayRecordSource = $788797dd5dbb3077$var$_interopRequireDefault((parcelRequire("kyCh1")));

var $788797dd5dbb3077$var$_RelayResponseNormalizer = $788797dd5dbb3077$var$_interopRequireDefault((parcelRequire("gUBAT")));
function $788797dd5dbb3077$var$normalizeResponse(response, selector, typeName, options, useExecTimeResolvers) {
    var _response$extensions;
    var data = response.data, errors = response.errors;
    var source = $788797dd5dbb3077$var$_RelayRecordSource["default"].create();
    var record = $788797dd5dbb3077$var$_RelayModernRecord["default"].create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = $788797dd5dbb3077$var$_RelayResponseNormalizer["default"].normalize(source, selector, data, options, errors, useExecTimeResolvers);
    return (0, $788797dd5dbb3077$var$_objectSpread2["default"])((0, $788797dd5dbb3077$var$_objectSpread2["default"])({}, relayPayload), {}, {
        isFinal: ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.is_final) === true
    });
}
module.exports = $788797dd5dbb3077$var$normalizeResponse;

});
parcelRegister("2yWF2", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $1ddc428f93313b54$var$_interopRequireDefault = $9Ew61.default;

var $1ddc428f93313b54$var$_defineProperty2 = $1ddc428f93313b54$var$_interopRequireDefault((parcelRequire("2bxFr")));

var $1ddc428f93313b54$var$_objectWithoutPropertiesLoose2 = $1ddc428f93313b54$var$_interopRequireDefault((parcelRequire("1lgQy")));

var $1ddc428f93313b54$var$_toPropertyKey2 = $1ddc428f93313b54$var$_interopRequireDefault((parcelRequire("cic30")));

var $1ddc428f93313b54$var$_objectSpread2 = $1ddc428f93313b54$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $u9izA = parcelRequire("u9izA");

var $e8h4i = parcelRequire("e8h4i");
var $1ddc428f93313b54$var$generateClientObjectClientID = $e8h4i.generateClientObjectClientID, $1ddc428f93313b54$var$isClientID = $e8h4i.isClientID;

var $mzzfX = parcelRequire("mzzfX");
var $1ddc428f93313b54$var$isSuspenseSentinel = $mzzfX.isSuspenseSentinel;

var $3axLc = parcelRequire("3axLc");
var $1ddc428f93313b54$var$ACTOR_IDENTIFIER_KEY = $3axLc.ACTOR_IDENTIFIER_KEY, $1ddc428f93313b54$var$ERRORS_KEY = $3axLc.ERRORS_KEY, $1ddc428f93313b54$var$ID_KEY = $3axLc.ID_KEY, $1ddc428f93313b54$var$INVALIDATED_AT_KEY = $3axLc.INVALIDATED_AT_KEY, $1ddc428f93313b54$var$REF_KEY = $3axLc.REF_KEY, $1ddc428f93313b54$var$REFS_KEY = $3axLc.REFS_KEY, $1ddc428f93313b54$var$RELAY_RESOLVER_VALUE_KEY = $3axLc.RELAY_RESOLVER_VALUE_KEY, $1ddc428f93313b54$var$ROOT_ID = $3axLc.ROOT_ID, $1ddc428f93313b54$var$TYPENAME_KEY = $3axLc.TYPENAME_KEY;

var $4MrjW = parcelRequire("4MrjW");

var $1etGW = parcelRequire("1etGW");
parcelRequire("4j8bN");
function $1ddc428f93313b54$var$clone(record) {
    return (0, $1ddc428f93313b54$var$_objectSpread2["default"])({}, record);
}
function $1ddc428f93313b54$var$copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== $1ddc428f93313b54$var$ID_KEY && key !== $1ddc428f93313b54$var$TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
function $1ddc428f93313b54$var$create(dataID, typeName) {
    var record = {};
    record[$1ddc428f93313b54$var$ID_KEY] = dataID;
    record[$1ddc428f93313b54$var$TYPENAME_KEY] = typeName;
    return record;
}
function $1ddc428f93313b54$var$fromObject(json) {
    return json;
}
function $1ddc428f93313b54$var$getDataID(record) {
    return record[$1ddc428f93313b54$var$ID_KEY];
}
function $1ddc428f93313b54$var$getFields(record) {
    if ($1ddc428f93313b54$var$ERRORS_KEY in record) return Object.keys(record).filter(function(field) {
        return field !== $1ddc428f93313b54$var$ERRORS_KEY;
    });
    return Object.keys(record);
}
function $1ddc428f93313b54$var$getType(record) {
    return record[$1ddc428f93313b54$var$TYPENAME_KEY];
}
function $1ddc428f93313b54$var$getErrors(record, storageKey) {
    var _record$ERRORS_KEY;
    return (_record$ERRORS_KEY = record[$1ddc428f93313b54$var$ERRORS_KEY]) === null || _record$ERRORS_KEY === void 0 ? void 0 : _record$ERRORS_KEY[storageKey];
}
function $1ddc428f93313b54$var$getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && typeof value === 'object') !(!value.hasOwnProperty($1ddc428f93313b54$var$REF_KEY) && !value.hasOwnProperty($1ddc428f93313b54$var$REFS_KEY)) && $1etGW(false);
    return value;
}
function $1ddc428f93313b54$var$hasValue(record, storageKey) {
    return storageKey in record;
}
function $1ddc428f93313b54$var$getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    var link = maybeLink;
    !(typeof link === 'object' && link && typeof link[$1ddc428f93313b54$var$REF_KEY] === 'string') && $1etGW(false);
    return link[$1ddc428f93313b54$var$REF_KEY];
}
function $1ddc428f93313b54$var$hasLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return false;
    var link = maybeLink;
    return typeof link === 'object' && link && typeof link[$1ddc428f93313b54$var$REF_KEY] === 'string';
}
function $1ddc428f93313b54$var$getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !(typeof links === 'object' && Array.isArray(links[$1ddc428f93313b54$var$REFS_KEY])) && $1etGW(false);
    return links[$1ddc428f93313b54$var$REFS_KEY];
}
function $1ddc428f93313b54$var$hasLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return false;
    return typeof links === 'object' && Array.isArray(links[$1ddc428f93313b54$var$REFS_KEY]) && links[$1ddc428f93313b54$var$REFS_KEY].every(function(link) {
        return typeof link === 'string';
    });
}
function $1ddc428f93313b54$var$getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[$1ddc428f93313b54$var$INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== 'number') return null;
    return invalidatedAt;
}
function $1ddc428f93313b54$var$update(prevRecord, nextRecord) {
    var _updated2;
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var prevErrorsByKey = prevRecord[$1ddc428f93313b54$var$ERRORS_KEY];
    var nextErrorsByKey = nextRecord[$1ddc428f93313b54$var$ERRORS_KEY];
    var updated = null;
    if (prevErrorsByKey == null && nextErrorsByKey == null) {
        var _updated;
        for(var storageKey in nextRecord)if (updated || !$4MrjW(prevRecord[storageKey], nextRecord[storageKey])) {
            updated = updated !== null ? updated : (0, $1ddc428f93313b54$var$_objectSpread2["default"])({}, prevRecord);
            updated[storageKey] = nextRecord[storageKey];
        }
        return (_updated = updated) !== null && _updated !== void 0 ? _updated : prevRecord;
    }
    for(var _storageKey2 in nextRecord){
        if (_storageKey2 === $1ddc428f93313b54$var$ERRORS_KEY) continue;
        var nextValue = nextRecord[_storageKey2];
        var nextErrors = nextErrorsByKey === null || nextErrorsByKey === void 0 ? void 0 : nextErrorsByKey[_storageKey2];
        if (updated == null) {
            var prevValue = prevRecord[_storageKey2];
            var prevErrors = prevErrorsByKey === null || prevErrorsByKey === void 0 ? void 0 : prevErrorsByKey[_storageKey2];
            if ($4MrjW(prevValue, nextValue) && $4MrjW(prevErrors, nextErrors)) continue;
            updated = (0, $1ddc428f93313b54$var$_objectSpread2["default"])({}, prevRecord);
            if (prevErrorsByKey != null) updated[$1ddc428f93313b54$var$ERRORS_KEY] = (0, $1ddc428f93313b54$var$_objectSpread2["default"])({}, prevErrorsByKey);
        }
        $1ddc428f93313b54$var$setValue(updated, _storageKey2, nextValue);
        $1ddc428f93313b54$var$setErrors(updated, _storageKey2, nextErrors);
    }
    return (_updated2 = updated) !== null && _updated2 !== void 0 ? _updated2 : prevRecord;
}
function $1ddc428f93313b54$var$merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    if ($1ddc428f93313b54$var$ERRORS_KEY in record1 || $1ddc428f93313b54$var$ERRORS_KEY in record2) {
        var errors1 = record1[$1ddc428f93313b54$var$ERRORS_KEY], fields1 = (0, $1ddc428f93313b54$var$_objectWithoutPropertiesLoose2["default"])(record1, [
            $1ddc428f93313b54$var$ERRORS_KEY
        ].map($1ddc428f93313b54$var$_toPropertyKey2["default"]));
        var errors2 = record2[$1ddc428f93313b54$var$ERRORS_KEY], fields2 = (0, $1ddc428f93313b54$var$_objectWithoutPropertiesLoose2["default"])(record2, [
            $1ddc428f93313b54$var$ERRORS_KEY
        ].map($1ddc428f93313b54$var$_toPropertyKey2["default"]));
        var updated = (0, $1ddc428f93313b54$var$_objectSpread2["default"])((0, $1ddc428f93313b54$var$_objectSpread2["default"])({}, fields1), fields2);
        if (errors1 == null && errors2 == null) return updated;
        var updatedErrors = {};
        for(var storageKey in errors1){
            if (fields2.hasOwnProperty(storageKey)) continue;
            updatedErrors[storageKey] = errors1[storageKey];
        }
        for(var _storageKey3 in errors2)updatedErrors[_storageKey3] = errors2[_storageKey3];
        for(var _storageKey in updatedErrors){
            updated[$1ddc428f93313b54$var$ERRORS_KEY] = updatedErrors;
            break;
        }
        return updated;
    } else return (0, $1ddc428f93313b54$var$_objectSpread2["default"])((0, $1ddc428f93313b54$var$_objectSpread2["default"])({}, record1), record2);
}
function $1ddc428f93313b54$var$freeze(record) {
    $u9izA(record);
}
function $1ddc428f93313b54$var$setErrors(record, storageKey, errors) {
    var errorsByStorageKey = record[$1ddc428f93313b54$var$ERRORS_KEY];
    if (errors != null && errors.length > 0) {
        if (errorsByStorageKey == null) record[$1ddc428f93313b54$var$ERRORS_KEY] = (0, $1ddc428f93313b54$var$_defineProperty2["default"])({}, storageKey, errors);
        else errorsByStorageKey[storageKey] = errors;
    } else if (errorsByStorageKey != null) {
        if (delete errorsByStorageKey[storageKey]) {
            for(var otherStorageKey in errorsByStorageKey){
                if (errorsByStorageKey.hasOwnProperty(otherStorageKey)) return;
            }
            delete record[$1ddc428f93313b54$var$ERRORS_KEY];
        }
    }
}
function $1ddc428f93313b54$var$setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
function $1ddc428f93313b54$var$setLinkedRecordID(record, storageKey, linkedID) {
    var link = {};
    link[$1ddc428f93313b54$var$REF_KEY] = linkedID;
    record[storageKey] = link;
}
function $1ddc428f93313b54$var$setLinkedRecordIDs(record, storageKey, linkedIDs) {
    var links = {};
    links[$1ddc428f93313b54$var$REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
function $1ddc428f93313b54$var$setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    var link = {};
    link[$1ddc428f93313b54$var$REF_KEY] = linkedID;
    link[$1ddc428f93313b54$var$ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
function $1ddc428f93313b54$var$getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !(typeof link === 'object' && typeof link[$1ddc428f93313b54$var$REF_KEY] === 'string' && link[$1ddc428f93313b54$var$ACTOR_IDENTIFIER_KEY] != null) && $1etGW(false);
    return [
        link[$1ddc428f93313b54$var$ACTOR_IDENTIFIER_KEY],
        link[$1ddc428f93313b54$var$REF_KEY]
    ];
}
function $1ddc428f93313b54$var$getResolverLinkedRecordID(record, typeName) {
    var id = $1ddc428f93313b54$var$getValue(record, $1ddc428f93313b54$var$RELAY_RESOLVER_VALUE_KEY);
    if (id == null || $1ddc428f93313b54$var$isSuspenseSentinel(id)) return null;
    if (typeof id === 'object') id = id.id;
    !(typeof id === 'string') && $1etGW(false);
    return $1ddc428f93313b54$var$generateClientObjectClientID(typeName, id);
}
function $1ddc428f93313b54$var$getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = $1ddc428f93313b54$var$getValue(record, $1ddc428f93313b54$var$RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || $1ddc428f93313b54$var$isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && $1etGW(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        if (typeof id === 'object') id = id.id;
        !(typeof id === 'string') && $1etGW(false);
        return $1ddc428f93313b54$var$generateClientObjectClientID(typeName, id);
    });
}
function $1ddc428f93313b54$var$toJSON(record) {
    return record;
}
module.exports = {
    clone: $1ddc428f93313b54$var$clone,
    copyFields: $1ddc428f93313b54$var$copyFields,
    create: $1ddc428f93313b54$var$create,
    freeze: $1ddc428f93313b54$var$freeze,
    fromObject: $1ddc428f93313b54$var$fromObject,
    getDataID: $1ddc428f93313b54$var$getDataID,
    getErrors: $1ddc428f93313b54$var$getErrors,
    getFields: $1ddc428f93313b54$var$getFields,
    getInvalidationEpoch: $1ddc428f93313b54$var$getInvalidationEpoch,
    getLinkedRecordID: $1ddc428f93313b54$var$getLinkedRecordID,
    getLinkedRecordIDs: $1ddc428f93313b54$var$getLinkedRecordIDs,
    getType: $1ddc428f93313b54$var$getType,
    getValue: $1ddc428f93313b54$var$getValue,
    hasValue: $1ddc428f93313b54$var$hasValue,
    hasLinkedRecordID: $1ddc428f93313b54$var$hasLinkedRecordID,
    hasLinkedRecordIDs: $1ddc428f93313b54$var$hasLinkedRecordIDs,
    merge: $1ddc428f93313b54$var$merge,
    setErrors: $1ddc428f93313b54$var$setErrors,
    setValue: $1ddc428f93313b54$var$setValue,
    setLinkedRecordID: $1ddc428f93313b54$var$setLinkedRecordID,
    setLinkedRecordIDs: $1ddc428f93313b54$var$setLinkedRecordIDs,
    update: $1ddc428f93313b54$var$update,
    getActorLinkedRecordID: $1ddc428f93313b54$var$getActorLinkedRecordID,
    setActorLinkedRecordID: $1ddc428f93313b54$var$setActorLinkedRecordID,
    getResolverLinkedRecordID: $1ddc428f93313b54$var$getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: $1ddc428f93313b54$var$getResolverLinkedRecordIDs,
    toJSON: $1ddc428f93313b54$var$toJSON
};

});
parcelRegister("1lgQy", function(module, exports) {
function $0fa4d2073a0c640f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $0fa4d2073a0c640f$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("kyCh1", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $ef74abfa6aa7a5a2$var$_interopRequireDefault = $9Ew61.default;

var $ef74abfa6aa7a5a2$var$_createForOfIteratorHelper2 = $ef74abfa6aa7a5a2$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $2yWF2 = parcelRequire("2yWF2");

var $24u1P = parcelRequire("24u1P");
var $ef74abfa6aa7a5a2$var$EXISTENT = $24u1P.EXISTENT, $ef74abfa6aa7a5a2$var$NONEXISTENT = $24u1P.NONEXISTENT, $ef74abfa6aa7a5a2$var$UNKNOWN = $24u1P.UNKNOWN;
var $ef74abfa6aa7a5a2$var$RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            var object = records[key];
            var record = $2yWF2.fromObject(object);
            _this._records.set(key, record);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return $ef74abfa6aa7a5a2$var$UNKNOWN;
        return this._records.get(dataID) == null ? $ef74abfa6aa7a5a2$var$NONEXISTENT : $ef74abfa6aa7a5a2$var$EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, $ef74abfa6aa7a5a2$var$_createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], record = _step$value[1];
                obj[key] = $2yWF2.toJSON(record);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = $ef74abfa6aa7a5a2$var$RelayRecordSource;

});
parcelRegister("24u1P", function(module, exports) {
'use strict';
var $18233f8b1a485c18$var$RelayRecordState = {
    EXISTENT: 'EXISTENT',
    NONEXISTENT: 'NONEXISTENT',
    UNKNOWN: 'UNKNOWN'
};
module.exports = $18233f8b1a485c18$var$RelayRecordState;

});


parcelRegister("gUBAT", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $c4ff09b1867b7b68$var$_interopRequireDefault = $9Ew61.default;

var $c4ff09b1867b7b68$var$_createForOfIteratorHelper2 = $c4ff09b1867b7b68$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $c4ff09b1867b7b68$var$_toConsumableArray2 = $c4ff09b1867b7b68$var$_interopRequireDefault((parcelRequire("4Ika6")));

var $8rx9f = parcelRequire("8rx9f");
var $c4ff09b1867b7b68$var$ACTOR_IDENTIFIER_FIELD_NAME = $8rx9f.ACTOR_IDENTIFIER_FIELD_NAME, $c4ff09b1867b7b68$var$getActorIdentifierFromPayload = $8rx9f.getActorIdentifierFromPayload;

var $1K5RO = parcelRequire("1K5RO");

var $e8h4i = parcelRequire("e8h4i");
var $c4ff09b1867b7b68$var$generateClientID = $e8h4i.generateClientID, $c4ff09b1867b7b68$var$isClientID = $e8h4i.isClientID;

var $8g71t = parcelRequire("8g71t");
var $c4ff09b1867b7b68$var$getLocalVariables = $8g71t.getLocalVariables;

var $1JrrV = parcelRequire("1JrrV");
var $c4ff09b1867b7b68$var$buildErrorTrie = $1JrrV.buildErrorTrie, $c4ff09b1867b7b68$var$getErrorsByKey = $1JrrV.getErrorsByKey, $c4ff09b1867b7b68$var$getNestedErrorTrieByKey = $1JrrV.getNestedErrorTrieByKey;

var $2yWF2 = parcelRequire("2yWF2");

var $5AfVC = parcelRequire("5AfVC");
var $c4ff09b1867b7b68$var$createNormalizationSelector = $5AfVC.createNormalizationSelector;

var $3axLc = parcelRequire("3axLc");
var $c4ff09b1867b7b68$var$ROOT_ID = $3axLc.ROOT_ID, $c4ff09b1867b7b68$var$TYPENAME_KEY = $3axLc.TYPENAME_KEY, $c4ff09b1867b7b68$var$getArgumentValues = $3axLc.getArgumentValues, $c4ff09b1867b7b68$var$getHandleStorageKey = $3axLc.getHandleStorageKey, $c4ff09b1867b7b68$var$getModuleComponentKey = $3axLc.getModuleComponentKey, $c4ff09b1867b7b68$var$getModuleOperationKey = $3axLc.getModuleOperationKey, $c4ff09b1867b7b68$var$getStorageKey = $3axLc.getStorageKey;

var $hRGwE = parcelRequire("hRGwE");
var $c4ff09b1867b7b68$var$TYPE_SCHEMA_TYPE = $hRGwE.TYPE_SCHEMA_TYPE, $c4ff09b1867b7b68$var$generateTypeID = $hRGwE.generateTypeID;
parcelRequire("4MrjW");

var $1etGW = parcelRequire("1etGW");
parcelRequire("4j8bN");
function $c4ff09b1867b7b68$var$normalize(recordSource, selector, response, options, errors, useExecTimeResolvers) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new $c4ff09b1867b7b68$var$RelayResponseNormalizer(recordSource, variables, options, useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false);
    return normalizer.normalizeResponse(node, dataID, response, errors);
}
var $c4ff09b1867b7b68$var$RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options, useExecTimeResolvers) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._useExecTimeResolvers = useExecTimeResolvers;
        this._followupPayloads = [];
        this._path = options.path ? (0, $c4ff09b1867b7b68$var$_toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
        this._log = options.log;
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data, errors) {
        var record = this._recordSource.get(dataID);
        !record && $1etGW(false);
        this._assignClientAbstractTypes(node);
        this._errorTrie = $c4ff09b1867b7b68$var$buildErrorTrie(errors);
        this._traverseSelections(node, record, data);
        return {
            errors: errors,
            fieldPayloads: this._handleFieldPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            followupPayloads: this._followupPayloads,
            source: this._recordSource,
            isFinal: false
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, $c4ff09b1867b7b68$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = $c4ff09b1867b7b68$var$generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = $2yWF2.create(typeID, $c4ff09b1867b7b68$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    $2yWF2.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $1etGW(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[$c4ff09b1867b7b68$var$TYPENAME_KEY];
        !(typeName != null) && $1etGW(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case 'ScalarField':
                case 'LinkedField':
                    this._normalizeField(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case 'FragmentSpread':
                    var prevVariables = this._variables;
                    this._variables = $c4ff09b1867b7b68$var$getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case 'InlineFragment':
                    var abstractKey = selection.abstractKey;
                    if (abstractKey == null) {
                        var typeName = $2yWF2.getType(record);
                        if (typeName === selection.type) this._traverseSelections(selection, record, data);
                    } else {
                        var implementsInterface = Object.prototype.hasOwnProperty.call(data, abstractKey);
                        var _typeName = $2yWF2.getType(record);
                        var typeID = $c4ff09b1867b7b68$var$generateTypeID(_typeName);
                        var typeRecord = this._recordSource.get(typeID);
                        if (typeRecord == null) {
                            typeRecord = $2yWF2.create(typeID, $c4ff09b1867b7b68$var$TYPE_SCHEMA_TYPE);
                            this._recordSource.set(typeID, typeRecord);
                        }
                        $2yWF2.setValue(typeRecord, abstractKey, implementsInterface);
                        if (implementsInterface) this._traverseSelections(selection, record, data);
                    }
                    break;
                case 'TypeDiscriminator':
                    var _abstractKey = selection.abstractKey;
                    var _implementsInterface = Object.prototype.hasOwnProperty.call(data, _abstractKey);
                    var _typeName2 = $2yWF2.getType(record);
                    var _typeID = $c4ff09b1867b7b68$var$generateTypeID(_typeName2);
                    var _typeRecord = this._recordSource.get(_typeID);
                    if (_typeRecord == null) {
                        _typeRecord = $2yWF2.create(_typeID, $c4ff09b1867b7b68$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(_typeID, _typeRecord);
                    }
                    $2yWF2.setValue(_typeRecord, _abstractKey, _implementsInterface);
                    break;
                case 'LinkedHandle':
                case 'ScalarHandle':
                    var args = selection.args ? $c4ff09b1867b7b68$var$getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = $c4ff09b1867b7b68$var$getStorageKey(selection, this._variables);
                    var handleKey = $c4ff09b1867b7b68$var$getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: $2yWF2.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleKey: handleKey,
                        handleArgs: selection.handleArgs ? $c4ff09b1867b7b68$var$getArgumentValues(selection.handleArgs, this._variables) : {}
                    });
                    break;
                case 'ModuleImport':
                    this._normalizeModuleImport(selection, record, data);
                    break;
                case 'Defer':
                    this._normalizeDefer(selection, record, data);
                    break;
                case 'Stream':
                    this._normalizeStream(selection, record, data);
                    break;
                case 'ClientExtension':
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case 'ClientComponent':
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case 'ActorChange':
                    this._normalizeActorChange(selection, record, data);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    if (!this._useExecTimeResolvers) this._normalizeResolver(selection, record, data);
                    break;
                case 'ClientEdgeToClientObject':
                    if (!this._useExecTimeResolvers) this._normalizeResolver(selection.backingField, record, data);
                    break;
                default:
                    selection;
                    $1etGW(false);
            }
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._traverseSelections(resolver.fragment, record, data);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) this._traverseSelections(defer, record, data);
        else this._incrementalPlaceholders.push({
            kind: 'defer',
            data: data,
            label: defer.label,
            path: (0, $c4ff09b1867b7b68$var$_toConsumableArray2["default"])(this._path),
            selector: $c4ff09b1867b7b68$var$createNormalizationSelector(defer, $2yWF2.getDataID(record), this._variables),
            typeName: $2yWF2.getType(record),
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) this._incrementalPlaceholders.push({
            kind: 'stream',
            label: stream.label,
            path: (0, $c4ff09b1867b7b68$var$_toConsumableArray2["default"])(this._path),
            parentID: $2yWF2.getDataID(record),
            node: stream,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(moduleImport, record, data) {
        !(typeof data === 'object' && data) && $1etGW(false);
        var typeName = $2yWF2.getType(record);
        var componentKey = $c4ff09b1867b7b68$var$getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        $2yWF2.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = $c4ff09b1867b7b68$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        $2yWF2.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            kind: 'ModuleImportPayload',
            args: moduleImport.args,
            data: data,
            dataID: $2yWF2.getDataID(record),
            operationReference: operationReference,
            path: (0, $c4ff09b1867b7b68$var$_toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeField = function _normalizeField(selection, record, data) {
        !(typeof data === 'object' && data) && $1etGW(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = $c4ff09b1867b7b68$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        var isNoncompliantlyNullish = $1K5RO.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(fieldValue) && fieldValue.length === 0;
        if (fieldValue == null || isNoncompliantlyNullish) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            if (selection.kind === 'ScalarField') this._validateConflictingFieldsWithIdenticalId(record, storageKey, null);
            if (isNoncompliantlyNullish) {
                if (selection.kind === 'LinkedField') $2yWF2.setLinkedRecordIDs(record, storageKey, []);
                else $2yWF2.setValue(record, storageKey, []);
            } else $2yWF2.setValue(record, storageKey, null);
            var errorTrie = this._errorTrie;
            if (errorTrie != null) {
                var errors = $c4ff09b1867b7b68$var$getErrorsByKey(errorTrie, responseKey);
                if (errors != null) $2yWF2.setErrors(record, storageKey, errors);
            }
            return;
        }
        if (selection.kind === 'ScalarField') {
            this._validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue);
            $2yWF2.setValue(record, storageKey, fieldValue);
        } else if (selection.kind === 'LinkedField') {
            this._path.push(responseKey);
            var oldErrorTrie = this._errorTrie;
            this._errorTrie = oldErrorTrie == null ? null : $c4ff09b1867b7b68$var$getNestedErrorTrieByKey(oldErrorTrie, responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._errorTrie = oldErrorTrie;
            this._path.pop();
        } else {
            selection;
            $1etGW(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !(typeof data === 'object' && data) && $1etGW(false);
        var responseKey = field.alias || field.name;
        var storageKey = $c4ff09b1867b7b68$var$getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $2yWF2.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = $c4ff09b1867b7b68$var$getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            $2yWF2.setValue(record, storageKey, null);
            return;
        }
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(fieldValue, typeName) || $2yWF2.getLinkedRecordID(record, storageKey) || $c4ff09b1867b7b68$var$generateClientID($2yWF2.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $1etGW(false);
        $2yWF2.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            kind: 'ActorPayload',
            data: fieldValue,
            dataID: nextID,
            path: [].concat((0, $c4ff09b1867b7b68$var$_toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables,
            node: field,
            actorIdentifier: actorIdentifier
        });
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !(typeof fieldValue === 'object' && fieldValue) && $1etGW(false);
        var nextID = this._getDataId(fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || $2yWF2.getLinkedRecordID(record, storageKey) || $c4ff09b1867b7b68$var$generateClientID($2yWF2.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $1etGW(false);
        this._validateConflictingLinkedFieldsWithIdenticalId($2yWF2.getLinkedRecordID(record, storageKey), nextID, storageKey);
        $2yWF2.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = $2yWF2.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        } else this._validateRecordType(nextRecord, field, fieldValue);
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && $1etGW(false);
        var prevIDs = $2yWF2.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            var oldErrorTrie = _this._errorTrie;
            _this._errorTrie = oldErrorTrie == null ? null : $c4ff09b1867b7b68$var$getNestedErrorTrieByKey(oldErrorTrie, nextIndex);
            !(typeof item === 'object') && $1etGW(false);
            var nextID = _this._getDataId(item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || $c4ff09b1867b7b68$var$generateClientID($2yWF2.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === 'string') && $1etGW(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = $2yWF2.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            } else _this._validateRecordType(nextRecord, field, item);
            if (prevIDs) _this._validateConflictingLinkedFieldsWithIdenticalId(prevIDs[nextIndex], nextID, storageKey);
            _this._traverseSelections(field, nextRecord, item);
            _this._errorTrie = oldErrorTrie;
            _this._path.pop();
        });
        $2yWF2.setLinkedRecordIDs(record, storageKey, nextIDs);
    };
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        if ($1K5RO.ENABLE_STORE_ID_COLLISION_LOGGING) {
            var _field$concreteType4;
            var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
            var dataID = $2yWF2.getDataID(record);
            var expected = $c4ff09b1867b7b68$var$isClientID(dataID) && dataID !== $c4ff09b1867b7b68$var$ROOT_ID || $2yWF2.getType(record) === typeName;
            if (!expected) {
                var logEvent = {
                    name: 'idCollision.typename',
                    previous_typename: $2yWF2.getType(record),
                    new_typename: typeName
                };
                if (this._log != null) this._log(logEvent);
            }
        }
        var _field$concreteType5, _typeName3, _dataID, _expected;
    };
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var previousValue, dataID, expected;
    };
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(prevID, nextID, storageKey) {
        var expected;
    };
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: $c4ff09b1867b7b68$var$normalize
};

});
parcelRegister("8rx9f", function(module, exports) {
'use strict';
var $625a8ee648de2b9f$var$ACTOR_IDENTIFIER_FIELD_NAME = 'actor_key';

var $6WFXo = parcelRequire("6WFXo");
var $625a8ee648de2b9f$var$getActorIdentifier = $6WFXo.getActorIdentifier;
function $625a8ee648de2b9f$var$getActorIdentifierFromPayload(payload) {
    if (payload != null && typeof payload === 'object' && typeof payload[$625a8ee648de2b9f$var$ACTOR_IDENTIFIER_FIELD_NAME] === 'string') return $625a8ee648de2b9f$var$getActorIdentifier(payload[$625a8ee648de2b9f$var$ACTOR_IDENTIFIER_FIELD_NAME]);
}
module.exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: $625a8ee648de2b9f$var$ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: $625a8ee648de2b9f$var$getActorIdentifierFromPayload
};

});
parcelRegister("6WFXo", function(module, exports) {
'use strict';

var $1etGW = parcelRequire("1etGW");
var $50e8b4a7ab044294$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = 'INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE';
function $50e8b4a7ab044294$var$assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === $50e8b4a7ab044294$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && $1etGW(false);
}
module.exports = {
    assertInternalActorIdentifier: $50e8b4a7ab044294$var$assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error('Not Implemented');
    },
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: $50e8b4a7ab044294$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE
};

});


parcelRegister("1JrrV", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $142f494ffd47b91b$var$_interopRequireDefault = $9Ew61.default;

var $142f494ffd47b91b$var$_objectSpread2 = $142f494ffd47b91b$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $142f494ffd47b91b$var$_objectWithoutPropertiesLoose2 = $142f494ffd47b91b$var$_interopRequireDefault((parcelRequire("1lgQy")));

var $142f494ffd47b91b$var$_createForOfIteratorHelper2 = $142f494ffd47b91b$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $142f494ffd47b91b$var$_toConsumableArray2 = $142f494ffd47b91b$var$_interopRequireDefault((parcelRequire("4Ika6")));
var $142f494ffd47b91b$var$_excluded = [
    "path",
    "locations"
];
var $142f494ffd47b91b$var$SELF = Symbol('$SELF');
function $142f494ffd47b91b$var$buildErrorTrie(errors) {
    if (errors == null) return null;
    var trie = new Map();
    var _iterator = (0, $142f494ffd47b91b$var$_createForOfIteratorHelper2["default"])(errors), _step;
    try {
        ERRORS: for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, path = _step$value.path, _ = _step$value.locations, error = (0, $142f494ffd47b91b$var$_objectWithoutPropertiesLoose2["default"])(_step$value, $142f494ffd47b91b$var$_excluded);
            if (path == null) continue;
            var length = path.length;
            if (length === 0) continue;
            var lastIndex = length - 1;
            var currentTrie = trie;
            for(var index = 0; index < lastIndex; index++){
                var key = path[index];
                var existingValue = currentTrie.get(key);
                if (existingValue instanceof Map) {
                    currentTrie = existingValue;
                    continue;
                }
                var newValue = new Map();
                if (Array.isArray(existingValue)) newValue.set($142f494ffd47b91b$var$SELF, existingValue);
                currentTrie.set(key, newValue);
                currentTrie = newValue;
            }
            var lastKey = path[lastIndex];
            var container = currentTrie.get(lastKey);
            if (container instanceof Map) {
                currentTrie = container;
                container = currentTrie.get(lastKey);
                lastKey = $142f494ffd47b91b$var$SELF;
            }
            if (Array.isArray(container)) container.push(error);
            else currentTrie.set(lastKey, [
                error
            ]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return trie;
}
function $142f494ffd47b91b$var$getErrorsByKey(trie, key) {
    var value = trie.get(key);
    if (value == null) return null;
    if (Array.isArray(value)) return value;
    var errors = [];
    $142f494ffd47b91b$var$recursivelyCopyErrorsIntoArray(value, errors);
    return errors;
}
function $142f494ffd47b91b$var$recursivelyCopyErrorsIntoArray(trieOrSet, errors) {
    var _iterator2 = (0, $142f494ffd47b91b$var$_createForOfIteratorHelper2["default"])(trieOrSet), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = _step2.value, childKey = _step2$value[0], value = _step2$value[1];
            var oldLength = errors.length;
            if (Array.isArray(value)) errors.push.apply(errors, (0, $142f494ffd47b91b$var$_toConsumableArray2["default"])(value));
            else $142f494ffd47b91b$var$recursivelyCopyErrorsIntoArray(value, errors);
            if (childKey === $142f494ffd47b91b$var$SELF) continue;
            var newLength = errors.length;
            for(var index = oldLength; index < newLength; index++){
                var error = errors[index];
                if (error.path == null) errors[index] = (0, $142f494ffd47b91b$var$_objectSpread2["default"])((0, $142f494ffd47b91b$var$_objectSpread2["default"])({}, error), {}, {
                    path: [
                        childKey
                    ]
                });
                else error.path.unshift(childKey);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $142f494ffd47b91b$var$getNestedErrorTrieByKey(trie, key) {
    var value = trie.get(key);
    if (value instanceof Map) return value;
    return null;
}
module.exports = {
    SELF: $142f494ffd47b91b$var$SELF,
    buildErrorTrie: $142f494ffd47b91b$var$buildErrorTrie,
    getNestedErrorTrieByKey: $142f494ffd47b91b$var$getNestedErrorTrieByKey,
    getErrorsByKey: $142f494ffd47b91b$var$getErrorsByKey
};

});

parcelRegister("hRGwE", function(module, exports) {
'use strict';
var $d0185f9b4df9ebe6$var$PREFIX = 'client:__type:';
var $d0185f9b4df9ebe6$var$TYPE_SCHEMA_TYPE = '__TypeSchema';
function $d0185f9b4df9ebe6$var$generateTypeID(typeName) {
    return $d0185f9b4df9ebe6$var$PREFIX + typeName;
}
function $d0185f9b4df9ebe6$var$isTypeID(id) {
    return id.indexOf($d0185f9b4df9ebe6$var$PREFIX) === 0;
}
module.exports = {
    generateTypeID: $d0185f9b4df9ebe6$var$generateTypeID,
    isTypeID: $d0185f9b4df9ebe6$var$isTypeID,
    TYPE_SCHEMA_TYPE: $d0185f9b4df9ebe6$var$TYPE_SCHEMA_TYPE
};

});



parcelRegister("14hz1", function(module, exports) {
'use strict';

var $iEOHk = parcelRequire("iEOHk");
var $0c73c9f9608eb7d1$var$getInlineDataFragment = $iEOHk.getInlineDataFragment;

var $3axLc = parcelRequire("3axLc");
var $0c73c9f9608eb7d1$var$FRAGMENTS_KEY = $3axLc.FRAGMENTS_KEY;

var $1etGW = parcelRequire("1etGW");
function $0c73c9f9608eb7d1$var$readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = $0c73c9f9608eb7d1$var$getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !(typeof fragmentRef === 'object') && $1etGW(false);
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[$0c73c9f9608eb7d1$var$FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && $1etGW(false);
    return inlineData;
}
module.exports = $0c73c9f9608eb7d1$var$readInlineData;

});

parcelRegister("8bN82", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $5f6575baf0dbafc9$var$_interopRequireDefault = $9Ew61.default;

var $5f6575baf0dbafc9$var$_objectSpread2 = $5f6575baf0dbafc9$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $6ePL7 = parcelRequire("6ePL7");

var $6WFXo = parcelRequire("6WFXo");
var $5f6575baf0dbafc9$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $6WFXo.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $5f6575baf0dbafc9$var$assertInternalActorIdentifier = $6WFXo.assertInternalActorIdentifier;

var $h6dVp = parcelRequire("h6dVp");

var $kDoSU = parcelRequire("kDoSU");

var $4Am9m = parcelRequire("4Am9m");

var $e1xPo = parcelRequire("e1xPo");

var $hxRDG = parcelRequire("hxRDG");

var $2xN6v = parcelRequire("2xN6v");

var $alzKh = parcelRequire("alzKh");

var $h6cAl = parcelRequire("h6cAl");

var $ew5WD = parcelRequire("ew5WD");

var $fnDZb = parcelRequire("fnDZb");

var $kyCh1 = parcelRequire("kyCh1");
parcelRequire("1etGW");
var $5f6575baf0dbafc9$var$RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$store, _config$log, _config$relayFieldLog, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$normalizeResp, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        var operationLoader = config.operationLoader;
        var store = (_config$store = config.store) !== null && _config$store !== void 0 ? _config$store : new $ew5WD(new $kyCh1(), {
            log: config.log,
            operationLoader: config.operationLoader,
            getDataID: config.getDataID,
            shouldProcessClientComponents: config.shouldProcessClientComponents
        });
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : $5f6575baf0dbafc9$var$emptyFunction;
        this.relayFieldLogger = (_config$relayFieldLog = config.relayFieldLogger) !== null && _config$relayFieldLog !== void 0 ? _config$relayFieldLog : $2xN6v;
        this._defaultRenderPolicy = (_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : 'partial';
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = $kDoSU(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : $hxRDG;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new $fnDZb(store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : $6ePL7, this._getDataID, this._missingFieldHandlers, this.__log);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this._normalizeResponse = (_config$normalizeResp = config.normalizeResponse) !== null && _config$normalizeResp !== void 0 ? _config$normalizeResp : $alzKh;
        this.__setNet = function(newNet) {
            return _this._network = $kDoSU(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new $4Am9m();
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        $e1xPo(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === 'active';
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return $h6dVp.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !$5f6575baf0dbafc9$var$operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return $h6dVp.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = $kyCh1.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            handlers: handlers,
            defaultActorIdentifier: $5f6575baf0dbafc9$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                $5f6575baf0dbafc9$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                $5f6575baf0dbafc9$var$assertInternalActorIdentifier(actorIdentifier);
                return target;
            }
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    };
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null, undefined, undefined, undefined, function() {
                    return _this7.check(operation);
                });
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    };
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, $5f6575baf0dbafc9$var$_objectSpread2["default"])((0, $5f6575baf0dbafc9$var$_objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    };
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : '', ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this10 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return $h6dVp.create(function(sink) {
            var executor = $h6cAl.execute({
                actorIdentifier: $5f6575baf0dbafc9$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this10._getDataID,
                isClientPayload: isClientPayload,
                log: _this10.__log,
                operation: operation,
                operationExecutions: _this10._operationExecutions,
                operationLoader: _this10._operationLoader,
                operationTracker: _this10._operationTracker,
                optimisticConfig: optimisticConfig,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    $5f6575baf0dbafc9$var$assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                scheduler: _this10._scheduler,
                shouldProcessClientComponents: _this10._shouldProcessClientComponents,
                sink: sink,
                source: createSource(),
                getStore: function getStore(actorIdentifier) {
                    $5f6575baf0dbafc9$var$assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                treatMissingFieldsAsNull: _this10._treatMissingFieldsAsNull,
                updater: updater,
                normalizeResponse: _this10._normalizeResponse
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function $5f6575baf0dbafc9$var$operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === 'Operation' && operation.root.node.clientAbstractTypes != null;
}
$5f6575baf0dbafc9$var$RelayModernEnvironment.prototype['@@RelayModernEnvironment'] = true;
function $5f6575baf0dbafc9$var$emptyFunction() {}
module.exports = $5f6575baf0dbafc9$var$RelayModernEnvironment;

});
parcelRegister("kDoSU", function(module, exports) {
'use strict';

var $lDtgD = parcelRequire("lDtgD");
function $f05ac0c0c2f9dd1d$var$wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables, _, encryptedVariables, preprocessResponse, checkOperation) {
            var networkRequestId = $lDtgD();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: 'network.start',
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: 'network.next',
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: 'network.error',
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: 'network.complete',
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: 'network.unsubscribe',
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: 'network.info',
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo, encryptedVariables, preprocessResponse, checkOperation)["do"](logObserver);
        }
    };
}
module.exports = $f05ac0c0c2f9dd1d$var$wrapNetworkWithLogObserver;

});
parcelRegister("lDtgD", function(module, exports) {
'use strict';
var $fc03f1623ee91fce$var$id = 100000;
function $fc03f1623ee91fce$var$generateID() {
    return $fc03f1623ee91fce$var$id++;
}
module.exports = $fc03f1623ee91fce$var$generateID;

});


parcelRegister("4Am9m", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $356bb4c0cb9a053d$var$_interopRequireDefault = $9Ew61.default;

var $356bb4c0cb9a053d$var$_createForOfIteratorHelper2 = $356bb4c0cb9a053d$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $1etGW = parcelRequire("1etGW");
var $356bb4c0cb9a053d$var$RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, $356bb4c0cb9a053d$var$_createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, $356bb4c0cb9a053d$var$_createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    };
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        var completedOwnersIdentifier = new Set();
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, $356bb4c0cb9a053d$var$_createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, $356bb4c0cb9a053d$var$_createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, $356bb4c0cb9a053d$var$_createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && $1etGW(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
module.exports = $356bb4c0cb9a053d$var$RelayOperationTracker;

});

parcelRegister("e1xPo", function(module, exports) {
'use strict';
function $a35b663a1eebe706$var$registerEnvironmentWithDevTools(environment) {
    var _global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
module.exports = $a35b663a1eebe706$var$registerEnvironmentWithDevTools;

});

parcelRegister("hxRDG", function(module, exports) {
'use strict';

var $qW3rR = parcelRequire("qW3rR");
var $cc5f2052554beaf0$var$VIEWER_ID = $qW3rR.VIEWER_ID, $cc5f2052554beaf0$var$VIEWER_TYPE = $qW3rR.VIEWER_TYPE;
function $cc5f2052554beaf0$var$defaultGetDataID(fieldValue, typeName) {
    if (typeName === $cc5f2052554beaf0$var$VIEWER_TYPE) return fieldValue.id == null ? $cc5f2052554beaf0$var$VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = $cc5f2052554beaf0$var$defaultGetDataID;

});
parcelRegister("qW3rR", function(module, exports) {
'use strict';

var $e8h4i = parcelRequire("e8h4i");
var $050f7642ca4ded6f$var$generateClientID = $e8h4i.generateClientID;

var $3axLc = parcelRequire("3axLc");
var $050f7642ca4ded6f$var$ROOT_ID = $3axLc.ROOT_ID;
var $050f7642ca4ded6f$var$VIEWER_ID = $050f7642ca4ded6f$var$generateClientID($050f7642ca4ded6f$var$ROOT_ID, 'viewer');
var $050f7642ca4ded6f$var$VIEWER_TYPE = 'Viewer';
module.exports = {
    VIEWER_ID: $050f7642ca4ded6f$var$VIEWER_ID,
    VIEWER_TYPE: $050f7642ca4ded6f$var$VIEWER_TYPE
};

});


parcelRegister("2xN6v", function(module, exports) {
'use strict';
var $1da4c0d72a92dbcf$var$defaultRelayFieldLogger = function defaultRelayFieldLogger(event) {};
module.exports = $1da4c0d72a92dbcf$var$defaultRelayFieldLogger;

});

parcelRegister("h6cAl", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $c72cc25dd3f7d3b3$var$_interopRequireDefault = $9Ew61.default;

var $c72cc25dd3f7d3b3$var$_createForOfIteratorHelper2 = $c72cc25dd3f7d3b3$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $c72cc25dd3f7d3b3$var$_toConsumableArray2 = $c72cc25dd3f7d3b3$var$_interopRequireDefault((parcelRequire("4Ika6")));

var $h6dVp = parcelRequire("h6dVp");

var $lDtgD = parcelRequire("lDtgD");

var $12eIF = parcelRequire("12eIF");

var $drt2N = parcelRequire("drt2N");

var $1K5RO = parcelRequire("1K5RO");

var $fAAFv = parcelRequire("fAAFv");
var $c72cc25dd3f7d3b3$var$stableCopy = $fAAFv.stableCopy;

var $tN1Ki = parcelRequire("tN1Ki");

var $e8h4i = parcelRequire("e8h4i");
var $c72cc25dd3f7d3b3$var$generateClientID = $e8h4i.generateClientID, $c72cc25dd3f7d3b3$var$generateUniqueClientID = $e8h4i.generateUniqueClientID;

var $8g71t = parcelRequire("8g71t");
var $c72cc25dd3f7d3b3$var$getLocalVariables = $8g71t.getLocalVariables;

var $2yWF2 = parcelRequire("2yWF2");

var $5AfVC = parcelRequire("5AfVC");
var $c72cc25dd3f7d3b3$var$createNormalizationSelector = $5AfVC.createNormalizationSelector, $c72cc25dd3f7d3b3$var$createReaderSelector = $5AfVC.createReaderSelector;

var $kyCh1 = parcelRequire("kyCh1");

var $3axLc = parcelRequire("3axLc");
var $c72cc25dd3f7d3b3$var$ROOT_TYPE = $3axLc.ROOT_TYPE, $c72cc25dd3f7d3b3$var$TYPENAME_KEY = $3axLc.TYPENAME_KEY, $c72cc25dd3f7d3b3$var$getStorageKey = $3axLc.getStorageKey;

var $1etGW = parcelRequire("1etGW");
parcelRequire("4j8bN");
function $c72cc25dd3f7d3b3$var$execute(config) {
    return new $c72cc25dd3f7d3b3$var$Executor(config);
}
var $c72cc25dd3f7d3b3$var$Executor = /*#__PURE__*/ function() {
    function Executor(_ref3) {
        var _this = this;
        var _ref, _this$_operation$requ, _this$_operation$requ2;
        var actorIdentifier = _ref3.actorIdentifier, getDataID = _ref3.getDataID, getPublishQueue = _ref3.getPublishQueue, getStore = _ref3.getStore, isClientPayload = _ref3.isClientPayload, operation = _ref3.operation, operationExecutions = _ref3.operationExecutions, operationLoader = _ref3.operationLoader, operationTracker = _ref3.operationTracker, optimisticConfig = _ref3.optimisticConfig, scheduler = _ref3.scheduler, shouldProcessClientComponents = _ref3.shouldProcessClientComponents, sink = _ref3.sink, source = _ref3.source, treatMissingFieldsAsNull = _ref3.treatMissingFieldsAsNull, updater = _ref3.updater, log = _ref3.log, normalizeResponse = _ref3.normalizeResponse;
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = $lDtgD();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._useExecTimeResolvers = (_ref = (_this$_operation$requ = this._operation.request.node.operation.use_exec_time_resolvers) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : ((_this$_operation$requ2 = this._operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _this$_operation$requ2 === void 0 ? void 0 : _this$_operation$requ2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        this._execTimeResolverResponseComplete = false;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = 'started';
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === 'subscription';
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        this._normalizeResponse = normalizeResponse;
        var id = this._nextSubscriptionId++;
        if ($1K5RO.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ3;
                _this._start(id, subscription);
                _this._log({
                    name: 'execute.start',
                    executeId: _this._executeId,
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables,
                    cacheConfig: (_this$_operation$requ3 = _this._operation.request.cacheConfig) !== null && _this$_operation$requ3 !== void 0 ? _this$_operation$requ3 : {}
                });
            },
            unsubscribe: function unsubscribe() {
                _this._log({
                    name: 'execute.unsubscribe',
                    executeId: _this._executeId
                });
            }
        });
        if (!$1K5RO.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === 'completed') return;
        this._state = 'completed';
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case 'started':
                activeState = 'active';
                break;
            case 'loading_incremental':
                activeState = 'active';
                break;
            case 'completed':
                activeState = 'inactive';
                break;
            case 'loading_final':
                activeState = this._pendingModulePayloadsCount > 0 || this._useExecTimeResolvers && !this._execTimeResolverResponseComplete ? 'active' : 'inactive';
                break;
            default:
                this._state;
                $1etGW(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task, priority) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            $h6dVp.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                }, priority);
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                name: 'execute.complete',
                executeId: this._executeId
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            name: 'execute.error',
            executeId: this._executeId,
            error: error
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        var priority = this._state === 'loading_incremental' ? 'low' : 'default';
        this._schedule(function() {
            _this4._log({
                name: 'execute.next.start',
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
            _this4._handleNext(response);
            _this4._maybeCompleteSubscriptionOperationTracking();
            _this4._log({
                name: 'execute.next.end',
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
        }, priority);
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty('errors')) return;
            else if (response.data == null) {
                var errors = response.hasOwnProperty('errors') && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref4) {
                    var message = _ref4.message;
                    return message;
                }).join('\n') : '(No errors)';
                var error = $drt2N.create('RelayNetwork', 'No data returned for operation `' + _this5._operation.request.node.params.name + '`, got error(s):\n' + messages + '\n\nSee the error `source` property for more information.');
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    };
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) $1etGW(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== 'started') $1etGW(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === 'completed') return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                this._state = 'loading_final';
                this._updateActiveState();
                this._incrementalPayloadsPending = false;
            }
            this._sink.next(response);
            return;
        }
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = $c72cc25dd3f7d3b3$var$partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1], normalizedResponses = _partitionGraphQLResp[2];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        var hasNormalizedResponses = normalizedResponses.length > 0;
        if (hasNonIncrementalResponses) {
            if (this._isSubscriptionOperation) {
                var nextID = $c72cc25dd3f7d3b3$var$generateUniqueClientID();
                this._operation = {
                    request: this._operation.request,
                    fragment: $c72cc25dd3f7d3b3$var$createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    root: $c72cc25dd3f7d3b3$var$createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (hasNormalizedResponses) {
            var _payloadFollowups = [];
            for(var i = 0; i < normalizedResponses.length; i++){
                var _response$extensions2;
                var _response = normalizedResponses[i];
                var source = new $kyCh1(_response.data);
                var isFinal = ((_response$extensions2 = _response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true;
                var payload = {
                    errors: [],
                    fieldPayloads: [],
                    followupPayloads: [],
                    incrementalPlaceholders: [],
                    isFinal: isFinal,
                    source: source
                };
                this._getPublishQueueAndSaveActor().commitPayload(this._operation, payload, this._updater);
                _payloadFollowups.push(payload);
                this._execTimeResolverResponseComplete = isFinal;
                if (isFinal) this._updateActiveState();
            }
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups2 = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups2);
        }
        if (this._isSubscriptionOperation) {
            if (responsesWithData[0].extensions == null) responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses || hasNormalizedResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this6 = this;
        !(this._optimisticUpdates === null) && $1etGW(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = this._normalizeResponse(response, this._operation.root, $c72cc25dd3f7d3b3$var$ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                getDataID: this._getDataID,
                log: this._log,
                path: [],
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            }, this._useExecTimeResolvers);
            $c72cc25dd3f7d3b3$var$validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $kyCh1.create(),
                isFinal: false
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this6._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        var updatedOwners = this._runPublishQueue();
        if ($1K5RO.ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES) this._updateOperationTracker(updatedOwners);
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, $c72cc25dd3f7d3b3$var$_createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case 'ModuleImportPayload':
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, $c72cc25dd3f7d3b3$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case 'ActorPayload':
                            break;
                        default:
                            followupPayload;
                            $1etGW(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === 'SplitOperation' && followupPayload.kind === 'ModuleImportPayload') variables = $c72cc25dd3f7d3b3$var$getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = $c72cc25dd3f7d3b3$var$createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        var nextResponse = {
            data: followupPayload.data,
            extensions: this._state === 'loading_final' ? {
                is_final: true
            } : undefined
        };
        return this._normalizeResponse(nextResponse, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: followupPayload.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = $12eIF(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        $c72cc25dd3f7d3b3$var$validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this7 = this;
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this7._state !== 'started') return;
            var moduleImportOptimisticUpdates = _this7._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this7._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this7._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, $c72cc25dd3f7d3b3$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                _this7._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this8 = this;
        this._log({
            name: 'execute.normalize.start',
            operation: this._operation
        });
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this8._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = _this8._normalizeResponse(payloadPart, _this8._operation.root, $c72cc25dd3f7d3b3$var$ROOT_TYPE, {
                actorIdentifier: _this8._actorIdentifier,
                getDataID: _this8._getDataID,
                log: _this8._log,
                path: [],
                treatMissingFieldsAsNull: _this8._treatMissingFieldsAsNull,
                shouldProcessClientComponents: _this8._shouldProcessClientComponents
            }, _this8._useExecTimeResolvers);
            _this8._getPublishQueueAndSaveActor().commitPayload(_this8._operation, relayPayload, _this8._updater);
            _this8._log({
                name: 'execute.normalize.end',
                operation: _this8._operation
            });
            return relayPayload;
        });
    };
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this9 = this;
        if (this._state === 'completed') return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this9._state = isFinal ? 'loading_final' : 'loading_incremental';
            _this9._updateActiveState();
            if (isFinal) _this9._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this9._actorIdentifier;
                _this9._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this9._actorIdentifier;
                _this9._processFollowupPayload(followupPayload);
                _this9._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this9._incrementalPayloadsPending = _this9._state !== 'loading_final';
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this9._actorIdentifier;
                    _this9._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this9._actorIdentifier;
                    _this9._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this9._actorIdentifier = prevActorIdentifier;
                });
                if (_this9._isClientPayload || _this9._state === 'loading_final') {
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === 'defer') relayPayloads.push(_this9._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data,
                            extensions: {
                                is_final: true
                            }
                        }));
                    });
                    if (relayPayloads.length > 0) _this9._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation && !(this._useExecTimeResolvers && this._execTimeResolverResponseComplete && this._state === 'loading_final')) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    };
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this10 = this;
        switch(followupPayload.kind){
            case 'ModuleImportPayload':
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) this._processFollowupPayloadWithNormalizationNode(followupPayload, $12eIF(node));
                else {
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this10._pendingModulePayloadsCount--;
                        _this10._maybeCompleteSubscriptionOperationTracking();
                    };
                    var networkObservable = $h6dVp.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    $h6dVp.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = $12eIF(loadedNode);
                                            var batchAsyncModuleUpdatesFN = $1K5RO.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this10._pendingModulePayloadsCount > 1;
                                            var _withStartAndDuration = $tN1Ki(function() {
                                                _this10._handleFollowupPayload(followupPayload, operation);
                                                if (shouldScheduleAsyncStoreUpdate) _this10._scheduleAsyncStoreUpdate(batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this10._runPublishQueue();
                                                    _this10._updateOperationTracker(updatedOwners);
                                                }
                                            }), _ = _withStartAndDuration[0], duration = _withStartAndDuration[1];
                                            _this10._log({
                                                name: 'execute.async.module',
                                                executeId: _this10._executeId,
                                                operationName: operation.name,
                                                duration: duration
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this10._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            },
                            error: sink.error
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this10._scheduler != null && cancellationToken != null) _this10._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this10._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this10._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this10._start(id, subscription);
                        }
                    });
                }
                break;
            case 'ActorPayload':
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                $1etGW(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    };
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join('.');
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === 'response' ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: 'placeholder',
            placeholder: placeholder
        });
        var parentID;
        if (placeholder.kind === 'stream') parentID = placeholder.parentID;
        else if (placeholder.kind === 'defer') parentID = placeholder.selector.dataID;
        else {
            placeholder;
            $1etGW(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = $c72cc25dd3f7d3b3$var$generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return fieldPayload.dataID === parentID || fieldID === parentID;
        });
        !(parentRecord != null) && $1etGW(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            nextParentRecord = $2yWF2.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = $c72cc25dd3f7d3b3$var$stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: nextParentPayloads
        });
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    };
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this11 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this11._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this11._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf('$defer$') !== -1) {
                var pathKey = path.map(String).join('.');
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === 'response') {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === 'defer') && $1etGW(false);
                relayPayloads.push(_this11._processDeferResponse(label, path, placeholder, response));
            } else {
                var _pathKey = path.slice(0, -2).map(String).join('.');
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === 'response') {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === 'stream') && $1etGW(false);
                relayPayloads.push(_this11._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = this._normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: placeholder.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $1etGW(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions3;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $kyCh1.create(),
                isFinal: ((_response$extensions3 = response.extensions) === null || _response$extensions3 === void 0 ? void 0 : _response$extensions3.is_final) === true
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        var field = node.selections[0];
        !(field != null && field.kind === 'LinkedField' && field.plural === true) && $1etGW(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) return;
            var nextItems = (0, $c72cc25dd3f7d3b3$var$_toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $kyCh1.create(),
                isFinal: false
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref2, _this$_getDataID;
        var data = response.data;
        !(typeof data === 'object') && $1etGW(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = $c72cc25dd3f7d3b3$var$getStorageKey(field, variables);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $1etGW(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        var prevIDs = $2yWF2.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && $1etGW(false);
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && $1etGW(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[$c72cc25dd3f7d3b3$var$TYPENAME_KEY];
        !(typeof typeName === 'string') && $1etGW(false);
        var itemID = (_ref2 = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref2 !== void 0 ? _ref2 : $c72cc25dd3f7d3b3$var$generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === 'string') && $1etGW(false);
        var selector = $c72cc25dd3f7d3b3$var$createNormalizationSelector(field, itemID, variables);
        var nextParentRecord = $2yWF2.clone(parentRecord);
        var nextIDs = (0, $c72cc25dd3f7d3b3$var$_toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        $2yWF2.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: fieldPayloads
        });
        var relayPayload = this._normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: [].concat((0, $c72cc25dd3f7d3b3$var$_toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this12 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this12._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this12._runPublishQueue();
            _this12._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, $c72cc25dd3f7d3b3$var$_createForOfIteratorHelper2["default"])(_this12._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this12._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, $c72cc25dd3f7d3b3$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, $c72cc25dd3f7d3b3$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, $c72cc25dd3f7d3b3$var$_createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && $1etGW(false);
        return operationLoader;
    };
    return Executor;
}();
function $c72cc25dd3f7d3b3$var$partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    var normalizedResponses = [];
    responses.forEach(function(response) {
        var _response$extensions4;
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) $1etGW(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else if (((_response$extensions4 = response.extensions) === null || _response$extensions4 === void 0 ? void 0 : _response$extensions4.is_normalized) === true) normalizedResponses.push(response);
        else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses,
        normalizedResponses
    ];
}
function $c72cc25dd3f7d3b3$var$stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify($c72cc25dd3f7d3b3$var$stableCopy(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
}
function $c72cc25dd3f7d3b3$var$validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) $1etGW(false);
}
module.exports = {
    execute: $c72cc25dd3f7d3b3$var$execute
};

});
parcelRegister("12eIF", function(module, exports) {
'use strict';

var $gSH3f = parcelRequire("gSH3f");
var $0c116557a10fe161$var$REQUEST = $gSH3f.REQUEST, $0c116557a10fe161$var$SPLIT_OPERATION = $gSH3f.SPLIT_OPERATION;
function $0c116557a10fe161$var$getOperation(node) {
    switch(node.kind){
        case $0c116557a10fe161$var$REQUEST:
            return node.operation;
        case $0c116557a10fe161$var$SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = $0c116557a10fe161$var$getOperation;

});

parcelRegister("drt2N", function(module, exports) {
'use strict';
function $9c9453849f0a38a2$var$createError(type, name, messageFormat) {
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        taalOpcodes: [
            2,
            2
        ]
    });
    if (error.stack === undefined) try {
        throw error;
    } catch (_unused) {}
    return error;
}
module.exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return $9c9453849f0a38a2$var$createError.apply(void 0, [
            'error',
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return $9c9453849f0a38a2$var$createError.apply(void 0, [
            'warn',
            name,
            messageFormat
        ].concat(messageParams));
    }
};

});

parcelRegister("tN1Ki", function(module, exports) {
'use strict';
var $0598bd51f45c797f$var$_window, $0598bd51f45c797f$var$_window$performance;
var $0598bd51f45c797f$var$isPerformanceNowAvailable = typeof window !== 'undefined' && typeof (($0598bd51f45c797f$var$_window = window) === null || $0598bd51f45c797f$var$_window === void 0 ? void 0 : ($0598bd51f45c797f$var$_window$performance = $0598bd51f45c797f$var$_window.performance) === null || $0598bd51f45c797f$var$_window$performance === void 0 ? void 0 : $0598bd51f45c797f$var$_window$performance.now) === 'function';
function $0598bd51f45c797f$var$currentTimestamp() {
    if ($0598bd51f45c797f$var$isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function $0598bd51f45c797f$var$withStartAndDuration(cb) {
    var startTime = $0598bd51f45c797f$var$currentTimestamp();
    var result = cb();
    return [
        startTime,
        $0598bd51f45c797f$var$currentTimestamp() - startTime,
        result
    ];
}
module.exports = $0598bd51f45c797f$var$withStartAndDuration;

});


parcelRegister("ew5WD", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $a918aa52fb35f6bb$var$_interopRequireDefault = $9Ew61.default;

var $a918aa52fb35f6bb$var$_createForOfIteratorHelper2 = $a918aa52fb35f6bb$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $a918aa52fb35f6bb$var$_defineProperty2 = $a918aa52fb35f6bb$var$_interopRequireDefault((parcelRequire("2bxFr")));

var $6WFXo = parcelRequire("6WFXo");
var $a918aa52fb35f6bb$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $6WFXo.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $a918aa52fb35f6bb$var$assertInternalActorIdentifier = $6WFXo.assertInternalActorIdentifier;
parcelRequire("u9izA");

var $goHeV = parcelRequire("goHeV");

var $jmJcQ = parcelRequire("jmJcQ");

var $hxRDG = parcelRequire("hxRDG");

var $hw076 = parcelRequire("hw076");
var $a918aa52fb35f6bb$var$LiveResolverCache = $hw076.LiveResolverCache, $a918aa52fb35f6bb$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $hw076.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $a918aa52fb35f6bb$var$getUpdatedDataIDs = $hw076.getUpdatedDataIDs;

var $2yWF2 = parcelRequire("2yWF2");

var $aj3uW = parcelRequire("aj3uW");

var $a5m1P = parcelRequire("a5m1P");

var $20C77 = parcelRequire("20C77");

var $jZ0c2 = parcelRequire("jZ0c2");

var $3axLc = parcelRequire("3axLc");

var $3axLc = parcelRequire("3axLc");
var $a918aa52fb35f6bb$var$ROOT_ID = $3axLc.ROOT_ID, $a918aa52fb35f6bb$var$ROOT_TYPE = $3axLc.ROOT_TYPE;

var $1etGW = parcelRequire("1etGW");
var $a918aa52fb35f6bb$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $a918aa52fb35f6bb$var$RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$shouldRetain, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$shouldProces, _options$treatMissing;
        (0, $a918aa52fb35f6bb$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $a918aa52fb35f6bb$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._shouldRetainWithinTTL_EXPERIMENTAL = (_options$shouldRetain = options === null || options === void 0 ? void 0 : options.shouldRetainWithinTTL_EXPERIMENTAL) !== null && _options$shouldRetain !== void 0 ? _options$shouldRetain : false;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $goHeV;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $hxRDG;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $a918aa52fb35f6bb$var$LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._resolverContext = options === null || options === void 0 ? void 0 : options.resolverContext;
        this._storeSubscriptions = new $jZ0c2(options === null || options === void 0 ? void 0 : options.log, this._resolverCache, this._resolverContext);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        $a918aa52fb35f6bb$var$initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto.getOperationLoader = function getOperationLoader() {
        return this._operationLoader;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _ref, _operation$request$no, _operation$request$no2, _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var useExecTimeResolvers = (_ref = (_operation$request$no = operation.request.node.operation.use_exec_time_resolvers) !== null && _operation$request$no !== void 0 ? _operation$request$no : ((_operation$request$no2 = operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _operation$request$no2 === void 0 ? void 0 : _operation$request$no2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $a918aa52fb35f6bb$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $a918aa52fb35f6bb$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $jmJcQ.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $a918aa52fb35f6bb$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents, this.__log, useExecTimeResolvers);
        return $a918aa52fb35f6bb$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    if (!_this2._shouldRetainWithinTTL_EXPERIMENTAL) _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        if (!_this2._shouldRetainWithinTTL_EXPERIMENTAL) _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var log = this.__log;
        if (log != null) log({
            name: 'store.lookup.start',
            selector: selector
        });
        var source = this.getSource();
        var snapshot = $a5m1P.read(source, selector, this._resolverCache, this._resolverContext);
        if (log != null) log({
            name: 'store.lookup.end',
            selector: selector
        });
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs,
            subscriptionsSize: this._storeSubscriptions.size(),
            updatedOwners: updatedOwners
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $a918aa52fb35f6bb$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'RelayModernStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $2yWF2.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $a918aa52fb35f6bb$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $1etGW(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $aj3uW.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && $1etGW(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = $aj3uW.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        if (this._shouldRetainWithinTTL_EXPERIMENTAL && this._queryCacheExpirationTime == null) return;
        var log = this.__log;
        top: while(true){
            if (log != null) log({
                name: 'store.gc.start'
            });
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $a918aa52fb35f6bb$var$_createForOfIteratorHelper2["default"])(this._roots.entries()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _ref2, _operation$request$no3, _operation$request$no4;
                    var _step2$value = _step2.value, _dataID = _step2$value[0], _step2$value$ = _step2$value[1], operation = _step2$value$.operation, refCount = _step2$value$.refCount, fetchTime = _step2$value$.fetchTime;
                    if (this._shouldRetainWithinTTL_EXPERIMENTAL) {
                        var _queryCacheExpirationTime = this._queryCacheExpirationTime;
                        !(_queryCacheExpirationTime != null) && $1etGW(false);
                        var recordHasExpired = fetchTime == null || fetchTime <= Date.now() - _queryCacheExpirationTime;
                        var recordShouldBeCollected = recordHasExpired && refCount === 0 && !this._releaseBuffer.includes(_dataID);
                        if (recordShouldBeCollected) continue;
                    }
                    var selector = operation.root;
                    var useExecTimeResolvers = (_ref2 = (_operation$request$no3 = operation.request.node.operation.use_exec_time_resolvers) !== null && _operation$request$no3 !== void 0 ? _operation$request$no3 : ((_operation$request$no4 = operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _operation$request$no4 === void 0 ? void 0 : _operation$request$no4.get()) === true) !== null && _ref2 !== void 0 ? _ref2 : false;
                    $20C77.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents, useExecTimeResolvers);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) {
                        if (log != null) log({
                            name: 'store.gc.interrupted'
                        });
                        continue top;
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var storeIDs = this._recordSource.getRecordIDs();
            for(var ii = 0; ii < storeIDs.length; ii++){
                var dataID = storeIDs[ii];
                if (!references.has(dataID)) {
                    var record = this._recordSource.get(dataID);
                    if (record != null) {
                        var maybeResolverSubscription = $2yWF2.getValue(record, $a918aa52fb35f6bb$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                        if (maybeResolverSubscription != null) maybeResolverSubscription();
                    }
                    this._recordSource.remove(dataID);
                    if (this._shouldRetainWithinTTL_EXPERIMENTAL) this._roots["delete"](dataID);
                }
            }
            if (log != null) log({
                name: 'store.gc.end',
                references: references
            });
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            log: this.__log,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = $a918aa52fb35f6bb$var$getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return RelayModernStore;
}();
function $a918aa52fb35f6bb$var$initializeRecordSource(target) {
    if (!target.has($a918aa52fb35f6bb$var$ROOT_ID)) {
        var rootRecord = $2yWF2.create($a918aa52fb35f6bb$var$ROOT_ID, $a918aa52fb35f6bb$var$ROOT_TYPE);
        target.set($a918aa52fb35f6bb$var$ROOT_ID, rootRecord);
    }
}
function $a918aa52fb35f6bb$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $2yWF2.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $2yWF2.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $2yWF2.setValue(nextRecord, $3axLc.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $2yWF2.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $a918aa52fb35f6bb$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $a918aa52fb35f6bb$var$RelayModernStore;

});
parcelRegister("goHeV", function(module, exports) {
'use strict';
var $bf006db97c3d509a$var$resolvedPromise = Promise.resolve();
function $bf006db97c3d509a$var$resolveImmediate(callback) {
    $bf006db97c3d509a$var$resolvedPromise.then(callback)["catch"]($bf006db97c3d509a$var$throwNext);
}
function $bf006db97c3d509a$var$throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = $bf006db97c3d509a$var$resolveImmediate;

});

parcelRegister("jmJcQ", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $e193235fff8e9f39$var$_interopRequireDefault = $9Ew61.default;

var $e193235fff8e9f39$var$_createForOfIteratorHelper2 = $e193235fff8e9f39$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $j77Hl = parcelRequire("j77Hl");

var $dWSDq = parcelRequire("dWSDq");

var $12eIF = parcelRequire("12eIF");

var $e8h4i = parcelRequire("e8h4i");
var $e193235fff8e9f39$var$isClientID = $e8h4i.isClientID;

var $6aM8d = parcelRequire("6aM8d");

var $iQ51z = parcelRequire("iQ51z");

var $8g71t = parcelRequire("8g71t");
var $e193235fff8e9f39$var$getLocalVariables = $8g71t.getLocalVariables;

var $2yWF2 = parcelRequire("2yWF2");

var $24u1P = parcelRequire("24u1P");
var $e193235fff8e9f39$var$EXISTENT = $24u1P.EXISTENT, $e193235fff8e9f39$var$UNKNOWN = $24u1P.UNKNOWN;

var $3axLc = parcelRequire("3axLc");

var $hRGwE = parcelRequire("hRGwE");
var $e193235fff8e9f39$var$TYPE_SCHEMA_TYPE = $hRGwE.TYPE_SCHEMA_TYPE, $e193235fff8e9f39$var$generateTypeID = $hRGwE.generateTypeID;

var $1etGW = parcelRequire("1etGW");
var $e193235fff8e9f39$var$getModuleOperationKey = $3axLc.getModuleOperationKey, $e193235fff8e9f39$var$getStorageKey = $3axLc.getStorageKey, $e193235fff8e9f39$var$getArgumentValues = $3axLc.getArgumentValues;
function $e193235fff8e9f39$var$check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers) {
    if (log != null) log({
        name: 'store.datachecker.start',
        selector: selector
    });
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new $e193235fff8e9f39$var$DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers);
    var result = checker.check(node, dataID);
    if (log != null) log({
        name: 'store.datachecker.end',
        selector: selector
    });
    return result;
}
var $e193235fff8e9f39$var$DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._useExecTimeResolvers = useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false;
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._log = log;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new $j77Hl(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new $dWSDq(mutator, this._getDataID, undefined, this._handlers, this._log);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            status: 'missing',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        } : {
            status: 'available',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $1etGW(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === 'id' && field.alias == null && $e193235fff8e9f39$var$isClientID(dataID)) return undefined;
        var args = field.args != undefined ? $e193235fff8e9f39$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, $e193235fff8e9f39$var$_createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === 'scalar') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? $e193235fff8e9f39$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, $e193235fff8e9f39$var$_createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === 'linked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === $e193235fff8e9f39$var$EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? $e193235fff8e9f39$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, $e193235fff8e9f39$var$_createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === 'pluralLinked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === $e193235fff8e9f39$var$EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === $e193235fff8e9f39$var$UNKNOWN) this._handleMissing();
        if (status === $e193235fff8e9f39$var$EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = $2yWF2.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ScalarField':
                    _this2._checkScalar(selection, dataID);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case 'ActorChange':
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'InlineFragment':
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && $1etGW(false);
                        var _typeID = $e193235fff8e9f39$var$generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) _this2._handleMissing();
                    }
                    break;
                case 'LinkedHandle':
                    var handleField = $6aM8d(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case 'ScalarHandle':
                    var _handleField = $iQ51z(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case 'ModuleImport':
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case 'Defer':
                case 'Stream':
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this2._variables;
                    _this2._variables = $e193235fff8e9f39$var$getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case 'ClientExtension':
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case 'TypeDiscriminator':
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && $1etGW(false);
                    var typeID = $e193235fff8e9f39$var$generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) _this2._handleMissing();
                    break;
                case 'ClientComponent':
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    if (!_this2._useExecTimeResolvers) _this2._checkResolver(selection, dataID);
                    break;
                case 'ClientEdgeToClientObject':
                    if (!_this2._useExecTimeResolvers) _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    $1etGW(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $1etGW(false);
        var operationKey = $e193235fff8e9f39$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $12eIF(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $e193235fff8e9f39$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = $e193235fff8e9f39$var$getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = $e193235fff8e9f39$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = $e193235fff8e9f39$var$getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = $e193235fff8e9f39$var$getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? $2yWF2.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator4 = (0, $e193235fff8e9f39$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var concreteType = _step4.value;
                    var typeID = $e193235fff8e9f39$var$generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, $e193235fff8e9f39$var$TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: $e193235fff8e9f39$var$check
};

});
parcelRegister("j77Hl", function(module, exports) {
'use strict';

var $2yWF2 = parcelRequire("2yWF2");

var $24u1P = parcelRequire("24u1P");
var $dea4a479dd30d42d$var$EXISTENT = $24u1P.EXISTENT;

var $1etGW = parcelRequire("1etGW");
var $dea4a479dd30d42d$var$RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = $2yWF2.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = $2yWF2.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = $2yWF2.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && $1etGW(false);
            sinkRecord = $2yWF2.create(dataID, $2yWF2.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && $1etGW(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) $2yWF2.copyFields(baseSource, sink);
        if (sinkSource) $2yWF2.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        $2yWF2.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== $dea4a479dd30d42d$var$EXISTENT && this._sink.getStatus(dataID) !== $dea4a479dd30d42d$var$EXISTENT) && $1etGW(false);
        var record = $2yWF2.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return $2yWF2.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $2yWF2.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        $2yWF2.setValue(sinkRecord, storageKey, value);
    };
    _proto.getErrors = function getErrors(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $2yWF2.getErrors(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setErrors = function setErrors(dataID, storageKey, errors) {
        var sinkRecord = this._getSinkRecord(dataID);
        $2yWF2.setErrors(sinkRecord, storageKey, errors);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = $2yWF2.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        $2yWF2.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = $2yWF2.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        $2yWF2.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = $dea4a479dd30d42d$var$RelayRecordSourceMutator;

});

parcelRegister("dWSDq", function(module, exports) {
'use strict';

var $2yWF2 = parcelRequire("2yWF2");

var $24u1P = parcelRequire("24u1P");
var $a27b127805fd6ab1$var$EXISTENT = $24u1P.EXISTENT, $a27b127805fd6ab1$var$NONEXISTENT = $24u1P.NONEXISTENT;

var $3axLc = parcelRequire("3axLc");
var $a27b127805fd6ab1$var$ROOT_ID = $3axLc.ROOT_ID, $a27b127805fd6ab1$var$ROOT_TYPE = $3axLc.ROOT_TYPE;

var $18vKq = parcelRequire("18vKq");
var $a27b127805fd6ab1$var$_readUpdatableFragment = $18vKq.readUpdatableFragment;

var $dliWH = parcelRequire("dliWH");
var $a27b127805fd6ab1$var$_readUpdatableQuery = $dliWH.readUpdatableQuery;

var $5OsMU = parcelRequire("5OsMU");

var $1etGW = parcelRequire("1etGW");
var $a27b127805fd6ab1$var$RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers, log) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
        this._log = log !== null && log !== void 0 ? log : function(LogEvent) {};
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === $a27b127805fd6ab1$var$EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== $a27b127805fd6ab1$var$EXISTENT) _this.create(dataID, $2yWF2.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === $a27b127805fd6ab1$var$NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $1etGW(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        !record && $1etGW(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== $a27b127805fd6ab1$var$ROOT_ID) && $1etGW(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === $a27b127805fd6ab1$var$EXISTENT) this._proxies[dataID] = new $5OsMU(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === $a27b127805fd6ab1$var$NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get($a27b127805fd6ab1$var$ROOT_ID);
        if (!root) root = this.create($a27b127805fd6ab1$var$ROOT_ID, $a27b127805fd6ab1$var$ROOT_TYPE);
        !(root && root.getType() === $a27b127805fd6ab1$var$ROOT_TYPE) && $1etGW(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $a27b127805fd6ab1$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $a27b127805fd6ab1$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = $a27b127805fd6ab1$var$RelayRecordSourceProxy;

});
parcelRegister("18vKq", function(module, exports) {
'use strict';

var $iEOHk = parcelRequire("iEOHk");
var $0d3f2a44a88d156e$var$getFragment = $iEOHk.getFragment;

var $5AfVC = parcelRequire("5AfVC");
var $0d3f2a44a88d156e$var$getVariablesFromFragment = $5AfVC.getVariablesFromFragment;

var $3axLc = parcelRequire("3axLc");
var $0d3f2a44a88d156e$var$ID_KEY = $3axLc.ID_KEY;

var $7kSjp = parcelRequire("7kSjp");
var $0d3f2a44a88d156e$var$createUpdatableProxy = $7kSjp.createUpdatableProxy;

var $1etGW = parcelRequire("1etGW");
function $0d3f2a44a88d156e$var$readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = $0d3f2a44a88d156e$var$getFragment(fragment);
    var fragmentVariables = $0d3f2a44a88d156e$var$getVariablesFromFragment(updatableFragment, fragmentReference);
    var id = fragmentReference[$0d3f2a44a88d156e$var$ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && $1etGW(false);
    return {
        updatableData: $0d3f2a44a88d156e$var$createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: $0d3f2a44a88d156e$var$readUpdatableFragment
};

});
parcelRegister("7kSjp", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $557487e193c6f5fa$var$_interopRequireDefault = $9Ew61.default;

var $557487e193c6f5fa$var$_createForOfIteratorHelper2 = $557487e193c6f5fa$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $3axLc = parcelRequire("3axLc");
var $557487e193c6f5fa$var$getArgumentValues = $3axLc.getArgumentValues;
var $557487e193c6f5fa$var$nonUpdatableKeys = [
    'id',
    '__id',
    '__typename',
    'js'
];
function $557487e193c6f5fa$var$createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    $557487e193c6f5fa$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    return mutableUpdatableProxy;
}
function $557487e193c6f5fa$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, $557487e193c6f5fa$var$_createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case 'LinkedField':
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: $557487e193c6f5fa$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $557487e193c6f5fa$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: $557487e193c6f5fa$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $557487e193c6f5fa$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case 'ScalarField':
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = $557487e193c6f5fa$var$getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = $557487e193c6f5fa$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: $557487e193c6f5fa$var$nonUpdatableKeys.includes(selection.name) ? undefined : function(newValue) {
                            var _selection$args2;
                            var newVariables = $557487e193c6f5fa$var$getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case 'InlineFragment':
                    if (updatableProxyRootRecord.getType() === selection.type) $557487e193c6f5fa$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'ClientExtension':
                    $557487e193c6f5fa$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'FragmentSpread':
                    break;
                case 'Condition':
                case 'ActorChange':
                case 'InlineDataFragmentSpread':
                case 'AliasedInlineFragmentSpread':
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                case 'Defer':
                case 'ModuleImport':
                case 'RequiredField':
                case 'CatchField':
                case 'Stream':
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
                default:
                    selection.kind;
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $557487e193c6f5fa$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = $557487e193c6f5fa$var$getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error('Do not assign null to plural linked fields; assign an empty array instead.');
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error('When assigning an array of items, none of the items should be null or undefined.');
                var __id = item.__id;
                if (__id == null) throw new Error('The __id field must be present on each item passed to the setter. This indicates a bug in Relay.');
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function $557487e193c6f5fa$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = $557487e193c6f5fa$var$getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error('The __id field must be present on the argument. This indicates a bug in Relay.');
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function $557487e193c6f5fa$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = $557487e193c6f5fa$var$getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = $557487e193c6f5fa$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                $557487e193c6f5fa$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                return updatableProxy;
            } else return linkedRecord;
        });
        else return linkedRecords;
    };
}
function $557487e193c6f5fa$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = $557487e193c6f5fa$var$getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = $557487e193c6f5fa$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            $557487e193c6f5fa$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            return updatableProxy;
        } else return linkedRecord;
    };
}
function $557487e193c6f5fa$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, $557487e193c6f5fa$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === 'linked') {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $557487e193c6f5fa$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, $557487e193c6f5fa$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === 'pluralLinked') {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $557487e193c6f5fa$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, $557487e193c6f5fa$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === 'scalar') {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: $557487e193c6f5fa$var$createUpdatableProxy
};

});


parcelRegister("dliWH", function(module, exports) {
'use strict';

var $iEOHk = parcelRequire("iEOHk");
var $9b6beec38734a463$var$getUpdatableQuery = $iEOHk.getUpdatableQuery;

var $7kSjp = parcelRequire("7kSjp");
var $9b6beec38734a463$var$createUpdatableProxy = $7kSjp.createUpdatableProxy;
function $9b6beec38734a463$var$readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = $9b6beec38734a463$var$getUpdatableQuery(query);
    return {
        updatableData: $9b6beec38734a463$var$createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: $9b6beec38734a463$var$readUpdatableQuery
};

});

parcelRegister("5OsMU", function(module, exports) {
'use strict';

var $e8h4i = parcelRequire("e8h4i");
var $43b7f3ebd171669e$var$generateClientID = $e8h4i.generateClientID;

var $3axLc = parcelRequire("3axLc");
var $43b7f3ebd171669e$var$getStableStorageKey = $3axLc.getStableStorageKey;

var $1etGW = parcelRequire("1etGW");
var $43b7f3ebd171669e$var$RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && $1etGW(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = $43b7f3ebd171669e$var$getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args, errors) {
        !$43b7f3ebd171669e$var$isValidLeafValue(value) && $1etGW(false);
        return this.setValue__UNSAFE(value, name, args, errors);
    };
    _proto.getErrors = function getErrors(name, args) {
        var storageKey = $43b7f3ebd171669e$var$getStableStorageKey(name, args);
        return this._mutator.getErrors(this._dataID, storageKey);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args, errors) {
        var storageKey = $43b7f3ebd171669e$var$getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        if (errors != null) {
            if (errors.length === 0) this._mutator.setErrors(this._dataID, storageKey);
            else this._mutator.setErrors(this._dataID, storageKey, errors);
        }
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = $43b7f3ebd171669e$var$getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(record instanceof RelayRecordProxy) && $1etGW(false);
        var storageKey = $43b7f3ebd171669e$var$getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = $43b7f3ebd171669e$var$getStableStorageKey(name, args);
            var clientID = $43b7f3ebd171669e$var$generateClientID(this.getDataID(), storageKey);
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = $43b7f3ebd171669e$var$getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && $1etGW(false);
        var storageKey = $43b7f3ebd171669e$var$getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function $43b7f3ebd171669e$var$isValidLeafValue(value) {
    return value == null || typeof value !== 'object' || Array.isArray(value) && value.every($43b7f3ebd171669e$var$isValidLeafValue);
}
module.exports = $43b7f3ebd171669e$var$RelayRecordProxy;

});


parcelRegister("6aM8d", function(module, exports) {
'use strict';

var $gSH3f = parcelRequire("gSH3f");
var $47e90325be5c3525$var$LINKED_FIELD = $gSH3f.LINKED_FIELD;

var $3axLc = parcelRequire("3axLc");
var $47e90325be5c3525$var$getHandleStorageKey = $3axLc.getHandleStorageKey;

var $4MrjW = parcelRequire("4MrjW");

var $1etGW = parcelRequire("1etGW");
function $47e90325be5c3525$var$cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $47e90325be5c3525$var$LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && $4MrjW(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $47e90325be5c3525$var$LINKED_FIELD) && $1etGW(false);
    var handleKey = $47e90325be5c3525$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'LinkedField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = $47e90325be5c3525$var$cloneRelayHandleSourceField;

});

parcelRegister("iQ51z", function(module, exports) {
'use strict';

var $gSH3f = parcelRequire("gSH3f");
var $db70fb107ff70e8a$var$SCALAR_FIELD = $gSH3f.SCALAR_FIELD;

var $3axLc = parcelRequire("3axLc");
var $db70fb107ff70e8a$var$getHandleStorageKey = $3axLc.getHandleStorageKey;

var $4MrjW = parcelRequire("4MrjW");

var $1etGW = parcelRequire("1etGW");
function $db70fb107ff70e8a$var$cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $db70fb107ff70e8a$var$SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && $4MrjW(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $db70fb107ff70e8a$var$SCALAR_FIELD) && $1etGW(false);
    var handleKey = $db70fb107ff70e8a$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'ScalarField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = $db70fb107ff70e8a$var$cloneRelayScalarHandleSourceField;

});


parcelRegister("hw076", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $cc058365f5d101b2$var$_interopRequireDefault = $9Ew61.default;

var $cc058365f5d101b2$var$_createForOfIteratorHelper2 = $cc058365f5d101b2$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $7g2Xq = parcelRequire("7g2Xq");

var $gSH3f = parcelRequire("gSH3f");
var $cc058365f5d101b2$var$RELAY_LIVE_RESOLVER = $gSH3f.RELAY_LIVE_RESOLVER;

var $1K5RO = parcelRequire("1K5RO");

var $8NqD9 = parcelRequire("8NqD9");

var $e8h4i = parcelRequire("e8h4i");
var $cc058365f5d101b2$var$generateClientID = $e8h4i.generateClientID, $cc058365f5d101b2$var$generateClientObjectClientID = $e8h4i.generateClientObjectClientID;

var $2yWF2 = parcelRequire("2yWF2");

var $5AfVC = parcelRequire("5AfVC");
var $cc058365f5d101b2$var$createNormalizationSelector = $5AfVC.createNormalizationSelector;

var $kyCh1 = parcelRequire("kyCh1");

var $gUBAT = parcelRequire("gUBAT");
var $cc058365f5d101b2$var$normalize = $gUBAT.normalize;

var $3axLc = parcelRequire("3axLc");
var $cc058365f5d101b2$var$RELAY_RESOLVER_ERROR_KEY = $3axLc.RELAY_RESOLVER_ERROR_KEY, $cc058365f5d101b2$var$RELAY_RESOLVER_INVALIDATION_KEY = $3axLc.RELAY_RESOLVER_INVALIDATION_KEY, $cc058365f5d101b2$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $3axLc.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $cc058365f5d101b2$var$RELAY_RESOLVER_SNAPSHOT_KEY = $3axLc.RELAY_RESOLVER_SNAPSHOT_KEY, $cc058365f5d101b2$var$RELAY_RESOLVER_VALUE_KEY = $3axLc.RELAY_RESOLVER_VALUE_KEY, $cc058365f5d101b2$var$getReadTimeResolverStorageKey = $3axLc.getReadTimeResolverStorageKey, $cc058365f5d101b2$var$getStorageKey = $3axLc.getStorageKey;

var $bBQRk = parcelRequire("bBQRk");

var $bJN79 = parcelRequire("bJN79");

var $mzzfX = parcelRequire("mzzfX");
var $cc058365f5d101b2$var$isSuspenseSentinel = $mzzfX.isSuspenseSentinel;

var $1etGW = parcelRequire("1etGW");
parcelRequire("4j8bN");
var $cc058365f5d101b2$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var $cc058365f5d101b2$var$RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var $cc058365f5d101b2$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var $cc058365f5d101b2$var$RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
var $cc058365f5d101b2$var$MODEL_PROPERTY_NAME = '__relay_model_instance';
function $cc058365f5d101b2$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $cc058365f5d101b2$var$LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = $cc058365f5d101b2$var$expectRecord(recordSource, recordID);
        var storageKey = $cc058365f5d101b2$var$getReadTimeResolverStorageKey(field, variables);
        var linkedID = $2yWF2.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) $cc058365f5d101b2$var$maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $cc058365f5d101b2$var$generateClientID(recordID, storageKey);
            linkedRecord = $2yWF2.create(linkedID, $cc058365f5d101b2$var$RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            $2yWF2.setValue(linkedRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $2yWF2.setValue(linkedRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === $cc058365f5d101b2$var$RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && $1etGW(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = $cc058365f5d101b2$var$expectRecord(recordSource, recordID);
            var nextRecord = $2yWF2.clone(currentRecord);
            $2yWF2.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = $cc058365f5d101b2$var$getStorageKey(field.fragment, variables);
                var resolverID = $cc058365f5d101b2$var$generateClientID(recordID, fragmentStorageKey);
                $cc058365f5d101b2$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $cc058365f5d101b2$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $cc058365f5d101b2$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $cc058365f5d101b2$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === $cc058365f5d101b2$var$RELAY_LIVE_RESOLVER && $2yWF2.getValue(linkedRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $cc058365f5d101b2$var$generateClientID(recordID, storageKey);
            linkedRecord = $2yWF2.clone(linkedRecord);
            var _liveState = $2yWF2.getValue(linkedRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!$bJN79(_liveState)) $1etGW(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            $2yWF2.setValue(linkedRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = $2yWF2.getValue(linkedRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $2yWF2.getValue(linkedRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if ($cc058365f5d101b2$var$isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $cc058365f5d101b2$var$generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && $1etGW(false);
        var liveState = $2yWF2.getValue(liveStateRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        $2yWF2.setValue(linkedRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        $2yWF2.setValue(linkedRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        $2yWF2.setValue(linkedRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!$2yWF2.hasValue(currentRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = $2yWF2.clone(currentRecord);
            $2yWF2.setValue(nextRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $kyCh1.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = $kyCh1.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && $1etGW(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        $2yWF2.setValue(resolverRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !$cc058365f5d101b2$var$isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = $bBQRk(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && $1etGW(false);
                resolverValue = [];
                var nextSource = $kyCh1.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === 'object') && $1etGW(false);
                    var typename = $cc058365f5d101b2$var$getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = $cc058365f5d101b2$var$generateClientObjectClientID(typename, $2yWF2.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, $cc058365f5d101b2$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, $cc058365f5d101b2$var$expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = $cc058365f5d101b2$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === 'object') && $1etGW(false);
                var _typename = $cc058365f5d101b2$var$getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = $cc058365f5d101b2$var$generateClientObjectClientID(_typename, $2yWF2.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, $cc058365f5d101b2$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = $cc058365f5d101b2$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            $2yWF2.setValue(resolverRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            $8NqD9(resolverValue);
            $2yWF2.setValue(resolverRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            $8NqD9(value);
            $2yWF2.setValue(resolverRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return $2yWF2.getValue(resolverRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            visited.add(recordID);
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, $cc058365f5d101b2$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        visited.add(fragment);
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, $cc058365f5d101b2$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                $cc058365f5d101b2$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) {
                                    visited.add(anotherRecordID);
                                    recordsToVisit.push(anotherRecordID);
                                }
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$2yWF2.getValue(record, $cc058365f5d101b2$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $2yWF2.getValue(record, $cc058365f5d101b2$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $7g2Xq(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($1K5RO.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $2yWF2.clone(record);
            $2yWF2.setValue(nextRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($2yWF2.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = $kyCh1.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = $2yWF2.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = $cc058365f5d101b2$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var useExecTimeResolvers = false;
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return $cc058365f5d101b2$var$normalize(source, selector, value, normalizationOptions, undefined, useExecTimeResolvers).source;
            case 'WeakModel':
                var _record = $2yWF2.create(outputTypeDataID, typename);
                $2yWF2.setValue(_record, $cc058365f5d101b2$var$MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                $1etGW(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = $cc058365f5d101b2$var$generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = $2yWF2.create(key, typeName);
            $2yWF2.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return $cc058365f5d101b2$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, $cc058365f5d101b2$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && $cc058365f5d101b2$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function $cc058365f5d101b2$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, $cc058365f5d101b2$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, $cc058365f5d101b2$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = $cc058365f5d101b2$var$expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = $cc058365f5d101b2$var$expectRecord(currentSource, _recordID2);
                var updatedRecord = $2yWF2.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    $cc058365f5d101b2$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function $cc058365f5d101b2$var$getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    $2yWF2.getFields(record).forEach(function(field) {
        if ($2yWF2.hasLinkedRecordID(record, field)) {
            var linkedRecordID = $2yWF2.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if ($2yWF2.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = $2yWF2.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function $cc058365f5d101b2$var$markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = $2yWF2.clone(record);
    $2yWF2.setValue(nextRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function $cc058365f5d101b2$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = $cc058365f5d101b2$var$getAllLinkedRecordIds(record);
    var _iterator9 = (0, $cc058365f5d101b2$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && $cc058365f5d101b2$var$isResolverRecord(_record2)) $cc058365f5d101b2$var$markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function $cc058365f5d101b2$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, $cc058365f5d101b2$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && $cc058365f5d101b2$var$isResolverRecord(record)) $cc058365f5d101b2$var$maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function $cc058365f5d101b2$var$isResolverRecord(record) {
    return $2yWF2.getType(record) === $cc058365f5d101b2$var$RELAY_RESOLVER_RECORD_TYPENAME;
}
function $cc058365f5d101b2$var$maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = $2yWF2.getValue(linkedRecord, $cc058365f5d101b2$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function $cc058365f5d101b2$var$expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && $1etGW(false);
    return record;
}
function $cc058365f5d101b2$var$getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function $cc058365f5d101b2$var$getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && $1etGW(false);
    return typename;
}
module.exports = {
    LiveResolverCache: $cc058365f5d101b2$var$LiveResolverCache,
    getUpdatedDataIDs: $cc058365f5d101b2$var$getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $cc058365f5d101b2$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};

});
parcelRegister("8NqD9", function(module, exports) {
'use strict';
module.exports = function shallowFreeze(value) {
    if (typeof value === 'object' && value != null && (Array.isArray(value) || value.constructor === Object)) Object.freeze(value);
};

});

parcelRegister("bBQRk", function(module, exports) {
'use strict';

var $2yWF2 = parcelRequire("2yWF2");

var $3axLc = parcelRequire("3axLc");
var $873c271e1e370e24$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $3axLc.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;

var $1etGW = parcelRequire("1etGW");
function $873c271e1e370e24$var$getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = $2yWF2.getValue(record, $873c271e1e370e24$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(maybeOutputTypeRecordIDs instanceof Set) && $1etGW(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = $873c271e1e370e24$var$getOutputTypeRecordIDs;

});

parcelRegister("bJN79", function(module, exports) {
'use strict';
function $88b9fec9151a669b$var$isLiveStateValue(v) {
    return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
module.exports = $88b9fec9151a669b$var$isLiveStateValue;

});


parcelRegister("aj3uW", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $780e646506ff0383$var$_interopRequireDefault = $9Ew61.default;

var $780e646506ff0383$var$_objectSpread2 = $780e646506ff0383$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $2yWF2 = parcelRequire("2yWF2");

var $kyCh1 = parcelRequire("kyCh1");

var $1etGW = parcelRequire("1etGW");
var $780e646506ff0383$var$UNPUBLISH_RECORD_SENTINEL = $2yWF2.fromObject(Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
}));
var $780e646506ff0383$var$RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = $kyCh1.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== $780e646506ff0383$var$UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === $780e646506ff0383$var$UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return 'UNKNOWN';
        else if (record === null) return 'NONEXISTENT';
        else return 'EXISTENT';
    };
    _proto.clear = function clear() {
        this._base = $kyCh1.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, $780e646506ff0383$var$UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, $780e646506ff0383$var$_objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = $2yWF2.toJSON(record);
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function $780e646506ff0383$var$create(base) {
    return new $780e646506ff0383$var$RelayOptimisticRecordSource(base);
}
function $780e646506ff0383$var$getOptimisticRecordIDs(source) {
    !(source instanceof $780e646506ff0383$var$RelayOptimisticRecordSource) && $1etGW(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: $780e646506ff0383$var$create,
    getOptimisticRecordIDs: $780e646506ff0383$var$getOptimisticRecordIDs
};

});

parcelRegister("a5m1P", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $757b75661079e4d2$var$_interopRequireDefault = $9Ew61.default;

var $757b75661079e4d2$var$_objectSpread2 = $757b75661079e4d2$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $757b75661079e4d2$var$_defineProperty2 = $757b75661079e4d2$var$_interopRequireDefault((parcelRequire("2bxFr")));

var $757b75661079e4d2$var$_objectWithoutPropertiesLoose2 = $757b75661079e4d2$var$_interopRequireDefault((parcelRequire("1lgQy")));

var $757b75661079e4d2$var$_toConsumableArray2 = $757b75661079e4d2$var$_interopRequireDefault((parcelRequire("4Ika6")));
var $757b75661079e4d2$var$_excluded = [
    "message"
];

var $1K5RO = parcelRequire("1K5RO");

var $mzzfX = parcelRequire("mzzfX");
var $757b75661079e4d2$var$isSuspenseSentinel = $mzzfX.isSuspenseSentinel;

var $8g71t = parcelRequire("8g71t");

var $2yWF2 = parcelRequire("2yWF2");

var $3axLc = parcelRequire("3axLc");
var $757b75661079e4d2$var$CLIENT_EDGE_TRAVERSAL_PATH = $3axLc.CLIENT_EDGE_TRAVERSAL_PATH, $757b75661079e4d2$var$FRAGMENT_OWNER_KEY = $3axLc.FRAGMENT_OWNER_KEY, $757b75661079e4d2$var$FRAGMENT_PROP_NAME_KEY = $3axLc.FRAGMENT_PROP_NAME_KEY, $757b75661079e4d2$var$FRAGMENTS_KEY = $3axLc.FRAGMENTS_KEY, $757b75661079e4d2$var$ID_KEY = $3axLc.ID_KEY, $757b75661079e4d2$var$MODULE_COMPONENT_KEY = $3axLc.MODULE_COMPONENT_KEY, $757b75661079e4d2$var$ROOT_ID = $3axLc.ROOT_ID, $757b75661079e4d2$var$getArgumentValues = $3axLc.getArgumentValues, $757b75661079e4d2$var$getModuleComponentKey = $3axLc.getModuleComponentKey, $757b75661079e4d2$var$getStorageKey = $3axLc.getStorageKey;

var $4Tlxm = parcelRequire("4Tlxm");
var $757b75661079e4d2$var$NoopResolverCache = $4Tlxm.NoopResolverCache;

var $aqnmy = parcelRequire("aqnmy");
var $757b75661079e4d2$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = $aqnmy.RESOLVER_FRAGMENT_ERRORED_SENTINEL, $757b75661079e4d2$var$withResolverContext = $aqnmy.withResolverContext;

var $hRGwE = parcelRequire("hRGwE");
var $757b75661079e4d2$var$generateTypeID = $hRGwE.generateTypeID;

var $1etGW = parcelRequire("1etGW");
function $757b75661079e4d2$var$read(recordSource, selector, resolverCache, resolverContext) {
    var reader = new $757b75661079e4d2$var$RelayReader(recordSource, selector, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new $757b75661079e4d2$var$NoopResolverCache(), resolverContext);
    return reader.read();
}
var $757b75661079e4d2$var$RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, resolverCache, resolverContext) {
        var _selector$clientEdgeT, _ref, _this$_owner$node$ope, _this$_owner$node$ope2;
        this._clientEdgeTraversalPath = (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, $757b75661079e4d2$var$_toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._fieldErrors = null;
        this._owner = selector.owner;
        this._useExecTimeResolvers = (_ref = (_this$_owner$node$ope = this._owner.node.operation.use_exec_time_resolvers) !== null && _this$_owner$node$ope !== void 0 ? _this$_owner$node$ope : ((_this$_owner$node$ope2 = this._owner.node.operation.exec_time_resolvers_enabled_provider) === null || _this$_owner$node$ope2 === void 0 ? void 0 : _this$_owner$node$ope2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
        this._resolverContext = resolverContext;
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector$node$;
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            if (!this._recordMatchesTypeCondition(record, node.type)) isDataExpectedToBePresent = false;
        }
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) isDataExpectedToBePresent = false;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        var catchTo = (_this$_selector$node$ = this._selector.node.metadata) === null || _this$_selector$node$ === void 0 ? void 0 : _this$_selector$node$.catchTo;
        if (catchTo != null) data = this._catchErrors(data, catchTo, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        return {
            data: data,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector,
            fieldErrors: this._fieldErrors
        };
    };
    _proto._maybeAddFieldErrors = function _maybeAddFieldErrors(record, storageKey) {
        var errors = $2yWF2.getErrors(record, storageKey);
        if (errors == null) return;
        var owner = this._fragmentName;
        if (this._fieldErrors == null) this._fieldErrors = [];
        for(var i = 0; i < errors.length; i++){
            var _error$path, _this$_selector$node$2, _this$_selector$node$3;
            var error = errors[i];
            this._fieldErrors.push({
                kind: 'relay_field_payload.error',
                owner: owner,
                fieldPath: ((_error$path = error.path) !== null && _error$path !== void 0 ? _error$path : []).join('.'),
                error: error,
                shouldThrow: (_this$_selector$node$2 = (_this$_selector$node$3 = this._selector.node.metadata) === null || _this$_selector$node$3 === void 0 ? void 0 : _this$_selector$node$3.throwOnFieldError) !== null && _this$_selector$node$2 !== void 0 ? _this$_selector$node$2 : false,
                handled: false,
                uiContext: undefined
            });
        }
    };
    _proto._markDataAsMissing = function _markDataAsMissing(fieldName) {
        var _this$_selector$node$4, _this$_selector$node$5;
        if (this._isWithinUnmatchedTypeRefinement) return;
        if (this._fieldErrors == null) this._fieldErrors = [];
        var owner = this._fragmentName;
        this._fieldErrors.push(((_this$_selector$node$4 = (_this$_selector$node$5 = this._selector.node.metadata) === null || _this$_selector$node$5 === void 0 ? void 0 : _this$_selector$node$5.throwOnFieldError) !== null && _this$_selector$node$4 !== void 0 ? _this$_selector$node$4 : false) ? {
            kind: 'missing_expected_data.throw',
            owner: owner,
            fieldPath: fieldName,
            handled: false,
            uiContext: undefined
        } : {
            kind: 'missing_expected_data.log',
            owner: owner,
            fieldPath: fieldName,
            uiContext: undefined
        });
        this._isMissingData = true;
        if (this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            if (top !== null) this._missingClientEdges.push({
                request: top.readerClientEdge.operation,
                clientEdgeDestinationID: top.clientEdgeDestinationID
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        this._seenRecords.add(dataID);
        if (record == null) {
            if (record === undefined) this._markDataAsMissing('<record>');
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $1etGW(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(selection) {
        if (selection.action === 'NONE') return;
        var owner = this._fragmentName;
        if (this._fieldErrors == null) this._fieldErrors = [];
        var fieldName;
        if (selection.field.linkedField != null) {
            var _selection$field$link;
            fieldName = (_selection$field$link = selection.field.linkedField.alias) !== null && _selection$field$link !== void 0 ? _selection$field$link : selection.field.linkedField.name;
        } else {
            var _selection$field$alia;
            fieldName = (_selection$field$alia = selection.field.alias) !== null && _selection$field$alia !== void 0 ? _selection$field$alia : selection.field.name;
        }
        switch(selection.action){
            case 'THROW':
                this._fieldErrors.push({
                    kind: 'missing_required_field.throw',
                    fieldPath: fieldName,
                    owner: owner,
                    handled: false,
                    uiContext: undefined
                });
                return;
            case 'LOG':
                this._fieldErrors.push({
                    kind: 'missing_required_field.log',
                    fieldPath: fieldName,
                    owner: owner,
                    uiContext: undefined
                });
                return;
            default:
                selection.action;
        }
    };
    _proto._handleRequiredFieldValue = function _handleRequiredFieldValue(selection, value) {
        if (value == null) {
            this._maybeReportUnexpectedNull(selection);
            return false;
        }
        return true;
    };
    _proto._catchErrors = function _catchErrors(_value, to, previousResponseFields) {
        var value = _value;
        switch(to){
            case 'RESULT':
                value = this._asResult(_value);
                break;
            case 'NULL':
                if (this._fieldErrors != null && this._fieldErrors.length > 0) value = null;
                break;
            default:
                to;
        }
        var childrenFieldErrors = this._fieldErrors;
        this._fieldErrors = previousResponseFields;
        if (childrenFieldErrors != null) {
            if (this._fieldErrors == null) this._fieldErrors = [];
            for(var i = 0; i < childrenFieldErrors.length; i++)this._fieldErrors.push($757b75661079e4d2$var$markFieldErrorHasHandled(childrenFieldErrors[i]));
        }
        return value;
    };
    _proto._asResult = function _asResult(value) {
        if (this._fieldErrors == null || this._fieldErrors.length === 0) return {
            ok: true,
            value: value
        };
        var errors = this._fieldErrors.map(function(error) {
            switch(error.kind){
                case 'relay_field_payload.error':
                    var _error$error = error.error, message = _error$error.message, displayError = (0, $757b75661079e4d2$var$_objectWithoutPropertiesLoose2["default"])(_error$error, $757b75661079e4d2$var$_excluded);
                    return displayError;
                case 'missing_expected_data.throw':
                case 'missing_expected_data.log':
                    return {
                        path: error.fieldPath.split('.')
                    };
                case 'relay_resolver.error':
                    return {
                        message: "Relay: Error in resolver for field at ".concat(error.fieldPath, " in ").concat(error.owner)
                    };
                case 'missing_required_field.throw':
                    return {
                        message: "Relay: Missing @required value at path '".concat(error.fieldPath, "' in '").concat(error.owner, "'.")
                    };
                case 'missing_required_field.log':
                    return null;
                default:
                    error.kind;
                    $1etGW(false);
            }
        }).filter(Boolean);
        return {
            ok: false,
            errors: errors
        };
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case 'RequiredField':
                    var requiredFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if (!this._handleRequiredFieldValue(selection, requiredFieldValue)) return false;
                    break;
                case 'CatchField':
                    var _selection$field$back, _selection$field, _field$alias;
                    var previousResponseFields = this._fieldErrors;
                    this._fieldErrors = null;
                    var catchFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    var field = (_selection$field$back = (_selection$field = selection.field) === null || _selection$field === void 0 ? void 0 : _selection$field.backingField) !== null && _selection$field$back !== void 0 ? _selection$field$back : selection.field;
                    var fieldName = (_field$alias = field === null || field === void 0 ? void 0 : field.alias) !== null && _field$alias !== void 0 ? _field$alias : field === null || field === void 0 ? void 0 : field.name;
                    !(fieldName != null) && $1etGW(false);
                    data[fieldName] = this._catchErrors(catchFieldValue, selection.to, previousResponseFields);
                    break;
                case 'ScalarField':
                    this._readScalar(selection, record, data);
                    break;
                case 'LinkedField':
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case 'InlineFragment':
                    var _hasExpectedData = this._readInlineFragment(selection, record, data, false);
                    if (_hasExpectedData === false) return false;
                    break;
                case 'RelayLiveResolver':
                case 'RelayResolver':
                    if (this._useExecTimeResolvers) this._readScalar(selection, record, data);
                    else this._readResolverField(selection, record, data);
                    break;
                case 'FragmentSpread':
                    this._createFragmentPointer(selection, record, data);
                    break;
                case 'AliasedInlineFragmentSpread':
                    this._readAliasedInlineFragment(selection, record, data);
                    break;
                case 'ModuleImport':
                    this._readModuleImport(selection, record, data);
                    break;
                case 'InlineDataFragmentSpread':
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case 'Defer':
                case 'ClientExtension':
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData2) return false;
                    break;
                case 'Stream':
                    var _hasExpectedData3 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData3) return false;
                    break;
                case 'ActorChange':
                    this._readActorChange(selection, record, data);
                    break;
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                    if (this._useExecTimeResolvers && (selection.backingField.kind === 'RelayResolver' || selection.backingField.kind === 'RelayLiveResolver')) {
                        var linkedField = selection.linkedField;
                        if (linkedField.plural) this._readPluralLink(linkedField, record, data);
                        else this._readLink(linkedField, record, data);
                    } else this._readClientEdge(selection, record, data);
                    break;
                default:
                    selection;
                    $1etGW(false);
            }
        }
        return true;
    };
    _proto._readClientSideDirectiveField = function _readClientSideDirectiveField(selection, record, data) {
        switch(selection.field.kind){
            case 'ScalarField':
                return this._readScalar(selection.field, record, data);
            case 'LinkedField':
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case 'RelayResolver':
            case 'RelayLiveResolver':
                if (this._useExecTimeResolvers) return this._readScalar(selection.field, record, data);
                else return this._readResolverField(selection.field, record, data);
            case 'ClientEdgeToClientObject':
            case 'ClientEdgeToServerObject':
                if (this._useExecTimeResolvers && (selection.field.backingField.kind === 'RelayResolver' || selection.field.backingField.kind === 'RelayLiveResolver')) {
                    var field = selection.field;
                    if (field.linkedField.plural) return this._readPluralLink(field.linkedField, record, data);
                    else return this._readLink(field.linkedField, record, data);
                } else return this._readClientEdge(selection.field, record, data);
            case 'AliasedInlineFragmentSpread':
                return this._readAliasedInlineFragment(selection.field, record, data);
            default:
                selection.field.kind;
                $1etGW(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _field$alias2;
        var parentRecordID = $2yWF2.getDataID(record);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var result = this._readResolverFieldImpl(field, parentRecordID);
        var fieldName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = result;
        return result;
    };
    _proto._readResolverFieldImpl = function _readResolverFieldImpl(field, parentRecordID) {
        var _this = this;
        var fragment = field.fragment;
        var snapshot;
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                fieldErrors: snapshot.fieldErrors
            };
            snapshot = $757b75661079e4d2$var$read(_this._recordSource, singularReaderSelector, _this._resolverCache);
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                fieldErrors: snapshot.fieldErrors
            };
        };
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __id: parentRecordID,
                    __fragmentOwner: _this._owner,
                    __fragments: (0, $757b75661079e4d2$var$_defineProperty2["default"])({}, fragment.name, fragment.args ? $757b75661079e4d2$var$getArgumentValues(fragment.args, _this._variables) : {})
                };
                if (_this._clientEdgeTraversalPath.length > 0 && _this._clientEdgeTraversalPath[_this._clientEdgeTraversalPath.length - 1] !== null) key[$757b75661079e4d2$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $757b75661079e4d2$var$_toConsumableArray2["default"])(_this._clientEdgeTraversalPath);
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return $757b75661079e4d2$var$withResolverContext(resolverContext, function() {
                    var _getResolverValue = $757b75661079e4d2$var$getResolverValue(field, _this._variables, key, _this._resolverContext), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        resolverResult: resolverResult,
                        snapshot: snapshot,
                        error: resolverError
                    };
                });
            } else {
                var _getResolverValue2 = $757b75661079e4d2$var$getResolverValue(field, _this._variables, null, _this._resolverContext), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    resolverResult: resolverResult,
                    snapshot: undefined,
                    error: _resolverError
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        this._propagateResolverMetadata(field.path, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs);
        return result;
    };
    _proto._propagateResolverMetadata = function _propagateResolverMetadata(fieldPath, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs) {
        var _this2 = this;
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingClientEdges != null) for(var i = 0; i < cachedSnapshot.missingClientEdges.length; i++){
                var missing = cachedSnapshot.missingClientEdges[i];
                this._missingClientEdges.push(missing);
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                for(var _i = 0; _i < cachedSnapshot.missingLiveResolverFields.length; _i++){
                    var missingResolverField = cachedSnapshot.missingLiveResolverFields[_i];
                    this._missingLiveResolverFields.push(missingResolverField);
                }
            }
            if (cachedSnapshot.fieldErrors != null) {
                if (this._fieldErrors == null) this._fieldErrors = [];
                for(var _i2 = 0; _i2 < cachedSnapshot.fieldErrors.length; _i2++){
                    var _this$_selector$node$6;
                    var error = cachedSnapshot.fieldErrors[_i2];
                    if (((_this$_selector$node$6 = this._selector.node.metadata) === null || _this$_selector$node$6 === void 0 ? void 0 : _this$_selector$node$6.throwOnFieldError) === true) this._fieldErrors.push(error);
                    else this._fieldErrors.push($757b75661079e4d2$var$markFieldErrorHasHandled(error));
                }
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        if (resolverError) {
            var _this$_selector$node$7, _this$_selector$node$8;
            var errorEvent = {
                kind: 'relay_resolver.error',
                fieldPath: fieldPath,
                owner: this._fragmentName,
                error: resolverError,
                shouldThrow: (_this$_selector$node$7 = (_this$_selector$node$8 = this._selector.node.metadata) === null || _this$_selector$node$8 === void 0 ? void 0 : _this$_selector$node$8.throwOnFieldError) !== null && _this$_selector$node$7 !== void 0 ? _this$_selector$node$7 : false,
                handled: false,
                uiContext: undefined
            };
            if (this._fieldErrors == null) this._fieldErrors = [
                errorEvent
            ];
            else this._fieldErrors.push(errorEvent);
        }
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push(suspenseID);
        }
        if (updatedDataIDs != null) updatedDataIDs.forEach(function(recordID) {
            _this2._updatedDataIDs.add(recordID);
        });
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _this3 = this;
        var _backingField$alias;
        var backingField = field.backingField;
        !(backingField.kind !== 'ClientExtension') && $1etGW(false);
        var fieldName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        var clientEdgeResolverResponse = backingFieldData[fieldName];
        if (clientEdgeResolverResponse == null || $757b75661079e4d2$var$isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[fieldName] = clientEdgeResolverResponse;
            return clientEdgeResolverResponse;
        }
        if (field.linkedField.plural) {
            !Array.isArray(clientEdgeResolverResponse) && $1etGW(false);
            var storeIDs;
            !(field.kind === 'ClientEdgeToClientObject') && $1etGW(false);
            if (field.backingField.normalizationInfo == null) storeIDs = clientEdgeResolverResponse.map(function(itemResponse) {
                var _field$concreteType;
                var concreteType = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : itemResponse.__typename;
                !(typeof concreteType === 'string') && $1etGW(false);
                var localId = $757b75661079e4d2$var$extractIdFromResponse(itemResponse, backingField.path, _this3._owner.identifier);
                var id = _this3._resolverCache.ensureClientRecord(localId, concreteType);
                var modelResolvers = field.modelResolvers;
                if (modelResolvers != null) {
                    var modelResolver = modelResolvers[concreteType];
                    !(modelResolver !== undefined) && $1etGW(false);
                    var model = _this3._readResolverFieldImpl(modelResolver, id);
                    return model != null ? id : null;
                }
                return id;
            });
            else storeIDs = clientEdgeResolverResponse.map(function(obj) {
                return $757b75661079e4d2$var$extractIdFromResponse(obj, backingField.path, _this3._owner.identifier);
            });
            this._clientEdgeTraversalPath.push(null);
            var edgeValues = this._readLinkedIds(field.linkedField, storeIDs, record, data);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValues;
            return edgeValues;
        } else {
            var _field$concreteType2;
            var id = $757b75661079e4d2$var$extractIdFromResponse(clientEdgeResolverResponse, backingField.path, this._owner.identifier);
            var storeID;
            var concreteType = (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : clientEdgeResolverResponse.__typename;
            var traversalPathSegment;
            if (field.kind === 'ClientEdgeToClientObject') {
                if (field.backingField.normalizationInfo == null) {
                    !(typeof concreteType === 'string') && $1etGW(false);
                    storeID = this._resolverCache.ensureClientRecord(id, concreteType);
                    traversalPathSegment = null;
                } else {
                    storeID = id;
                    traversalPathSegment = null;
                }
            } else {
                storeID = id;
                traversalPathSegment = {
                    readerClientEdge: field,
                    clientEdgeDestinationID: id
                };
            }
            var modelResolvers = field.modelResolvers;
            if (modelResolvers != null) {
                !(typeof concreteType === 'string') && $1etGW(false);
                var modelResolver = modelResolvers[concreteType];
                !(modelResolver !== undefined) && $1etGW(false);
                var model = this._readResolverFieldImpl(modelResolver, storeID);
                if (model == null) {
                    data[fieldName] = null;
                    return null;
                }
            }
            this._clientEdgeTraversalPath.push(traversalPathSegment);
            var prevData = data[fieldName];
            !(prevData == null || typeof prevData === 'object') && $1etGW(false);
            var prevErrors = this._fieldErrors;
            this._fieldErrors = null;
            var edgeValue = this._traverse(field.linkedField, storeID, prevData);
            this._prependPreviousErrors(prevErrors, fieldName);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValue;
            return edgeValue;
        }
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var fieldName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = $757b75661079e4d2$var$getStorageKey(field, this._variables);
        var value = $2yWF2.getValue(record, storageKey);
        if (value === null || $1K5RO.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(value) && value.length === 0) this._maybeAddFieldErrors(record, storageKey);
        else if (value === undefined) this._markDataAsMissing(fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var fieldName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = $757b75661079e4d2$var$getStorageKey(field, this._variables);
        var linkedID = $2yWF2.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[fieldName] = linkedID;
            if (linkedID === null) this._maybeAddFieldErrors(record, storageKey);
            else if (linkedID === undefined) this._markDataAsMissing(fieldName);
            return linkedID;
        }
        var prevData = data[fieldName];
        !(prevData == null || typeof prevData === 'object') && $1etGW(false);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var value = this._traverse(field, linkedID, prevData);
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._prependPreviousErrors = function _prependPreviousErrors(prevErrors, fieldNameOrIndex) {
        if (this._fieldErrors != null) {
            for(var i = 0; i < this._fieldErrors.length; i++){
                var event = this._fieldErrors[i];
                if (event.owner === this._fragmentName && (event.kind === 'missing_expected_data.throw' || event.kind === 'missing_expected_data.log' || event.kind === 'missing_required_field.throw' || event.kind === 'missing_required_field.log')) event.fieldPath = "".concat(fieldNameOrIndex, ".").concat(event.fieldPath);
            }
            if (prevErrors != null) {
                for(var _i3 = this._fieldErrors.length - 1; _i3 >= 0; _i3--)prevErrors.push(this._fieldErrors[_i3]);
                this._fieldErrors = prevErrors;
            }
        } else this._fieldErrors = prevErrors;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var fieldName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = $757b75661079e4d2$var$getStorageKey(field, this._variables);
        var externalRef = $2yWF2.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[fieldName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing(fieldName);
            else if (externalRef === null) this._maybeAddFieldErrors(record, storageKey);
            return data[fieldName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, $2yWF2.fromObject({
            __id: dataID
        }), fragmentRef);
        data[fieldName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[fieldName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = $757b75661079e4d2$var$getStorageKey(field, this._variables);
        var linkedIDs = $2yWF2.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs === null || $1K5RO.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(linkedIDs) && linkedIDs.length === 0) this._maybeAddFieldErrors(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this4 = this;
        var _field$alias6;
        var fieldName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[fieldName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing(fieldName);
            return linkedIDs;
        }
        var prevData = data[fieldName];
        !(prevData == null || Array.isArray(prevData)) && $1etGW(false);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this4._markDataAsMissing(String(nextIndex));
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || typeof prevItem === 'object') && $1etGW(false);
            var prevErrors = _this4._fieldErrors;
            _this4._fieldErrors = null;
            linkedArray[nextIndex] = _this4._traverse(field, linkedID, prevItem);
            _this4._prependPreviousErrors(prevErrors, nextIndex);
        });
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = linkedArray;
        return linkedArray;
    };
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        var componentKey = $757b75661079e4d2$var$getModuleComponentKey(moduleImport.documentName);
        var relayStoreComponent = $2yWF2.getValue(record, componentKey);
        var component = relayStoreComponent !== undefined ? relayStoreComponent : moduleImport.componentModuleProvider;
        if (component == null) {
            if (component === undefined) this._markDataAsMissing('<module-import>');
            return;
        }
        this._createFragmentPointer({
            kind: 'FragmentSpread',
            name: moduleImport.fragmentName,
            args: moduleImport.args
        }, record, data);
        data[$757b75661079e4d2$var$FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[$757b75661079e4d2$var$MODULE_COMPONENT_KEY] = component;
    };
    _proto._readAliasedInlineFragment = function _readAliasedInlineFragment(aliasedInlineFragment, record, data) {
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var fieldValue = this._readInlineFragment(aliasedInlineFragment.fragment, record, {}, true);
        this._prependPreviousErrors(prevErrors, aliasedInlineFragment.name);
        if (fieldValue === false) fieldValue = null;
        data[aliasedInlineFragment.name] = fieldValue;
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data, skipUnmatchedAbstractTypes) {
        if (inlineFragment.type == null) {
            var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
            if (hasExpectedData === false) return false;
            return data;
        }
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            if (!this._recordMatchesTypeCondition(record, inlineFragment.type)) return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false && skipUnmatchedAbstractTypes) return null;
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            var hasMissingData = this._traverseSelections(inlineFragment.selections, record, data);
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                this._isMissingData = parentIsMissingData;
                return null;
            } else if (implementsInterface == null) return undefined;
            else if (hasMissingData === false) return false;
        }
        return data;
    };
    _proto._recordMatchesTypeCondition = function _recordMatchesTypeCondition(record, type) {
        var typeName = $2yWF2.getType(record);
        return typeName != null && typeName === type || $2yWF2.getDataID(record) === $757b75661079e4d2$var$ROOT_ID;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[$757b75661079e4d2$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$757b75661079e4d2$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $1etGW(false);
        if (data[$757b75661079e4d2$var$ID_KEY] == null) data[$757b75661079e4d2$var$ID_KEY] = $2yWF2.getDataID(record);
        fragmentPointers[fragmentSpread.name] = $757b75661079e4d2$var$getArgumentValues(fragmentSpread.args, this._variables, this._isWithinUnmatchedTypeRefinement);
        data[$757b75661079e4d2$var$FRAGMENT_OWNER_KEY] = this._owner;
        if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[$757b75661079e4d2$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $757b75661079e4d2$var$_toConsumableArray2["default"])(this._clientEdgeTraversalPath);
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[$757b75661079e4d2$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$757b75661079e4d2$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $1etGW(false);
        if (data[$757b75661079e4d2$var$ID_KEY] == null) data[$757b75661079e4d2$var$ID_KEY] = $2yWF2.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        var argumentVariables = fragmentSpreadOrFragment.args ? $757b75661079e4d2$var$getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = $8g71t.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = $2yWF2.getType(record);
        var typeRecord = this._recordSource.get($757b75661079e4d2$var$generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? $2yWF2.getValue(typeRecord, abstractKey) : null;
        if (implementsInterface == null) this._markDataAsMissing('<abstract-type-hint>');
        return implementsInterface;
    };
    return RelayReader;
}();
function $757b75661079e4d2$var$markFieldErrorHasHandled(event) {
    switch(event.kind){
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
        case 'relay_field_payload.error':
        case 'relay_resolver.error':
            return (0, $757b75661079e4d2$var$_objectSpread2["default"])((0, $757b75661079e4d2$var$_objectSpread2["default"])({}, event), {}, {
                handled: true
            });
        case 'missing_expected_data.log':
        case 'missing_required_field.log':
            return event;
        default:
            event.kind;
            $1etGW(false);
    }
}
function $757b75661079e4d2$var$getResolverValue(field, variables, fragmentKey, resolverContext) {
    var resolverFunction = typeof field.resolverModule === 'function' ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? $757b75661079e4d2$var$getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverFunctionArgs.push(resolverContext);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        resolverResult = null;
        if (e !== $757b75661079e4d2$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL) resolverError = e;
    }
    return [
        resolverResult,
        resolverError
    ];
}
function $757b75661079e4d2$var$extractIdFromResponse(individualResponse, path, owner) {
    if (typeof individualResponse === 'string') return individualResponse;
    else if (typeof individualResponse === 'object' && individualResponse != null && typeof individualResponse.id === 'string') return individualResponse.id;
    $1etGW(false);
}
module.exports = {
    read: $757b75661079e4d2$var$read
};

});
parcelRegister("4Tlxm", function(module, exports) {
'use strict';

var $gSH3f = parcelRequire("gSH3f");
var $38fd014dd65c3f50$var$RELAY_LIVE_RESOLVER = $gSH3f.RELAY_LIVE_RESOLVER;

var $1etGW = parcelRequire("1etGW");
var $38fd014dd65c3f50$var$NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== $38fd014dd65c3f50$var$RELAY_LIVE_RESOLVER) && $1etGW(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        $1etGW(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
module.exports = {
    NoopResolverCache: $38fd014dd65c3f50$var$NoopResolverCache
};

});


parcelRegister("20C77", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $1769257b0d923a7c$var$_interopRequireDefault = $9Ew61.default;

var $1769257b0d923a7c$var$_createForOfIteratorHelper2 = $1769257b0d923a7c$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $12eIF = parcelRequire("12eIF");

var $6aM8d = parcelRequire("6aM8d");

var $bBQRk = parcelRequire("bBQRk");

var $8g71t = parcelRequire("8g71t");
var $1769257b0d923a7c$var$getLocalVariables = $8g71t.getLocalVariables;

var $2yWF2 = parcelRequire("2yWF2");

var $3axLc = parcelRequire("3axLc");

var $hRGwE = parcelRequire("hRGwE");
var $1769257b0d923a7c$var$generateTypeID = $hRGwE.generateTypeID;

var $1etGW = parcelRequire("1etGW");
var $1769257b0d923a7c$var$getReadTimeResolverStorageKey = $3axLc.getReadTimeResolverStorageKey, $1769257b0d923a7c$var$getStorageKey = $3axLc.getStorageKey, $1769257b0d923a7c$var$getModuleOperationKey = $3axLc.getModuleOperationKey;
function $1769257b0d923a7c$var$mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new $1769257b0d923a7c$var$RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers);
    marker.mark(node, dataID);
}
var $1769257b0d923a7c$var$RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._useExecTimeResolvers = useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === 'Operation' || node.kind === 'SplitOperation') this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $1etGW(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ActorChange':
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case 'InlineFragment':
                    if (selection.abstractKey == null) {
                        var typeName = $2yWF2.getType(record);
                        if (typeName != null && typeName === selection.type || typeName === $3axLc.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = $2yWF2.getType(record);
                        var typeID = $1769257b0d923a7c$var$generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this._variables;
                    _this._variables = $1769257b0d923a7c$var$getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case 'LinkedHandle':
                    var handleField = $6aM8d(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case 'Defer':
                case 'Stream':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ScalarField':
                case 'ScalarHandle':
                    break;
                case 'TypeDiscriminator':
                    var _typeName2 = $2yWF2.getType(record);
                    var _typeID = $1769257b0d923a7c$var$generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case 'ModuleImport':
                    _this._traverseModuleImport(selection, record);
                    break;
                case 'ClientExtension':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ClientComponent':
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    _this._traverseResolverField(selection, record);
                    break;
                case 'ClientEdgeToClientObject':
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    $1etGW(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        if (this._useExecTimeResolvers) {
            this._traverseLink(field.linkedField, record);
            return;
        }
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        if (field.backingField.isOutputType) {
            var outputTypeRecordIDs = $bBQRk(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, $1769257b0d923a7c$var$_createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var linkedField = field.linkedField;
            var concreteType = linkedField.concreteType;
            if (concreteType == null) return;
            if (linkedField.plural) {
                var dataIDs = $2yWF2.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, $1769257b0d923a7c$var$_createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = $2yWF2.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        if (this._useExecTimeResolvers) return;
        var storageKey = $1769257b0d923a7c$var$getReadTimeResolverStorageKey(field, this._variables);
        var dataID = $2yWF2.getLinkedRecordID(record, storageKey);
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $1etGW(false);
        var operationKey = $1769257b0d923a7c$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = $2yWF2.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $12eIF(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $1769257b0d923a7c$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = $1769257b0d923a7c$var$getStorageKey(field, this._variables);
        var linkedID = $2yWF2.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = $1769257b0d923a7c$var$getStorageKey(field, this._variables);
        var linkedIDs = $2yWF2.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: $1769257b0d923a7c$var$mark
};

});

parcelRegister("jZ0c2", function(module, exports) {
'use strict';
parcelRequire("u9izA");

var $7g2Xq = parcelRequire("7g2Xq");

var $1K5RO = parcelRequire("1K5RO");

var $9k0vm = parcelRequire("9k0vm");

var $904pv = parcelRequire("904pv");

var $a5m1P = parcelRequire("a5m1P");
var $e8c3dd2cf20e5138$var$RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache, resolverContext) {
        this._subscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
        this._resolverContext = resolverContext;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = $a5m1P.read(source, snapshot.selector, _this2._resolverCache, _this2._resolverContext);
            var nextData = $7g2Xq(snapshot.data, backup.data);
            backup.data = nextData;
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) subscription.stale = true;
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector,
                    fieldErrors: backup.fieldErrors
                };
            } else subscription.stale = true;
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this3 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this3._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    };
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && $9k0vm(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? $a5m1P.read(source, snapshot.selector, this._resolverCache, this._resolverContext) : backup;
        var nextData = $7g2Xq(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector,
            fieldErrors: nextSnapshot.fieldErrors
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && $1K5RO.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: 'store.notify.subscription',
                sourceOperation: sourceOperation,
                snapshot: snapshot,
                nextSnapshot: nextSnapshot
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
        if ($1K5RO.ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION && (stale || $904pv(snapshot.seenRecords, updatedRecordIDs))) return snapshot.selector.owner;
    };
    _proto.size = function size() {
        return this._subscriptions.size;
    };
    return RelayStoreSubscriptions;
}();
module.exports = $e8c3dd2cf20e5138$var$RelayStoreSubscriptions;

});
parcelRegister("9k0vm", function(module, exports) {
'use strict';
var $6c965f8ee5470dfa$var$ITERATOR_KEY = Symbol.iterator;
function $6c965f8ee5470dfa$var$hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$6c965f8ee5470dfa$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $6c965f8ee5470dfa$var$hasOverlappingIDs;

});

parcelRegister("904pv", function(module, exports) {
'use strict';

var $3axLc = parcelRequire("3axLc");
var $68d788f459beb9f0$var$ROOT_ID = $3axLc.ROOT_ID;

var $qW3rR = parcelRequire("qW3rR");
var $68d788f459beb9f0$var$VIEWER_ID = $qW3rR.VIEWER_ID;
var $68d788f459beb9f0$var$ITERATOR_KEY = Symbol.iterator;
function $68d788f459beb9f0$var$hasSignificantOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$68d788f459beb9f0$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key) && key !== $68d788f459beb9f0$var$ROOT_ID && key !== $68d788f459beb9f0$var$VIEWER_ID) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $68d788f459beb9f0$var$hasSignificantOverlappingIDs;

});



parcelRegister("fnDZb", function(module, exports) {
'use strict';
var $b3280557043dcb6d$var$_global$ErrorUtils$ap, $b3280557043dcb6d$var$_global$ErrorUtils;

var $j77Hl = parcelRequire("j77Hl");

var $dWSDq = parcelRequire("dWSDq");

var $bZFmn = parcelRequire("bZFmn");

var $1K5RO = parcelRequire("1K5RO");

var $a5m1P = parcelRequire("a5m1P");

var $kyCh1 = parcelRequire("kyCh1");

var $1etGW = parcelRequire("1etGW");
parcelRequire("4j8bN");
var $b3280557043dcb6d$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
var $b3280557043dcb6d$var$applyWithGuard = ($b3280557043dcb6d$var$_global$ErrorUtils$ap = $b3280557043dcb6d$var$_global === null || $b3280557043dcb6d$var$_global === void 0 ? void 0 : ($b3280557043dcb6d$var$_global$ErrorUtils = $b3280557043dcb6d$var$_global.ErrorUtils) === null || $b3280557043dcb6d$var$_global$ErrorUtils === void 0 ? void 0 : $b3280557043dcb6d$var$_global$ErrorUtils.applyWithGuard) !== null && $b3280557043dcb6d$var$_global$ErrorUtils$ap !== void 0 ? $b3280557043dcb6d$var$_global$ErrorUtils$ap : function(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
var $b3280557043dcb6d$var$RelayPublishQueue = /*#__PURE__*/ function() {
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers, log) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
        this._log = log;
    }
    var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && $1etGW(false);
        this._pendingOptimisticUpdates.add(updater);
    };
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    };
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    };
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'payload',
            operation: operation,
            payload: payload,
            updater: updater
        });
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'updater',
            updater: updater
        });
    };
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'source',
            source: source
        });
    };
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        $1K5RO.DISALLOW_NESTED_UPDATES && !(this._isRunning !== true) && $1etGW(false);
        this._isRunning = true;
        if (runIsANoop) {
            this._isRunning = false;
            return [];
        }
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        this._isRunning = false;
        return this._store.notify(sourceOperation, invalidatedStore);
    };
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new $j77Hl(this._store.getSource(), source);
        var recordSourceProxy = new $dWSDq(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers, this._log);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $1etGW(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && $1etGW(false);
            var recordSourceSelectorProxy = new $bZFmn(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = $b3280557043dcb6d$var$lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    };
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === 'payload') {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === 'source') {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = $kyCh1.create();
                var mutator = new $j77Hl(_this2._store.getSource(), sink);
                var recordSourceProxy = new $dWSDq(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers, _this2._log);
                $b3280557043dcb6d$var$applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:commitData');
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    };
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = $kyCh1.create();
        var mutator = new $j77Hl(this._store.getSource(), sink);
        var recordSourceProxy = new $dWSDq(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers, this._log);
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                $b3280557043dcb6d$var$applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:applyUpdates');
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = $b3280557043dcb6d$var$lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new $bZFmn(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    $b3280557043dcb6d$var$applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, 'RelayPublishQueue:applyUpdates');
                }
            }
        };
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function $b3280557043dcb6d$var$lookupSelector(source, selector) {
    var selectorData = $a5m1P.read(source, selector).data;
    var deepFreeze;
    return selectorData;
}
module.exports = $b3280557043dcb6d$var$RelayPublishQueue;

});
parcelRegister("bZFmn", function(module, exports) {
'use strict';

var $3axLc = parcelRequire("3axLc");
var $8bb57974636d8403$var$ROOT_TYPE = $3axLc.ROOT_TYPE, $8bb57974636d8403$var$getStorageKey = $3axLc.getStorageKey;

var $18vKq = parcelRequire("18vKq");
var $8bb57974636d8403$var$_readUpdatableFragment = $18vKq.readUpdatableFragment;

var $dliWH = parcelRequire("dliWH");
var $8bb57974636d8403$var$_readUpdatableQuery = $dliWH.readUpdatableQuery;

var $1etGW = parcelRequire("1etGW");
var $8bb57974636d8403$var$RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, $8bb57974636d8403$var$ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === 'LinkedField' && selection.name === fieldName || selection.kind === 'RequiredField' && selection.field.name === fieldName;
        });
        if (field && field.kind === 'RequiredField') field = field.field;
        !(field && field.kind === 'LinkedField') && $1etGW(false);
        !(field.plural === plural) && $1etGW(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = $8bb57974636d8403$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = $8bb57974636d8403$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $8bb57974636d8403$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $8bb57974636d8403$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
module.exports = $8bb57974636d8403$var$RelayRecordSourceSelectorProxy;

});



parcelRegister("z7Nhe", function(module, exports) {
'use strict';

var $dPcgp = parcelRequire("dPcgp");

var $iEOHk = parcelRequire("iEOHk");
var $069950aed42a27ff$var$getRequest = $iEOHk.getRequest;

var $3pXrs = parcelRequire("3pXrs");
var $069950aed42a27ff$var$createOperationDescriptor = $3pXrs.createOperationDescriptor;

var $5AfVC = parcelRequire("5AfVC");
var $069950aed42a27ff$var$createReaderSelector = $5AfVC.createReaderSelector;
parcelRequire("4j8bN");
function $069950aed42a27ff$var$requestSubscription(environment, config) {
    var subscription = $069950aed42a27ff$var$getRequest(config.subscription);
    if (subscription.params.operationKind !== 'subscription') throw new Error('requestSubscription: Must use Subscription operation');
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = $069950aed42a27ff$var$createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? $dPcgp.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === 'string') selector = $069950aed42a27ff$var$createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                onNext(data);
            }
        },
        error: onError,
        complete: onCompleted
    });
    return {
        dispose: sub.unsubscribe
    };
}
module.exports = $069950aed42a27ff$var$requestSubscription;

});

parcelRegister("c8rrR", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $8d5b860aa3902cca$var$_interopRequireDefault = $9Ew61.default;

var $8d5b860aa3902cca$var$_objectSpread2 = $8d5b860aa3902cca$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $3axLc = parcelRequire("3axLc");
var $8d5b860aa3902cca$var$getModuleComponentKey = $3axLc.getModuleComponentKey, $8d5b860aa3902cca$var$getModuleOperationKey = $3axLc.getModuleOperationKey;
function $8d5b860aa3902cca$var$createPayloadFor3DField(name, operation, component, response) {
    var data = (0, $8d5b860aa3902cca$var$_objectSpread2["default"])({}, response);
    data[$8d5b860aa3902cca$var$getModuleComponentKey(name)] = component;
    data[$8d5b860aa3902cca$var$getModuleOperationKey(name)] = operation;
    return data;
}
module.exports = $8d5b860aa3902cca$var$createPayloadFor3DField;

});

parcelRegister("6N0I9", function(module, exports) {
'use strict';

var $5AfVC = parcelRequire("5AfVC");
var $0146941c9021528d$var$getDataIDsFromFragment = $5AfVC.getDataIDsFromFragment, $0146941c9021528d$var$getSelector = $5AfVC.getSelector, $0146941c9021528d$var$getVariablesFromFragment = $5AfVC.getVariablesFromFragment;

var $ahjs5 = parcelRequire("ahjs5");

var $1K5RO = parcelRequire("1K5RO");

var $fAAFv = parcelRequire("fAAFv");
var $0146941c9021528d$var$stableCopy = $fAAFv.stableCopy;

var $cD1hi = parcelRequire("cD1hi");
var $0146941c9021528d$var$intern = $cD1hi.intern;
function $0146941c9021528d$var$getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = $0146941c9021528d$var$getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? 'null' : selector.kind === 'SingularReaderSelector' ? selector.owner.identifier : '[' + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(',') + ']';
    var fragmentVariables = $0146941c9021528d$var$getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = $0146941c9021528d$var$getDataIDsFromFragment(fragmentNode, fragmentRef);
    if ($1K5RO.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === 'undefined' ? 'missing' : dataIDs == null ? 'null' : Array.isArray(dataIDs) ? '[' + dataIDs.join(',') + ']' : dataIDs;
        ids = $1K5RO.STRING_INTERN_LEVEL <= 1 ? ids : $0146941c9021528d$var$intern(ids, $1K5RO.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + (fragmentVariables == null || $ahjs5(fragmentVariables) ? '{}' : JSON.stringify($0146941c9021528d$var$stableCopy(fragmentVariables))) + '/' + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'missing';
        _ids = $1K5RO.STRING_INTERN_LEVEL <= 1 ? _ids : $0146941c9021528d$var$intern(_ids, $1K5RO.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + JSON.stringify($0146941c9021528d$var$stableCopy(fragmentVariables)) + '/' + _ids;
    }
}
module.exports = $0146941c9021528d$var$getFragmentIdentifier;

});
parcelRegister("ahjs5", function(module, exports) {
'use strict';
var $01ee5d3c977a3ee8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $01ee5d3c977a3ee8$var$isEmptyObject(obj) {
    for(var _key in obj){
        if ($01ee5d3c977a3ee8$var$hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
module.exports = $01ee5d3c977a3ee8$var$isEmptyObject;

});


parcelRegister("0CevU", function(module, exports) {
'use strict';

var $j7ILL = parcelRequire("j7ILL");

var $1etGW = parcelRequire("1etGW");
function $001da87f4c47503f$var$getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = $j7ILL(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && $1etGW(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && $1etGW(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    !((identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) == null || typeof identifierInfo.identifierField === 'string') && $1etGW(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
module.exports = $001da87f4c47503f$var$getPaginationMetadata;

});
parcelRegister("j7ILL", function(module, exports) {
'use strict';

var $1etGW = parcelRequire("1etGW");
function $dec1660ed258d2c1$var$getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && $1etGW(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && $1etGW(false);
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== 'string') && $1etGW(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    if (identifierInfo != null) {
        !(identifierInfo.identifierField == null || typeof identifierInfo.identifierField === 'string') && $1etGW(false);
        !(identifierInfo.identifierQueryVariableName == null || typeof identifierInfo.identifierQueryVariableName === 'string') && $1etGW(false);
    }
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierInfo: identifierInfo,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
module.exports = $dec1660ed258d2c1$var$getRefetchMetadata;

});


parcelRegister("kXuaj", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $f420b78d2df23b51$var$_interopRequireDefault = $9Ew61.default;

var $f420b78d2df23b51$var$_defineProperty2 = $f420b78d2df23b51$var$_interopRequireDefault((parcelRequire("2bxFr")));

var $f420b78d2df23b51$var$_objectSpread4 = $f420b78d2df23b51$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $1etGW = parcelRequire("1etGW");
parcelRequire("4j8bN");
function $f420b78d2df23b51$var$getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === 'backward') {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && $1etGW(false);
        var _paginationVariables = (0, $f420b78d2df23b51$var$_objectSpread4["default"])((0, $f420b78d2df23b51$var$_objectSpread4["default"])((0, $f420b78d2df23b51$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, $f420b78d2df23b51$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, $f420b78d2df23b51$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && $1etGW(false);
    var paginationVariables = (0, $f420b78d2df23b51$var$_objectSpread4["default"])((0, $f420b78d2df23b51$var$_objectSpread4["default"])((0, $f420b78d2df23b51$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, $f420b78d2df23b51$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, $f420b78d2df23b51$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
module.exports = $f420b78d2df23b51$var$getPaginationVariables;

});

parcelRegister("hE0vQ", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $cd8691e3bbb143a7$var$_interopRequireDefault = $9Ew61.default;

var $cd8691e3bbb143a7$var$_createForOfIteratorHelper2 = $cd8691e3bbb143a7$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $1etGW = parcelRequire("1etGW");
function $cd8691e3bbb143a7$var$getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, $cd8691e3bbb143a7$var$_createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === 'number') {
                !Array.isArray(result) && $1etGW(false);
                result = result[key];
            } else {
                !(typeof result === 'object' && !Array.isArray(result)) && $1etGW(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
module.exports = $cd8691e3bbb143a7$var$getValueAtPath;

});

parcelRegister("gGE2x", function(module, exports) {
'use strict';
var $c25fa0a848f9df03$var$profileHandlersByName = {};
var $c25fa0a848f9df03$var$defaultProfiler = {
    stop: function stop() {}
};
var $c25fa0a848f9df03$var$RelayProfiler = {
    profile: function profile(name, state) {
        var handlers = $c25fa0a848f9df03$var$profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return $c25fa0a848f9df03$var$defaultProfiler;
    },
    attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!$c25fa0a848f9df03$var$profileHandlersByName.hasOwnProperty(name)) $c25fa0a848f9df03$var$profileHandlersByName[name] = [];
        $c25fa0a848f9df03$var$profileHandlersByName[name].push(handler);
    },
    detachProfileHandler: function detachProfileHandler(name, handler) {
        if ($c25fa0a848f9df03$var$profileHandlersByName.hasOwnProperty(name)) $c25fa0a848f9df03$var$removeFromArray($c25fa0a848f9df03$var$profileHandlersByName[name], handler);
    }
};
function $c25fa0a848f9df03$var$removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
module.exports = $c25fa0a848f9df03$var$RelayProfiler;

});




parcelRegister("9kbnH", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $6c9ecf68df0578ad$var$_interopRequireDefault = $9Ew61.default;

var $6c9ecf68df0578ad$var$_extends2 = $6c9ecf68df0578ad$var$_interopRequireDefault((parcelRequire("ghPm5")));

var $6c9ecf68df0578ad$var$_objectWithoutPropertiesLoose2 = $6c9ecf68df0578ad$var$_interopRequireDefault((parcelRequire("1lgQy")));

var $6c9ecf68df0578ad$var$_assertThisInitialized2 = $6c9ecf68df0578ad$var$_interopRequireDefault((parcelRequire("aKZ6h")));

var $6c9ecf68df0578ad$var$_inheritsLoose2 = $6c9ecf68df0578ad$var$_interopRequireDefault((parcelRequire("byPLZ")));

var $6c9ecf68df0578ad$var$_defineProperty2 = $6c9ecf68df0578ad$var$_interopRequireDefault((parcelRequire("2bxFr")));
var $6c9ecf68df0578ad$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $6KBaH = parcelRequire("6KBaH");

var $brhnK = parcelRequire("brhnK");
var $6c9ecf68df0578ad$var$getContainerName = $brhnK.getContainerName;

var $arhra = parcelRequire("arhra");
var $6c9ecf68df0578ad$var$assertRelayContext = $arhra.assertRelayContext;

var $4MrjW = parcelRequire("4MrjW");

var $2hRE7 = parcelRequire("2hRE7");

var $5ohfX = parcelRequire("5ohfX");
var $6c9ecf68df0578ad$var$createFragmentSpecResolver = $5ohfX.createFragmentSpecResolver, $6c9ecf68df0578ad$var$getDataIDsFromObject = $5ohfX.getDataIDsFromObject, $6c9ecf68df0578ad$var$isScalarAndEqual = $5ohfX.isScalarAndEqual;
function $6c9ecf68df0578ad$var$createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = $6c9ecf68df0578ad$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $6c9ecf68df0578ad$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $6c9ecf68df0578ad$var$_defineProperty2["default"])((0, $6c9ecf68df0578ad$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve(),
                        relayProp: $6c9ecf68df0578ad$var$getRelayProp(updatedState.relayProp.environment)
                    } : null;
                });
            });
            var relayContext = $6c9ecf68df0578ad$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            var resolver = $6c9ecf68df0578ad$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: $6c9ecf68df0578ad$var$getRelayProp(relayContext.environment),
                resolver: resolver
            };
            return _this;
        }
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $6c9ecf68df0578ad$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $6c9ecf68df0578ad$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $6c9ecf68df0578ad$var$getDataIDsFromObject(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$4MrjW(prevIDs, nextIDs)) {
                resolver = $6c9ecf68df0578ad$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    prevPropsContext: relayContext,
                    prevProps: nextProps,
                    relayProp: $6c9ecf68df0578ad$var$getRelayProp(relayContext.environment),
                    resolver: resolver
                };
            } else {
                resolver.setProps(nextProps);
                var data = resolver.resolve();
                if (data !== prevState.data) return {
                    data: data,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: $6c9ecf68df0578ad$var$getRelayProp(relayContext.environment)
                };
            }
            return null;
        };
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.state.resolver.dispose();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$6c9ecf68df0578ad$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $6c9ecf68df0578ad$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $6c9ecf68df0578ad$var$_excluded);
            return /*#__PURE__*/ $2hRE7.createElement(Component, (0, $6c9ecf68df0578ad$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            }));
        };
        return _class;
    }($2hRE7.Component), (0, $6c9ecf68df0578ad$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $6c9ecf68df0578ad$var$getRelayProp(environment) {
    return {
        environment: environment
    };
}
function $6c9ecf68df0578ad$var$createContainer(Component, fragmentSpec) {
    return $6KBaH(Component, fragmentSpec, $6c9ecf68df0578ad$var$createContainerWithFragments);
}
module.exports = {
    createContainer: $6c9ecf68df0578ad$var$createContainer
};

});
parcelRegister("ghPm5", function(module, exports) {
function $bdb611f2bb29c783$var$_extends() {
    return module.exports = $bdb611f2bb29c783$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $bdb611f2bb29c783$var$_extends.apply(null, arguments);
}
module.exports = $bdb611f2bb29c783$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aKZ6h", function(module, exports) {
function $7d4d987dc913d6fc$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $7d4d987dc913d6fc$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("byPLZ", function(module, exports) {

var $epdrm = parcelRequire("epdrm");
function $86ab07baaf79e871$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $epdrm(t, o);
}
module.exports = $86ab07baaf79e871$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("epdrm", function(module, exports) {
function $a7cdd3723d5c5a9c$var$_setPrototypeOf(t, e) {
    return module.exports = $a7cdd3723d5c5a9c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a7cdd3723d5c5a9c$var$_setPrototypeOf(t, e);
}
module.exports = $a7cdd3723d5c5a9c$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6KBaH", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $4ea3df6fad576c50$var$_interopRequireDefault = $9Ew61.default;

var $4ea3df6fad576c50$var$_extends2 = $4ea3df6fad576c50$var$_interopRequireDefault((parcelRequire("ghPm5")));

var $gBfu9 = parcelRequire("gBfu9");

var $brhnK = parcelRequire("brhnK");
var $4ea3df6fad576c50$var$getComponentName = $brhnK.getComponentName, $4ea3df6fad576c50$var$getContainerName = $brhnK.getContainerName;

var $b2BSK = parcelRequire("b2BSK");

var $ayZNC = parcelRequire("ayZNC");

var $1etGW = parcelRequire("1etGW");

var $2hRE7 = parcelRequire("2hRE7");

var $5ohfX = parcelRequire("5ohfX");
var $4ea3df6fad576c50$var$getFragment = $5ohfX.getFragment;
var $4ea3df6fad576c50$var$useContext = $2hRE7.useContext;
function $4ea3df6fad576c50$var$buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    var containerName = $4ea3df6fad576c50$var$getContainerName(ComponentClass);
    $gBfu9($4ea3df6fad576c50$var$getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for(var key in fragmentSpec)fragments[key] = $4ea3df6fad576c50$var$getFragment(fragmentSpec[key]);
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function ForwardRef(props, ref) {
        var _queryRendererContext;
        var context = $4ea3df6fad576c50$var$useContext($b2BSK);
        !(context != null) && $1etGW(false);
        var queryRendererContext = $4ea3df6fad576c50$var$useContext($ayZNC);
        return /*#__PURE__*/ $2hRE7.createElement(Container, (0, $4ea3df6fad576c50$var$_extends2["default"])({}, props, {
            __relayContext: context,
            __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
            componentRef: props.componentRef || ref
        }));
    }
    ForwardRef.displayName = containerName;
    var ForwardContainer = $2hRE7.forwardRef(ForwardRef);
    return ForwardContainer;
}
module.exports = $4ea3df6fad576c50$var$buildReactRelayContainer;

});
parcelRegister("gBfu9", function(module, exports) {
'use strict';

var $1etGW = parcelRequire("1etGW");
function $c15c1d1b35b8cdf9$var$assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && typeof fragmentSpec === 'object') && $1etGW(false);
    for(var key in fragmentSpec)if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && (typeof fragment === 'object' || typeof fragment === 'function')) && $1etGW(false);
    }
}
module.exports = $c15c1d1b35b8cdf9$var$assertFragmentMap;

});

parcelRegister("brhnK", function(module, exports) {
'use strict';
function $853fb30defa362cf$var$getComponentName(component) {
    return component.displayName || component.name || 'Component';
}
function $853fb30defa362cf$var$getContainerName(Component) {
    return 'Relay(' + $853fb30defa362cf$var$getComponentName(Component) + ')';
}
module.exports = {
    getComponentName: $853fb30defa362cf$var$getComponentName,
    getContainerName: $853fb30defa362cf$var$getContainerName
};

});

parcelRegister("ayZNC", function(module, exports) {
'use strict';

var $2hRE7 = parcelRequire("2hRE7");
module.exports = $2hRE7.createContext({
    rootIsQueryRenderer: false
});

});


parcelRegister("arhra", function(module, exports) {
'use strict';

var $1C6Iw = parcelRequire("1C6Iw");

var $1etGW = parcelRequire("1etGW");
function $7999f3ae444c27a0$var$assertRelayContext(relay) {
    !$7999f3ae444c27a0$var$isRelayContext(relay) && $1etGW(false);
    return relay;
}
function $7999f3ae444c27a0$var$isRelayContext(context) {
    return typeof context === 'object' && context !== null && !Array.isArray(context) && $1C6Iw(context.environment);
}
module.exports = {
    assertRelayContext: $7999f3ae444c27a0$var$assertRelayContext,
    isRelayContext: $7999f3ae444c27a0$var$isRelayContext
};

});
parcelRegister("1C6Iw", function(module, exports) {
'use strict';
function $12ce8cf455ace98c$var$isRelayEnvironment(environment) {
    return typeof environment === 'object' && environment !== null && typeof environment.check === 'function' && typeof environment.lookup === 'function' && typeof environment.retain === 'function' && typeof environment.execute === 'function' && typeof environment.subscribe === 'function';
}
module.exports = $12ce8cf455ace98c$var$isRelayEnvironment;

});



parcelRegister("aH9Fg", function(module, exports) {
'use strict';

var $b2BSK = parcelRequire("b2BSK");

var $ayZNC = parcelRequire("ayZNC");

var $4MrjW = parcelRequire("4MrjW");

var $2hRE7 = parcelRequire("2hRE7");

var $5ohfX = parcelRequire("5ohfX");
var $7c956ab6709b65e7$var$createOperationDescriptor = $5ohfX.createOperationDescriptor, $7c956ab6709b65e7$var$deepFreeze = $5ohfX.deepFreeze, $7c956ab6709b65e7$var$getRequest = $5ohfX.getRequest;
var $7c956ab6709b65e7$var$useLayoutEffect = $2hRE7.useLayoutEffect, $7c956ab6709b65e7$var$useState = $2hRE7.useState, $7c956ab6709b65e7$var$useRef = $2hRE7.useRef, $7c956ab6709b65e7$var$useMemo = $2hRE7.useMemo;
var $7c956ab6709b65e7$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
function $7c956ab6709b65e7$var$useDeepCompare(value) {
    var latestValue = $2hRE7.useRef(value);
    if (!$4MrjW(latestValue.current, value)) latestValue.current = value;
    return latestValue.current;
}
function $7c956ab6709b65e7$var$ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = $7c956ab6709b65e7$var$useDeepCompare(variables);
    var operation = $7c956ab6709b65e7$var$useMemo(function() {
        var request = $7c956ab6709b65e7$var$getRequest(query);
        return $7c956ab6709b65e7$var$createOperationDescriptor(request, latestVariables);
    }, [
        query,
        latestVariables
    ]);
    var relayContext = $7c956ab6709b65e7$var$useMemo(function() {
        return {
            environment: environment
        };
    }, [
        environment
    ]);
    var dataRef = $7c956ab6709b65e7$var$useRef(null);
    var _useState = $7c956ab6709b65e7$var$useState(null), forceUpdate = _useState[1];
    var cleanupFnRef = $7c956ab6709b65e7$var$useRef(null);
    var snapshot = $7c956ab6709b65e7$var$useMemo(function() {
        environment.check(operation);
        var res = environment.lookup(operation.fragment);
        dataRef.current = res.data;
        var retainDisposable = environment.retain(operation);
        var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
            dataRef.current = newSnapshot.data;
            forceUpdate(dataRef.current);
        });
        var disposed = false;
        function nextCleanupFn() {
            if (!disposed) {
                disposed = true;
                cleanupFnRef.current = null;
                retainDisposable.dispose();
                subscribeDisposable.dispose();
            }
        }
        if (cleanupFnRef.current) cleanupFnRef.current();
        cleanupFnRef.current = nextCleanupFn;
        return res;
    }, [
        environment,
        operation
    ]);
    $7c956ab6709b65e7$var$useLayoutEffect(function() {
        var cleanupFn = cleanupFnRef.current;
        return function() {
            cleanupFn && cleanupFn();
        };
    }, [
        snapshot
    ]);
    return /*#__PURE__*/ $2hRE7.createElement($b2BSK.Provider, {
        value: relayContext
    }, /*#__PURE__*/ $2hRE7.createElement($ayZNC.Provider, {
        value: $7c956ab6709b65e7$var$queryRendererContext
    }, render({
        props: dataRef.current
    })));
}
module.exports = $7c956ab6709b65e7$var$ReactRelayLocalQueryRenderer;

});

parcelRegister("5Mcad", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $434adee74f505b9d$var$_interopRequireDefault = $9Ew61.default;

var $434adee74f505b9d$var$_extends2 = $434adee74f505b9d$var$_interopRequireDefault((parcelRequire("ghPm5")));

var $434adee74f505b9d$var$_objectWithoutPropertiesLoose2 = $434adee74f505b9d$var$_interopRequireDefault((parcelRequire("1lgQy")));

var $434adee74f505b9d$var$_assertThisInitialized2 = $434adee74f505b9d$var$_interopRequireDefault((parcelRequire("aKZ6h")));

var $434adee74f505b9d$var$_inheritsLoose2 = $434adee74f505b9d$var$_interopRequireDefault((parcelRequire("byPLZ")));

var $434adee74f505b9d$var$_defineProperty2 = $434adee74f505b9d$var$_interopRequireDefault((parcelRequire("2bxFr")));

var $434adee74f505b9d$var$_objectSpread3 = $434adee74f505b9d$var$_interopRequireDefault((parcelRequire("7lyjq")));
var $434adee74f505b9d$var$_excluded = [
    "componentRef"
], $434adee74f505b9d$var$_excluded2 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
], $434adee74f505b9d$var$_excluded3 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $6KBaH = parcelRequire("6KBaH");

var $eq9nz = parcelRequire("eq9nz");

var $brhnK = parcelRequire("brhnK");
var $434adee74f505b9d$var$getComponentName = $brhnK.getComponentName, $434adee74f505b9d$var$getContainerName = $brhnK.getContainerName;

var $b2BSK = parcelRequire("b2BSK");

var $koqRh = parcelRequire("koqRh");

var $arhra = parcelRequire("arhra");
var $434adee74f505b9d$var$assertRelayContext = $arhra.assertRelayContext;

var $4MrjW = parcelRequire("4MrjW");

var $1etGW = parcelRequire("1etGW");

var $2hRE7 = parcelRequire("2hRE7");

var $5ohfX = parcelRequire("5ohfX");
var $434adee74f505b9d$var$ConnectionInterface = $5ohfX.ConnectionInterface, $434adee74f505b9d$var$Observable = $5ohfX.Observable, $434adee74f505b9d$var$RelayFeatureFlags = $5ohfX.RelayFeatureFlags, $434adee74f505b9d$var$createFragmentSpecResolver = $5ohfX.createFragmentSpecResolver, $434adee74f505b9d$var$createOperationDescriptor = $5ohfX.createOperationDescriptor, $434adee74f505b9d$var$getDataIDsFromObject = $5ohfX.getDataIDsFromObject, $434adee74f505b9d$var$getRequest = $5ohfX.getRequest, $434adee74f505b9d$var$getVariablesFromObject = $5ohfX.getVariablesFromObject, $434adee74f505b9d$var$isScalarAndEqual = $5ohfX.isScalarAndEqual;
parcelRequire("4j8bN");
var $434adee74f505b9d$var$FORWARD = 'forward';
function $434adee74f505b9d$var$createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path && $1etGW(false);
    return function(props) {
        var data = props[metadata.fragmentName];
        for(var i = 0; i < path.length; i++){
            if (!data || typeof data !== 'object') return null;
            data = data[path[i]];
        }
        return data;
    };
}
function $434adee74f505b9d$var$createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable && $1etGW(false);
    return function(prevVars, totalCount) {
        return (0, $434adee74f505b9d$var$_objectSpread3["default"])((0, $434adee74f505b9d$var$_objectSpread3["default"])({}, prevVars), {}, (0, $434adee74f505b9d$var$_defineProperty2["default"])({}, countVariable, totalCount));
    };
}
function $434adee74f505b9d$var$findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for(var fragmentName in fragments){
        var fragment = fragments[fragmentName];
        var connectionMetadata = fragment.metadata && fragment.metadata.connection;
        if (fragment.metadata !== undefined) isRelayModern = true;
        if (connectionMetadata) {
            !(connectionMetadata.length === 1) && $1etGW(false);
            !!foundConnectionMetadata && $1etGW(false);
            foundConnectionMetadata = (0, $434adee74f505b9d$var$_objectSpread3["default"])((0, $434adee74f505b9d$var$_objectSpread3["default"])({}, connectionMetadata[0]), {}, {
                fragmentName: fragmentName
            });
        }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) && $1etGW(false);
    return foundConnectionMetadata || {};
}
function $434adee74f505b9d$var$toObserver(observerOrCallback) {
    return typeof observerOrCallback === 'function' ? {
        error: observerOrCallback,
        complete: observerOrCallback,
        unsubscribe: function unsubscribe(subscription) {
            typeof observerOrCallback === 'function' && observerOrCallback();
        }
    } : observerOrCallback || {};
}
function $434adee74f505b9d$var$createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = $434adee74f505b9d$var$getComponentName(Component);
    var containerName = $434adee74f505b9d$var$getContainerName(Component);
    var metadata = $434adee74f505b9d$var$findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || $434adee74f505b9d$var$createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction && $1etGW(false);
    var getFragmentVariables = connectionConfig.getFragmentVariables || $434adee74f505b9d$var$createGetFragmentVariables(metadata);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $434adee74f505b9d$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $434adee74f505b9d$var$_defineProperty2["default"])((0, $434adee74f505b9d$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                _this.setState({
                    data: _this._resolver.resolve()
                });
            });
            (0, $434adee74f505b9d$var$_defineProperty2["default"])((0, $434adee74f505b9d$var$_assertThisInitialized2["default"])(_this), "_hasMore", function() {
                var connectionData = _this._getConnectionData();
                return !!(connectionData && connectionData.hasMore && connectionData.cursor);
            });
            (0, $434adee74f505b9d$var$_defineProperty2["default"])((0, $434adee74f505b9d$var$_assertThisInitialized2["default"])(_this), "_isLoading", function() {
                return !!_this._refetchSubscription;
            });
            (0, $434adee74f505b9d$var$_defineProperty2["default"])((0, $434adee74f505b9d$var$_assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
                if (!_this._canFetchPage('refetchConnection')) return {
                    dispose: function dispose() {}
                };
                _this._refetchVariables = refetchVariables;
                var paginatingVariables = {
                    count: totalCount,
                    cursor: null,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, $434adee74f505b9d$var$toObserver(observerOrCallback), {
                    force: true
                });
                return {
                    dispose: fetch.unsubscribe
                };
            });
            (0, $434adee74f505b9d$var$_defineProperty2["default"])((0, $434adee74f505b9d$var$_assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
                if (!_this._canFetchPage('loadMore')) return {
                    dispose: function dispose() {}
                };
                var observer = $434adee74f505b9d$var$toObserver(observerOrCallback);
                var connectionData = _this._getConnectionData();
                if (!connectionData) {
                    $434adee74f505b9d$var$Observable.create(function(sink) {
                        return sink.complete();
                    }).subscribe(observer);
                    return null;
                }
                var totalCount = connectionData.edgeCount + pageSize;
                if (options && options.force) return _this._refetchConnection(totalCount, observerOrCallback);
                var _ConnectionInterface$ = $434adee74f505b9d$var$ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
                var cursor = connectionData.cursor;
                var paginatingVariables = {
                    count: pageSize,
                    cursor: cursor,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, observer, options);
                return {
                    dispose: fetch.unsubscribe
                };
            });
            var relayContext = $434adee74f505b9d$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._isARequestInFlight = false;
            _this._refetchSubscription = null;
            _this._refetchVariables = null;
            if ($434adee74f505b9d$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) _this._resolver = $434adee74f505b9d$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            else _this._resolver = $434adee74f505b9d$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
            _this.state = {
                data: _this._resolver.resolve(),
                prevContext: relayContext,
                contextForChildren: relayContext,
                relayProp: _this._buildRelayProp(relayContext),
                resolverGeneration: 0
            };
            _this._isUnmounted = false;
            _this._hasFetched = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            if ($434adee74f505b9d$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($434adee74f505b9d$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
                if (prevState.resolverGeneration !== this.state.resolverGeneration) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
                else this._rerenderIfStoreHasChanged();
            }
        };
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;
            var _nextProps$__rootIsQu;
            var relayContext = $434adee74f505b9d$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $434adee74f505b9d$var$getDataIDsFromObject(fragments, this.props);
            var nextIDs = $434adee74f505b9d$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $eq9nz(fragments, this.props);
            var nextRootVariables = $eq9nz(fragments, nextProps);
            if (relayContext.environment !== this.state.prevContext.environment || !$4MrjW(prevRootVariables, nextRootVariables) || !$4MrjW(prevIDs, nextIDs)) {
                this._cleanup();
                if ($434adee74f505b9d$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._resolver = $434adee74f505b9d$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                else this._resolver = $434adee74f505b9d$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
                this.setState(function(prevState) {
                    return {
                        prevContext: relayContext,
                        contextForChildren: relayContext,
                        relayProp: _this2._buildRelayProp(relayContext),
                        resolverGeneration: prevState.resolverGeneration + 1
                    };
                });
            } else if (!this._hasFetched) this._resolver.setProps(nextProps);
            var data = this._resolver.resolve();
            if (data !== this.state.data) this.setState({
                data: data
            });
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this._cleanup();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevContext.environment !== this.state.prevContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$434adee74f505b9d$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._buildRelayProp = function _buildRelayProp(relayContext) {
            return {
                hasMore: this._hasMore,
                isLoading: this._isLoading,
                loadMore: this._loadMore,
                refetchConnection: this._refetchConnection,
                environment: relayContext.environment
            };
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getConnectionData = function _getConnectionData() {
            var _this$props = this.props, _ = _this$props.componentRef, restProps = (0, $434adee74f505b9d$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $434adee74f505b9d$var$_excluded);
            var props = (0, $434adee74f505b9d$var$_objectSpread3["default"])((0, $434adee74f505b9d$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var connectionData = getConnectionFromProps(props);
            if (connectionData == null) return null;
            var _ConnectionInterface$2 = $434adee74f505b9d$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
            !(typeof connectionData === 'object') && $1etGW(false);
            var edges = connectionData[EDGES];
            var pageInfo = connectionData[PAGE_INFO];
            if (edges == null || pageInfo == null) return null;
            !Array.isArray(edges) && $1etGW(false);
            !(typeof pageInfo === 'object') && $1etGW(false);
            var hasMore = direction === $434adee74f505b9d$var$FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
            var cursor = direction === $434adee74f505b9d$var$FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
            if (typeof hasMore !== 'boolean' || edges.length !== 0 && typeof cursor === 'undefined') return null;
            return {
                cursor: cursor,
                edgeCount: edges.length,
                hasMore: hasMore
            };
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $koqRh();
            return this._queryFetcher;
        };
        _proto._canFetchPage = function _canFetchPage(method) {
            if (this._isUnmounted) return false;
            return true;
        };
        _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
            var _this3 = this;
            var _assertRelayContext = $434adee74f505b9d$var$assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
            var _this$props2 = this.props, _ = _this$props2.componentRef, __relayContext = _this$props2.__relayContext, __rootIsQueryRenderer = _this$props2.__rootIsQueryRenderer, restProps = (0, $434adee74f505b9d$var$_objectWithoutPropertiesLoose2["default"])(_this$props2, $434adee74f505b9d$var$_excluded2);
            var props = (0, $434adee74f505b9d$var$_objectSpread3["default"])((0, $434adee74f505b9d$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var fragmentVariables;
            var rootVariables = $eq9nz(fragments, restProps);
            fragmentVariables = $434adee74f505b9d$var$getVariablesFromObject(fragments, restProps);
            fragmentVariables = (0, $434adee74f505b9d$var$_objectSpread3["default"])((0, $434adee74f505b9d$var$_objectSpread3["default"])((0, $434adee74f505b9d$var$_objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
            var fetchVariables = connectionConfig.getVariables(props, {
                count: paginatingVariables.count,
                cursor: paginatingVariables.cursor
            }, fragmentVariables);
            !(typeof fetchVariables === 'object' && fetchVariables !== null) && $1etGW(false);
            fetchVariables = (0, $434adee74f505b9d$var$_objectSpread3["default"])((0, $434adee74f505b9d$var$_objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
            fragmentVariables = (0, $434adee74f505b9d$var$_objectSpread3["default"])((0, $434adee74f505b9d$var$_objectSpread3["default"])({}, fetchVariables), fragmentVariables);
            var cacheConfig = options ? {
                force: !!options.force
            } : undefined;
            if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
            var request = $434adee74f505b9d$var$getRequest(connectionConfig.query);
            var operation = $434adee74f505b9d$var$createOperationDescriptor(request, fetchVariables, cacheConfig);
            var refetchSubscription = null;
            if (this._refetchSubscription) this._refetchSubscription.unsubscribe();
            this._hasFetched = true;
            var onNext = function onNext(payload, complete) {
                var prevData = _this3._resolver.resolve();
                _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
                var nextData = _this3._resolver.resolve();
                if (!$4MrjW(prevData, nextData)) _this3.setState({
                    data: nextData,
                    contextForChildren: {
                        environment: _this3.props.__relayContext.environment
                    }
                }, complete);
                else complete();
            };
            var cleanup = function cleanup() {
                if (_this3._refetchSubscription === refetchSubscription) {
                    _this3._refetchSubscription = null;
                    _this3._isARequestInFlight = false;
                }
            };
            this._isARequestInFlight = true;
            refetchSubscription = this._getQueryFetcher().execute({
                environment: environment,
                operation: operation,
                preservePreviousReferences: true
            }).mergeMap(function(payload) {
                return $434adee74f505b9d$var$Observable.create(function(sink) {
                    onNext(payload, function() {
                        sink.next();
                        sink.complete();
                    });
                });
            })["do"]({
                error: cleanup,
                complete: cleanup,
                unsubscribe: cleanup
            }).subscribe(observer || {});
            this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
            return refetchSubscription;
        };
        _proto._cleanup = function _cleanup() {
            this._resolver.dispose();
            this._refetchVariables = null;
            this._hasFetched = false;
            if (this._refetchSubscription) {
                this._refetchSubscription.unsubscribe();
                this._refetchSubscription = null;
                this._isARequestInFlight = false;
            }
            if (this._queryFetcher) this._queryFetcher.dispose();
        };
        _proto.render = function render() {
            var _this$props3 = this.props, componentRef = _this$props3.componentRef, __relayContext = _this$props3.__relayContext, __rootIsQueryRenderer = _this$props3.__rootIsQueryRenderer, props = (0, $434adee74f505b9d$var$_objectWithoutPropertiesLoose2["default"])(_this$props3, $434adee74f505b9d$var$_excluded3);
            return /*#__PURE__*/ $2hRE7.createElement($b2BSK.Provider, {
                value: this.state.contextForChildren
            }, /*#__PURE__*/ $2hRE7.createElement(Component, (0, $434adee74f505b9d$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            })));
        };
        return _class;
    }($2hRE7.Component), (0, $434adee74f505b9d$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $434adee74f505b9d$var$createContainer(Component, fragmentSpec, connectionConfig) {
    return $6KBaH(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $434adee74f505b9d$var$createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
}
module.exports = {
    createContainer: $434adee74f505b9d$var$createContainer
};

});
parcelRegister("eq9nz", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $a7fac4e513692496$var$_interopRequireDefault = $9Ew61.default;

var $a7fac4e513692496$var$_objectSpread2 = $a7fac4e513692496$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $5ohfX = parcelRequire("5ohfX");
var $a7fac4e513692496$var$getSelector = $5ohfX.getSelector;
function $a7fac4e513692496$var$getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    Object.keys(fragments).forEach(function(key) {
        var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
        var fragmentNode = fragments[key];
        var fragmentRef = props[key];
        var selector = $a7fac4e513692496$var$getSelector(fragmentNode, fragmentRef);
        var fragmentOwnerVariables = selector != null && selector.kind === 'PluralReaderSelector' ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
        rootVariables = (0, $a7fac4e513692496$var$_objectSpread2["default"])((0, $a7fac4e513692496$var$_objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
}
module.exports = $a7fac4e513692496$var$getRootVariablesForFragments;

});

parcelRegister("koqRh", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $ed8ae2122da4d6bf$var$_interopRequireDefault = $9Ew61.default;

var $ed8ae2122da4d6bf$var$_defineProperty2 = $ed8ae2122da4d6bf$var$_interopRequireDefault((parcelRequire("2bxFr")));

var $1etGW = parcelRequire("1etGW");

var $5ohfX = parcelRequire("5ohfX");
var $ed8ae2122da4d6bf$var$fetchQuery = $5ohfX.__internal.fetchQuery, $ed8ae2122da4d6bf$var$createOperationDescriptor = $5ohfX.createOperationDescriptor, $ed8ae2122da4d6bf$var$isRelayModernEnvironment = $5ohfX.isRelayModernEnvironment;
var $ed8ae2122da4d6bf$var$ReactRelayQueryFetcher = /*#__PURE__*/ function() {
    function ReactRelayQueryFetcher(args) {
        (0, $ed8ae2122da4d6bf$var$_defineProperty2["default"])(this, "_selectionReferences", []);
        (0, $ed8ae2122da4d6bf$var$_defineProperty2["default"])(this, "_didFetchFinish", false);
        if (args != null) {
            this._cacheSelectionReference = args.cacheSelectionReference;
            this._selectionReferences = args.selectionReferences;
        }
    }
    var _proto = ReactRelayQueryFetcher.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
        return {
            cacheSelectionReference: this._cacheSelectionReference,
            selectionReferences: this._selectionReferences
        };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
        if (fetchPolicy === 'store-and-network' || fetchPolicy === 'store-or-network') {
            if (environment.check(operation).status === 'available') {
                this._retainCachedOperation(environment, operation);
                return environment.lookup(operation.fragment);
            }
        }
        return null;
    };
    _proto.getFetchResult = function getFetchResult() {
        if (this._didFetchFinish) {
            if (this._error != null) return {
                error: this._error
            };
            else if (this._snapshot != null) return {
                snapshot: this._snapshot
            };
        } else return null;
    };
    _proto.execute = function execute(_ref) {
        var _this = this;
        var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
        var reference = environment.retain(operation);
        var error = function error() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var complete = function complete() {
            if (!preservePreviousReferences) _this.disposeSelectionReferences();
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var unsubscribe = function unsubscribe() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        if (!$ed8ae2122da4d6bf$var$isRelayModernEnvironment(environment)) return environment.execute({
            operation: operation
        })["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
        return $ed8ae2122da4d6bf$var$fetchQuery(environment, operation)["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
        !this._fetchOptions && $1etGW(false);
        if (typeof onDataChange === 'function') {
            this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
            this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
            if (this._didFetchFinish) {
                if (this._error != null) onDataChange({
                    error: this._error
                });
                else if (this._snapshot != null) onDataChange({
                    snapshot: this._snapshot
                });
            }
        }
    };
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
        var _this2 = this;
        var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
        var fetchHasReturned = false;
        var _error;
        this.disposeRequest();
        var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
        this._fetchOptions = {
            environment: environment,
            onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
            operation: operation
        };
        if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        var operationOverride = cacheConfigOverride ? $ed8ae2122da4d6bf$var$createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
        var request = this.execute({
            environment: environment,
            operation: operationOverride
        })["finally"](function() {
            _this2._pendingRequest = null;
        }).subscribe({
            next: function next() {
                _this2._didFetchFinish = true;
                _this2._error = null;
                _this2._onQueryDataAvailable({
                    notifyFirstResult: fetchHasReturned
                });
            },
            error: function error(err) {
                _this2._didFetchFinish = true;
                _this2._error = err;
                _this2._snapshot = null;
                var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
                if (fetchHasReturned) {
                    if (onDataChangeCallbacks) onDataChangeCallbacks.forEach(function(onDataChange) {
                        onDataChange({
                            error: err
                        });
                    });
                } else _error = err;
            }
        });
        this._pendingRequest = {
            dispose: function dispose() {
                request.unsubscribe();
            }
        };
        fetchHasReturned = true;
        if (_error) throw _error;
        return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
        !this._fetchOptions && $1etGW(false);
        return this.fetch({
            environment: this._fetchOptions.environment,
            operation: this._fetchOptions.operation,
            onDataChange: null
        }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
        this.disposeRequest();
        this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
        this._error = null;
        this._snapshot = null;
        if (this._pendingRequest) this._pendingRequest.dispose();
        if (this._rootSubscription) {
            this._rootSubscription.dispose();
            this._rootSubscription = null;
        }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
        this._disposeCacheSelectionReference();
        this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
        this._cacheSelectionReference && this._cacheSelectionReference.dispose();
        this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
        this._disposeCacheSelectionReference();
        this._selectionReferences.forEach(function(r) {
            return r.dispose();
        });
        this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
        var _this3 = this;
        var notifyFirstResult = _ref2.notifyFirstResult;
        !this._fetchOptions && $1etGW(false);
        var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
        if (this._snapshot) return;
        this._snapshot = environment.lookup(operation.fragment);
        this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot) {
            if (_this3._fetchOptions != null) {
                var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
                if (Array.isArray(maybeNewOnDataChangeCallbacks)) maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
                    return onDataChange({
                        snapshot: snapshot
                    });
                });
            }
        });
        if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
            var snapshot = this._snapshot;
            onDataChangeCallbacks.forEach(function(onDataChange) {
                return onDataChange({
                    snapshot: snapshot
                });
            });
        }
    };
    return ReactRelayQueryFetcher;
}();
module.exports = $ed8ae2122da4d6bf$var$ReactRelayQueryFetcher;

});


parcelRegister("lBgv6", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $fb99da5919562bab$var$_interopRequireDefault = $9Ew61.default;

var $fb99da5919562bab$var$_objectSpread2 = $fb99da5919562bab$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $fb99da5919562bab$var$_assertThisInitialized2 = $fb99da5919562bab$var$_interopRequireDefault((parcelRequire("aKZ6h")));

var $fb99da5919562bab$var$_inheritsLoose2 = $fb99da5919562bab$var$_interopRequireDefault((parcelRequire("byPLZ")));

var $fb99da5919562bab$var$_defineProperty2 = $fb99da5919562bab$var$_interopRequireDefault((parcelRequire("2bxFr")));

var $b2BSK = parcelRequire("b2BSK");

var $koqRh = parcelRequire("koqRh");

var $ayZNC = parcelRequire("ayZNC");

var $4MrjW = parcelRequire("4MrjW");

var $2hRE7 = parcelRequire("2hRE7");

var $5ohfX = parcelRequire("5ohfX");
var $fb99da5919562bab$var$createOperationDescriptor = $5ohfX.createOperationDescriptor, $fb99da5919562bab$var$deepFreeze = $5ohfX.deepFreeze, $fb99da5919562bab$var$getRequest = $5ohfX.getRequest;
var $fb99da5919562bab$var$requestCache = {};
var $fb99da5919562bab$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
var $fb99da5919562bab$var$ReactRelayQueryRenderer = /*#__PURE__*/ function(_React$Component) {
    (0, $fb99da5919562bab$var$_inheritsLoose2["default"])(ReactRelayQueryRenderer, _React$Component);
    function ReactRelayQueryRenderer(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        (0, $fb99da5919562bab$var$_defineProperty2["default"])((0, $fb99da5919562bab$var$_assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
            var error = params.error == null ? null : params.error;
            var snapshot = params.snapshot == null ? null : params.snapshot;
            _this.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $fb99da5919562bab$var$requestCache[prevRequestCacheKey];
                if (snapshot === prevState.snapshot && error === prevState.error) return null;
                return {
                    renderProps: $fb99da5919562bab$var$getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
                    snapshot: snapshot,
                    requestCacheKey: null
                };
            });
        });
        var retryCallbacks = {
            handleDataChange: null,
            handleRetryAfterError: null
        };
        var queryFetcher;
        var requestCacheKey;
        if (props.query) {
            var query = props.query;
            var request = $fb99da5919562bab$var$getRequest(query);
            requestCacheKey = $fb99da5919562bab$var$getRequestCacheKey(request.params, props.variables);
            queryFetcher = $fb99da5919562bab$var$requestCache[requestCacheKey] ? $fb99da5919562bab$var$requestCache[requestCacheKey].queryFetcher : new $koqRh();
        } else queryFetcher = new $koqRh();
        _this._maybeHiddenOrFastRefresh = false;
        _this.state = (0, $fb99da5919562bab$var$_objectSpread2["default"])({
            prevPropsEnvironment: props.environment,
            prevPropsVariables: props.variables,
            prevQuery: props.query,
            queryFetcher: queryFetcher,
            retryCallbacks: retryCallbacks
        }, $fb99da5919562bab$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
        return _this;
    }
    ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !$4MrjW(prevState.prevPropsVariables, nextProps.variables)) return $fb99da5919562bab$var$resetQueryStateForUpdate(nextProps, prevState);
        return null;
    };
    var _proto = ReactRelayQueryRenderer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        if (this._maybeHiddenOrFastRefresh === true) {
            this._maybeHiddenOrFastRefresh = false;
            this.setState(function(prevState) {
                var newState = $fb99da5919562bab$var$resetQueryStateForUpdate(_this2.props, prevState);
                var requestCacheKey = newState.requestCacheKey, queryFetcher = newState.queryFetcher;
                if (requestCacheKey != null && $fb99da5919562bab$var$requestCache[requestCacheKey] != null) queryFetcher.setOnDataChange(_this2._handleDataChange);
                return newState;
            });
            return;
        }
        var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
        if (requestCacheKey) delete $fb99da5919562bab$var$requestCache[requestCacheKey];
        retryCallbacks.handleDataChange = this._handleDataChange;
        retryCallbacks.handleRetryAfterError = function(error) {
            return _this2.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $fb99da5919562bab$var$requestCache[prevRequestCacheKey];
                return {
                    renderProps: $fb99da5919562bab$var$getLoadingRenderProps(),
                    requestCacheKey: null
                };
            });
        };
        if (this.props.query) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
        if (requestCacheKey) {
            delete $fb99da5919562bab$var$requestCache[requestCacheKey];
            delete this.state.requestCacheKey;
        }
        if (this.props.query && queryFetcher !== prevState.queryFetcher) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.queryFetcher.dispose();
        this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
        var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
        return /*#__PURE__*/ $2hRE7.createElement($b2BSK.Provider, {
            value: relayContext
        }, /*#__PURE__*/ $2hRE7.createElement($ayZNC.Provider, {
            value: $fb99da5919562bab$var$queryRendererContext
        }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer;
}($2hRE7.Component);
function $fb99da5919562bab$var$getLoadingRenderProps() {
    return {
        error: null,
        props: null,
        retry: null
    };
}
function $fb99da5919562bab$var$getEmptyRenderProps() {
    return {
        error: null,
        props: {},
        retry: null
    };
}
function $fb99da5919562bab$var$getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
        error: error ? error : null,
        props: snapshot ? snapshot.data : null,
        retry: function retry(cacheConfigOverride) {
            var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
            if (syncSnapshot && typeof retryCallbacks.handleDataChange === 'function') retryCallbacks.handleDataChange({
                snapshot: syncSnapshot
            });
            else if (error && typeof retryCallbacks.handleRetryAfterError === 'function') retryCallbacks.handleRetryAfterError(error);
        }
    };
}
function $fb99da5919562bab$var$getRequestCacheKey(request, variables) {
    return JSON.stringify({
        id: request.cacheID ? request.cacheID : request.id,
        variables: variables
    });
}
function $fb99da5919562bab$var$resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
        var request = $fb99da5919562bab$var$getRequest(query);
        var requestCacheKey = $fb99da5919562bab$var$getRequestCacheKey(request.params, props.variables);
        queryFetcher = $fb99da5919562bab$var$requestCache[requestCacheKey] ? $fb99da5919562bab$var$requestCache[requestCacheKey].queryFetcher : new $koqRh(prevSelectionReferences);
    } else queryFetcher = new $koqRh(prevSelectionReferences);
    return (0, $fb99da5919562bab$var$_objectSpread2["default"])({
        prevQuery: props.query,
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        queryFetcher: queryFetcher
    }, $fb99da5919562bab$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
}
function $fb99da5919562bab$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
        var request = $fb99da5919562bab$var$getRequest(query);
        var operation = $fb99da5919562bab$var$createOperationDescriptor(request, variables, cacheConfig);
        var relayContext = {
            environment: genericEnvironment
        };
        if (typeof requestCacheKey === 'string' && $fb99da5919562bab$var$requestCache[requestCacheKey]) {
            var snapshot = $fb99da5919562bab$var$requestCache[requestCacheKey].snapshot;
            if (snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $fb99da5919562bab$var$getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
                snapshot: snapshot,
                requestCacheKey: requestCacheKey
            };
            else return {
                error: null,
                relayContext: relayContext,
                renderProps: $fb99da5919562bab$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
        try {
            var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
            var querySnapshot = queryFetcher.fetch({
                environment: genericEnvironment,
                onDataChange: null,
                operation: operation
            });
            var _snapshot = querySnapshot || storeSnapshot;
            requestCacheKey = requestCacheKey || $fb99da5919562bab$var$getRequestCacheKey(request.params, props.variables);
            $fb99da5919562bab$var$requestCache[requestCacheKey] = {
                queryFetcher: queryFetcher,
                snapshot: _snapshot
            };
            if (!_snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $fb99da5919562bab$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
            return {
                error: null,
                relayContext: relayContext,
                renderProps: $fb99da5919562bab$var$getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
                snapshot: _snapshot,
                requestCacheKey: requestCacheKey
            };
        } catch (error) {
            return {
                error: error,
                relayContext: relayContext,
                renderProps: $fb99da5919562bab$var$getRenderProps(error, null, queryFetcher, retryCallbacks),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
    } else {
        queryFetcher.dispose();
        var _relayContext = {
            environment: genericEnvironment
        };
        return {
            error: null,
            relayContext: _relayContext,
            renderProps: $fb99da5919562bab$var$getEmptyRenderProps(),
            requestCacheKey: null
        };
    }
}
module.exports = $fb99da5919562bab$var$ReactRelayQueryRenderer;

});

parcelRegister("fRIad", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $b8ce1046c5fb20c3$var$_interopRequireDefault = $9Ew61.default;

var $b8ce1046c5fb20c3$var$_extends2 = $b8ce1046c5fb20c3$var$_interopRequireDefault((parcelRequire("ghPm5")));

var $b8ce1046c5fb20c3$var$_objectWithoutPropertiesLoose2 = $b8ce1046c5fb20c3$var$_interopRequireDefault((parcelRequire("1lgQy")));

var $b8ce1046c5fb20c3$var$_objectSpread2 = $b8ce1046c5fb20c3$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $b8ce1046c5fb20c3$var$_assertThisInitialized2 = $b8ce1046c5fb20c3$var$_interopRequireDefault((parcelRequire("aKZ6h")));

var $b8ce1046c5fb20c3$var$_inheritsLoose2 = $b8ce1046c5fb20c3$var$_interopRequireDefault((parcelRequire("byPLZ")));

var $b8ce1046c5fb20c3$var$_defineProperty2 = $b8ce1046c5fb20c3$var$_interopRequireDefault((parcelRequire("2bxFr")));
var $b8ce1046c5fb20c3$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $6KBaH = parcelRequire("6KBaH");

var $eq9nz = parcelRequire("eq9nz");

var $brhnK = parcelRequire("brhnK");
var $b8ce1046c5fb20c3$var$getContainerName = $brhnK.getContainerName;

var $b2BSK = parcelRequire("b2BSK");

var $koqRh = parcelRequire("koqRh");

var $arhra = parcelRequire("arhra");
var $b8ce1046c5fb20c3$var$assertRelayContext = $arhra.assertRelayContext;

var $4MrjW = parcelRequire("4MrjW");

var $2hRE7 = parcelRequire("2hRE7");

var $5ohfX = parcelRequire("5ohfX");
var $b8ce1046c5fb20c3$var$Observable = $5ohfX.Observable, $b8ce1046c5fb20c3$var$createFragmentSpecResolver = $5ohfX.createFragmentSpecResolver, $b8ce1046c5fb20c3$var$createOperationDescriptor = $5ohfX.createOperationDescriptor, $b8ce1046c5fb20c3$var$getDataIDsFromObject = $5ohfX.getDataIDsFromObject, $b8ce1046c5fb20c3$var$getRequest = $5ohfX.getRequest, $b8ce1046c5fb20c3$var$getVariablesFromObject = $5ohfX.getVariablesFromObject, $b8ce1046c5fb20c3$var$isScalarAndEqual = $5ohfX.isScalarAndEqual;
parcelRequire("4j8bN");
function $b8ce1046c5fb20c3$var$createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = $b8ce1046c5fb20c3$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $b8ce1046c5fb20c3$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $b8ce1046c5fb20c3$var$_defineProperty2["default"])((0, $b8ce1046c5fb20c3$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve()
                    } : null;
                });
            });
            (0, $b8ce1046c5fb20c3$var$_defineProperty2["default"])((0, $b8ce1046c5fb20c3$var$_assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
                if (_this._isUnmounted) return {
                    dispose: function dispose() {}
                };
                var _assertRelayContext = $b8ce1046c5fb20c3$var$assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
                var rootVariables = $eq9nz(fragments, _this.props);
                var fetchVariables = typeof refetchVariables === 'function' ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
                fetchVariables = (0, $b8ce1046c5fb20c3$var$_objectSpread2["default"])((0, $b8ce1046c5fb20c3$var$_objectSpread2["default"])({}, rootVariables), fetchVariables);
                var fragmentVariables = renderVariables ? (0, $b8ce1046c5fb20c3$var$_objectSpread2["default"])((0, $b8ce1046c5fb20c3$var$_objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
                var cacheConfig = options ? {
                    force: !!options.force
                } : undefined;
                if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
                var observer = typeof observerOrCallback === 'function' ? {
                    next: observerOrCallback,
                    error: observerOrCallback
                } : observerOrCallback || {};
                var query = $b8ce1046c5fb20c3$var$getRequest(taggedNode);
                var operation = $b8ce1046c5fb20c3$var$createOperationDescriptor(query, fetchVariables, cacheConfig);
                _this.state.localVariables = fetchVariables;
                _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
                var refetchSubscription;
                var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
                if (storeSnapshot != null) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    _this.setState(function(latestState) {
                        return {
                            data: latestState.resolver.resolve(),
                            contextForChildren: {
                                environment: _this.props.__relayContext.environment
                            }
                        };
                    }, function() {
                        observer.next && observer.next();
                        observer.complete && observer.complete();
                    });
                    return {
                        dispose: function dispose() {}
                    };
                }
                _this._getQueryFetcher().execute({
                    environment: environment,
                    operation: operation,
                    preservePreviousReferences: true
                }).mergeMap(function(response) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    return $b8ce1046c5fb20c3$var$Observable.create(function(sink) {
                        return _this.setState(function(latestState) {
                            return {
                                data: latestState.resolver.resolve(),
                                contextForChildren: {
                                    environment: _this.props.__relayContext.environment
                                }
                            };
                        }, function() {
                            sink.next();
                            sink.complete();
                        });
                    });
                })["finally"](function() {
                    if (_this._refetchSubscription === refetchSubscription) _this._refetchSubscription = null;
                }).subscribe((0, $b8ce1046c5fb20c3$var$_objectSpread2["default"])((0, $b8ce1046c5fb20c3$var$_objectSpread2["default"])({}, observer), {}, {
                    start: function start(subscription) {
                        _this._refetchSubscription = refetchSubscription = subscription;
                        observer.start && observer.start(subscription);
                    }
                }));
                return {
                    dispose: function dispose() {
                        refetchSubscription && refetchSubscription.unsubscribe();
                    }
                };
            });
            var relayContext = $b8ce1046c5fb20c3$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._refetchSubscription = null;
            var resolver = $b8ce1046c5fb20c3$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                localVariables: null,
                prevProps: props,
                prevPropsContext: relayContext,
                contextForChildren: relayContext,
                relayProp: $b8ce1046c5fb20c3$var$getRelayProp(relayContext.environment, _this._refetch),
                resolver: resolver
            };
            _this._isUnmounted = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._queryFetcher && this._queryFetcher.dispose();
                this._refetchSubscription && this._refetchSubscription.unsubscribe();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $b8ce1046c5fb20c3$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $b8ce1046c5fb20c3$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $b8ce1046c5fb20c3$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $eq9nz(fragments, prevProps);
            var nextRootVariables = $eq9nz(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$4MrjW(prevRootVariables, nextRootVariables) || !$4MrjW(prevIDs, nextIDs)) {
                resolver = $b8ce1046c5fb20c3$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    localVariables: null,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    contextForChildren: relayContext,
                    relayProp: $b8ce1046c5fb20c3$var$getRelayProp(relayContext.environment, prevState.relayProp.refetch),
                    resolver: resolver
                };
            } else if (!prevState.localVariables) resolver.setProps(nextProps);
            var data = resolver.resolve();
            if (data !== prevState.data) return {
                data: data,
                prevProps: nextProps
            };
            return null;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this.state.resolver.dispose();
            this._queryFetcher && this._queryFetcher.dispose();
            this._refetchSubscription && this._refetchSubscription.unsubscribe();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$b8ce1046c5fb20c3$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getFragmentVariables = function _getFragmentVariables() {
            return $b8ce1046c5fb20c3$var$getVariablesFromObject(fragments, this.props);
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $koqRh();
            return this._queryFetcher;
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $b8ce1046c5fb20c3$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $b8ce1046c5fb20c3$var$_excluded);
            var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
            return /*#__PURE__*/ $2hRE7.createElement($b2BSK.Provider, {
                value: contextForChildren
            }, /*#__PURE__*/ $2hRE7.createElement(Component, (0, $b8ce1046c5fb20c3$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: relayProp
            })));
        };
        return _class;
    }($2hRE7.Component), (0, $b8ce1046c5fb20c3$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $b8ce1046c5fb20c3$var$getRelayProp(environment, refetch) {
    return {
        environment: environment,
        refetch: refetch
    };
}
function $b8ce1046c5fb20c3$var$createContainer(Component, fragmentSpec, taggedNode) {
    return $6KBaH(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $b8ce1046c5fb20c3$var$createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
}
module.exports = {
    createContainer: $b8ce1046c5fb20c3$var$createContainer
};

});

parcelRegister("5eMli", function(module, exports) {
'use strict';

var $e5do4 = parcelRequire("e5do4");

var $1G3Wj = parcelRequire("1G3Wj");

var $2hRE7 = parcelRequire("2hRE7");

var $2hRE7 = parcelRequire("2hRE7");
var $3d03c2617f1204d1$var$useContext = $2hRE7.useContext, $3d03c2617f1204d1$var$useEffect = $2hRE7.useEffect;
parcelRequire("4j8bN");
function $3d03c2617f1204d1$var$EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = $3d03c2617f1204d1$var$useContext($e5do4);
    var environment = $1G3Wj();
    $3d03c2617f1204d1$var$useEffect(function() {
        environment.__log({
            name: 'entrypoint.root.consume',
            profilerContext: profilerContext,
            rootModuleID: rootModuleID
        });
    }, [
        environment,
        profilerContext,
        rootModuleID
    ]);
    return /*#__PURE__*/ $2hRE7.createElement(Component, {
        entryPoints: entryPoints,
        extraProps: extraProps,
        props: props,
        queries: queries
    });
}
module.exports = $3d03c2617f1204d1$var$EntryPointContainer;

});
parcelRegister("e5do4", function(module, exports) {
'use strict';

var $2hRE7 = parcelRequire("2hRE7");
var $a40beabf9705bb45$var$ProfilerContext = $2hRE7.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
        return cb();
    }
});
module.exports = $a40beabf9705bb45$var$ProfilerContext;

});

parcelRegister("1G3Wj", function(module, exports) {
'use strict';

var $b2BSK = parcelRequire("b2BSK");

var $1etGW = parcelRequire("1etGW");

var $2hRE7 = parcelRequire("2hRE7");
var $138cc4fd93839544$var$useContext = $2hRE7.useContext;
function $138cc4fd93839544$var$useRelayEnvironment() {
    var context = $138cc4fd93839544$var$useContext($b2BSK);
    !(context != null) && $1etGW(false);
    return context.environment;
}
module.exports = $138cc4fd93839544$var$useRelayEnvironment;

});


parcelRegister("fcNlB", function(module, exports) {
'use strict';

var $83mO0 = parcelRequire("83mO0");
var $b11e4165a92edb2a$var$loadQuery = $83mO0.loadQuery;
function $b11e4165a92edb2a$var$loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) loadingPromise = entryPoint.root.load();
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
        var queriesPropNames = Object.keys(queries);
        queriesPropNames.forEach(function(queryPropName) {
            var query = queries[queryPropName];
            if (query == null) return;
            var environmentProviderOptions = query.environmentProviderOptions, options = query.options, parameters = query.parameters, variables = query.variables;
            if ((options === null || options === void 0 ? void 0 : options.includeIf) === false) return;
            var environment = environmentProvider.getEnvironment(environmentProviderOptions);
            preloadedQueries[queryPropName] = $b11e4165a92edb2a$var$loadQuery(environment, parameters, variables, {
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig,
                __nameForWarning: 'loadEntryPoint'
            }, environmentProviderOptions);
        });
    }
    if (entryPoints != null) {
        var entryPointPropNames = Object.keys(entryPoints);
        entryPointPropNames.forEach(function(entryPointPropName) {
            var entryPointDescription = entryPoints[entryPointPropName];
            if (entryPointDescription == null) return;
            var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
            preloadedEntryPoints[entryPointPropName] = $b11e4165a92edb2a$var$loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
        });
    }
    var isDisposed = false;
    return {
        dispose: function dispose() {
            if (isDisposed) return;
            if (preloadedQueries != null) Object.values(preloadedQueries).forEach(function(_ref) {
                var innerDispose = _ref.dispose;
                innerDispose();
            });
            if (preloadedEntryPoints != null) Object.values(preloadedEntryPoints).forEach(function(_ref2) {
                var innerDispose = _ref2.dispose;
                innerDispose();
            });
            isDisposed = true;
        },
        entryPoints: preloadedEntryPoints,
        extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
        getComponent: function getComponent() {
            var componentModule = entryPoint.root.getModuleIfRequired();
            if (componentModule == null) {
                var _loadingPromise;
                loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
                throw loadingPromise;
            }
            var component = componentModule["default"] != null ? componentModule["default"] : componentModule;
            return component;
        },
        get isDisposed () {
            return isDisposed;
        },
        queries: preloadedQueries,
        rootModuleID: entryPoint.root.getModuleId()
    };
}
module.exports = $b11e4165a92edb2a$var$loadEntryPoint;

});
parcelRegister("83mO0", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $5dd04b3c8450a9e4$var$_interopRequireDefault = $9Ew61.default;

var $5dd04b3c8450a9e4$var$_objectSpread2 = $5dd04b3c8450a9e4$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $1etGW = parcelRequire("1etGW");

var $5ohfX = parcelRequire("5ohfX");
var $5dd04b3c8450a9e4$var$fetchQueryDeduped = $5ohfX.__internal.fetchQueryDeduped, $5dd04b3c8450a9e4$var$Observable = $5ohfX.Observable, $5dd04b3c8450a9e4$var$PreloadableQueryRegistry = $5ohfX.PreloadableQueryRegistry, $5dd04b3c8450a9e4$var$ReplaySubject = $5ohfX.ReplaySubject, $5dd04b3c8450a9e4$var$createOperationDescriptor = $5ohfX.createOperationDescriptor, $5dd04b3c8450a9e4$var$getRequest = $5ohfX.getRequest, $5dd04b3c8450a9e4$var$getRequestIdentifier = $5ohfX.getRequestIdentifier;
var $5dd04b3c8450a9e4$var$fetchKey = 100001;
function $5dd04b3c8450a9e4$var$loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _options$fetchPolicy;
    $5dd04b3c8450a9e4$var$fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'store-or-network';
    var networkCacheConfig = (0, $5dd04b3c8450a9e4$var$_objectSpread2["default"])((0, $5dd04b3c8450a9e4$var$_objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
        force: true
    });
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource(operation, networkObservable) {
        didExecuteNetworkSource = true;
        return environment.executeWithSource({
            operation: operation,
            source: networkObservable
        });
    };
    var executionSubject = new $5dd04b3c8450a9e4$var$ReplaySubject();
    var returnedObservable = $5dd04b3c8450a9e4$var$Observable.create(function(sink) {
        return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest(params, checkOperation) {
        didMakeNetworkRequest = true;
        var subject = new $5dd04b3c8450a9e4$var$ReplaySubject();
        var identifier = 'raw-network-request-' + $5dd04b3c8450a9e4$var$getRequestIdentifier(params, variables);
        var observable = $5dd04b3c8450a9e4$var$fetchQueryDeduped(environment, identifier, function() {
            var network = environment.getNetwork();
            return network.execute(params, variables, networkCacheConfig, undefined, undefined, undefined, undefined, checkOperation);
        });
        var _observable$subscribe = observable.subscribe({
            error: function error(err) {
                networkError = err;
                subject.error(err);
            },
            next: function next(data) {
                subject.next(data);
            },
            complete: function complete() {
                subject.complete();
            }
        }), unsubscribe = _observable$subscribe.unsubscribe;
        unsubscribeFromNetworkRequest = unsubscribe;
        return $5dd04b3c8450a9e4$var$Observable.create(function(sink) {
            var subjectSubscription = subject.subscribe(sink);
            return function() {
                subjectSubscription.unsubscribe();
                unsubscribeFromNetworkRequest();
            };
        });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped(operation, fetchFn) {
        didMakeNetworkRequest = true;
        var _fetchQueryDeduped$su = $5dd04b3c8450a9e4$var$fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
            error: function error(err) {
                executionSubject.error(err);
            },
            next: function next(data) {
                executionSubject.next(data);
            },
            complete: function complete() {
                executionSubject.complete();
            }
        });
        unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute(concreteRequest) {
        var operation = $5dd04b3c8450a9e4$var$createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
        retainReference = environment.retain(operation);
        if (fetchPolicy === 'store-only') return;
        var shouldFetch = fetchPolicy !== 'store-or-network' || environment.check(operation).status !== 'available';
        if (shouldFetch) executeDeduped(operation, function() {
            var networkObservable = makeNetworkRequest(concreteRequest.params, function() {
                return environment.check(operation);
            });
            var executeObservable = executeWithNetworkSource(operation, networkObservable);
            return executeObservable;
        });
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
        var preloadableConcreteRequest = preloadableRequest;
        params = preloadableConcreteRequest.params;
        var _params = params;
        queryId = _params.id;
        !(queryId !== null) && $1etGW(false);
        var _module = $5dd04b3c8450a9e4$var$PreloadableQueryRegistry.get(queryId);
        if (_module != null) checkAvailabilityAndExecute(_module);
        else {
            var networkObservable = fetchPolicy === 'store-only' ? null : makeNetworkRequest(params);
            var _PreloadableQueryRegi = $5dd04b3c8450a9e4$var$PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
                cancelOnLoadCallback();
                var operation = $5dd04b3c8450a9e4$var$createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
                retainReference = environment.retain(operation);
                if (networkObservable != null) executeDeduped(operation, function() {
                    return executeWithNetworkSource(operation, networkObservable);
                });
            });
            cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
        }
    } else {
        var graphQlTaggedNode = preloadableRequest;
        var request = $5dd04b3c8450a9e4$var$getRequest(graphQlTaggedNode);
        params = request.params;
        queryId = params.cacheID != null ? params.cacheID : params.id;
        checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery() {
        if (isReleased) return;
        retainReference && retainReference.dispose();
        isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest() {
        if (isNetworkRequestCancelled) return;
        if (didExecuteNetworkSource) unsubscribeFromExecution && unsubscribeFromExecution();
        else unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
        cancelOnLoadCallback && cancelOnLoadCallback();
        isNetworkRequestCancelled = true;
    };
    return {
        kind: 'PreloadedQuery',
        environment: environment,
        environmentProviderOptions: environmentProviderOptions,
        dispose: function dispose() {
            if (isDisposed) return;
            releaseQuery();
            cancelNetworkRequest();
            isDisposed = true;
        },
        releaseQuery: releaseQuery,
        cancelNetworkRequest: cancelNetworkRequest,
        fetchKey: $5dd04b3c8450a9e4$var$fetchKey,
        id: queryId,
        get isDisposed () {
            return isDisposed || isReleased;
        },
        get networkError () {
            return networkError;
        },
        name: params.name,
        networkCacheConfig: networkCacheConfig,
        fetchPolicy: fetchPolicy,
        source: didMakeNetworkRequest ? returnedObservable : undefined,
        variables: variables
    };
}
module.exports = {
    loadQuery: $5dd04b3c8450a9e4$var$loadQuery
};

});


parcelRegister("kf4EO", function(module, exports) {
'use strict';

var $b2BSK = parcelRequire("b2BSK");

var $2hRE7 = parcelRequire("2hRE7");
var $ebc8d22c89a8b7bb$var$useMemo = $2hRE7.useMemo;
function $ebc8d22c89a8b7bb$var$RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = $ebc8d22c89a8b7bb$var$useMemo(function() {
        return {
            environment: environment,
            getEnvironmentForActor: getEnvironmentForActor
        };
    }, [
        environment,
        getEnvironmentForActor
    ]);
    return /*#__PURE__*/ $2hRE7.createElement($b2BSK.Provider, {
        value: context
    }, children);
}
module.exports = $ebc8d22c89a8b7bb$var$RelayEnvironmentProvider;

});

parcelRegister("ciDJ8", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $8f45fb6babb76faa$var$_interopRequireDefault = $9Ew61.default;

var $8f45fb6babb76faa$var$_objectSpread2 = $8f45fb6babb76faa$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $jbd9B = parcelRequire("jbd9B");
function $8f45fb6babb76faa$var$useClientQuery(gqlQuery, variables, options) {
    var query = gqlQuery;
    return $jbd9B(query, variables, (0, $8f45fb6babb76faa$var$_objectSpread2["default"])((0, $8f45fb6babb76faa$var$_objectSpread2["default"])({}, options), {}, {
        fetchPolicy: 'store-only'
    }));
}
module.exports = $8f45fb6babb76faa$var$useClientQuery;

});
parcelRegister("jbd9B", function(module, exports) {
'use strict';

var $fJ7si = parcelRequire("fJ7si");

var $50MaW = parcelRequire("50MaW");

var $1G3Wj = parcelRequire("1G3Wj");

var $5ohfX = parcelRequire("5ohfX");
var $df693f7737b78a4e$var$fetchQuery = $5ohfX.__internal.fetchQuery;
function $df693f7737b78a4e$var$useLazyLoadQuery(gqlQuery, variables, options) {
    var environment = $1G3Wj();
    var query = $50MaW(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
        force: true
    });
    var data = $fJ7si({
        componentDisplayName: 'useLazyLoadQuery()',
        fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
        fetchObservable: $df693f7737b78a4e$var$fetchQuery(environment, query),
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        query: query,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
}
module.exports = $df693f7737b78a4e$var$useLazyLoadQuery;

});
parcelRegister("fJ7si", function(module, exports) {
'use strict';

var $e5do4 = parcelRequire("e5do4");

var $57w1d = parcelRequire("57w1d");
var $b730d775bf543a30$var$getQueryCacheIdentifier = $57w1d.getQueryCacheIdentifier, $b730d775bf543a30$var$getQueryResourceForEnvironment = $57w1d.getQueryResourceForEnvironment;

var $hVHUq = parcelRequire("hVHUq");

var $856c9 = parcelRequire("856c9");

var $1G3Wj = parcelRequire("1G3Wj");

var $2hRE7 = parcelRequire("2hRE7");
var $b730d775bf543a30$var$useContext = $2hRE7.useContext, $b730d775bf543a30$var$useEffect = $2hRE7.useEffect, $b730d775bf543a30$var$useState = $2hRE7.useState, $b730d775bf543a30$var$useRef = $2hRE7.useRef;
function $b730d775bf543a30$var$useLazyLoadQueryNode(_ref) {
    var query = _ref.query, componentDisplayName = _ref.componentDisplayName, fetchObservable = _ref.fetchObservable, fetchPolicy = _ref.fetchPolicy, fetchKey = _ref.fetchKey, renderPolicy = _ref.renderPolicy;
    var environment = $1G3Wj();
    var profilerContext = $b730d775bf543a30$var$useContext($e5do4);
    var QueryResource = $b730d775bf543a30$var$getQueryResourceForEnvironment(environment);
    var _useState = $b730d775bf543a30$var$useState(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = $hVHUq(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : '');
    var cacheIdentifier = $b730d775bf543a30$var$getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
    var preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
        return QueryResource.prepareWithIdentifier(cacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
            start: startFetch,
            complete: completeFetch,
            error: completeFetch
        }, profilerContext);
    });
    var maybeHiddenOrFastRefresh = $b730d775bf543a30$var$useRef(false);
    $b730d775bf543a30$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $b730d775bf543a30$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            forceUpdate(function(n) {
                return n + 1;
            });
            return;
        }
        var disposable = QueryResource.retain(preparedQueryResult, profilerContext);
        return function() {
            disposable.dispose();
        };
    }, [
        environment,
        cacheIdentifier
    ]);
    $b730d775bf543a30$var$useEffect(function() {
        QueryResource.releaseTemporaryRetain(preparedQueryResult);
    });
    var fragmentNode = preparedQueryResult.fragmentNode, fragmentRef = preparedQueryResult.fragmentRef;
    var data = $856c9(fragmentNode, fragmentRef, componentDisplayName);
    return data;
}
module.exports = $b730d775bf543a30$var$useLazyLoadQueryNode;

});
parcelRegister("57w1d", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $3ba67166d89bfc01$var$_interopRequireDefault = $9Ew61.default;

var $3ba67166d89bfc01$var$_objectSpread2 = $3ba67166d89bfc01$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $3ba67166d89bfc01$var$_defineProperty2 = $3ba67166d89bfc01$var$_interopRequireDefault((parcelRequire("2bxFr")));

var $4YZs3 = parcelRequire("4YZs3");

var $by9aT = parcelRequire("by9aT");

var $1etGW = parcelRequire("1etGW");

var $5ohfX = parcelRequire("5ohfX");
var $3ba67166d89bfc01$var$isPromise = $5ohfX.isPromise;
parcelRequire("4j8bN");
var $3ba67166d89bfc01$var$CACHE_CAPACITY = 1000;
var $3ba67166d89bfc01$var$DEFAULT_FETCH_POLICY = 'store-or-network';
var $3ba67166d89bfc01$var$DEFAULT_LIVE_FETCH_POLICY = 'store-and-network';
var $3ba67166d89bfc01$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
function $3ba67166d89bfc01$var$operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== undefined;
}
function $3ba67166d89bfc01$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $3ba67166d89bfc01$var$operationIsLiveQuery(operation) ? $3ba67166d89bfc01$var$DEFAULT_LIVE_FETCH_POLICY : $3ba67166d89bfc01$var$DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    return cacheIdentifier;
}
function $3ba67166d89bfc01$var$getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $3ba67166d89bfc01$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    return {
        cacheIdentifier: cacheIdentifier,
        fragmentNode: operation.request.node.fragment,
        fragmentRef: rootFragmentRef,
        operation: operation
    };
}
var $3ba67166d89bfc01$var$nextID = 200000;
function $3ba67166d89bfc01$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = $3ba67166d89bfc01$var$operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new $by9aT(function(environment) {
        var retention = environment.retain(operation);
        return {
            dispose: function dispose() {
                if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
                retention.dispose();
                onDispose(cacheEntry);
            }
        };
    });
    var cacheEntry = {
        cacheIdentifier: cacheIdentifier,
        id: $3ba67166d89bfc01$var$nextID++,
        processedPayloadsCount: 0,
        operationAvailability: operationAvailability,
        getValue: function getValue() {
            return currentValue;
        },
        setValue: function setValue(val) {
            currentValue = val;
        },
        setNetworkSubscription: function setNetworkSubscription(subscription) {
            if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
            currentNetworkSubscription = subscription;
        },
        temporaryRetain: function temporaryRetain(environment) {
            return suspenseResource.temporaryRetain(environment);
        },
        permanentRetain: function permanentRetain(environment) {
            return suspenseResource.permanentRetain(environment);
        },
        releaseTemporaryRetain: function releaseTemporaryRetain() {
            suspenseResource.releaseTemporaryRetain();
        }
    };
    return cacheEntry;
}
var $3ba67166d89bfc01$var$QueryResourceImpl = /*#__PURE__*/ function() {
    function QueryResourceImpl(environment) {
        var _this = this;
        (0, $3ba67166d89bfc01$var$_defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
            _this._cache["delete"](cacheEntry.cacheIdentifier);
        });
        this._environment = environment;
        this._cache = $4YZs3.create($3ba67166d89bfc01$var$CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
        var cacheIdentifier = $3ba67166d89bfc01$var$getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    };
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
        var environment = this._environment;
        var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $3ba67166d89bfc01$var$operationIsLiveQuery(operation) ? $3ba67166d89bfc01$var$DEFAULT_LIVE_FETCH_POLICY : $3ba67166d89bfc01$var$DEFAULT_FETCH_POLICY;
        var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
        var cacheEntry = this._cache.get(cacheIdentifier);
        var temporaryRetainDisposable = null;
        var entryWasCached = cacheEntry != null;
        if (cacheEntry == null) cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, $3ba67166d89bfc01$var$_objectSpread2["default"])((0, $3ba67166d89bfc01$var$_objectSpread2["default"])({}, observer), {}, {
            unsubscribe: function unsubscribe(subscription) {
                if (temporaryRetainDisposable != null) temporaryRetainDisposable.dispose();
                var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
                observerUnsubscribe && observerUnsubscribe(subscription);
            }
        }));
        temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
        var cachedValue = cacheEntry.getValue();
        if ($3ba67166d89bfc01$var$isPromise(cachedValue)) {
            environment.__log({
                name: 'suspense.query',
                fetchPolicy: fetchPolicy,
                isPromiseCached: entryWasCached,
                operation: operation,
                queryAvailability: cacheEntry.operationAvailability,
                renderPolicy: renderPolicy
            });
            throw cachedValue;
        }
        if (cachedValue instanceof Error) throw cachedValue;
        return cachedValue;
    };
    _proto.retain = function retain(queryResult, profilerContext) {
        var environment = this._environment;
        var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
        var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
        var disposable = cacheEntry.permanentRetain(environment);
        environment.__log({
            name: 'queryresource.retain',
            profilerContext: profilerContext,
            resourceID: cacheEntry.id
        });
        return {
            dispose: function dispose() {
                disposable.dispose();
            }
        };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
        var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
        if (cacheEntry != null) cacheEntry.releaseTemporaryRetain();
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
        var environment = this._environment;
        var cacheIdentifier = $3ba67166d89bfc01$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
        var cacheEntry = this._cache.get(cacheIdentifier);
        if (cacheEntry == null) {
            cacheEntry = $3ba67166d89bfc01$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, cacheEntry);
        }
        return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
        var _this2 = this;
        var environment = this._environment;
        var queryAvailability = environment.check(operation);
        var queryStatus = queryAvailability.status;
        var hasFullQuery = queryStatus === 'available';
        var canPartialRender = hasFullQuery || renderPolicy === 'partial' && queryStatus !== 'stale';
        var shouldFetch;
        var shouldAllowRender;
        var resolveNetworkPromise = function resolveNetworkPromise() {};
        switch(fetchPolicy){
            case 'store-only':
                shouldFetch = false;
                shouldAllowRender = true;
                break;
            case 'store-or-network':
                shouldFetch = !hasFullQuery;
                shouldAllowRender = canPartialRender;
                break;
            case 'store-and-network':
                shouldFetch = true;
                shouldAllowRender = canPartialRender;
                break;
            case 'network-only':
            default:
                shouldFetch = true;
                shouldAllowRender = false;
                break;
        }
        if (shouldAllowRender) {
            var queryResult = $3ba67166d89bfc01$var$getQueryResult(operation, cacheIdentifier);
            var _cacheEntry = $3ba67166d89bfc01$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, _cacheEntry);
        }
        if (shouldFetch) {
            var _queryResult = $3ba67166d89bfc01$var$getQueryResult(operation, cacheIdentifier);
            var networkSubscription;
            fetchObservable.subscribe({
                start: function start(subscription) {
                    networkSubscription = subscription;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(networkSubscription);
                    var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
                    if (observerStart) {
                        var subscriptionWithConditionalCancelation = (0, $3ba67166d89bfc01$var$_objectSpread2["default"])((0, $3ba67166d89bfc01$var$_objectSpread2["default"])({}, subscription), {}, {
                            unsubscribe: function unsubscribe() {
                                if ($3ba67166d89bfc01$var$operationIsLiveQuery(operation)) subscription.unsubscribe();
                            }
                        });
                        observerStart(subscriptionWithConditionalCancelation);
                    }
                },
                next: function next() {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
                    cacheEntry.processedPayloadsCount += 1;
                    cacheEntry.setValue(_queryResult);
                    resolveNetworkPromise();
                    var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
                    if (observerNext != null) {
                        var snapshot = environment.lookup(operation.fragment);
                        observerNext(snapshot);
                    }
                },
                error: function error(_error) {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
                    if (cacheEntry.processedPayloadsCount === 0) cacheEntry.setValue(_error);
                    resolveNetworkPromise();
                    networkSubscription = null;
                    cacheEntry.setNetworkSubscription(null);
                    var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
                    observerError && observerError(_error);
                },
                complete: function complete() {
                    resolveNetworkPromise();
                    networkSubscription = null;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(null);
                    var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
                    observerComplete && observerComplete();
                },
                unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
            });
            var _cacheEntry2 = this._cache.get(cacheIdentifier);
            if (!_cacheEntry2) {
                var networkPromise = new Promise(function(resolve) {
                    resolveNetworkPromise = resolve;
                });
                networkPromise.displayName = 'Relay(' + operation.fragment.node.name + ')';
                _cacheEntry2 = $3ba67166d89bfc01$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
                this._cache.set(cacheIdentifier, _cacheEntry2);
            }
        } else {
            var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete && observerComplete();
        }
        var cacheEntry = this._cache.get(cacheIdentifier);
        !(cacheEntry != null) && $1etGW(false);
        environment.__log({
            name: 'queryresource.fetch',
            resourceID: cacheEntry.id,
            operation: operation,
            profilerContext: profilerContext,
            fetchPolicy: fetchPolicy,
            renderPolicy: renderPolicy,
            queryAvailability: queryAvailability,
            shouldFetch: shouldFetch
        });
        return cacheEntry;
    };
    return QueryResourceImpl;
}();
function $3ba67166d89bfc01$var$createQueryResource(environment) {
    return new $3ba67166d89bfc01$var$QueryResourceImpl(environment);
}
var $3ba67166d89bfc01$var$dataResources = $3ba67166d89bfc01$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $3ba67166d89bfc01$var$getQueryResourceForEnvironment(environment) {
    var cached = $3ba67166d89bfc01$var$dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = $3ba67166d89bfc01$var$createQueryResource(environment);
    $3ba67166d89bfc01$var$dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createQueryResource: $3ba67166d89bfc01$var$createQueryResource,
    getQueryResourceForEnvironment: $3ba67166d89bfc01$var$getQueryResourceForEnvironment,
    getQueryCacheIdentifier: $3ba67166d89bfc01$var$getQueryCacheIdentifier
};

});
parcelRegister("4YZs3", function(module, exports) {
'use strict';

var $1etGW = parcelRequire("1etGW");
var $3a0c6f048c8da3ca$var$LRUCache = /*#__PURE__*/ function() {
    function LRUCache(capacity) {
        this._capacity = capacity;
        !(this._capacity > 0) && $1etGW(false);
        this._map = new Map();
    }
    var _proto = LRUCache.prototype;
    _proto.set = function set(key, value) {
        this._map["delete"](key);
        this._map.set(key, value);
        if (this._map.size > this._capacity) {
            var firstKey = this._map.keys().next();
            if (!firstKey.done) this._map["delete"](firstKey.value);
        }
    };
    _proto.get = function get(key) {
        var value = this._map.get(key);
        if (value != null) {
            this._map["delete"](key);
            this._map.set(key, value);
        }
        return value;
    };
    _proto.has = function has(key) {
        return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
        this._map["delete"](key);
    };
    _proto.size = function size() {
        return this._map.size;
    };
    _proto.capacity = function capacity() {
        return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
        this._map.clear();
    };
    return LRUCache;
}();
function $3a0c6f048c8da3ca$var$create(capacity) {
    return new $3a0c6f048c8da3ca$var$LRUCache(capacity);
}
module.exports = {
    create: $3a0c6f048c8da3ca$var$create
};

});

parcelRegister("by9aT", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $8689fc965804432b$var$_interopRequireDefault = $9Ew61.default;

var $8689fc965804432b$var$_defineProperty2 = $8689fc965804432b$var$_interopRequireDefault((parcelRequire("2bxFr")));
parcelRequire("4j8bN");
var $8689fc965804432b$var$TEMPORARY_RETAIN_DURATION_MS = 300000;
var $8689fc965804432b$var$SuspenseResource = /*#__PURE__*/ function() {
    function SuspenseResource(retain) {
        var _this = this;
        (0, $8689fc965804432b$var$_defineProperty2["default"])(this, "_retainCount", 0);
        (0, $8689fc965804432b$var$_defineProperty2["default"])(this, "_retainDisposable", null);
        (0, $8689fc965804432b$var$_defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
        this._retain = function(environment) {
            _this._retainCount++;
            if (_this._retainCount === 1) _this._retainDisposable = retain(environment);
            return {
                dispose: function dispose() {
                    _this._retainCount = Math.max(0, _this._retainCount - 1);
                    if (_this._retainCount === 0) {
                        if (_this._retainDisposable != null) {
                            _this._retainDisposable.dispose();
                            _this._retainDisposable = null;
                        }
                    }
                }
            };
        };
    }
    var _proto = SuspenseResource.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
        var _this2 = this;
        var _this$_releaseTempora;
        if (environment.isServer()) return {
            dispose: function dispose() {}
        };
        var retention = this._retain(environment);
        var releaseQueryTimeout = null;
        var releaseTemporaryRetain = function releaseTemporaryRetain() {
            clearTimeout(releaseQueryTimeout);
            releaseQueryTimeout = null;
            _this2._releaseTemporaryRetain = null;
            retention.dispose();
        };
        releaseQueryTimeout = setTimeout(releaseTemporaryRetain, $8689fc965804432b$var$TEMPORARY_RETAIN_DURATION_MS);
        (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 || _this$_releaseTempora.call(this);
        this._releaseTemporaryRetain = releaseTemporaryRetain;
        return {
            dispose: function dispose() {
                var _this$_releaseTempora2;
                (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 || _this$_releaseTempora2.call(_this2);
            }
        };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
        var disposable = this._retain(environment);
        this.releaseTemporaryRetain();
        return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
        var _this$_releaseTempora3;
        (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 || _this$_releaseTempora3.call(this);
        this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
        return this._retainCount;
    };
    return SuspenseResource;
}();
module.exports = $8689fc965804432b$var$SuspenseResource;

});


parcelRegister("hVHUq", function(module, exports) {
'use strict';

var $a4NG9 = parcelRequire("a4NG9");

var $2hRE7 = parcelRequire("2hRE7");
var $d0d9d1f1dc3d17d4$var$useCallback = $2hRE7.useCallback, $d0d9d1f1dc3d17d4$var$useEffect = $2hRE7.useEffect;
function $d0d9d1f1dc3d17d4$var$useFetchTrackingRef() {
    var subscriptionRef = $a4NG9(null);
    var isFetchingRef = $a4NG9(false);
    var disposeFetch = $d0d9d1f1dc3d17d4$var$useCallback(function() {
        if (subscriptionRef.current != null) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
        isFetchingRef.current = false;
    }, []);
    var startFetch = $d0d9d1f1dc3d17d4$var$useCallback(function(subscription) {
        subscriptionRef.current = subscription;
        isFetchingRef.current = true;
    }, []);
    var completeFetch = $d0d9d1f1dc3d17d4$var$useCallback(function() {
        subscriptionRef.current = null;
        isFetchingRef.current = false;
    }, []);
    $d0d9d1f1dc3d17d4$var$useEffect(function() {
        return disposeFetch;
    }, [
        disposeFetch
    ]);
    return {
        isFetchingRef: isFetchingRef,
        startFetch: startFetch,
        disposeFetch: disposeFetch,
        completeFetch: completeFetch
    };
}
module.exports = $d0d9d1f1dc3d17d4$var$useFetchTrackingRef;

});
parcelRegister("a4NG9", function(module, exports) {
'use strict';

var $2hRE7 = parcelRequire("2hRE7");
var $7560d0459658e426$var$useMemo = $2hRE7.useMemo;
function $7560d0459658e426$var$useUnsafeRef_DEPRECATED(init) {
    return $7560d0459658e426$var$useMemo(function() {
        return {
            current: init
        };
    }, []);
}
module.exports = $7560d0459658e426$var$useUnsafeRef_DEPRECATED;

});


parcelRegister("856c9", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $5e239891ace361cf$var$_interopRequireDefault = $9Ew61.default;

var $5e239891ace361cf$var$_useFragmentInternal_CURRENT = $5e239891ace361cf$var$_interopRequireDefault((parcelRequire("5ajjP")));

var $5e239891ace361cf$var$_useFragmentInternal_EXPERIMENTAL = $5e239891ace361cf$var$_interopRequireDefault((parcelRequire("aH7bV")));

var $5ohfX = parcelRequire("5ohfX");
function $5e239891ace361cf$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    if ($5ohfX.RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return (0, $5e239891ace361cf$var$_useFragmentInternal_EXPERIMENTAL["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
    return (0, $5e239891ace361cf$var$_useFragmentInternal_CURRENT["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
}
module.exports = $5e239891ace361cf$var$useFragmentInternal;

});
parcelRegister("5ajjP", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $3c2cdf430e7a54ca$var$_interopRequireDefault = $9Ew61.default;

var $3c2cdf430e7a54ca$var$_objectSpread2 = $3c2cdf430e7a54ca$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $3c2cdf430e7a54ca$var$_createForOfIteratorHelper2 = $3c2cdf430e7a54ca$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $3c2cdf430e7a54ca$var$_toConsumableArray2 = $3c2cdf430e7a54ca$var$_interopRequireDefault((parcelRequire("4Ika6")));

var $57w1d = parcelRequire("57w1d");
var $3c2cdf430e7a54ca$var$getQueryResourceForEnvironment = $57w1d.getQueryResourceForEnvironment;

var $1G3Wj = parcelRequire("1G3Wj");

var $7GTX5 = parcelRequire("7GTX5");

var $1etGW = parcelRequire("1etGW");

var $2hRE7 = parcelRequire("2hRE7");
var $3c2cdf430e7a54ca$var$useDebugValue = $2hRE7.useDebugValue, $3c2cdf430e7a54ca$var$useEffect = $2hRE7.useEffect, $3c2cdf430e7a54ca$var$useMemo = $2hRE7.useMemo, $3c2cdf430e7a54ca$var$useRef = $2hRE7.useRef, $3c2cdf430e7a54ca$var$useState = $2hRE7.useState;

var $5ohfX = parcelRequire("5ohfX");
var $3c2cdf430e7a54ca$var$_require3$__internal = $5ohfX.__internal, $3c2cdf430e7a54ca$var$fetchQueryInternal = $3c2cdf430e7a54ca$var$_require3$__internal.fetchQuery, $3c2cdf430e7a54ca$var$getPromiseForActiveRequest = $3c2cdf430e7a54ca$var$_require3$__internal.getPromiseForActiveRequest, $3c2cdf430e7a54ca$var$RelayFeatureFlags = $5ohfX.RelayFeatureFlags, $3c2cdf430e7a54ca$var$areEqualSelectors = $5ohfX.areEqualSelectors, $3c2cdf430e7a54ca$var$createOperationDescriptor = $5ohfX.createOperationDescriptor, $3c2cdf430e7a54ca$var$getPendingOperationsForFragment = $5ohfX.getPendingOperationsForFragment, $3c2cdf430e7a54ca$var$getSelector = $5ohfX.getSelector, $3c2cdf430e7a54ca$var$getVariablesFromFragment = $5ohfX.getVariablesFromFragment, $3c2cdf430e7a54ca$var$handlePotentialSnapshotErrors = $5ohfX.handlePotentialSnapshotErrors, $3c2cdf430e7a54ca$var$recycleNodesInto = $5ohfX.recycleNodesInto;
parcelRequire("4j8bN");
function $3c2cdf430e7a54ca$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $3c2cdf430e7a54ca$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $3c2cdf430e7a54ca$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $3c2cdf430e7a54ca$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $3c2cdf430e7a54ca$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $3c2cdf430e7a54ca$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $3c2cdf430e7a54ca$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $3c2cdf430e7a54ca$var$handlePotentialSnapshotErrorsForState(environment, state, loggingContext) {
    if (state.kind === 'singular') $3c2cdf430e7a54ca$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors, loggingContext);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, $3c2cdf430e7a54ca$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $3c2cdf430e7a54ca$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors, loggingContext);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $3c2cdf430e7a54ca$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $3c2cdf430e7a54ca$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            fieldErrors: currentSnapshot.fieldErrors
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $3c2cdf430e7a54ca$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                fieldErrors: _currentSnapshot.fieldErrors
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $1etGW(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch
            }
        ];
    }
}
function $3c2cdf430e7a54ca$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $3c2cdf430e7a54ca$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $3c2cdf430e7a54ca$var$_objectSpread2["default"])((0, $3c2cdf430e7a54ca$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $3c2cdf430e7a54ca$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $3c2cdf430e7a54ca$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $3c2cdf430e7a54ca$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        $3c2cdf430e7a54ca$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function $3c2cdf430e7a54ca$var$subscribeToSnapshot(environment, state, setState, hasPendingStateChanges) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector) {
                    var updates = $3c2cdf430e7a54ca$var$handleMissedUpdates(environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], nextState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        hasPendingStateChanges.current = dataChanged;
                        return dataChanged ? nextState : prevState;
                    } else return prevState;
                }
                hasPendingStateChanges.current = true;
                return {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch()
                };
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector) {
                        var updates = $3c2cdf430e7a54ca$var$handleMissedUpdates(environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], nextState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            hasPendingStateChanges.current = hasPendingStateChanges.current || dataChanged;
                            return dataChanged ? nextState : prevState;
                        } else return prevState;
                    }
                    var updated = (0, $3c2cdf430e7a54ca$var$_toConsumableArray2["default"])(prevState.snapshots);
                    updated[index] = latestSnapshot;
                    hasPendingStateChanges.current = true;
                    return {
                        kind: 'plural',
                        snapshots: updated,
                        epoch: environment.getStore().getEpoch()
                    };
                });
            });
        });
        return function() {
            var _iterator6 = (0, $3c2cdf430e7a54ca$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $3c2cdf430e7a54ca$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch()
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $3c2cdf430e7a54ca$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $3c2cdf430e7a54ca$var$useMemo(function() {
        return $3c2cdf430e7a54ca$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $1etGW(false);
    else !!Array.isArray(fragmentRef) && $1etGW(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $1etGW(false);
    var environment = $1G3Wj();
    var loggerContext;
    if ($3c2cdf430e7a54ca$var$RelayFeatureFlags.ENABLE_UI_CONTEXT_ON_RELAY_LOGGER) loggerContext = $7GTX5();
    var _useState = $3c2cdf430e7a54ca$var$useState(function() {
        return $3c2cdf430e7a54ca$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var _useState2 = $3c2cdf430e7a54ca$var$useState(state), _subscribedState = _useState2[0], setSubscribedState = _useState2[1];
    var subscribedState = _subscribedState;
    var _useState3 = $3c2cdf430e7a54ca$var$useState(fragmentSelector), previousFragmentSelector = _useState3[0], setPreviousFragmentSelector = _useState3[1];
    var _useState4 = $3c2cdf430e7a54ca$var$useState(environment), previousEnvironment = _useState4[0], setPreviousEnvironment = _useState4[1];
    if (!$3c2cdf430e7a54ca$var$areEqualSelectors(fragmentSelector, previousFragmentSelector) || environment !== previousEnvironment) {
        setPreviousFragmentSelector(fragmentSelector);
        setPreviousEnvironment(environment);
        var newState = $3c2cdf430e7a54ca$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        setSubscribedState(newState);
        state = newState;
        subscribedState = newState;
    }
    var committedFragmentSelectorRef = $3c2cdf430e7a54ca$var$useRef(false);
    $3c2cdf430e7a54ca$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $3c2cdf430e7a54ca$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var _useMemo = $3c2cdf430e7a54ca$var$useMemo(function() {
            var missingClientEdges = $3c2cdf430e7a54ca$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $3c2cdf430e7a54ca$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $3c2cdf430e7a54ca$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) throw Promise.all(activeRequestPromises);
        $3c2cdf430e7a54ca$var$useEffect(function() {
            var QueryResource = $3c2cdf430e7a54ca$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $3c2cdf430e7a54ca$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($3c2cdf430e7a54ca$var$isMissingData(state)) {
        var suspendingLiveResolvers = $3c2cdf430e7a54ca$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) throw Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
            return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
        if ($3c2cdf430e7a54ca$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$3c2cdf430e7a54ca$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $1etGW(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $3c2cdf430e7a54ca$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $3c2cdf430e7a54ca$var$handlePotentialSnapshotErrorsForState(environment, state, loggerContext);
    var hasPendingStateChanges = $3c2cdf430e7a54ca$var$useRef(false);
    $3c2cdf430e7a54ca$var$useEffect(function() {
        var currentState = subscribedState;
        var updates = $3c2cdf430e7a54ca$var$handleMissedUpdates(environment, subscribedState);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) setState(updatedState);
            currentState = updatedState;
        }
        return $3c2cdf430e7a54ca$var$subscribeToSnapshot(environment, currentState, setState, hasPendingStateChanges);
    }, [
        environment,
        subscribedState
    ]);
    if (hasPendingStateChanges.current) {
        var updates = $3c2cdf430e7a54ca$var$handleMissedUpdates(environment, state);
        if (updates != null) {
            var hasStateUpdates = updates[0], updatedState = updates[1];
            if (hasStateUpdates) {
                setState(updatedState);
                state = updatedState;
            }
        }
        hasPendingStateChanges.current = false;
    }
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $3c2cdf430e7a54ca$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $1etGW(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $1etGW(false);
        data = state.snapshot.data;
    }
    if ($3c2cdf430e7a54ca$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $3c2cdf430e7a54ca$var$useFragmentInternal;

});
parcelRegister("7GTX5", function(module, exports) {
'use strict';

var $7MzUb = parcelRequire("7MzUb");

var $2hRE7 = parcelRequire("2hRE7");
var $5997db914bea7dc5$var$useContext = $2hRE7.useContext;
function $5997db914bea7dc5$var$useRelayLoggingContext() {
    return $5997db914bea7dc5$var$useContext($7MzUb);
}
module.exports = $5997db914bea7dc5$var$useRelayLoggingContext;

});
parcelRegister("7MzUb", function(module, exports) {
'use strict';

var $2hRE7 = parcelRequire("2hRE7");

var $5ohfX = parcelRequire("5ohfX");
var $5aa8de18eb828182$var$createRelayLoggingContext = $5ohfX.__internal.createRelayLoggingContext;
module.exports = $5aa8de18eb828182$var$createRelayLoggingContext($2hRE7);

});



parcelRegister("aH7bV", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $7c937f99cf15adee$var$_interopRequireDefault = $9Ew61.default;

var $7c937f99cf15adee$var$_objectSpread2 = $7c937f99cf15adee$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $7c937f99cf15adee$var$_createForOfIteratorHelper2 = $7c937f99cf15adee$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $7c937f99cf15adee$var$_toConsumableArray2 = $7c937f99cf15adee$var$_interopRequireDefault((parcelRequire("4Ika6")));

var $57w1d = parcelRequire("57w1d");
var $7c937f99cf15adee$var$getQueryResourceForEnvironment = $57w1d.getQueryResourceForEnvironment;

var $1G3Wj = parcelRequire("1G3Wj");

var $7GTX5 = parcelRequire("7GTX5");

var $1etGW = parcelRequire("1etGW");

var $2hRE7 = parcelRequire("2hRE7");
var $7c937f99cf15adee$var$useDebugValue = $2hRE7.useDebugValue, $7c937f99cf15adee$var$useEffect = $2hRE7.useEffect, $7c937f99cf15adee$var$useMemo = $2hRE7.useMemo, $7c937f99cf15adee$var$useRef = $2hRE7.useRef, $7c937f99cf15adee$var$useState = $2hRE7.useState;

var $5ohfX = parcelRequire("5ohfX");
var $7c937f99cf15adee$var$_require3$__internal = $5ohfX.__internal, $7c937f99cf15adee$var$fetchQueryInternal = $7c937f99cf15adee$var$_require3$__internal.fetchQuery, $7c937f99cf15adee$var$getPromiseForActiveRequest = $7c937f99cf15adee$var$_require3$__internal.getPromiseForActiveRequest, $7c937f99cf15adee$var$RelayFeatureFlags = $5ohfX.RelayFeatureFlags, $7c937f99cf15adee$var$areEqualSelectors = $5ohfX.areEqualSelectors, $7c937f99cf15adee$var$createOperationDescriptor = $5ohfX.createOperationDescriptor, $7c937f99cf15adee$var$getPendingOperationsForFragment = $5ohfX.getPendingOperationsForFragment, $7c937f99cf15adee$var$getSelector = $5ohfX.getSelector, $7c937f99cf15adee$var$getVariablesFromFragment = $5ohfX.getVariablesFromFragment, $7c937f99cf15adee$var$handlePotentialSnapshotErrors = $5ohfX.handlePotentialSnapshotErrors, $7c937f99cf15adee$var$recycleNodesInto = $5ohfX.recycleNodesInto;
parcelRequire("4j8bN");
function $7c937f99cf15adee$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $7c937f99cf15adee$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $7c937f99cf15adee$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $7c937f99cf15adee$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $7c937f99cf15adee$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $7c937f99cf15adee$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $7c937f99cf15adee$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $7c937f99cf15adee$var$handlePotentialSnapshotErrorsForState(environment, state, loggingContext) {
    if (state.kind === 'singular') $7c937f99cf15adee$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors, loggingContext);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, $7c937f99cf15adee$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $7c937f99cf15adee$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors, loggingContext);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $7c937f99cf15adee$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $7c937f99cf15adee$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            fieldErrors: currentSnapshot.fieldErrors
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $7c937f99cf15adee$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                fieldErrors: _currentSnapshot.fieldErrors
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $1etGW(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    }
}
function $7c937f99cf15adee$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $7c937f99cf15adee$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $7c937f99cf15adee$var$_objectSpread2["default"])((0, $7c937f99cf15adee$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $7c937f99cf15adee$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $7c937f99cf15adee$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $7c937f99cf15adee$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    var promise = $7c937f99cf15adee$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request);
    if (promise != null && promise.displayName == null) promise.displayName = missingClientEdgeRequestInfo.request.params.name;
    return [
        queryResult,
        promise
    ];
}
function $7c937f99cf15adee$var$subscribeToSnapshot(environment, state, setState) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                var nextState = null;
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector || prevState.environment !== environment) {
                    var updates = $7c937f99cf15adee$var$handleMissedUpdates(prevState.environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], updatedState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        nextState = dataChanged ? updatedState : prevState;
                    } else nextState = prevState;
                } else nextState = {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch(),
                    selector: state.selector,
                    environment: state.environment
                };
                return nextState;
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    var nextState = null;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector || prevState.environment !== environment) {
                        var updates = $7c937f99cf15adee$var$handleMissedUpdates(prevState.environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], updatedState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            nextState = dataChanged ? updatedState : prevState;
                        } else nextState = prevState;
                    } else {
                        var updated = (0, $7c937f99cf15adee$var$_toConsumableArray2["default"])(prevState.snapshots);
                        updated[index] = latestSnapshot;
                        nextState = {
                            kind: 'plural',
                            snapshots: updated,
                            epoch: environment.getStore().getEpoch(),
                            selector: state.selector,
                            environment: state.environment
                        };
                    }
                    return nextState;
                });
            });
        });
        return function() {
            var _iterator6 = (0, $7c937f99cf15adee$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $7c937f99cf15adee$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout',
        environment: environment
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
}
function $7c937f99cf15adee$var$useFragmentInternal_EXPERIMENTAL(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $7c937f99cf15adee$var$useMemo(function() {
        return $7c937f99cf15adee$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $1etGW(false);
    else !!Array.isArray(fragmentRef) && $1etGW(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $1etGW(false);
    var environment = $1G3Wj();
    var loggerContext;
    if ($7c937f99cf15adee$var$RelayFeatureFlags.ENABLE_UI_CONTEXT_ON_RELAY_LOGGER) loggerContext = $7GTX5();
    var _useState = $7c937f99cf15adee$var$useState(function() {
        return $7c937f99cf15adee$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var previousEnvironment = state.environment;
    if (!$7c937f99cf15adee$var$areEqualSelectors(fragmentSelector, state.selector) || environment !== state.environment) {
        var newState = $7c937f99cf15adee$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        state = newState;
    }
    var committedFragmentSelectorRef = $7c937f99cf15adee$var$useRef(false);
    $7c937f99cf15adee$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $7c937f99cf15adee$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var _useMemo = $7c937f99cf15adee$var$useMemo(function() {
            var missingClientEdges = $7c937f99cf15adee$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $7c937f99cf15adee$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $7c937f99cf15adee$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) {
            var allPromises = Promise.all(activeRequestPromises);
            allPromises.displayName = "RelayClientEdge(".concat(activeRequestPromises.map(function(promise) {
                return promise.displayName;
            }).join(','), ")");
            throw allPromises;
        }
        $7c937f99cf15adee$var$useEffect(function() {
            var QueryResource = $7c937f99cf15adee$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $7c937f99cf15adee$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($7c937f99cf15adee$var$isMissingData(state)) {
        var suspendingLiveResolvers = $7c937f99cf15adee$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) {
            var promise = Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
                return environment.getStore().getLiveResolverPromise(liveStateID);
            }));
            promise.displayName = 'RelayLiveResolver(' + fragmentNode.name + ')';
            throw promise;
        }
        if ($7c937f99cf15adee$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$7c937f99cf15adee$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $1etGW(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $7c937f99cf15adee$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $7c937f99cf15adee$var$handlePotentialSnapshotErrorsForState(environment, state, loggerContext);
    var storeSubscriptionRef = $7c937f99cf15adee$var$useRef(null);
    $7c937f99cf15adee$var$useEffect(function() {
        var storeSubscription = storeSubscriptionRef.current;
        if (storeSubscription != null) {
            if (state.environment === storeSubscription.environment && state.selector === storeSubscription.selector) return;
            else storeSubscription.dispose();
        }
        if (state.kind === 'bailout') return;
        var stateForSubscription = state;
        var updates = $7c937f99cf15adee$var$handleMissedUpdates(state.environment, state);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) {
                setState(updatedState);
                return;
            }
            stateForSubscription = updatedState;
        }
        var dispose = $7c937f99cf15adee$var$subscribeToSnapshot(state.environment, stateForSubscription, setState);
        storeSubscriptionRef.current = {
            dispose: dispose,
            selector: state.selector,
            environment: state.environment
        };
    }, [
        state
    ]);
    $7c937f99cf15adee$var$useEffect(function() {
        if (storeSubscriptionRef.current == null && state.kind !== 'bailout') {
            var dispose = $7c937f99cf15adee$var$subscribeToSnapshot(state.environment, state, setState);
            storeSubscriptionRef.current = {
                dispose: dispose,
                selector: state.selector,
                environment: state.environment
            };
        }
        return function() {
            var _storeSubscriptionRef;
            (_storeSubscriptionRef = storeSubscriptionRef.current) === null || _storeSubscriptionRef === void 0 || _storeSubscriptionRef.dispose();
            storeSubscriptionRef.current = null;
        };
    }, []);
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $7c937f99cf15adee$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $1etGW(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $1etGW(false);
        data = state.snapshot.data;
    }
    if ($7c937f99cf15adee$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $7c937f99cf15adee$var$useFragmentInternal_EXPERIMENTAL;

});



parcelRegister("50MaW", function(module, exports) {
'use strict';

var $22NUH = parcelRequire("22NUH");

var $2hRE7 = parcelRequire("2hRE7");

var $5ohfX = parcelRequire("5ohfX");
var $3a625276d01e65d1$var$createOperationDescriptor = $5ohfX.createOperationDescriptor, $3a625276d01e65d1$var$getRequest = $5ohfX.getRequest;
var $3a625276d01e65d1$var$useMemo = $2hRE7.useMemo;
function $3a625276d01e65d1$var$useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = $22NUH(variables);
    var memoCacheConfig = $22NUH(cacheConfig || {});
    return $3a625276d01e65d1$var$useMemo(function() {
        return $3a625276d01e65d1$var$createOperationDescriptor($3a625276d01e65d1$var$getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [
        gqlQuery,
        memoVariables,
        memoCacheConfig
    ]);
}
module.exports = $3a625276d01e65d1$var$useMemoOperationDescriptor;

});
parcelRegister("22NUH", function(module, exports) {
'use strict';

var $4MrjW = parcelRequire("4MrjW");

var $2hRE7 = parcelRequire("2hRE7");
var $17d27c7733f04b3f$var$useState = $2hRE7.useState;
function $17d27c7733f04b3f$var$useMemoVariables(variables) {
    var _useState = $17d27c7733f04b3f$var$useState(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if ($4MrjW(variables, mirroredVariables)) return mirroredVariables;
    else {
        setMirroredVariables(variables);
        return variables;
    }
}
module.exports = $17d27c7733f04b3f$var$useMemoVariables;

});




parcelRegister("5Xv8M", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $456a9e4df54e4d1d$var$_interopRequireDefault = $9Ew61.default;

var $456a9e4df54e4d1d$var$_createForOfIteratorHelper2 = $456a9e4df54e4d1d$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $fcNlB = parcelRequire("fcNlB");

var $9HYLw = parcelRequire("9HYLw");

var $2hRE7 = parcelRequire("2hRE7");
var $456a9e4df54e4d1d$var$useCallback = $2hRE7.useCallback, $456a9e4df54e4d1d$var$useEffect = $2hRE7.useEffect, $456a9e4df54e4d1d$var$useRef = $2hRE7.useRef, $456a9e4df54e4d1d$var$useState = $2hRE7.useState;
var $456a9e4df54e4d1d$var$initialNullEntryPointReferenceState = {
    kind: 'NullEntryPointReference'
};
function $456a9e4df54e4d1d$var$useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : $456a9e4df54e4d1d$var$initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = $9HYLw();
    var undisposedEntryPointReferencesRef = $456a9e4df54e4d1d$var$useRef(new Set([
        initialEntryPointReferenceInternal
    ]));
    var _useState = $456a9e4df54e4d1d$var$useState(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = $456a9e4df54e4d1d$var$useState(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = $456a9e4df54e4d1d$var$useCallback(function() {
        if (isMountedRef.current) {
            var nullEntryPointReference = {
                kind: 'NullEntryPointReference'
            };
            undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
            setEntryPointReference(nullEntryPointReference);
        }
    }, [
        setEntryPointReference,
        isMountedRef
    ]);
    var entryPointLoaderCallback = $456a9e4df54e4d1d$var$useCallback(function(params) {
        if (isMountedRef.current) {
            var updatedEntryPointReference = $fcNlB(environmentProvider, entryPoint, params);
            undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
            setEntryPointReference(updatedEntryPointReference);
            setEntryPointParams(params);
        }
    }, [
        environmentProvider,
        entryPoint,
        setEntryPointReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $456a9e4df54e4d1d$var$useRef(false);
    $456a9e4df54e4d1d$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $456a9e4df54e4d1d$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (entryPointReference.kind !== 'NullEntryPointReference' && entryPointParams != null) entryPointLoaderCallback(entryPointParams);
            return;
        }
        var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $456a9e4df54e4d1d$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedEntryPointReference = _step.value;
                    if (undisposedEntryPointReference === entryPointReference) break;
                    undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
                    if (undisposedEntryPointReference.kind !== 'NullEntryPointReference') undisposedEntryPointReference.dispose();
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        entryPointReference,
        entryPointParams,
        entryPointLoaderCallback,
        isMountedRef
    ]);
    $456a9e4df54e4d1d$var$useEffect(function() {
        return function disposeAllRemainingEntryPointReferences() {
            var _iterator2 = (0, $456a9e4df54e4d1d$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var unhandledStateChange = _step2.value;
                    if (unhandledStateChange.kind !== 'NullEntryPointReference') unhandledStateChange.dispose();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, []);
    return [
        entryPointReference.kind === 'NullEntryPointReference' ? null : entryPointReference,
        entryPointLoaderCallback,
        disposeEntryPoint
    ];
}
module.exports = $456a9e4df54e4d1d$var$useLoadEntryPoint;

});
parcelRegister("9HYLw", function(module, exports) {
'use strict';

var $2hRE7 = parcelRequire("2hRE7");
var $711743fe11723ab1$var$useEffect = $2hRE7.useEffect, $711743fe11723ab1$var$useRef = $2hRE7.useRef;
function $711743fe11723ab1$var$useIsMountedRef() {
    var isMountedRef = $711743fe11723ab1$var$useRef(true);
    $711743fe11723ab1$var$useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
module.exports = $711743fe11723ab1$var$useIsMountedRef;

});


parcelRegister("6yaQf", function(module, exports) {
'use strict';

var $856c9 = parcelRequire("856c9");

var $4cr8T = parcelRequire("4cr8T");

var $2hRE7 = parcelRequire("2hRE7");
var $4c4e53f820b02f41$var$useDebugValue = $2hRE7.useDebugValue;

var $5ohfX = parcelRequire("5ohfX");
var $4c4e53f820b02f41$var$getFragment = $5ohfX.getFragment;
function $4c4e53f820b02f41$var$useFragment(fragment, key) {
    var fragmentNode = $4c4e53f820b02f41$var$getFragment(fragment);
    $4cr8T(fragmentNode, 'first argument of useFragment()');
    var data = $856c9(fragmentNode, key, 'useFragment()');
    return data;
}
module.exports = $4c4e53f820b02f41$var$useFragment;

});
parcelRegister("4cr8T", function(module, exports) {
'use strict';
parcelRequire("a4NG9");
parcelRequire("4j8bN");
function $30ed565aeb983eed$var$useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    var initialPropRef;
}
module.exports = $30ed565aeb983eed$var$useStaticFragmentNodeWarning;

});


parcelRegister("5RMmF", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $44576b31cfe7f7b3$var$_interopRequireDefault = $9Ew61.default;

var $44576b31cfe7f7b3$var$_objectSpread2 = $44576b31cfe7f7b3$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $9HYLw = parcelRequire("9HYLw");

var $1G3Wj = parcelRequire("1G3Wj");

var $2hRE7 = parcelRequire("2hRE7");

var $5ohfX = parcelRequire("5ohfX");
var $44576b31cfe7f7b3$var$defaultCommitMutation = $5ohfX.commitMutation;
var $44576b31cfe7f7b3$var$useState = $2hRE7.useState, $44576b31cfe7f7b3$var$useEffect = $2hRE7.useEffect, $44576b31cfe7f7b3$var$useRef = $2hRE7.useRef, $44576b31cfe7f7b3$var$useCallback = $2hRE7.useCallback;
function $44576b31cfe7f7b3$var$useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $44576b31cfe7f7b3$var$defaultCommitMutation;
    var environment = $1G3Wj();
    var isMountedRef = $9HYLw();
    var environmentRef = $44576b31cfe7f7b3$var$useRef(environment);
    var mutationRef = $44576b31cfe7f7b3$var$useRef(mutation);
    var inFlightMutationsRef = $44576b31cfe7f7b3$var$useRef(new Set());
    var _useState = $44576b31cfe7f7b3$var$useState(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = $44576b31cfe7f7b3$var$useCallback(function(disposable) {
        if (environmentRef.current === environment && mutationRef.current === mutation) {
            inFlightMutationsRef.current["delete"](disposable);
            if (isMountedRef.current) setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    $44576b31cfe7f7b3$var$useEffect(function() {
        if (environmentRef.current !== environment || mutationRef.current !== mutation) {
            inFlightMutationsRef.current = new Set();
            if (isMountedRef.current) setMutationInFlight(false);
            environmentRef.current = environment;
            mutationRef.current = mutation;
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    var commit = $44576b31cfe7f7b3$var$useCallback(function(config) {
        if (isMountedRef.current) setMutationInFlight(true);
        var disposable = commitMutationFn(environment, (0, $44576b31cfe7f7b3$var$_objectSpread2["default"])((0, $44576b31cfe7f7b3$var$_objectSpread2["default"])({}, config), {}, {
            mutation: mutation,
            onCompleted: function onCompleted(response, errors) {
                var _config$onCompleted;
                cleanup(disposable);
                (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 || _config$onCompleted.call(config, response, errors);
            },
            onError: function onError(error) {
                var _config$onError;
                cleanup(disposable);
                (_config$onError = config.onError) === null || _config$onError === void 0 || _config$onError.call(config, error);
            },
            onUnsubscribe: function onUnsubscribe() {
                var _config$onUnsubscribe;
                cleanup(disposable);
                (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 || _config$onUnsubscribe.call(config);
            },
            onNext: function onNext() {
                var _config$onNext;
                (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
            }
        }));
        inFlightMutationsRef.current.add(disposable);
        return disposable;
    }, [
        cleanup,
        commitMutationFn,
        environment,
        isMountedRef,
        mutation
    ]);
    return [
        commit,
        isMutationInFlight
    ];
}
module.exports = $44576b31cfe7f7b3$var$useMutation;

});

parcelRegister("b91lf", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $81d1936787094e8e$var$_interopRequireDefault = $9Ew61.default;

var $81d1936787094e8e$var$_objectSpread2 = $81d1936787094e8e$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $bBOUi = parcelRequire("bBOUi");

var $8gmAu = parcelRequire("8gmAu");

var $1G3Wj = parcelRequire("1G3Wj");

var $4cr8T = parcelRequire("4cr8T");

var $2hRE7 = parcelRequire("2hRE7");
var $81d1936787094e8e$var$useCallback = $2hRE7.useCallback, $81d1936787094e8e$var$useDebugValue = $2hRE7.useDebugValue, $81d1936787094e8e$var$useState = $2hRE7.useState;

var $5ohfX = parcelRequire("5ohfX");
var $81d1936787094e8e$var$RelayFeatureFlags = $5ohfX.RelayFeatureFlags, $81d1936787094e8e$var$getFragment = $5ohfX.getFragment, $81d1936787094e8e$var$getFragmentIdentifier = $5ohfX.getFragmentIdentifier, $81d1936787094e8e$var$getPaginationMetadata = $5ohfX.getPaginationMetadata;
function $81d1936787094e8e$var$usePaginationFragment(fragmentInput, parentFragmentRef) {
    var fragmentNode = $81d1936787094e8e$var$getFragment(fragmentInput);
    $4cr8T(fragmentNode, 'first argument of usePaginationFragment()');
    var componentDisplayName = 'usePaginationFragment()';
    var _getPaginationMetadat = $81d1936787094e8e$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $8gmAu(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $81d1936787094e8e$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var _useLoadMore = $81d1936787094e8e$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'backward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    var _useLoadMore2 = $81d1936787094e8e$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = $81d1936787094e8e$var$useCallback(function(variables, options) {
        disposeFetchNext();
        disposeFetchPrevious();
        return refetch(variables, (0, $81d1936787094e8e$var$_objectSpread2["default"])((0, $81d1936787094e8e$var$_objectSpread2["default"])({}, options), {}, {
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        disposeFetchPrevious,
        refetch
    ]);
    return {
        data: fragmentData,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        refetch: refetchPagination
    };
}
function $81d1936787094e8e$var$useLoadMore(args) {
    var environment = $1G3Wj();
    var _useState = $81d1936787094e8e$var$useState(false), isLoadingMore = _useState[0], reallySetIsLoadingMore = _useState[1];
    var setIsLoadingMore = function setIsLoadingMore(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    };
    var observer = {
        start: function start() {
            return setIsLoadingMore(true);
        },
        complete: function complete() {
            return setIsLoadingMore(false);
        },
        error: function error() {
            return setIsLoadingMore(false);
        },
        unsubscribe: $81d1936787094e8e$var$RelayFeatureFlags.ENABLE_USE_PAGINATION_IS_LOADING_FIX ? function() {
            return setIsLoadingMore(false);
        } : undefined
    };
    var handleReset = function handleReset() {
        return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = $bBOUi((0, $81d1936787094e8e$var$_objectSpread2["default"])((0, $81d1936787094e8e$var$_objectSpread2["default"])({}, args), {}, {
        observer: observer,
        onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [
        loadMore,
        hasMore,
        isLoadingMore,
        disposeFetch
    ];
}
module.exports = $81d1936787094e8e$var$usePaginationFragment;

});
parcelRegister("bBOUi", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $873aa377296b4f68$var$_interopRequireDefault = $9Ew61.default;

var $873aa377296b4f68$var$_objectSpread2 = $873aa377296b4f68$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $hNsZ4 = parcelRequire("hNsZ4");

var $hVHUq = parcelRequire("hVHUq");

var $9HYLw = parcelRequire("9HYLw");

var $9X9Gq = parcelRequire("9X9Gq");

var $2xvbC = parcelRequire("2xvbC");

var $1G3Wj = parcelRequire("1G3Wj");

var $1etGW = parcelRequire("1etGW");

var $2hRE7 = parcelRequire("2hRE7");
var $873aa377296b4f68$var$useCallback = $2hRE7.useCallback, $873aa377296b4f68$var$useEffect = $2hRE7.useEffect, $873aa377296b4f68$var$useState = $2hRE7.useState;

var $5ohfX = parcelRequire("5ohfX");
var $873aa377296b4f68$var$fetchQuery = $5ohfX.__internal.fetchQuery, $873aa377296b4f68$var$RelayFeatureFlags = $5ohfX.RelayFeatureFlags, $873aa377296b4f68$var$createOperationDescriptor = $5ohfX.createOperationDescriptor, $873aa377296b4f68$var$getPaginationVariables = $5ohfX.getPaginationVariables, $873aa377296b4f68$var$getRefetchMetadata = $5ohfX.getRefetchMetadata, $873aa377296b4f68$var$getSelector = $5ohfX.getSelector;
parcelRequire("4j8bN");
function $873aa377296b4f68$var$useLoadMoreFunction(args) {
    if ($873aa377296b4f68$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $2xvbC(args);
    return $873aa377296b4f68$var$useLoadMoreFunction_CURRENT(args);
}
function $873aa377296b4f68$var$useLoadMoreFunction_CURRENT(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $1G3Wj();
    var _useFetchTrackingRef = $hVHUq(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var _getRefetchMetadata = $873aa377296b4f68$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var isMountedRef = $9HYLw();
    var _useState = $873aa377296b4f68$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $873aa377296b4f68$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $9X9Gq(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        disposeFetch();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $hNsZ4(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    $873aa377296b4f68$var$useEffect(function() {
        return function() {
            disposeFetch();
        };
    }, [
        disposeFetch
    ]);
    var isRequestInvalid = fragmentData == null || isParentQueryActive;
    var loadMore = $873aa377296b4f68$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $873aa377296b4f68$var$getSelector(fragmentNode, fragmentRef);
        if (isFetchingRef.current === true || isRequestInvalid) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $1etGW(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $873aa377296b4f68$var$_objectSpread2["default"])((0, $873aa377296b4f68$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $873aa377296b4f68$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $873aa377296b4f68$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $873aa377296b4f68$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $873aa377296b4f68$var$fetchQuery(environment, paginationQuery).subscribe((0, $873aa377296b4f68$var$_objectSpread2["default"])((0, $873aa377296b4f68$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                startFetch(subscription);
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                completeFetch();
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                completeFetch();
                observer.error && observer.error(_error);
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: disposeFetch
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        startFetch,
        disposeFetch,
        completeFetch,
        isFetchingRef,
        isRequestInvalid,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        disposeFetch
    ];
}
module.exports = $873aa377296b4f68$var$useLoadMoreFunction;

});
parcelRegister("hNsZ4", function(module, exports) {
'use strict';

var $1etGW = parcelRequire("1etGW");

var $5ohfX = parcelRequire("5ohfX");
var $cf4d7ee82e53bde4$var$ConnectionInterface = $5ohfX.ConnectionInterface, $cf4d7ee82e53bde4$var$getValueAtPath = $5ohfX.getValueAtPath;
function $cf4d7ee82e53bde4$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = $cf4d7ee82e53bde4$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = $cf4d7ee82e53bde4$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) return {
        cursor: null,
        hasMore: false
    };
    !(typeof connection === 'object') && $1etGW(false);
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) return {
        cursor: null,
        hasMore: false
    };
    !Array.isArray(edges) && $1etGW(false);
    !(typeof pageInfo === 'object') && $1etGW(false);
    var cursor = direction === 'forward' ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === 'string') && $1etGW(false);
    var hasMore;
    if (direction === 'forward') hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    else hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    return {
        cursor: cursor,
        hasMore: hasMore
    };
}
module.exports = $cf4d7ee82e53bde4$var$getConnectionState;

});

parcelRegister("9X9Gq", function(module, exports) {
'use strict';

var $1G3Wj = parcelRequire("1G3Wj");

var $1etGW = parcelRequire("1etGW");

var $2hRE7 = parcelRequire("2hRE7");

var $5ohfX = parcelRequire("5ohfX");
var $73f122a70dbd7d9e$var$getObservableForActiveRequest = $5ohfX.__internal.getObservableForActiveRequest, $73f122a70dbd7d9e$var$getSelector = $5ohfX.getSelector;
var $73f122a70dbd7d9e$var$useEffect = $2hRE7.useEffect, $73f122a70dbd7d9e$var$useState = $2hRE7.useState, $73f122a70dbd7d9e$var$useMemo = $2hRE7.useMemo;
function $73f122a70dbd7d9e$var$useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = $1G3Wj();
    var observable = $73f122a70dbd7d9e$var$useMemo(function() {
        var selector = $73f122a70dbd7d9e$var$getSelector(fragmentNode, fragmentRef);
        if (selector == null) return null;
        !(selector.kind === 'SingularReaderSelector') && $1etGW(false);
        return $73f122a70dbd7d9e$var$getObservableForActiveRequest(environment, selector.owner);
    }, [
        environment,
        fragmentNode,
        fragmentRef
    ]);
    var _useState = $73f122a70dbd7d9e$var$useState(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    $73f122a70dbd7d9e$var$useEffect(function() {
        var subscription;
        setIsActive(observable != null);
        if (observable != null) {
            var onCompleteOrError = function onCompleteOrError() {
                setIsActive(false);
            };
            subscription = observable.subscribe({
                complete: onCompleteOrError,
                error: onCompleteOrError
            });
        }
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return isActive;
}
module.exports = $73f122a70dbd7d9e$var$useIsOperationNodeActive;

});

parcelRegister("2xvbC", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $1d96dacc06580ba9$var$_interopRequireDefault = $9Ew61.default;

var $1d96dacc06580ba9$var$_objectSpread2 = $1d96dacc06580ba9$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $hNsZ4 = parcelRequire("hNsZ4");

var $9HYLw = parcelRequire("9HYLw");

var $9X9Gq = parcelRequire("9X9Gq");

var $1G3Wj = parcelRequire("1G3Wj");

var $1etGW = parcelRequire("1etGW");

var $2hRE7 = parcelRequire("2hRE7");
var $1d96dacc06580ba9$var$useCallback = $2hRE7.useCallback, $1d96dacc06580ba9$var$useRef = $2hRE7.useRef, $1d96dacc06580ba9$var$useState = $2hRE7.useState;

var $5ohfX = parcelRequire("5ohfX");
var $1d96dacc06580ba9$var$fetchQuery = $5ohfX.__internal.fetchQuery, $1d96dacc06580ba9$var$createOperationDescriptor = $5ohfX.createOperationDescriptor, $1d96dacc06580ba9$var$getPaginationVariables = $5ohfX.getPaginationVariables, $1d96dacc06580ba9$var$getRefetchMetadata = $5ohfX.getRefetchMetadata, $1d96dacc06580ba9$var$getSelector = $5ohfX.getSelector;
parcelRequire("4j8bN");
function $1d96dacc06580ba9$var$useLoadMoreFunction_EXPERIMENTAL(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $1G3Wj();
    var _getRefetchMetadata = $1d96dacc06580ba9$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var fetchStatusRef = $1d96dacc06580ba9$var$useRef({
        kind: 'none'
    });
    var _useState = $1d96dacc06580ba9$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $1d96dacc06580ba9$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $9X9Gq(fragmentNode, fragmentRef);
    var forceDisposeFn = $1d96dacc06580ba9$var$useCallback(function() {
        if (fetchStatusRef.current.kind === 'fetching') fetchStatusRef.current.subscription.unsubscribe();
        fetchStatusRef.current = {
            kind: 'none'
        };
    }, []);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        forceDisposeFn();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $hNsZ4(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    var isRequestInvalid = fragmentData == null || isParentQueryActive;
    var isMountedRef = $9HYLw();
    var loadMore = $1d96dacc06580ba9$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $1d96dacc06580ba9$var$getSelector(fragmentNode, fragmentRef);
        if (fetchStatusRef.current.kind === 'fetching' || isRequestInvalid) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $1etGW(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $1d96dacc06580ba9$var$_objectSpread2["default"])((0, $1d96dacc06580ba9$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $1d96dacc06580ba9$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $1d96dacc06580ba9$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $1d96dacc06580ba9$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $1d96dacc06580ba9$var$fetchQuery(environment, paginationQuery).subscribe((0, $1d96dacc06580ba9$var$_objectSpread2["default"])((0, $1d96dacc06580ba9$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                fetchStatusRef.current = {
                    kind: 'fetching',
                    subscription: subscription
                };
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: function dispose() {}
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        isRequestInvalid,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        forceDisposeFn
    ];
}
module.exports = $1d96dacc06580ba9$var$useLoadMoreFunction_EXPERIMENTAL;

});


parcelRegister("8gmAu", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $604156c5ed3b2f77$var$_interopRequireDefault = $9Ew61.default;

var $604156c5ed3b2f77$var$_objectSpread2 = $604156c5ed3b2f77$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $e5do4 = parcelRequire("e5do4");

var $57w1d = parcelRequire("57w1d");
var $604156c5ed3b2f77$var$getQueryResourceForEnvironment = $57w1d.getQueryResourceForEnvironment;

var $c9fxA = parcelRequire("c9fxA");

var $856c9 = parcelRequire("856c9");

var $9HYLw = parcelRequire("9HYLw");

var $aReUR = parcelRequire("aReUR");

var $1G3Wj = parcelRequire("1G3Wj");

var $1etGW = parcelRequire("1etGW");

var $2hRE7 = parcelRequire("2hRE7");
var $604156c5ed3b2f77$var$useCallback = $2hRE7.useCallback, $604156c5ed3b2f77$var$useContext = $2hRE7.useContext, $604156c5ed3b2f77$var$useReducer = $2hRE7.useReducer;

var $5ohfX = parcelRequire("5ohfX");
var $604156c5ed3b2f77$var$fetchQuery = $5ohfX.__internal.fetchQuery, $604156c5ed3b2f77$var$createOperationDescriptor = $5ohfX.createOperationDescriptor, $604156c5ed3b2f77$var$getFragmentIdentifier = $5ohfX.getFragmentIdentifier, $604156c5ed3b2f77$var$getRefetchMetadata = $5ohfX.getRefetchMetadata, $604156c5ed3b2f77$var$getSelector = $5ohfX.getSelector, $604156c5ed3b2f77$var$getValueAtPath = $5ohfX.getValueAtPath;
parcelRequire("4j8bN");
function $604156c5ed3b2f77$var$reducer(state, action) {
    switch(action.type){
        case 'refetch':
            var _action$refetchEnviro;
            return (0, $604156c5ed3b2f77$var$_objectSpread2["default"])((0, $604156c5ed3b2f77$var$_objectSpread2["default"])({}, state), {}, {
                fetchPolicy: action.fetchPolicy,
                mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
                onComplete: action.onComplete,
                refetchEnvironment: action.refetchEnvironment,
                refetchQuery: action.refetchQuery,
                renderPolicy: action.renderPolicy
            });
        case 'reset':
            return {
                fetchPolicy: undefined,
                mirroredEnvironment: action.environment,
                mirroredFragmentIdentifier: action.fragmentIdentifier,
                onComplete: undefined,
                refetchQuery: null,
                renderPolicy: undefined
            };
        default:
            action.type;
            throw new Error('useRefetchableFragmentNode: Unexpected action type');
    }
}
function $604156c5ed3b2f77$var$useRefetchableFragmentInternal(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = $1G3Wj();
    var _getRefetchMetadata = $604156c5ed3b2f77$var$getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierInfo = _getRefetchMetadata.identifierInfo;
    var fragmentIdentifier = $604156c5ed3b2f77$var$getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = $604156c5ed3b2f77$var$useReducer($604156c5ed3b2f77$var$reducer, {
        fetchPolicy: undefined,
        mirroredEnvironment: parentEnvironment,
        mirroredFragmentIdentifier: fragmentIdentifier,
        onComplete: undefined,
        refetchEnvironment: null,
        refetchQuery: null,
        renderPolicy: undefined
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource = $604156c5ed3b2f77$var$getQueryResourceForEnvironment(environment);
    var profilerContext = $604156c5ed3b2f77$var$useContext($e5do4);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = $aReUR(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
        dispatch({
            type: 'reset',
            environment: environment,
            fragmentIdentifier: fragmentIdentifier
        });
        disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
        var debugPreviousIDAndTypename;
        var handleQueryCompleted = function handleQueryCompleted(maybeError) {
            onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
        };
        var fetchObservable = queryRef.source != null ? queryRef.source : $604156c5ed3b2f77$var$fetchQuery(environment, refetchQuery);
        var queryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
                error: handleQueryCompleted,
                complete: function complete() {
                    handleQueryCompleted();
                }
            }, queryRef.fetchKey, profilerContext);
        });
        var queryData = $c9fxA(environment, queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
        !(queryData != null) && $1etGW(false);
        var refetchedFragmentRef = $604156c5ed3b2f77$var$getValueAtPath(queryData, fragmentRefPathInResponse);
        fragmentRef = refetchedFragmentRef;
    }
    var fragmentData = $856c9(fragmentNode, fragmentRef, componentDisplayName);
    var refetch = $604156c5ed3b2f77$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest);
    return {
        fragmentData: fragmentData,
        fragmentRef: fragmentRef,
        refetch: refetch
    };
}
function $604156c5ed3b2f77$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = $9HYLw();
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    return $604156c5ed3b2f77$var$useCallback(function(providedRefetchVariables, options) {
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        parentFragmentRef;
        var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
        var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
        var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        var fragmentSelector = $604156c5ed3b2f77$var$getSelector(fragmentNode, parentFragmentRef);
        var parentVariables;
        var fragmentVariables;
        if (fragmentSelector == null) {
            parentVariables = {};
            fragmentVariables = {};
        } else if (fragmentSelector.kind === 'PluralReaderSelector') {
            var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
            parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
            fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
        } else {
            parentVariables = fragmentSelector.owner.variables;
            fragmentVariables = fragmentSelector.variables;
        }
        var refetchVariables = (0, $604156c5ed3b2f77$var$_objectSpread2["default"])((0, $604156c5ed3b2f77$var$_objectSpread2["default"])((0, $604156c5ed3b2f77$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
        if (identifierInfo != null && !providedRefetchVariables.hasOwnProperty(identifierInfo.identifierQueryVariableName)) {
            typeof identifierValue;
            refetchVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var refetchQuery = $604156c5ed3b2f77$var$createOperationDescriptor(refetchableRequest, refetchVariables, {
            force: true
        });
        loadQuery(refetchQuery.request.variables, {
            fetchPolicy: fetchPolicy,
            __environment: refetchEnvironment,
            __nameForWarning: 'refetch'
        });
        dispatch({
            type: 'refetch',
            fetchPolicy: fetchPolicy,
            onComplete: onComplete,
            refetchEnvironment: refetchEnvironment,
            refetchQuery: refetchQuery,
            renderPolicy: renderPolicy
        });
        return {
            dispose: disposeQuery
        };
    }, [
        fragmentIdentifier,
        dispatch,
        disposeQuery,
        identifierValue,
        loadQuery
    ]);
}
var $604156c5ed3b2f77$var$debugFunctions;
module.exports = $604156c5ed3b2f77$var$useRefetchableFragmentInternal;

});
parcelRegister("c9fxA", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $8d826162cc9b840c$var$_interopRequireDefault = $9Ew61.default;

var $8d826162cc9b840c$var$_objectSpread2 = $8d826162cc9b840c$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $8d826162cc9b840c$var$_createForOfIteratorHelper2 = $8d826162cc9b840c$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $57w1d = parcelRequire("57w1d");
var $8d826162cc9b840c$var$getQueryResourceForEnvironment = $57w1d.getQueryResourceForEnvironment;

var $1etGW = parcelRequire("1etGW");

var $5ohfX = parcelRequire("5ohfX");
var $8d826162cc9b840c$var$fetchQueryInternal = $5ohfX.__internal.fetchQuery, $8d826162cc9b840c$var$RelayFeatureFlags = $5ohfX.RelayFeatureFlags, $8d826162cc9b840c$var$createOperationDescriptor = $5ohfX.createOperationDescriptor, $8d826162cc9b840c$var$getPendingOperationsForFragment = $5ohfX.getPendingOperationsForFragment, $8d826162cc9b840c$var$getSelector = $5ohfX.getSelector, $8d826162cc9b840c$var$getVariablesFromFragment = $5ohfX.getVariablesFromFragment, $8d826162cc9b840c$var$handlePotentialSnapshotErrors = $5ohfX.handlePotentialSnapshotErrors;
parcelRequire("4j8bN");
function $8d826162cc9b840c$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $8d826162cc9b840c$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $8d826162cc9b840c$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $8d826162cc9b840c$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $8d826162cc9b840c$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') $8d826162cc9b840c$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors);
    else if (state.kind === 'plural') {
        var _iterator3 = (0, $8d826162cc9b840c$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                $8d826162cc9b840c$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    }
}
function $8d826162cc9b840c$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $8d826162cc9b840c$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $8d826162cc9b840c$var$_objectSpread2["default"])((0, $8d826162cc9b840c$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $8d826162cc9b840c$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $8d826162cc9b840c$var$getQueryResourceForEnvironment(environment);
    return QueryResource.prepare(queryOperationDescriptor, $8d826162cc9b840c$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
}
function $8d826162cc9b840c$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') {
        if (fragmentSelector.selectors.length === 0) return {
            kind: 'bailout'
        };
        else return {
            kind: 'plural',
            snapshots: fragmentSelector.selectors.map(function(s) {
                return environment.lookup(s);
            }),
            epoch: environment.getStore().getEpoch()
        };
    } else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $8d826162cc9b840c$var$readFragmentInternal(environment, fragmentNode, fragmentRef, hookDisplayName, queryOptions, fragmentKey) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $8d826162cc9b840c$var$getSelector(fragmentNode, fragmentRef);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $1etGW(false);
    else !!Array.isArray(fragmentRef) && $1etGW(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $1etGW(false);
    var state = $8d826162cc9b840c$var$getFragmentState(environment, fragmentSelector);
    var clientEdgeQueries = null;
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $8d826162cc9b840c$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var missingClientEdges = $8d826162cc9b840c$var$getMissingClientEdges(state);
        if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
            clientEdgeQueries = [];
            var _iterator4 = (0, $8d826162cc9b840c$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var edge = _step4.value;
                    clientEdgeQueries.push($8d826162cc9b840c$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions));
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    }
    if ($8d826162cc9b840c$var$isMissingData(state)) {
        !(fragmentSelector != null) && $1etGW(false);
        var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var pendingOperationsResult = $8d826162cc9b840c$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult) throw pendingOperationsResult.promise;
        $8d826162cc9b840c$var$handlePotentialSnapshotErrorsForState(environment, state);
    }
    var data;
    if (state.kind === 'bailout') data = isPlural ? [] : null;
    else if (state.kind === 'singular') data = state.snapshot.data;
    else data = state.snapshots.map(function(s) {
        return s.data;
    });
    if ($8d826162cc9b840c$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return {
        data: data,
        clientEdgeQueries: clientEdgeQueries
    };
}
module.exports = $8d826162cc9b840c$var$readFragmentInternal;

});

parcelRegister("aReUR", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $7e7a6cac9a7e5bd6$var$_interopRequireDefault = $9Ew61.default;

var $7e7a6cac9a7e5bd6$var$_createForOfIteratorHelper2 = $7e7a6cac9a7e5bd6$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $83mO0 = parcelRequire("83mO0");
var $7e7a6cac9a7e5bd6$var$loadQuery = $83mO0.loadQuery;

var $9HYLw = parcelRequire("9HYLw");

var $64kjS = parcelRequire("64kjS");

var $1G3Wj = parcelRequire("1G3Wj");

var $2hRE7 = parcelRequire("2hRE7");
var $7e7a6cac9a7e5bd6$var$useCallback = $2hRE7.useCallback, $7e7a6cac9a7e5bd6$var$useEffect = $2hRE7.useEffect, $7e7a6cac9a7e5bd6$var$useRef = $2hRE7.useRef, $7e7a6cac9a7e5bd6$var$useState = $2hRE7.useState;

var $5ohfX = parcelRequire("5ohfX");
var $7e7a6cac9a7e5bd6$var$RelayFeatureFlags = $5ohfX.RelayFeatureFlags, $7e7a6cac9a7e5bd6$var$getRequest = $5ohfX.getRequest;
var $7e7a6cac9a7e5bd6$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $7e7a6cac9a7e5bd6$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $7e7a6cac9a7e5bd6$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
function $7e7a6cac9a7e5bd6$var$useQueryLoader(preloadableRequest, initialQueryReference) {
    if ($7e7a6cac9a7e5bd6$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $64kjS(preloadableRequest, initialQueryReference);
    return $7e7a6cac9a7e5bd6$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference);
}
function $7e7a6cac9a7e5bd6$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $7e7a6cac9a7e5bd6$var$initialNullQueryReferenceState;
    var environment = $1G3Wj();
    var isMountedRef = $9HYLw();
    var undisposedQueryReferencesRef = $7e7a6cac9a7e5bd6$var$useRef(new Set([
        initialQueryReferenceInternal
    ]));
    var _useState = $7e7a6cac9a7e5bd6$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $7e7a6cac9a7e5bd6$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $7e7a6cac9a7e5bd6$var$useCallback(function() {
        if (isMountedRef.current) {
            undisposedQueryReferencesRef.current.add($7e7a6cac9a7e5bd6$var$initialNullQueryReferenceState);
            setQueryReference($7e7a6cac9a7e5bd6$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $7e7a6cac9a7e5bd6$var$useCallback(function(variables, options) {
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        if (isMountedRef.current) {
            var _options$__environmen;
            var updatedQueryReference = $7e7a6cac9a7e5bd6$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
            undisposedQueryReferencesRef.current.add(updatedQueryReference);
            setQueryReference(updatedQueryReference);
        }
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $7e7a6cac9a7e5bd6$var$useRef(false);
    $7e7a6cac9a7e5bd6$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $7e7a6cac9a7e5bd6$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (queryReference.kind !== 'NullQueryReference') queryLoaderCallback(queryReference.variables, {
                fetchPolicy: queryReference.fetchPolicy,
                networkCacheConfig: queryReference.networkCacheConfig
            });
            return;
        }
        var undisposedQueryReferences = undisposedQueryReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $7e7a6cac9a7e5bd6$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedQueryReference = _step.value;
                    if (undisposedQueryReference === queryReference) break;
                    undisposedQueryReferences["delete"](undisposedQueryReference);
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($7e7a6cac9a7e5bd6$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        queryReference,
        isMountedRef,
        queryLoaderCallback,
        preloadableRequest
    ]);
    $7e7a6cac9a7e5bd6$var$useEffect(function() {
        return function disposeAllRemainingQueryReferences() {
            var _iterator2 = (0, $7e7a6cac9a7e5bd6$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var undisposedQueryReference = _step2.value;
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($7e7a6cac9a7e5bd6$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $7e7a6cac9a7e5bd6$var$useQueryLoader;

});
parcelRegister("64kjS", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $46b2e0def0aacb0f$var$_interopRequireDefault = $9Ew61.default;

var $46b2e0def0aacb0f$var$_createForOfIteratorHelper2 = $46b2e0def0aacb0f$var$_interopRequireDefault((parcelRequire("cZ3zG")));

var $83mO0 = parcelRequire("83mO0");
var $46b2e0def0aacb0f$var$loadQuery = $83mO0.loadQuery;

var $9HYLw = parcelRequire("9HYLw");

var $1G3Wj = parcelRequire("1G3Wj");

var $2hRE7 = parcelRequire("2hRE7");
var $46b2e0def0aacb0f$var$useCallback = $2hRE7.useCallback, $46b2e0def0aacb0f$var$useEffect = $2hRE7.useEffect, $46b2e0def0aacb0f$var$useInsertionEffect = $2hRE7.useInsertionEffect, $46b2e0def0aacb0f$var$useRef = $2hRE7.useRef, $46b2e0def0aacb0f$var$useState = $2hRE7.useState;

var $5ohfX = parcelRequire("5ohfX");
var $46b2e0def0aacb0f$var$getRequest = $5ohfX.getRequest;
var $46b2e0def0aacb0f$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $46b2e0def0aacb0f$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $46b2e0def0aacb0f$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
var $46b2e0def0aacb0f$var$CLEANUP_TIMEOUT = 300000;
function $46b2e0def0aacb0f$var$useQueryLoader_EXPERIMENTAL(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $46b2e0def0aacb0f$var$initialNullQueryReferenceState;
    var environment = $1G3Wj();
    var isMountedRef = $9HYLw();
    var undisposedQueryReferencesRef = $46b2e0def0aacb0f$var$useRef(null);
    if (undisposedQueryReferencesRef.current == null) undisposedQueryReferencesRef.current = new Set([
        initialQueryReferenceInternal
    ]);
    var _useState = $46b2e0def0aacb0f$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $46b2e0def0aacb0f$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        var _undisposedQueryRefer;
        (_undisposedQueryRefer = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer === void 0 || _undisposedQueryRefer.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $46b2e0def0aacb0f$var$useCallback(function() {
        if (isMountedRef.current) {
            var _undisposedQueryRefer2;
            (_undisposedQueryRefer2 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer2 === void 0 || _undisposedQueryRefer2.add($46b2e0def0aacb0f$var$initialNullQueryReferenceState);
            setQueryReference($46b2e0def0aacb0f$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $46b2e0def0aacb0f$var$useCallback(function(variables, options) {
        var _options$__environmen, _undisposedQueryRefer3;
        if (!isMountedRef.current) return;
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        var updatedQueryReference = $46b2e0def0aacb0f$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
        (_undisposedQueryRefer3 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer3 === void 0 || _undisposedQueryRefer3.add(updatedQueryReference);
        setQueryReference(updatedQueryReference);
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var disposeAllRemainingQueryReferences = $46b2e0def0aacb0f$var$useCallback(function disposeAllRemainingQueryReferences(preloadableRequest, currentQueryReference) {
        var _undisposedQueryRefer4;
        var undisposedQueryReferences = (_undisposedQueryRefer4 = undisposedQueryReferencesRef.current) !== null && _undisposedQueryRefer4 !== void 0 ? _undisposedQueryRefer4 : new Set();
        var _iterator = (0, $46b2e0def0aacb0f$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var undisposedQueryReference = _step.value;
                if (undisposedQueryReference === currentQueryReference) continue;
                if (undisposedQueryReference.kind !== 'NullQueryReference') {
                    if ($46b2e0def0aacb0f$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                    else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }, []);
    var cleanupTimerRef = $46b2e0def0aacb0f$var$useRef(null);
    $46b2e0def0aacb0f$var$useEffect(function() {
        disposeAllRemainingQueryReferences(preloadableRequest, queryReference);
        if (cleanupTimerRef.current != null) {
            clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
        }
        return function() {
            cleanupTimerRef.current = setTimeout(function() {
                disposeAllRemainingQueryReferences(preloadableRequest, null);
            }, $46b2e0def0aacb0f$var$CLEANUP_TIMEOUT);
        };
    }, [
        preloadableRequest,
        queryReference
    ]);
    $46b2e0def0aacb0f$var$useInsertionEffect(function() {
        return function() {
            cleanupTimerRef.current && clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
            disposeAllRemainingQueryReferences(preloadableRequest, null);
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $46b2e0def0aacb0f$var$useQueryLoader_EXPERIMENTAL;

});




parcelRegister("e5uIp", function(module, exports) {
'use strict';

var $9Ew61 = parcelRequire("9Ew61");
var $a4195bb8aa0656af$var$_interopRequireDefault = $9Ew61.default;

var $a4195bb8aa0656af$var$_objectSpread2 = $a4195bb8aa0656af$var$_interopRequireDefault((parcelRequire("7lyjq")));

var $6yaQf = parcelRequire("6yaQf");

var $bBOUi = parcelRequire("bBOUi");

var $8gmAu = parcelRequire("8gmAu");

var $1G3Wj = parcelRequire("1G3Wj");

var $4cr8T = parcelRequire("4cr8T");

var $1etGW = parcelRequire("1etGW");

var $2hRE7 = parcelRequire("2hRE7");
var $a4195bb8aa0656af$var$useCallback = $2hRE7.useCallback, $a4195bb8aa0656af$var$useDebugValue = $2hRE7.useDebugValue, $a4195bb8aa0656af$var$useEffect = $2hRE7.useEffect, $a4195bb8aa0656af$var$useLayoutEffect = $2hRE7.useLayoutEffect, $a4195bb8aa0656af$var$useMemo = $2hRE7.useMemo, $a4195bb8aa0656af$var$useRef = $2hRE7.useRef, $a4195bb8aa0656af$var$useState = $2hRE7.useState;

var $5ohfX = parcelRequire("5ohfX");
var $a4195bb8aa0656af$var$getFragment = $5ohfX.getFragment, $a4195bb8aa0656af$var$getFragmentIdentifier = $5ohfX.getFragmentIdentifier, $a4195bb8aa0656af$var$getPaginationMetadata = $5ohfX.getPaginationMetadata;

var $5ohfX = parcelRequire("5ohfX");
var $a4195bb8aa0656af$var$ConnectionInterface = $5ohfX.ConnectionInterface, $a4195bb8aa0656af$var$RelayFeatureFlags = $5ohfX.RelayFeatureFlags, $a4195bb8aa0656af$var$getSelector = $5ohfX.getSelector, $a4195bb8aa0656af$var$getValueAtPath = $5ohfX.getValueAtPath;
function $a4195bb8aa0656af$var$usePrefetchableForwardPaginationFragment(fragmentInput, parentFragmentRef, bufferSize, initialSize, prefetchingLoadMoreOptions) {
    var _fragmentInput$metada, _fragmentInput$metada2;
    var minimalFetchSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
    var disablePrefetching = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var fragmentNode = $a4195bb8aa0656af$var$getFragment(fragmentInput);
    $4cr8T(fragmentNode, 'first argument of usePrefetchableForwardPaginationFragment()');
    var componentDisplayName = 'usePrefetchableForwardPaginationFragment()';
    var _getPaginationMetadat = $a4195bb8aa0656af$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $8gmAu(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $a4195bb8aa0656af$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var edgeKeys = $a4195bb8aa0656af$var$useMemo(function() {
        var connection = $a4195bb8aa0656af$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
        if (connection == null) return null;
        var _ConnectionInterface$ = $a4195bb8aa0656af$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES;
        return connection[EDGES];
    }, [
        connectionPathInFragmentData,
        fragmentData
    ]);
    var sourceSize = edgeKeys == null ? -1 : edgeKeys.length;
    var _useState = $a4195bb8aa0656af$var$useState(initialSize != null ? initialSize : sourceSize), _numInUse = _useState[0], setNumInUse = _useState[1];
    var numInUse = _numInUse;
    if (_numInUse === -1 && sourceSize !== -1) {
        numInUse = initialSize != null ? initialSize : sourceSize;
        setNumInUse(numInUse);
    }
    var environment = $1G3Wj();
    var _useState2 = $a4195bb8aa0656af$var$useState(false), isLoadingMore = _useState2[0], reallySetIsLoadingMore = _useState2[1];
    var _useState3 = $a4195bb8aa0656af$var$useState(false), isRefetching = _useState3[0], setIsRefetching = _useState3[1];
    var availableSizeRef = $a4195bb8aa0656af$var$useRef(0);
    var setIsLoadingMore = $a4195bb8aa0656af$var$useCallback(function(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    }, [
        environment
    ]);
    var isLoadingMoreRef = $a4195bb8aa0656af$var$useRef(false);
    var observer = $a4195bb8aa0656af$var$useMemo(function() {
        function setIsLoadingFalse() {
            isLoadingMoreRef.current = false;
            setIsLoadingMore(false);
        }
        return {
            start: function start() {
                isLoadingMoreRef.current = true;
                reallySetIsLoadingMore(true);
            },
            complete: setIsLoadingFalse,
            error: setIsLoadingFalse,
            unsubscribe: $a4195bb8aa0656af$var$RelayFeatureFlags.ENABLE_USE_PAGINATION_IS_LOADING_FIX ? setIsLoadingFalse : undefined
        };
    }, [
        setIsLoadingMore
    ]);
    var handleReset = $a4195bb8aa0656af$var$useCallback(function() {
        if (!isRefetching) {
            var _environment$getSched2;
            var schedule = (_environment$getSched2 = environment.getScheduler()) === null || _environment$getSched2 === void 0 ? void 0 : _environment$getSched2.schedule;
            if (schedule) schedule(function() {
                setNumInUse(-1);
            });
            else setNumInUse(-1);
        }
        isLoadingMoreRef.current = false;
        setIsLoadingMore(false);
    }, [
        environment,
        isRefetching,
        setIsLoadingMore
    ]);
    var _useLoadMoreFunction = $bBOUi({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest,
        observer: observer,
        onReset: handleReset
    }), loadMore = _useLoadMoreFunction[0], hasNext = _useLoadMoreFunction[1], disposeFetchNext = _useLoadMoreFunction[2];
    $a4195bb8aa0656af$var$useLayoutEffect(function() {
        availableSizeRef.current = sourceSize - numInUse;
    }, [
        numInUse,
        sourceSize
    ]);
    var prefetchingUNSTABLE_extraVariables = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.UNSTABLE_extraVariables;
    var prefetchingOnComplete = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.onComplete;
    var showMore = $a4195bb8aa0656af$var$useCallback(function(numToAdd, options) {
        if (!isLoadingMoreRef.current || availableSizeRef.current >= 0) {
            availableSizeRef.current -= numToAdd;
            setNumInUse(function(lastNumInUse) {
                return lastNumInUse + numToAdd;
            });
            if (!isLoadingMoreRef.current && availableSizeRef.current < 0) loadMore(Math.max(minimalFetchSize, Math.min(numToAdd, bufferSize - availableSizeRef.current)), options !== null && options !== void 0 ? options : {
                onComplete: prefetchingOnComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === 'function' ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = $a4195bb8aa0656af$var$getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === 'PluralReaderSelector') && $1etGW(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        bufferSize,
        loadMore,
        minimalFetchSize,
        edgeKeys,
        fragmentData,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete
    ]);
    var edgesFragment = (_fragmentInput$metada = fragmentInput.metadata) === null || _fragmentInput$metada === void 0 ? void 0 : (_fragmentInput$metada2 = _fragmentInput$metada.refetch) === null || _fragmentInput$metada2 === void 0 ? void 0 : _fragmentInput$metada2.edgesFragment;
    !(edgesFragment != null) && $1etGW(false);
    $a4195bb8aa0656af$var$useEffect(function() {
        if (!isLoadingMoreRef.current && !isLoadingMore && !isRefetching && !disablePrefetching && hasNext && (sourceSize - numInUse < bufferSize || numInUse > sourceSize)) {
            var onComplete = prefetchingOnComplete;
            loadMore(Math.max(bufferSize - Math.max(sourceSize - numInUse, 0), numInUse - sourceSize, minimalFetchSize), {
                onComplete: onComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === 'function' ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = $a4195bb8aa0656af$var$getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === 'PluralReaderSelector') && $1etGW(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        hasNext,
        bufferSize,
        isRefetching,
        loadMore,
        numInUse,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete,
        sourceSize,
        edgeKeys,
        isLoadingMore,
        minimalFetchSize,
        environment,
        edgesFragment
    ]);
    var realNumInUse = Math.min(numInUse, sourceSize);
    var derivedEdgeKeys = $a4195bb8aa0656af$var$useMemo(function() {
        var _edgeKeys$slice;
        return (_edgeKeys$slice = edgeKeys === null || edgeKeys === void 0 ? void 0 : edgeKeys.slice(0, realNumInUse)) !== null && _edgeKeys$slice !== void 0 ? _edgeKeys$slice : [];
    }, [
        edgeKeys,
        realNumInUse
    ]);
    var edges = $6yaQf(edgesFragment, derivedEdgeKeys);
    var refetchPagination = $a4195bb8aa0656af$var$useCallback(function(variables, options) {
        disposeFetchNext();
        setIsRefetching(true);
        return refetch(variables, (0, $a4195bb8aa0656af$var$_objectSpread2["default"])((0, $a4195bb8aa0656af$var$_objectSpread2["default"])({}, options), {}, {
            onComplete: function onComplete(maybeError) {
                var _environment$getSched3, _options$onComplete;
                var schedule = (_environment$getSched3 = environment.getScheduler()) === null || _environment$getSched3 === void 0 ? void 0 : _environment$getSched3.schedule;
                if (schedule) schedule(function() {
                    setIsRefetching(false);
                    setNumInUse(-1);
                });
                else {
                    setIsRefetching(false);
                    setNumInUse(-1);
                }
                options === null || options === void 0 || (_options$onComplete = options.onComplete) === null || _options$onComplete === void 0 || _options$onComplete.call(options, maybeError);
            },
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        environment,
        refetch
    ]);
    return {
        edges: edges,
        data: fragmentData,
        loadNext: showMore,
        hasNext: hasNext || sourceSize > numInUse,
        isLoadingNext: isLoadingMore && numInUse > sourceSize,
        refetch: refetchPagination
    };
}
module.exports = $a4195bb8aa0656af$var$usePrefetchableForwardPaginationFragment;

});

parcelRegister("83Owo", function(module, exports) {
'use strict';

var $fJ7si = parcelRequire("fJ7si");

var $50MaW = parcelRequire("50MaW");

var $1G3Wj = parcelRequire("1G3Wj");

var $1etGW = parcelRequire("1etGW");

var $2hRE7 = parcelRequire("2hRE7");
var $5de5cb13a8d16e25$var$useDebugValue = $2hRE7.useDebugValue;

var $5ohfX = parcelRequire("5ohfX");
var $5de5cb13a8d16e25$var$_require2$__internal = $5ohfX.__internal, $5de5cb13a8d16e25$var$fetchQueryDeduped = $5de5cb13a8d16e25$var$_require2$__internal.fetchQueryDeduped, $5de5cb13a8d16e25$var$fetchQuery = $5de5cb13a8d16e25$var$_require2$__internal.fetchQuery;
parcelRequire("4j8bN");
function $5de5cb13a8d16e25$var$usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    var environment = $1G3Wj();
    var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source, variables = preloadedQuery.variables, networkCacheConfig = preloadedQuery.networkCacheConfig;
    var operation = $50MaW(gqlQuery, variables, networkCacheConfig);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery.kind === 'PreloadedQuery_DEPRECATED') {
        !(operation.request.node.params.name === preloadedQuery.name) && $1etGW(false);
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchKey: fetchKey,
            fetchObservable: $5de5cb13a8d16e25$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
                if (environment === preloadedQuery.environment && source != null) return environment.executeWithSource({
                    operation: operation,
                    source: source
                });
                else return environment.execute({
                    operation: operation
                });
            }),
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    } else {
        var fallbackFetchObservable = $5de5cb13a8d16e25$var$fetchQuery(environment, operation);
        var fetchObservable;
        if (source != null && environment === preloadedQuery.environment) fetchObservable = source.ifEmpty(fallbackFetchObservable);
        else if (environment !== preloadedQuery.environment) fetchObservable = fallbackFetchObservable;
        else fetchObservable = fallbackFetchObservable;
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchObservable: fetchObservable,
            fetchKey: fetchKey,
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    }
    var data = $fJ7si(useLazyLoadQueryNodeParams);
    return data;
}
module.exports = $5de5cb13a8d16e25$var$usePreloadedQuery;

});

parcelRegister("4beU6", function(module, exports) {
'use strict';

var $8gmAu = parcelRequire("8gmAu");

var $4cr8T = parcelRequire("4cr8T");

var $2hRE7 = parcelRequire("2hRE7");
var $30b3c0194e12967f$var$useDebugValue = $2hRE7.useDebugValue;

var $5ohfX = parcelRequire("5ohfX");
var $30b3c0194e12967f$var$getFragment = $5ohfX.getFragment;
function $30b3c0194e12967f$var$useRefetchableFragment(fragmentInput, fragmentRef) {
    var fragmentNode = $30b3c0194e12967f$var$getFragment(fragmentInput);
    $4cr8T(fragmentNode, 'first argument of useRefetchableFragment()');
    var _useRefetchableFragme = $8gmAu(fragmentNode, fragmentRef, 'useRefetchableFragment()'), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    return [
        fragmentData,
        refetch
    ];
}
module.exports = $30b3c0194e12967f$var$useRefetchableFragment;

});

parcelRegister("bLLs1", function(module, exports) {
'use strict';

var $1G3Wj = parcelRequire("1G3Wj");

var $2hRE7 = parcelRequire("2hRE7");
var $8918e446f4a2f5dc$var$useEffect = $2hRE7.useEffect, $8918e446f4a2f5dc$var$useRef = $2hRE7.useRef;
function $8918e446f4a2f5dc$var$useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = $1G3Wj();
    var disposableRef = $8918e446f4a2f5dc$var$useRef(null);
    var stableDataIDs = Array.from(dataIDs).sort().join('');
    $8918e446f4a2f5dc$var$useEffect(function() {
        var store = environment.getStore();
        var invalidationState = store.lookupInvalidationState(dataIDs);
        var disposable = store.subscribeToInvalidationState(invalidationState, callback);
        disposableRef.current = disposable;
        return function() {
            return disposable.dispose();
        };
    }, [
        stableDataIDs,
        callback,
        environment
    ]);
    return {
        dispose: function dispose() {
            if (disposableRef.current != null) disposableRef.current.dispose();
        }
    };
}
module.exports = $8918e446f4a2f5dc$var$useSubscribeToInvalidationState;

});

parcelRegister("4JLoB", function(module, exports) {
'use strict';

var $1G3Wj = parcelRequire("1G3Wj");

var $2hRE7 = parcelRequire("2hRE7");
var $3730213be8f2bda2$var$useEffect = $2hRE7.useEffect;

var $5ohfX = parcelRequire("5ohfX");
var $3730213be8f2bda2$var$requestSubscription = $5ohfX.requestSubscription;
function $3730213be8f2bda2$var$useSubscription(config, requestSubscriptionFn) {
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : $3730213be8f2bda2$var$requestSubscription;
    var environment = $1G3Wj();
    $3730213be8f2bda2$var$useEffect(function() {
        var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
        return dispose;
    }, [
        environment,
        config,
        actualRequestSubscription
    ]);
}
module.exports = $3730213be8f2bda2$var$useSubscription;

});


parcelRegister("iICAS", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $da0a45fbe2ec0fdc$export$2b8d127b894957b9, (v) => $da0a45fbe2ec0fdc$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $da0a45fbe2ec0fdc$export$cea3a54a6425200c, (v) => $da0a45fbe2ec0fdc$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $da0a45fbe2ec0fdc$export$a7c73072b1a182ae, (v) => $da0a45fbe2ec0fdc$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $da0a45fbe2ec0fdc$export$9f27bc3417b4524d, (v) => $da0a45fbe2ec0fdc$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $da0a45fbe2ec0fdc$export$db77ccec0bb4ccac, (v) => $da0a45fbe2ec0fdc$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $da0a45fbe2ec0fdc$export$8392c0c9d3dcbd35, (v) => $da0a45fbe2ec0fdc$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $da0a45fbe2ec0fdc$export$ffb0004e005737fa, (v) => $da0a45fbe2ec0fdc$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $da0a45fbe2ec0fdc$export$b624eff549462981, (v) => $da0a45fbe2ec0fdc$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $da0a45fbe2ec0fdc$export$7897aa7841a5380c, (v) => $da0a45fbe2ec0fdc$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $da0a45fbe2ec0fdc$export$602eac185826482c, (v) => $da0a45fbe2ec0fdc$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $da0a45fbe2ec0fdc$export$e2c29f18771995cb, (v) => $da0a45fbe2ec0fdc$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $da0a45fbe2ec0fdc$export$5f8d39834fd61797, (v) => $da0a45fbe2ec0fdc$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $da0a45fbe2ec0fdc$export$74bf444e3cd11ea5, (v) => $da0a45fbe2ec0fdc$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $da0a45fbe2ec0fdc$export$92387174baf9b227, (v) => $da0a45fbe2ec0fdc$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $da0a45fbe2ec0fdc$export$ec112efeb987d9c6, (v) => $da0a45fbe2ec0fdc$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $da0a45fbe2ec0fdc$export$b706b080d889d2c9, (v) => $da0a45fbe2ec0fdc$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $da0a45fbe2ec0fdc$export$5be5a87408f70ddc, (v) => $da0a45fbe2ec0fdc$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $da0a45fbe2ec0fdc$export$45a5e7f76e0caa8d, (v) => $da0a45fbe2ec0fdc$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $da0a45fbe2ec0fdc$export$455c2e768291efa6, (v) => $da0a45fbe2ec0fdc$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $da0a45fbe2ec0fdc$export$9522e17588c12572, (v) => $da0a45fbe2ec0fdc$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $da0a45fbe2ec0fdc$export$2110ac352bb060b9, (v) => $da0a45fbe2ec0fdc$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $da0a45fbe2ec0fdc$export$56885ab8b9c456ab, (v) => $da0a45fbe2ec0fdc$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $da0a45fbe2ec0fdc$export$d927fcb6adf8f9de, (v) => $da0a45fbe2ec0fdc$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $da0a45fbe2ec0fdc$export$b82d16f27459e05a, (v) => $da0a45fbe2ec0fdc$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $da0a45fbe2ec0fdc$export$522c17b4f5e123e8, (v) => $da0a45fbe2ec0fdc$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $da0a45fbe2ec0fdc$export$1aabd8a0274ecfd6, (v) => $da0a45fbe2ec0fdc$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $da0a45fbe2ec0fdc$export$9b621391a187a31a, (v) => $da0a45fbe2ec0fdc$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $da0a45fbe2ec0fdc$export$f5bbd400c2f4426f, (v) => $da0a45fbe2ec0fdc$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $da0a45fbe2ec0fdc$export$2b8d127b894957b9;
var $da0a45fbe2ec0fdc$export$cea3a54a6425200c;
var $da0a45fbe2ec0fdc$export$a7c73072b1a182ae;
var $da0a45fbe2ec0fdc$export$9f27bc3417b4524d;
var $da0a45fbe2ec0fdc$export$db77ccec0bb4ccac;
var $da0a45fbe2ec0fdc$export$8392c0c9d3dcbd35;
var $da0a45fbe2ec0fdc$export$ffb0004e005737fa;
var $da0a45fbe2ec0fdc$export$b624eff549462981;
var $da0a45fbe2ec0fdc$export$7897aa7841a5380c;
var $da0a45fbe2ec0fdc$export$602eac185826482c;
var $da0a45fbe2ec0fdc$export$e2c29f18771995cb;
var $da0a45fbe2ec0fdc$export$5f8d39834fd61797;
var $da0a45fbe2ec0fdc$export$74bf444e3cd11ea5;
var $da0a45fbe2ec0fdc$export$92387174baf9b227;
var $da0a45fbe2ec0fdc$export$ec112efeb987d9c6;
var $da0a45fbe2ec0fdc$export$b706b080d889d2c9;
var $da0a45fbe2ec0fdc$export$5be5a87408f70ddc;
var $da0a45fbe2ec0fdc$export$45a5e7f76e0caa8d;
var $da0a45fbe2ec0fdc$export$455c2e768291efa6;
var $da0a45fbe2ec0fdc$export$9522e17588c12572;
var $da0a45fbe2ec0fdc$export$2110ac352bb060b9;
var $da0a45fbe2ec0fdc$export$56885ab8b9c456ab;
var $da0a45fbe2ec0fdc$export$d927fcb6adf8f9de;
var $da0a45fbe2ec0fdc$export$b82d16f27459e05a;
var $da0a45fbe2ec0fdc$export$522c17b4f5e123e8;
var $da0a45fbe2ec0fdc$export$1aabd8a0274ecfd6;
var $da0a45fbe2ec0fdc$export$9b621391a187a31a;
var $da0a45fbe2ec0fdc$export$f5bbd400c2f4426f;
'use strict';
var $da0a45fbe2ec0fdc$var$b = "function" === typeof Symbol && Symbol.for, $da0a45fbe2ec0fdc$var$c = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.element") : 60103, $da0a45fbe2ec0fdc$var$d = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.portal") : 60106, $da0a45fbe2ec0fdc$var$e = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.fragment") : 60107, $da0a45fbe2ec0fdc$var$f = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.strict_mode") : 60108, $da0a45fbe2ec0fdc$var$g = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.profiler") : 60114, $da0a45fbe2ec0fdc$var$h = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.provider") : 60109, $da0a45fbe2ec0fdc$var$k = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.context") : 60110, $da0a45fbe2ec0fdc$var$l = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.async_mode") : 60111, $da0a45fbe2ec0fdc$var$m = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.concurrent_mode") : 60111, $da0a45fbe2ec0fdc$var$n = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.forward_ref") : 60112, $da0a45fbe2ec0fdc$var$p = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.suspense") : 60113, $da0a45fbe2ec0fdc$var$q = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.suspense_list") : 60120, $da0a45fbe2ec0fdc$var$r = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.memo") : 60115, $da0a45fbe2ec0fdc$var$t = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.lazy") : 60116, $da0a45fbe2ec0fdc$var$v = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.block") : 60121, $da0a45fbe2ec0fdc$var$w = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.fundamental") : 60117, $da0a45fbe2ec0fdc$var$x = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.responder") : 60118, $da0a45fbe2ec0fdc$var$y = $da0a45fbe2ec0fdc$var$b ? Symbol.for("react.scope") : 60119;
function $da0a45fbe2ec0fdc$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $da0a45fbe2ec0fdc$var$c:
                switch(a = a.type, a){
                    case $da0a45fbe2ec0fdc$var$l:
                    case $da0a45fbe2ec0fdc$var$m:
                    case $da0a45fbe2ec0fdc$var$e:
                    case $da0a45fbe2ec0fdc$var$g:
                    case $da0a45fbe2ec0fdc$var$f:
                    case $da0a45fbe2ec0fdc$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $da0a45fbe2ec0fdc$var$k:
                            case $da0a45fbe2ec0fdc$var$n:
                            case $da0a45fbe2ec0fdc$var$t:
                            case $da0a45fbe2ec0fdc$var$r:
                            case $da0a45fbe2ec0fdc$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $da0a45fbe2ec0fdc$var$d:
                return u;
        }
    }
}
function $da0a45fbe2ec0fdc$var$A(a) {
    return $da0a45fbe2ec0fdc$var$z(a) === $da0a45fbe2ec0fdc$var$m;
}
$da0a45fbe2ec0fdc$export$2b8d127b894957b9 = $da0a45fbe2ec0fdc$var$l;
$da0a45fbe2ec0fdc$export$cea3a54a6425200c = $da0a45fbe2ec0fdc$var$m;
$da0a45fbe2ec0fdc$export$a7c73072b1a182ae = $da0a45fbe2ec0fdc$var$k;
$da0a45fbe2ec0fdc$export$9f27bc3417b4524d = $da0a45fbe2ec0fdc$var$h;
$da0a45fbe2ec0fdc$export$db77ccec0bb4ccac = $da0a45fbe2ec0fdc$var$c;
$da0a45fbe2ec0fdc$export$8392c0c9d3dcbd35 = $da0a45fbe2ec0fdc$var$n;
$da0a45fbe2ec0fdc$export$ffb0004e005737fa = $da0a45fbe2ec0fdc$var$e;
$da0a45fbe2ec0fdc$export$b624eff549462981 = $da0a45fbe2ec0fdc$var$t;
$da0a45fbe2ec0fdc$export$7897aa7841a5380c = $da0a45fbe2ec0fdc$var$r;
$da0a45fbe2ec0fdc$export$602eac185826482c = $da0a45fbe2ec0fdc$var$d;
$da0a45fbe2ec0fdc$export$e2c29f18771995cb = $da0a45fbe2ec0fdc$var$g;
$da0a45fbe2ec0fdc$export$5f8d39834fd61797 = $da0a45fbe2ec0fdc$var$f;
$da0a45fbe2ec0fdc$export$74bf444e3cd11ea5 = $da0a45fbe2ec0fdc$var$p;
$da0a45fbe2ec0fdc$export$92387174baf9b227 = function(a) {
    return $da0a45fbe2ec0fdc$var$A(a) || $da0a45fbe2ec0fdc$var$z(a) === $da0a45fbe2ec0fdc$var$l;
};
$da0a45fbe2ec0fdc$export$ec112efeb987d9c6 = $da0a45fbe2ec0fdc$var$A;
$da0a45fbe2ec0fdc$export$b706b080d889d2c9 = function(a) {
    return $da0a45fbe2ec0fdc$var$z(a) === $da0a45fbe2ec0fdc$var$k;
};
$da0a45fbe2ec0fdc$export$5be5a87408f70ddc = function(a) {
    return $da0a45fbe2ec0fdc$var$z(a) === $da0a45fbe2ec0fdc$var$h;
};
$da0a45fbe2ec0fdc$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $da0a45fbe2ec0fdc$var$c;
};
$da0a45fbe2ec0fdc$export$455c2e768291efa6 = function(a) {
    return $da0a45fbe2ec0fdc$var$z(a) === $da0a45fbe2ec0fdc$var$n;
};
$da0a45fbe2ec0fdc$export$9522e17588c12572 = function(a) {
    return $da0a45fbe2ec0fdc$var$z(a) === $da0a45fbe2ec0fdc$var$e;
};
$da0a45fbe2ec0fdc$export$2110ac352bb060b9 = function(a) {
    return $da0a45fbe2ec0fdc$var$z(a) === $da0a45fbe2ec0fdc$var$t;
};
$da0a45fbe2ec0fdc$export$56885ab8b9c456ab = function(a) {
    return $da0a45fbe2ec0fdc$var$z(a) === $da0a45fbe2ec0fdc$var$r;
};
$da0a45fbe2ec0fdc$export$d927fcb6adf8f9de = function(a) {
    return $da0a45fbe2ec0fdc$var$z(a) === $da0a45fbe2ec0fdc$var$d;
};
$da0a45fbe2ec0fdc$export$b82d16f27459e05a = function(a) {
    return $da0a45fbe2ec0fdc$var$z(a) === $da0a45fbe2ec0fdc$var$g;
};
$da0a45fbe2ec0fdc$export$522c17b4f5e123e8 = function(a) {
    return $da0a45fbe2ec0fdc$var$z(a) === $da0a45fbe2ec0fdc$var$f;
};
$da0a45fbe2ec0fdc$export$1aabd8a0274ecfd6 = function(a) {
    return $da0a45fbe2ec0fdc$var$z(a) === $da0a45fbe2ec0fdc$var$p;
};
$da0a45fbe2ec0fdc$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $da0a45fbe2ec0fdc$var$e || a === $da0a45fbe2ec0fdc$var$m || a === $da0a45fbe2ec0fdc$var$g || a === $da0a45fbe2ec0fdc$var$f || a === $da0a45fbe2ec0fdc$var$p || a === $da0a45fbe2ec0fdc$var$q || "object" === typeof a && null !== a && (a.$$typeof === $da0a45fbe2ec0fdc$var$t || a.$$typeof === $da0a45fbe2ec0fdc$var$r || a.$$typeof === $da0a45fbe2ec0fdc$var$h || a.$$typeof === $da0a45fbe2ec0fdc$var$k || a.$$typeof === $da0a45fbe2ec0fdc$var$n || a.$$typeof === $da0a45fbe2ec0fdc$var$w || a.$$typeof === $da0a45fbe2ec0fdc$var$x || a.$$typeof === $da0a45fbe2ec0fdc$var$y || a.$$typeof === $da0a45fbe2ec0fdc$var$v);
};
$da0a45fbe2ec0fdc$export$f5bbd400c2f4426f = $da0a45fbe2ec0fdc$var$z;

});

parcelRegister("7KV6Y", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $5a592170aa2a98d4$export$ffb0004e005737fa, (v) => $5a592170aa2a98d4$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $5a592170aa2a98d4$export$34b9dba7ce09269b, (v) => $5a592170aa2a98d4$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $5a592170aa2a98d4$export$25062201e9e25d76, (v) => $5a592170aa2a98d4$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5a592170aa2a98d4$export$ffb0004e005737fa;
var $5a592170aa2a98d4$export$34b9dba7ce09269b;
var $5a592170aa2a98d4$export$25062201e9e25d76;
'use strict';

var $2hRE7 = parcelRequire("2hRE7");
var $5a592170aa2a98d4$var$k = Symbol.for("react.element"), $5a592170aa2a98d4$var$l = Symbol.for("react.fragment"), $5a592170aa2a98d4$var$m = Object.prototype.hasOwnProperty, $5a592170aa2a98d4$var$n = $2hRE7.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $5a592170aa2a98d4$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5a592170aa2a98d4$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$5a592170aa2a98d4$var$m.call(a, b) && !$5a592170aa2a98d4$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $5a592170aa2a98d4$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $5a592170aa2a98d4$var$n.current
    };
}
$5a592170aa2a98d4$export$ffb0004e005737fa = $5a592170aa2a98d4$var$l;
$5a592170aa2a98d4$export$34b9dba7ce09269b = $5a592170aa2a98d4$var$q;
$5a592170aa2a98d4$export$25062201e9e25d76 = $5a592170aa2a98d4$var$q;

});

parcelRegister("9pfwj", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $jcj59 = parcelRequire("jcj59");

var $f5FWH = parcelRequire("f5FWH");
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $7WD16 = parcelRequire("7WD16");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && $f5FWH.isObject(url) && url instanceof Url) return url;
    var u = new Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!$f5FWH.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $7WD16.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        this.hostname = $jcj59.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $7WD16.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if ($f5FWH.isString(obj)) obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && $f5FWH.isObject(this.query) && Object.keys(this.query).length) query = $7WD16.stringify(this.query);
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if ($f5FWH.isString(relative)) {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = '/';
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!$f5FWH.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!$f5FWH.isNull(result.pathname) || !$f5FWH.isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join('/');
    //to support request.http
    if (!$f5FWH.isNull(result.pathname) || !$f5FWH.isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};

});
parcelRegister("jcj59", function(module, exports) {
/*! https://mths.be/punycode v1.3.2 by @mathias */ (function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.3.2',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(this);

});

parcelRegister("f5FWH", function(module, exports) {
'use strict';
module.exports = {
    isString: function(arg) {
        return typeof arg === 'string';
    },
    isObject: function(arg) {
        return typeof arg === 'object' && arg !== null;
    },
    isNull: function(arg) {
        return arg === null;
    },
    isNullOrUndefined: function(arg) {
        return arg == null;
    }
};

});

parcelRegister("7WD16", function(module, exports) {
$parcel$export(module.exports, "parse", () => $5c8c3720cb9d63c7$export$98e6a39c04603d36, (v) => $5c8c3720cb9d63c7$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $5c8c3720cb9d63c7$export$fac44ee5b035f737, (v) => $5c8c3720cb9d63c7$export$fac44ee5b035f737 = v);
var $5c8c3720cb9d63c7$export$2f872c0f2117be69;
var $5c8c3720cb9d63c7$export$98e6a39c04603d36;
var $5c8c3720cb9d63c7$export$c564cdbbe6da493;
var $5c8c3720cb9d63c7$export$fac44ee5b035f737;
'use strict';

$5c8c3720cb9d63c7$export$2f872c0f2117be69 = $5c8c3720cb9d63c7$export$98e6a39c04603d36 = (parcelRequire("1NWik"));

$5c8c3720cb9d63c7$export$c564cdbbe6da493 = $5c8c3720cb9d63c7$export$fac44ee5b035f737 = (parcelRequire("3niUv"));

});
parcelRegister("1NWik", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $1507962aa3434d96$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$1507962aa3434d96$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($1507962aa3434d96$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $1507962aa3434d96$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("3niUv", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $27523049c9269561$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $27523049c9269561$var$map($27523049c9269561$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($27523049c9269561$var$stringifyPrimitive(k)) + eq;
        if ($27523049c9269561$var$isArray(obj[k])) return $27523049c9269561$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($27523049c9269561$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($27523049c9269561$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($27523049c9269561$var$stringifyPrimitive(name)) + eq + encodeURIComponent($27523049c9269561$var$stringifyPrimitive(obj));
};
var $27523049c9269561$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $27523049c9269561$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $27523049c9269561$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});



parcelRegister("h8zcq", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7HN0V = parcelRequire("7HN0V");
function $c79e7cea4a4f1177$var$emptyFunction() {}
function $c79e7cea4a4f1177$var$emptyFunctionWithReset() {}
$c79e7cea4a4f1177$var$emptyFunctionWithReset.resetWarningCache = $c79e7cea4a4f1177$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7HN0V) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $c79e7cea4a4f1177$var$emptyFunctionWithReset,
        resetWarningCache: $c79e7cea4a4f1177$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7HN0V", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $59c291b459ad2fb8$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $59c291b459ad2fb8$var$ReactPropTypesSecret;

});


parcelRegister("1TaDb", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $16032c91407992e5$export$2b8d127b894957b9, (v) => $16032c91407992e5$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $16032c91407992e5$export$cea3a54a6425200c, (v) => $16032c91407992e5$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $16032c91407992e5$export$a7c73072b1a182ae, (v) => $16032c91407992e5$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $16032c91407992e5$export$9f27bc3417b4524d, (v) => $16032c91407992e5$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $16032c91407992e5$export$db77ccec0bb4ccac, (v) => $16032c91407992e5$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $16032c91407992e5$export$8392c0c9d3dcbd35, (v) => $16032c91407992e5$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $16032c91407992e5$export$ffb0004e005737fa, (v) => $16032c91407992e5$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $16032c91407992e5$export$b624eff549462981, (v) => $16032c91407992e5$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $16032c91407992e5$export$7897aa7841a5380c, (v) => $16032c91407992e5$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $16032c91407992e5$export$602eac185826482c, (v) => $16032c91407992e5$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $16032c91407992e5$export$e2c29f18771995cb, (v) => $16032c91407992e5$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $16032c91407992e5$export$5f8d39834fd61797, (v) => $16032c91407992e5$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $16032c91407992e5$export$74bf444e3cd11ea5, (v) => $16032c91407992e5$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $16032c91407992e5$export$92387174baf9b227, (v) => $16032c91407992e5$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $16032c91407992e5$export$ec112efeb987d9c6, (v) => $16032c91407992e5$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $16032c91407992e5$export$b706b080d889d2c9, (v) => $16032c91407992e5$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $16032c91407992e5$export$5be5a87408f70ddc, (v) => $16032c91407992e5$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $16032c91407992e5$export$45a5e7f76e0caa8d, (v) => $16032c91407992e5$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $16032c91407992e5$export$455c2e768291efa6, (v) => $16032c91407992e5$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $16032c91407992e5$export$9522e17588c12572, (v) => $16032c91407992e5$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $16032c91407992e5$export$2110ac352bb060b9, (v) => $16032c91407992e5$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $16032c91407992e5$export$56885ab8b9c456ab, (v) => $16032c91407992e5$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $16032c91407992e5$export$d927fcb6adf8f9de, (v) => $16032c91407992e5$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $16032c91407992e5$export$b82d16f27459e05a, (v) => $16032c91407992e5$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $16032c91407992e5$export$522c17b4f5e123e8, (v) => $16032c91407992e5$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $16032c91407992e5$export$1aabd8a0274ecfd6, (v) => $16032c91407992e5$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $16032c91407992e5$export$9b621391a187a31a, (v) => $16032c91407992e5$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $16032c91407992e5$export$f5bbd400c2f4426f, (v) => $16032c91407992e5$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $16032c91407992e5$export$2b8d127b894957b9;
var $16032c91407992e5$export$cea3a54a6425200c;
var $16032c91407992e5$export$a7c73072b1a182ae;
var $16032c91407992e5$export$9f27bc3417b4524d;
var $16032c91407992e5$export$db77ccec0bb4ccac;
var $16032c91407992e5$export$8392c0c9d3dcbd35;
var $16032c91407992e5$export$ffb0004e005737fa;
var $16032c91407992e5$export$b624eff549462981;
var $16032c91407992e5$export$7897aa7841a5380c;
var $16032c91407992e5$export$602eac185826482c;
var $16032c91407992e5$export$e2c29f18771995cb;
var $16032c91407992e5$export$5f8d39834fd61797;
var $16032c91407992e5$export$74bf444e3cd11ea5;
var $16032c91407992e5$export$92387174baf9b227;
var $16032c91407992e5$export$ec112efeb987d9c6;
var $16032c91407992e5$export$b706b080d889d2c9;
var $16032c91407992e5$export$5be5a87408f70ddc;
var $16032c91407992e5$export$45a5e7f76e0caa8d;
var $16032c91407992e5$export$455c2e768291efa6;
var $16032c91407992e5$export$9522e17588c12572;
var $16032c91407992e5$export$2110ac352bb060b9;
var $16032c91407992e5$export$56885ab8b9c456ab;
var $16032c91407992e5$export$d927fcb6adf8f9de;
var $16032c91407992e5$export$b82d16f27459e05a;
var $16032c91407992e5$export$522c17b4f5e123e8;
var $16032c91407992e5$export$1aabd8a0274ecfd6;
var $16032c91407992e5$export$9b621391a187a31a;
var $16032c91407992e5$export$f5bbd400c2f4426f;
'use strict';
var $16032c91407992e5$var$b = "function" === typeof Symbol && Symbol.for, $16032c91407992e5$var$c = $16032c91407992e5$var$b ? Symbol.for("react.element") : 60103, $16032c91407992e5$var$d = $16032c91407992e5$var$b ? Symbol.for("react.portal") : 60106, $16032c91407992e5$var$e = $16032c91407992e5$var$b ? Symbol.for("react.fragment") : 60107, $16032c91407992e5$var$f = $16032c91407992e5$var$b ? Symbol.for("react.strict_mode") : 60108, $16032c91407992e5$var$g = $16032c91407992e5$var$b ? Symbol.for("react.profiler") : 60114, $16032c91407992e5$var$h = $16032c91407992e5$var$b ? Symbol.for("react.provider") : 60109, $16032c91407992e5$var$k = $16032c91407992e5$var$b ? Symbol.for("react.context") : 60110, $16032c91407992e5$var$l = $16032c91407992e5$var$b ? Symbol.for("react.async_mode") : 60111, $16032c91407992e5$var$m = $16032c91407992e5$var$b ? Symbol.for("react.concurrent_mode") : 60111, $16032c91407992e5$var$n = $16032c91407992e5$var$b ? Symbol.for("react.forward_ref") : 60112, $16032c91407992e5$var$p = $16032c91407992e5$var$b ? Symbol.for("react.suspense") : 60113, $16032c91407992e5$var$q = $16032c91407992e5$var$b ? Symbol.for("react.suspense_list") : 60120, $16032c91407992e5$var$r = $16032c91407992e5$var$b ? Symbol.for("react.memo") : 60115, $16032c91407992e5$var$t = $16032c91407992e5$var$b ? Symbol.for("react.lazy") : 60116, $16032c91407992e5$var$v = $16032c91407992e5$var$b ? Symbol.for("react.block") : 60121, $16032c91407992e5$var$w = $16032c91407992e5$var$b ? Symbol.for("react.fundamental") : 60117, $16032c91407992e5$var$x = $16032c91407992e5$var$b ? Symbol.for("react.responder") : 60118, $16032c91407992e5$var$y = $16032c91407992e5$var$b ? Symbol.for("react.scope") : 60119;
function $16032c91407992e5$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $16032c91407992e5$var$c:
                switch(a = a.type, a){
                    case $16032c91407992e5$var$l:
                    case $16032c91407992e5$var$m:
                    case $16032c91407992e5$var$e:
                    case $16032c91407992e5$var$g:
                    case $16032c91407992e5$var$f:
                    case $16032c91407992e5$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $16032c91407992e5$var$k:
                            case $16032c91407992e5$var$n:
                            case $16032c91407992e5$var$t:
                            case $16032c91407992e5$var$r:
                            case $16032c91407992e5$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $16032c91407992e5$var$d:
                return u;
        }
    }
}
function $16032c91407992e5$var$A(a) {
    return $16032c91407992e5$var$z(a) === $16032c91407992e5$var$m;
}
$16032c91407992e5$export$2b8d127b894957b9 = $16032c91407992e5$var$l;
$16032c91407992e5$export$cea3a54a6425200c = $16032c91407992e5$var$m;
$16032c91407992e5$export$a7c73072b1a182ae = $16032c91407992e5$var$k;
$16032c91407992e5$export$9f27bc3417b4524d = $16032c91407992e5$var$h;
$16032c91407992e5$export$db77ccec0bb4ccac = $16032c91407992e5$var$c;
$16032c91407992e5$export$8392c0c9d3dcbd35 = $16032c91407992e5$var$n;
$16032c91407992e5$export$ffb0004e005737fa = $16032c91407992e5$var$e;
$16032c91407992e5$export$b624eff549462981 = $16032c91407992e5$var$t;
$16032c91407992e5$export$7897aa7841a5380c = $16032c91407992e5$var$r;
$16032c91407992e5$export$602eac185826482c = $16032c91407992e5$var$d;
$16032c91407992e5$export$e2c29f18771995cb = $16032c91407992e5$var$g;
$16032c91407992e5$export$5f8d39834fd61797 = $16032c91407992e5$var$f;
$16032c91407992e5$export$74bf444e3cd11ea5 = $16032c91407992e5$var$p;
$16032c91407992e5$export$92387174baf9b227 = function(a) {
    return $16032c91407992e5$var$A(a) || $16032c91407992e5$var$z(a) === $16032c91407992e5$var$l;
};
$16032c91407992e5$export$ec112efeb987d9c6 = $16032c91407992e5$var$A;
$16032c91407992e5$export$b706b080d889d2c9 = function(a) {
    return $16032c91407992e5$var$z(a) === $16032c91407992e5$var$k;
};
$16032c91407992e5$export$5be5a87408f70ddc = function(a) {
    return $16032c91407992e5$var$z(a) === $16032c91407992e5$var$h;
};
$16032c91407992e5$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $16032c91407992e5$var$c;
};
$16032c91407992e5$export$455c2e768291efa6 = function(a) {
    return $16032c91407992e5$var$z(a) === $16032c91407992e5$var$n;
};
$16032c91407992e5$export$9522e17588c12572 = function(a) {
    return $16032c91407992e5$var$z(a) === $16032c91407992e5$var$e;
};
$16032c91407992e5$export$2110ac352bb060b9 = function(a) {
    return $16032c91407992e5$var$z(a) === $16032c91407992e5$var$t;
};
$16032c91407992e5$export$56885ab8b9c456ab = function(a) {
    return $16032c91407992e5$var$z(a) === $16032c91407992e5$var$r;
};
$16032c91407992e5$export$d927fcb6adf8f9de = function(a) {
    return $16032c91407992e5$var$z(a) === $16032c91407992e5$var$d;
};
$16032c91407992e5$export$b82d16f27459e05a = function(a) {
    return $16032c91407992e5$var$z(a) === $16032c91407992e5$var$g;
};
$16032c91407992e5$export$522c17b4f5e123e8 = function(a) {
    return $16032c91407992e5$var$z(a) === $16032c91407992e5$var$f;
};
$16032c91407992e5$export$1aabd8a0274ecfd6 = function(a) {
    return $16032c91407992e5$var$z(a) === $16032c91407992e5$var$p;
};
$16032c91407992e5$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $16032c91407992e5$var$e || a === $16032c91407992e5$var$m || a === $16032c91407992e5$var$g || a === $16032c91407992e5$var$f || a === $16032c91407992e5$var$p || a === $16032c91407992e5$var$q || "object" === typeof a && null !== a && (a.$$typeof === $16032c91407992e5$var$t || a.$$typeof === $16032c91407992e5$var$r || a.$$typeof === $16032c91407992e5$var$h || a.$$typeof === $16032c91407992e5$var$k || a.$$typeof === $16032c91407992e5$var$n || a.$$typeof === $16032c91407992e5$var$w || a.$$typeof === $16032c91407992e5$var$x || a.$$typeof === $16032c91407992e5$var$y || a.$$typeof === $16032c91407992e5$var$v);
};
$16032c91407992e5$export$f5bbd400c2f4426f = $16032c91407992e5$var$z;

});

parcelRegister("7WuWW", function(module, exports) {

var $gakZB = parcelRequire("gakZB");

var $bLnDq = parcelRequire("bLnDq");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $gakZB.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $bLnDq;
module.exports = isBuffer;

});
parcelRegister("gakZB", function(module, exports) {

var $jtSjz = parcelRequire("jtSjz");
/** Detect free variable `self`. */ var $bc4ddd3236bdafe1$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $bc4ddd3236bdafe1$var$root = $jtSjz || $bc4ddd3236bdafe1$var$freeSelf || Function('return this')();
module.exports = $bc4ddd3236bdafe1$var$root;

});
parcelRegister("jtSjz", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $e2eadb8563dc363a$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $e2eadb8563dc363a$var$freeGlobal;

});


parcelRegister("bLnDq", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $89066aea9c57ae97$var$stubFalse() {
    return false;
}
module.exports = $89066aea9c57ae97$var$stubFalse;

});


parcelRegister("luz9U", function(module, exports) {

var $jtSjz = parcelRequire("jtSjz");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $jtSjz.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("7fWyJ", function(module, exports) {

var $c8DlO = parcelRequire("c8DlO");

var $3LMLt = parcelRequire("3LMLt");
/** Used to compose bitmasks for value comparisons. */ var $54875bbef08c95a3$var$COMPARE_PARTIAL_FLAG = 1, $54875bbef08c95a3$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $54875bbef08c95a3$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $c8DlO;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $3LMLt(srcValue, objValue, $54875bbef08c95a3$var$COMPARE_PARTIAL_FLAG | $54875bbef08c95a3$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $54875bbef08c95a3$var$baseIsMatch;

});
parcelRegister("c8DlO", function(module, exports) {

var $4nNae = parcelRequire("4nNae");

var $iybkS = parcelRequire("iybkS");

var $fSjrh = parcelRequire("fSjrh");

var $3NsQ4 = parcelRequire("3NsQ4");

var $9nqYe = parcelRequire("9nqYe");

var $bpPji = parcelRequire("bpPji");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d64c19ee06a86b2$var$Stack(entries) {
    var data = this.__data__ = new $4nNae(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$8d64c19ee06a86b2$var$Stack.prototype.clear = $iybkS;
$8d64c19ee06a86b2$var$Stack.prototype['delete'] = $fSjrh;
$8d64c19ee06a86b2$var$Stack.prototype.get = $3NsQ4;
$8d64c19ee06a86b2$var$Stack.prototype.has = $9nqYe;
$8d64c19ee06a86b2$var$Stack.prototype.set = $bpPji;
module.exports = $8d64c19ee06a86b2$var$Stack;

});
parcelRegister("4nNae", function(module, exports) {

var $6MnIo = parcelRequire("6MnIo");

var $dfc1P = parcelRequire("dfc1P");

var $h4aRK = parcelRequire("h4aRK");

var $1O0p9 = parcelRequire("1O0p9");

var $hTaou = parcelRequire("hTaou");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $330f725f0a7984c6$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$330f725f0a7984c6$var$ListCache.prototype.clear = $6MnIo;
$330f725f0a7984c6$var$ListCache.prototype['delete'] = $dfc1P;
$330f725f0a7984c6$var$ListCache.prototype.get = $h4aRK;
$330f725f0a7984c6$var$ListCache.prototype.has = $1O0p9;
$330f725f0a7984c6$var$ListCache.prototype.set = $hTaou;
module.exports = $330f725f0a7984c6$var$ListCache;

});
parcelRegister("6MnIo", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $4ef99f183f069b37$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $4ef99f183f069b37$var$listCacheClear;

});

parcelRegister("dfc1P", function(module, exports) {

var $9EmLA = parcelRequire("9EmLA");
/** Used for built-in method references. */ var $9a4601af17572674$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $9a4601af17572674$var$splice = $9a4601af17572674$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9a4601af17572674$var$listCacheDelete(key) {
    var data = this.__data__, index = $9EmLA(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $9a4601af17572674$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $9a4601af17572674$var$listCacheDelete;

});
parcelRegister("9EmLA", function(module, exports) {

var $3qKMr = parcelRequire("3qKMr");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $7069826b3c2c3caa$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($3qKMr(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $7069826b3c2c3caa$var$assocIndexOf;

});
parcelRegister("3qKMr", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $27f816675c80ce6c$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $27f816675c80ce6c$var$eq;

});



parcelRegister("h4aRK", function(module, exports) {

var $9EmLA = parcelRequire("9EmLA");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c6cb3d1db5cef1f4$var$listCacheGet(key) {
    var data = this.__data__, index = $9EmLA(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $c6cb3d1db5cef1f4$var$listCacheGet;

});

parcelRegister("1O0p9", function(module, exports) {

var $9EmLA = parcelRequire("9EmLA");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $150ac65073ddd123$var$listCacheHas(key) {
    return $9EmLA(this.__data__, key) > -1;
}
module.exports = $150ac65073ddd123$var$listCacheHas;

});

parcelRegister("hTaou", function(module, exports) {

var $9EmLA = parcelRequire("9EmLA");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $d05fa2c1d36e5c0e$var$listCacheSet(key, value) {
    var data = this.__data__, index = $9EmLA(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $d05fa2c1d36e5c0e$var$listCacheSet;

});


parcelRegister("iybkS", function(module, exports) {

var $4nNae = parcelRequire("4nNae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $d8143201a0ea5fce$var$stackClear() {
    this.__data__ = new $4nNae;
    this.size = 0;
}
module.exports = $d8143201a0ea5fce$var$stackClear;

});

parcelRegister("fSjrh", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b8eafa558b0b17c5$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $b8eafa558b0b17c5$var$stackDelete;

});

parcelRegister("3NsQ4", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2c3c5181ce63ba21$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $2c3c5181ce63ba21$var$stackGet;

});

parcelRegister("9nqYe", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6d3b2ed645217eff$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $6d3b2ed645217eff$var$stackHas;

});

parcelRegister("bpPji", function(module, exports) {

var $4nNae = parcelRequire("4nNae");

var $9nKZ4 = parcelRequire("9nKZ4");

var $kSJ9Q = parcelRequire("kSJ9Q");
/** Used as the size to enable large array optimizations. */ var $84f9d4a505768c54$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $84f9d4a505768c54$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $4nNae) {
        var pairs = data.__data__;
        if (!$9nKZ4 || pairs.length < $84f9d4a505768c54$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $kSJ9Q(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $84f9d4a505768c54$var$stackSet;

});
parcelRegister("9nKZ4", function(module, exports) {

var $iyW5S = parcelRequire("iyW5S");

var $gakZB = parcelRequire("gakZB");
/* Built-in method references that are verified to be native. */ var $6d4ab5181ecebf73$var$Map = $iyW5S($gakZB, 'Map');
module.exports = $6d4ab5181ecebf73$var$Map;

});
parcelRegister("iyW5S", function(module, exports) {

var $355sw = parcelRequire("355sw");

var $hRKFc = parcelRequire("hRKFc");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $d8387732568bc3b7$var$getNative(object, key) {
    var value = $hRKFc(object, key);
    return $355sw(value) ? value : undefined;
}
module.exports = $d8387732568bc3b7$var$getNative;

});
parcelRegister("355sw", function(module, exports) {

var $htGFU = parcelRequire("htGFU");

var $9WWev = parcelRequire("9WWev");

var $7M8w7 = parcelRequire("7M8w7");

var $iVBcs = parcelRequire("iVBcs");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $23e612ca279b4b57$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $23e612ca279b4b57$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $23e612ca279b4b57$var$funcProto = Function.prototype, $23e612ca279b4b57$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $23e612ca279b4b57$var$funcToString = $23e612ca279b4b57$var$funcProto.toString;
/** Used to check objects for own properties. */ var $23e612ca279b4b57$var$hasOwnProperty = $23e612ca279b4b57$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $23e612ca279b4b57$var$reIsNative = RegExp('^' + $23e612ca279b4b57$var$funcToString.call($23e612ca279b4b57$var$hasOwnProperty).replace($23e612ca279b4b57$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $23e612ca279b4b57$var$baseIsNative(value) {
    if (!$7M8w7(value) || $9WWev(value)) return false;
    var pattern = $htGFU(value) ? $23e612ca279b4b57$var$reIsNative : $23e612ca279b4b57$var$reIsHostCtor;
    return pattern.test($iVBcs(value));
}
module.exports = $23e612ca279b4b57$var$baseIsNative;

});
parcelRegister("htGFU", function(module, exports) {

var $fwZuK = parcelRequire("fwZuK");

var $7M8w7 = parcelRequire("7M8w7");
/** `Object#toString` result references. */ var $cb963f7a16d9ec7d$var$asyncTag = '[object AsyncFunction]', $cb963f7a16d9ec7d$var$funcTag = '[object Function]', $cb963f7a16d9ec7d$var$genTag = '[object GeneratorFunction]', $cb963f7a16d9ec7d$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $cb963f7a16d9ec7d$var$isFunction(value) {
    if (!$7M8w7(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $fwZuK(value);
    return tag == $cb963f7a16d9ec7d$var$funcTag || tag == $cb963f7a16d9ec7d$var$genTag || tag == $cb963f7a16d9ec7d$var$asyncTag || tag == $cb963f7a16d9ec7d$var$proxyTag;
}
module.exports = $cb963f7a16d9ec7d$var$isFunction;

});
parcelRegister("fwZuK", function(module, exports) {

var $5HSZ3 = parcelRequire("5HSZ3");

var $294w9 = parcelRequire("294w9");

var $dxMQ2 = parcelRequire("dxMQ2");
/** `Object#toString` result references. */ var $b4e98bc9a5f9fc20$var$nullTag = '[object Null]', $b4e98bc9a5f9fc20$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $b4e98bc9a5f9fc20$var$symToStringTag = $5HSZ3 ? $5HSZ3.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $b4e98bc9a5f9fc20$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $b4e98bc9a5f9fc20$var$undefinedTag : $b4e98bc9a5f9fc20$var$nullTag;
    return $b4e98bc9a5f9fc20$var$symToStringTag && $b4e98bc9a5f9fc20$var$symToStringTag in Object(value) ? $294w9(value) : $dxMQ2(value);
}
module.exports = $b4e98bc9a5f9fc20$var$baseGetTag;

});
parcelRegister("5HSZ3", function(module, exports) {

var $gakZB = parcelRequire("gakZB");
/** Built-in value references. */ var $427b9e81a892c964$var$Symbol = $gakZB.Symbol;
module.exports = $427b9e81a892c964$var$Symbol;

});

parcelRegister("294w9", function(module, exports) {

var $5HSZ3 = parcelRequire("5HSZ3");
/** Used for built-in method references. */ var $18ffed1ea9eb9be1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $18ffed1ea9eb9be1$var$hasOwnProperty = $18ffed1ea9eb9be1$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $18ffed1ea9eb9be1$var$nativeObjectToString = $18ffed1ea9eb9be1$var$objectProto.toString;
/** Built-in value references. */ var $18ffed1ea9eb9be1$var$symToStringTag = $5HSZ3 ? $5HSZ3.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $18ffed1ea9eb9be1$var$getRawTag(value) {
    var isOwn = $18ffed1ea9eb9be1$var$hasOwnProperty.call(value, $18ffed1ea9eb9be1$var$symToStringTag), tag = value[$18ffed1ea9eb9be1$var$symToStringTag];
    try {
        value[$18ffed1ea9eb9be1$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $18ffed1ea9eb9be1$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$18ffed1ea9eb9be1$var$symToStringTag] = tag;
        else delete value[$18ffed1ea9eb9be1$var$symToStringTag];
    }
    return result;
}
module.exports = $18ffed1ea9eb9be1$var$getRawTag;

});

parcelRegister("dxMQ2", function(module, exports) {
/** Used for built-in method references. */ var $9dc43db89afb65ef$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9dc43db89afb65ef$var$nativeObjectToString = $9dc43db89afb65ef$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $9dc43db89afb65ef$var$objectToString(value) {
    return $9dc43db89afb65ef$var$nativeObjectToString.call(value);
}
module.exports = $9dc43db89afb65ef$var$objectToString;

});


parcelRegister("7M8w7", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $5a939f6d2b33fcc7$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $5a939f6d2b33fcc7$var$isObject;

});


parcelRegister("9WWev", function(module, exports) {

var $b71dG = parcelRequire("b71dG");
/** Used to detect methods masquerading as native. */ var $73e6b3b4d1e95b59$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($b71dG && $b71dG.keys && $b71dG.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $73e6b3b4d1e95b59$var$isMasked(func) {
    return !!$73e6b3b4d1e95b59$var$maskSrcKey && $73e6b3b4d1e95b59$var$maskSrcKey in func;
}
module.exports = $73e6b3b4d1e95b59$var$isMasked;

});
parcelRegister("b71dG", function(module, exports) {

var $gakZB = parcelRequire("gakZB");
/** Used to detect overreaching core-js shims. */ var $81714b5ffe683269$var$coreJsData = $gakZB["__core-js_shared__"];
module.exports = $81714b5ffe683269$var$coreJsData;

});


parcelRegister("iVBcs", function(module, exports) {
/** Used for built-in method references. */ var $dc7a68043fbf08f5$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $dc7a68043fbf08f5$var$funcToString = $dc7a68043fbf08f5$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $dc7a68043fbf08f5$var$toSource(func) {
    if (func != null) {
        try {
            return $dc7a68043fbf08f5$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $dc7a68043fbf08f5$var$toSource;

});


parcelRegister("hRKFc", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d01b9552245e8dc3$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d01b9552245e8dc3$var$getValue;

});



parcelRegister("kSJ9Q", function(module, exports) {

var $8ZopW = parcelRequire("8ZopW");

var $kV3kc = parcelRequire("kV3kc");

var $2WgM1 = parcelRequire("2WgM1");

var $470sZ = parcelRequire("470sZ");

var $3V2r6 = parcelRequire("3V2r6");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f33be12c46371615$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$f33be12c46371615$var$MapCache.prototype.clear = $8ZopW;
$f33be12c46371615$var$MapCache.prototype['delete'] = $kV3kc;
$f33be12c46371615$var$MapCache.prototype.get = $2WgM1;
$f33be12c46371615$var$MapCache.prototype.has = $470sZ;
$f33be12c46371615$var$MapCache.prototype.set = $3V2r6;
module.exports = $f33be12c46371615$var$MapCache;

});
parcelRegister("8ZopW", function(module, exports) {

var $2wiOc = parcelRequire("2wiOc");

var $4nNae = parcelRequire("4nNae");

var $9nKZ4 = parcelRequire("9nKZ4");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $68b6f60342d9b17b$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $2wiOc,
        'map': new ($9nKZ4 || $4nNae),
        'string': new $2wiOc
    };
}
module.exports = $68b6f60342d9b17b$var$mapCacheClear;

});
parcelRegister("2wiOc", function(module, exports) {

var $jJf21 = parcelRequire("jJf21");

var $l87Za = parcelRequire("l87Za");

var $jdC0O = parcelRequire("jdC0O");

var $loosU = parcelRequire("loosU");

var $jXnbp = parcelRequire("jXnbp");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1d5d28f5364a971b$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$1d5d28f5364a971b$var$Hash.prototype.clear = $jJf21;
$1d5d28f5364a971b$var$Hash.prototype['delete'] = $l87Za;
$1d5d28f5364a971b$var$Hash.prototype.get = $jdC0O;
$1d5d28f5364a971b$var$Hash.prototype.has = $loosU;
$1d5d28f5364a971b$var$Hash.prototype.set = $jXnbp;
module.exports = $1d5d28f5364a971b$var$Hash;

});
parcelRegister("jJf21", function(module, exports) {

var $2zM8t = parcelRequire("2zM8t");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $e5cde1412bd32cee$var$hashClear() {
    this.__data__ = $2zM8t ? $2zM8t(null) : {};
    this.size = 0;
}
module.exports = $e5cde1412bd32cee$var$hashClear;

});
parcelRegister("2zM8t", function(module, exports) {

var $iyW5S = parcelRequire("iyW5S");
/* Built-in method references that are verified to be native. */ var $1e04306899235f32$var$nativeCreate = $iyW5S(Object, 'create');
module.exports = $1e04306899235f32$var$nativeCreate;

});


parcelRegister("l87Za", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $f6208a1be3358312$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $f6208a1be3358312$var$hashDelete;

});

parcelRegister("jdC0O", function(module, exports) {

var $2zM8t = parcelRequire("2zM8t");
/** Used to stand-in for `undefined` hash values. */ var $dfdcb79d6055181b$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $dfdcb79d6055181b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dfdcb79d6055181b$var$hasOwnProperty = $dfdcb79d6055181b$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $dfdcb79d6055181b$var$hashGet(key) {
    var data = this.__data__;
    if ($2zM8t) {
        var result = data[key];
        return result === $dfdcb79d6055181b$var$HASH_UNDEFINED ? undefined : result;
    }
    return $dfdcb79d6055181b$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $dfdcb79d6055181b$var$hashGet;

});

parcelRegister("loosU", function(module, exports) {

var $2zM8t = parcelRequire("2zM8t");
/** Used for built-in method references. */ var $f92ed12d76234570$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f92ed12d76234570$var$hasOwnProperty = $f92ed12d76234570$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f92ed12d76234570$var$hashHas(key) {
    var data = this.__data__;
    return $2zM8t ? data[key] !== undefined : $f92ed12d76234570$var$hasOwnProperty.call(data, key);
}
module.exports = $f92ed12d76234570$var$hashHas;

});

parcelRegister("jXnbp", function(module, exports) {

var $2zM8t = parcelRequire("2zM8t");
/** Used to stand-in for `undefined` hash values. */ var $e87582b148391f57$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $e87582b148391f57$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $2zM8t && value === undefined ? $e87582b148391f57$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $e87582b148391f57$var$hashSet;

});



parcelRegister("kV3kc", function(module, exports) {

var $55DS6 = parcelRequire("55DS6");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $f3abb5c3ea5b8d28$var$mapCacheDelete(key) {
    var result = $55DS6(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $f3abb5c3ea5b8d28$var$mapCacheDelete;

});
parcelRegister("55DS6", function(module, exports) {

var $ecoNN = parcelRequire("ecoNN");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $3b4c5909718970eb$var$getMapData(map, key) {
    var data = map.__data__;
    return $ecoNN(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $3b4c5909718970eb$var$getMapData;

});
parcelRegister("ecoNN", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $a5656ce1ab0d542a$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $a5656ce1ab0d542a$var$isKeyable;

});



parcelRegister("2WgM1", function(module, exports) {

var $55DS6 = parcelRequire("55DS6");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $223e026da4823339$var$mapCacheGet(key) {
    return $55DS6(this, key).get(key);
}
module.exports = $223e026da4823339$var$mapCacheGet;

});

parcelRegister("470sZ", function(module, exports) {

var $55DS6 = parcelRequire("55DS6");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2fe82d8946c2fc4b$var$mapCacheHas(key) {
    return $55DS6(this, key).has(key);
}
module.exports = $2fe82d8946c2fc4b$var$mapCacheHas;

});

parcelRegister("3V2r6", function(module, exports) {

var $55DS6 = parcelRequire("55DS6");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $2da895b6de9cccea$var$mapCacheSet(key, value) {
    var data = $55DS6(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $2da895b6de9cccea$var$mapCacheSet;

});




parcelRegister("3LMLt", function(module, exports) {

var $4na4Q = parcelRequire("4na4Q");

var $1OvKS = parcelRequire("1OvKS");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $2beb9687b09f09c7$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$1OvKS(value) && !$1OvKS(other)) return value !== value && other !== other;
    return $4na4Q(value, other, bitmask, customizer, $2beb9687b09f09c7$var$baseIsEqual, stack);
}
module.exports = $2beb9687b09f09c7$var$baseIsEqual;

});
parcelRegister("4na4Q", function(module, exports) {

var $c8DlO = parcelRequire("c8DlO");

var $fpsBE = parcelRequire("fpsBE");

var $fAghA = parcelRequire("fAghA");

var $kqNqo = parcelRequire("kqNqo");

var $4fbm2 = parcelRequire("4fbm2");

var $1Hc0l = parcelRequire("1Hc0l");

var $7WuWW = parcelRequire("7WuWW");

var $cfQRA = parcelRequire("cfQRA");
/** Used to compose bitmasks for value comparisons. */ var $32f12085d2f921cb$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $32f12085d2f921cb$var$argsTag = '[object Arguments]', $32f12085d2f921cb$var$arrayTag = '[object Array]', $32f12085d2f921cb$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $32f12085d2f921cb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $32f12085d2f921cb$var$hasOwnProperty = $32f12085d2f921cb$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $32f12085d2f921cb$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $1Hc0l(object), othIsArr = $1Hc0l(other), objTag = objIsArr ? $32f12085d2f921cb$var$arrayTag : $4fbm2(object), othTag = othIsArr ? $32f12085d2f921cb$var$arrayTag : $4fbm2(other);
    objTag = objTag == $32f12085d2f921cb$var$argsTag ? $32f12085d2f921cb$var$objectTag : objTag;
    othTag = othTag == $32f12085d2f921cb$var$argsTag ? $32f12085d2f921cb$var$objectTag : othTag;
    var objIsObj = objTag == $32f12085d2f921cb$var$objectTag, othIsObj = othTag == $32f12085d2f921cb$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $7WuWW(object)) {
        if (!$7WuWW(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $c8DlO);
        return objIsArr || $cfQRA(object) ? $fpsBE(object, other, bitmask, customizer, equalFunc, stack) : $fAghA(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $32f12085d2f921cb$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $32f12085d2f921cb$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $32f12085d2f921cb$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $c8DlO);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $c8DlO);
    return $kqNqo(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $32f12085d2f921cb$var$baseIsEqualDeep;

});
parcelRegister("fpsBE", function(module, exports) {

var $kxgyu = parcelRequire("kxgyu");

var $3FFJi = parcelRequire("3FFJi");

var $97AFs = parcelRequire("97AFs");
/** Used to compose bitmasks for value comparisons. */ var $b37f61700031496c$var$COMPARE_PARTIAL_FLAG = 1, $b37f61700031496c$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $b37f61700031496c$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $b37f61700031496c$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $b37f61700031496c$var$COMPARE_UNORDERED_FLAG ? new $kxgyu : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$3FFJi(other, function(othValue, othIndex) {
                if (!$97AFs(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $b37f61700031496c$var$equalArrays;

});
parcelRegister("kxgyu", function(module, exports) {

var $kSJ9Q = parcelRequire("kSJ9Q");

var $imSNx = parcelRequire("imSNx");

var $b4p4o = parcelRequire("b4p4o");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $ef33bb43ef84dfd3$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $kSJ9Q;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$ef33bb43ef84dfd3$var$SetCache.prototype.add = $ef33bb43ef84dfd3$var$SetCache.prototype.push = $imSNx;
$ef33bb43ef84dfd3$var$SetCache.prototype.has = $b4p4o;
module.exports = $ef33bb43ef84dfd3$var$SetCache;

});
parcelRegister("imSNx", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $d5f4c9d54385d04f$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $d5f4c9d54385d04f$var$setCacheAdd(value) {
    this.__data__.set(value, $d5f4c9d54385d04f$var$HASH_UNDEFINED);
    return this;
}
module.exports = $d5f4c9d54385d04f$var$setCacheAdd;

});

parcelRegister("b4p4o", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $80f383ca4e02df6b$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $80f383ca4e02df6b$var$setCacheHas;

});


parcelRegister("3FFJi", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $2ac5920b094e898f$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $2ac5920b094e898f$var$arraySome;

});

parcelRegister("97AFs", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6a4135f45e8d21b2$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $6a4135f45e8d21b2$var$cacheHas;

});


parcelRegister("fAghA", function(module, exports) {

var $5HSZ3 = parcelRequire("5HSZ3");

var $gsH5A = parcelRequire("gsH5A");

var $3qKMr = parcelRequire("3qKMr");

var $fpsBE = parcelRequire("fpsBE");

var $cfmYK = parcelRequire("cfmYK");

var $49ioj = parcelRequire("49ioj");
/** Used to compose bitmasks for value comparisons. */ var $b586d93943c08ecc$var$COMPARE_PARTIAL_FLAG = 1, $b586d93943c08ecc$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $b586d93943c08ecc$var$boolTag = '[object Boolean]', $b586d93943c08ecc$var$dateTag = '[object Date]', $b586d93943c08ecc$var$errorTag = '[object Error]', $b586d93943c08ecc$var$mapTag = '[object Map]', $b586d93943c08ecc$var$numberTag = '[object Number]', $b586d93943c08ecc$var$regexpTag = '[object RegExp]', $b586d93943c08ecc$var$setTag = '[object Set]', $b586d93943c08ecc$var$stringTag = '[object String]', $b586d93943c08ecc$var$symbolTag = '[object Symbol]';
var $b586d93943c08ecc$var$arrayBufferTag = '[object ArrayBuffer]', $b586d93943c08ecc$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $b586d93943c08ecc$var$symbolProto = $5HSZ3 ? $5HSZ3.prototype : undefined, $b586d93943c08ecc$var$symbolValueOf = $b586d93943c08ecc$var$symbolProto ? $b586d93943c08ecc$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $b586d93943c08ecc$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $b586d93943c08ecc$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $b586d93943c08ecc$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $gsH5A(object), new $gsH5A(other))) return false;
            return true;
        case $b586d93943c08ecc$var$boolTag:
        case $b586d93943c08ecc$var$dateTag:
        case $b586d93943c08ecc$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $3qKMr(+object, +other);
        case $b586d93943c08ecc$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $b586d93943c08ecc$var$regexpTag:
        case $b586d93943c08ecc$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $b586d93943c08ecc$var$mapTag:
            var convert = $cfmYK;
        case $b586d93943c08ecc$var$setTag:
            var isPartial = bitmask & $b586d93943c08ecc$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $49ioj);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $b586d93943c08ecc$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $fpsBE(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $b586d93943c08ecc$var$symbolTag:
            if ($b586d93943c08ecc$var$symbolValueOf) return $b586d93943c08ecc$var$symbolValueOf.call(object) == $b586d93943c08ecc$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $b586d93943c08ecc$var$equalByTag;

});
parcelRegister("gsH5A", function(module, exports) {

var $gakZB = parcelRequire("gakZB");
/** Built-in value references. */ var $bfc0af71fd107403$var$Uint8Array = $gakZB.Uint8Array;
module.exports = $bfc0af71fd107403$var$Uint8Array;

});

parcelRegister("cfmYK", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $8ea8b5e122cfa971$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $8ea8b5e122cfa971$var$mapToArray;

});

parcelRegister("49ioj", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $305644c84984449a$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $305644c84984449a$var$setToArray;

});


parcelRegister("kqNqo", function(module, exports) {

var $ceLPF = parcelRequire("ceLPF");
/** Used to compose bitmasks for value comparisons. */ var $03d6a7889759d4cd$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $03d6a7889759d4cd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $03d6a7889759d4cd$var$hasOwnProperty = $03d6a7889759d4cd$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $03d6a7889759d4cd$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $03d6a7889759d4cd$var$COMPARE_PARTIAL_FLAG, objProps = $ceLPF(object), objLength = objProps.length, othProps = $ceLPF(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $03d6a7889759d4cd$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $03d6a7889759d4cd$var$equalObjects;

});
parcelRegister("ceLPF", function(module, exports) {

var $cyAjh = parcelRequire("cyAjh");

var $2AXfG = parcelRequire("2AXfG");

var $icwHc = parcelRequire("icwHc");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $8e8be55edd06e0b9$var$getAllKeys(object) {
    return $cyAjh(object, $icwHc, $2AXfG);
}
module.exports = $8e8be55edd06e0b9$var$getAllKeys;

});
parcelRegister("cyAjh", function(module, exports) {

var $hsFEc = parcelRequire("hsFEc");

var $1Hc0l = parcelRequire("1Hc0l");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9244d36ec7ba001d$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $1Hc0l(object) ? result : $hsFEc(result, symbolsFunc(object));
}
module.exports = $9244d36ec7ba001d$var$baseGetAllKeys;

});
parcelRegister("hsFEc", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cb655b7a55299679$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $cb655b7a55299679$var$arrayPush;

});

parcelRegister("1Hc0l", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $13c31e77a4015437$var$isArray = Array.isArray;
module.exports = $13c31e77a4015437$var$isArray;

});


parcelRegister("2AXfG", function(module, exports) {

var $lDlu5 = parcelRequire("lDlu5");

var $6PME4 = parcelRequire("6PME4");
/** Used for built-in method references. */ var $1e3ce7c0869cc48a$var$objectProto = Object.prototype;
/** Built-in value references. */ var $1e3ce7c0869cc48a$var$propertyIsEnumerable = $1e3ce7c0869cc48a$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1e3ce7c0869cc48a$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $1e3ce7c0869cc48a$var$getSymbols = !$1e3ce7c0869cc48a$var$nativeGetSymbols ? $6PME4 : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $lDlu5($1e3ce7c0869cc48a$var$nativeGetSymbols(object), function(symbol) {
        return $1e3ce7c0869cc48a$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $1e3ce7c0869cc48a$var$getSymbols;

});
parcelRegister("lDlu5", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $fbfde7cc569db854$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $fbfde7cc569db854$var$arrayFilter;

});

parcelRegister("6PME4", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $4f9d3d6dd7c14427$var$stubArray() {
    return [];
}
module.exports = $4f9d3d6dd7c14427$var$stubArray;

});


parcelRegister("icwHc", function(module, exports) {

var $4D8pR = parcelRequire("4D8pR");

var $6BK37 = parcelRequire("6BK37");

var $hnmud = parcelRequire("hnmud");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $d402b5a8f76a59ec$var$keys(object) {
    return $hnmud(object) ? $4D8pR(object) : $6BK37(object);
}
module.exports = $d402b5a8f76a59ec$var$keys;

});
parcelRegister("4D8pR", function(module, exports) {

var $za1jS = parcelRequire("za1jS");

var $bI9Dv = parcelRequire("bI9Dv");

var $1Hc0l = parcelRequire("1Hc0l");

var $7WuWW = parcelRequire("7WuWW");

var $jBrG4 = parcelRequire("jBrG4");

var $cfQRA = parcelRequire("cfQRA");
/** Used for built-in method references. */ var $35f15534f6c69570$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $35f15534f6c69570$var$hasOwnProperty = $35f15534f6c69570$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $35f15534f6c69570$var$arrayLikeKeys(value, inherited) {
    var isArr = $1Hc0l(value), isArg = !isArr && $bI9Dv(value), isBuff = !isArr && !isArg && $7WuWW(value), isType = !isArr && !isArg && !isBuff && $cfQRA(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $za1jS(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $35f15534f6c69570$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $jBrG4(key, length)))) result.push(key);
    return result;
}
module.exports = $35f15534f6c69570$var$arrayLikeKeys;

});
parcelRegister("za1jS", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $069b0ad1b23db455$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $069b0ad1b23db455$var$baseTimes;

});

parcelRegister("bI9Dv", function(module, exports) {

var $jUGCH = parcelRequire("jUGCH");

var $1OvKS = parcelRequire("1OvKS");
/** Used for built-in method references. */ var $886b4750cf3b0534$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $886b4750cf3b0534$var$hasOwnProperty = $886b4750cf3b0534$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $886b4750cf3b0534$var$propertyIsEnumerable = $886b4750cf3b0534$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $886b4750cf3b0534$var$isArguments = $jUGCH(function() {
    return arguments;
}()) ? $jUGCH : function(value) {
    return $1OvKS(value) && $886b4750cf3b0534$var$hasOwnProperty.call(value, 'callee') && !$886b4750cf3b0534$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $886b4750cf3b0534$var$isArguments;

});
parcelRegister("jUGCH", function(module, exports) {

var $fwZuK = parcelRequire("fwZuK");

var $1OvKS = parcelRequire("1OvKS");
/** `Object#toString` result references. */ var $e7f44f5bbcd994ff$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $e7f44f5bbcd994ff$var$baseIsArguments(value) {
    return $1OvKS(value) && $fwZuK(value) == $e7f44f5bbcd994ff$var$argsTag;
}
module.exports = $e7f44f5bbcd994ff$var$baseIsArguments;

});
parcelRegister("1OvKS", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $152317dda474fe1c$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $152317dda474fe1c$var$isObjectLike;

});



parcelRegister("jBrG4", function(module, exports) {
/** Used as references for various `Number` constants. */ var $e456f1369ab078ab$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $e456f1369ab078ab$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $e456f1369ab078ab$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $e456f1369ab078ab$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $e456f1369ab078ab$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $e456f1369ab078ab$var$isIndex;

});

parcelRegister("cfQRA", function(module, exports) {

var $14kfv = parcelRequire("14kfv");

var $e46UM = parcelRequire("e46UM");

var $luz9U = parcelRequire("luz9U");
/* Node.js helper references. */ var $8ebfe451d86d0160$var$nodeIsTypedArray = $luz9U && $luz9U.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $8ebfe451d86d0160$var$isTypedArray = $8ebfe451d86d0160$var$nodeIsTypedArray ? $e46UM($8ebfe451d86d0160$var$nodeIsTypedArray) : $14kfv;
module.exports = $8ebfe451d86d0160$var$isTypedArray;

});
parcelRegister("14kfv", function(module, exports) {

var $fwZuK = parcelRequire("fwZuK");

var $ji1xl = parcelRequire("ji1xl");

var $1OvKS = parcelRequire("1OvKS");
/** `Object#toString` result references. */ var $0c75df36eddc079b$var$argsTag = '[object Arguments]', $0c75df36eddc079b$var$arrayTag = '[object Array]', $0c75df36eddc079b$var$boolTag = '[object Boolean]', $0c75df36eddc079b$var$dateTag = '[object Date]', $0c75df36eddc079b$var$errorTag = '[object Error]', $0c75df36eddc079b$var$funcTag = '[object Function]', $0c75df36eddc079b$var$mapTag = '[object Map]', $0c75df36eddc079b$var$numberTag = '[object Number]', $0c75df36eddc079b$var$objectTag = '[object Object]', $0c75df36eddc079b$var$regexpTag = '[object RegExp]', $0c75df36eddc079b$var$setTag = '[object Set]', $0c75df36eddc079b$var$stringTag = '[object String]', $0c75df36eddc079b$var$weakMapTag = '[object WeakMap]';
var $0c75df36eddc079b$var$arrayBufferTag = '[object ArrayBuffer]', $0c75df36eddc079b$var$dataViewTag = '[object DataView]', $0c75df36eddc079b$var$float32Tag = '[object Float32Array]', $0c75df36eddc079b$var$float64Tag = '[object Float64Array]', $0c75df36eddc079b$var$int8Tag = '[object Int8Array]', $0c75df36eddc079b$var$int16Tag = '[object Int16Array]', $0c75df36eddc079b$var$int32Tag = '[object Int32Array]', $0c75df36eddc079b$var$uint8Tag = '[object Uint8Array]', $0c75df36eddc079b$var$uint8ClampedTag = '[object Uint8ClampedArray]', $0c75df36eddc079b$var$uint16Tag = '[object Uint16Array]', $0c75df36eddc079b$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $0c75df36eddc079b$var$typedArrayTags = {};
$0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$float32Tag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$float64Tag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$int8Tag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$int16Tag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$int32Tag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$uint8Tag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$uint8ClampedTag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$uint16Tag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$uint32Tag] = true;
$0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$argsTag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$arrayTag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$arrayBufferTag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$boolTag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$dataViewTag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$dateTag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$errorTag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$funcTag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$mapTag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$numberTag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$objectTag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$regexpTag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$setTag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$stringTag] = $0c75df36eddc079b$var$typedArrayTags[$0c75df36eddc079b$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $0c75df36eddc079b$var$baseIsTypedArray(value) {
    return $1OvKS(value) && $ji1xl(value.length) && !!$0c75df36eddc079b$var$typedArrayTags[$fwZuK(value)];
}
module.exports = $0c75df36eddc079b$var$baseIsTypedArray;

});
parcelRegister("ji1xl", function(module, exports) {
/** Used as references for various `Number` constants. */ var $e0b0e3f364bcc766$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $e0b0e3f364bcc766$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $e0b0e3f364bcc766$var$MAX_SAFE_INTEGER;
}
module.exports = $e0b0e3f364bcc766$var$isLength;

});


parcelRegister("e46UM", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $a3d6cd8fd08fb2b1$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $a3d6cd8fd08fb2b1$var$baseUnary;

});



parcelRegister("6BK37", function(module, exports) {

var $lxWr3 = parcelRequire("lxWr3");

var $4AAef = parcelRequire("4AAef");
/** Used for built-in method references. */ var $4cf9eb2f74cfc37b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4cf9eb2f74cfc37b$var$hasOwnProperty = $4cf9eb2f74cfc37b$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $4cf9eb2f74cfc37b$var$baseKeys(object) {
    if (!$lxWr3(object)) return $4AAef(object);
    var result = [];
    for(var key in Object(object))if ($4cf9eb2f74cfc37b$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $4cf9eb2f74cfc37b$var$baseKeys;

});
parcelRegister("lxWr3", function(module, exports) {
/** Used for built-in method references. */ var $fafa021046a42b28$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $fafa021046a42b28$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $fafa021046a42b28$var$objectProto;
    return value === proto;
}
module.exports = $fafa021046a42b28$var$isPrototype;

});

parcelRegister("4AAef", function(module, exports) {

var $d5o8J = parcelRequire("d5o8J");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3576a0833f874e47$var$nativeKeys = $d5o8J(Object.keys, Object);
module.exports = $3576a0833f874e47$var$nativeKeys;

});
parcelRegister("d5o8J", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $986e77ab4dc48ffc$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $986e77ab4dc48ffc$var$overArg;

});



parcelRegister("hnmud", function(module, exports) {

var $htGFU = parcelRequire("htGFU");

var $ji1xl = parcelRequire("ji1xl");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ca6606fc265f8b67$var$isArrayLike(value) {
    return value != null && $ji1xl(value.length) && !$htGFU(value);
}
module.exports = $ca6606fc265f8b67$var$isArrayLike;

});




parcelRegister("4fbm2", function(module, exports) {

var $5iM5H = parcelRequire("5iM5H");

var $9nKZ4 = parcelRequire("9nKZ4");

var $7Hge7 = parcelRequire("7Hge7");

var $bHf0q = parcelRequire("bHf0q");

var $kwqqP = parcelRequire("kwqqP");

var $fwZuK = parcelRequire("fwZuK");

var $iVBcs = parcelRequire("iVBcs");
/** `Object#toString` result references. */ var $31715eea62244a9e$var$mapTag = '[object Map]', $31715eea62244a9e$var$objectTag = '[object Object]', $31715eea62244a9e$var$promiseTag = '[object Promise]', $31715eea62244a9e$var$setTag = '[object Set]', $31715eea62244a9e$var$weakMapTag = '[object WeakMap]';
var $31715eea62244a9e$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $31715eea62244a9e$var$dataViewCtorString = $iVBcs($5iM5H), $31715eea62244a9e$var$mapCtorString = $iVBcs($9nKZ4), $31715eea62244a9e$var$promiseCtorString = $iVBcs($7Hge7), $31715eea62244a9e$var$setCtorString = $iVBcs($bHf0q), $31715eea62244a9e$var$weakMapCtorString = $iVBcs($kwqqP);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $31715eea62244a9e$var$getTag = $fwZuK;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($5iM5H && $31715eea62244a9e$var$getTag(new $5iM5H(new ArrayBuffer(1))) != $31715eea62244a9e$var$dataViewTag || $9nKZ4 && $31715eea62244a9e$var$getTag(new $9nKZ4) != $31715eea62244a9e$var$mapTag || $7Hge7 && $31715eea62244a9e$var$getTag($7Hge7.resolve()) != $31715eea62244a9e$var$promiseTag || $bHf0q && $31715eea62244a9e$var$getTag(new $bHf0q) != $31715eea62244a9e$var$setTag || $kwqqP && $31715eea62244a9e$var$getTag(new $kwqqP) != $31715eea62244a9e$var$weakMapTag) $31715eea62244a9e$var$getTag = function(value) {
    var result = $fwZuK(value), Ctor = result == $31715eea62244a9e$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $iVBcs(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $31715eea62244a9e$var$dataViewCtorString:
            return $31715eea62244a9e$var$dataViewTag;
        case $31715eea62244a9e$var$mapCtorString:
            return $31715eea62244a9e$var$mapTag;
        case $31715eea62244a9e$var$promiseCtorString:
            return $31715eea62244a9e$var$promiseTag;
        case $31715eea62244a9e$var$setCtorString:
            return $31715eea62244a9e$var$setTag;
        case $31715eea62244a9e$var$weakMapCtorString:
            return $31715eea62244a9e$var$weakMapTag;
    }
    return result;
};
module.exports = $31715eea62244a9e$var$getTag;

});
parcelRegister("5iM5H", function(module, exports) {

var $iyW5S = parcelRequire("iyW5S");

var $gakZB = parcelRequire("gakZB");
/* Built-in method references that are verified to be native. */ var $3dc3f005bd2bebb9$var$DataView = $iyW5S($gakZB, 'DataView');
module.exports = $3dc3f005bd2bebb9$var$DataView;

});

parcelRegister("7Hge7", function(module, exports) {

var $iyW5S = parcelRequire("iyW5S");

var $gakZB = parcelRequire("gakZB");
/* Built-in method references that are verified to be native. */ var $59a922d8c36c2416$var$Promise = $iyW5S($gakZB, 'Promise');
module.exports = $59a922d8c36c2416$var$Promise;

});

parcelRegister("bHf0q", function(module, exports) {

var $iyW5S = parcelRequire("iyW5S");

var $gakZB = parcelRequire("gakZB");
/* Built-in method references that are verified to be native. */ var $883f59b3bf8718c4$var$Set = $iyW5S($gakZB, 'Set');
module.exports = $883f59b3bf8718c4$var$Set;

});

parcelRegister("kwqqP", function(module, exports) {

var $iyW5S = parcelRequire("iyW5S");

var $gakZB = parcelRequire("gakZB");
/* Built-in method references that are verified to be native. */ var $ef0b4c9610788d14$var$WeakMap = $iyW5S($gakZB, 'WeakMap');
module.exports = $ef0b4c9610788d14$var$WeakMap;

});





parcelRegister("eQCTh", function(module, exports) {

var $hPdF0 = parcelRequire("hPdF0");

var $icwHc = parcelRequire("icwHc");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $acf416e4c295e81b$var$getMatchData(object) {
    var result = $icwHc(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $hPdF0(value)
        ];
    }
    return result;
}
module.exports = $acf416e4c295e81b$var$getMatchData;

});
parcelRegister("hPdF0", function(module, exports) {

var $7M8w7 = parcelRequire("7M8w7");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $cfa1cbc7609e6982$var$isStrictComparable(value) {
    return value === value && !$7M8w7(value);
}
module.exports = $cfa1cbc7609e6982$var$isStrictComparable;

});


parcelRegister("lsyzF", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", () => $f9f7083e60f89ed8$export$306c0aa65ff9ec16, (v) => $f9f7083e60f89ed8$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f9f7083e60f89ed8$export$306c0aa65ff9ec16;
"use strict";

var $2hRE7 = parcelRequire("2hRE7");
function $f9f7083e60f89ed8$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $f9f7083e60f89ed8$var$objectIs = "function" === typeof Object.is ? Object.is : $f9f7083e60f89ed8$var$is, $f9f7083e60f89ed8$var$useState = $2hRE7.useState, $f9f7083e60f89ed8$var$useEffect = $2hRE7.useEffect, $f9f7083e60f89ed8$var$useLayoutEffect = $2hRE7.useLayoutEffect, $f9f7083e60f89ed8$var$useDebugValue = $2hRE7.useDebugValue;
function $f9f7083e60f89ed8$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $f9f7083e60f89ed8$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $f9f7083e60f89ed8$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $f9f7083e60f89ed8$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $f9f7083e60f89ed8$var$useEffect(function() {
        $f9f7083e60f89ed8$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $f9f7083e60f89ed8$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $f9f7083e60f89ed8$var$useDebugValue(value);
    return value;
}
function $f9f7083e60f89ed8$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$f9f7083e60f89ed8$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $f9f7083e60f89ed8$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $f9f7083e60f89ed8$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $f9f7083e60f89ed8$var$useSyncExternalStore$1 : $f9f7083e60f89ed8$var$useSyncExternalStore$2;
$f9f7083e60f89ed8$export$306c0aa65ff9ec16 = void 0 !== $2hRE7.useSyncExternalStore ? $2hRE7.useSyncExternalStore : $f9f7083e60f89ed8$var$shim;

});

parcelRegister("gSyep", function(module, exports) {

var $gakZB = parcelRequire("gakZB");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $gakZB.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("72pt0", function(module, exports) {

var $2M83v = parcelRequire("2M83v");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $51fc797e8ffa156a$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $51fc797e8ffa156a$var$MAX_UINT32 = 4294967295;

var $3VN6j = parcelRequire("3VN6j");
var $51fc797e8ffa156a$require$Buffer = $3VN6j.Buffer;
var $51fc797e8ffa156a$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
module.exports = function(size, cb) {
    if ($51fc797e8ffa156a$var$crypto && $51fc797e8ffa156a$var$crypto.getRandomValues) // browser
    return $51fc797e8ffa156a$var$randomBytes(size, cb);
    else {
        if (globalThis.crypto && globalThis.crypto.randomBytes) // tesseract runtime
        return globalThis.crypto.randomBytes(size, cb);
        else // tesseract init time
        throw new Error('No randomBytes() support in current environment.');
    }
};
function $51fc797e8ffa156a$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $51fc797e8ffa156a$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $51fc797e8ffa156a$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $51fc797e8ffa156a$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $51fc797e8ffa156a$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $51fc797e8ffa156a$var$crypto.getRandomValues(bytes.slice(generated, generated + $51fc797e8ffa156a$var$MAX_BYTES));
        else $51fc797e8ffa156a$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $2M83v.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("3VN6j", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $2zYso = parcelRequire("2zYso");
var $2dccc858b0d25c08$var$Buffer = $2zYso.Buffer;
// alternative to using Object.keys for old browsers
function $2dccc858b0d25c08$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($2dccc858b0d25c08$var$Buffer.from && $2dccc858b0d25c08$var$Buffer.alloc && $2dccc858b0d25c08$var$Buffer.allocUnsafe && $2dccc858b0d25c08$var$Buffer.allocUnsafeSlow) module.exports = $2zYso;
else {
    // Copy properties from require('buffer')
    $2dccc858b0d25c08$var$copyProps($2zYso, module.exports);
    module.exports.Buffer = $2dccc858b0d25c08$var$SafeBuffer;
}
function $2dccc858b0d25c08$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $2dccc858b0d25c08$var$Buffer(arg, encodingOrOffset, length);
}
$2dccc858b0d25c08$var$SafeBuffer.prototype = Object.create($2dccc858b0d25c08$var$Buffer.prototype);
// Copy static methods from Buffer
$2dccc858b0d25c08$var$copyProps($2dccc858b0d25c08$var$Buffer, $2dccc858b0d25c08$var$SafeBuffer);
$2dccc858b0d25c08$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $2dccc858b0d25c08$var$Buffer(arg, encodingOrOffset, length);
};
$2dccc858b0d25c08$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $2dccc858b0d25c08$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$2dccc858b0d25c08$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $2dccc858b0d25c08$var$Buffer(size);
};
$2dccc858b0d25c08$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $2zYso.SlowBuffer(size);
};

});


parcelRegister("bsVm9", function(module, exports) {
'use strict';

var $lubO4 = parcelRequire("lubO4");

var $aZDj9 = parcelRequire("aZDj9");

var $bxooq = parcelRequire("bxooq");

var $fwBLh = parcelRequire("fwBLh");

var $AhG97 = parcelRequire("AhG97");
function $858eccfc8e27405d$var$Hash(hash) {
    $AhG97.call(this, 'digest');
    this._hash = hash;
}
$lubO4($858eccfc8e27405d$var$Hash, $AhG97);
$858eccfc8e27405d$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$858eccfc8e27405d$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $aZDj9();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $bxooq();
    return new $858eccfc8e27405d$var$Hash($fwBLh(alg));
};

});
parcelRegister("lubO4", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("aZDj9", function(module, exports) {
'use strict';

var $lubO4 = parcelRequire("lubO4");

var $aGIAS = parcelRequire("aGIAS");

var $3VN6j = parcelRequire("3VN6j");
var $800e17a285abc15f$require$Buffer = $3VN6j.Buffer;
var $800e17a285abc15f$var$ARRAY16 = new Array(16);
function $800e17a285abc15f$var$MD5() {
    $aGIAS.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$lubO4($800e17a285abc15f$var$MD5, $aGIAS);
$800e17a285abc15f$var$MD5.prototype._update = function() {
    var M = $800e17a285abc15f$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $800e17a285abc15f$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $800e17a285abc15f$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $800e17a285abc15f$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $800e17a285abc15f$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $800e17a285abc15f$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $800e17a285abc15f$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $800e17a285abc15f$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $800e17a285abc15f$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $800e17a285abc15f$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $800e17a285abc15f$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $800e17a285abc15f$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $800e17a285abc15f$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $800e17a285abc15f$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $800e17a285abc15f$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $800e17a285abc15f$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $800e17a285abc15f$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $800e17a285abc15f$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $800e17a285abc15f$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $800e17a285abc15f$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $800e17a285abc15f$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $800e17a285abc15f$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $800e17a285abc15f$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $800e17a285abc15f$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $800e17a285abc15f$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $800e17a285abc15f$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $800e17a285abc15f$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $800e17a285abc15f$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $800e17a285abc15f$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $800e17a285abc15f$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $800e17a285abc15f$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $800e17a285abc15f$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $800e17a285abc15f$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $800e17a285abc15f$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $800e17a285abc15f$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $800e17a285abc15f$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $800e17a285abc15f$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $800e17a285abc15f$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $800e17a285abc15f$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $800e17a285abc15f$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $800e17a285abc15f$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $800e17a285abc15f$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $800e17a285abc15f$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $800e17a285abc15f$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $800e17a285abc15f$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $800e17a285abc15f$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $800e17a285abc15f$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $800e17a285abc15f$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $800e17a285abc15f$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $800e17a285abc15f$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $800e17a285abc15f$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $800e17a285abc15f$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $800e17a285abc15f$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $800e17a285abc15f$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $800e17a285abc15f$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $800e17a285abc15f$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $800e17a285abc15f$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $800e17a285abc15f$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $800e17a285abc15f$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $800e17a285abc15f$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $800e17a285abc15f$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $800e17a285abc15f$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $800e17a285abc15f$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $800e17a285abc15f$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $800e17a285abc15f$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$800e17a285abc15f$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $800e17a285abc15f$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $800e17a285abc15f$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $800e17a285abc15f$var$fnF(a, b, c, d, m, k, s) {
    return $800e17a285abc15f$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $800e17a285abc15f$var$fnG(a, b, c, d, m, k, s) {
    return $800e17a285abc15f$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $800e17a285abc15f$var$fnH(a, b, c, d, m, k, s) {
    return $800e17a285abc15f$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $800e17a285abc15f$var$fnI(a, b, c, d, m, k, s) {
    return $800e17a285abc15f$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $800e17a285abc15f$var$MD5;

});
parcelRegister("aGIAS", function(module, exports) {
'use strict';

var $3VN6j = parcelRequire("3VN6j");
var $7c806b0a86eb4466$require$Buffer = $3VN6j.Buffer;

var $gefsu = parcelRequire("gefsu");

var $aM5qg = parcelRequire("aM5qg");
var $7c806b0a86eb4466$require$Transform = $aM5qg.Transform;

var $lubO4 = parcelRequire("lubO4");
function $7c806b0a86eb4466$var$HashBase(blockSize) {
    $7c806b0a86eb4466$require$Transform.call(this);
    this._block = $7c806b0a86eb4466$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$lubO4($7c806b0a86eb4466$var$HashBase, $7c806b0a86eb4466$require$Transform);
$7c806b0a86eb4466$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$7c806b0a86eb4466$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$7c806b0a86eb4466$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    var dataBuffer = $gefsu(data, encoding); // asserts correct input type
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + dataBuffer.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;){
            block[i] = dataBuffer[offset];
            i += 1;
            offset += 1;
        }
        this._update();
        this._blockOffset = 0;
    }
    while(offset < dataBuffer.length){
        block[this._blockOffset] = dataBuffer[offset];
        this._blockOffset += 1;
        offset += 1;
    }
    // update length
    for(var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$7c806b0a86eb4466$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$7c806b0a86eb4466$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$7c806b0a86eb4466$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $7c806b0a86eb4466$var$HashBase;

});
parcelRegister("gefsu", function(module, exports) {
'use strict';

var $3VN6j = parcelRequire("3VN6j");
var $bd09f1e678a8180f$require$Buffer = $3VN6j.Buffer;

var $7roic = parcelRequire("7roic");
var $bd09f1e678a8180f$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $bd09f1e678a8180f$var$useArrayBuffer = $bd09f1e678a8180f$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $bd09f1e678a8180f$var$isView = $bd09f1e678a8180f$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding) {
    if (typeof thing === 'string' || $bd09f1e678a8180f$require$Buffer.isBuffer(thing) || $bd09f1e678a8180f$var$useUint8Array && thing instanceof Uint8Array || $bd09f1e678a8180f$var$isView && $bd09f1e678a8180f$var$isView(thing)) return $7roic(thing, encoding);
    throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

});
parcelRegister("7roic", function(module, exports) {
'use strict';

var $3VN6j = parcelRequire("3VN6j");
var $56ade604b217970c$require$Buffer = $3VN6j.Buffer;

var $hdHkJ = parcelRequire("hdHkJ");

var $4mUCF = parcelRequire("4mUCF");
var $56ade604b217970c$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $4mUCF(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $56ade604b217970c$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $56ade604b217970c$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $56ade604b217970c$var$useFromArrayBuffer = $56ade604b217970c$var$useArrayBuffer && ($56ade604b217970c$require$Buffer.prototype instanceof Uint8Array || $56ade604b217970c$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if ($56ade604b217970c$require$Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return $56ade604b217970c$require$Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return $56ade604b217970c$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($56ade604b217970c$var$useArrayBuffer && $56ade604b217970c$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $56ade604b217970c$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($56ade604b217970c$var$useFromArrayBuffer) {
            var res = $56ade604b217970c$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $56ade604b217970c$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($56ade604b217970c$var$useUint8Array && data instanceof Uint8Array) return $56ade604b217970c$require$Buffer.from(data);
    var isArr = $hdHkJ(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $56ade604b217970c$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $56ade604b217970c$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("hdHkJ", function(module, exports) {
var $c89543a8635b8a2c$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $c89543a8635b8a2c$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("4mUCF", function(module, exports) {
'use strict';

var $9rLhz = parcelRequire("9rLhz");

var $1wNjU = parcelRequire("1wNjU");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $32e52394a13a1950$var$$typedArrayBuffer = $1wNjU('TypedArray.prototype.buffer', true);

var $lwXn7 = parcelRequire("lwXn7");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $32e52394a13a1950$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$lwXn7(x)) throw new $9rLhz('Not a Typed Array');
    return x.buffer;
};

});
parcelRegister("lwXn7", function(module, exports) {
'use strict';

var $61P7U = parcelRequire("61P7U");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$61P7U(value);
};

});
parcelRegister("61P7U", function(module, exports) {
'use strict';

var $dwwy9 = parcelRequire("dwwy9");

var $eKI43 = parcelRequire("eKI43");

var $1bJel = parcelRequire("1bJel");

var $1wNjU = parcelRequire("1wNjU");

var $kKqS1 = parcelRequire("kKqS1");

var $9cG1G = parcelRequire("9cG1G");
var $463a7eb95f557df3$var$$toString = $1wNjU('Object.prototype.toString');

var $463a7eb95f557df3$var$hasToStringTag = (parcelRequire("7p3Eg"))();
var $463a7eb95f557df3$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $463a7eb95f557df3$var$typedArrays = $eKI43();
var $463a7eb95f557df3$var$$slice = $1wNjU('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $463a7eb95f557df3$var$$indexOf = $1wNjU('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $463a7eb95f557df3$var$cache = {
    __proto__: null
};
if ($463a7eb95f557df3$var$hasToStringTag && $kKqS1 && $9cG1G) $dwwy9($463a7eb95f557df3$var$typedArrays, function(typedArray) {
    var arr = new $463a7eb95f557df3$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $9cG1G) {
        var proto = $9cG1G(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $kKqS1(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $9cG1G(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $kKqS1(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $463a7eb95f557df3$var$cache['$' + typedArray] = $1bJel(descriptor.get);
    }
});
else $dwwy9($463a7eb95f557df3$var$typedArrays, function(typedArray) {
    var arr = new $463a7eb95f557df3$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $463a7eb95f557df3$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $1bJel(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $463a7eb95f557df3$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $dwwy9(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $463a7eb95f557df3$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $463a7eb95f557df3$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $463a7eb95f557df3$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $dwwy9(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $463a7eb95f557df3$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $463a7eb95f557df3$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$463a7eb95f557df3$var$hasToStringTag) {
        /** @type {string} */ var tag = $463a7eb95f557df3$var$$slice($463a7eb95f557df3$var$$toString(value), 8, -1);
        if ($463a7eb95f557df3$var$$indexOf($463a7eb95f557df3$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $463a7eb95f557df3$var$trySlices(value);
    }
    if (!$kKqS1) return null;
     // unknown engine
    return $463a7eb95f557df3$var$tryTypedArrays(value);
};

});
parcelRegister("dwwy9", function(module, exports) {
'use strict';

var $jdZRF = parcelRequire("jdZRF");
var $9d87833723d84037$var$toStr = Object.prototype.toString;
var $9d87833723d84037$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $9d87833723d84037$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($9d87833723d84037$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $9d87833723d84037$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $9d87833723d84037$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($9d87833723d84037$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $9d87833723d84037$var$isArray(x) {
    return $9d87833723d84037$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$jdZRF(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($9d87833723d84037$var$isArray(list)) $9d87833723d84037$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $9d87833723d84037$var$forEachString(list, iterator, receiver);
    else $9d87833723d84037$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("jdZRF", function(module, exports) {
'use strict';
var $dfef383add24fc51$var$fnToStr = Function.prototype.toString;
var $dfef383add24fc51$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $dfef383add24fc51$var$badArrayLike;
var $dfef383add24fc51$var$isCallableMarker;
if (typeof $dfef383add24fc51$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $dfef383add24fc51$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $dfef383add24fc51$var$isCallableMarker;
        }
    });
    $dfef383add24fc51$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $dfef383add24fc51$var$reflectApply(function() {
        throw 42;
    }, null, $dfef383add24fc51$var$badArrayLike);
} catch (_) {
    if (_ !== $dfef383add24fc51$var$isCallableMarker) $dfef383add24fc51$var$reflectApply = null;
}
else $dfef383add24fc51$var$reflectApply = null;
var $dfef383add24fc51$var$constructorRegex = /^\s*class\b/;
var $dfef383add24fc51$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $dfef383add24fc51$var$fnToStr.call(value);
        return $dfef383add24fc51$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $dfef383add24fc51$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($dfef383add24fc51$var$isES6ClassFn(value)) return false;
        $dfef383add24fc51$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $dfef383add24fc51$var$toStr = Object.prototype.toString;
var $dfef383add24fc51$var$objectClass = '[object Object]';
var $dfef383add24fc51$var$fnClass = '[object Function]';
var $dfef383add24fc51$var$genClass = '[object GeneratorFunction]';
var $dfef383add24fc51$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $dfef383add24fc51$var$ddaClass2 = '[object HTML document.all class]';
var $dfef383add24fc51$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $dfef383add24fc51$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $dfef383add24fc51$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $dfef383add24fc51$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $dfef383add24fc51$var$all = document.all;
    if ($dfef383add24fc51$var$toStr.call($dfef383add24fc51$var$all) === $dfef383add24fc51$var$toStr.call(document.all)) $dfef383add24fc51$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($dfef383add24fc51$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $dfef383add24fc51$var$toStr.call(value);
            return (str === $dfef383add24fc51$var$ddaClass || str === $dfef383add24fc51$var$ddaClass2 || str === $dfef383add24fc51$var$ddaClass3 // opera 12.16
             || str === $dfef383add24fc51$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $dfef383add24fc51$var$reflectApply ? function isCallable(value) {
    if ($dfef383add24fc51$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $dfef383add24fc51$var$reflectApply(value, null, $dfef383add24fc51$var$badArrayLike);
    } catch (e) {
        if (e !== $dfef383add24fc51$var$isCallableMarker) return false;
    }
    return !$dfef383add24fc51$var$isES6ClassFn(value) && $dfef383add24fc51$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($dfef383add24fc51$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($dfef383add24fc51$var$hasToStringTag) return $dfef383add24fc51$var$tryFunctionObject(value);
    if ($dfef383add24fc51$var$isES6ClassFn(value)) return false;
    var strClass = $dfef383add24fc51$var$toStr.call(value);
    if (strClass !== $dfef383add24fc51$var$fnClass && strClass !== $dfef383add24fc51$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $dfef383add24fc51$var$tryFunctionObject(value);
};

});


parcelRegister("eKI43", function(module, exports) {
'use strict';

var $gMvqJ = parcelRequire("gMvqJ");
var $abd78ad0941020e5$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $gMvqJ.length; i++)if (typeof $abd78ad0941020e5$var$g[$gMvqJ[i]] === 'function') // @ts-expect-error
    out[out.length] = $gMvqJ[i];
    return out;
};

});
parcelRegister("gMvqJ", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("1bJel", function(module, exports) {
'use strict';

var $2jfYU = parcelRequire("2jfYU");

var $fO8kA = parcelRequire("fO8kA");

var $cx98Z = parcelRequire("cx98Z");

var $jsuRX = parcelRequire("jsuRX");
module.exports = function callBind(originalFunction) {
    var func = $cx98Z(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $2jfYU(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($fO8kA) $fO8kA(module.exports, 'apply', {
    value: $jsuRX
});
else module.exports.apply = $jsuRX;

});
parcelRegister("2jfYU", function(module, exports) {
'use strict';

var $8k6tP = parcelRequire("8k6tP");

var $gzUlp = parcelRequire("gzUlp");

var $1ae9c0ae30dd21cc$var$hasDescriptors = (parcelRequire("8cWAb"))();

var $kKqS1 = parcelRequire("kKqS1");

var $9rLhz = parcelRequire("9rLhz");
var $1ae9c0ae30dd21cc$var$$floor = $8k6tP('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $9rLhz('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $1ae9c0ae30dd21cc$var$$floor(length) !== length) throw new $9rLhz('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $kKqS1) {
        var desc = $kKqS1(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($1ae9c0ae30dd21cc$var$hasDescriptors) $gzUlp(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $gzUlp(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("gzUlp", function(module, exports) {
'use strict';

var $fO8kA = parcelRequire("fO8kA");

var $4hu1o = parcelRequire("4hu1o");

var $9rLhz = parcelRequire("9rLhz");

var $kKqS1 = parcelRequire("kKqS1");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $9rLhz('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $9rLhz('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $9rLhz('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $9rLhz('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $9rLhz('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $9rLhz('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$kKqS1 && $kKqS1(obj, property);
    if ($fO8kA) $fO8kA(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $4hu1o('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("8cWAb", function(module, exports) {
'use strict';

var $fO8kA = parcelRequire("fO8kA");
var $5f9ce303ecb7ac06$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$fO8kA;
};
$5f9ce303ecb7ac06$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$fO8kA) return null;
    try {
        return $fO8kA([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $5f9ce303ecb7ac06$var$hasPropertyDescriptors;

});


parcelRegister("jsuRX", function(module, exports) {
'use strict';

var $9dkFD = parcelRequire("9dkFD");

var $j7f4s = parcelRequire("j7f4s");

var $2ntjQ = parcelRequire("2ntjQ");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $2ntjQ($9dkFD, $j7f4s, arguments);
};

});


parcelRegister("7p3Eg", function(module, exports) {
'use strict';

var $iiPi5 = parcelRequire("iiPi5");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $iiPi5() && !!Symbol.toStringTag;
};

});






parcelRegister("aM5qg", function(module, exports) {

exports = module.exports = (parcelRequire("lgGO3"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("hcEIx"));

exports.Duplex = (parcelRequire("d1DwD"));

exports.Transform = (parcelRequire("lRD8d"));

exports.PassThrough = (parcelRequire("kmmki"));

});
parcelRegister("lgGO3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $2M83v = parcelRequire("2M83v");
'use strict';

var $f6uEY = parcelRequire("f6uEY");
/*</replacement>*/ module.exports = $f7bc4c0969306b03$var$Readable;

var $kk5te = parcelRequire("kk5te");
/*</replacement>*/ /*<replacement>*/ var $f7bc4c0969306b03$var$Duplex;
/*</replacement>*/ $f7bc4c0969306b03$var$Readable.ReadableState = $f7bc4c0969306b03$var$ReadableState;

var $lAGdN = parcelRequire("lAGdN");
var $f7bc4c0969306b03$require$EE = $lAGdN.EventEmitter;
var $f7bc4c0969306b03$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $bv93F = parcelRequire("bv93F");

var $fe9JP = parcelRequire("fe9JP");
var $f7bc4c0969306b03$require$Buffer = $fe9JP.Buffer;
var $f7bc4c0969306b03$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $f7bc4c0969306b03$var$_uint8ArrayToBuffer(chunk) {
    return $f7bc4c0969306b03$require$Buffer.from(chunk);
}
function $f7bc4c0969306b03$var$_isUint8Array(obj) {
    return $f7bc4c0969306b03$require$Buffer.isBuffer(obj) || obj instanceof $f7bc4c0969306b03$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $f7bc4c0969306b03$var$util = Object.create((parcelRequire("EeTfc")));

$f7bc4c0969306b03$var$util.inherits = (parcelRequire("lubO4"));

var $a5Qi3 = parcelRequire("a5Qi3");
var $f7bc4c0969306b03$var$debug = void 0;
if ($a5Qi3 && $a5Qi3.debuglog) $f7bc4c0969306b03$var$debug = $a5Qi3.debuglog('stream');
else $f7bc4c0969306b03$var$debug = function() {};

var $ltv1Q = parcelRequire("ltv1Q");

var $Wc6I8 = parcelRequire("Wc6I8");
var $f7bc4c0969306b03$var$StringDecoder;
$f7bc4c0969306b03$var$util.inherits($f7bc4c0969306b03$var$Readable, $bv93F);
var $f7bc4c0969306b03$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $f7bc4c0969306b03$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($kk5te(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $f7bc4c0969306b03$var$ReadableState(options, stream) {
    $f7bc4c0969306b03$var$Duplex = $f7bc4c0969306b03$var$Duplex || (parcelRequire("d1DwD"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $f7bc4c0969306b03$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $ltv1Q();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$f7bc4c0969306b03$var$StringDecoder) $f7bc4c0969306b03$var$StringDecoder = (parcelRequire("2Zx2D")).StringDecoder;
        this.decoder = new $f7bc4c0969306b03$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $f7bc4c0969306b03$var$Readable(options) {
    $f7bc4c0969306b03$var$Duplex = $f7bc4c0969306b03$var$Duplex || (parcelRequire("d1DwD"));
    if (!(this instanceof $f7bc4c0969306b03$var$Readable)) return new $f7bc4c0969306b03$var$Readable(options);
    this._readableState = new $f7bc4c0969306b03$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $bv93F.call(this);
}
Object.defineProperty($f7bc4c0969306b03$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$f7bc4c0969306b03$var$Readable.prototype.destroy = $Wc6I8.destroy;
$f7bc4c0969306b03$var$Readable.prototype._undestroy = $Wc6I8.undestroy;
$f7bc4c0969306b03$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$f7bc4c0969306b03$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $f7bc4c0969306b03$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $f7bc4c0969306b03$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$f7bc4c0969306b03$var$Readable.prototype.unshift = function(chunk) {
    return $f7bc4c0969306b03$var$readableAddChunk(this, chunk, null, true, false);
};
function $f7bc4c0969306b03$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $f7bc4c0969306b03$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $f7bc4c0969306b03$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $f7bc4c0969306b03$require$Buffer.prototype) chunk = $f7bc4c0969306b03$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $f7bc4c0969306b03$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $f7bc4c0969306b03$var$addChunk(stream, state, chunk, false);
                    else $f7bc4c0969306b03$var$maybeReadMore(stream, state);
                } else $f7bc4c0969306b03$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $f7bc4c0969306b03$var$needMoreData(state);
}
function $f7bc4c0969306b03$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $f7bc4c0969306b03$var$emitReadable(stream);
    }
    $f7bc4c0969306b03$var$maybeReadMore(stream, state);
}
function $f7bc4c0969306b03$var$chunkInvalid(state, chunk) {
    var er;
    if (!$f7bc4c0969306b03$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $f7bc4c0969306b03$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$f7bc4c0969306b03$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$f7bc4c0969306b03$var$Readable.prototype.setEncoding = function(enc) {
    if (!$f7bc4c0969306b03$var$StringDecoder) $f7bc4c0969306b03$var$StringDecoder = (parcelRequire("2Zx2D")).StringDecoder;
    this._readableState.decoder = new $f7bc4c0969306b03$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $f7bc4c0969306b03$var$MAX_HWM = 0x800000;
function $f7bc4c0969306b03$var$computeNewHighWaterMark(n) {
    if (n >= $f7bc4c0969306b03$var$MAX_HWM) n = $f7bc4c0969306b03$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f7bc4c0969306b03$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $f7bc4c0969306b03$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$f7bc4c0969306b03$var$Readable.prototype.read = function(n) {
    $f7bc4c0969306b03$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $f7bc4c0969306b03$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $f7bc4c0969306b03$var$endReadable(this);
        else $f7bc4c0969306b03$var$emitReadable(this);
        return null;
    }
    n = $f7bc4c0969306b03$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $f7bc4c0969306b03$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $f7bc4c0969306b03$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $f7bc4c0969306b03$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $f7bc4c0969306b03$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $f7bc4c0969306b03$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $f7bc4c0969306b03$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $f7bc4c0969306b03$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $f7bc4c0969306b03$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $f7bc4c0969306b03$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $f7bc4c0969306b03$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $f7bc4c0969306b03$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $f7bc4c0969306b03$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $f6uEY.nextTick($f7bc4c0969306b03$var$emitReadable_, stream);
        else $f7bc4c0969306b03$var$emitReadable_(stream);
    }
}
function $f7bc4c0969306b03$var$emitReadable_(stream) {
    $f7bc4c0969306b03$var$debug('emit readable');
    stream.emit('readable');
    $f7bc4c0969306b03$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $f7bc4c0969306b03$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $f6uEY.nextTick($f7bc4c0969306b03$var$maybeReadMore_, stream, state);
    }
}
function $f7bc4c0969306b03$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $f7bc4c0969306b03$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$f7bc4c0969306b03$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$f7bc4c0969306b03$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $f7bc4c0969306b03$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2M83v.stdout && dest !== $2M83v.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $f6uEY.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $f7bc4c0969306b03$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $f7bc4c0969306b03$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $f7bc4c0969306b03$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $f7bc4c0969306b03$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $f7bc4c0969306b03$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $f7bc4c0969306b03$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $f7bc4c0969306b03$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $f7bc4c0969306b03$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($f7bc4c0969306b03$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $f7bc4c0969306b03$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $f7bc4c0969306b03$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $f7bc4c0969306b03$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $f7bc4c0969306b03$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $f7bc4c0969306b03$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $f7bc4c0969306b03$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $f7bc4c0969306b03$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $f7bc4c0969306b03$var$flow(src);
        }
    };
}
$f7bc4c0969306b03$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $f7bc4c0969306b03$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$f7bc4c0969306b03$var$Readable.prototype.on = function(ev, fn) {
    var res = $bv93F.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $f6uEY.nextTick($f7bc4c0969306b03$var$nReadingNextTick, this);
            else if (state.length) $f7bc4c0969306b03$var$emitReadable(this);
        }
    }
    return res;
};
$f7bc4c0969306b03$var$Readable.prototype.addListener = $f7bc4c0969306b03$var$Readable.prototype.on;
function $f7bc4c0969306b03$var$nReadingNextTick(self1) {
    $f7bc4c0969306b03$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$f7bc4c0969306b03$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $f7bc4c0969306b03$var$debug('resume');
        state.flowing = true;
        $f7bc4c0969306b03$var$resume(this, state);
    }
    return this;
};
function $f7bc4c0969306b03$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $f6uEY.nextTick($f7bc4c0969306b03$var$resume_, stream, state);
    }
}
function $f7bc4c0969306b03$var$resume_(stream, state) {
    if (!state.reading) {
        $f7bc4c0969306b03$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $f7bc4c0969306b03$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$f7bc4c0969306b03$var$Readable.prototype.pause = function() {
    $f7bc4c0969306b03$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $f7bc4c0969306b03$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $f7bc4c0969306b03$var$flow(stream) {
    var state = stream._readableState;
    $f7bc4c0969306b03$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$f7bc4c0969306b03$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $f7bc4c0969306b03$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $f7bc4c0969306b03$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $f7bc4c0969306b03$var$kProxyEvents.length; n++)stream.on($f7bc4c0969306b03$var$kProxyEvents[n], this.emit.bind(this, $f7bc4c0969306b03$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $f7bc4c0969306b03$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($f7bc4c0969306b03$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$f7bc4c0969306b03$var$Readable._fromList = $f7bc4c0969306b03$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f7bc4c0969306b03$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $f7bc4c0969306b03$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f7bc4c0969306b03$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $f7bc4c0969306b03$var$copyFromBufferString(n, list) : $f7bc4c0969306b03$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f7bc4c0969306b03$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f7bc4c0969306b03$var$copyFromBuffer(n, list) {
    var ret = $f7bc4c0969306b03$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $f7bc4c0969306b03$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $f6uEY.nextTick($f7bc4c0969306b03$var$endReadableNT, state, stream);
    }
}
function $f7bc4c0969306b03$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $f7bc4c0969306b03$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("f6uEY", function(module, exports) {

var $2M83v = parcelRequire("2M83v");
'use strict';
if (typeof $2M83v === 'undefined' || !$2M83v.version || $2M83v.version.indexOf('v0.') === 0 || $2M83v.version.indexOf('v1.') === 0 && $2M83v.version.indexOf('v1.8.') !== 0) module.exports = {
    nextTick: $afef32f42e28b431$var$nextTick
};
else module.exports = $2M83v;
function $afef32f42e28b431$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $2M83v.nextTick(fn);
        case 2:
            return $2M83v.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $2M83v.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $2M83v.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $2M83v.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("kk5te", function(module, exports) {
var $ecb9eb3474d606c2$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $ecb9eb3474d606c2$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("lAGdN", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $fb7db617f816e871$var$R = typeof Reflect === 'object' ? Reflect : null;
var $fb7db617f816e871$var$ReflectApply = $fb7db617f816e871$var$R && typeof $fb7db617f816e871$var$R.apply === 'function' ? $fb7db617f816e871$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $fb7db617f816e871$var$ReflectOwnKeys;
if ($fb7db617f816e871$var$R && typeof $fb7db617f816e871$var$R.ownKeys === 'function') $fb7db617f816e871$var$ReflectOwnKeys = $fb7db617f816e871$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $fb7db617f816e871$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $fb7db617f816e871$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $fb7db617f816e871$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $fb7db617f816e871$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $fb7db617f816e871$var$EventEmitter() {
    $fb7db617f816e871$var$EventEmitter.init.call(this);
}
module.exports = $fb7db617f816e871$var$EventEmitter;
module.exports.once = $fb7db617f816e871$var$once;
// Backwards-compat with node 0.10.x
$fb7db617f816e871$var$EventEmitter.EventEmitter = $fb7db617f816e871$var$EventEmitter;
$fb7db617f816e871$var$EventEmitter.prototype._events = undefined;
$fb7db617f816e871$var$EventEmitter.prototype._eventsCount = 0;
$fb7db617f816e871$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $fb7db617f816e871$var$defaultMaxListeners = 10;
function $fb7db617f816e871$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($fb7db617f816e871$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $fb7db617f816e871$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $fb7db617f816e871$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $fb7db617f816e871$var$defaultMaxListeners = arg;
    }
});
$fb7db617f816e871$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$fb7db617f816e871$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $fb7db617f816e871$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $fb7db617f816e871$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $fb7db617f816e871$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$fb7db617f816e871$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $fb7db617f816e871$var$_getMaxListeners(this);
};
$fb7db617f816e871$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $fb7db617f816e871$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $fb7db617f816e871$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$fb7db617f816e871$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $fb7db617f816e871$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $fb7db617f816e871$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $fb7db617f816e871$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $fb7db617f816e871$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$fb7db617f816e871$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $fb7db617f816e871$var$_addListener(this, type, listener, false);
};
$fb7db617f816e871$var$EventEmitter.prototype.on = $fb7db617f816e871$var$EventEmitter.prototype.addListener;
$fb7db617f816e871$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $fb7db617f816e871$var$_addListener(this, type, listener, true);
};
function $fb7db617f816e871$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $fb7db617f816e871$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $fb7db617f816e871$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$fb7db617f816e871$var$EventEmitter.prototype.once = function once(type, listener) {
    $fb7db617f816e871$var$checkListener(listener);
    this.on(type, $fb7db617f816e871$var$_onceWrap(this, type, listener));
    return this;
};
$fb7db617f816e871$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $fb7db617f816e871$var$checkListener(listener);
    this.prependListener(type, $fb7db617f816e871$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$fb7db617f816e871$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $fb7db617f816e871$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $fb7db617f816e871$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$fb7db617f816e871$var$EventEmitter.prototype.off = $fb7db617f816e871$var$EventEmitter.prototype.removeListener;
$fb7db617f816e871$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $fb7db617f816e871$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $fb7db617f816e871$var$unwrapListeners(evlistener) : $fb7db617f816e871$var$arrayClone(evlistener, evlistener.length);
}
$fb7db617f816e871$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $fb7db617f816e871$var$_listeners(this, type, true);
};
$fb7db617f816e871$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $fb7db617f816e871$var$_listeners(this, type, false);
};
$fb7db617f816e871$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $fb7db617f816e871$var$listenerCount.call(emitter, type);
};
$fb7db617f816e871$var$EventEmitter.prototype.listenerCount = $fb7db617f816e871$var$listenerCount;
function $fb7db617f816e871$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$fb7db617f816e871$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $fb7db617f816e871$var$ReflectOwnKeys(this._events) : [];
};
function $fb7db617f816e871$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $fb7db617f816e871$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $fb7db617f816e871$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $fb7db617f816e871$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $fb7db617f816e871$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $fb7db617f816e871$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $fb7db617f816e871$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $fb7db617f816e871$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $fb7db617f816e871$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("bv93F", function(module, exports) {

module.exports = (parcelRequire("lAGdN")).EventEmitter;

});

parcelRegister("fe9JP", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $2zYso = parcelRequire("2zYso");
var $b15fb79d731724a3$var$Buffer = $2zYso.Buffer;
// alternative to using Object.keys for old browsers
function $b15fb79d731724a3$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($b15fb79d731724a3$var$Buffer.from && $b15fb79d731724a3$var$Buffer.alloc && $b15fb79d731724a3$var$Buffer.allocUnsafe && $b15fb79d731724a3$var$Buffer.allocUnsafeSlow) module.exports = $2zYso;
else {
    // Copy properties from require('buffer')
    $b15fb79d731724a3$var$copyProps($2zYso, module.exports);
    module.exports.Buffer = $b15fb79d731724a3$var$SafeBuffer;
}
function $b15fb79d731724a3$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $b15fb79d731724a3$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$b15fb79d731724a3$var$copyProps($b15fb79d731724a3$var$Buffer, $b15fb79d731724a3$var$SafeBuffer);
$b15fb79d731724a3$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $b15fb79d731724a3$var$Buffer(arg, encodingOrOffset, length);
};
$b15fb79d731724a3$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $b15fb79d731724a3$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$b15fb79d731724a3$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b15fb79d731724a3$var$Buffer(size);
};
$b15fb79d731724a3$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $2zYso.SlowBuffer(size);
};

});

parcelRegister("EeTfc", function(module, exports) {
$parcel$export(module.exports, "isArray", () => $078f4964783205b1$export$43bee75e5e14138e, (v) => $078f4964783205b1$export$43bee75e5e14138e = v);
$parcel$export(module.exports, "isBoolean", () => $078f4964783205b1$export$f9ce7b637dfbe238, (v) => $078f4964783205b1$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isNull", () => $078f4964783205b1$export$630801d484da15df, (v) => $078f4964783205b1$export$630801d484da15df = v);
$parcel$export(module.exports, "isNullOrUndefined", () => $078f4964783205b1$export$bedb7023a7733221, (v) => $078f4964783205b1$export$bedb7023a7733221 = v);
$parcel$export(module.exports, "isNumber", () => $078f4964783205b1$export$7e4aa119212bc614, (v) => $078f4964783205b1$export$7e4aa119212bc614 = v);
$parcel$export(module.exports, "isString", () => $078f4964783205b1$export$844ec244b1367d54, (v) => $078f4964783205b1$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isSymbol", () => $078f4964783205b1$export$a244864fd9645c7f, (v) => $078f4964783205b1$export$a244864fd9645c7f = v);
$parcel$export(module.exports, "isUndefined", () => $078f4964783205b1$export$fce6876652108ab, (v) => $078f4964783205b1$export$fce6876652108ab = v);
$parcel$export(module.exports, "isRegExp", () => $078f4964783205b1$export$49841c62b9eff15, (v) => $078f4964783205b1$export$49841c62b9eff15 = v);
$parcel$export(module.exports, "isObject", () => $078f4964783205b1$export$a6cdc56e425d0d0a, (v) => $078f4964783205b1$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isDate", () => $078f4964783205b1$export$871608497c498473, (v) => $078f4964783205b1$export$871608497c498473 = v);
$parcel$export(module.exports, "isError", () => $078f4964783205b1$export$e6127cc7fe7395c3, (v) => $078f4964783205b1$export$e6127cc7fe7395c3 = v);
$parcel$export(module.exports, "isFunction", () => $078f4964783205b1$export$f6e2535fb5126e54, (v) => $078f4964783205b1$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isPrimitive", () => $078f4964783205b1$export$c3825b437cbdea5c, (v) => $078f4964783205b1$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isBuffer", () => $078f4964783205b1$export$a7884ebc965f8f54, (v) => $078f4964783205b1$export$a7884ebc965f8f54 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $078f4964783205b1$export$43bee75e5e14138e;
var $078f4964783205b1$export$f9ce7b637dfbe238;
var $078f4964783205b1$export$630801d484da15df;
var $078f4964783205b1$export$bedb7023a7733221;
var $078f4964783205b1$export$7e4aa119212bc614;
var $078f4964783205b1$export$844ec244b1367d54;
var $078f4964783205b1$export$a244864fd9645c7f;
var $078f4964783205b1$export$fce6876652108ab;
var $078f4964783205b1$export$49841c62b9eff15;
var $078f4964783205b1$export$a6cdc56e425d0d0a;
var $078f4964783205b1$export$871608497c498473;
var $078f4964783205b1$export$e6127cc7fe7395c3;
var $078f4964783205b1$export$f6e2535fb5126e54;
var $078f4964783205b1$export$c3825b437cbdea5c;
var $078f4964783205b1$export$a7884ebc965f8f54;
function $078f4964783205b1$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $078f4964783205b1$var$objectToString(arg) === '[object Array]';
}
$078f4964783205b1$export$43bee75e5e14138e = $078f4964783205b1$var$isArray;
function $078f4964783205b1$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$078f4964783205b1$export$f9ce7b637dfbe238 = $078f4964783205b1$var$isBoolean;
function $078f4964783205b1$var$isNull(arg) {
    return arg === null;
}
$078f4964783205b1$export$630801d484da15df = $078f4964783205b1$var$isNull;
function $078f4964783205b1$var$isNullOrUndefined(arg) {
    return arg == null;
}
$078f4964783205b1$export$bedb7023a7733221 = $078f4964783205b1$var$isNullOrUndefined;
function $078f4964783205b1$var$isNumber(arg) {
    return typeof arg === 'number';
}
$078f4964783205b1$export$7e4aa119212bc614 = $078f4964783205b1$var$isNumber;
function $078f4964783205b1$var$isString(arg) {
    return typeof arg === 'string';
}
$078f4964783205b1$export$844ec244b1367d54 = $078f4964783205b1$var$isString;
function $078f4964783205b1$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$078f4964783205b1$export$a244864fd9645c7f = $078f4964783205b1$var$isSymbol;
function $078f4964783205b1$var$isUndefined(arg) {
    return arg === void 0;
}
$078f4964783205b1$export$fce6876652108ab = $078f4964783205b1$var$isUndefined;
function $078f4964783205b1$var$isRegExp(re) {
    return $078f4964783205b1$var$objectToString(re) === '[object RegExp]';
}
$078f4964783205b1$export$49841c62b9eff15 = $078f4964783205b1$var$isRegExp;
function $078f4964783205b1$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$078f4964783205b1$export$a6cdc56e425d0d0a = $078f4964783205b1$var$isObject;
function $078f4964783205b1$var$isDate(d) {
    return $078f4964783205b1$var$objectToString(d) === '[object Date]';
}
$078f4964783205b1$export$871608497c498473 = $078f4964783205b1$var$isDate;
function $078f4964783205b1$var$isError(e) {
    return $078f4964783205b1$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$078f4964783205b1$export$e6127cc7fe7395c3 = $078f4964783205b1$var$isError;
function $078f4964783205b1$var$isFunction(arg) {
    return typeof arg === 'function';
}
$078f4964783205b1$export$f6e2535fb5126e54 = $078f4964783205b1$var$isFunction;
function $078f4964783205b1$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$078f4964783205b1$export$c3825b437cbdea5c = $078f4964783205b1$var$isPrimitive;

$078f4964783205b1$export$a7884ebc965f8f54 = (parcelRequire("2zYso")).Buffer.isBuffer;
function $078f4964783205b1$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("ltv1Q", function(module, exports) {
'use strict';
function $fa24600bc367fa2b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $fe9JP = parcelRequire("fe9JP");
var $fa24600bc367fa2b$require$Buffer = $fe9JP.Buffer;

var $a5Qi3 = parcelRequire("a5Qi3");
function $fa24600bc367fa2b$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $fa24600bc367fa2b$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $fa24600bc367fa2b$require$Buffer.alloc(0);
        var ret = $fa24600bc367fa2b$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $fa24600bc367fa2b$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($a5Qi3 && $a5Qi3.inspect && $a5Qi3.inspect.custom) module.exports.prototype[$a5Qi3.inspect.custom] = function() {
    var obj = $a5Qi3.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("Wc6I8", function(module, exports) {
'use strict';

var $f6uEY = parcelRequire("f6uEY");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $0aeecf23d07a575e$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $f6uEY.nextTick($0aeecf23d07a575e$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $f6uEY.nextTick($0aeecf23d07a575e$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $f6uEY.nextTick($0aeecf23d07a575e$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $f6uEY.nextTick($0aeecf23d07a575e$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $0aeecf23d07a575e$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $0aeecf23d07a575e$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $0aeecf23d07a575e$var$destroy,
    undestroy: $0aeecf23d07a575e$var$undestroy
};

});

parcelRegister("d1DwD", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $f6uEY = parcelRequire("f6uEY");
/*</replacement>*/ /*<replacement>*/ var $97ba0748186abede$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $97ba0748186abede$var$Duplex;

/*<replacement>*/ var $97ba0748186abede$var$util = Object.create((parcelRequire("EeTfc")));

$97ba0748186abede$var$util.inherits = (parcelRequire("lubO4"));

var $lgGO3 = parcelRequire("lgGO3");

var $hcEIx = parcelRequire("hcEIx");
$97ba0748186abede$var$util.inherits($97ba0748186abede$var$Duplex, $lgGO3);
// avoid scope creep, the keys array can then be collected
var $97ba0748186abede$var$keys = $97ba0748186abede$var$objectKeys($hcEIx.prototype);
for(var $97ba0748186abede$var$v = 0; $97ba0748186abede$var$v < $97ba0748186abede$var$keys.length; $97ba0748186abede$var$v++){
    var $97ba0748186abede$var$method = $97ba0748186abede$var$keys[$97ba0748186abede$var$v];
    if (!$97ba0748186abede$var$Duplex.prototype[$97ba0748186abede$var$method]) $97ba0748186abede$var$Duplex.prototype[$97ba0748186abede$var$method] = $hcEIx.prototype[$97ba0748186abede$var$method];
}
function $97ba0748186abede$var$Duplex(options) {
    if (!(this instanceof $97ba0748186abede$var$Duplex)) return new $97ba0748186abede$var$Duplex(options);
    $lgGO3.call(this, options);
    $hcEIx.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $97ba0748186abede$var$onend);
}
Object.defineProperty($97ba0748186abede$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $97ba0748186abede$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $f6uEY.nextTick($97ba0748186abede$var$onEndNT, this);
}
function $97ba0748186abede$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($97ba0748186abede$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$97ba0748186abede$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $f6uEY.nextTick(cb, err);
};

});
parcelRegister("hcEIx", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $f6uEY = parcelRequire("f6uEY");
/*</replacement>*/ module.exports = $c8632442ab43a94c$var$Writable;
/* <replacement> */ function $c8632442ab43a94c$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $c8632442ab43a94c$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $c8632442ab43a94c$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $c8632442ab43a94c$var$asyncWrite = (0, $f6uEY.nextTick);
/*</replacement>*/ /*<replacement>*/ var $c8632442ab43a94c$var$Duplex;
/*</replacement>*/ $c8632442ab43a94c$var$Writable.WritableState = $c8632442ab43a94c$var$WritableState;

/*<replacement>*/ var $c8632442ab43a94c$var$util = Object.create((parcelRequire("EeTfc")));

$c8632442ab43a94c$var$util.inherits = (parcelRequire("lubO4"));

/*</replacement>*/ /*<replacement>*/ var $c8632442ab43a94c$var$internalUtil = {
    deprecate: (parcelRequire("hs4ab"))
};

var $bv93F = parcelRequire("bv93F");

var $fe9JP = parcelRequire("fe9JP");
var $c8632442ab43a94c$require$Buffer = $fe9JP.Buffer;
var $c8632442ab43a94c$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $c8632442ab43a94c$var$_uint8ArrayToBuffer(chunk) {
    return $c8632442ab43a94c$require$Buffer.from(chunk);
}
function $c8632442ab43a94c$var$_isUint8Array(obj) {
    return $c8632442ab43a94c$require$Buffer.isBuffer(obj) || obj instanceof $c8632442ab43a94c$var$OurUint8Array;
}

var $Wc6I8 = parcelRequire("Wc6I8");
$c8632442ab43a94c$var$util.inherits($c8632442ab43a94c$var$Writable, $bv93F);
function $c8632442ab43a94c$var$nop() {}

function $c8632442ab43a94c$var$WritableState(options, stream) {
    $c8632442ab43a94c$var$Duplex = $c8632442ab43a94c$var$Duplex || (parcelRequire("d1DwD"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $c8632442ab43a94c$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $c8632442ab43a94c$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $c8632442ab43a94c$var$CorkedRequest(this);
}
$c8632442ab43a94c$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($c8632442ab43a94c$var$WritableState.prototype, 'buffer', {
            get: $c8632442ab43a94c$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $c8632442ab43a94c$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $c8632442ab43a94c$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($c8632442ab43a94c$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($c8632442ab43a94c$var$realHasInstance.call(this, object)) return true;
            if (this !== $c8632442ab43a94c$var$Writable) return false;
            return object && object._writableState instanceof $c8632442ab43a94c$var$WritableState;
        }
    });
} else $c8632442ab43a94c$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $c8632442ab43a94c$var$Writable(options) {
    $c8632442ab43a94c$var$Duplex = $c8632442ab43a94c$var$Duplex || (parcelRequire("d1DwD"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$c8632442ab43a94c$var$realHasInstance.call($c8632442ab43a94c$var$Writable, this) && !(this instanceof $c8632442ab43a94c$var$Duplex)) return new $c8632442ab43a94c$var$Writable(options);
    this._writableState = new $c8632442ab43a94c$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $bv93F.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$c8632442ab43a94c$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $c8632442ab43a94c$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $f6uEY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $c8632442ab43a94c$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $f6uEY.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$c8632442ab43a94c$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $c8632442ab43a94c$var$_isUint8Array(chunk);
    if (isBuf && !$c8632442ab43a94c$require$Buffer.isBuffer(chunk)) chunk = $c8632442ab43a94c$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $c8632442ab43a94c$var$nop;
    if (state.ended) $c8632442ab43a94c$var$writeAfterEnd(this, cb);
    else if (isBuf || $c8632442ab43a94c$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $c8632442ab43a94c$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$c8632442ab43a94c$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$c8632442ab43a94c$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $c8632442ab43a94c$var$clearBuffer(this, state);
    }
};
$c8632442ab43a94c$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $c8632442ab43a94c$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $c8632442ab43a94c$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($c8632442ab43a94c$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $c8632442ab43a94c$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $c8632442ab43a94c$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $c8632442ab43a94c$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $c8632442ab43a94c$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $c8632442ab43a94c$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $f6uEY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $f6uEY.nextTick($c8632442ab43a94c$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $c8632442ab43a94c$var$finishMaybe(stream, state);
    }
}
function $c8632442ab43a94c$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $c8632442ab43a94c$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $c8632442ab43a94c$var$onwriteStateUpdate(state);
    if (er) $c8632442ab43a94c$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $c8632442ab43a94c$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $c8632442ab43a94c$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $c8632442ab43a94c$var$asyncWrite($c8632442ab43a94c$var$afterWrite, stream, state, finished, cb);
        else $c8632442ab43a94c$var$afterWrite(stream, state, finished, cb);
    }
}
function $c8632442ab43a94c$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $c8632442ab43a94c$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $c8632442ab43a94c$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $c8632442ab43a94c$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $c8632442ab43a94c$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $c8632442ab43a94c$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $c8632442ab43a94c$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $c8632442ab43a94c$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$c8632442ab43a94c$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$c8632442ab43a94c$var$Writable.prototype._writev = null;
$c8632442ab43a94c$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $c8632442ab43a94c$var$endWritable(this, state, cb);
};
function $c8632442ab43a94c$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $c8632442ab43a94c$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $c8632442ab43a94c$var$finishMaybe(stream, state);
    });
}
function $c8632442ab43a94c$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $f6uEY.nextTick($c8632442ab43a94c$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $c8632442ab43a94c$var$finishMaybe(stream, state) {
    var need = $c8632442ab43a94c$var$needFinish(state);
    if (need) {
        $c8632442ab43a94c$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $c8632442ab43a94c$var$endWritable(stream, state, cb) {
    state.ending = true;
    $c8632442ab43a94c$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $f6uEY.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $c8632442ab43a94c$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($c8632442ab43a94c$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$c8632442ab43a94c$var$Writable.prototype.destroy = $Wc6I8.destroy;
$c8632442ab43a94c$var$Writable.prototype._undestroy = $Wc6I8.undestroy;
$c8632442ab43a94c$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});
parcelRegister("hs4ab", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $cb4847e9e4305003$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $cb4847e9e4305003$var$deprecate(fn, msg) {
    if ($cb4847e9e4305003$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($cb4847e9e4305003$var$config('throwDeprecation')) throw new Error(msg);
            else if ($cb4847e9e4305003$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $cb4847e9e4305003$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("2Zx2D", function(module, exports) {
$parcel$export(module.exports, "StringDecoder", () => $22dae8a0d214ce45$export$63a7aa211a91ed69, (v) => $22dae8a0d214ce45$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $22dae8a0d214ce45$export$63a7aa211a91ed69;
'use strict';

var $6oB2i = parcelRequire("6oB2i");
var $22dae8a0d214ce45$require$Buffer = $6oB2i.Buffer;
/*</replacement>*/ var $22dae8a0d214ce45$var$isEncoding = $22dae8a0d214ce45$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $22dae8a0d214ce45$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $22dae8a0d214ce45$var$normalizeEncoding(enc) {
    var nenc = $22dae8a0d214ce45$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($22dae8a0d214ce45$require$Buffer.isEncoding === $22dae8a0d214ce45$var$isEncoding || !$22dae8a0d214ce45$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$22dae8a0d214ce45$export$63a7aa211a91ed69 = $22dae8a0d214ce45$var$StringDecoder;
function $22dae8a0d214ce45$var$StringDecoder(encoding) {
    this.encoding = $22dae8a0d214ce45$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $22dae8a0d214ce45$var$utf16Text;
            this.end = $22dae8a0d214ce45$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $22dae8a0d214ce45$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $22dae8a0d214ce45$var$base64Text;
            this.end = $22dae8a0d214ce45$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $22dae8a0d214ce45$var$simpleWrite;
            this.end = $22dae8a0d214ce45$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $22dae8a0d214ce45$require$Buffer.allocUnsafe(nb);
}
$22dae8a0d214ce45$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$22dae8a0d214ce45$var$StringDecoder.prototype.end = $22dae8a0d214ce45$var$utf8End;
// Returns only complete characters in a Buffer
$22dae8a0d214ce45$var$StringDecoder.prototype.text = $22dae8a0d214ce45$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$22dae8a0d214ce45$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $22dae8a0d214ce45$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $22dae8a0d214ce45$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $22dae8a0d214ce45$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $22dae8a0d214ce45$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $22dae8a0d214ce45$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $22dae8a0d214ce45$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $22dae8a0d214ce45$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $22dae8a0d214ce45$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $22dae8a0d214ce45$var$utf8Text(buf, i) {
    var total = $22dae8a0d214ce45$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $22dae8a0d214ce45$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $22dae8a0d214ce45$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $22dae8a0d214ce45$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $22dae8a0d214ce45$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $22dae8a0d214ce45$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $22dae8a0d214ce45$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $22dae8a0d214ce45$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("6oB2i", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $2zYso = parcelRequire("2zYso");
var $4a81b6885ff530bd$var$Buffer = $2zYso.Buffer;
// alternative to using Object.keys for old browsers
function $4a81b6885ff530bd$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($4a81b6885ff530bd$var$Buffer.from && $4a81b6885ff530bd$var$Buffer.alloc && $4a81b6885ff530bd$var$Buffer.allocUnsafe && $4a81b6885ff530bd$var$Buffer.allocUnsafeSlow) module.exports = $2zYso;
else {
    // Copy properties from require('buffer')
    $4a81b6885ff530bd$var$copyProps($2zYso, module.exports);
    module.exports.Buffer = $4a81b6885ff530bd$var$SafeBuffer;
}
function $4a81b6885ff530bd$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $4a81b6885ff530bd$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$4a81b6885ff530bd$var$copyProps($4a81b6885ff530bd$var$Buffer, $4a81b6885ff530bd$var$SafeBuffer);
$4a81b6885ff530bd$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $4a81b6885ff530bd$var$Buffer(arg, encodingOrOffset, length);
};
$4a81b6885ff530bd$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $4a81b6885ff530bd$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$4a81b6885ff530bd$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $4a81b6885ff530bd$var$Buffer(size);
};
$4a81b6885ff530bd$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $2zYso.SlowBuffer(size);
};

});



parcelRegister("lRD8d", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $041b901c856969e2$var$Transform;

var $d1DwD = parcelRequire("d1DwD");

/*<replacement>*/ var $041b901c856969e2$var$util = Object.create((parcelRequire("EeTfc")));

$041b901c856969e2$var$util.inherits = (parcelRequire("lubO4"));
/*</replacement>*/ $041b901c856969e2$var$util.inherits($041b901c856969e2$var$Transform, $d1DwD);
function $041b901c856969e2$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $041b901c856969e2$var$Transform(options) {
    if (!(this instanceof $041b901c856969e2$var$Transform)) return new $041b901c856969e2$var$Transform(options);
    $d1DwD.call(this, options);
    this._transformState = {
        afterTransform: $041b901c856969e2$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $041b901c856969e2$var$prefinish);
}
function $041b901c856969e2$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $041b901c856969e2$var$done(_this, er, data);
    });
    else $041b901c856969e2$var$done(this, null, null);
}
$041b901c856969e2$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $d1DwD.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$041b901c856969e2$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$041b901c856969e2$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$041b901c856969e2$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$041b901c856969e2$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $d1DwD.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $041b901c856969e2$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("kmmki", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $ed272e43ffbff32c$var$PassThrough;

var $lRD8d = parcelRequire("lRD8d");

/*<replacement>*/ var $ed272e43ffbff32c$var$util = Object.create((parcelRequire("EeTfc")));

$ed272e43ffbff32c$var$util.inherits = (parcelRequire("lubO4"));
/*</replacement>*/ $ed272e43ffbff32c$var$util.inherits($ed272e43ffbff32c$var$PassThrough, $lRD8d);
function $ed272e43ffbff32c$var$PassThrough(options) {
    if (!(this instanceof $ed272e43ffbff32c$var$PassThrough)) return new $ed272e43ffbff32c$var$PassThrough(options);
    $lRD8d.call(this, options);
}
$ed272e43ffbff32c$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});




parcelRegister("bxooq", function(module, exports) {
'use strict';

var $2zYso = parcelRequire("2zYso");
var $8665b2b878532222$require$Buffer = $2zYso.Buffer;

var $lubO4 = parcelRequire("lubO4");

var $7qj0R = parcelRequire("7qj0R");
var $8665b2b878532222$var$ARRAY16 = new Array(16);
var $8665b2b878532222$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $8665b2b878532222$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $8665b2b878532222$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $8665b2b878532222$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $8665b2b878532222$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $8665b2b878532222$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $8665b2b878532222$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $8665b2b878532222$var$fn1(a, b, c, d, e, m, k, s) {
    return $8665b2b878532222$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $8665b2b878532222$var$fn2(a, b, c, d, e, m, k, s) {
    return $8665b2b878532222$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $8665b2b878532222$var$fn3(a, b, c, d, e, m, k, s) {
    return $8665b2b878532222$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $8665b2b878532222$var$fn4(a, b, c, d, e, m, k, s) {
    return $8665b2b878532222$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $8665b2b878532222$var$fn5(a, b, c, d, e, m, k, s) {
    return $8665b2b878532222$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
function $8665b2b878532222$var$RIPEMD160() {
    $7qj0R.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$lubO4($8665b2b878532222$var$RIPEMD160, $7qj0R);
$8665b2b878532222$var$RIPEMD160.prototype._update = function() {
    var words = $8665b2b878532222$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $8665b2b878532222$var$fn1(al, bl, cl, dl, el, words[$8665b2b878532222$var$zl[i]], $8665b2b878532222$var$hl[0], $8665b2b878532222$var$sl[i]);
            tr = $8665b2b878532222$var$fn5(ar, br, cr, dr, er, words[$8665b2b878532222$var$zr[i]], $8665b2b878532222$var$hr[0], $8665b2b878532222$var$sr[i]);
        } else if (i < 32) {
            tl = $8665b2b878532222$var$fn2(al, bl, cl, dl, el, words[$8665b2b878532222$var$zl[i]], $8665b2b878532222$var$hl[1], $8665b2b878532222$var$sl[i]);
            tr = $8665b2b878532222$var$fn4(ar, br, cr, dr, er, words[$8665b2b878532222$var$zr[i]], $8665b2b878532222$var$hr[1], $8665b2b878532222$var$sr[i]);
        } else if (i < 48) {
            tl = $8665b2b878532222$var$fn3(al, bl, cl, dl, el, words[$8665b2b878532222$var$zl[i]], $8665b2b878532222$var$hl[2], $8665b2b878532222$var$sl[i]);
            tr = $8665b2b878532222$var$fn3(ar, br, cr, dr, er, words[$8665b2b878532222$var$zr[i]], $8665b2b878532222$var$hr[2], $8665b2b878532222$var$sr[i]);
        } else if (i < 64) {
            tl = $8665b2b878532222$var$fn4(al, bl, cl, dl, el, words[$8665b2b878532222$var$zl[i]], $8665b2b878532222$var$hl[3], $8665b2b878532222$var$sl[i]);
            tr = $8665b2b878532222$var$fn2(ar, br, cr, dr, er, words[$8665b2b878532222$var$zr[i]], $8665b2b878532222$var$hr[3], $8665b2b878532222$var$sr[i]);
        } else {
            tl = $8665b2b878532222$var$fn5(al, bl, cl, dl, el, words[$8665b2b878532222$var$zl[i]], $8665b2b878532222$var$hl[4], $8665b2b878532222$var$sl[i]);
            tr = $8665b2b878532222$var$fn1(ar, br, cr, dr, er, words[$8665b2b878532222$var$zr[i]], $8665b2b878532222$var$hr[4], $8665b2b878532222$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $8665b2b878532222$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $8665b2b878532222$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$8665b2b878532222$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset] = 0x80;
    this._blockOffset += 1;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $8665b2b878532222$require$Buffer.alloc ? $8665b2b878532222$require$Buffer.alloc(20) : new $8665b2b878532222$require$Buffer(20); // eslint-disable-line no-buffer-constructor
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
module.exports = $8665b2b878532222$var$RIPEMD160;

});
parcelRegister("7qj0R", function(module, exports) {
'use strict';

var $3VN6j = parcelRequire("3VN6j");
var $5679b5a691ee6f74$require$Buffer = $3VN6j.Buffer;

var $ihrp6 = parcelRequire("ihrp6");

var $cYjNe = parcelRequire("cYjNe");
var $5679b5a691ee6f74$require$Transform = $cYjNe.Transform;

var $lubO4 = parcelRequire("lubO4");
function $5679b5a691ee6f74$var$HashBase(blockSize) {
    $5679b5a691ee6f74$require$Transform.call(this);
    this._block = $5679b5a691ee6f74$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$lubO4($5679b5a691ee6f74$var$HashBase, $5679b5a691ee6f74$require$Transform);
$5679b5a691ee6f74$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$5679b5a691ee6f74$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$5679b5a691ee6f74$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    var dataBuffer = $ihrp6(data, encoding); // asserts correct input type
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + dataBuffer.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;){
            block[i] = dataBuffer[offset];
            i += 1;
            offset += 1;
        }
        this._update();
        this._blockOffset = 0;
    }
    while(offset < dataBuffer.length){
        block[this._blockOffset] = dataBuffer[offset];
        this._blockOffset += 1;
        offset += 1;
    }
    // update length
    for(var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$5679b5a691ee6f74$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$5679b5a691ee6f74$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$5679b5a691ee6f74$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $5679b5a691ee6f74$var$HashBase;

});
parcelRegister("ihrp6", function(module, exports) {
'use strict';

var $3VN6j = parcelRequire("3VN6j");
var $d4ef12592db75418$require$Buffer = $3VN6j.Buffer;

var $7roic = parcelRequire("7roic");
var $d4ef12592db75418$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $d4ef12592db75418$var$useArrayBuffer = $d4ef12592db75418$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $d4ef12592db75418$var$isView = $d4ef12592db75418$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding) {
    if (typeof thing === 'string' || $d4ef12592db75418$require$Buffer.isBuffer(thing) || $d4ef12592db75418$var$useUint8Array && thing instanceof Uint8Array || $d4ef12592db75418$var$isView && $d4ef12592db75418$var$isView(thing)) return $7roic(thing, encoding);
    throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

});

parcelRegister("cYjNe", function(module, exports) {

exports = module.exports = (parcelRequire("fAVRg"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("b2yNd"));

exports.Duplex = (parcelRequire("jn8Lw"));

exports.Transform = (parcelRequire("gzEkz"));

exports.PassThrough = (parcelRequire("eaKGR"));

});
parcelRegister("fAVRg", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $2M83v = parcelRequire("2M83v");
'use strict';

var $f6uEY = parcelRequire("f6uEY");
/*</replacement>*/ module.exports = $b5a7193a55d117e6$var$Readable;

var $dN0sw = parcelRequire("dN0sw");
/*</replacement>*/ /*<replacement>*/ var $b5a7193a55d117e6$var$Duplex;
/*</replacement>*/ $b5a7193a55d117e6$var$Readable.ReadableState = $b5a7193a55d117e6$var$ReadableState;

var $lAGdN = parcelRequire("lAGdN");
var $b5a7193a55d117e6$require$EE = $lAGdN.EventEmitter;
var $b5a7193a55d117e6$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $d60dP = parcelRequire("d60dP");

var $l4DJy = parcelRequire("l4DJy");
var $b5a7193a55d117e6$require$Buffer = $l4DJy.Buffer;
var $b5a7193a55d117e6$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $b5a7193a55d117e6$var$_uint8ArrayToBuffer(chunk) {
    return $b5a7193a55d117e6$require$Buffer.from(chunk);
}
function $b5a7193a55d117e6$var$_isUint8Array(obj) {
    return $b5a7193a55d117e6$require$Buffer.isBuffer(obj) || obj instanceof $b5a7193a55d117e6$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $b5a7193a55d117e6$var$util = Object.create((parcelRequire("EeTfc")));

$b5a7193a55d117e6$var$util.inherits = (parcelRequire("lubO4"));

var $a5Qi3 = parcelRequire("a5Qi3");
var $b5a7193a55d117e6$var$debug = void 0;
if ($a5Qi3 && $a5Qi3.debuglog) $b5a7193a55d117e6$var$debug = $a5Qi3.debuglog('stream');
else $b5a7193a55d117e6$var$debug = function() {};

var $lil7R = parcelRequire("lil7R");

var $fpeOB = parcelRequire("fpeOB");
var $b5a7193a55d117e6$var$StringDecoder;
$b5a7193a55d117e6$var$util.inherits($b5a7193a55d117e6$var$Readable, $d60dP);
var $b5a7193a55d117e6$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $b5a7193a55d117e6$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($dN0sw(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $b5a7193a55d117e6$var$ReadableState(options, stream) {
    $b5a7193a55d117e6$var$Duplex = $b5a7193a55d117e6$var$Duplex || (parcelRequire("jn8Lw"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $b5a7193a55d117e6$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $lil7R();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$b5a7193a55d117e6$var$StringDecoder) $b5a7193a55d117e6$var$StringDecoder = (parcelRequire("ckrcr")).StringDecoder;
        this.decoder = new $b5a7193a55d117e6$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $b5a7193a55d117e6$var$Readable(options) {
    $b5a7193a55d117e6$var$Duplex = $b5a7193a55d117e6$var$Duplex || (parcelRequire("jn8Lw"));
    if (!(this instanceof $b5a7193a55d117e6$var$Readable)) return new $b5a7193a55d117e6$var$Readable(options);
    this._readableState = new $b5a7193a55d117e6$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $d60dP.call(this);
}
Object.defineProperty($b5a7193a55d117e6$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$b5a7193a55d117e6$var$Readable.prototype.destroy = $fpeOB.destroy;
$b5a7193a55d117e6$var$Readable.prototype._undestroy = $fpeOB.undestroy;
$b5a7193a55d117e6$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$b5a7193a55d117e6$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $b5a7193a55d117e6$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $b5a7193a55d117e6$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$b5a7193a55d117e6$var$Readable.prototype.unshift = function(chunk) {
    return $b5a7193a55d117e6$var$readableAddChunk(this, chunk, null, true, false);
};
function $b5a7193a55d117e6$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $b5a7193a55d117e6$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $b5a7193a55d117e6$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $b5a7193a55d117e6$require$Buffer.prototype) chunk = $b5a7193a55d117e6$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $b5a7193a55d117e6$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $b5a7193a55d117e6$var$addChunk(stream, state, chunk, false);
                    else $b5a7193a55d117e6$var$maybeReadMore(stream, state);
                } else $b5a7193a55d117e6$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $b5a7193a55d117e6$var$needMoreData(state);
}
function $b5a7193a55d117e6$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $b5a7193a55d117e6$var$emitReadable(stream);
    }
    $b5a7193a55d117e6$var$maybeReadMore(stream, state);
}
function $b5a7193a55d117e6$var$chunkInvalid(state, chunk) {
    var er;
    if (!$b5a7193a55d117e6$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $b5a7193a55d117e6$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$b5a7193a55d117e6$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$b5a7193a55d117e6$var$Readable.prototype.setEncoding = function(enc) {
    if (!$b5a7193a55d117e6$var$StringDecoder) $b5a7193a55d117e6$var$StringDecoder = (parcelRequire("ckrcr")).StringDecoder;
    this._readableState.decoder = new $b5a7193a55d117e6$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $b5a7193a55d117e6$var$MAX_HWM = 0x800000;
function $b5a7193a55d117e6$var$computeNewHighWaterMark(n) {
    if (n >= $b5a7193a55d117e6$var$MAX_HWM) n = $b5a7193a55d117e6$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $b5a7193a55d117e6$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $b5a7193a55d117e6$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$b5a7193a55d117e6$var$Readable.prototype.read = function(n) {
    $b5a7193a55d117e6$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $b5a7193a55d117e6$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $b5a7193a55d117e6$var$endReadable(this);
        else $b5a7193a55d117e6$var$emitReadable(this);
        return null;
    }
    n = $b5a7193a55d117e6$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $b5a7193a55d117e6$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $b5a7193a55d117e6$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $b5a7193a55d117e6$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $b5a7193a55d117e6$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $b5a7193a55d117e6$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $b5a7193a55d117e6$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $b5a7193a55d117e6$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $b5a7193a55d117e6$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $b5a7193a55d117e6$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $b5a7193a55d117e6$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $b5a7193a55d117e6$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $b5a7193a55d117e6$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $f6uEY.nextTick($b5a7193a55d117e6$var$emitReadable_, stream);
        else $b5a7193a55d117e6$var$emitReadable_(stream);
    }
}
function $b5a7193a55d117e6$var$emitReadable_(stream) {
    $b5a7193a55d117e6$var$debug('emit readable');
    stream.emit('readable');
    $b5a7193a55d117e6$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $b5a7193a55d117e6$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $f6uEY.nextTick($b5a7193a55d117e6$var$maybeReadMore_, stream, state);
    }
}
function $b5a7193a55d117e6$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $b5a7193a55d117e6$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$b5a7193a55d117e6$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$b5a7193a55d117e6$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $b5a7193a55d117e6$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2M83v.stdout && dest !== $2M83v.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $f6uEY.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $b5a7193a55d117e6$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $b5a7193a55d117e6$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $b5a7193a55d117e6$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $b5a7193a55d117e6$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $b5a7193a55d117e6$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $b5a7193a55d117e6$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $b5a7193a55d117e6$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $b5a7193a55d117e6$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($b5a7193a55d117e6$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $b5a7193a55d117e6$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $b5a7193a55d117e6$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $b5a7193a55d117e6$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $b5a7193a55d117e6$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $b5a7193a55d117e6$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $b5a7193a55d117e6$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $b5a7193a55d117e6$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $b5a7193a55d117e6$var$flow(src);
        }
    };
}
$b5a7193a55d117e6$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $b5a7193a55d117e6$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$b5a7193a55d117e6$var$Readable.prototype.on = function(ev, fn) {
    var res = $d60dP.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $f6uEY.nextTick($b5a7193a55d117e6$var$nReadingNextTick, this);
            else if (state.length) $b5a7193a55d117e6$var$emitReadable(this);
        }
    }
    return res;
};
$b5a7193a55d117e6$var$Readable.prototype.addListener = $b5a7193a55d117e6$var$Readable.prototype.on;
function $b5a7193a55d117e6$var$nReadingNextTick(self1) {
    $b5a7193a55d117e6$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$b5a7193a55d117e6$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $b5a7193a55d117e6$var$debug('resume');
        state.flowing = true;
        $b5a7193a55d117e6$var$resume(this, state);
    }
    return this;
};
function $b5a7193a55d117e6$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $f6uEY.nextTick($b5a7193a55d117e6$var$resume_, stream, state);
    }
}
function $b5a7193a55d117e6$var$resume_(stream, state) {
    if (!state.reading) {
        $b5a7193a55d117e6$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $b5a7193a55d117e6$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$b5a7193a55d117e6$var$Readable.prototype.pause = function() {
    $b5a7193a55d117e6$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $b5a7193a55d117e6$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $b5a7193a55d117e6$var$flow(stream) {
    var state = stream._readableState;
    $b5a7193a55d117e6$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$b5a7193a55d117e6$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $b5a7193a55d117e6$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $b5a7193a55d117e6$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $b5a7193a55d117e6$var$kProxyEvents.length; n++)stream.on($b5a7193a55d117e6$var$kProxyEvents[n], this.emit.bind(this, $b5a7193a55d117e6$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $b5a7193a55d117e6$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($b5a7193a55d117e6$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$b5a7193a55d117e6$var$Readable._fromList = $b5a7193a55d117e6$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $b5a7193a55d117e6$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $b5a7193a55d117e6$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $b5a7193a55d117e6$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $b5a7193a55d117e6$var$copyFromBufferString(n, list) : $b5a7193a55d117e6$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $b5a7193a55d117e6$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $b5a7193a55d117e6$var$copyFromBuffer(n, list) {
    var ret = $b5a7193a55d117e6$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $b5a7193a55d117e6$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $f6uEY.nextTick($b5a7193a55d117e6$var$endReadableNT, state, stream);
    }
}
function $b5a7193a55d117e6$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $b5a7193a55d117e6$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("dN0sw", function(module, exports) {
var $a0a0351c9c564259$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $a0a0351c9c564259$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("d60dP", function(module, exports) {

module.exports = (parcelRequire("lAGdN")).EventEmitter;

});

parcelRegister("l4DJy", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $2zYso = parcelRequire("2zYso");
var $f578caf71b87ffe0$var$Buffer = $2zYso.Buffer;
// alternative to using Object.keys for old browsers
function $f578caf71b87ffe0$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($f578caf71b87ffe0$var$Buffer.from && $f578caf71b87ffe0$var$Buffer.alloc && $f578caf71b87ffe0$var$Buffer.allocUnsafe && $f578caf71b87ffe0$var$Buffer.allocUnsafeSlow) module.exports = $2zYso;
else {
    // Copy properties from require('buffer')
    $f578caf71b87ffe0$var$copyProps($2zYso, module.exports);
    module.exports.Buffer = $f578caf71b87ffe0$var$SafeBuffer;
}
function $f578caf71b87ffe0$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $f578caf71b87ffe0$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$f578caf71b87ffe0$var$copyProps($f578caf71b87ffe0$var$Buffer, $f578caf71b87ffe0$var$SafeBuffer);
$f578caf71b87ffe0$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $f578caf71b87ffe0$var$Buffer(arg, encodingOrOffset, length);
};
$f578caf71b87ffe0$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $f578caf71b87ffe0$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$f578caf71b87ffe0$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $f578caf71b87ffe0$var$Buffer(size);
};
$f578caf71b87ffe0$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $2zYso.SlowBuffer(size);
};

});

parcelRegister("lil7R", function(module, exports) {
'use strict';
function $f80baa88df600e27$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $l4DJy = parcelRequire("l4DJy");
var $f80baa88df600e27$require$Buffer = $l4DJy.Buffer;

var $a5Qi3 = parcelRequire("a5Qi3");
function $f80baa88df600e27$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $f80baa88df600e27$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $f80baa88df600e27$require$Buffer.alloc(0);
        var ret = $f80baa88df600e27$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $f80baa88df600e27$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($a5Qi3 && $a5Qi3.inspect && $a5Qi3.inspect.custom) module.exports.prototype[$a5Qi3.inspect.custom] = function() {
    var obj = $a5Qi3.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("fpeOB", function(module, exports) {
'use strict';

var $f6uEY = parcelRequire("f6uEY");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $b374aec72535bca3$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $f6uEY.nextTick($b374aec72535bca3$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $f6uEY.nextTick($b374aec72535bca3$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $f6uEY.nextTick($b374aec72535bca3$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $f6uEY.nextTick($b374aec72535bca3$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $b374aec72535bca3$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b374aec72535bca3$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $b374aec72535bca3$var$destroy,
    undestroy: $b374aec72535bca3$var$undestroy
};

});

parcelRegister("jn8Lw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $f6uEY = parcelRequire("f6uEY");
/*</replacement>*/ /*<replacement>*/ var $e1a6f6f04c9552e0$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $e1a6f6f04c9552e0$var$Duplex;

/*<replacement>*/ var $e1a6f6f04c9552e0$var$util = Object.create((parcelRequire("EeTfc")));

$e1a6f6f04c9552e0$var$util.inherits = (parcelRequire("lubO4"));

var $fAVRg = parcelRequire("fAVRg");

var $b2yNd = parcelRequire("b2yNd");
$e1a6f6f04c9552e0$var$util.inherits($e1a6f6f04c9552e0$var$Duplex, $fAVRg);
// avoid scope creep, the keys array can then be collected
var $e1a6f6f04c9552e0$var$keys = $e1a6f6f04c9552e0$var$objectKeys($b2yNd.prototype);
for(var $e1a6f6f04c9552e0$var$v = 0; $e1a6f6f04c9552e0$var$v < $e1a6f6f04c9552e0$var$keys.length; $e1a6f6f04c9552e0$var$v++){
    var $e1a6f6f04c9552e0$var$method = $e1a6f6f04c9552e0$var$keys[$e1a6f6f04c9552e0$var$v];
    if (!$e1a6f6f04c9552e0$var$Duplex.prototype[$e1a6f6f04c9552e0$var$method]) $e1a6f6f04c9552e0$var$Duplex.prototype[$e1a6f6f04c9552e0$var$method] = $b2yNd.prototype[$e1a6f6f04c9552e0$var$method];
}
function $e1a6f6f04c9552e0$var$Duplex(options) {
    if (!(this instanceof $e1a6f6f04c9552e0$var$Duplex)) return new $e1a6f6f04c9552e0$var$Duplex(options);
    $fAVRg.call(this, options);
    $b2yNd.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $e1a6f6f04c9552e0$var$onend);
}
Object.defineProperty($e1a6f6f04c9552e0$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $e1a6f6f04c9552e0$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $f6uEY.nextTick($e1a6f6f04c9552e0$var$onEndNT, this);
}
function $e1a6f6f04c9552e0$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($e1a6f6f04c9552e0$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$e1a6f6f04c9552e0$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $f6uEY.nextTick(cb, err);
};

});
parcelRegister("b2yNd", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $f6uEY = parcelRequire("f6uEY");
/*</replacement>*/ module.exports = $809adeba26195f54$var$Writable;
/* <replacement> */ function $809adeba26195f54$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $809adeba26195f54$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $809adeba26195f54$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $809adeba26195f54$var$asyncWrite = (0, $f6uEY.nextTick);
/*</replacement>*/ /*<replacement>*/ var $809adeba26195f54$var$Duplex;
/*</replacement>*/ $809adeba26195f54$var$Writable.WritableState = $809adeba26195f54$var$WritableState;

/*<replacement>*/ var $809adeba26195f54$var$util = Object.create((parcelRequire("EeTfc")));

$809adeba26195f54$var$util.inherits = (parcelRequire("lubO4"));

/*</replacement>*/ /*<replacement>*/ var $809adeba26195f54$var$internalUtil = {
    deprecate: (parcelRequire("hs4ab"))
};

var $d60dP = parcelRequire("d60dP");

var $l4DJy = parcelRequire("l4DJy");
var $809adeba26195f54$require$Buffer = $l4DJy.Buffer;
var $809adeba26195f54$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $809adeba26195f54$var$_uint8ArrayToBuffer(chunk) {
    return $809adeba26195f54$require$Buffer.from(chunk);
}
function $809adeba26195f54$var$_isUint8Array(obj) {
    return $809adeba26195f54$require$Buffer.isBuffer(obj) || obj instanceof $809adeba26195f54$var$OurUint8Array;
}

var $fpeOB = parcelRequire("fpeOB");
$809adeba26195f54$var$util.inherits($809adeba26195f54$var$Writable, $d60dP);
function $809adeba26195f54$var$nop() {}

function $809adeba26195f54$var$WritableState(options, stream) {
    $809adeba26195f54$var$Duplex = $809adeba26195f54$var$Duplex || (parcelRequire("jn8Lw"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $809adeba26195f54$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $809adeba26195f54$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $809adeba26195f54$var$CorkedRequest(this);
}
$809adeba26195f54$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($809adeba26195f54$var$WritableState.prototype, 'buffer', {
            get: $809adeba26195f54$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $809adeba26195f54$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $809adeba26195f54$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($809adeba26195f54$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($809adeba26195f54$var$realHasInstance.call(this, object)) return true;
            if (this !== $809adeba26195f54$var$Writable) return false;
            return object && object._writableState instanceof $809adeba26195f54$var$WritableState;
        }
    });
} else $809adeba26195f54$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $809adeba26195f54$var$Writable(options) {
    $809adeba26195f54$var$Duplex = $809adeba26195f54$var$Duplex || (parcelRequire("jn8Lw"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$809adeba26195f54$var$realHasInstance.call($809adeba26195f54$var$Writable, this) && !(this instanceof $809adeba26195f54$var$Duplex)) return new $809adeba26195f54$var$Writable(options);
    this._writableState = new $809adeba26195f54$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $d60dP.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$809adeba26195f54$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $809adeba26195f54$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $f6uEY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $809adeba26195f54$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $f6uEY.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$809adeba26195f54$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $809adeba26195f54$var$_isUint8Array(chunk);
    if (isBuf && !$809adeba26195f54$require$Buffer.isBuffer(chunk)) chunk = $809adeba26195f54$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $809adeba26195f54$var$nop;
    if (state.ended) $809adeba26195f54$var$writeAfterEnd(this, cb);
    else if (isBuf || $809adeba26195f54$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $809adeba26195f54$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$809adeba26195f54$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$809adeba26195f54$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $809adeba26195f54$var$clearBuffer(this, state);
    }
};
$809adeba26195f54$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $809adeba26195f54$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $809adeba26195f54$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($809adeba26195f54$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $809adeba26195f54$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $809adeba26195f54$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $809adeba26195f54$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $809adeba26195f54$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $809adeba26195f54$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $f6uEY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $f6uEY.nextTick($809adeba26195f54$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $809adeba26195f54$var$finishMaybe(stream, state);
    }
}
function $809adeba26195f54$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $809adeba26195f54$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $809adeba26195f54$var$onwriteStateUpdate(state);
    if (er) $809adeba26195f54$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $809adeba26195f54$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $809adeba26195f54$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $809adeba26195f54$var$asyncWrite($809adeba26195f54$var$afterWrite, stream, state, finished, cb);
        else $809adeba26195f54$var$afterWrite(stream, state, finished, cb);
    }
}
function $809adeba26195f54$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $809adeba26195f54$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $809adeba26195f54$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $809adeba26195f54$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $809adeba26195f54$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $809adeba26195f54$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $809adeba26195f54$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $809adeba26195f54$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$809adeba26195f54$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$809adeba26195f54$var$Writable.prototype._writev = null;
$809adeba26195f54$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $809adeba26195f54$var$endWritable(this, state, cb);
};
function $809adeba26195f54$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $809adeba26195f54$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $809adeba26195f54$var$finishMaybe(stream, state);
    });
}
function $809adeba26195f54$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $f6uEY.nextTick($809adeba26195f54$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $809adeba26195f54$var$finishMaybe(stream, state) {
    var need = $809adeba26195f54$var$needFinish(state);
    if (need) {
        $809adeba26195f54$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $809adeba26195f54$var$endWritable(stream, state, cb) {
    state.ending = true;
    $809adeba26195f54$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $f6uEY.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $809adeba26195f54$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($809adeba26195f54$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$809adeba26195f54$var$Writable.prototype.destroy = $fpeOB.destroy;
$809adeba26195f54$var$Writable.prototype._undestroy = $fpeOB.undestroy;
$809adeba26195f54$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("ckrcr", function(module, exports) {
$parcel$export(module.exports, "StringDecoder", () => $8f9c739149c33d8f$export$63a7aa211a91ed69, (v) => $8f9c739149c33d8f$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $8f9c739149c33d8f$export$63a7aa211a91ed69;
'use strict';

var $kvYKG = parcelRequire("kvYKG");
var $8f9c739149c33d8f$require$Buffer = $kvYKG.Buffer;
/*</replacement>*/ var $8f9c739149c33d8f$var$isEncoding = $8f9c739149c33d8f$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $8f9c739149c33d8f$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $8f9c739149c33d8f$var$normalizeEncoding(enc) {
    var nenc = $8f9c739149c33d8f$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($8f9c739149c33d8f$require$Buffer.isEncoding === $8f9c739149c33d8f$var$isEncoding || !$8f9c739149c33d8f$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$8f9c739149c33d8f$export$63a7aa211a91ed69 = $8f9c739149c33d8f$var$StringDecoder;
function $8f9c739149c33d8f$var$StringDecoder(encoding) {
    this.encoding = $8f9c739149c33d8f$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $8f9c739149c33d8f$var$utf16Text;
            this.end = $8f9c739149c33d8f$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $8f9c739149c33d8f$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $8f9c739149c33d8f$var$base64Text;
            this.end = $8f9c739149c33d8f$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $8f9c739149c33d8f$var$simpleWrite;
            this.end = $8f9c739149c33d8f$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $8f9c739149c33d8f$require$Buffer.allocUnsafe(nb);
}
$8f9c739149c33d8f$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$8f9c739149c33d8f$var$StringDecoder.prototype.end = $8f9c739149c33d8f$var$utf8End;
// Returns only complete characters in a Buffer
$8f9c739149c33d8f$var$StringDecoder.prototype.text = $8f9c739149c33d8f$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$8f9c739149c33d8f$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $8f9c739149c33d8f$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $8f9c739149c33d8f$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $8f9c739149c33d8f$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $8f9c739149c33d8f$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $8f9c739149c33d8f$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $8f9c739149c33d8f$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $8f9c739149c33d8f$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $8f9c739149c33d8f$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $8f9c739149c33d8f$var$utf8Text(buf, i) {
    var total = $8f9c739149c33d8f$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $8f9c739149c33d8f$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $8f9c739149c33d8f$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $8f9c739149c33d8f$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $8f9c739149c33d8f$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $8f9c739149c33d8f$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $8f9c739149c33d8f$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $8f9c739149c33d8f$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("kvYKG", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $2zYso = parcelRequire("2zYso");
var $eef5d3f28107d665$var$Buffer = $2zYso.Buffer;
// alternative to using Object.keys for old browsers
function $eef5d3f28107d665$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($eef5d3f28107d665$var$Buffer.from && $eef5d3f28107d665$var$Buffer.alloc && $eef5d3f28107d665$var$Buffer.allocUnsafe && $eef5d3f28107d665$var$Buffer.allocUnsafeSlow) module.exports = $2zYso;
else {
    // Copy properties from require('buffer')
    $eef5d3f28107d665$var$copyProps($2zYso, module.exports);
    module.exports.Buffer = $eef5d3f28107d665$var$SafeBuffer;
}
function $eef5d3f28107d665$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $eef5d3f28107d665$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$eef5d3f28107d665$var$copyProps($eef5d3f28107d665$var$Buffer, $eef5d3f28107d665$var$SafeBuffer);
$eef5d3f28107d665$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $eef5d3f28107d665$var$Buffer(arg, encodingOrOffset, length);
};
$eef5d3f28107d665$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $eef5d3f28107d665$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$eef5d3f28107d665$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $eef5d3f28107d665$var$Buffer(size);
};
$eef5d3f28107d665$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $2zYso.SlowBuffer(size);
};

});



parcelRegister("gzEkz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $c10f330e38dcf782$var$Transform;

var $jn8Lw = parcelRequire("jn8Lw");

/*<replacement>*/ var $c10f330e38dcf782$var$util = Object.create((parcelRequire("EeTfc")));

$c10f330e38dcf782$var$util.inherits = (parcelRequire("lubO4"));
/*</replacement>*/ $c10f330e38dcf782$var$util.inherits($c10f330e38dcf782$var$Transform, $jn8Lw);
function $c10f330e38dcf782$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $c10f330e38dcf782$var$Transform(options) {
    if (!(this instanceof $c10f330e38dcf782$var$Transform)) return new $c10f330e38dcf782$var$Transform(options);
    $jn8Lw.call(this, options);
    this._transformState = {
        afterTransform: $c10f330e38dcf782$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $c10f330e38dcf782$var$prefinish);
}
function $c10f330e38dcf782$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $c10f330e38dcf782$var$done(_this, er, data);
    });
    else $c10f330e38dcf782$var$done(this, null, null);
}
$c10f330e38dcf782$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $jn8Lw.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$c10f330e38dcf782$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$c10f330e38dcf782$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$c10f330e38dcf782$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$c10f330e38dcf782$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $jn8Lw.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $c10f330e38dcf782$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("eaKGR", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $a516379b16ff50d1$var$PassThrough;

var $gzEkz = parcelRequire("gzEkz");

/*<replacement>*/ var $a516379b16ff50d1$var$util = Object.create((parcelRequire("EeTfc")));

$a516379b16ff50d1$var$util.inherits = (parcelRequire("lubO4"));
/*</replacement>*/ $a516379b16ff50d1$var$util.inherits($a516379b16ff50d1$var$PassThrough, $gzEkz);
function $a516379b16ff50d1$var$PassThrough(options) {
    if (!(this instanceof $a516379b16ff50d1$var$PassThrough)) return new $a516379b16ff50d1$var$PassThrough(options);
    $gzEkz.call(this, options);
}
$a516379b16ff50d1$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});




parcelRegister("fwBLh", function(module, exports) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

module.exports.sha = (parcelRequire("igfDI"));

module.exports.sha1 = (parcelRequire("hf7GM"));

module.exports.sha224 = (parcelRequire("biZpM"));

module.exports.sha256 = (parcelRequire("enNBg"));

module.exports.sha384 = (parcelRequire("7f2xP"));

module.exports.sha512 = (parcelRequire("4EzhI"));

});
parcelRegister("igfDI", function(module, exports) {
'use strict';

var $lubO4 = parcelRequire("lubO4");

var $lAzQL = parcelRequire("lAzQL");

var $3VN6j = parcelRequire("3VN6j");
var $d4b5da539ddb96d2$require$Buffer = $3VN6j.Buffer;
var $d4b5da539ddb96d2$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $d4b5da539ddb96d2$var$W = new Array(80);
function $d4b5da539ddb96d2$var$Sha() {
    this.init();
    this._w = $d4b5da539ddb96d2$var$W;
    $lAzQL.call(this, 64, 56);
}
$lubO4($d4b5da539ddb96d2$var$Sha, $lAzQL);
$d4b5da539ddb96d2$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $d4b5da539ddb96d2$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $d4b5da539ddb96d2$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $d4b5da539ddb96d2$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$d4b5da539ddb96d2$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $d4b5da539ddb96d2$var$rotl5(a) + $d4b5da539ddb96d2$var$ft(s, b, c, d) + e + w[j] + $d4b5da539ddb96d2$var$K[s] | 0;
        e = d;
        d = c;
        c = $d4b5da539ddb96d2$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$d4b5da539ddb96d2$var$Sha.prototype._hash = function() {
    var H = $d4b5da539ddb96d2$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $d4b5da539ddb96d2$var$Sha;

});
parcelRegister("lAzQL", function(module, exports) {
'use strict';

var $3VN6j = parcelRequire("3VN6j");
var $fb78c4d99201f93b$require$Buffer = $3VN6j.Buffer;

var $7roic = parcelRequire("7roic");
// prototype class for hash functions
function $fb78c4d99201f93b$var$Hash(blockSize, finalSize) {
    this._block = $fb78c4d99201f93b$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$fb78c4d99201f93b$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $7roic(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$fb78c4d99201f93b$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$fb78c4d99201f93b$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $fb78c4d99201f93b$var$Hash;

});


parcelRegister("hf7GM", function(module, exports) {
'use strict';

var $lubO4 = parcelRequire("lubO4");

var $lAzQL = parcelRequire("lAzQL");

var $3VN6j = parcelRequire("3VN6j");
var $c8d9cd3e4939d2d0$require$Buffer = $3VN6j.Buffer;
var $c8d9cd3e4939d2d0$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $c8d9cd3e4939d2d0$var$W = new Array(80);
function $c8d9cd3e4939d2d0$var$Sha1() {
    this.init();
    this._w = $c8d9cd3e4939d2d0$var$W;
    $lAzQL.call(this, 64, 56);
}
$lubO4($c8d9cd3e4939d2d0$var$Sha1, $lAzQL);
$c8d9cd3e4939d2d0$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $c8d9cd3e4939d2d0$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $c8d9cd3e4939d2d0$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $c8d9cd3e4939d2d0$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $c8d9cd3e4939d2d0$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$c8d9cd3e4939d2d0$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $c8d9cd3e4939d2d0$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $c8d9cd3e4939d2d0$var$rotl5(a) + $c8d9cd3e4939d2d0$var$ft(s, b, c, d) + e + w[j] + $c8d9cd3e4939d2d0$var$K[s] | 0;
        e = d;
        d = c;
        c = $c8d9cd3e4939d2d0$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$c8d9cd3e4939d2d0$var$Sha1.prototype._hash = function() {
    var H = $c8d9cd3e4939d2d0$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $c8d9cd3e4939d2d0$var$Sha1;

});

parcelRegister("biZpM", function(module, exports) {
'use strict';

var $lubO4 = parcelRequire("lubO4");

var $enNBg = parcelRequire("enNBg");

var $lAzQL = parcelRequire("lAzQL");

var $3VN6j = parcelRequire("3VN6j");
var $83b103d95afc011a$require$Buffer = $3VN6j.Buffer;
var $83b103d95afc011a$var$W = new Array(64);
function $83b103d95afc011a$var$Sha224() {
    this.init();
    this._w = $83b103d95afc011a$var$W; // new Array(64)
    $lAzQL.call(this, 64, 56);
}
$lubO4($83b103d95afc011a$var$Sha224, $enNBg);
$83b103d95afc011a$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$83b103d95afc011a$var$Sha224.prototype._hash = function() {
    var H = $83b103d95afc011a$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $83b103d95afc011a$var$Sha224;

});
parcelRegister("enNBg", function(module, exports) {
'use strict';

var $lubO4 = parcelRequire("lubO4");

var $lAzQL = parcelRequire("lAzQL");

var $3VN6j = parcelRequire("3VN6j");
var $a789b032728edad4$require$Buffer = $3VN6j.Buffer;
var $a789b032728edad4$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $a789b032728edad4$var$W = new Array(64);
function $a789b032728edad4$var$Sha256() {
    this.init();
    this._w = $a789b032728edad4$var$W; // new Array(64)
    $lAzQL.call(this, 64, 56);
}
$lubO4($a789b032728edad4$var$Sha256, $lAzQL);
$a789b032728edad4$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $a789b032728edad4$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $a789b032728edad4$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $a789b032728edad4$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $a789b032728edad4$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $a789b032728edad4$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $a789b032728edad4$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$a789b032728edad4$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $a789b032728edad4$var$gamma1(w[i - 2]) + w[i - 7] + $a789b032728edad4$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $a789b032728edad4$var$sigma1(e) + $a789b032728edad4$var$ch(e, f, g) + $a789b032728edad4$var$K[j] + w[j] | 0;
        var T2 = $a789b032728edad4$var$sigma0(a) + $a789b032728edad4$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$a789b032728edad4$var$Sha256.prototype._hash = function() {
    var H = $a789b032728edad4$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $a789b032728edad4$var$Sha256;

});


parcelRegister("7f2xP", function(module, exports) {
'use strict';

var $lubO4 = parcelRequire("lubO4");

var $4EzhI = parcelRequire("4EzhI");

var $lAzQL = parcelRequire("lAzQL");

var $3VN6j = parcelRequire("3VN6j");
var $545be8730a6cfd79$require$Buffer = $3VN6j.Buffer;
var $545be8730a6cfd79$var$W = new Array(160);
function $545be8730a6cfd79$var$Sha384() {
    this.init();
    this._w = $545be8730a6cfd79$var$W;
    $lAzQL.call(this, 128, 112);
}
$lubO4($545be8730a6cfd79$var$Sha384, $4EzhI);
$545be8730a6cfd79$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$545be8730a6cfd79$var$Sha384.prototype._hash = function() {
    var H = $545be8730a6cfd79$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $545be8730a6cfd79$var$Sha384;

});
parcelRegister("4EzhI", function(module, exports) {
'use strict';

var $lubO4 = parcelRequire("lubO4");

var $lAzQL = parcelRequire("lAzQL");

var $3VN6j = parcelRequire("3VN6j");
var $363644aa8a4a7074$require$Buffer = $3VN6j.Buffer;
var $363644aa8a4a7074$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $363644aa8a4a7074$var$W = new Array(160);
function $363644aa8a4a7074$var$Sha512() {
    this.init();
    this._w = $363644aa8a4a7074$var$W;
    $lAzQL.call(this, 128, 112);
}
$lubO4($363644aa8a4a7074$var$Sha512, $lAzQL);
$363644aa8a4a7074$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $363644aa8a4a7074$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $363644aa8a4a7074$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $363644aa8a4a7074$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $363644aa8a4a7074$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $363644aa8a4a7074$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $363644aa8a4a7074$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $363644aa8a4a7074$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $363644aa8a4a7074$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $363644aa8a4a7074$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$363644aa8a4a7074$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $363644aa8a4a7074$var$Gamma0(xh, xl);
        var gamma0l = $363644aa8a4a7074$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $363644aa8a4a7074$var$Gamma1(xh, xl);
        var gamma1l = $363644aa8a4a7074$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $363644aa8a4a7074$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $363644aa8a4a7074$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $363644aa8a4a7074$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $363644aa8a4a7074$var$maj(ah, bh, ch);
        var majl = $363644aa8a4a7074$var$maj(al, bl, cl);
        var sigma0h = $363644aa8a4a7074$var$sigma0(ah, al);
        var sigma0l = $363644aa8a4a7074$var$sigma0(al, ah);
        var sigma1h = $363644aa8a4a7074$var$sigma1(eh, el);
        var sigma1l = $363644aa8a4a7074$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $363644aa8a4a7074$var$K[j];
        var Kil = $363644aa8a4a7074$var$K[j + 1];
        var chh = $363644aa8a4a7074$var$Ch(eh, fh, gh);
        var chl = $363644aa8a4a7074$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $363644aa8a4a7074$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $363644aa8a4a7074$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $363644aa8a4a7074$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $363644aa8a4a7074$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $363644aa8a4a7074$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $363644aa8a4a7074$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $363644aa8a4a7074$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $363644aa8a4a7074$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $363644aa8a4a7074$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $363644aa8a4a7074$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $363644aa8a4a7074$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $363644aa8a4a7074$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $363644aa8a4a7074$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $363644aa8a4a7074$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $363644aa8a4a7074$var$getCarry(this._hl, hl) | 0;
};
$363644aa8a4a7074$var$Sha512.prototype._hash = function() {
    var H = $363644aa8a4a7074$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $363644aa8a4a7074$var$Sha512;

});



parcelRegister("AhG97", function(module, exports) {
'use strict';

var $3VN6j = parcelRequire("3VN6j");
var $06d1138b62e0f0d1$require$Buffer = $3VN6j.Buffer;

var $hmAWJ = parcelRequire("hmAWJ");
var $06d1138b62e0f0d1$require$Transform = $hmAWJ.Transform;

var $eATqd = parcelRequire("eATqd");
var $06d1138b62e0f0d1$require$StringDecoder = $eATqd.StringDecoder;

var $lubO4 = parcelRequire("lubO4");
function $06d1138b62e0f0d1$var$CipherBase(hashMode) {
    $06d1138b62e0f0d1$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$lubO4($06d1138b62e0f0d1$var$CipherBase, $06d1138b62e0f0d1$require$Transform);
var $06d1138b62e0f0d1$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $06d1138b62e0f0d1$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($06d1138b62e0f0d1$require$Buffer.prototype instanceof Uint8Array || $06d1138b62e0f0d1$require$Buffer.TYPED_ARRAY_SUPPORT);
function $06d1138b62e0f0d1$var$toBuffer(data, encoding) {
    /*
	 * No need to do anything for exact instance
	 * This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
	 */ if (data instanceof $06d1138b62e0f0d1$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $06d1138b62e0f0d1$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($06d1138b62e0f0d1$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $06d1138b62e0f0d1$require$Buffer.alloc(0);
        var res = $06d1138b62e0f0d1$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        /*
		 * Recheck result size, as offset/length doesn't work on Node.js <5.10
		 * We just go to Uint8Array case if this fails
		 */ if (res.byteLength === data.byteLength) return res;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($06d1138b62e0f0d1$var$useUint8Array && data instanceof Uint8Array) return $06d1138b62e0f0d1$require$Buffer.from(data);
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if ($06d1138b62e0f0d1$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $06d1138b62e0f0d1$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$06d1138b62e0f0d1$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $06d1138b62e0f0d1$var$toBuffer(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$06d1138b62e0f0d1$var$CipherBase.prototype.setAutoPadding = function() {};
$06d1138b62e0f0d1$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$06d1138b62e0f0d1$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$06d1138b62e0f0d1$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$06d1138b62e0f0d1$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$06d1138b62e0f0d1$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$06d1138b62e0f0d1$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $06d1138b62e0f0d1$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$06d1138b62e0f0d1$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $06d1138b62e0f0d1$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $06d1138b62e0f0d1$var$CipherBase;

});
parcelRegister("hmAWJ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $ca412680aaff324c$var$Stream;

var $lAGdN = parcelRequire("lAGdN");
var $ca412680aaff324c$require$EE = $lAGdN.EventEmitter;

var $lubO4 = parcelRequire("lubO4");
$lubO4($ca412680aaff324c$var$Stream, $ca412680aaff324c$require$EE);

$ca412680aaff324c$var$Stream.Readable = (parcelRequire("39PPl"));

$ca412680aaff324c$var$Stream.Writable = (parcelRequire("lmkYv"));

$ca412680aaff324c$var$Stream.Duplex = (parcelRequire("injwu"));

$ca412680aaff324c$var$Stream.Transform = (parcelRequire("6XXYS"));

$ca412680aaff324c$var$Stream.PassThrough = (parcelRequire("bP41s"));

$ca412680aaff324c$var$Stream.finished = (parcelRequire("bcheM"));

$ca412680aaff324c$var$Stream.pipeline = (parcelRequire("cwpRa"));
// Backwards-compat with node 0.4.x
$ca412680aaff324c$var$Stream.Stream = $ca412680aaff324c$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $ca412680aaff324c$var$Stream() {
    $ca412680aaff324c$require$EE.call(this);
}
$ca412680aaff324c$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($ca412680aaff324c$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("39PPl", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $2M83v = parcelRequire("2M83v");
'use strict';
module.exports = $24ca6a2c951395c7$var$Readable;
/*<replacement>*/ var $24ca6a2c951395c7$var$Duplex;
/*</replacement>*/ $24ca6a2c951395c7$var$Readable.ReadableState = $24ca6a2c951395c7$var$ReadableState;

var $lAGdN = parcelRequire("lAGdN");
var $24ca6a2c951395c7$require$EE = $lAGdN.EventEmitter;
var $24ca6a2c951395c7$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $cPMzz = parcelRequire("cPMzz");

var $2zYso = parcelRequire("2zYso");
var $24ca6a2c951395c7$require$Buffer = $2zYso.Buffer;
var $24ca6a2c951395c7$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $24ca6a2c951395c7$var$_uint8ArrayToBuffer(chunk) {
    return $24ca6a2c951395c7$require$Buffer.from(chunk);
}
function $24ca6a2c951395c7$var$_isUint8Array(obj) {
    return $24ca6a2c951395c7$require$Buffer.isBuffer(obj) || obj instanceof $24ca6a2c951395c7$var$OurUint8Array;
}

var $a5Qi3 = parcelRequire("a5Qi3");
var $24ca6a2c951395c7$var$debug;
if ($a5Qi3 && $a5Qi3.debuglog) $24ca6a2c951395c7$var$debug = $a5Qi3.debuglog('stream');
else $24ca6a2c951395c7$var$debug = function debug() {};

var $6MVas = parcelRequire("6MVas");

var $lDbA2 = parcelRequire("lDbA2");

var $8ghwY = parcelRequire("8ghwY");
var $24ca6a2c951395c7$var$getHighWaterMark = $8ghwY.getHighWaterMark;

var $hGFgY = parcelRequire("hGFgY");
var $24ca6a2c951395c7$require$_require$codes = $hGFgY.codes;
var $24ca6a2c951395c7$var$ERR_INVALID_ARG_TYPE = $24ca6a2c951395c7$require$_require$codes.ERR_INVALID_ARG_TYPE, $24ca6a2c951395c7$var$ERR_STREAM_PUSH_AFTER_EOF = $24ca6a2c951395c7$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $24ca6a2c951395c7$var$ERR_METHOD_NOT_IMPLEMENTED = $24ca6a2c951395c7$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $24ca6a2c951395c7$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $24ca6a2c951395c7$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $24ca6a2c951395c7$var$StringDecoder;
var $24ca6a2c951395c7$var$createReadableStreamAsyncIterator;
var $24ca6a2c951395c7$var$from;

(parcelRequire("lubO4"))($24ca6a2c951395c7$var$Readable, $cPMzz);
var $24ca6a2c951395c7$var$errorOrDestroy = $lDbA2.errorOrDestroy;
var $24ca6a2c951395c7$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $24ca6a2c951395c7$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $24ca6a2c951395c7$var$ReadableState(options, stream, isDuplex) {
    $24ca6a2c951395c7$var$Duplex = $24ca6a2c951395c7$var$Duplex || (parcelRequire("injwu"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $24ca6a2c951395c7$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $24ca6a2c951395c7$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $6MVas();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$24ca6a2c951395c7$var$StringDecoder) $24ca6a2c951395c7$var$StringDecoder = (parcelRequire("eATqd")).StringDecoder;
        this.decoder = new $24ca6a2c951395c7$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $24ca6a2c951395c7$var$Readable(options) {
    $24ca6a2c951395c7$var$Duplex = $24ca6a2c951395c7$var$Duplex || (parcelRequire("injwu"));
    if (!(this instanceof $24ca6a2c951395c7$var$Readable)) return new $24ca6a2c951395c7$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $24ca6a2c951395c7$var$Duplex;
    this._readableState = new $24ca6a2c951395c7$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $cPMzz.call(this);
}
Object.defineProperty($24ca6a2c951395c7$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$24ca6a2c951395c7$var$Readable.prototype.destroy = $lDbA2.destroy;
$24ca6a2c951395c7$var$Readable.prototype._undestroy = $lDbA2.undestroy;
$24ca6a2c951395c7$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$24ca6a2c951395c7$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $24ca6a2c951395c7$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $24ca6a2c951395c7$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$24ca6a2c951395c7$var$Readable.prototype.unshift = function(chunk) {
    return $24ca6a2c951395c7$var$readableAddChunk(this, chunk, null, true, false);
};
function $24ca6a2c951395c7$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $24ca6a2c951395c7$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $24ca6a2c951395c7$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $24ca6a2c951395c7$var$chunkInvalid(state, chunk);
        if (er) $24ca6a2c951395c7$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $24ca6a2c951395c7$require$Buffer.prototype) chunk = $24ca6a2c951395c7$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $24ca6a2c951395c7$var$errorOrDestroy(stream, new $24ca6a2c951395c7$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $24ca6a2c951395c7$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $24ca6a2c951395c7$var$errorOrDestroy(stream, new $24ca6a2c951395c7$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $24ca6a2c951395c7$var$addChunk(stream, state, chunk, false);
                    else $24ca6a2c951395c7$var$maybeReadMore(stream, state);
                } else $24ca6a2c951395c7$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $24ca6a2c951395c7$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $24ca6a2c951395c7$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $24ca6a2c951395c7$var$emitReadable(stream);
    }
    $24ca6a2c951395c7$var$maybeReadMore(stream, state);
}
function $24ca6a2c951395c7$var$chunkInvalid(state, chunk) {
    var er;
    if (!$24ca6a2c951395c7$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $24ca6a2c951395c7$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$24ca6a2c951395c7$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$24ca6a2c951395c7$var$Readable.prototype.setEncoding = function(enc) {
    if (!$24ca6a2c951395c7$var$StringDecoder) $24ca6a2c951395c7$var$StringDecoder = (parcelRequire("eATqd")).StringDecoder;
    var decoder = new $24ca6a2c951395c7$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $24ca6a2c951395c7$var$MAX_HWM = 0x40000000;
function $24ca6a2c951395c7$var$computeNewHighWaterMark(n) {
    if (n >= $24ca6a2c951395c7$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $24ca6a2c951395c7$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $24ca6a2c951395c7$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $24ca6a2c951395c7$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$24ca6a2c951395c7$var$Readable.prototype.read = function(n) {
    $24ca6a2c951395c7$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $24ca6a2c951395c7$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $24ca6a2c951395c7$var$endReadable(this);
        else $24ca6a2c951395c7$var$emitReadable(this);
        return null;
    }
    n = $24ca6a2c951395c7$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $24ca6a2c951395c7$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $24ca6a2c951395c7$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $24ca6a2c951395c7$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $24ca6a2c951395c7$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $24ca6a2c951395c7$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $24ca6a2c951395c7$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $24ca6a2c951395c7$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $24ca6a2c951395c7$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $24ca6a2c951395c7$var$onEofChunk(stream, state) {
    $24ca6a2c951395c7$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $24ca6a2c951395c7$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $24ca6a2c951395c7$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $24ca6a2c951395c7$var$emitReadable(stream) {
    var state = stream._readableState;
    $24ca6a2c951395c7$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $24ca6a2c951395c7$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2M83v.nextTick($24ca6a2c951395c7$var$emitReadable_, stream);
    }
}
function $24ca6a2c951395c7$var$emitReadable_(stream) {
    var state = stream._readableState;
    $24ca6a2c951395c7$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $24ca6a2c951395c7$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $24ca6a2c951395c7$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $2M83v.nextTick($24ca6a2c951395c7$var$maybeReadMore_, stream, state);
    }
}
function $24ca6a2c951395c7$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $24ca6a2c951395c7$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$24ca6a2c951395c7$var$Readable.prototype._read = function(n) {
    $24ca6a2c951395c7$var$errorOrDestroy(this, new $24ca6a2c951395c7$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$24ca6a2c951395c7$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $24ca6a2c951395c7$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2M83v.stdout && dest !== $2M83v.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2M83v.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $24ca6a2c951395c7$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $24ca6a2c951395c7$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $24ca6a2c951395c7$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $24ca6a2c951395c7$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $24ca6a2c951395c7$var$debug('ondata');
        var ret = dest.write(chunk);
        $24ca6a2c951395c7$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $24ca6a2c951395c7$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $24ca6a2c951395c7$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $24ca6a2c951395c7$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($24ca6a2c951395c7$var$EElistenerCount(dest, 'error') === 0) $24ca6a2c951395c7$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $24ca6a2c951395c7$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $24ca6a2c951395c7$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $24ca6a2c951395c7$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $24ca6a2c951395c7$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $24ca6a2c951395c7$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $24ca6a2c951395c7$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $24ca6a2c951395c7$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $24ca6a2c951395c7$var$flow(src);
        }
    };
}
$24ca6a2c951395c7$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $24ca6a2c951395c7$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$24ca6a2c951395c7$var$Readable.prototype.on = function(ev, fn) {
    var res = $cPMzz.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $24ca6a2c951395c7$var$debug('on readable', state.length, state.reading);
            if (state.length) $24ca6a2c951395c7$var$emitReadable(this);
            else if (!state.reading) $2M83v.nextTick($24ca6a2c951395c7$var$nReadingNextTick, this);
        }
    }
    return res;
};
$24ca6a2c951395c7$var$Readable.prototype.addListener = $24ca6a2c951395c7$var$Readable.prototype.on;
$24ca6a2c951395c7$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $cPMzz.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2M83v.nextTick($24ca6a2c951395c7$var$updateReadableListening, this);
    return res;
};
$24ca6a2c951395c7$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $cPMzz.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2M83v.nextTick($24ca6a2c951395c7$var$updateReadableListening, this);
    return res;
};
function $24ca6a2c951395c7$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $24ca6a2c951395c7$var$nReadingNextTick(self1) {
    $24ca6a2c951395c7$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$24ca6a2c951395c7$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $24ca6a2c951395c7$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $24ca6a2c951395c7$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $24ca6a2c951395c7$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2M83v.nextTick($24ca6a2c951395c7$var$resume_, stream, state);
    }
}
function $24ca6a2c951395c7$var$resume_(stream, state) {
    $24ca6a2c951395c7$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $24ca6a2c951395c7$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$24ca6a2c951395c7$var$Readable.prototype.pause = function() {
    $24ca6a2c951395c7$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $24ca6a2c951395c7$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $24ca6a2c951395c7$var$flow(stream) {
    var state = stream._readableState;
    $24ca6a2c951395c7$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$24ca6a2c951395c7$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $24ca6a2c951395c7$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $24ca6a2c951395c7$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $24ca6a2c951395c7$var$kProxyEvents.length; n++)stream.on($24ca6a2c951395c7$var$kProxyEvents[n], this.emit.bind(this, $24ca6a2c951395c7$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $24ca6a2c951395c7$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $24ca6a2c951395c7$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($24ca6a2c951395c7$var$createReadableStreamAsyncIterator === undefined) $24ca6a2c951395c7$var$createReadableStreamAsyncIterator = (parcelRequire("fWvjm"));
    return $24ca6a2c951395c7$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($24ca6a2c951395c7$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($24ca6a2c951395c7$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($24ca6a2c951395c7$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$24ca6a2c951395c7$var$Readable._fromList = $24ca6a2c951395c7$var$fromList;
Object.defineProperty($24ca6a2c951395c7$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $24ca6a2c951395c7$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $24ca6a2c951395c7$var$endReadable(stream) {
    var state = stream._readableState;
    $24ca6a2c951395c7$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2M83v.nextTick($24ca6a2c951395c7$var$endReadableNT, state, stream);
    }
}
function $24ca6a2c951395c7$var$endReadableNT(state, stream) {
    $24ca6a2c951395c7$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $24ca6a2c951395c7$var$Readable.from = function(iterable, opts) {
    if ($24ca6a2c951395c7$var$from === undefined) $24ca6a2c951395c7$var$from = (parcelRequire("7HrDr"));
    return $24ca6a2c951395c7$var$from($24ca6a2c951395c7$var$Readable, iterable, opts);
};
function $24ca6a2c951395c7$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("cPMzz", function(module, exports) {

module.exports = (parcelRequire("lAGdN")).EventEmitter;

});

parcelRegister("6MVas", function(module, exports) {
'use strict';
function $4f13920fb0819fcd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4f13920fb0819fcd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4f13920fb0819fcd$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4f13920fb0819fcd$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4f13920fb0819fcd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4f13920fb0819fcd$var$_defineProperty(obj, key, value) {
    key = $4f13920fb0819fcd$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4f13920fb0819fcd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4f13920fb0819fcd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4f13920fb0819fcd$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4f13920fb0819fcd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4f13920fb0819fcd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4f13920fb0819fcd$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4f13920fb0819fcd$var$_toPropertyKey(arg) {
    var key = $4f13920fb0819fcd$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $4f13920fb0819fcd$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $2zYso = parcelRequire("2zYso");
var $4f13920fb0819fcd$var$Buffer = $2zYso.Buffer;

var $a5Qi3 = parcelRequire("a5Qi3");
var $4f13920fb0819fcd$var$inspect = $a5Qi3.inspect;
var $4f13920fb0819fcd$var$custom = $4f13920fb0819fcd$var$inspect && $4f13920fb0819fcd$var$inspect.custom || 'inspect';
function $4f13920fb0819fcd$var$copyBuffer(src, target, offset) {
    $4f13920fb0819fcd$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $4f13920fb0819fcd$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $4f13920fb0819fcd$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $4f13920fb0819fcd$var$Buffer.alloc(0);
                var ret = $4f13920fb0819fcd$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $4f13920fb0819fcd$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $4f13920fb0819fcd$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $4f13920fb0819fcd$var$custom,
            value: function value(_, options) {
                return $4f13920fb0819fcd$var$inspect(this, $4f13920fb0819fcd$var$_objectSpread($4f13920fb0819fcd$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("lDbA2", function(module, exports) {

var $2M83v = parcelRequire("2M83v");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $fbf6391a725801a4$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $2M83v.nextTick($fbf6391a725801a4$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $2M83v.nextTick($fbf6391a725801a4$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $2M83v.nextTick($fbf6391a725801a4$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $2M83v.nextTick($fbf6391a725801a4$var$emitErrorAndCloseNT, _this, err);
            } else $2M83v.nextTick($fbf6391a725801a4$var$emitCloseNT, _this);
        } else if (cb) {
            $2M83v.nextTick($fbf6391a725801a4$var$emitCloseNT, _this);
            cb(err);
        } else $2M83v.nextTick($fbf6391a725801a4$var$emitCloseNT, _this);
    });
    return this;
}
function $fbf6391a725801a4$var$emitErrorAndCloseNT(self, err) {
    $fbf6391a725801a4$var$emitErrorNT(self, err);
    $fbf6391a725801a4$var$emitCloseNT(self);
}
function $fbf6391a725801a4$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $fbf6391a725801a4$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $fbf6391a725801a4$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $fbf6391a725801a4$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $fbf6391a725801a4$var$destroy,
    undestroy: $fbf6391a725801a4$var$undestroy,
    errorOrDestroy: $fbf6391a725801a4$var$errorOrDestroy
};

});

parcelRegister("8ghwY", function(module, exports) {
'use strict';

var $603d6a9f71ebd3c0$var$ERR_INVALID_OPT_VALUE = (parcelRequire("hGFgY")).codes.ERR_INVALID_OPT_VALUE;
function $603d6a9f71ebd3c0$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $603d6a9f71ebd3c0$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $603d6a9f71ebd3c0$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $603d6a9f71ebd3c0$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $603d6a9f71ebd3c0$var$getHighWaterMark
};

});
parcelRegister("hGFgY", function(module, exports) {
$parcel$export(module.exports, "codes", () => $ce065fcf3a4bd895$export$e45cb6485273080e, (v) => $ce065fcf3a4bd895$export$e45cb6485273080e = v);
var $ce065fcf3a4bd895$export$e45cb6485273080e;
'use strict';
function $ce065fcf3a4bd895$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $ce065fcf3a4bd895$var$codes = {};
function $ce065fcf3a4bd895$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $ce065fcf3a4bd895$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $ce065fcf3a4bd895$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $ce065fcf3a4bd895$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $ce065fcf3a4bd895$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $ce065fcf3a4bd895$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $ce065fcf3a4bd895$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$ce065fcf3a4bd895$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$ce065fcf3a4bd895$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $ce065fcf3a4bd895$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($ce065fcf3a4bd895$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($ce065fcf3a4bd895$var$oneOf(expected, 'type'));
    else {
        var type = $ce065fcf3a4bd895$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($ce065fcf3a4bd895$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$ce065fcf3a4bd895$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$ce065fcf3a4bd895$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$ce065fcf3a4bd895$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$ce065fcf3a4bd895$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$ce065fcf3a4bd895$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$ce065fcf3a4bd895$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$ce065fcf3a4bd895$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$ce065fcf3a4bd895$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$ce065fcf3a4bd895$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$ce065fcf3a4bd895$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$ce065fcf3a4bd895$export$e45cb6485273080e = $ce065fcf3a4bd895$var$codes;

});


parcelRegister("injwu", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $2M83v = parcelRequire("2M83v");
'use strict';
/*<replacement>*/ var $d60984d48b1edb44$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $d60984d48b1edb44$var$Duplex;

var $39PPl = parcelRequire("39PPl");

var $lmkYv = parcelRequire("lmkYv");

(parcelRequire("lubO4"))($d60984d48b1edb44$var$Duplex, $39PPl);
// Allow the keys array to be GC'ed.
var $d60984d48b1edb44$var$keys = $d60984d48b1edb44$var$objectKeys($lmkYv.prototype);
for(var $d60984d48b1edb44$var$v = 0; $d60984d48b1edb44$var$v < $d60984d48b1edb44$var$keys.length; $d60984d48b1edb44$var$v++){
    var $d60984d48b1edb44$var$method = $d60984d48b1edb44$var$keys[$d60984d48b1edb44$var$v];
    if (!$d60984d48b1edb44$var$Duplex.prototype[$d60984d48b1edb44$var$method]) $d60984d48b1edb44$var$Duplex.prototype[$d60984d48b1edb44$var$method] = $lmkYv.prototype[$d60984d48b1edb44$var$method];
}
function $d60984d48b1edb44$var$Duplex(options) {
    if (!(this instanceof $d60984d48b1edb44$var$Duplex)) return new $d60984d48b1edb44$var$Duplex(options);
    $39PPl.call(this, options);
    $lmkYv.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $d60984d48b1edb44$var$onend);
        }
    }
}
Object.defineProperty($d60984d48b1edb44$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($d60984d48b1edb44$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($d60984d48b1edb44$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $d60984d48b1edb44$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $2M83v.nextTick($d60984d48b1edb44$var$onEndNT, this);
}
function $d60984d48b1edb44$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($d60984d48b1edb44$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("lmkYv", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $2M83v = parcelRequire("2M83v");
'use strict';
module.exports = $f8cbec364215295f$var$Writable;
/* <replacement> */ function $f8cbec364215295f$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $f8cbec364215295f$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $f8cbec364215295f$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $f8cbec364215295f$var$Duplex;
/*</replacement>*/ $f8cbec364215295f$var$Writable.WritableState = $f8cbec364215295f$var$WritableState;

/*<replacement>*/ var $f8cbec364215295f$var$internalUtil = {
    deprecate: (parcelRequire("hs4ab"))
};

var $cPMzz = parcelRequire("cPMzz");

var $2zYso = parcelRequire("2zYso");
var $f8cbec364215295f$require$Buffer = $2zYso.Buffer;
var $f8cbec364215295f$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $f8cbec364215295f$var$_uint8ArrayToBuffer(chunk) {
    return $f8cbec364215295f$require$Buffer.from(chunk);
}
function $f8cbec364215295f$var$_isUint8Array(obj) {
    return $f8cbec364215295f$require$Buffer.isBuffer(obj) || obj instanceof $f8cbec364215295f$var$OurUint8Array;
}

var $lDbA2 = parcelRequire("lDbA2");

var $8ghwY = parcelRequire("8ghwY");
var $f8cbec364215295f$var$getHighWaterMark = $8ghwY.getHighWaterMark;

var $hGFgY = parcelRequire("hGFgY");
var $f8cbec364215295f$require$_require$codes = $hGFgY.codes;
var $f8cbec364215295f$var$ERR_INVALID_ARG_TYPE = $f8cbec364215295f$require$_require$codes.ERR_INVALID_ARG_TYPE, $f8cbec364215295f$var$ERR_METHOD_NOT_IMPLEMENTED = $f8cbec364215295f$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $f8cbec364215295f$var$ERR_MULTIPLE_CALLBACK = $f8cbec364215295f$require$_require$codes.ERR_MULTIPLE_CALLBACK, $f8cbec364215295f$var$ERR_STREAM_CANNOT_PIPE = $f8cbec364215295f$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $f8cbec364215295f$var$ERR_STREAM_DESTROYED = $f8cbec364215295f$require$_require$codes.ERR_STREAM_DESTROYED, $f8cbec364215295f$var$ERR_STREAM_NULL_VALUES = $f8cbec364215295f$require$_require$codes.ERR_STREAM_NULL_VALUES, $f8cbec364215295f$var$ERR_STREAM_WRITE_AFTER_END = $f8cbec364215295f$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $f8cbec364215295f$var$ERR_UNKNOWN_ENCODING = $f8cbec364215295f$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $f8cbec364215295f$var$errorOrDestroy = $lDbA2.errorOrDestroy;

(parcelRequire("lubO4"))($f8cbec364215295f$var$Writable, $cPMzz);
function $f8cbec364215295f$var$nop() {}

function $f8cbec364215295f$var$WritableState(options, stream, isDuplex) {
    $f8cbec364215295f$var$Duplex = $f8cbec364215295f$var$Duplex || (parcelRequire("injwu"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $f8cbec364215295f$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $f8cbec364215295f$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $f8cbec364215295f$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $f8cbec364215295f$var$CorkedRequest(this);
}
$f8cbec364215295f$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($f8cbec364215295f$var$WritableState.prototype, 'buffer', {
            get: $f8cbec364215295f$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $f8cbec364215295f$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $f8cbec364215295f$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($f8cbec364215295f$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($f8cbec364215295f$var$realHasInstance.call(this, object)) return true;
            if (this !== $f8cbec364215295f$var$Writable) return false;
            return object && object._writableState instanceof $f8cbec364215295f$var$WritableState;
        }
    });
} else $f8cbec364215295f$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $f8cbec364215295f$var$Writable(options) {
    $f8cbec364215295f$var$Duplex = $f8cbec364215295f$var$Duplex || (parcelRequire("injwu"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $f8cbec364215295f$var$Duplex;
    if (!isDuplex && !$f8cbec364215295f$var$realHasInstance.call($f8cbec364215295f$var$Writable, this)) return new $f8cbec364215295f$var$Writable(options);
    this._writableState = new $f8cbec364215295f$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $cPMzz.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$f8cbec364215295f$var$Writable.prototype.pipe = function() {
    $f8cbec364215295f$var$errorOrDestroy(this, new $f8cbec364215295f$var$ERR_STREAM_CANNOT_PIPE());
};
function $f8cbec364215295f$var$writeAfterEnd(stream, cb) {
    var er = new $f8cbec364215295f$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $f8cbec364215295f$var$errorOrDestroy(stream, er);
    $2M83v.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $f8cbec364215295f$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $f8cbec364215295f$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $f8cbec364215295f$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $f8cbec364215295f$var$errorOrDestroy(stream, er);
        $2M83v.nextTick(cb, er);
        return false;
    }
    return true;
}
$f8cbec364215295f$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $f8cbec364215295f$var$_isUint8Array(chunk);
    if (isBuf && !$f8cbec364215295f$require$Buffer.isBuffer(chunk)) chunk = $f8cbec364215295f$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $f8cbec364215295f$var$nop;
    if (state.ending) $f8cbec364215295f$var$writeAfterEnd(this, cb);
    else if (isBuf || $f8cbec364215295f$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $f8cbec364215295f$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$f8cbec364215295f$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$f8cbec364215295f$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $f8cbec364215295f$var$clearBuffer(this, state);
    }
};
$f8cbec364215295f$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $f8cbec364215295f$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($f8cbec364215295f$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $f8cbec364215295f$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $f8cbec364215295f$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($f8cbec364215295f$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $f8cbec364215295f$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $f8cbec364215295f$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $f8cbec364215295f$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $f8cbec364215295f$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $f8cbec364215295f$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $f8cbec364215295f$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $2M83v.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $2M83v.nextTick($f8cbec364215295f$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $f8cbec364215295f$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $f8cbec364215295f$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $f8cbec364215295f$var$finishMaybe(stream, state);
    }
}
function $f8cbec364215295f$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $f8cbec364215295f$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $f8cbec364215295f$var$ERR_MULTIPLE_CALLBACK();
    $f8cbec364215295f$var$onwriteStateUpdate(state);
    if (er) $f8cbec364215295f$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $f8cbec364215295f$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $f8cbec364215295f$var$clearBuffer(stream, state);
        if (sync) $2M83v.nextTick($f8cbec364215295f$var$afterWrite, stream, state, finished, cb);
        else $f8cbec364215295f$var$afterWrite(stream, state, finished, cb);
    }
}
function $f8cbec364215295f$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $f8cbec364215295f$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $f8cbec364215295f$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $f8cbec364215295f$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $f8cbec364215295f$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $f8cbec364215295f$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $f8cbec364215295f$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $f8cbec364215295f$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$f8cbec364215295f$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $f8cbec364215295f$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$f8cbec364215295f$var$Writable.prototype._writev = null;
$f8cbec364215295f$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $f8cbec364215295f$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($f8cbec364215295f$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $f8cbec364215295f$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $f8cbec364215295f$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $f8cbec364215295f$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $f8cbec364215295f$var$finishMaybe(stream, state);
    });
}
function $f8cbec364215295f$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $2M83v.nextTick($f8cbec364215295f$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $f8cbec364215295f$var$finishMaybe(stream, state) {
    var need = $f8cbec364215295f$var$needFinish(state);
    if (need) {
        $f8cbec364215295f$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $f8cbec364215295f$var$endWritable(stream, state, cb) {
    state.ending = true;
    $f8cbec364215295f$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $2M83v.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $f8cbec364215295f$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($f8cbec364215295f$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$f8cbec364215295f$var$Writable.prototype.destroy = $lDbA2.destroy;
$f8cbec364215295f$var$Writable.prototype._undestroy = $lDbA2.undestroy;
$f8cbec364215295f$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});


parcelRegister("eATqd", function(module, exports) {
$parcel$export(module.exports, "StringDecoder", () => $a9ff6b1fd0b5eadf$export$63a7aa211a91ed69, (v) => $a9ff6b1fd0b5eadf$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $a9ff6b1fd0b5eadf$export$63a7aa211a91ed69;
'use strict';

var $3VN6j = parcelRequire("3VN6j");
var $a9ff6b1fd0b5eadf$require$Buffer = $3VN6j.Buffer;
/*</replacement>*/ var $a9ff6b1fd0b5eadf$var$isEncoding = $a9ff6b1fd0b5eadf$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $a9ff6b1fd0b5eadf$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $a9ff6b1fd0b5eadf$var$normalizeEncoding(enc) {
    var nenc = $a9ff6b1fd0b5eadf$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($a9ff6b1fd0b5eadf$require$Buffer.isEncoding === $a9ff6b1fd0b5eadf$var$isEncoding || !$a9ff6b1fd0b5eadf$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$a9ff6b1fd0b5eadf$export$63a7aa211a91ed69 = $a9ff6b1fd0b5eadf$var$StringDecoder;
function $a9ff6b1fd0b5eadf$var$StringDecoder(encoding) {
    this.encoding = $a9ff6b1fd0b5eadf$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $a9ff6b1fd0b5eadf$var$utf16Text;
            this.end = $a9ff6b1fd0b5eadf$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $a9ff6b1fd0b5eadf$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $a9ff6b1fd0b5eadf$var$base64Text;
            this.end = $a9ff6b1fd0b5eadf$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $a9ff6b1fd0b5eadf$var$simpleWrite;
            this.end = $a9ff6b1fd0b5eadf$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $a9ff6b1fd0b5eadf$require$Buffer.allocUnsafe(nb);
}
$a9ff6b1fd0b5eadf$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$a9ff6b1fd0b5eadf$var$StringDecoder.prototype.end = $a9ff6b1fd0b5eadf$var$utf8End;
// Returns only complete characters in a Buffer
$a9ff6b1fd0b5eadf$var$StringDecoder.prototype.text = $a9ff6b1fd0b5eadf$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$a9ff6b1fd0b5eadf$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $a9ff6b1fd0b5eadf$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $a9ff6b1fd0b5eadf$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $a9ff6b1fd0b5eadf$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $a9ff6b1fd0b5eadf$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $a9ff6b1fd0b5eadf$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $a9ff6b1fd0b5eadf$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $a9ff6b1fd0b5eadf$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $a9ff6b1fd0b5eadf$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $a9ff6b1fd0b5eadf$var$utf8Text(buf, i) {
    var total = $a9ff6b1fd0b5eadf$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $a9ff6b1fd0b5eadf$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $a9ff6b1fd0b5eadf$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $a9ff6b1fd0b5eadf$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $a9ff6b1fd0b5eadf$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $a9ff6b1fd0b5eadf$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $a9ff6b1fd0b5eadf$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $a9ff6b1fd0b5eadf$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("fWvjm", function(module, exports) {

var $2M83v = parcelRequire("2M83v");
'use strict';
var $b9b48f9011b6677d$var$_Object$setPrototypeO;
function $b9b48f9011b6677d$var$_defineProperty(obj, key, value) {
    key = $b9b48f9011b6677d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b9b48f9011b6677d$var$_toPropertyKey(arg) {
    var key = $b9b48f9011b6677d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $b9b48f9011b6677d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $bcheM = parcelRequire("bcheM");
var $b9b48f9011b6677d$var$kLastResolve = Symbol('lastResolve');
var $b9b48f9011b6677d$var$kLastReject = Symbol('lastReject');
var $b9b48f9011b6677d$var$kError = Symbol('error');
var $b9b48f9011b6677d$var$kEnded = Symbol('ended');
var $b9b48f9011b6677d$var$kLastPromise = Symbol('lastPromise');
var $b9b48f9011b6677d$var$kHandlePromise = Symbol('handlePromise');
var $b9b48f9011b6677d$var$kStream = Symbol('stream');
function $b9b48f9011b6677d$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $b9b48f9011b6677d$var$readAndResolve(iter) {
    var resolve = iter[$b9b48f9011b6677d$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$b9b48f9011b6677d$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$b9b48f9011b6677d$var$kLastPromise] = null;
            iter[$b9b48f9011b6677d$var$kLastResolve] = null;
            iter[$b9b48f9011b6677d$var$kLastReject] = null;
            resolve($b9b48f9011b6677d$var$createIterResult(data, false));
        }
    }
}
function $b9b48f9011b6677d$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $2M83v.nextTick($b9b48f9011b6677d$var$readAndResolve, iter);
}
function $b9b48f9011b6677d$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$b9b48f9011b6677d$var$kEnded]) {
                resolve($b9b48f9011b6677d$var$createIterResult(undefined, true));
                return;
            }
            iter[$b9b48f9011b6677d$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $b9b48f9011b6677d$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $b9b48f9011b6677d$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($b9b48f9011b6677d$var$_Object$setPrototypeO = {
    get stream () {
        return this[$b9b48f9011b6677d$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$b9b48f9011b6677d$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$b9b48f9011b6677d$var$kEnded]) return Promise.resolve($b9b48f9011b6677d$var$createIterResult(undefined, true));
        if (this[$b9b48f9011b6677d$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $2M83v.nextTick(function() {
                if (_this[$b9b48f9011b6677d$var$kError]) reject(_this[$b9b48f9011b6677d$var$kError]);
                else resolve($b9b48f9011b6677d$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$b9b48f9011b6677d$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($b9b48f9011b6677d$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$b9b48f9011b6677d$var$kStream].read();
            if (data !== null) return Promise.resolve($b9b48f9011b6677d$var$createIterResult(data, false));
            promise = new Promise(this[$b9b48f9011b6677d$var$kHandlePromise]);
        }
        this[$b9b48f9011b6677d$var$kLastPromise] = promise;
        return promise;
    }
}, $b9b48f9011b6677d$var$_defineProperty($b9b48f9011b6677d$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $b9b48f9011b6677d$var$_defineProperty($b9b48f9011b6677d$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$b9b48f9011b6677d$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($b9b48f9011b6677d$var$createIterResult(undefined, true));
        });
    });
}), $b9b48f9011b6677d$var$_Object$setPrototypeO), $b9b48f9011b6677d$var$AsyncIteratorPrototype);
var $b9b48f9011b6677d$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($b9b48f9011b6677d$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $b9b48f9011b6677d$var$_defineProperty(_Object$create, $b9b48f9011b6677d$var$kStream, {
        value: stream,
        writable: true
    }), $b9b48f9011b6677d$var$_defineProperty(_Object$create, $b9b48f9011b6677d$var$kLastResolve, {
        value: null,
        writable: true
    }), $b9b48f9011b6677d$var$_defineProperty(_Object$create, $b9b48f9011b6677d$var$kLastReject, {
        value: null,
        writable: true
    }), $b9b48f9011b6677d$var$_defineProperty(_Object$create, $b9b48f9011b6677d$var$kError, {
        value: null,
        writable: true
    }), $b9b48f9011b6677d$var$_defineProperty(_Object$create, $b9b48f9011b6677d$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $b9b48f9011b6677d$var$_defineProperty(_Object$create, $b9b48f9011b6677d$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$b9b48f9011b6677d$var$kStream].read();
            if (data) {
                iterator[$b9b48f9011b6677d$var$kLastPromise] = null;
                iterator[$b9b48f9011b6677d$var$kLastResolve] = null;
                iterator[$b9b48f9011b6677d$var$kLastReject] = null;
                resolve($b9b48f9011b6677d$var$createIterResult(data, false));
            } else {
                iterator[$b9b48f9011b6677d$var$kLastResolve] = resolve;
                iterator[$b9b48f9011b6677d$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$b9b48f9011b6677d$var$kLastPromise] = null;
    $bcheM(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$b9b48f9011b6677d$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$b9b48f9011b6677d$var$kLastPromise] = null;
                iterator[$b9b48f9011b6677d$var$kLastResolve] = null;
                iterator[$b9b48f9011b6677d$var$kLastReject] = null;
                reject(err);
            }
            iterator[$b9b48f9011b6677d$var$kError] = err;
            return;
        }
        var resolve = iterator[$b9b48f9011b6677d$var$kLastResolve];
        if (resolve !== null) {
            iterator[$b9b48f9011b6677d$var$kLastPromise] = null;
            iterator[$b9b48f9011b6677d$var$kLastResolve] = null;
            iterator[$b9b48f9011b6677d$var$kLastReject] = null;
            resolve($b9b48f9011b6677d$var$createIterResult(undefined, true));
        }
        iterator[$b9b48f9011b6677d$var$kEnded] = true;
    });
    stream.on('readable', $b9b48f9011b6677d$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $b9b48f9011b6677d$var$createReadableStreamAsyncIterator;

});
parcelRegister("bcheM", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $826e2fb31d7861ee$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("hGFgY")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $826e2fb31d7861ee$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $826e2fb31d7861ee$var$noop() {}
function $826e2fb31d7861ee$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $826e2fb31d7861ee$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $826e2fb31d7861ee$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $826e2fb31d7861ee$var$once(callback || $826e2fb31d7861ee$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $826e2fb31d7861ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $826e2fb31d7861ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($826e2fb31d7861ee$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $826e2fb31d7861ee$var$eos;

});


parcelRegister("7HrDr", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("6XXYS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $5126c7b988b34fed$var$Transform;

var $hGFgY = parcelRequire("hGFgY");
var $5126c7b988b34fed$require$_require$codes = $hGFgY.codes;
var $5126c7b988b34fed$var$ERR_METHOD_NOT_IMPLEMENTED = $5126c7b988b34fed$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5126c7b988b34fed$var$ERR_MULTIPLE_CALLBACK = $5126c7b988b34fed$require$_require$codes.ERR_MULTIPLE_CALLBACK, $5126c7b988b34fed$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $5126c7b988b34fed$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $5126c7b988b34fed$var$ERR_TRANSFORM_WITH_LENGTH_0 = $5126c7b988b34fed$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $injwu = parcelRequire("injwu");

(parcelRequire("lubO4"))($5126c7b988b34fed$var$Transform, $injwu);
function $5126c7b988b34fed$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $5126c7b988b34fed$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $5126c7b988b34fed$var$Transform(options) {
    if (!(this instanceof $5126c7b988b34fed$var$Transform)) return new $5126c7b988b34fed$var$Transform(options);
    $injwu.call(this, options);
    this._transformState = {
        afterTransform: $5126c7b988b34fed$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $5126c7b988b34fed$var$prefinish);
}
function $5126c7b988b34fed$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $5126c7b988b34fed$var$done(_this, er, data);
    });
    else $5126c7b988b34fed$var$done(this, null, null);
}
$5126c7b988b34fed$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $injwu.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$5126c7b988b34fed$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $5126c7b988b34fed$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$5126c7b988b34fed$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$5126c7b988b34fed$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$5126c7b988b34fed$var$Transform.prototype._destroy = function(err, cb) {
    $injwu.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $5126c7b988b34fed$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $5126c7b988b34fed$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $5126c7b988b34fed$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("bP41s", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $89b793ef286e9604$var$PassThrough;

var $6XXYS = parcelRequire("6XXYS");

(parcelRequire("lubO4"))($89b793ef286e9604$var$PassThrough, $6XXYS);
function $89b793ef286e9604$var$PassThrough(options) {
    if (!(this instanceof $89b793ef286e9604$var$PassThrough)) return new $89b793ef286e9604$var$PassThrough(options);
    $6XXYS.call(this, options);
}
$89b793ef286e9604$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("cwpRa", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $91dc87c310101de1$var$eos;
function $91dc87c310101de1$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $hGFgY = parcelRequire("hGFgY");
var $91dc87c310101de1$require$_require$codes = $hGFgY.codes;
var $91dc87c310101de1$var$ERR_MISSING_ARGS = $91dc87c310101de1$require$_require$codes.ERR_MISSING_ARGS, $91dc87c310101de1$var$ERR_STREAM_DESTROYED = $91dc87c310101de1$require$_require$codes.ERR_STREAM_DESTROYED;
function $91dc87c310101de1$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $91dc87c310101de1$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $91dc87c310101de1$var$destroyer(stream, reading, writing, callback) {
    callback = $91dc87c310101de1$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($91dc87c310101de1$var$eos === undefined) $91dc87c310101de1$var$eos = (parcelRequire("bcheM"));
    $91dc87c310101de1$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($91dc87c310101de1$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $91dc87c310101de1$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $91dc87c310101de1$var$call(fn) {
    fn();
}
function $91dc87c310101de1$var$pipe(from, to) {
    return from.pipe(to);
}
function $91dc87c310101de1$var$popCallback(streams) {
    if (!streams.length) return $91dc87c310101de1$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $91dc87c310101de1$var$noop;
    return streams.pop();
}
function $91dc87c310101de1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $91dc87c310101de1$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $91dc87c310101de1$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $91dc87c310101de1$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($91dc87c310101de1$var$call);
            if (reading) return;
            destroys.forEach($91dc87c310101de1$var$call);
            callback(error);
        });
    });
    return streams.reduce($91dc87c310101de1$var$pipe);
}
module.exports = $91dc87c310101de1$var$pipeline;

});




parcelRegister("bIUE1", function(module, exports) {
'use strict';

var $lubO4 = parcelRequire("lubO4");

var $39swn = parcelRequire("39swn");

var $AhG97 = parcelRequire("AhG97");

var $3VN6j = parcelRequire("3VN6j");
var $888fbe3686b97181$require$Buffer = $3VN6j.Buffer;

var $43f4e = parcelRequire("43f4e");

var $bxooq = parcelRequire("bxooq");

var $fwBLh = parcelRequire("fwBLh");
var $888fbe3686b97181$var$ZEROS = $888fbe3686b97181$require$Buffer.alloc(128);
function $888fbe3686b97181$var$Hmac(alg, key) {
    $AhG97.call(this, 'digest');
    if (typeof key === 'string') key = $888fbe3686b97181$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $bxooq() : $fwBLh(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $888fbe3686b97181$require$Buffer.concat([
        key,
        $888fbe3686b97181$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $888fbe3686b97181$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $888fbe3686b97181$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $bxooq() : $fwBLh(alg);
    this._hash.update(ipad);
}
$lubO4($888fbe3686b97181$var$Hmac, $AhG97);
$888fbe3686b97181$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$888fbe3686b97181$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $bxooq() : $fwBLh(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $888fbe3686b97181$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $39swn($43f4e, key);
    return new $888fbe3686b97181$var$Hmac(alg, key);
};

});
parcelRegister("39swn", function(module, exports) {
'use strict';

var $lubO4 = parcelRequire("lubO4");

var $3VN6j = parcelRequire("3VN6j");
var $24b85615ea1321f3$require$Buffer = $3VN6j.Buffer;

var $AhG97 = parcelRequire("AhG97");
var $24b85615ea1321f3$var$ZEROS = $24b85615ea1321f3$require$Buffer.alloc(128);
var $24b85615ea1321f3$var$blocksize = 64;
function $24b85615ea1321f3$var$Hmac(alg, key) {
    $AhG97.call(this, 'digest');
    if (typeof key === 'string') key = $24b85615ea1321f3$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $24b85615ea1321f3$var$blocksize) key = alg(key);
    else if (key.length < $24b85615ea1321f3$var$blocksize) key = $24b85615ea1321f3$require$Buffer.concat([
        key,
        $24b85615ea1321f3$var$ZEROS
    ], $24b85615ea1321f3$var$blocksize);
    var ipad = this._ipad = $24b85615ea1321f3$require$Buffer.allocUnsafe($24b85615ea1321f3$var$blocksize);
    var opad = this._opad = $24b85615ea1321f3$require$Buffer.allocUnsafe($24b85615ea1321f3$var$blocksize);
    for(var i = 0; i < $24b85615ea1321f3$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$lubO4($24b85615ea1321f3$var$Hmac, $AhG97);
$24b85615ea1321f3$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$24b85615ea1321f3$var$Hmac.prototype._final = function() {
    var h = this._alg($24b85615ea1321f3$require$Buffer.concat(this._hash));
    return this._alg($24b85615ea1321f3$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $24b85615ea1321f3$var$Hmac;

});

parcelRegister("43f4e", function(module, exports) {

var $aZDj9 = parcelRequire("aZDj9");
module.exports = function(buffer) {
    return new $aZDj9().update(buffer).digest();
};

});


parcelRegister("57hRw", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});

parcelRegister("eShhr", function(module, exports) {
'use strict';

var $3VN6j = parcelRequire("3VN6j");
var $ad43835b8c1ba69a$require$Buffer = $3VN6j.Buffer;

var $jpWKY = parcelRequire("jpWKY");

var $4ogjX = parcelRequire("4ogjX");

var $ipzG4 = parcelRequire("ipzG4");

var $l0ioJ = parcelRequire("l0ioJ");
var $ad43835b8c1ba69a$var$ZERO_BUF;
var $ad43835b8c1ba69a$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $ad43835b8c1ba69a$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $ad43835b8c1ba69a$var$checks = [];
var $ad43835b8c1ba69a$var$nextTick;
function $ad43835b8c1ba69a$var$getNextTick() {
    if ($ad43835b8c1ba69a$var$nextTick) return $ad43835b8c1ba69a$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $ad43835b8c1ba69a$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $ad43835b8c1ba69a$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $ad43835b8c1ba69a$var$nextTick = $parcel$global.setImmediate;
    else $ad43835b8c1ba69a$var$nextTick = $parcel$global.setTimeout;
    return $ad43835b8c1ba69a$var$nextTick;
}
function $ad43835b8c1ba69a$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $ad43835b8c1ba69a$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $ad43835b8c1ba69a$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $ad43835b8c1ba69a$require$Buffer.from(res);
    });
}
function $ad43835b8c1ba69a$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$ad43835b8c1ba69a$var$subtle || !$ad43835b8c1ba69a$var$subtle.importKey || !$ad43835b8c1ba69a$var$subtle.deriveBits) return Promise.resolve(false);
    if ($ad43835b8c1ba69a$var$checks[algo] !== undefined) return $ad43835b8c1ba69a$var$checks[algo];
    $ad43835b8c1ba69a$var$ZERO_BUF = $ad43835b8c1ba69a$var$ZERO_BUF || $ad43835b8c1ba69a$require$Buffer.alloc(8);
    var prom = $ad43835b8c1ba69a$var$browserPbkdf2($ad43835b8c1ba69a$var$ZERO_BUF, $ad43835b8c1ba69a$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $ad43835b8c1ba69a$var$checks[algo] = prom;
    return prom;
}
function $ad43835b8c1ba69a$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $ad43835b8c1ba69a$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $ad43835b8c1ba69a$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    keylen = $jpWKY(iterations, keylen);
    password = $l0ioJ(password, $4ogjX, 'Password');
    salt = $l0ioJ(salt, $4ogjX, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = $ad43835b8c1ba69a$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $ad43835b8c1ba69a$var$getNextTick()(function() {
            var out;
            try {
                out = $ipzG4(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $ad43835b8c1ba69a$var$resolvePromise($ad43835b8c1ba69a$var$checkNative(algo).then(function(resp) {
        if (resp) return $ad43835b8c1ba69a$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $ipzG4(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("jpWKY", function(module, exports) {
'use strict';
var $e22dedfc75644213$var$$isFinite = isFinite;
var $e22dedfc75644213$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0 || !$e22dedfc75644213$var$$isFinite(iterations)) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $e22dedfc75644213$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
    // `-0` passes the `keylen < 0` guard above (since `-0 < 0` is `false`), but
    // the native binding requires a true Int32; `-0` is held as a double and
    // aborts the process (SIGABRT) on Node.js 15+. Coerce it to `+0`.
    return keylen + 0;
};

});

parcelRegister("4ogjX", function(module, exports) {

var $2M83v = parcelRequire("2M83v");
'use strict';
var $33261048560c0305$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $33261048560c0305$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $33261048560c0305$var$pVersionMajor = parseInt($2M83v.version.split('.')[0].slice(1), 10);
    $33261048560c0305$var$defaultEncoding = $33261048560c0305$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $33261048560c0305$var$defaultEncoding = 'utf-8';
module.exports = $33261048560c0305$var$defaultEncoding;

});

parcelRegister("ipzG4", function(module, exports) {
'use strict';

var $43f4e = parcelRequire("43f4e");

var $bxooq = parcelRequire("bxooq");

var $fwBLh = parcelRequire("fwBLh");

var $3VN6j = parcelRequire("3VN6j");
var $d6763c9783fc6231$require$Buffer = $3VN6j.Buffer;

var $jpWKY = parcelRequire("jpWKY");

var $4ogjX = parcelRequire("4ogjX");

var $l0ioJ = parcelRequire("l0ioJ");
var $d6763c9783fc6231$var$ZEROS = $d6763c9783fc6231$require$Buffer.alloc(128);
var $d6763c9783fc6231$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $d6763c9783fc6231$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $d6763c9783fc6231$var$rmd160Func(data) {
    return new $bxooq().update(data).digest();
}
function $d6763c9783fc6231$var$getDigest(alg) {
    function shaFunc(data) {
        return $fwBLh(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $d6763c9783fc6231$var$rmd160Func;
    if (alg === 'md5') return $43f4e;
    return shaFunc;
}
function $d6763c9783fc6231$var$Hmac(alg, key, saltLen) {
    var hash = $d6763c9783fc6231$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $d6763c9783fc6231$require$Buffer.concat([
        key,
        $d6763c9783fc6231$var$ZEROS
    ], blocksize);
    var ipad = $d6763c9783fc6231$require$Buffer.allocUnsafe(blocksize + $d6763c9783fc6231$var$sizes[alg]);
    var opad = $d6763c9783fc6231$require$Buffer.allocUnsafe(blocksize + $d6763c9783fc6231$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $d6763c9783fc6231$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $d6763c9783fc6231$var$sizes[alg];
}
$d6763c9783fc6231$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $d6763c9783fc6231$var$pbkdf2(password, salt, iterations, keylen, digest) {
    keylen = $jpWKY(iterations, keylen);
    password = $l0ioJ(password, $4ogjX, 'Password');
    salt = $l0ioJ(salt, $4ogjX, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $d6763c9783fc6231$var$mapping[lowerDigest] || lowerDigest;
    var size = $d6763c9783fc6231$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $d6763c9783fc6231$var$Hmac(mappedDigest, password, salt.length);
    var DK = $d6763c9783fc6231$require$Buffer.allocUnsafe(keylen);
    var block1 = $d6763c9783fc6231$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $d6763c9783fc6231$var$pbkdf2;

});
parcelRegister("l0ioJ", function(module, exports) {
'use strict';

var $3VN6j = parcelRequire("3VN6j");
var $f4a7de84eb0ab7fb$require$Buffer = $3VN6j.Buffer;

var $7roic = parcelRequire("7roic");
var $f4a7de84eb0ab7fb$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $f4a7de84eb0ab7fb$var$useArrayBuffer = $f4a7de84eb0ab7fb$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $f4a7de84eb0ab7fb$var$isView = $f4a7de84eb0ab7fb$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $f4a7de84eb0ab7fb$require$Buffer.isBuffer(thing) || $f4a7de84eb0ab7fb$var$useUint8Array && thing instanceof Uint8Array || $f4a7de84eb0ab7fb$var$isView && $f4a7de84eb0ab7fb$var$isView(thing)) return $7roic(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});



parcelRegister("jTZQF", function(module, exports) {
$parcel$export(module.exports, "readUInt32BE", () => $e7d32132acc6c8c5$export$cfaef8ed399428b0, (v) => $e7d32132acc6c8c5$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $e7d32132acc6c8c5$export$a80c7deaea7cbd80, (v) => $e7d32132acc6c8c5$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $e7d32132acc6c8c5$export$ed7577ae6e1cd0ef, (v) => $e7d32132acc6c8c5$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $e7d32132acc6c8c5$export$5dcbef3aa594f567, (v) => $e7d32132acc6c8c5$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $e7d32132acc6c8c5$export$5bc8001ca71ed9c5, (v) => $e7d32132acc6c8c5$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $e7d32132acc6c8c5$export$3e714e2c5d5d8cb2, (v) => $e7d32132acc6c8c5$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $e7d32132acc6c8c5$export$94c3e544fd062b7f, (v) => $e7d32132acc6c8c5$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $e7d32132acc6c8c5$export$9f77e0932fb78f72, (v) => $e7d32132acc6c8c5$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $e7d32132acc6c8c5$export$d865ce2836f5927f, (v) => $e7d32132acc6c8c5$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $e7d32132acc6c8c5$export$95e62ad65da8b7d2, (v) => $e7d32132acc6c8c5$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $e7d32132acc6c8c5$export$209139ff098c441a, (v) => $e7d32132acc6c8c5$export$209139ff098c441a = v);
var $e7d32132acc6c8c5$export$cfaef8ed399428b0;
var $e7d32132acc6c8c5$export$a80c7deaea7cbd80;
var $e7d32132acc6c8c5$export$ed7577ae6e1cd0ef;
var $e7d32132acc6c8c5$export$5dcbef3aa594f567;
var $e7d32132acc6c8c5$export$5bc8001ca71ed9c5;
var $e7d32132acc6c8c5$export$3e714e2c5d5d8cb2;
var $e7d32132acc6c8c5$export$94c3e544fd062b7f;
var $e7d32132acc6c8c5$export$9f77e0932fb78f72;
var $e7d32132acc6c8c5$export$d865ce2836f5927f;
var $e7d32132acc6c8c5$export$95e62ad65da8b7d2;
var $e7d32132acc6c8c5$export$209139ff098c441a;
'use strict';
$e7d32132acc6c8c5$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$e7d32132acc6c8c5$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$e7d32132acc6c8c5$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$e7d32132acc6c8c5$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$e7d32132acc6c8c5$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$e7d32132acc6c8c5$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $e7d32132acc6c8c5$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$e7d32132acc6c8c5$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $e7d32132acc6c8c5$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $e7d32132acc6c8c5$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $e7d32132acc6c8c5$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $e7d32132acc6c8c5$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$e7d32132acc6c8c5$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $e7d32132acc6c8c5$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$e7d32132acc6c8c5$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $e7d32132acc6c8c5$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $e7d32132acc6c8c5$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $e7d32132acc6c8c5$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$e7d32132acc6c8c5$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $e7d32132acc6c8c5$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $e7d32132acc6c8c5$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$e7d32132acc6c8c5$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("03hP1", function(module, exports) {
'use strict';

var $bYAD2 = parcelRequire("bYAD2");
function $009e1afe170e5e65$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $009e1afe170e5e65$var$Cipher;
$009e1afe170e5e65$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$009e1afe170e5e65$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$009e1afe170e5e65$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$009e1afe170e5e65$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$009e1afe170e5e65$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$009e1afe170e5e65$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$009e1afe170e5e65$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$009e1afe170e5e65$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$009e1afe170e5e65$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$009e1afe170e5e65$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$009e1afe170e5e65$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $bYAD2.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("bYAD2", function(module, exports) {
module.exports = $8b81b5ffb039c142$var$assert;
function $8b81b5ffb039c142$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$8b81b5ffb039c142$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("l8xhO", function(module, exports) {
'use strict';

var $bYAD2 = parcelRequire("bYAD2");

var $lubO4 = parcelRequire("lubO4");

var $jTZQF = parcelRequire("jTZQF");

var $03hP1 = parcelRequire("03hP1");
function $f6342a48c53a3600$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $f6342a48c53a3600$var$DES(options) {
    $03hP1.call(this, options);
    var state = new $f6342a48c53a3600$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$lubO4($f6342a48c53a3600$var$DES, $03hP1);
module.exports = $f6342a48c53a3600$var$DES;
$f6342a48c53a3600$var$DES.create = function create(options) {
    return new $f6342a48c53a3600$var$DES(options);
};
var $f6342a48c53a3600$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$f6342a48c53a3600$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $bYAD2.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $jTZQF.readUInt32BE(key, 0);
    var kR = $jTZQF.readUInt32BE(key, 4);
    $jTZQF.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $f6342a48c53a3600$var$shiftTable[i >>> 1];
        kL = $jTZQF.r28shl(kL, shift);
        kR = $jTZQF.r28shl(kR, shift);
        $jTZQF.pc2(kL, kR, state.keys, i);
    }
};
$f6342a48c53a3600$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $jTZQF.readUInt32BE(inp, inOff);
    var r = $jTZQF.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $jTZQF.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $jTZQF.writeUInt32BE(out, l, outOff);
    $jTZQF.writeUInt32BE(out, r, outOff + 4);
};
$f6342a48c53a3600$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$f6342a48c53a3600$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$bYAD2.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$f6342a48c53a3600$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $jTZQF.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $jTZQF.substitute(keyL, keyR);
        var f = $jTZQF.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $jTZQF.rip(r, l, out, off);
};
$f6342a48c53a3600$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $jTZQF.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $jTZQF.substitute(keyL, keyR);
        var f = $jTZQF.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $jTZQF.rip(l, r, out, off);
};

});

parcelRegister("84VWS", function(module, exports) {
$parcel$export(module.exports, "instantiate", () => $5e1ba5d87497a8e9$export$f9bb8d20ccc7477a, (v) => $5e1ba5d87497a8e9$export$f9bb8d20ccc7477a = v);
var $5e1ba5d87497a8e9$export$f9bb8d20ccc7477a;
'use strict';

var $bYAD2 = parcelRequire("bYAD2");

var $lubO4 = parcelRequire("lubO4");
var $5e1ba5d87497a8e9$var$proto = {};
function $5e1ba5d87497a8e9$var$CBCState(iv) {
    $bYAD2.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $5e1ba5d87497a8e9$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $lubO4(CBC, Base);
    var keys = Object.keys($5e1ba5d87497a8e9$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $5e1ba5d87497a8e9$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$5e1ba5d87497a8e9$export$f9bb8d20ccc7477a = $5e1ba5d87497a8e9$var$instantiate;
$5e1ba5d87497a8e9$var$proto._cbcInit = function _cbcInit() {
    var state = new $5e1ba5d87497a8e9$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$5e1ba5d87497a8e9$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("43WKo", function(module, exports) {
'use strict';

var $bYAD2 = parcelRequire("bYAD2");

var $lubO4 = parcelRequire("lubO4");

var $03hP1 = parcelRequire("03hP1");

var $l8xhO = parcelRequire("l8xhO");
function $2f5503323f0fb406$var$EDEState(type, key) {
    $bYAD2.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $l8xhO.create({
            type: 'encrypt',
            key: k1
        }),
        $l8xhO.create({
            type: 'decrypt',
            key: k2
        }),
        $l8xhO.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $l8xhO.create({
            type: 'decrypt',
            key: k3
        }),
        $l8xhO.create({
            type: 'encrypt',
            key: k2
        }),
        $l8xhO.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $2f5503323f0fb406$var$EDE(options) {
    $03hP1.call(this, options);
    var state = new $2f5503323f0fb406$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$lubO4($2f5503323f0fb406$var$EDE, $03hP1);
module.exports = $2f5503323f0fb406$var$EDE;
$2f5503323f0fb406$var$EDE.create = function create(options) {
    return new $2f5503323f0fb406$var$EDE(options);
};
$2f5503323f0fb406$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$2f5503323f0fb406$var$EDE.prototype._pad = $l8xhO.prototype._pad;
$2f5503323f0fb406$var$EDE.prototype._unpad = $l8xhO.prototype._unpad;

});

parcelRegister("dlMRO", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $9b83247d48c77c19$export$5b0f6292f11d1d18, (v) => $9b83247d48c77c19$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $9b83247d48c77c19$export$e85a0c9a1067c5d3, (v) => $9b83247d48c77c19$export$e85a0c9a1067c5d3 = v);
var $9b83247d48c77c19$export$5b0f6292f11d1d18;
var $9b83247d48c77c19$export$e85a0c9a1067c5d3;
$9b83247d48c77c19$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$9b83247d48c77c19$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("hmiZI", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $ca3339a8f0af376b$export$5b0f6292f11d1d18, (v) => $ca3339a8f0af376b$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $ca3339a8f0af376b$export$e85a0c9a1067c5d3, (v) => $ca3339a8f0af376b$export$e85a0c9a1067c5d3 = v);
var $ca3339a8f0af376b$export$5b0f6292f11d1d18;
var $ca3339a8f0af376b$export$e85a0c9a1067c5d3;

var $6BzeD = parcelRequire("6BzeD");
$ca3339a8f0af376b$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $6BzeD(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$ca3339a8f0af376b$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $6BzeD(out, pad);
};

});
parcelRegister("6BzeD", function(module, exports) {

var $2zYso = parcelRequire("2zYso");
var $4cf187b9042907a2$require$Buffer = $2zYso.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $4cf187b9042907a2$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("7PPN1", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $5b45782e708bd759$export$5b0f6292f11d1d18, (v) => $5b45782e708bd759$export$5b0f6292f11d1d18 = v);
var $5b45782e708bd759$export$5b0f6292f11d1d18;

var $3VN6j = parcelRequire("3VN6j");
var $5b45782e708bd759$require$Buffer = $3VN6j.Buffer;

var $6BzeD = parcelRequire("6BzeD");
function $5b45782e708bd759$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $6BzeD(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $5b45782e708bd759$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$5b45782e708bd759$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $5b45782e708bd759$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $5b45782e708bd759$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $5b45782e708bd759$require$Buffer.concat([
                out,
                $5b45782e708bd759$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $5b45782e708bd759$require$Buffer.concat([
                out,
                $5b45782e708bd759$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("5ZCbH", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $45d0458dfc8f5de7$export$5b0f6292f11d1d18, (v) => $45d0458dfc8f5de7$export$5b0f6292f11d1d18 = v);
var $45d0458dfc8f5de7$export$5b0f6292f11d1d18;

var $3VN6j = parcelRequire("3VN6j");
var $45d0458dfc8f5de7$require$Buffer = $3VN6j.Buffer;
function $45d0458dfc8f5de7$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $45d0458dfc8f5de7$require$Buffer.concat([
        self._prev.slice(1),
        $45d0458dfc8f5de7$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$45d0458dfc8f5de7$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $45d0458dfc8f5de7$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $45d0458dfc8f5de7$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("g5Fqo", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $bb6d3f073ad21000$export$5b0f6292f11d1d18, (v) => $bb6d3f073ad21000$export$5b0f6292f11d1d18 = v);
var $bb6d3f073ad21000$export$5b0f6292f11d1d18;

var $3VN6j = parcelRequire("3VN6j");
var $bb6d3f073ad21000$require$Buffer = $3VN6j.Buffer;
function $bb6d3f073ad21000$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $bb6d3f073ad21000$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $bb6d3f073ad21000$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $bb6d3f073ad21000$require$Buffer.allocUnsafe(buffer.length);
    buffer = $bb6d3f073ad21000$require$Buffer.concat([
        buffer,
        $bb6d3f073ad21000$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$bb6d3f073ad21000$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $bb6d3f073ad21000$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $bb6d3f073ad21000$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("4Gi4v", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $36891a53d9a74dcc$export$5b0f6292f11d1d18, (v) => $36891a53d9a74dcc$export$5b0f6292f11d1d18 = v);
var $36891a53d9a74dcc$export$5b0f6292f11d1d18;

var $2zYso = parcelRequire("2zYso");
var $36891a53d9a74dcc$require$Buffer = $2zYso.Buffer;

var $6BzeD = parcelRequire("6BzeD");
function $36891a53d9a74dcc$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$36891a53d9a74dcc$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $36891a53d9a74dcc$require$Buffer.concat([
        self._cache,
        $36891a53d9a74dcc$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $6BzeD(chunk, pad);
};

});

parcelRegister("2nKMt", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $1bc2046e09168fd0$export$5b0f6292f11d1d18, (v) => $1bc2046e09168fd0$export$5b0f6292f11d1d18 = v);
var $1bc2046e09168fd0$export$5b0f6292f11d1d18;

var $6BzeD = parcelRequire("6BzeD");

var $3VN6j = parcelRequire("3VN6j");
var $1bc2046e09168fd0$require$Buffer = $3VN6j.Buffer;

var $jhGkU = parcelRequire("jhGkU");
function $1bc2046e09168fd0$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $jhGkU(self._prev);
    return out;
}
var $1bc2046e09168fd0$var$blockSize = 16;
$1bc2046e09168fd0$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $1bc2046e09168fd0$var$blockSize);
    var start = self._cache.length;
    self._cache = $1bc2046e09168fd0$require$Buffer.concat([
        self._cache,
        $1bc2046e09168fd0$require$Buffer.allocUnsafe(chunkNum * $1bc2046e09168fd0$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $1bc2046e09168fd0$var$getBlock(self);
        var offset = start + i * $1bc2046e09168fd0$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $6BzeD(chunk, pad);
};

});
parcelRegister("jhGkU", function(module, exports) {
function $e0a071f86c1eaec5$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $e0a071f86c1eaec5$var$incr32;

});


parcelRegister("6MZ4r", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("a5Qi3")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("4zkLw", function(module, exports) {
var $353a89e7675bb345$var$r;
module.exports = function rand(len) {
    if (!$353a89e7675bb345$var$r) $353a89e7675bb345$var$r = new $353a89e7675bb345$var$Rand(null);
    return $353a89e7675bb345$var$r.generate(len);
};
function $353a89e7675bb345$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $353a89e7675bb345$var$Rand;
$353a89e7675bb345$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$353a89e7675bb345$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $353a89e7675bb345$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $353a89e7675bb345$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $353a89e7675bb345$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $353a89e7675bb345$var$crypto = (parcelRequire("a5Qi3"));
    if (typeof $353a89e7675bb345$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $353a89e7675bb345$var$Rand.prototype._rand = function _rand(n) {
        return $353a89e7675bb345$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("6barc", function(module, exports) {

exports = module.exports = (parcelRequire("8BG9M"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("gvOeT"));

exports.Duplex = (parcelRequire("1IQxn"));

exports.Transform = (parcelRequire("70ih1"));

exports.PassThrough = (parcelRequire("8S1FO"));

});
parcelRegister("8BG9M", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $2M83v = parcelRequire("2M83v");
'use strict';

var $f6uEY = parcelRequire("f6uEY");
/*</replacement>*/ module.exports = $64427adeabe25cb7$var$Readable;

var $fjujn = parcelRequire("fjujn");
/*</replacement>*/ /*<replacement>*/ var $64427adeabe25cb7$var$Duplex;
/*</replacement>*/ $64427adeabe25cb7$var$Readable.ReadableState = $64427adeabe25cb7$var$ReadableState;

var $lAGdN = parcelRequire("lAGdN");
var $64427adeabe25cb7$require$EE = $lAGdN.EventEmitter;
var $64427adeabe25cb7$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $gEcii = parcelRequire("gEcii");

var $ituKa = parcelRequire("ituKa");
var $64427adeabe25cb7$require$Buffer = $ituKa.Buffer;
var $64427adeabe25cb7$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $64427adeabe25cb7$var$_uint8ArrayToBuffer(chunk) {
    return $64427adeabe25cb7$require$Buffer.from(chunk);
}
function $64427adeabe25cb7$var$_isUint8Array(obj) {
    return $64427adeabe25cb7$require$Buffer.isBuffer(obj) || obj instanceof $64427adeabe25cb7$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $64427adeabe25cb7$var$util = Object.create((parcelRequire("EeTfc")));

$64427adeabe25cb7$var$util.inherits = (parcelRequire("lubO4"));

var $a5Qi3 = parcelRequire("a5Qi3");
var $64427adeabe25cb7$var$debug = void 0;
if ($a5Qi3 && $a5Qi3.debuglog) $64427adeabe25cb7$var$debug = $a5Qi3.debuglog('stream');
else $64427adeabe25cb7$var$debug = function() {};

var $j5pAJ = parcelRequire("j5pAJ");

var $jeSiA = parcelRequire("jeSiA");
var $64427adeabe25cb7$var$StringDecoder;
$64427adeabe25cb7$var$util.inherits($64427adeabe25cb7$var$Readable, $gEcii);
var $64427adeabe25cb7$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $64427adeabe25cb7$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($fjujn(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $64427adeabe25cb7$var$ReadableState(options, stream) {
    $64427adeabe25cb7$var$Duplex = $64427adeabe25cb7$var$Duplex || (parcelRequire("1IQxn"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $64427adeabe25cb7$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $j5pAJ();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$64427adeabe25cb7$var$StringDecoder) $64427adeabe25cb7$var$StringDecoder = (parcelRequire("dtPrV")).StringDecoder;
        this.decoder = new $64427adeabe25cb7$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $64427adeabe25cb7$var$Readable(options) {
    $64427adeabe25cb7$var$Duplex = $64427adeabe25cb7$var$Duplex || (parcelRequire("1IQxn"));
    if (!(this instanceof $64427adeabe25cb7$var$Readable)) return new $64427adeabe25cb7$var$Readable(options);
    this._readableState = new $64427adeabe25cb7$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $gEcii.call(this);
}
Object.defineProperty($64427adeabe25cb7$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$64427adeabe25cb7$var$Readable.prototype.destroy = $jeSiA.destroy;
$64427adeabe25cb7$var$Readable.prototype._undestroy = $jeSiA.undestroy;
$64427adeabe25cb7$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$64427adeabe25cb7$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $64427adeabe25cb7$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $64427adeabe25cb7$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$64427adeabe25cb7$var$Readable.prototype.unshift = function(chunk) {
    return $64427adeabe25cb7$var$readableAddChunk(this, chunk, null, true, false);
};
function $64427adeabe25cb7$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $64427adeabe25cb7$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $64427adeabe25cb7$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $64427adeabe25cb7$require$Buffer.prototype) chunk = $64427adeabe25cb7$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $64427adeabe25cb7$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $64427adeabe25cb7$var$addChunk(stream, state, chunk, false);
                    else $64427adeabe25cb7$var$maybeReadMore(stream, state);
                } else $64427adeabe25cb7$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $64427adeabe25cb7$var$needMoreData(state);
}
function $64427adeabe25cb7$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $64427adeabe25cb7$var$emitReadable(stream);
    }
    $64427adeabe25cb7$var$maybeReadMore(stream, state);
}
function $64427adeabe25cb7$var$chunkInvalid(state, chunk) {
    var er;
    if (!$64427adeabe25cb7$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $64427adeabe25cb7$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$64427adeabe25cb7$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$64427adeabe25cb7$var$Readable.prototype.setEncoding = function(enc) {
    if (!$64427adeabe25cb7$var$StringDecoder) $64427adeabe25cb7$var$StringDecoder = (parcelRequire("dtPrV")).StringDecoder;
    this._readableState.decoder = new $64427adeabe25cb7$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $64427adeabe25cb7$var$MAX_HWM = 0x800000;
function $64427adeabe25cb7$var$computeNewHighWaterMark(n) {
    if (n >= $64427adeabe25cb7$var$MAX_HWM) n = $64427adeabe25cb7$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $64427adeabe25cb7$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $64427adeabe25cb7$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$64427adeabe25cb7$var$Readable.prototype.read = function(n) {
    $64427adeabe25cb7$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $64427adeabe25cb7$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $64427adeabe25cb7$var$endReadable(this);
        else $64427adeabe25cb7$var$emitReadable(this);
        return null;
    }
    n = $64427adeabe25cb7$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $64427adeabe25cb7$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $64427adeabe25cb7$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $64427adeabe25cb7$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $64427adeabe25cb7$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $64427adeabe25cb7$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $64427adeabe25cb7$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $64427adeabe25cb7$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $64427adeabe25cb7$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $64427adeabe25cb7$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $64427adeabe25cb7$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $64427adeabe25cb7$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $64427adeabe25cb7$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $f6uEY.nextTick($64427adeabe25cb7$var$emitReadable_, stream);
        else $64427adeabe25cb7$var$emitReadable_(stream);
    }
}
function $64427adeabe25cb7$var$emitReadable_(stream) {
    $64427adeabe25cb7$var$debug('emit readable');
    stream.emit('readable');
    $64427adeabe25cb7$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $64427adeabe25cb7$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $f6uEY.nextTick($64427adeabe25cb7$var$maybeReadMore_, stream, state);
    }
}
function $64427adeabe25cb7$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $64427adeabe25cb7$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$64427adeabe25cb7$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$64427adeabe25cb7$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $64427adeabe25cb7$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2M83v.stdout && dest !== $2M83v.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $f6uEY.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $64427adeabe25cb7$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $64427adeabe25cb7$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $64427adeabe25cb7$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $64427adeabe25cb7$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $64427adeabe25cb7$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $64427adeabe25cb7$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $64427adeabe25cb7$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $64427adeabe25cb7$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($64427adeabe25cb7$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $64427adeabe25cb7$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $64427adeabe25cb7$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $64427adeabe25cb7$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $64427adeabe25cb7$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $64427adeabe25cb7$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $64427adeabe25cb7$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $64427adeabe25cb7$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $64427adeabe25cb7$var$flow(src);
        }
    };
}
$64427adeabe25cb7$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $64427adeabe25cb7$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$64427adeabe25cb7$var$Readable.prototype.on = function(ev, fn) {
    var res = $gEcii.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $f6uEY.nextTick($64427adeabe25cb7$var$nReadingNextTick, this);
            else if (state.length) $64427adeabe25cb7$var$emitReadable(this);
        }
    }
    return res;
};
$64427adeabe25cb7$var$Readable.prototype.addListener = $64427adeabe25cb7$var$Readable.prototype.on;
function $64427adeabe25cb7$var$nReadingNextTick(self1) {
    $64427adeabe25cb7$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$64427adeabe25cb7$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $64427adeabe25cb7$var$debug('resume');
        state.flowing = true;
        $64427adeabe25cb7$var$resume(this, state);
    }
    return this;
};
function $64427adeabe25cb7$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $f6uEY.nextTick($64427adeabe25cb7$var$resume_, stream, state);
    }
}
function $64427adeabe25cb7$var$resume_(stream, state) {
    if (!state.reading) {
        $64427adeabe25cb7$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $64427adeabe25cb7$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$64427adeabe25cb7$var$Readable.prototype.pause = function() {
    $64427adeabe25cb7$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $64427adeabe25cb7$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $64427adeabe25cb7$var$flow(stream) {
    var state = stream._readableState;
    $64427adeabe25cb7$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$64427adeabe25cb7$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $64427adeabe25cb7$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $64427adeabe25cb7$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $64427adeabe25cb7$var$kProxyEvents.length; n++)stream.on($64427adeabe25cb7$var$kProxyEvents[n], this.emit.bind(this, $64427adeabe25cb7$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $64427adeabe25cb7$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($64427adeabe25cb7$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$64427adeabe25cb7$var$Readable._fromList = $64427adeabe25cb7$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $64427adeabe25cb7$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $64427adeabe25cb7$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $64427adeabe25cb7$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $64427adeabe25cb7$var$copyFromBufferString(n, list) : $64427adeabe25cb7$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $64427adeabe25cb7$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $64427adeabe25cb7$var$copyFromBuffer(n, list) {
    var ret = $64427adeabe25cb7$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $64427adeabe25cb7$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $f6uEY.nextTick($64427adeabe25cb7$var$endReadableNT, state, stream);
    }
}
function $64427adeabe25cb7$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $64427adeabe25cb7$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("fjujn", function(module, exports) {
var $b260249727107b21$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $b260249727107b21$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("gEcii", function(module, exports) {

module.exports = (parcelRequire("lAGdN")).EventEmitter;

});

parcelRegister("ituKa", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $2zYso = parcelRequire("2zYso");
var $d732c87bb2d69da9$var$Buffer = $2zYso.Buffer;
// alternative to using Object.keys for old browsers
function $d732c87bb2d69da9$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($d732c87bb2d69da9$var$Buffer.from && $d732c87bb2d69da9$var$Buffer.alloc && $d732c87bb2d69da9$var$Buffer.allocUnsafe && $d732c87bb2d69da9$var$Buffer.allocUnsafeSlow) module.exports = $2zYso;
else {
    // Copy properties from require('buffer')
    $d732c87bb2d69da9$var$copyProps($2zYso, module.exports);
    module.exports.Buffer = $d732c87bb2d69da9$var$SafeBuffer;
}
function $d732c87bb2d69da9$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $d732c87bb2d69da9$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$d732c87bb2d69da9$var$copyProps($d732c87bb2d69da9$var$Buffer, $d732c87bb2d69da9$var$SafeBuffer);
$d732c87bb2d69da9$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $d732c87bb2d69da9$var$Buffer(arg, encodingOrOffset, length);
};
$d732c87bb2d69da9$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $d732c87bb2d69da9$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$d732c87bb2d69da9$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $d732c87bb2d69da9$var$Buffer(size);
};
$d732c87bb2d69da9$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $2zYso.SlowBuffer(size);
};

});

parcelRegister("j5pAJ", function(module, exports) {
'use strict';
function $de5255e5051966c3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $ituKa = parcelRequire("ituKa");
var $de5255e5051966c3$require$Buffer = $ituKa.Buffer;

var $a5Qi3 = parcelRequire("a5Qi3");
function $de5255e5051966c3$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $de5255e5051966c3$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $de5255e5051966c3$require$Buffer.alloc(0);
        var ret = $de5255e5051966c3$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $de5255e5051966c3$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($a5Qi3 && $a5Qi3.inspect && $a5Qi3.inspect.custom) module.exports.prototype[$a5Qi3.inspect.custom] = function() {
    var obj = $a5Qi3.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("jeSiA", function(module, exports) {
'use strict';

var $f6uEY = parcelRequire("f6uEY");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $e01971bba354d1ee$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $f6uEY.nextTick($e01971bba354d1ee$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $f6uEY.nextTick($e01971bba354d1ee$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $f6uEY.nextTick($e01971bba354d1ee$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $f6uEY.nextTick($e01971bba354d1ee$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $e01971bba354d1ee$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $e01971bba354d1ee$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $e01971bba354d1ee$var$destroy,
    undestroy: $e01971bba354d1ee$var$undestroy
};

});

parcelRegister("1IQxn", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $f6uEY = parcelRequire("f6uEY");
/*</replacement>*/ /*<replacement>*/ var $1412a7568c82633a$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $1412a7568c82633a$var$Duplex;

/*<replacement>*/ var $1412a7568c82633a$var$util = Object.create((parcelRequire("EeTfc")));

$1412a7568c82633a$var$util.inherits = (parcelRequire("lubO4"));

var $8BG9M = parcelRequire("8BG9M");

var $gvOeT = parcelRequire("gvOeT");
$1412a7568c82633a$var$util.inherits($1412a7568c82633a$var$Duplex, $8BG9M);
// avoid scope creep, the keys array can then be collected
var $1412a7568c82633a$var$keys = $1412a7568c82633a$var$objectKeys($gvOeT.prototype);
for(var $1412a7568c82633a$var$v = 0; $1412a7568c82633a$var$v < $1412a7568c82633a$var$keys.length; $1412a7568c82633a$var$v++){
    var $1412a7568c82633a$var$method = $1412a7568c82633a$var$keys[$1412a7568c82633a$var$v];
    if (!$1412a7568c82633a$var$Duplex.prototype[$1412a7568c82633a$var$method]) $1412a7568c82633a$var$Duplex.prototype[$1412a7568c82633a$var$method] = $gvOeT.prototype[$1412a7568c82633a$var$method];
}
function $1412a7568c82633a$var$Duplex(options) {
    if (!(this instanceof $1412a7568c82633a$var$Duplex)) return new $1412a7568c82633a$var$Duplex(options);
    $8BG9M.call(this, options);
    $gvOeT.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $1412a7568c82633a$var$onend);
}
Object.defineProperty($1412a7568c82633a$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $1412a7568c82633a$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $f6uEY.nextTick($1412a7568c82633a$var$onEndNT, this);
}
function $1412a7568c82633a$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($1412a7568c82633a$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$1412a7568c82633a$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $f6uEY.nextTick(cb, err);
};

});
parcelRegister("gvOeT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $f6uEY = parcelRequire("f6uEY");
/*</replacement>*/ module.exports = $c056830b01e82ec2$var$Writable;
/* <replacement> */ function $c056830b01e82ec2$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $c056830b01e82ec2$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $c056830b01e82ec2$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $c056830b01e82ec2$var$asyncWrite = (0, $f6uEY.nextTick);
/*</replacement>*/ /*<replacement>*/ var $c056830b01e82ec2$var$Duplex;
/*</replacement>*/ $c056830b01e82ec2$var$Writable.WritableState = $c056830b01e82ec2$var$WritableState;

/*<replacement>*/ var $c056830b01e82ec2$var$util = Object.create((parcelRequire("EeTfc")));

$c056830b01e82ec2$var$util.inherits = (parcelRequire("lubO4"));

/*</replacement>*/ /*<replacement>*/ var $c056830b01e82ec2$var$internalUtil = {
    deprecate: (parcelRequire("hs4ab"))
};

var $gEcii = parcelRequire("gEcii");

var $ituKa = parcelRequire("ituKa");
var $c056830b01e82ec2$require$Buffer = $ituKa.Buffer;
var $c056830b01e82ec2$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $c056830b01e82ec2$var$_uint8ArrayToBuffer(chunk) {
    return $c056830b01e82ec2$require$Buffer.from(chunk);
}
function $c056830b01e82ec2$var$_isUint8Array(obj) {
    return $c056830b01e82ec2$require$Buffer.isBuffer(obj) || obj instanceof $c056830b01e82ec2$var$OurUint8Array;
}

var $jeSiA = parcelRequire("jeSiA");
$c056830b01e82ec2$var$util.inherits($c056830b01e82ec2$var$Writable, $gEcii);
function $c056830b01e82ec2$var$nop() {}

function $c056830b01e82ec2$var$WritableState(options, stream) {
    $c056830b01e82ec2$var$Duplex = $c056830b01e82ec2$var$Duplex || (parcelRequire("1IQxn"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $c056830b01e82ec2$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $c056830b01e82ec2$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $c056830b01e82ec2$var$CorkedRequest(this);
}
$c056830b01e82ec2$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($c056830b01e82ec2$var$WritableState.prototype, 'buffer', {
            get: $c056830b01e82ec2$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $c056830b01e82ec2$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $c056830b01e82ec2$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($c056830b01e82ec2$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($c056830b01e82ec2$var$realHasInstance.call(this, object)) return true;
            if (this !== $c056830b01e82ec2$var$Writable) return false;
            return object && object._writableState instanceof $c056830b01e82ec2$var$WritableState;
        }
    });
} else $c056830b01e82ec2$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $c056830b01e82ec2$var$Writable(options) {
    $c056830b01e82ec2$var$Duplex = $c056830b01e82ec2$var$Duplex || (parcelRequire("1IQxn"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$c056830b01e82ec2$var$realHasInstance.call($c056830b01e82ec2$var$Writable, this) && !(this instanceof $c056830b01e82ec2$var$Duplex)) return new $c056830b01e82ec2$var$Writable(options);
    this._writableState = new $c056830b01e82ec2$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $gEcii.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$c056830b01e82ec2$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $c056830b01e82ec2$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $f6uEY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $c056830b01e82ec2$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $f6uEY.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$c056830b01e82ec2$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $c056830b01e82ec2$var$_isUint8Array(chunk);
    if (isBuf && !$c056830b01e82ec2$require$Buffer.isBuffer(chunk)) chunk = $c056830b01e82ec2$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $c056830b01e82ec2$var$nop;
    if (state.ended) $c056830b01e82ec2$var$writeAfterEnd(this, cb);
    else if (isBuf || $c056830b01e82ec2$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $c056830b01e82ec2$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$c056830b01e82ec2$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$c056830b01e82ec2$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $c056830b01e82ec2$var$clearBuffer(this, state);
    }
};
$c056830b01e82ec2$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $c056830b01e82ec2$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $c056830b01e82ec2$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($c056830b01e82ec2$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $c056830b01e82ec2$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $c056830b01e82ec2$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $c056830b01e82ec2$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $c056830b01e82ec2$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $c056830b01e82ec2$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $f6uEY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $f6uEY.nextTick($c056830b01e82ec2$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $c056830b01e82ec2$var$finishMaybe(stream, state);
    }
}
function $c056830b01e82ec2$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $c056830b01e82ec2$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $c056830b01e82ec2$var$onwriteStateUpdate(state);
    if (er) $c056830b01e82ec2$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $c056830b01e82ec2$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $c056830b01e82ec2$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $c056830b01e82ec2$var$asyncWrite($c056830b01e82ec2$var$afterWrite, stream, state, finished, cb);
        else $c056830b01e82ec2$var$afterWrite(stream, state, finished, cb);
    }
}
function $c056830b01e82ec2$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $c056830b01e82ec2$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $c056830b01e82ec2$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $c056830b01e82ec2$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $c056830b01e82ec2$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $c056830b01e82ec2$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $c056830b01e82ec2$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $c056830b01e82ec2$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$c056830b01e82ec2$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$c056830b01e82ec2$var$Writable.prototype._writev = null;
$c056830b01e82ec2$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $c056830b01e82ec2$var$endWritable(this, state, cb);
};
function $c056830b01e82ec2$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $c056830b01e82ec2$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $c056830b01e82ec2$var$finishMaybe(stream, state);
    });
}
function $c056830b01e82ec2$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $f6uEY.nextTick($c056830b01e82ec2$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $c056830b01e82ec2$var$finishMaybe(stream, state) {
    var need = $c056830b01e82ec2$var$needFinish(state);
    if (need) {
        $c056830b01e82ec2$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $c056830b01e82ec2$var$endWritable(stream, state, cb) {
    state.ending = true;
    $c056830b01e82ec2$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $f6uEY.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $c056830b01e82ec2$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($c056830b01e82ec2$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$c056830b01e82ec2$var$Writable.prototype.destroy = $jeSiA.destroy;
$c056830b01e82ec2$var$Writable.prototype._undestroy = $jeSiA.undestroy;
$c056830b01e82ec2$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("dtPrV", function(module, exports) {
$parcel$export(module.exports, "StringDecoder", () => $9d05e492bafd8156$export$63a7aa211a91ed69, (v) => $9d05e492bafd8156$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $9d05e492bafd8156$export$63a7aa211a91ed69;
'use strict';

var $ctsuq = parcelRequire("ctsuq");
var $9d05e492bafd8156$require$Buffer = $ctsuq.Buffer;
/*</replacement>*/ var $9d05e492bafd8156$var$isEncoding = $9d05e492bafd8156$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $9d05e492bafd8156$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $9d05e492bafd8156$var$normalizeEncoding(enc) {
    var nenc = $9d05e492bafd8156$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($9d05e492bafd8156$require$Buffer.isEncoding === $9d05e492bafd8156$var$isEncoding || !$9d05e492bafd8156$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$9d05e492bafd8156$export$63a7aa211a91ed69 = $9d05e492bafd8156$var$StringDecoder;
function $9d05e492bafd8156$var$StringDecoder(encoding) {
    this.encoding = $9d05e492bafd8156$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $9d05e492bafd8156$var$utf16Text;
            this.end = $9d05e492bafd8156$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $9d05e492bafd8156$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $9d05e492bafd8156$var$base64Text;
            this.end = $9d05e492bafd8156$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $9d05e492bafd8156$var$simpleWrite;
            this.end = $9d05e492bafd8156$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $9d05e492bafd8156$require$Buffer.allocUnsafe(nb);
}
$9d05e492bafd8156$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$9d05e492bafd8156$var$StringDecoder.prototype.end = $9d05e492bafd8156$var$utf8End;
// Returns only complete characters in a Buffer
$9d05e492bafd8156$var$StringDecoder.prototype.text = $9d05e492bafd8156$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$9d05e492bafd8156$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $9d05e492bafd8156$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $9d05e492bafd8156$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $9d05e492bafd8156$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $9d05e492bafd8156$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $9d05e492bafd8156$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $9d05e492bafd8156$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $9d05e492bafd8156$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $9d05e492bafd8156$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $9d05e492bafd8156$var$utf8Text(buf, i) {
    var total = $9d05e492bafd8156$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $9d05e492bafd8156$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $9d05e492bafd8156$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $9d05e492bafd8156$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $9d05e492bafd8156$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $9d05e492bafd8156$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $9d05e492bafd8156$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $9d05e492bafd8156$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("ctsuq", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $2zYso = parcelRequire("2zYso");
var $914e4af5fd97dfc1$var$Buffer = $2zYso.Buffer;
// alternative to using Object.keys for old browsers
function $914e4af5fd97dfc1$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($914e4af5fd97dfc1$var$Buffer.from && $914e4af5fd97dfc1$var$Buffer.alloc && $914e4af5fd97dfc1$var$Buffer.allocUnsafe && $914e4af5fd97dfc1$var$Buffer.allocUnsafeSlow) module.exports = $2zYso;
else {
    // Copy properties from require('buffer')
    $914e4af5fd97dfc1$var$copyProps($2zYso, module.exports);
    module.exports.Buffer = $914e4af5fd97dfc1$var$SafeBuffer;
}
function $914e4af5fd97dfc1$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $914e4af5fd97dfc1$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$914e4af5fd97dfc1$var$copyProps($914e4af5fd97dfc1$var$Buffer, $914e4af5fd97dfc1$var$SafeBuffer);
$914e4af5fd97dfc1$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $914e4af5fd97dfc1$var$Buffer(arg, encodingOrOffset, length);
};
$914e4af5fd97dfc1$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $914e4af5fd97dfc1$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$914e4af5fd97dfc1$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $914e4af5fd97dfc1$var$Buffer(size);
};
$914e4af5fd97dfc1$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $2zYso.SlowBuffer(size);
};

});



parcelRegister("70ih1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $5196b53d87503797$var$Transform;

var $1IQxn = parcelRequire("1IQxn");

/*<replacement>*/ var $5196b53d87503797$var$util = Object.create((parcelRequire("EeTfc")));

$5196b53d87503797$var$util.inherits = (parcelRequire("lubO4"));
/*</replacement>*/ $5196b53d87503797$var$util.inherits($5196b53d87503797$var$Transform, $1IQxn);
function $5196b53d87503797$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $5196b53d87503797$var$Transform(options) {
    if (!(this instanceof $5196b53d87503797$var$Transform)) return new $5196b53d87503797$var$Transform(options);
    $1IQxn.call(this, options);
    this._transformState = {
        afterTransform: $5196b53d87503797$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $5196b53d87503797$var$prefinish);
}
function $5196b53d87503797$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $5196b53d87503797$var$done(_this, er, data);
    });
    else $5196b53d87503797$var$done(this, null, null);
}
$5196b53d87503797$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $1IQxn.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$5196b53d87503797$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$5196b53d87503797$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$5196b53d87503797$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$5196b53d87503797$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $1IQxn.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $5196b53d87503797$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("8S1FO", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $6754aa32df103e5e$var$PassThrough;

var $70ih1 = parcelRequire("70ih1");

/*<replacement>*/ var $6754aa32df103e5e$var$util = Object.create((parcelRequire("EeTfc")));

$6754aa32df103e5e$var$util.inherits = (parcelRequire("lubO4"));
/*</replacement>*/ $6754aa32df103e5e$var$util.inherits($6754aa32df103e5e$var$PassThrough, $70ih1);
function $6754aa32df103e5e$var$PassThrough(options) {
    if (!(this instanceof $6754aa32df103e5e$var$PassThrough)) return new $6754aa32df103e5e$var$PassThrough(options);
    $70ih1.call(this, options);
}
$6754aa32df103e5e$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("dj5fD", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("a5Qi3")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("de1aF", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("7g6O5", function(module, exports) {
'use strict';
var $548f4ebfacad83ff$var$utils = module.exports;

var $6MZ4r = parcelRequire("6MZ4r");

var $bYAD2 = parcelRequire("bYAD2");

var $7InN7 = parcelRequire("7InN7");
$548f4ebfacad83ff$var$utils.assert = $bYAD2;
$548f4ebfacad83ff$var$utils.toArray = $7InN7.toArray;
$548f4ebfacad83ff$var$utils.zero2 = $7InN7.zero2;
$548f4ebfacad83ff$var$utils.toHex = $7InN7.toHex;
$548f4ebfacad83ff$var$utils.encode = $7InN7.encode;
// Represent num in a w-NAF form
function $548f4ebfacad83ff$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$548f4ebfacad83ff$var$utils.getNAF = $548f4ebfacad83ff$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $548f4ebfacad83ff$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$548f4ebfacad83ff$var$utils.getJSF = $548f4ebfacad83ff$var$getJSF;
function $548f4ebfacad83ff$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$548f4ebfacad83ff$var$utils.cachedProperty = $548f4ebfacad83ff$var$cachedProperty;
function $548f4ebfacad83ff$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $548f4ebfacad83ff$var$utils.toArray(bytes, 'hex') : bytes;
}
$548f4ebfacad83ff$var$utils.parseBytes = $548f4ebfacad83ff$var$parseBytes;
function $548f4ebfacad83ff$var$intFromLE(bytes) {
    return new $6MZ4r(bytes, 'hex', 'le');
}
$548f4ebfacad83ff$var$utils.intFromLE = $548f4ebfacad83ff$var$intFromLE;

});
parcelRegister("7InN7", function(module, exports) {
'use strict';
var $59df18e4c33d2f19$var$utils = module.exports;
function $59df18e4c33d2f19$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$59df18e4c33d2f19$var$utils.toArray = $59df18e4c33d2f19$var$toArray;
function $59df18e4c33d2f19$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$59df18e4c33d2f19$var$utils.zero2 = $59df18e4c33d2f19$var$zero2;
function $59df18e4c33d2f19$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $59df18e4c33d2f19$var$zero2(msg[i].toString(16));
    return res;
}
$59df18e4c33d2f19$var$utils.toHex = $59df18e4c33d2f19$var$toHex;
$59df18e4c33d2f19$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $59df18e4c33d2f19$var$toHex(arr);
    else return arr;
};

});


parcelRegister("6QOtF", function(module, exports) {
'use strict';
var $4fcec1348310ea75$var$curve = module.exports;

$4fcec1348310ea75$var$curve.base = (parcelRequire("hPcgI"));

$4fcec1348310ea75$var$curve.short = (parcelRequire("bHzSX"));

$4fcec1348310ea75$var$curve.mont = (parcelRequire("ebfL4"));

$4fcec1348310ea75$var$curve.edwards = (parcelRequire("7i87R"));

});
parcelRegister("hPcgI", function(module, exports) {
'use strict';

var $6MZ4r = parcelRequire("6MZ4r");

var $7g6O5 = parcelRequire("7g6O5");
var $03594d47d21958cc$var$getNAF = $7g6O5.getNAF;
var $03594d47d21958cc$var$getJSF = $7g6O5.getJSF;
var $03594d47d21958cc$var$assert = $7g6O5.assert;
function $03594d47d21958cc$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $6MZ4r(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $6MZ4r.red(conf.prime) : $6MZ4r.mont(this.p);
    // Useful for many curves
    this.zero = new $6MZ4r(0).toRed(this.red);
    this.one = new $6MZ4r(1).toRed(this.red);
    this.two = new $6MZ4r(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $6MZ4r(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $03594d47d21958cc$var$BaseCurve;
$03594d47d21958cc$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$03594d47d21958cc$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$03594d47d21958cc$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $03594d47d21958cc$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $03594d47d21958cc$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$03594d47d21958cc$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $03594d47d21958cc$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $03594d47d21958cc$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$03594d47d21958cc$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $03594d47d21958cc$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $03594d47d21958cc$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $03594d47d21958cc$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $03594d47d21958cc$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$03594d47d21958cc$var$BaseCurve.BasePoint = $03594d47d21958cc$var$BasePoint;
$03594d47d21958cc$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$03594d47d21958cc$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$03594d47d21958cc$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $7g6O5.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $03594d47d21958cc$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $03594d47d21958cc$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$03594d47d21958cc$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$03594d47d21958cc$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$03594d47d21958cc$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $7g6O5.encode(this._encode(compact), enc);
};
$03594d47d21958cc$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$03594d47d21958cc$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$03594d47d21958cc$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$03594d47d21958cc$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$03594d47d21958cc$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$03594d47d21958cc$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("bHzSX", function(module, exports) {
'use strict';

var $7g6O5 = parcelRequire("7g6O5");

var $6MZ4r = parcelRequire("6MZ4r");

var $lubO4 = parcelRequire("lubO4");

var $hPcgI = parcelRequire("hPcgI");
var $884f8bf5b65773b5$var$assert = $7g6O5.assert;
function $884f8bf5b65773b5$var$ShortCurve(conf) {
    $hPcgI.call(this, 'short', conf);
    this.a = new $6MZ4r(conf.a, 16).toRed(this.red);
    this.b = new $6MZ4r(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$lubO4($884f8bf5b65773b5$var$ShortCurve, $hPcgI);
module.exports = $884f8bf5b65773b5$var$ShortCurve;
$884f8bf5b65773b5$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $6MZ4r(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $6MZ4r(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $884f8bf5b65773b5$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $6MZ4r(vec.a, 16),
            b: new $6MZ4r(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$884f8bf5b65773b5$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $6MZ4r.mont(num);
    var tinv = new $6MZ4r(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $6MZ4r(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$884f8bf5b65773b5$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $6MZ4r(1);
    var y1 = new $6MZ4r(0);
    var x2 = new $6MZ4r(0);
    var y2 = new $6MZ4r(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$884f8bf5b65773b5$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$884f8bf5b65773b5$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $6MZ4r(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$884f8bf5b65773b5$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$884f8bf5b65773b5$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $884f8bf5b65773b5$var$Point(curve, x, y, isRed) {
    $hPcgI.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $6MZ4r(x, 16);
        this.y = new $6MZ4r(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$lubO4($884f8bf5b65773b5$var$Point, $hPcgI.BasePoint);
$884f8bf5b65773b5$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $884f8bf5b65773b5$var$Point(this, x, y, isRed);
};
$884f8bf5b65773b5$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $884f8bf5b65773b5$var$Point.fromJSON(this, obj, red);
};
$884f8bf5b65773b5$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$884f8bf5b65773b5$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$884f8bf5b65773b5$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$884f8bf5b65773b5$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$884f8bf5b65773b5$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$884f8bf5b65773b5$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$884f8bf5b65773b5$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$884f8bf5b65773b5$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$884f8bf5b65773b5$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$884f8bf5b65773b5$var$Point.prototype.mul = function mul(k) {
    k = new $6MZ4r(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$884f8bf5b65773b5$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$884f8bf5b65773b5$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$884f8bf5b65773b5$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$884f8bf5b65773b5$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$884f8bf5b65773b5$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $884f8bf5b65773b5$var$JPoint(curve, x, y, z) {
    $hPcgI.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $6MZ4r(0);
    } else {
        this.x = new $6MZ4r(x, 16);
        this.y = new $6MZ4r(y, 16);
        this.z = new $6MZ4r(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$lubO4($884f8bf5b65773b5$var$JPoint, $hPcgI.BasePoint);
$884f8bf5b65773b5$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $884f8bf5b65773b5$var$JPoint(this, x, y, z);
};
$884f8bf5b65773b5$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$884f8bf5b65773b5$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$884f8bf5b65773b5$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$884f8bf5b65773b5$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$884f8bf5b65773b5$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$884f8bf5b65773b5$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$884f8bf5b65773b5$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$884f8bf5b65773b5$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$884f8bf5b65773b5$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$884f8bf5b65773b5$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$884f8bf5b65773b5$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $6MZ4r(k, kbase);
    return this.curve._wnafMul(this, k);
};
$884f8bf5b65773b5$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$884f8bf5b65773b5$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$884f8bf5b65773b5$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$884f8bf5b65773b5$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("ebfL4", function(module, exports) {
'use strict';

var $6MZ4r = parcelRequire("6MZ4r");

var $lubO4 = parcelRequire("lubO4");

var $hPcgI = parcelRequire("hPcgI");

var $7g6O5 = parcelRequire("7g6O5");
function $a52e5107ad3d43a2$var$MontCurve(conf) {
    $hPcgI.call(this, 'mont', conf);
    this.a = new $6MZ4r(conf.a, 16).toRed(this.red);
    this.b = new $6MZ4r(conf.b, 16).toRed(this.red);
    this.i4 = new $6MZ4r(4).toRed(this.red).redInvm();
    this.two = new $6MZ4r(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$lubO4($a52e5107ad3d43a2$var$MontCurve, $hPcgI);
module.exports = $a52e5107ad3d43a2$var$MontCurve;
$a52e5107ad3d43a2$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $a52e5107ad3d43a2$var$Point(curve, x, z) {
    $hPcgI.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $6MZ4r(x, 16);
        this.z = new $6MZ4r(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$lubO4($a52e5107ad3d43a2$var$Point, $hPcgI.BasePoint);
$a52e5107ad3d43a2$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($7g6O5.toArray(bytes, enc), 1);
};
$a52e5107ad3d43a2$var$MontCurve.prototype.point = function point(x, z) {
    return new $a52e5107ad3d43a2$var$Point(this, x, z);
};
$a52e5107ad3d43a2$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $a52e5107ad3d43a2$var$Point.fromJSON(this, obj);
};
$a52e5107ad3d43a2$var$Point.prototype.precompute = function precompute() {
// No-op
};
$a52e5107ad3d43a2$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$a52e5107ad3d43a2$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $a52e5107ad3d43a2$var$Point(curve, obj[0], obj[1] || curve.one);
};
$a52e5107ad3d43a2$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$a52e5107ad3d43a2$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$a52e5107ad3d43a2$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$a52e5107ad3d43a2$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$a52e5107ad3d43a2$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$a52e5107ad3d43a2$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$a52e5107ad3d43a2$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$a52e5107ad3d43a2$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$a52e5107ad3d43a2$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$a52e5107ad3d43a2$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$a52e5107ad3d43a2$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("7i87R", function(module, exports) {
'use strict';

var $7g6O5 = parcelRequire("7g6O5");

var $6MZ4r = parcelRequire("6MZ4r");

var $lubO4 = parcelRequire("lubO4");

var $hPcgI = parcelRequire("hPcgI");
var $54f0846f795c3ba2$var$assert = $7g6O5.assert;
function $54f0846f795c3ba2$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $hPcgI.call(this, 'edwards', conf);
    this.a = new $6MZ4r(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $6MZ4r(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $6MZ4r(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $54f0846f795c3ba2$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$lubO4($54f0846f795c3ba2$var$EdwardsCurve, $hPcgI);
module.exports = $54f0846f795c3ba2$var$EdwardsCurve;
$54f0846f795c3ba2$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$54f0846f795c3ba2$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$54f0846f795c3ba2$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$54f0846f795c3ba2$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $6MZ4r(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$54f0846f795c3ba2$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $6MZ4r(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$54f0846f795c3ba2$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $54f0846f795c3ba2$var$Point(curve, x, y, z, t) {
    $hPcgI.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $6MZ4r(x, 16);
        this.y = new $6MZ4r(y, 16);
        this.z = z ? new $6MZ4r(z, 16) : this.curve.one;
        this.t = t && new $6MZ4r(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$lubO4($54f0846f795c3ba2$var$Point, $hPcgI.BasePoint);
$54f0846f795c3ba2$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $54f0846f795c3ba2$var$Point.fromJSON(this, obj);
};
$54f0846f795c3ba2$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $54f0846f795c3ba2$var$Point(this, x, y, z, t);
};
$54f0846f795c3ba2$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $54f0846f795c3ba2$var$Point(curve, obj[0], obj[1], obj[2]);
};
$54f0846f795c3ba2$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$54f0846f795c3ba2$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$54f0846f795c3ba2$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$54f0846f795c3ba2$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$54f0846f795c3ba2$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$54f0846f795c3ba2$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$54f0846f795c3ba2$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$54f0846f795c3ba2$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$54f0846f795c3ba2$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$54f0846f795c3ba2$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$54f0846f795c3ba2$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$54f0846f795c3ba2$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$54f0846f795c3ba2$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$54f0846f795c3ba2$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$54f0846f795c3ba2$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$54f0846f795c3ba2$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$54f0846f795c3ba2$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$54f0846f795c3ba2$var$Point.prototype.toP = $54f0846f795c3ba2$var$Point.prototype.normalize;
$54f0846f795c3ba2$var$Point.prototype.mixedAdd = $54f0846f795c3ba2$var$Point.prototype.add;

});


parcelRegister("f9IVx", function(module, exports) {
'use strict';
var $b08a8bdb97d61ec6$var$curves = module.exports;

var $6QFT4 = parcelRequire("6QFT4");

var $6QOtF = parcelRequire("6QOtF");

var $7g6O5 = parcelRequire("7g6O5");
var $b08a8bdb97d61ec6$var$assert = $7g6O5.assert;
function $b08a8bdb97d61ec6$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $6QOtF.short(options);
    else if (options.type === 'edwards') this.curve = new $6QOtF.edwards(options);
    else this.curve = new $6QOtF.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $b08a8bdb97d61ec6$var$assert(this.g.validate(), 'Invalid curve');
    $b08a8bdb97d61ec6$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$b08a8bdb97d61ec6$var$curves.PresetCurve = $b08a8bdb97d61ec6$var$PresetCurve;
function $b08a8bdb97d61ec6$var$defineCurve(name, options) {
    Object.defineProperty($b08a8bdb97d61ec6$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $b08a8bdb97d61ec6$var$PresetCurve(options);
            Object.defineProperty($b08a8bdb97d61ec6$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$b08a8bdb97d61ec6$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $6QFT4.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$b08a8bdb97d61ec6$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $6QFT4.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$b08a8bdb97d61ec6$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $6QFT4.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$b08a8bdb97d61ec6$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $6QFT4.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$b08a8bdb97d61ec6$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $6QFT4.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$b08a8bdb97d61ec6$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $6QFT4.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$b08a8bdb97d61ec6$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $6QFT4.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $b08a8bdb97d61ec6$var$pre;

try {
    $b08a8bdb97d61ec6$var$pre = (parcelRequire("ezd0G"));
} catch (e) {
    $b08a8bdb97d61ec6$var$pre = undefined;
}
$b08a8bdb97d61ec6$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $6QFT4.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $b08a8bdb97d61ec6$var$pre
    ]
});

});
parcelRegister("6QFT4", function(module, exports) {
var $4fc8175231627b7b$var$hash = module.exports;

$4fc8175231627b7b$var$hash.utils = (parcelRequire("92uAL"));

$4fc8175231627b7b$var$hash.common = (parcelRequire("g5Cvc"));

$4fc8175231627b7b$var$hash.sha = (parcelRequire("7MkUw"));

$4fc8175231627b7b$var$hash.ripemd = (parcelRequire("hvfHs"));

$4fc8175231627b7b$var$hash.hmac = (parcelRequire("lR3Pe"));
// Proxy hash functions to the main object
$4fc8175231627b7b$var$hash.sha1 = $4fc8175231627b7b$var$hash.sha.sha1;
$4fc8175231627b7b$var$hash.sha256 = $4fc8175231627b7b$var$hash.sha.sha256;
$4fc8175231627b7b$var$hash.sha224 = $4fc8175231627b7b$var$hash.sha.sha224;
$4fc8175231627b7b$var$hash.sha384 = $4fc8175231627b7b$var$hash.sha.sha384;
$4fc8175231627b7b$var$hash.sha512 = $4fc8175231627b7b$var$hash.sha.sha512;
$4fc8175231627b7b$var$hash.ripemd160 = $4fc8175231627b7b$var$hash.ripemd.ripemd160;

});
parcelRegister("92uAL", function(module, exports) {
$parcel$export(module.exports, "inherits", () => $694c07e40437b2a2$export$69f1b2dcda23c5f8, (v) => $694c07e40437b2a2$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $694c07e40437b2a2$export$45b10814cc054894, (v) => $694c07e40437b2a2$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $694c07e40437b2a2$export$7ea66e3774a60b67, (v) => $694c07e40437b2a2$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $694c07e40437b2a2$export$34a52f00f601f6f1, (v) => $694c07e40437b2a2$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $694c07e40437b2a2$export$812b0cbd5e8a72ab, (v) => $694c07e40437b2a2$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $694c07e40437b2a2$export$f24f9e11d63bb314, (v) => $694c07e40437b2a2$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $694c07e40437b2a2$export$b71357c7e07ca1f1, (v) => $694c07e40437b2a2$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $694c07e40437b2a2$export$2e58a4b541fdcbe8, (v) => $694c07e40437b2a2$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $694c07e40437b2a2$export$183b950bde9faab8, (v) => $694c07e40437b2a2$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $694c07e40437b2a2$export$4785c77169fea59e, (v) => $694c07e40437b2a2$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $694c07e40437b2a2$export$242a185dfcffac5b, (v) => $694c07e40437b2a2$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $694c07e40437b2a2$export$58c04ae0ae31877d, (v) => $694c07e40437b2a2$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $694c07e40437b2a2$export$d058ca695f8c6f11, (v) => $694c07e40437b2a2$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $694c07e40437b2a2$export$a1efd7fc3e986367, (v) => $694c07e40437b2a2$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $694c07e40437b2a2$export$bbfea4a2b5abaab4, (v) => $694c07e40437b2a2$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $694c07e40437b2a2$export$97ad4afc7de86152, (v) => $694c07e40437b2a2$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $694c07e40437b2a2$export$ce4673d9a79f6a4b, (v) => $694c07e40437b2a2$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $694c07e40437b2a2$export$786cc99fc6eedc0b, (v) => $694c07e40437b2a2$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $694c07e40437b2a2$export$45c59b9a1848dd0, (v) => $694c07e40437b2a2$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $694c07e40437b2a2$export$50d8f613e76d3034, (v) => $694c07e40437b2a2$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $694c07e40437b2a2$export$b8e83683c60ee162, (v) => $694c07e40437b2a2$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $694c07e40437b2a2$export$aeeb51790d1bcc4a, (v) => $694c07e40437b2a2$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $694c07e40437b2a2$export$bb7c616f719ad9c, (v) => $694c07e40437b2a2$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $694c07e40437b2a2$export$4d63290824f9d7df, (v) => $694c07e40437b2a2$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $694c07e40437b2a2$export$2f64ceb90ef28ea1, (v) => $694c07e40437b2a2$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $694c07e40437b2a2$export$8d2089d465f6d10d, (v) => $694c07e40437b2a2$export$8d2089d465f6d10d = v);
var $694c07e40437b2a2$export$69f1b2dcda23c5f8;
var $694c07e40437b2a2$export$45b10814cc054894;
var $694c07e40437b2a2$export$7ea66e3774a60b67;
var $694c07e40437b2a2$export$34a52f00f601f6f1;
var $694c07e40437b2a2$export$812b0cbd5e8a72ab;
var $694c07e40437b2a2$export$f24f9e11d63bb314;
var $694c07e40437b2a2$export$b71357c7e07ca1f1;
var $694c07e40437b2a2$export$2e58a4b541fdcbe8;
var $694c07e40437b2a2$export$183b950bde9faab8;
var $694c07e40437b2a2$export$4785c77169fea59e;
var $694c07e40437b2a2$export$242a185dfcffac5b;
var $694c07e40437b2a2$export$58c04ae0ae31877d;
var $694c07e40437b2a2$export$d058ca695f8c6f11;
var $694c07e40437b2a2$export$a1efd7fc3e986367;
var $694c07e40437b2a2$export$bbfea4a2b5abaab4;
var $694c07e40437b2a2$export$97ad4afc7de86152;
var $694c07e40437b2a2$export$ce4673d9a79f6a4b;
var $694c07e40437b2a2$export$786cc99fc6eedc0b;
var $694c07e40437b2a2$export$45c59b9a1848dd0;
var $694c07e40437b2a2$export$50d8f613e76d3034;
var $694c07e40437b2a2$export$b8e83683c60ee162;
var $694c07e40437b2a2$export$aeeb51790d1bcc4a;
var $694c07e40437b2a2$export$bb7c616f719ad9c;
var $694c07e40437b2a2$export$4d63290824f9d7df;
var $694c07e40437b2a2$export$2f64ceb90ef28ea1;
var $694c07e40437b2a2$export$8d2089d465f6d10d;
'use strict';

var $bYAD2 = parcelRequire("bYAD2");

var $lubO4 = parcelRequire("lubO4");
$694c07e40437b2a2$export$69f1b2dcda23c5f8 = $lubO4;
function $694c07e40437b2a2$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $694c07e40437b2a2$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($694c07e40437b2a2$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$694c07e40437b2a2$export$45b10814cc054894 = $694c07e40437b2a2$var$toArray;
function $694c07e40437b2a2$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $694c07e40437b2a2$var$zero2(msg[i].toString(16));
    return res;
}
$694c07e40437b2a2$export$7ea66e3774a60b67 = $694c07e40437b2a2$var$toHex;
function $694c07e40437b2a2$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$694c07e40437b2a2$export$34a52f00f601f6f1 = $694c07e40437b2a2$var$htonl;
function $694c07e40437b2a2$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $694c07e40437b2a2$var$htonl(w);
        res += $694c07e40437b2a2$var$zero8(w.toString(16));
    }
    return res;
}
$694c07e40437b2a2$export$812b0cbd5e8a72ab = $694c07e40437b2a2$var$toHex32;
function $694c07e40437b2a2$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$694c07e40437b2a2$export$f24f9e11d63bb314 = $694c07e40437b2a2$var$zero2;
function $694c07e40437b2a2$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$694c07e40437b2a2$export$b71357c7e07ca1f1 = $694c07e40437b2a2$var$zero8;
function $694c07e40437b2a2$var$join32(msg, start, end, endian) {
    var len = end - start;
    $bYAD2(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$694c07e40437b2a2$export$2e58a4b541fdcbe8 = $694c07e40437b2a2$var$join32;
function $694c07e40437b2a2$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$694c07e40437b2a2$export$183b950bde9faab8 = $694c07e40437b2a2$var$split32;
function $694c07e40437b2a2$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$694c07e40437b2a2$export$4785c77169fea59e = $694c07e40437b2a2$var$rotr32;
function $694c07e40437b2a2$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$694c07e40437b2a2$export$242a185dfcffac5b = $694c07e40437b2a2$var$rotl32;
function $694c07e40437b2a2$var$sum32(a, b) {
    return a + b >>> 0;
}
$694c07e40437b2a2$export$58c04ae0ae31877d = $694c07e40437b2a2$var$sum32;
function $694c07e40437b2a2$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$694c07e40437b2a2$export$d058ca695f8c6f11 = $694c07e40437b2a2$var$sum32_3;
function $694c07e40437b2a2$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$694c07e40437b2a2$export$a1efd7fc3e986367 = $694c07e40437b2a2$var$sum32_4;
function $694c07e40437b2a2$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$694c07e40437b2a2$export$bbfea4a2b5abaab4 = $694c07e40437b2a2$var$sum32_5;
function $694c07e40437b2a2$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$694c07e40437b2a2$export$97ad4afc7de86152 = $694c07e40437b2a2$var$sum64;
function $694c07e40437b2a2$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$694c07e40437b2a2$export$ce4673d9a79f6a4b = $694c07e40437b2a2$var$sum64_hi;
function $694c07e40437b2a2$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$694c07e40437b2a2$export$786cc99fc6eedc0b = $694c07e40437b2a2$var$sum64_lo;
function $694c07e40437b2a2$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$694c07e40437b2a2$export$45c59b9a1848dd0 = $694c07e40437b2a2$var$sum64_4_hi;
function $694c07e40437b2a2$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$694c07e40437b2a2$export$50d8f613e76d3034 = $694c07e40437b2a2$var$sum64_4_lo;
function $694c07e40437b2a2$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$694c07e40437b2a2$export$b8e83683c60ee162 = $694c07e40437b2a2$var$sum64_5_hi;
function $694c07e40437b2a2$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$694c07e40437b2a2$export$aeeb51790d1bcc4a = $694c07e40437b2a2$var$sum64_5_lo;
function $694c07e40437b2a2$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$694c07e40437b2a2$export$bb7c616f719ad9c = $694c07e40437b2a2$var$rotr64_hi;
function $694c07e40437b2a2$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$694c07e40437b2a2$export$4d63290824f9d7df = $694c07e40437b2a2$var$rotr64_lo;
function $694c07e40437b2a2$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$694c07e40437b2a2$export$2f64ceb90ef28ea1 = $694c07e40437b2a2$var$shr64_hi;
function $694c07e40437b2a2$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$694c07e40437b2a2$export$8d2089d465f6d10d = $694c07e40437b2a2$var$shr64_lo;

});

parcelRegister("g5Cvc", function(module, exports) {
$parcel$export(module.exports, "BlockHash", () => $bb6afab15361f6dd$export$8687658379b577e6, (v) => $bb6afab15361f6dd$export$8687658379b577e6 = v);
var $bb6afab15361f6dd$export$8687658379b577e6;
'use strict';

var $92uAL = parcelRequire("92uAL");

var $bYAD2 = parcelRequire("bYAD2");
function $bb6afab15361f6dd$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$bb6afab15361f6dd$export$8687658379b577e6 = $bb6afab15361f6dd$var$BlockHash;
$bb6afab15361f6dd$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $92uAL.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $92uAL.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$bb6afab15361f6dd$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $bYAD2(this.pending === null);
    return this._digest(enc);
};
$bb6afab15361f6dd$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("7MkUw", function(module, exports) {
$parcel$export(module.exports, "sha1", () => $5a9d3c8aab59e24f$export$5091bdda49ba90f5, (v) => $5a9d3c8aab59e24f$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $5a9d3c8aab59e24f$export$97b70509d4e397ea, (v) => $5a9d3c8aab59e24f$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $5a9d3c8aab59e24f$export$bced8d2aada2d1c9, (v) => $5a9d3c8aab59e24f$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $5a9d3c8aab59e24f$export$612d47d55dedde45, (v) => $5a9d3c8aab59e24f$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $5a9d3c8aab59e24f$export$a888d2532e6dc7bb, (v) => $5a9d3c8aab59e24f$export$a888d2532e6dc7bb = v);
var $5a9d3c8aab59e24f$export$5091bdda49ba90f5;
var $5a9d3c8aab59e24f$export$97b70509d4e397ea;
var $5a9d3c8aab59e24f$export$bced8d2aada2d1c9;
var $5a9d3c8aab59e24f$export$612d47d55dedde45;
var $5a9d3c8aab59e24f$export$a888d2532e6dc7bb;
'use strict';

$5a9d3c8aab59e24f$export$5091bdda49ba90f5 = (parcelRequire("erhqM"));

$5a9d3c8aab59e24f$export$97b70509d4e397ea = (parcelRequire("hyhOX"));

$5a9d3c8aab59e24f$export$bced8d2aada2d1c9 = (parcelRequire("jbWem"));

$5a9d3c8aab59e24f$export$612d47d55dedde45 = (parcelRequire("870yl"));

$5a9d3c8aab59e24f$export$a888d2532e6dc7bb = (parcelRequire("2nd7d"));

});
parcelRegister("erhqM", function(module, exports) {
'use strict';

var $92uAL = parcelRequire("92uAL");

var $g5Cvc = parcelRequire("g5Cvc");

var $59OQM = parcelRequire("59OQM");
var $a8311bb896639d0b$var$rotl32 = $92uAL.rotl32;
var $a8311bb896639d0b$var$sum32 = $92uAL.sum32;
var $a8311bb896639d0b$var$sum32_5 = $92uAL.sum32_5;
var $a8311bb896639d0b$var$ft_1 = $59OQM.ft_1;
var $a8311bb896639d0b$var$BlockHash = $g5Cvc.BlockHash;
var $a8311bb896639d0b$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $a8311bb896639d0b$var$SHA1() {
    if (!(this instanceof $a8311bb896639d0b$var$SHA1)) return new $a8311bb896639d0b$var$SHA1();
    $a8311bb896639d0b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$92uAL.inherits($a8311bb896639d0b$var$SHA1, $a8311bb896639d0b$var$BlockHash);
module.exports = $a8311bb896639d0b$var$SHA1;
$a8311bb896639d0b$var$SHA1.blockSize = 512;
$a8311bb896639d0b$var$SHA1.outSize = 160;
$a8311bb896639d0b$var$SHA1.hmacStrength = 80;
$a8311bb896639d0b$var$SHA1.padLength = 64;
$a8311bb896639d0b$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $a8311bb896639d0b$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $a8311bb896639d0b$var$sum32_5($a8311bb896639d0b$var$rotl32(a, 5), $a8311bb896639d0b$var$ft_1(s, b, c, d), e, W[i], $a8311bb896639d0b$var$sha1_K[s]);
        e = d;
        d = c;
        c = $a8311bb896639d0b$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $a8311bb896639d0b$var$sum32(this.h[0], a);
    this.h[1] = $a8311bb896639d0b$var$sum32(this.h[1], b);
    this.h[2] = $a8311bb896639d0b$var$sum32(this.h[2], c);
    this.h[3] = $a8311bb896639d0b$var$sum32(this.h[3], d);
    this.h[4] = $a8311bb896639d0b$var$sum32(this.h[4], e);
};
$a8311bb896639d0b$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $92uAL.toHex32(this.h, 'big');
    else return $92uAL.split32(this.h, 'big');
};

});
parcelRegister("59OQM", function(module, exports) {
$parcel$export(module.exports, "ft_1", () => $3c153cd16609b478$export$5a92649d7ddb9f63, (v) => $3c153cd16609b478$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $3c153cd16609b478$export$c6d0d020c3a6269, (v) => $3c153cd16609b478$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $3c153cd16609b478$export$eb90c27fca05f956, (v) => $3c153cd16609b478$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $3c153cd16609b478$export$14a4a98e063b1999, (v) => $3c153cd16609b478$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $3c153cd16609b478$export$d20cecfa1564c686, (v) => $3c153cd16609b478$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $3c153cd16609b478$export$44fd472a12fc6db, (v) => $3c153cd16609b478$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $3c153cd16609b478$export$1ed238bb6ea1dd47, (v) => $3c153cd16609b478$export$1ed238bb6ea1dd47 = v);
var $3c153cd16609b478$export$5a92649d7ddb9f63;
var $3c153cd16609b478$export$c6d0d020c3a6269;
var $3c153cd16609b478$export$eb90c27fca05f956;
var $3c153cd16609b478$export$cc992891a14496a1;
var $3c153cd16609b478$export$14a4a98e063b1999;
var $3c153cd16609b478$export$d20cecfa1564c686;
var $3c153cd16609b478$export$44fd472a12fc6db;
var $3c153cd16609b478$export$1ed238bb6ea1dd47;
'use strict';

var $92uAL = parcelRequire("92uAL");
var $3c153cd16609b478$var$rotr32 = $92uAL.rotr32;
function $3c153cd16609b478$var$ft_1(s, x, y, z) {
    if (s === 0) return $3c153cd16609b478$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $3c153cd16609b478$var$p32(x, y, z);
    if (s === 2) return $3c153cd16609b478$var$maj32(x, y, z);
}
$3c153cd16609b478$export$5a92649d7ddb9f63 = $3c153cd16609b478$var$ft_1;
function $3c153cd16609b478$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$3c153cd16609b478$export$c6d0d020c3a6269 = $3c153cd16609b478$var$ch32;
function $3c153cd16609b478$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$3c153cd16609b478$export$eb90c27fca05f956 = $3c153cd16609b478$var$maj32;
function $3c153cd16609b478$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$3c153cd16609b478$export$cc992891a14496a1 = $3c153cd16609b478$var$p32;
function $3c153cd16609b478$var$s0_256(x) {
    return $3c153cd16609b478$var$rotr32(x, 2) ^ $3c153cd16609b478$var$rotr32(x, 13) ^ $3c153cd16609b478$var$rotr32(x, 22);
}
$3c153cd16609b478$export$14a4a98e063b1999 = $3c153cd16609b478$var$s0_256;
function $3c153cd16609b478$var$s1_256(x) {
    return $3c153cd16609b478$var$rotr32(x, 6) ^ $3c153cd16609b478$var$rotr32(x, 11) ^ $3c153cd16609b478$var$rotr32(x, 25);
}
$3c153cd16609b478$export$d20cecfa1564c686 = $3c153cd16609b478$var$s1_256;
function $3c153cd16609b478$var$g0_256(x) {
    return $3c153cd16609b478$var$rotr32(x, 7) ^ $3c153cd16609b478$var$rotr32(x, 18) ^ x >>> 3;
}
$3c153cd16609b478$export$44fd472a12fc6db = $3c153cd16609b478$var$g0_256;
function $3c153cd16609b478$var$g1_256(x) {
    return $3c153cd16609b478$var$rotr32(x, 17) ^ $3c153cd16609b478$var$rotr32(x, 19) ^ x >>> 10;
}
$3c153cd16609b478$export$1ed238bb6ea1dd47 = $3c153cd16609b478$var$g1_256;

});


parcelRegister("hyhOX", function(module, exports) {
'use strict';

var $92uAL = parcelRequire("92uAL");

var $jbWem = parcelRequire("jbWem");
function $cc736f7d8f9cfa92$var$SHA224() {
    if (!(this instanceof $cc736f7d8f9cfa92$var$SHA224)) return new $cc736f7d8f9cfa92$var$SHA224();
    $jbWem.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$92uAL.inherits($cc736f7d8f9cfa92$var$SHA224, $jbWem);
module.exports = $cc736f7d8f9cfa92$var$SHA224;
$cc736f7d8f9cfa92$var$SHA224.blockSize = 512;
$cc736f7d8f9cfa92$var$SHA224.outSize = 224;
$cc736f7d8f9cfa92$var$SHA224.hmacStrength = 192;
$cc736f7d8f9cfa92$var$SHA224.padLength = 64;
$cc736f7d8f9cfa92$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $92uAL.toHex32(this.h.slice(0, 7), 'big');
    else return $92uAL.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("jbWem", function(module, exports) {
'use strict';

var $92uAL = parcelRequire("92uAL");

var $g5Cvc = parcelRequire("g5Cvc");

var $59OQM = parcelRequire("59OQM");

var $bYAD2 = parcelRequire("bYAD2");
var $df8c36cf27fce709$var$sum32 = $92uAL.sum32;
var $df8c36cf27fce709$var$sum32_4 = $92uAL.sum32_4;
var $df8c36cf27fce709$var$sum32_5 = $92uAL.sum32_5;
var $df8c36cf27fce709$var$ch32 = $59OQM.ch32;
var $df8c36cf27fce709$var$maj32 = $59OQM.maj32;
var $df8c36cf27fce709$var$s0_256 = $59OQM.s0_256;
var $df8c36cf27fce709$var$s1_256 = $59OQM.s1_256;
var $df8c36cf27fce709$var$g0_256 = $59OQM.g0_256;
var $df8c36cf27fce709$var$g1_256 = $59OQM.g1_256;
var $df8c36cf27fce709$var$BlockHash = $g5Cvc.BlockHash;
var $df8c36cf27fce709$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $df8c36cf27fce709$var$SHA256() {
    if (!(this instanceof $df8c36cf27fce709$var$SHA256)) return new $df8c36cf27fce709$var$SHA256();
    $df8c36cf27fce709$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $df8c36cf27fce709$var$sha256_K;
    this.W = new Array(64);
}
$92uAL.inherits($df8c36cf27fce709$var$SHA256, $df8c36cf27fce709$var$BlockHash);
module.exports = $df8c36cf27fce709$var$SHA256;
$df8c36cf27fce709$var$SHA256.blockSize = 512;
$df8c36cf27fce709$var$SHA256.outSize = 256;
$df8c36cf27fce709$var$SHA256.hmacStrength = 192;
$df8c36cf27fce709$var$SHA256.padLength = 64;
$df8c36cf27fce709$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $df8c36cf27fce709$var$sum32_4($df8c36cf27fce709$var$g1_256(W[i - 2]), W[i - 7], $df8c36cf27fce709$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $bYAD2(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $df8c36cf27fce709$var$sum32_5(h, $df8c36cf27fce709$var$s1_256(e), $df8c36cf27fce709$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $df8c36cf27fce709$var$sum32($df8c36cf27fce709$var$s0_256(a), $df8c36cf27fce709$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $df8c36cf27fce709$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $df8c36cf27fce709$var$sum32(T1, T2);
    }
    this.h[0] = $df8c36cf27fce709$var$sum32(this.h[0], a);
    this.h[1] = $df8c36cf27fce709$var$sum32(this.h[1], b);
    this.h[2] = $df8c36cf27fce709$var$sum32(this.h[2], c);
    this.h[3] = $df8c36cf27fce709$var$sum32(this.h[3], d);
    this.h[4] = $df8c36cf27fce709$var$sum32(this.h[4], e);
    this.h[5] = $df8c36cf27fce709$var$sum32(this.h[5], f);
    this.h[6] = $df8c36cf27fce709$var$sum32(this.h[6], g);
    this.h[7] = $df8c36cf27fce709$var$sum32(this.h[7], h);
};
$df8c36cf27fce709$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $92uAL.toHex32(this.h, 'big');
    else return $92uAL.split32(this.h, 'big');
};

});


parcelRegister("870yl", function(module, exports) {
'use strict';

var $92uAL = parcelRequire("92uAL");

var $2nd7d = parcelRequire("2nd7d");
function $5e7f67fc685bf23a$var$SHA384() {
    if (!(this instanceof $5e7f67fc685bf23a$var$SHA384)) return new $5e7f67fc685bf23a$var$SHA384();
    $2nd7d.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$92uAL.inherits($5e7f67fc685bf23a$var$SHA384, $2nd7d);
module.exports = $5e7f67fc685bf23a$var$SHA384;
$5e7f67fc685bf23a$var$SHA384.blockSize = 1024;
$5e7f67fc685bf23a$var$SHA384.outSize = 384;
$5e7f67fc685bf23a$var$SHA384.hmacStrength = 192;
$5e7f67fc685bf23a$var$SHA384.padLength = 128;
$5e7f67fc685bf23a$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $92uAL.toHex32(this.h.slice(0, 12), 'big');
    else return $92uAL.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("2nd7d", function(module, exports) {
'use strict';

var $92uAL = parcelRequire("92uAL");

var $g5Cvc = parcelRequire("g5Cvc");

var $bYAD2 = parcelRequire("bYAD2");
var $1ba7e731e1f83d00$var$rotr64_hi = $92uAL.rotr64_hi;
var $1ba7e731e1f83d00$var$rotr64_lo = $92uAL.rotr64_lo;
var $1ba7e731e1f83d00$var$shr64_hi = $92uAL.shr64_hi;
var $1ba7e731e1f83d00$var$shr64_lo = $92uAL.shr64_lo;
var $1ba7e731e1f83d00$var$sum64 = $92uAL.sum64;
var $1ba7e731e1f83d00$var$sum64_hi = $92uAL.sum64_hi;
var $1ba7e731e1f83d00$var$sum64_lo = $92uAL.sum64_lo;
var $1ba7e731e1f83d00$var$sum64_4_hi = $92uAL.sum64_4_hi;
var $1ba7e731e1f83d00$var$sum64_4_lo = $92uAL.sum64_4_lo;
var $1ba7e731e1f83d00$var$sum64_5_hi = $92uAL.sum64_5_hi;
var $1ba7e731e1f83d00$var$sum64_5_lo = $92uAL.sum64_5_lo;
var $1ba7e731e1f83d00$var$BlockHash = $g5Cvc.BlockHash;
var $1ba7e731e1f83d00$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $1ba7e731e1f83d00$var$SHA512() {
    if (!(this instanceof $1ba7e731e1f83d00$var$SHA512)) return new $1ba7e731e1f83d00$var$SHA512();
    $1ba7e731e1f83d00$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $1ba7e731e1f83d00$var$sha512_K;
    this.W = new Array(160);
}
$92uAL.inherits($1ba7e731e1f83d00$var$SHA512, $1ba7e731e1f83d00$var$BlockHash);
module.exports = $1ba7e731e1f83d00$var$SHA512;
$1ba7e731e1f83d00$var$SHA512.blockSize = 1024;
$1ba7e731e1f83d00$var$SHA512.outSize = 512;
$1ba7e731e1f83d00$var$SHA512.hmacStrength = 192;
$1ba7e731e1f83d00$var$SHA512.padLength = 128;
$1ba7e731e1f83d00$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $1ba7e731e1f83d00$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $1ba7e731e1f83d00$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $1ba7e731e1f83d00$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $1ba7e731e1f83d00$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $1ba7e731e1f83d00$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $1ba7e731e1f83d00$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$1ba7e731e1f83d00$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $bYAD2(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $1ba7e731e1f83d00$var$s1_512_hi(eh, el);
        var c1_lo = $1ba7e731e1f83d00$var$s1_512_lo(eh, el);
        var c2_hi = $1ba7e731e1f83d00$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $1ba7e731e1f83d00$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $1ba7e731e1f83d00$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $1ba7e731e1f83d00$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $1ba7e731e1f83d00$var$s0_512_hi(ah, al);
        c0_lo = $1ba7e731e1f83d00$var$s0_512_lo(ah, al);
        c1_hi = $1ba7e731e1f83d00$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $1ba7e731e1f83d00$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $1ba7e731e1f83d00$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $1ba7e731e1f83d00$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $1ba7e731e1f83d00$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $1ba7e731e1f83d00$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $1ba7e731e1f83d00$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $1ba7e731e1f83d00$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $1ba7e731e1f83d00$var$sum64(this.h, 0, ah, al);
    $1ba7e731e1f83d00$var$sum64(this.h, 2, bh, bl);
    $1ba7e731e1f83d00$var$sum64(this.h, 4, ch, cl);
    $1ba7e731e1f83d00$var$sum64(this.h, 6, dh, dl);
    $1ba7e731e1f83d00$var$sum64(this.h, 8, eh, el);
    $1ba7e731e1f83d00$var$sum64(this.h, 10, fh, fl);
    $1ba7e731e1f83d00$var$sum64(this.h, 12, gh, gl);
    $1ba7e731e1f83d00$var$sum64(this.h, 14, hh, hl);
};
$1ba7e731e1f83d00$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $92uAL.toHex32(this.h, 'big');
    else return $92uAL.split32(this.h, 'big');
};
function $1ba7e731e1f83d00$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $1ba7e731e1f83d00$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $1ba7e731e1f83d00$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $1ba7e731e1f83d00$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $1ba7e731e1f83d00$var$s0_512_hi(xh, xl) {
    var c0_hi = $1ba7e731e1f83d00$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $1ba7e731e1f83d00$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $1ba7e731e1f83d00$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $1ba7e731e1f83d00$var$s0_512_lo(xh, xl) {
    var c0_lo = $1ba7e731e1f83d00$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $1ba7e731e1f83d00$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $1ba7e731e1f83d00$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $1ba7e731e1f83d00$var$s1_512_hi(xh, xl) {
    var c0_hi = $1ba7e731e1f83d00$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $1ba7e731e1f83d00$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $1ba7e731e1f83d00$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $1ba7e731e1f83d00$var$s1_512_lo(xh, xl) {
    var c0_lo = $1ba7e731e1f83d00$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $1ba7e731e1f83d00$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $1ba7e731e1f83d00$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $1ba7e731e1f83d00$var$g0_512_hi(xh, xl) {
    var c0_hi = $1ba7e731e1f83d00$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $1ba7e731e1f83d00$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $1ba7e731e1f83d00$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $1ba7e731e1f83d00$var$g0_512_lo(xh, xl) {
    var c0_lo = $1ba7e731e1f83d00$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $1ba7e731e1f83d00$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $1ba7e731e1f83d00$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $1ba7e731e1f83d00$var$g1_512_hi(xh, xl) {
    var c0_hi = $1ba7e731e1f83d00$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $1ba7e731e1f83d00$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $1ba7e731e1f83d00$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $1ba7e731e1f83d00$var$g1_512_lo(xh, xl) {
    var c0_lo = $1ba7e731e1f83d00$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $1ba7e731e1f83d00$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $1ba7e731e1f83d00$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("hvfHs", function(module, exports) {
$parcel$export(module.exports, "ripemd160", () => $cbe1829df44975bf$export$d1cea0ee4e3f0d3e, (v) => $cbe1829df44975bf$export$d1cea0ee4e3f0d3e = v);
var $cbe1829df44975bf$export$d1cea0ee4e3f0d3e;
'use strict';

var $92uAL = parcelRequire("92uAL");

var $g5Cvc = parcelRequire("g5Cvc");
var $cbe1829df44975bf$var$rotl32 = $92uAL.rotl32;
var $cbe1829df44975bf$var$sum32 = $92uAL.sum32;
var $cbe1829df44975bf$var$sum32_3 = $92uAL.sum32_3;
var $cbe1829df44975bf$var$sum32_4 = $92uAL.sum32_4;
var $cbe1829df44975bf$var$BlockHash = $g5Cvc.BlockHash;
function $cbe1829df44975bf$var$RIPEMD160() {
    if (!(this instanceof $cbe1829df44975bf$var$RIPEMD160)) return new $cbe1829df44975bf$var$RIPEMD160();
    $cbe1829df44975bf$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$92uAL.inherits($cbe1829df44975bf$var$RIPEMD160, $cbe1829df44975bf$var$BlockHash);
$cbe1829df44975bf$export$d1cea0ee4e3f0d3e = $cbe1829df44975bf$var$RIPEMD160;
$cbe1829df44975bf$var$RIPEMD160.blockSize = 512;
$cbe1829df44975bf$var$RIPEMD160.outSize = 160;
$cbe1829df44975bf$var$RIPEMD160.hmacStrength = 192;
$cbe1829df44975bf$var$RIPEMD160.padLength = 64;
$cbe1829df44975bf$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $cbe1829df44975bf$var$sum32($cbe1829df44975bf$var$rotl32($cbe1829df44975bf$var$sum32_4(A, $cbe1829df44975bf$var$f(j, B, C, D), msg[$cbe1829df44975bf$var$r[j] + start], $cbe1829df44975bf$var$K(j)), $cbe1829df44975bf$var$s[j]), E);
        A = E;
        E = D;
        D = $cbe1829df44975bf$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $cbe1829df44975bf$var$sum32($cbe1829df44975bf$var$rotl32($cbe1829df44975bf$var$sum32_4(Ah, $cbe1829df44975bf$var$f(79 - j, Bh, Ch, Dh), msg[$cbe1829df44975bf$var$rh[j] + start], $cbe1829df44975bf$var$Kh(j)), $cbe1829df44975bf$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $cbe1829df44975bf$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $cbe1829df44975bf$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $cbe1829df44975bf$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $cbe1829df44975bf$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $cbe1829df44975bf$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $cbe1829df44975bf$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$cbe1829df44975bf$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $92uAL.toHex32(this.h, 'little');
    else return $92uAL.split32(this.h, 'little');
};
function $cbe1829df44975bf$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $cbe1829df44975bf$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $cbe1829df44975bf$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $cbe1829df44975bf$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $cbe1829df44975bf$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $cbe1829df44975bf$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $cbe1829df44975bf$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("lR3Pe", function(module, exports) {
'use strict';

var $92uAL = parcelRequire("92uAL");

var $bYAD2 = parcelRequire("bYAD2");
function $fe9183d099b52938$var$Hmac(hash, key, enc) {
    if (!(this instanceof $fe9183d099b52938$var$Hmac)) return new $fe9183d099b52938$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($92uAL.toArray(key, enc));
}
module.exports = $fe9183d099b52938$var$Hmac;
$fe9183d099b52938$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $bYAD2(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$fe9183d099b52938$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$fe9183d099b52938$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("ezd0G", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("blA89", function(module, exports) {
'use strict';

var $6MZ4r = parcelRequire("6MZ4r");

var $2X9Cm = parcelRequire("2X9Cm");

var $7g6O5 = parcelRequire("7g6O5");

var $f9IVx = parcelRequire("f9IVx");

var $4zkLw = parcelRequire("4zkLw");
var $842daea100de1b3d$var$assert = $7g6O5.assert;

var $biQ0o = parcelRequire("biQ0o");

var $9gRsA = parcelRequire("9gRsA");
function $842daea100de1b3d$var$EC(options) {
    if (!(this instanceof $842daea100de1b3d$var$EC)) return new $842daea100de1b3d$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $842daea100de1b3d$var$assert(Object.prototype.hasOwnProperty.call($f9IVx, options), 'Unknown curve ' + options);
        options = $f9IVx[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $f9IVx.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $842daea100de1b3d$var$EC;
$842daea100de1b3d$var$EC.prototype.keyPair = function keyPair(options) {
    return new $biQ0o(this, options);
};
$842daea100de1b3d$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $biQ0o.fromPrivate(this, priv, enc);
};
$842daea100de1b3d$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $biQ0o.fromPublic(this, pub, enc);
};
$842daea100de1b3d$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $2X9Cm({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $4zkLw(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $6MZ4r(2));
    for(;;){
        var priv = new $6MZ4r(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$842daea100de1b3d$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($6MZ4r.isBN(msg) || typeof msg === 'number') {
        msg = new $6MZ4r(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $6MZ4r(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $6MZ4r(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$842daea100de1b3d$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$6MZ4r.isBN(msg)) {
        $842daea100de1b3d$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $842daea100de1b3d$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$842daea100de1b3d$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $842daea100de1b3d$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $842daea100de1b3d$var$assert(new $6MZ4r(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $2X9Cm({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $6MZ4r(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $6MZ4r(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $9gRsA({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$842daea100de1b3d$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $9gRsA(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$842daea100de1b3d$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $842daea100de1b3d$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $9gRsA(signature, enc);
    var n = this.n;
    var e = new $6MZ4r(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$842daea100de1b3d$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $9gRsA(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("2X9Cm", function(module, exports) {
'use strict';

var $6QFT4 = parcelRequire("6QFT4");

var $7InN7 = parcelRequire("7InN7");

var $bYAD2 = parcelRequire("bYAD2");
function $22688d51c54857c3$var$HmacDRBG(options) {
    if (!(this instanceof $22688d51c54857c3$var$HmacDRBG)) return new $22688d51c54857c3$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $7InN7.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $7InN7.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $7InN7.toArray(options.pers, options.persEnc || 'hex');
    $bYAD2(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $22688d51c54857c3$var$HmacDRBG;
$22688d51c54857c3$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$22688d51c54857c3$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $6QFT4.hmac(this.hash, this.K);
};
$22688d51c54857c3$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$22688d51c54857c3$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $7InN7.toArray(entropy, entropyEnc);
    add = $7InN7.toArray(add, addEnc);
    $bYAD2(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$22688d51c54857c3$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $7InN7.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $7InN7.encode(res, enc);
};

});

parcelRegister("biQ0o", function(module, exports) {
'use strict';

var $6MZ4r = parcelRequire("6MZ4r");

var $7g6O5 = parcelRequire("7g6O5");
var $83a9b75868635428$var$assert = $7g6O5.assert;
function $83a9b75868635428$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $83a9b75868635428$var$KeyPair;
$83a9b75868635428$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $83a9b75868635428$var$KeyPair) return pub;
    return new $83a9b75868635428$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$83a9b75868635428$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $83a9b75868635428$var$KeyPair) return priv;
    return new $83a9b75868635428$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$83a9b75868635428$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$83a9b75868635428$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$83a9b75868635428$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$83a9b75868635428$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $6MZ4r(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$83a9b75868635428$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $83a9b75868635428$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $83a9b75868635428$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$83a9b75868635428$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $83a9b75868635428$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$83a9b75868635428$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$83a9b75868635428$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$83a9b75868635428$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("9gRsA", function(module, exports) {
'use strict';

var $6MZ4r = parcelRequire("6MZ4r");

var $7g6O5 = parcelRequire("7g6O5");
var $6bff13bf8e8af7c2$var$assert = $7g6O5.assert;
function $6bff13bf8e8af7c2$var$Signature(options, enc) {
    if (options instanceof $6bff13bf8e8af7c2$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $6bff13bf8e8af7c2$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $6MZ4r(options.r, 16);
    this.s = new $6MZ4r(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $6bff13bf8e8af7c2$var$Signature;
function $6bff13bf8e8af7c2$var$Position() {
    this.place = 0;
}
function $6bff13bf8e8af7c2$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $6bff13bf8e8af7c2$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$6bff13bf8e8af7c2$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $7g6O5.toArray(data, enc);
    var p = new $6bff13bf8e8af7c2$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $6bff13bf8e8af7c2$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $6bff13bf8e8af7c2$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $6bff13bf8e8af7c2$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $6MZ4r(r);
    this.s = new $6MZ4r(s);
    this.recoveryParam = null;
    return true;
};
function $6bff13bf8e8af7c2$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$6bff13bf8e8af7c2$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $6bff13bf8e8af7c2$var$rmPadding(r);
    s = $6bff13bf8e8af7c2$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $6bff13bf8e8af7c2$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $6bff13bf8e8af7c2$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $6bff13bf8e8af7c2$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $7g6O5.encode(res, enc);
};

});


parcelRegister("kds6p", function(module, exports) {
'use strict';

var $6QFT4 = parcelRequire("6QFT4");

var $f9IVx = parcelRequire("f9IVx");

var $7g6O5 = parcelRequire("7g6O5");
var $eb7ad219282af8a9$var$assert = $7g6O5.assert;
var $eb7ad219282af8a9$var$parseBytes = $7g6O5.parseBytes;

var $UsG8m = parcelRequire("UsG8m");

var $90f1d = parcelRequire("90f1d");
function $eb7ad219282af8a9$var$EDDSA(curve) {
    $eb7ad219282af8a9$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $eb7ad219282af8a9$var$EDDSA)) return new $eb7ad219282af8a9$var$EDDSA(curve);
    curve = $f9IVx[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $6QFT4.sha512;
}
module.exports = $eb7ad219282af8a9$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $eb7ad219282af8a9$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $eb7ad219282af8a9$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $eb7ad219282af8a9$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $eb7ad219282af8a9$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$eb7ad219282af8a9$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $7g6O5.intFromLE(hash.digest()).umod(this.curve.n);
};
$eb7ad219282af8a9$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $UsG8m.fromPublic(this, pub);
};
$eb7ad219282af8a9$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $UsG8m.fromSecret(this, secret);
};
$eb7ad219282af8a9$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $90f1d) return sig;
    return new $90f1d(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $eb7ad219282af8a9$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$eb7ad219282af8a9$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $7g6O5.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $7g6O5.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$eb7ad219282af8a9$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$eb7ad219282af8a9$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $7g6O5.intFromLE(bytes);
};
$eb7ad219282af8a9$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("UsG8m", function(module, exports) {
'use strict';

var $7g6O5 = parcelRequire("7g6O5");
var $0a9b7a0bc792cadf$var$assert = $7g6O5.assert;
var $0a9b7a0bc792cadf$var$parseBytes = $7g6O5.parseBytes;
var $0a9b7a0bc792cadf$var$cachedProperty = $7g6O5.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $0a9b7a0bc792cadf$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $0a9b7a0bc792cadf$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $0a9b7a0bc792cadf$var$parseBytes(params.pub);
}
$0a9b7a0bc792cadf$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $0a9b7a0bc792cadf$var$KeyPair) return pub;
    return new $0a9b7a0bc792cadf$var$KeyPair(eddsa, {
        pub: pub
    });
};
$0a9b7a0bc792cadf$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $0a9b7a0bc792cadf$var$KeyPair) return secret;
    return new $0a9b7a0bc792cadf$var$KeyPair(eddsa, {
        secret: secret
    });
};
$0a9b7a0bc792cadf$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$0a9b7a0bc792cadf$var$cachedProperty($0a9b7a0bc792cadf$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$0a9b7a0bc792cadf$var$cachedProperty($0a9b7a0bc792cadf$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$0a9b7a0bc792cadf$var$cachedProperty($0a9b7a0bc792cadf$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$0a9b7a0bc792cadf$var$cachedProperty($0a9b7a0bc792cadf$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$0a9b7a0bc792cadf$var$cachedProperty($0a9b7a0bc792cadf$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$0a9b7a0bc792cadf$var$cachedProperty($0a9b7a0bc792cadf$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$0a9b7a0bc792cadf$var$KeyPair.prototype.sign = function sign(message) {
    $0a9b7a0bc792cadf$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$0a9b7a0bc792cadf$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$0a9b7a0bc792cadf$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $0a9b7a0bc792cadf$var$assert(this._secret, 'KeyPair is public only');
    return $7g6O5.encode(this.secret(), enc);
};
$0a9b7a0bc792cadf$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $7g6O5.encode(this.pubBytes(), enc);
};
module.exports = $0a9b7a0bc792cadf$var$KeyPair;

});

parcelRegister("90f1d", function(module, exports) {
'use strict';

var $6MZ4r = parcelRequire("6MZ4r");

var $7g6O5 = parcelRequire("7g6O5");
var $68dfc38a98df650f$var$assert = $7g6O5.assert;
var $68dfc38a98df650f$var$cachedProperty = $7g6O5.cachedProperty;
var $68dfc38a98df650f$var$parseBytes = $7g6O5.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $68dfc38a98df650f$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $68dfc38a98df650f$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $68dfc38a98df650f$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $68dfc38a98df650f$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $6MZ4r) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$68dfc38a98df650f$var$cachedProperty($68dfc38a98df650f$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$68dfc38a98df650f$var$cachedProperty($68dfc38a98df650f$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$68dfc38a98df650f$var$cachedProperty($68dfc38a98df650f$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$68dfc38a98df650f$var$cachedProperty($68dfc38a98df650f$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$68dfc38a98df650f$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$68dfc38a98df650f$var$Signature.prototype.toHex = function toHex() {
    return $7g6O5.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $68dfc38a98df650f$var$Signature;

});


parcelRegister("lKvyH", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("a5Qi3")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("WOQFG", function(module, exports) {

var $dJPni = parcelRequire("dJPni");

var $lubO4 = parcelRequire("lubO4");
var $0b0cdc5ac17a790e$var$api = module.exports;
$0b0cdc5ac17a790e$var$api.define = function define(name, body) {
    return new $0b0cdc5ac17a790e$var$Entity(name, body);
};
function $0b0cdc5ac17a790e$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$0b0cdc5ac17a790e$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("bBJce")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $lubO4(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$0b0cdc5ac17a790e$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($dJPni.decoders[enc]);
    return this.decoders[enc];
};
$0b0cdc5ac17a790e$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$0b0cdc5ac17a790e$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($dJPni.encoders[enc]);
    return this.encoders[enc];
};
$0b0cdc5ac17a790e$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("dJPni", function(module, exports) {
var $a007544932554905$var$asn1 = module.exports;

$a007544932554905$var$asn1.bignum = (parcelRequire("6MZ4r"));

$a007544932554905$var$asn1.define = (parcelRequire("WOQFG")).define;

$a007544932554905$var$asn1.base = (parcelRequire("4L05I"));

$a007544932554905$var$asn1.constants = (parcelRequire("lyJqR"));

$a007544932554905$var$asn1.decoders = (parcelRequire("4Mtie"));

$a007544932554905$var$asn1.encoders = (parcelRequire("hsgje"));

});
parcelRegister("4L05I", function(module, exports) {
var $376b9f4fe78f0810$var$base = module.exports;

$376b9f4fe78f0810$var$base.Reporter = (parcelRequire("d0iDz")).Reporter;

$376b9f4fe78f0810$var$base.DecoderBuffer = (parcelRequire("3Zdyk")).DecoderBuffer;

$376b9f4fe78f0810$var$base.EncoderBuffer = (parcelRequire("3Zdyk")).EncoderBuffer;

$376b9f4fe78f0810$var$base.Node = (parcelRequire("9vGe1"));

});
parcelRegister("d0iDz", function(module, exports) {
$parcel$export(module.exports, "Reporter", () => $9779bb660003d5cf$export$957313a2f485e5ed, (v) => $9779bb660003d5cf$export$957313a2f485e5ed = v);
var $9779bb660003d5cf$export$957313a2f485e5ed;

var $lubO4 = parcelRequire("lubO4");
function $9779bb660003d5cf$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$9779bb660003d5cf$export$957313a2f485e5ed = $9779bb660003d5cf$var$Reporter;
$9779bb660003d5cf$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $9779bb660003d5cf$var$ReporterError;
};
$9779bb660003d5cf$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$9779bb660003d5cf$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$9779bb660003d5cf$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$9779bb660003d5cf$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$9779bb660003d5cf$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$9779bb660003d5cf$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$9779bb660003d5cf$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$9779bb660003d5cf$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$9779bb660003d5cf$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $9779bb660003d5cf$var$ReporterError;
    if (inherited) err = msg;
    else err = new $9779bb660003d5cf$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$9779bb660003d5cf$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $9779bb660003d5cf$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$lubO4($9779bb660003d5cf$var$ReporterError, Error);
$9779bb660003d5cf$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $9779bb660003d5cf$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("3Zdyk", function(module, exports) {
$parcel$export(module.exports, "DecoderBuffer", () => $2e7194dfc769dd21$export$bf9f79cdc4a49163, (v) => $2e7194dfc769dd21$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $2e7194dfc769dd21$export$8ff24f7760c7a78e, (v) => $2e7194dfc769dd21$export$8ff24f7760c7a78e = v);
var $2e7194dfc769dd21$export$bf9f79cdc4a49163;
var $2e7194dfc769dd21$export$8ff24f7760c7a78e;

var $lubO4 = parcelRequire("lubO4");

var $4L05I = parcelRequire("4L05I");
var $2e7194dfc769dd21$require$Reporter = $4L05I.Reporter;

var $2zYso = parcelRequire("2zYso");
var $2e7194dfc769dd21$require$Buffer = $2zYso.Buffer;
function $2e7194dfc769dd21$var$DecoderBuffer(base, options) {
    $2e7194dfc769dd21$require$Reporter.call(this, options);
    if (!$2e7194dfc769dd21$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$lubO4($2e7194dfc769dd21$var$DecoderBuffer, $2e7194dfc769dd21$require$Reporter);
$2e7194dfc769dd21$export$bf9f79cdc4a49163 = $2e7194dfc769dd21$var$DecoderBuffer;
$2e7194dfc769dd21$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $2e7194dfc769dd21$require$Reporter.prototype.save.call(this)
    };
};
$2e7194dfc769dd21$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $2e7194dfc769dd21$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $2e7194dfc769dd21$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$2e7194dfc769dd21$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$2e7194dfc769dd21$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$2e7194dfc769dd21$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $2e7194dfc769dd21$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$2e7194dfc769dd21$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $2e7194dfc769dd21$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $2e7194dfc769dd21$var$EncoderBuffer)) item = new $2e7194dfc769dd21$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $2e7194dfc769dd21$require$Buffer.byteLength(value);
    } else if ($2e7194dfc769dd21$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$2e7194dfc769dd21$export$8ff24f7760c7a78e = $2e7194dfc769dd21$var$EncoderBuffer;
$2e7194dfc769dd21$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $2e7194dfc769dd21$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($2e7194dfc769dd21$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("9vGe1", function(module, exports) {

var $4L05I = parcelRequire("4L05I");
var $01c96a60586f63dc$require$Reporter = $4L05I.Reporter;

var $4L05I = parcelRequire("4L05I");
var $01c96a60586f63dc$require$EncoderBuffer = $4L05I.EncoderBuffer;

var $4L05I = parcelRequire("4L05I");
var $01c96a60586f63dc$require$DecoderBuffer = $4L05I.DecoderBuffer;

var $bYAD2 = parcelRequire("bYAD2");
// Supported tags
var $01c96a60586f63dc$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $01c96a60586f63dc$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($01c96a60586f63dc$var$tags);
// Overrided methods list
var $01c96a60586f63dc$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $01c96a60586f63dc$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $01c96a60586f63dc$var$Node;
var $01c96a60586f63dc$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$01c96a60586f63dc$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $01c96a60586f63dc$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$01c96a60586f63dc$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $01c96a60586f63dc$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$01c96a60586f63dc$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $bYAD2(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $bYAD2.equal(state.children.length, 1, 'Root node can have only one child');
};
$01c96a60586f63dc$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $bYAD2(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $bYAD2(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$01c96a60586f63dc$var$overrided.forEach(function(method) {
    $01c96a60586f63dc$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$01c96a60586f63dc$var$tags.forEach(function(tag) {
    $01c96a60586f63dc$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $bYAD2(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$01c96a60586f63dc$var$Node.prototype.use = function use(item) {
    $bYAD2(item);
    var state = this._baseState;
    $bYAD2(state.use === null);
    state.use = item;
    return this;
};
$01c96a60586f63dc$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$01c96a60586f63dc$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $bYAD2(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$01c96a60586f63dc$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $bYAD2(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$01c96a60586f63dc$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $bYAD2(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$01c96a60586f63dc$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$01c96a60586f63dc$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $bYAD2(state.key === null);
    state.key = newKey;
    return this;
};
$01c96a60586f63dc$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$01c96a60586f63dc$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $bYAD2(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$01c96a60586f63dc$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $bYAD2(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$01c96a60586f63dc$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $01c96a60586f63dc$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$01c96a60586f63dc$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$01c96a60586f63dc$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $bYAD2(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$01c96a60586f63dc$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$01c96a60586f63dc$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $01c96a60586f63dc$require$EncoderBuffer(data, this.reporter);
};
$01c96a60586f63dc$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$01c96a60586f63dc$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $01c96a60586f63dc$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$01c96a60586f63dc$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $bYAD2(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$01c96a60586f63dc$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$01c96a60586f63dc$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$01c96a60586f63dc$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("lyJqR", function(module, exports) {
var $fb2003da6b145f73$var$constants = module.exports;
// Helper
$fb2003da6b145f73$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$fb2003da6b145f73$var$constants.der = (parcelRequire("f63eA"));

});
parcelRegister("f63eA", function(module, exports) {
$parcel$export(module.exports, "tagClass", () => $afd9ecd5a70611ad$export$3584c46ed60baee8, (v) => $afd9ecd5a70611ad$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $afd9ecd5a70611ad$export$f18596ef8d632e49, (v) => $afd9ecd5a70611ad$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $afd9ecd5a70611ad$export$2b067c6666111485, (v) => $afd9ecd5a70611ad$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $afd9ecd5a70611ad$export$f17df38a421ab9e3, (v) => $afd9ecd5a70611ad$export$f17df38a421ab9e3 = v);
var $afd9ecd5a70611ad$export$3584c46ed60baee8;
var $afd9ecd5a70611ad$export$f18596ef8d632e49;
var $afd9ecd5a70611ad$export$2b067c6666111485;
var $afd9ecd5a70611ad$export$f17df38a421ab9e3;

var $lyJqR = parcelRequire("lyJqR");
$afd9ecd5a70611ad$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$afd9ecd5a70611ad$export$f18596ef8d632e49 = $lyJqR._reverse($afd9ecd5a70611ad$export$3584c46ed60baee8);
$afd9ecd5a70611ad$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$afd9ecd5a70611ad$export$f17df38a421ab9e3 = $lyJqR._reverse($afd9ecd5a70611ad$export$2b067c6666111485);

});


parcelRegister("4Mtie", function(module, exports) {
var $37b25e1c51ef3cc3$var$decoders = module.exports;

$37b25e1c51ef3cc3$var$decoders.der = (parcelRequire("9hrx8"));

$37b25e1c51ef3cc3$var$decoders.pem = (parcelRequire("5ucOD"));

});
parcelRegister("9hrx8", function(module, exports) {

var $lubO4 = parcelRequire("lubO4");

var $dJPni = parcelRequire("dJPni");
var $01be5f365bc8ddf4$var$base = $dJPni.base;
var $01be5f365bc8ddf4$var$bignum = $dJPni.bignum;
// Import DER constants
var $01be5f365bc8ddf4$var$der = $dJPni.constants.der;
function $01be5f365bc8ddf4$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $01be5f365bc8ddf4$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $01be5f365bc8ddf4$var$DERDecoder;
$01be5f365bc8ddf4$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $01be5f365bc8ddf4$var$base.DecoderBuffer)) data = new $01be5f365bc8ddf4$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $01be5f365bc8ddf4$var$DERNode(parent) {
    $01be5f365bc8ddf4$var$base.Node.call(this, 'der', parent);
}
$lubO4($01be5f365bc8ddf4$var$DERNode, $01be5f365bc8ddf4$var$base.Node);
$01be5f365bc8ddf4$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $01be5f365bc8ddf4$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$01be5f365bc8ddf4$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $01be5f365bc8ddf4$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $01be5f365bc8ddf4$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$01be5f365bc8ddf4$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $01be5f365bc8ddf4$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $01be5f365bc8ddf4$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$01be5f365bc8ddf4$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$01be5f365bc8ddf4$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$01be5f365bc8ddf4$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$01be5f365bc8ddf4$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$01be5f365bc8ddf4$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$01be5f365bc8ddf4$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$01be5f365bc8ddf4$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $01be5f365bc8ddf4$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$01be5f365bc8ddf4$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $01be5f365bc8ddf4$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $01be5f365bc8ddf4$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $01be5f365bc8ddf4$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $01be5f365bc8ddf4$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("5ucOD", function(module, exports) {

var $lubO4 = parcelRequire("lubO4");

var $2zYso = parcelRequire("2zYso");
var $3fe9b201aead43a4$require$Buffer = $2zYso.Buffer;

var $9hrx8 = parcelRequire("9hrx8");
function $3fe9b201aead43a4$var$PEMDecoder(entity) {
    $9hrx8.call(this, entity);
    this.enc = 'pem';
}
$lubO4($3fe9b201aead43a4$var$PEMDecoder, $9hrx8);
module.exports = $3fe9b201aead43a4$var$PEMDecoder;
$3fe9b201aead43a4$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $3fe9b201aead43a4$require$Buffer(base64, 'base64');
    return $9hrx8.prototype.decode.call(this, input, options);
};

});


parcelRegister("hsgje", function(module, exports) {
var $cb51b3dc35986b65$var$encoders = module.exports;

$cb51b3dc35986b65$var$encoders.der = (parcelRequire("gI4mN"));

$cb51b3dc35986b65$var$encoders.pem = (parcelRequire("2WVeK"));

});
parcelRegister("gI4mN", function(module, exports) {

var $lubO4 = parcelRequire("lubO4");

var $2zYso = parcelRequire("2zYso");
var $c2a4248a9748e878$require$Buffer = $2zYso.Buffer;

var $dJPni = parcelRequire("dJPni");
var $c2a4248a9748e878$var$base = $dJPni.base;
// Import DER constants
var $c2a4248a9748e878$var$der = $dJPni.constants.der;
function $c2a4248a9748e878$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $c2a4248a9748e878$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $c2a4248a9748e878$var$DEREncoder;
$c2a4248a9748e878$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $c2a4248a9748e878$var$DERNode(parent) {
    $c2a4248a9748e878$var$base.Node.call(this, 'der', parent);
}
$lubO4($c2a4248a9748e878$var$DERNode, $c2a4248a9748e878$var$base.Node);
$c2a4248a9748e878$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $c2a4248a9748e878$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $c2a4248a9748e878$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $c2a4248a9748e878$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$c2a4248a9748e878$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $c2a4248a9748e878$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$c2a4248a9748e878$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $c2a4248a9748e878$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $c2a4248a9748e878$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$c2a4248a9748e878$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $c2a4248a9748e878$var$two(date.getFullYear()),
        $c2a4248a9748e878$var$two(date.getUTCMonth() + 1),
        $c2a4248a9748e878$var$two(date.getUTCDate()),
        $c2a4248a9748e878$var$two(date.getUTCHours()),
        $c2a4248a9748e878$var$two(date.getUTCMinutes()),
        $c2a4248a9748e878$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $c2a4248a9748e878$var$two(date.getFullYear() % 100),
        $c2a4248a9748e878$var$two(date.getUTCMonth() + 1),
        $c2a4248a9748e878$var$two(date.getUTCDate()),
        $c2a4248a9748e878$var$two(date.getUTCHours()),
        $c2a4248a9748e878$var$two(date.getUTCMinutes()),
        $c2a4248a9748e878$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$c2a4248a9748e878$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$c2a4248a9748e878$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$c2a4248a9748e878$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $c2a4248a9748e878$require$Buffer(numArray);
    }
    if ($c2a4248a9748e878$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $c2a4248a9748e878$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $c2a4248a9748e878$require$Buffer(out));
};
$c2a4248a9748e878$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$c2a4248a9748e878$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$c2a4248a9748e878$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $c2a4248a9748e878$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($c2a4248a9748e878$var$der.tagByName.hasOwnProperty(tag)) res = $c2a4248a9748e878$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $c2a4248a9748e878$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("2WVeK", function(module, exports) {

var $lubO4 = parcelRequire("lubO4");

var $gI4mN = parcelRequire("gI4mN");
function $225d659e0c378081$var$PEMEncoder(entity) {
    $gI4mN.call(this, entity);
    this.enc = 'pem';
}
$lubO4($225d659e0c378081$var$PEMEncoder, $gI4mN);
module.exports = $225d659e0c378081$var$PEMEncoder;
$225d659e0c378081$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $gI4mN.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("bBJce", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("bT2Mw", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $dJPni = parcelRequire("dJPni");
var $8a76fd1d19b23692$var$Time = $dJPni.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $8a76fd1d19b23692$var$AttributeTypeValue = $dJPni.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $8a76fd1d19b23692$var$AlgorithmIdentifier = $dJPni.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $8a76fd1d19b23692$var$SubjectPublicKeyInfo = $dJPni.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($8a76fd1d19b23692$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $8a76fd1d19b23692$var$RelativeDistinguishedName = $dJPni.define('RelativeDistinguishedName', function() {
    this.setof($8a76fd1d19b23692$var$AttributeTypeValue);
});
var $8a76fd1d19b23692$var$RDNSequence = $dJPni.define('RDNSequence', function() {
    this.seqof($8a76fd1d19b23692$var$RelativeDistinguishedName);
});
var $8a76fd1d19b23692$var$Name = $dJPni.define('Name', function() {
    this.choice({
        rdnSequence: this.use($8a76fd1d19b23692$var$RDNSequence)
    });
});
var $8a76fd1d19b23692$var$Validity = $dJPni.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($8a76fd1d19b23692$var$Time), this.key('notAfter').use($8a76fd1d19b23692$var$Time));
});
var $8a76fd1d19b23692$var$Extension = $dJPni.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $8a76fd1d19b23692$var$TBSCertificate = $dJPni.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($8a76fd1d19b23692$var$AlgorithmIdentifier), this.key('issuer').use($8a76fd1d19b23692$var$Name), this.key('validity').use($8a76fd1d19b23692$var$Validity), this.key('subject').use($8a76fd1d19b23692$var$Name), this.key('subjectPublicKeyInfo').use($8a76fd1d19b23692$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($8a76fd1d19b23692$var$Extension).optional());
});
var $8a76fd1d19b23692$var$X509Certificate = $dJPni.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($8a76fd1d19b23692$var$TBSCertificate), this.key('signatureAlgorithm').use($8a76fd1d19b23692$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $8a76fd1d19b23692$var$X509Certificate;

});

parcelRegister("h0XCx", function(module, exports) {

var $2zYso = parcelRequire("2zYso");
var $c630af23bdc0e1ee$require$Buffer = $2zYso.Buffer;

var $laUMt = parcelRequire("laUMt");

var $6MZ4r = parcelRequire("6MZ4r");
module.exports = function createECDH(curve) {
    return new $c630af23bdc0e1ee$var$ECDH(curve);
};
var $c630af23bdc0e1ee$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$c630af23bdc0e1ee$var$aliases.p224 = $c630af23bdc0e1ee$var$aliases.secp224r1;
$c630af23bdc0e1ee$var$aliases.p256 = $c630af23bdc0e1ee$var$aliases.secp256r1 = $c630af23bdc0e1ee$var$aliases.prime256v1;
$c630af23bdc0e1ee$var$aliases.p192 = $c630af23bdc0e1ee$var$aliases.secp192r1 = $c630af23bdc0e1ee$var$aliases.prime192v1;
$c630af23bdc0e1ee$var$aliases.p384 = $c630af23bdc0e1ee$var$aliases.secp384r1;
$c630af23bdc0e1ee$var$aliases.p521 = $c630af23bdc0e1ee$var$aliases.secp521r1;
function $c630af23bdc0e1ee$var$ECDH(curve) {
    this.curveType = $c630af23bdc0e1ee$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $laUMt.ec(this.curveType.name); // eslint-disable-line new-cap
    this.keys = void 0;
}
$c630af23bdc0e1ee$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$c630af23bdc0e1ee$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$c630af23bdc0e1ee$require$Buffer.isBuffer(other)) other = new $c630af23bdc0e1ee$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $c630af23bdc0e1ee$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$c630af23bdc0e1ee$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $c630af23bdc0e1ee$var$formatReturnValue(key, enc);
};
$c630af23bdc0e1ee$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $c630af23bdc0e1ee$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$c630af23bdc0e1ee$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$c630af23bdc0e1ee$require$Buffer.isBuffer(pub)) pub = new $c630af23bdc0e1ee$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$c630af23bdc0e1ee$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$c630af23bdc0e1ee$require$Buffer.isBuffer(priv)) priv = new $c630af23bdc0e1ee$require$Buffer(priv, enc);
    var _priv = new $6MZ4r(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $c630af23bdc0e1ee$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $c630af23bdc0e1ee$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $c630af23bdc0e1ee$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $c630af23bdc0e1ee$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("laUMt", function(module, exports) {
'use strict';
var $f6a693a2e8e75b7f$var$elliptic = module.exports;

$f6a693a2e8e75b7f$var$elliptic.version = (parcelRequire("de1aF")).version;

$f6a693a2e8e75b7f$var$elliptic.utils = (parcelRequire("7g6O5"));

$f6a693a2e8e75b7f$var$elliptic.rand = (parcelRequire("4zkLw"));

$f6a693a2e8e75b7f$var$elliptic.curve = (parcelRequire("6QOtF"));

$f6a693a2e8e75b7f$var$elliptic.curves = (parcelRequire("f9IVx"));

// Protocols
$f6a693a2e8e75b7f$var$elliptic.ec = (parcelRequire("blA89"));

$f6a693a2e8e75b7f$var$elliptic.eddsa = (parcelRequire("kds6p"));

});


parcelRegister("gj5zU", function(module, exports) {

var $8GoMl = parcelRequire("8GoMl");

var $72pt0 = parcelRequire("72pt0");

var $bsVm9 = parcelRequire("bsVm9");

var $b8gBN = parcelRequire("b8gBN");

var $cAOk6 = parcelRequire("cAOk6");

var $6MZ4r = parcelRequire("6MZ4r");

var $wnnAU = parcelRequire("wnnAU");

var $g4fKB = parcelRequire("g4fKB");

var $3VN6j = parcelRequire("3VN6j");
var $bdf2bf6acb2d483d$require$Buffer = $3VN6j.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $8GoMl(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $bdf2bf6acb2d483d$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $bdf2bf6acb2d483d$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $6MZ4r(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $g4fKB(paddedMsg, key);
    else return $wnnAU(paddedMsg, key);
};
function $bdf2bf6acb2d483d$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $bsVm9('sha1').update($bdf2bf6acb2d483d$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $bdf2bf6acb2d483d$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $72pt0(hLen);
    var maskedDb = $cAOk6($bdf2bf6acb2d483d$require$Buffer.concat([
        iHash,
        ps,
        $bdf2bf6acb2d483d$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $b8gBN(seed, dblen));
    var maskedSeed = $cAOk6(seed, $b8gBN(maskedDb, hLen));
    return new $6MZ4r($bdf2bf6acb2d483d$require$Buffer.concat([
        $bdf2bf6acb2d483d$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $bdf2bf6acb2d483d$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $bdf2bf6acb2d483d$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $bdf2bf6acb2d483d$var$nonZero(k - mLen - 3);
    return new $6MZ4r($bdf2bf6acb2d483d$require$Buffer.concat([
        $bdf2bf6acb2d483d$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $bdf2bf6acb2d483d$require$Buffer.alloc(1),
        msg
    ], k));
}
function $bdf2bf6acb2d483d$var$nonZero(len) {
    var out = $bdf2bf6acb2d483d$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $72pt0(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $72pt0(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("8GoMl", function(module, exports) {
'use strict';

var $bp0YO = parcelRequire("bp0YO");

var $bCavB = parcelRequire("bCavB");

var $25VWb = parcelRequire("25VWb");

var $iClUZ = parcelRequire("iClUZ");

var $cFQaq = parcelRequire("cFQaq");

var $3VN6j = parcelRequire("3VN6j");
var $652577817d5255e8$require$Buffer = $3VN6j.Buffer;
function $652577817d5255e8$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $bCavB[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $cFQaq.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $iClUZ.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $652577817d5255e8$require$Buffer.concat(out);
}
function $652577817d5255e8$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$652577817d5255e8$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $652577817d5255e8$require$Buffer.from(buffer);
    var stripped = $25VWb(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $bp0YO.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $bp0YO.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $bp0YO.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $bp0YO.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $bp0YO.EncryptedPrivateKey.decode(data, 'der');
            data = $652577817d5255e8$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $bp0YO.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $bp0YO.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $bp0YO.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $bp0YO.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $bp0YO.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $bp0YO.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $bp0YO.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $bp0YO.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$652577817d5255e8$var$parseKeys.signature = $bp0YO.signature;
module.exports = $652577817d5255e8$var$parseKeys;

});
parcelRegister("bp0YO", function(module, exports) {
$parcel$export(module.exports, "certificate", () => $84d2ca14c25d7207$export$c98397a6eb8d0678, (v) => $84d2ca14c25d7207$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $84d2ca14c25d7207$export$f4aab6816f64fa6b, (v) => $84d2ca14c25d7207$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $84d2ca14c25d7207$export$4471f5c65d097c11, (v) => $84d2ca14c25d7207$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $84d2ca14c25d7207$export$ca8b6604d6ce14de, (v) => $84d2ca14c25d7207$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $84d2ca14c25d7207$export$8f54525b330fd87b, (v) => $84d2ca14c25d7207$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $84d2ca14c25d7207$export$23cd2842b44ca3e7, (v) => $84d2ca14c25d7207$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $84d2ca14c25d7207$export$245c9aaa9f5ce4ce, (v) => $84d2ca14c25d7207$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $84d2ca14c25d7207$export$8ad762e3e6399afe, (v) => $84d2ca14c25d7207$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $84d2ca14c25d7207$export$32ef6f92e22c6ab0, (v) => $84d2ca14c25d7207$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $84d2ca14c25d7207$export$c9cd164b539ebb63, (v) => $84d2ca14c25d7207$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $84d2ca14c25d7207$export$c98397a6eb8d0678;
var $84d2ca14c25d7207$export$f4aab6816f64fa6b;
var $84d2ca14c25d7207$export$4471f5c65d097c11;
var $84d2ca14c25d7207$export$ca8b6604d6ce14de;
var $84d2ca14c25d7207$export$8f54525b330fd87b;
var $84d2ca14c25d7207$export$23cd2842b44ca3e7;
var $84d2ca14c25d7207$export$245c9aaa9f5ce4ce;
var $84d2ca14c25d7207$export$8ad762e3e6399afe;
var $84d2ca14c25d7207$export$32ef6f92e22c6ab0;
var $84d2ca14c25d7207$export$c9cd164b539ebb63;
'use strict';

var $dJPni = parcelRequire("dJPni");

$84d2ca14c25d7207$export$c98397a6eb8d0678 = (parcelRequire("bT2Mw"));
var $84d2ca14c25d7207$var$RSAPrivateKey = $dJPni.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$84d2ca14c25d7207$export$f4aab6816f64fa6b = $84d2ca14c25d7207$var$RSAPrivateKey;
var $84d2ca14c25d7207$var$RSAPublicKey = $dJPni.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$84d2ca14c25d7207$export$4471f5c65d097c11 = $84d2ca14c25d7207$var$RSAPublicKey;
var $84d2ca14c25d7207$var$AlgorithmIdentifier = $dJPni.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $84d2ca14c25d7207$var$PublicKey = $dJPni.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($84d2ca14c25d7207$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$84d2ca14c25d7207$export$ca8b6604d6ce14de = $84d2ca14c25d7207$var$PublicKey;
var $84d2ca14c25d7207$var$PrivateKeyInfo = $dJPni.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($84d2ca14c25d7207$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$84d2ca14c25d7207$export$8f54525b330fd87b = $84d2ca14c25d7207$var$PrivateKeyInfo;
var $84d2ca14c25d7207$var$EncryptedPrivateKeyInfo = $dJPni.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$84d2ca14c25d7207$export$23cd2842b44ca3e7 = $84d2ca14c25d7207$var$EncryptedPrivateKeyInfo;
var $84d2ca14c25d7207$var$DSAPrivateKey = $dJPni.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$84d2ca14c25d7207$export$245c9aaa9f5ce4ce = $84d2ca14c25d7207$var$DSAPrivateKey;
$84d2ca14c25d7207$export$8ad762e3e6399afe = $dJPni.define('DSAparam', function() {
    this['int']();
});
var $84d2ca14c25d7207$var$ECParameters = $dJPni.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $84d2ca14c25d7207$var$ECPrivateKey = $dJPni.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($84d2ca14c25d7207$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$84d2ca14c25d7207$export$32ef6f92e22c6ab0 = $84d2ca14c25d7207$var$ECPrivateKey;
$84d2ca14c25d7207$export$c9cd164b539ebb63 = $dJPni.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});

parcelRegister("bCavB", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("25VWb", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $1868fd91064b415b$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $1868fd91064b415b$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $1868fd91064b415b$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $7HP4I = parcelRequire("7HP4I");

var $iClUZ = parcelRequire("iClUZ");

var $3VN6j = parcelRequire("3VN6j");
var $1868fd91064b415b$require$Buffer = $3VN6j.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($1868fd91064b415b$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($1868fd91064b415b$var$fullRegex);
        decrypted = $1868fd91064b415b$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $1868fd91064b415b$require$Buffer.from(match[2], 'hex');
        var cipherText = $1868fd91064b415b$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $7HP4I(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $iClUZ.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $1868fd91064b415b$require$Buffer.concat(out);
    }
    var tag = key.match($1868fd91064b415b$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});
parcelRegister("7HP4I", function(module, exports) {

var $3VN6j = parcelRequire("3VN6j");
var $59c42b029b58a2bf$require$Buffer = $3VN6j.Buffer;

var $aZDj9 = parcelRequire("aZDj9");
/* eslint-disable camelcase */ function $59c42b029b58a2bf$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$59c42b029b58a2bf$require$Buffer.isBuffer(password)) password = $59c42b029b58a2bf$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$59c42b029b58a2bf$require$Buffer.isBuffer(salt)) salt = $59c42b029b58a2bf$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $59c42b029b58a2bf$require$Buffer.alloc(keyLen);
    var iv = $59c42b029b58a2bf$require$Buffer.alloc(ivLen || 0);
    var tmp = $59c42b029b58a2bf$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $aZDj9();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $59c42b029b58a2bf$var$EVP_BytesToKey;

});

parcelRegister("iClUZ", function(module, exports) {
$parcel$export(module.exports, "createCipheriv", () => $d8dcc715c79cfbe7$export$2f64596b8cbf08b4, (v) => $d8dcc715c79cfbe7$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $d8dcc715c79cfbe7$export$36b6d6ef312eab39, (v) => $d8dcc715c79cfbe7$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $d8dcc715c79cfbe7$export$58a258485f1e49f6, (v) => $d8dcc715c79cfbe7$export$58a258485f1e49f6 = v);
var $d8dcc715c79cfbe7$export$bdd223f16383713e;
var $d8dcc715c79cfbe7$export$26e5786e8ac8e530;
var $d8dcc715c79cfbe7$export$2f64596b8cbf08b4;
var $d8dcc715c79cfbe7$export$20533d26f07f1ee0;
var $d8dcc715c79cfbe7$export$12ada9414fbc594c;
var $d8dcc715c79cfbe7$export$2ce6d8d0e8b04e1a;
var $d8dcc715c79cfbe7$export$36b6d6ef312eab39;
var $d8dcc715c79cfbe7$export$f5e7e39d57cd9700;
var $d8dcc715c79cfbe7$export$dedd8dc3dc62b370;
var $d8dcc715c79cfbe7$export$58a258485f1e49f6;

var $3CyKB = parcelRequire("3CyKB");

var $fUQom = parcelRequire("fUQom");

var $kCTIG = parcelRequire("kCTIG");
function $d8dcc715c79cfbe7$var$getCiphers() {
    return Object.keys($kCTIG);
}
$d8dcc715c79cfbe7$export$bdd223f16383713e = $d8dcc715c79cfbe7$export$26e5786e8ac8e530 = $3CyKB.createCipher;
$d8dcc715c79cfbe7$export$2f64596b8cbf08b4 = $d8dcc715c79cfbe7$export$20533d26f07f1ee0 = $3CyKB.createCipheriv;
$d8dcc715c79cfbe7$export$12ada9414fbc594c = $d8dcc715c79cfbe7$export$2ce6d8d0e8b04e1a = $fUQom.createDecipher;
$d8dcc715c79cfbe7$export$36b6d6ef312eab39 = $d8dcc715c79cfbe7$export$f5e7e39d57cd9700 = $fUQom.createDecipheriv;
$d8dcc715c79cfbe7$export$dedd8dc3dc62b370 = $d8dcc715c79cfbe7$export$58a258485f1e49f6 = $d8dcc715c79cfbe7$var$getCiphers;

});
parcelRegister("3CyKB", function(module, exports) {
$parcel$export(module.exports, "createCipheriv", () => $2a2fe0725cc547b4$export$2f64596b8cbf08b4, (v) => $2a2fe0725cc547b4$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $2a2fe0725cc547b4$export$bdd223f16383713e, (v) => $2a2fe0725cc547b4$export$bdd223f16383713e = v);
var $2a2fe0725cc547b4$export$2f64596b8cbf08b4;
var $2a2fe0725cc547b4$export$bdd223f16383713e;

var $c22JZ = parcelRequire("c22JZ");

var $bshsc = parcelRequire("bshsc");

var $3VN6j = parcelRequire("3VN6j");
var $2a2fe0725cc547b4$require$Buffer = $3VN6j.Buffer;

var $74ePQ = parcelRequire("74ePQ");

var $AhG97 = parcelRequire("AhG97");

var $9cQzZ = parcelRequire("9cQzZ");

var $7HP4I = parcelRequire("7HP4I");

var $lubO4 = parcelRequire("lubO4");
function $2a2fe0725cc547b4$var$Cipher(mode, key, iv) {
    $AhG97.call(this);
    this._cache = new $2a2fe0725cc547b4$var$Splitter();
    this._cipher = new $9cQzZ.AES(key);
    this._prev = $2a2fe0725cc547b4$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$lubO4($2a2fe0725cc547b4$var$Cipher, $AhG97);
$2a2fe0725cc547b4$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $2a2fe0725cc547b4$require$Buffer.concat(out);
};
var $2a2fe0725cc547b4$var$PADDING = $2a2fe0725cc547b4$require$Buffer.alloc(16, 0x10);
$2a2fe0725cc547b4$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($2a2fe0725cc547b4$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$2a2fe0725cc547b4$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $2a2fe0725cc547b4$var$Splitter() {
    this.cache = $2a2fe0725cc547b4$require$Buffer.allocUnsafe(0);
}
$2a2fe0725cc547b4$var$Splitter.prototype.add = function(data) {
    this.cache = $2a2fe0725cc547b4$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$2a2fe0725cc547b4$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$2a2fe0725cc547b4$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $2a2fe0725cc547b4$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $2a2fe0725cc547b4$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $2a2fe0725cc547b4$var$createCipheriv(suite, password, iv) {
    var config = $c22JZ[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $2a2fe0725cc547b4$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $2a2fe0725cc547b4$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $74ePQ(config.module, password, iv);
    else if (config.type === 'auth') return new $bshsc(config.module, password, iv);
    return new $2a2fe0725cc547b4$var$Cipher(config.module, password, iv);
}
function $2a2fe0725cc547b4$var$createCipher(suite, password) {
    var config = $c22JZ[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $7HP4I(password, false, config.key, config.iv);
    return $2a2fe0725cc547b4$var$createCipheriv(suite, keys.key, keys.iv);
}
$2a2fe0725cc547b4$export$2f64596b8cbf08b4 = $2a2fe0725cc547b4$var$createCipheriv;
$2a2fe0725cc547b4$export$bdd223f16383713e = $2a2fe0725cc547b4$var$createCipher;

});
parcelRegister("c22JZ", function(module, exports) {








var $8c27cc340acce43c$var$modeModules = {
    ECB: (parcelRequire("dlMRO")),
    CBC: (parcelRequire("hmiZI")),
    CFB: (parcelRequire("7PPN1")),
    CFB8: (parcelRequire("5ZCbH")),
    CFB1: (parcelRequire("g5Fqo")),
    OFB: (parcelRequire("4Gi4v")),
    CTR: (parcelRequire("2nKMt")),
    GCM: (parcelRequire("2nKMt"))
};

var $kCTIG = parcelRequire("kCTIG");
for(var $8c27cc340acce43c$var$key in $kCTIG)$kCTIG[$8c27cc340acce43c$var$key].module = $8c27cc340acce43c$var$modeModules[$kCTIG[$8c27cc340acce43c$var$key].mode];
module.exports = $kCTIG;

});
parcelRegister("kCTIG", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("bshsc", function(module, exports) {

var $9cQzZ = parcelRequire("9cQzZ");

var $3VN6j = parcelRequire("3VN6j");
var $856fd9315967e674$require$Buffer = $3VN6j.Buffer;

var $AhG97 = parcelRequire("AhG97");

var $lubO4 = parcelRequire("lubO4");

var $1IgSz = parcelRequire("1IgSz");

var $6BzeD = parcelRequire("6BzeD");

var $jhGkU = parcelRequire("jhGkU");
function $856fd9315967e674$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $856fd9315967e674$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $856fd9315967e674$require$Buffer.concat([
            iv,
            $856fd9315967e674$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $856fd9315967e674$require$Buffer.concat([
            iv,
            $856fd9315967e674$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $1IgSz(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($856fd9315967e674$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($856fd9315967e674$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $856fd9315967e674$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $856fd9315967e674$require$Buffer.from(self._finID);
    $jhGkU(out);
    return out;
}
function $856fd9315967e674$var$StreamCipher(mode, key, iv, decrypt) {
    $AhG97.call(this);
    var h = $856fd9315967e674$require$Buffer.alloc(4, 0);
    this._cipher = new $9cQzZ.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $1IgSz(ck);
    iv = $856fd9315967e674$var$calcIv(this, iv, ck);
    this._prev = $856fd9315967e674$require$Buffer.from(iv);
    this._cache = $856fd9315967e674$require$Buffer.allocUnsafe(0);
    this._secCache = $856fd9315967e674$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$lubO4($856fd9315967e674$var$StreamCipher, $AhG97);
$856fd9315967e674$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $856fd9315967e674$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$856fd9315967e674$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $6BzeD(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $856fd9315967e674$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$856fd9315967e674$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$856fd9315967e674$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$856fd9315967e674$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$856fd9315967e674$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $856fd9315967e674$var$StreamCipher;

});
parcelRegister("9cQzZ", function(module, exports) {
$parcel$export(module.exports, "AES", () => $6b3e053f774d2f3c$export$b80fbe1c3a2b92b5, (v) => $6b3e053f774d2f3c$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $6b3e053f774d2f3c$export$b80fbe1c3a2b92b5;

var $3VN6j = parcelRequire("3VN6j");
var $6b3e053f774d2f3c$require$Buffer = $3VN6j.Buffer;
function $6b3e053f774d2f3c$var$asUInt32Array(buf) {
    if (!$6b3e053f774d2f3c$require$Buffer.isBuffer(buf)) buf = $6b3e053f774d2f3c$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $6b3e053f774d2f3c$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $6b3e053f774d2f3c$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $6b3e053f774d2f3c$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $6b3e053f774d2f3c$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $6b3e053f774d2f3c$var$AES(key) {
    this._key = $6b3e053f774d2f3c$var$asUInt32Array(key);
    this._reset();
}
$6b3e053f774d2f3c$var$AES.blockSize = 16;
$6b3e053f774d2f3c$var$AES.keySize = 32;
$6b3e053f774d2f3c$var$AES.prototype.blockSize = $6b3e053f774d2f3c$var$AES.blockSize;
$6b3e053f774d2f3c$var$AES.prototype.keySize = $6b3e053f774d2f3c$var$AES.keySize;
$6b3e053f774d2f3c$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $6b3e053f774d2f3c$var$G.SBOX[t >>> 24] << 24 | $6b3e053f774d2f3c$var$G.SBOX[t >>> 16 & 0xff] << 16 | $6b3e053f774d2f3c$var$G.SBOX[t >>> 8 & 0xff] << 8 | $6b3e053f774d2f3c$var$G.SBOX[t & 0xff];
            t ^= $6b3e053f774d2f3c$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $6b3e053f774d2f3c$var$G.SBOX[t >>> 24] << 24 | $6b3e053f774d2f3c$var$G.SBOX[t >>> 16 & 0xff] << 16 | $6b3e053f774d2f3c$var$G.SBOX[t >>> 8 & 0xff] << 8 | $6b3e053f774d2f3c$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $6b3e053f774d2f3c$var$G.INV_SUB_MIX[0][$6b3e053f774d2f3c$var$G.SBOX[tt >>> 24]] ^ $6b3e053f774d2f3c$var$G.INV_SUB_MIX[1][$6b3e053f774d2f3c$var$G.SBOX[tt >>> 16 & 0xff]] ^ $6b3e053f774d2f3c$var$G.INV_SUB_MIX[2][$6b3e053f774d2f3c$var$G.SBOX[tt >>> 8 & 0xff]] ^ $6b3e053f774d2f3c$var$G.INV_SUB_MIX[3][$6b3e053f774d2f3c$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$6b3e053f774d2f3c$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $6b3e053f774d2f3c$var$asUInt32Array(M);
    return $6b3e053f774d2f3c$var$cryptBlock(M, this._keySchedule, $6b3e053f774d2f3c$var$G.SUB_MIX, $6b3e053f774d2f3c$var$G.SBOX, this._nRounds);
};
$6b3e053f774d2f3c$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $6b3e053f774d2f3c$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$6b3e053f774d2f3c$var$AES.prototype.decryptBlock = function(M) {
    M = $6b3e053f774d2f3c$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $6b3e053f774d2f3c$var$cryptBlock(M, this._invKeySchedule, $6b3e053f774d2f3c$var$G.INV_SUB_MIX, $6b3e053f774d2f3c$var$G.INV_SBOX, this._nRounds);
    var buf = $6b3e053f774d2f3c$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$6b3e053f774d2f3c$var$AES.prototype.scrub = function() {
    $6b3e053f774d2f3c$var$scrubVec(this._keySchedule);
    $6b3e053f774d2f3c$var$scrubVec(this._invKeySchedule);
    $6b3e053f774d2f3c$var$scrubVec(this._key);
};
$6b3e053f774d2f3c$export$b80fbe1c3a2b92b5 = $6b3e053f774d2f3c$var$AES;

});

parcelRegister("1IgSz", function(module, exports) {

var $3VN6j = parcelRequire("3VN6j");
var $13f6fe5cc2e82027$require$Buffer = $3VN6j.Buffer;
var $13f6fe5cc2e82027$var$ZEROES = $13f6fe5cc2e82027$require$Buffer.alloc(16, 0);
function $13f6fe5cc2e82027$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $13f6fe5cc2e82027$var$fromArray(out) {
    var buf = $13f6fe5cc2e82027$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $13f6fe5cc2e82027$var$GHASH(key) {
    this.h = key;
    this.state = $13f6fe5cc2e82027$require$Buffer.alloc(16, 0);
    this.cache = $13f6fe5cc2e82027$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$13f6fe5cc2e82027$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$13f6fe5cc2e82027$var$GHASH.prototype._multiply = function() {
    var Vi = $13f6fe5cc2e82027$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $13f6fe5cc2e82027$var$fromArray(Zi);
};
$13f6fe5cc2e82027$var$GHASH.prototype.update = function(buf) {
    this.cache = $13f6fe5cc2e82027$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$13f6fe5cc2e82027$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($13f6fe5cc2e82027$require$Buffer.concat([
        this.cache,
        $13f6fe5cc2e82027$var$ZEROES
    ], 16));
    this.ghash($13f6fe5cc2e82027$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $13f6fe5cc2e82027$var$GHASH;

});


parcelRegister("74ePQ", function(module, exports) {

var $9cQzZ = parcelRequire("9cQzZ");

var $3VN6j = parcelRequire("3VN6j");
var $52546a16480101c0$require$Buffer = $3VN6j.Buffer;

var $AhG97 = parcelRequire("AhG97");

var $lubO4 = parcelRequire("lubO4");
function $52546a16480101c0$var$StreamCipher(mode, key, iv, decrypt) {
    $AhG97.call(this);
    this._cipher = new $9cQzZ.AES(key);
    this._prev = $52546a16480101c0$require$Buffer.from(iv);
    this._cache = $52546a16480101c0$require$Buffer.allocUnsafe(0);
    this._secCache = $52546a16480101c0$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$lubO4($52546a16480101c0$var$StreamCipher, $AhG97);
$52546a16480101c0$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$52546a16480101c0$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $52546a16480101c0$var$StreamCipher;

});


parcelRegister("fUQom", function(module, exports) {
$parcel$export(module.exports, "createDecipher", () => $b964b9e52ace1f0a$export$12ada9414fbc594c, (v) => $b964b9e52ace1f0a$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $b964b9e52ace1f0a$export$36b6d6ef312eab39, (v) => $b964b9e52ace1f0a$export$36b6d6ef312eab39 = v);
var $b964b9e52ace1f0a$export$12ada9414fbc594c;
var $b964b9e52ace1f0a$export$36b6d6ef312eab39;

var $bshsc = parcelRequire("bshsc");

var $3VN6j = parcelRequire("3VN6j");
var $b964b9e52ace1f0a$require$Buffer = $3VN6j.Buffer;

var $c22JZ = parcelRequire("c22JZ");

var $74ePQ = parcelRequire("74ePQ");

var $AhG97 = parcelRequire("AhG97");

var $9cQzZ = parcelRequire("9cQzZ");

var $7HP4I = parcelRequire("7HP4I");

var $lubO4 = parcelRequire("lubO4");
function $b964b9e52ace1f0a$var$Decipher(mode, key, iv) {
    $AhG97.call(this);
    this._cache = new $b964b9e52ace1f0a$var$Splitter();
    this._last = void 0;
    this._cipher = new $9cQzZ.AES(key);
    this._prev = $b964b9e52ace1f0a$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$lubO4($b964b9e52ace1f0a$var$Decipher, $AhG97);
$b964b9e52ace1f0a$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $b964b9e52ace1f0a$require$Buffer.concat(out);
};
$b964b9e52ace1f0a$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $b964b9e52ace1f0a$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$b964b9e52ace1f0a$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $b964b9e52ace1f0a$var$Splitter() {
    this.cache = $b964b9e52ace1f0a$require$Buffer.allocUnsafe(0);
}
$b964b9e52ace1f0a$var$Splitter.prototype.add = function(data) {
    this.cache = $b964b9e52ace1f0a$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$b964b9e52ace1f0a$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$b964b9e52ace1f0a$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $b964b9e52ace1f0a$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $b964b9e52ace1f0a$var$createDecipheriv(suite, password, iv) {
    var config = $c22JZ[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $b964b9e52ace1f0a$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $b964b9e52ace1f0a$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $74ePQ(config.module, password, iv, true);
    else if (config.type === 'auth') return new $bshsc(config.module, password, iv, true);
    return new $b964b9e52ace1f0a$var$Decipher(config.module, password, iv);
}
function $b964b9e52ace1f0a$var$createDecipher(suite, password) {
    var config = $c22JZ[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $7HP4I(password, false, config.key, config.iv);
    return $b964b9e52ace1f0a$var$createDecipheriv(suite, keys.key, keys.iv);
}
$b964b9e52ace1f0a$export$12ada9414fbc594c = $b964b9e52ace1f0a$var$createDecipher;
$b964b9e52ace1f0a$export$36b6d6ef312eab39 = $b964b9e52ace1f0a$var$createDecipheriv;

});



parcelRegister("cFQaq", function(module, exports) {
$parcel$export(module.exports, "pbkdf2", () => $93a1c7b0002d47c4$export$448fa22aedc9dbca, (v) => $93a1c7b0002d47c4$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $93a1c7b0002d47c4$export$b80c7ba289c8fa56, (v) => $93a1c7b0002d47c4$export$b80c7ba289c8fa56 = v);
var $93a1c7b0002d47c4$export$448fa22aedc9dbca;
var $93a1c7b0002d47c4$export$b80c7ba289c8fa56;
'use strict';

$93a1c7b0002d47c4$export$448fa22aedc9dbca = (parcelRequire("eShhr"));

$93a1c7b0002d47c4$export$b80c7ba289c8fa56 = (parcelRequire("ipzG4"));

});


parcelRegister("b8gBN", function(module, exports) {

var $bsVm9 = parcelRequire("bsVm9");

var $3VN6j = parcelRequire("3VN6j");
var $81ad532bdfd6cb9f$require$Buffer = $3VN6j.Buffer;
module.exports = function(seed, len) {
    var t = $81ad532bdfd6cb9f$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $81ad532bdfd6cb9f$var$i2ops(i++);
        t = $81ad532bdfd6cb9f$require$Buffer.concat([
            t,
            $bsVm9('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $81ad532bdfd6cb9f$var$i2ops(c) {
    var out = $81ad532bdfd6cb9f$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("cAOk6", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("wnnAU", function(module, exports) {

var $6MZ4r = parcelRequire("6MZ4r");

var $3VN6j = parcelRequire("3VN6j");
var $06151ff7558f9d11$require$Buffer = $3VN6j.Buffer;
function $06151ff7558f9d11$var$withPublic(paddedMsg, key) {
    return $06151ff7558f9d11$require$Buffer.from(paddedMsg.toRed($6MZ4r.mont(key.modulus)).redPow(new $6MZ4r(key.publicExponent)).fromRed().toArray());
}
module.exports = $06151ff7558f9d11$var$withPublic;

});

parcelRegister("g4fKB", function(module, exports) {
'use strict';

var $dj5fD = parcelRequire("dj5fD");

var $72pt0 = parcelRequire("72pt0");

var $3VN6j = parcelRequire("3VN6j");
var $bb293cd6f59962e3$require$Buffer = $3VN6j.Buffer;
function $bb293cd6f59962e3$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $dj5fD($72pt0(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $bb293cd6f59962e3$var$blind(priv) {
    var r = $bb293cd6f59962e3$var$getr(priv);
    var blinder = r.toRed($dj5fD.mont(priv.modulus)).redPow(new $dj5fD(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $bb293cd6f59962e3$var$crt(msg, priv) {
    var blinds = $bb293cd6f59962e3$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $dj5fD(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($dj5fD.mont(priv.prime1));
    var c2 = blinded.toRed($dj5fD.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($bb293cd6f59962e3$require$Buffer, 'be', len);
}
$bb293cd6f59962e3$var$crt.getr = $bb293cd6f59962e3$var$getr;
module.exports = $bb293cd6f59962e3$var$crt;

});


parcelRegister("1sZKu", function(module, exports) {

var $8GoMl = parcelRequire("8GoMl");

var $b8gBN = parcelRequire("b8gBN");

var $cAOk6 = parcelRequire("cAOk6");

var $6MZ4r = parcelRequire("6MZ4r");

var $g4fKB = parcelRequire("g4fKB");

var $bsVm9 = parcelRequire("bsVm9");

var $wnnAU = parcelRequire("wnnAU");

var $3VN6j = parcelRequire("3VN6j");
var $11184e007c484462$require$Buffer = $3VN6j.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $8GoMl(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $6MZ4r(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $wnnAU(new $6MZ4r(enc), key);
    else msg = $g4fKB(enc, key);
    var zBuffer = $11184e007c484462$require$Buffer.alloc(k - msg.length);
    msg = $11184e007c484462$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $11184e007c484462$var$oaep(key, msg);
    else if (padding === 1) return $11184e007c484462$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $11184e007c484462$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $bsVm9('sha1').update($11184e007c484462$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $cAOk6(maskedSeed, $b8gBN(maskedDb, hLen));
    var db = $cAOk6(maskedDb, $b8gBN(seed, k - hLen - 1));
    if ($11184e007c484462$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $11184e007c484462$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $11184e007c484462$var$compare(a, b) {
    a = $11184e007c484462$require$Buffer.from(a);
    b = $11184e007c484462$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});

$parcel$global.rwr("kpJNO", () => { 
var $2hRE7 = parcelRequire("2hRE7");
var $766861cd6455b608$exports = {};
'use strict';
function $766861cd6455b608$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($766861cd6455b608$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$766861cd6455b608$var$checkDCE();

$766861cd6455b608$exports = (parcelRequire("507zh"));



var $2hRE7 = parcelRequire("2hRE7");

var $2hRE7 = parcelRequire("2hRE7");
const $15f344f9545a569e$export$a7b0697657ed8bd0 = /*#__PURE__*/ (0, $2hRE7.createContext)({
    start () {},
    succeed () {},
    fail () {},
    abort () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    },
    getExperienceState () {
        return null;
    },
    updateAttributes () {},
    attachDebugPoint () {}
});
function $15f344f9545a569e$export$f88dde183f4d31cb(WrappedComponent) {
    const withExperienceTracker = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($15f344f9545a569e$export$a7b0697657ed8bd0.Consumer, null, (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement(WrappedComponent, {
                ...props,
                experienceTracker: value
            }));
    withExperienceTracker.displayName = `withExperienceTracker(${WrappedComponent.displayName || WrappedComponent.name})`;
    return withExperienceTracker;
}



var $aLoS2 = parcelRequire("aLoS2");
var $c29b43bb0df96673$exports = {};
var $8620f91002fd03c7$exports = {};
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $8620f91002fd03c7$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($8620f91002fd03c7$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $8620f91002fd03c7$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    $8620f91002fd03c7$exports = function whatwgRNG() {
        $8620f91002fd03c7$var$getRandomValues($8620f91002fd03c7$var$rnds8);
        return $8620f91002fd03c7$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $8620f91002fd03c7$var$rnds = new Array(16);
    $8620f91002fd03c7$exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $8620f91002fd03c7$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $8620f91002fd03c7$var$rnds;
    };
}


var $0eb3fc9f8addfeea$exports = {};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $0eb3fc9f8addfeea$var$byteToHex = [];
for(var $0eb3fc9f8addfeea$var$i = 0; $0eb3fc9f8addfeea$var$i < 256; ++$0eb3fc9f8addfeea$var$i)$0eb3fc9f8addfeea$var$byteToHex[$0eb3fc9f8addfeea$var$i] = ($0eb3fc9f8addfeea$var$i + 0x100).toString(16).substr(1);
function $0eb3fc9f8addfeea$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $0eb3fc9f8addfeea$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
$0eb3fc9f8addfeea$exports = $0eb3fc9f8addfeea$var$bytesToUuid;


function $c29b43bb0df96673$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $8620f91002fd03c7$exports)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $0eb3fc9f8addfeea$exports(rnds);
}
$c29b43bb0df96673$exports = $c29b43bb0df96673$var$v4;


const $4bbad620418b05ff$export$9c05e7ef9f2c8895 = (event)=>({
        // Events should match the schema defined here:
        // https://hello.atlassian.net/wiki/spaces/BIZOPS/pages/387788554/Analytics+Event+Schema+for+SLA
        source: 'ui',
        actionSubject: 'ui',
        action: event.action,
        eventType: 'operational',
        attributes: $4bbad620418b05ff$var$createExperienceTrackerAnalyticsAttributes(event)
    });
function $4bbad620418b05ff$var$createExperienceTrackerAnalyticsAttributes(event) {
    const { action: action, name: name, id: id, attributes: experienceAttributes, ...rest } = event;
    const attributes = {
        ...experienceAttributes,
        ...rest,
        task: name,
        taskId: id
    };
    if (attributes.error) {
        let error;
        if (typeof attributes.error === 'string') error = new Error(attributes.error);
        else error = attributes.error;
        delete attributes.error;
        attributes.errorName = error.name;
        if (!attributes.traceId && error.traceId) attributes.traceId = error.traceId;
        attributes.errorMessage = error.message;
    }
    attributes.browserInfo = window.navigator.userAgent;
    // Matches the analytics-web-client's apdex event
    attributes.isActiveTab = document.visibilityState === 'visible';
    return attributes;
}


/**
 *  Data Services - Analytics Web Client for E-MAU
 *  url to the JIRA ticket (https://product-fabric.atlassian.net/browse/CFEA-16)
 *  source code (https://bitbucket.org/atlassian/analytics-web-client)
 */ // import uuid from 'uuid/v4';
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
var $b9a40c449374f876$exports = {};
var $17e46adde5bc9684$exports = {};
var $5e492d2fdb4a2805$exports = {};
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $5e492d2fdb4a2805$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($5e492d2fdb4a2805$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $5e492d2fdb4a2805$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    $5e492d2fdb4a2805$exports = function whatwgRNG() {
        $5e492d2fdb4a2805$var$getRandomValues($5e492d2fdb4a2805$var$rnds8);
        return $5e492d2fdb4a2805$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $5e492d2fdb4a2805$var$rnds = new Array(16);
    $5e492d2fdb4a2805$exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $5e492d2fdb4a2805$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $5e492d2fdb4a2805$var$rnds;
    };
}


var $d06337b288336fbf$exports = {};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $d06337b288336fbf$var$byteToHex = [];
for(var $d06337b288336fbf$var$i = 0; $d06337b288336fbf$var$i < 256; ++$d06337b288336fbf$var$i)$d06337b288336fbf$var$byteToHex[$d06337b288336fbf$var$i] = ($d06337b288336fbf$var$i + 0x100).toString(16).substr(1);
function $d06337b288336fbf$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $d06337b288336fbf$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
$d06337b288336fbf$exports = $d06337b288336fbf$var$bytesToUuid;


// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $17e46adde5bc9684$var$_nodeId;
var $17e46adde5bc9684$var$_clockseq;
// Previous uuid creation time
var $17e46adde5bc9684$var$_lastMSecs = 0;
var $17e46adde5bc9684$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $17e46adde5bc9684$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $17e46adde5bc9684$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $17e46adde5bc9684$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $5e492d2fdb4a2805$exports();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $17e46adde5bc9684$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $17e46adde5bc9684$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $17e46adde5bc9684$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $17e46adde5bc9684$var$_lastMSecs + (nsecs - $17e46adde5bc9684$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $17e46adde5bc9684$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $17e46adde5bc9684$var$_lastMSecs = msecs;
    $17e46adde5bc9684$var$_lastNSecs = nsecs;
    $17e46adde5bc9684$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $d06337b288336fbf$exports(b);
}
$17e46adde5bc9684$exports = $17e46adde5bc9684$var$v1;


var $9ef336c085dd15cc$exports = {};


function $9ef336c085dd15cc$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $5e492d2fdb4a2805$exports)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $d06337b288336fbf$exports(rnds);
}
$9ef336c085dd15cc$exports = $9ef336c085dd15cc$var$v4;


var $b9a40c449374f876$var$uuid = $9ef336c085dd15cc$exports;
$b9a40c449374f876$var$uuid.v1 = $17e46adde5bc9684$exports;
$b9a40c449374f876$var$uuid.v4 = $9ef336c085dd15cc$exports;
$b9a40c449374f876$exports = $b9a40c449374f876$var$uuid;


/**
 * This file converts between Base64 and Base 64 Encoding with URL and Filename Safe Alphabet,
 * the latter of which has URL-safe characters only (drops =, + and /).
 *
 * Why not use a library? The popular libs use Buffer to be able to
 * encode any data to base64. We don't need this capability, and it causes
 * Webpack to include 30KB of a Buffer polyfill.
 * Webpack's/UglifyJS's Tree Shaking seems to be unable to drop it.
 *
 * See: RFC 4648 section 5 (https://tools.ietf.org/html/rfc4648#section-5)
 */ function $37f794eccff7439c$export$3b91e21dac1023c6(base64) {
    if (base64 == null) return '';
    return String(base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function $37f794eccff7439c$export$47c5265a25535d02(base64url) {
    if (base64url == null) return '';
    const base64 = String(base64url).replace(/-/g, '+').replace(/_/g, '/');
    const padLength = (4 - base64url.length % 4) % 4;
    const pad = '==='.slice(0, padLength);
    return base64 + pad;
}



var $2zYso = parcelRequire("2zYso");


const $947ce68258e6900c$export$d3cd91e0fdbfdbc0 = ()=>({
        atob: // atob/btoa need to be bound because they throw an illegal invocation error when called as a method (obj.atob())
        typeof atob === 'function' && atob.bind(undefined) || typeof (0, $2zYso.Buffer) !== 'undefined' && ((encoded)=>(0, $2zYso.Buffer).from(encoded, 'base64').toString()),
        btoa: typeof btoa === 'function' && btoa.bind(undefined) || typeof (0, $2zYso.Buffer) !== 'undefined' && ((str)=>(0, $2zYso.Buffer).from(str).toString('base64')),
        URLSearchParams: typeof URLSearchParams === 'function' && URLSearchParams || (parcelRequire("2cRRf")).URLSearchParams,
        URL: typeof URL === 'function' && URL || (parcelRequire("2cRRf")).URL
    });
let $947ce68258e6900c$var$env;
const $947ce68258e6900c$export$4bd44a2aa29d3d6e = ()=>$947ce68258e6900c$var$env || ($947ce68258e6900c$var$env = $947ce68258e6900c$var$validateEnv($947ce68258e6900c$export$d3cd91e0fdbfdbc0()));
const $947ce68258e6900c$var$validateEnv = (env)=>{
    if (!(env.atob && env.btoa && env.URLSearchParams && env.URL)) throw new TypeError(`Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).`);
    return env;
};


const $2dfd68b3683b01ed$var$productShorthands = {
    confluence: 'c',
    jira: 'j',
    stride: 's',
    bitbucket: 'b',
    trello: 't'
};
function $2dfd68b3683b01ed$export$c564cdbbe6da493(originData) {
    const json = JSON.stringify($2dfd68b3683b01ed$export$4bc4b533a565aabe(originData));
    const base64 = (0, $947ce68258e6900c$export$4bd44a2aa29d3d6e)().btoa(json);
    return (0, $37f794eccff7439c$export$3b91e21dac1023c6)(base64);
}
function $2dfd68b3683b01ed$export$2f872c0f2117be69(encodedOriginString) {
    const base64 = (0, $37f794eccff7439c$export$47c5265a25535d02)(encodedOriginString);
    const json = (0, $947ce68258e6900c$export$4bd44a2aa29d3d6e)().atob(base64);
    return $2dfd68b3683b01ed$export$46d5cda6b884b7ab(JSON.parse(json));
}
function $2dfd68b3683b01ed$export$4bc4b533a565aabe({ id: id, product: product }) {
    return {
        i: id,
        p: product && product in $2dfd68b3683b01ed$var$productShorthands ? $2dfd68b3683b01ed$var$productShorthands[product] : product
    };
}
function $2dfd68b3683b01ed$export$46d5cda6b884b7ab(originJSONObject) {
    const originData = {};
    if (originJSONObject.i) originData.id = originJSONObject.i;
    if (originJSONObject.p) originData.product = $2dfd68b3683b01ed$var$expandProductShorthand(originJSONObject.p);
    return originData;
}
function $2dfd68b3683b01ed$var$expandProductShorthand(maybeShorthand) {
    const products = Object.keys($2dfd68b3683b01ed$var$productShorthands);
    for(let i = 0; i < products.length; i++){
        const product = products[i];
        const shorthand = $2dfd68b3683b01ed$var$productShorthands[product];
        if (maybeShorthand === shorthand) return product;
    }
    return maybeShorthand;
}



const $8842ba9e63d2c9a2$var$packageVersion = "0.0.0-use.local";
const $8842ba9e63d2c9a2$var$originParamName = 'atlOrigin';
const $8842ba9e63d2c9a2$var$originVersioningAttributes = {
    originLibrary: `origin-tracing.js@${$8842ba9e63d2c9a2$var$packageVersion}`
};
class $8842ba9e63d2c9a2$export$2e2bcd8739ae039 {
    static isValidId(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
    }
    static isValidProduct(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
    }
    static generateId() {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, $b9a40c449374f876$exports.v4)();
        // Dash positions are fixed so they don't add to uniqueness.
        // Remove them to save space in the encoded form.
        return id.replace(/-/g, '');
    }
    static createEmpty() {
        return new $8842ba9e63d2c9a2$var$EmptyOriginTracer();
    }
    static createMalformed() {
        return new $8842ba9e63d2c9a2$var$MalformedOriginTracer();
    }
    static fromUrl(url) {
        let params = new ((0, $947ce68258e6900c$export$4bd44a2aa29d3d6e)()).URLSearchParams();
        $8842ba9e63d2c9a2$var$replaceQuery(url, (queryString)=>{
            params = new ((0, $947ce68258e6900c$export$4bd44a2aa29d3d6e)()).URLSearchParams(queryString);
        });
        return $8842ba9e63d2c9a2$export$2e2bcd8739ae039.fromEncoded(params.get($8842ba9e63d2c9a2$var$originParamName));
    }
    static fromEncoded(encoded) {
        if (!encoded) return $8842ba9e63d2c9a2$export$2e2bcd8739ae039.createEmpty();
        try {
            return $8842ba9e63d2c9a2$export$2e2bcd8739ae039.decode(encoded);
        } catch (e) {
            return $8842ba9e63d2c9a2$export$2e2bcd8739ae039.createMalformed();
        }
    }
    static removeFromUrl(url) {
        return $8842ba9e63d2c9a2$var$replaceQuery(url, (queryString)=>{
            const params = new ((0, $947ce68258e6900c$export$4bd44a2aa29d3d6e)()).URLSearchParams(queryString);
            params.delete($8842ba9e63d2c9a2$var$originParamName);
            return params.toString();
        });
    }
    static decode(encodedOrigin) {
        const originData = (0, $2dfd68b3683b01ed$export$2f872c0f2117be69)(encodedOrigin);
        return new $8842ba9e63d2c9a2$export$2e2bcd8739ae039(originData);
    }
    encode() {
        return (0, $2dfd68b3683b01ed$export$c564cdbbe6da493)({
            id: this.id,
            product: this.product
        });
    }
    addToUrl(url) {
        return $8842ba9e63d2c9a2$var$replaceQuery(url, (originalQueryString)=>{
            const params = new ((0, $947ce68258e6900c$export$4bd44a2aa29d3d6e)()).URLSearchParams(originalQueryString);
            params.set($8842ba9e63d2c9a2$var$originParamName, this.encode());
            return params.toString();
        });
    }
    containsOrigin(urlString) {
        const url = new ((0, $947ce68258e6900c$export$4bd44a2aa29d3d6e)()).URL(urlString);
        const params = new URLSearchParams(url.search);
        return params.has($8842ba9e63d2c9a2$var$originParamName);
    }
    isEmpty() {
        return false;
    }
    isMalformed() {
        return !this.isEmpty() && !this.isValid();
    }
    isValid() {
        return true;
    }
    toAnalyticsAttributes({ transformValue: transformValue = (v)=>v === null ? undefined : v, hasGeneratedId: hasGeneratedId = false } = {}) {
        // `originIdGenerated` should be used in analytic events that generated this originId.
        // Subsequent events should use `originId`.
        // No two events should have the same value of originIdGenerated.
        const originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
        return {
            [originIdProp]: transformValue(this.id),
            originProduct: transformValue(this.product),
            ...$8842ba9e63d2c9a2$var$originVersioningAttributes
        };
    }
    validate() {
        if (!$8842ba9e63d2c9a2$export$2e2bcd8739ae039.isValidId(this.id)) throw new TypeError('Invalid Origin id');
        if (!$8842ba9e63d2c9a2$export$2e2bcd8739ae039.isValidProduct(this.product)) throw new TypeError('Missing/invalid Origin product');
    }
    constructor({ id: id = $8842ba9e63d2c9a2$export$2e2bcd8739ae039.generateId(), product: product, dangerouslySkipValidation: dangerouslySkipValidation = false }){
        this.id = void 0;
        this.product = void 0;
        this.id = id;
        this.product = product;
        if (!dangerouslySkipValidation) this.validate();
    }
}
class $8842ba9e63d2c9a2$var$EmptyOriginTracer extends $8842ba9e63d2c9a2$export$2e2bcd8739ae039 {
    isValid() {
        return false;
    }
    isEmpty() {
        return true;
    }
    toAnalyticsAttributes() {
        return {
            ...$8842ba9e63d2c9a2$var$originVersioningAttributes
        };
    }
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
}
class $8842ba9e63d2c9a2$var$MalformedOriginTracer extends $8842ba9e63d2c9a2$export$2e2bcd8739ae039 {
    isValid() {
        return false;
    }
    isEmpty() {
        return false;
    }
    toAnalyticsAttributes() {
        return {
            originMalformed: true,
            ...$8842ba9e63d2c9a2$var$originVersioningAttributes
        };
    }
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
}
function $8842ba9e63d2c9a2$var$replaceQuery(url, replacer) {
    const urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
    // If we get passed window.location, we don't want to call window.location.replace()
    const urlString = String(url);
    return urlString.replace(urlWithQueryStringRegex, (_wholeMatch, beforeQuery, queryString, afterQuery)=>{
        let newQueryString = replacer(queryString);
        if (newQueryString) newQueryString = `?${newQueryString}`;
        return `${beforeQuery}${newQueryString}${afterQuery}`;
    });
}



var $deE7Q = parcelRequire("deE7Q");

var $kzZXs = parcelRequire("kzZXs");
let $c086cef45a2cc129$export$3dcce53a3755dc8c;
const $c086cef45a2cc129$export$57d3cdb500cb5402 = (agent)=>{
    if (agent) $c086cef45a2cc129$export$3dcce53a3755dc8c = agent;
    else if (typeof window !== 'undefined' && window.navigator) $c086cef45a2cc129$export$3dcce53a3755dc8c = window.navigator.userAgent;
};
const $c086cef45a2cc129$export$aad8462122ac592b = ()=>{
    $c086cef45a2cc129$export$3dcce53a3755dc8c = undefined;
};
const $c086cef45a2cc129$export$b7d78993b74f766d = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Firefox/') !== -1;
};
const $c086cef45a2cc129$export$c87f7e935aea4901 = ()=>{
    return !$c086cef45a2cc129$export$b7d78993b74f766d();
};
const $c086cef45a2cc129$export$552b0ed0b7a8f620 = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Edge/') !== -1;
};
const $c086cef45a2cc129$export$bf319670985f797f = ()=>{
    return !$c086cef45a2cc129$export$552b0ed0b7a8f620();
};
const $c086cef45a2cc129$export$7e7b1a9668aaed8 = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('MSIE') !== -1 || $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Trident/') !== -1 || $c086cef45a2cc129$export$552b0ed0b7a8f620();
};
const $c086cef45a2cc129$export$a9ab798d36ba46c = ()=>{
    return !$c086cef45a2cc129$export$7e7b1a9668aaed8();
};
const $c086cef45a2cc129$export$6446a186d09e379e = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Chrome/') !== -1;
};
const $c086cef45a2cc129$export$23ee57a84a15eab5 = ()=>{
    return !$c086cef45a2cc129$export$6446a186d09e379e();
};
const $c086cef45a2cc129$export$95df08bae54cb4df = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Safari/') !== -1 && $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Chrome/') === -1;
};
const $c086cef45a2cc129$export$bc187e33086c8385 = ()=>{
    return !$c086cef45a2cc129$export$95df08bae54cb4df();
};
const $c086cef45a2cc129$export$7b405d3c2ef63516 = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('PhantomJS') !== -1;
};
const $c086cef45a2cc129$export$f11fe2ca946efdb2 = ()=>{
    return !$c086cef45a2cc129$export$7b405d3c2ef63516();
};
const $c086cef45a2cc129$export$6d5620528cf86fa2 = ()=>{
    return !!$c086cef45a2cc129$export$3dcce53a3755dc8c && ($c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Confluence iOS/') !== -1 || $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Confluence Android/') !== -1);
};
const $c086cef45a2cc129$export$83d89fbfd8236492 = ()=>{
    let versionMatch;
    if ($c086cef45a2cc129$export$7e7b1a9668aaed8()) versionMatch = $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/MSIE\s([\d.]+)/) || $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/rv:([\d.]+)/) || $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/Edge\/([\d.]+)/);
    else if ($c086cef45a2cc129$export$6446a186d09e379e()) versionMatch = $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/Chrome\/([\d.]+)/);
    else if ($c086cef45a2cc129$export$95df08bae54cb4df()) versionMatch = $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/Version\/([\d.]+)/);
    else if ($c086cef45a2cc129$export$b7d78993b74f766d()) versionMatch = $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/Firefox\/([\d.]+)/);
    return versionMatch && parseInt(versionMatch[1]);
};
const $c086cef45a2cc129$export$f52e1a142ed579d = ()=>{
    if ($c086cef45a2cc129$export$552b0ed0b7a8f620()) return 'MSEdge';
    if ($c086cef45a2cc129$export$7e7b1a9668aaed8()) return 'IE';
    if ($c086cef45a2cc129$export$6446a186d09e379e()) return 'Chrome';
    if ($c086cef45a2cc129$export$95df08bae54cb4df()) return 'Safari';
    if ($c086cef45a2cc129$export$b7d78993b74f766d()) return 'Firefox';
};


var $477e019f2b5e6422$export$1e511d4a378977f5;
var $477e019f2b5e6422$export$2e2bcd8739ae039;
'use strict';
$477e019f2b5e6422$export$1e511d4a378977f5 = true;
var $477e019f2b5e6422$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $477e019f2b5e6422$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $3ad7f8c8e251eaf8$exports = {};
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $3ad7f8c8e251eaf8$var$warning = function() {};
$3ad7f8c8e251eaf8$exports = $3ad7f8c8e251eaf8$var$warning;


var $477e019f2b5e6422$var$_warning2 = $477e019f2b5e6422$var$_interopRequireDefault($3ad7f8c8e251eaf8$exports);

var $1etGW = parcelRequire("1etGW");
var $477e019f2b5e6422$var$_invariant2 = $477e019f2b5e6422$var$_interopRequireDefault($1etGW);
var $8f47cb9e5c14e83a$export$1e511d4a378977f5;
var $8f47cb9e5c14e83a$export$c3e8bb440bd55b18;
var $8f47cb9e5c14e83a$export$90c043f1c57770b8;
'use strict';
$8f47cb9e5c14e83a$export$1e511d4a378977f5 = true;
$8f47cb9e5c14e83a$export$c3e8bb440bd55b18 = $8f47cb9e5c14e83a$export$90c043f1c57770b8 = undefined;
var $8f47cb9e5c14e83a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $affb96385603b672$exports = {};

$parcel$defineInteropFlag($affb96385603b672$exports);
$parcel$export($affb96385603b672$exports, "default", () => $affb96385603b672$export$2e2bcd8739ae039);
function $affb96385603b672$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $affb96385603b672$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $affb96385603b672$var$resolvePathname(to) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $affb96385603b672$var$isAbsolute(to);
    var isFromAbs = from && $affb96385603b672$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $affb96385603b672$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash = void 0;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $affb96385603b672$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $affb96385603b672$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $affb96385603b672$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$affb96385603b672$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $affb96385603b672$export$2e2bcd8739ae039 = $affb96385603b672$var$resolvePathname;


var $8f47cb9e5c14e83a$var$_resolvePathname2 = $8f47cb9e5c14e83a$var$_interopRequireDefault($affb96385603b672$exports);
var $1251071b4f9f7ce8$exports = {};

$parcel$defineInteropFlag($1251071b4f9f7ce8$exports);
$parcel$export($1251071b4f9f7ce8$exports, "default", () => $1251071b4f9f7ce8$export$2e2bcd8739ae039);
var $1251071b4f9f7ce8$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $1251071b4f9f7ce8$var$valueEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $1251071b4f9f7ce8$var$valueEqual(item, b[index]);
    });
    var aType = typeof a === 'undefined' ? 'undefined' : $1251071b4f9f7ce8$var$_typeof(a);
    var bType = typeof b === 'undefined' ? 'undefined' : $1251071b4f9f7ce8$var$_typeof(b);
    if (aType !== bType) return false;
    if (aType === 'object') {
        var aValue = a.valueOf();
        var bValue = b.valueOf();
        if (aValue !== a || bValue !== b) return $1251071b4f9f7ce8$var$valueEqual(aValue, bValue);
        var aKeys = Object.keys(a);
        var bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        return aKeys.every(function(key) {
            return $1251071b4f9f7ce8$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $1251071b4f9f7ce8$export$2e2bcd8739ae039 = $1251071b4f9f7ce8$var$valueEqual;


var $8f47cb9e5c14e83a$var$_valueEqual2 = $8f47cb9e5c14e83a$var$_interopRequireDefault($1251071b4f9f7ce8$exports);
var $71e1af5b080b12ca$export$1e511d4a378977f5;
var $71e1af5b080b12ca$export$5b4913142e03bca8;
var $71e1af5b080b12ca$export$79c5b1569e3be9e6;
var $71e1af5b080b12ca$export$10497c7ce66fcb84;
var $71e1af5b080b12ca$export$b69e3301ce081aa3;
var $71e1af5b080b12ca$export$d95b4586d238a081;
var $71e1af5b080b12ca$export$8ccf933b0513f8d0;
var $71e1af5b080b12ca$export$fe53371bee54353d;
'use strict';
$71e1af5b080b12ca$export$1e511d4a378977f5 = true;
var $71e1af5b080b12ca$var$addLeadingSlash = $71e1af5b080b12ca$export$5b4913142e03bca8 = function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
};
var $71e1af5b080b12ca$var$stripLeadingSlash = $71e1af5b080b12ca$export$79c5b1569e3be9e6 = function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
};
var $71e1af5b080b12ca$var$hasBasename = $71e1af5b080b12ca$export$10497c7ce66fcb84 = function hasBasename(path, prefix) {
    return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};
var $71e1af5b080b12ca$var$stripBasename = $71e1af5b080b12ca$export$b69e3301ce081aa3 = function stripBasename(path, prefix) {
    return $71e1af5b080b12ca$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};
var $71e1af5b080b12ca$var$stripTrailingSlash = $71e1af5b080b12ca$export$d95b4586d238a081 = function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};
var $71e1af5b080b12ca$var$parsePath = $71e1af5b080b12ca$export$8ccf933b0513f8d0 = function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
};
var $71e1af5b080b12ca$var$createPath = $71e1af5b080b12ca$export$fe53371bee54353d = function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
    return path;
};


function $8f47cb9e5c14e83a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8f47cb9e5c14e83a$var$createLocation = $8f47cb9e5c14e83a$export$90c043f1c57770b8 = function createLocation(path, state, key, currentLocation) {
    var location = void 0;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = (0, $71e1af5b080b12ca$export$8ccf933b0513f8d0)(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = $8f47cb9e5c14e83a$var$_extends({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $8f47cb9e5c14e83a$var$_resolvePathname2.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
};
var $8f47cb9e5c14e83a$var$locationsAreEqual = $8f47cb9e5c14e83a$export$c3e8bb440bd55b18 = function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $8f47cb9e5c14e83a$var$_valueEqual2.default)(a.state, b.state);
};



var $b5b0f87adb64f216$exports = {};

$parcel$defineInteropFlag($b5b0f87adb64f216$exports);
$parcel$export($b5b0f87adb64f216$exports, "__esModule", () => $b5b0f87adb64f216$export$1e511d4a378977f5, (v) => $b5b0f87adb64f216$export$1e511d4a378977f5 = v);
$parcel$export($b5b0f87adb64f216$exports, "default", () => $b5b0f87adb64f216$export$2e2bcd8739ae039, (v) => $b5b0f87adb64f216$export$2e2bcd8739ae039 = v);
var $b5b0f87adb64f216$export$1e511d4a378977f5;
var $b5b0f87adb64f216$export$2e2bcd8739ae039;
'use strict';
$b5b0f87adb64f216$export$1e511d4a378977f5 = true;

var $b5b0f87adb64f216$var$_warning2 = $b5b0f87adb64f216$var$_interopRequireDefault($3ad7f8c8e251eaf8$exports);
function $b5b0f87adb64f216$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b5b0f87adb64f216$var$createTransitionManager = function createTransitionManager() {
    var prompt = null;
    var setPrompt = function setPrompt(nextPrompt) {
        (0, $b5b0f87adb64f216$var$_warning2.default)(prompt == null, 'A history supports only one prompt at a time');
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    };
    var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else {
                    (0, $b5b0f87adb64f216$var$_warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
                    callback(true);
                }
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    };
    var listeners = [];
    var appendListener = function appendListener(fn) {
        var isActive = true;
        var listener = function listener() {
            if (isActive) fn.apply(undefined, arguments);
        };
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    };
    var notifyListeners = function notifyListeners() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(undefined, args);
        });
    };
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
};
$b5b0f87adb64f216$export$2e2bcd8739ae039 = $b5b0f87adb64f216$var$createTransitionManager;


var $477e019f2b5e6422$var$_createTransitionManager2 = $477e019f2b5e6422$var$_interopRequireDefault($b5b0f87adb64f216$exports);
var $06fa104e4adbc166$export$1e511d4a378977f5;
var $06fa104e4adbc166$export$71594e8a50f746f4;
var $06fa104e4adbc166$export$3f65cefe8380dbea;
var $06fa104e4adbc166$export$8ff9f68337b520c0;
var $06fa104e4adbc166$export$ef38efb4b47d01db;
var $06fa104e4adbc166$export$67fc34576016d6ec;
var $06fa104e4adbc166$export$bd919e6f5f49fb48;
var $06fa104e4adbc166$export$9a5b29ff20eb48f9;
var $06fa104e4adbc166$export$aa3c5b1dd6fed00;
'use strict';
$06fa104e4adbc166$export$1e511d4a378977f5 = true;
var $06fa104e4adbc166$var$canUseDOM = $06fa104e4adbc166$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $06fa104e4adbc166$var$addEventListener = $06fa104e4adbc166$export$3f65cefe8380dbea = function addEventListener(node, event, listener) {
    return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};
var $06fa104e4adbc166$var$removeEventListener = $06fa104e4adbc166$export$8ff9f68337b520c0 = function removeEventListener(node, event, listener) {
    return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};
var $06fa104e4adbc166$var$getConfirmation = $06fa104e4adbc166$export$ef38efb4b47d01db = function getConfirmation(message, callback) {
    return callback(window.confirm(message));
}; // eslint-disable-line no-alert
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ var $06fa104e4adbc166$var$supportsHistory = $06fa104e4adbc166$export$67fc34576016d6ec = function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
};
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ var $06fa104e4adbc166$var$supportsPopStateOnHashChange = $06fa104e4adbc166$export$bd919e6f5f49fb48 = function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
};
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ var $06fa104e4adbc166$var$supportsGoWithoutReloadUsingHash = $06fa104e4adbc166$export$9a5b29ff20eb48f9 = function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
};
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ var $06fa104e4adbc166$var$isExtraneousPopstateEvent = $06fa104e4adbc166$export$aa3c5b1dd6fed00 = function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};


function $477e019f2b5e6422$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $477e019f2b5e6422$var$PopStateEvent = 'popstate';
var $477e019f2b5e6422$var$HashChangeEvent = 'hashchange';
var $477e019f2b5e6422$var$getHistoryState = function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
};
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ var $477e019f2b5e6422$var$createBrowserHistory = function createBrowserHistory() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, $477e019f2b5e6422$var$_invariant2.default)($06fa104e4adbc166$export$71594e8a50f746f4, 'Browser history needs a DOM');
    var globalHistory = window.history;
    var canUseHistory = (0, $06fa104e4adbc166$export$67fc34576016d6ec)();
    var needsHashChangeListener = !(0, $06fa104e4adbc166$export$bd919e6f5f49fb48)();
    var _props$forceRefresh = props.forceRefresh, forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh, _props$getUserConfirm = props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === undefined ? $06fa104e4adbc166$export$ef38efb4b47d01db : _props$getUserConfirm, _props$keyLength = props.keyLength, keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
    var basename = props.basename ? (0, $71e1af5b080b12ca$export$d95b4586d238a081)((0, $71e1af5b080b12ca$export$5b4913142e03bca8)(props.basename)) : '';
    var getDOMLocation = function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        (0, $477e019f2b5e6422$var$_warning2.default)(!basename || (0, $71e1af5b080b12ca$export$10497c7ce66fcb84)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
        if (basename) path = (0, $71e1af5b080b12ca$export$b69e3301ce081aa3)(path, basename);
        return (0, $8f47cb9e5c14e83a$export$90c043f1c57770b8)(path, state, key);
    };
    var createKey = function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    };
    var transitionManager = (0, $477e019f2b5e6422$var$_createTransitionManager2.default)();
    var setState = function setState(nextState) {
        $477e019f2b5e6422$var$_extends(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    };
    var handlePopState = function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ((0, $06fa104e4adbc166$export$aa3c5b1dd6fed00)(event)) return;
        handlePop(getDOMLocation(event.state));
    };
    var handleHashChange = function handleHashChange() {
        handlePop(getDOMLocation($477e019f2b5e6422$var$getHistoryState()));
    };
    var forceNextPop = false;
    var handlePop = function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    };
    var revertPop = function revertPop(fromLocation) {
        var toLocation = history.location;
        // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    };
    var initialLocation = getDOMLocation($477e019f2b5e6422$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ];
    // Public interface
    var createHref = function createHref(location) {
        return basename + (0, $71e1af5b080b12ca$export$fe53371bee54353d)(location);
    };
    var push = function push(path, state) {
        (0, $477e019f2b5e6422$var$_warning2.default)(!((typeof path === 'undefined' ? 'undefined' : $477e019f2b5e6422$var$_typeof(path)) === 'object' && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to push when the 1st argument is a location-like object that already has state; it is ignored");
        var action = 'PUSH';
        var location = (0, $8f47cb9e5c14e83a$export$90c043f1c57770b8)(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else {
                (0, $477e019f2b5e6422$var$_warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
                window.location.href = href;
            }
        });
    };
    var replace = function replace(path, state) {
        (0, $477e019f2b5e6422$var$_warning2.default)(!((typeof path === 'undefined' ? 'undefined' : $477e019f2b5e6422$var$_typeof(path)) === 'object' && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to replace when the 1st argument is a location-like object that already has state; it is ignored");
        var action = 'REPLACE';
        var location = (0, $8f47cb9e5c14e83a$export$90c043f1c57770b8)(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else {
                (0, $477e019f2b5e6422$var$_warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
                window.location.replace(href);
            }
        });
    };
    var go = function go(n) {
        globalHistory.go(n);
    };
    var goBack = function goBack() {
        return go(-1);
    };
    var goForward = function goForward() {
        return go(1);
    };
    var listenerCount = 0;
    var checkDOMListeners = function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1) {
            (0, $06fa104e4adbc166$export$3f65cefe8380dbea)(window, $477e019f2b5e6422$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) (0, $06fa104e4adbc166$export$3f65cefe8380dbea)(window, $477e019f2b5e6422$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            (0, $06fa104e4adbc166$export$8ff9f68337b520c0)(window, $477e019f2b5e6422$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) (0, $06fa104e4adbc166$export$8ff9f68337b520c0)(window, $477e019f2b5e6422$var$HashChangeEvent, handleHashChange);
        }
    };
    var isBlocked = false;
    var block = function block() {
        var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    };
    var listen = function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    };
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
};
$477e019f2b5e6422$export$2e2bcd8739ae039 = $477e019f2b5e6422$var$createBrowserHistory;



var $aLoS2 = parcelRequire("aLoS2");
let $efe75065bf034d65$var$browserHistoryListener = null;
const $efe75065bf034d65$export$39f750fd76b05ae3 = (newBrowserHistoryListener)=>{
    $efe75065bf034d65$var$browserHistoryListener = newBrowserHistoryListener;
    return ()=>{
        $efe75065bf034d65$var$browserHistoryListener = null;
    };
};
const $efe75065bf034d65$export$1ddb08151d15bc78 = (0, $aLoS2.default)(()=>{
    const browserHistory = (0, $477e019f2b5e6422$export$2e2bcd8739ae039)();
    browserHistory.listen((location, action)=>{
        $efe75065bf034d65$var$browserHistoryListener?.(location, action);
    });
    return browserHistory;
});


// The build information here are populated by the code inlined in the bootstrapping HTML
// They can be found in:
// - packages/confluence-frontend-server/templates/*
function $f3f8c1a227f13835$var$getReleaseTrack() {
    try {
        // This value overrides the track as "dev". Helpful for when
        // end-to-end tests are run from dev machine against a production instance.
        // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (sessionStorage.getItem('confluence.telemetry-dev-track-override')) return 'dev';
    } catch  {
    // no-op
    }
    return 'prod';
}
function $f3f8c1a227f13835$export$4ea39b9726d98a51() {
    const injectedBuildInfo = window.__buildInfo || {};
    let { FRONTEND_VERSION: FRONTEND_VERSION, BUILD_VARIANT: BUILD_VARIANT } = injectedBuildInfo;
    if (!FRONTEND_VERSION) FRONTEND_VERSION = '';
    if (!BUILD_VARIANT) BUILD_VARIANT = '';
    const FRONTEND_VERSION_PATTERN = /^([^-]+)-(.+)-(\d+)$/;
    const match = FRONTEND_VERSION_PATTERN.exec(FRONTEND_VERSION);
    return {
        FRONTEND_VERSION: match ? FRONTEND_VERSION : 'UNKNOWN-unknown-0',
        BRANCH_NAME: match ? match[2] : 'unknown',
        BUILD_NUMBER: match ? parseInt(match[3], 10) : 0,
        BUILD_DATE: injectedBuildInfo.BUILD_DATE || 0,
        BUILD_VARIANT: BUILD_VARIANT,
        PUBLIC_PATH: injectedBuildInfo.PUBLIC_PATH || 'unknown',
        RELEASE_TRACK: $f3f8c1a227f13835$var$getReleaseTrack(),
        IS_BIFROST: window.__IS_BIFROST__ || false,
        MULTI_THREAD: window.__IS_MULTITHREADED_RUNTIME__ || false,
        RUNTIME_VERSION: window.__SSR_RUNTIME_VERSION__ || 'unknown',
        IS_BY_SSR_SHADOW: window.__SSR_IS_IN_SHADOW__ || false
    };
}


const $cd3135dd152096aa$var$PromiseStatus = Symbol.for('PromiseStatus');
const $cd3135dd152096aa$var$PromiseValue = Symbol.for('PromiseValue');
const $cd3135dd152096aa$export$cc373701aed148fc = (promise)=>{
    const newPromise = promise.then((value)=>{
        newPromise[$cd3135dd152096aa$var$PromiseStatus] = 'resolved';
        newPromise[$cd3135dd152096aa$var$PromiseValue] = value;
        return value;
    }, (error)=>{
        newPromise[$cd3135dd152096aa$var$PromiseStatus] = 'rejected';
        newPromise[$cd3135dd152096aa$var$PromiseValue] = error;
        throw error;
    });
    newPromise[$cd3135dd152096aa$var$PromiseStatus] = 'pending';
    return newPromise;
};
const $cd3135dd152096aa$export$b1a2a6bd0c6f9666 = (liftedPromise)=>liftedPromise[$cd3135dd152096aa$var$PromiseStatus] === 'resolved';
const $cd3135dd152096aa$export$bf7199a9ebcb84a9 = (liftedPromise)=>liftedPromise[$cd3135dd152096aa$var$PromiseValue];



var $6oQI4 = parcelRequire("6oQI4");
var $0067f33686f0fdf7$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $0067f33686f0fdf7$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $0067f33686f0fdf7$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $0067f33686f0fdf7$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $0067f33686f0fdf7$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $0067f33686f0fdf7$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    CategoryStorageType["IndexedDB"] = "IndexedDB";
    return CategoryStorageType;
}({});
var $0067f33686f0fdf7$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    Status["ERROR"] = "ERROR";
    return Status;
}({});
var $0067f33686f0fdf7$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});



var $eWNrv = parcelRequire("eWNrv");

var $6oQI4 = parcelRequire("6oQI4");

/**
 * Internal numeric log level. Higher = more verbose; a Logger method fires
 * when the resolved level is `>=` its own. Not exported from the package's
 * public entry — consumers use `PackageLogLevel` instead.
 */ var $71e8c7b45d8212b5$export$243e62d78d3b544d = /*#__PURE__*/ function(LogLevel) {
    LogLevel[LogLevel["SILENT"] = 0] = "SILENT";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["INFO"] = 3] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 4] = "DEBUG";
    return LogLevel;
}({});
const $71e8c7b45d8212b5$export$97d4c6871900dcac = 1;
const $71e8c7b45d8212b5$var$PACKAGE_LOG_LEVEL_BY_STRING = {
    silent: 0,
    error: 1,
    warn: 2,
    info: 3,
    debug: 4
};
const $71e8c7b45d8212b5$export$6b31b02af0747fdf = (value)=>{
    if (value === undefined) return null;
    return $71e8c7b45d8212b5$var$PACKAGE_LOG_LEVEL_BY_STRING[value] ?? null;
};


/**
 * Returns the active log level for the BSC Logger, resolved from (in order):
 * developer cookie override, consumer init param, or `DEFAULT_LOG_LEVEL`.
 *
 * The first call resolves and caches; subsequent calls return the cached
 * value. `initializeGlobalState` invalidates the cache via
 * `resetLogLevelCache()` so an init that runs after the first Logger call
 * still picks up the consumer's `packageLogLevel`.
 *
 * SSR caveat: `cachedLogLevel` is a module-level singleton, so in a shared
 * Node module cache it persists across requests. Both `initializeGlobalState`
 * and `clearGlobalState` call `resetLogLevelCache()`, so per-request init and
 * teardown keep it correct — one request's resolved level cannot leak into the
 * next.
 */ let $79053f52f58eeaa6$var$cachedLogLevel;
const $79053f52f58eeaa6$export$5461380538f47d52 = ()=>{
    if ($79053f52f58eeaa6$var$cachedLogLevel !== undefined) return $79053f52f58eeaa6$var$cachedLogLevel;
    $79053f52f58eeaa6$var$cachedLogLevel = $79053f52f58eeaa6$var$readDebugCookieOverride() ?? $79053f52f58eeaa6$var$readInitParamLogLevel() ?? (0, $71e8c7b45d8212b5$export$97d4c6871900dcac);
    return $79053f52f58eeaa6$var$cachedLogLevel;
};
const $79053f52f58eeaa6$export$977223726df102da = ()=>{
    $79053f52f58eeaa6$var$cachedLogLevel = undefined;
};
/**
 * Returns `LogLevel.DEBUG` when the dev override is active (cookie set AND
 * the safety-net FF is enabled), else `null`. The FF gate lets us remotely
 * disable the cookie path if it ever misbehaves.
 *
 * The cookie is checked BEFORE the feature gate on purpose: `fg` is only ever
 * evaluated when the (rare, dev-only) `atl-bsc-debug-mode` cookie is present.
 * This keeps `Logger.*` calls — including ones that run at module-load time
 * (e.g. the AtlIndexedDb singleton) — from calling `fg` during a plain import.
 * Otherwise importing BSC crashes any consumer whose test mocks `fg` with a
 * not-yet-initialized factory variable ("Cannot access 'mockFg' before
 * initialization").
 */ const $79053f52f58eeaa6$var$readDebugCookieOverride = ()=>{
    let debugCookieSet = false;
    try {
        debugCookieSet = (0, $eWNrv.default).get('atl-bsc-debug-mode') === 'true';
    } catch  {
        // Cookie access can throw in sandboxed iframes / strict cookie policies.
        return null;
    }
    if (!debugCookieSet) return null;
    return (0, $6oQI4.fg)('platform_moonjelly_bsc_debug_mode') ? (0, $71e8c7b45d8212b5$export$243e62d78d3b544d).DEBUG : null;
};
/**
 * Returns the LogLevel corresponding to the consumer's `packageLogLevel` init
 * param, or `null` if unset or unrecognized.
 */ const $79053f52f58eeaa6$var$readInitParamLogLevel = ()=>{
    return (0, $71e8c7b45d8212b5$export$6b31b02af0747fdf)((0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().packageLogLevel);
};


let $d9b5d31a7ff7454b$var$analyticsEnabledGlobalState;
let $d9b5d31a7ff7454b$var$productGlobalState;
let $d9b5d31a7ff7454b$var$perimeterGlobalState;
let $d9b5d31a7ff7454b$var$webStorageControlsEnabledGlobalState;
let $d9b5d31a7ff7454b$var$indexedDbControlsEnabledGlobalState;
let $d9b5d31a7ff7454b$var$disableWebStorageConsentChecksGlobalState;
let $d9b5d31a7ff7454b$var$localConsentModeGlobalState;
let $d9b5d31a7ff7454b$var$packageLogLevelGlobalState;
let $d9b5d31a7ff7454b$var$allowUncategorizedCookiesInOverridesGlobalState;
let $d9b5d31a7ff7454b$var$allowUncategorizedItemsInWebStorageOverridesGlobalState;
let $d9b5d31a7ff7454b$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState;
let $d9b5d31a7ff7454b$var$disableIndexedDbConsentChecksGlobalState;
let $d9b5d31a7ff7454b$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState;
let $d9b5d31a7ff7454b$var$userIdGlobalState;
let $d9b5d31a7ff7454b$var$cloudIdGlobalState;
let $d9b5d31a7ff7454b$var$hasInitialized = false;
let $d9b5d31a7ff7454b$var$cacheLoadedDateGlobalState;
let $d9b5d31a7ff7454b$var$patternFormatGlobalState;
let $d9b5d31a7ff7454b$var$resolvedFlatPatternFileFormatGlobalState;
let $d9b5d31a7ff7454b$var$cookiesCacheLoader;
let $d9b5d31a7ff7454b$var$localStorageCacheLoader;
let $d9b5d31a7ff7454b$var$sessionStorageCacheLoader;
let $d9b5d31a7ff7454b$var$indexedDBCacheLoader;
let $d9b5d31a7ff7454b$var$loadCache = async (storageType)=>{
    switch(storageType){
        case (0, $0067f33686f0fdf7$export$2506b012eb637f61).Cookies:
            return await $d9b5d31a7ff7454b$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $0067f33686f0fdf7$export$2506b012eb637f61).LocalStorage:
            return await $d9b5d31a7ff7454b$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $0067f33686f0fdf7$export$2506b012eb637f61).SessionStorage:
            return await $d9b5d31a7ff7454b$var$sessionStorageCacheLoader?.loadStorageControlsData();
        case (0, $0067f33686f0fdf7$export$2506b012eb637f61).IndexedDB:
            return await $d9b5d31a7ff7454b$var$indexedDBCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
let $d9b5d31a7ff7454b$var$loadCacheMaybeSync = (storageType)=>{
    switch(storageType){
        case (0, $0067f33686f0fdf7$export$2506b012eb637f61).Cookies:
            return $d9b5d31a7ff7454b$var$cookiesCacheLoader?.getStorageControlsDataFromCache() ?? $d9b5d31a7ff7454b$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $0067f33686f0fdf7$export$2506b012eb637f61).LocalStorage:
            return $d9b5d31a7ff7454b$var$localStorageCacheLoader?.getStorageControlsDataFromCache() ?? $d9b5d31a7ff7454b$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $0067f33686f0fdf7$export$2506b012eb637f61).SessionStorage:
            return $d9b5d31a7ff7454b$var$sessionStorageCacheLoader?.getStorageControlsDataFromCache() ?? $d9b5d31a7ff7454b$var$sessionStorageCacheLoader?.loadStorageControlsData();
        case (0, $0067f33686f0fdf7$export$2506b012eb637f61).IndexedDB:
            return $d9b5d31a7ff7454b$var$indexedDBCacheLoader?.getStorageControlsDataFromCache() ?? $d9b5d31a7ff7454b$var$indexedDBCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
const $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28 = ()=>{
    return {
        analyticsEnabled: $d9b5d31a7ff7454b$var$analyticsEnabledGlobalState ?? true,
        product: $d9b5d31a7ff7454b$var$productGlobalState,
        perimeter: $d9b5d31a7ff7454b$var$perimeterGlobalState,
        webStorageEnabled: $d9b5d31a7ff7454b$var$webStorageControlsEnabledGlobalState ?? false,
        indexedDbEnabled: $d9b5d31a7ff7454b$var$indexedDbControlsEnabledGlobalState ?? false,
        disableWebStorageConsentChecks: $d9b5d31a7ff7454b$var$disableWebStorageConsentChecksGlobalState ?? false,
        localConsentMode: $d9b5d31a7ff7454b$var$localConsentModeGlobalState ?? false,
        allowUncategorizedCookiesInOverrides: $d9b5d31a7ff7454b$var$allowUncategorizedCookiesInOverridesGlobalState ?? false,
        allowUncategorizedItemsInWebStorageOverrides: $d9b5d31a7ff7454b$var$allowUncategorizedItemsInWebStorageOverridesGlobalState ?? false,
        allowUncategorizedItemsInIndexedDBOverrides: $d9b5d31a7ff7454b$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState ?? false,
        disableIndexedDbConsentChecks: $d9b5d31a7ff7454b$var$disableIndexedDbConsentChecksGlobalState ?? false,
        __UNSAFE_shouldEnforceKeyForRollout: $d9b5d31a7ff7454b$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState,
        packageLogLevel: $d9b5d31a7ff7454b$var$packageLogLevelGlobalState,
        cookiesCacheLoader: $d9b5d31a7ff7454b$var$cookiesCacheLoader,
        localStorageCacheLoader: $d9b5d31a7ff7454b$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $d9b5d31a7ff7454b$var$sessionStorageCacheLoader,
        indexedDBCacheLoader: $d9b5d31a7ff7454b$var$indexedDBCacheLoader,
        loadCache: $d9b5d31a7ff7454b$var$loadCache,
        loadCacheMaybeSync: $d9b5d31a7ff7454b$var$loadCacheMaybeSync,
        hasInitialized: $d9b5d31a7ff7454b$var$hasInitialized,
        userId: $d9b5d31a7ff7454b$var$userIdGlobalState,
        cloudId: $d9b5d31a7ff7454b$var$cloudIdGlobalState,
        cacheLoadedDate: $d9b5d31a7ff7454b$var$cacheLoadedDateGlobalState,
        patternFormat: $d9b5d31a7ff7454b$var$patternFormatGlobalState
    };
};
const $d9b5d31a7ff7454b$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, loadCacheMaybeSync: overrideLoadCacheMaybeSync, product: overrideProduct })=>{
    if (overrideLoadCache) $d9b5d31a7ff7454b$var$loadCache = overrideLoadCache;
    if (overrideLoadCacheMaybeSync) $d9b5d31a7ff7454b$var$loadCacheMaybeSync = overrideLoadCacheMaybeSync;
    if (overrideProduct) $d9b5d31a7ff7454b$var$productGlobalState = overrideProduct;
};
const $d9b5d31a7ff7454b$export$ac7c2edd09656c05 = ()=>{
    $d9b5d31a7ff7454b$var$analyticsEnabledGlobalState = undefined;
    $d9b5d31a7ff7454b$var$productGlobalState = undefined;
    $d9b5d31a7ff7454b$var$webStorageControlsEnabledGlobalState = undefined;
    $d9b5d31a7ff7454b$var$indexedDbControlsEnabledGlobalState = undefined;
    $d9b5d31a7ff7454b$var$disableWebStorageConsentChecksGlobalState = undefined;
    $d9b5d31a7ff7454b$var$localConsentModeGlobalState = undefined;
    $d9b5d31a7ff7454b$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $d9b5d31a7ff7454b$var$allowUncategorizedItemsInWebStorageOverridesGlobalState = undefined;
    $d9b5d31a7ff7454b$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState = undefined;
    $d9b5d31a7ff7454b$var$disableIndexedDbConsentChecksGlobalState = undefined;
    $d9b5d31a7ff7454b$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState = undefined;
    $d9b5d31a7ff7454b$var$userIdGlobalState = undefined;
    $d9b5d31a7ff7454b$var$cloudIdGlobalState = undefined;
    $d9b5d31a7ff7454b$var$packageLogLevelGlobalState = undefined;
    // Reset the resolved-log-level cache too, so a teardown that clears global state without a
    // following initializeGlobalState() can't bleed the previous request's level into the next.
    (0, $79053f52f58eeaa6$export$977223726df102da)();
    $d9b5d31a7ff7454b$var$cookiesCacheLoader = undefined;
    $d9b5d31a7ff7454b$var$localStorageCacheLoader = undefined;
    $d9b5d31a7ff7454b$var$sessionStorageCacheLoader = undefined;
    $d9b5d31a7ff7454b$var$indexedDBCacheLoader = undefined;
    $d9b5d31a7ff7454b$var$hasInitialized = false;
    $d9b5d31a7ff7454b$var$cacheLoadedDateGlobalState = undefined;
    $d9b5d31a7ff7454b$var$patternFormatGlobalState = undefined;
    $d9b5d31a7ff7454b$var$resolvedFlatPatternFileFormatGlobalState = undefined;
};
function $d9b5d31a7ff7454b$export$725ef39b428c0dc2(updates) {
    if (updates.productGlobalState !== undefined) $d9b5d31a7ff7454b$var$productGlobalState = updates.productGlobalState;
    if (updates.webStorageControlsEnabledGlobalState !== undefined) $d9b5d31a7ff7454b$var$webStorageControlsEnabledGlobalState = updates.webStorageControlsEnabledGlobalState;
    if (updates.indexedDbControlsEnabledGlobalState !== undefined) $d9b5d31a7ff7454b$var$indexedDbControlsEnabledGlobalState = updates.indexedDbControlsEnabledGlobalState;
    if (updates.disableWebStorageConsentChecksGlobalState !== undefined) $d9b5d31a7ff7454b$var$disableWebStorageConsentChecksGlobalState = updates.disableWebStorageConsentChecksGlobalState;
    if (updates.allowUncategorizedCookiesInOverridesGlobalState !== undefined) $d9b5d31a7ff7454b$var$allowUncategorizedCookiesInOverridesGlobalState = updates.allowUncategorizedCookiesInOverridesGlobalState;
    if (updates.allowUncategorizedItemsInWebStorageOverridesGlobalState !== undefined) $d9b5d31a7ff7454b$var$allowUncategorizedItemsInWebStorageOverridesGlobalState = updates.allowUncategorizedItemsInWebStorageOverridesGlobalState;
    if (updates.allowUncategorizedItemsInIndexedDBOverridesGlobalState !== undefined) $d9b5d31a7ff7454b$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState = updates.allowUncategorizedItemsInIndexedDBOverridesGlobalState;
    if (updates.disableIndexedDbConsentChecksGlobalState !== undefined) $d9b5d31a7ff7454b$var$disableIndexedDbConsentChecksGlobalState = updates.disableIndexedDbConsentChecksGlobalState;
    if (updates.__UNSAFE_shouldEnforceKeyForRolloutGlobalState !== undefined) $d9b5d31a7ff7454b$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState = updates.__UNSAFE_shouldEnforceKeyForRolloutGlobalState;
    if (updates.localConsentModeGlobalState !== undefined) $d9b5d31a7ff7454b$var$localConsentModeGlobalState = updates.localConsentModeGlobalState;
    if (updates.analyticsEnabledGlobalState !== undefined) $d9b5d31a7ff7454b$var$analyticsEnabledGlobalState = updates.analyticsEnabledGlobalState;
    if (updates.perimeterGlobalState !== undefined) $d9b5d31a7ff7454b$var$perimeterGlobalState = updates.perimeterGlobalState;
    if (updates.cookiesCacheLoader !== undefined) $d9b5d31a7ff7454b$var$cookiesCacheLoader = updates.cookiesCacheLoader;
    if (updates.localStorageCacheLoader !== undefined) $d9b5d31a7ff7454b$var$localStorageCacheLoader = updates.localStorageCacheLoader;
    if (updates.sessionStorageCacheLoader !== undefined) $d9b5d31a7ff7454b$var$sessionStorageCacheLoader = updates.sessionStorageCacheLoader;
    if (updates.indexedDBCacheLoader !== undefined) $d9b5d31a7ff7454b$var$indexedDBCacheLoader = updates.indexedDBCacheLoader;
    if (updates.packageLogLevelGlobalState !== undefined) $d9b5d31a7ff7454b$var$packageLogLevelGlobalState = updates.packageLogLevelGlobalState;
    if (updates.hasInitialized !== undefined) $d9b5d31a7ff7454b$var$hasInitialized = updates.hasInitialized;
    if (updates.cloudIdGlobalState !== undefined) $d9b5d31a7ff7454b$var$cloudIdGlobalState = updates.cloudIdGlobalState;
    if (updates.userIdGlobalState !== undefined) $d9b5d31a7ff7454b$var$userIdGlobalState = updates.userIdGlobalState;
}
function $d9b5d31a7ff7454b$export$f9550288b9b1f6e3() {
    return $d9b5d31a7ff7454b$var$patternFormatGlobalState;
}
function $d9b5d31a7ff7454b$export$f10a7691f1fb3cb(patternFormat) {
    if ($d9b5d31a7ff7454b$var$patternFormatGlobalState === undefined) $d9b5d31a7ff7454b$var$patternFormatGlobalState = patternFormat;
}
function $d9b5d31a7ff7454b$export$8bf1367cc4bb66da() {
    return $d9b5d31a7ff7454b$var$resolvedFlatPatternFileFormatGlobalState;
}
function $d9b5d31a7ff7454b$export$2bd306fd2b97e710(value) {
    if ($d9b5d31a7ff7454b$var$resolvedFlatPatternFileFormatGlobalState === undefined) $d9b5d31a7ff7454b$var$resolvedFlatPatternFileFormatGlobalState = value;
}
function $d9b5d31a7ff7454b$export$8835d45f445e6ba4() {
    return $d9b5d31a7ff7454b$var$hasInitialized;
}
function $d9b5d31a7ff7454b$export$9dfdd17bbd03b460() {
    return $d9b5d31a7ff7454b$var$productGlobalState;
}
function $d9b5d31a7ff7454b$export$d96c3b0fb6d35c5d() {
    return $d9b5d31a7ff7454b$var$webStorageControlsEnabledGlobalState;
}
function $d9b5d31a7ff7454b$export$c8554d68c78456d3() {
    return $d9b5d31a7ff7454b$var$indexedDbControlsEnabledGlobalState;
}
function $d9b5d31a7ff7454b$export$ea650e4f51ec84d8() {
    return $d9b5d31a7ff7454b$var$disableWebStorageConsentChecksGlobalState;
}
function $d9b5d31a7ff7454b$export$fa1f6ebb49ec4b30() {
    return $d9b5d31a7ff7454b$var$allowUncategorizedCookiesInOverridesGlobalState;
}
function $d9b5d31a7ff7454b$export$b60c6437117dfaf9() {
    return $d9b5d31a7ff7454b$var$allowUncategorizedItemsInWebStorageOverridesGlobalState;
}
function $d9b5d31a7ff7454b$export$cff869f7e58c9036() {
    return $d9b5d31a7ff7454b$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState;
}
function $d9b5d31a7ff7454b$export$45364c2f8f3ebde3() {
    return $d9b5d31a7ff7454b$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState;
}
function $d9b5d31a7ff7454b$export$491d0e6c401a0697(date) {
    if ($d9b5d31a7ff7454b$var$cacheLoadedDateGlobalState === undefined) $d9b5d31a7ff7454b$var$cacheLoadedDateGlobalState = date;
}
function $d9b5d31a7ff7454b$export$ea32fe1e8610fd3b() {
    return $d9b5d31a7ff7454b$var$disableIndexedDbConsentChecksGlobalState;
}


var $1HmhQ = parcelRequire("1HmhQ");

var $6oQI4 = parcelRequire("6oQI4");
const $ff92312187da7e87$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $6oQI4.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $1HmhQ.default));
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};


var $1HmhQ = parcelRequire("1HmhQ");

var $juSGQ = parcelRequire("juSGQ");

const $5300b8f30864be2d$export$5e28bf885ebebfa6 = '[browser-storage-controls]';
const $5300b8f30864be2d$export$aeb1f5aa1188ce28 = 5000; // min gap between sends of the same action
const $5300b8f30864be2d$export$ee3d07c2528881e2 = 10; // hard cap per action per page load


const $c2e74d6a59751acd$export$9345d7360ffe0722 = "platform-pkg" ?? '';
const $c2e74d6a59751acd$export$91546b032799aa40 = "0.0.0-use.local" ?? '';




class $2e138c904e2dba50$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
    constructor(){
        this.cache = void 0;
    }
}


const $6b05843765249583$export$69a3209f1a06c04d = new (0, $2e138c904e2dba50$export$b886edaf6623554a)();



const $bdbd165d893737d9$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 100,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    indexDbSetRecordError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1,
    usedAtlIndexedDBOpen: 100,
    usedAtlIndexedDBOpenError: 1,
    usedAtlIndexedDBOpenStrictlyNecessary: 100,
    usedAtlIndexedDBOpenStrictlyNecessaryError: 1,
    bscInitControlsParameters: 1000,
    setItemWithoutInit: 1000,
    uncategorizedWebStorageItemSet: 100,
    browserExtensionKeysAllowed: 100,
    storageCleanupCategorized: 100,
    storageCleanupDeleted: 100,
    storageCleanupError: 1,
    detectPerimeterError: 1,
    usedAtlBrowserStorageSetItemBscDisabled: 100,
    usedSetCookieMasterKillswitch: 100,
    cookieConsentPreferences: 1,
    cookieConsentModal: 1,
    cookieConsentBanner: 1,
    preferences: 1,
    onlyNecessary: 1,
    acceptAll: 1,
    cookiesTrackingNotice: 1,
    confirm: 1,
    performanceConsent: 1,
    functionalConsent: 1,
    targetingConsent: 1,
    cancel: 1,
    close: 1,
    background: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $bdbd165d893737d9$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $bdbd165d893737d9$var$loadSamplingConfig() {
    if ((0, $6b05843765249583$export$69a3209f1a06c04d).cachedSamplingConfig) return (0, $6b05843765249583$export$69a3209f1a06c04d).cachedSamplingConfig;
    if ((0, $ff92312187da7e87$export$48d7c418edadb60c)()) return undefined;
    const { loadCache: loadCache } = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)();
    const controlsData = await loadCache((0, $0067f33686f0fdf7$export$2506b012eb637f61).Cookies);
    const analyticsSamplingRatioConfigs = controlsData?.analyticsSamplingRatio;
    (0, $6b05843765249583$export$69a3209f1a06c04d).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $bdbd165d893737d9$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($bdbd165d893737d9$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $bdbd165d893737d9$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $bdbd165d893737d9$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $bdbd165d893737d9$export$1138592b3c099377;
    const samplingRatio = samplingConfig?.[analyticsEventKey] !== undefined ? samplingConfig[analyticsEventKey] : $bdbd165d893737d9$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $bdbd165d893737d9$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
       ________
      /\       \
     /()\   ()  \
    /    \_______\
    \    /()     /
     \()/   ()  /
      \/_____()/
  */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $bdbd165d893737d9$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $bdbd165d893737d9$export$b286f5e8716d11ad(analyticsEventKey);
    $bdbd165d893737d9$export$dc2f0946255b3f89(ratio, cb);
}


const $61449d71f1ebd90f$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.') || hostname.includes('.jira-dev.') || hostname.includes('.jira-stg.')) return (0, $juSGQ.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $juSGQ.envType).DEV;
    return (0, $juSGQ.envType).PROD;
};
const $61449d71f1ebd90f$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $61449d71f1ebd90f$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $61449d71f1ebd90f$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $61449d71f1ebd90f$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $61449d71f1ebd90f$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $61449d71f1ebd90f$var$decorateEventAttributes = (attributes)=>{
    const { domain: domain, product: product } = $61449d71f1ebd90f$export$fce3dd735e04d566();
    return {
        packageName: $c2e74d6a59751acd$export$9345d7360ffe0722,
        packageVersion: $c2e74d6a59751acd$export$91546b032799aa40,
        domain: domain,
        product: (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().product?.toLowerCase() ?? product,
        ...attributes && attributes
    };
};
const $61449d71f1ebd90f$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().analyticsEnabled) {
                instance = new (0, $1HmhQ.default)({
                    env: $61449d71f1ebd90f$var$getEnvironment(),
                    product: 'atlassianCookies'
                }, {
                    // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                    // When set to false, the client will use a stargate proxy for the current URL to send events
                    // to GAS. Said another way:
                    // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                    // false => events are sent to <the current domain>/gasv3/api/v1/batch
                    //
                    // By default, this should be set to false.  If you need to validate that analytics events
                    // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                    // won't be able to proxy to GAS via stargate.
                    useLegacyUrl: false,
                    disableCookiePersistence: true
                });
                if ((0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().cloudId) instance.setTenantInfo((0, $juSGQ.tenantType).CLOUD_ID, (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().cloudId);
                if ((0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().userId) instance.setUserInfo((0, $juSGQ.userType).ATLASSIAN_ACCOUNT, (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().userId ?? '');
            }
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            // eslint-disable-next-line no-console
            console.error(`${(0, $5300b8f30864be2d$export$5e28bf885ebebfa6)}: Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $61449d71f1ebd90f$export$5bfe55348e7aebc1(properties) {
    (0, $bdbd165d893737d9$export$67b6e87f323cb6ad)(properties.action, ()=>$61449d71f1ebd90f$export$fde53e78fd93a54d()?.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $61449d71f1ebd90f$var$decorateEventAttributes(properties.attributes)
        }));
}
function $61449d71f1ebd90f$export$c986f0e7f985d67f(properties) {
    $61449d71f1ebd90f$export$fde53e78fd93a54d()?.sendOperationalEvent({
        source: 'package',
        actionSubject: 'package',
        action: properties.action,
        attributes: $61449d71f1ebd90f$var$decorateEventAttributes(properties.attributes)
    });
}
function $61449d71f1ebd90f$export$1aecf263098db667(properties) {
    (0, $bdbd165d893737d9$export$67b6e87f323cb6ad)(properties.actionSubjectId, ()=>$61449d71f1ebd90f$export$fde53e78fd93a54d()?.sendUIEvent({
            ...properties,
            attributes: $61449d71f1ebd90f$var$decorateEventAttributes(properties.attributes)
        }));
}
function $61449d71f1ebd90f$export$22a3b1671f38a193(properties) {
    (0, $bdbd165d893737d9$export$67b6e87f323cb6ad)(properties.name, ()=>$61449d71f1ebd90f$export$fde53e78fd93a54d()?.sendScreenEvent({
            ...properties,
            attributes: $61449d71f1ebd90f$var$decorateEventAttributes(properties.attributes)
        }));
}
function $61449d71f1ebd90f$export$1ba525b8a711eaac(properties) {
    const { onSent: onSent, ...eventProperties } = properties;
    (0, $bdbd165d893737d9$export$67b6e87f323cb6ad)(properties.actionSubject, ()=>{
        const client = $61449d71f1ebd90f$export$fde53e78fd93a54d();
        if (!client) // No client means nothing was emitted, so we must not run onSent
        return;
        client.sendTrackEvent({
            ...eventProperties,
            attributes: $61449d71f1ebd90f$var$decorateEventAttributes(properties.attributes)
        });
        onSent?.();
    });
}


/* eslint-disable no-console */ 



// Per-process (per page load) throttle state, keyed by operational event action.
// Resets naturally on page reload because module state is re-initialised, which gives
// us the "per session" semantic for free (same pattern as bsc-global-state).
const $515c8a254ad7c29d$var$throttleState = new Map();
function $515c8a254ad7c29d$export$e54335114720f029(action) {
    const now = Date.now();
    const entry = $515c8a254ad7c29d$var$throttleState.get(action);
    if (!entry) {
        // First occurrence of this action this session always sends.
        $515c8a254ad7c29d$var$throttleState.set(action, {
            lastSentAt: now,
            sentCount: 1
        });
        return true;
    }
    if (entry.sentCount >= (0, $5300b8f30864be2d$export$ee3d07c2528881e2)) // Hard per-session cap reached — drop regardless of elapsed time.
    return false;
    if (now - entry.lastSentAt < (0, $5300b8f30864be2d$export$aeb1f5aa1188ce28)) // Within the cooldown window since the last send for this action.
    return false;
    entry.lastSentAt = now;
    entry.sentCount += 1;
    return true;
}
function $515c8a254ad7c29d$export$a5ff37ede5ff9625() {
    $515c8a254ad7c29d$var$throttleState.clear();
}



const $aa62d0d0c1b0df43$var$formatMetadata = (metadata)=>{
    if (!metadata) return '';
    // `LoggingMetadata` allows a bare string; emit it as-is rather than running it
    // through JSON.stringify, which would wrap it in extra quotes ("error-code" -> '"error-code"').
    return typeof metadata === 'string' ? metadata : JSON.stringify(metadata);
};
class $aa62d0d0c1b0df43$export$efa9a398d6368992 {
    // Console output is controlled solely by the resolved log level. `DEFAULT_LOG_LEVEL` is ERROR,
    // so info/warn/debug stay silent unless a consumer raises `packageLogLevel` or a developer sets
    // the `atl-bsc-debug-mode` cookie. ERROR output is intentionally always on.
    //
    // Keep these guards free of `fg` calls: `Logger.*` runs at module-load time in some consumers
    // (e.g. the AtlIndexedDb singleton), and evaluating a feature gate during a plain import breaks
    // consumers whose tests mock `fg` with a not-yet-initialized factory variable. The one gate this
    // path can still reach is handled in determine-log-level.ts, which checks its cookie first.
    static info(message, metadata) {
        if ((0, $79053f52f58eeaa6$export$5461380538f47d52)() >= (0, $71e8c7b45d8212b5$export$243e62d78d3b544d).INFO) console.info(`${(0, $5300b8f30864be2d$export$5e28bf885ebebfa6)}: ${message}`, $aa62d0d0c1b0df43$var$formatMetadata(metadata));
    }
    static warn(message, metadata) {
        if ((0, $79053f52f58eeaa6$export$5461380538f47d52)() >= (0, $71e8c7b45d8212b5$export$243e62d78d3b544d).WARN) console.warn(`${(0, $5300b8f30864be2d$export$5e28bf885ebebfa6)}: ${message}`, $aa62d0d0c1b0df43$var$formatMetadata(metadata));
    }
    static error(message, metadata) {
        if ((0, $79053f52f58eeaa6$export$5461380538f47d52)() >= (0, $71e8c7b45d8212b5$export$243e62d78d3b544d).ERROR) console.error(`${(0, $5300b8f30864be2d$export$5e28bf885ebebfa6)}: ${message}`, $aa62d0d0c1b0df43$var$formatMetadata(metadata));
    }
    static debug(message, metadata) {
        if ((0, $79053f52f58eeaa6$export$5461380538f47d52)() >= (0, $71e8c7b45d8212b5$export$243e62d78d3b544d).DEBUG) console.debug(`${(0, $5300b8f30864be2d$export$5e28bf885ebebfa6)}: DEBUG ${message}`, $aa62d0d0c1b0df43$var$formatMetadata(metadata));
    }
    /**
   * Sends an unsampled operational event to backend telemetry and also emits the message via
   * `Logger.error`. The telemetry send is throttled per-action (see error-event-throttle). The
   * console output is always at ERROR level (subject to the resolved log level).
   */ static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            // shouldSendErrorEvent records the send and limits per-action volume, so a repeatedly
            // failing call site cannot flood telemetry with duplicate events.
            if ((0, $515c8a254ad7c29d$export$e54335114720f029)(action)) (0, $61449d71f1ebd90f$export$c986f0e7f985d67f)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata);
    }
}



var $4a82c714b0d3c5be$export$259e3a861f28589b = /*#__PURE__*/ function(WebStorageType) {
    WebStorageType["LocalStorage"] = "LocalStorage";
    WebStorageType["SessionStorage"] = "SessionStorage";
    return WebStorageType;
}({});




const $b558ecfd4bee7980$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};


var $6oQI4 = parcelRequire("6oQI4");


var $6oQI4 = parcelRequire("6oQI4");


const $7bc7e96d097eef26$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $7bc7e96d097eef26$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $7bc7e96d097eef26$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $7bc7e96d097eef26$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $7bc7e96d097eef26$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $7bc7e96d097eef26$export$37073d560ecebada = 'atl-testing-consents';
const $7bc7e96d097eef26$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
const $7bc7e96d097eef26$export$b28b5d760fe14a21 = {
    [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).StrictlyNecessary]: true,
    [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Functional]: true,
    [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Marketing]: true,
    [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Analytics]: true,
    [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Unknown]: true // Includes uncategorized cookies
};
const $7bc7e96d097eef26$export$4a12f9e99971760a = {
    [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).StrictlyNecessary]: true,
    [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Functional]: false,
    [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Marketing]: false,
    [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Analytics]: false,
    [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Unknown]: false
};
const $7bc7e96d097eef26$export$f0fd1d13ec1d48f2 = {
    ...$7bc7e96d097eef26$export$4a12f9e99971760a,
    [(0, $0067f33686f0fdf7$export$fac80ad19b60e313).ConsentsAreDefault]: true,
    [(0, $0067f33686f0fdf7$export$fac80ad19b60e313).UserIsAuthenticated]: false,
    [(0, $0067f33686f0fdf7$export$fac80ad19b60e313).ConsentDataUnavailable]: true
};
const $7bc7e96d097eef26$export$f95182b7aa141c57 = '001';
const $7bc7e96d097eef26$export$1f25427b34f9c405 = '002';
const $7bc7e96d097eef26$export$31deaeaebce525bb = '003';




var $eWNrv = parcelRequire("eWNrv");

var $6oQI4 = parcelRequire("6oQI4");


function $abd0f3c27709557c$export$4be65e66cfa2648a(key) {
    if ((0, $6oQI4.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, $eWNrv.default).get(key) : (0, $eWNrv.default).get();
    try {
        (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, $eWNrv.default).get(key) : (0, $eWNrv.default).get();
    } catch (e) {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}




const $6a003dd042b2e8fc$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $abd0f3c27709557c$export$4be65e66cfa2648a)((0, $7bc7e96d097eef26$export$37073d560ecebada));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};


const $9d7ffb24bc821b40$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $9d7ffb24bc821b40$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};




var $eWNrv = parcelRequire("eWNrv");







var $6bfd072d8743b5dc$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});


const $db3834e2337320de$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $7bc7e96d097eef26$export$1f25427b34f9c405);
    return isV2Schema;
};
const $db3834e2337320de$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $7bc7e96d097eef26$export$f95182b7aa141c57);
    return isV1Schema;
};
const $db3834e2337320de$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($db3834e2337320de$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $db3834e2337320de$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV1ConsentToken = $db3834e2337320de$var$isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = $db3834e2337320de$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $db3834e2337320de$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, $9d7ffb24bc821b40$export$27647458f3cf29d2)(consentToken[7]);
    return isDefaultTokenV3;
};
const $db3834e2337320de$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $7bc7e96d097eef26$export$31deaeaebce525bb);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $7bc7e96d097eef26$export$f0fd1d13ec1d48f2)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).StrictlyNecessary) return acc;
        if (key === (0, $0067f33686f0fdf7$export$fac80ad19b60e313).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(userIsAuthed);
        }
        if (key === (0, $0067f33686f0fdf7$export$fac80ad19b60e313).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(!!consentsUnavailable);
        return acc + (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $db3834e2337320de$export$42a0b3fb1e53e7b9 = (consents)=>{
    const version = (0, $7bc7e96d097eef26$export$31deaeaebce525bb);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(!!consents.find((key)=>key.key === (0, $6bfd072d8743b5dc$export$31140359b1e505cf).Functional)?.granted);
    const analyticsConsent = (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(!!consents.find((key)=>key.key === (0, $6bfd072d8743b5dc$export$31140359b1e505cf).Analytics)?.granted);
    const marketingConsent = (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(!!consents.find((key)=>key.key === (0, $6bfd072d8743b5dc$export$31140359b1e505cf).Marketing)?.granted);
    const unknownConsent = (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(!!consents.find((key)=>key.key === (0, $6bfd072d8743b5dc$export$31140359b1e505cf).Unknown)?.granted);
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $db3834e2337320de$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $abd0f3c27709557c$export$4be65e66cfa2648a)((0, $7bc7e96d097eef26$export$23a1e02c3c0b0d08));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $db3834e2337320de$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $db3834e2337320de$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $db3834e2337320de$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $db3834e2337320de$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).StrictlyNecessary,
        (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Functional,
        (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Analytics,
        (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Marketing,
        (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Unknown
    ];
    const consentKeyMap = {
        [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).StrictlyNecessary]: (0, $6bfd072d8743b5dc$export$31140359b1e505cf).StrictlyNecessary,
        [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Functional]: (0, $6bfd072d8743b5dc$export$31140359b1e505cf).Functional,
        [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Analytics]: (0, $6bfd072d8743b5dc$export$31140359b1e505cf).Analytics,
        [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Marketing]: (0, $6bfd072d8743b5dc$export$31140359b1e505cf).Marketing,
        [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Unknown]: (0, $6bfd072d8743b5dc$export$31140359b1e505cf).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $db3834e2337320de$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $db3834e2337320de$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
const $db3834e2337320de$export$7133f415a79804e8 = (preferences)=>{
    if (!preferences) return false;
    const prefetchedToken = 'consentToken' in preferences && preferences.consentToken;
    const prefetchedTokenIsDefault = $db3834e2337320de$export$497a647f0eb30ef4(prefetchedToken || '');
    const hasLegitConsentToken = prefetchedToken && !prefetchedTokenIsDefault;
    const prefetchedConsents = 'consents' in preferences && preferences.consents;
    const hasLegitConsents = prefetchedConsents && Array.isArray(prefetchedConsents) && prefetchedConsents.length > 0;
    return Boolean(hasLegitConsentToken || hasLegitConsents);
};
class $db3834e2337320de$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = void 0;
        this.status = status;
        Object.setPrototypeOf(this, $db3834e2337320de$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $db3834e2337320de$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}








const $93c80f4815c945b3$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $7bc7e96d097eef26$export$f95182b7aa141c57) && consentToken.length === 7;
    const isV002 = version === (0, $7bc7e96d097eef26$export$1f25427b34f9c405) && consentToken.length === 12;
    const isV003 = version === (0, $7bc7e96d097eef26$export$31deaeaebce525bb) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $7bc7e96d097eef26$export$f95182b7aa141c57),
        (0, $7bc7e96d097eef26$export$1f25427b34f9c405),
        (0, $7bc7e96d097eef26$export$31deaeaebce525bb)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $93c80f4815c945b3$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $7bc7e96d097eef26$export$f95182b7aa141c57);
    return [
        version,
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(userPreferences.FUNCTIONAL),
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(userPreferences.ANALYTICS),
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(userPreferences.MARKETING),
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(userPreferences.UNKNOWN)
    ].join('');
};
const $93c80f4815c945b3$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).StrictlyNecessary]: true,
        [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Functional]: userPreferencesCookie[3] === '1',
        [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $93c80f4815c945b3$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $7bc7e96d097eef26$export$31deaeaebce525bb);
    const hasConsentedPreviously = userPreferences[(0, $0067f33686f0fdf7$export$cdef20bac194f235).ConsentedUnderGDPR] || userPreferences[(0, $0067f33686f0fdf7$export$cdef20bac194f235).ConsentedUnderCPRA] || userPreferences[(0, $0067f33686f0fdf7$export$cdef20bac194f235).ConsentedUnderLGPD] || userPreferences[(0, $0067f33686f0fdf7$export$cdef20bac194f235).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $0067f33686f0fdf7$export$fac80ad19b60e313).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(userPreferences[(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Functional]),
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(userPreferences[(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Analytics]),
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(userPreferences[(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Marketing]),
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(userPreferences[(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Unknown]),
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(isDefaultConsentBit),
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(userIsAuthenticatedBit),
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(existingConsentDataUnavailableBit)
    ].join('');
};
const $93c80f4815c945b3$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $db3834e2337320de$export$497a647f0eb30ef4)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$93c80f4815c945b3$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $0067f33686f0fdf7$export$fac80ad19b60e313).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $0067f33686f0fdf7$export$fac80ad19b60e313).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $0067f33686f0fdf7$export$fac80ad19b60e313).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $93c80f4815c945b3$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $7bc7e96d097eef26$export$31deaeaebce525bb);
    return [
        version,
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(userPreferences[(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Functional]),
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(userPreferences[(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Analytics]),
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(userPreferences[(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Marketing]),
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(userPreferences[(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Unknown]),
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(userPreferences[(0, $0067f33686f0fdf7$export$fac80ad19b60e313).ConsentsAreDefault]),
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(userPreferences[(0, $0067f33686f0fdf7$export$fac80ad19b60e313).UserIsAuthenticated]),
        (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(userPreferences[(0, $0067f33686f0fdf7$export$fac80ad19b60e313).ConsentDataUnavailable])
    ].join('');
};
const $93c80f4815c945b3$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).StrictlyNecessary]: true,
        [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Functional]: userPreferencesCookie[3] === '1',
        [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $0067f33686f0fdf7$export$fac80ad19b60e313).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $0067f33686f0fdf7$export$fac80ad19b60e313).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $0067f33686f0fdf7$export$fac80ad19b60e313).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $93c80f4815c945b3$var$V002SpecificBitKeys = [
    (0, $0067f33686f0fdf7$export$fac80ad19b60e313).ConsentDataUnavailable,
    (0, $0067f33686f0fdf7$export$cdef20bac194f235).ConsentedUnderGDPR,
    (0, $0067f33686f0fdf7$export$cdef20bac194f235).ConsentedUnderCPRA,
    (0, $0067f33686f0fdf7$export$cdef20bac194f235).ConsentedUnderLGPD,
    (0, $0067f33686f0fdf7$export$cdef20bac194f235).ConsentedUnderFADP
];
const $93c80f4815c945b3$var$V003SpecificBitKeys = [
    (0, $0067f33686f0fdf7$export$fac80ad19b60e313).ConsentsAreDefault,
    (0, $0067f33686f0fdf7$export$fac80ad19b60e313).UserIsAuthenticated,
    (0, $0067f33686f0fdf7$export$fac80ad19b60e313).ConsentDataUnavailable
];
function $93c80f4815c945b3$export$3199823fec979bd1(userPreferences) {
    if ((0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().localConsentMode) return $93c80f4815c945b3$var$packPrefsVersion001(userPreferences);
    const isV002 = $93c80f4815c945b3$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $93c80f4815c945b3$var$packPrefsVersion002(userPreferences);
    const isV003 = $93c80f4815c945b3$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $93c80f4815c945b3$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $93c80f4815c945b3$var$packPrefsVersion001(userPreferences);
}
function $93c80f4815c945b3$export$8d213cb390bab4fa(userPreferencesCookie) {
    if ((0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $7bc7e96d097eef26$export$f95182b7aa141c57)) return $93c80f4815c945b3$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $93c80f4815c945b3$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $93c80f4815c945b3$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $93c80f4815c945b3$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $93c80f4815c945b3$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $93c80f4815c945b3$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $93c80f4815c945b3$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $0067f33686f0fdf7$export$5d6594a0bba4ab8a).INTERNAL) {
        if ($93c80f4815c945b3$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $93c80f4815c945b3$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $db3834e2337320de$export$92ba0b2fe50f90df)(initialPreferences);
            const unpackedPrefetchedPrefs = $93c80f4815c945b3$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $0067f33686f0fdf7$export$5d6594a0bba4ab8a).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};


const $9fe1ff20bd73d464$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $93c80f4815c945b3$export$64b31470e8522819)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $9fe1ff20bd73d464$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $9fe1ff20bd73d464$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $9d7ffb24bc821b40$export$27647458f3cf29d2)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $db3834e2337320de$export$497a647f0eb30ef4)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $9fe1ff20bd73d464$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $db3834e2337320de$export$497a647f0eb30ef4)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $9fe1ff20bd73d464$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $db3834e2337320de$export$42b0ca8aba2631e4)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $9fe1ff20bd73d464$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $9fe1ff20bd73d464$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $9d7ffb24bc821b40$export$27647458f3cf29d2)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $db3834e2337320de$export$497a647f0eb30ef4)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
        They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
        then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)

        UX Problem:
        Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
        But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
        is infrequent (either via Account Privacy Page or once this fallback expires in a year).

        Example:
        While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
        fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
        because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...

        We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
        to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
        persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.

        Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
        consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year

        Result: Show the banner again and hope we officially recapture consents this time around
      */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $9fe1ff20bd73d464$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $db3834e2337320de$export$497a647f0eb30ef4)(consentToken);
    if (tokenIsADefaultConsent) return $9fe1ff20bd73d464$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $db3834e2337320de$export$3387347b75450ae1)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $9fe1ff20bd73d464$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents }, ssrOptions)=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    // Detect if js-cookie has been replaced with SSR-safe version (Confluence only)
    const isJsCookieSSRSafe = typeof (0, $eWNrv.default).__SSR_INITIALIZE_COOKIES__ === 'function';
    // Jira passes getCookie explicitly via ssrOptions - it works on both SSR and CSR.
    const ssrFriendlyGetCookie = ssrOptions?.getCookie;
    let fallbackConsentToken;
    if (ssrFriendlyGetCookie) fallbackConsentToken = fallbackConsents || ssrFriendlyGetCookie((0, $7bc7e96d097eef26$export$23a1e02c3c0b0d08));
    else fallbackConsentToken = (0, $ff92312187da7e87$export$48d7c418edadb60c)() ? fallbackConsents || (isJsCookieSSRSafe ? (0, $abd0f3c27709557c$export$4be65e66cfa2648a)((0, $7bc7e96d097eef26$export$23a1e02c3c0b0d08)) : undefined) : fallbackConsents || (0, $abd0f3c27709557c$export$4be65e66cfa2648a)((0, $7bc7e96d097eef26$export$23a1e02c3c0b0d08));
    let userIsAuthenticatedBit = $9fe1ff20bd73d464$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $9d7ffb24bc821b40$export$27647458f3cf29d2)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $9fe1ff20bd73d464$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $9fe1ff20bd73d464$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};



var $eWNrv = parcelRequire("eWNrv");

var $6oQI4 = parcelRequire("6oQI4");


const $15e3bb9fc3b96c99$export$93509ff9a62ee022 = (key, value, attributes)=>{
    if ((0, $6oQI4.fg)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, $eWNrv.default).set(key, value, {
        ...attributes,
        'atl-set-cookie': true
    });
    else try {
        if (!(0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().hasInitialized) (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: 'Cookie'
            }
        });
        (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, $eWNrv.default).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
        throw e;
    }
};


const $6dc7a97b7838b6fc$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 50;
const $6dc7a97b7838b6fc$var$MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 70;
const $6dc7a97b7838b6fc$export$6e0b780517c88191 = ()=>{
    // Random offset is 0-20 minutes inclusive, so the final lifetime spreads across 50-70 minutes.
    const randomizedOffsetMinutes = Math.floor(Math.random() * ($6dc7a97b7838b6fc$var$MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES - $6dc7a97b7838b6fc$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + 1));
    // Spread cookie expiration times to smooth traffic spikes to ConsentHub.
    return $6dc7a97b7838b6fc$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + randomizedOffsetMinutes;
};
// Pick once per module load so both required consent cookies share the same spread-out expiry.
const $6dc7a97b7838b6fc$var$RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = $6dc7a97b7838b6fc$export$6e0b780517c88191();
const $6dc7a97b7838b6fc$var$getRequiredConsentCookieExpiryDate = ()=>{
    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + $6dc7a97b7838b6fc$var$RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES * 60000);
    return expiryDate;
};
const $6dc7a97b7838b6fc$export$8e560d0760f733a2 = (consentToken)=>{
    (0, $15e3bb9fc3b96c99$export$93509ff9a62ee022)((0, $7bc7e96d097eef26$export$435de28e5b000487), consentToken, {
        expires: $6dc7a97b7838b6fc$var$getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug(`Set Consent Token ${(0, $7bc7e96d097eef26$export$435de28e5b000487)} ${consentToken}`);
};
const $6dc7a97b7838b6fc$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $15e3bb9fc3b96c99$export$93509ff9a62ee022)((0, $7bc7e96d097eef26$export$23a1e02c3c0b0d08), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug(`set fallback consent token: ${(0, $7bc7e96d097eef26$export$23a1e02c3c0b0d08)} ${consentToken}`);
};
const $6dc7a97b7838b6fc$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $9fe1ff20bd73d464$export$bfdb9f82a9194c1e)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $9d7ffb24bc821b40$export$929f1500428a1fc8)(!!bannerVisibility);
    (0, $15e3bb9fc3b96c99$export$93509ff9a62ee022)((0, $7bc7e96d097eef26$export$4b17acc0e875ba2a), shouldShowBanner, {
        expires: $6dc7a97b7838b6fc$var$getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug(`set shouldShowBannerCookie: ${(0, $7bc7e96d097eef26$export$4b17acc0e875ba2a)} ${shouldShowBanner}`);
};
const $6dc7a97b7838b6fc$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $6dc7a97b7838b6fc$export$8e560d0760f733a2(consentToken);
    $6dc7a97b7838b6fc$export$99ecece88c58d938(consentToken, consentTimestamps);
};




var $6oQI4 = parcelRequire("6oQI4");



const $50507051aab6e1eb$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $50507051aab6e1eb$var$POST_CONSENTS_URL = `${$50507051aab6e1eb$var$BASE_CONSENTS_URL}/user`;
const $50507051aab6e1eb$var$GET_CONSENTS_URL = `${$50507051aab6e1eb$var$POST_CONSENTS_URL}/consents/cookies`;
const $50507051aab6e1eb$var$getConsentHubHeaders = ()=>({
        'Content-Type': 'application/json',
        'X-Request-Origin': 'bsc',
        'X-Request-Origin-App': $50507051aab6e1eb$var$getProductForConsentHubHeader()
    });
const $50507051aab6e1eb$var$getProductForConsentHubHeader = ()=>{
    const product = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().product;
    if (!product || product === 'all') return 'unknown';
    if ((0, $6oQI4.fg)('platform_bsc_consent_hub_x_origin_app_normalized')) // ConsentHub buckets anything that is not lowercase and hyphen-separated as `unknown`.
    return product.toLowerCase().replace(/\s+/g, '-');
    return product;
};
const $50507051aab6e1eb$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $db3834e2337320de$export$92ba0b2fe50f90df)(consentData);
        const consentTimestamp = (0, $db3834e2337320de$export$13e4cff933f26b03)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $db3834e2337320de$export$92ba0b2fe50f90df)({}),
        consentHubInaccessible: true
    };
};
const $50507051aab6e1eb$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$50507051aab6e1eb$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: $50507051aab6e1eb$var$getConsentHubHeaders()
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $50507051aab6e1eb$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $50507051aab6e1eb$export$bd9f5bcbf9cd947c();
    }
};
const $50507051aab6e1eb$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $db3834e2337320de$export$bfa0c91662787fb0)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $50507051aab6e1eb$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$50507051aab6e1eb$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: $50507051aab6e1eb$var$getConsentHubHeaders(),
            body: $50507051aab6e1eb$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $db3834e2337320de$export$a79c0ea3d7c2444a)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};



const $078e18b27635f142$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $50507051aab6e1eb$export$86467566615ab85e)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $93c80f4815c945b3$export$64b31470e8522819)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else {
            const version = (0, $7bc7e96d097eef26$export$31deaeaebce525bb);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        }
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};


/**
 * Module-level cache of the in-flight ConsentHub fetch promise.
 * Cleared as soon as the promise settles (resolved or rejected).
 *
 * Without this, N concurrent callers that all find the consent cookie absent
 * would each independently fire a fetch to ConsentHub, causing a request
 * fan-out on every page load where multiple components call getPreferences()
 * simultaneously.
 */ let $30bde9dc7916d19e$var$inFlightConsentToken = null;
const $30bde9dc7916d19e$var$_getConsentToken = async ()=>{
    const fallbackConsentToken = (0, $abd0f3c27709557c$export$4be65e66cfa2648a)((0, $7bc7e96d097eef26$export$23a1e02c3c0b0d08));
    const consentData = await (0, $078e18b27635f142$export$c515de1cc9cebc71)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $6a003dd042b2e8fc$export$b5282052fc15e1ae)(consentToken);
        const testingConsentOverride = (0, $abd0f3c27709557c$export$4be65e66cfa2648a)((0, $7bc7e96d097eef26$export$37073d560ecebada));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $6dc7a97b7838b6fc$export$99ecece88c58d938)(potentiallyOverriddenConsentToken);
            (0, $6dc7a97b7838b6fc$export$8e560d0760f733a2)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $6dc7a97b7838b6fc$export$b3365240280cb3c3)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};
const $30bde9dc7916d19e$export$f1b8f2ca713fca08 = ()=>{
    // N concurrent callers share a single in-flight promise so only one ConsentHub fetch
    // fires per page load regardless of how many components call getPreferences() simultaneously.
    if ($30bde9dc7916d19e$var$inFlightConsentToken) return $30bde9dc7916d19e$var$inFlightConsentToken;
    $30bde9dc7916d19e$var$inFlightConsentToken = $30bde9dc7916d19e$var$_getConsentToken().finally(()=>{
        $30bde9dc7916d19e$var$inFlightConsentToken = null;
    });
    return $30bde9dc7916d19e$var$inFlightConsentToken;
};




async function $72a0ad571a2b0dec$export$1de6a888ae076ff8() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().localConsentMode) {
        const packedPrefs = (0, $abd0f3c27709557c$export$4be65e66cfa2648a)((0, $7bc7e96d097eef26$export$10d7db8e1a856fd8));
        if (!packedPrefs) return undefined;
        return (0, $93c80f4815c945b3$export$8d213cb390bab4fa)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $abd0f3c27709557c$export$4be65e66cfa2648a)((0, $7bc7e96d097eef26$export$435de28e5b000487));
        if (!packedLocalPrefs) {
            const consentToken = await (0, $30bde9dc7916d19e$export$f1b8f2ca713fca08)();
            if ((0, $ff92312187da7e87$export$48d7c418edadb60c)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $93c80f4815c945b3$export$8d213cb390bab4fa)(consentToken) : undefined;
        }
        return (0, $93c80f4815c945b3$export$8d213cb390bab4fa)(packedLocalPrefs);
    }
}
function $72a0ad571a2b0dec$export$39c2cb6e65c1c16b() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().localConsentMode) {
        const packedPrefs = (0, $abd0f3c27709557c$export$4be65e66cfa2648a)((0, $7bc7e96d097eef26$export$10d7db8e1a856fd8));
        if (!packedPrefs) return undefined;
        return (0, $93c80f4815c945b3$export$8d213cb390bab4fa)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $abd0f3c27709557c$export$4be65e66cfa2648a)((0, $7bc7e96d097eef26$export$435de28e5b000487));
        if (!packedLocalPrefs) return (0, $30bde9dc7916d19e$export$f1b8f2ca713fca08)().then((consentToken)=>{
            if ((0, $ff92312187da7e87$export$48d7c418edadb60c)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $93c80f4815c945b3$export$8d213cb390bab4fa)(consentToken) : undefined;
        });
        else return (0, $93c80f4815c945b3$export$8d213cb390bab4fa)(packedLocalPrefs);
    }
}





// Detects storage writes made by browser extensions so consent enforcement doesn't block them.
// Chromium family (Chrome, Chromium Edge, Brave, Opera) all use `chrome-extension://`.
// Firefox uses `moz-extension://`; Safari uses `safari-web-extension://`.
// `ms-browser-extension://` is the legacy EdgeHTML
const $efbbf032b63c0118$export$99d1f70e3d2681ed = /(chrome-extension|moz-extension|safari-web-extension|ms-browser-extension):\/\/([^/)\s]+)/;
// A frame's script location, minus the `:line:column`. Matches V8's `at fn (url:1:2)` and
// SpiderMonkey/JavaScriptCore's `fn@url:1:2`.
const $efbbf032b63c0118$var$FRAME_LOCATION = /([a-z][a-z0-9+.-]*:\/\/[^\s)]+?)(?::\d+){0,2}\)?$/i;
// A frame line, not the `Error: ` header V8 prefixes the trace with. V8 starts frames with `at `; the
// other engines use `name@url` and emit no header, so filtering keeps indices comparable.
const $efbbf032b63c0118$var$FRAME_LINE = /^at\s|@/;
// How many leading frames can hold the code that made the write. BSC sits 2 frames above the caller —
// `captureCallerSignals` and the override closure — and neither can be inlined away: the closure is the
// value installed on `setItem`/the cookie accessor, and a minifier won't inline a function containing
// try/catch. The capture is deliberately one function for that reason.
//
// Bounding the scan is the point of this module. Matching an extension URL anywhere in the stack also
// matches every write made by Atlassian code that an extension merely called into, which turns the
// extension allowance into a blanket consent bypass for our own writes.
const $efbbf032b63c0118$var$ORIGINATOR_FRAME_WINDOW = 3;
// Nothing past the window is read. V8 defaults to 10 and a product can lower it, so pin it.
const $efbbf032b63c0118$var$CAPTURED_FRAME_LIMIT = 6;
const $efbbf032b63c0118$var$parseFrames = (stack)=>stack.split('\n').map((line)=>line.trim()).filter((line)=>$efbbf032b63c0118$var$FRAME_LINE.test(line));
const $efbbf032b63c0118$var$asExtensionCaller = (frame)=>{
    const extension = frame?.match($efbbf032b63c0118$var$FRAME_LOCATION)?.[1]?.match($efbbf032b63c0118$export$99d1f70e3d2681ed);
    return extension ? {
        scheme: extension[1],
        id: extension[2]
    } : null;
};
const $efbbf032b63c0118$export$d5f56ab842d0792b = (captured)=>{
    const stack = captured?.stack;
    if (!stack) return null;
    for (const frame of $efbbf032b63c0118$var$parseFrames(stack).slice(0, $efbbf032b63c0118$var$ORIGINATOR_FRAME_WINDOW)){
        const caller = $efbbf032b63c0118$var$asExtensionCaller(frame);
        if (caller) return caller;
    }
    return null;
};
const $efbbf032b63c0118$export$9a9299a14dc0c1cb = ()=>{
    try {
        const previousLimit = Error.stackTraceLimit;
        Error.stackTraceLimit = $efbbf032b63c0118$var$CAPTURED_FRAME_LIMIT;
        const stack = new Error();
        Error.stackTraceLimit = previousLimit;
        return {
            stack: stack
        };
    } catch  {
        return {
            stack: new Error()
        };
    }
};
const $efbbf032b63c0118$export$9674893ac982a3cc = (signals)=>signals ? $efbbf032b63c0118$export$d5f56ab842d0792b(signals.stack) : null;



/**
 * Narrows a payload to the layout it declares, so the matchers below can be type-checked against a
 * concrete pattern shape rather than casting.
 *
 * An absent `patternFormat` means the legacy trie layout — the format the CDN serves while the
 * flat-format gate is off, and what a payload fetched by a consumer that predates COOK-632 will be.
 * TypeScript cannot infer that rule, so this is the one place it is asserted.
 */ const $fbf524e7c49c5e71$var$asConcreteCache = (storageControlsData)=>storageControlsData.patternFormat === 'flat' ? storageControlsData : storageControlsData;
/**
 * WeakMap cache for precompiled RegExp objects, keyed by the raw regExp product map.
 * This ensures RegExp strings are compiled at most once per unique cache object.
 */ const $fbf524e7c49c5e71$var$compiledRegExpCache = new WeakMap();
const $fbf524e7c49c5e71$var$compileRegExpPatterns = (rawPatterns)=>{
    if ($fbf524e7c49c5e71$var$compiledRegExpCache.has(rawPatterns)) return $fbf524e7c49c5e71$var$compiledRegExpCache.get(rawPatterns);
    const compiled = [];
    for (const [regexString, category] of Object.entries(rawPatterns))try {
        compiled.push({
            regexp: new RegExp(regexString),
            category: category
        });
    } catch (e) {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn(`BSC: Invalid RegExp pattern "${regexString}" in storage controls cache \u{2014} skipping.`);
    }
    $fbf524e7c49c5e71$var$compiledRegExpCache.set(rawPatterns, compiled);
    return compiled;
};
const $fbf524e7c49c5e71$export$2c141b1c00f3e482 = (itemKey, startsWith)=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const $fbf524e7c49c5e71$export$81a82818a800a999 = (itemKey, compiledPatterns)=>{
    for (const { regexp: regexp, category: category } of compiledPatterns){
        if (regexp.test(itemKey)) return category;
    }
    return null;
};
const $fbf524e7c49c5e71$export$c4a1dd71bbd8954c = (itemKey, endsWith)=>{
    // Return category number if str is found in the trie, otherwise return undefined
    const trieSearch = (str)=>{
        let currentStep = endsWith;
        let foundString = '';
        let terminalNumber;
        for(let i = 0; i < str.length; i++){
            const char = str[i];
            currentStep = currentStep[char];
            if (currentStep === undefined) break;
            foundString += char;
            if (typeof currentStep === 'number') {
                terminalNumber = currentStep;
                break;
            }
        }
        if (foundString === str) // Trie contained the complete string
        return terminalNumber;
        else // Trie did not contain the complete string
        return undefined;
    };
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        const remainderMatch = trieSearch(itemKey.slice(position));
        if (remainderMatch !== undefined) return remainderMatch;
        position++;
    }
    return null;
};
const $fbf524e7c49c5e71$export$915dea35caff63c = (itemKey, startsWith)=>{
    for (const prefix of Object.keys(startsWith)){
        if (itemKey.startsWith(prefix)) return startsWith[prefix];
    }
    return null;
};
const $fbf524e7c49c5e71$export$4381be1b9fd38456 = (itemKey, startsWith)=>{
    let best = null;
    for (const prefix of Object.keys(startsWith)){
        if (itemKey.startsWith(prefix)) {
            if (best === null || prefix.length > best.length) best = {
                category: startsWith[prefix],
                length: prefix.length
            };
        }
    }
    return best;
};
const $fbf524e7c49c5e71$export$495f1917e0bfb98c = (itemKey, endsWith)=>{
    let best = null;
    for (const suffix of Object.keys(endsWith)){
        if (itemKey.endsWith(suffix)) {
            if (best === null || suffix.length > best.length) best = {
                category: endsWith[suffix],
                length: suffix.length
            };
        }
    }
    return best;
};
const $fbf524e7c49c5e71$export$f6f7882079c4a2cb = (itemKey, endsWith)=>{
    for (const suffix of Object.keys(endsWith)){
        if (itemKey.endsWith(suffix)) return endsWith[suffix];
    }
    return null;
};
const $fbf524e7c49c5e71$export$69d5b68d01f4a366 = (itemKey, storageControlsData, productName)=>{
    const downcasedProduct = productName?.toLowerCase();
    let itemCategoryNumber = null;
    const { categories: categories, patterns: patterns } = storageControlsData;
    // The payload states its own format, recorded when it was fetched. Re-evaluating the flat-format
    // rollout gate here could disagree with the gate value that chose the file we actually fetched — an
    // unresolved Statsig client, a stale cross-request SSR cache entry, or a gate flip mid-session — and
    // the losing matcher silently returns null for every pattern rather than erroring. The gate stays
    // the sole input to the *fetch* decision.
    const cache = $fbf524e7c49c5e71$var$asConcreteCache(storageControlsData);
    let productKeys = {
        ...storageControlsData['keys']['all'],
        ...downcasedProduct ? storageControlsData['keys'][downcasedProduct] : {}
    };
    // Find direct match in keys
    if (Object.keys(productKeys).includes(itemKey)) itemCategoryNumber = productKeys[itemKey];
    else if (cache.patternFormat === 'flat') {
        // Flat prefix/suffix maps merge cleanly, because each key is a whole pattern rather than one
        // character of one.
        const productStartsWithPatterns = {
            ...cache.patterns.startsWith['all'],
            ...downcasedProduct ? cache.patterns.startsWith[downcasedProduct] : {}
        };
        const productEndsWithPatterns = {
            ...cache.patterns.endsWith['all'],
            ...downcasedProduct ? cache.patterns.endsWith[downcasedProduct] : {}
        };
        if ((0, $6oQI4.fg)('platform_bsc_longest_pattern_match_wins')) {
            // Longest-match-wins flat path
            const swMatch = $fbf524e7c49c5e71$export$4381be1b9fd38456(itemKey, productStartsWithPatterns);
            if (swMatch !== null) itemCategoryNumber = swMatch.category;
            else {
                const ewMatch = $fbf524e7c49c5e71$export$495f1917e0bfb98c(itemKey, productEndsWithPatterns);
                if (ewMatch !== null) itemCategoryNumber = ewMatch.category;
            }
        } else {
            // First-match flat path (COOK-435)
            itemCategoryNumber = $fbf524e7c49c5e71$export$915dea35caff63c(itemKey, productStartsWithPatterns);
            if (itemCategoryNumber === null) itemCategoryNumber = $fbf524e7c49c5e71$export$f6f7882079c4a2cb(itemKey, productEndsWithPatterns);
        }
    } else {
        // Legacy trie matching path. We search the product trie first and fall back
        // to the 'all' trie; a merged trie is unsafe because a shared first character
        // silently drops the entire 'all' subtree under it (HOT-303432).
        const productStartsWith = downcasedProduct ? cache.patterns.startsWith[downcasedProduct] : undefined;
        const productEndsWith = downcasedProduct ? cache.patterns.endsWith[downcasedProduct] : undefined;
        const allStartsWith = cache.patterns.startsWith['all'];
        const allEndsWith = cache.patterns.endsWith['all'];
        if (productStartsWith) itemCategoryNumber = $fbf524e7c49c5e71$export$2c141b1c00f3e482(itemKey, productStartsWith);
        if (itemCategoryNumber === null && allStartsWith) itemCategoryNumber = $fbf524e7c49c5e71$export$2c141b1c00f3e482(itemKey, allStartsWith);
        if (itemCategoryNumber === null && productEndsWith) itemCategoryNumber = $fbf524e7c49c5e71$export$c4a1dd71bbd8954c(itemKey, productEndsWith);
        if (itemCategoryNumber === null && allEndsWith) itemCategoryNumber = $fbf524e7c49c5e71$export$c4a1dd71bbd8954c(itemKey, allEndsWith);
    }
    // RegExp fallback, applied to both the flat and legacy trie pattern paths
    if (itemCategoryNumber === null) {
        const rawRegExpPatterns = {
            ...patterns.regexp?.['all'],
            ...downcasedProduct ? patterns.regexp?.[downcasedProduct] : {}
        };
        const compiledPatterns = $fbf524e7c49c5e71$var$compileRegExpPatterns(rawRegExpPatterns);
        itemCategoryNumber = $fbf524e7c49c5e71$export$81a82818a800a999(itemKey, compiledPatterns);
    }
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Functional,
        [categories.ANALYTICS]: (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Analytics,
        [categories.MARKETING]: (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Marketing,
        [categories.UNKNOWN]: (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Unknown
    };
    // A matcher can hand back a value that is not a category number when the payload's shape does
    // not match the matcher in use, so the lookup misses. Coalesce that miss to `null` to honour
    // the declared `PreferenceCategory | null` return type; callers treat `null` as uncategorized.
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] ?? null : null;
};
const $fbf524e7c49c5e71$export$ec8ce5237293e4a4 = async (itemKey, storageType, productName)=>{
    const storageControlsData = await (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().loadCache(storageType);
    if (!storageControlsData) return null;
    else return $fbf524e7c49c5e71$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
};
const $fbf524e7c49c5e71$export$4369c812aac99591 = (value)=>value != null && typeof value.then === 'function';
const $fbf524e7c49c5e71$export$68b935e7ddb93762 = (itemKey, storageType, productName)=>{
    const storageControlsDataOrPromise = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().loadCacheMaybeSync(storageType);
    if ($fbf524e7c49c5e71$export$4369c812aac99591(storageControlsDataOrPromise)) return storageControlsDataOrPromise.then((storageControlsData)=>{
        if (!storageControlsData) return null;
        else return $fbf524e7c49c5e71$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
    });
    if (!storageControlsDataOrPromise) return null;
    else return $fbf524e7c49c5e71$export$69d5b68d01f4a366(itemKey, storageControlsDataOrPromise, productName);
};
function $fbf524e7c49c5e71$var$getEffectiveCategory(category) {
    if (category === null) return (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Marketing;
    return category;
}
function $fbf524e7c49c5e71$var$isProcessingAllowedForCategoryAndPreferenceSync(category, preferences) {
    const effectiveCategory = $fbf524e7c49c5e71$var$getEffectiveCategory(category);
    if (!!preferences) {
        if (!!effectiveCategory) return preferences[effectiveCategory];
    }
    return false;
}
/**
 * Given an item category and a promise or object of user preferences, determines whether the item can be set.
 * It avoids only returns a promise if we need the preference data to determine the result, otherwise it returns synchronously.
 *
 * DO NOT CONVERT THIS FUNCTION TO ASYNC - as async functions always return a promise, breaking read-after-write consistency for clients that have already loaded the cache.
 */ function $fbf524e7c49c5e71$var$isProcessingAllowedForCategoryMaybeSync(itemCategory, preferencesOrPromise) {
    if (itemCategory === (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).StrictlyNecessary) return {
        itemCategory: itemCategory,
        shouldProcessItem: true
    };
    if ($fbf524e7c49c5e71$export$4369c812aac99591(preferencesOrPromise)) return preferencesOrPromise.then((prefs)=>{
        return {
            itemCategory: itemCategory,
            shouldProcessItem: $fbf524e7c49c5e71$var$isProcessingAllowedForCategoryAndPreferenceSync(itemCategory, prefs)
        };
    });
    else return {
        itemCategory: itemCategory,
        shouldProcessItem: $fbf524e7c49c5e71$var$isProcessingAllowedForCategoryAndPreferenceSync(itemCategory, preferencesOrPromise)
    };
}
const $fbf524e7c49c5e71$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync = ({ itemKey: itemKey, storageType: storageType, productName: productName })=>{
    // start fetching both promises upfront, so they can resolve in parallel if needed
    const itemCategoryOrPromise = $fbf524e7c49c5e71$export$68b935e7ddb93762(itemKey, storageType, productName);
    const preferencesOrPromise = (0, $72a0ad571a2b0dec$export$39c2cb6e65c1c16b)();
    if ($fbf524e7c49c5e71$export$4369c812aac99591(itemCategoryOrPromise)) return itemCategoryOrPromise.then((category)=>$fbf524e7c49c5e71$var$isProcessingAllowedForCategoryMaybeSync(category, preferencesOrPromise));
    else return $fbf524e7c49c5e71$var$isProcessingAllowedForCategoryMaybeSync(itemCategoryOrPromise, preferencesOrPromise);
};
const $fbf524e7c49c5e71$export$ffbb879d3fefb45c = ({ itemKey: itemKey, storageType: storageType, productName: productName, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, extensionSignals: extensionSignals })=>{
    const categoryAndPreferenceOrPromise = $fbf524e7c49c5e71$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    if ((0, $6oQI4.fg)('platform_bsc_catch_deferred_storage_errors')) {
        const handleDecision = ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory }, wasAsync)=>{
            if (shouldProcessItem) {
                allowedCallback?.({
                    wasAsync: wasAsync
                });
                return shouldProcessItem;
            }
            // Check if blocked item is from extension
            const extensionCaller = itemCategory === null ? (0, $efbbf032b63c0118$export$9674893ac982a3cc)(extensionSignals) : null;
            if (extensionCaller) {
                (0, $61449d71f1ebd90f$export$1ba525b8a711eaac)({
                    source: 'package',
                    action: 'package',
                    actionSubject: 'browserExtensionKeysAllowed',
                    attributes: {
                        itemKey: itemKey,
                        storageType: storageType,
                        productName: productName,
                        extensionScheme: extensionCaller.scheme
                    }
                });
                allowedCallback?.({
                    wasAsync: wasAsync
                });
                return true;
            }
            blockedCallback?.({
                itemHasCategory: itemCategory != null,
                itemCategory: itemCategory,
                wasAsync: wasAsync
            });
            return shouldProcessItem;
        };
        if ($fbf524e7c49c5e71$export$4369c812aac99591(categoryAndPreferenceOrPromise)) return categoryAndPreferenceOrPromise.then((categoryAndPreference)=>handleDecision(categoryAndPreference, true));
        else return handleDecision(categoryAndPreferenceOrPromise, false);
    }
    if ($fbf524e7c49c5e71$export$4369c812aac99591(categoryAndPreferenceOrPromise)) return categoryAndPreferenceOrPromise.then(({ shouldProcessItem: shouldProcessItem })=>shouldProcessItem);
    else return categoryAndPreferenceOrPromise.shouldProcessItem;
};
const $fbf524e7c49c5e71$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, storageType: storageType, productName: productName, extensionSignals: extensionSignals })=>{
    let shouldProcessItem;
    let itemCategory = null;
    let wasAsync = true;
    let categoryAndPreferenceOrPromise = $fbf524e7c49c5e71$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    if ($fbf524e7c49c5e71$export$4369c812aac99591(categoryAndPreferenceOrPromise)) // this should be the only await in the function.
    ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = await categoryAndPreferenceOrPromise);
    else {
        wasAsync = false;
        ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = categoryAndPreferenceOrPromise);
    }
    if (shouldProcessItem) allowedCallback?.({
        wasAsync: wasAsync
    });
    else {
        // Check if blocked item is from extension
        const extensionCaller = itemCategory === null ? (0, $efbbf032b63c0118$export$9674893ac982a3cc)(extensionSignals) : null;
        if (extensionCaller) {
            (0, $61449d71f1ebd90f$export$1ba525b8a711eaac)({
                source: 'package',
                action: 'package',
                actionSubject: 'browserExtensionKeysAllowed',
                attributes: {
                    itemKey: itemKey,
                    storageType: storageType,
                    productName: productName,
                    extensionScheme: extensionCaller.scheme
                }
            });
            allowedCallback?.({
                wasAsync: wasAsync
            });
            return true;
        }
        blockedCallback?.({
            itemHasCategory: itemCategory != null,
            itemCategory: itemCategory,
            wasAsync: wasAsync
        });
    }
    return shouldProcessItem;
};
const $fbf524e7c49c5e71$export$17e4a7e00d5b99d9 = async ({ itemKey: itemKey, storageType: storageType, productName: productName, extensionSignals: extensionSignals })=>{
    const categoryAndPreferenceOrPromise = $fbf524e7c49c5e71$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    let shouldProcessItem;
    let itemCategory;
    if ($fbf524e7c49c5e71$export$4369c812aac99591(categoryAndPreferenceOrPromise)) ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = await categoryAndPreferenceOrPromise);
    else ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = categoryAndPreferenceOrPromise);
    // Check if blocked item is from extension
    if (!shouldProcessItem) {
        const extensionCaller = itemCategory === null ? (0, $efbbf032b63c0118$export$9674893ac982a3cc)(extensionSignals) : null;
        if (extensionCaller) {
            (0, $61449d71f1ebd90f$export$1ba525b8a711eaac)({
                source: 'package',
                action: 'package',
                actionSubject: 'browserExtensionKeysAllowed',
                attributes: {
                    itemKey: itemKey,
                    storageType: storageType,
                    productName: productName,
                    extensionScheme: extensionCaller.scheme
                }
            });
            return {
                isAllowed: true,
                itemCategory: itemCategory
            };
        }
    }
    return {
        isAllowed: shouldProcessItem,
        itemCategory: itemCategory
    };
};




class $ac2b8707abf64f74$var$ItemKeyCacheService {
    markSetByPackage(storageType, itemKey) {
        this.cache[storageType].add(itemKey);
    }
    wasSetByPackage(storageType, itemKey) {
        return this.cache[storageType].has(itemKey);
    }
    constructor(){
        this.cache = void 0;
        this.cache = Object.fromEntries(Object.keys((0, $0067f33686f0fdf7$export$2506b012eb637f61)).map((storageType)=>{
            return [
                storageType,
                new Set()
            ];
        }));
    }
}
const $ac2b8707abf64f74$export$ff3c91e80f54f26c = new $ac2b8707abf64f74$var$ItemKeyCacheService();




/**
 * Identifies browser "quota exceeded" storage failures across the cross-browser variants (per MDN's
 * `Storage.setItem` exceptions): modern browsers throw a `DOMException` named `QuotaExceededError`;
 * legacy WebKit/Blink expose the numeric `code === 22` (`QUOTA_EXCEEDED_ERR`); Firefox historically
 * throws `NS_ERROR_DOM_QUOTA_REACHED` with `code === 1014`.
 */ const $4393b827109285c8$var$isQuotaExceededError = (error)=>{
    if (!error || typeof error !== 'object') return false;
    const { name: name, code: code } = error;
    return name === 'QuotaExceededError' || name === 'NS_ERROR_DOM_QUOTA_REACHED' || code === 22 || code === 1014;
};
const $4393b827109285c8$export$ba6a684424c69e54 = ({ message: message, attributes: attributes, error: error })=>{
    if ($4393b827109285c8$var$isQuotaExceededError(error)) {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).error(message);
        return;
    }
    (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).errorWithOperationalEvent({
        action: 'usedAtlBrowserStorageSetItemError',
        message: message,
        attributes: attributes
    });
};


const $1febb3d394ff6c03$var$isPromise = (value)=>value != null && typeof value.then === 'function';
const $1febb3d394ff6c03$export$5ee8760f703d9d62 = async (itemKey, value, storageType, productName, browserStorage)=>{
    const categoryStorageType = storageType === (0, $4a82c714b0d3c5be$export$259e3a861f28589b).LocalStorage ? (0, $0067f33686f0fdf7$export$2506b012eb637f61).LocalStorage : (0, $0067f33686f0fdf7$export$2506b012eb637f61).SessionStorage;
    // `disableWebStorageConsentChecks` skips the consent pipeline (analytics-only),
    // but `__UNSAFE_shouldEnforceKeyForRollout(key, type) === true` re-enables enforcement for this key.
    let disableWebStorageConsentChecks = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().disableWebStorageConsentChecks ?? false;
    if ((0, $6oQI4.fg)('jfp-magma-selective-storage-enforcement')) {
        const __UNSAFE_shouldEnforceKeyForRollout = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().__UNSAFE_shouldEnforceKeyForRollout;
        const enforceThisKey = __UNSAFE_shouldEnforceKeyForRollout?.(itemKey, categoryStorageType) === true;
        disableWebStorageConsentChecks = ((0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().disableWebStorageConsentChecks ?? false) && !enforceThisKey;
    }
    if (disableWebStorageConsentChecks) {
        const eventAttributes = {
            itemKey: itemKey,
            storageType: storageType,
            consentChecksDisabled: true
        };
        try {
            // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
            // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
            (0, $ac2b8707abf64f74$export$ff3c91e80f54f26c).markSetByPackage(categoryStorageType, itemKey);
            browserStorage.setItem(itemKey, value);
        } catch (e) {
            (0, $4393b827109285c8$export$ba6a684424c69e54)({
                message: `${storageType} failed to setItem with consent checks disabled. ${e.message || ''}`,
                attributes: eventAttributes,
                error: e
            });
            return {
                status: (0, $0067f33686f0fdf7$export$96e9906d6d93a972).ERROR,
                error: e
            };
        }
        let wasAsync = true;
        try {
            let shouldSetItem;
            const shouldSetItemOrPromise = (0, $fbf524e7c49c5e71$export$ffbb879d3fefb45c)({
                itemKey: itemKey,
                storageType: categoryStorageType,
                productName: productName
            });
            if ($1febb3d394ff6c03$var$isPromise(shouldSetItemOrPromise)) shouldSetItem = await shouldSetItemOrPromise;
            else {
                wasAsync = false;
                shouldSetItem = shouldSetItemOrPromise;
            }
            (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: {
                    ...eventAttributes,
                    wasRejected: !shouldSetItem,
                    wasAsync: wasAsync
                }
            });
        } catch (e) {
            (0, $4393b827109285c8$export$ba6a684424c69e54)({
                attributes: {
                    ...eventAttributes,
                    wasAsync: wasAsync
                },
                message: `Failed to emit analytics for setStorageItem with consent checks disabled. ${e.message || ''}`,
                error: e
            });
        }
        return {
            status: (0, $0067f33686f0fdf7$export$96e9906d6d93a972).SUCCESS
        };
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    let shouldSetItem;
    let wasAsync = true;
    const shouldSetItemOrPromise = (0, $fbf524e7c49c5e71$export$ffbb879d3fefb45c)({
        itemKey: itemKey,
        storageType: categoryStorageType,
        productName: productName
    });
    if ($1febb3d394ff6c03$var$isPromise(shouldSetItemOrPromise)) shouldSetItem = await shouldSetItemOrPromise;
    else {
        wasAsync = false;
        shouldSetItem = shouldSetItemOrPromise;
    }
    // The synchronous preference check surfaces no block reason:
    // `isProcessingAllowedByPreferencesMaybeSync` takes no blockedCallback, so we cannot tell
    // "key not registered in the allow-list" from "blocked by user consent" here. The BLOCKED
    // result therefore carries `blockedItemCategory: undefined` ("reason unknown"), which the
    // caller reads as such and answers with a terse "was blocked" warning.
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey: itemKey,
        storageType: storageType,
        consentChecksDisabled: false,
        wasAsync: wasAsync
    };
    try {
        (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
            // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
            (0, $ac2b8707abf64f74$export$ff3c91e80f54f26c).markSetByPackage(categoryStorageType, itemKey);
            browserStorage.setItem(itemKey, value);
            return {
                status: (0, $0067f33686f0fdf7$export$96e9906d6d93a972).SUCCESS
            };
        } else return {
            status: (0, $0067f33686f0fdf7$export$96e9906d6d93a972).BLOCKED,
            blockedItemCategory: undefined
        };
    } catch (e) {
        (0, $4393b827109285c8$export$ba6a684424c69e54)({
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`,
            error: e
        });
        return {
            status: (0, $0067f33686f0fdf7$export$96e9906d6d93a972).ERROR,
            error: e
        };
    }
};






const $30dd2e852b2fa431$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
            attributes: eventAttributes
        });
        // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
        // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
        (0, $ac2b8707abf64f74$export$ff3c91e80f54f26c).markSetByPackage(storageType === (0, $4a82c714b0d3c5be$export$259e3a861f28589b).LocalStorage ? (0, $0067f33686f0fdf7$export$2506b012eb637f61).LocalStorage : (0, $0067f33686f0fdf7$export$2506b012eb637f61).SessionStorage, itemKey);
        browserStorage.setItem(itemKey, value);
        return (0, $0067f33686f0fdf7$export$96e9906d6d93a972).SUCCESS;
    } catch (e) {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, $0067f33686f0fdf7$export$96e9906d6d93a972).FAILED;
    }
};


class $07c6527a5ae2a4cf$export$8e4a3cf07a10930b {
    get isWebStorageEnabled() {
        // Note: outside of user configuration, webStorageEnabled is also feature gated by
        // 1. platform_moonjelly_bsc_master_killswitch
        // 2. platform_moonjelly_bsc_web_storage_killswitch
        if ((0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().webStorageEnabled) return true;
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return this.storage.getItem(key);
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn(`${this.storageType} is unavailable. Failed to get item ${key}`);
            return null;
        }
        const retrievedItem = (0, $b558ecfd4bee7980$export$e612bb1301d659de)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        if (!this.isWebStorageEnabled) {
            // BSC controls are disabled (pre-init, caller opted out, or killswitch active).
            // Write proceeds unconditionally — emit analytics so we can quantify bypass volume
            // (gated by platform_bsc_consent_bypass_analytics for safe rollout).
            if ((0, $6oQI4.fg)('platform_bsc_consent_bypass_analytics')) {
                const globalState = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)();
                (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
                    action: 'usedAtlBrowserStorageSetItemBscDisabled',
                    attributes: {
                        storageType: this.storageType,
                        product: globalState.product,
                        hasInitialized: globalState.hasInitialized ?? false
                    }
                });
            }
            this.storage.setItem(key, value);
            return {
                status: (0, $0067f33686f0fdf7$export$96e9906d6d93a972).SUCCESS
            };
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn(`${this.storageType} is unavailable. Failed to set item ${key}`);
            return {
                status: (0, $0067f33686f0fdf7$export$96e9906d6d93a972).ERROR,
                error: new Error(`${this.storageType} is unavailable. Failed to set item ${key}`)
            };
        }
        const globalStateProduct = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().product;
        const wasInitialized = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().hasInitialized;
        // IMPORTANT: do not await above this line - if you do it will cause reading after writing to not return the new value until the microtask queue is drained, instead of just those that need to wait for remote fetch.
        const itemSetResult = await (0, $1febb3d394ff6c03$export$5ee8760f703d9d62)(key, value, this.storageType, globalStateProduct, this.storage);
        if (!wasInitialized) (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: this.storageType
            }
        });
        if (itemSetResult.status === (0, $0067f33686f0fdf7$export$96e9906d6d93a972).SUCCESS) (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug(`Successfully set item ${key} with value ${value}`);
        else if (itemSetResult.status === (0, $0067f33686f0fdf7$export$96e9906d6d93a972).BLOCKED) {
            // Only an actual block is described as "blocked" — errors are surfaced (and logged)
            // upstream in setStorageItem's catch blocks via Logger.errorWithOperationalEvent.
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug(`Blocked setting item ${key}`);
            const productSuffix = globalStateProduct ? ` for product "${globalStateProduct}"` : '';
            if (itemSetResult.blockedItemCategory === null) // Async path with confirmed cause: key is not registered.
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn(`${this.storageType}.setItem('${key}', ...) was blocked${productSuffix}` + `: '${key}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
            else if (itemSetResult.blockedItemCategory === undefined) // MaybeSync path: cause not available. State only what we know.
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn(`${this.storageType}.setItem('${key}', ...) was blocked${productSuffix}.`);
        }
        return itemSetResult;
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item ${key}`);
            return;
        }
        const itemSetStatus = (0, $30dd2e852b2fa431$export$f1b0c189562aa9fd)(key, value, this.storageType, this.storage);
        if (!(0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().hasInitialized) (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: this.storageType
            }
        });
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug(`${itemSetStatus === (0, $0067f33686f0fdf7$export$96e9906d6d93a972).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn(`${this.storageType} is unavailable. Failed to remove item ${key}`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, $ff92312187da7e87$export$48d7c418edadb60c)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
    constructor(storage, storageType){
        this.storage = void 0;
        this.storageType = void 0;
        this.isAvailable = false;
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
}
const $07c6527a5ae2a4cf$export$c8cc3ffd3f2c1d2f = new $07c6527a5ae2a4cf$export$8e4a3cf07a10930b(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
globalThis.localStorage, (0, $4a82c714b0d3c5be$export$259e3a861f28589b).LocalStorage);
const $07c6527a5ae2a4cf$export$edbae459bdf957a5 = new $07c6527a5ae2a4cf$export$8e4a3cf07a10930b(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
globalThis.sessionStorage, (0, $4a82c714b0d3c5be$export$259e3a861f28589b).SessionStorage);
const $07c6527a5ae2a4cf$export$14921bfc334334c0 = (type)=>{
    return ({
        [(0, $4a82c714b0d3c5be$export$259e3a861f28589b).LocalStorage]: $07c6527a5ae2a4cf$export$c8cc3ffd3f2c1d2f,
        [(0, $4a82c714b0d3c5be$export$259e3a861f28589b).SessionStorage]: $07c6527a5ae2a4cf$export$edbae459bdf957a5
    })[type];
};



/* eslint-disable no-console */ function $a6897acd40ed68b1$var$getLoggerName(logSource) {
    return typeof logSource === 'string' ? logSource : logSource.displayName || logSource.name || 'Unknown';
}
class $a6897acd40ed68b1$var$Logger {
    log(strings, ...values) {
        this.logAnyLevel(1, console.log, strings, values);
    }
    debug(strings, ...values) {
        this.logAnyLevel(2, console.debug, strings, values);
    }
    info(strings, ...values) {
        this.logAnyLevel(3, console.info, strings, values);
    }
    warn(strings, ...values) {
        this.logAnyLevel(4, console.warn, strings, values);
    }
    error(strings, ...values) {
        this.logAnyLevel(5, console.error, strings, values);
    }
    logAnyLevel(logLevel, consoleFunction, strings, values) {
        try {
            if (// There's no sessionStorage in service workers.
            // We'll just enable logging from service workers for simplicity.
            typeof sessionStorage === 'undefined' || sessionStorage.getItem('confluence.enable-logging') === 'true') {
                const logLevelSetting = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('confluence.log-level');
                const configuredLogLevel = parseInt(logLevelSetting || '', 10) || 1;
                if (configuredLogLevel > logLevel) return;
                const prefix = [
                    `[@${Math.round(performance.now())} ${this.name}]`
                ];
                const messages = strings.reduce((processed, str, index)=>{
                    const value = values[index];
                    const trimmedStr = str.trim()// Allow multiline strings to be indented in code but printed without indenting
                    .replace(/\n\s+/g, '\n');
                    if (trimmedStr) processed.push(trimmedStr);
                    if (index !== strings.length - 1) processed.push(typeof value === 'string' ? JSON.stringify(value) : value);
                    return processed;
                }, prefix);
                consoleFunction(...messages);
            }
        } catch (e) {
            // Catch and log.
            // We don't want to stop execution due to a logging error.
            console.error(e);
        }
    }
    constructor(logSource){
        this.name = void 0;
        this.name = $a6897acd40ed68b1$var$getLoggerName(logSource);
    }
}
const $a6897acd40ed68b1$export$2b1d391cd05230fd = (logSource)=>new $a6897acd40ed68b1$var$Logger(logSource);


// Must call this before any browser-helper functions, to ensure user agent has been set first
(0, $c086cef45a2cc129$export$57d3cdb500cb5402)();
const $3793e1e9d193543a$var$logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('mobile-detection');
// Copied from com.atlassian.confluence.mobile.MobileUtils
const $3793e1e9d193543a$var$NATIVE_IOS_REGEX_STRING = 'iPhone;|iPad;|iPhone Simulator;|iPod;|iPod touch;';
const $3793e1e9d193543a$var$NATIVE_ANDROID_REGEX_STRING = 'Linux; U; Android|Android';
const $3793e1e9d193543a$var$MOBILE_USER_AGENT_REGEX = new RegExp(`(${$3793e1e9d193543a$var$NATIVE_IOS_REGEX_STRING}|${$3793e1e9d193543a$var$NATIVE_ANDROID_REGEX_STRING})`, 'i');
const $3793e1e9d193543a$var$ANDROID_CHROME = /Chrome\/[.\d]* Mobile/i;
const $3793e1e9d193543a$var$OLD_ANDROID = /Linux; U; Android (?:[23]\.\d|4\.0\.[12])/i;
const $3793e1e9d193543a$var$NATIVE_IOS = new RegExp(`(${$3793e1e9d193543a$var$NATIVE_IOS_REGEX_STRING})`, 'i');
const $3793e1e9d193543a$var$NATIVE_ANDROID = new RegExp(`(${$3793e1e9d193543a$var$NATIVE_ANDROID_REGEX_STRING})`, 'i');
const $3793e1e9d193543a$export$bb3c728251279d4a = 'mobileWebTestingMode=testing';
const $3793e1e9d193543a$export$2275282fb5681637 = 'mobile.web.desktop.override.active';
const $3793e1e9d193543a$export$abee7d877fc322c9 = ()=>{
    // Port from com.atlassian.confluence.mobile.MobileUtils#isMobileViewRequest
    const ua = window.navigator.userAgent;
    return !!ua && !$3793e1e9d193543a$var$OLD_ANDROID.test(ua) && ($3793e1e9d193543a$var$MOBILE_USER_AGENT_REGEX.test(ua) || $3793e1e9d193543a$var$ANDROID_CHROME.test(ua) || (0, $c086cef45a2cc129$export$6d5620528cf86fa2)());
};
const $3793e1e9d193543a$export$cc63546398e0df2 = ()=>(0, $07c6527a5ae2a4cf$export$c8cc3ffd3f2c1d2f).getItem($3793e1e9d193543a$export$2275282fb5681637) === 'true';
const $3793e1e9d193543a$export$47a2095e97aaa3d3 = ()=>{
    try {
        // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
        (0, $07c6527a5ae2a4cf$export$c8cc3ffd3f2c1d2f).setItem($3793e1e9d193543a$export$2275282fb5681637, 'true');
    } catch (e) {
        $3793e1e9d193543a$var$logger.error`Unable to set local storage. key = "${$3793e1e9d193543a$export$2275282fb5681637}", value = "true": ${e}`;
    }
};
const $3793e1e9d193543a$export$77ee453f21ed22ca = ()=>{
    (0, $07c6527a5ae2a4cf$export$c8cc3ffd3f2c1d2f).removeItem($3793e1e9d193543a$export$2275282fb5681637);
};
function $3793e1e9d193543a$export$1adf40e7373cdd98() {
    // for testing purposes, query param forces mobile web
    if (window.location.search.includes($3793e1e9d193543a$export$bb3c728251279d4a)) return true;
    return $3793e1e9d193543a$export$abee7d877fc322c9() && !$3793e1e9d193543a$export$cc63546398e0df2();
}
const $3793e1e9d193543a$export$4483f9f8ce987764 = ()=>{
    const ua = window.navigator.userAgent;
    return !!ua && $3793e1e9d193543a$var$NATIVE_ANDROID.test(ua);
};
const $3793e1e9d193543a$export$63c82ea425a2bb3d = ()=>{
    const ua = window.navigator.userAgent;
    return !!ua && $3793e1e9d193543a$var$NATIVE_IOS.test(ua);
};



var $3ihMw = parcelRequire("3ihMw");
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ const $6dfc48732bedef66$export$42f4885608027d0c = 'non_boolean';


function $f7e6c5c041457727$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch  {
        return false;
    }
    return false;
}
function $f7e6c5c041457727$var$isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function $f7e6c5c041457727$var$isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch  {
        // swallow any errors
        result = false;
    }
    return result;
}
function $f7e6c5c041457727$export$7b4abba432e57989(value) {
    return $f7e6c5c041457727$var$isString(value) && $f7e6c5c041457727$var$startsAsObject(value) || $f7e6c5c041457727$var$isObject(value);
}


function $8b54f4c303b569b0$export$fcc03ee4c944962f(featureFlagValue) {
    return (0, $f7e6c5c041457727$export$7b4abba432e57989)(featureFlagValue) ? (0, $6dfc48732bedef66$export$42f4885608027d0c) : featureFlagValue;
}


const $cf5258fb0d237fac$export$5b78c989c8db2561 = new Map();
const $cf5258fb0d237fac$export$2a5c8df26bb89760 = new Map();
function $cf5258fb0d237fac$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $8b54f4c303b569b0$export$fcc03ee4c944962f)(featureFlagValue);
    $cf5258fb0d237fac$export$5b78c989c8db2561.set(featureFlagName, value);
    $cf5258fb0d237fac$export$2a5c8df26bb89760.set(featureFlagName, value);
}


const $3df4286e75ff1ab6$export$b40ec24ac8275656 = (gateName)=>{
    // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
    const value = (0, $3ihMw.default).checkGate(gateName);
    (0, $cf5258fb0d237fac$export$47fade9662f71000)(gateName, value);
    return value;
};










function $d4a7caa009eb781c$export$eca64eb737a4c2bc(requestInit) {
    // referrerPolicy is not supported by Edge pre Chromium:
    if (requestInit && 'referrerPolicy' in requestInit) {
        const { referrerPolicy: referrerPolicy, ...requestInitWithoutReferrerPolicy } = requestInit;
        try {
            new Request('/', {
                referrerPolicy: referrerPolicy
            });
        // The referrerPolicy seems to be supported. Leave it in requestInit.
        } catch (_) {
            // The referrerPolicy does not seem to be supported. Drop it from
            // requestInit; otherwise, the Request constructor and fetch will throw:
            requestInit = requestInitWithoutReferrerPolicy;
        }
    }
    return requestInit;
}


const $32b74afc9e827b44$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-b3-traceid') || response?.headers?.get('atl-traceid') || null;



var $3g9wx = parcelRequire("3g9wx");

var $cKFfd = parcelRequire("cKFfd");
var $1a8Re = parcelRequire("1a8Re");

var $l1TqZ = parcelRequire("l1TqZ");
var $kN795 = parcelRequire("kN795");

var $9YhYD = parcelRequire("9YhYD");

var $3g9wx = parcelRequire("3g9wx");

var $2M83v = parcelRequire("2M83v");
var $f1904a311c995b0d$var$genericMessage = "Invariant Violation";
var $f1904a311c995b0d$var$_a = Object.setPrototypeOf, $f1904a311c995b0d$var$setPrototypeOf = $f1904a311c995b0d$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $f1904a311c995b0d$var$_a;
var $f1904a311c995b0d$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $3g9wx.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $f1904a311c995b0d$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $f1904a311c995b0d$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $f1904a311c995b0d$var$genericMessage;
        $f1904a311c995b0d$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $f1904a311c995b0d$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $f1904a311c995b0d$export$cea12affaee22fe8(message);
}
function $f1904a311c995b0d$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $f1904a311c995b0d$var$wrapConsoleMethod("warn");
    invariant.error = $f1904a311c995b0d$var$wrapConsoleMethod("error");
})($f1904a311c995b0d$export$f5708dca728d7177 || ($f1904a311c995b0d$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $f1904a311c995b0d$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $2M83v === "object") $f1904a311c995b0d$export$e54fe5b0f43758f7 = $2M83v;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($f1904a311c995b0d$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $f1904a311c995b0d$var$invariant$1 = $f1904a311c995b0d$export$f5708dca728d7177;
var $f1904a311c995b0d$export$2e2bcd8739ae039 = $f1904a311c995b0d$var$invariant$1;



var $cRbCO = parcelRequire("cRbCO");
var $fdeb0f8a75299761$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($fdeb0f8a75299761$export$bd096ddbd246c79c || ($fdeb0f8a75299761$export$bd096ddbd246c79c = {}));
function $fdeb0f8a75299761$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $fdeb0f8a75299761$var$Observable = function(_super) {
    (0, $3g9wx.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $9YhYD.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $kN795.default));
function $fdeb0f8a75299761$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $fdeb0f8a75299761$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $fdeb0f8a75299761$var$generateErrorMessage = function(err) {
    var message = '';
    if ($fdeb0f8a75299761$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $fdeb0f8a75299761$export$26a337512320b8c6 = function(_super) {
    (0, $3g9wx.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $fdeb0f8a75299761$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $fdeb0f8a75299761$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($fdeb0f8a75299761$export$160bafb6ac1e0641 || ($fdeb0f8a75299761$export$160bafb6ac1e0641 = {}));
var $fdeb0f8a75299761$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $fdeb0f8a75299761$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $fdeb0f8a75299761$export$6c1b56eac59c9584 = function(_super) {
    (0, $3g9wx.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $cKFfd.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $fdeb0f8a75299761$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($fdeb0f8a75299761$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $fdeb0f8a75299761$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $fdeb0f8a75299761$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $fdeb0f8a75299761$export$bd096ddbd246c79c.loading : $fdeb0f8a75299761$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, result), {
            stale: false
        }));
        return (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $1a8Re.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $f1904a311c995b0d$export$cea12affaee22fe8)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $1a8Re.equal)(this.variables, variables)) this.variables = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, this.variables), variables);
        if (!(0, $1a8Re.equal)(this.options.variables, this.variables)) this.options.variables = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $fdeb0f8a75299761$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $f1904a311c995b0d$export$f5708dca728d7177)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $3g9wx.__assign)((0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $fdeb0f8a75299761$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $1a8Re.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $cKFfd.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $fdeb0f8a75299761$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $cKFfd.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $fdeb0f8a75299761$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $fdeb0f8a75299761$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $fdeb0f8a75299761$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $fdeb0f8a75299761$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $1a8Re.equal)(previousVariables, variables)) _this.refetch();
                        else $fdeb0f8a75299761$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $fdeb0f8a75299761$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($fdeb0f8a75299761$var$Observable);
function $fdeb0f8a75299761$var$defaultSubscriptionObserverErrorCallback(error) {}
function $fdeb0f8a75299761$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $fdeb0f8a75299761$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $f1904a311c995b0d$export$f5708dca728d7177)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $fdeb0f8a75299761$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $fdeb0f8a75299761$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $f1904a311c995b0d$export$f5708dca728d7177)(!previousQuery || previousQuery.document === query.document || (0, $1a8Re.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $fdeb0f8a75299761$export$bd096ddbd246c79c.loading) {
            if (!(0, $1a8Re.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $fdeb0f8a75299761$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $fdeb0f8a75299761$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $fdeb0f8a75299761$export$bd096ddbd246c79c.refetch;
        else networkStatus = $fdeb0f8a75299761$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $fdeb0f8a75299761$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $fdeb0f8a75299761$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $fdeb0f8a75299761$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $fdeb0f8a75299761$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $fdeb0f8a75299761$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $fdeb0f8a75299761$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $fdeb0f8a75299761$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $fdeb0f8a75299761$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $fdeb0f8a75299761$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $cKFfd.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $cKFfd.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $3g9wx.__awaiter)(this, void 0, void 0, function() {
            return (0, $3g9wx.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $cKFfd.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $cKFfd.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $f1904a311c995b0d$export$f5708dca728d7177)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $3g9wx.__awaiter)(this, void 0, void 0, function() {
            return (0, $3g9wx.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $3g9wx.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $cRbCO.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $cRbCO.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $cKFfd.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $3g9wx.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $3g9wx.__generator)(this, function(_b) {
                mainDefinition = (0, $cKFfd.getMainDefinition)(document);
                fragments = (0, $cKFfd.getFragmentDefinitions)(document);
                fragmentMap = (0, $cKFfd.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $fdeb0f8a75299761$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $3g9wx.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $3g9wx.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $3g9wx.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $3g9wx.__generator)(this, function(_a) {
                            if (!(0, $cKFfd.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $cKFfd.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $cKFfd.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $cKFfd.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $f1904a311c995b0d$export$f5708dca728d7177)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $cKFfd.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $3g9wx.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $3g9wx.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $cKFfd.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $cKFfd.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $fdeb0f8a75299761$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $fdeb0f8a75299761$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $fdeb0f8a75299761$var$asyncMap(observable, mapFn) {
    return new $fdeb0f8a75299761$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $fdeb0f8a75299761$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $fdeb0f8a75299761$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $fdeb0f8a75299761$var$MutationStore();
        this.queryStore = new $fdeb0f8a75299761$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $cKFfd.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $fdeb0f8a75299761$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $f1904a311c995b0d$export$cea12affaee22fe8)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $3g9wx.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $3g9wx.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $f1904a311c995b0d$export$f5708dca728d7177)(mutation, 9);
                        (0, $f1904a311c995b0d$export$f5708dca728d7177)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $fdeb0f8a75299761$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $cKFfd.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $fdeb0f8a75299761$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $fdeb0f8a75299761$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($fdeb0f8a75299761$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $cKFfd.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $3g9wx.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $3g9wx.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $cKFfd.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $fdeb0f8a75299761$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $fdeb0f8a75299761$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($fdeb0f8a75299761$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $fdeb0f8a75299761$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $fdeb0f8a75299761$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $fdeb0f8a75299761$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $fdeb0f8a75299761$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $fdeb0f8a75299761$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $cKFfd.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $cKFfd.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $cKFfd.getDefaultValues)((0, $cKFfd.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $f1904a311c995b0d$export$f5708dca728d7177)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $3g9wx.__assign)({}, options);
        return new $fdeb0f8a75299761$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $f1904a311c995b0d$export$f5708dca728d7177)(options.query, 12);
        (0, $f1904a311c995b0d$export$f5708dca728d7177)(options.query.kind === 'Document', 13);
        (0, $f1904a311c995b0d$export$f5708dca728d7177)(!options.returnPartialData, 14);
        (0, $f1904a311c995b0d$export$f5708dca728d7177)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $f1904a311c995b0d$export$cea12affaee22fe8)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $cKFfd.graphQLResultHasError)(result)) throw new $fdeb0f8a75299761$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $fdeb0f8a75299761$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $f1904a311c995b0d$export$f5708dca728d7177)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) {
                const name = info && info.document && info.document.definitions && info.document.definitions[0] && info.document.definitions[0].name && info.document.definitions[0].name.value;
                const stats = typeof window !== 'undefined' && window && window.__APOLLO_STATS__ && window.__APOLLO_STATS__.broadcast;
                if (name && stats) {
                    stats[name] = stats[name] || 0;
                    stats[name]++;
                }
                info.listeners.forEach(function(listener) {
                    if (listener) listener(_this.queryStore.get(id), info.newData);
                });
            }
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $cKFfd.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $fdeb0f8a75299761$var$multiplex((0, $l1TqZ.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $fdeb0f8a75299761$var$multiplex((0, $l1TqZ.execute)(link, operation));
        } else {
            observable = $fdeb0f8a75299761$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $fdeb0f8a75299761$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $fdeb0f8a75299761$var$isNonEmptyArray(result.errors)) return reject(new $fdeb0f8a75299761$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $fdeb0f8a75299761$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $fdeb0f8a75299761$export$bd096ddbd246c79c.ready && query.networkStatus !== $fdeb0f8a75299761$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $f1904a311c995b0d$export$f5708dca728d7177)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $fdeb0f8a75299761$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $fdeb0f8a75299761$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $cKFfd.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $cKFfd.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $cKFfd.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $cKFfd.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $cKFfd.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $cKFfd.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $cKFfd.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $fdeb0f8a75299761$var$version = "2.6.10";
var $fdeb0f8a75299761$var$hasSuggestedDevtools = false;
var $fdeb0f8a75299761$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $l1TqZ.ApolloLink).empty();
        if (!link || !cache) throw new (0, $f1904a311c995b0d$export$cea12affaee22fe8)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $fdeb0f8a75299761$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        $fdeb0f8a75299761$var$hasSuggestedDevtools;
        this.version = $fdeb0f8a75299761$var$version;
        this.localState = new $fdeb0f8a75299761$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $fdeb0f8a75299761$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, this.defaultOptions.query), options);
        (0, $f1904a311c995b0d$export$f5708dca728d7177)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $l1TqZ.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $fdeb0f8a75299761$export$2e2bcd8739ae039 = $fdeb0f8a75299761$export$13f5a5f0f1dbab88;


function $4d95c1e0202d387b$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}


function $82aa2798c78e4e52$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $82aa2798c78e4e52$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $82aa2798c78e4e52$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $82aa2798c78e4e52$var$_typeof(obj);
}
function $82aa2798c78e4e52$export$2e2bcd8739ae039(value) {
    return $82aa2798c78e4e52$var$_typeof(value) == 'object' && value !== null;
}


// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $9396579e49d8388a$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $9396579e49d8388a$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $9396579e49d8388a$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';


/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $743811774e592d25$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}



function $fc8b6d0a506083e4$export$96a9681e539deed(location) {
    return $fc8b6d0a506083e4$export$867940333fd9f869(location.source, (0, $743811774e592d25$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $fc8b6d0a506083e4$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $fc8b6d0a506083e4$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $fc8b6d0a506083e4$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $fc8b6d0a506083e4$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $fc8b6d0a506083e4$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $fc8b6d0a506083e4$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $fc8b6d0a506083e4$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $fc8b6d0a506083e4$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $fc8b6d0a506083e4$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $fc8b6d0a506083e4$var$leftPad(len, str) {
    return $fc8b6d0a506083e4$var$whitespace(len - str.length) + str;
}


function $597d1726912070b7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $597d1726912070b7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $597d1726912070b7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $597d1726912070b7$var$_typeof(obj);
}
function $597d1726912070b7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $597d1726912070b7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $597d1726912070b7$var$ownKeys(Object(source), true).forEach(function(key) {
            $597d1726912070b7$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $597d1726912070b7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $597d1726912070b7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $597d1726912070b7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $597d1726912070b7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $597d1726912070b7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $597d1726912070b7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $597d1726912070b7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $597d1726912070b7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $597d1726912070b7$var$_setPrototypeOf(subClass, superClass);
}
function $597d1726912070b7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $597d1726912070b7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $597d1726912070b7$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $597d1726912070b7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $597d1726912070b7$var$_possibleConstructorReturn(this, result);
    };
}
function $597d1726912070b7$var$_possibleConstructorReturn(self, call) {
    if (call && ($597d1726912070b7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $597d1726912070b7$var$_assertThisInitialized(self);
}
function $597d1726912070b7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $597d1726912070b7$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $597d1726912070b7$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$597d1726912070b7$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $597d1726912070b7$var$_construct(Class, arguments, $597d1726912070b7$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $597d1726912070b7$var$_setPrototypeOf(Wrapper, Class);
    };
    return $597d1726912070b7$var$_wrapNativeSuper(Class);
}
function $597d1726912070b7$var$_construct(Parent, args, Class) {
    if ($597d1726912070b7$var$_isNativeReflectConstruct()) $597d1726912070b7$var$_construct = Reflect.construct;
    else $597d1726912070b7$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $597d1726912070b7$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $597d1726912070b7$var$_construct.apply(null, arguments);
}
function $597d1726912070b7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $597d1726912070b7$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $597d1726912070b7$var$_setPrototypeOf(o, p) {
    $597d1726912070b7$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $597d1726912070b7$var$_setPrototypeOf(o, p);
}
function $597d1726912070b7$var$_getPrototypeOf(o) {
    $597d1726912070b7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $597d1726912070b7$var$_getPrototypeOf(o);
}
var $597d1726912070b7$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $597d1726912070b7$var$_inherits(GraphQLError, _Error);
    var _super = $597d1726912070b7$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $597d1726912070b7$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $597d1726912070b7$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $597d1726912070b7$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $743811774e592d25$export$e7fd20fad3cf4b5f)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $743811774e592d25$export$e7fd20fad3cf4b5f)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $82aa2798c78e4e52$export$2e2bcd8739ae039)(originalExtensions)) _this.extensions = $597d1726912070b7$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($597d1726912070b7$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($597d1726912070b7$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $597d1726912070b7$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($597d1726912070b7$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($597d1726912070b7$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $597d1726912070b7$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $597d1726912070b7$export$55ee1551a3f962e6(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $597d1726912070b7$export$7b5b869ee98c16ab(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $9396579e49d8388a$export$5deadc579ccc7c9c),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $597d1726912070b7$var$_wrapNativeSuper(Error));
function $597d1726912070b7$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $597d1726912070b7$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $fc8b6d0a506083e4$export$96a9681e539deed)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $fc8b6d0a506083e4$export$867940333fd9f869)(error.source, location);
    }
    return output;
}
function $597d1726912070b7$export$7b5b869ee98c16ab(error) {
    var _error$message;
    error || (0, $4d95c1e0202d387b$export$2e2bcd8739ae039)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 


const $a73698f3e4fe6cd8$export$17f5e6bd290bb15d = (error)=>{
    return typeof error === 'object' && error != null && (error.hasOwnProperty('graphQLErrors') || error.hasOwnProperty('networkError'));
};
class $a73698f3e4fe6cd8$export$3ad5d0415dc12c65 extends (0, $fdeb0f8a75299761$export$26a337512320b8c6) {
    constructor(options){
        // sometimes graphQLErrors isn't properly passed as an array (passed as typeof any)
        // we check if it's an array and if not, we wrap it in an array.
        // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        const graphQLErrors = (Array.isArray(options.graphQLErrors) ? options.graphQLErrors : [
            options.graphQLErrors
        ]).filter(Boolean).map((error)=>{
            if (error instanceof (0, $597d1726912070b7$export$92d6ed0888e7cb7f)) return error;
            const message = error.message;
            const extensions = error.extensions;
            const path = error.path;
            const originalError = new Error(message, {
                cause: error
            });
            const graphQLError = new (0, $597d1726912070b7$export$92d6ed0888e7cb7f)(message, undefined, undefined, undefined, path, originalError, extensions);
            Object.defineProperties(graphQLError, {
                nodes: {
                    get () {
                        throw new Error(`[Relay migration] 'nodes' is not supported yet`);
                    }
                },
                source: {
                    get () {
                        throw new Error(`[Relay migration] 'source' is not supported yet`);
                    }
                },
                positions: {
                    get () {
                        throw new Error(`[Relay migration] 'positions' is not supported yet`);
                    }
                }
            });
            return graphQLError;
        });
        super({
            ...options,
            graphQLErrors: graphQLErrors
        });
        // Fix prototype chain for instanceof checks
        // This is necessary when extending Error-based classes in JavaScript
        Object.setPrototypeOf(this, $a73698f3e4fe6cd8$export$3ad5d0415dc12c65.prototype);
    }
}



function $eb7022fe2ef8793b$export$d54488e5d0ecaef7(value) {
    return value instanceof (0, $597d1726912070b7$export$92d6ed0888e7cb7f);
}


class $65398bb1ddc9160a$export$bae979e68e4dc802 extends Error {
    constructor(...args){
        super(...args);
        this.requestUrl = void 0;
    }
}
function $65398bb1ddc9160a$export$bda33884db3cf75b(error) {
    if (error instanceof $65398bb1ddc9160a$export$bae979e68e4dc802) return true;
    if ((0, $a73698f3e4fe6cd8$export$17f5e6bd290bb15d)(error)) {
        const { graphQLErrors: graphQLErrors, networkError: networkError } = error;
        if (networkError) // ApolloError describes a network-related error if its networkError
        // property value is truthy. These are errors that have occurred within a
        // NetworkLink of ApolloClient. Think non-experimental queries (and
        // mutations).
        return true;
        return graphQLErrors.some($65398bb1ddc9160a$export$bda33884db3cf75b);
    }
    if ((0, $eb7022fe2ef8793b$export$d54488e5d0ecaef7)(error)) {
        const { originalError: originalError } = error;
        if (originalError) return $65398bb1ddc9160a$export$bda33884db3cf75b(originalError);
    }
    return false;
}
function $65398bb1ddc9160a$export$762bd3eeab681428(error) {
    return error.cause instanceof Error && error.cause?.name === 'AbortError';
}


class $165abb9eb28d58da$export$12c8b3d0a1a46f87 extends (0, $65398bb1ddc9160a$export$bae979e68e4dc802) {
    get traceId() {
        return (0, $32b74afc9e827b44$export$9f229e40eb65abfc)(this.response);
    }
    static isBadStatusError(value) {
        return value instanceof $165abb9eb28d58da$export$12c8b3d0a1a46f87;
    }
    constructor(message, response){
        super(message);
        this.response = void 0;
        this.name = 'BadStatusError';
        this.response = response;
    }
}



class $ea3ad52d3b05fdce$export$79f50640f30c1c0e extends (0, $65398bb1ddc9160a$export$bae979e68e4dc802) {
    constructor(...args){
        super(...args);
        /**
     * If the call site of `cfetch` has indicated that `NoNetworkError`s are to be
     * ignored by handlers, then `true`; otherwise, `false` or `undefined`.
     */ this.ignore = void 0;
    }
}



const $47f40898ee722892$var$RATE_LIMIT_TEXT_MARK = 'rate limit exceeded';
class $47f40898ee722892$export$b5f929f4d77c16a9 extends (0, $165abb9eb28d58da$export$12c8b3d0a1a46f87) {
    constructor(message, response){
        super(`${message} ${$47f40898ee722892$var$RATE_LIMIT_TEXT_MARK}`, response);
    }
}


function $57a53db822db3688$export$bee20cbc27fea50(headers, headerName, headerValue) {
    if (Array.isArray(headers)) {
        headers.push([
            headerName,
            headerValue
        ]);
        return;
    }
    if (headers instanceof Headers) {
        headers.append(headerName, headerValue);
        return;
    }
    headers[headerName] = headerValue;
}


function $1c343939761f9a65$export$149b1181d497cd(headers, headerName) {
    if (Array.isArray(headers)) {
        const header = headers.find(([name])=>name === headerName);
        return header ? header[1] : null;
    }
    if (headers instanceof Headers) return headers.get(headerName);
    return headers[headerName] ?? null;
}


const $e8815de0e5744b4a$export$1fccf6c6ebec28fe = 'X-Atl-Experience';
const $e8815de0e5744b4a$export$ecc9e1785213e182 = 'X-Atl-Experience-Id';


const $53b31fbcee8a9542$var$NO_DATA_FETCHER_BOUNDARY = 'no-data-fetcher-boundary';
const $53b31fbcee8a9542$var$sanitizeBoundaryName = (value)=>value.replace(/[^\-.\w]/g, '_');
const $53b31fbcee8a9542$var$createEmptyStats = ()=>({
        totalOperations: 0,
        byBoundary: {}
    });
const $53b31fbcee8a9542$var$cloneStats = (stats)=>({
        totalOperations: stats.totalOperations,
        byBoundary: {
            ...stats.byBoundary
        }
    });
const $53b31fbcee8a9542$var$subtractStats = (stats, baseline)=>{
    const result = {
        totalOperations: stats.totalOperations - baseline.totalOperations,
        byBoundary: {}
    };
    const boundaryNames = new Set([
        ...Object.keys(stats.byBoundary),
        ...Object.keys(baseline.byBoundary)
    ]);
    boundaryNames.forEach((boundaryName)=>{
        const boundaryDelta = (stats.byBoundary[boundaryName] ?? 0) - (baseline.byBoundary[boundaryName] ?? 0);
        if (boundaryDelta) result.byBoundary[boundaryName] = boundaryDelta;
    });
    return result;
};
class $53b31fbcee8a9542$var$FrontendNetworkTracker {
    getBoundaryName() {
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const boundaryName = window.__CONFLUENCE_CURRENT_DATA_FETCHER_BOUNDARY__;
        if (!boundaryName) return $53b31fbcee8a9542$var$NO_DATA_FETCHER_BOUNDARY;
        return $53b31fbcee8a9542$var$sanitizeBoundaryName(boundaryName);
    }
    trackOperation() {
        this.stats.totalOperations++;
        const boundaryName = this.getBoundaryName();
        this.stats.byBoundary[boundaryName] = (this.stats.byBoundary[boundaryName] ?? 0) + 1;
    }
    // Called from createWrappedFetch for each individual operation
    trackGraphQLOperations(operationNames) {
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (typeof window === 'undefined') return;
        if (!operationNames.length) return;
        operationNames.forEach(()=>{
            this.trackOperation();
        });
    }
    // Called from cfetch for REST calls
    trackRestCall(_url) {
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (typeof window === 'undefined') return;
        this.trackOperation();
    }
    getStats() {
        return {
            totalOperations: this.stats.totalOperations
        };
    }
    getDetailedStats() {
        return $53b31fbcee8a9542$var$cloneStats(this.stats);
    }
    startPageLoadTracking({ isInitial: isInitial } = {}) {
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (typeof window === 'undefined') return;
        this.pageLoadBaseline = isInitial ? $53b31fbcee8a9542$var$createEmptyStats() : $53b31fbcee8a9542$var$cloneStats(this.stats);
    }
    getStatsSincePageLoadStart() {
        return $53b31fbcee8a9542$var$subtractStats(this.stats, this.pageLoadBaseline);
    }
    reset() {
        this.stats = $53b31fbcee8a9542$var$createEmptyStats();
        this.pageLoadBaseline = $53b31fbcee8a9542$var$createEmptyStats();
    }
    constructor(){
        this.stats = $53b31fbcee8a9542$var$createEmptyStats();
        this.pageLoadBaseline = $53b31fbcee8a9542$var$createEmptyStats();
    }
}
const $53b31fbcee8a9542$export$9a57a9973e788640 = new $53b31fbcee8a9542$var$FrontendNetworkTracker();


const $b9f93b053c525d82$export$7fd82c6bb3f5e7d5 = async (resource, init = {})=>{
    const urlPrefix = '/gateway/api/graphql';
    if (typeof window !== 'undefined' && window['GLOBAL_FALLBACK_ATL_EXP']) {
        if (resource instanceof Request && resource.url.startsWith(urlPrefix)) resource.headers.append((0, $e8815de0e5744b4a$export$1fccf6c6ebec28fe), resource.headers.get((0, $e8815de0e5744b4a$export$1fccf6c6ebec28fe)) || window['GLOBAL_FALLBACK_ATL_EXP']);
        else if (String(resource).startsWith(urlPrefix)) {
            init.headers = init?.headers || {};
            // For requests sending outside of exp tracker scope fallback to URL based exp name
            (0, $57a53db822db3688$export$bee20cbc27fea50)(init.headers, (0, $e8815de0e5744b4a$export$1fccf6c6ebec28fe), (0, $1c343939761f9a65$export$149b1181d497cd)(init.headers, (0, $e8815de0e5744b4a$export$1fccf6c6ebec28fe)) || window['GLOBAL_FALLBACK_ATL_EXP']);
        }
    }
    // eslint-disable-next-line prefer-const
    let { ignoreNoNetworkError: ignoreNoNetworkError, requestInit: requestInit } = $b9f93b053c525d82$var$decomposeInit(init);
    // XXX Default RequestInit's credentials to "include" but not always: if the
    // caller provided a Request as resource and no init, then us adding a
    // RequestInit can break the caller.
    if (!resource || typeof resource === 'string' || !resource.credentials) requestInit = {
        credentials: 'include',
        ...requestInit
    };
    let response;
    const { url: url } = $b9f93b053c525d82$var$getRequestInfo(resource);
    let finalUrl = url;
    let authHeaders = {};
    let queryBoundary;
    let guardName;
    let untrackInflightRequest;
    try {
        // Track REST calls for frontend (GraphQL is tracked separately)
        // Only track in browser environment
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (typeof window !== 'undefined') (0, $53b31fbcee8a9542$export$9a57a9973e788640).trackRestCall(url);
        if (typeof resource === 'string') resource = finalUrl;
        else if (resource instanceof Request) {
            if (finalUrl !== url) resource = new Request(finalUrl, resource);
        } else resource = new URL(finalUrl);
        // eslint-disable-next-line check-credentials-option/has-credentials-option, no-restricted-syntax
        response = await fetch(resource, requestInit);
    } catch (e) {
        // According to the fetch spec, a network failure results in a Promise
        // rejected with a TypeError. Any Response at all will resolve the Promise,
        // with the status property revealing the HTTP status code.
        const cause = e;
        const error = new (0, $ea3ad52d3b05fdce$export$79f50640f30c1c0e)(`Network failure: ${cause}`, {
            cause: cause
        });
        error.ignore = ignoreNoNetworkError;
        error.requestUrl = $b9f93b053c525d82$var$getRequestUrl(resource);
        error.ignore || $b9f93b053c525d82$var$emit(/* response */ undefined, error);
        throw error;
    } finally{
        untrackInflightRequest?.();
    }
    // If we don't get a 2xx Response, we'll consider that an error, and we'll
    // throw an exception. If we don't, we risk developers not checking the
    // Response status, running parsing logic such as parsing JSON, and failing
    // on non-2xx HTTP status code with weird errors like:
    // * Unexpected end of JSON input
    // * Unexpected token < in JSON at position 0
    // * JSON.parse: unexpected end of data at line 1 column 1 of the JSON data
    // * etc.
    //
    // By using our own Error subclass, we can prevent such unintended running of
    // parsing logic and we allow the product easily recognize the error and apply
    // product-wide processing.
    if (!response.ok) {
        let error;
        if (response.status === 429) error = new (0, $47f40898ee722892$export$b5f929f4d77c16a9)($b9f93b053c525d82$var$getRequestUrl(resource), response);
        else error = new (0, $165abb9eb28d58da$export$12c8b3d0a1a46f87)(`Received status ${response.status}`, response);
        error.requestUrl = $b9f93b053c525d82$var$getRequestUrl(resource);
        $b9f93b053c525d82$var$emit(response, error);
        throw error;
    }
    $b9f93b053c525d82$var$emit(response, /* error */ undefined);
    return response;
};
function $b9f93b053c525d82$var$decomposeInit(init = {}) {
    const { ignoreNoNetworkError: ignoreNoNetworkError, ...requestInit } = init;
    return {
        ignoreNoNetworkError: ignoreNoNetworkError,
        requestInit: Object.getOwnPropertyNames(requestInit).length ? (0, $d4a7caa009eb781c$export$eca64eb737a4c2bc)(requestInit) : undefined
    };
}
const $b9f93b053c525d82$var$logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)($b9f93b053c525d82$export$7fd82c6bb3f5e7d5);
let $b9f93b053c525d82$var$subscribers = [];
/**
 * Adds a specific `subscriber` to be notified whenever any `cfetch` call
 * resolves with a `Response` and/or an `Error`. If you're calling `cfetch` and
 * are interested in the outcome of that particular call only, please await the
 * resolution of the `Promise` returned by `cfetch`.
 */ $b9f93b053c525d82$export$7fd82c6bb3f5e7d5.subscribe = (subscriber)=>{
    if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
    $b9f93b053c525d82$var$subscribers.push(subscriber);
    return ()=>{
        $b9f93b053c525d82$var$subscribers = $b9f93b053c525d82$var$subscribers.filter((x)=>x !== subscriber);
    };
};
function $b9f93b053c525d82$var$emit(response, error) {
    $b9f93b053c525d82$var$subscribers.forEach((subscriber)=>{
        try {
            subscriber(response, error);
        } catch (e) {
            $b9f93b053c525d82$var$logger.error`Error occurred in a cfetch subscriber: ${e}`;
        }
    });
}
function $b9f93b053c525d82$var$getRequestUrl(resource) {
    return typeof resource === 'string' ? resource : resource instanceof Request ? resource.url : resource.toString();
}
/**
 * Helper function to extract URL and determine if request is GraphQL
 */ function $b9f93b053c525d82$var$getRequestInfo(resource) {
    const url = $b9f93b053c525d82$var$getRequestUrl(resource);
    const isGraphQL = url.includes('/gateway/api/graphql') || url.includes('?q=') || url.includes('&q=');
    return {
        url: url,
        isGraphQL: isGraphQL
    };
}


const $ce97530b5e3fb851$export$54fe7bbc3a8667b6 = `
  query isNewUserQuery {
    isNewUser
  }
`;


const $5ffd74b04d73fde2$export$53cb6decc268273b = (attributes)=>{
    const URI = '/gateway/api/graphql/slow';
    const regionHint = window['GLOBAL_AGG_REGION_STEERING_HINT'];
    (0, $b9f93b053c525d82$export$7fd82c6bb3f5e7d5)(`${URI}?q=isNewUserQuery`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'X-APOLLO-OPERATION-NAME': 'isNewUserQuery',
            'Content-Type': 'application/json',
            'atl-attribution': JSON.stringify({
                product: 'Confluence Cloud',
                service: 'confluence-frontend'
            }),
            ...regionHint ? {
                'Atl-Edge-Region-Hint': regionHint
            } : {}
        },
        body: JSON.stringify({
            operationName: 'isNewUserQuery',
            query: (0, $ce97530b5e3fb851$export$54fe7bbc3a8667b6)
        })
    }).then(async (res)=>{
        if (res.ok) {
            const data = await res.json();
            const isNewUser = data?.data?.isNewUser || false;
            if (!!isNewUser) {
                (0, $b9f93b053c525d82$export$7fd82c6bb3f5e7d5)('/wiki/rest/onboarding/1/store', {
                    method: 'PUT',
                    body: JSON.stringify({
                        key: 'onboarding-origin-state:attributes',
                        value: JSON.stringify(attributes)
                    }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                window.dispatchEvent(new Event('onboardingAttributesUpdated'));
            }
        }
    });
};


// Must call this before any browser-helper functions, to ensure user agent has been set first
(0, $c086cef45a2cc129$export$57d3cdb500cb5402)();
let $b76dfd1db5681318$var$provideClient;
const $b76dfd1db5681318$var$analyticsWebClientPromise = (0, $cd3135dd152096aa$export$cc373701aed148fc)(new Promise((resolve)=>{
    $b76dfd1db5681318$var$provideClient = resolve;
}));
let $b76dfd1db5681318$var$provideDwellTimeHelper;
const $b76dfd1db5681318$var$dwellTimeHelperPromise = (0, $cd3135dd152096aa$export$cc373701aed148fc)(new Promise((resolve)=>{
    $b76dfd1db5681318$var$provideDwellTimeHelper = resolve;
}));
const $b76dfd1db5681318$var$GAS_V3_ROUTE = 'gateway/api/gasv3/api/v1';
const $b76dfd1db5681318$export$45a69314cf48a3eb = ({ envType: envType, originType: originType, environment: environment, platformType: platformType, locale: locale, product: product, subproduct: subproduct })=>{
    const env = // In dev, proxying to a site will give that site's environment,
    // which is not what we want
    window.location.hostname === 'localhost' ? envType.DEV : environment === 'STAGING' ? envType.STAGING : environment === 'PRODUCTION' ? envType.PROD : envType.DEV;
    return {
        env: env,
        product: product || 'confluence',
        ...subproduct ? {
            subproduct: subproduct
        } : undefined,
        version: (0, $f3f8c1a227f13835$export$4ea39b9726d98a51)().FRONTEND_VERSION,
        origin: originType.WEB,
        platform: (0, $3793e1e9d193543a$export$1adf40e7373cdd98)() ? platformType.MOBILE_WEB : platformType.WEB,
        locale: locale,
        ...(0, $deE7Q.isIsolatedCloud)() && {
            ic: (0, $kzZXs.isolationContextId)()
        }
    };
};
const $b76dfd1db5681318$export$cac1fa7ce63519ac = (cloudId, activationId)=>`ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
let $b76dfd1db5681318$var$updateAmplitudeSRSession;
let $b76dfd1db5681318$var$amplitudeAttributesInjector;
const $b76dfd1db5681318$var$wrapSendMethod = (originalMethod)=>{
    return function(payload, ...args) {
        // Inject amplitude attributes if injector exists
        if ($b76dfd1db5681318$var$amplitudeAttributesInjector && payload) $b76dfd1db5681318$var$amplitudeAttributesInjector(payload);
        // Call original method
        return originalMethod.call(this, payload, ...args);
    };
};




const $b76dfd1db5681318$export$7d842b959fcdcd03 = ({ cloudId: cloudId, userId: userId, environment: environment, product: product, subproduct: subproduct, locale: locale, activationId: activationId, eventFilterOptions: eventFilterOptions = {
    shouldFilterEvents: false,
    eventMatchers: []
}, callback: callback })=>{
    let config;
    Promise.all([
        // oxlint-disable-next-line no-restricted-imports
        (parcelRequire("3Y1mv")),
        (parcelRequire("hlQDR")),
        // This is needed for @atlassiansox/origin-tracing to work in old versions of Edge (<=16).
        // Origin Tracing needs URLSearchParams, but the API is missing from old Edge,
        // and old Edge is not served the ES5/polyfills bundle.
        typeof URLSearchParams === 'undefined' ? (parcelRequire("lIz8L")) : Promise.resolve()
    ]).then(async ([analyticsWebClientModule, { buildCompressionFunction: buildCompressionFunction, canCompress: canCompress }])=>{
        const { default: AnalyticsWebClient, originType: originType, tenantType: tenantType, userType: userType, envType: envType, platformType: platformType, DwellTimeHelper: DwellTimeHelper, CompressionRule: CompressionRule } = analyticsWebClientModule;
        config = $b76dfd1db5681318$export$45a69314cf48a3eb({
            envType: envType,
            originType: originType,
            environment: environment,
            platformType: platformType,
            locale: locale,
            product: product,
            subproduct: subproduct
        });
        let analyticsWebClient;
        // COMMENTS-195 - Send an operational event when a session starts
        const handleSessionStarted = ()=>{
            analyticsWebClient && analyticsWebClient.sendOperationalEvent({
                action: 'started',
                actionSubject: 'session',
                source: 'webClient'
            });
            if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('cc_engagement_amplitude_session_replay_gate')) $b76dfd1db5681318$var$updateAmplitudeSRSession && $b76dfd1db5681318$var$updateAmplitudeSRSession(analyticsWebClient);
        };
        $b76dfd1db5681318$var$provideDwellTimeHelper(DwellTimeHelper);
        const browserHistory = (0, $efe75065bf034d65$export$1ddb08151d15bc78)();
        const settings = {
            historyReplaceFn: (url)=>{
                const { pathname: pathname, search: search, hash: hash } = new URL(url);
                // Warning: can't pass an instance of URL here as it will erase query params and hash
                // Caused: https://product-fabric.atlassian.net/browse/WS-2317
                browserHistory.replace({
                    pathname: pathname,
                    search: search,
                    hash: hash
                });
            },
            delayQueueCompressors: [
                new CompressionRule(canCompress, buildCompressionFunction())
            ],
            onNewSessionStarted: handleSessionStarted,
            apiHostProtocol: window.location.hostname === 'localhost' ? 'http' : 'https',
            ...(0, $deE7Q.isIsolatedCloud)() && {
                apiHost: `${window.location.hostname}/${$b76dfd1db5681318$var$GAS_V3_ROUTE}`
            },
            disableCookiePersistence: true
        };
        const { shouldFilterEvents: shouldFilterEvents, eventMatchers: eventMatchers } = eventFilterOptions;
        // We suppress analytics events if we're within the mobile app so that we don't
        // end up firing overlapping events from the native and web code
        if (shouldFilterEvents || (0, $c086cef45a2cc129$export$6d5620528cf86fa2)()) {
            /**
       * Don't use Stargate if we're filtering events.
       * According to the analytics-web-client package source code at https://bitbucket.org/atlassian/analytics-web-client/src/bf3bd861ee8d08759e0e79830fcb1d69156db1a5/src/analyticsWebClient.js?at=master#lines-208
       * By default, useStargate is true. On a production instance, even if we set the env to "staging" or "dev", this event will land to the huge production Redash Socrates table, such as cloud.event_operational.
       * For the purpose of preproduction performance detection, we need the analytics event to send to staging table, such as raw_dlf_stg.event_operational.
       * The staging table has much less data, so we can run data transformation job hourly, and query more real-time data. Production table is huge, so we can only run data transformation job daily.
       */ const useStargate = !shouldFilterEvents;
            const { createFilteredAWC: createFilteredAWC } = await (parcelRequire("cq9aL"));
            analyticsWebClient = createFilteredAWC(analyticsWebClientModule, config, {
                ...settings,
                useStargate: useStargate
            }, eventMatchers);
        } else analyticsWebClient = new AnalyticsWebClient(config, settings);
        analyticsWebClient.setTenantInfo(tenantType.CLOUD_ID, cloudId);
        if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('cc_engagement_amplitude_session_replay_gate')) {
            analyticsWebClient.setUpdateAmplitudeSRSession = (callback)=>{
                $b76dfd1db5681318$var$updateAmplitudeSRSession = callback || undefined;
            };
            analyticsWebClient.setAmplitudeAttributesInjector = (injector)=>{
                $b76dfd1db5681318$var$amplitudeAttributesInjector = injector || undefined;
            };
            analyticsWebClient.sendScreenEvent = $b76dfd1db5681318$var$wrapSendMethod(analyticsWebClient.sendScreenEvent);
            analyticsWebClient.sendUIEvent = $b76dfd1db5681318$var$wrapSendMethod(analyticsWebClient.sendUIEvent);
        }
        if (activationId) {
            const workspaceId = $b76dfd1db5681318$export$cac1fa7ce63519ac(cloudId, activationId);
            analyticsWebClient.setWorkspaceInfo(workspaceId);
        }
        // userId is null when the user is anonymous. In that scenario we don't
        // want to set any account ID on the analytics client.
        if (userId) analyticsWebClient.setUserInfo(userType.ATLASSIAN_ACCOUNT, userId);
        analyticsWebClient.setOriginTracingHandlers({
            atlOrigin: (encodedOrigin)=>{
                const origin = (0, $8842ba9e63d2c9a2$export$2e2bcd8739ae039).fromEncoded(encodedOrigin);
                if (origin.isMalformed()) return {};
                const attributes = origin.toAnalyticsAttributes();
                if (userId) (0, $5ffd74b04d73fde2$export$53cb6decc268273b)(attributes);
                return {
                    originTracingAttributes: {
                        id: attributes.originId,
                        product: attributes.originProduct,
                        library: attributes.originLibrary
                    },
                    taskSessionId: origin.id
                };
            }
        });
        if (product === 'embeddedConfluence') {
            const href = window?.location?.href;
            if (href) {
                const url = new URL(href);
                const embeddedConfluenceSource = url.searchParams.get('embeddedConfluenceSource');
                analyticsWebClient.setUIViewedAttributes({
                    embeddedConfluenceSource: embeddedConfluenceSource || 'unknown'
                });
            }
        }
        analyticsWebClient.startUIViewedEvent();
        $b76dfd1db5681318$var$provideClient(analyticsWebClient);
        callback && callback();
    }).catch((error)=>{
        throw new Error(`Analytics Web Client ${error}, ${JSON.stringify({
            ...config
        })}`);
    });
};
const $b76dfd1db5681318$export$e9ba7ef9458d1a4a = ()=>$b76dfd1db5681318$var$analyticsWebClientPromise;
const $b76dfd1db5681318$export$68106415736c5577 = ()=>$b76dfd1db5681318$var$dwellTimeHelperPromise;



/**
 * confluence/meta is used to access dynamic metadata passed from the
 * server to JavaScript via the page HTML.
 */ /**
 *  A backing map to use if the user sets data.
 */ const $b9d7d5d25d527513$export$1591b5b8c61dbb9c = {};
const $b9d7d5d25d527513$export$357972e1dc28ee9f = (key, value)=>{
    $b9d7d5d25d527513$export$1591b5b8c61dbb9c[key] = value;
};
const $b9d7d5d25d527513$export$70f24959ef00553b = (value)=>{
    const evaluatedValue = typeof value === 'string' ? value.toLowerCase() : '';
    const booleanEnum = {
        true: true,
        false: false
    };
    return evaluatedValue in booleanEnum ? booleanEnum[evaluatedValue] : value;
};
const $b9d7d5d25d527513$export$72427a1521dd0069 = (key)=>{
    // Check if we're server-side or client-side
    if ($b9d7d5d25d527513$export$9542afab8c2a5f48()) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const metaEl = document.querySelector(`meta[name='ajs-${key}']`);
        if (metaEl) return $b9d7d5d25d527513$export$70f24959ef00553b(metaEl.content);
        return $b9d7d5d25d527513$export$1591b5b8c61dbb9c[key];
    }
    // Always return undefined on the server-side
    return undefined;
};
const $b9d7d5d25d527513$export$49258654c956d9af = ()=>{
    const map = {};
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!document?.querySelectorAll?.length) return map;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const metas = document.querySelectorAll('meta[name^=ajs-]');
    if (metas) for(let i = 0; i < metas.length; i++){
        const { name: name, content: content } = metas[i];
        map[name.substring(4)] = content;
    }
    return Object.assign(map, $b9d7d5d25d527513$export$1591b5b8c61dbb9c);
};
const $b9d7d5d25d527513$export$594c6655c9709eda = ()=>{
    const metaData = {};
    if ($b9d7d5d25d527513$export$9542afab8c2a5f48()) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const metaTags = document.querySelectorAll('meta[name^=ajs-]');
        for(let i = 0; i < metaTags.length; i++){
            const { name: name, content: content } = metaTags[i];
            metaData[name.replace(/^ajs-/, '')] = content;
        }
    }
    return metaData;
};
const $b9d7d5d25d527513$export$9542afab8c2a5f48 = ()=>{
    return typeof document !== 'undefined';
};
const $b9d7d5d25d527513$export$578af21a462ae10b = ()=>{
    Object.keys($b9d7d5d25d527513$export$1591b5b8c61dbb9c).forEach((key)=>{
        delete $b9d7d5d25d527513$export$1591b5b8c61dbb9c[key];
    });
};


// Please only keep this import as a *type import* to avoid bringing in the entire lib
/**
 * The error returned if an error occurs while calling a REST API.
 */ class $b1c79be305194522$export$e704fce35c66bf42 extends Error {
    constructor({ message: message, method: method, url: url, 'status-code': statusCode }, { route: route, traceId: traceId } = {}){
        const formattedMessage = message.length ? message : `Failed to ${method} ${route || url}`;
        super(formattedMessage);
        /**
     * The URL of the failed request.
     */ this.url = void 0;
        /**
     * The attempted http request method.
     */ this.method = void 0;
        /**
     * The status code returned in the response
     */ this.statusCode = void 0;
        /**
     * The name of the requested route (without UGC/PII)
     */ this.route = void 0;
        /**
     * The traceId of the request
     */ this.traceId = void 0;
        this.url = url;
        this.route = route;
        this.method = method;
        this.statusCode = statusCode;
        this.traceId = traceId;
    }
}


function $8a3a8685062675cc$var$isApolloErrorInterop(error) {
    // theoretically this could be an `instanceof ApolloErrorInterop` check, but bringing another
    // dependency to this package for the sake of this single check seems like an overkill
    return typeof error === 'object' && error !== null && ('graphQLErrors' in error || 'networkError' in error);
}
const $8a3a8685062675cc$var$REACT_ERROR_CONTEXT_SYMBOL = Symbol('React error context');
function $8a3a8685062675cc$export$df1c6d0ba3db287e(error, context) {
    if (typeof error === 'object' && error !== null) error[$8a3a8685062675cc$var$REACT_ERROR_CONTEXT_SYMBOL] = context;
}
function $8a3a8685062675cc$export$8b5fa6128aa81e5e(error) {
    if (typeof error === 'object' && error !== null) return error[$8a3a8685062675cc$var$REACT_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
const $8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL = Symbol('Graphql error context');
function $8a3a8685062675cc$export$6f0dbe4e2bbe0509(error, context) {
    if (typeof error === 'object' && error !== null) error[$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL] = context;
}
function $8a3a8685062675cc$export$b19e649eafc62480(error) {
    if (typeof error !== 'object' || error === null) return undefined;
    if (error[$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL]) return error[$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL];
    // Currently the graphql error context is set on the first entry of the `graphqlErrors`
    // property of `ApolloError`. That way, `ApolloError` itself does not have the context
    // set properly. This method is a measure to overcome this and make sure that
    // we are able to retrieve the context correctly.
    return $8a3a8685062675cc$var$getGraphqlErrorAttributesFromApolloError(error);
}
function $8a3a8685062675cc$var$getGraphqlErrorAttributesFromApolloError(error) {
    if (!$8a3a8685062675cc$var$isApolloErrorInterop(error)) return undefined;
    const graphqlErrors = error.graphQLErrors;
    // the context is populated by next/packages/graphql/src/links/OnErrorLink.ts
    if (graphqlErrors && graphqlErrors.length > 0 && graphqlErrors[0][$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL]) return graphqlErrors[0][$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL];
    if (error.networkError) return error.networkError[$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
const $8a3a8685062675cc$var$SLA_ERROR_CONTEXT_SYMBOL = Symbol('SLA error context');
function $8a3a8685062675cc$export$d4fe004fb0aaaf4f(error) {
    if (typeof error === 'object' && error !== null) return error[$8a3a8685062675cc$var$SLA_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
function $8a3a8685062675cc$export$a986f274521b30d7(error, context) {
    if (typeof error === 'object' && error !== null) error[$8a3a8685062675cc$var$SLA_ERROR_CONTEXT_SYMBOL] = context;
}
function $8a3a8685062675cc$var$getBadStatusErrorAttributes(error) {
    if (!(error instanceof (0, $165abb9eb28d58da$export$12c8b3d0a1a46f87))) return undefined;
    return {
        statusCode: error.response.status,
        traceId: (0, $32b74afc9e827b44$export$9f229e40eb65abfc)(error.response)
    };
}
function $8a3a8685062675cc$var$getConfluenceRestApiErrorAttributes(error) {
    if (!(error instanceof (0, $b1c79be305194522$export$e704fce35c66bf42))) return undefined;
    return {
        statusCode: error.statusCode,
        restMethod: error.method,
        restRoute: error.route,
        traceId: error.traceId
    };
}
const $8a3a8685062675cc$var$CONTENT_ERROR_CONTEXT_SYMBOL = Symbol('Content error context');
function $8a3a8685062675cc$export$c37ca7d37ab54fcc(error, context) {
    if (typeof error === 'object' && error !== null) error[$8a3a8685062675cc$var$CONTENT_ERROR_CONTEXT_SYMBOL] = context;
}
function $8a3a8685062675cc$export$bc010311f017b17c(error) {
    if (typeof error === 'object' && error !== null) return error[$8a3a8685062675cc$var$CONTENT_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
const $8a3a8685062675cc$var$LOADABLE_ERROR_CONTEXT_SYMBOL = Symbol('Loadable error context');
function $8a3a8685062675cc$export$6f86bd8e510ff607(error, context) {
    if (typeof error === 'object' && error !== null) error[$8a3a8685062675cc$var$LOADABLE_ERROR_CONTEXT_SYMBOL] = context;
}
function $8a3a8685062675cc$export$b8f8f1e62c6397ed(error) {
    if (typeof error === 'object' && error !== null) return error[$8a3a8685062675cc$var$LOADABLE_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
function $8a3a8685062675cc$export$69408b85ed2a0e77(error) {
    const traceId = $8a3a8685062675cc$export$b19e649eafc62480(error)?.traceId || $8a3a8685062675cc$export$b19e649eafc62480(error?.graphQLErrors?.[0])?.traceId;
    if (traceId) return traceId;
    // handle experimental query error
    if (error.graphQLErrors?.[0].originalError instanceof (0, $165abb9eb28d58da$export$12c8b3d0a1a46f87)) return error.graphQLErrors[0].originalError?.traceId;
    return null;
}
function $8a3a8685062675cc$export$d08bac32cb78075f(error) {
    if (!error || typeof error !== 'object') return {};
    return {
        ...$8a3a8685062675cc$export$8b5fa6128aa81e5e(error),
        ...$8a3a8685062675cc$export$b19e649eafc62480(error),
        ...$8a3a8685062675cc$export$d4fe004fb0aaaf4f(error),
        ...$8a3a8685062675cc$export$bc010311f017b17c(error),
        ...$8a3a8685062675cc$export$b8f8f1e62c6397ed(error),
        ...$8a3a8685062675cc$var$getConfluenceRestApiErrorAttributes(error),
        ...$8a3a8685062675cc$var$getBadStatusErrorAttributes(error)
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Get a key to uniquely identify a context value */ function $a6694f96a559a9a5$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var $a6694f96a559a9a5$var$BaseContext = /** @class */ function() {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function(key) {
            return self._currentContext.get(key);
        };
        self.setValue = function(key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function(key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}();
var $a6694f96a559a9a5$export$78df28f9b2f9a7dc = new $a6694f96a559a9a5$var$BaseContext();
















/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $7065a8cc71eca745$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $7065a8cc71eca745$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $7065a8cc71eca745$export$a27e5df35d1539a6 = /** @class */ function() {
    function NoopContextManager() {}
    NoopContextManager.prototype.active = function() {
        return 0, $a6694f96a559a9a5$export$78df28f9b2f9a7dc;
    };
    NoopContextManager.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, $7065a8cc71eca745$var$__spreadArray([
            thisArg
        ], $7065a8cc71eca745$var$__read(args), false));
    };
    NoopContextManager.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function() {
        return this;
    };
    NoopContextManager.prototype.disable = function() {
        return this;
    };
    return NoopContextManager;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $ef5c756fdfb11581$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $c05ef5e142c6a87f$export$a4ad2735b021c132 = '1.9.0';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $6cf57df2e75b0f0d$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $6cf57df2e75b0f0d$export$a5733a4d26a1ec61(ownVersion) {
    var acceptedVersions = new Set([
        ownVersion
    ]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match($6cf57df2e75b0f0d$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match($6cf57df2e75b0f0d$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var $6cf57df2e75b0f0d$export$7fc0d8c3ab188c4c = $6cf57df2e75b0f0d$export$a5733a4d26a1ec61((0, $c05ef5e142c6a87f$export$a4ad2735b021c132));


var $7ed60f360d25eba5$var$major = (0, $c05ef5e142c6a87f$export$a4ad2735b021c132).split('.')[0];
var $7ed60f360d25eba5$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + $7ed60f360d25eba5$var$major);
var $7ed60f360d25eba5$var$_global = (0, $ef5c756fdfb11581$export$5c524ddf7208c00c);
function $7ed60f360d25eba5$export$d586ae880b433238(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) allowOverride = false;
    var api = $7ed60f360d25eba5$var$_global[$7ed60f360d25eba5$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $7ed60f360d25eba5$var$_global[$7ed60f360d25eba5$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $c05ef5e142c6a87f$export$a4ad2735b021c132)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $c05ef5e142c6a87f$export$a4ad2735b021c132)) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + (0, $c05ef5e142c6a87f$export$a4ad2735b021c132));
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + (0, $c05ef5e142c6a87f$export$a4ad2735b021c132) + ".");
    return true;
}
function $7ed60f360d25eba5$export$a4e55266d2135a7f(type) {
    var _a, _b;
    var globalVersion = (_a = $7ed60f360d25eba5$var$_global[$7ed60f360d25eba5$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $6cf57df2e75b0f0d$export$7fc0d8c3ab188c4c)(globalVersion)) return;
    return (_b = $7ed60f360d25eba5$var$_global[$7ed60f360d25eba5$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $7ed60f360d25eba5$export$d42ac835f38d1fb2(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + (0, $c05ef5e142c6a87f$export$a4ad2735b021c132) + ".");
    var api = $7ed60f360d25eba5$var$_global[$7ed60f360d25eba5$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $72844ffca8f9dc10$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $72844ffca8f9dc10$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */ var $72844ffca8f9dc10$export$b4bccc12f5b13129 = /** @class */ function() {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    DiagComponentLogger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $72844ffca8f9dc10$var$logProxy('debug', this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $72844ffca8f9dc10$var$logProxy('error', this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $72844ffca8f9dc10$var$logProxy('info', this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $72844ffca8f9dc10$var$logProxy('warn', this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $72844ffca8f9dc10$var$logProxy('verbose', this._namespace, args);
    };
    return DiagComponentLogger;
}();
function $72844ffca8f9dc10$var$logProxy(funcName, namespace, args) {
    var logger = (0, $7ed60f360d25eba5$export$a4e55266d2135a7f)('diag');
    // shortcut if logger not set
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, $72844ffca8f9dc10$var$__spreadArray([], $72844ffca8f9dc10$var$__read(args), false));
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $6f0383fd56b98d64$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($6f0383fd56b98d64$export$b7d7b4c0f3c95263 || ($6f0383fd56b98d64$export$b7d7b4c0f3c95263 = {}));


function $95cb1c53e6f1b968$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $6f0383fd56b98d64$export$b7d7b4c0f3c95263).NONE) maxLevel = (0, $6f0383fd56b98d64$export$b7d7b4c0f3c95263).NONE;
    else if (maxLevel > (0, $6f0383fd56b98d64$export$b7d7b4c0f3c95263).ALL) maxLevel = (0, $6f0383fd56b98d64$export$b7d7b4c0f3c95263).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, $6f0383fd56b98d64$export$b7d7b4c0f3c95263).ERROR),
        warn: _filterFunc('warn', (0, $6f0383fd56b98d64$export$b7d7b4c0f3c95263).WARN),
        info: _filterFunc('info', (0, $6f0383fd56b98d64$export$b7d7b4c0f3c95263).INFO),
        debug: _filterFunc('debug', (0, $6f0383fd56b98d64$export$b7d7b4c0f3c95263).DEBUG),
        verbose: _filterFunc('verbose', (0, $6f0383fd56b98d64$export$b7d7b4c0f3c95263).VERBOSE)
    };
}




var $6d29ebbe7ba80ead$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $6d29ebbe7ba80ead$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $6d29ebbe7ba80ead$var$API_NAME = 'diag';
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */ var $6d29ebbe7ba80ead$export$5c8937ffc688cfd3 = /** @class */ function() {
    /**
     * Private internal constructor
     * @private
     */ function DiagAPI() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = (0, $7ed60f360d25eba5$export$a4e55266d2135a7f)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName].apply(logger, $6d29ebbe7ba80ead$var$__spreadArray([], $6d29ebbe7ba80ead$var$__read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function(logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: (0, $6f0383fd56b98d64$export$b7d7b4c0f3c95263).INFO
            };
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = (0, $7ed60f360d25eba5$export$a4e55266d2135a7f)('diag');
            var newLogger = (0, $95cb1c53e6f1b968$export$9a9cc475abb19689)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $6f0383fd56b98d64$export$b7d7b4c0f3c95263).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return (0, $7ed60f360d25eba5$export$d586ae880b433238)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function() {
            (0, $7ed60f360d25eba5$export$d42ac835f38d1fb2)($6d29ebbe7ba80ead$var$API_NAME, self);
        };
        self.createComponentLogger = function(options) {
            return new (0, $72844ffca8f9dc10$export$b4bccc12f5b13129)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
    /** Get the singleton instance of the DiagAPI API */ DiagAPI.instance = function() {
        if (!this._instance) this._instance = new DiagAPI();
        return this._instance;
    };
    return DiagAPI;
}();


var $f3a51cb3758c0466$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f3a51cb3758c0466$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $f3a51cb3758c0466$var$API_NAME = 'context';
var $f3a51cb3758c0466$var$NOOP_CONTEXT_MANAGER = new (0, $7065a8cc71eca745$export$a27e5df35d1539a6)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */ var $f3a51cb3758c0466$export$4148866f0a453927 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function ContextAPI() {}
    /** Get the singleton instance of the Context API */ ContextAPI.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI();
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
        return (0, $7ed60f360d25eba5$export$d586ae880b433238)($f3a51cb3758c0466$var$API_NAME, contextManager, (0, $6d29ebbe7ba80ead$export$5c8937ffc688cfd3).instance());
    };
    /**
     * Get the currently active context
     */ ContextAPI.prototype.active = function() {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ ContextAPI.prototype.with = function(context, fn, thisArg) {
        var _a;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a = this._getContextManager()).with.apply(_a, $f3a51cb3758c0466$var$__spreadArray([
            context,
            fn,
            thisArg
        ], $f3a51cb3758c0466$var$__read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ ContextAPI.prototype.bind = function(context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function() {
        return (0, $7ed60f360d25eba5$export$a4e55266d2135a7f)($f3a51cb3758c0466$var$API_NAME) || $f3a51cb3758c0466$var$NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */ ContextAPI.prototype.disable = function() {
        this._getContextManager().disable();
        (0, $7ed60f360d25eba5$export$d42ac835f38d1fb2)($f3a51cb3758c0466$var$API_NAME, (0, $6d29ebbe7ba80ead$export$5c8937ffc688cfd3).instance());
    };
    return ContextAPI;
}();


var $43097f6bb448a328$export$a078c61943f9dbbe = (0, $f3a51cb3758c0466$export$4148866f0a453927).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $88593d3676b70ce4$export$c042e7c2f59bc046 = (0, $6d29ebbe7ba80ead$export$5c8937ffc688cfd3).instance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6b471e263ed149dc$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ var $6b471e263ed149dc$export$c23c6f85dd4fc1e9 = /** @class */ function() {
    function NoopMeter() {}
    /**
     * @see {@link Meter.createGauge}
     */ NoopMeter.prototype.createGauge = function(_name, _options) {
        return $6b471e263ed149dc$export$dd01300aacbcec1c;
    };
    /**
     * @see {@link Meter.createHistogram}
     */ NoopMeter.prototype.createHistogram = function(_name, _options) {
        return $6b471e263ed149dc$export$689c32a6a552e1a6;
    };
    /**
     * @see {@link Meter.createCounter}
     */ NoopMeter.prototype.createCounter = function(_name, _options) {
        return $6b471e263ed149dc$export$e6d19fe5233efc54;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */ NoopMeter.prototype.createUpDownCounter = function(_name, _options) {
        return $6b471e263ed149dc$export$2f189cd99d2b7429;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */ NoopMeter.prototype.createObservableGauge = function(_name, _options) {
        return $6b471e263ed149dc$export$ea67e3c6ff624776;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */ NoopMeter.prototype.createObservableCounter = function(_name, _options) {
        return $6b471e263ed149dc$export$163422b94c3edbcb;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ NoopMeter.prototype.createObservableUpDownCounter = function(_name, _options) {
        return $6b471e263ed149dc$export$5b8be9ab17b673b3;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ NoopMeter.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ NoopMeter.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter;
}();
var $6b471e263ed149dc$export$834a616d1cf278b = /** @class */ function() {
    function NoopMetric() {}
    return NoopMetric;
}();
var $6b471e263ed149dc$export$b556ba0f560c45b = /** @class */ function(_super) {
    $6b471e263ed149dc$var$__extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric;
}($6b471e263ed149dc$export$834a616d1cf278b);
var $6b471e263ed149dc$export$df09a35db160df98 = /** @class */ function(_super) {
    $6b471e263ed149dc$var$__extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric;
}($6b471e263ed149dc$export$834a616d1cf278b);
var $6b471e263ed149dc$export$b7f4a3c7ea16c24 = /** @class */ function(_super) {
    $6b471e263ed149dc$var$__extends(NoopGaugeMetric, _super);
    function NoopGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric.prototype.record = function(_value, _attributes) {};
    return NoopGaugeMetric;
}($6b471e263ed149dc$export$834a616d1cf278b);
var $6b471e263ed149dc$export$ef064c3e0426c607 = /** @class */ function(_super) {
    $6b471e263ed149dc$var$__extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric;
}($6b471e263ed149dc$export$834a616d1cf278b);
var $6b471e263ed149dc$export$a5a3e7829c289482 = /** @class */ function() {
    function NoopObservableMetric() {}
    NoopObservableMetric.prototype.addCallback = function(_callback) {};
    NoopObservableMetric.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric;
}();
var $6b471e263ed149dc$export$7a7e4b169d5c93a8 = /** @class */ function(_super) {
    $6b471e263ed149dc$var$__extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}($6b471e263ed149dc$export$a5a3e7829c289482);
var $6b471e263ed149dc$export$6990a2f90809ffc1 = /** @class */ function(_super) {
    $6b471e263ed149dc$var$__extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}($6b471e263ed149dc$export$a5a3e7829c289482);
var $6b471e263ed149dc$export$3ec3555bc6f693a4 = /** @class */ function(_super) {
    $6b471e263ed149dc$var$__extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}($6b471e263ed149dc$export$a5a3e7829c289482);
var $6b471e263ed149dc$export$65e277d35235a01f = new $6b471e263ed149dc$export$c23c6f85dd4fc1e9();
var $6b471e263ed149dc$export$e6d19fe5233efc54 = new $6b471e263ed149dc$export$b556ba0f560c45b();
var $6b471e263ed149dc$export$dd01300aacbcec1c = new $6b471e263ed149dc$export$b7f4a3c7ea16c24();
var $6b471e263ed149dc$export$689c32a6a552e1a6 = new $6b471e263ed149dc$export$ef064c3e0426c607();
var $6b471e263ed149dc$export$2f189cd99d2b7429 = new $6b471e263ed149dc$export$df09a35db160df98();
var $6b471e263ed149dc$export$163422b94c3edbcb = new $6b471e263ed149dc$export$7a7e4b169d5c93a8();
var $6b471e263ed149dc$export$ea67e3c6ff624776 = new $6b471e263ed149dc$export$6990a2f90809ffc1();
var $6b471e263ed149dc$export$5b8be9ab17b673b3 = new $6b471e263ed149dc$export$3ec3555bc6f693a4();
function $6b471e263ed149dc$export$bc3a498ccbb5c2b5() {
    return $6b471e263ed149dc$export$65e277d35235a01f;
}


/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */ var $d598e59723b8caa1$export$51c513ea08316108 = /** @class */ function() {
    function NoopMeterProvider() {}
    NoopMeterProvider.prototype.getMeter = function(_name, _version, _options) {
        return 0, $6b471e263ed149dc$export$65e277d35235a01f;
    };
    return NoopMeterProvider;
}();
var $d598e59723b8caa1$export$d21fe83355c56e18 = new $d598e59723b8caa1$export$51c513ea08316108();




var $1d1d3c64107b51c6$var$API_NAME = 'metrics';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */ var $1d1d3c64107b51c6$export$1339f6eb6111c638 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function MetricsAPI() {}
    /** Get the singleton instance of the Metrics API */ MetricsAPI.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI();
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ MetricsAPI.prototype.setGlobalMeterProvider = function(provider) {
        return (0, $7ed60f360d25eba5$export$d586ae880b433238)($1d1d3c64107b51c6$var$API_NAME, provider, (0, $6d29ebbe7ba80ead$export$5c8937ffc688cfd3).instance());
    };
    /**
     * Returns the global meter provider.
     */ MetricsAPI.prototype.getMeterProvider = function() {
        return (0, $7ed60f360d25eba5$export$a4e55266d2135a7f)($1d1d3c64107b51c6$var$API_NAME) || (0, $d598e59723b8caa1$export$d21fe83355c56e18);
    };
    /**
     * Returns a meter from the global meter provider.
     */ MetricsAPI.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */ MetricsAPI.prototype.disable = function() {
        (0, $7ed60f360d25eba5$export$d42ac835f38d1fb2)($1d1d3c64107b51c6$var$API_NAME, (0, $6d29ebbe7ba80ead$export$5c8937ffc688cfd3).instance());
    };
    return MetricsAPI;
}();


var $36b5e32bef45d774$export$b0c5c2fac8144e54 = (0, $1d1d3c64107b51c6$export$1339f6eb6111c638).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ var $f337c252a5d92a22$export$8356c7eb3af7963b = /** @class */ function() {
    function NoopTextMapPropagator() {}
    /** Noop inject function does nothing */ NoopTextMapPropagator.prototype.inject = function(_context, _carrier) {};
    /** Noop extract function does nothing and returns the input context */ NoopTextMapPropagator.prototype.extract = function(context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $1e4b2c5d26054798$export$a0f575f55f38720a = {
    get: function(carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys: function(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var $1e4b2c5d26054798$export$f70f1d111fccf1c1 = {
    set: function(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/**
 * Baggage key
 */ var $7c7d99af298b7f5d$var$BAGGAGE_KEY = (0, $a6694f96a559a9a5$export$b8c322c5a7cfce78)('OpenTelemetry Baggage Key');
function $7c7d99af298b7f5d$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($7c7d99af298b7f5d$var$BAGGAGE_KEY) || undefined;
}
function $7c7d99af298b7f5d$export$120a1756099436ee() {
    return $7c7d99af298b7f5d$export$f3bffa0b5dd10d1e((0, $f3a51cb3758c0466$export$4148866f0a453927).getInstance().active());
}
function $7c7d99af298b7f5d$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($7c7d99af298b7f5d$var$BAGGAGE_KEY, baggage);
}
function $7c7d99af298b7f5d$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($7c7d99af298b7f5d$var$BAGGAGE_KEY);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $145aab604a09df2e$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $145aab604a09df2e$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $145aab604a09df2e$export$b8c511fa1a5f4987 = /** @class */ function() {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a) {
            var _b = $145aab604a09df2e$var$__read(_a, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function() {
        var e_1, _a;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for(var keys_1 = $145aab604a09df2e$var$__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function() {
        return new BaggageImpl();
    };
    return BaggageImpl;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ var $bf0354f1912ac564$export$92dd2fe8ddb5cb7 = Symbol('BaggageEntryMetadata');


var $906918d0c26c40eb$var$diag = (0, $6d29ebbe7ba80ead$export$5c8937ffc688cfd3).instance();
function $906918d0c26c40eb$export$1034a425c7384452(entries) {
    if (entries === void 0) entries = {};
    return new (0, $145aab604a09df2e$export$b8c511fa1a5f4987)(new Map(Object.entries(entries)));
}
function $906918d0c26c40eb$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== 'string') {
        $906918d0c26c40eb$var$diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = '';
    }
    return {
        __TYPE__: (0, $bf0354f1912ac564$export$92dd2fe8ddb5cb7),
        toString: function() {
            return str;
        }
    };
}



var $83713bff934088cf$var$API_NAME = 'propagation';
var $83713bff934088cf$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $f337c252a5d92a22$export$8356c7eb3af7963b)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */ var $83713bff934088cf$export$471eda0a6213cac9 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function PropagationAPI() {
        this.createBaggage = (0, $906918d0c26c40eb$export$1034a425c7384452);
        this.getBaggage = (0, $7c7d99af298b7f5d$export$f3bffa0b5dd10d1e);
        this.getActiveBaggage = (0, $7c7d99af298b7f5d$export$120a1756099436ee);
        this.setBaggage = (0, $7c7d99af298b7f5d$export$adc9ca19eab3f500);
        this.deleteBaggage = (0, $7c7d99af298b7f5d$export$4ca3a8a743c9f633);
    }
    /** Get the singleton instance of the Propagator API */ PropagationAPI.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI();
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ PropagationAPI.prototype.setGlobalPropagator = function(propagator) {
        return (0, $7ed60f360d25eba5$export$d586ae880b433238)($83713bff934088cf$var$API_NAME, propagator, (0, $6d29ebbe7ba80ead$export$5c8937ffc688cfd3).instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ PropagationAPI.prototype.inject = function(context, carrier, setter) {
        if (setter === void 0) setter = (0, $1e4b2c5d26054798$export$f70f1d111fccf1c1);
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ PropagationAPI.prototype.extract = function(context, carrier, getter) {
        if (getter === void 0) getter = (0, $1e4b2c5d26054798$export$a0f575f55f38720a);
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */ PropagationAPI.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */ PropagationAPI.prototype.disable = function() {
        (0, $7ed60f360d25eba5$export$d42ac835f38d1fb2)($83713bff934088cf$var$API_NAME, (0, $6d29ebbe7ba80ead$export$5c8937ffc688cfd3).instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function() {
        return (0, $7ed60f360d25eba5$export$a4e55266d2135a7f)($83713bff934088cf$var$API_NAME) || $83713bff934088cf$var$NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}();


var $e2202e6ddf227b3e$export$3e49040daa9dba20 = (0, $83713bff934088cf$export$471eda0a6213cac9).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $819cfd60e9985d6e$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($819cfd60e9985d6e$export$bf9049ad2b0883ff || ($819cfd60e9985d6e$export$bf9049ad2b0883ff = {}));


var $662ed26abdd53ed1$export$55cc39fb0d4bb4c0 = '0000000000000000';
var $662ed26abdd53ed1$export$22be96e88d95e128 = '00000000000000000000000000000000';
var $662ed26abdd53ed1$export$8591e4c852b66703 = {
    traceId: $662ed26abdd53ed1$export$22be96e88d95e128,
    spanId: $662ed26abdd53ed1$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $819cfd60e9985d6e$export$bf9049ad2b0883ff).NONE
};


/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */ var $bcb0de3b2cdb621b$export$972d28f7c6a8c6c7 = /** @class */ function() {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) _spanContext = (0, $662ed26abdd53ed1$export$8591e4c852b66703);
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function() {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function(_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function(_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function(_links) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function(_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function(_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function(_endTime) {};
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function() {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan;
}();



/**
 * span key
 */ var $1674daf3bac05545$var$SPAN_KEY = (0, $a6694f96a559a9a5$export$b8c322c5a7cfce78)('OpenTelemetry Context Key SPAN');
function $1674daf3bac05545$export$246e04ba06066af1(context) {
    return context.getValue($1674daf3bac05545$var$SPAN_KEY) || undefined;
}
function $1674daf3bac05545$export$1be426a8e585c83e() {
    return $1674daf3bac05545$export$246e04ba06066af1((0, $f3a51cb3758c0466$export$4148866f0a453927).getInstance().active());
}
function $1674daf3bac05545$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($1674daf3bac05545$var$SPAN_KEY, span);
}
function $1674daf3bac05545$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($1674daf3bac05545$var$SPAN_KEY);
}
function $1674daf3bac05545$export$c90bf5428c14cdb1(context, spanContext) {
    return $1674daf3bac05545$export$8ab2f2e6ee8ed0a8(context, new (0, $bcb0de3b2cdb621b$export$972d28f7c6a8c6c7)(spanContext));
}
function $1674daf3bac05545$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $1674daf3bac05545$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $0171274bf0bcbc57$var$VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var $0171274bf0bcbc57$var$VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function $0171274bf0bcbc57$export$29dd34cf1269f6da(traceId) {
    return $0171274bf0bcbc57$var$VALID_TRACEID_REGEX.test(traceId) && traceId !== (0, $662ed26abdd53ed1$export$22be96e88d95e128);
}
function $0171274bf0bcbc57$export$8e51c6d8f0586aff(spanId) {
    return $0171274bf0bcbc57$var$VALID_SPANID_REGEX.test(spanId) && spanId !== (0, $662ed26abdd53ed1$export$55cc39fb0d4bb4c0);
}
function $0171274bf0bcbc57$export$e4373b9a2c09216c(spanContext) {
    return $0171274bf0bcbc57$export$29dd34cf1269f6da(spanContext.traceId) && $0171274bf0bcbc57$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $0171274bf0bcbc57$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $bcb0de3b2cdb621b$export$972d28f7c6a8c6c7)(spanContext);
}


var $7636880007275ae5$var$contextApi = (0, $f3a51cb3758c0466$export$4148866f0a453927).getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */ var $7636880007275ae5$export$714c1036cabcd223 = /** @class */ function() {
    function NoopTracer() {}
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function(name, options, context) {
        if (context === void 0) context = $7636880007275ae5$var$contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $bcb0de3b2cdb621b$export$972d28f7c6a8c6c7)();
        var parentFromContext = context && (0, $1674daf3bac05545$export$1a635f8f0b912781)(context);
        if ($7636880007275ae5$var$isSpanContext(parentFromContext) && (0, $0171274bf0bcbc57$export$e4373b9a2c09216c)(parentFromContext)) return new (0, $bcb0de3b2cdb621b$export$972d28f7c6a8c6c7)(parentFromContext);
        else return new (0, $bcb0de3b2cdb621b$export$972d28f7c6a8c6c7)();
    };
    NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $7636880007275ae5$var$contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = (0, $1674daf3bac05545$export$8ab2f2e6ee8ed0a8)(parentContext, span);
        return $7636880007275ae5$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}();
function $7636880007275ae5$var$isSpanContext(spanContext) {
    return typeof spanContext === 'object' && typeof spanContext['spanId'] === 'string' && typeof spanContext['traceId'] === 'string' && typeof spanContext['traceFlags'] === 'number';
}


var $cd4c6d76f4c8a08f$var$NOOP_TRACER = new (0, $7636880007275ae5$export$714c1036cabcd223)();
/**
 * Proxy tracer provided by the proxy tracer provider
 */ var $cd4c6d76f4c8a08f$export$df2c38268c6bb6b3 = /** @class */ function() {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ ProxyTracer.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $cd4c6d76f4c8a08f$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */ var $d4a01f4c33033e11$export$87d8e93756f9e86e = /** @class */ function() {
    function NoopTracerProvider() {}
    NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
        return new (0, $7636880007275ae5$export$714c1036cabcd223)();
    };
    return NoopTracerProvider;
}();


var $14487037e26401ec$var$NOOP_TRACER_PROVIDER = new (0, $d4a01f4c33033e11$export$87d8e93756f9e86e)();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */ var $14487037e26401ec$export$4137aabcb4254962 = /** @class */ function() {
    function ProxyTracerProvider() {}
    /**
     * Get a {@link ProxyTracer}
     */ ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $cd4c6d76f4c8a08f$export$df2c38268c6bb6b3)(this, name, version, options);
    };
    ProxyTracerProvider.prototype.getDelegate = function() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $14487037e26401ec$var$NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */ ProxyTracerProvider.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}();





var $c055bf669fcada38$var$API_NAME = 'trace';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */ var $c055bf669fcada38$export$2cccde6fcc7b568a = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function TraceAPI() {
        this._proxyTracerProvider = new (0, $14487037e26401ec$export$4137aabcb4254962)();
        this.wrapSpanContext = (0, $0171274bf0bcbc57$export$c19cc0f1911bdb85);
        this.isSpanContextValid = (0, $0171274bf0bcbc57$export$e4373b9a2c09216c);
        this.deleteSpan = (0, $1674daf3bac05545$export$a6bbfe9a17f7941c);
        this.getSpan = (0, $1674daf3bac05545$export$246e04ba06066af1);
        this.getActiveSpan = (0, $1674daf3bac05545$export$1be426a8e585c83e);
        this.getSpanContext = (0, $1674daf3bac05545$export$1a635f8f0b912781);
        this.setSpan = (0, $1674daf3bac05545$export$8ab2f2e6ee8ed0a8);
        this.setSpanContext = (0, $1674daf3bac05545$export$c90bf5428c14cdb1);
    }
    /** Get the singleton instance of the Trace API */ TraceAPI.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI();
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
        var success = (0, $7ed60f360d25eba5$export$d586ae880b433238)($c055bf669fcada38$var$API_NAME, this._proxyTracerProvider, (0, $6d29ebbe7ba80ead$export$5c8937ffc688cfd3).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    /**
     * Returns the global tracer provider.
     */ TraceAPI.prototype.getTracerProvider = function() {
        return (0, $7ed60f360d25eba5$export$a4e55266d2135a7f)($c055bf669fcada38$var$API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */ TraceAPI.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */ TraceAPI.prototype.disable = function() {
        (0, $7ed60f360d25eba5$export$d42ac835f38d1fb2)($c055bf669fcada38$var$API_NAME, (0, $6d29ebbe7ba80ead$export$5c8937ffc688cfd3).instance());
        this._proxyTracerProvider = new (0, $14487037e26401ec$export$4137aabcb4254962)();
    };
    return TraceAPI;
}();


var $293358a77b98e233$export$357889f174732d38 = (0, $c055bf669fcada38$export$2cccde6fcc7b568a).getInstance();


var // Default export.
$43823dc5212e39b1$export$2e2bcd8739ae039 = {
    context: (0, $43097f6bb448a328$export$a078c61943f9dbbe),
    diag: (0, $88593d3676b70ce4$export$c042e7c2f59bc046),
    metrics: (0, $36b5e32bef45d774$export$b0c5c2fac8144e54),
    propagation: (0, $e2202e6ddf227b3e$export$3e49040daa9dba20),
    trace: (0, $293358a77b98e233$export$357889f174732d38)
};



var $6oQI4 = parcelRequire("6oQI4");

const $9c16bba5deda8cf2$export$1069c2293742749e = (0, $a6694f96a559a9a5$export$b8c322c5a7cfce78)('type');



const $e2e9f70b4f58b5ed$export$ccdc89d1d45284c2 = (0, $a6694f96a559a9a5$export$b8c322c5a7cfce78)('spanId');


const $96978f64a2608679$export$ca000e230c0caa3e = {
    context: null
};



const $12849b6b770cec75$export$65f3d43d675bb81b = (0, $a6694f96a559a9a5$export$b8c322c5a7cfce78)('traceId');


function $3f9dbb98c6868de1$export$b6ac780db3a3cc77() {
    if ((0, $6oQI4.fg)('platform_ufo_enable_otel_context_manager')) {
        // Get trace context from active context
        const activeTraceContext = {
            traceId: String((0, $43097f6bb448a328$export$a078c61943f9dbbe).active().getValue((0, $12849b6b770cec75$export$65f3d43d675bb81b))),
            spanId: String((0, $43097f6bb448a328$export$a078c61943f9dbbe).active().getValue((0, $e2e9f70b4f58b5ed$export$ccdc89d1d45284c2))),
            type: String((0, $43097f6bb448a328$export$a078c61943f9dbbe).active().getValue((0, $9c16bba5deda8cf2$export$1069c2293742749e)))
        };
        // Return activeTraceContext if traceId and spanId are not "undefined"
        return activeTraceContext.traceId !== 'undefined' && activeTraceContext.spanId !== 'undefined' ? activeTraceContext : undefined;
    } else return (0, $96978f64a2608679$export$ca000e230c0caa3e).context || undefined;
}


/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Preserves the existing UUID implementation.

/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $e652262e1c536287$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $e652262e1c536287$export$2e2bcd8739ae039 = $e652262e1c536287$var$coinflip;


const $ee361b69170cd5c9$export$4c07c8a3507ce307 = 255;
const $ee361b69170cd5c9$var$GQL_OPERATION_PARAMS = [
    'operation',
    'operationName',
    'q'
];
function $ee361b69170cd5c9$var$isGqlUrl(name) {
    try {
        const url = new URL(name);
        const searchParams = url.search ? new URLSearchParams(url.search) : null;
        return $ee361b69170cd5c9$var$GQL_OPERATION_PARAMS.some((param)=>Boolean(searchParams?.get(param)));
    } catch  {
        return false;
    }
}
function $ee361b69170cd5c9$export$23e69abaca7d0236(name) {
    if (name.length <= $ee361b69170cd5c9$export$4c07c8a3507ce307) return name;
    if ($ee361b69170cd5c9$var$isGqlUrl(name)) return name;
    return name.slice(0, $ee361b69170cd5c9$export$4c07c8a3507ce307);
}


/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $7FIrY = parcelRequire("7FIrY");

var $6oQI4 = parcelRequire("6oQI4");
let $d0427bdd60d98885$var$config;
/**
 * Cached result of `isFedrampModerate()` so we don't re-parse cookies on
 * every selector lookup. Reset via `__resetFedrampOverrideCacheForTests` in
 * unit tests only.
 */ let $d0427bdd60d98885$var$cachedIsFedrampModerate;
function $d0427bdd60d98885$var$detectIsFedrampModerate() {
    if ($d0427bdd60d98885$var$cachedIsFedrampModerate !== undefined) return $d0427bdd60d98885$var$cachedIsFedrampModerate;
    try {
        $d0427bdd60d98885$var$cachedIsFedrampModerate = (0, $7FIrY.isFedrampModerate)();
    } catch  {
        // Defensive default: if perimeter detection throws, treat as non-FedRAMP
        // so UFO behaviour is unchanged. Mirrors `analyticsWebClient` pattern.
        $d0427bdd60d98885$var$cachedIsFedrampModerate = false;
    }
    return $d0427bdd60d98885$var$cachedIsFedrampModerate;
}
function $d0427bdd60d98885$export$89dc2b6be8cc261() {
    $d0427bdd60d98885$var$cachedIsFedrampModerate = undefined;
}
function $d0427bdd60d98885$export$1133b5e2873baa7a() {
    try {
        return $d0427bdd60d98885$var$detectIsFedrampModerate();
    } catch  {
        return false;
    }
}
const $d0427bdd60d98885$var$FEDRAMP_DISABLED_SELECTOR_CONFIG = Object.freeze({
    id: false,
    testId: false,
    role: false,
    className: false,
    dataVC: false
});
const $d0427bdd60d98885$export$f9bb3bb330fb9609 = 'fy26.04';
function $d0427bdd60d98885$export$2182e73d31080cbc() {
    return $d0427bdd60d98885$export$f9bb3bb330fb9609;
}
const $d0427bdd60d98885$export$d50dacda7fe6392b = 1000;
function $d0427bdd60d98885$export$10d6139a8fb42158(newConfig) {
    // Handle edge cases with `enabledVCRevisions`
    const { enabledVCRevisions: enabledVCRevisions } = newConfig?.vc ?? {};
    if (enabledVCRevisions) {
        const byExperience = typeof enabledVCRevisions?.byExperience === 'object' ? enabledVCRevisions.byExperience : {};
        const allRevisions = [
            // Products control their own revisions.
            ...enabledVCRevisions?.all ?? [],
            ...Object.values(byExperience).flat()
        ];
        $d0427bdd60d98885$var$config = {
            ...newConfig,
            vc: {
                ...newConfig.vc,
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience: byExperience
                }
            }
        };
    } else $d0427bdd60d98885$var$config = newConfig;
}
function $d0427bdd60d98885$export$44487a86467333c3() {
    return $d0427bdd60d98885$var$config;
}
function $d0427bdd60d98885$export$59e1f072477dfb48(callerOverride, defaultConfig) {
    // 1. FedRAMP override always wins.
    if ($d0427bdd60d98885$var$detectIsFedrampModerate()) return $d0427bdd60d98885$var$FEDRAMP_DISABLED_SELECTOR_CONFIG;
    // 2. Then caller-provided.
    // 3. Then centrally configured.
    // 4. Then caller-provided default.
    return callerOverride ?? $d0427bdd60d98885$var$config?.vc?.selectorConfig ?? defaultConfig;
}
function $d0427bdd60d98885$export$74bdb753f1cf4860() {
    // Default to enabled if config is not set or enabled is not explicitly false
    return $d0427bdd60d98885$var$config?.enabled !== false;
}
const $d0427bdd60d98885$var$isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function $d0427bdd60d98885$export$87fbc8e01b137811(experienceKey = '') {
    try {
        if (!$d0427bdd60d98885$var$config) return [];
        if ($d0427bdd60d98885$var$config.vc?.enabled) {
            const { enabledVCRevisions: enabledVCRevisions } = $d0427bdd60d98885$var$config.vc ?? {};
            if ($d0427bdd60d98885$var$isValidConfigArray(enabledVCRevisions?.byExperience?.[experienceKey])) return enabledVCRevisions.byExperience?.[experienceKey];
            // When the disable flag is on, treat an explicitly-set empty array as
            // "no client-side revisions" rather than falling back to the default revision.
            const allRevisions = enabledVCRevisions?.all;
            if (Array.isArray(allRevisions) && allRevisions.length === 0 && (0, $6oQI4.fg)('ufo_disable_ttvc_v4')) return allRevisions;
            if ($d0427bdd60d98885$var$isValidConfigArray(allRevisions)) return allRevisions;
            return [
                $d0427bdd60d98885$export$2182e73d31080cbc()
            ];
        }
        return [];
    } catch  {
        return [];
    }
}
function $d0427bdd60d98885$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $d0427bdd60d98885$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $d0427bdd60d98885$export$70184d6e2c753893(experienceKey = '') {
    const enabledVCRevisions = $d0427bdd60d98885$export$87fbc8e01b137811(experienceKey);
    if (enabledVCRevisions.length === 0) return $d0427bdd60d98885$export$2182e73d31080cbc();
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $d0427bdd60d98885$export$2d8f8d64dc343d7b() {
    if (!$d0427bdd60d98885$var$config) return undefined;
    try {
        const stats = $d0427bdd60d98885$var$config?.getReactHydrationStats?.();
        return stats ?? undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $d0427bdd60d98885$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$d0427bdd60d98885$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $d0427bdd60d98885$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        const isUnknown = name === 'unknown';
        if (isUnknown) {
            if (rates?.[name] != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $d0427bdd60d98885$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name?.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        // Fallback
        return 0;
    }
}
function $d0427bdd60d98885$export$48f4e0d964030a96(name, interactionType) {
    return $d0427bdd60d98885$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $d0427bdd60d98885$export$9c69f5a724f05f38(name, interactionType) {
    return $d0427bdd60d98885$export$48f4e0d964030a96(name, interactionType) > 0;
}
function $d0427bdd60d98885$export$1d459f020c06ae34(name, interactionType) {
    return $d0427bdd60d98885$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $d0427bdd60d98885$export$29b9ffb14861a1d(capability) {
    if ((0, $6oQI4.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$d0427bdd60d98885$var$config) return 0;
        const { capability: capabilityRate } = $d0427bdd60d98885$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
function $d0427bdd60d98885$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$d0427bdd60d98885$var$config) return 0;
        const gotConfig = $d0427bdd60d98885$var$config[configName];
        if (!gotConfig?.enabled) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch  {
        return 0;
    }
}
const $d0427bdd60d98885$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $d0427bdd60d98885$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$d0427bdd60d98885$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $d0427bdd60d98885$var$config;
        if (typingMethod != null && $d0427bdd60d98885$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch  {
        return defaultMethod;
    }
}
function $d0427bdd60d98885$export$2d311b3fd18dcab1() {
    try {
        if (!$d0427bdd60d98885$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $d0427bdd60d98885$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch  {
        return [];
    }
}
function $d0427bdd60d98885$export$4f4649ef27b6f5d6() {
    try {
        if (!$d0427bdd60d98885$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $d0427bdd60d98885$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch  {
        return undefined;
    }
}
function $d0427bdd60d98885$export$b150ddad71c80d77() {
    try {
        if (!$d0427bdd60d98885$var$config) return undefined;
        const { minorInteractions: minorInteractions } = $d0427bdd60d98885$var$config;
        return minorInteractions;
    } catch  {
        return undefined;
    }
}
function $d0427bdd60d98885$export$3c170167645a0eff() {
    try {
        if (!$d0427bdd60d98885$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $d0427bdd60d98885$var$config;
        return doNotAbortActivePressInteraction;
    } catch  {
        return undefined;
    }
}
function $d0427bdd60d98885$export$d6dc9444bd15f70f() {
    try {
        if (!$d0427bdd60d98885$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $d0427bdd60d98885$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
function $d0427bdd60d98885$export$20e8108b8ccdd0bd() {
    try {
        if (!$d0427bdd60d98885$var$config) return undefined;
        const { finishInteractionOnTransition: finishInteractionOnTransition } = $d0427bdd60d98885$var$config;
        return finishInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
const $d0427bdd60d98885$export$2a8604960d7d23d9 = 60000;
function $d0427bdd60d98885$export$c681731847989445(ufoName) {
    try {
        if (!$d0427bdd60d98885$var$config) return $d0427bdd60d98885$export$2a8604960d7d23d9;
        const { interactionTimeout: interactionTimeout } = $d0427bdd60d98885$var$config;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $d0427bdd60d98885$export$2a8604960d7d23d9;
    } catch  {
        return $d0427bdd60d98885$export$2a8604960d7d23d9;
    }
}


const $53edcdca15d32c39$var$interactionBuffer = [];
const $53edcdca15d32c39$export$af15cc1c63c2807a = {
    interactionBuffer: $53edcdca15d32c39$var$interactionBuffer,
    bufferInteractionData: (interactionId, data)=>{
        $53edcdca15d32c39$var$interactionBuffer.push({
            interactionId: interactionId,
            data: data
        });
    }
};


function $9ad27da18e251816$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        (0, $53edcdca15d32c39$export$af15cc1c63c2807a).bufferInteractionData(interactionId, data);
        (0, $53edcdca15d32c39$export$af15cc1c63c2807a).interactionBuffer.length = 0;
    }
}


function $0ad31d6ba681eb2f$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}


function $21607425b000f9cb$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}


function $71b607808958af03$export$3535cd9da4961282(name) {
    if (name.startsWith('/')) name = name.replace(/^\/+/, '');
    if (name.endsWith('/')) name = name.replace(/\/+$/, '');
    return name;
}


function $08edc97a18a6c043$export$caeee352b541de1f(labelStack) {
    return labelStack.map((l)=>{
        const name = (0, $71b607808958af03$export$3535cd9da4961282)(l.name);
        if ((0, $21607425b000f9cb$export$1adbaf5c2363e4ae)(l)) return `${name}:${l.segmentId}`;
        return name;
    }).join('/');
}




var $6oQI4 = parcelRequire("6oQI4");

/**
 * We need to store a reference to the Context manager so that we can get it later.
 * This is because the OTel JS API doesn't allow us to get the registered context manager,
 * and we need to get it because we need to call a function that's not available in the OTel API:
 * `setActive`. The OTel JS API design doesn't allow us to manually set the active context
 * despite the spec allowing for the capability. Sigh.
 *
 * I imagine this situation might not be permanent if we can move to a system were we can rely
 * solely on the API, but for the purposes of the first change being React UFO API compatible,
 * we'll need to do this.
 */ let $633b968a1407d222$var$contextManager;
function $633b968a1407d222$export$4a00ab8a5dd9b5cf(ctxMgr) {
    $633b968a1407d222$var$contextManager = ctxMgr;
}
function $633b968a1407d222$export$831109c9f7727010() {
    return $633b968a1407d222$var$contextManager;
}
class $633b968a1407d222$export$dd301b96c16f583d {
    /**
   *
   * @param context
   * @param target Function to be executed within the context
   */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context = (0, $a6694f96a559a9a5$export$78df28f9b2f9a7dc), target) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
   * Returns the active context
   */ active() {
        return this._currentContext;
    }
    /**
   * Binds a the certain context or the active one to the target function and then returns the target
   * @param context A context (span) to be bind to target
   * @param target a function or event emitter. When target or one of its callbacks is called,
   *  the provided context will be used as the active context for the duration of the call.
   */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    }
    /**
   * Disable the context manager (clears the current context)
   */ disable() {
        this._currentContext = (0, $a6694f96a559a9a5$export$78df28f9b2f9a7dc);
        this._enabled = false;
        return this;
    }
    /**
   * Enables the context manager and creates a default(root) context
   */ enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $a6694f96a559a9a5$export$78df28f9b2f9a7dc);
        return this;
    }
    /**
   * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
   * The context will be set as active
   * @param context
   * @param fn Callback function
   * @param thisArg optional receiver to be used for calling fn
   * @param args optional arguments forwarded to fn
   */ with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || (0, $a6694f96a559a9a5$export$78df28f9b2f9a7dc);
        try {
            return fn.call(thisArg, ...args);
        } finally{
            this._currentContext = previousContext;
        }
    }
    /**
   * Sets the active context.
   * This function is an extension of the OTel spec, in order to facilitate the current API of React UFO trace context handling.
   * It doesn't keep track of any previously set active contexts, because it's assumed (for now) that only one trace context
   * will ever exist at a time.
   * The next step in the work to improve tracing in the FE will likely remove this function as we need to track the
   * hierarchy of contexts (likely using the `with()` function above).
   * @param context The context to be made the globally active one
   */ setActive(context) {
        if (this._enabled) this._currentContext = context;
    }
    constructor(){
        /**
     * whether the context manager is enabled or not
     */ this._enabled = false;
        /**
     * Keeps the reference to current context
     */ this._currentContext = (0, $a6694f96a559a9a5$export$78df28f9b2f9a7dc);
    }
}



function $704a9804c9307b07$export$17ab21d7be720b() {
    if ((0, $6oQI4.fg)('platform_ufo_enable_otel_context_manager')) // Now we need to get the global Context Manager and set the active context
    // Using type assertion because we've "extended" the ContextManager type
    {
        if ((0, $633b968a1407d222$export$831109c9f7727010)() instanceof (0, $633b968a1407d222$export$dd301b96c16f583d)) {
            let contextManager = (0, $633b968a1407d222$export$831109c9f7727010)();
            // ROOT_CONTEXT is an empty context used to initialise ContextManagers
            contextManager.setActive((0, $a6694f96a559a9a5$export$78df28f9b2f9a7dc));
        }
    } else (0, $96978f64a2608679$export$ca000e230c0caa3e).context = null;
}



// Subscription system for interaction ID changes
const $6dbeb2d55f259f39$export$58bed631278dbc67 = new Set();
const $6dbeb2d55f259f39$export$3e0c3023952f6774 = (listener)=>{
    $6dbeb2d55f259f39$export$58bed631278dbc67.add(listener);
    return ()=>{
        $6dbeb2d55f259f39$export$58bed631278dbc67.delete(listener);
    };
};


class $056559c8228a75c5$var$ObservableInteractionID {
    get current() {
        return this._current;
    }
    set current(newId) {
        const oldId = this._current;
        this._current = newId;
        if (oldId !== newId) (0, $6dbeb2d55f259f39$export$58bed631278dbc67).forEach((listener)=>listener(newId));
    }
    constructor(){
        this._current = null;
    }
}
const $056559c8228a75c5$var$initializeGlobalDefaultInteractionID = ()=>{
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    const instance = new $056559c8228a75c5$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
const $056559c8228a75c5$var$DefaultInteractionID = $056559c8228a75c5$var$initializeGlobalDefaultInteractionID();
var $056559c8228a75c5$export$2e2bcd8739ae039 = $056559c8228a75c5$var$DefaultInteractionID;


const $6385281f5ef7c8dd$export$37bca3107733ac1e = ()=>(0, $056559c8228a75c5$export$2e2bcd8739ae039);


const $cb202f74b57749f2$export$c3b002e13fbb9ef2 = new Set([
    'fetch',
    'xmlhttprequest'
]);



var $3ihMw = parcelRequire("3ihMw");
function $9a9850d6654223c3$export$4d143603f9782455() {
    if ((0, $3ihMw.default).getExperimentValue('confluence_enable_react-compiler-runtime-platform', 'isEnabled', false)) return true;
    return false;
}




var $ebfe460bd680287b$exports = {};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @lightSyntaxTransform
 * @noflow
 * @nolint
 * @preventMunge
 * @preserve-invariant-messages
 */ "use no memo";
"use strict";
var $ebfe460bd680287b$var$__create = Object.create;
var $ebfe460bd680287b$var$__defProp = Object.defineProperty;
var $ebfe460bd680287b$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $ebfe460bd680287b$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $ebfe460bd680287b$var$__getProtoOf = Object.getPrototypeOf;
var $ebfe460bd680287b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ebfe460bd680287b$var$__export = (target, all)=>{
    for(var name in all)$ebfe460bd680287b$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $ebfe460bd680287b$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $ebfe460bd680287b$var$__getOwnPropNames(from))if (!$ebfe460bd680287b$var$__hasOwnProp.call(to, key) && key !== except) $ebfe460bd680287b$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $ebfe460bd680287b$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $ebfe460bd680287b$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $ebfe460bd680287b$var$__create($ebfe460bd680287b$var$__getProtoOf(mod)) : {}, $ebfe460bd680287b$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $ebfe460bd680287b$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $ebfe460bd680287b$var$__toCommonJS = (mod)=>$ebfe460bd680287b$var$__copyProps($ebfe460bd680287b$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/index.ts
var $ebfe460bd680287b$var$index_exports = {};
$ebfe460bd680287b$var$__export($ebfe460bd680287b$var$index_exports, {
    $dispatcherGuard: ()=>$ebfe460bd680287b$var$$dispatcherGuard,
    $makeReadOnly: ()=>$ebfe460bd680287b$var$$makeReadOnly,
    $reset: ()=>$ebfe460bd680287b$var$$reset,
    $structuralCheck: ()=>$ebfe460bd680287b$var$$structuralCheck,
    c: ()=>$ebfe460bd680287b$var$c,
    clearRenderCounterRegistry: ()=>$ebfe460bd680287b$var$clearRenderCounterRegistry,
    renderCounterRegistry: ()=>$ebfe460bd680287b$var$renderCounterRegistry,
    useRenderCounter: ()=>$ebfe460bd680287b$var$useRenderCounter
});
$ebfe460bd680287b$exports = $ebfe460bd680287b$var$__toCommonJS($ebfe460bd680287b$var$index_exports);

var $ebfe460bd680287b$var$React = $ebfe460bd680287b$var$__toESM((parcelRequire("2hRE7")));
var { useRef: $ebfe460bd680287b$var$useRef, useEffect: $ebfe460bd680287b$var$useEffect, isValidElement: $ebfe460bd680287b$var$isValidElement } = $ebfe460bd680287b$var$React;
var $ebfe460bd680287b$var$_a;
var $ebfe460bd680287b$var$ReactSecretInternals = //@ts-ignore
($ebfe460bd680287b$var$_a = $ebfe460bd680287b$var$React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE) != null ? $ebfe460bd680287b$var$_a : $ebfe460bd680287b$var$React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
var $ebfe460bd680287b$var$$empty = Symbol.for("react.memo_cache_sentinel");
var $ebfe460bd680287b$var$_a2;
var $ebfe460bd680287b$var$c = // @ts-expect-error
typeof (($ebfe460bd680287b$var$_a2 = $ebfe460bd680287b$var$React.__COMPILER_RUNTIME) == null ? void 0 : $ebfe460bd680287b$var$_a2.c) === "function" ? // @ts-expect-error
$ebfe460bd680287b$var$React.__COMPILER_RUNTIME.c : function c2(size) {
    return $ebfe460bd680287b$var$React.useMemo(()=>{
        const $ = new Array(size);
        for(let ii = 0; ii < size; ii++)$[ii] = $ebfe460bd680287b$var$$empty;
        $[$ebfe460bd680287b$var$$empty] = true;
        return $;
    }, []);
};
var $ebfe460bd680287b$var$LazyGuardDispatcher = {};
[
    "readContext",
    "useCallback",
    "useContext",
    "useEffect",
    "useImperativeHandle",
    "useInsertionEffect",
    "useLayoutEffect",
    "useMemo",
    "useReducer",
    "useRef",
    "useState",
    "useDebugValue",
    "useDeferredValue",
    "useTransition",
    "useMutableSource",
    "useSyncExternalStore",
    "useId",
    "unstable_isNewReconciler",
    "getCacheSignal",
    "getCacheForType",
    "useCacheRefresh"
].forEach((name)=>{
    $ebfe460bd680287b$var$LazyGuardDispatcher[name] = ()=>{
        throw new Error(`[React] Unexpected React hook call (${name}) from a React compiled function. Check that all hooks are called directly and named according to convention ('use[A-Z]') `);
    };
});
var $ebfe460bd680287b$var$originalDispatcher = null;
$ebfe460bd680287b$var$LazyGuardDispatcher["useMemoCache"] = (count)=>{
    if ($ebfe460bd680287b$var$originalDispatcher == null) throw new Error("React Compiler internal invariant violation: unexpected null dispatcher");
    else return $ebfe460bd680287b$var$originalDispatcher.useMemoCache(count);
};
function $ebfe460bd680287b$var$setCurrent(newDispatcher) {
    $ebfe460bd680287b$var$ReactSecretInternals.ReactCurrentDispatcher.current = newDispatcher;
    return $ebfe460bd680287b$var$ReactSecretInternals.ReactCurrentDispatcher.current;
}
var $ebfe460bd680287b$var$guardFrames = [];
function $ebfe460bd680287b$var$$dispatcherGuard(kind) {
    const curr = $ebfe460bd680287b$var$ReactSecretInternals.ReactCurrentDispatcher.current;
    if (kind === 0 /* PushGuardContext */ ) {
        $ebfe460bd680287b$var$guardFrames.push(curr);
        if ($ebfe460bd680287b$var$guardFrames.length === 1) $ebfe460bd680287b$var$originalDispatcher = curr;
        if (curr === $ebfe460bd680287b$var$LazyGuardDispatcher) throw new Error(`[React] Unexpected call to custom hook or component from a React compiled function. Check that (1) all hooks are called directly and named according to convention ('use[A-Z]') and (2) components are returned as JSX instead of being directly invoked.`);
        $ebfe460bd680287b$var$setCurrent($ebfe460bd680287b$var$LazyGuardDispatcher);
    } else if (kind === 1 /* PopGuardContext */ ) {
        const lastFrame = $ebfe460bd680287b$var$guardFrames.pop();
        if (lastFrame == null) throw new Error("React Compiler internal error: unexpected null in guard stack");
        if ($ebfe460bd680287b$var$guardFrames.length === 0) $ebfe460bd680287b$var$originalDispatcher = null;
        $ebfe460bd680287b$var$setCurrent(lastFrame);
    } else if (kind === 2 /* PushExpectHook */ ) {
        $ebfe460bd680287b$var$guardFrames.push(curr);
        $ebfe460bd680287b$var$setCurrent($ebfe460bd680287b$var$originalDispatcher);
    } else if (kind === 3 /* PopExpectHook */ ) {
        const lastFrame = $ebfe460bd680287b$var$guardFrames.pop();
        if (lastFrame == null) throw new Error("React Compiler internal error: unexpected null in guard stack");
        $ebfe460bd680287b$var$setCurrent(lastFrame);
    } else throw new Error("React Compiler internal error: unreachable block" + kind);
}
function $ebfe460bd680287b$var$$reset($) {
    for(let ii = 0; ii < $.length; ii++)$[ii] = $ebfe460bd680287b$var$$empty;
}
function $ebfe460bd680287b$var$$makeReadOnly() {
    throw new Error("TODO: implement $makeReadOnly in react-compiler-runtime");
}
var $ebfe460bd680287b$var$renderCounterRegistry = /* @__PURE__ */ new Map();
function $ebfe460bd680287b$var$clearRenderCounterRegistry() {
    for (const counters of $ebfe460bd680287b$var$renderCounterRegistry.values())counters.forEach((counter)=>{
        counter.count = 0;
    });
}
function $ebfe460bd680287b$var$registerRenderCounter(name, val) {
    let counters = $ebfe460bd680287b$var$renderCounterRegistry.get(name);
    if (counters == null) {
        counters = /* @__PURE__ */ new Set();
        $ebfe460bd680287b$var$renderCounterRegistry.set(name, counters);
    }
    counters.add(val);
}
function $ebfe460bd680287b$var$removeRenderCounter(name, val) {
    const counters = $ebfe460bd680287b$var$renderCounterRegistry.get(name);
    if (counters == null) return;
    counters.delete(val);
}
function $ebfe460bd680287b$var$useRenderCounter(name) {
    const val = $ebfe460bd680287b$var$useRef(null);
    if (val.current != null) val.current.count += 1;
    $ebfe460bd680287b$var$useEffect(()=>{
        if (val.current == null) {
            const counter = {
                count: 0
            };
            $ebfe460bd680287b$var$registerRenderCounter(name, counter);
            val.current = counter;
        }
        return ()=>{
            if (val.current !== null) $ebfe460bd680287b$var$removeRenderCounter(name, val.current);
        };
    });
}
var $ebfe460bd680287b$var$seenErrors = /* @__PURE__ */ new Set();
function $ebfe460bd680287b$var$$structuralCheck(oldValue, newValue, variableName, fnName, kind, loc) {
    function error(l, r, path, depth) {
        const str = `${fnName}:${loc} [${kind}] ${variableName}${path} changed from ${l} to ${r} at depth ${depth}`;
        if ($ebfe460bd680287b$var$seenErrors.has(str)) return;
        $ebfe460bd680287b$var$seenErrors.add(str);
        console.error(str);
    }
    const depthLimit = 2;
    function recur(oldValue2, newValue2, path, depth) {
        if (depth > depthLimit) return;
        else if (oldValue2 === newValue2) return;
        else if (typeof oldValue2 !== typeof newValue2) error(`type ${typeof oldValue2}`, `type ${typeof newValue2}`, path, depth);
        else if (typeof oldValue2 === "object") {
            const oldArray = Array.isArray(oldValue2);
            const newArray = Array.isArray(newValue2);
            if (oldValue2 === null && newValue2 !== null) error("null", `type ${typeof newValue2}`, path, depth);
            else if (newValue2 === null) error(`type ${typeof oldValue2}`, "null", path, depth);
            else if (oldValue2 instanceof Map) {
                if (!(newValue2 instanceof Map)) error(`Map instance`, `other value`, path, depth);
                else if (oldValue2.size !== newValue2.size) error(`Map instance with size ${oldValue2.size}`, `Map instance with size ${newValue2.size}`, path, depth);
                else {
                    for (const [k, v] of oldValue2)if (!newValue2.has(k)) error(`Map instance with key ${k}`, `Map instance without key ${k}`, path, depth);
                    else recur(v, newValue2.get(k), `${path}.get(${k})`, depth + 1);
                }
            } else if (newValue2 instanceof Map) error("other value", `Map instance`, path, depth);
            else if (oldValue2 instanceof Set) {
                if (!(newValue2 instanceof Set)) error(`Set instance`, `other value`, path, depth);
                else if (oldValue2.size !== newValue2.size) error(`Set instance with size ${oldValue2.size}`, `Set instance with size ${newValue2.size}`, path, depth);
                else {
                    for (const v of newValue2)if (!oldValue2.has(v)) error(`Set instance without element ${v}`, `Set instance with element ${v}`, path, depth);
                }
            } else if (newValue2 instanceof Set) error("other value", `Set instance`, path, depth);
            else if (oldArray || newArray) {
                if (oldArray !== newArray) error(`type ${oldArray ? "array" : "object"}`, `type ${newArray ? "array" : "object"}`, path, depth);
                else if (oldValue2.length !== newValue2.length) error(`array with length ${oldValue2.length}`, `array with length ${newValue2.length}`, path, depth);
                else for(let ii = 0; ii < oldValue2.length; ii++)recur(oldValue2[ii], newValue2[ii], `${path}[${ii}]`, depth + 1);
            } else if ($ebfe460bd680287b$var$isValidElement(oldValue2) || $ebfe460bd680287b$var$isValidElement(newValue2)) {
                if ($ebfe460bd680287b$var$isValidElement(oldValue2) !== $ebfe460bd680287b$var$isValidElement(newValue2)) error(`type ${$ebfe460bd680287b$var$isValidElement(oldValue2) ? "React element" : "object"}`, `type ${$ebfe460bd680287b$var$isValidElement(newValue2) ? "React element" : "object"}`, path, depth);
                else if (oldValue2.type !== newValue2.type) error(`React element of type ${oldValue2.type}`, `React element of type ${newValue2.type}`, path, depth);
                else recur(oldValue2.props, newValue2.props, `[props of ${path}]`, depth + 1);
            } else {
                for(const key in newValue2)if (!(key in oldValue2)) error(`object without key ${key}`, `object with key ${key}`, path, depth);
                for(const key in oldValue2)if (!(key in newValue2)) error(`object with key ${key}`, `object without key ${key}`, path, depth);
                else recur(oldValue2[key], newValue2[key], `${path}.${key}`, depth + 1);
            }
        } else if (typeof oldValue2 === "function") return;
        else if (isNaN(oldValue2) || isNaN(newValue2)) {
            if (isNaN(oldValue2) !== isNaN(newValue2)) error(`${isNaN(oldValue2) ? "NaN" : "non-NaN value"}`, `${isNaN(newValue2) ? "NaN" : "non-NaN value"}`, path, depth);
        } else if (oldValue2 !== newValue2) error(oldValue2, newValue2, path, depth);
    }
    recur(oldValue, newValue, "", 0);
}



var $2hRE7 = parcelRequire("2hRE7");




var $2M83v = parcelRequire("2M83v");
// These are stored outside react context to be resilient to concurrent mode
// restarting the start marker from a suspense and losing the initial render
const $7e58dfb7b9203da6$var$startTimes = new Map();
const $7e58dfb7b9203da6$var$spanStates = new Map();
const $7e58dfb7b9203da6$export$cf4e4023c0a34c8d = ()=>{
    $7e58dfb7b9203da6$var$startTimes.clear();
    $7e58dfb7b9203da6$var$spanStates.clear();
};
// Keep track of the last interaction id and reset the start timers if it ever changes.
// This is to allow multi-step ssr to track the render timers from different "interaction"s seperately
let $7e58dfb7b9203da6$var$lastActiveInteraction;
function $7e58dfb7b9203da6$var$checkActiveInteractionAndResetStartMarksIfSet() {
    const activeInteractionId = (0, $fa77cab6e7101561$export$2b3954d2e8509985)()?.id;
    if (!!$7e58dfb7b9203da6$var$lastActiveInteraction && $7e58dfb7b9203da6$var$lastActiveInteraction !== activeInteractionId) $7e58dfb7b9203da6$export$cf4e4023c0a34c8d();
    $7e58dfb7b9203da6$var$lastActiveInteraction = activeInteractionId;
}
const $7e58dfb7b9203da6$var$getIsNativeTracingEnabled = ()=>(0, $d0427bdd60d98885$export$44487a86467333c3)()?.ssr?.enableNativeTracing ?? false;
const $7e58dfb7b9203da6$var$onStartRender = (id, currentSegmentName, parentContext)=>{
    if (!$7e58dfb7b9203da6$var$startTimes.has(id)) $7e58dfb7b9203da6$var$startTimes.set(id, []);
    $7e58dfb7b9203da6$var$startTimes.get(id)?.push(performance.now());
    if (!$7e58dfb7b9203da6$var$getIsNativeTracingEnabled()) return null;
    const startSpan = globalThis.__vm_internals__?.telemetry?.startSpan;
    let spanState = $7e58dfb7b9203da6$var$spanStates.get(id) ?? null;
    if (!spanState && startSpan) {
        const span = startSpan(currentSegmentName, {
            parentSpanId: parentContext?.spanId
        });
        spanState = {
            span: span
        };
        $7e58dfb7b9203da6$var$spanStates.set(id, spanState);
    }
    return spanState;
};
const $7e58dfb7b9203da6$var$isInSSR = typeof __SERVER__ !== 'undefined' && __SERVER__ || typeof $2M83v !== 'undefined' && Boolean($2M83v?.env?.REACT_SSR || false);
const $7e58dfb7b9203da6$var$ProfilerMarker = ({ onRender: onRender })=>{
    onRender?.();
    return null;
};
const $7e58dfb7b9203da6$var$ParentSpanContext = /*#__PURE__*/ (0, $2hRE7.createContext)(null);
const $7e58dfb7b9203da6$export$c8760e11c713fafc = ()=>{
    $7e58dfb7b9203da6$var$spanStates.forEach((spanState)=>{
        if (spanState.latestEndTime != null) spanState.span.end(spanState.latestEndTime);
    });
    $7e58dfb7b9203da6$var$spanStates.clear();
};
const $7e58dfb7b9203da6$export$b8bd105b650b1c1e = (0, $9a9850d6654223c3$export$4d143603f9782455)() ? (t0)=>{
    const $ = (0, $ebfe460bd680287b$exports.c)(15);
    const { children: children, labelStack: labelStack, onRender: onRender } = t0;
    let t1;
    if ($[0] !== labelStack) {
        t1 = labelStack.map($7e58dfb7b9203da6$var$_temp).join("/");
        $[0] = labelStack;
        $[1] = t1;
    } else t1 = $[1];
    const reactProfilerId = t1;
    $7e58dfb7b9203da6$var$checkActiveInteractionAndResetStartMarksIfSet();
    const parentSpan = (0, $2hRE7.useContext)($7e58dfb7b9203da6$var$ParentSpanContext);
    let T0;
    let t2;
    if ($[2] !== labelStack || $[3] !== parentSpan || $[4] !== reactProfilerId) {
        const currentSpanState = $7e58dfb7b9203da6$var$onStartRender(reactProfilerId, (0, $71b607808958af03$export$3535cd9da4961282)(labelStack[labelStack.length - 1].name), parentSpan);
        T0 = $7e58dfb7b9203da6$var$ParentSpanContext.Provider;
        t2 = currentSpanState?.span.getSpanContext() ?? null;
        $[2] = labelStack;
        $[3] = parentSpan;
        $[4] = reactProfilerId;
        $[5] = T0;
        $[6] = t2;
    } else {
        T0 = $[5];
        t2 = $[6];
    }
    let t3;
    if ($[7] !== onRender || $[8] !== reactProfilerId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($7e58dfb7b9203da6$var$ProfilerMarker, {
            onRender: ()=>{
                const startTimesForId = $7e58dfb7b9203da6$var$startTimes.get(reactProfilerId);
                if (startTimesForId?.length) {
                    const endTime = performance.now();
                    const firstStartTime = startTimesForId[0];
                    const lastStartTime = startTimesForId[startTimesForId.length - 1];
                    const baseDuration = endTime - lastStartTime;
                    const actualDuration = endTime - firstStartTime;
                    onRender("mount", actualDuration, baseDuration, firstStartTime, endTime);
                }
                const spanState = $7e58dfb7b9203da6$var$spanStates.get(reactProfilerId);
                if (spanState) spanState.latestEndTime = performance.now();
            }
        });
        $[7] = onRender;
        $[8] = reactProfilerId;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== T0 || $[11] !== children || $[12] !== t2 || $[13] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement(T0, {
            value: t2
        }, children, t3));
        $[10] = T0;
        $[11] = children;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
    } else t4 = $[14];
    return t4;
} : ({ children: children, labelStack: labelStack, onRender: onRender })=>{
    const reactProfilerId = (0, $2hRE7.useMemo)(()=>labelStack.map((l)=>(0, $71b607808958af03$export$3535cd9da4961282)(l.name)).join('/'), [
        labelStack
    ]);
    $7e58dfb7b9203da6$var$checkActiveInteractionAndResetStartMarksIfSet();
    const parentSpan = (0, $2hRE7.useContext)($7e58dfb7b9203da6$var$ParentSpanContext);
    const currentSpanState = $7e58dfb7b9203da6$var$onStartRender(reactProfilerId, (0, $71b607808958af03$export$3535cd9da4961282)(labelStack[labelStack.length - 1].name), parentSpan);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($7e58dfb7b9203da6$var$ParentSpanContext.Provider, {
        value: currentSpanState?.span.getSpanContext() ?? null
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($7e58dfb7b9203da6$var$ProfilerMarker, {
        onRender: ()=>{
            const startTimesForId = $7e58dfb7b9203da6$var$startTimes.get(reactProfilerId);
            if (startTimesForId?.length) {
                const endTime = performance.now();
                const firstStartTime = startTimesForId[0];
                const lastStartTime = startTimesForId[startTimesForId.length - 1];
                const baseDuration = endTime - lastStartTime;
                const actualDuration = endTime - firstStartTime;
                onRender('mount', // this is incorrect, but on the server there is no mount phase
                actualDuration, baseDuration, firstStartTime, endTime);
            }
            const spanState = $7e58dfb7b9203da6$var$spanStates.get(reactProfilerId);
            if (spanState) spanState.latestEndTime = performance.now();
        }
    })));
};
const $7e58dfb7b9203da6$var$SsrRenderProfiler = (0, $9a9850d6654223c3$export$4d143603f9782455)() ? (props)=>{
    const $ = (0, $ebfe460bd680287b$exports.c)(5);
    if ($7e58dfb7b9203da6$var$isInSSR) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($7e58dfb7b9203da6$export$b8bd105b650b1c1e, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($7e58dfb7b9203da6$var$ProfilerMarker, null);
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== props.children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).Fragment, null, t0, props.children);
        $[3] = props.children;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    if ($7e58dfb7b9203da6$var$isInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($7e58dfb7b9203da6$export$b8bd105b650b1c1e, props);
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($7e58dfb7b9203da6$var$ProfilerMarker, null), props.children);
};
var $7e58dfb7b9203da6$export$2e2bcd8739ae039 = $7e58dfb7b9203da6$var$SsrRenderProfiler;
function $7e58dfb7b9203da6$var$_temp(l) {
    return (0, $71b607808958af03$export$3535cd9da4961282)(l.name);
}


// Some products set this variable to indicate it is running in SSR

var $2M83v = parcelRequire("2M83v");
let $de6d41de60f61fb8$var$isServer = Boolean(globalThis?.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
let $de6d41de60f61fb8$var$isReactSSR = typeof $2M83v !== 'undefined' && Boolean($2M83v?.env?.REACT_SSR || false);
function $de6d41de60f61fb8$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($de6d41de60f61fb8$var$isReactSSR || $de6d41de60f61fb8$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof globalThis?.WeakRef !== 'function') return false;
    if (typeof globalThis?.MutationObserver !== 'function' || typeof globalThis?.IntersectionObserver !== 'function' || typeof globalThis?.PerformanceObserver !== 'function') return false;
    return true;
}


class $d3191430a81dac65$export$24d07287b49da906 {
    start(_) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(_) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(_) {}
    setReactRootRenderStart(_) {}
    setReactRootRenderStop(_) {}
}




var $6oQI4 = parcelRequire("6oQI4");


var $04ce8cf050459c71$exports = {};
"use strict";
Object.defineProperty($04ce8cf050459c71$exports, "__esModule", {
    value: true
});
$04ce8cf050459c71$exports.bindAll = $04ce8cf050459c71$exports.bind = void 0;
var $87cfcf3cc10cc789$exports = {};
"use strict";
Object.defineProperty($87cfcf3cc10cc789$exports, "__esModule", {
    value: true
});
$87cfcf3cc10cc789$exports.bind = void 0;
function $87cfcf3cc10cc789$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
$87cfcf3cc10cc789$exports.bind = $87cfcf3cc10cc789$var$bind;


Object.defineProperty($04ce8cf050459c71$exports, "bind", {
    enumerable: true,
    get: function() {
        return $87cfcf3cc10cc789$exports.bind;
    }
});
var $528d71b2bff88c1f$exports = {};
"use strict";
var $528d71b2bff88c1f$var$__assign = $528d71b2bff88c1f$exports && $528d71b2bff88c1f$exports.__assign || function() {
    $528d71b2bff88c1f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $528d71b2bff88c1f$var$__assign.apply(this, arguments);
};
Object.defineProperty($528d71b2bff88c1f$exports, "__esModule", {
    value: true
});
$528d71b2bff88c1f$exports.bindAll = void 0;

function $528d71b2bff88c1f$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $528d71b2bff88c1f$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $528d71b2bff88c1f$var$__assign($528d71b2bff88c1f$var$__assign({}, original), {
        options: $528d71b2bff88c1f$var$__assign($528d71b2bff88c1f$var$__assign({}, $528d71b2bff88c1f$var$toOptions(sharedOptions)), $528d71b2bff88c1f$var$toOptions(original.options))
    });
    return binding;
}
function $528d71b2bff88c1f$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $528d71b2bff88c1f$var$getBinding(original, sharedOptions);
        return (0, $87cfcf3cc10cc789$exports.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
$528d71b2bff88c1f$exports.bindAll = $528d71b2bff88c1f$var$bindAll;


Object.defineProperty($04ce8cf050459c71$exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $528d71b2bff88c1f$exports.bindAll;
    }
});


const $75438a4b70c96068$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};


// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $734b83dcbc6eaeb8$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}


function $73ea5edd539be009$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}


function $d5c296b3fe8ae423$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $04ce8cf050459c71$exports.bind)(window, {
        type: (0, $75438a4b70c96068$export$199edc0307b5587f).wheel,
        listener: (e)=>{
            callback((0, $75438a4b70c96068$export$199edc0307b5587f).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $04ce8cf050459c71$exports.bind)(window, {
        type: (0, $75438a4b70c96068$export$199edc0307b5587f).keydown,
        listener: (e)=>{
            callback((0, $75438a4b70c96068$export$199edc0307b5587f).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $04ce8cf050459c71$exports.bind)(window, {
        type: (0, $75438a4b70c96068$export$199edc0307b5587f).resize,
        listener: (e)=>{
            if ((0, $73ea5edd539be009$export$a497a1dcb4408212)() !== initialViewPort.w || (0, $734b83dcbc6eaeb8$export$4f01c15d21ef9cc6)() !== initialViewPort.h) {
                callback((0, $75438a4b70c96068$export$199edc0307b5587f).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}


function $ff2c03df3367967d$export$72e6dda9d5859230({ revision: revision, isClean: isClean, abortReason: abortReason, VCEntries: VCEntries, componentsLog: componentsLog, interactionId: interactionId }) {
    // Pre-sort VCEntries by time for efficient lookups
    const sortedVCEntries = [
        ...VCEntries
    ].sort((a, b)=>a.time - b.time);
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    const maxViewportPercentageAtTime = new Map();
    let maxSoFar = 0;
    for (const entry of sortedVCEntries){
        maxSoFar = Math.max(maxSoFar, entry.vc);
        maxViewportPercentageAtTime.set(entry.time, maxSoFar);
    }
    // Helper function to find the biggest previous viewport percentage
    const getBiggestPreviousViewportPercentage = (targetTime)=>{
        // Binary search for the largest time <= targetTime
        let left = 0;
        let right = sortedVCEntries.length - 1;
        let result = -1;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    const allVcLogs = [];
    // Add regular VC entries
    for (const entry of VCEntries){
        const timeLogEntries = componentsLog[entry.time];
        allVcLogs.push({
            time: entry.time,
            viewportPercentage: entry.vc,
            entries: entry.elements.map((element)=>{
                const logEntry = timeLogEntries?.find((log)=>log.targetName === element);
                return {
                    elementName: element,
                    type: logEntry?.type,
                    rect: logEntry?.intersectionRect,
                    visible: true,
                    attributeName: logEntry?.attributeName,
                    oldValue: logEntry?.oldValue,
                    newValue: logEntry?.newValue,
                    ignoreReason: logEntry?.ignoreReason
                };
            })
        });
    }
    // Add ignored elements - only process timestamps that have ignored elements
    for (const [timestamp, timeLogEntries] of Object.entries(componentsLog)){
        const ignoredElements = timeLogEntries.filter((log)=>log.ignoreReason);
        if (ignoredElements.length === 0) continue;
        const time = Number(timestamp);
        const viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map((logEntry)=>({
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                }))
        });
    }
    // Sort once at the end
    allVcLogs.sort((a, b)=>a.time - b.time);
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}



/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 

var $6oQI4 = parcelRequire("6oQI4");
const $862991da4a6032b9$var$timings = [];
let $862991da4a6032b9$var$wasHiddenFlag;
let $862991da4a6032b9$var$setupFlag = false;
// Threshold for determining if page was opened in background.
// If setup runs within this time and page is hidden, we assume it was opened in a background tab.
const $862991da4a6032b9$var$OPENED_IN_BACKGROUND_THRESHOLD_MS = 100;
let $862991da4a6032b9$var$openedInBackground = null;
function $862991da4a6032b9$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $862991da4a6032b9$var$SIZE = 50;
let $862991da4a6032b9$var$insertIndex = 0;
function $862991da4a6032b9$export$754443ce7c615bd7(startTime, endTime) {
    const earliestHiddenTiming = $862991da4a6032b9$var$timings.find(({ hidden: hidden, time: time })=>hidden && time > 0 && time >= startTime && time <= endTime)?.time;
    if (typeof earliestHiddenTiming === 'number') return Math.round(earliestHiddenTiming - startTime);
}
function $862991da4a6032b9$export$21a1a62a307062f1(interactionType) {
    if (interactionType !== 'page_load') return false;
    // Check native visibility-state entries first (most reliable, Chromium only)
    try {
        const entries = performance.getEntriesByType('visibility-state');
        if (entries.length > 0) return entries.some((entry)=>entry.name === 'hidden' && entry.startTime <= $862991da4a6032b9$var$OPENED_IN_BACKGROUND_THRESHOLD_MS);
    } catch  {
    // visibility-state not supported (Firefox/Safari)
    }
    // Fallback to cached value from setup (determined using time threshold)
    return $862991da4a6032b9$var$openedInBackground === true;
}
function $862991da4a6032b9$var$pushHidden(isPageHiddenFlag, time) {
    $862991da4a6032b9$var$timings[$862991da4a6032b9$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $862991da4a6032b9$var$insertIndex = ($862991da4a6032b9$var$insertIndex + 1) % $862991da4a6032b9$var$SIZE;
    $862991da4a6032b9$var$wasHiddenFlag = isPageHiddenFlag;
}
function $862991da4a6032b9$var$handleChange() {
    const isPageHiddenFlag = $862991da4a6032b9$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$862991da4a6032b9$var$wasHiddenFlag) $862991da4a6032b9$var$pushHidden(isPageHiddenFlag);
        $862991da4a6032b9$var$wasHiddenFlag = true;
    } else {
        if ($862991da4a6032b9$var$wasHiddenFlag) $862991da4a6032b9$var$pushHidden(isPageHiddenFlag);
        $862991da4a6032b9$var$wasHiddenFlag = false;
    }
}
let $862991da4a6032b9$var$hasHiddenTimingBeforeSetup = false;
function $862991da4a6032b9$export$95f048bd8bcdda23() {
    return $862991da4a6032b9$var$hasHiddenTimingBeforeSetup;
}
function $862991da4a6032b9$var$setup() {
    try {
        const results = performance.getEntriesByType('visibility-state');
        results?.forEach((result)=>{
            if ((0, $6oQI4.fg)('platform_ufo_use_native_page_visibility_api')) $862991da4a6032b9$var$pushHidden(result.name === 'hidden', result.startTime);
            if (result.name === 'hidden') $862991da4a6032b9$var$hasHiddenTimingBeforeSetup = true;
        });
    } catch  {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, $04ce8cf050459c71$exports.bind)(window, {
        type: 'pageshow',
        listener: $862991da4a6032b9$var$handleChange
    });
    (0, $04ce8cf050459c71$exports.bind)(window, {
        type: 'pagehide',
        listener: $862991da4a6032b9$var$handleChange
    });
    (0, $04ce8cf050459c71$exports.bind)(document, {
        type: 'visibilitychange',
        listener: $862991da4a6032b9$var$handleChange
    });
}
function $862991da4a6032b9$export$554cefe0f0373da4() {
    if (!$862991da4a6032b9$var$setupFlag) {
        const isPageHiddenFlag = $862991da4a6032b9$var$isPageHidden();
        const setupTime = performance.now();
        // Determine if page was opened in background.
        // If we're early in page lifecycle (< threshold) and page is hidden,
        // it's likely the page was opened in a background tab.
        if ($862991da4a6032b9$var$openedInBackground === null) $862991da4a6032b9$var$openedInBackground = isPageHiddenFlag && setupTime < $862991da4a6032b9$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        $862991da4a6032b9$var$pushHidden(isPageHiddenFlag, 0);
        $862991da4a6032b9$var$setup();
        $862991da4a6032b9$var$setupFlag = true;
    }
}
function $862991da4a6032b9$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($862991da4a6032b9$var$timings.length === 0) return 'visible';
    const currentSize = $862991da4a6032b9$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $862991da4a6032b9$var$insertIndex;
    let endIdx = $862991da4a6032b9$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($862991da4a6032b9$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($862991da4a6032b9$var$timings[tmpIdx] && $862991da4a6032b9$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($862991da4a6032b9$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $862991da4a6032b9$var$timings[startIdx]) hiddenState = $862991da4a6032b9$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}
// Throttle detection configuration
// Expected interval for timer checks (in milliseconds)
const $862991da4a6032b9$var$THROTTLE_CHECK_INTERVAL_MS = 1000;
// Threshold for considering a timer as throttled (50% drift tolerance)
const $862991da4a6032b9$var$THROTTLE_DRIFT_THRESHOLD = 1.5;
// Maximum number of throttle measurements to store (circular buffer)
const $862991da4a6032b9$var$THROTTLE_BUFFER_SIZE = 120;
// Circular buffer to store throttle measurements
const $862991da4a6032b9$var$throttleMeasurements = [];
let $862991da4a6032b9$var$throttleInsertIndex = 0;
let $862991da4a6032b9$var$throttleIntervalId = null;
let $862991da4a6032b9$var$lastThrottleCheckTime = null;
let $862991da4a6032b9$var$throttleSetupDone = false;
function $862991da4a6032b9$var$recordThrottleMeasurement(expectedElapsed, actualElapsed) {
    const isThrottled = actualElapsed > expectedElapsed * $862991da4a6032b9$var$THROTTLE_DRIFT_THRESHOLD;
    $862991da4a6032b9$var$throttleMeasurements[$862991da4a6032b9$var$throttleInsertIndex] = {
        time: performance.now(),
        expectedElapsed: expectedElapsed,
        actualElapsed: actualElapsed,
        isThrottled: isThrottled
    };
    $862991da4a6032b9$var$throttleInsertIndex = ($862991da4a6032b9$var$throttleInsertIndex + 1) % $862991da4a6032b9$var$THROTTLE_BUFFER_SIZE;
}
function $862991da4a6032b9$var$throttleCheckCallback() {
    const currentTime = performance.now();
    if ($862991da4a6032b9$var$lastThrottleCheckTime !== null) {
        const actualElapsed = currentTime - $862991da4a6032b9$var$lastThrottleCheckTime;
        $862991da4a6032b9$var$recordThrottleMeasurement($862991da4a6032b9$var$THROTTLE_CHECK_INTERVAL_MS, actualElapsed);
    }
    $862991da4a6032b9$var$lastThrottleCheckTime = currentTime;
}
function $862991da4a6032b9$export$fa0d29a9c87052da() {
    if ($862991da4a6032b9$var$throttleSetupDone) return;
    $862991da4a6032b9$var$throttleSetupDone = true;
    // Record the initial timestamp
    $862991da4a6032b9$var$lastThrottleCheckTime = performance.now();
    // Start the periodic timer for throttle detection
    $862991da4a6032b9$var$throttleIntervalId = setInterval($862991da4a6032b9$var$throttleCheckCallback, $862991da4a6032b9$var$THROTTLE_CHECK_INTERVAL_MS);
}
function $862991da4a6032b9$export$3279694d66e4a1() {
    if ($862991da4a6032b9$var$throttleIntervalId !== null) {
        clearInterval($862991da4a6032b9$var$throttleIntervalId);
        $862991da4a6032b9$var$throttleIntervalId = null;
    }
    $862991da4a6032b9$var$lastThrottleCheckTime = null;
    $862991da4a6032b9$var$throttleSetupDone = false;
    $862991da4a6032b9$var$throttleMeasurements.length = 0;
    $862991da4a6032b9$var$throttleInsertIndex = 0;
}
function $862991da4a6032b9$export$62a28c860277b3bf(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return false;
    // No measurements available
    if ($862991da4a6032b9$var$throttleMeasurements.length === 0) return false;
    // Check if any measurement within the time window indicates throttling
    for(let i = 0; i < $862991da4a6032b9$var$throttleMeasurements.length; i++){
        const measurement = $862991da4a6032b9$var$throttleMeasurements[i];
        if (measurement && measurement.time >= startTime && measurement.time <= endTime && measurement.isThrottled) return true;
    }
    return false;
}
function $862991da4a6032b9$export$77aaa9b1ce57d9bc(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    return $862991da4a6032b9$var$throttleMeasurements.filter((measurement)=>measurement && measurement.time >= startTime && measurement.time <= endTime);
}
function $862991da4a6032b9$export$9332de935653b687(measurement) {
    $862991da4a6032b9$var$throttleMeasurements[$862991da4a6032b9$var$throttleInsertIndex] = measurement;
    $862991da4a6032b9$var$throttleInsertIndex = ($862991da4a6032b9$var$throttleInsertIndex + 1) % $862991da4a6032b9$var$THROTTLE_BUFFER_SIZE;
}
function $862991da4a6032b9$export$5a06b84e47ad70d9(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    if ($862991da4a6032b9$var$timings.length === 0) return [];
    const result = [];
    // Find the most recent entry at or before startTime to establish initial state
    let initialEntry;
    const currentSize = $862991da4a6032b9$var$timings.length;
    for(let i = 0; i < currentSize; i++){
        const idx = ($862991da4a6032b9$var$insertIndex + i) % currentSize;
        const entry = $862991da4a6032b9$var$timings[idx];
        if (entry && entry.time <= startTime) initialEntry = entry;
    }
    // Add the initial visibility state at the start of the window
    if (initialEntry) result.push({
        time: 0,
        hidden: initialEntry.hidden
    });
    // Add all entries within the time window
    for(let i = 0; i < currentSize; i++){
        const idx = ($862991da4a6032b9$var$insertIndex + i) % currentSize;
        const entry = $862991da4a6032b9$var$timings[idx];
        if (entry && entry.time > startTime && entry.time <= endTime) result.push({
            time: Math.round(entry.time - startTime),
            hidden: entry.hidden
        });
    }
    return result;
}
// Expose testing API on window for integration tests
if (typeof window !== 'undefined') window.__reactUfoHiddenTiming = {
    __injectThrottleMeasurementForTesting: $862991da4a6032b9$export$9332de935653b687
};


const $f6282decd619b0ad$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const $f6282decd619b0ad$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $f6282decd619b0ad$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC: VC, VCBox: VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of $f6282decd619b0ad$var$VCParts)details[key] = {
        t: VC[key] || -1,
        e: VCBox[key] || $f6282decd619b0ad$var$READONLY_EMPTY_ARRAY
    };
    return details;
}
function $f6282decd619b0ad$export$5c86a34c9becd6d0({ fullPrefix: fullPrefix, interaction: interaction, isVCClean: isVCClean, isEventAborted: isEventAborted, calculatedVC: calculatedVC, calculatedVCNext: calculatedVCNext, experienceKey: experienceKey, ratios: ratios }) {
    const pageVisibilityUpToTTAI = (0, $862991da4a6032b9$export$768b2008623433e1)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    const availableVCRevisionPayloads = [];
    if ((0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('fy25.01', experienceKey)) {
        const revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $f6282decd619b0ad$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('fy25.02', experienceKey)) {
        const revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $f6282decd619b0ad$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    return {
        [`${fullPrefix}vc:rev`]: availableVCRevisionPayloads
    };
}








var $2hRE7 = parcelRequire("2hRE7");
const $e23e847e8c54c79b$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $e23e847e8c54c79b$export$7028e9efe569888c = {
    [$e23e847e8c54c79b$export$7674290405cc25b0]: true
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $e23e847e8c54c79b$var$MediaWrapper = (0, $9a9850d6654223c3$export$4d143603f9782455)() ? function MediaWrapper(t0) {
    const $ = (0, $ebfe460bd680287b$exports.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement("div", $e23e847e8c54c79b$export$7028e9efe569888c, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function MediaWrapper({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement("div", $e23e847e8c54c79b$export$7028e9efe569888c, children);
};
var $e23e847e8c54c79b$export$2e2bcd8739ae039 = $e23e847e8c54c79b$var$MediaWrapper;


function $14277febf8941d0f$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $e23e847e8c54c79b$export$7674290405cc25b0))) return true;
        node = node.parentNode;
    }
    return false;
}


/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $2d2125bd390ba546$var$isNonVisualStyleMutation({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $2d2125bd390ba546$export$2e2bcd8739ae039 = $2d2125bd390ba546$var$isNonVisualStyleMutation;


const $a2080f66a03331f7$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
class $a2080f66a03331f7$export$166779fc0f49d4df {
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ static getInstance() {
        if (typeof globalThis !== 'undefined') {
            if (!globalThis[$a2080f66a03331f7$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$a2080f66a03331f7$var$GLOBAL_RLL_HANDLERS_KEY] = new $a2080f66a03331f7$export$166779fc0f49d4df();
            return globalThis[$a2080f66a03331f7$var$GLOBAL_RLL_HANDLERS_KEY];
        }
        // Fallback for environments without globalThis (should be rare)
        return new $a2080f66a03331f7$export$166779fc0f49d4df();
    }
    reset() {
        this.placeholders = [];
    }
    /**
   * Collects all React Loosely Lazy (RLL) placeholders from the DOM and caches their viewport intersecting rectangles.
   * RLL placeholders are marked with data-lazy-begin and data-lazy-end attributes on hidden input elements.
   * Performance optimized to batch getBoundingClientRect calls and minimize layout thrashing.
   * Only stores the intersecting portions of rectangles that are currently visible in the viewport.
   */ collectRLLPlaceholders() {
        if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
        const beginElements = document.querySelectorAll('input[data-lazy-begin]');
        const beginCount = beginElements.length;
        if (beginCount === 0) return;
        // Performance optimization: pre-allocate array with estimated size
        const allElements = [];
        // Performance optimization: use traditional for loop instead of forEach
        for(let i = 0; i < beginCount; i++){
            const beginEl = beginElements[i];
            const id = beginEl.getAttribute('data-lazy-begin');
            if (!id) continue;
            const elements = this.refElements(beginEl, id);
            if (elements.length > 0) allElements.push(...elements);
        }
        // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
        const allElementsLength = allElements.length;
        if (allElementsLength > 0) {
            // Performance optimization: pre-allocate array with exact size
            const intersectingRects = [];
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            for(let i = 0; i < allElementsLength; i++){
                const rect = allElements[i].getBoundingClientRect();
                // Performance optimization: inline intersection calculation to avoid function call overhead
                const left = Math.max(rect.left, 0);
                const top = Math.max(rect.top, 0);
                const right = Math.min(rect.right, windowWidth);
                const bottom = Math.min(rect.bottom, windowHeight);
                // Check if there's a valid intersection with non-zero width and height
                if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
            }
            this.placeholders = intersectingRects;
        }
    }
    /**
   * Traverses DOM siblings to find all elements between RLL begin and end markers.
   * Based on the refElements pattern from react-loosely-lazy's platform/packages/async/react-loosely-lazy/src/collect/hydrate.ts
   * Performance optimized to minimize iterations and early exit conditions.
   *
   * @param fromEl - The input element with data-lazy-begin attribute
   * @param id - The placeholder ID to match against data-lazy-end
   * @returns Array of DOM elements between the begin/end markers
   */ refElements(fromEl, id) {
        const result = [];
        let el = fromEl.nextSibling;
        // Performance optimization: use while loop instead of recursive calls
        while(el){
            if (el.dataset?.lazyEnd === id) break;
            if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
            el = el.nextSibling;
        }
        return result;
    }
    /**
   * Returns the cached intersecting viewport rectangles for all RLL placeholder elements.
   * @returns Array of DOMRect objects representing the intersecting portions of placeholders within the viewport
   */ getPlaceholders() {
        return this.placeholders;
    }
    /**
   * Checks if the given intersecting rectangle matches any of the cached RLL placeholder intersecting rectangles.
   * This is designed to be called from IntersectionObserver with the intersectionRect.
   * Performance optimized with early exits and minimal calculations.
   * @param intersectingRect - The intersecting rectangle from IntersectionObserver
   * @returns true if the intersecting rectangle matches a cached placeholder rectangle and hasn't exceeded match limit, false otherwise
   */ isRLLPlaceholderHydration(intersectingRect) {
        const placeholdersLength = this.placeholders.length;
        if (placeholdersLength === 0) return false;
        // Performance optimization: cache array length and use traditional for loop
        for(let i = 0; i < placeholdersLength; i++){
            const placeholderRect = this.placeholders[i];
            if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
        }
        return false;
    }
    /**
   * Compares two DOMRect objects for equality with ±1 pixel tolerance.
   * Performance optimized to minimize calculations and early exit on major differences.
   * @param rect1 - First rectangle to compare
   * @param rect2 - Second rectangle to compare
   * @returns true if rectangles are within 1 pixel tolerance for all properties
   */ areRectsEqual(rect1, rect2) {
        // Early exit for exact matches (most common case)
        if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
        // Performance optimization: check largest differences first for early exit
        const leftDiff = rect1.left - rect2.left;
        if (leftDiff > 1 || leftDiff < -1) return false;
        const rightDiff = rect1.right - rect2.right;
        if (rightDiff > 1 || rightDiff < -1) return false;
        const topDiff = rect1.top - rect2.top;
        if (topDiff > 1 || topDiff < -1) return false;
        const bottomDiff = rect1.bottom - rect2.bottom;
        if (bottomDiff > 1 || bottomDiff < -1) return false;
        return true;
    }
    constructor(){
        this.placeholders = [];
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
}


const $58e60c4d354c2851$var$ANCESTOR_LOOKUP_LIMIT = 10;
const $58e60c4d354c2851$var$PAGE_LAYOUT_ID = 'page-layout.root';
class $58e60c4d354c2851$export$c0102f1a1198d10f {
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    collectPlaceholdersInternal() {
        const selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
        const existingElements = document.querySelectorAll(selector);
        existingElements.forEach((el)=>{
            const placeholderId = el instanceof HTMLElement && this.getPlaceholderId(el);
            if (placeholderId && !this.staticPlaceholders.has(placeholderId)) {
                let width = -1;
                let height = -1;
                let x = -1;
                let y = -1;
                // Use SSR dimensions from window global if available
                const boundingClientRect = window.__SSR_PLACEHOLDERS_DIMENSIONS__?.[placeholderId];
                if (boundingClientRect) {
                    width = boundingClientRect.width;
                    height = boundingClientRect.height;
                    x = boundingClientRect.x;
                    y = boundingClientRect.y;
                } else {
                    // Fallback to current bounding rect if SSR dimensions not available
                    const rect = el.getBoundingClientRect();
                    width = rect.width;
                    height = rect.height;
                    x = rect.x;
                    y = rect.y;
                }
                this.staticPlaceholders.set(placeholderId, {
                    width: width,
                    height: height,
                    x: x,
                    y: y
                });
                this.intersectionObserver?.observe(el);
            }
        });
    }
    /**
   * Added this method to be utilised for testing purposes.
   * In production it collection placeholder should only happens on constructor
   */ collectExistingPlaceholders() {
        if (!window.document) return;
        try {
            // Collect placeholders using SSR dimensions or fallback to live dimensions
            this.collectPlaceholdersInternal();
        } catch  {
        // Silently fail if there are any issues
        }
    }
    isPlaceholder(element) {
        return Boolean(this.getPlaceholderId(element));
    }
    isPlaceholderReplacement(element) {
        return Boolean(this.getPlaceholderReplacementId(element));
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    isPlaceholderV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $58e60c4d354c2851$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    isPlaceholderReplacementV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $58e60c4d354c2851$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $58e60c4d354c2851$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    findNearestPlaceholderOrContainer(element, limit = $58e60c4d354c2851$var$ANCESTOR_LOOKUP_LIMIT) {
        let ancestor = element;
        if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < limit){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            if (ancestor.parentElement) {
                ancestor = ancestor.parentElement;
                i++;
            } else break;
        }
        return element;
    }
    // Validates placeholder match using asynchronous observation and resolves with the result
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.callbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    // Validates placeholder match synchronously using stored SSR dimensions and current bounds
    checkIfExistedAndSizeMatchingV3(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        const placeholderRects = this.staticPlaceholders.get(id);
        if (!placeholderRects) return false;
        return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
    }
    getSize(el) {
        return new Promise((resolve)=>{
            this.getSizeCallbacks.set(this.getPlaceholderId(el), resolve);
            this.intersectionObserver?.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderReplacementId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.reactValidateCallbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    validateReactComponentMatchToPlaceholderV4(el) {
        el = this.findNearestPlaceholderOrContainer(el, 2); // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
        const id = this.getPlaceholderReplacementId(el);
        return this.staticPlaceholders.has(id);
    }
    hasSameSizePosition(rect, boundingClientRect) {
        if (!rect) return false;
        const horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
        const verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
        return horizontalCheck && verticalCheck || false;
    }
    /**
   * Gets the effective bounding rectangle for an element, handling display: contents elements
   * by collecting dimensions from their children instead
   */ getEffectiveBoundingRect(el) {
        const computedStyle = window.getComputedStyle(el);
        // If element has display: contents, collect bounding rect from children
        if (computedStyle.display === 'contents') {
            const children = Array.from(el.children);
            if (children.length === 0) // No children, return zero rect
            return new DOMRect(0, 0, 0, 0);
            // Calculate union of all children's bounding rects
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            children.forEach((child)=>{
                const childRect = child.getBoundingClientRect();
                // Skip children with zero dimensions (likely also display: contents)
                if (childRect.width > 0 || childRect.height > 0) {
                    minX = Math.min(minX, childRect.left);
                    minY = Math.min(minY, childRect.top);
                    maxX = Math.max(maxX, childRect.right);
                    maxY = Math.max(maxY, childRect.bottom);
                }
            });
            // If no children with dimensions found, return zero rect
            if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
            return new DOMRect(minX, minY, maxX - minX, maxY - minY);
        }
        // Normal element, return its bounding rect
        return el.getBoundingClientRect();
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
    constructor({ enablePageLayoutPlaceholder: enablePageLayoutPlaceholder = false }){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.intersectionObserver = void 0;
        this.EQUALITY_THRESHOLD = 1;
        this.enablePageLayoutPlaceholder = void 0;
        this.getPlaceholderId = (el)=>{
            const ssrPlaceholderId = el?.dataset?.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $58e60c4d354c2851$var$PAGE_LAYOUT_ID) return $58e60c4d354c2851$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.getPlaceholderReplacementId = (el)=>{
            const ssrPlaceholderReplaceId = el?.dataset?.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $58e60c4d354c2851$var$PAGE_LAYOUT_ID) return $58e60c4d354c2851$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            this.intersectionObserver?.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = this.getPlaceholderId(target);
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = this.getEffectiveBoundingRect(target);
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = this.getPlaceholderReplacementId(target);
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = this.getEffectiveBoundingRect(target);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions. __SSR_PLACEHOLDERS_DIMENSIONS__ is
            // deliberately left in place: several VCObserverWrappers are built per page load and each
            // builds its own handler, so dropping it here would leave every later handler measuring
            // each placeholder with getBoundingClientRect() — a synchronous style recalc and a
            // full-document layout mid-hydration. Keeping it costs one small map per document.
            this.collectPlaceholdersInternal();
        } catch  {}
    }
}


const $27644a368a9757d8$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $27644a368a9757d8$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class $27644a368a9757d8$export$b65d046240060e78 {
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        this.totalTime = 0;
        this.ssr = {
            state: $27644a368a9757d8$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.mutationObserver?.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView.clear();
        this.callbacks.clear();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $27644a368a9757d8$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $27644a368a9757d8$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $27644a368a9757d8$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $27644a368a9757d8$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $27644a368a9757d8$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $14277febf8941d0f$export$f61fbc3b9c4a9019)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            this.elementsInView.delete(node);
                            this.intersectionObserver?.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        /*
            	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            	Conceptually there is after all a mutation: there is an old value replaced with a new one,
            	and whether or not they are the same doesn't really matter.
            	And Custom elements should work the same way as MutationObserver."
            	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ const oldValue = mutation.oldValue ?? undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, $2d2125bd390ba546$export$2e2bcd8739ae039)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, $14277febf8941d0f$export$f61fbc3b9c4a9019)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch  {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!data?.mutation) // ignore intersection report without recent mutation
                    return;
                    if (!$27644a368a9757d8$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    if ((0, $a2080f66a03331f7$export$166779fc0f49d4df).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch  {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
    constructor(opts){
        this.intersectionObserver = void 0;
        this.mutationObserver = void 0;
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssrPlaceholderHandler = void 0;
        this.ssr = {
            state: $27644a368a9757d8$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
            this.intersectionObserver?.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        // Selector-config resolution is centralised in `getSelectorConfig()`.
        // It enforces FedRAMP-override > caller-override > centrally
        // configured > caller default.
        const resolved = (0, $d0427bdd60d98885$export$59e1f072477dfb48)(opts.selectorConfig, this.selectorConfig);
        this.selectorConfig = resolved ?? {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $58e60c4d354c2851$export$c0102f1a1198d10f)({
            enablePageLayoutPlaceholder: opts.SSRConfig?.enablePageLayoutPlaceholder
        });
    }
}


const $0b934ca4495e12d5$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $0b934ca4495e12d5$var$UNUSED_SECTOR = 0;
function $0b934ca4495e12d5$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $0b934ca4495e12d5$export$1f70d263701b1d01 {
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static getSSRRatio(entries, ssr) {
        if (ssr === undefined || entries.length === 0) return undefined;
        const maybeSSR = entries[0];
        if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
        return 0;
    }
    static calculateVC({ heatmap: heatmap, ssr: ssr = $0b934ca4495e12d5$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport, fixSSRAttribution: fixSSRAttribution }) {
        const lastUpdate = {};
        let totalPainted = 0;
        const ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
        if (ssrTime !== $0b934ca4495e12d5$var$UNUSED_SECTOR) {
            const element = {
                __debug__element: new WeakRef(window.document?.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
            componentsLog[ssrTime].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $0b934ca4495e12d5$var$UNUSED_SECTOR && ssrTime !== $0b934ca4495e12d5$var$UNUSED_SECTOR ? ssrTime : entry);
                totalPainted += rounded !== $0b934ca4495e12d5$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $0b934ca4495e12d5$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $0b934ca4495e12d5$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $0b934ca4495e12d5$export$1f70d263701b1d01.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            $0b934ca4495e12d5$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set(componentsLog[time]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set(componentsLog[timestamp]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (acc.rel[i - 1]?.vc ?? 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $0b934ca4495e12d5$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($0b934ca4495e12d5$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $73ea5edd539be009$export$a497a1dcb4408212)();
        this.viewport.h = (0, $734b83dcbc6eaeb8$export$4f01c15d21ef9cc6)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($0b934ca4495e12d5$var$abortReason.error, time, `index - ${row}`);
                } catch  {
                    this.setAbortReason($0b934ca4495e12d5$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $0b934ca4495e12d5$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        if (this.unbind) {
            const { unbind: unbind } = this;
            for(let i = 0; i < unbind.length; i++)unbind[i]();
            this.unbind.length = 0;
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.heatmap = void 0;
        this.heatmapNext = void 0;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this.observers = void 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.devToolsEnabled = void 0;
        this.oldDomUpdatesEnabled = void 0;
        this.unbind = [];
        this.isPostInteraction = void 0;
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: {
                    ...this.abortReason
                },
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: {
                    ...this.componentsLog
                },
                viewport: {
                    ...this.viewport
                },
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc, isEventAborted: isEventAborted, experienceKey: experienceKey, interactionId: interactionId, includeSSRRatio: includeSSRRatio })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios } = rawData;
            const isTTVCv1Disabled = !(0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('fy25.01', experienceKey);
            if (abortReasonInfo !== null) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch  {}
                const vcAbortedResultWithRevisions = {
                    [`${fullPrefix}vc:rev`]: [
                        {
                            revision: 'fy25.02',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason,
                            abortTimestamp: Math.round(abortReason.timestamp)
                        }
                    ]
                };
                if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                    revision: 'fy25.01',
                    clean: false,
                    'metric:vc90': null,
                    abortReason: abortReason.reason,
                    abortTimestamp: Math.round(abortReason.timestamp)
                });
                return vcAbortedResultWithRevisions;
            }
            const ttvcV1Result = isTTVCv1Disabled ? {
                VC: {},
                VCBox: {},
                VCEntries: {
                    abs: [],
                    rel: [],
                    speedIndex: -1
                },
                totalPainted: -1
            } : $0b934ca4495e12d5$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: {
                    ...componentsLog
                },
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = ttvcV1Result;
            const _componentsLog = {};
            Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            const vcNext = $0b934ca4495e12d5$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: _componentsLog,
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    const ttvcV2DevToolInfo = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmapNext,
                        ratios: ratios
                    };
                    if (isTTVCv1Disabled) {
                        window.__vc = ttvcV2DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    } else {
                        window.__vc = ttvcV1DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    }
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: $0b934ca4495e12d5$var$filterComponentsLog(componentsLog),
                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                        }
                    }));
                }
                if (!this.isPostInteraction) {
                    // Only create revision debug details if callbacks exist
                    const shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                    if (shouldCreateDebugDetails) {
                        const v1RevisionDebugDetails = (0, $ff2c03df3367967d$export$72e6dda9d5859230)({
                            revision: 'fy25.01',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        const v2RevisionDebugDetails = (0, $ff2c03df3367967d$export$72e6dda9d5859230)({
                            revision: 'fy25.02',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: vcNext.VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        // Add devtool callback for both v1 and v2
                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                            // Handle v1 if not disabled
                            if (!isTTVCv1Disabled) window.__ufo_devtool_onVCRevisionReady__?.(v1RevisionDebugDetails);
                            // Handle v2
                            window.__ufo_devtool_onVCRevisionReady__?.(v2RevisionDebugDetails);
                        }
                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                            if (!isTTVCv1Disabled) window.__on_ufo_vc_debug_data_ready?.(v1RevisionDebugDetails);
                            window.__on_ufo_vc_debug_data_ready?.(v2RevisionDebugDetails);
                        }
                    }
                }
            } catch  {
            /*  do nothing */ }
            const isVCClean = !abortReasonInfo;
            const revisionsData = (0, $f6282decd619b0ad$export$5c86a34c9becd6d0)({
                fullPrefix: fullPrefix,
                interaction: {
                    start: start,
                    end: stop
                },
                isVCClean: isVCClean,
                calculatedVC: {
                    VC: VC,
                    VCBox: VCBox
                },
                calculatedVCNext: {
                    VC: vcNext.VC,
                    VCBox: vcNext.VCBox
                },
                isEventAborted: isEventAborted,
                experienceKey: experienceKey,
                ratios: ratios
            });
            const speedIndex = {
                [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
                [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
            };
            const SSRRatio = $0b934ca4495e12d5$export$1f70d263701b1d01.getSSRRatio(VCEntries.rel, ssr);
            const SSRRatioNext = $0b934ca4495e12d5$export$1f70d263701b1d01.getSSRRatio(vcNext.VCEntries.rel, ssr);
            const SSRRatioPayload = includeSSRRatio ? {
                [`${fullPrefix}vc:ssrRatio`]: isTTVCv1Disabled ? SSRRatioNext : SSRRatio,
                [`${fullPrefix}vc:next:ssrRatio`]: SSRRatioNext
            } : {};
            if (isTTVCv1Disabled) return {
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatioNext,
                ...revisionsData,
                ...speedIndex
            };
            const isTTVCv3Enabled = (0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('fy25.03', experienceKey);
            return {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: isVCClean,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatio,
                ...outOfBoundary,
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                const interaction = (0, $fa77cab6e7101561$export$2b3954d2e8509985)();
                const isTTVCv1Disabled = !(0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('fy25.01', interaction?.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason($0b934ca4495e12d5$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    // Don't abort press interactions on keydown events, as keydown is expected
                    // when users press Enter/Space to activate buttons or other interactive elements
                    if ((0, $6oQI4.fg)('platform_ufo_keypress_interaction_abort')) {
                        const interaction = (0, $fa77cab6e7101561$export$2b3954d2e8509985)();
                        if (interaction?.type === 'press') break;
                    }
                    this.setAbortReason($0b934ca4495e12d5$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason($0b934ca4495e12d5$var$abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            this.detachAbortListeners();
            let unbinds = (0, $d5c296b3fe8ae423$export$9010aa71841a6887)(window, this.viewport, this.abortReasonCallback);
            if (window?.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                if (time) this.abortReasonCallback(key, time);
            });
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        const { ssrEnablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler: ssrPlaceholderHandler } = options;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It enforces FedRAMP-override > caller-override >
        // centrally configured > caller default. When `getSelectorConfig()`
        // returns `undefined` we fall back to the legacy hard-coded default
        // to preserve pre-existing behaviour for callers that don't pass an
        // explicit `selectorConfig`.
        const LEGACY_DEFAULT_SELECTOR_CONFIG = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.observers = new (0, $27644a368a9757d8$export$b65d046240060e78)({
            selectorConfig: (0, $d0427bdd60d98885$export$59e1f072477dfb48)(options.selectorConfig, LEGACY_DEFAULT_SELECTOR_CONFIG) || options.selectorConfig || LEGACY_DEFAULT_SELECTOR_CONFIG,
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
}
/** config * */ $0b934ca4495e12d5$export$1f70d263701b1d01.VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];



var $6oQI4 = parcelRequire("6oQI4");




class $b00520024666479c$export$2e2bcd8739ae039 {
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = this.sortedEntriesCache.get(cacheKey)?.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
    constructor(){
        this.unorderedEntries = void 0;
        this.sortedEntriesCache = void 0;
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
}


const $e80f24cd58367ae7$var$nameCache = new WeakMap();
function $e80f24cd58367ae7$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        let elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            const parentElementSelector = $e80f24cd58367ae7$var$getElementName(selectorConfig, element.parentElement);
            return `${parentElementSelector} > ${elementInstance}`;
        } else return elementInstance;
    }
    const cachedName = $e80f24cd58367ae7$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch  {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $e80f24cd58367ae7$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $e80f24cd58367ae7$var$nameCache.set(element, name);
    return name;
}
var $e80f24cd58367ae7$export$2e2bcd8739ae039 = $e80f24cd58367ae7$var$getElementName;



var $6oQI4 = parcelRequire("6oQI4");

var $3ihMw = parcelRequire("3ihMw");

const $fc4e94e8db3350dd$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue)=>{
    // If client is not initialized, we return the default value
    if (!(0, $3ihMw.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $3ihMw.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $cf5258fb0d237fac$export$47fade9662f71000)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
};



var $6oQI4 = parcelRequire("6oQI4");
/**
 * Matches only the editor drag and drop anchors. This is the pre-gate behaviour.
 */ const $42226e2277fa3587$var$isDnDAnchorNameDeclaration = (declaration)=>{
    return declaration.startsWith('anchor-name: --node-anchor');
};
/**
 * Matches any `anchor-name` declaration.
 *
 * `anchor-name` (CSS Anchor Positioning) only names an element so that _other_
 * elements can position themselves against it. It never changes how the named
 * element itself renders, so adding or removing it is never a visual change.
 *
 * `@atlaskit/top-layer` writes `anchor-name` onto a popover's trigger as soon as
 * the popover host element exists, which for `Popover`-based consumers is first
 * open (for example, hovering an `@atlaskit/tooltip` trigger). Without this
 * exclusion that write is recorded as a repaint of the trigger at hover time,
 * which shifts TTVC in sessions where a user hovers a trigger before the page
 * has settled. See COPPER-1736.
 */ const $42226e2277fa3587$var$isAnyAnchorNameDeclaration = (declaration)=>{
    return declaration.startsWith('anchor-name:');
};
const $42226e2277fa3587$var$parseStyleSet = (style)=>{
    if (!style) return null;
    const set = new Set();
    for (const part of style.split(';')){
        const t = part.trim();
        if (t) set.add(t);
    }
    return set;
};
/**
 * Checks if a mutation record represents a `style` change that consists only
 * of `anchor-name` declarations being added or removed.
 *
 * Without `platform_ufo_exclude_anchor_name_from_ttvc` this is limited to the
 * editor's drag and drop anchors (`--node-anchor…`), which is where the check
 * originated. With the gate on, every `anchor-name` is treated as non-visual,
 * because the property never affects the rendering of the element it is set on.
 *
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is an anchor-name-only style mutation
 */ function $42226e2277fa3587$export$7a0b59cebcbf44ec({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (!(target instanceof Element)) return false;
    return $42226e2277fa3587$export$f83f33200c1a234e({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $42226e2277fa3587$export$f83f33200c1a234e({ attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (attributeName !== 'style') return false;
    // Resolved once per mutation rather than once per declaration: this runs
    // inside the MutationObserver callback.
    const isIgnoredDeclaration = (0, $6oQI4.fg)('platform_ufo_exclude_anchor_name_from_ttvc') ? $42226e2277fa3587$var$isAnyAnchorNameDeclaration : $42226e2277fa3587$var$isDnDAnchorNameDeclaration;
    const oldStyles = $42226e2277fa3587$var$parseStyleSet(oldValue);
    const newStyles = $42226e2277fa3587$var$parseStyleSet(newValue);
    let isAnchorNameMutation = false;
    for (const s of oldStyles ?? [])if (!newStyles?.has(s)) {
        if (!isIgnoredDeclaration(s)) return false;
        isAnchorNameMutation = true;
    }
    for (const s of newStyles ?? [])if (!oldStyles?.has(s)) {
        if (!isIgnoredDeclaration(s)) return false;
        isAnchorNameMutation = true;
    }
    return isAnchorNameMutation;
}
var $42226e2277fa3587$export$2e2bcd8739ae039 = $42226e2277fa3587$export$7a0b59cebcbf44ec;



var $6oQI4 = parcelRequire("6oQI4");
function $cd96b4bdb2133b25$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}


function $5e9886de9ba95999$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    const entries = new Array(elementMap.size);
    let cumulativePixels = 0;
    let speedIndex = 0;
    let previousPercentCovered = 0;
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    for(let i = 0; i < sortedEntries.length; i++){
        const [time, pixelCount] = sortedEntries[i];
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const entryDatas = elementMap.get(time) || [];
        const relativeTime = Math.round(Number(time - startTime));
        entries[i] = {
            time: relativeTime,
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
        // Speed index calculation: sum of (time × incremental viewport percentage)
        const ratioDelta = (percentCovered - previousPercentCovered) / 100;
        speedIndex += relativeTime * ratioDelta;
        previousPercentCovered = percentCovered;
    }
    return {
        entries: entries,
        speedIndex: Math.round(speedIndex)
    };
}


// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $2f7485e31616ee8c$var$taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
var $2f7485e31616ee8c$export$2e2bcd8739ae039 = $2f7485e31616ee8c$var$taskYield;


async function $044e9b62a5d452d0$export$fafc9be44839f9c8(imageData, _, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, $2f7485e31616ee8c$export$2e2bcd8739ae039)();
    }
    return arr;
}


function $04f7da53df647b10$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}


class $abc631b91760e5e0$export$3e59ac9de7402fb1 {
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ createCanvas(width, height) {
        if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
   * Clears the entire canvas by removing all drawn content.
   * @private
   */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
   * Generates a unique RGB color from an incrementing counter.
   * Uses a 24-bit color space (16,777,216 possible colors).
   *
   * @private
   * @returns A unique RGB color string
   *
   * @example
   * // Example bit operations for color 0x00FF8040:
   * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
   * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
   * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
   */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return (0, $04f7da53df647b10$export$54591583ed0b20ce)(rgbColor);
    }
    /**
   * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
   * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
   *
   * @param rect - The rectangle dimensions to draw
   * @param timestamp - The timestamp to associate with this drawing operation
   */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
   * Calculates the number of pixels drawn for each timestamp.
   * This method:
   * 1. Reads the pixel data from the canvas
   * 2. Counts pixels of each unique color
   * 3. Maps colors back to their timestamps
   * 4. Adjusts counts based on the scale factor
   *
   * @returns A Map containing timestamp to pixel count mappings
   */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await (0, $044e9b62a5d452d0$export$fafc9be44839f9c8)(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = (0, $04f7da53df647b10$export$54591583ed0b20ce)(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
    /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ constructor(viewport, scaleFactor = 1){
        /** The underlying Canvas instance (either OffscreenCanvas or HTMLCanvasElement) */ this.canvas = void 0;
        /** The 2D rendering context of the canvas */ this.ctx = void 0;
        /** Scale factor applied to the canvas (affects final pixel counts) */ this.scaleFactor = void 0;
        /** Maps unique colors to their corresponding timestamps */ this.colorTimeMap = void 0;
        /** Counter used to generate unique colors */ this.colorCounter = void 0;
        this.scaledWidth = void 0;
        this.scaledHeight = void 0;
        this.scaleX = void 0;
        this.scaleY = void 0;
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
}


async function $0e594b28245ce7e6$var$calculateTTVCPercentiles({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles, startTime: startTime }) {
    const canvas = new (0, $abc631b91760e5e0$export$3e59ac9de7402fb1)(viewport, (0, $6oQI4.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return (0, $cd96b4bdb2133b25$export$89c8da9b65eff678)(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
async function $0e594b28245ce7e6$export$96ea73435089b05a({ viewport: viewport, orderedEntries: orderedEntries, startTime: startTime }) {
    const canvas = new (0, $abc631b91760e5e0$export$3e59ac9de7402fb1)(viewport, (0, $6oQI4.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
        elementMap.get(entry.time).push(entry.data);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimensions = canvas.getScaledDimensions();
    const totalPixels = canvasDimensions.width * canvasDimensions.height;
    return (0, $5e9886de9ba95999$export$a532ce01ea38d882)(timePixelCounts, elementMap, totalPixels, startTime);
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0e594b28245ce7e6$export$2e2bcd8739ae039 = $0e594b28245ce7e6$var$calculateTTVCPercentiles;


const $6455eca4eafac67e$var$calculateOffenderState = (current, matchesCurrentEntry)=>{
    // Once we know it's mixed across entries, we can short-circuit.
    if (current === 'some') return 'some';
    const entryState = matchesCurrentEntry ? 'all' : 'none';
    if (current == null) return entryState;
    // If the state flips between entries (all <-> none), it's "some".
    if (current !== entryState) return 'some';
    return current;
};
const $6455eca4eafac67e$var$calculateLayoutShiftMovement = (layoutShiftEntries)=>{
    const movements = layoutShiftEntries.map((lsEntry)=>{
        const rect = lsEntry.rect;
        const previousRect = lsEntry.previousRect;
        if (!rect || !previousRect) return null;
        const dx = rect.x - previousRect.x;
        const dy = rect.y - previousRect.y;
        return {
            dx: dx,
            dy: dy,
            movedX: dx !== 0,
            movedY: dy !== 0,
            dirX: Math.sign(dx),
            dirY: Math.sign(dy),
            absDx: Math.abs(dx),
            absDy: Math.abs(dy)
        };
    });
    const hasMovement = (m)=>m !== null;
    const validMovements = movements.filter(hasMovement);
    const allHaveRects = layoutShiftEntries.length > 0 && validMovements.length === layoutShiftEntries.length;
    if (!allHaveRects) return {
        allHaveRects: allHaveRects,
        allMovedSameWay: false,
        allMovedSameAmount: false
    };
    const first = validMovements[0];
    const allMovedSameWay = validMovements.every((m)=>m.movedX === first.movedX && m.movedY === first.movedY && m.dirX === first.dirX && m.dirY === first.dirY);
    const allMovedSameAmount = allMovedSameWay && validMovements.every((m)=>m.absDx === first.absDx && m.absDy === first.absDy);
    return {
        allHaveRects: allHaveRects,
        allMovedSameWay: allMovedSameWay,
        allMovedSameAmount: allMovedSameAmount,
        deltaX: first.dx,
        deltaY: first.dy
    };
};
const $6455eca4eafac67e$export$93ce39b765ea2cd3 = ({ viewportEntries: viewportEntries, layoutShiftEntries: layoutShiftEntries, time: time, startTime: startTime, offenderWindowMs: offenderWindowMs = 250 })=>{
    const checkpointTimestamp = startTime + time;
    const filteredLSPotentialOffenders = viewportEntries.filter((viewportEntry)=>(viewportEntry.time < checkpointTimestamp && viewportEntry.time > checkpointTimestamp - offenderWindowMs || viewportEntry.time > checkpointTimestamp && viewportEntry.time < checkpointTimestamp + offenderWindowMs) && viewportEntry.data.type !== 'layout-shift');
    // Summarize whether all layout-shift entries moved in a consistent direction and by the same amount.
    const layoutShiftVariables = $6455eca4eafac67e$var$calculateLayoutShiftMovement(layoutShiftEntries);
    // Classify each offender against *all* layout-shift entries when the layout shift is consistently moving in a
    // single axis (pure X or pure Y) so we can reason about whether an offender could have caused the movement.
    const layoutShiftOffenders = filteredLSPotentialOffenders.reduce((acc, offender)=>{
        const offenderData = offender.data;
        const offenderRect = offenderData.rect;
        if (!offenderRect) return acc;
        const offenderTimestamp = offenderData.originalMutationTimestamp ?? offender.time;
        const happenedBefore = offenderTimestamp <= checkpointTimestamp;
        const offenderLeft = offenderRect.x;
        const offenderRight = offenderRect.x + offenderRect.width;
        const offenderTop = offenderRect.y;
        const offenderBottom = offenderRect.y + offenderRect.height;
        const shouldClassifyAgainstAllEntries = layoutShiftVariables.allMovedSameWay && 'deltaX' in layoutShiftVariables && 'deltaY' in layoutShiftVariables && layoutShiftVariables.deltaX === 0 !== (layoutShiftVariables.deltaY === 0);
        let isAbove = null;
        let isLeft = null;
        let isRight = null;
        let hasHorizontalOverlap = null;
        let hasVerticalOverlap = null;
        if (shouldClassifyAgainstAllEntries) for (const lsEntry of layoutShiftEntries){
            const lsRect = lsEntry.rect;
            if (!lsRect) continue;
            const lsLeft = lsRect.x;
            const lsRight = lsRect.x + lsRect.width;
            const lsTop = lsRect.y;
            const lsBottom = lsRect.y + lsRect.height;
            isAbove = $6455eca4eafac67e$var$calculateOffenderState(isAbove, offenderBottom <= lsTop);
            isLeft = $6455eca4eafac67e$var$calculateOffenderState(isLeft, offenderRight <= lsLeft);
            isRight = $6455eca4eafac67e$var$calculateOffenderState(isRight, offenderLeft >= lsRight);
            hasHorizontalOverlap = $6455eca4eafac67e$var$calculateOffenderState(hasHorizontalOverlap, offenderLeft < lsRight && offenderRight > lsLeft);
            hasVerticalOverlap = $6455eca4eafac67e$var$calculateOffenderState(hasVerticalOverlap, offenderTop < lsBottom && offenderBottom > lsTop);
        }
        let matchesLayoutShiftDelta = false;
        if (shouldClassifyAgainstAllEntries && layoutShiftVariables.allMovedSameAmount && offenderData.previousRect) {
            const dx = offenderRect.x - offenderData.previousRect.x;
            const dy = offenderRect.y - offenderData.previousRect.y;
            const isPureX = layoutShiftVariables.deltaX !== 0 && layoutShiftVariables.deltaY === 0;
            const isPureY = layoutShiftVariables.deltaY !== 0 && layoutShiftVariables.deltaX === 0;
            if (isPureX) matchesLayoutShiftDelta = dx === layoutShiftVariables.deltaX && dy === 0;
            else if (isPureY) matchesLayoutShiftDelta = dy === layoutShiftVariables.deltaY && dx === 0;
        }
        acc.push({
            offender: offenderData.elementName,
            happenedBefore: happenedBefore,
            distanceToLS: Math.round(offenderTimestamp - checkpointTimestamp),
            isAbove: isAbove ?? 'none',
            isLeft: isLeft ?? 'none',
            isRight: isRight ?? 'none',
            hasHorizontalOverlap: hasHorizontalOverlap ?? 'none',
            hasVerticalOverlap: hasVerticalOverlap ?? 'none',
            matchesLayoutShiftDelta: matchesLayoutShiftDelta
        });
        return acc;
    }, []);
    return {
        layoutShiftVariables: layoutShiftVariables,
        layoutShiftOffenders: layoutShiftOffenders
    };
};


function $e2b4e09b71851474$var$getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $e2b4e09b71851474$export$2e2bcd8739ae039 = $e2b4e09b71851474$var$getViewportHeight;


function $198f583f16a03674$var$getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $198f583f16a03674$export$2e2bcd8739ae039 = $198f583f16a03674$var$getViewportWidth;


function $060abdc7408e5559$var$isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $060abdc7408e5559$export$2e2bcd8739ae039 = $060abdc7408e5559$var$isViewportEntryData;


// Helper function for reporting ratios
function $6d164c2ff0558a95$var$roundDecimal(value, decimals = 3) {
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
class $6d164c2ff0558a95$export$2e2bcd8739ae039 {
    filterViewportEntries(entries) {
        return entries.filter((entry)=>{
            return 'rect' in entry.data;
        });
    }
    /**
   * Calculate ratios for each element based on their viewport coverage.
   */ calculateRatios(filteredEntries) {
        const ratios = {};
        const viewportWidth = (0, $198f583f16a03674$export$2e2bcd8739ae039)();
        const viewportHeight = (0, $e2b4e09b71851474$export$2e2bcd8739ae039)();
        const totalViewportArea = viewportWidth * viewportHeight;
        if (totalViewportArea === 0) return ratios;
        const elementRects = new Map();
        for (const entry of filteredEntries)if ('rect' in entry.data) {
            const viewportEntry = entry.data;
            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
        }
        for (const [elementName, rect] of elementRects){
            const elementArea = rect.width * rect.height;
            ratios[elementName] = $6d164c2ff0558a95$var$roundDecimal(elementArea / totalViewportArea);
        }
        return ratios;
    }
    getLabelStacks(filteredEntries, isPostInteraction) {
        const labelStacks = {};
        for (const entry of filteredEntries)if ((0, $060abdc7408e5559$export$2e2bcd8739ae039)(entry.data) && entry.data.labelStacks) {
            if (isPostInteraction) labelStacks[entry.data.elementName] = {
                segment: entry.data.labelStacks.segment,
                labelStack: entry.data.labelStacks.labelStack
            };
            else labelStacks[entry.data.elementName] = entry.data.labelStacks.labelStack;
        }
        return labelStacks;
    }
    async calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders) {
        const percentiles = [
            25,
            50,
            75,
            80,
            85,
            90,
            95,
            98,
            99,
            100
        ];
        const viewportEntries = this.filterViewportEntries(filteredEntries);
        const { entries: vcLogs, speedIndex: speedIndex } = await (0, $0e594b28245ce7e6$export$96ea73435089b05a)({
            viewport: {
                width: (0, $198f583f16a03674$export$2e2bcd8739ae039)(),
                height: (0, $e2b4e09b71851474$export$2e2bcd8739ae039)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: viewportEntries
        });
        const vcDetails = {};
        let percentileIndex = 0;
        const entryDataBuffer = new Set();
        let ssrRatio = -1;
        let layoutShiftInsights = null;
        let previousViewportPercentage = 0;
        if (vcLogs) for (const entry of vcLogs){
            const { time: time, viewportPercentage: viewportPercentage, entries: entries } = entry;
            if (includeSSRRatio && ssrRatio === -1 && entries.some((e)=>e.elementName === 'SSR')) ssrRatio = viewportPercentage;
            // Only process entries if we haven't reached all percentiles
            if (percentileIndex >= percentiles.length) break;
            // Check if this entry matches any checkpoint percentiles
            if (viewportPercentage >= percentiles[percentileIndex]) {
                const elementNames = [
                    ...new Set(entries.map((e)=>e.elementName))
                ];
                // Process all matching percentiles in one go
                while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                    vcDetails[`${percentiles[percentileIndex]}`] = {
                        t: Math.round(time),
                        e: elementNames
                    };
                    if (reportLayoutShiftOffenders && percentiles[percentileIndex] === 90 && entries.some((e)=>e.type === 'layout-shift')) {
                        const layoutShiftEntries = entries.filter((e)=>e.type === 'layout-shift');
                        layoutShiftInsights = {
                            layoutShiftOffendersResult: (0, $6455eca4eafac67e$export$93ce39b765ea2cd3)({
                                viewportEntries: viewportEntries,
                                layoutShiftEntries: layoutShiftEntries,
                                time: time,
                                startTime: startTime
                            }),
                            layoutShiftEntriesCount: layoutShiftEntries.length,
                            layoutShiftImpact: viewportPercentage - previousViewportPercentage
                        };
                    }
                    percentileIndex++;
                }
                // Clear buffer after processing all matching percentiles
                entryDataBuffer.clear();
            } else // Only add to buffer if we haven't reached all percentiles
            entries.forEach((e)=>entryDataBuffer.add(e));
            previousViewportPercentage = viewportPercentage;
        }
        // Fill in any missing percentiles with the last known values
        let previousResult = {
            t: 0,
            e: []
        };
        for(let i = 0; i < percentiles.length; i++){
            const percentile = percentiles[i];
            if (!(percentile in vcDetails)) vcDetails[`${percentile}`] = previousResult;
            else previousResult = vcDetails[`${percentile}`];
        }
        let enhancedVcLogs = vcLogs ? vcLogs.map((log)=>({
                ...log,
                entries: log.entries.map((entry)=>({
                        ...entry,
                        rect: entry.rect?.toJSON(),
                        previousRect: entry.previousRect?.toJSON()
                    })),
                viewportPercentage: log.viewportPercentage
            })) : [];
        // If 3p metric enabled - calculate the debug details
        const shouldCalculate3p = include3p;
        // Only calculate enhanced debug details if devtool callbacks exist
        const shouldCalculateDebugDetails = !isPostInteraction && (typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window?.__on_ufo_vc_debug_data_ready === 'function' || typeof window?.__ufo_devtool_vc_3p_debug_data === 'function');
        if (shouldCalculateDebugDetails && allEntries && vcLogs) {
            // Pre-sort vcLogs by time for efficient lookups
            const sortedVcLogs = [
                ...vcLogs
            ].sort((a, b)=>a.time - b.time);
            // Pre-calculate max viewport percentage up to each time for efficient lookups
            const maxViewportPercentageAtTime = new Map();
            let maxSoFar = 0;
            for (const log of sortedVcLogs)if (log.viewportPercentage !== null) {
                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                maxViewportPercentageAtTime.set(log.time, maxSoFar);
            }
            // Helper function to find the biggest previous viewport percentage
            const getBiggestPreviousViewportPercentage = (targetTime)=>{
                // Binary search for the largest time <= targetTime
                let left = 0;
                let right = sortedVcLogs.length - 1;
                let result = -1;
                while(left <= right){
                    const mid = Math.floor((left + right) / 2);
                    if (sortedVcLogs[mid].time <= targetTime) {
                        result = mid;
                        left = mid + 1;
                    } else right = mid - 1;
                }
                return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
            };
            // Group ignored entries by timestamp
            const ignoredEntriesByTime = new Map();
            for (const entry of allEntries)if ('rect' in entry.data && !this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch)) {
                const viewportData = entry.data;
                const timestamp = Math.round(entry.time);
                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                ignoredEntriesByTime.get(timestamp)?.push({
                    ...viewportData,
                    rect: viewportData.rect?.toJSON(),
                    previousRect: viewportData.previousRect?.toJSON(),
                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                });
            }
            // Add ignored entries to vcLogs
            const additionalVcLogs = [];
            for (const [timestamp, ignoredEntries] of ignoredEntriesByTime)if (ignoredEntries.length > 0) {
                const viewportPercentage = getBiggestPreviousViewportPercentage(timestamp);
                additionalVcLogs.push({
                    time: timestamp,
                    viewportPercentage: viewportPercentage,
                    entries: ignoredEntries
                });
            }
            // Combine and sort all vcLogs
            enhancedVcLogs = [
                ...enhancedVcLogs,
                ...additionalVcLogs
            ].sort((a, b)=>a.time - b.time);
        }
        // Only create debug details if callbacks exist
        let v3RevisionDebugDetails = null;
        if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
            revision: this.revisionNo,
            isClean: isVCClean && !interactionAbortReason && isPageVisible,
            abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason ?? interactionAbortReason,
            vcLogs: enhancedVcLogs,
            interactionId: interactionId,
            interactionType: interactionType
        };
        // Handle devtool callback
        if (v3RevisionDebugDetails && typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' && !include3p) try {
            window?.__ufo_devtool_onVCRevisionReady__?.(v3RevisionDebugDetails);
        } catch (e) {
            // if any error communicating with devtool, we don't want to break the app
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && typeof window?.__on_ufo_vc_debug_data_ready === 'function' && !include3p) try {
            window?.__on_ufo_vc_debug_data_ready?.(v3RevisionDebugDetails);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && shouldCalculate3p) try {
            // Log vc details with 3p for debugging
            window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in 3pDebugData', e);
        }
        return {
            vcDetails: vcDetails,
            ssrRatio: ssrRatio,
            speedIndex: speedIndex,
            VC90layoutShiftInsights: layoutShiftInsights
        };
    }
    async calculate({ startTime: startTime, stopTime: stopTime, orderedEntries: orderedEntries, interactionId: interactionId, isPostInteraction: isPostInteraction, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, interactionType: interactionType, isPageVisible: isPageVisible, interactionAbortReason: interactionAbortReason, reportLayoutShiftOffenders: reportLayoutShiftOffenders }) {
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        });
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isVCClean) return {
            revision: this.revisionNo,
            'metric:vc90': null,
            clean: false,
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp
        };
        const { vcDetails: vcDetails, ssrRatio: ssrRatio, speedIndex: speedIndex, VC90layoutShiftInsights: VC90layoutShiftInsights } = await this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders);
        let layoutShiftInsightsPayload;
        if (VC90layoutShiftInsights !== null && reportLayoutShiftOffenders) {
            const { layoutShiftOffendersResult: layoutShiftOffendersResult, layoutShiftEntriesCount: layoutShiftEntriesCount, layoutShiftImpact: layoutShiftImpact } = VC90layoutShiftInsights;
            layoutShiftInsightsPayload = {
                impact: layoutShiftImpact,
                sources: layoutShiftEntriesCount ?? 0,
                same: {
                    dir: layoutShiftOffendersResult?.layoutShiftVariables.allMovedSameWay ?? false,
                    dist: layoutShiftOffendersResult?.layoutShiftVariables.allMovedSameAmount ?? false
                },
                total_mut: layoutShiftOffendersResult?.layoutShiftOffenders.length ?? 0,
                mut: layoutShiftOffendersResult?.layoutShiftOffenders.sort((a, b)=>Math.abs(a.distanceToLS) - Math.abs(b.distanceToLS)).slice(0, 5).map((offender)=>({
                        e: offender.offender,
                        size: -1,
                        // @todo: calculate size
                        attr: {
                            t_before: offender.happenedBefore,
                            t_distance: offender.distanceToLS,
                            p_above: offender.isAbove,
                            p_left: offender.isLeft,
                            p_right: offender.isRight,
                            p_h_overlap: offender.hasHorizontalOverlap,
                            p_v_overlap: offender.hasVerticalOverlap,
                            p_same_offset: offender.matchesLayoutShiftDelta ? 'all' : 'none'
                        }
                    }))
            };
        }
        const result = {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': vcDetails?.['90']?.t ?? null,
            vcDetails: vcDetails ?? undefined,
            'vc90:ls': layoutShiftInsightsPayload ?? undefined
        };
        result.ratios = this.calculateRatios(filteredEntries);
        if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
        // speedIndex is only included in the result when it has a meaningful value (> 0)
        if (speedIndex > 0) result.speedIndex = speedIndex;
        result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
        return result;
    }
    constructor(revisionNo){
        this.revisionNo = void 0;
        this.revisionNo = revisionNo;
    }
}


// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
const $aa0f0977a83f4b9d$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed',
    'data-aui-version',
    'data-testid',
    'data-vc',
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace',
    'data-vc-nvs',
    'data-media-vc-wrapper',
    'data-renderer-start-pos',
    'data-table-local-id',
    'spellcheck',
    'data-auto-scrollable',
    'id',
    'tabindex',
    'data-is-ttvc-ready',
    'contenteditable',
    'data-has-collab-initialised',
    'translate',
    'data-comment-id',
    'data-access-level'
];
const $aa0f0977a83f4b9d$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
const $aa0f0977a83f4b9d$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
const $aa0f0977a83f4b9d$export$2492353b2cc31cc0 = [
    'fdprocessedid',
    'data-dashlane-classification'
];
const $aa0f0977a83f4b9d$export$5a7b359ee5e32a5b = [
    // dark reader extension
    'data-darkreader-inline-bgcolor',
    'data-darkreader-inline-bgimage',
    'data-darkreader-inline-border',
    'data-darkreader-inline-border-bottom',
    'data-darkreader-inline-border-left',
    'data-darkreader-inline-border-right',
    'data-darkreader-inline-border-top',
    'data-darkreader-inline-boxshadow',
    'data-darkreader-inline-color',
    'data-darkreader-inline-fill',
    'data-darkreader-inline-stroke',
    'data-darkreader-inline-outline',
    'data-darkreader-inline-stopcolor',
    'data-darkreader-inline-bg',
    'data-darkreader-inline-border-short',
    'data-darkreader-inline-border-bottom-short',
    'data-darkreader-inline-border-left-short',
    'data-darkreader-inline-border-right-short',
    'data-darkreader-inline-border-top-short'
];



const $388cf5bdb92448ee$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $388cf5bdb92448ee$var$REVISION_NO = 'fy25.03';
const $388cf5bdb92448ee$var$getConsideredEntryTypes = (include3p, excludeSmartAnswersInSearch)=>{
    const entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // Only include third-party elements in TTVC calculation when explicitly requested.
    // GenAI elements intentionally remain excluded from core TTVC; a server-side metric variant
    // can derive "including GenAI" from the emitted metricWindows payload.
    if (include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if (!excludeSmartAnswersInSearch) {
        entryTypes.push('mutation:smart-answers-element');
        entryTypes.push('mutation:smart-answers-attribute');
    }
    entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
class $388cf5bdb92448ee$export$2e2bcd8739ae039 extends (0, $6d164c2ff0558a95$export$2e2bcd8739ae039) {
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        if (!$388cf5bdb92448ee$var$getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch).includes(entry.data.type)) return false;
        if (entry.data.type === 'mutation:attribute:framework-routing') return false;
        if (entry.data.type === 'mutation:media' && (0, $6oQI4.fg)('media-perf-uplift-mutation-fix')) {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, $fc4e94e8db3350dd$export$9db1624a8af791a4)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
            // special case for style attribute to ignore only anchor-name changes
            if ((0, $fc4e94e8db3350dd$export$9db1624a8af791a4)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                if ((0, $42226e2277fa3587$export$f83f33200c1a234e)({
                    attributeName: entryData.attributeName,
                    oldValue: entryData.oldValue,
                    newValue: entryData.newValue
                })) return false;
            }
        }
        if (entry.data.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || (0, $aa0f0977a83f4b9d$export$98812f4e79596e2b).includes(attributeName)) return false;
            if (attributeName.startsWith('data-test') || (0, $aa0f0977a83f4b9d$export$44331555a87fcd9e).includes(attributeName) || (0, $aa0f0977a83f4b9d$export$5a7b359ee5e32a5b).includes(attributeName) || (0, $aa0f0977a83f4b9d$export$2492353b2cc31cc0).includes(attributeName) && (0, $6oQI4.fg)('platform_ufo_exclude_fdprocessedid_attribute')) return false;
            return true;
        }
        if ((0, $060abdc7408e5559$export$2e2bcd8739ae039)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($388cf5bdb92448ee$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    constructor(revisionNo){
        super(revisionNo ?? $388cf5bdb92448ee$var$REVISION_NO);
    }
}



var $6oQI4 = parcelRequire("6oQI4");


const $2bfdc910e3c96a4e$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
const $2bfdc910e3c96a4e$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [
        'layout-shift:same-rect',
        'mutation:attribute:non-visual-input-name'
    ];
    return excludedEntryTypes;
};
const $2bfdc910e3c96a4e$var$fy26_04_excluded_attributes = [
    'data-is-hovered' // non-visual attribute
];
class $2bfdc910e3c96a4e$export$2e2bcd8739ae039 extends (0, $388cf5bdb92448ee$export$2e2bcd8739ae039) {
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const extra_fy26_04_excluded_attributes = [
            'data-fabric-mode'
        ];
        const entryData = entry.data;
        const { attributeName: attributeName } = entryData;
        if (entry.data.type === 'mutation:attribute' && attributeName && extra_fy26_04_excluded_attributes.includes(attributeName)) return false;
        const isEntryIncludedInV3 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV3 && !$2bfdc910e3c96a4e$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        if (entry.data.type === 'mutation:attribute' && (!attributeName || $2bfdc910e3c96a4e$var$fy26_04_excluded_attributes.includes(attributeName) && (0, $6oQI4.fg)('platform_ufo_data-is-hovered-v4-exclusion'))) return false;
        const thirdPartyAttributes = [
            ...(0, $aa0f0977a83f4b9d$export$c4351da6279bef53),
            ...(0, $aa0f0977a83f4b9d$export$5a7b359ee5e32a5b),
            ...(0, $6oQI4.fg)('platform_ufo_exclude_fdprocessedid_attribute') ? (0, $aa0f0977a83f4b9d$export$2492353b2cc31cc0) : []
        ];
        if (entryData.type === 'mutation:display-contents-children-attribute') {
            if (!attributeName || attributeName.startsWith('data-test') || (0, $aa0f0977a83f4b9d$export$98812f4e79596e2b).includes(attributeName) || (0, $aa0f0977a83f4b9d$export$44331555a87fcd9e).includes(attributeName) || thirdPartyAttributes.includes(attributeName)) return false;
            return true;
        }
        return $2bfdc910e3c96a4e$var$getConsideredEntryTypes().includes(entry.data.type);
    }
    constructor(revisionNo = 'fy26.04'){
        super(revisionNo);
    }
}





const $959fc081dcef2005$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize',
    'scroll-container'
];
const $959fc081dcef2005$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [];
    return consideredEntryTypes;
};
const $959fc081dcef2005$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [];
    return excludedEntryTypes;
};
class $959fc081dcef2005$export$2e2bcd8739ae039 extends (0, $2bfdc910e3c96a4e$export$2e2bcd8739ae039) {
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const isEntryIncludedInV4 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV4 && !$959fc081dcef2005$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        return $959fc081dcef2005$var$getConsideredEntryTypes().includes(entry.data.type);
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($959fc081dcef2005$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    if (eventType === 'keydown') dirtyReason = 'keypress';
                    else if (eventType === 'scroll-container') dirtyReason = 'scroll';
                    else dirtyReason = eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    constructor(){
        super('next');
    }
}






const $465646326ea289a4$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $465646326ea289a4$var$MAX_OBSERVATIONS = 200;
const $465646326ea289a4$var$encodeRect = (rect)=>[
        Math.round(rect.left * 10) / 10,
        Math.round(rect.top * 10) / 10,
        Math.round(rect.right * 10) / 10,
        Math.round(rect.bottom * 10) / 10
    ];
const $465646326ea289a4$var$areRectsEqual = (left, right)=>left.every((value, index)=>value === right[index]);
function $465646326ea289a4$var$isWindowEventEntryData(data) {
    return data.type === 'window:event' && 'eventType' in data;
}
class $465646326ea289a4$export$2e2bcd8739ae039 {
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($465646326ea289a4$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    async getRawData({ entries: entries, startTime: startTime, stopTime: stopTime, isPageVisible: isPageVisible }) {
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(entries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isPageVisible) return {
            revision: this.revisionNo,
            clean: false,
            'metric:vc90': null,
            abortReason: 'browser_backgrounded',
            abortTimestamp: (0, $862991da4a6032b9$export$754443ce7c615bd7)(startTime, stopTime) ?? -1,
            viewport: {
                w: (0, $198f583f16a03674$export$2e2bcd8739ae039)(),
                h: (0, $e2b4e09b71851474$export$2e2bcd8739ae039)()
            }
        };
        const viewportEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
        });
        const windowEventEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && $465646326ea289a4$var$isWindowEventEntryData(entry.data);
        });
        const targetNameToIdMap = new Map();
        const elementMapEntriesMap = {};
        let nextElementId = 1;
        const typeMap = new Map();
        const typeMapEntriesMap = {};
        let nextTypeId = 1;
        const attributeMap = new Map();
        const attributeEntriesMap = {};
        let nextAttributeId = 1;
        const eventTypeMap = new Map();
        const eventTypeMapEntriesMap = {};
        let nextEventTypeId = 1;
        const labelStacksMap = {};
        let rawObservations = viewportEntries.map((entry)=>{
            const viewportEntry = entry.data;
            const targetName = viewportEntry.elementName || '';
            const type = viewportEntry.type || '';
            const rect = viewportEntry.rect;
            const attributeName = viewportEntry.attributeName || '';
            let eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
            if (eid === 0) {
                eid = nextElementId;
                nextElementId += 1;
                targetNameToIdMap.set(targetName, eid);
                elementMapEntriesMap[eid] = targetName;
            }
            // Capture labelStacks per element (only stored once per unique element)
            if (viewportEntry.labelStacks && !(eid in labelStacksMap)) {
                const labelInfo = {
                    s: viewportEntry.labelStacks.segment,
                    l: viewportEntry.labelStacks.labelStack
                };
                const shouldCompactImplicitUnknown = labelInfo.s === 'unknown' && labelInfo.l === 'unknown';
                labelStacksMap[eid] = shouldCompactImplicitUnknown ? 'u' : labelInfo;
            }
            let chg = typeMap.get(type || '') || 0;
            if (chg === 0) {
                chg = nextTypeId;
                nextTypeId += 1;
                typeMap.set(type, chg);
                typeMapEntriesMap[chg] = type;
            }
            let att = 0;
            if (attributeName) {
                att = attributeMap.get(attributeName) || 0;
                if (att === 0) {
                    att = nextAttributeId;
                    nextAttributeId += 1;
                    attributeMap.set(attributeName, att);
                    attributeEntriesMap[att] = attributeName;
                }
            }
            const encodedRect = $465646326ea289a4$var$encodeRect(rect);
            const encodedPreviousRect = viewportEntry.previousRect ? $465646326ea289a4$var$encodeRect(viewportEntry.previousRect) : null;
            const shouldIncludePreviousRect = encodedPreviousRect === null || !$465646326ea289a4$var$areRectsEqual(encodedRect, encodedPreviousRect);
            const observation = {
                t: Math.round(entry.time - startTime),
                r: encodedRect,
                ...shouldIncludePreviousRect ? {
                    pr: encodedPreviousRect
                } : {},
                chg: chg,
                eid: eid || 0,
                ...att > 0 ? {
                    att: att
                } : {}
            };
            return observation;
        });
        let rawEventObservations = windowEventEntries.map((entry)=>{
            const windowEventEntry = entry.data;
            const eventType = windowEventEntry.eventType;
            let evtId = eventTypeMap.get(eventType) || 0;
            if (evtId === 0) {
                evtId = nextEventTypeId;
                nextEventTypeId += 1;
                eventTypeMap.set(eventType, evtId);
                eventTypeMapEntriesMap[evtId] = eventType;
            }
            let eventTargetId = 0;
            const eventTargetName = windowEventEntry.elementName || '';
            if (eventTargetName) {
                eventTargetId = targetNameToIdMap.get(eventTargetName) || 0;
                if (eventTargetId === 0) {
                    eventTargetId = nextElementId;
                    nextElementId += 1;
                    targetNameToIdMap.set(eventTargetName, eventTargetId);
                    elementMapEntriesMap[eventTargetId] = eventTargetName;
                }
            }
            const eventObservation = {
                t: Math.round(entry.time - startTime),
                evt: evtId,
                ...eventTargetId > 0 ? {
                    eid: eventTargetId
                } : {}
            };
            return eventObservation;
        });
        const shouldTrimEventObservations = rawEventObservations.length > $465646326ea289a4$var$MAX_OBSERVATIONS;
        const shouldTrimViewportObservations = rawObservations.length > $465646326ea289a4$var$MAX_OBSERVATIONS;
        // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
        // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
        if (shouldTrimEventObservations) {
            const firstEventObservation = rawEventObservations[0];
            const lastEventObservations = rawEventObservations.slice(-$465646326ea289a4$var$MAX_OBSERVATIONS);
            rawEventObservations = [
                firstEventObservation,
                ...lastEventObservations
            ];
        }
        // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
        // We do this by keeping the first observation, the SSR observation (if present), and the last MAX_OBSERVATIONS observations.
        if (shouldTrimViewportObservations) {
            const firstObservation = rawObservations[0];
            const lastObservations = rawObservations.slice(-$465646326ea289a4$var$MAX_OBSERVATIONS);
            // Find the SSR observation by looking up the eid that corresponds to 'SSR' element name
            const ssrEid = targetNameToIdMap.get('SSR');
            const ssrObservation = ssrEid ? rawObservations.find((obs)=>obs.eid === ssrEid && obs !== firstObservation) : undefined;
            // Include SSR observation if it exists and is not already in the kept observations
            const ssrAlreadyIncluded = ssrObservation && lastObservations.some((obs)=>obs === ssrObservation);
            rawObservations = [
                firstObservation,
                ...ssrObservation && !ssrAlreadyIncluded ? [
                    ssrObservation
                ] : [],
                ...lastObservations
            ];
        }
        if (shouldTrimViewportObservations || shouldTrimEventObservations) {
            // Collect referenced IDs from final retained observations. Keep this inside the trim
            // guard so the common untrimmed path avoids extra Set allocations and scans.
            const referencedEids = new Set();
            const referencedChgs = new Set();
            const referencedAtts = new Set();
            const referencedEvts = new Set();
            const referencedEventTargetEids = new Set();
            for (const observation of rawObservations){
                if (observation.eid > 0) referencedEids.add(observation.eid);
                if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
            }
            for (const observation of rawEventObservations){
                if (observation.evt > 0) referencedEvts.add(observation.evt);
                if (observation.eid !== undefined && observation.eid > 0) referencedEventTargetEids.add(observation.eid);
            }
            for (const eid of Object.keys(elementMapEntriesMap).map(Number))if (!referencedEids.has(eid) && !referencedEventTargetEids.has(eid)) {
                delete elementMapEntriesMap[eid];
                delete labelStacksMap[eid];
            }
            if (shouldTrimViewportObservations) {
                for (const chg of Object.keys(typeMapEntriesMap).map(Number))if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
                for (const att of Object.keys(attributeEntriesMap).map(Number))if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
            }
            if (shouldTrimEventObservations) {
                // Event type map cleanup is only needed when event observations were trimmed.
                // If only viewport observations were trimmed, all event observations remain and
                // therefore every event type ID in the map is still referenced.
                for (const evt of Object.keys(eventTypeMapEntriesMap).map(Number))if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
            }
        }
        // FedRAMP-Moderate scrubbing.
        //
        // In commercial environments the raw-handler payload includes:
        //   - `rawData.att` / `obs[].att`  → DOM attribute names from
        //     `MutationRecord.attributeName`. These are *names* (not values),
        //     but custom product attributes can in principle embed
        //     identifiers (e.g. `data-user-{id}-state`).
        //   - `rawData.lbl`                → UFO labelStacks. Generally
        //     curated product paths but in poorly-instrumented call sites
        //     could embed dynamic identifiers.
        //
        // Server-side TTVC reconstruction does not require these fields
        // (it is driven by timestamps, rectangles, and mutation kind),
        // so dropping them in FedRAMP is safe and removes residual PII risk.
        const isFedrampScrubbed = (0, $d0427bdd60d98885$export$1133b5e2873baa7a)();
        const scrubbedObservations = isFedrampScrubbed ? rawObservations.map(({ att: _att, ...rest })=>rest) : rawObservations;
        const result = {
            revision: this.revisionNo,
            clean: isVCClean,
            'metric:vc90': null,
            rawData: {
                obs: scrubbedObservations ?? undefined,
                eid: elementMapEntriesMap ?? undefined,
                chg: typeMapEntriesMap ?? undefined,
                att: isFedrampScrubbed ? undefined : attributeEntriesMap ?? undefined,
                evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined,
                lbl: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? labelStacksMap : undefined,
                lblMode: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? 'sentinel-v1' : undefined
            },
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp,
            viewport: {
                w: (0, $198f583f16a03674$export$2e2bcd8739ae039)(),
                h: (0, $e2b4e09b71851474$export$2e2bcd8739ae039)()
            }
        };
        return result;
    }
    constructor(){
        this.revisionNo = 'raw-handler';
    }
}



var $6oQI4 = parcelRequire("6oQI4");



/**
 * Attributes that Pragmatic Drag and Drop adds via `setAttribute` during its
 * post-paint registration step. They are used purely for hit testing and
 * registration bookkeeping, and do not affect layout, paint, or visible
 * styling, so they are safe to ignore for VC measurement.
 *
 * Drop target attributes follow `data-drop-target-for-<typeKey>` and are
 * handled by the prefix below (covers shipped and custom adapters).
 */ const $1d3b886527023598$export$bcd335ae574a0717 = new Set([
    // @atlaskit/pragmatic-drag-and-drop (core)
    'draggable',
    // Honey pot lives on a transient element; included for completeness.
    'data-pdnd-honey-pot',
    // @atlaskit/pragmatic-drag-and-drop-auto-scroll
    'data-auto-scrollable',
    // @atlaskit/pragmatic-drag-and-drop/react-beautiful-dnd-migration
    'data-rbd-draggable-droppable-id',
    'data-rbd-draggable-index',
    'data-rbd-droppable-type',
    'data-rbd-droppable-direction',
    'data-rbd-droppable-id',
    'data-rbd-droppable-context-id',
    'data-rbd-style-context-id'
]);
const $1d3b886527023598$export$846396c2d8be3710 = 'data-drop-target-for-';
function $1d3b886527023598$export$2e2bcd8739ae039({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (!attributeName) return false;
    if ($1d3b886527023598$export$bcd335ae574a0717.has(attributeName)) return true;
    if (attributeName.startsWith($1d3b886527023598$export$846396c2d8be3710)) return true;
    return false;
}



function $6b2ccda788b8fb3d$export$80d6b07c2266a1c6(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}


function $76e460ee1342b969$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $76e460ee1342b969$export$c3799d33e0ae80a5({ onEntry: onEntry, onObserved: onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement)) return;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, $6b2ccda788b8fb3d$export$80d6b07c2266a1c6)(entry.intersectionRect)) {
                const zeroDimensionRectangleTagCallback = (props)=>{
                    const tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute' && 'oldValue' in tagOrCallbackResult.mutationData) {
                        const { attributeName: attributeName, oldValue: oldValue, newValue: newValue } = tagOrCallbackResult.mutationData;
                        const isRoutingMutation = attributeName === 'style' && (!oldValue && newValue === 'display: none !important;' || oldValue === 'display: none !important;' && !newValue);
                        if (isRoutingMutation) return {
                            type: 'mutation:attribute:framework-routing',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return {
                            type: 'mutation:display-contents-children-attribute',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                    }
                    return tagOrCallbackResult;
                };
                for (const child of Array.from(entry.target.children)){
                    observer.observe(child);
                    callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                }
                return;
            }
            if (!$76e460ee1342b969$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved?.({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}



function $5c4e29a08742eced$var$createMutationObserver({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        const batchedMutations = new Map();
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if ((0, $fc4e94e8db3350dd$export$9db1624a8af791a4)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                // Currently being tested in Confluence
                // Skip elements with data-vc-oob attribute
                if (mut.target.dataset.vcOob) return;
            }
            if (mut.type === 'attributes') {
                /*
        	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
        	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
        	Conceptually there is after all a mutation: there is an old value replaced with a new one,
        	and whether or not they are the same doesn't really matter.
        	And Custom elements should work the same way as MutationObserver."
        	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
        */ const oldValue = mut.oldValue ?? undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown',
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: mut.timestamp || performance.now()
                });
                continue;
            } else if (mut.type === 'childList') {
                // In chromium browser MutationRecord has timestamp field, which we should use.
                const timestamp = Math.round(mut.timestamp || performance.now());
                // Get or create timestamp bucket
                let timestampBucket = batchedMutations.get(timestamp);
                if (!timestampBucket) {
                    timestampBucket = new Map();
                    batchedMutations.set(timestamp, timestampBucket);
                }
                // Get or create target batch within timestamp bucket
                let batch = timestampBucket.get(mut.target);
                if (!batch) {
                    batch = {
                        target: new WeakRef(mut.target),
                        addedNodes: [],
                        removedNodes: [],
                        timestamp: timestamp
                    };
                    timestampBucket.set(mut.target, batch);
                }
                // Accumulate added nodes
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                });
                // Accumulate removed nodes
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                });
            }
            targets.push(mut.target);
        }
        // Process all batched childList mutations
        for (const timestampBucket of batchedMutations.values())for (const batch of timestampBucket.values())onChildListMutation({
            target: batch.target,
            addedNodes: batch.addedNodes,
            removedNodes: batch.removedNodes,
            timestamp: batch.timestamp
        });
        onMutationFinished?.({
            targets: targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $5c4e29a08742eced$export$2e2bcd8739ae039 = $5c4e29a08742eced$var$createMutationObserver;


// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $398a3de2f60cf7de$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}


function $fcdb2dc45cee1a63$var$createPerformanceObserver({ onLayoutShift: onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift' && 'sources' in entry) {
            // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: (0, $398a3de2f60cf7de$export$5e3f54cad8cb65e2)(attr.currentRect),
                    previousRect: (0, $398a3de2f60cf7de$export$5e3f54cad8cb65e2)(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$fcdb2dc45cee1a63$export$2e2bcd8739ae039 = $fcdb2dc45cee1a63$var$createPerformanceObserver;



var $6oQI4 = parcelRequire("6oQI4");

const $f010f06df4112efa$export$2d67c094e7802413 = {
    callCount: 0
};


// Helper function to extract component name from fiber
function $0ae85a5e20573b96$export$2e2bcd8739ae039(fiber) {
    const type = fiber?.type;
    if (!type) return undefined;
    if (typeof type === 'function' || typeof type === 'object') return type.displayName || type.name;
    return undefined;
}


function $6b51aef318aafe05$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    const componentName = (0, $0ae85a5e20573b96$export$2e2bcd8739ae039)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $6b51aef318aafe05$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}



function $7b0274938bbe4909$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    (0, $f010f06df4112efa$export$2d67c094e7802413).callCount = 0;
    return resultCache;
}


// Helper function to find React fiber on an element
function $1f86a55c5adca7be$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(const key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}


function $1f427b67ca059def$export$2e2bcd8739ae039(element, maxLevel, checkedNodes, resultCache) {
    let currentElement = element;
    let remainingLevels = maxLevel;
    while(currentElement && remainingLevels > 0){
        const cachedResult = resultCache?.get(currentElement);
        if (cachedResult !== undefined) return {
            fiber: null,
            cachedResult: cachedResult
        };
        checkedNodes.push(currentElement);
        const fiber = (0, $1f86a55c5adca7be$export$2e2bcd8739ae039)(currentElement);
        if (fiber) return {
            fiber: fiber
        };
        currentElement = currentElement.parentElement;
        remainingLevels--;
    }
    return {
        fiber: null
    };
}


const $b91ad0dd12a0768c$var$OLD_DOM_WALK_MAX_LEVEL = 40;
const $b91ad0dd12a0768c$var$OLD_FIBER_WALK_MAX_LEVEL = 40;
const $b91ad0dd12a0768c$var$NEW_DOM_WALK_MAX_LEVEL = 400;
const $b91ad0dd12a0768c$var$NEW_FIBER_WALK_MAX_LEVEL = 400;
const $b91ad0dd12a0768c$var$CLEANUP_THRESHOLD = 50;
function $b91ad0dd12a0768c$var$maybeCleanup(resultCache) {
    (0, $f010f06df4112efa$export$2d67c094e7802413).callCount++;
    if ((0, $f010f06df4112efa$export$2d67c094e7802413).callCount >= $b91ad0dd12a0768c$var$CLEANUP_THRESHOLD && (0, $e652262e1c536287$export$2e2bcd8739ae039)(0.3)) (0, $7b0274938bbe4909$export$6a35c3789c327630)(resultCache);
}
function $b91ad0dd12a0768c$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $b91ad0dd12a0768c$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) return {
        isWithin: resultCache.get(node) ?? false
    };
    const checkedNodes = [];
    const shouldUseBumpedWalkLevels = (0, $6oQI4.fg)('ufo-bump-walk-levels');
    const DOM_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $b91ad0dd12a0768c$var$NEW_DOM_WALK_MAX_LEVEL : $b91ad0dd12a0768c$var$OLD_DOM_WALK_MAX_LEVEL;
    const FIBER_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $b91ad0dd12a0768c$var$NEW_FIBER_WALK_MAX_LEVEL : $b91ad0dd12a0768c$var$OLD_FIBER_WALK_MAX_LEVEL;
    // Always use cached fiber strategy to handle non-React elements reliably
    const { fiber: fiber, cachedResult: cachedResult } = (0, $1f427b67ca059def$export$2e2bcd8739ae039)(node, DOM_WALK_MAX_LEVEL, checkedNodes, shouldUseBumpedWalkLevels ? resultCache : undefined);
    if (cachedResult !== undefined) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, cachedResult);
        });
        return {
            isWithin: cachedResult
        };
    }
    if (!fiber) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    const isWithin = (0, $6b51aef318aafe05$export$2e2bcd8739ae039)(fiber, targetComponentName, FIBER_WALK_MAX_LEVEL);
    checkedNodes.forEach((checkedNode)=>{
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}



const $95970a834a60122e$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};


function $71327a3d9e8c17a9$export$16c2770458939f21(node) {
    const doc = (0, $95970a834a60122e$export$f65ca476c09acec0)();
    if (!doc) return false;
    const smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    // When the node is the smart answer element, .contains() still returns true
    return smartAnswersElement.contains(node);
}


function $cfef482cdaf14332$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch  {
        // there is no support for checkVisibility
        return true;
    }
}


/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $80108e0ea1cae78c$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $80108e0ea1cae78c$export$2e2bcd8739ae039(element.parentElement);
}


// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
function $361796c0f91bde61$export$80a5724ceedcfd3d({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    return target instanceof HTMLInputElement && attributeName === 'name' && (oldValue === '' || newValue === '');
}


const $9792b0e8d240932d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $9792b0e8d240932d$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $9792b0e8d240932d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $9792b0e8d240932d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $9792b0e8d240932d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $9792b0e8d240932d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}


const $cd2fcd0ff916cc90$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $cd2fcd0ff916cc90$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $cd2fcd0ff916cc90$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $cd2fcd0ff916cc90$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}


const $7d0cbf71016a12c4$var$createElementMutationsWatcher = (removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, $80108e0ea1cae78c$export$2e2bcd8739ae039)(target)) return 'mutation:remount';
        if ((0, $14277febf8941d0f$export$f61fbc3b9c4a9019)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        if (isWithinGenAISegment) return 'mutation:gen-ai-element';
        if (isWithinSmartAnswersSegment) return 'mutation:smart-answers-element';
        const isInIgnoreLsMarker = (0, $80108e0ea1cae78c$export$2e2bcd8739ae039)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        const isRLLPlaceholder = (0, $a2080f66a03331f7$export$166779fc0f49d4df).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        const wasDeleted = removedNodeRects.some((nr)=>(0, $9792b0e8d240932d$export$fde63bc968551821)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
const $7d0cbf71016a12c4$var$createElementMutationsWatcherNew = (removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
        }
        if (hasSameDeletedNode && (0, $80108e0ea1cae78c$export$2e2bcd8739ae039)(target)) return {
            type: 'mutation:remount',
            mutationData: {
                timestamp: timestamp
            }
        };
        if ((0, $14277febf8941d0f$export$f61fbc3b9c4a9019)(target)) return {
            type: 'mutation:media',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinThirdPartySegment) return {
            type: 'mutation:third-party-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinGenAISegment) return {
            type: 'mutation:gen-ai-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinSmartAnswersSegment) return {
            type: 'mutation:smart-answers-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isInIgnoreLsMarker = (0, $80108e0ea1cae78c$export$2e2bcd8739ae039)(target);
        if (!isInIgnoreLsMarker) return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isRLLPlaceholder = (0, $a2080f66a03331f7$export$166779fc0f49d4df).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return {
            type: 'mutation:rll-placeholder',
            mutationData: {
                timestamp: timestamp
            }
        };
        const wasDeleted = removedNodeRects.some((nr)=>(0, $9792b0e8d240932d$export$fde63bc968551821)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return {
            type: 'mutation:element-replacement',
            mutationData: {
                timestamp: timestamp
            }
        };
        return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
    };
class $7d0cbf71016a12c4$export$2e2bcd8739ae039 {
    initializeObservers() {
        if (this.isStarted) return;
        this.intersectionObserver = (0, $76e460ee1342b969$export$c3799d33e0ae80a5)({
            onEntry: this.handleIntersectionEntry
        });
        this.mutationObserver = (0, $5c4e29a08742eced$export$2e2bcd8739ae039)({
            onChildListMutation: this.handleChildListMutation,
            onAttributeMutation: this.handleAttributeMutation
        });
        this.performanceObserver = (0, $fcdb2dc45cee1a63$export$2e2bcd8739ae039)({
            onLayoutShift: this.handleLayoutShift
        });
    }
    start() {
        if (this.isStarted) return;
        this.initializeObservers();
        this.mutationObserver?.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        this.performanceObserver?.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore -error
            durationThreshold: 30
        });
        this.isStarted = true;
    }
    stop() {
        if (!this.isStarted) return;
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.performanceObserver?.disconnect();
        this.isStarted = false;
        // Clean up caches when stopping
        (0, $7b0274938bbe4909$export$6a35c3789c327630)(this.mapIs3pResult);
    }
    constructor({ onChange: onChange, getSSRState: getSSRState, getSSRPlaceholderHandler: getSSRPlaceholderHandler, trackLayoutShiftOffenders: trackLayoutShiftOffenders = false, searchPageConfig: searchPageConfig }){
        this.intersectionObserver = void 0;
        this.mutationObserver = void 0;
        this.performanceObserver = void 0;
        this.mapVisibleNodeRects = void 0;
        this.mapIs3pResult = void 0;
        this.mapIsGenAIResult = void 0;
        this.onChange = void 0;
        this.isStarted = void 0;
        this.trackLayoutShiftOffenders = void 0;
        this.searchPageConfig = void 0;
        // SSR context functions
        this.getSSRState = void 0;
        this.getSSRPlaceholderHandler = void 0;
        this.handleIntersectionEntry = ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
            if (!target) return;
            const visible = (0, $cfef482cdaf14332$export$e989c0fffaa6b27a)(target);
            const lastElementRect = this.mapVisibleNodeRects.get(target);
            this.mapVisibleNodeRects.set(target, rect);
            this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        };
        this.handleChildListMutation = async ({ target: target, addedNodes: addedNodes, removedNodes: removedNodes, timestamp: timestamp })=>{
            const removedNodeRects = removedNodes.map((ref)=>{
                const n = ref.deref();
                if (!n) return;
                return this.mapVisibleNodeRects.get(n);
            });
            const targetNode = target.deref();
            for (const addedNodeRef of addedNodes){
                const addedNode = addedNodeRef.deref();
                if (!addedNode) continue;
                const hasSameDeletedNode = removedNodes.find((ref)=>{
                    const n = ref.deref();
                    if (!n || !addedNode) return false;
                    return n.isEqualNode(addedNode);
                });
                const { isWithin: isWithinThirdPartySegment } = (0, $b91ad0dd12a0768c$export$2e2bcd8739ae039)(addedNode, 'UFOThirdPartySegment', this.mapIs3pResult);
                const { isWithin: isWithinGenAISegment } = (0, $b91ad0dd12a0768c$export$2e2bcd8739ae039)(addedNode, 'UFOGenAISegment', this.mapIsGenAIResult);
                const isWithinSmartAnswersSegment = Boolean(this.shouldCheckSmartAnswersMutations() && (0, $71327a3d9e8c17a9$export$16c2770458939f21)(addedNode));
                const isTargetReactRoot = targetNode === this.getSSRState?.()?.reactRootElement;
                this.intersectionObserver?.watchAndTag(addedNode, (this.trackLayoutShiftOffenders ? $7d0cbf71016a12c4$var$createElementMutationsWatcherNew : $7d0cbf71016a12c4$var$createElementMutationsWatcher)(removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, this.getSSRState, this.getSSRPlaceholderHandler));
            }
        };
        this.handleAttributeMutation = ({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue, timestamp: timestamp })=>{
            this.intersectionObserver?.watchAndTag(target, ({ target: target, rect: rect })=>{
                if ((0, $14277febf8941d0f$export$f61fbc3b9c4a9019)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const { isWithin: isWithinThirdPartySegment } = (0, $b91ad0dd12a0768c$export$2e2bcd8739ae039)(target, 'UFOThirdPartySegment', this.mapIs3pResult);
                const { isWithin: isWithinGenAISegment } = (0, $b91ad0dd12a0768c$export$2e2bcd8739ae039)(target, 'UFOGenAISegment', this.mapIsGenAIResult);
                if (isWithinThirdPartySegment) return {
                    type: 'mutation:third-party-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (isWithinGenAISegment) return {
                    type: 'mutation:gen-ai-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (this.shouldCheckSmartAnswersMutations() && (0, $71327a3d9e8c17a9$export$16c2770458939f21)(target)) return {
                    type: 'mutation:smart-answers-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $42226e2277fa3587$export$2e2bcd8739ae039)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $2d2125bd390ba546$export$2e2bcd8739ae039)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                // Pragmatic Drag and Drop attributes added during post-paint
                // registration; do not affect layout or paint.
                if ((0, $1d3b886527023598$export$2e2bcd8739ae039)({
                    target: target,
                    attributeName: attributeName
                }) && (0, $6oQI4.fg)('platform_ufo_exclude_pdnd_attributes_from_vc')) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $361796c0f91bde61$export$80a5724ceedcfd3d)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-input-name',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const isRLLPlaceholder = (0, $a2080f66a03331f7$export$166779fc0f49d4df).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $cd2fcd0ff916cc90$export$597b41700f7dcd36)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
            });
        };
        this.handleLayoutShift = ({ time: time, changedRects: changedRects })=>{
            for (const changedRect of changedRects){
                const target = changedRect.node;
                if (target) {
                    const isSameCurrentAndPreviousRects = (0, $9792b0e8d240932d$export$fde63bc968551821)(changedRect.rect, changedRect.previousRect);
                    this.onChange({
                        time: time,
                        elementRef: new WeakRef(target),
                        visible: true,
                        rect: changedRect.rect,
                        previousRect: changedRect.previousRect,
                        type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                    });
                }
            }
        };
        this.shouldCheckSmartAnswersMutations = ()=>{
            return this.searchPageConfig?.enableSmartAnswersMutations && this.searchPageConfig?.searchPageRoute && window?.location?.pathname && window.location.pathname === this.searchPageConfig.searchPageRoute;
        };
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.mapIsGenAIResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        this.trackLayoutShiftOffenders = trackLayoutShiftOffenders;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
        this.searchPageConfig = searchPageConfig;
    }
}



class $cbfe91ad231f3e0b$export$2e2bcd8739ae039 {
    bindEvent(type) {
        const unbindCallback = (0, $04ce8cf050459c71$exports.bind)(window, {
            type: type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    /**
   * Binds a scroll listener on `document` using the capture phase.
   * The `scroll` event does not bubble, so listening on `window` only catches
   * document-level scrolls. By using `{ capture: true }` on `document`, we can
   * detect scroll events from any element in the DOM tree, including inner
   * scrollable containers (e.g. when the user drags a scrollbar).
   */ bindCaptureScrollEvent() {
        const unbindCallback = (0, $04ce8cf050459c71$exports.bind)(document, {
            type: 'scroll',
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: 'scroll-container',
                    event: event
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
        this.bindCaptureScrollEvent();
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = void 0;
        this.onEvent = opts.onEvent;
    }
}


const $eadbf1e05f14d7c3$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
const $eadbf1e05f14d7c3$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
class $eadbf1e05f14d7c3$export$2e2bcd8739ae039 {
    start(_) {
        // Reset SSR state on start (matches old VCObserver behavior)
        this.ssr = {
            state: $eadbf1e05f14d7c3$var$SSRState.normal,
            reactRootElement: null,
            // Reset to null (matches old VCObserver)
            renderStart: -1,
            renderStop: -1
        };
        this.viewportObserver?.start();
        this.entriesTimeline.clear();
        if (window?.__SSR_ABORT_LISTENERS__) {
            const abortListeners = window.__SSR_ABORT_LISTENERS__;
            const aborts = abortListeners.aborts;
            if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                if (typeof time === 'number') this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: key
                    }
                });
            });
        }
        this.windowEventObserver?.start();
    }
    stop() {
        this.viewportObserver?.stop();
        this.windowEventObserver?.stop();
        // Clear SSR state on stop (matches old VCObserver behavior)
        this.ssr.reactRootElement = null;
    }
    // SSR related methods
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $eadbf1e05f14d7c3$var$SSRState.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    // Internal methods for ViewportObserver to access SSR state
    getSSRState() {
        return this.ssr;
    }
    getSSRPlaceholderHandler() {
        return this.ssrPlaceholderHandler;
    }
    addSSR(ssr) {
        this.entriesTimeline.push({
            time: ssr,
            data: {
                elementName: 'SSR',
                type: 'mutation:element',
                rect: {
                    height: (0, $e2b4e09b71851474$export$2e2bcd8739ae039)(),
                    width: (0, $198f583f16a03674$export$2e2bcd8739ae039)(),
                    left: 0,
                    top: 0,
                    x: 0,
                    y: 0,
                    bottom: (0, $e2b4e09b71851474$export$2e2bcd8739ae039)(),
                    right: (0, $198f583f16a03674$export$2e2bcd8739ae039)(),
                    toJSON () {
                        return null;
                    }
                },
                visible: true
            }
        });
    }
    async getVCResult(param) {
        const { start: start, stop: stop, interactionId: interactionId, interactionType: interactionType, interactionAbortReason: interactionAbortReason, isPageVisible: isPageVisible, include3p: include3p, includeSSRRatio: includeSSRRatio, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, rawDataStopTime: rawDataStopTime } = param;
        const results = [];
        this.addStartEntry(start);
        const feVCCalculationStartTime = performance.now();
        const calculator_fy25_03 = new (0, $388cf5bdb92448ee$export$2e2bcd8739ae039)();
        if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        const fy25_03 = (0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('fy25.03') ? await calculator_fy25_03.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        }) : null;
        if (fy25_03) results.push(fy25_03);
        // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
        if (param.ssr) this.addSSR(param.ssr);
        const calculator_fy26_04 = new (0, $2bfdc910e3c96a4e$export$2e2bcd8739ae039)();
        const calculator_next = new (0, $959fc081dcef2005$export$2e2bcd8739ae039)();
        const calculatorParams = {
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        };
        const isFy2604Enabled = (0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('fy26.04');
        const [fy26_04, vcNext] = await Promise.all([
            isFy2604Enabled ? calculator_fy26_04.calculate(calculatorParams) : null,
            (0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('next') ? calculator_next.calculate(calculatorParams) : null
        ]);
        if (fy26_04) results.push(fy26_04);
        if (vcNext) results.push(vcNext);
        const feVCCalculationEndTime = performance.now();
        // Always include raw data so the server can recalculate metrics
        // (ssrRatio, labelStacks, speedIndex) from raw observations.
        const rawVCCalculationStartTime = performance.now();
        const rawHandler = new (0, $465646326ea289a4$export$2e2bcd8739ae039)();
        // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
        const rawStopTime = rawDataStopTime ?? stop;
        const rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: rawStopTime
        }) : orderedEntries;
        const raw = await rawHandler.getRawData({
            entries: rawOrderedEntries,
            startTime: start,
            stopTime: rawStopTime,
            isPageVisible: isPageVisible
        });
        results.forEach((result)=>{
            delete result.vcDetails;
            delete result.ratios;
        });
        if (raw) {
            raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
            raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
            results.push(raw);
        }
        return results;
    }
    addStartEntry(startTime) {
        this.entriesTimeline.push({
            time: startTime,
            data: {
                type: 'mutation:element',
                elementName: 'START',
                visible: true,
                rect: {
                    x: 0,
                    y: 0,
                    width: window.innerWidth,
                    height: window.innerHeight,
                    top: 0,
                    left: 0,
                    bottom: window.innerHeight,
                    right: window.innerWidth,
                    toJSON: function() {
                        return {
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                            top: this.top,
                            left: this.left,
                            bottom: this.bottom,
                            right: this.right
                        };
                    }
                }
            }
        });
    }
    getElementName(element) {
        return (0, $e80f24cd58367ae7$export$2e2bcd8739ae039)(this.selectorConfig, element);
    }
    constructor(config){
        this.selectorConfig = void 0;
        this.viewportObserver = null;
        this.windowEventObserver = null;
        this.entriesTimeline = void 0;
        this.isPostInteraction = void 0;
        this.trackLayoutShiftOffenders = void 0;
        // SSR related properties
        this.ssrPlaceholderHandler = null;
        this.ssr = {
            state: $eadbf1e05f14d7c3$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.entriesTimeline = new (0, $b00520024666479c$export$2e2bcd8739ae039)();
        this.isPostInteraction = config.isPostInteraction ?? false;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It applies the FedRAMP all-`false` override when
        // `isFedrampModerate()` is true; otherwise it returns `caller-override
        // → setUFOConfig value → historical default`.
        this.selectorConfig = (0, $d0427bdd60d98885$export$59e1f072477dfb48)(config.selectorConfig, $eadbf1e05f14d7c3$var$DEFAULT_SELECTOR_CONFIG) ?? config.selectorConfig ?? $eadbf1e05f14d7c3$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $58e60c4d354c2851$export$c0102f1a1198d10f)({
            enablePageLayoutPlaceholder: config.SSRConfig?.enablePageLayoutPlaceholder ?? false
        });
        this.trackLayoutShiftOffenders = config.trackLayoutShiftOffenders ?? false;
        this.viewportObserver = new (0, $7d0cbf71016a12c4$export$2e2bcd8739ae039)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                const data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData?.attributeName,
                    oldValue: mutationData?.oldValue,
                    newValue: mutationData?.newValue,
                    originalMutationTimestamp: mutationData?.timestamp
                };
                if (element) {
                    const labelStacks = $eadbf1e05f14d7c3$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: ()=>this.getSSRState(),
            getSSRPlaceholderHandler: ()=>this.getSSRPlaceholderHandler(),
            searchPageConfig: config.searchPageConfig,
            trackLayoutShiftOffenders: this.trackLayoutShiftOffenders
        });
        this.windowEventObserver = new (0, $cbfe91ad231f3e0b$export$2e2bcd8739ae039)({
            onEvent: ({ time: time, type: type, event: event })=>{
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === 'keydown' && (0, $6oQI4.fg)('platform_ufo_keypress_interaction_abort')) {
                    const interaction = (0, $fa77cab6e7101561$export$2b3954d2e8509985)();
                    if (interaction?.type === 'press') return;
                }
                const abortEventTargetElement = $eadbf1e05f14d7c3$var$isAbortEventTargetSupported(type) && event ? $eadbf1e05f14d7c3$var$getAbortEventTargetElement(event.target) : null;
                const elementName = abortEventTargetElement ? this.getElementName(abortEventTargetElement) : undefined;
                this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type,
                        ...elementName ? {
                            elementName: elementName
                        } : {}
                    }
                });
            }
        });
    }
}
function $eadbf1e05f14d7c3$var$labelStackFromFiber(fiber) {
    const value = fiber?.child?.memoizedProps?.value;
    return Array.isArray(value?.labelStack) ? value.labelStack : [];
}
function $eadbf1e05f14d7c3$var$labelStackToString(labelStack) {
    return labelStack.map((label)=>(0, $71b607808958af03$export$3535cd9da4961282)(label.name)).join('/');
}
function $eadbf1e05f14d7c3$var$labelStackToSegment(labelStack) {
    let segmentIndex = -1;
    for(let i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map((label)=>(0, $71b607808958af03$export$3535cd9da4961282)(label.name)).join('/');
}
function $eadbf1e05f14d7c3$var$traverseFiber(fiber) {
    let segment = 'unknown';
    let labelStackString = 'unknown';
    let currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            const componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                const labelStack = $eadbf1e05f14d7c3$var$labelStackFromFiber(currentFiber);
                labelStackString = $eadbf1e05f14d7c3$var$labelStackToString(labelStack) || 'unknown';
                segment = $eadbf1e05f14d7c3$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $eadbf1e05f14d7c3$var$getLabelStacks(element) {
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (!reactFiberKey) return null;
    const fiber = element[reactFiberKey];
    return fiber ? $eadbf1e05f14d7c3$var$traverseFiber(fiber) : null;
}
const $eadbf1e05f14d7c3$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES = new Set([
    'scroll-container',
    'scroll',
    'wheel'
]);
function $eadbf1e05f14d7c3$var$isAbortEventTargetSupported(type) {
    return $eadbf1e05f14d7c3$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES.has(type);
}
function $eadbf1e05f14d7c3$var$getAbortEventTargetElement(target) {
    if (target instanceof HTMLElement) return target;
    if (target instanceof Document) {
        const scrollingElement = target.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.documentElement ?? null;
    }
    if (target instanceof Window) {
        const scrollingElement = target.document.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.document.documentElement ?? null;
    }
    if (target instanceof Node) return target.parentElement;
    return null;
}




class $013b957a82c34ab6$export$4a1fe1ab3c13bbf5 {
    // Helper method to process SSR abort listeners
    processSsrAbortListeners() {
        // Process any SSR abort listeners that remain
        if (window?.__SSR_ABORT_LISTENERS__) {
            // Clean up any event listeners that may have been registered during SSR
            // This is centralized here so only the wrapper handles unbinding, not individual observers
            if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach((unbind)=>{
                if (typeof unbind === 'function') unbind();
            });
            // After all observers had a chance to process abort events,
            // we can safely delete the SSR_ABORT_LISTENERS object
            delete window.__SSR_ABORT_LISTENERS__;
        }
    }
    start({ startTime: startTime, experienceKey: experienceKey }) {
        if ((0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('fy25.01', experienceKey) || (0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('fy25.02', experienceKey)) this.oldVCObserver?.start({
            startTime: startTime
        });
        this.newVCObserver?.start({
            startTime: startTime
        });
        // Clean up any remaining SSR abort listeners after all observers have been started
        this.processSsrAbortListeners();
    }
    stop(experienceKey) {
        if ((0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('fy25.01', experienceKey) || (0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('fy25.02', experienceKey)) this.oldVCObserver?.stop();
        this.newVCObserver?.stop();
        (0, $a2080f66a03331f7$export$166779fc0f49d4df).getInstance().reset();
        // Clear shared SSR placeholder handler
        this.ssrPlaceholderHandler.clear();
    }
    getVCRawData() {
        return this.oldVCObserver?.getVCRawData() ?? null;
    }
    async getVCResult(param) {
        const { experienceKey: experienceKey, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, includeRawData: includeRawData } = param;
        const v1v2Result = (0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('fy25.01', experienceKey) || (0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('fy25.02', experienceKey) ? await this.oldVCObserver?.getVCResult(param) : {};
        const v3v4Result = await this.newVCObserver?.getVCResult({
            start: param.start,
            stop: param.stop,
            interactionId: param.interactionId,
            ssr: param.ssr,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            interactionType: param.interactionType,
            isPageVisible: param.isPageVisible,
            interactionAbortReason: param.interactionAbortReason,
            includeRawData: includeRawData,
            includeSSRInV3: param.includeSSRInV3,
            rawDataStopTime: param.rawDataStopTime,
            reportLayoutShiftOffenders: param.reportLayoutShiftOffenders
        });
        if (!v3v4Result || v3v4Result.length === 0) return v1v2Result ?? {};
        const ssrRatio = v3v4Result?.[0]?.ssrRatio;
        return {
            ...includeSSRRatio && ssrRatio !== undefined ? {
                'ufo:vc:ssrRatio': ssrRatio
            } : {},
            ...v1v2Result,
            'ufo:vc:rev': [
                ...v1v2Result?.['ufo:vc:rev'] ?? [],
                ...v3v4Result ?? []
            ]
        };
    }
    setSSRElement(element) {
        this.oldVCObserver?.setSSRElement(element);
        this.newVCObserver?.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime) {
        this.oldVCObserver?.setReactRootRenderStart(startTime || performance.now());
        this.newVCObserver?.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        this.oldVCObserver?.setReactRootRenderStop(stopTime || performance.now());
        this.newVCObserver?.setReactRootRenderStop(stopTime || performance.now());
    }
    collectSSRPlaceholders() {
        this.ssrPlaceholderHandler.collectExistingPlaceholders();
    }
    constructor(opts = {}){
        this.oldVCObserver = void 0;
        this.newVCObserver = void 0;
        this.ssrPlaceholderHandler = void 0;
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $58e60c4d354c2851$export$c0102f1a1198d10f)({
            enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
        });
        this.newVCObserver = new (0, $eadbf1e05f14d7c3$export$2e2bcd8739ae039)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler,
            trackLayoutShiftOffenders: opts.trackLayoutShiftOffenders ?? false,
            searchPageConfig: opts.searchPageConfig
        });
        if ((0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('fy25.01') || (0, $d0427bdd60d98885$export$4babcefc81a3ef0b)('fy25.02')) this.oldVCObserver = new (0, $0b934ca4495e12d5$export$1f70d263701b1d01)({
            ...opts,
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        });
    }
}


function $2c44bc2215643fd1$export$c69731bddfc24d85(opts = {}) {
    const shouldMockVCObserver = !(0, $de6d41de60f61fb8$export$68d57b133e88584d)();
    const observer = shouldMockVCObserver ? new (0, $d3191430a81dac65$export$24d07287b49da906)() : new (0, $013b957a82c34ab6$export$4a1fe1ab3c13bbf5)(opts);
    return observer;
}


const $deff72440153d7ae$export$cc97b17ef9aeb088 = new Map();





const $370eeda9fb4fdd3d$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $370eeda9fb4fdd3d$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $013b957a82c34ab6$export$4a1fe1ab3c13bbf5)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        this.vcObserver?.stop();
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
   * Set the VC result as per the last interaction
   * Used to compare diffs of VC updates vs post interaction VC observer
   * @param result - VC result as calculated by UFO create payload
   */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
   * Set the fn that would be invoked to process / send the observation data
   */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
   * Reset state of the log
   */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        this.holdInfo = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
   * Check if there is data in the log
   */ hasData() {
        return this.reactProfilerTimings?.length > 0;
    }
    /**
   * Send the log if there is data
   */ async sendPostInteractionLog() {
        if (!this.lastInteractionFinish || !this.sinkHandlerFn) {
            this.reset();
            this.vcObserver?.stop();
            return;
        }
        const pageVisibilityState = (0, $862991da4a6032b9$export$768b2008623433e1)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
        const isPageVisible = pageVisibilityState === 'visible';
        const config = (0, $d0427bdd60d98885$export$44487a86467333c3)();
        const postInteractionFinishVCResult = await this.vcObserver?.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            // no need for TTI value here
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            experienceKey: this.lastInteractionFinish.ufoName,
            interactionId: this.lastInteractionFinish.id,
            includeSSRInV3: config?.vc?.includeSSRInV3,
            includeSSRRatio: config?.vc?.includeSSRRatio,
            ...this.vcObserverSSRConfig,
            interactionType: this.lastInteractionFinish.type,
            isPageVisible: isPageVisible,
            interactionAbortReason: this.lastInteractionFinish.abortReason
        });
        this.vcObserver?.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
            postInteractionHoldInfo: this.holdInfo
        });
        this.reset();
    }
    /**
   * This fn should be invoked when an interaction has finished
   * Basic details about the finished interaction will be recorded
   * A timeout will be setup to send the post interaction observation after some time.
   */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, errors: errors }) {
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            errors: errors
        };
        const timeout = (0, $d0427bdd60d98885$export$44487a86467333c3)()?.timeWindowForLateMutationsInMilliseconds || $370eeda9fb4fdd3d$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
   * This fn should be invoked when a React render happens after interaction has finished
   */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    addHoldInfo(labelStack, name, start) {
        this.holdInfo.push({
            name: name,
            labelStack: labelStack,
            start: start
        });
    }
    constructor(){
        /**
     * Basic info about interaction that has just finished
     */ this.lastInteractionFinish = null;
        /**
     * Array of observed react render timings
     */ this.reactProfilerTimings = [];
        /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */ this.sinkTimeoutId = null;
        this.holdInfo = [];
        /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        this.lastInteractionFinishVCResult = void 0;
        /**
     * Handler function to process / send the observation data
     */ this.sinkHandlerFn = ()=>{};
    }
}


const $fa77cab6e7101561$export$dbba6cdedab4e68b = {
    id: undefined,
    name: undefined,
    type: undefined,
    isAborted: undefined,
    timestamp: undefined
};
const $fa77cab6e7101561$export$d8f52e8f804021e8 = new (0, $370eeda9fb4fdd3d$export$2e2bcd8739ae039)();
const $fa77cab6e7101561$var$interactionQueue = [];
const $fa77cab6e7101561$var$segmentCache = new Map();
const $fa77cab6e7101561$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
const $fa77cab6e7101561$var$segmentObservers = [];
function $fa77cab6e7101561$export$2b3954d2e8509985() {
    const interactionId = (0, $6385281f5ef7c8dd$export$37bca3107733ac1e)();
    if (!interactionId.current) return;
    return (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId.current);
}
function $fa77cab6e7101561$var$isPerformanceTracingEnabled() {
    return (0, $d0427bdd60d98885$export$44487a86467333c3)()?.enableAdditionalPerformanceMarks || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let $fa77cab6e7101561$var$performanceEventObserver;
const $fa77cab6e7101561$export$17afbba0f16b4b19 = ()=>{
    $fa77cab6e7101561$var$performanceEventObserver = $fa77cab6e7101561$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $fa77cab6e7101561$export$e6be05b411ce21a6(entry);
    });
    return $fa77cab6e7101561$var$performanceEventObserver;
};
const $fa77cab6e7101561$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = $fa77cab6e7101561$export$2b3954d2e8509985();
    if (interaction?.type === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $fa77cab6e7101561$var$labelStackToString(labelStack, name) {
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return stack.map((l)=>l.name)?.join('/');
}
function $fa77cab6e7101561$var$labelStackToIdString(labelStack) {
    return labelStack?.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)?.join('/');
}
function $fa77cab6e7101561$var$addSegmentObserver(observer) {
    $fa77cab6e7101561$var$segmentObservers.push(observer);
    for (const segmentInfo of $fa77cab6e7101561$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $fa77cab6e7101561$var$removeSegmentObserver(observer) {
    const index = $fa77cab6e7101561$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $fa77cab6e7101561$var$segmentObservers.splice(index, 1);
}
function $fa77cab6e7101561$export$cd7f480d6b8286c3(interactionId) {
    (0, $deff72440153d7ae$export$cc97b17ef9aeb088).delete(interactionId);
}
function $fa77cab6e7101561$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $fa77cab6e7101561$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $fa77cab6e7101561$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $fa77cab6e7101561$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $fa77cab6e7101561$export$9bfdf89f35702b2e(interactionId, segmentId, data) {
    var _interaction;
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) ((_interaction = interaction).excluded3pSegmentData ?? (_interaction.excluded3pSegmentData = {}))[segmentId] = {
        segmentId: segmentId,
        ...interaction.excluded3pSegmentData[segmentId],
        ...data
    };
}
function $fa77cab6e7101561$export$35723c3772fda7dd(interactionId, segmentId, data) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        if (!interaction.segmentExtraData) interaction.segmentExtraData = {};
        interaction.segmentExtraData[segmentId] = {
            ...interaction.segmentExtraData[segmentId],
            ...data
        };
    }
}
/**
 * Builds a stable cross-segment dedup key for a segment3pTimings entry.
 *
 * For `resource-timing`, query-stripped backend labels + timing fields identify a request without
 * depending on query parameters. Shared CSS/JS asset timings dedupe across segments, but backend
 * fetch/XHR entries are scoped by `segmentId` because each iframe can make its own backend request
 * to the same URL.
 *
 * For all other labels the data objects are small (a handful of fields), so we use a full
 * JSON fingerprint which is cheap and collision-free.
 */ function $fa77cab6e7101561$var$buildCrossSegmentDedupKey(entry, segmentId) {
    if (entry.label === 'resource-timing') {
        const { label: resourceLabel, startTime: startTime, duration: duration, requestStart: requestStart, fetchStart: fetchStart, ttfb: ttfb, type: type } = entry.data;
        if ((0, $cb202f74b57749f2$export$c3b002e13fbb9ef2).has(String(type))) // Backend calls are separate requests per segment; include extra timings and segment scope.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}|${fetchStart}|${requestStart}|${ttfb}|${segmentId}`;
        // Shared CSS/JS assets keep the original B3 key so they can dedupe across segments.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}`;
    }
    return `${entry.label}|${JSON.stringify(entry.data)}`;
}
function $fa77cab6e7101561$export$c227d812a1e08d80(interactionId, segmentId, entry) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        // B3: dedup by content — drops identical entries within and across iframes.
        // Abort markers are excluded so every segment's abort is recorded.
        if (entry.label !== 'segment-timing-abort') {
            if (!interaction.segment3pCrossSegmentSeen) interaction.segment3pCrossSegmentSeen = new Set();
            const key = $fa77cab6e7101561$var$buildCrossSegmentDedupKey(entry, segmentId);
            if (interaction.segment3pCrossSegmentSeen.has(key)) return;
            interaction.segment3pCrossSegmentSeen.add(key);
        }
        if (!interaction.segment3pTimings) interaction.segment3pTimings = {};
        if (!interaction.segment3pTimings[segmentId]) interaction.segment3pTimings[segmentId] = [];
        interaction.segment3pTimings[segmentId].push(entry);
    }
}
function $fa77cab6e7101561$export$20265b12c6625451(interactionId, key, value) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $fa77cab6e7101561$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const sanitizedData = Object.fromEntries(Object.entries(data).map(([key, timingData])=>[
                (0, $ee361b69170cd5c9$export$23e69abaca7d0236)(key),
                timingData
            ]));
        interaction.customTimings.push({
            labelStack: labelStack,
            data: sanitizedData
        });
        if ($fa77cab6e7101561$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(sanitizedData)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$fa77cab6e7101561$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
function $fa77cab6e7101561$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($fa77cab6e7101561$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$fa77cab6e7101561$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $fa77cab6e7101561$export$85d1eb835f669bf(_interactionId, _labelStack, _time) {}
function $fa77cab6e7101561$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $deff72440153d7ae$export$cc97b17ef9aeb088).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($fa77cab6e7101561$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$fa77cab6e7101561$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $fa77cab6e7101561$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($fa77cab6e7101561$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$fa77cab6e7101561$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
}
function $fa77cab6e7101561$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $deff72440153d7ae$export$cc97b17ef9aeb088).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($fa77cab6e7101561$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$fa77cab6e7101561$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch  {
    // do nothing
    }
}
function $fa77cab6e7101561$export$9e04fe1a58571ec(moduleId, timestamp) {
    $fa77cab6e7101561$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $fa77cab6e7101561$export$6f228d1fdc911d7(identifier, start, end) {
    $fa77cab6e7101561$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $fa77cab6e7101561$var$moduleLoadingRequests = {};
function $fa77cab6e7101561$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $fa77cab6e7101561$var$addHoldCriterion(id, labelStack, name, startTime) {
    if (!window.__CRITERION__?.addUFOHold) return;
    window.__CRITERION__.addUFOHold(id, $fa77cab6e7101561$var$labelStackToString(labelStack), name, startTime);
}
function $fa77cab6e7101561$var$removeHoldCriterion(id) {
    if (!window.__CRITERION__?.removeUFOHold) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $fa77cab6e7101561$export$7606887303596f82(interactionId, labelStack, name, _experimental, holdStartedAt) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $b9a40c449374f876$exports.v4)();
    if (!interaction) // add hold timestamp to post interaction log if interaction is complete
    $fa77cab6e7101561$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, holdStartedAt ?? performance.now());
    if (interaction != null) {
        const start = holdStartedAt ?? performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ($fa77cab6e7101561$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $fa77cab6e7101561$var$ensureExtendedHoldActive(interaction).set(id, {
            ...holdActive,
            start: start
        });
        else {
            interaction.holdActive.set(id, {
                ...holdActive,
                start: start
            });
            $fa77cab6e7101561$var$addHoldCriterion(id, labelStack, name, start);
        }
        return ()=>{
            const end = performance.now();
            if ($fa77cab6e7101561$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$fa77cab6e7101561$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
            $fa77cab6e7101561$var$removeHoldCriterion(id);
            const currentInteraction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (interaction.hold3pActive) {
                    const current3pHold = interaction.hold3pActive.get(id);
                    if (current3pHold != null) {
                        $fa77cab6e7101561$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                        if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                        currentInteraction.hold3pInfo.push({
                            ...current3pHold,
                            end: end
                        });
                        interaction.hold3pActive.delete(id);
                    }
                }
            }
        };
    }
    return ()=>{};
}
function $fa77cab6e7101561$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        };
        if ($fa77cab6e7101561$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $fa77cab6e7101561$var$ensureExtendedHoldActive(interaction).set(id, holdActive);
        else {
            interaction.holdActive.set(id, holdActive);
            $fa77cab6e7101561$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return ()=>{};
}
function $fa77cab6e7101561$export$d6cf9650acfb0dab(interactionId, labelStack, name, start, end) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        // `recordMetricVariantCategoryEnd` skips excluded (background-script) holds, so the completed
        // hold is retained in `hold3pInfo` for observability but never contributes a third-party
        // category end.
        $fa77cab6e7101561$var$recordMetricVariantCategoryEnd(interaction, labelStack, end);
        $fa77cab6e7101561$var$ensureExtendedHoldInfo(interaction).push({
            labelStack: labelStack,
            name: name,
            start: start,
            end: end
        });
    }
}
function $fa77cab6e7101561$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            if ($fa77cab6e7101561$var$shouldMoveHoldToExtendedBucket(currentInteraction, currentHold)) $fa77cab6e7101561$var$ensureExtendedHoldInfo(currentInteraction).push({
                ...currentHold,
                end: end
            });
            else currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $fa77cab6e7101561$var$removeHoldCriterion(id);
        }
        if (interaction.hold3pActive) {
            const current3pHold = interaction.hold3pActive.get(id);
            if (currentInteraction != null && current3pHold != null) {
                $fa77cab6e7101561$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                currentInteraction.hold3pInfo.push({
                    ...current3pHold,
                    end: end
                });
                interaction.hold3pActive.delete(id);
            }
        }
    }
}
function $fa77cab6e7101561$export$2df109852219d16e(interactionId) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
function $fa77cab6e7101561$export$b1ce94abc72c69d7(interactionId, info) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction == null) return ()=>{};
    const preloadRow = {
        source: info.source,
        preloadStartedAt: info.preloadStartedAt,
        adoptedAt: info.adoptedAt
    };
    interaction.preloadInfo.push(preloadRow);
    const releaseHold = $fa77cab6e7101561$export$7606887303596f82(interactionId, [], `preload:${info.source}`, false, interaction.start);
    let released = false;
    return ()=>{
        if (released) return;
        released = true;
        preloadRow.settledAt = performance.now();
        releaseHold();
    };
}
function $fa77cab6e7101561$export$43f87b52eb8fc449(args) {
    const interaction = $fa77cab6e7101561$export$2b3954d2e8509985();
    if (interaction == null || interaction.ufoName !== args.experienceKey || args.preloadKey !== undefined && interaction.preloadKey !== undefined && interaction.preloadKey !== args.preloadKey) return null;
    return $fa77cab6e7101561$export$b1ce94abc72c69d7(interaction.id, {
        source: args.source,
        preloadStartedAt: args.preloadStartedAt,
        adoptedAt: args.adoptedAt
    });
}
let $fa77cab6e7101561$var$onInteractionStartForPreloadHolds = null;
function $fa77cab6e7101561$export$e96f751b1e82abda(hook) {
    $fa77cab6e7101561$var$onInteractionStartForPreloadHolds = hook;
}
const $fa77cab6e7101561$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $fa77cab6e7101561$export$9e04fe1a58571ec($fa77cab6e7101561$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $fa77cab6e7101561$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $fa77cab6e7101561$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $fa77cab6e7101561$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $fa77cab6e7101561$var$moduleLoadingRequests[info.identifier];
            $fa77cab6e7101561$export$6f228d1fdc911d7($fa77cab6e7101561$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $6385281f5ef7c8dd$export$37bca3107733ac1e)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $fa77cab6e7101561$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $6385281f5ef7c8dd$export$37bca3107733ac1e)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $fa77cab6e7101561$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $fa77cab6e7101561$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $fa77cab6e7101561$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $deff72440153d7ae$export$cc97b17ef9aeb088).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $fa77cab6e7101561$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    if ($fa77cab6e7101561$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$fa77cab6e7101561$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch  {
    // do nothing
    }
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((0, $d0427bdd60d98885$export$44487a86467333c3)()?.postInteractionLog?.enabled) $fa77cab6e7101561$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $fa77cab6e7101561$var$pushToQueue(id, data) {
    $fa77cab6e7101561$var$interactionQueue.push({
        id: id,
        data: data
    });
}
let $fa77cab6e7101561$var$handleInteraction = $fa77cab6e7101561$var$pushToQueue;
const $fa77cab6e7101561$var$isKnownMetricVariantCategory = (type)=>type === 'third-party' || type === 'gen-ai';
const $fa77cab6e7101561$var$hasMetricVariantCategory = (labelStack, category)=>labelStack?.some((label)=>'type' in label && label.type === category) ?? false;
const $fa77cab6e7101561$var$hasAnyMetricVariantCategory = (labelStack)=>labelStack?.some((label)=>'type' in label && $fa77cab6e7101561$var$isKnownMetricVariantCategory(label.type)) ?? false;
/**
 * A hold is fully excluded from every metric window (standard and include-third-party) and from
 * completion gating iff its labelStack contains a single label that is BOTH `type: 'third-party'`
 * AND `excludeFromMetrics: true`. Requiring both on the same label guarantees exclusion can only
 * ever apply to third-party work, never first-party. Such holds are dropped at creation time, so
 * they never enter `holdActive`/`hold3pActive`, never block completion.
 */ const $fa77cab6e7101561$var$isExcludedThirdPartyHold = (labelStack)=>labelStack?.some((label)=>'type' in label && label.type === 'third-party' && 'excludeFromMetrics' in label && label.excludeFromMetrics === true) ?? false;
const $fa77cab6e7101561$var$getMetricVariantCategories = (labelStack)=>{
    const categories = new Set();
    labelStack?.forEach((label)=>{
        if ('type' in label && $fa77cab6e7101561$var$isKnownMetricVariantCategory(label.type)) categories.add(label.type);
    });
    return [
        ...categories
    ];
};
const $fa77cab6e7101561$var$hasMetricVariantCategoryInHoldData = (interaction, category)=>interaction.holdInfo.some((hold)=>$fa77cab6e7101561$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.holdActive.values() ?? []
    ].some((hold)=>$fa77cab6e7101561$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.hold3pInfo ?? []
    ].some((hold)=>$fa77cab6e7101561$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.hold3pActive?.values() ?? []
    ].some((hold)=>$fa77cab6e7101561$var$hasMetricVariantCategory(hold.labelStack, category));
const $fa77cab6e7101561$var$recordMetricVariantCategoryEnd = (interaction, labelStack, end)=>{
    // Excluded third-party holds (e.g. Forge background scripts) still live in `hold3pActive` and
    // gate completion like any third-party hold, but they must never contribute a third-party
    // category end. Skipping here covers every caller at once: the normal-release closure in
    // `addHold`, `removeHoldByID`, `addCompletedHold`, and the abort/timeout iterator
    // `recordActiveMetricVariantCategoryEnds`.
    if ($fa77cab6e7101561$var$isExcludedThirdPartyHold(labelStack)) return;
    const categories = $fa77cab6e7101561$var$getMetricVariantCategories(labelStack);
    if (categories.length === 0) return;
    interaction.metricCategoryEnds = interaction.metricCategoryEnds ?? {};
    categories.forEach((category)=>{
        interaction.metricCategoryEnds[category] = Math.max(interaction.metricCategoryEnds[category] ?? 0, end);
    });
};
const $fa77cab6e7101561$var$recordActiveMetricVariantCategoryEnds = (interaction, end)=>{
    interaction.hold3pActive?.forEach((hold)=>{
        $fa77cab6e7101561$var$recordMetricVariantCategoryEnd(interaction, hold.labelStack, end);
    });
};
const $fa77cab6e7101561$var$hasActiveMetricVariantCategory = (interaction, category)=>[
        ...interaction.hold3pActive?.values() ?? []
    ].some((hold)=>$fa77cab6e7101561$var$hasMetricVariantCategory(hold.labelStack, category));
function $fa77cab6e7101561$var$shouldMoveHoldToExtendedBucket(interaction, hold) {
    // Excluded third-party holds (e.g. Forge background scripts) are routed to the extended
    // (`hold3pActive`) bucket exactly like any other third-party hold: they carry `type: 'third-party'`
    // so `hasAnyMetricVariantCategory` is true. They therefore keep gating completion (which preserves
    // the standard-bucket VC parity), and are excluded ONLY at the third-party accounting sites
    // (`recordMetricVariantCategoryEnd` and the `end3p` computation via `getNonExcludedThirdPartyEnd`).
    return $fa77cab6e7101561$var$hasAnyMetricVariantCategory(hold.labelStack) || interaction.end !== 0 && hold.start > interaction.end;
}
/**
 * The third-party end marker (`end3p`), used as the `include-third-party` window end whenever no
 * genuine third-party category end was recorded, must reflect only NON-excluded third-party work.
 *
 * `currentTime` is the timestamp the caller would otherwise have used verbatim (e.g. the abort
 * time, or the interaction end on the success path). If there is any genuine (non-excluded)
 * third-party hold that is still ACTIVE at this point, that work legitimately extends to
 * `currentTime`, so we keep it. Otherwise the only active third-party holds are excluded
 * background scripts, which must NOT drag the marker, so we fall back to the latest end among the
 * already-released non-excluded holds, clamped to at least `interactionEnd`. This preserves the
 * pre-fix behaviour for real third-party work while preventing background scripts from inflating
 * `end3p` / the include-third-party window.
 *
 * Note the released entries in `hold3pInfo` are `HoldActive & { end: number }`, so we read `h.end`.
 */ const $fa77cab6e7101561$var$getNonExcludedThirdPartyEnd = (interaction, currentTime, interactionEnd)=>{
    const activeHolds = [
        ...interaction.hold3pActive?.values() ?? []
    ];
    const releasedHolds = interaction.hold3pInfo ?? [];
    // If this interaction never involved an excluded (background-script) hold at all
    // (none active AND none released), it is unaffected by an exclusion logic.
    // The derivation below only runs when at least one excluded hold actually exists.
    const hasAnyExcludedThirdParty = activeHolds.some((hold)=>$fa77cab6e7101561$var$isExcludedThirdPartyHold(hold.labelStack)) || releasedHolds.some((hold)=>$fa77cab6e7101561$var$isExcludedThirdPartyHold(hold.labelStack));
    if (!hasAnyExcludedThirdParty) return currentTime;
    // If a genuine (non-excluded) third-party hold is still active, the interaction is legitimately
    // being kept open by real third-party work, so the marker is the current time
    const hasActiveNonExcludedThirdParty = activeHolds.some((hold)=>!$fa77cab6e7101561$var$isExcludedThirdPartyHold(hold.labelStack));
    if (hasActiveNonExcludedThirdParty) return currentTime;
    // Otherwise, only excluded background-script holds (if any) remain active. `currentTime` may have
    // been pushed out purely by a background script, so derive the marker from the latest genuine
    // (non-excluded) third-party work instead, floored to the interaction end so it is never reported
    // earlier than the interaction itself and a background script can never drag it late.
    return Math.max(interactionEnd, ...releasedHolds.filter((hold)=>!$fa77cab6e7101561$var$isExcludedThirdPartyHold(hold.labelStack)).map((hold)=>hold.end));
};
function $fa77cab6e7101561$var$ensureExtendedHoldActive(interaction) {
    interaction.hold3pActive = interaction.hold3pActive ?? new Map();
    return interaction.hold3pActive;
}
function $fa77cab6e7101561$var$ensureExtendedHoldInfo(interaction) {
    interaction.hold3pInfo = interaction.hold3pInfo ?? [];
    return interaction.hold3pInfo;
}
function $fa77cab6e7101561$var$moveLateActiveHoldsToExtendedBucket(interaction) {
    if (interaction.end === 0) return;
    const holdsToMove = [
        ...interaction.holdActive.entries()
    ].filter(([, hold])=>$fa77cab6e7101561$var$shouldMoveHoldToExtendedBucket(interaction, hold));
    holdsToMove.forEach(([id, hold])=>{
        $fa77cab6e7101561$var$ensureExtendedHoldActive(interaction).set(id, hold);
        interaction.holdActive.delete(id);
    });
}
function $fa77cab6e7101561$var$ensureMetricWindows(interaction) {
    if (interaction.end === 0) return;
    const hasGenAI = $fa77cab6e7101561$var$hasMetricVariantCategoryInHoldData(interaction, 'gen-ai');
    const hasThirdParty = $fa77cab6e7101561$var$hasMetricVariantCategoryInHoldData(interaction, 'third-party');
    const includeThirdPartyEnd = interaction.metricCategoryEnds?.['third-party'] !== undefined ? Math.max(interaction.metricCategoryEnds['third-party'], interaction.end) : interaction.end3p;
    const includeGenAIEnd = interaction.metricCategoryEnds?.['gen-ai'] !== undefined ? Math.max(interaction.metricCategoryEnds['gen-ai'], interaction.end) : undefined;
    interaction.metricWindows = {
        ...interaction.metricWindows,
        standard: {
            start: interaction.start,
            end: interaction.end,
            includeCategories: [],
            excludeCategories: [
                'third-party',
                'gen-ai'
            ]
        }
    };
    if (includeThirdPartyEnd !== undefined && (hasThirdParty || !hasGenAI)) interaction.metricWindows['include-third-party'] = {
        start: interaction.start,
        end: includeThirdPartyEnd,
        includeCategories: [
            'third-party'
        ],
        excludeCategories: []
    };
    if (hasGenAI && includeGenAIEnd !== undefined) interaction.metricWindows['include-gen-ai'] = {
        start: interaction.start,
        end: includeGenAIEnd,
        includeCategories: [
            'gen-ai'
        ],
        excludeCategories: []
    };
}
function $fa77cab6e7101561$var$addLifecycleObservation(interaction, observation) {
    interaction.lifecycleObservations = interaction.lifecycleObservations ?? [];
    interaction.lifecycleObservations.push(observation);
}
function $fa77cab6e7101561$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function $fa77cab6e7101561$var$finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    $fa77cab6e7101561$var$ensureMetricWindows(data);
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark(`TTAI`, {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch  {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $cf5258fb0d237fac$export$2a5c8df26bb89760));
    (0, $704a9804c9307b07$export$17ab21d7be720b)();
    $fa77cab6e7101561$var$callCleanUpCallbacks(data);
    (0, $7e58dfb7b9203da6$export$c8760e11c713fafc)();
    if (data.type === 'page_load') data.hydration = (0, $d0427bdd60d98885$export$2d8f8d64dc343d7b)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    if (!(0, $e652262e1c536287$export$2e2bcd8739ae039)((0, $d0427bdd60d98885$export$1d459f020c06ae34)((0, $0ad31d6ba681eb2f$export$e08487ea3ae92adb)(data.ufoName), data.type))) $fa77cab6e7101561$export$d8f52e8f804021e8.stopVCObserver();
    $fa77cab6e7101561$export$cd7f480d6b8286c3(id);
    $fa77cab6e7101561$export$dbba6cdedab4e68b.id = data.id;
    $fa77cab6e7101561$export$dbba6cdedab4e68b.type = data.type;
    $fa77cab6e7101561$export$dbba6cdedab4e68b.timestamp = data.end;
    $fa77cab6e7101561$export$dbba6cdedab4e68b.name = data.ufoName || 'unknown';
    $fa77cab6e7101561$export$dbba6cdedab4e68b.isAborted = data.abortReason != null;
    if (data.ufoName) $fa77cab6e7101561$var$handleInteraction(id, data);
    if ($fa77cab6e7101561$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $fa77cab6e7101561$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$fa77cab6e7101561$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary-dark'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch  {
    // do nothing
    }
}
function $fa77cab6e7101561$export$9e614a29a1ac213e(sinkFn) {
    if ($fa77cab6e7101561$var$handleInteraction === $fa77cab6e7101561$var$pushToQueue) {
        $fa77cab6e7101561$var$handleInteraction = sinkFn;
        $fa77cab6e7101561$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $fa77cab6e7101561$var$interactionQueue.length = 0;
    }
}
function $fa77cab6e7101561$export$8a1ba7bef607358a(sinkFn) {
    $fa77cab6e7101561$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let $fa77cab6e7101561$var$activeSubmitted = false;
function $fa77cab6e7101561$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const shouldUseRawDataThirdParty = (0, $d0427bdd60d98885$export$9c69f5a724f05f38)(interaction.ufoName, interaction.type);
        const postInteraction = async ()=>{
            if ((0, $d0427bdd60d98885$export$44487a86467333c3)()?.postInteractionLog?.enabled) $fa77cab6e7101561$export$d8f52e8f804021e8.onInteractionComplete(interaction);
            $fa77cab6e7101561$var$activeSubmitted = false;
        };
        const noMoreActiveMetricVariantHolds = interaction.hold3pActive?.size === 0 || interaction.hold3pActive === undefined;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $fa77cab6e7101561$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If using separated metric variant behavior, wait for extended category holds to clear.
        // The backing fields still use their legacy 3P names because they are part of the existing
        // third-party payload contract, but this bucket now also drives client metric windows.
        if (shouldUseSeparatedMetricVariantBehavior) {
            // If there are no standard holds active, mark the interaction as successful
            // but don't finish until extended metric variant holds are cleared.
            if (noMoreActiveHolds && !noMoreActiveMetricVariantHolds) {
                // Mark interaction as successful by setting endTime, but don't finish yet
                if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                $fa77cab6e7101561$var$moveLateActiveHoldsToExtendedBucket(interaction);
                $fa77cab6e7101561$var$ensureMetricWindows(interaction);
                // Wait for extended metric variant holds to clear before finishing.
                return;
            }
            // If all holds, including extended metric variant holds, are cleared, finish the interaction.
            if (noMoreActiveHolds && noMoreActiveMetricVariantHolds) {
                if (!$fa77cab6e7101561$var$activeSubmitted) {
                    // Set the legacy third-party end marker when extended metric variant holds clear,
                    // preserving existing 3P payload behavior while category-specific end times are
                    // recorded separately in metricCategoryEnds. When a genuine third-party hold is still
                    // active (or was the last to release), `getNonExcludedThirdPartyEnd` returns the same
                    // clamped current time as before. When only excluded background-script holds remain,
                    // the marker is derived from the non-excluded third-party holds and floored to the
                    // interaction end, so a background script cannot drag it late.
                    const currentTime = endTime ?? performance.now();
                    interaction.end3p = $fa77cab6e7101561$var$getNonExcludedThirdPartyEnd(interaction, interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime, interaction.end !== 0 ? interaction.end : currentTime);
                    $fa77cab6e7101561$var$ensureMetricWindows(interaction);
                    $fa77cab6e7101561$var$finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                    if ((0, $d0427bdd60d98885$export$44487a86467333c3)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $d0427bdd60d98885$export$44487a86467333c3)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $9ad27da18e251816$export$74b9ce7e9d206a8)(interactionId, interaction);
                    $fa77cab6e7101561$var$activeSubmitted = true;
                }
                postInteraction();
            }
        } else if (noMoreActiveHolds) {
            if (!$fa77cab6e7101561$var$activeSubmitted) {
                $fa77cab6e7101561$var$finishInteraction(interactionId, interaction, endTime);
                if ((0, $d0427bdd60d98885$export$44487a86467333c3)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $d0427bdd60d98885$export$44487a86467333c3)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $9ad27da18e251816$export$74b9ce7e9d206a8)(interactionId, interaction);
                $fa77cab6e7101561$var$activeSubmitted = true;
            }
            postInteraction();
        }
    }
}
function $fa77cab6e7101561$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $fa77cab6e7101561$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $d0427bdd60d98885$export$9c69f5a724f05f38)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $fa77cab6e7101561$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds that are still active at abort/timeout must not drag
            // `end3p` (and thus the include-third-party window) past the real interaction end. Derive it
            // from the non-excluded third-party holds only. `recordActiveMetricVariantCategoryEnds`
            // likewise skips excluded holds internally.
            interaction.end3p = $fa77cab6e7101561$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $fa77cab6e7101561$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $fa77cab6e7101561$var$addLifecycleObservation(interaction, {
                type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
                timestamp: interaction.end3p,
                activeHoldCount: interaction.hold3pActive?.size ?? 0
            });
            $fa77cab6e7101561$var$ensureMetricWindows(interaction);
            $fa77cab6e7101561$var$finishInteraction(interactionId, interaction, endTime);
            $fa77cab6e7101561$export$d8f52e8f804021e8.reset();
            $fa77cab6e7101561$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $fa77cab6e7101561$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $fa77cab6e7101561$var$addLifecycleObservation(interaction, {
            type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
            timestamp: performance.now(),
            activeHoldCount: interaction.holdActive.size + (interaction.hold3pActive?.size ?? 0)
        });
        $fa77cab6e7101561$var$finishInteraction(interactionId, interaction);
        $fa77cab6e7101561$export$d8f52e8f804021e8.reset();
        $fa77cab6e7101561$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $fa77cab6e7101561$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $d0427bdd60d98885$export$9c69f5a724f05f38)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $fa77cab6e7101561$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds still active at this point must not drag `end3p` (and
            // thus the include-third-party window) past the real interaction end. Derive it from the
            // non-excluded third-party holds only, clamped to at least the interaction end.
            interaction.end3p = $fa77cab6e7101561$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $fa77cab6e7101561$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $fa77cab6e7101561$var$addLifecycleObservation(interaction, {
                type: 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: interactionName
            });
            $fa77cab6e7101561$var$ensureMetricWindows(interaction);
            $fa77cab6e7101561$var$finishInteraction(interactionId, interaction, endTime);
            $fa77cab6e7101561$export$d8f52e8f804021e8.reset();
            $fa77cab6e7101561$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $fa77cab6e7101561$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $fa77cab6e7101561$var$addLifecycleObservation(interaction, {
            type: 'new_interaction_started',
            timestamp: performance.now(),
            triggerName: interactionName
        });
        $fa77cab6e7101561$var$finishInteraction(interactionId, interaction);
        $fa77cab6e7101561$export$d8f52e8f804021e8.reset();
        $fa77cab6e7101561$export$d8f52e8f804021e8.stopVCObserver();
    } else {
        // post-interaction log is active after interaction is aborted by new one
        $fa77cab6e7101561$export$d8f52e8f804021e8.reset();
        $fa77cab6e7101561$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $fa77cab6e7101561$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    const activeInteraction = $fa77cab6e7101561$export$2b3954d2e8509985();
    const finishInteractions = (0, $d0427bdd60d98885$export$20e8108b8ccdd0bd)();
    (0, $deff72440153d7ae$export$cc97b17ef9aeb088).forEach((interaction, interactionId)=>{
        const isActiveInteraction = activeInteraction === interaction;
        let hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions?.includes(interaction.ufoName)) hasFinished = true;
        const shouldUseRawDataThirdParty = (0, $d0427bdd60d98885$export$9c69f5a724f05f38)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $fa77cab6e7101561$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Excluded background-script holds still active at transition/new-interaction abort must not
            // drag `end3p` (and thus the include-third-party window) past the real interaction end.
            // Derive it from the non-excluded third-party holds only, clamped to at least the end.
            interaction.end3p = $fa77cab6e7101561$var$getNonExcludedThirdPartyEnd(interaction, performance.now(), endTime);
            $fa77cab6e7101561$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $fa77cab6e7101561$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: abortedByInteractionName
            });
            $fa77cab6e7101561$var$ensureMetricWindows(interaction);
            $fa77cab6e7101561$var$finishInteraction(interactionId, interaction, endTime);
            $fa77cab6e7101561$export$d8f52e8f804021e8.reset();
            $fa77cab6e7101561$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        if (!hasFinished) {
            $fa77cab6e7101561$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
            $fa77cab6e7101561$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: performance.now(),
                triggerName: abortedByInteractionName
            });
        }
        $fa77cab6e7101561$var$finishInteraction(interactionId, interaction);
        $fa77cab6e7101561$export$d8f52e8f804021e8.reset();
        $fa77cab6e7101561$export$d8f52e8f804021e8.stopVCObserver();
    });
}
function $fa77cab6e7101561$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(id);
    interaction?.cancelCallbacks.push(cancelCallback);
}
function $fa77cab6e7101561$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null, preloadKey) {
    $fa77cab6e7101561$export$d8f52e8f804021e8.reset();
    let vcObserver;
    let previousTime = startTime;
    let timeoutTime = (0, $d0427bdd60d98885$export$c681731847989445)(ufoName);
    const timerID = setTimeout(()=>{
        $fa77cab6e7101561$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $fa77cab6e7101561$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $e652262e1c536287$export$2e2bcd8739ae039)((0, $d0427bdd60d98885$export$29b9ffb14861a1d)('feature_flag_access'));
    const config = (0, $d0427bdd60d98885$export$44487a86467333c3)();
    const searchPageConfig = {
        enableSmartAnswersMutations: config?.extraSearchPageInteraction?.enabled,
        searchPageRoute: config?.extraSearchPageInteraction?.searchPageRoute
    };
    if (config && config.vc) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $d0427bdd60d98885$export$59e1f072477dfb48)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders,
            searchPageConfig: searchPageConfig
        };
        vcObserver = (0, $2c44bc2215643fd1$export$c69731bddfc24d85)(vcOptions);
    }
    const priorAccessedFg = type === 'press' ? {} : Object.fromEntries((0, $cf5258fb0d237fac$export$5b78c989c8db2561));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        preloadKey: preloadKey,
        type: type,
        previousInteractionName: $fa77cab6e7101561$export$dbba6cdedab4e68b.name,
        isPreviousInteractionAborted: $fa77cab6e7101561$export$dbba6cdedab4e68b.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        preloadInfo: [],
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        excluded3pSegmentData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $cf5258fb0d237fac$export$2a5c8df26bb89760).clear();
    (0, $deff72440153d7ae$export$cc97b17ef9aeb088).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $fa77cab6e7101561$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $fa77cab6e7101561$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(()=>{
        vcObserver.stop(ufoName);
    });
    const awaitBM3TTIList = (0, $d0427bdd60d98885$export$2d311b3fd18dcab1)();
    if (awaitBM3TTIList.includes(ufoName)) $fa77cab6e7101561$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((0, $d0427bdd60d98885$export$44487a86467333c3)()?.postInteractionLog?.enabled) $fa77cab6e7101561$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
    if ($fa77cab6e7101561$var$onInteractionStartForPreloadHolds) try {
        $fa77cab6e7101561$var$onInteractionStartForPreloadHolds(interactionId, ufoName, preloadKey);
    } catch  {
    // Preload instrumentation must not break interaction creation.
    }
}
function $fa77cab6e7101561$export$4a759336b50e86e3(event) {
    const interaction = $fa77cab6e7101561$export$2b3954d2e8509985();
    if (interaction) {
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && event.config?.type === 'PAGE_LOAD') $fa77cab6e7101561$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $fa77cab6e7101561$export$ad216cc25852d44b(apdex) {
    (0, $deff72440153d7ae$export$cc97b17ef9aeb088).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $fa77cab6e7101561$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $fa77cab6e7101561$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $fa77cab6e7101561$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $fa77cab6e7101561$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $fa77cab6e7101561$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $fa77cab6e7101561$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($fa77cab6e7101561$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $fa77cab6e7101561$export$1c43f9ac826b6462(labelStack) {
    const key = $fa77cab6e7101561$var$getSegmentCacheKey(labelStack);
    const existingSegment = $fa77cab6e7101561$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $fa77cab6e7101561$var$segmentCache.set(key, segmentInfo);
        $fa77cab6e7101561$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $fa77cab6e7101561$export$d0365e48b58231c3(labelStack) {
    const key = $fa77cab6e7101561$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $fa77cab6e7101561$var$segmentCache.get(key);
    if (segmentInfo) {
        $fa77cab6e7101561$var$segmentCache.delete(JSON.stringify(labelStack));
        const cacheKey = (0, $08edc97a18a6c043$export$caeee352b541de1f)(labelStack);
        $fa77cab6e7101561$export$a2b14406ded37d60.set(cacheKey, ($fa77cab6e7101561$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        $fa77cab6e7101561$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $fa77cab6e7101561$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $deff72440153d7ae$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($fa77cab6e7101561$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: prevRedirect?.time ?? interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
const $fa77cab6e7101561$export$6ce04c7ca6810a7e = [];
const $fa77cab6e7101561$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $fa77cab6e7101561$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $fa77cab6e7101561$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $fa77cab6e7101561$export$6ce04c7ca6810a7e.push(customSpan);
}









var $aLoS2 = parcelRequire("aLoS2");




const $bafd16c1172e5624$var$cloudFrontRegex = /(https?):\/\/[a-z0-9]+\.cloudfront\.net\//g;
const $bafd16c1172e5624$var$cloudFrontS3Regex = /(https?):\/\/[a-z0-9]+\.cloudfront\.net\/download\//g;
// Used to match web resource URLs like this:
//   .../wiki/s/99914b932bd37a50b983c5e7c90ae93b-CDN/-1510873586/6452/236c4aa50522e3b557db968ff45d01d44604ffe1/1000.0.53/_/download/...
//   .../wiki/s/d41d8cd98f00b204e9800998ecf8427e-CDN/-783152381/h/2ddebfb80ae902fe7ab6e15441fe94e2/_/download/batch/...
//   .../wiki/s/d065fee603fdcf75115204ec65310e1c-CDN/-1510873586/6452/236c4aa50522e3b557db968ff45d01d44604ffe1/11d5083bb8bb9dac4c3a5987eeac4b5b/_/download/contextbatch/...
//   .../wiki/s/1283600969/6452/571d5459a4fbf60c255c41bb4e0d3ef3b8022627/_/download/resources/...
const $bafd16c1172e5624$var$wrmResourceRegex = /s\/[^_]+_\/download\//g;
/**
 * For values which represent a stringified JSON, tries to extract the `"message"`
 * property and returns it if found. Returned result defaults to input value.
 */ function $bafd16c1172e5624$var$tryExtractMessage(value) {
    try {
        const parsedValue = JSON.parse(value);
        return parsedValue.message || value;
    } catch (_) {
        return value;
    }
}
// Turns the culprit URL into .../wiki/download/... to remove the hash information.
function $bafd16c1172e5624$var$stripHashAndCDNHost(url) {
    return url.match($bafd16c1172e5624$var$wrmResourceRegex) ? url.replace($bafd16c1172e5624$var$wrmResourceRegex, 'download/').replace($bafd16c1172e5624$var$cloudFrontRegex, '$1://') : url;
}
function $bafd16c1172e5624$var$getErrorFingerprint(error) {
    // See docs at https://docs.sentry.io/platforms/javascript/data-management/event-grouping/sdk-fingerprinting/
    const DEFAULT_FINGERPRINT = '{{ default }}';
    if (error.message.startsWith('Quota exceeded on key') || error.message.startsWith('QuotaExceededError')) return [
        'storage-quota-error'
    ];
    if (error.message.startsWith('Maximum call stack size exceeded') || error.message.startsWith('too much recursion')) // Most (if not all) of these errors originate from editor/prosemirror, and they
    // are hard to troubleshoot. So, although they all might represent a
    // different error, we're bundling them together
    return [
        'maximum-call-stack'
    ];
    if (error.message.startsWith('Invalid position')) // These errors originate from editor/prosemirror. The rest of the message
    // is the position number itself, and Sentry seldom groups those together.
    // By giving them all the same fingerprint, we're forcing Sentry to treat all
    // of those as the occurrence of one and the same error.
    return [
        'invalid-position'
    ];
    if (error.message.match(/Loading chunk .+? failed/)) // These are webpack chunk load errors, which often have very different stack traces.
    // We're grouping them together.
    return [
        'chunk-load-error'
    ];
    if (error.message.startsWith('Error creating blueprint content:')) // Grouping those by message should work better than looking at the stack trace
    return [
        'blueprint-creation-error',
        error.message.substr(0, 100)
    ];
    if (error.message.startsWith('Error from synchrony plugin')) // These are hard to troubleshoot, so to reduce noise we group them together
    return [
        'error-from-synchrony-plugin'
    ];
    if (error.message.includes('Error fetching data from identity - Error has been logged with execution ID:')) // The "execution ID" part in these errors is always different.
    return [
        'identity-fetching-error'
    ];
    if (error.message.includes('java.net.SocketTimeoutException')) return [
        'socket-timeout'
    ];
    if (error instanceof URIError) // This will group all URI errors together, as they often have different stack traces
    return [
        'malformed-uri-error'
    ];
    if (error instanceof (0, $b1c79be305194522$export$e704fce35c66bf42) && error.route) // These errors tend to produce unpredictable messages which are hard to group.
    // So, instead of grouping by message, we'll group them by `route` and status code (which should be more predictable)
    return [
        `rest-api-${error.route}-${error.statusCode}`
    ];
    const logSafeAttributes = (0, $8a3a8685062675cc$export$d08bac32cb78075f)(error);
    if (logSafeAttributes.failedSlaExperience) {
        if (logSafeAttributes.operationName || logSafeAttributes.statusCode) // This code branch is for GraphQL/REST failures which result in experience failures.
        // Since the same backend errors can be thrown for different operations/endpoints,
        // we're applying a per-message grouping.
        // Also, we're **not** including default fingerprint here.
        return [
            `experience-${logSafeAttributes.failedSlaExperience}`,
            $bafd16c1172e5624$var$tryExtractMessage(error.message).substr(0, 100)
        ];
        else // this way SLA-affecting errors shouldn't be bundled with other types of errors
        return [
            DEFAULT_FINGERPRINT,
            `experience-${logSafeAttributes.failedSlaExperience}`
        ];
    }
    return undefined;
}
const $bafd16c1172e5624$var$dataTransformer = function(data, hint) {
    let fromWRM = false;
    let fromS3 = false;
    if (data.exception?.values) // Go through the stack trace and sanitize all the exception URLs.
    data.exception.values = data.exception.values.map((exception)=>{
        if (exception.stacktrace && exception.stacktrace.frames) exception.stacktrace.frames = exception.stacktrace.frames.map((frame)=>{
            if (frame.filename) {
                fromWRM = Boolean(frame.filename.match($bafd16c1172e5624$var$wrmResourceRegex));
                fromS3 = Boolean(frame.filename.match($bafd16c1172e5624$var$cloudFrontS3Regex));
                frame.filename = $bafd16c1172e5624$var$stripHashAndCDNHost(frame.filename);
            }
            return frame;
        });
        return exception;
    });
    if (typeof hint?.originalException === 'object' && hint?.originalException !== null) {
        data.fingerprint = $bafd16c1172e5624$var$getErrorFingerprint(hint.originalException);
        const { componentStack: _1, // this field is very big
        failedSlaExperience: _2, // this one is included as tag
        ...rest } = (0, $8a3a8685062675cc$export$d08bac32cb78075f)(hint.originalException);
        data.extra = {
            ...data.extra,
            ...rest
        };
    }
    if (fromWRM) data.logger = 'wrm';
    else if (fromS3) data.logger = 'react';
    else data.logger = 'javascript';
    // strip out url and breadcrumbs which include customer sensitive data
    if (data.request) delete data.request.url;
    delete data.breadcrumbs;
    data.transaction = ''; // transactions can have URLs in them, too
    return data;
};
// Structure: https://<PUBLIC_KEY>@o55978.ingest.sentry.io/<PROJECT_ID>
// See: https://hello.atlassian.net/wiki/spaces/OBSERVABILITY/pages/1436386358/Sentry+Cloud+-+Getting+Started#Setting-up-the-Sentry-SDK-for-your-project
function $bafd16c1172e5624$var$getSentryDsn() {
    // https://sentry.io/settings/atlassian-2y/projects/confluence/keys/
    const SENTRY_DSN_PROD = 'https://1f56d81aaaae4b1ea5ca08bca6633223@o55978.ingest.sentry.io/5988811';
    // https://sentry.io/settings/atlassian-2y/projects/confluence-staging/keys/
    const SENTRY_DSN_STAGING = 'https://ce2ea70bbd2a439793b772cc1d59e2fe@o55978.ingest.sentry.io/5988871';
    return SENTRY_DSN_PROD;
}
function $bafd16c1172e5624$var$getSentryEnvironment() {
    const SENTRY_ENV_PROD = 'CONFLUENCE';
    const SENTRY_ENV_STAGING = 'CONFLUENCE-STAGING';
    const SENTRY_ENV_HELLO = 'HELLO';
    return SENTRY_ENV_PROD;
}
function $bafd16c1172e5624$export$138324b295200599(dsn) {
    const additionalOptions = {};
    return {
        release: (0, $f3f8c1a227f13835$export$4ea39b9726d98a51)().FRONTEND_VERSION,
        dsn: dsn,
        environment: $bafd16c1172e5624$var$getSentryEnvironment(),
        beforeSend (event, hint) {
            return $bafd16c1172e5624$var$dataTransformer(event, hint);
        },
        ignoreErrors: [
            'Transport destroyed',
            // Error being thrown by media that won't be resolved any time soon.
            'Worker was destroyed',
            // Error being thrown by media that won't be resolved any time soon.
            'Failed to connect on any of the ADC ports',
            // Error being thrown by media that won't be resolved any time soon.
            "Cannot read property 'postMessage' of undefined",
            // Error being thrown by Connect that won't be resolved any time soon.
            "Cannot read property 'postMessage' of null",
            // Error being thrown by Connect that won't be resolved any time soon.
            'd.hide is not a function',
            // From com.atlassian.auiplugin:aui-date-picker,
            /^network error/i,
            // We can't do anything about network issues
            /^network failure/i,
            // We can't do anything about network issues
            'TypeError: Failed to fetch',
            // We can't do anything about network issues
            'ResizeObserver loop limit exceeded',
            // A benign error, see https://stackoverflow.com/a/50387233/2645305
            /ResizeObserver loop completed with undelivered notifications/,
            // See https://product-fabric.atlassian.net/browse/PGXT-9417 — module not found errors from
            // failed dynamic imports don't impact customers but skew SLA metrics. Suppress at the
            // Sentry SDK level so unhandled rejections caught by the global handler are also filtered.
            /Cannot find module/,
            /Failed to find module/,
            /Module not found/
        ],
        autoSessionTracking: false,
        ...additionalOptions
    };
}

const $bafd16c1172e5624$export$c2e2a07dfafd1ea2 = (0, $aLoS2.default)(async ()=>{
    // https://sentry.io/settings/atlassian-2y/projects/confluence-sla/keys/
    const SENTRY_DSN_SLA = 'https://2d329ea4a8a04cf0b19117b4675b336f@o55978.ingest.sentry.io/5988900';
    return (0, $cd3135dd152096aa$export$cc373701aed148fc)((parcelRequire("3xo4s")).then(({ BrowserClient: BrowserClient, Hub: Hub })=>{
        const client = new BrowserClient($bafd16c1172e5624$export$138324b295200599(SENTRY_DSN_SLA));
        return new Hub(client);
    }).catch(()=>{
        // noop, there's nowhere to report this error
        return null;
    }));
});

function $bafd16c1172e5624$export$1f7656c617418e15() {
    (parcelRequire("3xo4s")).then(({ init: init })=>{
        init($bafd16c1172e5624$export$138324b295200599($bafd16c1172e5624$var$getSentryDsn()));
    }).catch(()=>{
    // noop, there's nowhere to report this error
    });
}


/* eslint-disable no-useless-constructor */ class $bf7ff670cf416156$export$704b12ddc1dacdd2 {
    add(item) {
        this.scheduleFlush();
        this.currentBatch.push(item);
        if (this.currentBatch.length >= this.batchMaxSize) this.flush();
    }
    onFlush(callback) {
        if (!(callback instanceof Function)) throw new Error(`"onFlush" callback is supposed to be a function; saw ${typeof callback} instead`);
        this.onFlushCallbacks.add(callback);
        return {
            unsubscribe: ()=>{
                this.onFlushCallbacks.delete(callback);
            }
        };
    }
    /**
   * Forcefully flushes the batcher. Noop if current batch is empty.
   */ forceFlush() {
        // Currently force-flush is synchronous. Make sure the call sites are updated if
        // this is changed to a promise-based approach
        this.flush();
    }
    renewBatch() {
        const oldBatch = this.currentBatch;
        this.currentBatch = [];
        return oldBatch;
    }
    scheduleFlush() {
        if (!this.flushIntervalId) this.flushIntervalId = window.setInterval(this.flush, this.flushIntervalMs);
    }
    unscheduleFlush() {
        if (this.flushIntervalId) {
            window.clearInterval(this.flushIntervalId);
            this.flushIntervalId = undefined;
        }
    }
    constructor(flushIntervalMs, batchMaxSize){
        this.flushIntervalMs = flushIntervalMs;
        this.batchMaxSize = batchMaxSize;
        this.flushIntervalId = void 0;
        this.onFlushCallbacks = new Set();
        this.currentBatch = [];
        this.flush = ()=>{
            const batch = this.renewBatch();
            this.unscheduleFlush();
            if (batch.length === 0) return;
            this.onFlushCallbacks.forEach((cb)=>{
                try {
                    cb(batch);
                } catch (e) {
                    // rethrow error asynchronously to allow other callbacks to execute
                    setTimeout(()=>{
                        /* eslint-disable-next-line no-console */ console.error(`"onFlush" callback threw the below error. Please make sure your callbacks have proper error handling`);
                        throw e;
                    }, 0);
                }
            });
        };
    }
}


// See https://product-fabric.atlassian.net/browse/PGXT-9417 for more context.
// Module not found errors from failed dynamic imports don't impact customers but skew SLA metrics.
// This utility is shared between CustomMonitoringClient and the experience tracker
// so both can suppress these errors consistently.
const $3a74d2139e317bf1$export$fb9e315560414aed = (error)=>{
    const errorMessage = String(error?.message || error || '');
    return errorMessage.includes('Cannot find module') || errorMessage.includes('Failed to find module') || errorMessage.includes('Module not found');
};



const $20a7f4cbd1623994$var$logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('CustomMonitoringClient');
const $20a7f4cbd1623994$var$getIsBifrostTag = ()=>`isBifrost:${window?.__IS_BIFROST__ ?? false}`;

class $20a7f4cbd1623994$export$a54226afd3e3cacc {
    enableNewSentry() {
        this.newSentryEnabled = true;
    }
    enableSendErrorsToTelemetryService() {
        this.sendErrorsToTelemetryService = true;
    }
    shouldIgnoreError(error) {
        return (0, $3a74d2139e317bf1$export$fb9e315560414aed)(error);
    }
    submitError(error, errorData) {
        if (!error) return;
        if (this.shouldIgnoreError(error)) return;
        if (this.errorsPerCurrentTransition === this.errorsPerTransitionLimit) // limit reached; do not submit the errors
        return;
        this.errorsPerCurrentTransition++;
        const logSafeErrorAttributes = (0, $8a3a8685062675cc$export$d08bac32cb78075f)(error);
        const { attribution: attribution } = errorData;
        let isFirstInSession = this.firstErrorInSession;
        const errorWithStackTrace = error && error.stack && error.message ? error : new Error(error && error.message || String(error));
        if ($20a7f4cbd1623994$var$isErrorIgnorableByOnCall(errorWithStackTrace, attribution, logSafeErrorAttributes)) isFirstInSession = false;
        else this.firstErrorInSession = false;
        const errorCounterTags = [
            `attribution:${attribution}`,
            `firstInSession:${isFirstInSession}`,
            ...logSafeErrorAttributes.operationName ? [
                `queryName:${logSafeErrorAttributes.operationName}`
            ] : []
        ];
        if (this.context.shard) errorCounterTags.push(`shard:${this.context.shard}`);
        errorCounterTags.push($20a7f4cbd1623994$var$getIsBifrostTag());
        errorCounterTags.push(`isMultiThread:${window?.__IS_MULTITHREADED_RUNTIME__}`);
        this.incrementCounter('jsErrors', errorCounterTags);
        const sentryTags = {
            attribution: attribution
        };
        if (this.context.slaExperience) sentryTags.slaExperience = this.context.slaExperience;
        if (this.context.pageName) sentryTags.pageName = this.context.pageName;
        if (logSafeErrorAttributes.failedSlaExperience) sentryTags.failedSlaExperience = logSafeErrorAttributes.failedSlaExperience;
        if (logSafeErrorAttributes.operationName) sentryTags.operationName = logSafeErrorAttributes.operationName;
        sentryTags.ssrRendered = Boolean(window.__SSR_RENDERED__).toString();
        if (logSafeErrorAttributes.failedSlaExperience) this.logSlaErrorToSentry(errorWithStackTrace, sentryTags).catch((sentryError)=>{
            this.logError(sentryError, {
                attribution: 'backbone'
            });
        });
        else if (this.newSentryEnabled) this.logErrorToSentry(errorWithStackTrace, sentryTags);
        this.logError(errorWithStackTrace, {
            ...errorData,
            ...logSafeErrorAttributes,
            firstInSession: isFirstInSession
        });
    }
    updateContext(update) {
        if (update.transitionId !== undefined && (update.transitionId === 0 || this.context.transitionId !== update.transitionId)) {
            const tags = [
                `type:${update.transitionId === 0 ? 'initial' : 'transition'}`
            ];
            tags.push($20a7f4cbd1623994$var$getIsBifrostTag());
            tags.push(`isMultiThread:${window?.__IS_MULTITHREADED_RUNTIME__}`);
            this.incrementCounter('session', tags);
            // Next error will be first in the session when there is a initial load (transition id = 0) or a SPA transition.
            this.firstErrorInSession = true;
            this.errorsPerCurrentTransition = 0;
        }
        if (update.pageName && this.context.pageName !== update.pageName) // since the page name changed, all the events in the current batch were done
        // under an old page name. Hence we force-flush the batch, and only then set the new context.
        {
            if (this.context.pageName !== undefined) // skip force-flush if that's the first time we set pageName (i.e. initial navigation)
            this.batcher.forceFlush();
        }
        Object.assign(this.context, update);
    }
    incrementCounter(counterName, tags) {
        this.batcher.add(this.createMetric({
            type: 'increment',
            name: counterName,
            value: 1,
            tags: tags
        }));
    }
    gauge(counterName, value, tags) {
        this.batcher.add(this.createMetric({
            type: 'gauge',
            name: counterName,
            value: value,
            tags: tags
        }));
    }
    logErrorToSentry(error, tags) {
        (parcelRequire("3xo4s")).then(({ withScope: withScope, captureException: captureException })=>{
            withScope((scope)=>{
                scope.setTags(tags);
                captureException(error);
            });
        }).catch((sentryError)=>{
            this.logError(sentryError, {
                attribution: 'backbone'
            });
        });
    }
    async logSlaErrorToSentry(error, tags) {
        let sentryHub = null;
        const standaloneSentryPromise = (0, $bafd16c1172e5624$export$c2e2a07dfafd1ea2)();
        if ((0, $cd3135dd152096aa$export$b1a2a6bd0c6f9666)(standaloneSentryPromise)) sentryHub = (0, $cd3135dd152096aa$export$bf7199a9ebcb84a9)(standaloneSentryPromise);
        else sentryHub = await standaloneSentryPromise;
        if (sentryHub) sentryHub.withScope((scope)=>{
            scope.setTags(tags);
            sentryHub.captureException(error);
        });
    }
    /**
   * There is a 64kb payload limit for navigator.sendBeacon requests
   * 10 events sent max.
   * 3 fields that are being trimmed
   * That allows for 65536/10/3 = 2184.5 per field
   * we add a bit of buffer for the rest of the payload by reducing that number further to 1000
   * @param errorAttributes
   * @returns a new object with trimmed attributes if they exceed the limit determined by
   * errorBatchMsgTrimLength` which is calculated based on the following details
   */ trimAttributes(errorAttributes) {
        const attributesToTrim = [
            'error',
            'stack',
            'componentStack'
        ];
        const newErrorAttributes = {
            ...errorAttributes
        };
        if (errorAttributes.error?.startsWith?.('Minified React error #130') && (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_untrimmed_react_errors')) {
            // Oct 2025: Log the (hopefully entire) stack for minified react error 130, to aid investigations into increased occurrences. Still trims to <64kb limit.
            newErrorAttributes.error = this.trimTextLength(newErrorAttributes.error, 2000);
            newErrorAttributes.stack = this.trimTextLength(newErrorAttributes.stack, 25000);
            newErrorAttributes.componentStack = this.trimTextLength(newErrorAttributes.componentStack, 25000);
        } else attributesToTrim.forEach((attribute)=>{
            if (newErrorAttributes[attribute]) newErrorAttributes[attribute] = this.trimTextLength(newErrorAttributes[attribute], this.errorBatchMsgTrimLength);
        });
        return newErrorAttributes;
    }
    async logError(error, additionalData) {
        try {
            const analyticsWebClientPromise = (0, $b76dfd1db5681318$export$e9ba7ef9458d1a4a)();
            let client;
            if ((0, $cd3135dd152096aa$export$b1a2a6bd0c6f9666)(analyticsWebClientPromise)) client = (0, $cd3135dd152096aa$export$bf7199a9ebcb84a9)(analyticsWebClientPromise);
            else client = await analyticsWebClientPromise;
            const errorAttributes = {
                error: error.message || String(error),
                stack: error.stack,
                browserInfo: window.navigator.userAgent,
                ssrRendered: Boolean(window.__SSR_RENDERED__),
                releaseId: (0, $f3f8c1a227f13835$export$4ea39b9726d98a51)().FRONTEND_VERSION,
                track: (0, $f3f8c1a227f13835$export$4ea39b9726d98a51)().RELEASE_TRACK,
                pageName: this.context.pageName,
                shard: this.context.shard,
                edition: this.context.edition,
                jqVer: window.jQuery?.fn?.jquery,
                activeExperiences: this.context.activeExperiences ? Array.from(this.context.activeExperiences) : undefined,
                slaExperience: this.context.slaExperience,
                ufoTraceId: (0, $3f9dbb98c6868de1$export$b6ac780db3a3cc77)()?.traceId,
                ufoTraceType: (0, $3f9dbb98c6868de1$export$b6ac780db3a3cc77)()?.type,
                ...additionalData
            };
            const trimmedErrorAttributes = this.trimAttributes(errorAttributes);
            const hydrationFailed = window && window.__HYDRATION_FAILED__ && (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_prevent_hydration_ufo_abort');
            if (!hydrationFailed) (0, $fa77cab6e7101561$export$7379c15afd3840fa)('confluence-frontend-monitoring-client', null, 'interaction unhandled error', errorAttributes.error);
            client.sendOperationalEvent({
                source: 'ui',
                action: 'unhandledError',
                actionSubject: 'ui',
                attributes: trimmedErrorAttributes
            });
            // Push unhandled errors to a window array so synthetic test runners can read them.
            // We check window.__IS_SYNTHETIC_ENV__ (set in SPA entry point) instead of importing
            // StatsigConfigurations directly, because it would create unavoidable circular dependency.
            if (window && window.__IS_SYNTHETIC_ENV__) {
                if (!window.__UNHANDLED_ERRORS__) window.__UNHANDLED_ERRORS__ = [];
                window.__UNHANDLED_ERRORS__.push({
                    source: 'ui',
                    action: 'unhandledError',
                    actionSubject: 'ui',
                    attributes: trimmedErrorAttributes
                });
            }
            if (this.sendErrorsToTelemetryService) this.errorBatcher.add({
                event: trimmedErrorAttributes
            });
        } catch  {
        // no-op, if an error occurs here, there's really nowhere to submit it
        }
    }
    /**
   * Defines an allow-list of context attributes that will be sent as "global" tags to FE Telemetry and SignalFX with every event.
   * Tags additionally have to be allow-listed in the FE Telemetry repository. We PURPOSELY exclude certain tags (that are allowed by FE Telemetry)
   * such as "edition", as we do not want to be sending that tag for every experience event (thereby increasing metric cardinality). Instead, those tags
   * are included with specific experience events.
   * @private
   */ formatContextAsTags() {
        const tags = [];
        if (this.context.pageName) tags.push(`page:${this.context.pageName}`);
        if (this.context.tenantId) tags.push(`cloudId:${this.context.tenantId}`);
        if (this.context.shard) tags.push(`shard:${this.context.shard}`);
        if (this.context.product) tags.push(`product:${this.context.product}`);
        const { FRONTEND_VERSION: frontendVersion, RELEASE_TRACK: releaseTrack } = (0, $f3f8c1a227f13835$export$4ea39b9726d98a51)();
        if (frontendVersion) tags.push(`version:${frontendVersion}`);
        if (releaseTrack) tags.push(`track:${releaseTrack}`);
        return tags;
    }
    onBatch(batch) {
        const payload = {
            type: 'metric',
            meta: {
                globalTags: this.formatContextAsTags()
            },
            data: batch
        };
        this.send(payload);
    }
    onErrorBatch(batch) {
        const payload = {
            type: 'error',
            meta: {
                globalTags: this.formatContextAsTags()
            },
            data: batch
        };
        this.send(payload);
    }
    send(telemetryPayload) {
        try {
            $20a7f4cbd1623994$var$logger.info`Sending monitoring events: ${telemetryPayload}`;
            const reportingUrl = '/gateway/api/telemetry';
            const data = JSON.stringify(telemetryPayload);
            let isSentViaBeacon = false;
            if (typeof navigator !== 'undefined' && navigator.sendBeacon) isSentViaBeacon = navigator.sendBeacon(reportingUrl, data);
            if (!isSentViaBeacon) {
                // resorting to XMLHttpRequest instead of fetch here so that we can submit these events *synchronously* when
                // the page unloads (`fetch` can't do that)
                const client = new XMLHttpRequest();
                const shouldBeSync = this.isWindowUnloading;
                client.open('POST', reportingUrl, !shouldBeSync);
                // we're setting the "Content-Type" header to "text/plain" to behave as closely to `sendBeacon` as possible
                client.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
                client.send(data);
            }
        } catch (e) {
            // ignore - there's nothing we can do when monitoring is down
            $20a7f4cbd1623994$var$logger.error`Sending monitoring data failed: ${e}`;
        }
    }
    createMetric({ type: type, name: name, value: value, tags: tags = [] }) {
        return {
            type: type,
            name: name,
            value: value,
            sampleRate: 1,
            tags: tags,
            timestamp: new Date().toISOString()
        };
    }
    trimTextLength(text, trimmedLength) {
        if (!text || !trimmedLength) return text;
        if (text.length > trimmedLength) return `${text.substring(0, trimmedLength)}...`;
        return text;
    }
    constructor({ errorsPerTransitionLimit: errorsPerTransitionLimit = 1000, metricBatchMaxSize: metricBatchMaxSize = 50, metricBatchFlushIntervalMs: metricBatchFlushIntervalMs = 10000, errorBatchFlushIntervalMs: errorBatchFlushIntervalMs = 10000, errorBatchMaxSize: errorBatchMaxSize = 10, errorBatchMsgTrimLength: errorBatchMsgTrimLength = 1000 } = {}){
        this.batcher = void 0;
        this.errorBatcher = void 0;
        this.isWindowUnloading = false;
        this.context = {};
        // First error occurred in initial load or transition
        this.firstErrorInSession = true;
        this.newSentryEnabled = false;
        this.sendErrorsToTelemetryService = false;
        this.errorsPerTransitionLimit = void 0;
        this.errorsPerCurrentTransition = 0;
        this.errorBatchMsgTrimLength = void 0;
        this.errorsPerTransitionLimit = errorsPerTransitionLimit;
        this.errorBatchMsgTrimLength = errorBatchMsgTrimLength;
        this.batcher = new (0, $bf7ff670cf416156$export$704b12ddc1dacdd2)(metricBatchFlushIntervalMs, metricBatchMaxSize);
        this.errorBatcher = new (0, $bf7ff670cf416156$export$704b12ddc1dacdd2)(errorBatchFlushIntervalMs, errorBatchMaxSize);
        this.batcher.onFlush((batch)=>{
            this.onBatch(batch);
        });
        this.errorBatcher.onFlush((batch)=>{
            this.onErrorBatch(batch);
        });
        const unloadListener = ()=>{
            this.isWindowUnloading = true;
            this.batcher.forceFlush();
            this.errorBatcher.forceFlush();
        };
        window.addEventListener('pagehide', unloadListener);
    }
}
function $20a7f4cbd1623994$var$isErrorIgnorableByOnCall(error, attribution, attrs) {
    // make sure that this condition remains first, as it should override everything else
    if (attrs.failedSlaExperience) // non-ignorable, because it resulted in a failure of an SLA-bound experience
    return false;
    if ((0, $65398bb1ddc9160a$export$bda33884db3cf75b)(error)) // ignorable, because on-call can't do much about user-side network connectivity
    return true;
    if (attribution === 'backbone-loadable') // while we do want to report those, we don't want to overwhelm our error rate detector
    return true;
    if (error.message.includes('.PermissionException') || error.message.includes('Authorization failed: Principal has insufficient permissions') || error.message.includes('.NotFoundException') || attrs.statusCode === 401 || attrs.statusCode === 403) // on-call engineers can't do much about those errors, because they indicate a client-side issue
    return true;
    return false;
}


class $e83139af63a401f5$export$97cc0a779e2b1c0d {
    submitError() {}
    updateContext() {}
    incrementCounter() {}
    gauge() {}
}



let $d1c1e8e192b1a688$var$monitoringClient;
const $d1c1e8e192b1a688$export$39a3b7739331403b = ()=>{
    if (!$d1c1e8e192b1a688$var$monitoringClient) {
        if (/bot/i.test(window.navigator.userAgent)) // Do nothing for search engine crawlers
        $d1c1e8e192b1a688$var$monitoringClient = new (0, $e83139af63a401f5$export$97cc0a779e2b1c0d)();
        else $d1c1e8e192b1a688$var$monitoringClient = new (0, $20a7f4cbd1623994$export$a54226afd3e3cacc)();
    }
    return $d1c1e8e192b1a688$var$monitoringClient;
};
const $d1c1e8e192b1a688$export$b97a02aaddc4fced = ()=>{
    if ($d1c1e8e192b1a688$var$monitoringClient instanceof (0, $20a7f4cbd1623994$export$a54226afd3e3cacc)) $d1c1e8e192b1a688$var$monitoringClient.enableSendErrorsToTelemetryService();
};




var $2hRE7 = parcelRequire("2hRE7");


var $aLoS2 = parcelRequire("aLoS2");

var $b2g2S = parcelRequire("b2g2S");

var $2IOnA = parcelRequire("2IOnA");
function $e1c00b92bef458ab$export$f2b591175b3e424c(resolver) {
    (0, $b2g2S.globalVar)[0, $2IOnA.PFF_GLOBAL_KEY].booleanResolver = resolver;
}


function $e9be8c7cd5545b25$export$ba05d765b8392e5e(flagResolver) {
    (0, $e1c00b92bef458ab$export$f2b591175b3e424c)(flagResolver);
}


/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
function $00ec216a734f59be$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}


function $93a83582283f8934$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $00ec216a734f59be$export$f9ce7b637dfbe238),
        defaultValue: config.defaultValue
    };
}



var $2M83v = parcelRequire("2M83v");
const $fe81af328120e8a0$var$IS_TESTING_ENV = typeof $2M83v !== 'undefined' && ($2M83v?.env?.NODE_ENV === 'test' || $2M83v?.env?.JEST_WORKER_ID !== undefined);
function $fe81af328120e8a0$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($fe81af328120e8a0$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}


function $749e4ec907f900af$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        typeGuard: (0, $fe81af328120e8a0$export$a9a18ae5ba42aeab)(config.values),
        defaultValue: config.defaultValue
    };
}


const $1eaa9a44197570d2$export$5c897d5297c5b7fd = [
    'platform_editor_block_menu',
    'platform_editor_blocks',
    'platform_editor_controls',
    'advanced_layouts',
    'single_column_layouts',
    'platform_editor_preview_panel_responsiveness',
    'platform_editor_toolbar_aifc',
    'comment_on_bodied_extensions'
];
const $1eaa9a44197570d2$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Added 2026-07-18
    cc_maui_remix_button_hover_corridor: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_maui_remix_button_hover_corridor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-24
    platform_editor_layout_column_delete_shortcut_fix: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_layout_column_delete_shortcut_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-21
    // `isEnabled` is the gating param; the experiment's dynamic config also carries the numeric
    // `shimmerDurationMs` (skeleton) and `highlightDurationMs` (purple highlight) durations, read at
    // runtime via `expVal`.
    platform_editor_agent_be_streaming: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_agent_be_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Editor Platform experiments
    // lwoollard experiments
    // Added 2026-04-21
    cwr_page_tree_auto_finalize: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cwr_page_tree_auto_finalize'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 02-12-2025
    cc_fix_hydration_ttvc: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_fix_hydration_ttvc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    'editor_a11y__enghealth-46814_fy26': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_a11y__enghealth-46814_fy26'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-20
    'editor_a11y__primary-toolbar-aria-label_fy27': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_a11y__primary-toolbar-aria-label_fy27',
            jira: 'editor_a11y__primary-toolbar-aria-label_fy27'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-21
    'editor_a11y__toolbar-item-aria-described-by_fy27': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_a11y__toolbar-item-aria-described-by_fy27',
            jira: 'editor_a11y__toolbar-item-aria-described-by_fy27'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    'enghealth-53346_fix_redaction_marker_editor': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            jira: 'enghealth-53346_fix_redaction_marker_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-03
    editor_tinymce_full_width_mode: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_tinymce_full_width_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_remove_important_in_render_ext: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_remove_important_in_render_ext'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-10
    confluence_max_width_content_appearance: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_max_width_content_appearance'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_comment_nudgebar_improvement: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_comment_nudgebar_improvement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_quick_insert_embeds: (0, $749e4ec907f900af$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_quick_insert_embeds'
        },
        param: 'cohort',
        values: [
            'control',
            'prioritizeLinkInQIM',
            'prioritizeEmbedInQIM'
        ],
        defaultValue: 'control'
    }),
    confluence_remix_icon_right_side: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_remix_icon_right_side'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    cc_editor_fix_insm_inp_buffer: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_fix_insm_inp_buffer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    cwr_blank_object_experiment: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cwr_blank_object_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    confluence_inline_comments_fix_stale_selection: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_inline_comments_fix_stale_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    rovo_remix_experience_context: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'rovo_remix_experience_context'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-05
    'databases-native-embeds-v2': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'databases-native-embeds-v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $749e4ec907f900af$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-17
    platform_editor_renderer_extension_width_fix: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_renderer_extension_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_media_external_badge_bbc_fix: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_media_external_badge_bbc_fix',
            bitbucket: 'platform_editor_media_external_badge_bbc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    platform_editor_annotations_sync_on_docchange: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_annotations_sync_on_docchange'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $749e4ec907f900af$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_per_plugin_error_boundary: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_per_plugin_error_boundary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-05
    'company_hub_carousel_thumbnails-refactor': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'company_hub_carousel_thumbnails-refactor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $749e4ec907f900af$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_paste_actions_menu: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-19
    platform_editor_controls_reliable_anchor: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_controls_reliable_anchor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $749e4ec907f900af$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_controls',
            jira: 'platform_editor_controls_jira'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-07-21
    confluence_cwr_3p_connection_suggested_prompts: (0, $749e4ec907f900af$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_cwr_3p_connection_suggested_prompts'
        },
        param: 'cohort',
        values: [
            'control',
            'variant_a',
            'variant_b'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-26
    platform_editor_agent_mentions: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_agent_mentions',
            jira: 'platform_editor_agent_mentions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_reduced_agent_profile_cards: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_reduced_agent_profile_cards',
            jira: 'platform_editor_reduced_agent_profile_cards'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    platform_editor_fix_link_paste_menu: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_link_paste_menu',
            jira: 'platform_editor_fix_link_paste_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_no_cursor_on_edit_page_init'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_code_block_q4_lovability: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_code_block_q4_lovability',
            jira: 'platform_editor_code_block_q4_lovability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-17-03
    platform_editor_media_name_fallback: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_media_name_fallback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    platform_editor_media_name_fallback_viewer_card: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_media_name_fallback_viewer_card'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_hide_overflow_menu: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_hide_overflow_menu',
            jira: 'platform_editor_toolbar_hide_overflow_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_responsiveness'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-27
    platform_editor_table_excerpts_fix: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_table_excerpts_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $749e4ec907f900af$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-06-25
    jira_editor_a11y_toolbar_fixes: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'jira_editor_a11y_toolbar_fixes',
            jira: 'jira_editor_a11y_toolbar_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025--8-05
    platform_editor_block_menu: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_menu',
            jira: 'platform_editor_blocks_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-09
    platform_editor_blocks: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_blocks_conf',
            jira: 'platform_editor_blocks_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    'editor-a11y-fy26-keyboard-move-row-column': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor-a11y-fy26-keyboard-move-row-column',
            jira: 'editor-a11y-fy26-keyboard-move-row-column'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $749e4ec907f900af$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-01-09
    platform_editor_render_bodied_extension_as_inline: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_render_bodied_extension_as_inline'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-03
    platform_editor_ai_quick_prompt_iw_cc: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_quick_prompt_iw_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-15
    cc_smarts_should_improve_writing_migration: (0, $749e4ec907f900af$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cc_smarts_should_improve_writing_migration'
        },
        param: 'routingMode',
        values: [
            'control',
            'shadow_compare',
            'live_cc_smarts'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-01
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $749e4ec907f900af$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    editor_a11y_7152_profile_card_tab_order: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_a11y_7152_profile_card_tab_order'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-27 — Pre-auth unauthorised inline hover card UX
    platform_sl_3p_preauth_better_hovercard: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_better_hovercard',
            jira: 'platform_sl_3p_preauth_better_hovercard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21 — Post-auth GDrive Smart Link to Rovo Chat auto-open
    platform_sl_3p_post_auth_chat_open_exp: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_sl_3p_post_auth_chat_open_exp',
            jira: 'platform_sl_3p_post_auth_chat_open_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11 — Pre-auth inline CTA 'Preview' experiment for unauthorised 3P inline smart links
    'rovogrowth-635-pre-auth-cta-preview-exp': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'rovogrowth-635-pre-auth-cta-preview-exp',
            jira: 'rovogrowth-635-pre-auth-cta-preview-exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-29 — Social proof inline CTA for unauthorised 3P inline smart links
    platform_sl_3p_preauth_social_proof_inline_cta: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_social_proof_inline_cta',
            jira: 'platform_sl_3p_preauth_social_proof_inline_cta'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15 — Embed card footer rovo action for resolved 3P smart links in confluence
    platform_sl_3p_auth_rovo_embed_footer_exp: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_sl_3p_auth_rovo_embed_footer_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_submenu_open_click: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_submenu_open_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-13
    platform_editor_hide_extension_renderer_support: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_hide_extension_renderer_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-23
    platform_editor_fix_new_line_after_heading: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_new_line_after_heading',
            jira: 'platform_editor_fix_new_line_after_heading'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-21
    platform_editor_copy_link_a11y_inconsistency_fix: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_copy_link_a11y_inconsistency_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_fix_lagging_embed_resize_handle: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_lagging_embed_resize_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-30
    platform_editor_fix_cross_origin_editor_focus: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_cross_origin_editor_focus'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_ttvc_inline_extensions: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_ttvc_inline_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-03
    platform_editor_enghealth_a11y_jan_fixes: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_enghealth_a11y_jan_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    cc_fd_db_top_editor_toolbar: (0, $749e4ec907f900af$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cc_fd_db_top_editor_toolbar'
        },
        param: 'cohort',
        values: [
            'control',
            'new-description',
            'orig-description'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-07-20
    platform_editor_fix_ai_streaming_race: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_ai_streaming_race'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    cc_page_experiences_editor_image_generation: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_page_experiences_editor_image_generation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-23
    'cc-maui-experiment': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc-maui-experiment',
            jira: 'jira_maui_remix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_maui_create_keyword: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_maui_create_keyword'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // A/A experiment paired with cc_maui_create_keyword, used only to balance exposures.
    cc_maui_create_keyword_aa: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_maui_create_keyword_aa'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-13
    confluence_native_tabs_experiment: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_native_tabs_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-07
    'cc-maui-overlay-by-localid': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc-maui-overlay-by-localid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-29
    cc_maui_polish_changes_batch_4: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_maui_polish_changes_batch_4'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    'cc-mui-slides-experiment': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc-mui-slides-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    confluence_frontend_cwr_outcome_type_picker: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_frontend_cwr_outcome_type_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    cfe_cwr_outcome_picker_respect_site_settings: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cfe_cwr_outcome_picker_respect_site_settings'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    prompt_tile_content_type_localizaiton: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'prompt_tile_content_type_localizaiton'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-24
    'cwr-modal-ui-refresh': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cwr-modal-ui-refresh'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-08
    'cc-disambiguation-in-cwr': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc-disambiguation-in-cwr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    'cwr-reduce-prompt-suggestion-max-chars': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cwr-reduce-prompt-suggestion-max-chars'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    'cwr-staging-area-close-as-minimize-button': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cwr-staging-area-close-as-minimize-button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-08
    cc_cwr_prompt_strength_indicator: (0, $749e4ec907f900af$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cc_cwr_prompt_strength_indicator'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-02-12
    platform_editor_a11y_escape_link_dialog: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_a11y_escape_link_dialog',
            jira: 'platform_editor_a11y_escape_link_dialog'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_panel_icon: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_panel_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-19
    platform_editor_flexible_list_indentation: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_flexible_list_indentation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_flexible_list_schema: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_flexible_list_schema'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_emoji_default_scale: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_emoji_default_scale',
            jira: 'platform_editor_emoji_default_scale'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-17
    platform_editor_emoji_hover_show_tooltip: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_emoji_hover_show_tooltip',
            jira: 'platform_editor_emoji_hover_show_tooltip'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_teamoji_26_refresh_emoji_picker: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_teamoji_26_refresh_emoji_picker',
            jira: 'platform_teamoji_26_refresh_emoji_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16
    platform_use_unicode_emojis: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_use_unicode_emojis_confluence',
            jira: 'platform_use_unicode_emojis_jira',
            bitbucket: 'platform_use_unicode_emojis_bitbucket'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-26
    platform_editor_toolbar_update_jira_config: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_toolbar_update_jira_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    platform_editor_appearance_shared_state: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_appearance_shared_state'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_ai_blockmenu_integration: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_blockmenu_integration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-26
    platform_editor_remix_in_block_menu: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_remix_in_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19 — fix table text length calculation for Remix/Improve Writing hero prompts
    remix_iw_block_menu_table_calc_fix: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'remix_iw_block_menu_table_calc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_rovobutton_smartlink_toolbar_exp: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_rovobutton_smartlink_toolbar_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_a11y_scrollable_region: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_a11y_scrollable_region'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    confluence_fe_renderer_inline_node_mark_color_fix: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_fe_renderer_inline_node_mark_color_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_small_font_size: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_small_font_size',
            jira: 'platform_editor_small_font_size'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_diff_plugin_extended: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_diff_plugin_extended'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_fix_media_toolbar_border_dropdown: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_media_toolbar_border_dropdown'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_single_player_expand: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_single_player_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_fit_to_content_on_demand: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_table_fit_to_content_on_demand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-09
    platform_editor_remove_collab_step_metrics: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_remove_collab_step_metrics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_ai_normalized_telemetry: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_normalized_telemetry'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_sync_block_ssr_config: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_sync_block_ssr_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-06
    confluence_fe_create_page_suggestion: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_fe_create_page_suggestion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-18
    platform_editor_selection_toolbar_block_handle: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_selection_toolbar_block_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    platform_editor_improve_preset_builder_logging: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_improve_preset_builder_logging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-23
    'cc-markdown-mode': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc-markdown-mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_ai_xstate_migration: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_xstate_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-31
    platform_editor_dnd_accessibility_fixes_expand: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_dnd_accessibility_fixes_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-15
    platform_editor_ai_no_stream_skip_pacer: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_no_stream_skip_pacer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-07
    platform_editor_layout_column_menu: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_layout_column_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-29
    platform_editor_layout_column_selection_fix: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_layout_column_selection_fix',
            jira: 'platform_editor_layout_column_selection_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    platform_editor_layout_column_valign_rendering: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_layout_column_valign_rendering'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21
    platform_editor_layout_typeahead_reorder: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_layout_typeahead_reorder',
            jira: 'platform_editor_layout_typeahead_reorder'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_editor_external_embed_grid_fix: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_external_embed_grid_fix',
            jira: 'platform_editor_external_embed_grid_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-08
    cc_fd_wb_jira_quick_insert_experiment: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            jira: 'cc_fd_wb_jira_quick_insert_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-30
    cc_fix_editor_context_on_cwr_followups: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_fix_editor_context_on_cwr_followups'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    cc_fix_ephemeral_preview_staging_area_registration: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_fix_ephemeral_preview_staging_area_registration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_hydration_skip_react_portal: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_hydration_skip_react_portal'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-28
    platform_editor_use_markdown_plus_parser: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_use_markdown_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_use_html_plus_parser: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_core_static_css: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_core_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_core_non_ecc_static_css: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_core_non_ecc_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_q4_loveability: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_table_q4_loveability',
            jira: 'platform_editor_table_q4_loveability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    platform_editor_table_menu_updates: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_table_menu_updates',
            jira: 'platform_editor_table_menu_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-06
    confluence_live_doc_table_sort_bugfix: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_live_doc_table_sort_bugfix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    confluence_fe_disable_comment_if_offline_fix: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_fe_disable_comment_if_offline_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-22
    platform_editor_korean_characters_split: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_korean_characters_split'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-09
    platform_editor_sync_block_activation: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_sync_block_activation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_paste_actions_menu_v2: (0, $749e4ec907f900af$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu_v2',
            jira: 'platform_editor_paste_actions_menu_v2'
        },
        param: 'variant',
        values: [
            'control',
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-01 — Social proof experiment for unauthorized 3P block cards
    social_proof_3p_unauth_block_exp: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'social_proof_3p_unauth_block_exp',
            jira: 'social_proof_3p_unauth_block_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_replace_doc/setup
    platform_editor_ai_replace_doc: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_replace_doc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-18
    platform_editor_nest_table_in_panel: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_nest_table_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_rovo_support_create_inline_comment: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_rovo_support_create_inline_comment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_fix_sticky_header_malfunction: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_malfunction'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    platform_editor_fix_sticky_header_row: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_row'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-10
    confluence_editor_paste_3p_link_actions_menu: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_editor_paste_3p_link_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-19
    platform_editor_ai_improve_formatting_toolbar: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_improve_formatting_toolbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-29
    'a11y-fixes-week3-may-2026': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'a11y-fixes-week3-may-2026',
            jira: 'a11y-fixes-week3-may-2026'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_reactions_selector_list: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_a11y_fixes_reactions_selector_list',
            jira: 'platform_a11y_fixes_reactions_selector_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_picker_list: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_picker_list',
            jira: 'platform_a11y_fixes_emoji_picker_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_a11y_fixes_emoji_title_shortname: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_a11y_fixes_emoji_title_shortname',
            jira: 'platform_a11y_fixes_emoji_title_shortname'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-25
    // HTML+ v2 incremental tool-call streaming contract — gates the new
    // PartialStreamParserV2 / ToolCallProcessorV2 / AdfChunkStrategyV2 stack
    // in `@atlassian/editor-rovo-bridge`, the `replaceValue` orchestrator
    // action, and the `toolCallsStreaming.supportsProvisionalToolCalls`
    // capability advert on `PageContentCommandResult`.
    platform_editor_use_html_plus_streaming_parser: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_streaming_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_wide_slash_trigger: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_wide_slash_trigger'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11 — [CCI-15904] New AIFC Editor Experience (Full Page Staging Area + Post Stream Review Toolbar)
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_new_aifc_editor_experience/setup
    platform_editor_ai_new_aifc_editor_experience: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_new_aifc_editor_experience'
        },
        param: 'isBackendReviewMomentEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    // Gates the `GhostIconWave` animation primitive in
    // `@atlassian/rovo-platform-ui-components` — rendered as a loading cue on
    // Confluence's 3p-in-CWR (Rovo) surfaces. When off the primitive renders
    // nothing.
    confluence_3p_in_cwr_ghost_icons: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_3p_in_cwr_ghost_icons'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    platform_editor_lovability_text_bg_color: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_text_bg_color',
            jira: 'platform_editor_lovability_text_bg_color'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-25
    platform_editor_fix_selection_text_color_change: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_selection_text_color_change',
            jira: 'platform_editor_fix_selection_text_color_change'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-20
    platform_editor_ssr_toolbar_optimistic: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ssr_toolbar_optimistic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19
    platform_editor_lovability_resize_dividers_panels: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_resize_dividers_panels'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-16
    platform_editor_add_breakout_marks_on_page_load: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_add_breakout_marks_on_page_load'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-23
    'aifc-confluence-editor-csp-fix': (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'aifc-confluence-editor-csp-fix',
            jira: 'aifc-confluence-editor-csp-fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-02
    platform_editor_media_download_fallback_name: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_media_download_fallback_name'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-01
    platform_editor_remove_pause_streaming: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_remove_pause_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-07-17
    revert_remix_ephemeral_iframe_sizing_fix: (0, $93a83582283f8934$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'revert_remix_ephemeral_iframe_sizing_fix',
            jira: 'revert_remix_ephemeral_iframe_sizing_fix'
        },
        param: 'value',
        defaultValue: false
    }),
    // Added 2026-07-28
    cwr_publish_flow_live_doc_toggle_exp: (0, $749e4ec907f900af$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cwr_publish_flow_live_doc_toggle_exp'
        },
        param: 'cohort',
        defaultValue: 'control',
        values: [
            'control',
            'variantA',
            'variantB',
            'variantC'
        ]
    })
};


const $44edcfb3318a5595$export$7e849a84a00ffd1c = {
    cwr_publish_flow_live_doc_toggle_exp: 'control',
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_controls: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_hover_card_preview_panel: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_table_sticky_header_improvements: 'test_with_overflow',
    cc_fd_db_top_editor_toolbar: 'control',
    platform_editor_paste_actions_menu_v2: 'control',
    cc_smarts_should_improve_writing_migration: 'control',
    confluence_quick_insert_embeds: 'control',
    cc_cwr_prompt_strength_indicator: 'control',
    confluence_cwr_3p_connection_suggested_prompts: 'control'
};
const $44edcfb3318a5595$export$54960937bb713f97 = {
    cc_maui_polish_changes_batch_4: false,
    social_proof_3p_unauth_block_exp: false,
    platform_sl_3p_preauth_better_hovercard: true,
    cwr_blank_object_experiment: false,
    platform_editor_preview_panel_responsiveness: false,
    'enghealth-53346_fix_redaction_marker_editor': false,
    platform_editor_toolbar_aifc: false,
    'test-new-experiments-package': false,
    platform_renderer_table_sticky_scrollbar: false,
    comment_on_bodied_extensions: false,
    advanced_layouts: false,
    single_column_layouts: false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_no_cursor_on_edit_page_init: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_paste_actions_menu: false,
    platform_editor_table_fit_to_content_on_demand: false,
    platform_editor_table_q4_loveability: false,
    platform_editor_table_menu_updates: false,
    'cwr-modal-ui-refresh': false,
    'cc-disambiguation-in-cwr': false,
    'cwr-reduce-prompt-suggestion-max-chars': false,
    'cwr-staging-area-close-as-minimize-button': false,
    prompt_tile_content_type_localizaiton: false,
    // [CCI-15904] New AIFC Editor Experience — AND-gated with
    // `platform_editor_ai_xstate_migration` (see `isNewAifcExperienceEnabled`
    // in `editor-plugin-ai/src/ui/utils/new-aifc-experience-enabled.ts`).
    // (afm-ai-pr-review-bot #2) The previous comment incorrectly referenced
    // `platform_editor_ai_replace_doc` as the AND partner; the unrelated
    // `platform_editor_ai_replace_doc: false` override has been removed since
    // it does not gate this feature.
    platform_editor_ai_new_aifc_editor_experience: false,
    cc_page_experiences_editor_image_generation: false,
    platform_use_unicode_emojis: false,
    platform_editor_emoji_hover_show_tooltip: false,
    'aifc-confluence-editor-csp-fix': false
};


let $533c87c482bbd949$export$e5d73bf4f8e2ae96 = {};
let $533c87c482bbd949$export$4e849416bb5c5b52 = {};
let $533c87c482bbd949$export$cf7305fc65acbf0d;
function $533c87c482bbd949$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $1eaa9a44197570d2$export$6cbb856f286b07ef)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $533c87c482bbd949$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !options?.disableTestOverrides) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        const testOverrides = Object.fromEntries(Object.entries((0, $1eaa9a44197570d2$export$6cbb856f286b07ef)).map(([key, value])=>{
            const defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                groupOverrides?.[key] ?? (0, $44edcfb3318a5595$export$7e849a84a00ffd1c)[key] ?? (0, $44edcfb3318a5595$export$54960937bb713f97)[key] ?? defaultValue
            ];
        }));
        $533c87c482bbd949$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $533c87c482bbd949$export$cf7305fc65acbf0d = product;
    $533c87c482bbd949$export$4e849416bb5c5b52 = paramOverrides || {};
}


var $1e5a54b682096899$export$2c20ffeba7dbc068 = /*#__PURE__*/ function(ExposureTriggerReason) {
    ExposureTriggerReason["OptIn"] = "optInExposure";
    ExposureTriggerReason["Manual"] = "manualExposure";
    ExposureTriggerReason["Default"] = "defaultExposure";
    ExposureTriggerReason["AutoExposure"] = "autoExposure";
    ExposureTriggerReason["hasCustomAttributes"] = "hasCustomAttributes";
    return ExposureTriggerReason;
}({});


const $dbc6af25ff4f0261$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object';
const $dbc6af25ff4f0261$export$8ed1df9dbe2e9a7d = (obj)=>{
    return obj ? Object.keys(obj).length === 0 : true;
};
const $dbc6af25ff4f0261$export$c7d37910dd25ecbf = (obj, attributes, identifier)=>{
    attributes.forEach((attribute)=>{
        if (!(attribute in obj)) {
            const title = identifier ? `${identifier}: ` : '';
            throw new Error(`${title}Missing ${attribute}`);
        }
    });
};
const $dbc6af25ff4f0261$export$891630e169ca14a4 = (customAttributes)=>{
    const reservedAttributes = [
        'flagKey',
        'ruleId',
        'reason',
        'value',
        'errorKind'
    ];
    const keys = customAttributes ? Object.keys(customAttributes) : [];
    if (reservedAttributes.some((attribute)=>keys.includes(attribute))) throw new TypeError(`exposureData contains a reserved attribute. Reserved attributes are: ${reservedAttributes.join(', ')}`);
};
const $dbc6af25ff4f0261$var$validateFlag = (flagKey, flag)=>{
    if ($dbc6af25ff4f0261$export$a6cdc56e425d0d0a(flag) && 'value' in flag) return true;
};
const $dbc6af25ff4f0261$export$410eec87ab950965 = (flags)=>{
    Object.keys(flags).forEach((key)=>$dbc6af25ff4f0261$var$validateFlag(key, flags[key]));
};


const $8bc23867ec57f542$export$933245d8afcc8872 = {
    kind: 'ERROR',
    errorKind: 'FLAG_NOT_FOUND'
};
class $8bc23867ec57f542$export$2e2bcd8739ae039 {
    evaluate(defaultValue) {
        return defaultValue;
    }
    getBooleanValue(options) {
        return this.evaluate(options.default);
    }
    getVariantValue(options) {
        return this.evaluate(options.default);
    }
    getJSONValue() {
        return this.evaluate({});
    }
    getRawValue(options) {
        return this.evaluate(options.default);
    }
    getFlagEvaluation(options) {
        const value = this.evaluate(options.default);
        return {
            value: value,
            explanation: $8bc23867ec57f542$export$933245d8afcc8872
        };
    }
    constructor(){
        // Unused but required for type
        this.evaluationCount = -1;
    }
}



class $866f8cb5ebc8e5ee$export$2e2bcd8739ae039 {
    getCachedResultOrCompute(defaultValue, { shouldTrackExposureEvent: shouldTrackExposureEvent, exposureData: exposureData, oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let exposureTriggerReason = (0, $1e5a54b682096899$export$2c20ffeba7dbc068).OptIn;
        if (shouldTrackExposureEvent === undefined) {
            shouldTrackExposureEvent = true;
            exposureTriggerReason = (0, $1e5a54b682096899$export$2c20ffeba7dbc068).Default;
        }
        // It is very common for products to call this method many times for the same flag key,
        // as flag evaluations are often done inside action callbacks and/or inside components with many instances.
        // We can cache the result of the first evaluation to avoid doing the same validation checks on every call.
        if (this.evaluationResult === undefined) this.evaluationResult = this.computeWithValidation(defaultValue, {
            oneOf: oneOf,
            ignoreTypes: ignoreTypes
        });
        let value = this.evaluationResult.value;
        if (this.evaluationResult.didFallbackToDefaultValue) // Use the default that was passed in, just in case it's different to what it was in the initial evaluation
        value = defaultValue;
        else if (shouldTrackExposureEvent) // For backwards compability, only fire the opt-in exposure event in valid evaluations.
        this.trackExposure(this.flagKey, this.flag, exposureTriggerReason, exposureData);
        this.sendAutomaticExposure(this.flagKey, value, this.evaluationResult.explanation);
        this.evaluationCount++;
        return {
            value: value,
            explanation: this.evaluationResult.explanation
        };
    }
    computeWithValidation(defaultValue, { oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let result = {
            value: this.flag.value,
            explanation: this.flag.explanation,
            didFallbackToDefaultValue: false
        };
        if (!ignoreTypes && typeof this.flag.value !== typeof defaultValue) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'WRONG_TYPE'
            };
        } else if (oneOf !== undefined && !oneOf.includes(this.flag.value)) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'VALIDATION_ERROR'
            };
        }
        return result;
    }
    getBooleanValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: undefined,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getVariantValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: options.oneOf,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getJSONValue() {
        return this.getCachedResultOrCompute({}, {
            shouldTrackExposureEvent: false,
            ignoreTypes: this.ignoreTypes
        }).value;
    }
    getRawValue(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            oneOf: undefined,
            ignoreTypes: true
        }).value;
    }
    getFlagEvaluation(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            ignoreTypes: this.ignoreTypes || false
        });
    }
    constructor(flagKey, flag, trackExposure, sendAutomaticExposure, ignoreTypes){
        this.evaluationCount = void 0;
        this.flagKey = void 0;
        this.flag = void 0;
        this.trackExposure = void 0;
        this.sendAutomaticExposure = void 0;
        this.ignoreTypes = void 0;
        // Makes the casting easier later on. The APIs should not leak any.
        // Should only be used in private functions.
        this.evaluationResult = void 0;
        this.flagKey = flagKey;
        this.flag = flag;
        this.evaluationCount = 0;
        this.trackExposure = trackExposure;
        this.sendAutomaticExposure = sendAutomaticExposure;
        this.ignoreTypes = ignoreTypes;
    }
}


class $c96835877545a2d9$export$2e2bcd8739ae039 {
    setFlags(flags) {
        if (!(0, $dbc6af25ff4f0261$export$a6cdc56e425d0d0a)(flags)) return;
        Object.entries(flags).forEach(([flagKey, flag])=>{
            this.flags.set(flagKey, flag);
        });
        // Clear any cached data for flags that have been passed in again,
        // in case they have different values or explanations
        for (const flagKey of this.flagWrapperCache.keys())if (flags.hasOwnProperty(flagKey)) this.flagWrapperCache.delete(flagKey);
    }
    setAnalyticsHandler(analyticsHandler) {
        this.analyticsHandler = analyticsHandler;
    }
    setIsAutomaticExposuresEnabled(isEnabled) {
        this.isAutomaticExposuresEnabled = isEnabled;
    }
    /**
   * This method returns the wrapper object for the given flag key.
   * If the flag does not exist, this will return a stubbed flag following the null-object pattern,
   * so it is always guaranteed to return an object.
   */ getFlagWrapper(flagKey) {
        let wrapper = this.flagWrapperCache.get(flagKey);
        if (wrapper !== undefined) return wrapper;
        const flag = this.flags.get(flagKey);
        if (flag) wrapper = new (0, $866f8cb5ebc8e5ee$export$2e2bcd8739ae039)(flagKey, flag, this._trackExposure.bind(this), this.sendAutomaticExposure.bind(this), this.ignoreTypes);
        else wrapper = new (0, $8bc23867ec57f542$export$2e2bcd8739ae039)();
        this.flagWrapperCache.set(flagKey, wrapper);
        return wrapper;
    }
    clear() {
        this.flags.clear();
        this.flagWrapperCache.clear();
        this.trackedFlags.clear();
    }
    getBooleanValue(flagKey, options) {
        (0, $dbc6af25ff4f0261$export$c7d37910dd25ecbf)(options, [
            'default'
        ], 'getBooleanValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getBooleanValue(options);
    }
    getVariantValue(flagKey, options) {
        (0, $dbc6af25ff4f0261$export$c7d37910dd25ecbf)(options, [
            'default',
            'oneOf'
        ], 'getVariantValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getVariantValue(options);
    }
    getJSONValue(flagKey) {
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getJSONValue();
    }
    getRawValue(flagKey, options) {
        (0, $dbc6af25ff4f0261$export$c7d37910dd25ecbf)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getRawValue(options);
    }
    getFlagEvaluation(flagKey, options) {
        (0, $dbc6af25ff4f0261$export$c7d37910dd25ecbf)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getFlagEvaluation(options);
    }
    /**
   * This method combines both the trackExposure and sendAutomaticExposure flows into
   * one endpoint. Depending on the passed in trigger reason a manual or automatic exposure
   * is sent.
   **/ trackFeatureFlag(flagKey, options = {}) {
        const triggerReason = options?.triggerReason ? options.triggerReason : (0, $1e5a54b682096899$export$2c20ffeba7dbc068).Manual;
        const isValueSet = this.flags.has(flagKey) || 'value' in options;
        if (!isValueSet) {
            // eslint-disable-next-line no-console
            console.warn(`No value associated with the flagKey: ${flagKey} with an exposure trigger reason of: ${triggerReason}`);
            return;
        }
        // if no values for flagValue and explanation supplied then retrieve them from the flags map
        const flagValue = 'value' in options ? options.value : this.flags.get(flagKey)?.value;
        const flagExplanation = options?.explanation ? options.explanation : this.flags.get(flagKey)?.explanation;
        if (triggerReason === (0, $1e5a54b682096899$export$2c20ffeba7dbc068).AutoExposure) this.sendAutomaticExposure(flagKey, flagValue, flagExplanation);
        else // default to fire a manual track exposure
        this._trackExposure(flagKey, {
            value: flagValue,
            explanation: flagExplanation
        }, triggerReason);
    }
    trackExposure(flagKey, flag, exposureData = {}) {
        return this._trackExposure(flagKey, flag, (0, $1e5a54b682096899$export$2c20ffeba7dbc068).Manual, exposureData);
    }
    _trackExposure(flagKey, flag, exposureTriggerReason, exposureData) {
        if (!(flag && flag.explanation && this.shouldSendEvent(flagKey, exposureData))) return;
        (0, $dbc6af25ff4f0261$export$891630e169ca14a4)(exposureData);
        const flagAttributes = {
            flagKey: flagKey,
            reason: flag.explanation.kind,
            ruleId: flag.explanation.ruleId,
            value: flag.value
        };
        this.sendExposureEvent(flagAttributes, exposureTriggerReason, exposureData);
    }
    shouldSendEvent(flagKey, customAttributes) {
        return this.analyticsHandler !== undefined && (!this.trackedFlags.has(flagKey) || !(0, $dbc6af25ff4f0261$export$8ed1df9dbe2e9a7d)(customAttributes) && !this.customAttributesExposuresCache.has(flagKey));
    }
    sendAutomaticExposure(flagKey, value, flagExplanation) {
        if (!(flagExplanation && this.isAutomaticExposuresEnabled && this.shouldSendEvent(flagKey))) return;
        const flagAttributes = {
            flagKey: flagKey,
            value: value,
            reason: flagExplanation.kind || 'SIMPLE_EVAL',
            // In theory this shouldnt be necessary
            ruleId: flagExplanation.ruleId,
            errorKind: flagExplanation.errorKind
        };
        this.sendExposureEvent(flagAttributes, (0, $1e5a54b682096899$export$2c20ffeba7dbc068).AutoExposure);
    }
    sendExposureEvent(attributes, exposureTriggerReason, customAttributes) {
        if (!this.trackedFlags.has(attributes.flagKey)) {
            const exposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: attributes,
                tags: [
                    'measurement',
                    exposureTriggerReason
                ],
                highPriority: false,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(exposureEvent);
            this.trackedFlags.add(attributes.flagKey);
        }
        // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
        // events. In order not to break existing users of this feature immediately, we're sending an
        // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
        // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
        if (!(0, $dbc6af25ff4f0261$export$8ed1df9dbe2e9a7d)(customAttributes)) {
            const customeAttributesExposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: Object.assign({}, attributes, customAttributes),
                tags: [
                    'measurement',
                    (0, $1e5a54b682096899$export$2c20ffeba7dbc068).hasCustomAttributes,
                    exposureTriggerReason
                ],
                highPriority: true,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(customeAttributesExposureEvent);
            this.customAttributesExposuresCache.add(attributes.flagKey);
        }
    }
    getFlagStats() {
        const flagStats = {};
        for (const [flagKey, wrapper] of this.flagWrapperCache){
            const { evaluationCount: evaluationCount } = wrapper;
            flagStats[flagKey] = {
                evaluationCount: evaluationCount
            };
        }
        return flagStats;
    }
    constructor(options){
        this.flags = void 0;
        this.flagWrapperCache = void 0;
        this.analyticsHandler = void 0;
        this.isAutomaticExposuresEnabled = void 0;
        this.trackedFlags = void 0;
        this.customAttributesExposuresCache = void 0;
        this.ignoreTypes = void 0;
        (0, $dbc6af25ff4f0261$export$c7d37910dd25ecbf)(options, [
            'analyticsHandler'
        ], 'Feature Flag Client');
        const { flags: flags, analyticsHandler: analyticsHandler, isAutomaticExposuresEnabled: isAutomaticExposuresEnabled, ignoreTypes: ignoreTypes } = options;
        this.flags = new Map();
        this.flagWrapperCache = new Map();
        this.customAttributesExposuresCache = new Set();
        this.trackedFlags = new Set();
        this.isAutomaticExposuresEnabled = isAutomaticExposuresEnabled || false;
        this.ignoreTypes = ignoreTypes || false;
        this.setFlags(flags || {});
        this.setAnalyticsHandler(analyticsHandler);
    }
}



function $7a55ff9c881e37e5$export$30a0bf30ea993fb(value) {
    if (value === 'true') return true;
    else if (value === 'false') return false;
    else if (typeof value === 'object') return JSON.stringify(value);
    return value;
}
function $7a55ff9c881e37e5$export$254798ec7ef71406(objectList, valueGetter) {
    return objectList.reduce((keyedObject, item)=>{
        keyedObject[item.id] = valueGetter(item);
        return keyedObject;
    }, {});
}
const $7a55ff9c881e37e5$export$b474714fac955e7c = (flags)=>{
    return $7a55ff9c881e37e5$export$254798ec7ef71406(flags, (item)=>$7a55ff9c881e37e5$export$30a0bf30ea993fb(item.value));
};


function $f1239c91f558df40$var$normalizeValue(rawValue) {
    if (typeof rawValue === 'object' && 'value' in rawValue) return {
        ...rawValue.explanation ? {
            explanation: {
                ...rawValue.explanation
            }
        } : {},
        value: (0, $7a55ff9c881e37e5$export$30a0bf30ea993fb)(rawValue.value)
    };
    else return {
        value: (0, $7a55ff9c881e37e5$export$30a0bf30ea993fb)(rawValue),
        explanation: undefined
    };
}
const $f1239c91f558df40$var$noopAnalyticsHandler = {
    sendOperationalEvent: (_event)=>Promise.resolve()
};
const $f1239c91f558df40$export$8c9b5e98a87ea54c = (0, $aLoS2.default)((flags, platformFlags)=>{
    const normalizedFeatureFlags = flags ? (0, $7a55ff9c881e37e5$export$254798ec7ef71406)(flags, $f1239c91f558df40$var$normalizeValue) : {};
    const normalizedPlatformFeatureFlags = platformFlags != null ? (0, $7a55ff9c881e37e5$export$254798ec7ef71406)(platformFlags, $f1239c91f558df40$var$normalizeValue) : {};
    Object.assign(normalizedFeatureFlags, normalizedPlatformFeatureFlags);
    const featureFlagClient = new (0, $c96835877545a2d9$export$2e2bcd8739ae039)({
        flags: normalizedFeatureFlags,
        analyticsHandler: $f1239c91f558df40$var$noopAnalyticsHandler
    });
    // This sets up tooling for the editor experiments
    (0, $533c87c482bbd949$export$1c2b6dbf79eb3560)('confluence');
    // This sets up the platform feature flags
    (0, $e9be8c7cd5545b25$export$ba05d765b8392e5e)((flagKey)=>{
        // eslint-disable-next-line confluence-feature-gating/static-feature-gates
        if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)(flagKey)) return true;
        return false;
    });
    const allFlags = flags.concat(platformFlags);
    const original = (0, $7a55ff9c881e37e5$export$b474714fac955e7c)(allFlags);
    return {
        originalFeatureFlags: original,
        featureFlagsWithOverrides: original,
        featureFlagClient: featureFlagClient
    };
});


const $2800afeb4fc22c91$export$3aa1d70b86d65666 = ()=>$2800afeb4fc22c91$export$48ea97dcec207a60(null);
function $2800afeb4fc22c91$export$48ea97dcec207a60(data) {
    const { originalFeatureFlags: originalFeatureFlags, featureFlagsWithOverrides: featureFlagsWithOverrides, featureFlagClient: featureFlagClient } = (0, $f1239c91f558df40$export$8c9b5e98a87ea54c)([], []);
    // nullability of `tenant` is probably a schema issue
    // `userForAnalytics.id` would probably never be null, follow up with Xiao
    const confluenceLocale = data?.user?.confluence?.locale?.replace('_', '-');
    return {
        shard: data?.tenant?.shard || '',
        cloudId: data?.tenant?.cloudId || '',
        activationId: data?.tenant?.activationId || '',
        orgId: data?.organization?.orgId || undefined,
        environment: data?.tenant?.environment || 'PRODUCTION',
        edition: data?.confluence_tenantContext?.editions?.confluence || null,
        entitlementId: data?.confluence_tenantContext?.licenseStates?.confluence?.ccpEntitlementId || null,
        userId: data?.user?.id || null,
        displayName: data?.user?.displayName || null,
        isLoggedIn: Boolean(data?.user?.id),
        // CCP-472: This is for JSD users who are unlicensed for
        // Confluence usage. In that case, we need to skip
        // `WatchDialogQuery` as they are causing NullPointerExceptions
        // in the BE.
        isLicensed: Boolean(data?.user?.confluence?.accountId && data?.user?.confluence?.userKey),
        accessStatus: data?.user?.confluence?.accessStatus || null,
        userIdForAnalytics: data?.userForAnalytics?.id || null,
        featureFlags: featureFlagsWithOverrides,
        featureFlagClient: featureFlagClient,
        _originalFeatureFlags: originalFeatureFlags,
        locale: confluenceLocale || 'en-US',
        timeZone: data?.user?.timeZone || null,
        tenantTimeZone: data?.confluence_tenantContext?.timeZone || null,
        tenantBaseUrl: data?.confluence_tenantContext?.baseUrl || null,
        isAdminHubAIEnabled: Boolean(data?.getAIConfig?.isEnabled),
        isRovoEnabled: Boolean(data?.getAIConfig?.isRovoEnabled),
        isRovoLLMEnabled: Boolean(data?.getAIConfig?.isRovoLLMEnabled),
        isAIEarlyAccessEnabled: Boolean(data?.getAIConfig?.isAIEarlyAccessEnabled),
        isAtlassianHostedLLMOnlyEnabled: Boolean(data?.getAIConfig?.isAtlassianHostedLLMOnlyEnabled),
        monolithRegion: data?.confluence_tenantContext?.monolithRegion || null,
        isHideTitleInUrl: Boolean(data?.siteSettings?.isHideTitleInUrl)
    };
}



var $212659139b40e729$exports = {};
/**
 * Relay v20.1.1
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
$212659139b40e729$exports = (parcelRequire("bQ0TW"));



var $5ohfX = parcelRequire("5ohfX");

const $97465b9cc2c6882c$var$errorCollector = new Map();
const $97465b9cc2c6882c$export$da396ad2a542b095 = 120000; // 2min
const $97465b9cc2c6882c$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $97465b9cc2c6882c$var$errorCollector.delete(key);
    }, $97465b9cc2c6882c$export$da396ad2a542b095);
};
const $97465b9cc2c6882c$export$c211170518c6d0f6 = (key = (0, $b9a40c449374f876$exports.v4)())=>{
    $97465b9cc2c6882c$var$errorCollector.set(key, []);
    $97465b9cc2c6882c$var$scheduleCleanup(key);
    return key;
};
const $97465b9cc2c6882c$export$e0491a0d974dadfa = (key)=>{
    const errors = $97465b9cc2c6882c$var$errorCollector.get(key);
    $97465b9cc2c6882c$var$errorCollector.delete(key);
    return errors || [];
};
const $97465b9cc2c6882c$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $97465b9cc2c6882c$var$errorCollector.forEach((value, key)=>{
        $97465b9cc2c6882c$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $97465b9cc2c6882c$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};
const $97465b9cc2c6882c$export$60fba4117567a49b = (errors)=>{
    const stepUpError = errors.find((error)=>error.message.startsWith('Step-up authentication is required.') && error.extensions?.statusCode === 303 && error.extensions?.stepUpUrl);
    return {
        hasStepUpAuthError: !!stepUpError,
        stepUpUrl: stepUpError?.extensions?.stepUpUrl ?? undefined
    };
};



/**
 * Executes the operation through the Relay **network layer** rather than the environment, which is
 * what skips normalization. Going through `getNetwork()` instead of raw `fetch` deliberately keeps
 * everything the network layer provides: auth, `StatusCodeRetryMiddleware`, batching,
 * network-status middleware, tracing, GraphQL error capture (`captureErrors` runs in the batch
 * fetcher), and the SSR response replay in `readDataFromStream` — so a bypassed operation still
 * reuses SSR-streamed data instead of issuing a second request. Only the normalizer is skipped.
 */ const $236a0479de2086e5$var$executeWithoutStore = (environment, query, variables, options)=>{
    const request = (0, $5ohfX.getRequest)(query);
    return environment.getNetwork().execute(request.params, variables ?? {}, options?.networkCacheConfig ?? {}, null).map((response)=>{
        // `@defer`/`@stream` operations emit multiple payloads, and the subscriber below completes
        // on the first one, so incremental fragments would be dropped. None of the current
        // `'no-store'` callers use them; revisit here if that changes.
        const singular = Array.isArray(response) ? response[0] : response;
        return singular?.data;
    });
};
const $236a0479de2086e5$export$74e68cf219d434a7 = (environment, query, variables, options, errorPolicyOptions)=>{
    const errorPolicy = errorPolicyOptions?.errorPolicy ?? 'none';
    const operationName = query.params.name;
    const errorCollector = (0, $97465b9cc2c6882c$export$c211170518c6d0f6)();
    // The error-policy handling below is identical either way: `captureErrors` runs in the network
    // layer, so GraphQL errors are collected even when the normalizer is skipped.
    const source = errorPolicyOptions?.noStore ? $236a0479de2086e5$var$executeWithoutStore(environment, query, variables, options) : (0, $212659139b40e729$exports.fetchQuery)(environment, query, variables, options);
    return (0, $5ohfX.Observable).create((sink)=>{
        source.subscribe({
            next: (data)=>{
                const errors = (0, $97465b9cc2c6882c$export$e0491a0d974dadfa)(errorCollector);
                const graphQLErrors = errors.filter((error)=>error.meta.operationName === operationName).flatMap((e)=>e.errors);
                if (graphQLErrors.length > 0) {
                    const error = new (0, $a73698f3e4fe6cd8$export$3ad5d0415dc12c65)({
                        graphQLErrors: graphQLErrors
                    });
                    if (errorPolicy === 'ignore') {
                        sink.next({
                            data: data
                        });
                        sink.complete();
                        return;
                    }
                    if (errorPolicy === 'all') {
                        sink.next({
                            data: data,
                            error: error
                        });
                        sink.complete();
                        return;
                    }
                    sink.error(error);
                    return;
                }
                sink.next({
                    data: data
                });
                sink.complete();
            },
            error: (error)=>{
                sink.error(error);
            },
            complete: ()=>{
                sink.complete();
            }
        });
    });
};
const $236a0479de2086e5$export$a1c549e76b7f385e = (...args)=>{
    return (0, $5ohfX.Observable).create((sink)=>{
        $236a0479de2086e5$export$74e68cf219d434a7(...args).subscribe({
            next: ({ data: data })=>{
                sink.next(data);
                sink.complete();
            },
            error: (error)=>{
                sink.error(error);
            },
            complete: ()=>{
                sink.complete();
            }
        });
    });
};


function $dd65965b7034d4a1$export$fb4bac2a1144dc5a(fetchPolicy) {
    switch(fetchPolicy){
        case 'no-cache':
        case 'network-only':
        case 'cache-and-network':
        // 'no-store' additionally suppresses the store write, which a Relay fetch policy cannot
        // express — `isNoStoreFetchPolicy` drives that separately. The policy itself only has to
        // guarantee the network round trip.
        case 'no-store':
            // Map to 'network-only' to preserve the mandatory network refetch.
            // The cached-data-first behaviour can't be expressed here.
            return 'network-only';
        case 'cache-first':
        case 'cache-only':
        case 'standby':
        default:
            return 'store-or-network';
    }
}
function $dd65965b7034d4a1$export$620d34b8241c453e(fetchPolicy) {
    return fetchPolicy === 'no-store';
}


async function $fe53f802bdf7b7dd$export$a0256de6700e2ad9({ environment: environment, query: query, variables: variables, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy, context: context }) {
    const result = await (0, $236a0479de2086e5$export$74e68cf219d434a7)(environment, query, variables, {
        fetchPolicy: (0, $dd65965b7034d4a1$export$fb4bac2a1144dc5a)(fetchPolicy),
        networkCacheConfig: {
            metadata: context
        }
    }, {
        errorPolicy: errorPolicy,
        noStore: (0, $dd65965b7034d4a1$export$620d34b8241c453e)(fetchPolicy)
    }).toPromise();
    return {
        data: result?.data,
        error: result?.error
    };
}



var $3ihMw = parcelRequire("3ihMw");

const $ef003bca5ae3d837$var$DEFAULT_ENABLED_PARAM = 'isEnabled';
function $ef003bca5ae3d837$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    // Check if the CRITERION override mechanism is available
    if (typeof globalThis?.window?.__CRITERION__?.getExperimentValueOverride === 'function') {
        const overrideValue = globalThis.window.__CRITERION__.getExperimentValueOverride(experimentName, param);
        if (overrideValue !== undefined && overrideValue !== null) {
            (0, $cf5258fb0d237fac$export$47fade9662f71000)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
    }
    // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
    const value = (0, $3ihMw.default).getExperimentValue(experimentName, param, defaultValue);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $cf5258fb0d237fac$export$47fade9662f71000)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
function $ef003bca5ae3d837$export$da472ee01c19d92e(experimentName, param, defaultValue) {
    // Check if the CRITERION override mechanism is available
    if (typeof globalThis?.window?.__CRITERION__?.getExperimentValueOverride === 'function') {
        const overrideValue = globalThis.window.__CRITERION__.getExperimentValueOverride(experimentName, param);
        if (overrideValue !== undefined && overrideValue !== null) {
            (0, $cf5258fb0d237fac$export$47fade9662f71000)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
    }
    // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
    const value = (0, $3ihMw.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: false
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $cf5258fb0d237fac$export$47fade9662f71000)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
function $ef003bca5ae3d837$export$45abdb3f977b5b14(experimentName, param, comparatorValue) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $ef003bca5ae3d837$export$9db1624a8af791a4(experimentName, param, null) === comparatorValue;
}
function $ef003bca5ae3d837$export$d9ae946a42fe8ba9(experimentName, param, comparatorValue) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $ef003bca5ae3d837$export$da472ee01c19d92e(experimentName, param, null) === comparatorValue;
}
function $ef003bca5ae3d837$export$d14de861476c5d7c(experimentName) {
    (0, $3ihMw.default).manuallyLogExperimentExposure(experimentName);
}
function $ef003bca5ae3d837$export$336b018592dc9972(experimentName) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $ef003bca5ae3d837$export$45abdb3f977b5b14(experimentName, $ef003bca5ae3d837$var$DEFAULT_ENABLED_PARAM, true);
}
function $ef003bca5ae3d837$export$9a4bf900b9ee892d(experimentName) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $ef003bca5ae3d837$export$d9ae946a42fe8ba9(experimentName, $ef003bca5ae3d837$var$DEFAULT_ENABLED_PARAM, true);
}
class $ef003bca5ae3d837$var$ExperimentConfig {
    get(key, defaultValue, typeGuard) {
        // Check if the CRITERION override mechanism is available
        if (window && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            const overrideValue = window.__CRITERION__.getExperimentValueOverride(this._experimentName, key);
            if (overrideValue !== undefined && overrideValue !== null) {
                (0, $cf5258fb0d237fac$export$47fade9662f71000)(`${this._experimentName}:${key}`, overrideValue);
                return overrideValue;
            }
        }
        const value = this._config.get(key, defaultValue, typeGuard);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $cf5258fb0d237fac$export$47fade9662f71000)(`${this._experimentName}:${key}`, value);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return value;
    }
    constructor(experimentName, config){
        this._experimentName = void 0;
        this._config = void 0;
        this._experimentName = experimentName;
        this._config = config;
    }
}
const $ef003bca5ae3d837$var$cache = new Map();
function $ef003bca5ae3d837$export$677f9fa2e1ae6fec(experimentName) {
    let instance = $ef003bca5ae3d837$var$cache.get(experimentName);
    if (instance == null) {
        const config = (0, $3ihMw.default).getExperiment(experimentName, {
            fireExperimentExposure: false
        });
        const fireExposure = ()=>(0, $3ihMw.default).manuallyLogExperimentExposure(experimentName);
        instance = [
            new $ef003bca5ae3d837$var$ExperimentConfig(experimentName, config),
            fireExposure
        ];
        $ef003bca5ae3d837$var$cache.set(experimentName, instance);
    }
    return instance;
}



var $362db24ca11e535b$exports = {};
var $1962c69abbc7e350$exports = {};
$parcel$export($1962c69abbc7e350$exports, "setErrorMap", () => $1962c69abbc7e350$export$1097a8289cfd22d7);
$parcel$export($1962c69abbc7e350$exports, "getErrorMap", () => $1962c69abbc7e350$export$32f27c719778d4c4);
$parcel$export($1962c69abbc7e350$exports, "defaultErrorMap", () => $81a8f18f24f6faa1$export$2e2bcd8739ae039);
var $c5464aefb6655c5b$exports = {};
$parcel$export($c5464aefb6655c5b$exports, "ZodIssueCode", () => $c5464aefb6655c5b$export$5ba560653e4a1035);
$parcel$export($c5464aefb6655c5b$exports, "quotelessJson", () => $c5464aefb6655c5b$export$913eddeaf297cfea);
$parcel$export($c5464aefb6655c5b$exports, "ZodError", () => $c5464aefb6655c5b$export$f98dac4b251ab333);
var $4a20734f269c1104$exports = {};
$parcel$export($4a20734f269c1104$exports, "util", () => $4a20734f269c1104$export$7debb50ef11d5e0b);
$parcel$export($4a20734f269c1104$exports, "objectUtil", () => $4a20734f269c1104$export$4aa2142c225fd5c7);
$parcel$export($4a20734f269c1104$exports, "ZodParsedType", () => $4a20734f269c1104$export$5716da67bfaa244d);
$parcel$export($4a20734f269c1104$exports, "getParsedType", () => $4a20734f269c1104$export$3e9057828ebd5c7a);
var $4a20734f269c1104$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (_)=>{};
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($4a20734f269c1104$export$7debb50ef11d5e0b || ($4a20734f269c1104$export$7debb50ef11d5e0b = {}));
var $4a20734f269c1104$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($4a20734f269c1104$export$4aa2142c225fd5c7 || ($4a20734f269c1104$export$4aa2142c225fd5c7 = {}));
const $4a20734f269c1104$export$5716da67bfaa244d = $4a20734f269c1104$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $4a20734f269c1104$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $4a20734f269c1104$export$5716da67bfaa244d.undefined;
        case "string":
            return $4a20734f269c1104$export$5716da67bfaa244d.string;
        case "number":
            return Number.isNaN(data) ? $4a20734f269c1104$export$5716da67bfaa244d.nan : $4a20734f269c1104$export$5716da67bfaa244d.number;
        case "boolean":
            return $4a20734f269c1104$export$5716da67bfaa244d.boolean;
        case "function":
            return $4a20734f269c1104$export$5716da67bfaa244d.function;
        case "bigint":
            return $4a20734f269c1104$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $4a20734f269c1104$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $4a20734f269c1104$export$5716da67bfaa244d.array;
            if (data === null) return $4a20734f269c1104$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $4a20734f269c1104$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $4a20734f269c1104$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $4a20734f269c1104$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $4a20734f269c1104$export$5716da67bfaa244d.date;
            return $4a20734f269c1104$export$5716da67bfaa244d.object;
        default:
            return $4a20734f269c1104$export$5716da67bfaa244d.unknown;
    }
};


const $c5464aefb6655c5b$export$5ba560653e4a1035 = (0, $4a20734f269c1104$export$7debb50ef11d5e0b).arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $c5464aefb6655c5b$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $c5464aefb6655c5b$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $c5464aefb6655c5b$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, (0, $4a20734f269c1104$export$7debb50ef11d5e0b).jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            const firstEl = sub.path[0];
            fieldErrors[firstEl] = fieldErrors[firstEl] || [];
            fieldErrors[firstEl].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
}
$c5464aefb6655c5b$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $c5464aefb6655c5b$export$f98dac4b251ab333(issues);
    return error;
};



const $81a8f18f24f6faa1$var$errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type:
            if (issue.received === (0, $4a20734f269c1104$export$5716da67bfaa244d).undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, (0, $4a20734f269c1104$export$7debb50ef11d5e0b).jsonStringifyReplacer)}`;
            break;
        case (0, $c5464aefb6655c5b$export$5ba560653e4a1035).unrecognized_keys:
            message = `Unrecognized key(s) in object: ${(0, $4a20734f269c1104$export$7debb50ef11d5e0b).joinValues(issue.keys, ", ")}`;
            break;
        case (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_union:
            message = `Invalid input`;
            break;
        case (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${(0, $4a20734f269c1104$export$7debb50ef11d5e0b).joinValues(issue.options)}`;
            break;
        case (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_enum_value:
            message = `Invalid enum value. Expected ${(0, $4a20734f269c1104$export$7debb50ef11d5e0b).joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_return_type:
            message = `Invalid function return type`;
            break;
        case (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_date:
            message = `Invalid date`;
            break;
        case (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else (0, $4a20734f269c1104$export$7debb50ef11d5e0b).assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "bigint") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case (0, $c5464aefb6655c5b$export$5ba560653e4a1035).custom:
            message = `Invalid input`;
            break;
        case (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case (0, $c5464aefb6655c5b$export$5ba560653e4a1035).not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case (0, $c5464aefb6655c5b$export$5ba560653e4a1035).not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            (0, $4a20734f269c1104$export$7debb50ef11d5e0b).assertNever(issue);
    }
    return {
        message: message
    };
};
var $81a8f18f24f6faa1$export$2e2bcd8739ae039 = $81a8f18f24f6faa1$var$errorMap;


let $1962c69abbc7e350$var$overrideErrorMap = (0, $81a8f18f24f6faa1$export$2e2bcd8739ae039);
function $1962c69abbc7e350$export$1097a8289cfd22d7(map) {
    $1962c69abbc7e350$var$overrideErrorMap = map;
}
function $1962c69abbc7e350$export$32f27c719778d4c4() {
    return $1962c69abbc7e350$var$overrideErrorMap;
}


var $b5e9dbcf321fac0a$exports = {};
$parcel$export($b5e9dbcf321fac0a$exports, "makeIssue", () => $b5e9dbcf321fac0a$export$244a85fde9c419ed);
$parcel$export($b5e9dbcf321fac0a$exports, "EMPTY_PATH", () => $b5e9dbcf321fac0a$export$1526d2e05f74572);
$parcel$export($b5e9dbcf321fac0a$exports, "addIssueToContext", () => $b5e9dbcf321fac0a$export$db7caee60e5d514d);
$parcel$export($b5e9dbcf321fac0a$exports, "ParseStatus", () => $b5e9dbcf321fac0a$export$5b20a5c3d05c1f6f);
$parcel$export($b5e9dbcf321fac0a$exports, "INVALID", () => $b5e9dbcf321fac0a$export$9a105a556e65c2c0);
$parcel$export($b5e9dbcf321fac0a$exports, "DIRTY", () => $b5e9dbcf321fac0a$export$325a211da9693fcf);
$parcel$export($b5e9dbcf321fac0a$exports, "OK", () => $b5e9dbcf321fac0a$export$c6813a8d51f77eaf);
$parcel$export($b5e9dbcf321fac0a$exports, "isAborted", () => $b5e9dbcf321fac0a$export$afa861e3c5730743);
$parcel$export($b5e9dbcf321fac0a$exports, "isDirty", () => $b5e9dbcf321fac0a$export$910b6cdd390341b3);
$parcel$export($b5e9dbcf321fac0a$exports, "isValid", () => $b5e9dbcf321fac0a$export$1ea939691cdc45b8);
$parcel$export($b5e9dbcf321fac0a$exports, "isAsync", () => $b5e9dbcf321fac0a$export$aefee5ebe1dcfd9e);


const $b5e9dbcf321fac0a$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $b5e9dbcf321fac0a$export$1526d2e05f74572 = [];
function $b5e9dbcf321fac0a$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = (0, $1962c69abbc7e350$export$32f27c719778d4c4)();
    const issue = $b5e9dbcf321fac0a$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === (0, $81a8f18f24f6faa1$export$2e2bcd8739ae039) ? undefined : (0, $81a8f18f24f6faa1$export$2e2bcd8739ae039)
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $b5e9dbcf321fac0a$export$5b20a5c3d05c1f6f {
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $b5e9dbcf321fac0a$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
    constructor(){
        this.value = "valid";
    }
}
const $b5e9dbcf321fac0a$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $b5e9dbcf321fac0a$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $b5e9dbcf321fac0a$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $b5e9dbcf321fac0a$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $b5e9dbcf321fac0a$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $b5e9dbcf321fac0a$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $b5e9dbcf321fac0a$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;


var $f46b546b674f8528$exports = {};



var $f74f9c617b22a60f$exports = {};
$parcel$export($f74f9c617b22a60f$exports, "ZodType", () => $f74f9c617b22a60f$export$2afb8ab49d4b92c0);
$parcel$export($f74f9c617b22a60f$exports, "ZodEffects", () => $f74f9c617b22a60f$export$a60af00cc0ce2582);
$parcel$export($f74f9c617b22a60f$exports, "ZodFirstPartyTypeKind", () => $f74f9c617b22a60f$export$558106ce543bd011);
$parcel$export($f74f9c617b22a60f$exports, "ZodOptional", () => $f74f9c617b22a60f$export$aa56fec1e9d629b8);
$parcel$export($f74f9c617b22a60f$exports, "ZodNullable", () => $f74f9c617b22a60f$export$aaac0b8b429cef5);
$parcel$export($f74f9c617b22a60f$exports, "ZodArray", () => $f74f9c617b22a60f$export$7acfc3e64785411);
$parcel$export($f74f9c617b22a60f$exports, "ZodPromise", () => $f74f9c617b22a60f$export$3f196b0127d6e50a);
$parcel$export($f74f9c617b22a60f$exports, "ZodUnion", () => $f74f9c617b22a60f$export$a8b236cb5070a311);
$parcel$export($f74f9c617b22a60f$exports, "ZodIntersection", () => $f74f9c617b22a60f$export$c02deaf0bb5203d4);
$parcel$export($f74f9c617b22a60f$exports, "ZodDefault", () => $f74f9c617b22a60f$export$bb19b37874861e7e);
$parcel$export($f74f9c617b22a60f$exports, "ZodBranded", () => $f74f9c617b22a60f$export$66b0c798a395271f);
$parcel$export($f74f9c617b22a60f$exports, "ZodCatch", () => $f74f9c617b22a60f$export$75a44ec6249ac76b);
$parcel$export($f74f9c617b22a60f$exports, "ZodPipeline", () => $f74f9c617b22a60f$export$a3c3ef8a0e95c6da);
$parcel$export($f74f9c617b22a60f$exports, "ZodReadonly", () => $f74f9c617b22a60f$export$5d1f7ef05c4e493a);
$parcel$export($f74f9c617b22a60f$exports, "datetimeRegex", () => $f74f9c617b22a60f$export$a4b563879add27a);
$parcel$export($f74f9c617b22a60f$exports, "ZodString", () => $f74f9c617b22a60f$export$1230eb29b8d3b502);
$parcel$export($f74f9c617b22a60f$exports, "ZodNumber", () => $f74f9c617b22a60f$export$5b070a55c0c43e09);
$parcel$export($f74f9c617b22a60f$exports, "ZodBigInt", () => $f74f9c617b22a60f$export$67d741fd70ff98f4);
$parcel$export($f74f9c617b22a60f$exports, "ZodBoolean", () => $f74f9c617b22a60f$export$723d146f80596191);
$parcel$export($f74f9c617b22a60f$exports, "ZodDate", () => $f74f9c617b22a60f$export$e974be33bdc55521);
$parcel$export($f74f9c617b22a60f$exports, "ZodSymbol", () => $f74f9c617b22a60f$export$bcc3b40f6b638044);
$parcel$export($f74f9c617b22a60f$exports, "ZodUndefined", () => $f74f9c617b22a60f$export$4e780e961c30340d);
$parcel$export($f74f9c617b22a60f$exports, "ZodNull", () => $f74f9c617b22a60f$export$a96281f914484f2d);
$parcel$export($f74f9c617b22a60f$exports, "ZodAny", () => $f74f9c617b22a60f$export$b9d1edb536b4e4eb);
$parcel$export($f74f9c617b22a60f$exports, "ZodUnknown", () => $f74f9c617b22a60f$export$ef3b1bb1630977ae);
$parcel$export($f74f9c617b22a60f$exports, "ZodNever", () => $f74f9c617b22a60f$export$1e576a20c3ce9fb5);
$parcel$export($f74f9c617b22a60f$exports, "ZodVoid", () => $f74f9c617b22a60f$export$7d39f5df85f21031);
$parcel$export($f74f9c617b22a60f$exports, "ZodObject", () => $f74f9c617b22a60f$export$736315c5b55efbad);
$parcel$export($f74f9c617b22a60f$exports, "ZodTuple", () => $f74f9c617b22a60f$export$e2a18bb771d8e6a3);
$parcel$export($f74f9c617b22a60f$exports, "ZodLazy", () => $f74f9c617b22a60f$export$378d0cfce37406e6);
$parcel$export($f74f9c617b22a60f$exports, "ZodLiteral", () => $f74f9c617b22a60f$export$7e44096782a165d3);
$parcel$export($f74f9c617b22a60f$exports, "ZodEnum", () => $f74f9c617b22a60f$export$d325d1f0e1c20179);
$parcel$export($f74f9c617b22a60f$exports, "ZodNativeEnum", () => $f74f9c617b22a60f$export$370b2e8d6d6f5c56);
$parcel$export($f74f9c617b22a60f$exports, "ZodDiscriminatedUnion", () => $f74f9c617b22a60f$export$5ef2424805ac76a3);
$parcel$export($f74f9c617b22a60f$exports, "ZodRecord", () => $f74f9c617b22a60f$export$a2acc09968cb4b7f);
$parcel$export($f74f9c617b22a60f$exports, "ZodMap", () => $f74f9c617b22a60f$export$163b6a2b712d9542);
$parcel$export($f74f9c617b22a60f$exports, "ZodSet", () => $f74f9c617b22a60f$export$977057706f816712);
$parcel$export($f74f9c617b22a60f$exports, "ZodFunction", () => $f74f9c617b22a60f$export$d4602ba55673f53c);
$parcel$export($f74f9c617b22a60f$exports, "ZodTransformer", () => $f74f9c617b22a60f$export$a60af00cc0ce2582);
$parcel$export($f74f9c617b22a60f$exports, "ZodNaN", () => $f74f9c617b22a60f$export$26ccfa0145e8511f);
$parcel$export($f74f9c617b22a60f$exports, "BRAND", () => $f74f9c617b22a60f$export$cf2deea74cde46b4);
$parcel$export($f74f9c617b22a60f$exports, "custom", () => $f74f9c617b22a60f$export$4c00f665f0d4b443);
$parcel$export($f74f9c617b22a60f$exports, "Schema", () => $f74f9c617b22a60f$export$2afb8ab49d4b92c0);
$parcel$export($f74f9c617b22a60f$exports, "ZodSchema", () => $f74f9c617b22a60f$export$2afb8ab49d4b92c0);
$parcel$export($f74f9c617b22a60f$exports, "late", () => $f74f9c617b22a60f$export$1ee8ee30835eab8b);
$parcel$export($f74f9c617b22a60f$exports, "instanceof", () => $f74f9c617b22a60f$export$3d916e7c22dbd8b5);
$parcel$export($f74f9c617b22a60f$exports, "string", () => $f74f9c617b22a60f$export$22b082955e083ec3);
$parcel$export($f74f9c617b22a60f$exports, "number", () => $f74f9c617b22a60f$export$98e628dec113755e);
$parcel$export($f74f9c617b22a60f$exports, "nan", () => $f74f9c617b22a60f$export$9e06de0973666692);
$parcel$export($f74f9c617b22a60f$exports, "bigint", () => $f74f9c617b22a60f$export$a0f65b52274bcc00);
$parcel$export($f74f9c617b22a60f$exports, "boolean", () => $f74f9c617b22a60f$export$4a21f16c33752377);
$parcel$export($f74f9c617b22a60f$exports, "date", () => $f74f9c617b22a60f$export$324d90190a8b822a);
$parcel$export($f74f9c617b22a60f$exports, "symbol", () => $f74f9c617b22a60f$export$8f701197936bc2a6);
$parcel$export($f74f9c617b22a60f$exports, "undefined", () => $f74f9c617b22a60f$export$1db45310990710a5);
$parcel$export($f74f9c617b22a60f$exports, "null", () => $f74f9c617b22a60f$export$7b1b591b262c240);
$parcel$export($f74f9c617b22a60f$exports, "any", () => $f74f9c617b22a60f$export$4154a199d7d90455);
$parcel$export($f74f9c617b22a60f$exports, "unknown", () => $f74f9c617b22a60f$export$19282c40b967aec6);
$parcel$export($f74f9c617b22a60f$exports, "never", () => $f74f9c617b22a60f$export$b3e22bcfd64c1022);
$parcel$export($f74f9c617b22a60f$exports, "void", () => $f74f9c617b22a60f$export$490e536ee7389aeb);
$parcel$export($f74f9c617b22a60f$exports, "array", () => $f74f9c617b22a60f$export$2f23118c22fb2630);
$parcel$export($f74f9c617b22a60f$exports, "object", () => $f74f9c617b22a60f$export$be5493f9613cbbe);
$parcel$export($f74f9c617b22a60f$exports, "strictObject", () => $f74f9c617b22a60f$export$8fb0df5f40d0b477);
$parcel$export($f74f9c617b22a60f$exports, "union", () => $f74f9c617b22a60f$export$971dd5b0dfd021b6);
$parcel$export($f74f9c617b22a60f$exports, "discriminatedUnion", () => $f74f9c617b22a60f$export$4b888e40c4ee26dd);
$parcel$export($f74f9c617b22a60f$exports, "intersection", () => $f74f9c617b22a60f$export$bc86dfbf7795668c);
$parcel$export($f74f9c617b22a60f$exports, "tuple", () => $f74f9c617b22a60f$export$65e3907585753458);
$parcel$export($f74f9c617b22a60f$exports, "record", () => $f74f9c617b22a60f$export$e5185e241753e543);
$parcel$export($f74f9c617b22a60f$exports, "map", () => $f74f9c617b22a60f$export$871de8747c9eaa88);
$parcel$export($f74f9c617b22a60f$exports, "set", () => $f74f9c617b22a60f$export$adaa4cf7ef1b65be);
$parcel$export($f74f9c617b22a60f$exports, "function", () => $f74f9c617b22a60f$export$44e51c8aac7c2deb);
$parcel$export($f74f9c617b22a60f$exports, "lazy", () => $f74f9c617b22a60f$export$488013bae63b21da);
$parcel$export($f74f9c617b22a60f$exports, "literal", () => $f74f9c617b22a60f$export$c8ec6e1ec9fefcb0);
$parcel$export($f74f9c617b22a60f$exports, "enum", () => $f74f9c617b22a60f$export$78a99c8d44d72635);
$parcel$export($f74f9c617b22a60f$exports, "nativeEnum", () => $f74f9c617b22a60f$export$6fe7eca19ebe5199);
$parcel$export($f74f9c617b22a60f$exports, "promise", () => $f74f9c617b22a60f$export$c957ef27a0ebfd4);
$parcel$export($f74f9c617b22a60f$exports, "effect", () => $f74f9c617b22a60f$export$dc573d8a6576cdb3);
$parcel$export($f74f9c617b22a60f$exports, "optional", () => $f74f9c617b22a60f$export$516e28dec6a4b6d4);
$parcel$export($f74f9c617b22a60f$exports, "nullable", () => $f74f9c617b22a60f$export$133fc36489ac9add);
$parcel$export($f74f9c617b22a60f$exports, "preprocess", () => $f74f9c617b22a60f$export$fc37fe19dfda43ee);
$parcel$export($f74f9c617b22a60f$exports, "pipeline", () => $f74f9c617b22a60f$export$43f28b24e1eb8181);
$parcel$export($f74f9c617b22a60f$exports, "ostring", () => $f74f9c617b22a60f$export$3b3d07727c5b702c);
$parcel$export($f74f9c617b22a60f$exports, "onumber", () => $f74f9c617b22a60f$export$eb150471a61fced6);
$parcel$export($f74f9c617b22a60f$exports, "oboolean", () => $f74f9c617b22a60f$export$269251733cdcbbf1);
$parcel$export($f74f9c617b22a60f$exports, "coerce", () => $f74f9c617b22a60f$export$8c14e57e778d3873);
$parcel$export($f74f9c617b22a60f$exports, "transformer", () => $f74f9c617b22a60f$export$dc573d8a6576cdb3);
$parcel$export($f74f9c617b22a60f$exports, "NEVER", () => $f74f9c617b22a60f$export$96c94437c95d7862);


var $9cba153ee5f90bfc$export$b9faa7f0c32cb80d;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    // biome-ignore lint:
    errorUtil.toString = (message)=>typeof message === "string" ? message : message?.message;
})($9cba153ee5f90bfc$export$b9faa7f0c32cb80d || ($9cba153ee5f90bfc$export$b9faa7f0c32cb80d = {}));




class $f74f9c617b22a60f$var$ParseInputLazyPath {
    get path() {
        if (!this._cachedPath.length) {
            if (Array.isArray(this._key)) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
}
const $f74f9c617b22a60f$var$handleResult = (ctx, result)=>{
    if ((0, $b5e9dbcf321fac0a$export$1ea939691cdc45b8)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new (0, $c5464aefb6655c5b$export$f98dac4b251ab333)(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $f74f9c617b22a60f$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message ?? ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: message ?? required_error ?? ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: message ?? invalid_type_error ?? ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, $4a20734f269c1104$export$3e9057828ebd5c7a)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, $4a20734f269c1104$export$3e9057828ebd5c7a)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new (0, $b5e9dbcf321fac0a$export$5b20a5c3d05c1f6f)(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, $4a20734f269c1104$export$3e9057828ebd5c7a)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, $b5e9dbcf321fac0a$export$aefee5ebe1dcfd9e)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        const ctx = {
            common: {
                issues: [],
                async: params?.async ?? false,
                contextualErrorMap: params?.errorMap
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $4a20734f269c1104$export$3e9057828ebd5c7a)(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $f74f9c617b22a60f$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $4a20734f269c1104$export$3e9057828ebd5c7a)(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return (0, $b5e9dbcf321fac0a$export$1ea939691cdc45b8)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if (err?.message?.toLowerCase()?.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>(0, $b5e9dbcf321fac0a$export$1ea939691cdc45b8)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params?.errorMap,
                async: true
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $4a20734f269c1104$export$3e9057828ebd5c7a)(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, $b5e9dbcf321fac0a$export$aefee5ebe1dcfd9e)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $f74f9c617b22a60f$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $f74f9c617b22a60f$export$a60af00cc0ce2582({
            schema: this,
            typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $f74f9c617b22a60f$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $f74f9c617b22a60f$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $f74f9c617b22a60f$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $f74f9c617b22a60f$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $f74f9c617b22a60f$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $f74f9c617b22a60f$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $f74f9c617b22a60f$export$a60af00cc0ce2582({
            ...$f74f9c617b22a60f$var$processCreateParams(this._def),
            schema: this,
            typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $f74f9c617b22a60f$export$bb19b37874861e7e({
            ...$f74f9c617b22a60f$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $f74f9c617b22a60f$export$66b0c798a395271f({
            typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$f74f9c617b22a60f$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $f74f9c617b22a60f$export$75a44ec6249ac76b({
            ...$f74f9c617b22a60f$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $f74f9c617b22a60f$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $f74f9c617b22a60f$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
}
const $f74f9c617b22a60f$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $f74f9c617b22a60f$var$cuid2Regex = /^[0-9a-z]+$/;
const $f74f9c617b22a60f$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $f74f9c617b22a60f$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $f74f9c617b22a60f$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $f74f9c617b22a60f$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $f74f9c617b22a60f$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $f74f9c617b22a60f$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $f74f9c617b22a60f$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $f74f9c617b22a60f$var$emojiRegex;
// faster, simpler, safer
const $f74f9c617b22a60f$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $f74f9c617b22a60f$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $f74f9c617b22a60f$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $f74f9c617b22a60f$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $f74f9c617b22a60f$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $f74f9c617b22a60f$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $f74f9c617b22a60f$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $f74f9c617b22a60f$var$dateRegex = new RegExp(`^${$f74f9c617b22a60f$var$dateRegexSource}$`);
function $f74f9c617b22a60f$var$timeRegexSource(args) {
    let secondsRegexSource = `[0-5]\\d`;
    if (args.precision) secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
    else if (args.precision == null) secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
    const secondsQuantifier = args.precision ? "+" : "?"; // require seconds if precision is nonzero
    return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function $f74f9c617b22a60f$var$timeRegex(args) {
    return new RegExp(`^${$f74f9c617b22a60f$var$timeRegexSource(args)}$`);
}
function $f74f9c617b22a60f$export$a4b563879add27a(args) {
    let regex = `${$f74f9c617b22a60f$var$dateRegexSource}T${$f74f9c617b22a60f$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $f74f9c617b22a60f$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $f74f9c617b22a60f$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $f74f9c617b22a60f$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $f74f9c617b22a60f$var$isValidJWT(jwt, alg) {
    if (!$f74f9c617b22a60f$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        if (!header) return false;
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if ("typ" in decoded && decoded?.typ !== "JWT") return false;
        if (!decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch  {
        return false;
    }
}
function $f74f9c617b22a60f$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $f74f9c617b22a60f$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $f74f9c617b22a60f$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $f74f9c617b22a60f$export$1230eb29b8d3b502 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).string) {
            const ctx = this._getOrReturnCtx(input);
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).string,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        const status = new (0, $b5e9dbcf321fac0a$export$5b20a5c3d05c1f6f)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$f74f9c617b22a60f$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        validation: "email",
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$f74f9c617b22a60f$var$emojiRegex) $f74f9c617b22a60f$var$emojiRegex = new RegExp($f74f9c617b22a60f$var$_emojiRegex, "u");
                if (!$f74f9c617b22a60f$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        validation: "emoji",
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$f74f9c617b22a60f$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        validation: "uuid",
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$f74f9c617b22a60f$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        validation: "nanoid",
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$f74f9c617b22a60f$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        validation: "cuid",
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$f74f9c617b22a60f$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        validation: "cuid2",
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$f74f9c617b22a60f$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        validation: "ulid",
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch  {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                    validation: "url",
                    code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        validation: "regex",
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $f74f9c617b22a60f$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $f74f9c617b22a60f$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $f74f9c617b22a60f$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$f74f9c617b22a60f$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        validation: "duration",
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$f74f9c617b22a60f$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        validation: "ip",
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$f74f9c617b22a60f$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        validation: "jwt",
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$f74f9c617b22a60f$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        validation: "cidr",
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$f74f9c617b22a60f$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        validation: "base64",
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$f74f9c617b22a60f$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        validation: "base64url",
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $4a20734f269c1104$export$7debb50ef11d5e0b).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_string,
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    _addCheck(check) {
        return new $f74f9c617b22a60f$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(options)
        });
    }
    datetime(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            offset: options?.offset ?? false,
            local: options?.local ?? false,
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(options?.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(options?.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options?.position,
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(options?.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...(0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message));
    }
    trim() {
        return new $f74f9c617b22a60f$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $f74f9c617b22a60f$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $f74f9c617b22a60f$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$f74f9c617b22a60f$export$1230eb29b8d3b502.create = (params)=>{
    return new $f74f9c617b22a60f$export$1230eb29b8d3b502({
        checks: [],
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodString,
        coerce: params?.coerce ?? false,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $f74f9c617b22a60f$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
class $f74f9c617b22a60f$export$5b070a55c0c43e09 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).number) {
            const ctx = this._getOrReturnCtx(input);
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).number,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new (0, $b5e9dbcf321fac0a$export$5b20a5c3d05c1f6f)();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!(0, $4a20734f269c1104$export$7debb50ef11d5e0b).isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($f74f9c617b22a60f$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $4a20734f269c1104$export$7debb50ef11d5e0b).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $f74f9c617b22a60f$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $f74f9c617b22a60f$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && (0, $4a20734f269c1104$export$7debb50ef11d5e0b).isInteger(ch.value));
    }
    get isFinite() {
        let max = null;
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
}
$f74f9c617b22a60f$export$5b070a55c0c43e09.create = (params)=>{
    return new $f74f9c617b22a60f$export$5b070a55c0c43e09({
        checks: [],
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodNumber,
        coerce: params?.coerce || false,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$67d741fd70ff98f4 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch  {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new (0, $b5e9dbcf321fac0a$export$5b20a5c3d05c1f6f)();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $4a20734f269c1104$export$7debb50ef11d5e0b).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
            code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
            expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).bigint,
            received: ctx.parsedType
        });
        return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $f74f9c617b22a60f$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $f74f9c617b22a60f$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
}
$f74f9c617b22a60f$export$67d741fd70ff98f4.create = (params)=>{
    return new $f74f9c617b22a60f$export$67d741fd70ff98f4({
        checks: [],
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodBigInt,
        coerce: params?.coerce ?? false,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$723d146f80596191 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).boolean,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        return (0, $b5e9dbcf321fac0a$export$c6813a8d51f77eaf)(input.data);
    }
}
$f74f9c617b22a60f$export$723d146f80596191.create = (params)=>{
    return new $f74f9c617b22a60f$export$723d146f80596191({
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodBoolean,
        coerce: params?.coerce || false,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$e974be33bdc55521 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).date) {
            const ctx = this._getOrReturnCtx(input);
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).date,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        if (Number.isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_date
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        const status = new (0, $b5e9dbcf321fac0a$export$5b20a5c3d05c1f6f)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else (0, $4a20734f269c1104$export$7debb50ef11d5e0b).assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $f74f9c617b22a60f$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$f74f9c617b22a60f$export$e974be33bdc55521.create = (params)=>{
    return new $f74f9c617b22a60f$export$e974be33bdc55521({
        checks: [],
        coerce: params?.coerce || false,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodDate,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$bcc3b40f6b638044 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).symbol,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        return (0, $b5e9dbcf321fac0a$export$c6813a8d51f77eaf)(input.data);
    }
}
$f74f9c617b22a60f$export$bcc3b40f6b638044.create = (params)=>{
    return new $f74f9c617b22a60f$export$bcc3b40f6b638044({
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodSymbol,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$4e780e961c30340d extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).undefined,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        return (0, $b5e9dbcf321fac0a$export$c6813a8d51f77eaf)(input.data);
    }
}
$f74f9c617b22a60f$export$4e780e961c30340d.create = (params)=>{
    return new $f74f9c617b22a60f$export$4e780e961c30340d({
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodUndefined,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$a96281f914484f2d extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).null) {
            const ctx = this._getOrReturnCtx(input);
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).null,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        return (0, $b5e9dbcf321fac0a$export$c6813a8d51f77eaf)(input.data);
    }
}
$f74f9c617b22a60f$export$a96281f914484f2d.create = (params)=>{
    return new $f74f9c617b22a60f$export$a96281f914484f2d({
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodNull,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$b9d1edb536b4e4eb extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        return (0, $b5e9dbcf321fac0a$export$c6813a8d51f77eaf)(input.data);
    }
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
}
$f74f9c617b22a60f$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $f74f9c617b22a60f$export$b9d1edb536b4e4eb({
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodAny,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$ef3b1bb1630977ae extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        return (0, $b5e9dbcf321fac0a$export$c6813a8d51f77eaf)(input.data);
    }
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
}
$f74f9c617b22a60f$export$ef3b1bb1630977ae.create = (params)=>{
    return new $f74f9c617b22a60f$export$ef3b1bb1630977ae({
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodUnknown,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$1e576a20c3ce9fb5 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
            code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
            expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).never,
            received: ctx.parsedType
        });
        return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
    }
}
$f74f9c617b22a60f$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $f74f9c617b22a60f$export$1e576a20c3ce9fb5({
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodNever,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$7d39f5df85f21031 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).void,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        return (0, $b5e9dbcf321fac0a$export$c6813a8d51f77eaf)(input.data);
    }
}
$f74f9c617b22a60f$export$7d39f5df85f21031.create = (params)=>{
    return new $f74f9c617b22a60f$export$7d39f5df85f21031({
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodVoid,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$7acfc3e64785411 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).array) {
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).array,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                    code: tooBig ? (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_big : (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                    code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                    code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $f74f9c617b22a60f$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return (0, $b5e9dbcf321fac0a$export$5b20a5c3d05c1f6f).mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $f74f9c617b22a60f$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return (0, $b5e9dbcf321fac0a$export$5b20a5c3d05c1f6f).mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $f74f9c617b22a60f$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $f74f9c617b22a60f$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
            }
        });
    }
    length(len, message) {
        return new $f74f9c617b22a60f$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$f74f9c617b22a60f$export$7acfc3e64785411.create = (schema, params)=>{
    return new $f74f9c617b22a60f$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodArray,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
function $f74f9c617b22a60f$var$deepPartialify(schema) {
    if (schema instanceof $f74f9c617b22a60f$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $f74f9c617b22a60f$export$aa56fec1e9d629b8.create($f74f9c617b22a60f$var$deepPartialify(fieldSchema));
        }
        return new $f74f9c617b22a60f$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $f74f9c617b22a60f$export$7acfc3e64785411) return new $f74f9c617b22a60f$export$7acfc3e64785411({
        ...schema._def,
        type: $f74f9c617b22a60f$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $f74f9c617b22a60f$export$aa56fec1e9d629b8) return $f74f9c617b22a60f$export$aa56fec1e9d629b8.create($f74f9c617b22a60f$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $f74f9c617b22a60f$export$aaac0b8b429cef5) return $f74f9c617b22a60f$export$aaac0b8b429cef5.create($f74f9c617b22a60f$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $f74f9c617b22a60f$export$e2a18bb771d8e6a3) return $f74f9c617b22a60f$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$f74f9c617b22a60f$var$deepPartialify(item)));
    else return schema;
}
class $f74f9c617b22a60f$export$736315c5b55efbad extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = (0, $4a20734f269c1104$export$7debb50ef11d5e0b).objectKeys(shape);
        this._cached = {
            shape: shape,
            keys: keys
        };
        return this._cached;
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).object) {
            const ctx = this._getOrReturnCtx(input);
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).object,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $f74f9c617b22a60f$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $f74f9c617b22a60f$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $f74f9c617b22a60f$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                        code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $f74f9c617b22a60f$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return (0, $b5e9dbcf321fac0a$export$5b20a5c3d05c1f6f).mergeObjectSync(status, syncPairs);
        });
        else return (0, $b5e9dbcf321fac0a$export$5b20a5c3d05c1f6f).mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj;
        return new $f74f9c617b22a60f$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).errToObj(message).message ?? defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $f74f9c617b22a60f$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $f74f9c617b22a60f$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $f74f9c617b22a60f$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $f74f9c617b22a60f$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $f74f9c617b22a60f$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        for (const key of (0, $4a20734f269c1104$export$7debb50ef11d5e0b).objectKeys(mask))if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        return new $f74f9c617b22a60f$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        for (const key of (0, $4a20734f269c1104$export$7debb50ef11d5e0b).objectKeys(this.shape))if (!mask[key]) shape[key] = this.shape[key];
        return new $f74f9c617b22a60f$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $f74f9c617b22a60f$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        for (const key of (0, $4a20734f269c1104$export$7debb50ef11d5e0b).objectKeys(this.shape)){
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        }
        return new $f74f9c617b22a60f$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        for (const key of (0, $4a20734f269c1104$export$7debb50ef11d5e0b).objectKeys(this.shape))if (mask && !mask[key]) newShape[key] = this.shape[key];
        else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while(newField instanceof $f74f9c617b22a60f$export$aa56fec1e9d629b8)newField = newField._def.innerType;
            newShape[key] = newField;
        }
        return new $f74f9c617b22a60f$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $f74f9c617b22a60f$var$createZodEnum((0, $4a20734f269c1104$export$7debb50ef11d5e0b).objectKeys(this.shape));
    }
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
}
$f74f9c617b22a60f$export$736315c5b55efbad.create = (shape, params)=>{
    return new $f74f9c617b22a60f$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $f74f9c617b22a60f$export$1e576a20c3ce9fb5.create(),
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodObject,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
$f74f9c617b22a60f$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $f74f9c617b22a60f$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $f74f9c617b22a60f$export$1e576a20c3ce9fb5.create(),
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodObject,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
$f74f9c617b22a60f$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $f74f9c617b22a60f$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $f74f9c617b22a60f$export$1e576a20c3ce9fb5.create(),
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodObject,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$a8b236cb5070a311 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new (0, $c5464aefb6655c5b$export$f98dac4b251ab333)(result.ctx.common.issues));
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new (0, $c5464aefb6655c5b$export$f98dac4b251ab333)(issues));
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$f74f9c617b22a60f$export$a8b236cb5070a311.create = (types, params)=>{
    return new $f74f9c617b22a60f$export$a8b236cb5070a311({
        options: types,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodUnion,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $f74f9c617b22a60f$var$getDiscriminator = (type)=>{
    if (type instanceof $f74f9c617b22a60f$export$378d0cfce37406e6) return $f74f9c617b22a60f$var$getDiscriminator(type.schema);
    else if (type instanceof $f74f9c617b22a60f$export$a60af00cc0ce2582) return $f74f9c617b22a60f$var$getDiscriminator(type.innerType());
    else if (type instanceof $f74f9c617b22a60f$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $f74f9c617b22a60f$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $f74f9c617b22a60f$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return (0, $4a20734f269c1104$export$7debb50ef11d5e0b).objectValues(type.enum);
    else if (type instanceof $f74f9c617b22a60f$export$bb19b37874861e7e) return $f74f9c617b22a60f$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $f74f9c617b22a60f$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $f74f9c617b22a60f$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $f74f9c617b22a60f$export$aa56fec1e9d629b8) return [
        undefined,
        ...$f74f9c617b22a60f$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $f74f9c617b22a60f$export$aaac0b8b429cef5) return [
        null,
        ...$f74f9c617b22a60f$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $f74f9c617b22a60f$export$66b0c798a395271f) return $f74f9c617b22a60f$var$getDiscriminator(type.unwrap());
    else if (type instanceof $f74f9c617b22a60f$export$5d1f7ef05c4e493a) return $f74f9c617b22a60f$var$getDiscriminator(type.unwrap());
    else if (type instanceof $f74f9c617b22a60f$export$75a44ec6249ac76b) return $f74f9c617b22a60f$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $f74f9c617b22a60f$export$5ef2424805ac76a3 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).object) {
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).object,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $f74f9c617b22a60f$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $f74f9c617b22a60f$export$5ef2424805ac76a3({
            typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$f74f9c617b22a60f$var$processCreateParams(params)
        });
    }
}
function $f74f9c617b22a60f$var$mergeValues(a, b) {
    const aType = (0, $4a20734f269c1104$export$3e9057828ebd5c7a)(a);
    const bType = (0, $4a20734f269c1104$export$3e9057828ebd5c7a)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === (0, $4a20734f269c1104$export$5716da67bfaa244d).object && bType === (0, $4a20734f269c1104$export$5716da67bfaa244d).object) {
        const bKeys = (0, $4a20734f269c1104$export$7debb50ef11d5e0b).objectKeys(b);
        const sharedKeys = (0, $4a20734f269c1104$export$7debb50ef11d5e0b).objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $f74f9c617b22a60f$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === (0, $4a20734f269c1104$export$5716da67bfaa244d).array && bType === (0, $4a20734f269c1104$export$5716da67bfaa244d).array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $f74f9c617b22a60f$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === (0, $4a20734f269c1104$export$5716da67bfaa244d).date && bType === (0, $4a20734f269c1104$export$5716da67bfaa244d).date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $f74f9c617b22a60f$export$c02deaf0bb5203d4 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, $b5e9dbcf321fac0a$export$afa861e3c5730743)(parsedLeft) || (0, $b5e9dbcf321fac0a$export$afa861e3c5730743)(parsedRight)) return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
            const merged = $f74f9c617b22a60f$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                    code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_intersection_types
                });
                return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
            }
            if ((0, $b5e9dbcf321fac0a$export$910b6cdd390341b3)(parsedLeft) || (0, $b5e9dbcf321fac0a$export$910b6cdd390341b3)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$f74f9c617b22a60f$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $f74f9c617b22a60f$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodIntersection,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$e2a18bb771d8e6a3 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).array) {
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).array,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $f74f9c617b22a60f$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return (0, $b5e9dbcf321fac0a$export$5b20a5c3d05c1f6f).mergeArray(status, results);
        });
        else return (0, $b5e9dbcf321fac0a$export$5b20a5c3d05c1f6f).mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $f74f9c617b22a60f$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$f74f9c617b22a60f$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $f74f9c617b22a60f$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$a2acc09968cb4b7f extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).object) {
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).object,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $f74f9c617b22a60f$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $f74f9c617b22a60f$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return (0, $b5e9dbcf321fac0a$export$5b20a5c3d05c1f6f).mergeObjectAsync(status, pairs);
        else return (0, $b5e9dbcf321fac0a$export$5b20a5c3d05c1f6f).mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $f74f9c617b22a60f$export$2afb8ab49d4b92c0) return new $f74f9c617b22a60f$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodRecord,
            ...$f74f9c617b22a60f$var$processCreateParams(third)
        });
        return new $f74f9c617b22a60f$export$a2acc09968cb4b7f({
            keyType: $f74f9c617b22a60f$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodRecord,
            ...$f74f9c617b22a60f$var$processCreateParams(second)
        });
    }
}
class $f74f9c617b22a60f$export$163b6a2b712d9542 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).map) {
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).map,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $f74f9c617b22a60f$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $f74f9c617b22a60f$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$f74f9c617b22a60f$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $f74f9c617b22a60f$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodMap,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$977057706f816712 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).set) {
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).set,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                    code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                    code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $f74f9c617b22a60f$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $f74f9c617b22a60f$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $f74f9c617b22a60f$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: (0, $9cba153ee5f90bfc$export$b9faa7f0c32cb80d).toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$f74f9c617b22a60f$export$977057706f816712.create = (valueType, params)=>{
    return new $f74f9c617b22a60f$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodSet,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$d4602ba55673f53c extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).function) {
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).function,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return (0, $b5e9dbcf321fac0a$export$244a85fde9c419ed)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $1962c69abbc7e350$export$32f27c719778d4c4)(),
                    (0, $81a8f18f24f6faa1$export$2e2bcd8739ae039)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, $b5e9dbcf321fac0a$export$244a85fde9c419ed)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $1962c69abbc7e350$export$32f27c719778d4c4)(),
                    (0, $81a8f18f24f6faa1$export$2e2bcd8739ae039)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $f74f9c617b22a60f$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $b5e9dbcf321fac0a$export$c6813a8d51f77eaf)(async function(...args) {
                const error = new (0, $c5464aefb6655c5b$export$f98dac4b251ab333)([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $b5e9dbcf321fac0a$export$c6813a8d51f77eaf)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new (0, $c5464aefb6655c5b$export$f98dac4b251ab333)([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new (0, $c5464aefb6655c5b$export$f98dac4b251ab333)([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $f74f9c617b22a60f$export$d4602ba55673f53c({
            ...this._def,
            args: $f74f9c617b22a60f$export$e2a18bb771d8e6a3.create(items).rest($f74f9c617b22a60f$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $f74f9c617b22a60f$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $f74f9c617b22a60f$export$d4602ba55673f53c({
            args: args ? args : $f74f9c617b22a60f$export$e2a18bb771d8e6a3.create([]).rest($f74f9c617b22a60f$export$ef3b1bb1630977ae.create()),
            returns: returns || $f74f9c617b22a60f$export$ef3b1bb1630977ae.create(),
            typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodFunction,
            ...$f74f9c617b22a60f$var$processCreateParams(params)
        });
    }
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
}
class $f74f9c617b22a60f$export$378d0cfce37406e6 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$f74f9c617b22a60f$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $f74f9c617b22a60f$export$378d0cfce37406e6({
        getter: getter,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodLazy,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$7e44096782a165d3 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                received: ctx.data,
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_literal,
                expected: this._def.value
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$f74f9c617b22a60f$export$7e44096782a165d3.create = (value, params)=>{
    return new $f74f9c617b22a60f$export$7e44096782a165d3({
        value: value,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodLiteral,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
function $f74f9c617b22a60f$var$createZodEnum(values, params) {
    return new $f74f9c617b22a60f$export$d325d1f0e1c20179({
        values: values,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodEnum,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
}
class $f74f9c617b22a60f$export$d325d1f0e1c20179 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                expected: (0, $4a20734f269c1104$export$7debb50ef11d5e0b).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        if (!this._cache) this._cache = new Set(this._def.values);
        if (!this._cache.has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                received: ctx.data,
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_enum_value,
                options: expectedValues
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        return (0, $b5e9dbcf321fac0a$export$c6813a8d51f77eaf)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $f74f9c617b22a60f$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $f74f9c617b22a60f$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$f74f9c617b22a60f$export$d325d1f0e1c20179.create = $f74f9c617b22a60f$var$createZodEnum;
class $f74f9c617b22a60f$export$370b2e8d6d6f5c56 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const nativeEnumValues = (0, $4a20734f269c1104$export$7debb50ef11d5e0b).getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).string && ctx.parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).number) {
            const expectedValues = (0, $4a20734f269c1104$export$7debb50ef11d5e0b).objectValues(nativeEnumValues);
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                expected: (0, $4a20734f269c1104$export$7debb50ef11d5e0b).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        if (!this._cache) this._cache = new Set((0, $4a20734f269c1104$export$7debb50ef11d5e0b).getValidEnumValues(this._def.values));
        if (!this._cache.has(input.data)) {
            const expectedValues = (0, $4a20734f269c1104$export$7debb50ef11d5e0b).objectValues(nativeEnumValues);
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                received: ctx.data,
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_enum_value,
                options: expectedValues
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        return (0, $b5e9dbcf321fac0a$export$c6813a8d51f77eaf)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$f74f9c617b22a60f$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $f74f9c617b22a60f$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodNativeEnum,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$3f196b0127d6e50a extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).promise && ctx.common.async === false) {
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).promise,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === (0, $4a20734f269c1104$export$5716da67bfaa244d).promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, $b5e9dbcf321fac0a$export$c6813a8d51f77eaf)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$f74f9c617b22a60f$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $f74f9c617b22a60f$export$3f196b0127d6e50a({
        type: schema,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodPromise,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$a60af00cc0ce2582 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $f74f9c617b22a60f$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
                if (result.status === "dirty") return (0, $b5e9dbcf321fac0a$export$325a211da9693fcf)(result.value);
                if (status.value === "dirty") return (0, $b5e9dbcf321fac0a$export$325a211da9693fcf)(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
                if (result.status === "dirty") return (0, $b5e9dbcf321fac0a$export$325a211da9693fcf)(result.value);
                if (status.value === "dirty") return (0, $b5e9dbcf321fac0a$export$325a211da9693fcf)(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, $b5e9dbcf321fac0a$export$1ea939691cdc45b8)(base)) return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, $b5e9dbcf321fac0a$export$1ea939691cdc45b8)(base)) return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        (0, $4a20734f269c1104$export$7debb50ef11d5e0b).assertNever(effect);
    }
}
$f74f9c617b22a60f$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $f74f9c617b22a60f$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
$f74f9c617b22a60f$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $f74f9c617b22a60f$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodEffects,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$aa56fec1e9d629b8 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $4a20734f269c1104$export$5716da67bfaa244d).undefined) return (0, $b5e9dbcf321fac0a$export$c6813a8d51f77eaf)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$f74f9c617b22a60f$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $f74f9c617b22a60f$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodOptional,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$aaac0b8b429cef5 extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $4a20734f269c1104$export$5716da67bfaa244d).null) return (0, $b5e9dbcf321fac0a$export$c6813a8d51f77eaf)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$f74f9c617b22a60f$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $f74f9c617b22a60f$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodNullable,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$bb19b37874861e7e extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === (0, $4a20734f269c1104$export$5716da67bfaa244d).undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$f74f9c617b22a60f$export$bb19b37874861e7e.create = (type, params)=>{
    return new $f74f9c617b22a60f$export$bb19b37874861e7e({
        innerType: type,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$75a44ec6249ac76b extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, $b5e9dbcf321fac0a$export$aefee5ebe1dcfd9e)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new (0, $c5464aefb6655c5b$export$f98dac4b251ab333)(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new (0, $c5464aefb6655c5b$export$f98dac4b251ab333)(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$f74f9c617b22a60f$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $f74f9c617b22a60f$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
class $f74f9c617b22a60f$export$26ccfa0145e8511f extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $4a20734f269c1104$export$5716da67bfaa244d).nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, $b5e9dbcf321fac0a$export$db7caee60e5d514d)(ctx, {
                code: (0, $c5464aefb6655c5b$export$5ba560653e4a1035).invalid_type,
                expected: (0, $4a20734f269c1104$export$5716da67bfaa244d).nan,
                received: ctx.parsedType
            });
            return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$f74f9c617b22a60f$export$26ccfa0145e8511f.create = (params)=>{
    return new $f74f9c617b22a60f$export$26ccfa0145e8511f({
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodNaN,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
const $f74f9c617b22a60f$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $f74f9c617b22a60f$export$66b0c798a395271f extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $f74f9c617b22a60f$export$a3c3ef8a0e95c6da extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, $b5e9dbcf321fac0a$export$325a211da9693fcf)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return 0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $f74f9c617b22a60f$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $f74f9c617b22a60f$export$5d1f7ef05c4e493a extends $f74f9c617b22a60f$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ((0, $b5e9dbcf321fac0a$export$1ea939691cdc45b8)(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return (0, $b5e9dbcf321fac0a$export$aefee5ebe1dcfd9e)(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$f74f9c617b22a60f$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $f74f9c617b22a60f$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $f74f9c617b22a60f$export$558106ce543bd011.ZodReadonly,
        ...$f74f9c617b22a60f$var$processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function $f74f9c617b22a60f$var$cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function $f74f9c617b22a60f$export$4c00f665f0d4b443(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $f74f9c617b22a60f$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            if (!r) {
                const params = $f74f9c617b22a60f$var$cleanParams(_params, data);
                const _fatal = params.fatal ?? fatal ?? true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = $f74f9c617b22a60f$var$cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return $f74f9c617b22a60f$export$b9d1edb536b4e4eb.create();
}
const $f74f9c617b22a60f$export$1ee8ee30835eab8b = {
    object: $f74f9c617b22a60f$export$736315c5b55efbad.lazycreate
};
var $f74f9c617b22a60f$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($f74f9c617b22a60f$export$558106ce543bd011 || ($f74f9c617b22a60f$export$558106ce543bd011 = {}));
// requires TS 4.4+
class $f74f9c617b22a60f$var$Class {
    constructor(..._){}
}
const $f74f9c617b22a60f$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$f74f9c617b22a60f$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $f74f9c617b22a60f$export$22b082955e083ec3 = $f74f9c617b22a60f$export$1230eb29b8d3b502.create;
const $f74f9c617b22a60f$export$98e628dec113755e = $f74f9c617b22a60f$export$5b070a55c0c43e09.create;
const $f74f9c617b22a60f$export$9e06de0973666692 = $f74f9c617b22a60f$export$26ccfa0145e8511f.create;
const $f74f9c617b22a60f$export$a0f65b52274bcc00 = $f74f9c617b22a60f$export$67d741fd70ff98f4.create;
const $f74f9c617b22a60f$export$4a21f16c33752377 = $f74f9c617b22a60f$export$723d146f80596191.create;
const $f74f9c617b22a60f$export$324d90190a8b822a = $f74f9c617b22a60f$export$e974be33bdc55521.create;
const $f74f9c617b22a60f$export$8f701197936bc2a6 = $f74f9c617b22a60f$export$bcc3b40f6b638044.create;
const $f74f9c617b22a60f$export$1db45310990710a5 = $f74f9c617b22a60f$export$4e780e961c30340d.create;
const $f74f9c617b22a60f$export$7b1b591b262c240 = $f74f9c617b22a60f$export$a96281f914484f2d.create;
const $f74f9c617b22a60f$export$4154a199d7d90455 = $f74f9c617b22a60f$export$b9d1edb536b4e4eb.create;
const $f74f9c617b22a60f$export$19282c40b967aec6 = $f74f9c617b22a60f$export$ef3b1bb1630977ae.create;
const $f74f9c617b22a60f$export$b3e22bcfd64c1022 = $f74f9c617b22a60f$export$1e576a20c3ce9fb5.create;
const $f74f9c617b22a60f$export$490e536ee7389aeb = $f74f9c617b22a60f$export$7d39f5df85f21031.create;
const $f74f9c617b22a60f$export$2f23118c22fb2630 = $f74f9c617b22a60f$export$7acfc3e64785411.create;
const $f74f9c617b22a60f$export$be5493f9613cbbe = $f74f9c617b22a60f$export$736315c5b55efbad.create;
const $f74f9c617b22a60f$export$8fb0df5f40d0b477 = $f74f9c617b22a60f$export$736315c5b55efbad.strictCreate;
const $f74f9c617b22a60f$export$971dd5b0dfd021b6 = $f74f9c617b22a60f$export$a8b236cb5070a311.create;
const $f74f9c617b22a60f$export$4b888e40c4ee26dd = $f74f9c617b22a60f$export$5ef2424805ac76a3.create;
const $f74f9c617b22a60f$export$bc86dfbf7795668c = $f74f9c617b22a60f$export$c02deaf0bb5203d4.create;
const $f74f9c617b22a60f$export$65e3907585753458 = $f74f9c617b22a60f$export$e2a18bb771d8e6a3.create;
const $f74f9c617b22a60f$export$e5185e241753e543 = $f74f9c617b22a60f$export$a2acc09968cb4b7f.create;
const $f74f9c617b22a60f$export$871de8747c9eaa88 = $f74f9c617b22a60f$export$163b6a2b712d9542.create;
const $f74f9c617b22a60f$export$adaa4cf7ef1b65be = $f74f9c617b22a60f$export$977057706f816712.create;
const $f74f9c617b22a60f$export$44e51c8aac7c2deb = $f74f9c617b22a60f$export$d4602ba55673f53c.create;
const $f74f9c617b22a60f$export$488013bae63b21da = $f74f9c617b22a60f$export$378d0cfce37406e6.create;
const $f74f9c617b22a60f$export$c8ec6e1ec9fefcb0 = $f74f9c617b22a60f$export$7e44096782a165d3.create;
const $f74f9c617b22a60f$export$78a99c8d44d72635 = $f74f9c617b22a60f$export$d325d1f0e1c20179.create;
const $f74f9c617b22a60f$export$6fe7eca19ebe5199 = $f74f9c617b22a60f$export$370b2e8d6d6f5c56.create;
const $f74f9c617b22a60f$export$c957ef27a0ebfd4 = $f74f9c617b22a60f$export$3f196b0127d6e50a.create;
const $f74f9c617b22a60f$export$dc573d8a6576cdb3 = $f74f9c617b22a60f$export$a60af00cc0ce2582.create;
const $f74f9c617b22a60f$export$516e28dec6a4b6d4 = $f74f9c617b22a60f$export$aa56fec1e9d629b8.create;
const $f74f9c617b22a60f$export$133fc36489ac9add = $f74f9c617b22a60f$export$aaac0b8b429cef5.create;
const $f74f9c617b22a60f$export$fc37fe19dfda43ee = $f74f9c617b22a60f$export$a60af00cc0ce2582.createWithPreprocess;
const $f74f9c617b22a60f$export$43f28b24e1eb8181 = $f74f9c617b22a60f$export$a3c3ef8a0e95c6da.create;
const $f74f9c617b22a60f$export$3b3d07727c5b702c = ()=>$f74f9c617b22a60f$export$22b082955e083ec3().optional();
const $f74f9c617b22a60f$export$eb150471a61fced6 = ()=>$f74f9c617b22a60f$export$98e628dec113755e().optional();
const $f74f9c617b22a60f$export$269251733cdcbbf1 = ()=>$f74f9c617b22a60f$export$4a21f16c33752377().optional();
const $f74f9c617b22a60f$export$8c14e57e778d3873 = {
    string: (arg)=>$f74f9c617b22a60f$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$f74f9c617b22a60f$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$f74f9c617b22a60f$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$f74f9c617b22a60f$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$f74f9c617b22a60f$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $f74f9c617b22a60f$export$96c94437c95d7862 = (0, $b5e9dbcf321fac0a$export$9a105a556e65c2c0);



$parcel$exportWildcard($362db24ca11e535b$exports, $1962c69abbc7e350$exports);
$parcel$exportWildcard($362db24ca11e535b$exports, $b5e9dbcf321fac0a$exports);
$parcel$exportWildcard($362db24ca11e535b$exports, $f46b546b674f8528$exports);
$parcel$exportWildcard($362db24ca11e535b$exports, $4a20734f269c1104$exports);
$parcel$exportWildcard($362db24ca11e535b$exports, $f74f9c617b22a60f$exports);
$parcel$exportWildcard($362db24ca11e535b$exports, $c5464aefb6655c5b$exports);



var $80cccc8f932d018f$export$2e2bcd8739ae039 = $362db24ca11e535b$exports;


const $ac5a0effd567c619$export$c5fb415882705cf4 = {
    NotFound: 'not_found',
    InvalidState: 'state_invalid',
    IncorrectType: 'incorrect_type'
};
const $ac5a0effd567c619$export$e94ee64b2671e155 = (0, $362db24ca11e535b$exports).record((0, $362db24ca11e535b$exports).string(), (0, $362db24ca11e535b$exports).object({
    value: (0, $362db24ca11e535b$exports).union([
        (0, $362db24ca11e535b$exports).boolean(),
        (0, $362db24ca11e535b$exports).string(),
        (0, $362db24ca11e535b$exports).number(),
        (0, $362db24ca11e535b$exports).string().array(),
        (0, $362db24ca11e535b$exports).number().array()
    ])
}));
const $ac5a0effd567c619$export$e38f7b10db0e126a = (0, $362db24ca11e535b$exports).tuple([
    // list of boolean configs which are on
    (0, $362db24ca11e535b$exports).string().array(),
    // list of string config tuples
    (0, $362db24ca11e535b$exports).array((0, $362db24ca11e535b$exports).string()).refine((arr)=>arr.length % 2 === 0),
    // list of number config tuples
    (0, $362db24ca11e535b$exports).array((0, $362db24ca11e535b$exports).union([
        (0, $362db24ca11e535b$exports).string(),
        (0, $362db24ca11e535b$exports).number()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            if (typeof arr[i] !== 'string') return false;
            if (typeof arr[i + 1] !== 'number') return false;
        }
        return true;
    }),
    // list of string list config tuples
    (0, $362db24ca11e535b$exports).array((0, $362db24ca11e535b$exports).union([
        (0, $362db24ca11e535b$exports).string(),
        (0, $362db24ca11e535b$exports).string().array()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every((x)=>typeof x === 'string')) return false;
        }
        return true;
    }),
    // list of number list config tuples
    (0, $362db24ca11e535b$exports).array((0, $362db24ca11e535b$exports).union([
        (0, $362db24ca11e535b$exports).string(),
        (0, $362db24ca11e535b$exports).number().array()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every((x)=>typeof x === 'number')) return false;
        }
        return true;
    })
]);
const $ac5a0effd567c619$export$960d45de79bd7d81 = (0, $362db24ca11e535b$exports).union([
    $ac5a0effd567c619$export$e94ee64b2671e155,
    $ac5a0effd567c619$export$e38f7b10db0e126a
]);
const $ac5a0effd567c619$export$ac2e9c88ba5d7cbb = (0, $362db24ca11e535b$exports).map((0, $362db24ca11e535b$exports).string(), (0, $362db24ca11e535b$exports).object({
    value: (0, $362db24ca11e535b$exports).union([
        (0, $362db24ca11e535b$exports).boolean(),
        (0, $362db24ca11e535b$exports).string(),
        (0, $362db24ca11e535b$exports).number(),
        (0, $362db24ca11e535b$exports).string().array(),
        (0, $362db24ca11e535b$exports).number().array()
    ])
}));
function $ac5a0effd567c619$var$pairs(arr, fn) {
    for(let i = 0; i < arr.length; i += 2){
        const key = arr[i];
        const val = arr[i + 1];
        if (typeof key !== 'string') throw new Error(`Expected a string while iterating pairs, got: ${arr[i]}`);
        fn(key, val);
    }
}
function $ac5a0effd567c619$export$c29ba52779f58587(minimal) {
    const map = new Map();
    minimal[0].forEach((boolean)=>map.set(boolean, {
            value: true
        }));
    $ac5a0effd567c619$var$pairs(minimal[1], (a, b)=>map.set(a, {
            value: b
        }));
    $ac5a0effd567c619$var$pairs(minimal[2], (a, b)=>map.set(a, {
            value: b
        }));
    $ac5a0effd567c619$var$pairs(minimal[3], (a, b)=>map.set(a, {
            value: b
        }));
    $ac5a0effd567c619$var$pairs(minimal[4], (a, b)=>map.set(a, {
            value: b
        }));
    return map;
}
function $ac5a0effd567c619$export$be5b69ecb011d7cc(standard) {
    const map = new Map();
    Object.entries(standard).forEach(([key, value])=>map.set(key, value));
    return map;
}
function $ac5a0effd567c619$export$460f06addafd9f86(map) {
    const minimal = [
        [],
        [],
        [],
        [],
        []
    ];
    for (const [key, { value: value }] of map.entries())switch(typeof value){
        case 'boolean':
            if (value) minimal[0].push(key);
            break;
        case 'string':
            minimal[1].push(key, value);
            break;
        case 'number':
            minimal[2].push(key, value);
            break;
        default:
            if (!Array.isArray(value)) throw new Error(`Unexpected configuration value: ${value}`);
            const allStrings = value.every((x)=>typeof x === 'string');
            if (allStrings) {
                minimal[3].push(key, value);
                break;
            }
            const allNumbers = value.every((x)=>typeof x === 'number');
            if (allNumbers) {
                minimal[4].push(key, value);
                break;
            }
            throw new Error(`Unexpected configuration value: ${value}`);
    }
    return minimal;
}
function $ac5a0effd567c619$export$9d0101ad8235e092(map) {
    return Object.fromEntries(map.entries());
}


class $969c594ecdd7e542$export$f9c837a54db411d extends Error {
    constructor(message, cause){
        super(message);
        this.cause = void 0;
        this.cause = cause;
    }
}
function $969c594ecdd7e542$var$safeParse(json) {
    try {
        return {
            data: (0, $ac5a0effd567c619$export$960d45de79bd7d81).parse(JSON.parse(json)),
            success: true
        };
    } catch (error) {
        if (error instanceof Error) return {
            success: false,
            error: error
        };
        return {
            success: false,
            error: new $969c594ecdd7e542$export$f9c837a54db411d('An unknown error occurred during parsing', error)
        };
    }
}
class $969c594ecdd7e542$export$2be5653e4dada0a3 {
    static fromValues(values, options) {
        const result = $969c594ecdd7e542$var$safeParse(values);
        if (!result.success) {
            const parseError = new $969c594ecdd7e542$export$f9c837a54db411d('Failed to deserialize config', result.error);
            if (options?.throw) throw parseError;
            // eslint-disable-next-line no-console
            console.error(parseError);
            return $969c594ecdd7e542$export$2be5653e4dada0a3.empty();
        }
        return this.fromData(result.data);
    }
    static fromData(data) {
        return new $969c594ecdd7e542$export$2be5653e4dada0a3(Array.isArray(data) ? (0, $ac5a0effd567c619$export$c29ba52779f58587)(data) : (0, $ac5a0effd567c619$export$be5b69ecb011d7cc)(data));
    }
    static empty() {
        return new $969c594ecdd7e542$export$2be5653e4dada0a3(new Map());
    }
    toJson(format) {
        switch(format){
            case 'standard':
                return JSON.stringify((0, $ac5a0effd567c619$export$9d0101ad8235e092)(this.config));
            case 'minimal':
                return JSON.stringify((0, $ac5a0effd567c619$export$460f06addafd9f86)(this.config));
        }
    }
    getBoolean(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $ac5a0effd567c619$export$c5fb415882705cf4).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'boolean') return {
            error: (0, $ac5a0effd567c619$export$c5fb415882705cf4).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getString(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $ac5a0effd567c619$export$c5fb415882705cf4).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'string') return {
            error: (0, $ac5a0effd567c619$export$c5fb415882705cf4).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getNumber(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $ac5a0effd567c619$export$c5fb415882705cf4).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'number') return {
            error: (0, $ac5a0effd567c619$export$c5fb415882705cf4).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getStringList(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $ac5a0effd567c619$export$c5fb415882705cf4).NotFound
        };
        const { value: value } = config;
        if (!Array.isArray(value) || !value.every((x)=>typeof x === 'string')) return {
            error: (0, $ac5a0effd567c619$export$c5fb415882705cf4).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getNumberList(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $ac5a0effd567c619$export$c5fb415882705cf4).NotFound
        };
        const { value: value } = config;
        if (!Array.isArray(value) || !value.every((x)=>typeof x === 'number')) return {
            error: (0, $ac5a0effd567c619$export$c5fb415882705cf4).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    constructor(config){
        this.config = void 0;
        this.config = config;
    }
}



var $3ihMw = parcelRequire("3ihMw");
class $796eee35378ec3b4$var$StatsigConfigurations {
    static initialize(instance) {
        this.configCollection = instance;
        if ((0, $3ihMw.default).initializeCompleted()) this.initializeOverrides();
    }
    static initializeFromValues(configCollectionValues) {
        if (typeof configCollectionValues === 'string') // @deprecated
        this.initialize((0, $969c594ecdd7e542$export$2be5653e4dada0a3).fromValues(configCollectionValues));
        else this.initialize((0, $969c594ecdd7e542$export$2be5653e4dada0a3).fromData(configCollectionValues));
    }
    static initializeOverrides() {
        const featureGateOverrides = (0, $3ihMw.default).getOverrides();
        this.configOverrides = Object.entries(featureGateOverrides.configs).reduce((overrideConfigs, [name, value])=>{
            // We currently use FeatureGates library for Statsig gate and experiment overrides.
            // Experiment overrides are stored in the same configs object, so we need to extract the
            // overrides for dynamic configs.
            if (Object.keys(value).length === 1 && value.hasOwnProperty('value')) overrideConfigs[name] = value;
            return overrideConfigs;
        }, {});
    }
    static getValueOrDefault(getFunction, configName, defaultVal) {
        if (this.configOverrides && Object.keys(this.configOverrides).length > 0) {
            const override = this.configOverrides[configName];
            if (override && typeof override.value === typeof defaultVal) return override.value;
        }
        if (!this.configCollection) return defaultVal;
        const configResult = getFunction.call(this.configCollection, configName);
        if (!configResult || 'error' in configResult || !('value' in configResult)) return defaultVal;
        return configResult.value;
    }
    static isKillSwitchOn(configName) {
        return this.getValueOrDefault(this.configCollection?.getBoolean, configName, false);
    }
    static getBoolean(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getBoolean, configName, defaultVal);
    }
    static getString(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getString, configName, defaultVal);
    }
    static getNumber(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getNumber, configName, defaultVal);
    }
    static getStringList(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getStringList, configName, defaultVal);
    }
    static getNumberList(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getNumberList, configName, defaultVal);
    }
}
/* eslint-disable import/no-default-export */ $796eee35378ec3b4$var$StatsigConfigurations.configCollection = void 0;
$796eee35378ec3b4$var$StatsigConfigurations.configOverrides = void 0;
var $796eee35378ec3b4$export$2e2bcd8739ae039 = $796eee35378ec3b4$var$StatsigConfigurations;




function $fe4af4580eaa77a2$export$81abac75ccaea24f(name, callback) {
    return callback();
}
function $fe4af4580eaa77a2$export$a7333d5334c5a076() {
    return null;
}


function $3189054c4ccc424d$var$getRuntime() {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return typeof window === 'undefined' ? 'server' : 'client';
}
function $3189054c4ccc424d$var$getBoundaryName() {
    try {
        return (0, $fe4af4580eaa77a2$export$a7333d5334c5a076)() ?? 'none';
    } catch  {
        return 'unknown';
    }
}
function $3189054c4ccc424d$var$formatDiagnosticValue(value) {
    return String(value ?? 'none').replace(/"/g, '\\"');
}
function $3189054c4ccc424d$export$e46c6766229c2ce9(eventName, fields = {}) {
    const fieldText = Object.entries({
        runtime: $3189054c4ccc424d$var$getRuntime(),
        boundary: $3189054c4ccc424d$var$getBoundaryName(),
        ...fields
    }).map(([key, value])=>`${key}="${$3189054c4ccc424d$var$formatDiagnosticValue(value)}"`).join(' ');
    // eslint-disable-next-line no-console
    console.log(`[Relay migration] ${eventName} ${fieldText}`);
}


const $9c1cd0b61bef59ae$export$7ed338c36f75d9bd = [
    'content-state',
    'admin-announcement-banner',
    'restrictions',
    'whiteboard-common',
    'content-ownership',
    'experiment-personalized-templates-v2',
    'space-permissions',
    'trial-components'
];
const $9c1cd0b61bef59ae$export$52100b186e01dcb0 = [
    'content-state',
    'admin-announcement-banner',
    'restrictions',
    'whiteboard-common',
    'content-ownership',
    'experiment-personalized-templates-v2',
    'space-permissions',
    'trial-components',
    'template-preview',
    'grant-access-dialog',
    'premium-trial',
    'app-navigation',
    'content-renderer',
    'comments-data',
    'create-space',
    'experiment-ai-in-editor-eot',
    'advanced-search',
    'attachments-page',
    'quick-summary',
    'space-directory',
    'content-history-new',
    'live-pages-features',
    'access-requests'
];
const $9c1cd0b61bef59ae$export$931bddf7c452fa92 = [
    'action-buttons',
    'reactions',
    'content-state',
    'admin-announcement-banner',
    'restrictions',
    'whiteboard-common',
    'content-ownership',
    'experiment-personalized-templates-v2',
    'space-permissions',
    'trial-components',
    'template-preview',
    'grant-access-dialog',
    'premium-trial',
    'app-navigation',
    'content-renderer',
    'comments-data',
    'create-space',
    'experiment-ai-in-editor-eot',
    'advanced-search',
    'attachments-page',
    'quick-summary',
    'space-directory',
    'content-history-new',
    'live-pages-features',
    'access-requests',
    'activity-filter',
    'ai-comments-summary',
    'auto-provisioning-edition-parity',
    'blank-page-quick-actions',
    'blog-posts-macro',
    'blog-tree',
    'breadcrumbs',
    'bulk-permissions',
    'confluence-databases-extension',
    'confluence-embeds',
    'contact-administrator',
    'content-history',
    'content-renderer-legacy-macros',
    'copy-space-permissions',
    'cross-flow',
    'custom-content',
    'edit-button',
    'editor-conversion',
    'editor-revert-dialog',
    'experiment-land-users-in-editor-with-revamped-bpqa',
    'experiment-more-product-users-can-upgrade-pay',
    'fabric-extension-lib',
    'fabric-page-optin-migration',
    'favourite-button',
    'import-from-sources',
    'inspect-permissions',
    'mentions-notifications',
    'move-blog-modal',
    'nav-menus',
    'navigation-search-dialog',
    'notifications',
    'page-rovo-config-common',
    'performance-insights',
    'profile',
    'space-manager',
    'snippets',
    'smart-create',
    'template-editor',
    'template-list',
    'version-history',
    'watermark-admin',
    'fabric-providers',
    'inline-comments',
    'inline-comments-hooks',
    'full-page-editor',
    'native-collab',
    'query-preloaders',
    'query-preloader-tools',
    'graphql',
    'editor-features',
    'content-types-header',
    'comments-pubsub',
    'create-blank-fabric-page',
    'templates-cards',
    'blueprints',
    'change-edition',
    'billing-page',
    'onboarding-helpers',
    'no-permission',
    'share-and-restrict-dialog',
    'flags',
    'create-space-preload',
    'space-roles',
    'recent-spaces',
    'delete-space',
    'popular-labels',
    'admin-center',
    'view-page',
    'view-page-common',
    'content-body',
    'content-container',
    'content-prerequisites',
    'content-renderer',
    'content-appearance',
    'inline-highlights-query',
    'page-cover-picture',
    'content-header',
    'content-topper',
    'restrictions',
    'comment-extension-handlers',
    'comment-simple',
    'comments-hooks',
    'comments-panel-utils',
    'comments-query-param-handlers',
    'comments-pubsub',
    'comments-util',
    'confluence-databases',
    'contextual-create',
    'contributors-macro',
    'copy-content-link',
    'copy-page-tree-dialog',
    'core-invites-provider',
    'create-from-template',
    'current-user',
    'custom-content-view',
    'live-page-route-preloader',
    'load-live-page',
    'load-edit-page',
    'live-pages',
    'external-share',
    'confluence-fabric-editor'
];
const $9c1cd0b61bef59ae$export$a0bcd84119b6d2a = [
    'action-buttons',
    'reactions',
    'content-state',
    'admin-announcement-banner',
    'restrictions',
    'whiteboard-common',
    'content-ownership',
    'experiment-personalized-templates-v2',
    'space-permissions',
    'trial-components',
    'template-preview',
    'grant-access-dialog',
    'premium-trial',
    'app-navigation',
    'content-renderer',
    'comments-data',
    'create-space',
    'experiment-ai-in-editor-eot',
    'advanced-search',
    'attachments-page',
    'quick-summary',
    'space-directory',
    'content-history-new',
    'live-pages-features',
    'access-requests',
    'activity-filter',
    'ai-comments-summary',
    'auto-provisioning-edition-parity',
    'blank-page-quick-actions',
    'blog-posts-macro',
    'blog-tree',
    'breadcrumbs',
    'bulk-permissions',
    'confluence-databases-extension',
    'confluence-embeds',
    'contact-administrator',
    'content-history',
    'content-renderer-legacy-macros',
    'copy-space-permissions',
    'cross-flow',
    'custom-content',
    'edit-button',
    'editor-conversion',
    'editor-revert-dialog',
    'experiment-land-users-in-editor-with-revamped-bpqa',
    'experiment-more-product-users-can-upgrade-pay',
    'fabric-extension-lib',
    'fabric-page-optin-migration',
    'favourite-button',
    'import-from-sources',
    'inspect-permissions',
    'mentions-notifications',
    'move-blog-modal',
    'nav-menus',
    'navigation-search-dialog',
    'notifications',
    'page-rovo-config-common',
    'performance-insights',
    'profile',
    'space-manager',
    'snippets',
    'smart-create',
    'template-editor',
    'template-list',
    'version-history',
    'watermark-admin',
    'fabric-providers',
    'inline-comments',
    'inline-comments-hooks',
    'full-page-editor',
    'native-collab',
    'query-preloaders',
    'query-preloader-tools',
    'graphql',
    'editor-features',
    'content-types-header',
    'comments-pubsub',
    'create-blank-fabric-page',
    'templates-cards',
    'blueprints',
    'change-edition',
    'billing-page',
    'onboarding-helpers',
    'no-permission',
    'share-and-restrict-dialog',
    'flags',
    'create-space-preload',
    'space-roles',
    'recent-spaces',
    'delete-space',
    'popular-labels',
    'admin-center',
    'view-page',
    'view-page-common',
    'content-body',
    'content-container',
    'content-prerequisites',
    'content-renderer',
    'content-appearance',
    'inline-highlights-query',
    'page-cover-picture',
    'content-header',
    'content-topper',
    'restrictions',
    'comment-extension-handlers',
    'comment-simple',
    'comments-hooks',
    'comments-panel-utils',
    'comments-query-param-handlers',
    'comments-pubsub',
    'comments-util',
    'confluence-databases',
    'contextual-create',
    'contributors-macro',
    'copy-content-link',
    'copy-page-tree-dialog',
    'core-invites-provider',
    'create-from-template',
    'current-user',
    'custom-content-view',
    'live-page-route-preloader',
    'load-live-page',
    'load-edit-page',
    'live-pages',
    'custom-content-view',
    'data-lifecycle-management',
    'data-security',
    'delete-pages',
    'delete-space',
    'edit-features',
    'edit-space-logo',
    'edition-awareness',
    'editor-breadcrumbs',
    'editor-context-panel-content-creation-panel',
    'editor-ellipsis-dropdown',
    'editor-flags',
    'editor-help',
    'editor-move-page-button',
    'editor-offline-storage',
    'editor-preview',
    'editor-primary-toolbar-components',
    'editor-schedule-publish',
    'entity-operations',
    'error-types',
    'excerpt-include',
    'experiment-cfind-5139-confluence-aifc-onboarding',
    'experiment-cfind-5291-template-touchpoint',
    'experiment-contextual-collab-onboarding-for-new-end-users',
    'experiment-home-onboarding-takeover-v2',
    'experiment-nth-user-orientation',
    'experiment-reverse-trial-message-suppression',
    'experiment-suggest-whiteboard-based-on-page-title',
    'experiment-tailor-in-product-journey-sub-anchors',
    'experiment-teammate-content-screen-page',
    'export-space',
    'external-collab-ui',
    'external-share-utils',
    'fabric-extension-queries',
    'feature-discovery',
    'folder',
    'folder-conversion',
    'global-feedback-collector',
    'global-operations',
    'graphql-error-processor',
    'highlight-actions',
    'in-product-help',
    'in-trial-feature-gates-banner',
    'inconsistent-license',
    'inline-comments-reattach',
    'inline-highlights-query',
    'integrations-discovery',
    'issue-create-side-panel',
    'keyboard-shortcuts-dialog',
    'labels-footer',
    'live-search',
    'mobile-app-macro-renderer',
    'mobile-web',
    'monitoring',
    'move-pencil-button',
    'network',
    'onboarding-setup-modal-common',
    'onboarding-state-update-tooling',
    'page-catchup',
    'page-cover-picture',
    'page-footer-comments',
    'page-header-loom-button',
    'page-info',
    'page-layout',
    'page-selection-table',
    'page-selector',
    'page-utils',
    'pagetree-macro',
    'permissions-principals',
    'persistent-invite-button',
    'persistent-upgrade',
    'powered-by-templates',
    'premium-onboarding',
    'presentation-mode',
    'profile-macros',
    'prompt-competitor-link',
    'publish-page-as-blog',
    'quick-reload',
    'recently-updated-macro',
    'redactions',
    'redirect-legacy-view-page',
    'render-for-feature-flag',
    'roles-hub',
    'screen',
    'search-breadcrumbs',
    'smart-create-page-editor',
    'smart-link-droppable',
    'spa-view-context',
    'space-access-details',
    'space-base',
    'space-curation',
    'space-pages',
    'space-selector',
    'storage-enforcement',
    'super-admin',
    'team-admin-controls',
    'template-card',
    'template-migration-preview',
    'template-suggestions',
    'template-utils',
    'theming',
    'title-area-content-components',
    'topics',
    'unified-analytics',
    'update-content-property-utils',
    'user-and-group-search',
    'whiteboard',
    'whiteboard-extension',
    'add-personal-space-dialog',
    'adf-renderer',
    'analytics',
    'anonymous-access',
    'archive-space',
    'archived-pages-list',
    'audit-log',
    'automation',
    'automation-menu',
    'automated-meeting-notes',
    'beta-features',
    'comment-button',
    'conditional-publish-dialog',
    'content-by-label-macro',
    'content-metadata',
    'content-title',
    'content-tools',
    'content-tree-actions',
    'content-tree-search'
];
const $9c1cd0b61bef59ae$export$61b49a5ae59d663 = [
    'access-links',
    'access-requests',
    'action-buttons',
    'activity-filter',
    'add-personal-space-dialog',
    'adf-renderer',
    'admin-announcement-banner',
    'admin-center',
    'advanced-search',
    'agent-mention',
    'ai-comments-summary',
    'ai-floating-context-menu',
    'ai-planner-confluence-bridge-route',
    'ai-rovo-button',
    'analytics',
    'annotation-provider-inline-comments',
    'anonymous-access',
    'app-navigation',
    'approvals',
    'archive-pages',
    'archive-space',
    'archived-pages-list',
    'attachments-macro',
    'attachments-page',
    'audio',
    'audit-log',
    'auto-provisioning-edition-parity',
    'automated-meeting-notes',
    'automation',
    'automation-discovery',
    'automation-extensions',
    'automation-menu',
    'beta-features',
    'billing-page',
    'blank-page-quick-actions',
    'blog-posts-macro',
    'blog-tree',
    'blueprints',
    'breadcrumbs',
    'bulk-page-actions',
    'bulk-permissions',
    'byline-connections',
    'change-edition',
    'change-history-macro',
    'comment',
    'comment-button',
    'comment-extension-handlers',
    'comment-simple',
    'comments-data',
    'comments-data-manager',
    'comments-hooks',
    'comments-panel',
    'comments-panel-queries',
    'comments-panel-utils',
    'comments-pubsub',
    'comments-query-param-handlers',
    'comments-util',
    'company-hub',
    'company-hub-utils',
    'conditional-publish-dialog',
    'confluence-analytics',
    'confluence-databases',
    'confluence-databases-extension',
    'confluence-embeds',
    'confluence-fabric-editor',
    'confluence-frontend-server',
    'confluence-post-office-provider',
    'connectors',
    'contact-administrator',
    'content-appearance',
    'content-body',
    'content-by-label-macro',
    'content-container',
    'content-header',
    'content-history',
    'content-history-new',
    'content-markdown-mode',
    'content-metadata',
    'content-ownership',
    'content-prerequisites',
    'content-quick-actions',
    'content-renderer',
    'content-renderer-legacy-macros',
    'content-report-table-macro',
    'content-smartlinks',
    'content-state',
    'content-title',
    'content-tools',
    'content-topper',
    'content-tree-actions',
    'content-tree-search',
    'content-types-header',
    'content-types-utils',
    'contextual-create',
    'contextual-reading-aids',
    'contributors-macro',
    'copy-content-link',
    'copy-page-tree-dialog',
    'copy-space-permissions',
    'core-invites-provider',
    'create-blank-fabric-page',
    'create-content-from-template',
    'create-from-template',
    'create-space',
    'create-space-preload',
    'cross-flow',
    'current-user',
    'custom-content',
    'custom-content-view',
    'custom-header-footer',
    'custom-sites-extensions',
    'customize-navigation',
    'data-classification',
    'data-lifecycle-management',
    'data-security',
    'default-space-permissions',
    'delete-pages',
    'delete-space',
    'details-panel',
    'dev-docs',
    'edit-button',
    'edit-features',
    'edit-space-logo',
    'edition-awareness',
    'editor-action-bar',
    'editor-breadcrumbs',
    'editor-content-mode-button',
    'editor-context-panel-content-creation-panel',
    'editor-conversion',
    'editor-ellipsis-dropdown',
    'editor-features',
    'editor-flags',
    'editor-help',
    'editor-move-page-button',
    'editor-offline-storage',
    'editor-preloader',
    'editor-presets',
    'editor-preview',
    'editor-primary-toolbar-components',
    'editor-revert-dialog',
    'editor-schedule-publish',
    'emoji-title',
    'entity-operations',
    'error-types',
    'excerpt-include',
    'experiment-ai-collaboration-brief',
    'experiment-ai-in-editor-eot',
    'experiment-cfind-5139-confluence-aifc-onboarding',
    'experiment-cfind-5291-template-touchpoint',
    'experiment-twcg-2304-import-in-onboarding',
    'experiment-contextual-collab-onboarding-for-new-end-users',
    'experiment-editor-title-area-banner',
    'experiment-home-onboarding-takeover-v2',
    'experiment-inline-reactions',
    'experiment-land-users-in-editor-with-revamped-bpqa',
    'experiment-more-product-users-can-upgrade-pay',
    'experiment-nth-user-orientation',
    'experiment-omnibar',
    'experiment-personalized-templates-v2',
    'experiment-reverse-trial-message-suppression',
    'experiment-suggest-whiteboard-based-on-page-title',
    'experiment-tailor-in-product-journey-sub-anchors',
    'experiment-teammate-content-screen-page',
    'experiment-twcg-1489-cc-3p-connector-onboarding',
    'experiment-twc-aifc-onboarding',
    'export-space',
    'external-collab-ui',
    'external-share',
    'external-share-utils',
    'fabric-extension-handlers',
    'fabric-extension-legacy-macro-renderer',
    'fabric-extension-lib',
    'fabric-extension-queries',
    'fabric-media-support',
    'fabric-page-optin-migration',
    'fabric-providers',
    'favourite-button',
    'feature-discovery',
    'feed',
    'flags',
    'folder',
    'folder-conversion',
    'forge-ui',
    'full-page-editor',
    'global-feedback-collector',
    'global-operations',
    'grant-access-dialog',
    'graphql',
    'graphql-error-processor',
    'highlight-actions',
    'home',
    'import-content',
    'import-from-sources',
    'importer-dashboard',
    'in-product-help',
    'in-trial-feature-gates-banner',
    'inconsistent-license',
    'inline-comments',
    'inline-comments-common',
    'inline-comments-hooks',
    'inline-comments-reattach',
    'inline-highlights-query',
    'inspect-permissions',
    'integrations-discovery',
    'issue-create-side-panel',
    'keyboard-shortcuts-dialog',
    'labels',
    'labels-footer',
    'legacy-schema-bridge',
    'link-to-this-page-dialog',
    'live-page-route-preloader',
    'live-pages',
    'live-pages-features',
    'live-pages-utils',
    'live-search',
    'load-edit-page',
    'load-live-page',
    'local-activity',
    'loom-utils',
    'main-layout',
    'manage-pages',
    'manage-watcher-dialog',
    'media-client',
    'mentions-notifications',
    'mobile-app-macro-renderer',
    'mobile-web',
    'monitoring',
    'move-blog-modal',
    'move-pencil-button',
    'native-collab',
    'nav-menus',
    'navigation-search-dialog',
    'nbm-migration',
    'network',
    'no-permission',
    'not-found',
    'notifications',
    'object-comments',
    'onboarding',
    'onboarding-account-setup-modal',
    'onboarding-helpers',
    'onboarding-nth-user-setup-modal',
    'onboarding-setup-modal-common',
    'onboarding-state-update-tooling',
    'page-card',
    'page-catchup',
    'page-comments-queries',
    'page-cover-picture',
    'page-footer-comments',
    'page-header-loom-button',
    'page-include-macro',
    'page-info',
    'page-layout',
    'page-pdf-export',
    'page-properties-report-renderer',
    'page-recommendations',
    'page-restrictions-context',
    'page-rovo-config-common',
    'page-selection-table',
    'page-selector',
    'page-splitter',
    'page-tree',
    'page-utils',
    'pagetree-macro',
    'pagetree-search-macro',
    'performance-insights',
    'permissions-principals',
    'persistent-invite-button',
    'persistent-upgrade',
    'popular-labels',
    'popular-labels-macro',
    'powered-by-templates',
    'preload-macros',
    'preload-storage-queries',
    'premium-onboarding',
    'premium-trial',
    'presentation-mode',
    'profile',
    'profile-macros',
    'prompt-competitor-link',
    'public-links',
    'publish-modal',
    'publish-page-as-blog',
    'query-group',
    'query-preloader-tools',
    'query-preloaders',
    'query-preloaders-common',
    'quick-reload',
    'quick-summary',
    'reactions',
    'read-time',
    'recent-spaces',
    'recently-updated-macro',
    'redactions',
    'redirect-legacy-view-page',
    'render-for-feature-flag',
    'resolved-inline-comments-dialog',
    'restrictions',
    'roles-hub',
    'screen',
    'search-breadcrumbs',
    'session-data',
    'share-and-restrict-dialog',
    'side-navigation',
    'site-operations',
    'site-permissions',
    'site-settings',
    'smart-card-provider',
    'smart-create',
    'smart-create-page-editor',
    'smart-folder',
    'smart-link-droppable',
    'snippets',
    'spa-view-context',
    'space-access-details',
    'space-base',
    'space-contributors',
    'space-curation',
    'space-directory',
    'space-guest-list',
    'space-manager',
    'space-overview',
    'space-pages',
    'space-permissions',
    'space-roles',
    'space-selector',
    'space-settings',
    'space-shortcuts',
    'space-suggestions',
    'space-utils',
    'space-views',
    'storage-enforcement',
    'super-admin',
    'targeting',
    'tasks-report-macro',
    'team-admin-controls',
    'team-calendar',
    'team-presence',
    'template-card',
    'template-editor',
    'template-gallery',
    'template-list',
    'template-migration-preview',
    'template-preview',
    'template-suggestions',
    'template-utils',
    'templates-cards',
    'theming',
    'title-area-content-components',
    'topics',
    'trial-components',
    'unified-analytics',
    'unread-comments',
    'update-content-property-utils',
    'user-and-group-search',
    'version-history',
    'view-page',
    'view-page-common',
    'view-page-gateway',
    'viewpdf-macro',
    'viewxls-macro',
    'watch-dialog',
    'watermark-admin',
    'web-item-location',
    'web-panel-location',
    'whiteboard',
    'whiteboard-common',
    'whiteboard-extension',
    'wrm'
];
const $9c1cd0b61bef59ae$export$5622575a018d099e = '*';
const $9c1cd0b61bef59ae$export$13c5e607888fa711 = [
    $9c1cd0b61bef59ae$export$5622575a018d099e
];
const $9c1cd0b61bef59ae$export$b56fc941145f38f8 = {
    'set:A1': $9c1cd0b61bef59ae$export$7ed338c36f75d9bd,
    'set:A2': $9c1cd0b61bef59ae$export$52100b186e01dcb0,
    'set:A3': $9c1cd0b61bef59ae$export$931bddf7c452fa92,
    'set:A4': $9c1cd0b61bef59ae$export$a0bcd84119b6d2a,
    'set:ALL': $9c1cd0b61bef59ae$export$61b49a5ae59d663,
    'set:EVERYTHING': $9c1cd0b61bef59ae$export$13c5e607888fa711
};
/**
 * Matches any `set:<name>` reference, where `<name>` is alphanumeric — both the numbered sets
 * (`set:A1`) and named ones (`set:ALL`).
 *
 * Historically this was `/^set:[A-Z]\d+$/`, which required a digit suffix and therefore did NOT
 * match `set:ALL`. That made `'set:ALL'` fall through to the literal-package-name branch below, so
 * configuring it enabled Relay for *zero* packages instead of all of them — indistinguishable from
 * `?disableRelay=1`, and silent.
 */ const $9c1cd0b61bef59ae$var$packageSetPattern = /^set:[A-Za-z0-9]+$/;
function $9c1cd0b61bef59ae$export$23b8081faeb32b9e(configuredPackages, packageSets = $9c1cd0b61bef59ae$export$b56fc941145f38f8) {
    const excludedPackages = configuredPackages.flatMap((configuredPackage)=>configuredPackage.startsWith('-') ? [
            configuredPackage.slice(1)
        ] : []);
    const excludedPackageSet = new Set(excludedPackages);
    const expandedPackages = configuredPackages.flatMap((configuredPackage)=>{
        if (configuredPackage.startsWith('-')) return [];
        if (!$9c1cd0b61bef59ae$var$packageSetPattern.test(configuredPackage)) return [
            configuredPackage
        ];
        return packageSets[configuredPackage] ?? [];
    });
    const enabledPackages = expandedPackages.filter((expandedPackage)=>!excludedPackageSet.has(expandedPackage));
    return {
        // Derived from the filtered list so that `-*` turns the wildcard back off, consistent with
        // exclusions winning everywhere else.
        enablesEveryPackage: enabledPackages.includes($9c1cd0b61bef59ae$export$5622575a018d099e),
        enabledPackages: enabledPackages,
        excludedPackages: excludedPackages
    };
}
function $9c1cd0b61bef59ae$export$527166c432e3972e(configuredPackages, packageSets = $9c1cd0b61bef59ae$export$b56fc941145f38f8) {
    return $9c1cd0b61bef59ae$export$23b8081faeb32b9e(configuredPackages, packageSets).enabledPackages;
}


/**
 * Argument definitions declared by a Relay artifact — a `ConcreteRequest`'s normalization operation
 * or a `ReaderFragment`. Apollo `DocumentNode`s carry none, so they resolve to `null`.
 */ function $d9376047307287a2$var$getRelayArgumentDefinitions(node) {
    const artifact = node;
    return artifact?.operation?.argumentDefinitions ?? artifact?.argumentDefinitions ?? null;
}
function $d9376047307287a2$export$aa74e92267694566(node, variables) {
    const provided = variables ?? {};
    const argumentDefinitions = $d9376047307287a2$var$getRelayArgumentDefinitions(node);
    if (!argumentDefinitions || argumentDefinitions.length === 0) return provided;
    let resolved;
    for (const definition of argumentDefinitions){
        const name = definition?.name;
        // `defaultValue == null` means the artifact declares no default (Relay emits `null` here for
        // undefaulted variables), so there is nothing to fill in. Falsy-but-present defaults such as
        // `false`, `0` and `''` are real defaults and must still be applied.
        if (typeof name !== 'string' || definition.defaultValue == null) continue;
        if (provided[name] != null) continue;
        resolved = resolved ?? {
            ...provided
        };
        resolved[name] = definition.defaultValue;
    }
    return resolved ?? provided;
}
function $d9376047307287a2$var$sanitizeOperationKey(operationName) {
    return operationName.replace(/[^\-.\w]/g, '_');
}
function $d9376047307287a2$export$7c7cda779ed3b967(query) {
    if ('params' in query) return query.params?.name ?? null;
    if ('definitions' in query) {
        const definition = query.definitions?.find((d)=>d.kind === 'OperationDefinition' && 'name' in d);
        return definition?.name?.value ?? null;
    }
    return null;
}
function $d9376047307287a2$export$97985874639f879d(operationName, _variables) {
    if (!operationName) return null;
    return $d9376047307287a2$var$sanitizeOperationKey(operationName);
}


const $d19417f48dced338$var$LEGACY_CONFLUENCE_PACKAGE_PREFIXES = [
    '@confluence/',
    '@confluence-classic/'
];
const $d19417f48dced338$var$CONFIGURED_PACKAGES_CACHE_KEY_SEPARATOR = '\u0000';
let $d19417f48dced338$var$disableRelayOverride;
let $d19417f48dced338$var$relayInteropEnabledOverride;
let $d19417f48dced338$var$relayMigrationDiagnosticsEnabled;
let $d19417f48dced338$var$relayEnabledPackagesConfig;
const $d19417f48dced338$var$resolvedPackageConfigCache = new Map();
function $d19417f48dced338$export$fc4268acbf806479(value) {
    $d19417f48dced338$var$relayInteropEnabledOverride = value;
}
function $d19417f48dced338$export$586d72d4cbfe5176() {
    $d19417f48dced338$var$disableRelayOverride = undefined;
}
function $d19417f48dced338$export$492fd3bbe8482fd() {
    $d19417f48dced338$var$relayMigrationDiagnosticsEnabled = undefined;
    $d19417f48dced338$var$relayEnabledPackagesConfig = undefined;
    $d19417f48dced338$var$resolvedPackageConfigCache.clear();
}
function $d19417f48dced338$var$isRelayDisabledByQueryParam() {
    if ($d19417f48dced338$var$disableRelayOverride !== undefined) return $d19417f48dced338$var$disableRelayOverride;
    try {
        if (typeof window !== 'undefined' && window.location?.search) {
            const params = new URLSearchParams(window.location.search);
            const value = params.get('disableRelay');
            $d19417f48dced338$var$disableRelayOverride = value === '1' || value === 'true';
        } else $d19417f48dced338$var$disableRelayOverride = false;
    } catch  {
        $d19417f48dced338$var$disableRelayOverride = false;
    }
    return $d19417f48dced338$var$disableRelayOverride;
}
function $d19417f48dced338$var$getPackageAliases(packageName) {
    for (const packagePrefix of $d19417f48dced338$var$LEGACY_CONFLUENCE_PACKAGE_PREFIXES){
        if (packageName.startsWith(packagePrefix)) return [
            packageName,
            packageName.slice(packagePrefix.length)
        ];
    }
    return [
        packageName,
        ...$d19417f48dced338$var$LEGACY_CONFLUENCE_PACKAGE_PREFIXES.map((packagePrefix)=>`${packagePrefix}${packageName}`)
    ];
}
function $d19417f48dced338$var$getPackageAliasSet(packageNames) {
    return new Set(packageNames.flatMap($d19417f48dced338$var$getPackageAliases));
}
function $d19417f48dced338$var$getConfiguredPackagesCacheKey(configuredPackages) {
    return configuredPackages.join($d19417f48dced338$var$CONFIGURED_PACKAGES_CACHE_KEY_SEPARATOR);
}
function $d19417f48dced338$var$getCachedRelayEnabledPackages(configuredPackages) {
    const configuredPackagesCacheKey = $d19417f48dced338$var$getConfiguredPackagesCacheKey(configuredPackages);
    const cachedPackages = $d19417f48dced338$var$resolvedPackageConfigCache.get(configuredPackagesCacheKey);
    if (cachedPackages) return cachedPackages;
    const { enablesEveryPackage: enablesEveryPackage, enabledPackages: enabledPackages, excludedPackages: excludedPackages } = (0, $9c1cd0b61bef59ae$export$23b8081faeb32b9e)(configuredPackages);
    const resolvedPackages = {
        enablesEveryPackage: enablesEveryPackage,
        enabledPackageAliases: $d19417f48dced338$var$getPackageAliasSet(enabledPackages),
        excludedPackageAliases: $d19417f48dced338$var$getPackageAliasSet(excludedPackages),
        packageDecisions: new Map()
    };
    $d19417f48dced338$var$resolvedPackageConfigCache.set(configuredPackagesCacheKey, resolvedPackages);
    return resolvedPackages;
}
function $d19417f48dced338$var$getRelayEnabledPackagesConfig() {
    if ($d19417f48dced338$var$relayEnabledPackagesConfig === undefined) $d19417f48dced338$var$relayEnabledPackagesConfig = (0, $796eee35378ec3b4$export$2e2bcd8739ae039).getStringList('confluence_relay_enabled_packages', []);
    return $d19417f48dced338$var$relayEnabledPackagesConfig;
}
function $d19417f48dced338$var$isRelayMigrationDiagnosticsEnabled() {
    if ($d19417f48dced338$var$relayMigrationDiagnosticsEnabled === undefined) $d19417f48dced338$var$relayMigrationDiagnosticsEnabled = (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_relay_migration_diagnostics_enabled');
    return $d19417f48dced338$var$relayMigrationDiagnosticsEnabled;
}
function $d19417f48dced338$export$4f08331e1253d12a(configuredPackages, callerPackage) {
    const { enablesEveryPackage: enablesEveryPackage, enabledPackageAliases: enabledPackageAliases, excludedPackageAliases: excludedPackageAliases, packageDecisions: packageDecisions } = $d19417f48dced338$var$getCachedRelayEnabledPackages(configuredPackages);
    const cachedPackageDecision = packageDecisions.get(callerPackage);
    if (cachedPackageDecision !== undefined) return cachedPackageDecision;
    // Exclusions are checked first and against the caller directly, because they must also override
    // `set:EVERYTHING` — which enables packages that appear in no list, so there is nothing to filter
    // them out of.
    const relayEnabled = !excludedPackageAliases.has(callerPackage) && (enablesEveryPackage || enabledPackageAliases.has(callerPackage));
    packageDecisions.set(callerPackage, relayEnabled);
    return relayEnabled;
}
function $d19417f48dced338$var$logRelayDecision({ callerPackage: callerPackage, operationName: operationName, operationKey: operationKey, phase: phase, relayEnabled: relayEnabled, decisionReason: decisionReason }) {
    if (!$d19417f48dced338$var$isRelayMigrationDiagnosticsEnabled()) return;
    (0, $3189054c4ccc424d$export$e46c6766229c2ce9)('Decision', {
        phase: phase,
        callerPackage: callerPackage,
        operationName: operationName,
        operationKey: operationKey,
        relayEnabled: relayEnabled,
        decisionReason: decisionReason
    });
}
function $d19417f48dced338$export$129c37b549a1eea7(callerPackage, options = {}) {
    const phase = options.phase ?? 'unknown';
    const operationName = options.operationName ?? null;
    const operationKey = options.operationKey ?? (0, $d9376047307287a2$export$97985874639f879d)(operationName, options.variables) ?? null;
    // Query param override: ?disableRelay=1 or ?disableRelay=true forces Relay off
    if ($d19417f48dced338$var$isRelayDisabledByQueryParam()) {
        $d19417f48dced338$var$logRelayDecision({
            callerPackage: callerPackage,
            operationName: operationName,
            operationKey: operationKey,
            phase: phase,
            relayEnabled: false,
            decisionReason: 'disableRelay query param'
        });
        return false;
    }
    if ($d19417f48dced338$var$relayInteropEnabledOverride !== undefined) {
        $d19417f48dced338$var$logRelayDecision({
            callerPackage: callerPackage,
            operationName: operationName,
            operationKey: operationKey,
            phase: phase,
            relayEnabled: $d19417f48dced338$var$relayInteropEnabledOverride,
            decisionReason: 'relay interop override'
        });
        return $d19417f48dced338$var$relayInteropEnabledOverride;
    }
    if (!(0, $ef003bca5ae3d837$export$9db1624a8af791a4)('confluence_apollo_to_relay_migration', 'isEnabled', false)) {
        $d19417f48dced338$var$logRelayDecision({
            callerPackage: callerPackage,
            operationName: operationName,
            operationKey: operationKey,
            phase: phase,
            relayEnabled: false,
            decisionReason: 'master experiment disabled'
        });
        return false;
    }
    if (operationKey) {
        const operations = (0, $796eee35378ec3b4$export$2e2bcd8739ae039).getStringList('confluence_relay_enabled_operations', []);
        if (operations.includes(operationKey)) {
            $d19417f48dced338$var$logRelayDecision({
                callerPackage: callerPackage,
                operationName: operationName,
                operationKey: operationKey,
                phase: phase,
                relayEnabled: true,
                decisionReason: 'operation allowlist'
            });
            return true;
        }
        $d19417f48dced338$var$logRelayDecision({
            callerPackage: callerPackage,
            operationName: operationName,
            operationKey: operationKey,
            phase: phase,
            relayEnabled: false,
            decisionReason: operations.length > 0 ? 'operation allowlist miss' : 'operation allowlist empty'
        });
    }
    if (!callerPackage) {
        $d19417f48dced338$var$logRelayDecision({
            callerPackage: callerPackage,
            operationName: operationName,
            operationKey: operationKey,
            phase: phase,
            relayEnabled: false,
            decisionReason: 'missing caller package'
        });
        return false;
    }
    if (!(0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_relay_package_rollout_enabled')) {
        $d19417f48dced338$var$logRelayDecision({
            callerPackage: callerPackage,
            operationName: operationName,
            operationKey: operationKey,
            phase: phase,
            relayEnabled: false,
            decisionReason: 'package rollout feature gate disabled'
        });
        return false;
    }
    const relayEnabled = $d19417f48dced338$export$4f08331e1253d12a($d19417f48dced338$var$getRelayEnabledPackagesConfig(), callerPackage);
    $d19417f48dced338$var$logRelayDecision({
        callerPackage: callerPackage,
        operationName: operationName,
        operationKey: operationKey,
        phase: phase,
        relayEnabled: relayEnabled,
        decisionReason: 'package allowlist'
    });
    return relayEnabled;
}



var $3g9wx = parcelRequire("3g9wx");

function $4ccd28be33b51c76$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $597d1726912070b7$export$92d6ed0888e7cb7f)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}


/**
 * The set of allowed kind values for AST nodes.
 */ var $df22df0c34b6b6fb$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 



var $fSkCz = parcelRequire("fSkCz");
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $4ac8f0480dfb0ef5$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 




var $gjwnY = parcelRequire("gjwnY");


function $39b6c1c5a9ba1d3a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $39b6c1c5a9ba1d3a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $39b6c1c5a9ba1d3a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $39b6c1c5a9ba1d3a$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$39b6c1c5a9ba1d3a$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};


function $b2c14c4eb18ae1f9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b2c14c4eb18ae1f9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b2c14c4eb18ae1f9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b2c14c4eb18ae1f9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $b2c14c4eb18ae1f9$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $4d95c1e0202d387b$export$2e2bcd8739ae039)(0, "Body must be a string. Received: ".concat((0, $gjwnY.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $4d95c1e0202d387b$export$2e2bcd8739ae039)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $4d95c1e0202d387b$export$2e2bcd8739ae039)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $b2c14c4eb18ae1f9$var$_createClass(Source, [
        {
            key: (0, $9396579e49d8388a$export$5deadc579ccc7c9c),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $b2c14c4eb18ae1f9$export$75135ee9ed6e435b(source) {
    return (0, $39b6c1c5a9ba1d3a$export$2e2bcd8739ae039)(source, $b2c14c4eb18ae1f9$export$1d2df86270c81ecb);
}


/**
 * The set of allowed directive location values.
 */ var $b7a7400c364919cb$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 




var $fSkCz = parcelRequire("fSkCz");

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $3656dc6a494b8587$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $3656dc6a494b8587$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $3656dc6a494b8587$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $3656dc6a494b8587$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $3656dc6a494b8587$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $3656dc6a494b8587$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $3656dc6a494b8587$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


var $523e1b201dcf266a$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    };
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $523e1b201dcf266a$var$readToken(this, token);
        }while (token.kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).COMMENT);
        return token;
    };
    return Lexer;
}();
function $523e1b201dcf266a$export$59ac0f4da287406a(kind) {
    return kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BANG || kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).DOLLAR || kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).AMP || kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).PAREN_L || kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).PAREN_R || kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).SPREAD || kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).COLON || kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).EQUALS || kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).AT || kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACKET_L || kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACKET_R || kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_L || kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).PIPE || kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_R;
}
function $523e1b201dcf266a$var$printCharCode(code) {
    return isNaN(code) ? (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $523e1b201dcf266a$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $523e1b201dcf266a$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $523e1b201dcf266a$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $523e1b201dcf266a$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $523e1b201dcf266a$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $523e1b201dcf266a$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $4ccd28be33b51c76$export$bbee0c6176c019d4)(source, pos, $523e1b201dcf266a$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $523e1b201dcf266a$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($523e1b201dcf266a$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($523e1b201dcf266a$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $523e1b201dcf266a$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $523e1b201dcf266a$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $4ccd28be33b51c76$export$bbee0c6176c019d4)(source, position, "Invalid number, unexpected digit after 0: ".concat($523e1b201dcf266a$var$printCharCode(code), "."));
    } else {
        position = $523e1b201dcf266a$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $523e1b201dcf266a$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $523e1b201dcf266a$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $523e1b201dcf266a$var$isNameStart(code)) throw (0, $4ccd28be33b51c76$export$bbee0c6176c019d4)(source, position, "Invalid number, expected digit but got: ".concat($523e1b201dcf266a$var$printCharCode(code), "."));
    return new (0, $fSkCz.Token)(isFloat ? (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).FLOAT : (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $523e1b201dcf266a$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $4ccd28be33b51c76$export$bbee0c6176c019d4)(source, position, "Invalid number, expected digit but got: ".concat($523e1b201dcf266a$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $523e1b201dcf266a$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $4ccd28be33b51c76$export$bbee0c6176c019d4)(source, position, "Invalid character within String: ".concat($523e1b201dcf266a$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $523e1b201dcf266a$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $4ccd28be33b51c76$export$bbee0c6176c019d4)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $4ccd28be33b51c76$export$bbee0c6176c019d4)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $4ccd28be33b51c76$export$bbee0c6176c019d4)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $523e1b201dcf266a$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, line, col, prev, (0, $3656dc6a494b8587$export$fd88c0b652c46ccc)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $4ccd28be33b51c76$export$bbee0c6176c019d4)(source, position, "Invalid character within String: ".concat($523e1b201dcf266a$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $4ccd28be33b51c76$export$bbee0c6176c019d4)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $523e1b201dcf266a$var$uniCharCode(a, b, c, d) {
    return $523e1b201dcf266a$var$char2hex(a) << 12 | $523e1b201dcf266a$var$char2hex(b) << 8 | $523e1b201dcf266a$var$char2hex(c) << 4 | $523e1b201dcf266a$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $523e1b201dcf266a$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $523e1b201dcf266a$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $fSkCz.Token)((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $523e1b201dcf266a$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}


function $014faf4fb9554b60$export$98e6a39c04603d36(source, options) {
    var parser = new $014faf4fb9554b60$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $014faf4fb9554b60$export$5303528d1070ff6f(source, options) {
    var parser = new $014faf4fb9554b60$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).EOF);
    return value;
}
function $014faf4fb9554b60$export$28b8f402ccc88182(source, options) {
    var parser = new $014faf4fb9554b60$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).EOF);
    return type;
}
var $014faf4fb9554b60$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $b2c14c4eb18ae1f9$export$75135ee9ed6e435b)(source) ? source : new (0, $b2c14c4eb18ae1f9$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $523e1b201dcf266a$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).NAME);
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
    ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).EOF),
            loc: this.loc(start)
        };
    };
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
    ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_L)) return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    };
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).PAREN_R);
    };
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    };
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).DOLLAR);
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    };
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    };
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    };
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).PAREN_L, item, (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).PAREN_R);
    };
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).COLON);
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
    ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).NAME)) return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
    ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).INT:
                this._lexer.advance();
                return {
                    kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).STRING:
            case (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BLOCK_STRING,
            loc: this.loc(token)
        };
    };
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).LIST,
            values: this.any((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACKET_L, item, (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACKET_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_L, item, (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).COLON);
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
    ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    };
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).AT);
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
    ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACKET_R);
            type = {
                kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BANG)) return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    };
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
    ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).STRING) || this.peek((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BLOCK_STRING);
    };
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    };
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_R);
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).AMP) || this.peek((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).NAME));
            return types;
        }
        return this.delimitedMany((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).AMP, this.parseNamedType);
    };
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_L) && this._lexer.lookahead().kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_R);
    };
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).PAREN_R);
    };
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    };
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_R);
    };
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_R);
    };
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $df22df0c34b6b6fb$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    };
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $b7a7400c364919cb$export$b45ffd2948484c41)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
    ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $fSkCz.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    };
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    };
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $4ccd28be33b51c76$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Expected ".concat($014faf4fb9554b60$var$getTokenKindDesc(kind), ", found ").concat($014faf4fb9554b60$var$getTokenDesc(token), "."));
    };
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    };
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).NAME && token.value === value) this._lexer.advance();
        else throw (0, $4ccd28be33b51c76$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($014faf4fb9554b60$var$getTokenDesc(token), "."));
    };
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $4ac8f0480dfb0ef5$export$8b9d26ab11394711).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    };
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $4ccd28be33b51c76$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Unexpected ".concat($014faf4fb9554b60$var$getTokenDesc(token), "."));
    };
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    };
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    };
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    };
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $014faf4fb9554b60$var$getTokenDesc(token) {
    var value = token.value;
    return $014faf4fb9554b60$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $014faf4fb9554b60$var$getTokenKindDesc(kind) {
    return (0, $523e1b201dcf266a$export$59ac0f4da287406a)(kind) ? "\"".concat(kind, "\"") : kind;
}


var $612b4cc9ef2afad2$var$docCache = new Map();
var $612b4cc9ef2afad2$var$fragmentSourceMap = new Map();
var $612b4cc9ef2afad2$var$printFragmentWarnings = true;
var $612b4cc9ef2afad2$var$experimentalFragmentVariables = false;
function $612b4cc9ef2afad2$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $612b4cc9ef2afad2$var$cacheKeyFromLoc(loc) {
    return $612b4cc9ef2afad2$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $612b4cc9ef2afad2$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $612b4cc9ef2afad2$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $612b4cc9ef2afad2$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($612b4cc9ef2afad2$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $612b4cc9ef2afad2$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, ast), {
        definitions: definitions
    });
}
function $612b4cc9ef2afad2$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $612b4cc9ef2afad2$var$parseDocument(source) {
    var cacheKey = $612b4cc9ef2afad2$var$normalize(source);
    if (!$612b4cc9ef2afad2$var$docCache.has(cacheKey)) {
        var parsed = (0, $014faf4fb9554b60$export$98e6a39c04603d36)(source, {
            experimentalFragmentVariables: $612b4cc9ef2afad2$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $612b4cc9ef2afad2$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $612b4cc9ef2afad2$var$docCache.set(cacheKey, $612b4cc9ef2afad2$var$stripLoc($612b4cc9ef2afad2$var$processFragments(parsed)));
    }
    return $612b4cc9ef2afad2$var$docCache.get(cacheKey);
}
function $612b4cc9ef2afad2$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $612b4cc9ef2afad2$var$parseDocument(result);
}
function $612b4cc9ef2afad2$export$657554ef4dc7ac2d() {
    $612b4cc9ef2afad2$var$docCache.clear();
    $612b4cc9ef2afad2$var$fragmentSourceMap.clear();
}
function $612b4cc9ef2afad2$export$e4294e638636c6ab() {
    $612b4cc9ef2afad2$var$printFragmentWarnings = false;
}
function $612b4cc9ef2afad2$export$78cf889af350c840() {
    $612b4cc9ef2afad2$var$experimentalFragmentVariables = true;
}
function $612b4cc9ef2afad2$export$5290df9bbbd3cfa() {
    $612b4cc9ef2afad2$var$experimentalFragmentVariables = false;
}
var $612b4cc9ef2afad2$var$extras = {
    gql: $612b4cc9ef2afad2$export$72e4926bf8358653,
    resetCaches: $612b4cc9ef2afad2$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $612b4cc9ef2afad2$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $612b4cc9ef2afad2$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $612b4cc9ef2afad2$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $612b4cc9ef2afad2$var$extras.gql, gql_1.resetCaches = $612b4cc9ef2afad2$var$extras.resetCaches, gql_1.disableFragmentWarnings = $612b4cc9ef2afad2$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $612b4cc9ef2afad2$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $612b4cc9ef2afad2$var$extras.disableExperimentalFragmentVariables;
})($612b4cc9ef2afad2$export$72e4926bf8358653 || ($612b4cc9ef2afad2$export$72e4926bf8358653 = {}));
$612b4cc9ef2afad2$export$72e4926bf8358653["default"] = $612b4cc9ef2afad2$export$72e4926bf8358653;
var $612b4cc9ef2afad2$export$2e2bcd8739ae039 = $612b4cc9ef2afad2$export$72e4926bf8358653;


/**
 * Normalizes GraphQL errors to ensure graphQLErrors is always an array
 * This prevents "error.graphQLErrors.every is not a function" errors
 */ function $0f48a177c099c909$var$normalizeGraphQLError(error) {
    if (error && !Array.isArray(error.graphQLErrors)) error.graphQLErrors = error.graphQLErrors ? [
        error.graphQLErrors
    ] : [];
    throw error;
}
/**
 * Safe wrapper around gql() that normalizes errors
 */ function $0f48a177c099c909$var$safeGql(query) {
    try {
        return (0, $612b4cc9ef2afad2$export$2e2bcd8739ae039)(query);
    } catch (error) {
        $0f48a177c099c909$var$normalizeGraphQLError(error);
    }
}
/**
 * Checks if a string value is likely a GraphQL enum value.
 * Enum values are typically all uppercase with underscores (e.g., ATLAS_DOC_FORMAT)
 *
 * NOTE: This is a heuristic because Relay's ReaderFragment doesn't include schema
 * type metadata to distinguish enum values from string literals at runtime.
 * Both are stored as plain strings in the `value` field of Literal arguments.
 *
 * Limitation: This won't correctly handle:
 * - Lowercase enum values (e.g., enum Status { active, inactive })
 * - String literals that look like enums (e.g., "CONSTANT_VALUE")
 *
 * For queries/mutations, use params.text instead which has correct formatting.
 */ function $0f48a177c099c909$var$isLikelyEnum(value) {
    // Check if the string matches enum naming conventions:
    // - Starts with uppercase letter
    // - Contains only uppercase letters, numbers, and underscores
    // - Has at least one uppercase letter
    return /^[A-Z][A-Z0-9_]*$/.test(value);
}
function $0f48a177c099c909$export$7c1c2f97801b533e(graphqlTaggedNode) {
    if (typeof graphqlTaggedNode === 'string') // For backwards-compatibility only; that's why `string` is not specified as an accepted argument type
    return $0f48a177c099c909$var$safeGql(graphqlTaggedNode);
    if ('kind' in graphqlTaggedNode && 'definitions' in graphqlTaggedNode) return graphqlTaggedNode;
    if ('kind' in graphqlTaggedNode && graphqlTaggedNode.kind === 'Fragment') return $0f48a177c099c909$var$fragmentToDocumentNode(graphqlTaggedNode);
    if (!('params' in graphqlTaggedNode)) throw new Error('[Relay Migration] unsupported tagged node provided. Please make sure you generated Relay artifacts for your operation');
    const params = graphqlTaggedNode.params;
    const operationText = params.text;
    if (!operationText) {
        const operationName = params.name ?? '(unknown)';
        const requestId = 'id' in params && params.id ? params.id : null;
        const identifiers = [
            `operationName: ${operationName}`,
            ...requestId ? [
                `requestId: ${requestId}`
            ] : []
        ].join(', ');
        throw new Error(`[Relay Migration] The provided \`ConcreteRequest\` did not specify \`params.text\` (required for Apollo interop). ` + `Identifiers for debugging: ${identifiers}. ` + `Ensure Relay compiler is configured with \`persist: { includeQueryText: true }\`.`);
    }
    return $0f48a177c099c909$var$safeGql(operationText);
}
function $0f48a177c099c909$var$fragmentToDocumentNode(readerFragment) {
    const selections = readerFragment.selections;
    // Helper to format a single value for GraphQL
    function formatValue(v) {
        if (typeof v === 'string') {
            // Check if this is an enum value (unquoted) or a string literal (quoted)
            if ($0f48a177c099c909$var$isLikelyEnum(v)) return v; // Enum values are not quoted
            return `"${v}"`;
        }
        return String(v);
    }
    // Format arguments for a field
    function formatArguments(args) {
        if (!args || args.length === 0) return '';
        const formattedArgs = args.map((arg)=>{
            let value;
            if (arg.kind === 'Variable') // Variable reference: $variableName
            value = `$${arg.variableName}`;
            else if (arg.kind === 'Literal') {
                // Literal value: format based on type
                if (typeof arg.value === 'string') {
                    // Check if this is an enum value (unquoted) or a string literal (quoted)
                    if ($0f48a177c099c909$var$isLikelyEnum(arg.value)) value = arg.value; // Enum values are not quoted
                    else value = `"${arg.value}"`;
                } else if (typeof arg.value === 'number' || typeof arg.value === 'boolean') value = String(arg.value);
                else if (arg.value === null) value = 'null';
                else if (Array.isArray(arg.value)) {
                    const arrayItems = arg.value.map(formatValue).join(', ');
                    value = `[${arrayItems}]`;
                } else if (typeof arg.value === 'object') {
                    // Object literal - convert to GraphQL input object syntax
                    const fields = Object.entries(arg.value).map(([k, v])=>{
                        const formattedValue = formatValue(v);
                        return `${k}: ${formattedValue}`;
                    }).join(', ');
                    value = `{${fields}}`;
                } else value = String(arg.value);
            } else value = String(arg.value);
            return `${arg.name}: ${value}`;
        });
        return `(${formattedArgs.join(', ')})`;
    }
    function selectionToString(selection) {
        const sel = selection;
        switch(sel.kind){
            case 'ScalarField':
                {
                    // Handles: id, name, email
                    // Added: Support for aliases (e.g., userName: name)
                    const alias = sel.alias ? `${sel.alias}: ` : '';
                    const args = formatArguments(sel.args || []);
                    return `${alias}${sel.name}${args}`;
                }
            case 'LinkedField':
                {
                    // Handles: nested objects like profile { avatar bio }
                    // Added: Support for arguments and aliases
                    const alias = sel.alias ? `${sel.alias}: ` : '';
                    const args = formatArguments(sel.args || []);
                    const nestedSelections = sel.selections.map(selectionToString).join(' ');
                    return `${alias}${sel.name}${args}{${nestedSelections}}`;
                }
            case 'InlineFragment':
                {
                    // Handles: ... on TypeName { fields }
                    // Why: Used for union types and interfaces to select fields based on concrete type
                    // Example: ... on InlineComment { markerRef }
                    const typeCondition = sel.type ? ` on ${sel.type}` : '';
                    const nestedSelections = sel.selections.map(selectionToString).join(' ');
                    return `...${typeCondition} {${nestedSelections}}`;
                }
            case 'FragmentSpread':
                // Handles: ...FragmentName
                // Why: Used to include other fragment definitions
                // Example: ...UserProfileFragment
                // Note: Fragment spreads with arguments (@arguments directive) are Relay-specific
                // and need to be converted to inline the fragment instead
                return `...${sel.name}`;
            case 'Condition':
                {
                    // Handles: @include(if: $var) or @skip(if: $var)
                    // Why: Conditional field inclusion based on variables
                    // Example: field @include(if: $showField)
                    const condition = sel.condition;
                    const passingValue = sel.passingValue;
                    const directiveName = passingValue ? '@include' : '@skip';
                    const directiveStr = `${directiveName}(if: $${condition})`;
                    // Apply the directive to each nested selection
                    const nestedSelections = sel.selections.map((s)=>{
                        const fieldStr = selectionToString(s);
                        // Add directive after the field but before any nested braces or directives
                        // For simple fields, just append the directive
                        // For complex fields with selections, insert before the opening brace
                        if (fieldStr.includes('{')) {
                            const braceIndex = fieldStr.indexOf('{');
                            const beforeBrace = fieldStr.slice(0, braceIndex);
                            const afterBrace = fieldStr.slice(braceIndex);
                            return `${beforeBrace} ${directiveStr} ${afterBrace}`;
                        } else return `${fieldStr} ${directiveStr}`;
                    }).join(' ');
                    return nestedSelections;
                }
            case 'Defer':
                {
                    // Handles: @defer directive for deferred fragments
                    // Why: Progressive loading of fragments
                    // Example: ... @defer { slowField }
                    const labelStr = 'label' in selection && selection.label ? `(label: "${selection.label}")` : '';
                    const nestedSelections = 'selections' in selection && selection.selections ? selection.selections.map(selectionToString).join(' ') : '';
                    const deferDirective = `... @defer${labelStr}`;
                    return `${deferDirective} {${nestedSelections}}`;
                }
            case 'ModuleImport':
                {
                    // Handles: @module and @match directives
                    // Why: Used for code-splitting and dynamic imports in Relay
                    // Note: Apollo doesn't have direct equivalent, may need custom handling
                    // This is rarely used and Apollo doesn't support it directly
                    const nestedSelections = 'selections' in selection && selection.selections ? selection.selections.map(selectionToString).join(' ') : '';
                    const docName = 'documentName' in selection && selection.documentName ? selection.documentName : 'unknown';
                    return nestedSelections || `# ModuleImport: ${docName}`;
                }
            case 'TypeDiscriminator':
                // Handles: __typename field for type discrimination
                // Why: Used by Relay for abstract types (unions/interfaces)
                // Apollo uses __typename extensively, so this should be preserved
                return '__typename';
            default:
                // Catch any other selection kinds that might exist
                // This ensures we don't silently ignore new Relay features
                throw new Error(`[Relay Migration] unimplemented fragment selection kind: ${selection.kind}`);
        }
    }
    // Note: Fragments in GraphQL don't support variable definitions
    // Variables are declared at the operation (query/mutation) level
    // and are available to all fragments within that operation.
    const selectionsStr = selections.map(selectionToString).join(' ');
    // Ensure proper spacing in GraphQL syntax
    const fragmentDef = `fragment ${readerFragment.name} on ${readerFragment.type} {
		${selectionsStr}
	}`;
    try {
        return $0f48a177c099c909$var$safeGql(fragmentDef);
    } catch (error) {
        // Add context about the generated GraphQL for debugging
        const contextError = error;
        if (contextError) {
            const originalMessage = contextError.message;
            const errorPrefix = '[Relay Migration] Failed to parse generated GraphQL fragment: ';
            const generatedGraphQL = `\nGenerated GraphQL:\n${fragmentDef}`;
            contextError.message = errorPrefix + originalMessage + generatedGraphQL;
        }
        throw error;
    }
}


function $5f09c9ccba6a638c$export$cff554ea7a2a50dc(fetchPolicy) {
    return fetchPolicy === 'no-store' ? 'no-cache' : fetchPolicy;
}



var $5ohfX = parcelRequire("5ohfX");
// Retentions are scoped to a Relay environment and normalized operation identifier, so different
// pages can remain warm without sharing or replacing each other's query records.
const $b8ffbe2cb3daf34b$var$retentionsByEnvironment = new WeakMap();
const $b8ffbe2cb3daf34b$var$getRetentions = (environment)=>{
    const existingRetentions = $b8ffbe2cb3daf34b$var$retentionsByEnvironment.get(environment);
    if (existingRetentions) return existingRetentions;
    const retentions = new Map();
    $b8ffbe2cb3daf34b$var$retentionsByEnvironment.set(environment, retentions);
    return retentions;
};
const $b8ffbe2cb3daf34b$var$releaseRetention = (environment, operationIdentifier, expectedRetention)=>{
    const retentions = $b8ffbe2cb3daf34b$var$retentionsByEnvironment.get(environment);
    const retention = retentions?.get(operationIdentifier);
    if (!retention || expectedRetention && retention !== expectedRetention) return false;
    retention.disposable.dispose();
    retentions?.delete(operationIdentifier);
    return true;
};
const $b8ffbe2cb3daf34b$export$a6653d437d704843 = (environment, query, variables, lifecycle)=>{
    const operation = (0, $5ohfX.createOperationDescriptor)((0, $5ohfX.getRequest)(query), variables);
    const operationIdentifier = operation.request.identifier;
    const retentions = $b8ffbe2cb3daf34b$var$getRetentions(environment);
    const existingRetention = retentions.get(operationIdentifier);
    if (existingRetention) {
        existingRetention.lifecycle = lifecycle;
        existingRetention.generation += 1;
        return ()=>{};
    }
    const retention = {
        disposable: environment.retain(operation),
        lifecycle: lifecycle,
        generation: 0
    };
    retentions.set(operationIdentifier, retention);
    const generation = retention.generation;
    return ()=>{
        if (retention.generation === generation) $b8ffbe2cb3daf34b$var$releaseRetention(environment, operationIdentifier, retention);
    };
};
const $b8ffbe2cb3daf34b$export$894a743657db6f9d = (environment, operationIdentifier)=>{
    const retention = $b8ffbe2cb3daf34b$var$retentionsByEnvironment.get(environment)?.get(operationIdentifier);
    if (retention?.lifecycle !== 'hook-unmount') return false;
    return $b8ffbe2cb3daf34b$var$releaseRetention(environment, operationIdentifier, retention);
};



var $5ohfX = parcelRequire("5ohfX");

function $ac2d60f994c80912$var$getConsoleWarnArgs(diagnostic) {
    const { message: message, error: error, ...diagnosticContext } = diagnostic;
    return [
        message,
        diagnosticContext,
        error
    ];
}
const $ac2d60f994c80912$var$consoleWarnCacheBridgeFailureReporter = {
    reportFailure: (diagnostic)=>{
        const [message, diagnosticContext, error] = $ac2d60f994c80912$var$getConsoleWarnArgs(diagnostic);
        // eslint-disable-next-line no-console -- cache bridge failures are degraded-mode fallbacks and should remain visible without introducing a monitoring dependency.
        console.warn(message, diagnosticContext, error);
    }
};
// Dependency inversion point: bridge diagnostics depend on the reporter
// interface above, while the concrete observability transport is chosen here.
// If cache bridge warnings move into production monitoring later, wire an
// @confluence/monitoring-backed reporter here instead of changing bridge callers.
const $ac2d60f994c80912$var$cacheBridgeFailureReporter = $ac2d60f994c80912$var$consoleWarnCacheBridgeFailureReporter;
function $ac2d60f994c80912$export$589d608ce9b2ef1(diagnostic) {
    $ac2d60f994c80912$var$cacheBridgeFailureReporter.reportFailure(diagnostic);
}


function $69c1d060f20636b6$var$getCacheBridgeFailureMessage(context) {
    return `[APOLLO RELAY CACHE SYNC] Secondary ${context.bridge} cache bridge ${context.operation} failed while accessing the ${context.targetCache} cache.`;
}
function $69c1d060f20636b6$var$getCacheBridgeFailureImpact(context) {
    return context.operation === 'read' ? 'The failed secondary cache read is treated as a cache miss. Original read semantics are preserved.' : 'The original operation remains successful. The secondary cache may be stale or incomplete.';
}
function $69c1d060f20636b6$var$getCacheBridgeFailureAction(context) {
    return context.operation === 'read' ? 'Inspect the error stack and target cache read path to determine why fallback data could not be read.' : 'Inspect the error stack and target cache write path to determine why mirroring did not complete.';
}
function $69c1d060f20636b6$var$buildCacheBridgeFailureDiagnostic(error, context) {
    return {
        ...context,
        message: $69c1d060f20636b6$var$getCacheBridgeFailureMessage(context),
        impact: $69c1d060f20636b6$var$getCacheBridgeFailureImpact(context),
        action: $69c1d060f20636b6$var$getCacheBridgeFailureAction(context),
        error: error
    };
}
function $69c1d060f20636b6$export$6e88ce993161db0e(error, context) {
    try {
        (0, $ac2d60f994c80912$export$589d608ce9b2ef1)($69c1d060f20636b6$var$buildCacheBridgeFailureDiagnostic(error, context));
    } catch  {
    // Reporting must not turn a secondary cache bridge failure into a primary operation failure.
    }
}


function $f768a5ce4eef5240$export$5c269e9658924c9d(reason) {
    return {
        status: 'skipped',
        reason: reason
    };
}
function $f768a5ce4eef5240$export$a173cd1d67506346() {
    return {
        status: 'written'
    };
}
function $f768a5ce4eef5240$export$5db55a39299bc96c(source) {
    return source === 'apollo' ? 'relay' : 'apollo';
}
function $f768a5ce4eef5240$export$9802b30dff8a70e2(bridge, operation, targetCache) {
    return {
        bridge: bridge,
        operation: operation,
        targetCache: targetCache
    };
}
function $f768a5ce4eef5240$var$runSafely(run, context, onError) {
    try {
        return run();
    } catch (error) {
        (0, $69c1d060f20636b6$export$6e88ce993161db0e)(error, context);
        return onError(error);
    }
}
function $f768a5ce4eef5240$export$e9ed9ab374349e18(write, context) {
    return $f768a5ce4eef5240$var$runSafely(write, context, (error)=>({
            status: 'failed',
            error: error
        }));
}



function $399f332696f4928f$export$60f060f74b0bfcca() {
    if (!(0, $ef003bca5ae3d837$export$45abdb3f977b5b14)('confluence_apollo_to_relay_migration', 'isEnabled', true)) return 'apollo-to-relay-migration-disabled';
    if (!(0, $ef003bca5ae3d837$export$45abdb3f977b5b14)('confluence_apollo_relay_cache_bridge', 'isEnabled', true)) return 'apollo-relay-cache-bridge-disabled';
    return null;
}



var $5ohfX = parcelRequire("5ohfX");
function $b62a14fe7d1f730f$var$isResultRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function $b62a14fe7d1f730f$var$getResultKey(selection) {
    return selection.alias ?? selection.name;
}
function $b62a14fe7d1f730f$var$hasDirectTypenameSelection(selections) {
    return selections.some((selection)=>selection.kind === 'ScalarField' && selection.name === '__typename');
}
function $b62a14fe7d1f730f$var$hasResultDataForSelections(data, selections) {
    let hasExpectedSelectionData = false;
    const selectionsToCheck = [
        ...selections
    ];
    // Typename inference is intentionally conservative: one shared field is
    // not enough to prove which concrete type produced an abstract payload.
    while(selectionsToCheck.length > 0){
        const selection = selectionsToCheck.pop();
        if (!selection) break;
        switch(selection.kind){
            case 'ScalarField':
                if (selection.name === '__typename') break;
                hasExpectedSelectionData = true;
                if (!(selection.name in data)) return false;
                break;
            case 'LinkedField':
                hasExpectedSelectionData = true;
                if (!($b62a14fe7d1f730f$var$getResultKey(selection) in data)) return false;
                break;
            case 'ActorChange':
                hasExpectedSelectionData = true;
                if (!($b62a14fe7d1f730f$var$getResultKey(selection.linkedField) in data)) return false;
                break;
            case 'ClientExtension':
            case 'Condition':
            case 'Defer':
            case 'InlineFragment':
            case 'Stream':
                selectionsToCheck.push(...selection.selections);
                break;
            case 'ClientComponent':
                if (!('selections' in selection.fragment)) break;
                selectionsToCheck.push(...selection.fragment.selections);
                break;
            default:
                break;
        }
    }
    return hasExpectedSelectionData;
}
function $b62a14fe7d1f730f$var$collectMatchingInlineFragmentTypes(data, selections, matchingTypes) {
    selections.forEach((selection)=>{
        switch(selection.kind){
            case 'InlineFragment':
                if ($b62a14fe7d1f730f$var$hasResultDataForSelections(data, selection.selections)) matchingTypes.add(selection.type);
                return;
            case 'ClientExtension':
            case 'Condition':
            case 'Defer':
            case 'Stream':
                $b62a14fe7d1f730f$var$collectMatchingInlineFragmentTypes(data, selection.selections, matchingTypes);
                return;
            case 'ClientComponent':
                if ('selections' in selection.fragment) $b62a14fe7d1f730f$var$collectMatchingInlineFragmentTypes(data, selection.fragment.selections, matchingTypes);
                return;
            default:
                return;
        }
    });
}
function $b62a14fe7d1f730f$var$inferInlineFragmentTypename(data, selections) {
    const matchingTypes = new Set();
    $b62a14fe7d1f730f$var$collectMatchingInlineFragmentTypes(data, selections, matchingTypes);
    // Apollo's fragment matcher needs a concrete __typename for inline fragments.
    // Relay reader data can omit it, so infer only when the result shape points to
    // exactly one fragment type. Ambiguous abstract payloads are left unchanged.
    return matchingTypes.size === 1 ? [
        ...matchingTypes
    ][0] : null;
}
function $b62a14fe7d1f730f$var$addLinkedFieldTypenames(value, selection) {
    if (value == null) return {
        value: value,
        changed: false
    };
    if (selection.plural) {
        if (!Array.isArray(value)) return {
            value: value,
            changed: false
        };
        let nextItems = null;
        let omittedItem = false;
        value.forEach((item, index)=>{
            if (omittedItem) return;
            const result = $b62a14fe7d1f730f$var$addLinkedFieldTypenames(item, {
                ...selection,
                plural: false
            });
            if (result.omitted) {
                // Keep plural field semantics intact. Filtering a single unsafe item
                // would shift list indexes/order, so omit the whole mirrored field.
                omittedItem = true;
                return;
            }
            if (result.changed) {
                nextItems ?? (nextItems = [
                    ...value
                ]);
                nextItems[index] = result.value;
            }
        });
        if (omittedItem) return {
            changed: true,
            omitted: true
        };
        return nextItems ? {
            value: nextItems,
            changed: true
        } : {
            value: value,
            changed: false
        };
    }
    if (!$b62a14fe7d1f730f$var$isResultRecord(value)) return {
        value: value,
        changed: false
    };
    let nextValue = value;
    let changed = false;
    if (selection.concreteType && nextValue.__typename == null) {
        nextValue = {
            ...nextValue,
            __typename: selection.concreteType
        };
        changed = true;
    }
    const nestedResult = $b62a14fe7d1f730f$var$addTypenamesForSelections(nextValue, selection.selections);
    if (nestedResult.changed) {
        nextValue = nestedResult.value;
        changed = true;
    }
    if (!selection.concreteType && nextValue.__typename == null && $b62a14fe7d1f730f$var$hasDirectTypenameSelection(selection.selections)) // Apollo 1.x rejects writes that replace a generated linked record with a
    // typename-less payload. Relay query data can omit __typename for abstract
    // fields, so omit only that untypable child and keep the rest of the mirror.
    return {
        changed: true,
        omitted: true
    };
    return {
        value: nextValue,
        changed: changed
    };
}
function $b62a14fe7d1f730f$var$addTypenamesForSelections(data, selections) {
    let nextData = data;
    let changed = false;
    if (nextData.__typename == null) {
        const inferredTypename = $b62a14fe7d1f730f$var$inferInlineFragmentTypename(nextData, selections);
        if (inferredTypename) {
            nextData = {
                ...nextData,
                __typename: inferredTypename
            };
            changed = true;
        }
    }
    selections.forEach((selection)=>{
        switch(selection.kind){
            case 'LinkedField':
                {
                    const key = $b62a14fe7d1f730f$var$getResultKey(selection);
                    if (!(key in nextData)) return;
                    const result = $b62a14fe7d1f730f$var$addLinkedFieldTypenames(nextData[key], selection);
                    if (!result.changed) return;
                    if (!changed) {
                        nextData = {
                            ...nextData
                        };
                        changed = true;
                    }
                    if (result.omitted) delete nextData[key];
                    else nextData[key] = result.value;
                    return;
                }
            case 'ActorChange':
                {
                    const key = $b62a14fe7d1f730f$var$getResultKey(selection.linkedField);
                    if (!(key in nextData)) return;
                    const result = $b62a14fe7d1f730f$var$addLinkedFieldTypenames(nextData[key], selection.linkedField);
                    if (!result.changed) return;
                    if (!changed) {
                        nextData = {
                            ...nextData
                        };
                        changed = true;
                    }
                    if (result.omitted) delete nextData[key];
                    else nextData[key] = result.value;
                    return;
                }
            case 'ClientExtension':
            case 'Condition':
            case 'Defer':
            case 'InlineFragment':
            case 'Stream':
                {
                    const result = $b62a14fe7d1f730f$var$addTypenamesForSelections(nextData, selection.selections);
                    if (!result.changed) return;
                    nextData = result.value;
                    changed = true;
                    return;
                }
            case 'ClientComponent':
                {
                    if (!('selections' in selection.fragment)) return;
                    const result = $b62a14fe7d1f730f$var$addTypenamesForSelections(nextData, selection.fragment.selections);
                    if (!result.changed) return;
                    nextData = result.value;
                    changed = true;
                    return;
                }
            default:
                return;
        }
    });
    return {
        value: nextData,
        changed: changed
    };
}
function $b62a14fe7d1f730f$export$98df03d975151b17(operation, data) {
    if (!$b62a14fe7d1f730f$var$isResultRecord(data)) return data;
    const request = (0, $5ohfX.getRequest)(operation);
    const result = $b62a14fe7d1f730f$var$addTypenamesForSelections(data, request.operation.selections);
    return result.value;
}
function $b62a14fe7d1f730f$export$18ac8092ad81ec5e(query, data) {
    return $b62a14fe7d1f730f$export$98df03d975151b17(query, data);
}


function $bc7c202ade7f8d1f$export$1e6cfeaf8b88bd01({ useAggClient: useAggClient, client: client } = {}) {
    if (useAggClient) // AGG-backed interops need to mirror into the same Apollo cache their
    // primary operation used, otherwise bridge writes can land in the wrong client.
    return window['GLOBAL_APOLLO_AGG_CLIENT'] ?? window['MOCK_GATEWAY_APOLLO_CLIENT'];
    return client ?? window['GLOBAL_APOLLO_CLIENT'];
}


function $6a940922b38cbb5c$export$ffa93f1e5be01566(relayEnvironment) {
    if (relayEnvironment) return relayEnvironment;
    if (!('GLOBAL_RELAY_ENV' in window)) return undefined;
    return window['GLOBAL_RELAY_ENV'];
}


function $d14bb8a67c1929eb$export$9c807efd0c0be8fe({ data: data, fetchPolicy: fetchPolicy }) {
    // These are expected no-op cases, not bridge failures. Callers surface them
    // as skipped results without warning so diagnostics stay signal-heavy.
    if (fetchPolicy === 'no-cache') return 'no-cache';
    if (data == null) return 'data-missing';
    return null;
}


function $64f1f22d67738d71$var$writeQueryToApollo(args) {
    const skipReason = (0, $d14bb8a67c1929eb$export$9c807efd0c0be8fe)(args);
    if (skipReason) return (0, $f768a5ce4eef5240$export$5c269e9658924c9d)(skipReason);
    const client = (0, $bc7c202ade7f8d1f$export$1e6cfeaf8b88bd01)({
        useAggClient: args.useAggClient
    });
    if (!client) return (0, $f768a5ce4eef5240$export$5c269e9658924c9d)('apollo-client-missing');
    return (0, $f768a5ce4eef5240$export$e9ed9ab374349e18)(()=>{
        const data = (0, $b62a14fe7d1f730f$export$18ac8092ad81ec5e)(args.query, args.data);
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- cache bridge intentionally mirrors Relay query results into Apollo during migration
        client.writeQuery({
            query: (0, $0f48a177c099c909$export$7c1c2f97801b533e)(args.query),
            variables: args.variables,
            data: data
        });
        return (0, $f768a5ce4eef5240$export$a173cd1d67506346)();
    }, (0, $f768a5ce4eef5240$export$9802b30dff8a70e2)('query', 'write', 'apollo'));
}
function $64f1f22d67738d71$var$writeQueryToRelay(args) {
    const skipReason = (0, $d14bb8a67c1929eb$export$9c807efd0c0be8fe)(args);
    if (skipReason) return (0, $f768a5ce4eef5240$export$5c269e9658924c9d)(skipReason);
    const environment = (0, $6a940922b38cbb5c$export$ffa93f1e5be01566)();
    if (!environment) return (0, $f768a5ce4eef5240$export$5c269e9658924c9d)('relay-environment-missing');
    return (0, $f768a5ce4eef5240$export$e9ed9ab374349e18)(()=>{
        const operation = (0, $5ohfX.createOperationDescriptor)((0, $5ohfX.getRequest)(args.query), args.variables ?? {});
        environment.commitPayload(operation, args.data);
        return (0, $f768a5ce4eef5240$export$a173cd1d67506346)();
    }, (0, $f768a5ce4eef5240$export$9802b30dff8a70e2)('query', 'write', 'relay'));
}
function $64f1f22d67738d71$var$writeQueryToCache(args, targetCache) {
    return targetCache === 'apollo' ? $64f1f22d67738d71$var$writeQueryToApollo(args) : $64f1f22d67738d71$var$writeQueryToRelay(args);
}
function $64f1f22d67738d71$export$141e77f0e0e5592c({ source: source, error: error, skip: skip, ...writeArgs }) {
    // Query mirroring is secondary work: only successful, non-skipped primary
    // operations should attempt to populate the opposite cache.
    if (skip) return (0, $f768a5ce4eef5240$export$5c269e9658924c9d)('operation-skipped');
    if (error) return (0, $f768a5ce4eef5240$export$5c269e9658924c9d)('operation-error');
    const disabledReason = (0, $399f332696f4928f$export$60f060f74b0bfcca)();
    if (disabledReason) return (0, $f768a5ce4eef5240$export$5c269e9658924c9d)(disabledReason);
    return $64f1f22d67738d71$var$writeQueryToCache(writeArgs, (0, $f768a5ce4eef5240$export$5db55a39299bc96c)(source));
}



function $92055207a5a5a2a3$export$c53086aa5c7d04b4(params) {
    const operationName = (0, $d9376047307287a2$export$7c7cda779ed3b967)(params.query);
    // `??` short-circuits, so `isRelayEnabled` is not consulted (and fires no experiment exposure)
    // when the caller has already resolved the routing.
    const routeToRelay = params.forceRelay ?? (0, $d19417f48dced338$export$129c37b549a1eea7)(params.__callerPackage__, {
        operationName: operationName,
        phase: 'preload'
    });
    const source = routeToRelay ? 'relay' : 'apollo';
    return $92055207a5a5a2a3$var$queryInteropWithBridge(params, source);
}
async function $92055207a5a5a2a3$var$queryInteropWithBridge(params, source) {
    const result = source === 'relay' ? await $92055207a5a5a2a3$var$queryInteropRelay(params) : await $92055207a5a5a2a3$var$queryInteropApollo(params);
    // Keep the original query result contract intact, then mirror successful
    // results into the secondary cache as best-effort bridge work.
    (0, $64f1f22d67738d71$export$141e77f0e0e5592c)({
        source: source,
        error: result.error,
        query: params.query,
        variables: params.variables,
        data: result.data,
        fetchPolicy: params.fetchPolicy,
        useAggClient: params.interopApolloAggClient
    });
    return result;
}
async function $92055207a5a5a2a3$var$queryInteropRelay(params) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    if (!relayEnv) {
        // eslint-disable-next-line no-console
        console.warn(`[Relay migration] Missing GLOBAL_RELAY_ENV for queryInterop; falling back to Apollo for package ${params.__callerPackage__}.`);
        return $92055207a5a5a2a3$var$queryInteropApollo(params);
    }
    const releasePreloadRetention = params.relayQueryPreloadRetention && params.fetchPolicy !== 'no-store' ? (0, $b8ffbe2cb3daf34b$export$a6653d437d704843)(relayEnv, params.query, params.variables ?? {}, params.relayQueryPreloadRetention) : null;
    // `executeRelayQuery` owns the fetch-policy mapping and the `noStore` derivation. That matters
    // most on this path: it runs during SSR, where whatever normalizes into the store is serialized
    // into `__RELAY_STORE__` and hydrated on the client before its first fetch, so a missed `noStore`
    // re-poisons the store server-side and makes the client-side bypass pointless.
    try {
        return await (0, $fe53f802bdf7b7dd$export$a0256de6700e2ad9)({
            environment: relayEnv,
            query: params.query,
            variables: params.variables ?? {},
            fetchPolicy: params.fetchPolicy,
            errorPolicy: params.errorPolicy,
            context: params.context
        });
    } catch (error) {
        releasePreloadRetention?.();
        throw error;
    }
}
async function $92055207a5a5a2a3$var$queryInteropApollo({ query: query, fetchPolicy: fetchPolicy, ...rest }) {
    const client = rest.interopApolloAggClient ? window['GLOBAL_APOLLO_AGG_CLIENT'] ?? window['MOCK_GATEWAY_APOLLO_CLIENT'] : window['GLOBAL_APOLLO_CLIENT'];
    // `client.query` only accepts the narrower `FetchPolicy` (no `cache-and-network`/`standby`).
    // Map the watch-only values to the closest one-shot equivalent. `mapFetchPolicyForApollo` first,
    // so the interop-only `'no-store'` becomes `'no-cache'` rather than falling through to Apollo's
    // default cache behaviour.
    const apolloFetchPolicy = (0, $5f09c9ccba6a638c$export$cff554ea7a2a50dc)(fetchPolicy);
    const oneShotFetchPolicy = apolloFetchPolicy === 'cache-and-network' || apolloFetchPolicy === 'standby' ? 'cache-first' : apolloFetchPolicy;
    const result = await client.query({
        ...rest,
        fetchPolicy: oneShotFetchPolicy,
        query: (0, $0f48a177c099c909$export$7c1c2f97801b533e)(query)
    });
    return {
        data: result.data,
        error: result.errors?.length ? new (0, $a73698f3e4fe6cd8$export$3ad5d0415dc12c65)({
            graphQLErrors: result.errors
        }) : undefined
    };
}
function $92055207a5a5a2a3$export$657ce0d4a1b8cb1a(error) {
    // TODO: Implement proper error conversion
    return error;
}


/**
 * Per-request answer to a single question, resolved by Bifrost before Statsig is initialised:
 * *will the post-init reader of `SiteInformationQuery` route it to Relay?*
 *
 * ## Why this exists
 *
 * `isRelayEnabled` resolves the rollout configuration through the Statsig client. On the Bifrost
 * early-preload path, `getSessionData()` (and so `SiteInformationQuery` via `loadSessionData` →
 * `queryInterop`) runs while the pipeline that calls `initializeClientFromValues` is still awaiting
 * `getRenderContext()`. Reading an experiment before then does not fail loudly:
 * `FeatureGates.getExperiment` throws `assertInitialized`, the throw is swallowed, an empty config
 * comes back, and every read yields its default. For the migration experiment that default is
 * `false`, so the write silently goes to Apollo no matter how the rollout is configured.
 *
 * `SPAViewContextProvider` then reads the same query during `renderToString`, after Statsig is
 * available, resolves to Relay, and finds nothing — `frontCoverState` falls back to `''` and
 * `CompanyHubRoute` redirects to Home.
 *
 * Bifrost can answer the question much earlier from the native edge SDK, which needs only the
 * request-derived user context and no network round-trip. `loadSessionData` passes the answer to
 * `queryInterop` as `forceRelay`, so the write lands in whichever cache the read will consult.
 *
 * ## Invariants
 *
 * 1. **It describes the reader, not the writer.** The point is agreement. Forcing the write to
 *    Relay while the reader resolves to Apollo would simply invert the same bug, so Bifrost
 *    evaluates `spa-view-context`'s enrolment — not `session-data`'s.
 * 2. **Set unconditionally, once per request.** Bifrost is a long-lived process and this is module
 *    state, so a request that skipped setting it would read the *previous* request's answer — a
 *    per-tenant hazard. Callers must set it on every request, including error paths, passing `null`
 *    when it cannot be resolved so the normal `isRelayEnabled` path is used instead.
 * 3. **Only `loadSessionData` consumes it.** Deliberately not consulted inside `queryInterop`
 *    itself: that would apply it to every imperative query rather than the one whose routing is
 *    known to be broken.
 */ let $96bbc70980550850$var$ssrForcedRelay = null;
function $96bbc70980550850$export$a1265d6b7d33fe39(value) {
    $96bbc70980550850$var$ssrForcedRelay = value;
}
function $96bbc70980550850$export$14e4d10d25ee113c() {
    return $96bbc70980550850$var$ssrForcedRelay;
}
function $96bbc70980550850$export$b708937066ffe5c() {
    $96bbc70980550850$var$ssrForcedRelay = null;
}




var $2hRE7 = parcelRequire("2hRE7");

function $8001e21998d25cdc$export$93aea9a3d680252e(error, statusCode, statusCodeAlternative) {
    if (error) {
        if ((0, $a73698f3e4fe6cd8$export$17f5e6bd290bb15d)(error)) return error.graphQLErrors?.some((graphQLError)=>$8001e21998d25cdc$var$isStatusCodeNonApolloError(graphQLError, statusCode, statusCodeAlternative)) || $8001e21998d25cdc$var$isStatusCodeNonApolloError(error?.networkError, statusCode, statusCodeAlternative);
        return $8001e21998d25cdc$var$isStatusCodeNonApolloError(error, statusCode, statusCodeAlternative);
    }
    return false;
}
function $8001e21998d25cdc$export$4b7f1fcb987c29b8(error) {
    if (error) {
        if ((0, $a73698f3e4fe6cd8$export$17f5e6bd290bb15d)(error)) {
            for (const graphQLError of error?.graphQLErrors || []){
                const result = $8001e21998d25cdc$var$getStatusCodeNonApolloError(graphQLError);
                if (result) return result;
            }
            const networkErrorStatusCode = $8001e21998d25cdc$var$getStatusCodeNonApolloError(error?.networkError);
            if (networkErrorStatusCode) return networkErrorStatusCode;
        }
        return $8001e21998d25cdc$var$getStatusCodeNonApolloError(error);
    }
    return undefined;
}
function $8001e21998d25cdc$var$isStatusCodeNonApolloError(error, statusCode, statusCodeAlternative) {
    if (error) {
        if ($8001e21998d25cdc$export$68868794c9b58e55(error) === statusCode || statusCodeAlternative?.(error)) return true;
        const { originalError: originalError } = error;
        if (originalError) return $8001e21998d25cdc$export$93aea9a3d680252e(originalError, statusCode, statusCodeAlternative);
    }
    return false;
}
function $8001e21998d25cdc$var$getStatusCodeNonApolloError(error) {
    if (error) {
        const result = $8001e21998d25cdc$export$68868794c9b58e55(error);
        if (result) return result;
        const { originalError: originalError } = error;
        if (originalError) return $8001e21998d25cdc$export$68868794c9b58e55(originalError);
    }
    return undefined;
}
function $8001e21998d25cdc$export$68868794c9b58e55(error) {
    if (error) {
        let status = error?.response?.status;
        if (status == null) {
            const { extensions: extensions } = error;
            if (extensions) status = extensions.statusCode || extensions.http?.status;
        }
        // Coercing to string because backend is inconsistent in the response type,
        // both string and number have been seen in practice:
        return status?.toString();
    }
    return undefined;
}



var $2hRE7 = parcelRequire("2hRE7");

var $2hRE7 = parcelRequire("2hRE7");
const $4aa6efa966e6f6e4$export$6ae4df695e19c5 = (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createContext(()=>false);
$4aa6efa966e6f6e4$export$6ae4df695e19c5.displayName = 'KnownErrorBoundaryContext';


class $13120d3a5460a891$export$a6c66dc6b08c87fe extends (0, $2hRE7.Component) {
    componentDidCatch(error) {
        if (this.props.isKnownError(error)) {
            this.props.onError?.(error);
            this.setState({
                error: error
            });
        } else throw error;
    }
    render() {
        const { error: error } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $4aa6efa966e6f6e4$export$6ae4df695e19c5).Consumer, null, (willCatch)=>{
            this.willParentCatch = willCatch;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $4aa6efa966e6f6e4$export$6ae4df695e19c5).Provider, {
                value: this.willCatch
            }, error ? this.props.renderOnError(error) : this.props.children);
        });
    }
    constructor(...args){
        super(...args);
        this.willParentCatch = void 0;
        this.state = {
            error: null
        };
        this.willCatch = (error)=>Boolean(this.props.isKnownError(error) || this.willParentCatch?.(error));
    }
}


const $6e2aeba1bc095709$export$616870549cbd985 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $13120d3a5460a891$export$a6c66dc6b08c87fe), {
        isKnownError: $6e2aeba1bc095709$export$55152de1f925fd05,
        ...props
    });
/**
 * https://pug.jira-dev.com/wiki/spaces/CCB/pages/4709260932/GraphQL+Errors+Contract+for+Status+Code+401+and+403
 */ const $6e2aeba1bc095709$var$isLegacyUnauthorizedGraphQLError = (error)=>error?.extensions?.data?.authorized === false;
const $6e2aeba1bc095709$export$55152de1f925fd05 = (error)=>(0, $8001e21998d25cdc$export$93aea9a3d680252e)(error, '403', $6e2aeba1bc095709$var$isLegacyUnauthorizedGraphQLError);





function $4b7988ce40c8fd3c$var$onGraphqlError(error) {
    (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(error, {
        attribution: 'graphql'
    });
}
// NOTE: use `Symbol.for(...)` here because this module is bundled into two separate
// chunks - preloader and main app. Creating it via `Symbol(...)` will result in two
// different symbols, so errors that are handled in the preloader won't be identified
// as handled in the main app.
const $4b7988ce40c8fd3c$var$HANDLED_ERROR_MARK_SYMBOL = Symbol.for('error marked as handled');
class $4b7988ce40c8fd3c$export$bba8f5318e9cae27 {
    scheduleErrorReporting(error) {
        const timeoutId = window.setTimeout(()=>{
            // NOTE: This is an extra measure to prevent over-reporting of an otherwise handled error.
            // When query is preloaded and errors out, the reporting is scheduled by onErrorLink from
            // both preloader and from the place where query data is processed, but `errorsToHandle`
            // would only contain the entry of the error mapped to the latest timeoutId.
            if (this.isErrorMarkedAsHandled(error)) return;
            this.errorHandler(error);
            $4b7988ce40c8fd3c$export$702f853386561b84(error);
        }, this.gracefulHandlingPeriodMs);
        this.errorsToHandle.set(error, timeoutId);
    }
    // eslint-disable-next-line no-useless-constructor
    constructor(gracefulHandlingPeriodMs, errorHandler){
        this.gracefulHandlingPeriodMs = gracefulHandlingPeriodMs;
        this.errorHandler = errorHandler;
        // map of Error to timeoutId of when the generic error handling will kick-off
        this.errorsToHandle = new Map();
        this.processError = (error)=>{
            if (error) this.scheduleErrorReporting(error);
        };
        this.isErrorMarkedAsHandled = (error)=>{
            if (!error) return false;
            if (typeof error !== 'object') return false;
            return Boolean(error[$4b7988ce40c8fd3c$var$HANDLED_ERROR_MARK_SYMBOL]);
        };
        this.markErrorAsHandled = (error)=>{
            if (!error) return;
            if ((0, $a73698f3e4fe6cd8$export$17f5e6bd290bb15d)(error)) {
                (error.graphQLErrors || []).forEach((e)=>this.markErrorAsHandled(e));
                this.markErrorAsHandled(error.networkError);
            }
            const timeoutId = this.errorsToHandle.get(error);
            if (typeof error === 'object') error[$4b7988ce40c8fd3c$var$HANDLED_ERROR_MARK_SYMBOL] = true;
            window.clearTimeout(timeoutId);
            this.errorsToHandle.delete(error);
        };
    }
}
const $4b7988ce40c8fd3c$var$GRACEFUL_ERROR_HANDLING_PERIOD_MS = 100;
// GraphqlErrorProcessor is stateful and should be a singleton. Given that this module
// is bundled into two separate chunks - preloader and main app, we need to make sure
// that the same instance is used in both places.
const $4b7988ce40c8fd3c$var$graphqlErrorProcessor = new $4b7988ce40c8fd3c$export$bba8f5318e9cae27($4b7988ce40c8fd3c$var$GRACEFUL_ERROR_HANDLING_PERIOD_MS, $4b7988ce40c8fd3c$var$onGraphqlError);
const $4b7988ce40c8fd3c$export$db43d00048f0afe4 = $4b7988ce40c8fd3c$var$GRACEFUL_ERROR_HANDLING_PERIOD_MS;
const $4b7988ce40c8fd3c$export$702f853386561b84 = $4b7988ce40c8fd3c$var$graphqlErrorProcessor.markErrorAsHandled;
const $4b7988ce40c8fd3c$export$792efb60958ecf86 = $4b7988ce40c8fd3c$var$graphqlErrorProcessor.isErrorMarkedAsHandled;
const $4b7988ce40c8fd3c$export$83457a6c00af4df7 = $4b7988ce40c8fd3c$var$graphqlErrorProcessor.processError;


/**
 * @generated SignedSource<<86043c04be3327e24acd832b00ba6fcc>>
 * @relayHash 3d865716288db362e4482bca61bae234
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4081e27c2eac6ae1fe6c53268126950193be606ac668f1ff38f8b6a3896b17c0
const $9dcb399372c982ec$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "timeZone"
    }, v2 = [
        {
            "concreteType": "Tenant",
            "kind": "LinkedField",
            "name": "tenant",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "shard"
                },
                {
                    "kind": "ScalarField",
                    "name": "cloudId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environment"
                },
                {
                    "kind": "ScalarField",
                    "name": "activationId"
                }
            ]
        },
        {
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "orgId"
                }
            ]
        },
        {
            "alias": "userForAnalytics",
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ 
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "userKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "locale"
                        }
                    ]
                },
                v1 /*: any*/ 
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "product",
                    "value": "CONFLUENCE"
                }
            ],
            "concreteType": "AIConfigResponse",
            "kind": "LinkedField",
            "name": "getAIConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEnabled"
                },
                {
                    "kind": "ScalarField",
                    "name": "isRovoEnabled"
                },
                {
                    "kind": "ScalarField",
                    "name": "isAIEarlyAccessEnabled"
                },
                {
                    "kind": "ScalarField",
                    "name": "isAtlassianHostedLLMOnlyEnabled"
                },
                {
                    "kind": "ScalarField",
                    "name": "isRovoLLMEnabled"
                }
            ],
            "storageKey": "getAIConfig(product:\"CONFLUENCE\")"
        },
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "baseUrl"
                },
                {
                    "concreteType": "LicenseStates",
                    "kind": "LinkedField",
                    "name": "licenseStates",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "LicenseState",
                            "kind": "LinkedField",
                            "name": "confluence",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "ccpEntitlementId"
                                }
                            ]
                        }
                    ]
                },
                v1 /*: any*/ ,
                {
                    "concreteType": "Editions",
                    "kind": "LinkedField",
                    "name": "editions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "confluence"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "monolithRegion"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "isSiteAdmin"
        },
        {
            "kind": "ScalarField",
            "name": "abTestCohorts"
        },
        {
            "kind": "ScalarField",
            "name": "experimentFeatures"
        },
        {
            "kind": "ScalarField",
            "name": "userCanCreateContent"
        },
        {
            "kind": "ScalarField",
            "name": "isNewUser"
        },
        {
            "concreteType": "SiteSettings",
            "kind": "LinkedField",
            "name": "siteSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Homepage",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "uri"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "siteTitle"
                },
                {
                    "kind": "ScalarField",
                    "name": "showApplicationTitle"
                },
                {
                    "concreteType": "FrontCover",
                    "kind": "LinkedField",
                    "name": "frontCover",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "frontCoverState"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "companyHubName"
                },
                {
                    "kind": "ScalarField",
                    "name": "isHideTitleInUrl"
                }
            ]
        },
        {
            "concreteType": "SiteDescription",
            "kind": "LinkedField",
            "name": "siteDescription",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "logoUrl"
                }
            ]
        },
        {
            "concreteType": "CurrentConfluenceUser",
            "kind": "LinkedField",
            "name": "currentConfluenceUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isAnonymous"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "SiteInformationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "SiteInformationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "3d865716288db362e4482bca61bae234",
            "id": "4081e27c2eac6ae1fe6c53268126950193be606ac668f1ff38f8b6a3896b17c0",
            "metadata": {},
            "name": "SiteInformationQuery",
            "operationKind": "query",
            "text": "query SiteInformationQuery{tenant{shard,cloudId,environment,activationId},organization{orgId},userForAnalytics:confluence_atlassianUser{id},user:confluence_atlassianUser(current:true){id,displayName,confluence{accessStatus,accountId,userKey,locale},timeZone},getAIConfig(product:CONFLUENCE){isEnabled,isRovoEnabled,isAIEarlyAccessEnabled,isAtlassianHostedLLMOnlyEnabled,isRovoLLMEnabled},confluence_tenantContext{baseUrl,licenseStates{confluence{ccpEntitlementId}},timeZone,editions{confluence},monolithRegion},isSiteAdmin,abTestCohorts,experimentFeatures,userCanCreateContent,isNewUser,siteSettings{homepage{uri,title},siteTitle,showApplicationTitle,frontCover{frontCoverState},companyHubName,isHideTitleInUrl},siteDescription{logoUrl},currentConfluenceUser{isAnonymous}}"
        }
    };
}();
$9dcb399372c982ec$var$node.hash = "18c74553c8fa46eb3e25cb65e41ffce3";
var $9dcb399372c982ec$export$2e2bcd8739ae039 = $9dcb399372c982ec$var$node;


let $b409c2781320251f$var$sessionDataError;
const $b409c2781320251f$export$a313e6830b104e3b = ()=>$b409c2781320251f$var$sessionDataError;
const $b409c2781320251f$var$normalizeSessionDataError = (error)=>{
    const errorCandidate = Array.isArray(error) ? error.find((candidate)=>candidate instanceof Error) ?? error[0] : error;
    if (errorCandidate instanceof Error) return errorCandidate;
    const message = typeof errorCandidate === 'object' && errorCandidate !== null && 'message' in errorCandidate && typeof errorCandidate.message === 'string' ? errorCandidate.message : 'Unknown session data error';
    return new Error(message);
};
async function $b409c2781320251f$export$5ae208508f6870b() {
    // __SITEINFORMATION__ is either actual session data
    // or the promise that is resolving the session data
    // In the case when page is rendered by SSR, the __SITEINFORMATION__ will be populated with JSON data.
    if (window['__SITEINFORMATION__']) return window['__SITEINFORMATION__'];
    $b409c2781320251f$var$sessionDataError = undefined;
    window['__SITEINFORMATION__'] = (0, $92055207a5a5a2a3$export$c53086aa5c7d04b4)({
        query: (0, $9dcb399372c982ec$export$2e2bcd8739ae039),
        errorPolicy: 'all',
        fetchPolicy: 'cache-first',
        // On the Bifrost SSR path this call runs before the Statsig client is initialised, so
        // `isRelayEnabled` cannot read the rollout configuration and silently answers "Apollo" —
        // while `SPAViewContextProvider` reads the same query after initialisation and resolves to
        // Relay, finding nothing. Bifrost resolves the routing up front from the native edge SDK;
        // `null` (every other environment) leaves the normal decision untouched.
        forceRelay: (0, $96bbc70980550850$export$14e4d10d25ee113c)(),
        context: {
            single: false,
            allowOnExternalPage: true
        },
        __callerPackage__: "session-data"
    }).then((result)=>{
        $b409c2781320251f$var$sessionDataError = result.error;
        const errors = result.error?.graphQLErrors ?? [];
        if (errors.length > 0) errors.forEach((e)=>{
            if ((0, $6e2aeba1bc095709$export$55152de1f925fd05)(e) && !!result?.data?.tenant?.cloudId) (0, $4b7988ce40c8fd3c$export$702f853386561b84)(e);
            else (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(e, {
                isSiteInformationError: true,
                partialFailure: true,
                attribution: 'FATAL'
            });
        });
        return result.data;
    }).catch((error)=>{
        $b409c2781320251f$var$sessionDataError = $b409c2781320251f$var$sessionDataError ?? $b409c2781320251f$var$normalizeSessionDataError(error);
        if (Array.isArray(error)) error.forEach((e)=>(0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(e, {
                isSiteInformationError: true,
                partialFailure: false,
                attribution: 'FATAL'
            }));
        else (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(error, {
            isSiteInformationError: true,
            partialFailure: false,
            attribution: 'FATAL'
        });
        return null;
    });
    return window['__SITEINFORMATION__'];
}


const $b5780f5a758d6771$export$4163744babc94103 = ()=>{
    // Not using memorize here because we want to reset promise in test
    if (window['__SITEINFORMATION_PROMISE__']) return window['__SITEINFORMATION_PROMISE__'];
    return window['__SITEINFORMATION_PROMISE__'] = (0, $cd3135dd152096aa$export$cc373701aed148fc)((0, $b409c2781320251f$export$5ae208508f6870b)().then((0, $2800afeb4fc22c91$export$48ea97dcec207a60)));
};
const $b5780f5a758d6771$export$fdd2c0ba94025c3c = ()=>{
    const sessionDataPromise = $b5780f5a758d6771$export$4163744babc94103();
    if ((0, $cd3135dd152096aa$export$b1a2a6bd0c6f9666)(sessionDataPromise)) return (0, $cd3135dd152096aa$export$bf7199a9ebcb84a9)(sessionDataPromise)?.cloudId;
    else // Session data is not loaded yet, return null
    return null;
};
class $b5780f5a758d6771$export$14dde3d2ec7dfd8f extends (0, $2hRE7.Component) {
    componentWillUnmount() {
        this._mount = false;
    }
    render() {
        const { sessionData: sessionData } = this.state;
        if (sessionData) return this.props.children(sessionData);
        if (this.props.renderChildrenWhenLoading === true) return this.props.children({
            loading: true
        });
        return null;
    }
    constructor(props){
        super(props);
        this._mount = void 0;
        this.state = {};
        const promise = $b5780f5a758d6771$export$4163744babc94103();
        this._mount = true;
        if ((0, $cd3135dd152096aa$export$b1a2a6bd0c6f9666)(promise)) this.state = {
            sessionData: (0, $cd3135dd152096aa$export$bf7199a9ebcb84a9)(promise)
        };
        else promise.then((sessionData)=>{
            if (this._mount) this.setState({
                sessionData: sessionData
            });
        });
    }
}



const $a4b9a8903fd62c69$var$COMPANY_HUB_SPACE_KEY_PREFIX = '~HUB';
const $a4b9a8903fd62c69$export$5ab9c400208ad907 = (spaceKey)=>!!(spaceKey?.startsWith($a4b9a8903fd62c69$var$COMPANY_HUB_SPACE_KEY_PREFIX) && spaceKey?.endsWith('~'));
const $a4b9a8903fd62c69$export$6193f65d76fa4c00 = (sessionData)=>{
    if (!sessionData?.activationId || !sessionData?.cloudId) sessionData = (0, $cd3135dd152096aa$export$bf7199a9ebcb84a9)((0, $b5780f5a758d6771$export$4163744babc94103)());
    if (sessionData) {
        const { activationId: activationId, cloudId: cloudId } = sessionData;
        if (activationId && cloudId) return `${$a4b9a8903fd62c69$var$COMPANY_HUB_SPACE_KEY_PREFIX}-${cloudId}-${activationId}~`;
    }
    // We used to return undefined, but pretty much always we fell back to the empty string with code like `?? ''` or `|| ''`.
    // Instead of sprinkling noise like that all over, it's less complex to do the de facto fallback here.
    return '';
};
var $a4b9a8903fd62c69$export$8b92a390c1734cf9 = /*#__PURE__*/ function(FrontCoverStateEnum) {
    FrontCoverStateEnum["UNSET"] = "unset";
    FrontCoverStateEnum["HIDDEN"] = "hidden";
    FrontCoverStateEnum["EDITORS_ONLY"] = "editors_only";
    FrontCoverStateEnum["SHOWN"] = "shown";
    return FrontCoverStateEnum;
}({});
var $a4b9a8903fd62c69$export$ec1312b61cf60ef3 = /*#__PURE__*/ function(FrontCoverStateInputEnum) {
    FrontCoverStateInputEnum["UNSET"] = "UNSET";
    FrontCoverStateInputEnum["HIDDEN"] = "HIDDEN";
    FrontCoverStateInputEnum["SHOWN"] = "SHOWN";
    return FrontCoverStateInputEnum;
}({});


// Deep link visiting
const $d4b865e8cc459c1f$export$61f782d99db03c49 = 'follow-deep-link';
const $d4b865e8cc459c1f$export$ed2197e4948fef6c = 'view-macro-renderer';
const $d4b865e8cc459c1f$export$136d4e1bb3adaa98 = 'view-macro-editor';
const $d4b865e8cc459c1f$export$54747aca26cee3f8 = 'view-all-macro';
const $d4b865e8cc459c1f$export$f8afba90a5a815ad = 'view-jira-macro';
const $d4b865e8cc459c1f$export$87daa9a1b1dd910d = 'migrate-page';
const $d4b865e8cc459c1f$export$6c0a7d453b9ba427 = 'migrate-page/publish';
const $d4b865e8cc459c1f$export$b39a77dbc03575b1 = 'migrate-template';
const $d4b865e8cc459c1f$export$f94e85276e6d639f = 'add-page-comment';
const $d4b865e8cc459c1f$export$31bd7de6ca230764 = 'add-page-comment/load';
const $d4b865e8cc459c1f$export$4cb6cf73aff93e7d = 'add-page-comment/publish';
const $d4b865e8cc459c1f$export$2a99a63e28df64fd = 'edit-page-comment';
const $d4b865e8cc459c1f$export$515913089a77cb7c = 'edit-page-comment/load';
const $d4b865e8cc459c1f$export$c0906b23fa1e3b63 = 'edit-page-comment/publish';
const $d4b865e8cc459c1f$export$e9a5501ca0d5d256 = 'reply-to-page-comment';
const $d4b865e8cc459c1f$export$3fdffa656412b99a = 'reply-to-page-comment/load';
const $d4b865e8cc459c1f$export$bfebfbab40727cd6 = 'reply-to-page-comment/publish';
const $d4b865e8cc459c1f$export$91d50c2b267d0461 = 'delete-page-comment';
const $d4b865e8cc459c1f$export$24ef8c79de5598b9 = 'resolve-page-comment';
const $d4b865e8cc459c1f$export$8c6422f793f7efae = 'mark-comments-as-read';
const $d4b865e8cc459c1f$export$98dbdebd041da61c = 'mark-all-comments-as-read';
const $d4b865e8cc459c1f$export$6f58645a9a5f7936 = 'create-inline-comment';
const $d4b865e8cc459c1f$export$8180a49fb6c681b1 = 'create-inline-comment/init';
const $d4b865e8cc459c1f$export$ed5e210bce3a41a9 = 'create-inline-comment/draft-to-publish';
const $d4b865e8cc459c1f$export$db23cb60632b0aa0 = 'create-inline-comment/attach-comment';
const $d4b865e8cc459c1f$export$f8e0e16825f0d222 = 'select-inline-comment';
const $d4b865e8cc459c1f$export$2003fd9c8f509d96 = 'add-inline-comment';
const $d4b865e8cc459c1f$export$a69ecd33d83d56ce = 'add-inline-comment/load';
const $d4b865e8cc459c1f$export$eb89dbd7422d8194 = 'add-inline-comment/publish';
const $d4b865e8cc459c1f$export$29c433981d13c955 = 'edit-inline-comment';
const $d4b865e8cc459c1f$export$a557d8a611f835b = 'edit-inline-comment/load';
const $d4b865e8cc459c1f$export$e9dafdd46fb3d4ed = 'edit-inline-comment/publish';
const $d4b865e8cc459c1f$export$20fbac00cba3c8a = 'view-inline-comment';
const $d4b865e8cc459c1f$export$533f2a7cfe4f757e = 'view-inline-comment/toplevel';
const $d4b865e8cc459c1f$export$fb1f28583d577755 = 'view-inline-comment/reply';
const $d4b865e8cc459c1f$export$a4a647338c1ce0b3 = 'view-page-comment';
const $d4b865e8cc459c1f$export$32f41dd330b40a4d = 'view-page-comment/toplevel';
const $d4b865e8cc459c1f$export$fd92dc7dd22c3700 = 'view-page-comment/reply';
const $d4b865e8cc459c1f$export$9d157677f817543f = 'reply-to-inline-comment';
const $d4b865e8cc459c1f$export$b4f2ad99abb89883 = 'reply-to-inline-comment/load';
const $d4b865e8cc459c1f$export$32059abd767a1104 = 'reply-to-inline-comment/publish';
const $d4b865e8cc459c1f$export$bcfccb61f33e9641 = 'delete-inline-comment';
const $d4b865e8cc459c1f$export$819fbef15068ac1d = 'resolve-inline-comment';
const $d4b865e8cc459c1f$export$996a096215f40255 = 'unresolve-inline-comment';
const $d4b865e8cc459c1f$export$c64ae72fd2ff5bed = 'resolved-inline-comments-dialog-sort';
const $d4b865e8cc459c1f$export$a32711b0e13e94b7 = 'reattach-inline-comment';
const $d4b865e8cc459c1f$export$ea70cc80532deae9 = 'delete-inline-reaction';
const $d4b865e8cc459c1f$export$df5d14cacddd40da = 'resolve-inline-reaction';
const $d4b865e8cc459c1f$export$b8b053a7da5f296e = 'unresolve-inline-reaction';
const $d4b865e8cc459c1f$export$d6f52083721d3342 = 'view-reactions';
const $d4b865e8cc459c1f$export$e6f0efe9d461092e = 'view-reaction-user-list';
const $d4b865e8cc459c1f$export$ba45b443cf775f1b = 'add-reaction';
const $d4b865e8cc459c1f$export$63f7987e2f1f8f3 = 'delete-reaction';
const $d4b865e8cc459c1f$export$d2b2dda7569d39d7 = 'view-omnibar';
const $d4b865e8cc459c1f$export$498dd94d9e0dae1b = 'omnibar/add-reaction';
const $d4b865e8cc459c1f$export$77e51adee9393adf = 'omnibar/delete-reaction';
const $d4b865e8cc459c1f$export$aa1b3aa6132c5165 = 'add-quick-reaction';
const $d4b865e8cc459c1f$export$7321222ee6dc4c8a = 'copy-space-permissions';
const $d4b865e8cc459c1f$export$227ea80a7d6d8ef2 = 'create-page';
const $d4b865e8cc459c1f$export$1773354263fb7a1f = 'create-page/load-dialog';
const $d4b865e8cc459c1f$export$5f80ef7b2915bb38 = 'create-page/template-variable-input';
const $d4b865e8cc459c1f$export$58a8157586db4510 = 'create-page-from-link-creation';
const $d4b865e8cc459c1f$export$f27db95814bbdf0 = 'create-whiteboard';
const $d4b865e8cc459c1f$export$13566a78bbba7568 = 'create-database';
const $d4b865e8cc459c1f$export$c6222c9fbf47e43b = 'create-embed';
const $d4b865e8cc459c1f$export$49548e7a8766f858 = 'create-slide';
const $d4b865e8cc459c1f$export$63a2c018dc189e0 = 'create-folder';
const $d4b865e8cc459c1f$export$9c40f417713b17ea = 'edit-page-smart-create/load';
const $d4b865e8cc459c1f$export$3b77354df5b75bc7 = 'aifc-bridge-registration';
const $d4b865e8cc459c1f$export$dd70d6707192298e = 'edit-page';
const $d4b865e8cc459c1f$export$cd96dc6a09f60949 = 'edit-legacy-page';
const $d4b865e8cc459c1f$export$b6f302e969b56ed5 = 'edit-page-embed';
const $d4b865e8cc459c1f$export$cfe717283b384dee = 'edit-page/loader'; // loader to determine editor routing (next vs. classic)
const $d4b865e8cc459c1f$export$54650b8dd9597591 = 'edit-page/load';
const $d4b865e8cc459c1f$export$9cfef550e5af515d = 'edit-legacy-page/load';
const $d4b865e8cc459c1f$export$4aed0cf42acf9c68 = 'edit-page/publish';
const $d4b865e8cc459c1f$export$770ea955fed26e20 = 'edit-legacy-page/publish';
const $d4b865e8cc459c1f$export$4abcdf78bb75330c = 'edit-page/publish-as-blog';
const $d4b865e8cc459c1f$export$92edebd76eb1ad1 = 'edit-page/close';
const $d4b865e8cc459c1f$export$1339ae8dc80b092c = 'edit-legacy-page/close';
const $d4b865e8cc459c1f$export$42ce143b9452f768 = 'edit-page/revert-draft';
const $d4b865e8cc459c1f$export$3814d28dd3802a02 = 'live-page-session';
const $d4b865e8cc459c1f$export$40fb2b7b657bf7d = 'live-page/publish';
const $d4b865e8cc459c1f$export$9e0dcc9389703292 = 'create-and-edit-page';
const $d4b865e8cc459c1f$export$b9892a850189b3e9 = 'template-edit-page';
const $d4b865e8cc459c1f$export$3604f7decc6e0567 = 'template-edit-page/load';
const $d4b865e8cc459c1f$export$1a3cf6b911b3771 = 'template-edit-page/close';
const $d4b865e8cc459c1f$export$a7f90c693668eabe = 'template-edit-page/publish';
const $d4b865e8cc459c1f$export$3c5dcebba4317c7e = 'template-edit-page/publish/template-body';
const $d4b865e8cc459c1f$export$3a8f568ddb8f3189 = 'template-edit-page/publish/template-properties';
const $d4b865e8cc459c1f$export$583391c24e8a1735 = 'in-editor-templates-load-panel';
const $d4b865e8cc459c1f$export$6afe1d2e05c85172 = 'in-editor-templates-load-panel/template-list';
const $d4b865e8cc459c1f$export$6085a8760b035f6 = 'in-editor-templates-load-panel/categories';
const $d4b865e8cc459c1f$export$cbd9dfa0a050a0e0 = 'in-editor-templates-load-panel/space-selector';
const $d4b865e8cc459c1f$export$8fcf8395eb106389 = 'in-editor-templates-update-content';
const $d4b865e8cc459c1f$export$eac277758b783558 = 'in-editor-templates-update-content/refresh-editor';
const $d4b865e8cc459c1f$export$d3b70eeb61a68ef1 = 'template-suggestions';
const $d4b865e8cc459c1f$export$89e30156af35c723 = 'view-in-product-help';
const $d4b865e8cc459c1f$export$1072a5750cf51c7e = 'search-in-product-help';
const $d4b865e8cc459c1f$export$85f8b3853315a126 = 'search-in-product-help/load';
const $d4b865e8cc459c1f$export$49e4c787a6cc62e = 'view-article-in-product-help';
const $d4b865e8cc459c1f$export$3d1292b099f0e166 = 'view-article-in-product-help/load';
const $d4b865e8cc459c1f$export$54615853abc6859 = 'template-gallery';
const $d4b865e8cc459c1f$export$82c983e2a60f2e28 = 'template-gallery/space-selector';
const $d4b865e8cc459c1f$export$61439b391c5a3aca = 'template-gallery/categories';
const $d4b865e8cc459c1f$export$81cd8bf6923e1bf1 = 'template-gallery/cards';
const $d4b865e8cc459c1f$export$b6af3a64b182b9d0 = 'template-gallery/template-detail';
const $d4b865e8cc459c1f$export$588acf29fbd8637d = 'template-gallery/template-detail-update';
const $d4b865e8cc459c1f$export$a1cf4f28febc3bee = 'template-gallery/template-detail/header';
const $d4b865e8cc459c1f$export$b802716fd0c5b93f = 'template-preview';
const $d4b865e8cc459c1f$export$e0195c05e32ed777 = 'refresh-editor-content';
const $d4b865e8cc459c1f$export$9194ae178043ade6 = 'create-content-from-template';
const $d4b865e8cc459c1f$export$1545639c80579c53 = 'blueprint-wizard-load-dialog';
const $d4b865e8cc459c1f$export$fc0c176abc30d17b = 'connect-addon';
const $d4b865e8cc459c1f$export$2b71c2d15060e9a5 = 'connect-theme-render';
const $d4b865e8cc459c1f$export$dc0130214b990857 = 'widget-connector-embed';
const $d4b865e8cc459c1f$export$42abbe7bae78d499 = 'connect-custom-content';
const $d4b865e8cc459c1f$export$97b170c4be77228 = 'quick-reload';
const $d4b865e8cc459c1f$export$9625ccab45afe35a = 'quick-reload-v3';
const $d4b865e8cc459c1f$export$dbbd27df623b094f = 'restricted-page';
const $d4b865e8cc459c1f$export$8f404e4bd2a13aa = 'restricted-space-for-guest';
const $d4b865e8cc459c1f$export$727b779ceeca0a78 = 'restricted-space';
const $d4b865e8cc459c1f$export$b9ee7465c962e842 = 'restrictions-dialog';
const $d4b865e8cc459c1f$export$2e96e7e6b8da0317 = 'restrictions-dialog/load';
const $d4b865e8cc459c1f$export$6b54d78a736a983b = 'restrictions-dialog/apply';
const $d4b865e8cc459c1f$export$a66250c876dd8838 = 'publish-modal/load-restrictions';
const $d4b865e8cc459c1f$export$e64caae0c75dd921 = 'impersonation-flag';
const $d4b865e8cc459c1f$export$7ebe8ae2b3f231cb = 'inspect-permissions';
const $d4b865e8cc459c1f$export$b659623b19114e87 = 'user-access';
const $d4b865e8cc459c1f$export$9d715fddec195756 = 'upsell-edition';
const $d4b865e8cc459c1f$export$a7ffbea51ff646ee = 'upsell-edition-upflow';
const $d4b865e8cc459c1f$export$bd5028ea224c4de1 = 'archiving/archive-pages';
const $d4b865e8cc459c1f$export$e63a17e805ed8387 = 'archiving/restore-pages';
const $d4b865e8cc459c1f$export$d74c17e82f5dbc27 = 'archiving/view-space-archived-pages';
const $d4b865e8cc459c1f$export$b7a40ae431fd676d = 'archiving/view-space-archived-pages/paginate';
const $d4b865e8cc459c1f$export$b84de3b67d7aa4be = 'archiving/edit-notes-archive-pages';
const $d4b865e8cc459c1f$export$9efd42121cbefbff = 'archiving/bulk-edit-notes-archive-pages';
const $d4b865e8cc459c1f$export$c30b739e25dc756b = 'archiving/archived-page-banner';
const $d4b865e8cc459c1f$export$fc9036c892e05ff9 = 'automation-discovery/add-label';
const $d4b865e8cc459c1f$export$abe2705723fc11ac = 'automation-discovery/publish-meeting-notes';
const $d4b865e8cc459c1f$export$90d9afd417e81733 = 'automation-discovery/archive-page';
const $d4b865e8cc459c1f$export$bcf33c3d2ec343df = 'automation-discovery/hover-over-page-title';
const $d4b865e8cc459c1f$export$8b43be9232ec143f = 'automation-discovery/jira-link';
const $d4b865e8cc459c1f$export$adc097acaa5bd53a = 'automation-discovery/manual-trigger';
const $d4b865e8cc459c1f$export$184da8822d56484c = 'automation-discovery/bulk-archive';
const $d4b865e8cc459c1f$export$65a0bbd38d8f5b63 = 'automation-discovery/page-public-link';
const $d4b865e8cc459c1f$export$c7dca20d997e95ed = 'automation-manual-triggers';
const $d4b865e8cc459c1f$export$2504afae65d57ffb = 'automation-discovery/whiteboards';
const $d4b865e8cc459c1f$export$cf23f74117283d17 = 'automation-discovery/bulk-change-page-owner';
const $d4b865e8cc459c1f$export$78bf51c34f43d049 = 'automation-smart-button-run-rule';
const $d4b865e8cc459c1f$export$d0afbe071e52a5cf = 'automation-smart-button-create-rule';
const $d4b865e8cc459c1f$export$b30eb768fa4c3967 = 'automation-smart-button-edit-rule';
const $d4b865e8cc459c1f$export$2cc8139334567c4f = 'automation-smart-button-preview-rule';
const $d4b865e8cc459c1f$export$cab2a1e3c7ddbb06 = 'automation-side-nav-bar';
const $d4b865e8cc459c1f$export$a03bf7627f412dc4 = 'automation-upsell';
const $d4b865e8cc459c1f$export$a26e99521ea3a9f4 = 'delete-page';
const $d4b865e8cc459c1f$export$57cc53c6e3b9be1b = 'bulk-delete-pages';
const $d4b865e8cc459c1f$export$91d3a54b5d7e1b7f = 'bulk-change-owner';
const $d4b865e8cc459c1f$export$ba8b23dd795f5f9e = 'bulk-change-status';
const $d4b865e8cc459c1f$export$7bea875d555696ca = 'bulk-convert-page-to-live-doc';
const $d4b865e8cc459c1f$export$a837ee39f68fa2dd = 'edit-sidebar';
const $d4b865e8cc459c1f$export$e69ba0c4a7667861 = 'edit-sidebar/update';
const $d4b865e8cc459c1f$export$c6fd99844ee488c5 = 'manage-pages';
const $d4b865e8cc459c1f$export$8fc86f50c7402da0 = 'manage-pages/paginate';
const $d4b865e8cc459c1f$export$d4b4a08489e4dfe2 = 'content-manager';
const $d4b865e8cc459c1f$export$c03f98139dd9719e = 'move-page-dialog-load';
const $d4b865e8cc459c1f$export$1167cf561a6df618 = 'move-published-page';
const $d4b865e8cc459c1f$export$95c6dda6cbbf364 = 'move-blog';
const $d4b865e8cc459c1f$export$fbbc408e16c59382 = 'not-found';
const $d4b865e8cc459c1f$export$cf73dfff88c1f700 = 'view-content';
const $d4b865e8cc459c1f$export$d4712ac27cc4e72f = 'view-page';
const $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2 = 'view-page-session';
const $d4b865e8cc459c1f$export$2a57468d23984a9d = 'space-overview';
const $d4b865e8cc459c1f$export$54504a2cc31519bf = 'breadcrumbs';
const $d4b865e8cc459c1f$export$68af05e1cf40b8e6 = 'breadcrumbs/dropdown';
const $d4b865e8cc459c1f$export$863ebd92a50403cf = 'view-page/title';
const $d4b865e8cc459c1f$export$df0793573ff7d63c = 'view-page/reactions';
const $d4b865e8cc459c1f$export$bdd2d0f331a38827 = 'view-page/labels'; //After confluence_frontend_labels_in_footer is rolled out, this will only beused for tiny pages which show the old view page labels experience
const $d4b865e8cc459c1f$export$def55fa9fa47c777 = 'view-page/labels/footer';
const $d4b865e8cc459c1f$export$49fde5724a27b431 = 'view-page/byline';
const $d4b865e8cc459c1f$export$7a119c18309263c = 'view-page/byline/forge';
const $d4b865e8cc459c1f$export$45c9f537ef090ccd = 'view-page/comments';
const $d4b865e8cc459c1f$export$d7d1b2bdd9bd08f4 = 'view-page/direct-comment-data-flow';
const $d4b865e8cc459c1f$export$dc03e514628af5e9 = 'view-page/edit';
const $d4b865e8cc459c1f$export$38478feb41239856 = 'view-page/content-tools';
const $d4b865e8cc459c1f$export$ef641459105e6b1a = 'view-page/content-tools/forge';
const $d4b865e8cc459c1f$export$255077470163d493 = 'view-page/context-menu';
const $d4b865e8cc459c1f$export$43081e88ffac9568 = 'view-page/context-menu/forge';
const $d4b865e8cc459c1f$export$14a39beec323232a = 'view-page/content-header'; // for old view page header
const $d4b865e8cc459c1f$export$5870dabed6d7b7fc = 'view-page/favorite';
const $d4b865e8cc459c1f$export$857306718a36d667 = 'view-page/share-button';
const $d4b865e8cc459c1f$export$b7907767002e32d = 'view-page/restrictions-button';
const $d4b865e8cc459c1f$export$aa15347df133b367 = 'view-page/comment-button';
const $d4b865e8cc459c1f$export$18cb1bed3afb8173 = 'view-page/discover-inline-comments-feature';
const $d4b865e8cc459c1f$export$b500820ed8b3aee5 = 'view-page/publish-as-blog';
const $d4b865e8cc459c1f$export$6d3091550f30a4fa = 'page-split/action';
const $d4b865e8cc459c1f$export$b6aa627543f70c56 = 'page-split/load';
const $d4b865e8cc459c1f$export$a83700d85c7e0745 = 'whiteboard-page';
const $d4b865e8cc459c1f$export$c6cbeacb537102dd = 'slide-page';
const $d4b865e8cc459c1f$export$327b4b6488d8cc55 = 'slide-page/content';
const $d4b865e8cc459c1f$export$bdaf5db6d84a5581 = 'whiteboard-page/content';
const $d4b865e8cc459c1f$export$4252e8d96c415d57 = 'whiteboard-version-history-side-panel';
const $d4b865e8cc459c1f$export$b8cdecdc06b6252 = 'whiteboard-restore-version';
const $d4b865e8cc459c1f$export$90f5a89f66458e77 = 'whiteboard-version-history-restore-modal';
const $d4b865e8cc459c1f$export$ac543fcfec35df26 = 'suggest-whiteboard-based-on-page-title';
const $d4b865e8cc459c1f$export$e5419fb2b0f293a6 = 'slide-version-history-side-panel';
const $d4b865e8cc459c1f$export$7554b7d0b01722ed = 'slide-restore-version';
const $d4b865e8cc459c1f$export$6d6f07b7b01315d = 'slide-version-history-restore-modal';
const $d4b865e8cc459c1f$export$f02aef641190ead6 = 'database-page';
const $d4b865e8cc459c1f$export$7140ccdb0c7b2b37 = 'database-page/content';
const $d4b865e8cc459c1f$export$857587c3b96ae00c = 'database-version-history-side-panel';
const $d4b865e8cc459c1f$export$bdbfe4dafa70ffab = 'database-restore-version';
const $d4b865e8cc459c1f$export$7cc7b880d5b3f324 = 'database-version-history-restore-modal';
const $d4b865e8cc459c1f$export$ba3b240cb9a3ffd0 = 'database-load-historical-version';
const $d4b865e8cc459c1f$export$602ada09f4d43ce4 = 'dev-docs/create-documents';
const $d4b865e8cc459c1f$export$94ff2c022e9f446c = 'dev-docs/create-documents/setup-folder';
const $d4b865e8cc459c1f$export$2fe9f8f0f7a0b45a = 'dev-docs/create-documents/start-sync';
const $d4b865e8cc459c1f$export$773869ad1ebed954 = 'dev-docs/generation';
const $d4b865e8cc459c1f$export$4aed1e03b01bf97e = 'dev-docs/github-oauth';
const $d4b865e8cc459c1f$export$119ebf0a4096ceb1 = 'dev-docs/manage-sync/sync-state';
const $d4b865e8cc459c1f$export$cf8ac0bde75903b0 = 'dev-docs/repository-discovery';
const $d4b865e8cc459c1f$export$97d4ac8da1e7a3ee = 'dev-docs/source-resolution';
const $d4b865e8cc459c1f$export$b839a2412b71146a = 'dev-docs/stop-syncing';
const $d4b865e8cc459c1f$export$f6164c04d856ace5 = 'dev-docs/suggestions-load';
const $d4b865e8cc459c1f$export$499863c729a1378e = 'dev-docs/sync-now';
const $d4b865e8cc459c1f$export$c85a8dac7f241add = 'embed-page';
const $d4b865e8cc459c1f$export$927658f514adba70 = 'embed-page/content';
const $d4b865e8cc459c1f$export$c1092431c58e1571 = 'edit-embed';
const $d4b865e8cc459c1f$export$3485e62ad9c27d0b = 'folder-page';
const $d4b865e8cc459c1f$export$6237c6dbe5a63f05 = 'folder-page/content';
const $d4b865e8cc459c1f$export$7fd0425089f6d999 = 'content-types-header';
const $d4b865e8cc459c1f$export$47f14e5e827cfff3 = 'content-types-header/watch';
const $d4b865e8cc459c1f$export$748b7f600814978a = 'content-creation-paywall';
const $d4b865e8cc459c1f$export$5e1aeeb6f31be57a = 'record-loom-entry-point';
const $d4b865e8cc459c1f$export$c427a8b1052a6522 = 'loom-page-header-content-insertion';
const $d4b865e8cc459c1f$export$6ca90e5df7047c10 = 'loom-cross-sell';
const $d4b865e8cc459c1f$export$96f8e8997d2c8722 = 'edit-page/labels';
const $d4b865e8cc459c1f$export$e9e0897b7cf2ab3f = 'labels/add-label';
const $d4b865e8cc459c1f$export$5a4fc6855f9c48e = 'labels/create-label';
const $d4b865e8cc459c1f$export$3f19e9a9a0d72413 = 'labels/delete-label';
const $d4b865e8cc459c1f$export$39d403abc2174e5e = 'labels/search-label';
const $d4b865e8cc459c1f$export$4d573c9dfbc9337c = 'labels/recommended';
const $d4b865e8cc459c1f$export$8af5d568de2d4e43 = 'template-edit-page/labels';
const $d4b865e8cc459c1f$export$c5ef6dea1c804893 = 'template-edit-page/labels/add-label';
const $d4b865e8cc459c1f$export$fa82b911a68fea4d = 'template-edit-page/labels/create-label';
const $d4b865e8cc459c1f$export$20b2f79b83628af0 = 'template-edit-page/labels/delete-label';
const $d4b865e8cc459c1f$export$479dc90f08ae49d = 'template-edit-page/labels/search-label';
const $d4b865e8cc459c1f$export$d8e5793fc3893dd0 = 'header-items/group-load';
const $d4b865e8cc459c1f$export$66f0a82e06e92ea = 'home';
const $d4b865e8cc459c1f$export$8856e11bfa69959d = 'home/spaces';
const $d4b865e8cc459c1f$export$8ef0e6a462dfc555 = 'home/recent-pages';
const $d4b865e8cc459c1f$export$d931b261468db3be = 'home/right-panel';
const $d4b865e8cc459c1f$export$cd6478684fc4b278 = 'home/right-panel/activity';
const $d4b865e8cc459c1f$export$45cf379c9ef28a2d = 'home/right-panel/welcome-message';
const $d4b865e8cc459c1f$export$ceb391a6374fc2 = 'home/right-panel/calendars';
const $d4b865e8cc459c1f$export$799c1b543715aab4 = 'home/right-panel/apps';
const $d4b865e8cc459c1f$export$519eb6f457873738 = 'home/right-panel/forge';
const $d4b865e8cc459c1f$export$b57c8eba324f4ab1 = 'home/right-panel/recommendations';
const $d4b865e8cc459c1f$export$cf6a4f3279a69e87 = 'confluence';
const $d4b865e8cc459c1f$export$680e462c4f71cea1 = 'feed';
const $d4b865e8cc459c1f$export$d660d67b42309542 = 'home/overview';
const $d4b865e8cc459c1f$export$f987075f870b167d = 'home/overview/recent';
const $d4b865e8cc459c1f$export$6c96437f170477a4 = 'home/overview/recent/paginate';
const $d4b865e8cc459c1f$export$94f2ecf008a81b99 = 'home/recent';
const $d4b865e8cc459c1f$export$45d7f7ed7a82bcd = 'home/starred';
const $d4b865e8cc459c1f$export$ecf5fd41d4da9bf8 = 'home/watching';
const $d4b865e8cc459c1f$export$9b242f2ddcd908fc = 'home/drafts';
const $d4b865e8cc459c1f$export$5393f7f46c9e5055 = 'advanced-search';
const $d4b865e8cc459c1f$export$91a00c702eb82c2c = 'advanced-search/space-filter';
const $d4b865e8cc459c1f$export$3f0c1a8eb5419bb4 = 'advanced-search/contributor-filter';
const $d4b865e8cc459c1f$export$bda2c35d9a84e22c = 'advanced-search/smart-contributor-filter';
const $d4b865e8cc459c1f$export$ec545137ad6ac054 = 'quick-search/pre-query';
const $d4b865e8cc459c1f$export$e64dfa2771353f5c = 'recent-dropdown/visited';
const $d4b865e8cc459c1f$export$53f4f21972586e42 = 'recent-dropdown/created-by-me';
const $d4b865e8cc459c1f$export$985013c384c228e1 = 'recent-dropdown/worked-on';
const $d4b865e8cc459c1f$export$605220fac97de = 'recent-dropdown/drafts';
const $d4b865e8cc459c1f$export$7c6d9e11a2120c1b = 'recent-dropdown/starred';
const $d4b865e8cc459c1f$export$90de82ddab5d3bda = 'content/quick-actions';
const $d4b865e8cc459c1f$export$59a9c2c7ae337de7 = 'page-tree';
const $d4b865e8cc459c1f$export$bbc326cd1f124322 = 'page-tree/dnd';
const $d4b865e8cc459c1f$export$cd3eec90d152a8ea = 'page-tree/rename';
const $d4b865e8cc459c1f$export$9d1f80f618a6627b = 'blog-tree';
const $d4b865e8cc459c1f$export$899513ff8720fa55 = 'blog-tree/pagination';
const $d4b865e8cc459c1f$export$d200becb25c80dc0 = 'activity/tailored';
const $d4b865e8cc459c1f$export$8729a78bfed79808 = 'activity/create-space-button';
const $d4b865e8cc459c1f$export$b0be9d71080b7c81 = 'activity/right-sidebar';
const $d4b865e8cc459c1f$export$2783f61e72caafb5 = 'feed-migration/activity/popular';
const $d4b865e8cc459c1f$export$fcff442a18d04a5d = 'feed-migration/activity/all-updates';
const $d4b865e8cc459c1f$export$357a2b9b5fb0f4e4 = 'navigation/nav-2-admin-navigation/forge';
const $d4b865e8cc459c1f$export$9b5915bb3a4fbcae = 'navigation/app-nav-global-navigation';
const $d4b865e8cc459c1f$export$e3e183dd97af67fd = 'navigation/app-nav-container-navigation';
const $d4b865e8cc459c1f$export$14b67f3e8f5e6f95 = 'navigation/app-nav-admin-navigation';
const $d4b865e8cc459c1f$export$f089f204ab93864e = 'navigation/app-nav-spaces-dropdown';
const $d4b865e8cc459c1f$export$5c3671291c82150b = 'navigation/app-nav-pages-dropdown';
const $d4b865e8cc459c1f$export$63d03b6879925116 = 'navigation/app-nav-apps-dropdown';
const $d4b865e8cc459c1f$export$fa160b39d3766fc0 = 'navigation/app-nav-notifications-dropdown';
const $d4b865e8cc459c1f$export$986139018de1521a = 'navigation/app-nav-profile-dropdown';
const $d4b865e8cc459c1f$export$6cebb7e0b005cd28 = 'space-directory';
const $d4b865e8cc459c1f$export$aeda23f4b92ccc3b = 'space-directory/your-spaces';
const $d4b865e8cc459c1f$export$4a890f75d0a61967 = 'space-directory/filter';
const $d4b865e8cc459c1f$export$39e9ebfcfd8e8bad = 'space-directory/paginate';
const $d4b865e8cc459c1f$export$de6098630f95035a = 'create-space/submit';
const $d4b865e8cc459c1f$export$9b47bc79e174bc93 = 'create-space/validate';
const $d4b865e8cc459c1f$export$e11c878086229943 = 'create-space/connector-files/recommended';
const $d4b865e8cc459c1f$export$d104f46411fba29c = 'create-space/connector-files/recently-viewed';
const $d4b865e8cc459c1f$export$b1f02d9551fbd754 = 'create-space/connector-oauth';
const $d4b865e8cc459c1f$export$f1880ca93d7d075e = 'create-space/connector-files';
const $d4b865e8cc459c1f$export$29f408e6654a1d7b = 'create-space/with-connectors';
const $d4b865e8cc459c1f$export$1d45fd96fcd751f5 = 'onboarding/start';
const $d4b865e8cc459c1f$export$4ead33eb5b37dee5 = 'onboarding/follow-spaces';
const $d4b865e8cc459c1f$export$59c55b717acdcf15 = 'onboarding/auto-follow-spaces';
const $d4b865e8cc459c1f$export$a09834a747086083 = 'onboarding/shared-link-spotlight';
const $d4b865e8cc459c1f$export$749c4d9c23381805 = 'onboarding/nudge';
const $d4b865e8cc459c1f$export$1aaba3dd5fd71b43 = 'onboarding-account-setup-modal';
const $d4b865e8cc459c1f$export$7989a920a6248647 = 'onboarding-jsw-xflow/admin-switcher-tour';
const $d4b865e8cc459c1f$export$55172161173a2d6e = 'onboarding-jsw-xflow/nth-switcher-tour';
const $d4b865e8cc459c1f$export$aaf55a29d2f12a6e = 'onboarding-jsw-xflow/invite-teammate-task';
const $d4b865e8cc459c1f$export$e40755126e0d0b54 = 'onboarding-editor/draft-banner';
const $d4b865e8cc459c1f$export$32b7ff7de164c7ad = 'onboarding-editor/land-in-editor-banner';
const $d4b865e8cc459c1f$export$d04515c6314fec11 = 'onboarding-editor/publish-modal-prompt';
const $d4b865e8cc459c1f$export$8425321c06a7c373 = 'onboarding-editor/publish-success-flag';
const $d4b865e8cc459c1f$export$f3de65caafc09b21 = 'onboarding-editor/recent-draft-spotlight';
const $d4b865e8cc459c1f$export$25e1b00b32cd992d = 'onboarding/query/labels';
const $d4b865e8cc459c1f$export$8125e64b190d01e2 = 'onboarding/storage-enforcement-banner';
const $d4b865e8cc459c1f$export$343afc350dc963df = 'onboarding/storage-enforcement-banner/dismiss';
const $d4b865e8cc459c1f$export$9491541521237449 = 'onboarding/storage-enforcement-flags';
const $d4b865e8cc459c1f$export$616864953f0d339 = 'onboarding/storage-enforcement/block-create-modal';
const $d4b865e8cc459c1f$export$61418bee30087820 = 'onboarding/home/templates-collection';
const $d4b865e8cc459c1f$export$70cb2a8c47e6afd8 = 'onboarding/home/templates-collection/create-template';
const $d4b865e8cc459c1f$export$c03570fb82968b7e = 'onboarding/nth-user-setup-modal';
const $d4b865e8cc459c1f$export$3971f3f0bdcc083 = 'onboarding/onboarding-surface-import/global-import/create-page';
const $d4b865e8cc459c1f$export$3edd3fbbb3bde42a = 'onboarding/nth-user-confluence-home-onboarding-takeover';
const $d4b865e8cc459c1f$export$be5f66bc85ac48a2 = 'onboarding/confluence-personalized-templates-v2';
const $d4b865e8cc459c1f$export$4ef813fe853a14e1 = 'onboarding/nth-user-home-onboarding-revamp';
const $d4b865e8cc459c1f$export$6c1417b243659f4b = 'attachment-action-apps/forge';
const $d4b865e8cc459c1f$export$241c40e7f0f7d7b2 = 'content-action-apps/forge';
const $d4b865e8cc459c1f$export$404655cfa9ecfbc3 = 'byline-apps/forge';
const $d4b865e8cc459c1f$export$224bdd20537c043c = 'context-menu-apps/forge';
const $d4b865e8cc459c1f$export$fe9e3a7216162400 = 'settings-page-apps/forge';
const $d4b865e8cc459c1f$export$16a139fd3cad706d = 'custom-content-apps/forge';
const $d4b865e8cc459c1f$export$a333c0535291436a = 'space-page-apps/forge';
const $d4b865e8cc459c1f$export$4e660f0eec1b7b63 = 'space-settings/integrations/forge';
const $d4b865e8cc459c1f$export$42fe8757b12b9abb = 'space-settings-v2/integrations/forge';
const $d4b865e8cc459c1f$export$e4e961f07f20b1e9 = 'space-settings-v2/landing-page';
const $d4b865e8cc459c1f$export$30670c5b5576bc9d = 'global-page-apps/forge';
const $d4b865e8cc459c1f$export$de2b763dff9c90e = 'full-page-apps/forge';
const $d4b865e8cc459c1f$export$7fee035e8993093b = 'background-script-apps/forge';
const $d4b865e8cc459c1f$export$9e5ae7aaba94272 = 'forge/attachment-action-discovery';
const $d4b865e8cc459c1f$export$456e380b2b695016 = 'forge/attachment-action/metadata-popup';
const $d4b865e8cc459c1f$export$8ec6cc2d3ec2962e = 'forge-ui-extensions';
const $d4b865e8cc459c1f$export$d773e3323beb4d91 = 'site-permission/space-access';
const $d4b865e8cc459c1f$export$1fdf87b44bf66203 = 'space-pages';
const $d4b865e8cc459c1f$export$eab5c9963f80520c = 'space-pages/filter';
const $d4b865e8cc459c1f$export$6af7d14b23c7ed20 = 'space-pages/paginate';
const $d4b865e8cc459c1f$export$1ae7d5b32e27dd1b = 'space-views/initial';
const $d4b865e8cc459c1f$export$92e7a42b4d134675 = 'space-views/change';
const $d4b865e8cc459c1f$export$cd0c9383cd80d210 = 'space-views/paginate';
const $d4b865e8cc459c1f$export$90dff6c3d9facebb = 'space-views/hover-page-card';
const $d4b865e8cc459c1f$export$8a00f2824cff2c5e = 'site-permissions/space-access/remove';
const $d4b865e8cc459c1f$export$30e6c2e5c854e3d7 = 'site-permissions/space-access/add';
const $d4b865e8cc459c1f$export$b07723d1eb2313ad = 'site-permissions/space-access/guest/change';
const $d4b865e8cc459c1f$export$2d0e7e1dcf827b7c = 'perf-insights/content-metrics';
const $d4b865e8cc459c1f$export$367e3821dc11654d = 'perf-insights/content-metrics/content-table';
const $d4b865e8cc459c1f$export$bdcb6d2b5ae0cd2c = 'perf-insights/content-metrics/overall-content-performance-panel';
const $d4b865e8cc459c1f$export$a013a7a56371a528 = 'perf-insights/load-times';
const $d4b865e8cc459c1f$export$20eb30e628617357 = 'perf-insights/load-times/percentile-trend-chart';
const $d4b865e8cc459c1f$export$2f67a1a2f9550730 = 'perf-insights/load-times/performance-bands-chart';
const $d4b865e8cc459c1f$export$1b1a6d53f6f7d616 = 'perf-insights/overview';
const $d4b865e8cc459c1f$export$d8ccdde606e4c64c = 'perf-insights/overview/content-performance-card';
const $d4b865e8cc459c1f$export$9aa8bbd196cfb15c = 'perf-insights/overview/load-times-card';
const $d4b865e8cc459c1f$export$6cc05649dbdb9942 = 'perf-insights/overview/user-setup-card';
const $d4b865e8cc459c1f$export$8853ec0a6d10cb89 = 'perf-insights/user-setup';
const $d4b865e8cc459c1f$export$d78ae2a61699f613 = 'perf-insights/user-setup/cpu-core-count-page';
const $d4b865e8cc459c1f$export$be6879e3f9752a36 = 'perf-insights/user-setup/network-protocol-page';
const $d4b865e8cc459c1f$export$3723423634ed476f = 'perf-insights/user-setup/network-speed-page';
const $d4b865e8cc459c1f$export$d10db7acd38bb286 = 'perf-insights/user-setup/operating-system-page';
const $d4b865e8cc459c1f$export$94d2e4338cb54b2c = 'insights/page-byline';
const $d4b865e8cc459c1f$export$27bffcf643f6c238 = 'insights/page-dialog';
const $d4b865e8cc459c1f$export$460c09ff51f88f24 = 'insights/page-dialog-upsell';
const $d4b865e8cc459c1f$export$371cd738ccd37b38 = 'insights/page-analytics';
const $d4b865e8cc459c1f$export$3861bdd55a91a4a0 = 'insights/page-analytics/view-chart';
const $d4b865e8cc459c1f$export$968182ed9835d21a = 'insights/page-analytics/total-views-card';
const $d4b865e8cc459c1f$export$24ed3cf43f154734 = 'insights/page-analytics/unique-viewers-card';
const $d4b865e8cc459c1f$export$a531b5e2ff0b9747 = 'insights/page-analytics/mentioned-users-card';
const $d4b865e8cc459c1f$export$27ccd506e08e0e = 'insights/page-analytics/viewers-table';
const $d4b865e8cc459c1f$export$ec84fc419c424bb5 = 'insights/page-analytics/mentioned-users-reminder';
const $d4b865e8cc459c1f$export$8ddcb6f0d9ebf30e = 'insights/page-analytics/mentioned-users-table';
const $d4b865e8cc459c1f$export$f8f3f70f34becef9 = 'insights/page-analytics/links-inbound-total-clicks-card';
const $d4b865e8cc459c1f$export$3d388f0f7fc44c3f = 'insights/page-analytics/links-inbound-ctr-card';
const $d4b865e8cc459c1f$export$310d1207c2b3ca7d = 'insights/page-analytics/links-inbound-table';
const $d4b865e8cc459c1f$export$ab6abc47e6a1b436 = 'insights/page-analytics/links-outbound-total-clicks-card';
const $d4b865e8cc459c1f$export$a1934b3cd762057c = 'insights/page-analytics/links-outbound-ctr-card';
const $d4b865e8cc459c1f$export$11b4f841e984d2a8 = 'insights/page-analytics/links-outbound-table';
const $d4b865e8cc459c1f$export$5478a6cbf2100291 = 'insights/space-analytics';
const $d4b865e8cc459c1f$export$12f42654844570d0 = 'insights/space-analytics/overview-chart';
const $d4b865e8cc459c1f$export$40a98279383e549e = 'insights/space-analytics/popular-content-card';
const $d4b865e8cc459c1f$export$b7a620563c5783cd = 'insights/space-analytics/active-agents-card';
const $d4b865e8cc459c1f$export$340eeaf9226a3e00 = 'insights/space-analytics/active-readers-card';
const $d4b865e8cc459c1f$export$327f825878dc4802 = 'insights/space-analytics/active-contributors-card';
const $d4b865e8cc459c1f$export$9595ac2edfb0edec = 'insights/space-analytics/content-activity-table';
const $d4b865e8cc459c1f$export$bfbd1b5517d327f6 = 'insights/space-analytics/user-activity-table';
const $d4b865e8cc459c1f$export$ae73006a481ab5bc = 'insights/space-analytics/async-export';
const $d4b865e8cc459c1f$export$e27cd103e9670e33 = 'insights/space-analytics/permissions/load';
const $d4b865e8cc459c1f$export$5a507008b468c991 = 'insights/space-analytics/permissions/update';
const $d4b865e8cc459c1f$export$8ed4273d919d1070 = 'insights/site-analytics';
const $d4b865e8cc459c1f$export$f2d660eb8a9ba56e = 'insights/site-analytics/overview-chart';
const $d4b865e8cc459c1f$export$8e5ed6a75264c549 = 'insights/site-analytics/popular-spaces-card';
const $d4b865e8cc459c1f$export$7cc392d1f03d59f9 = 'insights/site-analytics/active-readers-card';
const $d4b865e8cc459c1f$export$e5b5e8161ac66e90 = 'insights/site-analytics/popular-searches-card';
const $d4b865e8cc459c1f$export$221bc81bca00257 = 'insights/site-analytics/spaces-table';
const $d4b865e8cc459c1f$export$31b3362136d95230 = 'insights/site-analytics/users-table';
const $d4b865e8cc459c1f$export$86dcda8aa2b50b8a = 'insights/site-analytics/search-table';
const $d4b865e8cc459c1f$export$91ffba1860245927 = 'insights/site-analytics/search-panel';
const $d4b865e8cc459c1f$export$1b7a393d48199f1c = 'insights/site-analytics/search-panel/graph';
const $d4b865e8cc459c1f$export$4020b74c723b4607 = 'insights/site-analytics/search-panel/content-list';
const $d4b865e8cc459c1f$export$343c48c7798baab8 = 'insights/site-analytics/search-panel/spaces-list';
const $d4b865e8cc459c1f$export$58ad08103bb62c4b = 'insights/site-analytics/permissions/load';
const $d4b865e8cc459c1f$export$f73b370055c8cbef = 'insights/site-analytics/permissions/update';
const $d4b865e8cc459c1f$export$5d12872cd9595692 = 'bulk-space-permissions';
const $d4b865e8cc459c1f$export$ee395498ea9fc566 = 'global-perms';
const $d4b865e8cc459c1f$export$bbc6348b8482e5b1 = 'expand-group';
const $d4b865e8cc459c1f$export$f96f0a60f840676c = 'group-members-load-more';
const $d4b865e8cc459c1f$export$257aa31d09a106e = 'team-admin-controls';
const $d4b865e8cc459c1f$export$4b1f94680c79a72 = 'team-admin-controls/update';
const $d4b865e8cc459c1f$export$7b06f43e66d37bd9 = 'view-space-guest-list';
const $d4b865e8cc459c1f$export$b3639316349424 = 'team-calendar';
const $d4b865e8cc459c1f$export$b731d5eab77f5ae2 = 'team-calendar-upsell';
const $d4b865e8cc459c1f$export$6e2e950545a96fb5 = 'team-calendars/calendar/add';
const $d4b865e8cc459c1f$export$e60dce5b561d6551 = 'team-calendars/calendar/add-existing';
const $d4b865e8cc459c1f$export$25067b28cdd34cc6 = 'team-calendars/calendar/delete';
const $d4b865e8cc459c1f$export$19d86a52695ae312 = 'team-calendars/calendar/remove';
const $d4b865e8cc459c1f$export$120ce8feec0488aa = 'team-calendars/calendar/subscribe';
const $d4b865e8cc459c1f$export$dc96bc0456e09d60 = 'team-calendars/calendar/update';
const $d4b865e8cc459c1f$export$d23cc4800e46d1e6 = 'team-calendars/calendar/import';
const $d4b865e8cc459c1f$export$13b2254026213b46 = 'team-calendars/event-type/add';
const $d4b865e8cc459c1f$export$c348a46d97587ee4 = 'team-calendars/event-type/delete';
const $d4b865e8cc459c1f$export$bfd3172de881908e = 'team-calendars/event-type/update';
const $d4b865e8cc459c1f$export$e1a32de918001908 = 'team-calendars/event/add';
const $d4b865e8cc459c1f$export$36abe825d06f7b68 = 'team-calendars/event/jira-calendar';
const $d4b865e8cc459c1f$export$1be22ae521e809a9 = 'team-calendars/event/update';
const $d4b865e8cc459c1f$export$eb40d48a494923c8 = 'team-calendars/event/delete';
const $d4b865e8cc459c1f$export$66104f246f979de9 = 'team-calendars/restrictions/update';
const $d4b865e8cc459c1f$export$a245b5e8e50aca4e = 'edit-space-logo/restore';
const $d4b865e8cc459c1f$export$38c64d0e786460e8 = 'edit-space-logo/save';
const $d4b865e8cc459c1f$export$53b6eab7c794efdf = 'edit-space-logo/details-load';
const $d4b865e8cc459c1f$export$d4e50447c54e832a = 'cover-picture/unsplash-upload';
const $d4b865e8cc459c1f$export$3b296e5e8d4fbd72 = 'cover-picture/media-upload';
const $d4b865e8cc459c1f$export$75c73b1e1363abb2 = 'cover-picture/remove';
const $d4b865e8cc459c1f$export$56b59e3252d65c77 = 'view-app-suggestions';
const $d4b865e8cc459c1f$export$61ad3866e7413864 = 'conditional_publish_dialog';
const $d4b865e8cc459c1f$export$5685c80727d12c34 = 'extension_point_byline';
const $d4b865e8cc459c1f$export$4b9cf95d297cf82f = 'extension_point_space_buttons';
const $d4b865e8cc459c1f$export$811ef7c3a5f94996 = 'extension_point_home_footer';
const $d4b865e8cc459c1f$export$dfab08323861cbc1 = 'extension_point_home_header';
const $d4b865e8cc459c1f$export$aa9a33eaf0b3cefa = 'extension_point_editor_savebar';
const $d4b865e8cc459c1f$export$4933a09c775176cb = 'extension_point_page_metadata_banner';
const $d4b865e8cc459c1f$export$645909341bfebc9b = 'extension_point_page_banner';
const $d4b865e8cc459c1f$export$facf18b53398c3d7 = 'extension_point_space_settings_tabs';
const $d4b865e8cc459c1f$export$23be08d2ca73ecf = 'core-invites';
const $d4b865e8cc459c1f$export$b1dd9d960d4ea959 = 'custom-content-page-all';
const $d4b865e8cc459c1f$export$38660dec2eb2a695 = 'custom-content-space-list-view';
const $d4b865e8cc459c1f$export$7b1fe4d076a9542a = 'custom-content-page-list-view';
const $d4b865e8cc459c1f$export$ad06e79f63068f5e = 'custom-content-view';
const $d4b865e8cc459c1f$export$eef674482902ef6d = 'connections-panel-view';
const $d4b865e8cc459c1f$export$c5bcbbcb1df627e5 = 'end-of-page-recommendations';
const $d4b865e8cc459c1f$export$3b683344868f9f0a = 'notify-on-first-view';
const $d4b865e8cc459c1f$export$4fdd9934209dba0e = 'presenter-mode/view';
const $d4b865e8cc459c1f$export$40638d9b45e8ceca = 'presenter-mode/full-screen-api';
const $d4b865e8cc459c1f$export$b1f7a84b45eb9afb = 'view-public-link-site-settings';
const $d4b865e8cc459c1f$export$8294c237289049c4 = 'view-public-link-spaces-table';
const $d4b865e8cc459c1f$export$ec6e09c5fd9fa221 = 'view-public-links-page-table';
const $d4b865e8cc459c1f$export$5cc7e9470bfae723 = 'public-links-spaces-table-action';
const $d4b865e8cc459c1f$export$c102a9d514fc95ac = 'public-link-site-toggle-change';
const $d4b865e8cc459c1f$export$ff2fb656c8231637 = 'view-public-links-space-settings';
const $d4b865e8cc459c1f$export$ba803d464f49a265 = 'public-links-space-toggle-change';
const $d4b865e8cc459c1f$export$d95bcf023bd8993 = 'view-public-links-default-space-settings';
const $d4b865e8cc459c1f$export$7362876707c57af9 = 'public-links-default-space-toggle-change';
const $d4b865e8cc459c1f$export$c7ff49e7eaa45ff1 = 'view-public-link-shared-page';
const $d4b865e8cc459c1f$export$b1718899801763d9 = 'view-access-link-shared-page';
const $d4b865e8cc459c1f$export$24cbec84f278c600 = 'public-link-rendered';
const $d4b865e8cc459c1f$export$5b89a66b04cea206 = 'public-link-toggle-change';
const $d4b865e8cc459c1f$export$44b7602dc9689e08 = 'public-link-disable-from-restrictions';
const $d4b865e8cc459c1f$export$eed7907041fecd69 = 'public-link-page-table-action';
const $d4b865e8cc459c1f$export$49a01ffc1a18656b = 'external-share';
const $d4b865e8cc459c1f$export$71c211e9eb26da62 = 'access-link';
const $d4b865e8cc459c1f$export$e25df1f458506fcd = 'copy-content-link';
const $d4b865e8cc459c1f$export$7c34e8285a2b9238 = 'content-history';
const $d4b865e8cc459c1f$export$d0af9d147d5db5e0 = 'attachments-page';
const $d4b865e8cc459c1f$export$b9b41dfe39f06772 = 'view-tasks';
const $d4b865e8cc459c1f$export$6be3453279e7dd85 = 'set-task-complete';
const $d4b865e8cc459c1f$export$80a3b142ba868b57 = 'change-page-owner';
const $d4b865e8cc459c1f$export$19875313f499fad9 = 'content-ownership/dialog';
const $d4b865e8cc459c1f$export$6f36502851eaa4cb = 'audit-log/load';
const $d4b865e8cc459c1f$export$e94c6163c32592ce = 'admin-announcement-banner';
const $d4b865e8cc459c1f$export$7653dfd9fd5557b = 'admin-announcement-banner-dismissed';
const $d4b865e8cc459c1f$export$394294e59b36efb9 = 'admin-announcement-banner-settings';
const $d4b865e8cc459c1f$export$8f017785cc4bb995 = 'admin-announcement-banner-publish';
const $d4b865e8cc459c1f$export$a4d890726485d79a = 'admin-announcement-banner-turn-off';
const $d4b865e8cc459c1f$export$47d510c88b13ea8d = 'admin-announcement-banner-table';
const $d4b865e8cc459c1f$export$548adb1a2fe6e6b1 = 'space-manager';
const $d4b865e8cc459c1f$export$35f739fc0b127205 = 'space-manager-quick-action-item';
const $d4b865e8cc459c1f$export$bfe6ff6cddeed6e3 = 'importer-dashboard';
const $d4b865e8cc459c1f$export$2decaadcf840e6b3 = 'company-hub-general-settings';
const $d4b865e8cc459c1f$export$23b4a008c670d304 = 'company-hub-general-settings-your-hub';
const $d4b865e8cc459c1f$export$c6198e9d6ab9e417 = 'company-hub-general-settings-your-hub-actions';
const $d4b865e8cc459c1f$export$e1b506612f6e9657 = 'company-hub-general-settings-recent-activity';
const $d4b865e8cc459c1f$export$dfdc3f1142f40689 = 'company-hub-general-settings-hub-views';
const $d4b865e8cc459c1f$export$e9845af7b7fd8501 = 'company-hub-general-settings-most-clicks';
const $d4b865e8cc459c1f$export$237a7d3a8e219dbb = 'admin-center';
const $d4b865e8cc459c1f$export$b7b3a9d4d05ffd12 = 'admin-center-confluence-admins';
const $d4b865e8cc459c1f$export$367f60a3ad6918c1 = 'admin-center-search-count';
const $d4b865e8cc459c1f$export$9a8113803e6447cf = 'admin-center-search-ctr';
const $d4b865e8cc459c1f$export$8f37d7eb1e6f681d = 'admin-center-top-searches';
const $d4b865e8cc459c1f$export$2ad5d40786f81da0 = 'admin-center-top-unsuccessful-searches';
const $d4b865e8cc459c1f$export$e68566fb281dbb33 = 'admin-center-external-access';
const $d4b865e8cc459c1f$export$a7f1ee469fd8596c = 'admin-center-beta-features';
const $d4b865e8cc459c1f$export$8a3b06f53918d80e = 'admin-center-total-spaces';
const $d4b865e8cc459c1f$export$d4f2672a4a997be2 = 'admin-center-total-content';
const $d4b865e8cc459c1f$export$61440d1f5d765856 = 'admin-center-grouped-summary-section';
const $d4b865e8cc459c1f$export$a122d82c3b13ba99 = 'admin-center-inactive-pages';
const $d4b865e8cc459c1f$export$bf035e1987052c42 = 'admin-center-top-inactive-pages';
const $d4b865e8cc459c1f$export$1613edca53571ea3 = 'admin-center-deactivated-owner-pages';
const $d4b865e8cc459c1f$export$4ba2b40dc30760f9 = 'admin-center-top-deactivated-owner-pages';
const $d4b865e8cc459c1f$export$5d6b6234c4e9f70d = 'admin-center-content-created';
const $d4b865e8cc459c1f$export$39552d32ae5efc36 = 'admin-center-content-updated';
const $d4b865e8cc459c1f$export$a4934c826482e207 = 'admin-center-content-views';
const $d4b865e8cc459c1f$export$4c0549ea0cf0f43d = 'admin-center-top-content-views';
const $d4b865e8cc459c1f$export$6b8c8a94a6fb0b10 = 'admin-center-grouped-summary-section-v2-update';
const $d4b865e8cc459c1f$export$a4855248cbcdc638 = 'admin-center-grouped-summary-section-v2';
const $d4b865e8cc459c1f$export$f1c6b44ad858e24f = 'admin-center-search-count-summary';
const $d4b865e8cc459c1f$export$aaba8c517b5b0014 = 'admin-center-search-ctr-summary';
const $d4b865e8cc459c1f$export$3463471aa64d2a20 = 'admin-center-total-spaces-summary';
const $d4b865e8cc459c1f$export$aed49d47c6d277d2 = 'admin-center-total-content-summary';
const $d4b865e8cc459c1f$export$c89944dc251c7694 = 'admin-center-inactive-pages-num-summary';
const $d4b865e8cc459c1f$export$45d06e7b1bc06ed4 = 'admin-center-inactive-pages-percent-summary';
const $d4b865e8cc459c1f$export$50744fb70a2982a2 = 'admin-center-deactivated-owner-pages-num-summary';
const $d4b865e8cc459c1f$export$35f523c785c60e15 = 'admin-center-deactivated-owner-pages-percent-summary';
const $d4b865e8cc459c1f$export$d4f40a3c80d7fa00 = 'admin-center-content-created-summary';
const $d4b865e8cc459c1f$export$3e98f2df16d1f652 = 'admin-center-content-updated-summary';
const $d4b865e8cc459c1f$export$512d403dd28c8f13 = 'admin-center-content-views-summary';
const $d4b865e8cc459c1f$export$b5db801ede6fe9e5 = 'admin-center-public-link-views-summary';
const $d4b865e8cc459c1f$export$2df6bcfd56d7c9e8 = 'admin-center-public-links-summary';
const $d4b865e8cc459c1f$export$6c98543cf0a07a9f = 'admin-center-suggestions';
const $d4b865e8cc459c1f$export$9f5be3c30e870f46 = 'admin-center-suggestions-unassigned-guest';
const $d4b865e8cc459c1f$export$56c7132579558fc8 = 'admin-center-suggestions-inactive-pages';
const $d4b865e8cc459c1f$export$4bc17e6067981b1f = 'admin-center-suggestions-deactivated-owner-pages';
const $d4b865e8cc459c1f$export$2f62829f51afa45a = 'admin-center-suggestions-space-manager';
const $d4b865e8cc459c1f$export$19020e617b152304 = 'admin-center-suggestions-user-access';
const $d4b865e8cc459c1f$export$8a50a36bc65b8673 = 'suggest-skill-based-on-page-title';
const $d4b865e8cc459c1f$export$12a435102ccb624a = 'admin-center-suggestions-quick-action-item';
const $d4b865e8cc459c1f$export$dec2cee4628ab9c4 = 'admin-center-suggestions-metric-cta';
const $d4b865e8cc459c1f$export$88a8c07833ef47b1 = 'space-admin-center';
const $d4b865e8cc459c1f$export$fb0bb005ed2de56c = 'space-admin-center-grouped-summary-section';
const $d4b865e8cc459c1f$export$73c5a862f5073e46 = 'space-admin-center-external-access';
const $d4b865e8cc459c1f$export$4d72041a86e9e003 = 'space-admin-center-space-admins';
const $d4b865e8cc459c1f$export$724928cbf61f8819 = 'space-admin-center-content-views';
const $d4b865e8cc459c1f$export$eee5f90734589227 = 'space-admin-center-top-content-views';
const $d4b865e8cc459c1f$export$a5e95165e3a702d1 = 'space-admin-center-content-created';
const $d4b865e8cc459c1f$export$32dde1d12c499528 = 'space-admin-center-content-updated';
const $d4b865e8cc459c1f$export$147226654b32f956 = 'space-admin-center-total-content';
const $d4b865e8cc459c1f$export$648d00fafa66ae14 = 'space-admin-center-inactive-pages';
const $d4b865e8cc459c1f$export$a3fdce9bb003f0b8 = 'space-admin-center-top-inactive-pages';
const $d4b865e8cc459c1f$export$71daddda71b57298 = 'space-admin-center-deactivated-owner-pages';
const $d4b865e8cc459c1f$export$62d9e5dacf2e073d = 'space-admin-center-top-deactivated-owner-pages';
const $d4b865e8cc459c1f$export$8c3b600f7a5dce0f = 'dwell-time/start';
const $d4b865e8cc459c1f$export$b0fe8424f6f27f51 = 'trial-components/lozenge-view';
const $d4b865e8cc459c1f$export$40c0cee2cad141c5 = 'trial-components/flag-view';
const $d4b865e8cc459c1f$export$d6bad6d87d8c028f = 'trial-components/premium-insights-action-menu-item-view';
const $d4b865e8cc459c1f$export$d0e7688ec900110c = 'team-presence/avatar-group-view';
const $d4b865e8cc459c1f$export$655feba7d95d5b26 = 'team-presence/click-to-find';
const $d4b865e8cc459c1f$export$a3748c7e642ec857 = 'flywheel-feature-discovery';
const $d4b865e8cc459c1f$export$f8372d329c2aeea0 = 'quick-summary';
const $d4b865e8cc459c1f$export$31e4e6e2658a6cae = 'quick-summary-whiteboards';
const $d4b865e8cc459c1f$export$4a493e4dc06e57e7 = 'quick-summary-to-page';
const $d4b865e8cc459c1f$export$5565b0bba4d72eee = 'comments-summary';
const $d4b865e8cc459c1f$export$c17159824be2dcc1 = 'comments-panel-summary';
const $d4b865e8cc459c1f$export$8d9dfd2f17501337 = 'ai-content-catchup';
const $d4b865e8cc459c1f$export$bb8fdee2f545676e = 'ai-snippet';
const $d4b865e8cc459c1f$export$c114a6d7848b93cb = 'ai-bulk-issue-create';
const $d4b865e8cc459c1f$export$a48ee5f2c131dea3 = 'ai-audio';
const $d4b865e8cc459c1f$export$f9a8f9ac1a851fe7 = 'ai-audio-briefing';
const $d4b865e8cc459c1f$export$6086ea87dfcad89d = 'ai-audio-narration';
const $d4b865e8cc459c1f$export$daafa0ab79e187e5 = 'ai-title-generation';
const $d4b865e8cc459c1f$export$8091bb21bb2521cb = 'ai-header-image-generation';
const $d4b865e8cc459c1f$export$530e334566c01c65 = 'plan-comparison-modal';
const $d4b865e8cc459c1f$export$af3f8586c2e30e0 = 'pendo-installation';
const $d4b865e8cc459c1f$export$7f32d11b06ee25ff = 'reading-aids';
const $d4b865e8cc459c1f$export$38e6a52d8f0a641f = 'ai-definitions-autohighlight';
const $d4b865e8cc459c1f$export$9bd965a890617f5b = 'view-guest-request-to-upgrade';
const $d4b865e8cc459c1f$export$85b1366ed05e7209 = 'submit-guest-request-to-upgrade';
const $d4b865e8cc459c1f$export$7ca653e6d1fa2509 = 'view-guest-request-to-upgrade-side-nav';
const $d4b865e8cc459c1f$export$30addda68c1793d0 = 'submit-guest-request-to-upgrade-side-nav';
const $d4b865e8cc459c1f$export$aace851408b6de3e = 'submit-guest-mentions-upgrade-flow';
const $d4b865e8cc459c1f$export$611140537004e76c = 'view-guest-spaces-menu-request-to-upgrade';
const $d4b865e8cc459c1f$export$e73147035caab2f2 = 'submit-guest-spaces-menu-request-to-upgrade';
const $d4b865e8cc459c1f$export$11311af26ac8cb8b = 'restore-space';
const $d4b865e8cc459c1f$export$dec29f1de3a4a5ce = 'hard-delete-space';
const $d4b865e8cc459c1f$export$e69556d68987dda1 = 'view-space-permissions';
const $d4b865e8cc459c1f$export$a5bcda9ae1f6839a = 'edit-space-permissions';
const $d4b865e8cc459c1f$export$22c9153bc8c871f3 = 'view-app-custom-content-permissions';
const $d4b865e8cc459c1f$export$32f7f39f260e234c = 'edit-app-custom-content-permissions';
const $d4b865e8cc459c1f$export$c39bf2cb4e8cc70c = 'view-jsm-banner';
const $d4b865e8cc459c1f$export$4e373788dac39943 = 'disable-jsm-permissions';
const $d4b865e8cc459c1f$export$f7308c84ae7be9c8 = 'view-default-space-permissions';
const $d4b865e8cc459c1f$export$85cd19170159a085 = 'edit-default-space-permissions';
const $d4b865e8cc459c1f$export$3cfa8e4552e9e6ce = 'view-all-spaces-tab';
const $d4b865e8cc459c1f$export$c9f8ebbba8f73eeb = 'company-home-builder-load';
const $d4b865e8cc459c1f$export$d4d3fc5b22a2a5d2 = 'company-home-builder-edit';
const $d4b865e8cc459c1f$export$cc438f9a49eb57aa = 'company-home-builder-edit/upload';
const $d4b865e8cc459c1f$export$90e15cc4582adffa = 'company-hub-creation';
const $d4b865e8cc459c1f$export$9458ecd4beb6dc6b = 'company-hub-change-hub-name';
const $d4b865e8cc459c1f$export$7f2689ec25c432a4 = 'front-cover-load'; // TODO: rename this to COMPANY_HUB_LOAD_EXPERIENCE
const $d4b865e8cc459c1f$export$c8ff6311a26d2c8c = 'company-hub-unpublish-hub';
const $d4b865e8cc459c1f$export$f5a5045f5872d850 = 'company-hub-analytics';
const $d4b865e8cc459c1f$export$2c2b8afe13693d2b = 'company-hub-analytics-box-row';
const $d4b865e8cc459c1f$export$db8c2f7bf58fe015 = 'company-hub-analytics-chart';
const $d4b865e8cc459c1f$export$b0852f88603c392f = 'company-hub-analytics-table';
const $d4b865e8cc459c1f$export$c5e974e322d233b1 = 'company-hub-card-ai-description';
const $d4b865e8cc459c1f$export$c6d05c48b9430e3c = 'company-hub-editor';
const $d4b865e8cc459c1f$export$35975591aeab4dd6 = 'company-hub-editor/load';
const $d4b865e8cc459c1f$export$7a3dfdccebea9c7b = 'company-hub-editor/close';
const $d4b865e8cc459c1f$export$eef6122c9774ba1c = 'front-cover-publish'; // TODO: rename this to COMPANY_HUB_PUBLISH_EXPERIENCE
const $d4b865e8cc459c1f$export$b414a79d615eda80 = 'end-of-trial-modal';
const $d4b865e8cc459c1f$export$393f60effc43223a = 'end-of-trial-modal/number-of-users';
const $d4b865e8cc459c1f$export$85f2b0ac7d403e39 = 'end-of-trial-modal/guest-access';
const $d4b865e8cc459c1f$export$d28aabd131a0c82d = 'end-of-trial-modal/page-insights';
const $d4b865e8cc459c1f$export$a3809cd1b0c7c1f9 = 'end-of-trial-modal/page-restrictions';
const $d4b865e8cc459c1f$export$82fbc9c9caa0525b = 'end-of-trial-modal/osb-link';
const $d4b865e8cc459c1f$export$651b4e780cbf5647 = 'cards-image-upload';
const $d4b865e8cc459c1f$export$3e70adb2ef2d5f7a = 'admin-team-calendars-load';
const $d4b865e8cc459c1f$export$18051474a34eda87 = 'admin-team-calendars-update';
const $d4b865e8cc459c1f$export$7e4c7c98306e835d = 'standard-differentiators-onboarding';
const $d4b865e8cc459c1f$export$1230cc550a8fe90f = 'standard-differentiators-help';
const $d4b865e8cc459c1f$export$dc2f45d36e47ca3a = 'admin-general-configuration-load';
const $d4b865e8cc459c1f$export$b27bac0c0dea2a55 = 'admin-general-configuration-update';
const $d4b865e8cc459c1f$export$a3c4dc4a199ee1b8 = 'admin-general-configuration-update/favicon-upload';
const $d4b865e8cc459c1f$export$d32cd699d9dbf985 = 'notifications-site-settings-load';
const $d4b865e8cc459c1f$export$6fd7ab2f1e137193 = 'notifications-site-settings-update';
const $d4b865e8cc459c1f$export$7875e1f75aa15306 = 'admin-configure-code-macro-load';
const $d4b865e8cc459c1f$export$164e825247db8d43 = 'admin-configure-code-macro-update';
const $d4b865e8cc459c1f$export$c390f9e07c545581 = 'admin-default-space-logo-config-load';
const $d4b865e8cc459c1f$export$4090d6a71e5b3ead = 'admin-default-space-logo-config-media-service-load';
const $d4b865e8cc459c1f$export$a1986920605a1163 = 'admin-default-space-logo-config-update';
const $d4b865e8cc459c1f$export$313ad6157a5a0ea9 = 'admin-header-and-footer-load';
const $d4b865e8cc459c1f$export$dd6c028654f91f02 = 'admin-header-and-footer-update';
const $d4b865e8cc459c1f$export$bb009baa1a9cbcf0 = 'space-settings-admin-page-layout-load';
const $d4b865e8cc459c1f$export$6d0fbdff5b6fa174 = 'space-settings-admin-page-layout-update';
const $d4b865e8cc459c1f$export$8abd8604ca7982c7 = 'admin-security-configuration-load';
const $d4b865e8cc459c1f$export$21855cac8c6f3d91 = 'admin-security-configuration-update';
const $d4b865e8cc459c1f$export$faa6a1cbc50fd4a5 = 'admin-templates-and-blueprints-load';
const $d4b865e8cc459c1f$export$9cfd44509d36312b = 'admin-templates-and-blueprints-load/page-templates';
const $d4b865e8cc459c1f$export$fb29220c46f6993 = 'admin-templates-and-blueprints-load/page-blueprints';
const $d4b865e8cc459c1f$export$90402aae1ab35229 = 'admin-templates-and-blueprints-load/system-templates';
const $d4b865e8cc459c1f$export$8e008c4796774e26 = 'space-settings-admin-templates-and-blueprints-load';
const $d4b865e8cc459c1f$export$bc61a3e94ba2560e = 'admin-import-spaces-configuration-load';
const $d4b865e8cc459c1f$export$936492407dd3e3ab = 'admin-import-spaces-import';
const $d4b865e8cc459c1f$export$99f32e90f59041e7 = 'admin-trashed-spaces-load';
const $d4b865e8cc459c1f$export$1057adadb9206825 = 'admin-trashed-spaces-restore';
const $d4b865e8cc459c1f$export$9f610d573468ea4 = 'admin-trashed-spaces-hard-delete';
const $d4b865e8cc459c1f$export$86fdc512ee3200db = 'admin-color-scheme-load';
const $d4b865e8cc459c1f$export$db764d23341437ca = 'admin-color-scheme-update';
const $d4b865e8cc459c1f$export$4447822883006e0 = 'admin-application-navigator-load';
const $d4b865e8cc459c1f$export$93194ca916026abe = 'admin-application-navigator-update';
const $d4b865e8cc459c1f$export$c226034eea0cb4de = 'admin-application-navigator-add';
const $d4b865e8cc459c1f$export$22f1f1a21c7d0c50 = 'admin-themes-load';
const $d4b865e8cc459c1f$export$12093307e4f8fd56 = 'admin-themes-update';
const $d4b865e8cc459c1f$export$a48b049eb2fcbe71 = 'space-settings-admin-themes-load';
const $d4b865e8cc459c1f$export$5b92dfbf1efa2144 = 'space-settings-admin-themes-update';
const $d4b865e8cc459c1f$export$565897f0a51f5efd = 'admin-jira-macro-repair-load';
const $d4b865e8cc459c1f$export$2292c61864873ec0 = 'admin-jira-macro-repair-update';
const $d4b865e8cc459c1f$export$d8f5df97692e60be = 'admin-pdf-export-load-experience';
const $d4b865e8cc459c1f$export$e2eb28f9e03e0850 = 'admin-pdf-export-update-experience';
const $d4b865e8cc459c1f$export$ab0128b7a160aaed = 'space-settings-admin-pdf-export-load-experience';
const $d4b865e8cc459c1f$export$e65a54ac514355c1 = 'space-settings-admin-pdf-export-update-experience';
const $d4b865e8cc459c1f$export$9e6e2adcf47359af = 'space-settings-admin-pdf-export-load-experience-ncs';
const $d4b865e8cc459c1f$export$9fb76bc73314ca1e = 'space-settings-csv-export-experience';
const $d4b865e8cc459c1f$export$fde5d45e43ea2ca4 = 'export-page-tree-load';
const $d4b865e8cc459c1f$export$b9b428ecdf423548 = 'export-page-export-completed-export-and-download';
const $d4b865e8cc459c1f$export$5fa322173b52c417 = 'pdf-export-page';
const $d4b865e8cc459c1f$export$bda7d7fc953c118f = 'space-settings-legacy-content-report-experience';
const $d4b865e8cc459c1f$export$c08c7422d3e7a141 = 'admin-macro-usage-load';
const $d4b865e8cc459c1f$export$d6369a194e24ad7f = 'watch-dialog-watch';
const $d4b865e8cc459c1f$export$8012a45d3107312e = 'watch-dialog-watch-children';
const $d4b865e8cc459c1f$export$84a690fd513af1de = 'manage-watchers-dialog-unfiltered';
const $d4b865e8cc459c1f$export$7c7b27adbfa0b2a1 = 'auto-upgrade-awareness-modal';
const $d4b865e8cc459c1f$export$6d5416d96215c2a6 = 'space-settings-admin-look-and-feel-experience';
const $d4b865e8cc459c1f$export$ce75b3763db649b5 = 'user-access-update';
const $d4b865e8cc459c1f$export$ae036afd16ed2b49 = 'user-access-space-permissions-report';
const $d4b865e8cc459c1f$export$2361c2310cf691ea = 'convert-page-to-folder';
const $d4b865e8cc459c1f$export$e85b045b69985ed1 = 'share-and-restrict-button-load';
const $d4b865e8cc459c1f$export$4717394ee1c94acc = 'share-and-restrict-dialog-load';
const $d4b865e8cc459c1f$export$15b0dc8b7eaf2460 = 'share-and-restrict-dialog-save-action';
const $d4b865e8cc459c1f$export$d7fbaabd51b7e8aa = 'share-and-restrict-dialog-share-action';
const $d4b865e8cc459c1f$export$99b088ebcc063a46 = 'share-and-restrict-dialog-general-access-update';
const $d4b865e8cc459c1f$export$4a49467bfdab7ac4 = 'share-and-restrict-dialog-restriction-update';
const $d4b865e8cc459c1f$export$a108df63350cf475 = 'share-and-restrict-dialog-resolve-mismatched-restrictions';
const $d4b865e8cc459c1f$export$c2b92a9eeaa63308 = 'access-link/create';
const $d4b865e8cc459c1f$export$43773ebac97d19d = 'access-link/update';
const $d4b865e8cc459c1f$export$2b8a60202c032379 = 'access-link/remove';
const $d4b865e8cc459c1f$export$9bb1bf34ecda77d2 = 'access-link/dialog-load';
const $d4b865e8cc459c1f$export$f17b14a735f6599c = 'access-links/site-settings';
const $d4b865e8cc459c1f$export$3f9eca43f8474ea7 = 'access-links/site-settings/spaces-table-action';
const $d4b865e8cc459c1f$export$680b8ec8cd96ba62 = 'access-links/site-settings/spaces-table-bulk-action';
const $d4b865e8cc459c1f$export$85a9a6288921dd4a = 'access-links/site-settings/configuration';
const $d4b865e8cc459c1f$export$eb4f70c08770ff50 = 'access-links/space-settings';
const $d4b865e8cc459c1f$export$b3535c96679db861 = 'access-links/space-settings/page-table-action';
const $d4b865e8cc459c1f$export$e668b186765ef8be = 'access-links/space-settings/page-table-bulk-action';
const $d4b865e8cc459c1f$export$d4c0e768f2da4420 = 'access-links/space-settings/configuration';
const $d4b865e8cc459c1f$export$62f393504fed6ed = 'flyout-messaging';
const $d4b865e8cc459c1f$export$5409fe2736a41b4e = 'confluence-eot-premium-recommend-standard-buy';
const $d4b865e8cc459c1f$export$b3185617ebec44c9 = 'view-space-role-assignments';
const $d4b865e8cc459c1f$export$2bf4fa4e191abad2 = 'edit-space-role-assignments';
const $d4b865e8cc459c1f$export$a2e8aa26b8f23b29 = 'view-default-space-role-assignments';
const $d4b865e8cc459c1f$export$f615f6649fe944d3 = 'edit-default-space-role-assignments';
const $d4b865e8cc459c1f$export$c355f58335217bcc = 'view-site-roles';
const $d4b865e8cc459c1f$export$ea342babb9acb6bc = 'edit-site-roles';
const $d4b865e8cc459c1f$export$839b7fdc920b413f = 'admin-system-operations';
const $d4b865e8cc459c1f$export$ca1dc95ac860c58e = 'admin-system-operations/set-role';
const $d4b865e8cc459c1f$export$f6c4ac51d51b4d11 = 'space-details-load';
const $d4b865e8cc459c1f$export$e6949233f3fd16fa = 'space-details-update';
const $d4b865e8cc459c1f$export$ac4798c67f4aca63 = 'space-details-space-label-search';
const $d4b865e8cc459c1f$export$13c8bebb873a5fd2 = 'object-header';
const $d4b865e8cc459c1f$export$717078a23de7ce41 = 'sidebar-details-panel-load';
const $d4b865e8cc459c1f$export$8bb2fdea912e6360 = 'sidebar-comments-panel-load';
const $d4b865e8cc459c1f$export$785ec834db7448db = 'sidebar-comments-panel-load-open';
const $d4b865e8cc459c1f$export$9455f903a440f62b = 'sidebar-comments-panel-load-unread';
const $d4b865e8cc459c1f$export$9eb18c236ac889d2 = 'sidebar-comments-panel-load-resolved';
const $d4b865e8cc459c1f$export$e6d0321727a888ba = 'sidebar-comments-panel-load-deleted-content';
const $d4b865e8cc459c1f$export$690919d29c2dc9e2 = 'sidebar-comments-panel-load-mentions-me';
const $d4b865e8cc459c1f$export$89c31c18d20e326d = 'comments-data-background-load';
const $d4b865e8cc459c1f$export$1f5ef81ae9b1b308 = 'import-content';
const $d4b865e8cc459c1f$export$8e0f9138cc943183 = 'import-miro-users';
const $d4b865e8cc459c1f$export$c81d8b61dfed18d = 'mpucup-free-to-standard-fg-modal';
const $d4b865e8cc459c1f$export$bf23e3ec80d510d = 'content-overflow-menu';
const $d4b865e8cc459c1f$export$5167cfad2b30339a = 'mobile-macro-renderer-query';
const $d4b865e8cc459c1f$export$db5f7458e232d5f3 = 'mobile-macro-renderer';
const $d4b865e8cc459c1f$export$d4235a0083f21618 = 'permissions-audit-generation';
const $d4b865e8cc459c1f$export$a992b43898fc066a = 'permissions-audit-generation-view';
const $d4b865e8cc459c1f$export$67fdee74bc56af65 = 'permissions-transition-view';
const $d4b865e8cc459c1f$export$c716fe0a8ee64e7d = 'permissions-transition-edit';
const $d4b865e8cc459c1f$export$62975932929ce7be = 'permissions-transition-update-role-mode';
const $d4b865e8cc459c1f$export$8a6ae5f44edb5b0a = 'content-access-request-decision';
const $d4b865e8cc459c1f$export$b3b0c496911f9f12 = 'comments-pubsub-event';
const $d4b865e8cc459c1f$export$ac4301a7ed3dbe70 = 'connect-iframe-render';
const $d4b865e8cc459c1f$export$3019f5237aa5520 = 'connect-referentiality';
const $d4b865e8cc459c1f$export$9d950945a81efcb3 = 'connect-static-macro-render';
const $d4b865e8cc459c1f$export$b2e38552f83730c7 = 'connect-static-macro-ssr';
const $d4b865e8cc459c1f$export$8d06389ee018f02a = 'marketplace-page-render';
const $d4b865e8cc459c1f$export$86485f83cddf4313 = 'office-macro-render';
const $d4b865e8cc459c1f$export$b62e73df843f514f = 'space-curation/review-suggestions';
const $d4b865e8cc459c1f$export$a37f920bd19d0352 = 'attachments-macro/add-attachment';
const $d4b865e8cc459c1f$export$ddf6b90372540806 = 'attachments-macro/add-attachment/file-picker';
const $d4b865e8cc459c1f$export$741e8c6603a0769f = 'attachments-macro/add-attachment/upload';
const $d4b865e8cc459c1f$export$2531f3f214ad9fbf = 'attachments-page-upload';


class $4b50c1dadb433c8a$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}






const $ebb54c1f7b9c33e4$var$CAUGHT_SESSION_ERROR_TEXT = 'Session expired';
class $ebb54c1f7b9c33e4$export$8220cdf0bd206e05 extends (0, $165abb9eb28d58da$export$12c8b3d0a1a46f87) {
    constructor(message, response){
        super(`${message} ${$ebb54c1f7b9c33e4$var$CAUGHT_SESSION_ERROR_TEXT}`, response);
    }
}
function $ebb54c1f7b9c33e4$export$1bd7f0128d65baef(error) {
    if (!error) return false;
    if (error instanceof $ebb54c1f7b9c33e4$export$8220cdf0bd206e05) return true;
    const errorMessage = error?.message || '';
    if (errorMessage.indexOf($ebb54c1f7b9c33e4$var$CAUGHT_SESSION_ERROR_TEXT) != -1) return true;
    const errorStatusCode = error?.extensions?.statusCode;
    if (errorStatusCode == 401) return true;
    return false;
}
function $ebb54c1f7b9c33e4$export$b8c2308c7b82c3a9(error) {
    if (!error) return false;
    if ($ebb54c1f7b9c33e4$export$1bd7f0128d65baef(error)) return true;
    if ((0, $a73698f3e4fe6cd8$export$17f5e6bd290bb15d)(error)) {
        const { graphQLErrors: graphQLErrors, networkError: networkError } = error;
        if ($ebb54c1f7b9c33e4$export$1bd7f0128d65baef(networkError)) return true;
        if ((graphQLErrors || []).some($ebb54c1f7b9c33e4$export$1bd7f0128d65baef)) return true;
    }
    return false;
}



var $aLoS2 = parcelRequire("aLoS2");


const $0f301ee8607b3904$export$1e9642d012cc75d6 = {
    uuid: null,
    pageId: '',
    routeName: '',
    transitionId: 0,
    routingTimestamp: 0,
    currentSavedTimestamp: 0,
    isLivePage: null
};


const $0b946e8b990b9608$export$3dc3660453120ccc = ()=>{
    (0, $0f301ee8607b3904$export$1e9642d012cc75d6).currentSavedTimestamp = performance.now();
    const activeTrace = (0, $3f9dbb98c6868de1$export$b6ac780db3a3cc77)();
    const activeTraceId = activeTrace?.traceId;
    return {
        uuid: (0, $0f301ee8607b3904$export$1e9642d012cc75d6).uuid,
        contentId: (0, $0f301ee8607b3904$export$1e9642d012cc75d6).pageId,
        isInitial: (0, $0f301ee8607b3904$export$1e9642d012cc75d6).transitionId === 0,
        isSSR: Boolean(window['__SSR_RENDERED__']),
        routingDuration: (0, $0f301ee8607b3904$export$1e9642d012cc75d6).currentSavedTimestamp - (0, $0f301ee8607b3904$export$1e9642d012cc75d6).routingTimestamp,
        ...activeTraceId ? {
            ufoTraceId: activeTraceId,
            ufoTraceType: activeTrace.type
        } : {},
        ...(0, $0f301ee8607b3904$export$1e9642d012cc75d6).isLivePage !== null ? {
            isLivePage: (0, $0f301ee8607b3904$export$1e9642d012cc75d6).isLivePage
        } : {}
    };
};
const $0b946e8b990b9608$export$eef458cd11f4b6e7 = ()=>{
    return (0, $0f301ee8607b3904$export$1e9642d012cc75d6).currentSavedTimestamp;
};
const $0b946e8b990b9608$export$8c17c676096b7909 = (routeName = '', match, transitionId, userInfo)=>{
    const contentId = match?.params?.contentId;
    const useUserInfo = userInfo.userId;
    if ((0, $0f301ee8607b3904$export$1e9642d012cc75d6).pageId !== contentId || (0, $0f301ee8607b3904$export$1e9642d012cc75d6).routeName !== routeName) {
        let savedUniqueId;
        if (useUserInfo) savedUniqueId = $0b946e8b990b9608$var$createPageLoadId(routeName, contentId, userInfo);
        else savedUniqueId = $0b946e8b990b9608$var$createUniqueId();
        (0, $0f301ee8607b3904$export$1e9642d012cc75d6).uuid = savedUniqueId;
        (0, $0f301ee8607b3904$export$1e9642d012cc75d6).routeName = routeName;
        (0, $0f301ee8607b3904$export$1e9642d012cc75d6).pageId = contentId;
        (0, $0f301ee8607b3904$export$1e9642d012cc75d6).transitionId = transitionId;
        (0, $0f301ee8607b3904$export$1e9642d012cc75d6).routingTimestamp = performance.now();
    }
};
const $0b946e8b990b9608$export$2cb0d16c23c1cda0 = (isLivePage)=>{
    (0, $0f301ee8607b3904$export$1e9642d012cc75d6).isLivePage = isLivePage;
};
// refer to https://gist.github.com/jed/982883 for uuid generation
// For Anonymous users
const $0b946e8b990b9608$var$createUniqueId = ()=>{
    return `${1e7}${-1000}${-4000}${-8000}${-100000000000}`.replace(/1|0/g, function() {
        // This is a LEGACY disable statement after rule addition. Use `Math.floor()` next time
        // eslint-disable-next-line no-bitwise
        return (0 | Math.random() * 16).toString(16);
    });
};
// For Atlassian users
const $0b946e8b990b9608$var$createPageLoadId = (routeName, contentId, userInfo)=>{
    const { userId: userId, cloudId: cloudId } = userInfo;
    routeName = routeName || 'route';
    contentId = contentId || 'page';
    // TO-DO ask Dennis if he wants to take any of these out
    return `${routeName}-${contentId}-${userId}-${cloudId}-${Date.now()}`;
};




var $aLoS2 = parcelRequire("aLoS2");

class $12387e80c2ebd079$export$a00c080e726db0b {
    initialize() {
        if (typeof document === 'undefined') return {
            teardown: ()=>{}
        };
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (document.hidden) // if the tab is active, `onVisibilityChange` will result in invariant violation
        this.onVisibilityChange();
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        return {
            teardown: ()=>{
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.removeEventListener('visibilitychange', this.onVisibilityChange);
            }
        };
    }
    getInactiveMillisecondsSince(timestamp) {
        let inactivityDuration = 0;
        // for-loop will allow us to perform an early exit
        for (const [start, end] of this.inactivityIntervals){
            // cases:
            // - timestamp < start     < end        : Relevant
            // - start     < timestamp < end        : Relevant
            // - start     < timestamp ; end=null   : Relevant
            // - start     < end       < timestamp  : Irrelevant
            const inactivityEnd = end || window.performance.now();
            if (timestamp > inactivityEnd) break;
            inactivityDuration += inactivityEnd - Math.max(start, timestamp);
        }
        return inactivityDuration;
    }
    constructor({ maxIntervalsToStore: maxIntervalsToStore } = {}){
        /**
     * Stores intervals in reverse order (that is, latest interval will be the first item in the array).
     * The items in this array are tuples of [intervalStartTimestamp, intervalEndTimestamp].
     * If `intervalEndTimestamp` is `null`, that means that tab is still inactive.
     * Example value (number would actually be timestamps, but they are exemplified differently for ease of understanding):
     * ```js
     * // if the tab is currently active, but was hidden before
     * [ [500, 600], [300, 400], [100, 200] ]
     *
     * // while the tab is still inactive
     * [ [500, null], [100, 200] ]
     *
     * // if the tab has never been hidden
     * [ ]
     * ```
     */ this.inactivityIntervals = [];
        this.logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('TabInactivityTracker');
        // in order to not increase memory footprint indefinitely, we'll cap the maximum amount of items
        this.maxIntervalsToStore = void 0;
        this.onVisibilityChange = ()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            if (!document.hidden) {
                // we were inactive before, which means that there is an "unfinished" interval
                // we'll finish it after verifying invariants
                if (this.inactivityIntervals.length === 0 || this.inactivityIntervals[0][1] != null) this.logger.error`Invariant violation: tab is currently active, but inactivity intervals are in inconsistent state`;
                else this.inactivityIntervals[0][1] = window.performance.now();
            } else {
                if (this.inactivityIntervals.length >= this.maxIntervalsToStore) // we're about to add a new interval; but we're also at max array capacity, so we'll
                // intentionally lose the most dated items in the array in the hope that they won't be needed anymore.
                this.inactivityIntervals.splice(this.maxIntervalsToStore - 1);
                // tab just became inactive; we'll create a new "unfinished" interval
                this.inactivityIntervals.unshift([
                    window.performance.now(),
                    null
                ]);
            }
        };
        const DEFAULT_MAX_INTERVALS_TO_STORE = 100;
        this.maxIntervalsToStore = typeof maxIntervalsToStore === 'number' ? maxIntervalsToStore : DEFAULT_MAX_INTERVALS_TO_STORE;
    }
}
const $12387e80c2ebd079$export$39c3eb20723b04b = (0, $aLoS2.default)(()=>{
    const tracker = new $12387e80c2ebd079$export$a00c080e726db0b();
    tracker.initialize();
    return tracker;
});



var $aLoS2 = parcelRequire("aLoS2");
class $93bba6ebad0146b8$export$51cec848073e2e7a {
    start() {
        let lastFreezeStart;
        if (typeof document !== 'undefined') {
            document.addEventListener('freeze', ()=>{
                lastFreezeStart = performance.now();
            });
            document.addEventListener('resume', ()=>{
                // probably zero chance of it happening, but still
                if (typeof lastFreezeStart !== 'number') return;
                const now = performance.now();
                for (const callback of this.callbacks.values())callback(now - lastFreezeStart);
            });
        }
    }
    subscribe(name, callback) {
        // We are not subscribe and unsubscribe with callback's reference.
        // Because there are known cases that experiences are not properly stopped.
        // In order prevent from memory leak here we are using the name as the key since the variation is bounded.
        this.callbacks.set(name, callback);
    }
    unsubscribe(name) {
        this.callbacks.delete(name);
    }
    constructor(){
        this.callbacks = new Map();
    }
}
const $93bba6ebad0146b8$export$40336562f0f00c2a = (0, $aLoS2.default)(()=>new $93bba6ebad0146b8$export$51cec848073e2e7a());



// Maps error-boundary attribution to bounded responder values for experience-alert routing.
// Add entries only when a distinct responder needs routing; every new value increases SignalFX tag cardinality.
const $325fc8bf5cab101c$var$responderByErrorAttribution = {
    ccgraphql: 'backend'
};
const $325fc8bf5cab101c$var$mappedResponders = new Set(Object.values($325fc8bf5cab101c$var$responderByErrorAttribution));
function $325fc8bf5cab101c$export$ea1f25cade8992b1(errorAttribution) {
    return typeof errorAttribution === 'string' ? $325fc8bf5cab101c$var$responderByErrorAttribution[errorAttribution] : undefined;
}
function $325fc8bf5cab101c$export$f7ab48ee673dc0a0(value) {
    return typeof value === 'string' && $325fc8bf5cab101c$var$mappedResponders.has(value);
}


// Whenever we want to target view-page experience, we should ensure we're targeting all correlated view-page experiences.
// This is more complete and helps avoid bugs related to view-content experience forwarding to view-page.
const $b56cd77aa456103d$var$VIEW_PAGE_EXPERIENCES = [
    (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f),
    (0, $d4b865e8cc459c1f$export$cf73dfff88c1f700),
    (0, $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2)
];
// Experience timeouts by default are considered taskFails. Certain experiences should instead treat timeouts as aborts, to reduce unnecessary noise and improve SLI accuracy.
const $b56cd77aa456103d$var$EXPERIENCE_TIMEOUTS_TO_ABORT = [
    (0, $d4b865e8cc459c1f$export$227ea80a7d6d8ef2),
    (0, $d4b865e8cc459c1f$export$58a8157586db4510),
    ...$b56cd77aa456103d$var$VIEW_PAGE_EXPERIENCES,
    (0, $d4b865e8cc459c1f$export$a83700d85c7e0745),
    (0, $d4b865e8cc459c1f$export$bdaf5db6d84a5581),
    (0, $d4b865e8cc459c1f$export$c6cbeacb537102dd),
    (0, $d4b865e8cc459c1f$export$327b4b6488d8cc55),
    (0, $d4b865e8cc459c1f$export$2a57468d23984a9d),
    (0, $d4b865e8cc459c1f$export$4717394ee1c94acc),
    (0, $d4b865e8cc459c1f$export$3485e62ad9c27d0b)
];
// Errors that are thrown by client side and can be ignored, this is to avoid treating these as fails that can impact SLOs.
// ideally we can show the user a flag that shows something is wrong, please avoid adding to this list unless absolutely necessary.
const $b56cd77aa456103d$var$IGNORABLE_CLIENT_SIDE_ERRORS = [
    "can't access dead object"
];
// HOT-127428: a third-party browser extension / DLP agent patches `appendChild` to `JSON.stringify`
// inserted DOM nodes, which throws on React's circular `__reactFiber$` refs during commit. This is a
// client-environment issue (not our code; seen across multiple tenants/products) that we cannot fix,
// so we abort rather than fail — keeping it out of SLOs. Matched narrowly (message AND `__reactFiber$`)
// behind a gate so it can't mask a genuine in-house circular-JSON regression.
function $b56cd77aa456103d$var$isIgnorableClientSideError(message) {
    if (!message) return false;
    if ($b56cd77aa456103d$var$IGNORABLE_CLIENT_SIDE_ERRORS.includes(message)) return true;
    return message.includes('Converting circular structure to JSON') && message.includes('__reactFiber$') && (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_ignore_third_party_dom_patch_errors');
}
/**
 * A list of experiences that should have debugMessages attached to abort events.
 *
 * This is not a safe default, as at time of addition ~20% of experiences
 * with some events having ~90% abort rates with high volume (>10k per 15m)
 *
 * If adding -- ensure you first review the event and abort volume.
 */ const $b56cd77aa456103d$var$EXPERIENCES_TO_DEBUG_ON_ABORT = [
    (0, $d4b865e8cc459c1f$export$f8e0e16825f0d222)
];
class $b56cd77aa456103d$export$c90b54e658fc4d7c {
    succeed(attributes, publishDebugPoints) {
        if (this.hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getAbsoluteDuration(),
            activeDuration: this.getDurationAdjustedForActive(),
            adjustedDuration: this.getDurationAdjustedForTabActivity(),
            ...publishDebugPoints && {
                debugPoints: this.debugPoints
            },
            attributes: {
                ...(0, $0b946e8b990b9608$export$3dc3660453120ccc)(),
                ...this.getFeatureGateAttributes(),
                ...this.attributes,
                ...attributes
            }
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this.hasStopped) return;
        if ($b56cd77aa456103d$var$isIgnorableClientSideError(error?.message)) {
            this.abort({
                reason: 'Aborted because of client side error',
                attributes: {
                    ...attributes,
                    clientSideError: error.message
                }
            });
            return;
        }
        this.onFailure && this.onFailure();
        const alertResponder = (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_experience_responder_routing') ? (0, $325fc8bf5cab101c$export$ea1f25cade8992b1)(attributes?.errorAttribution ?? this.attributes?.errorAttribution) : undefined;
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getAbsoluteDuration(),
            activeDuration: this.getDurationAdjustedForActive(),
            adjustedDuration: this.getDurationAdjustedForTabActivity(),
            debugPoints: this.debugPoints,
            error: error,
            attributes: {
                ...(0, $0b946e8b990b9608$export$3dc3660453120ccc)(),
                ...this.getFeatureGateAttributes(),
                ...this.attributes,
                ...attributes,
                ...alertResponder ? {
                    alertResponder: alertResponder
                } : {}
            }
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true, publishDebugPoints: /**
     * @deprecated
     * This will not attach debug points in the event that the experience in scenarios where
     * the abort is not coming from consumer code (e.g. when the experience is stopped due
     * to a new experience starting).
     */ publishDebugPoints = false }) {
        if (this.hasStopped) return;
        const adjustedDuration = this.getDurationAdjustedForTabActivity();
        const isTimeout = checkForTimeout && this.timeout != null && adjustedDuration >= this.timeout;
        // Check if the experience should have failed due to timeout
        if (isTimeout) // We want to abort timeouts from view-page and create-page to improve SLO reliability accuracy as they're not guaranteed to be correlated to real user impact. For more info see MODES-4806.
        {
            if (!$b56cd77aa456103d$var$EXPERIENCE_TIMEOUTS_TO_ABORT.includes(this.name)) {
                this.fail({
                    attributes: {
                        originalAbortReason: reason,
                        ...attributes
                    },
                    error: new (0, $4b50c1dadb433c8a$export$d27a2b6293f7631c)(`${this.name} failed to complete in ${this.timeout}ms`)
                });
                return;
            }
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getAbsoluteDuration(),
            activeDuration: this.getDurationAdjustedForActive(),
            adjustedDuration: adjustedDuration,
            ...$b56cd77aa456103d$var$EXPERIENCES_TO_DEBUG_ON_ABORT.includes(this.name) ? {
                debugPoints: this.debugPoints
            } : {},
            ...publishDebugPoints && {
                debugPoints: this.debugPoints
            },
            reason: isTimeout ? `ExperienceTimeout: ${this.name} failed to complete in ${this.timeout}ms` : reason,
            checkForTimeout: checkForTimeout,
            attributes: {
                originalAbortReason: isTimeout ? reason : undefined,
                ...(0, $0b946e8b990b9608$export$3dc3660453120ccc)(),
                ...this.getFeatureGateAttributes(),
                ...this.attributes,
                ...attributes
            }
        });
    }
    /**
   * Called on experience to stop it with the same action (success / failure / abort) and attributes as another event.
   * For example, compound experience (e.g. edit-page) is failed if sub-experience (e.g. edit-page/publish) fails.
   */ stopOn(event, extraAttributes = {}) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed({});
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            attributes: {
                ...extraAttributes,
                stoppedOn: event.name,
                stoppedOnPath: this.getStoppedOnPath(event)
            },
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error,
            attributes: {
                ...extraAttributes,
                stoppedOn: event.name,
                stoppedOnPath: this.getStoppedOnPath(event)
            }
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    attachDebugPoint(message, attributes = {}) {
        if (this.debugPoints?.some((debugPoint)=>debugPoint.message === message)) // Avoid adding duplicate debug points
        return;
        this.debugPoints.push({
            timestamp: new Date().toISOString(),
            now: typeof window !== 'undefined' ? window.performance.now() : 0,
            message: message,
            attributes: attributes
        });
    }
    getState() {
        return {
            taskId: this.id,
            timeout: this.timeout,
            hasStopped: this.hasStopped,
            stopState: this.stopState,
            startTime: this.startTime,
            name: this.name,
            attributes: this.attributes
        };
    }
    get hasStopped() {
        return this.stopState !== null;
    }
    stop(event) {
        this.stopState = event.action;
        if (this.onStop) this.onStop(event);
        (0, $93bba6ebad0146b8$export$40336562f0f00c2a)().unsubscribe(this.name);
    }
    getAbsoluteDuration() {
        return Math.round((typeof window !== 'undefined' ? window.performance.now() : 0) - this.startTime);
    }
    getDurationAdjustedForTabActivity() {
        return this.getAbsoluteDuration() - (0, $12387e80c2ebd079$export$39c3eb20723b04b)().getInactiveMillisecondsSince(this.startTime);
    }
    getDurationAdjustedForActive() {
        return this.getAbsoluteDuration() - this.freezeTime;
    }
    getStoppedOnPath(event) {
        if (!event.attributes?.stoppedOnPath) return event.name;
        return `${event.name},${event.attributes.stoppedOnPath}`;
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = typeof window !== 'undefined' ? window.performance.now() : 0, attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this.freezeTime = 0;
        this.stopState = null;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.debugPoints = [];
        // Include certain broad-impact feature gates in experience events
        this.getFeatureGateAttributes = (0, $aLoS2.default)(()=>{
            return {
                isContentWrapperEnabled: true,
                isNav4Enabled: true
            };
        });
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: {
                ...(0, $0b946e8b990b9608$export$3dc3660453120ccc)(),
                ...attributes,
                ...this.getFeatureGateAttributes()
            }
        };
        if (onStart) this.onStop = onStart(startEvent);
        (0, $93bba6ebad0146b8$export$40336562f0f00c2a)().subscribe(name, (time)=>{
            this.freezeTime += time;
        });
    }
}




const $b4f5dc9bddcbc766$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $b4f5dc9bddcbc766$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);
const $b4f5dc9bddcbc766$export$7895096fcdde5712 = (event, key, value)=>Boolean(event.attributes?.hasOwnProperty(key) && event.attributes[key] === value);



const $db2847de8e87cb6c$var$EDIT_PAGE_SUBEXPERIENCES = [
    (0, $d4b865e8cc459c1f$export$54650b8dd9597591),
    (0, $d4b865e8cc459c1f$export$92edebd76eb1ad1),
    (0, $d4b865e8cc459c1f$export$4aed0cf42acf9c68)
];
const $db2847de8e87cb6c$var$COMPANY_HUB_EDITOR_SUBEXPERIENCES = [
    (0, $d4b865e8cc459c1f$export$35975591aeab4dd6),
    (0, $d4b865e8cc459c1f$export$7a3dfdccebea9c7b),
    (0, $d4b865e8cc459c1f$export$eef6122c9774ba1c)
];
const $db2847de8e87cb6c$export$b4cbec267823a12e = ()=>{
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$9e0dcc9389703292),
        collect: $db2847de8e87cb6c$export$bb44f104e3c54dae
    });
};
const $db2847de8e87cb6c$export$bb44f104e3c54dae = (events, experience)=>{
    experience.stopOn($db2847de8e87cb6c$export$e2067cc0ba855137(events, 'taskSuccess'));
    experience.stopOn($db2847de8e87cb6c$export$e2067cc0ba855137(events, 'taskFail'));
};
const $db2847de8e87cb6c$export$e2067cc0ba855137 = (events, action)=>{
    return events.find((event)=>event.action === action && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, (0, $d4b865e8cc459c1f$export$dd70d6707192298e)));
};
const $db2847de8e87cb6c$export$2b69dcd5daaf6a2c = ()=>{
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    const editPageExperienceState = tracker.getExperienceState((0, $d4b865e8cc459c1f$export$dd70d6707192298e));
    const isEditPageRunning = editPageExperienceState && !editPageExperienceState.hasStopped;
    if (!isEditPageRunning) return false;
    // Validate all subexperiences are healthy. If any experience is unhealthy, `every` will immediately return false, otherwise true
    return $db2847de8e87cb6c$var$EDIT_PAGE_SUBEXPERIENCES.every((subexperience)=>{
        const subexperienceState = tracker.getExperienceState(subexperience);
        // Subexperience has not run, so edit-page is still healthy
        if (!subexperienceState) return true;
        // Subexperience has not run for current edit-page's contentId, so edit-page is still healthy
        if (subexperienceState.attributes?.contentId !== editPageExperienceState.attributes?.contentId) return true;
        // Subexperience has run and has finished successfully, so edit-page is still healthy
        if (subexperienceState.stopState === 'taskSuccess') return true;
        // Subexperience has run and has not finished successfully, so edit-page is unhealthy
        return false;
    });
};
const $db2847de8e87cb6c$export$c15dc70f74e1c751 = ()=>{
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    const hubEditorExperienceState = tracker.getExperienceState((0, $d4b865e8cc459c1f$export$c6d05c48b9430e3c));
    const isHubEditorRunning = hubEditorExperienceState && !hubEditorExperienceState.hasStopped;
    if (!isHubEditorRunning) return false;
    // Validate all subexperiences are healthy. If any experience is unhealthy, `every` will immediately return false, otherwise true
    return $db2847de8e87cb6c$var$COMPANY_HUB_EDITOR_SUBEXPERIENCES.every((subexperience)=>{
        const subexperienceState = tracker.getExperienceState(subexperience);
        // Subexperience has not run, so hub editor experience is still healthy
        if (!subexperienceState) return true;
        // Subexperience has run and has finished successfully, so hub editor experience is still healthy
        if (subexperienceState.stopState === 'taskSuccess') return true;
        // Subexperience has run and has not finished successfully, so hub editor experience is unhealthy
        return false;
    });
};



// eslint-disable-next-line import/no-cycle

const $4554f58440667b87$export$11699410c9e76883 = ({ parentExperience: parentExperience, subExperiences: subExperiences })=>{
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    const parentExperienceState = tracker.getExperienceState(parentExperience);
    const isParentExperienceRunning = parentExperienceState && !parentExperienceState.hasStopped;
    if (!isParentExperienceRunning) return false;
    const parentExperienceContentId = String(parentExperienceState.attributes?.contentId);
    return $4554f58440667b87$var$areSubExperiencesHealthy({
        parentExperienceContentId: parentExperienceContentId,
        subExperiences: subExperiences
    });
};
const $4554f58440667b87$var$areSubExperiencesHealthy = ({ parentExperienceContentId: parentExperienceContentId, subExperiences: subExperiences = [] })=>{
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    // Validate all subExperiences are healthy. If any experience is unhealthy, `every` will immediately return false, otherwise true
    return subExperiences.every((subExperience)=>{
        const subExperienceState = tracker.getExperienceState(subExperience);
        // Subexperience has not run, so parent is still healthy
        if (!subExperienceState) return true;
        // Subexperience has not run for current parentExperience's contentId, so parentExperience is still healthy
        const isSubExperienceForDifferentContent = parentExperienceContentId !== subExperienceState.attributes?.contentId;
        if (isSubExperienceForDifferentContent) return true;
        const hasSubExperienceCompletedSuccessfully = subExperienceState.stopState === 'taskSuccess';
        if (hasSubExperienceCompletedSuccessfully) return true;
        // Subexperience has run and has not finished successfully, so parentExperience is unhealthy
        return false;
    });
};


const $59f627305e19cfab$export$77dd5573732a240c = ()=>(0, $4554f58440667b87$export$11699410c9e76883)({
        parentExperience: (0, $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2),
        subExperiences: [
            (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f)
        ]
    });
const $59f627305e19cfab$export$41f7b734fb3e4a50 = ({ id: id, tracker: tracker, attributes: attributes, startTime: startTime })=>{
    tracker.start({
        name: (0, $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2),
        id: id,
        startTime: startTime,
        attributes: attributes,
        collect: (events, experience)=>{
            const viewExperienceLoadingFailed = events.find(({ action: action, name: name })=>action === 'taskFail' && name === (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f));
            const viewExperienceLoadingAborted = events.find(({ action: action, name: name })=>action === 'taskAbort' && name === (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f));
            if (viewExperienceLoadingFailed) experience.fail({
                error: new Error('View page load experience failed')
            });
            else if (viewExperienceLoadingAborted) experience.abort({
                reason: 'View page load experience aborted'
            });
        }
    });
};



function $09236c8503a0584b$var$getExperienceStopReason(error) {
    // message text check is a stop-gap measure due to re-packaging of errors. refactoring is underway.
    if ((0, $ebb54c1f7b9c33e4$export$b8c2308c7b82c3a9)(error)) return `Aborted because of session expiration error: ${error.toString()}`;
    if ((0, $65398bb1ddc9160a$export$bda33884db3cf75b)(error)) return `Aborted because of network error: ${error.toString()}`;
    return undefined;
}
class $09236c8503a0584b$export$12b6b072930fd68f {
    start({ name: name, id: id = (0, (/*@__PURE__*/$parcel$interopDefault($c29b43bb0df96673$exports)))(), timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        // Do not restart an experience that has the same id and is still running
        if (current && current.id === id && !current.hasStopped) return;
        // Before replacing a current experience, abort it to ensure it is cleaned up.
        if (current && !current.hasStopped) current.abort({
            reason: 'Aborted because the same experience was started with a new id',
            attributes: {
                newTaskId: id
            }
        });
        const experience = new (0, $b56cd77aa456103d$export$c90b54e658fc4d7c)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes, publishDebugPoints: publishDebugPoints }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes, publishDebugPoints);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout, publishDebugPoints: publishDebugPoints }) {
        Object.values(this.experiences).forEach((experience)=>{
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes,
                publishDebugPoints: publishDebugPoints
            });
        });
    }
    stopOnError({ error: error, name: name, attributes: attributes }) {
        const reason = $09236c8503a0584b$var$getExperienceStopReason(error);
        if (reason) {
            this.abort({
                name: name,
                reason: reason,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    getExperienceState(experienceName) {
        return this.experiences[experienceName] ? this.experiences[experienceName].getState() : null;
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    attachDebugPoint({ name: name, message: message, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.attachDebugPoint(message, attributes);
    }
    emit(event) {
        this.logger.debug`${event.action} ${event}`;
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {
                this.logger.error`Error occurred in ExperienceTracker subscriber ${e} when handling event ${event}`;
            }
        });
    }
    constructor(){
        this.experiences = {};
        this.subscribers = [];
        this.logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('ExperienceTracker');
        (0, $93bba6ebad0146b8$export$40336562f0f00c2a)().start();
        if (typeof window !== 'undefined') window.addEventListener('pagehide', ()=>{
            const livePageEditExperienceState = this.getExperienceState((0, $d4b865e8cc459c1f$export$dd70d6707192298e));
            const livePageSessionExperienceState = this.getExperienceState((0, $d4b865e8cc459c1f$export$3814d28dd3802a02));
            const experiencesToSucceed = [
                {
                    name: (0, $d4b865e8cc459c1f$export$dd70d6707192298e),
                    successCondition: livePageEditExperienceState && !livePageEditExperienceState.hasStopped && livePageEditExperienceState.attributes?.isLivePage
                },
                {
                    name: (0, $d4b865e8cc459c1f$export$dd70d6707192298e),
                    successCondition: (0, $db2847de8e87cb6c$export$2b69dcd5daaf6a2c)()
                },
                {
                    name: (0, $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2),
                    successCondition: (0, $59f627305e19cfab$export$77dd5573732a240c)()
                },
                {
                    name: (0, $d4b865e8cc459c1f$export$3814d28dd3802a02),
                    successCondition: livePageSessionExperienceState && !livePageSessionExperienceState.hasStopped
                }
            ];
            experiencesToSucceed.forEach(({ name: name, successCondition: successCondition })=>{
                if (successCondition) this.succeed({
                    name: name
                });
            });
            // Abort the rest of our experiences.
            this.abort({
                reason: 'Window unloading'
            });
        });
    }
}



const $fb98a59fbc7d7496$var$SLA_EXPERIENCES = new Set([
    // Currently not SLA experience, but will be in the future
    (0, $d4b865e8cc459c1f$export$f8e0e16825f0d222),
    (0, $d4b865e8cc459c1f$export$6f58645a9a5f7936),
    (0, $d4b865e8cc459c1f$export$20fbac00cba3c8a),
    // SLA experiences ⬇️
    (0, $d4b865e8cc459c1f$export$f94e85276e6d639f),
    (0, $d4b865e8cc459c1f$export$227ea80a7d6d8ef2),
    (0, $d4b865e8cc459c1f$export$dd70d6707192298e),
    (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f)
]);
const $fb98a59fbc7d7496$var$activeSlaExperiences = new Map();
const $fb98a59fbc7d7496$var$activeExperiences = new Set();
const $fb98a59fbc7d7496$var$currentRoute = {
    routeName: '',
    successfulExperiences: new Set()
};
const $fb98a59fbc7d7496$var$previousRoute = {
    routeName: '',
    successfulExperiences: new Set()
};
const $fb98a59fbc7d7496$var$getIsBifrostTag = ()=>`isBifrost:${window?.__IS_BIFROST__ ?? false}`;
function $fb98a59fbc7d7496$export$6369eb07eb8a8518({ action: action, name: name, id: id, attributes: attributes = {} }) {
    const isSlaExperience = $fb98a59fbc7d7496$var$SLA_EXPERIENCES.has(name);
    if (action === 'taskStart') {
        if (isSlaExperience) {
            // Create a unique experience ID for request headers
            attributes.uniqueExperienceId = (0, (/*@__PURE__*/$parcel$interopDefault($c29b43bb0df96673$exports)))();
            $fb98a59fbc7d7496$var$activeSlaExperiences.set(name, {
                id: id,
                attributes: attributes
            });
        }
        $fb98a59fbc7d7496$var$activeExperiences.add(name);
    } else {
        if (isSlaExperience) {
            // Extract unique experience ID to attach to event attributes for analytics/monitoring logs
            attributes.uniqueExperienceId = $fb98a59fbc7d7496$var$activeSlaExperiences.get(name)?.attributes?.uniqueExperienceId;
            $fb98a59fbc7d7496$var$activeSlaExperiences.delete(name);
        }
        $fb98a59fbc7d7496$var$activeExperiences.delete(name);
        if (action === 'taskSuccess') $fb98a59fbc7d7496$var$currentRoute.successfulExperiences.add(name);
    }
    const slaExperience = $fb98a59fbc7d7496$export$1e7d0a9a962cdd28();
    const experiences = $fb98a59fbc7d7496$var$activeExperiences.size > 0 ? $fb98a59fbc7d7496$var$activeExperiences : null;
    if (slaExperience || experiences) {
        const updatedContext = {};
        if (experiences) updatedContext.activeExperiences = $fb98a59fbc7d7496$var$activeExperiences;
        if (slaExperience) updatedContext.slaExperience = slaExperience.name;
        (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().updateContext(updatedContext);
    }
}
function $fb98a59fbc7d7496$export$1e7d0a9a962cdd28() {
    if ($fb98a59fbc7d7496$var$activeSlaExperiences.size === 0) return null;
    const experienceEntry = Array.from($fb98a59fbc7d7496$var$activeSlaExperiences).pop();
    return {
        ...experienceEntry[1],
        name: experienceEntry[0]
    };
}
const $fb98a59fbc7d7496$export$a1fa58e5690a5a9a = (0, $aLoS2.default)(()=>{
    const tracker = new (0, $09236c8503a0584b$export$12b6b072930fd68f)();
    // Do nothing for search engine crawlers
    if (/bot/i.test(window.navigator.userAgent)) return tracker;
    tracker.subscribe((event)=>{
        //
        // View Page SLA Split
        //
        if (event.name === (0, $d4b865e8cc459c1f$export$cf73dfff88c1f700)) {
            $fb98a59fbc7d7496$var$splitViewContentExperience(tracker, event);
            // View-content was introduced only to split space-overview out of
            // view-page, because view-page is covered by Premium SLA and
            // space-overview was not satisfactorily reliable. View-content is not
            // allowlisted in cc-fe-telemetry so submitting through MonitoringClient
            // below is a waste. Sending through AnalyticsWebClient is a waste too
            // since view-content is not tracked as an SLO and it could be derived
            // from view-page and space-overview which are tracked as separate SLOs
            // already anyway. Splunk found 23 million view-content events in the last
            // 24 hours which is about 3% of experience-tracker events.
            return;
        }
        $fb98a59fbc7d7496$export$6369eb07eb8a8518(event);
        //
        // AnalyticsWebClient
        //
        (0, $b76dfd1db5681318$export$e9ba7ef9458d1a4a)().then((client)=>{
            client.sendOperationalEvent((0, $4bbad620418b05ff$export$9c05e7ef9f2c8895)($fb98a59fbc7d7496$var$provideGenericAttributes(event)));
        });
        //
        // MonitoringClient
        //
        const isTimeoutError = event.action === 'taskFail' && event?.error?.name === 'ExperienceTimeoutError' || event.action === 'taskAbort' && typeof event?.reason === 'string' && event.reason.startsWith('ExperienceTimeout');
        const isPermissionError = event.name === (0, $d4b865e8cc459c1f$export$dd70d6707192298e) && event.action === 'taskAbort' && (event.reason?.includes?.('401') || event.reason?.includes?.('403'));
        const tags = [
            `action:${event.action}`,
            `isActiveTab:${typeof document !== 'undefined' && document.visibilityState === 'visible'}`,
            ...event.action === 'taskFail' || event.action === 'taskAbort' ? [
                `isTimeoutError:${isTimeoutError}`
            ] : [],
            ...event.name === (0, $d4b865e8cc459c1f$export$dd70d6707192298e) && event.action === 'taskAbort' ? [
                `isPermissionError:${isPermissionError}`
            ] : []
        ];
        if (event.attributes) for(const a in event.attributes){
            if (a === 'alertResponder' && (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_experience_responder_routing')) {
                // Only tag `alertResponder` for fail events. `alertResponder` to be used to help determine which team to send alerts to.
                // `attributes.alertResponder` is set on all fail events when appropriate. See confluence/next/packages/experience-tracker/src/Experience.ts
                if (event.action === 'taskFail') tags.push(`alertResponder:${event.attributes[a]}`);
                continue;
            }
            tags.push(`${a}:${event.attributes[a]}`);
        }
        tags.push($fb98a59fbc7d7496$var$getIsBifrostTag());
        tags.push(`isMultiThread:${window?.__IS_MULTITHREADED_RUNTIME__}`);
        if (event.action === 'taskFail' && $fb98a59fbc7d7496$var$SLA_EXPERIENCES.has(event.name)) {
            // in this section, we submit information about SLA-affecting experience failures.
            // We don't submit timeout errors to monitoring systems however; they would be submitted to Analytics instead.
            // cc-fe-telemetry will filter these additional tags before sending to SFX, these are only for "Raw TelemetryEvent" Splunk logs
            if (event?.error?.message) tags.push(`error:${event.error.message}`);
            // Supply additional information from alternative sources, for case where SessionDataQuery is not available
            tags.push(`hostname:${window.location.hostname}`);
            tags.push(`tenantIdMeta:${(0, $b9d7d5d25d527513$export$72427a1521dd0069)('cloud-id')}`);
            // See https://product-fabric.atlassian.net/browse/PGXT-9417 — suppress module not found
            // errors from the experience-tracker counter so they don't skew SLA metrics in Splunk.
            if (!(0, $3a74d2139e317bf1$export$fb9e315560414aed)(event.error)) {
                (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().incrementCounter(`experience-tracker:${event.name}`, tags);
                if (!(event.error instanceof (0, $4b50c1dadb433c8a$export$d27a2b6293f7631c))) {
                    (0, $8a3a8685062675cc$export$c37ca7d37ab54fcc)(event.error, {
                        objectId: event.attributes?.contentId
                    });
                    (0, $8a3a8685062675cc$export$a986f274521b30d7)(event.error, {
                        failedSlaExperience: event.name,
                        experienceId: event.attributes?.uniqueExperienceId ?? event.id
                    });
                    (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(event.error, {
                        attribution: 'sla'
                    });
                }
            }
        } else (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().incrementCounter(`experience-tracker:${event.name}`, tags);
    });
    return tracker;
});
function $fb98a59fbc7d7496$export$720dc4209419df4e(name, error, attributes) {
    $fb98a59fbc7d7496$export$a1fa58e5690a5a9a().stopOnError({
        name: name,
        error: error,
        attributes: attributes
    });
}
const $fb98a59fbc7d7496$export$1c9cdc2685ab8d2 = (tracker, event, name = event.name)=>{
    switch(event.action){
        case 'taskStart':
            tracker.start({
                ...event,
                name: name
            });
            break;
        case 'taskSuccess':
            tracker.succeed({
                ...event,
                name: name
            });
            break;
        case 'taskFail':
            tracker.fail({
                ...event,
                name: name
            });
            break;
        case 'taskAbort':
            tracker.abort({
                ...event,
                name: name
            });
    }
};
function $fb98a59fbc7d7496$export$e8918c537d57dc96(routeName) {
    $fb98a59fbc7d7496$var$previousRoute.routeName = $fb98a59fbc7d7496$var$currentRoute.routeName;
    $fb98a59fbc7d7496$var$previousRoute.successfulExperiences = $fb98a59fbc7d7496$var$currentRoute.successfulExperiences;
    $fb98a59fbc7d7496$var$currentRoute.routeName = routeName;
    $fb98a59fbc7d7496$var$currentRoute.successfulExperiences = new Set();
}
function $fb98a59fbc7d7496$export$5259f71d975e46f5() {
    return {
        ...$fb98a59fbc7d7496$var$previousRoute
    };
}
const $fb98a59fbc7d7496$var$splitViewContentExperience = (tracker, event)=>{
    let name;
    if (event.attributes?.contentType === 'space') {
        name = (0, $d4b865e8cc459c1f$export$2a57468d23984a9d);
        const spaceKey = event.attributes?.spaceKey;
        if (typeof spaceKey === 'string' && (0, $a4b9a8903fd62c69$export$5ab9c400208ad907)(spaceKey)) name = (0, $d4b865e8cc459c1f$export$7f2689ec25c432a4);
    } else {
        name = (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f);
        if (event.action === 'taskStart') (0, $59f627305e19cfab$export$41f7b734fb3e4a50)({
            tracker: tracker,
            attributes: {
                ...event.attributes
            },
            startTime: event.startTime,
            id: event.id
        });
    }
    $fb98a59fbc7d7496$export$1c9cdc2685ab8d2(tracker, event, name);
};
/**
 * Extend the ExperienceEvent with Confluence-specific additional attributes based on available data and type of event.
 *
 * @param event ExperienceEvent
 * @returns ExperienceEvent with additional attributes
 */ const $fb98a59fbc7d7496$var$provideGenericAttributes = (event)=>{
    const errorTraceId = event.action === 'taskFail' && !!event?.error ? (0, $8a3a8685062675cc$export$d08bac32cb78075f)(event.error)?.traceId : undefined;
    // Expected that condition will be extended with && for other attributes added in the future
    if (!errorTraceId) return event;
    event.attributes = {
        ...!!errorTraceId && {
            traceId: errorTraceId
        },
        ...event.attributes
    };
    return event;
};




var $2cRRf = parcelRequire("2cRRf");
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
const $437f0681ff1c62d3$export$cdb0163d35da79f3 = '__EP_REACT_PROPS_OBSERVABLE_OBJECT__';


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

const $5b839e976cc39dc2$export$ab9998995666ebe3 = 'embedded-confluence-iframe';
const $5b839e976cc39dc2$export$f2fe03976fe13de = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return `${$5b839e976cc39dc2$export$ab9998995666ebe3}-${(0, $b9a40c449374f876$exports.v4)()}`;
};
const $5b839e976cc39dc2$export$45b0adb7f9689286 = 'passThroughProps';
const $5b839e976cc39dc2$export$78cada8c8749e264 = 'propsUpdated';
const $5b839e976cc39dc2$export$b75934a6b56fd9ba = 'experienceForwarding';


const $777d964ae375d5c2$export$8195e508b27d5978 = ()=>Boolean(window?.frameElement?.[0, $437f0681ff1c62d3$export$cdb0163d35da79f3]) || window?.name.includes((0, $5b839e976cc39dc2$export$ab9998995666ebe3));


// Keep these values aligned with @confluence/mobile-app-detection-common. They are duplicated here
// to avoid importing a product package into this @atlassian package.
// TODO: Extract these values to a shared Platform location so both packages use one source of truth.
const $71776876d780834d$var$MOBILE_APP_PRESENTATION_MODE_VALUES = [
    'mobileAppWithEditing',
    'mobileAppWithCommenting',
    'mobileApp'
];
const $71776876d780834d$var$isMobileAppPresentationMode = (value)=>Array.isArray(value) ? value.some((item)=>$71776876d780834d$var$MOBILE_APP_PRESENTATION_MODE_VALUES.includes(item)) : Boolean(value && $71776876d780834d$var$MOBILE_APP_PRESENTATION_MODE_VALUES.includes(value));
const $71776876d780834d$export$9c21f25960873ecb = (location)=>{
    if (!location) location = window.location;
    const { query: query } = (0, (/*@__PURE__*/$parcel$interopDefault($2cRRf))).parse(location.search, true);
    return query.embedded === 'true' || Boolean(query.parentProduct) || $71776876d780834d$var$isMobileAppPresentationMode(query.presentationMode) || (0, $777d964ae375d5c2$export$8195e508b27d5978)();
};




var $6oQI4 = parcelRequire("6oQI4");


var $25T3r = parcelRequire("25T3r");

var $6oQI4 = parcelRequire("6oQI4");


var $7FIrY = parcelRequire("7FIrY");

var $6oQI4 = parcelRequire("6oQI4");
var $8c86e30f970857bb$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $8c86e30f970857bb$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});




var $6oQI4 = parcelRequire("6oQI4");
const $ad8cbd425a6b28af$export$ca000e230c0caa3e = {
    context: null
};


function $6ce1e9c9056ffb63$export$17ab21d7be720b() {
    (0, $ad8cbd425a6b28af$export$ca000e230c0caa3e).context = null;
}


/**
 * Generates a random 16-character hexadecimal span ID.
 * This is used for creating new span IDs in distributed tracing.
 *
 * @returns A 16-character hexadecimal string
 *
 * @example
 * ```typescript
 * const spanId = generateSpanId(); // e.g., "84a67a1b3ceccf27"
 * ```
 */ function $463dfa9fda582707$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}


/**
 * Generates a random 32-character hexadecimal trace ID.
 * This is used for creating new trace IDs in distributed tracing.
 *
 * @returns A 32-character hexadecimal string
 *
 * @example
 * ```typescript
 * const traceId = generateTraceId(); // e.g., "9ad3407c1a7d484b86847e7226e566d3"
 * ```
 */ function $6c66e22136933fb5$export$dc6d7ea554bcce10() {
    return Array.from(new Array(32), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}



function $f913503d2bf7ba32$export$b6ac780db3a3cc77() {
    return (0, $ad8cbd425a6b28af$export$ca000e230c0caa3e).context;
}



var $1HmhQ = parcelRequire("1HmhQ");

var $juSGQ = parcelRequire("juSGQ");
function $46b2db7984fa809b$export$57570b1603cf6adb() {
    // Gaurd for running in the browser - if SSR (somehow) just return prod
    if (typeof window === 'undefined') return (0, $juSGQ.envType).PROD;
    const { hostname: hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return (0, $juSGQ.envType).LOCAL;
    if (hostname.includes('.dev.')) return (0, $juSGQ.envType).STAGING;
    if (hostname.includes('.stg.')) return (0, $juSGQ.envType).STAGING;
    return (0, $juSGQ.envType).PROD;
}



const $015005ddefb2e480$var$getAnalyticsClient = (()=>{
    let instance;
    return ()=>{
        if (!instance) {
            const env = (0, $46b2db7984fa809b$export$57570b1603cf6adb)();
            instance = new (0, $1HmhQ.default)({
                env: env,
                product: 'observability'
            });
        }
        return instance;
    };
})();
function $015005ddefb2e480$export$a1002be327997103(traceId, spanId, source) {
    // If trace context has already been set, there has been an experience collision
    // Don't update the trace context.
    if ((0, $ad8cbd425a6b28af$export$ca000e230c0caa3e).context !== null) $015005ddefb2e480$var$getAnalyticsClient().sendOperationalEvent({
        source: source,
        action: 'setActiveTrace',
        actionSubject: 'traceContext',
        attributes: {
            currentContext: (0, $ad8cbd425a6b28af$export$ca000e230c0caa3e).context,
            incomingContext: {
                traceId: traceId,
                spanId: spanId
            },
            status: 'collision'
        },
        tags: [
            'observability'
        ]
    });
    else (0, $ad8cbd425a6b28af$export$ca000e230c0caa3e).context = {
        traceId: traceId,
        spanId: spanId
    };
}


// temp solution until we can get it automated
const $60b0861ff9f1eeb5$export$2295b861f318254a = '0.1.5';


const $559ee1afcd2da156$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};


var $f8153cbe5af4cb94$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $f8153cbe5af4cb94$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $f8153cbe5af4cb94$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $f8153cbe5af4cb94$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $f8153cbe5af4cb94$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $f8153cbe5af4cb94$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $f8153cbe5af4cb94$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $f8153cbe5af4cb94$export$9f2bf58999404c75 = 'fmp';
const $f8153cbe5af4cb94$export$837e0f79a8056912 = 'inline-response';


const $20bfa9c77292d15c$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $f8153cbe5af4cb94$export$96253c35c37cf96b).EXPERIENCE_PAYLOAD,
        payload: data
    };
};


/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 




const $82110d38d5573dea$export$d8b468db8a225bc9 = 250;


const $5a67facd091ab2e9$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < (0, $82110d38d5573dea$export$d8b468db8a225bc9)) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};



const $b2fa67bd4177b64f$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $f8153cbe5af4cb94$export$96253c35c37cf96b).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};



const $245974498aa6f8a2$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $f8153cbe5af4cb94$export$96253c35c37cf96b).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};


/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 

class $7d75443170d44d54$var$UFOLogger {
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($7d75443170d44d54$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($7d75443170d44d54$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
$7d75443170d44d54$var$UFOLogger.UFOprefix = "[ufo\uD83D\uDEF8]";
const $7d75443170d44d54$export$4ab84f6f04f6566d = new $7d75443170d44d54$var$UFOLogger();


const $6035edc03de31bae$export$b4958caff08a0960 = (...args)=>{
    (0, $7d75443170d44d54$export$4ab84f6f04f6566d).log(...args);
};



const $f438f1eb8ffe4363$export$d53d07b6034c4560 = (...args)=>{
    (0, $7d75443170d44d54$export$4ab84f6f04f6566d).warn(...args);
};



class $4721409c9bb35384$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $559ee1afcd2da156$export$15e172712955e18f)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $4721409c9bb35384$export$13e680397ec8f3eb = new $4721409c9bb35384$var$VisibilityChangeObserver();



const $201b4dddb93775dc$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};



const $41d6970b6c194d5c$var$UFOStateAvailableTransitions = {
    [(0, $201b4dddb93775dc$export$81b70111112841a0).NOT_STARTED.id]: [
        (0, $201b4dddb93775dc$export$81b70111112841a0).STARTED.id
    ],
    [(0, $201b4dddb93775dc$export$81b70111112841a0).STARTED.id]: [
        (0, $201b4dddb93775dc$export$81b70111112841a0).IN_PROGRESS.id,
        (0, $201b4dddb93775dc$export$81b70111112841a0).BLOCKED.id,
        (0, $201b4dddb93775dc$export$81b70111112841a0).SUCCEEDED.id,
        (0, $201b4dddb93775dc$export$81b70111112841a0).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $201b4dddb93775dc$export$81b70111112841a0).FAILED.id,
        (0, $201b4dddb93775dc$export$81b70111112841a0).ABORTED.id
    ],
    [(0, $201b4dddb93775dc$export$81b70111112841a0).IN_PROGRESS.id]: [
        (0, $201b4dddb93775dc$export$81b70111112841a0).BLOCKED.id,
        (0, $201b4dddb93775dc$export$81b70111112841a0).SUCCEEDED.id,
        (0, $201b4dddb93775dc$export$81b70111112841a0).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $201b4dddb93775dc$export$81b70111112841a0).FAILED.id,
        (0, $201b4dddb93775dc$export$81b70111112841a0).ABORTED.id
    ],
    [(0, $201b4dddb93775dc$export$81b70111112841a0).BLOCKED.id]: [
        (0, $201b4dddb93775dc$export$81b70111112841a0).RECOVERED.id,
        (0, $201b4dddb93775dc$export$81b70111112841a0).ABORTED.id
    ],
    [(0, $201b4dddb93775dc$export$81b70111112841a0).RECOVERED.id]: [
        (0, $201b4dddb93775dc$export$81b70111112841a0).STARTED.id,
        (0, $201b4dddb93775dc$export$81b70111112841a0).SUCCEEDED.id,
        (0, $201b4dddb93775dc$export$81b70111112841a0).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $201b4dddb93775dc$export$81b70111112841a0).FAILED.id,
        (0, $201b4dddb93775dc$export$81b70111112841a0).ABORTED.id
    ],
    [(0, $201b4dddb93775dc$export$81b70111112841a0).SUCCEEDED.id]: [
        (0, $201b4dddb93775dc$export$81b70111112841a0).STARTED.id
    ],
    [(0, $201b4dddb93775dc$export$81b70111112841a0).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $201b4dddb93775dc$export$81b70111112841a0).SUCCEEDED.id,
        (0, $201b4dddb93775dc$export$81b70111112841a0).FAILED.id,
        (0, $201b4dddb93775dc$export$81b70111112841a0).ABORTED.id
    ],
    [(0, $201b4dddb93775dc$export$81b70111112841a0).FAILED.id]: [
        (0, $201b4dddb93775dc$export$81b70111112841a0).STARTED.id
    ],
    [(0, $201b4dddb93775dc$export$81b70111112841a0).ABORTED.id]: [
        (0, $201b4dddb93775dc$export$81b70111112841a0).STARTED.id
    ]
};
const $41d6970b6c194d5c$export$178881f329fdb81f = (state1, state2)=>{
    return $41d6970b6c194d5c$var$UFOStateAvailableTransitions[state1.id] && $41d6970b6c194d5c$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};



const $fedba5b33c3a8e43$export$5f490af6b2b115cf = ()=>~~performance.now();


const $0946a833271bbb64$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $fedba5b33c3a8e43$export$5f490af6b2b115cf)();
};


const $7b4c325a9c3e7899$var$getPageVisibleState = ()=>{
    return !(0, $559ee1afcd2da156$export$15e172712955e18f)() || !window.document || window.document.visibilityState === 'visible' ? (0, $f8153cbe5af4cb94$export$a12c67b37a306b13).VISIBLE : (0, $f8153cbe5af4cb94$export$a12c67b37a306b13).HIDDEN;
};
class $7b4c325a9c3e7899$export$d31c89db257648c {
    async transition(newState, timestamp) {
        (0, $6035edc03de31bae$export$b4958caff08a0960)('async transition', this.id, this.state.id, newState.id);
        if ((0, $41d6970b6c194d5c$export$178881f329fdb81f)(this.state, newState)) {
            (0, $6035edc03de31bae$export$b4958caff08a0960)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $201b4dddb93775dc$export$81b70111112841a0).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = (0, $0946a833271bbb64$export$c753e8669d30c8ad)(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $b9a40c449374f876$exports.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = (0, $0946a833271bbb64$export$c753e8669d30c8ad)(timestamp);
                if (!this._isManualStateEnabled()) (0, $5a67facd091ab2e9$export$6123a44dc2384540)().push((0, $245974498aa6f8a2$export$ee1a7bd1fc9ea85e)((0, $f8153cbe5af4cb94$export$79bf131685ad41d7), this.handleDoneBind));
                this.stopTrace();
                const data = await this.exportData();
                (0, $6035edc03de31bae$export$b4958caff08a0960)('this.parent', this.parent);
                (0, $5a67facd091ab2e9$export$6123a44dc2384540)().push((0, $20bfa9c77292d15c$export$7c957416596ca127)(data));
            }
            return true;
        }
        (0, $6035edc03de31bae$export$b4958caff08a0960)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $f438f1eb8ffe4363$export$d53d07b6034c4560)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $201b4dddb93775dc$export$81b70111112841a0).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $7b4c325a9c3e7899$var$getPageVisibleState();
            (0, $4721409c9bb35384$export$13e680397ec8f3eb).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $6035edc03de31bae$export$b4958caff08a0960)('subscribed', this.id);
                (0, $5a67facd091ab2e9$export$6123a44dc2384540)().push((0, $b2fa67bd4177b64f$export$37863216db4b714d)((0, $f8153cbe5af4cb94$export$79bf131685ad41d7), this.handleDoneBind));
            }
            this.startTrace(this.id);
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $f8153cbe5af4cb94$export$9f2bf58999404c75) && name !== (0, $f8153cbe5af4cb94$export$837e0f79a8056912)) this._mark(name, timestamp);
        else (0, $f438f1eb8ffe4363$export$d53d07b6034c4560)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: (0, $0946a833271bbb64$export$c753e8669d30c8ad)(timestamp)
        });
        this.transition((0, $201b4dddb93775dc$export$81b70111112841a0).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $f8153cbe5af4cb94$export$9f2bf58999404c75), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $f8153cbe5af4cb94$export$837e0f79a8056912), timestamp);
    }
    startTrace(experienceId) {
        if ((0, $6oQI4.fg)('ufo_v1_tracing')) {
            let traceContext = (0, $f913503d2bf7ba32$export$b6ac780db3a3cc77)();
            if (!traceContext) {
                traceContext = {
                    traceId: (0, $6c66e22136933fb5$export$dc6d7ea554bcce10)(),
                    spanId: (0, $463dfa9fda582707$export$295213bc4d0c54ad)()
                };
                (0, $015005ddefb2e480$export$a1002be327997103)(traceContext.traceId, traceContext.spanId, 'ufo_v1.' + experienceId);
            }
            this.traceContext = traceContext;
        }
    }
    stopTrace() {
        if ((0, $6oQI4.fg)('ufo_v1_tracing')) (0, $6ce1e9c9056ffb63$export$17ab21d7be720b)();
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $f438f1eb8ffe4363$export$d53d07b6034c4560)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $4721409c9bb35384$export$13e680397ec8f3eb).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $201b4dddb93775dc$export$81b70111112841a0).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $201b4dddb93775dc$export$81b70111112841a0).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $201b4dddb93775dc$export$81b70111112841a0).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $6035edc03de31bae$export$b4958caff08a0960)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $60b0861ff9f1eeb5$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig,
            ...(0, $6oQI4.fg)('ufo_v1_tracing') ? {
                traceContext: this.traceContext
            } : {}
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.traceContext = null;
        this._until = this.until ? this.until() : null;
    }
    constructor(id, config, instanceId = null){
        this.state = (0, $201b4dddb93775dc$export$81b70111112841a0).NOT_STARTED;
        this.id = void 0;
        this.instanceId = null;
        // for concurrent
        this.parent = null;
        this.category = null;
        this.type = void 0;
        this.performanceType = void 0;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.featureFlags = void 0;
        this.timings = void 0;
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.handleDoneBind = void 0;
        this.uuid = null;
        this.until = void 0;
        this._until = null;
        this.pageVisibleState = void 0;
        this.traceContext = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.config = void 0;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $f8153cbe5af4cb94$export$a12c67b37a306b13).MIXED;
            (0, $4721409c9bb35384$export$13e680397ec8f3eb).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $7b4c325a9c3e7899$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $8c86e30f970857bb$export$cc26007c03242fff).PageLoad || config.performanceType === (0, $8c86e30f970857bb$export$cc26007c03242fff).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
}


class $b5f886cb4ac872ad$export$c00d22927c60484a extends (0, $7b4c325a9c3e7899$export$d31c89db257648c) {
}




var $6oQI4 = parcelRequire("6oQI4");


const $8a3fd6a66d3e7822$export$43a35c1452d55dd7 = ()=>{
    if (!(0, $ff92312187da7e87$export$48d7c418edadb60c)()) return (0, $6oQI4.fg)('platform_bsc_flat_pattern_file_structure');
    return (0, $d9b5d31a7ff7454b$export$8bf1367cc4bb66da)() ?? (0, $6oQI4.fg)('platform_bsc_ssr_flat_pattern_file_format');
};
const $8a3fd6a66d3e7822$export$711aafe8a89fd09c = (value)=>{
    (0, $d9b5d31a7ff7454b$export$2bd306fd2b97e710)(value);
};
const $8a3fd6a66d3e7822$export$38a9c01091046388 = ()=>{
    const decided = (0, $d9b5d31a7ff7454b$export$f9550288b9b1f6e3)();
    if (decided) return decided;
    const patternFormat = $8a3fd6a66d3e7822$export$43a35c1452d55dd7() ? 'flat' : 'trie';
    (0, $d9b5d31a7ff7454b$export$f10a7691f1fb3cb)(patternFormat);
    return patternFormat;
};





var $12d9df73cc17ee57$export$40467b362aa82ae = /*#__PURE__*/ function(Sources) {
    Sources["BIFROST"] = "bifrost";
    Sources["CLOUDFRONT_S3"] = "cloudfrontS3";
    return Sources;
}({});
var $12d9df73cc17ee57$export$c5ae10d7c88c4d3e = /*#__PURE__*/ function(FileType) {
    FileType["COOKIE"] = "COOKIE";
    FileType["LOCAL_STORAGE"] = "LOCAL_STORAGE";
    FileType["SESSION_STORAGE"] = "SESSION_STORAGE";
    FileType["INDEXED_DB"] = "INDEXED_DB";
    return FileType;
}({});
const $12d9df73cc17ee57$var$baseBifrostCommercialPath = 'https://atlassian-cookies.prod-east.frontend.public.atl-paas.net/';
const $12d9df73cc17ee57$var$baseBifrostFedrampPath = 'https://atlassian-cookies.frontend.cdn.atlassian-us-gov-mod.com/';
const $12d9df73cc17ee57$var$generateResourcePath = (perimeter, storageType, useFlatFormat = false)=>{
    const fileName = useFlatFormat ? `categories_v2_${storageType}.json` : `categories_${storageType}.json`;
    switch(perimeter){
        case 'fedramp-moderate':
            return `${$12d9df73cc17ee57$var$baseBifrostFedrampPath}${fileName}`;
        case 'commercial':
            return `${$12d9df73cc17ee57$var$baseBifrostCommercialPath}${fileName}`;
        default:
            return `${$12d9df73cc17ee57$var$baseBifrostCommercialPath}${fileName}`;
    }
};
const $12d9df73cc17ee57$export$5989415260e0cf82 = (useFlatFormat = false)=>{
    return {
        [(0, $0067f33686f0fdf7$export$2506b012eb637f61).Cookies]: $12d9df73cc17ee57$var$generateResourcePath('commercial', "COOKIE", useFlatFormat),
        [(0, $0067f33686f0fdf7$export$2506b012eb637f61).LocalStorage]: $12d9df73cc17ee57$var$generateResourcePath('commercial', "LOCAL_STORAGE", useFlatFormat),
        [(0, $0067f33686f0fdf7$export$2506b012eb637f61).SessionStorage]: $12d9df73cc17ee57$var$generateResourcePath('commercial', "SESSION_STORAGE", useFlatFormat),
        [(0, $0067f33686f0fdf7$export$2506b012eb637f61).IndexedDB]: $12d9df73cc17ee57$var$generateResourcePath('commercial', "INDEXED_DB", useFlatFormat)
    };
};
const $12d9df73cc17ee57$export$9797a362f9385b1a = (useFlatFormat = false)=>{
    return {
        commercial: $12d9df73cc17ee57$export$5989415260e0cf82(useFlatFormat),
        'fedramp-moderate': {
            [(0, $0067f33686f0fdf7$export$2506b012eb637f61).Cookies]: $12d9df73cc17ee57$var$generateResourcePath('fedramp-moderate', "COOKIE", useFlatFormat),
            [(0, $0067f33686f0fdf7$export$2506b012eb637f61).LocalStorage]: $12d9df73cc17ee57$var$generateResourcePath('fedramp-moderate', "LOCAL_STORAGE", useFlatFormat),
            [(0, $0067f33686f0fdf7$export$2506b012eb637f61).SessionStorage]: $12d9df73cc17ee57$var$generateResourcePath('fedramp-moderate', "SESSION_STORAGE", useFlatFormat),
            [(0, $0067f33686f0fdf7$export$2506b012eb637f61).IndexedDB]: $12d9df73cc17ee57$var$generateResourcePath('fedramp-moderate', "INDEXED_DB", useFlatFormat)
        }
    };
};
const $12d9df73cc17ee57$export$1f60178895e28eb8 = (source, perimeter, storageType, UNSAFE__resolvedFlatPatternFileFormat)=>{
    if (UNSAFE__resolvedFlatPatternFileFormat !== undefined) (0, $8a3fd6a66d3e7822$export$711aafe8a89fd09c)(UNSAFE__resolvedFlatPatternFileFormat);
    return $12d9df73cc17ee57$var$generateResourcePath(perimeter, storageType, (0, $8a3fd6a66d3e7822$export$38a9c01091046388)() === 'flat');
};


class $cbde94134d10cc6b$export$e479342c697b82a9 {
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
   * Unpacks the response promise from the categories CDN
   *
   * errors if that request was unsuccessful, returns the categories data otherwise
   *
   */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || response?.json();
        return this.localResponseJsonPromiseCache;
    }
    getStorageControlsDataFromCache() {
        return this.localResponseCache;
    }
    /**
   * The format of the file this loader fetches.
  	* TEMPORARY: Will be removed when the related feature flags are cleaned up (`platform_bsc_ssr_flat_pattern_file_format`,
   * `platform_bsc_flat_pattern_file_structure`)
   */ getFetchedPatternFormat() {
        return this.fetchedPatternFormat;
    }
    async loadStorageControlsData() {
        const isFetchTrackingSampled = !Math.floor(Math.random() * 100);
        let fetchExperience = null;
        if (isFetchTrackingSampled) {
            fetchExperience = new (0, $b5f886cb4ac872ad$export$c00d22927c60484a)('browser-storage-controls-fetch-time', {
                type: (0, $8c86e30f970857bb$export$994164cf3ae1cc9a).Load,
                performanceType: (0, $8c86e30f970857bb$export$cc26007c03242fff).Custom,
                platform: {
                    component: 'browser-storage-controls'
                }
            });
            fetchExperience.start();
        }
        if (this.localResponseCache) {
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            // Record what we actually fetched, so pattern matching never has to re-evaluate the
            // rollout gate to work out how to read it. clearStorageControlsDataCache() drops the
            // payload, so a re-fetch re-records from that loader's own format. A malformed response
            // can parse to a primitive, which cannot carry the field — those fall back to the legacy
            // trie reading, and match nothing either way.
            if (typeof this.localResponseCache === 'object' && this.localResponseCache !== null) this.localResponseCache.patternFormat = this.fetchedPatternFormat;
            (0, $d9b5d31a7ff7454b$export$491d0e6c401a0697)(new Date().toISOString().slice(0, 10));
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } catch (e) {
            if (fetchExperience) fetchExperience.failure({
                metadata: {
                    error: String(e)
                }
            });
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
    constructor(storageType, perimeter){
        this.cacheUrl = void 0;
        /**
     * The format of the file `cacheUrl` points at — the layout this process decided to fetch. Read from
     * that single decision rather than passed in, so the URL and the format recorded on the fetched
     * payload cannot come from different gate evaluations.
     *
     * TEMPORARY: Will be removed when the related feature flags are cleaned up (`platform_bsc_ssr_flat_pattern_file_format`,
     * `platform_bsc_flat_pattern_file_structure`)
     */ this.fetchedPatternFormat = void 0;
        /**
     * Cache variable for storing categorized cookies cache
     */ this.localResponseCache = void 0;
        /**
     * Cache variable for storing a promise that's been fired by a different invocation of loadStorageControls
     *
     * Allows for many invocations to happen simultaneously, and for only one fetch to go out
     */ this.localResponsePromiseCache = void 0;
        /**
     * Cache variable for storing the promise returned from the response object's json method
     *
     * Ensures we don't invoke response.json multiple times
     */ this.localResponseJsonPromiseCache = void 0;
        // Asked for, not passed in: whoever constructs a loader gets the layout this process already
        // decided to fetch, so no caller can hand it a format that disagrees with everyone else's.
        this.fetchedPatternFormat = (0, $8a3fd6a66d3e7822$export$38a9c01091046388)();
        // Auto-detect perimeter from the Atl-Ctx-Perimeter cookie when not explicitly provided.
        // isFedrampModerate() reads the cookie set by the platform; if absent, the perimeter is commercial.
        // Gated by platform_bsc_auto_detect_perimeter for safe rollout.
        // Wrapped in try/catch to ensure a cookie-read failure never breaks BSC initialisation.
        const detectPerimeter = ()=>{
            try {
                return (0, $7FIrY.isFedrampModerate)() ? 'fedramp-moderate' : 'commercial';
            } catch (e) {
                (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).errorWithOperationalEvent({
                    action: 'detectPerimeterError',
                    message: e?.message || 'Failed to detect perimeter via isFedrampModerate'
                });
                return 'commercial';
            }
        };
        const resolvedPerimeter = perimeter ?? ((0, $6oQI4.fg)('platform_bsc_auto_detect_perimeter') ? detectPerimeter() : 'commercial');
        const useFlatFormat = this.fetchedPatternFormat === 'flat';
        const cacheUrlLookup = (0, $12d9df73cc17ee57$export$9797a362f9385b1a)(useFlatFormat)[resolvedPerimeter] || (0, $12d9df73cc17ee57$export$5989415260e0cf82)(useFlatFormat);
        this.cacheUrl = cacheUrlLookup[storageType];
    }
}





const $5eed1bf229e32cb0$export$882c4530c58781d8 = ({ webStorageEnabled: webStorageEnabled, indexedDbEnabled: indexedDbEnabled, disableWebStorageConsentChecks: disableWebStorageConsentChecks, packageLogLevel: packageLogLevel, allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides, allowUncategorizedItemsInIndexedDBOverrides: allowUncategorizedItemsInIndexedDBOverrides, disableIndexedDbConsentChecks: disableIndexedDbConsentChecks, __UNSAFE_shouldEnforceKeyForRollout: __UNSAFE_shouldEnforceKeyForRollout, localConsentMode: localConsentMode = false, product: product = 'all', perimeter: perimeter, analyticsEnabled: analyticsEnabled = true, userId: userId, cloudId: cloudId, overrideOnceParams: overrideOnceParams = false } = {})=>{
    (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug('Initialize global state invoked');
    const productGlobalState = (0, $d9b5d31a7ff7454b$export$9dfdd17bbd03b460)();
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!productGlobalState || productGlobalState == null || productGlobalState === 'all') && product) (0, $d9b5d31a7ff7454b$export$725ef39b428c0dc2)({
        productGlobalState: product
    });
    // Treating webStorageEnabled, indexedDbEnabled, and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    const webStorageControlsEnabledGlobalState = (0, $d9b5d31a7ff7454b$export$d96c3b0fb6d35c5d)();
    if (webStorageEnabled !== undefined && webStorageControlsEnabledGlobalState === undefined) (0, $d9b5d31a7ff7454b$export$725ef39b428c0dc2)({
        webStorageControlsEnabledGlobalState: webStorageEnabled && !(0, $6oQI4.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $6oQI4.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    const indexedDbControlsEnabledGlobalState = (0, $d9b5d31a7ff7454b$export$c8554d68c78456d3)();
    if (indexedDbEnabled !== undefined && indexedDbControlsEnabledGlobalState === undefined) (0, $d9b5d31a7ff7454b$export$725ef39b428c0dc2)({
        indexedDbControlsEnabledGlobalState: indexedDbEnabled && !(0, $6oQI4.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $6oQI4.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    // `disableWebStorageConsentChecks` is sticky like the other controls flags above and
    // mirrors the behaviour of `disableIndexedDbConsentChecks`. When the caller does not
    // explicitly pass a value, the global state is left undefined and the public getter
    // (`getBscGlobalState`) reports `false` by default. It only takes effect when the
    // matching `webStorageEnabled` is `true` — see the consumer in `initializeControls`.
    const disableWebStorageConsentChecksGlobalState = (0, $d9b5d31a7ff7454b$export$ea650e4f51ec84d8)();
    if (disableWebStorageConsentChecks !== undefined && disableWebStorageConsentChecksGlobalState === undefined) (0, $d9b5d31a7ff7454b$export$725ef39b428c0dc2)({
        disableWebStorageConsentChecksGlobalState: disableWebStorageConsentChecks
    });
    const allowUncategorizedCookiesInOverridesGlobalState = (0, $d9b5d31a7ff7454b$export$fa1f6ebb49ec4b30)();
    if (allowUncategorizedCookiesInOverrides !== undefined && allowUncategorizedCookiesInOverridesGlobalState === undefined) (0, $d9b5d31a7ff7454b$export$725ef39b428c0dc2)({
        allowUncategorizedCookiesInOverridesGlobalState: allowUncategorizedCookiesInOverrides
    });
    // `allowUncategorizedItemsInWebStorageOverrides` is the web-storage-only counterpart to
    // `allowUncategorizedCookiesInOverrides`. It is sticky in the same way, and only takes
    // effect when web-storage controls are enabled. It does not affect cookies.
    const allowUncategorizedItemsInWebStorageOverridesGlobalState = (0, $d9b5d31a7ff7454b$export$b60c6437117dfaf9)();
    if (allowUncategorizedItemsInWebStorageOverrides !== undefined && allowUncategorizedItemsInWebStorageOverridesGlobalState === undefined) (0, $d9b5d31a7ff7454b$export$725ef39b428c0dc2)({
        allowUncategorizedItemsInWebStorageOverridesGlobalState: allowUncategorizedItemsInWebStorageOverrides
    });
    // `allowUncategorizedItemsInIndexedDBOverrides` is the IDB-only counterpart to
    // `allowUncategorizedItemsInWebStorageOverrides`. It is sticky in the same way, and only
    // takes effect when IndexedDB controls are enabled. It does not affect cookies or web storage.
    const allowUncategorizedItemsInIndexedDBOverridesGlobalState = (0, $d9b5d31a7ff7454b$export$cff869f7e58c9036)();
    if (allowUncategorizedItemsInIndexedDBOverrides !== undefined && allowUncategorizedItemsInIndexedDBOverridesGlobalState === undefined) (0, $d9b5d31a7ff7454b$export$725ef39b428c0dc2)({
        allowUncategorizedItemsInIndexedDBOverridesGlobalState: allowUncategorizedItemsInIndexedDBOverrides
    });
    const disableIndexedDbConsentChecksGlobalState = (0, $d9b5d31a7ff7454b$export$ea32fe1e8610fd3b)();
    if (disableIndexedDbConsentChecks !== undefined && disableIndexedDbConsentChecksGlobalState === undefined) (0, $d9b5d31a7ff7454b$export$725ef39b428c0dc2)({
        disableIndexedDbConsentChecksGlobalState: disableIndexedDbConsentChecks
    });
    // Sticky on first set, mirroring the consent-check flags above.
    const __UNSAFE_shouldEnforceKeyForRolloutGlobalState = (0, $d9b5d31a7ff7454b$export$45364c2f8f3ebde3)();
    if (__UNSAFE_shouldEnforceKeyForRollout !== undefined && __UNSAFE_shouldEnforceKeyForRolloutGlobalState === undefined) (0, $d9b5d31a7ff7454b$export$725ef39b428c0dc2)({
        __UNSAFE_shouldEnforceKeyForRolloutGlobalState: __UNSAFE_shouldEnforceKeyForRollout
    });
    // All other state can only be initialized once and is defaulted if not passed on the first initialization.
    // overrideOnceParams allows a subsequent call (e.g. from initializeControls) to bypass this guard
    // and re-apply these parameters, correcting values that were defaulted by an earlier accidental call
    // (e.g. from ConsentBannerImpl before initializeControls has run).
    if ((0, $d9b5d31a7ff7454b$export$8835d45f445e6ba4)() && !overrideOnceParams) return;
    // Force local consent mode when ConsentHub is not enabled because ConsentHub is
    // not hydrated in the perimeter as of this comment
    const localConsentModeGlobalState = localConsentMode || !(0, $25T3r.isFeatureEnabled)('consent-platform', 'consenthub');
    const cookiesCacheLoader = new (0, $cbde94134d10cc6b$export$e479342c697b82a9)((0, $0067f33686f0fdf7$export$2506b012eb637f61).Cookies, perimeter);
    const localStorageCacheLoader = new (0, $cbde94134d10cc6b$export$e479342c697b82a9)((0, $0067f33686f0fdf7$export$2506b012eb637f61).LocalStorage, perimeter);
    const sessionStorageCacheLoader = new (0, $cbde94134d10cc6b$export$e479342c697b82a9)((0, $0067f33686f0fdf7$export$2506b012eb637f61).SessionStorage, perimeter);
    const indexedDBCacheLoader = new (0, $cbde94134d10cc6b$export$e479342c697b82a9)((0, $0067f33686f0fdf7$export$2506b012eb637f61).IndexedDB, perimeter);
    const updates = {
        localConsentModeGlobalState: localConsentModeGlobalState,
        analyticsEnabledGlobalState: analyticsEnabled,
        perimeterGlobalState: perimeter,
        cookiesCacheLoader: cookiesCacheLoader,
        localStorageCacheLoader: localStorageCacheLoader,
        sessionStorageCacheLoader: sessionStorageCacheLoader,
        indexedDBCacheLoader: indexedDBCacheLoader,
        packageLogLevelGlobalState: packageLogLevel,
        hasInitialized: true
    };
    if (cloudId) updates.cloudIdGlobalState = cloudId;
    if (userId) updates.userIdGlobalState = userId;
    (0, $d9b5d31a7ff7454b$export$725ef39b428c0dc2)(updates);
    // Invalidate the resolved Logger level so any callers that triggered an
    // early `Logger.*` call before init pick up the new `packageLogLevel`.
    (0, $79053f52f58eeaa6$export$977223726df102da)();
};




var $eWNrv = parcelRequire("eWNrv");

var $6oQI4 = parcelRequire("6oQI4");





function $c214649aca695fe2$var$isCategoryRevoked({ category: category, preferences: preferences }) {
    if (category === (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).StrictlyNecessary) return false;
    if (!preferences) return false;
    return !preferences[category];
}
function $c214649aca695fe2$var$yieldToMain() {
    return new Promise((resolve)=>setTimeout(resolve, 0));
}
const $c214649aca695fe2$var$ITEMS_PER_YIELD = 50;
// Per-run enumeration cap. Yielding to the main thread every ITEMS_PER_YIELD items is independent
// of the limit, so the loop stays cooperative however high this is set.
const $c214649aca695fe2$var$ENUMERATION_LIMIT = 10000;
const $c214649aca695fe2$export$54394d3cfbbf53d0 = 1000;
// `deleteDatabase` completes only once every other connection to that database closes, which the
// browser asks for by firing `versionchange` on each of them. Nothing obliges a holder to listen, so
// the wait needs a bound. Confirmations run concurrently, making this the cost to a run rather than
// the cost per database.
const $c214649aca695fe2$var$IDB_DELETE_CONFIRM_TIMEOUT_MS = 500;
function $c214649aca695fe2$var$isRunningInFrame() {
    try {
        return window.top !== window.self;
    } catch  {
        // A cross-origin read of `window.top` throws, which itself proves we are framed.
        return true;
    }
}
/**
 * Resolves for every outcome rather than rejecting, so one database cannot fail a whole run.
 *
 * `blocked` is deliberately not handled: it is not an outcome. Another open connection leaves the
 * request pending, and `success` still arrives if those connections close, so treating `blocked` as
 * a failure would report a delete that then went through as undeleted. The deadline decides instead
 * — unblocked in time counts as deleted, still blocked when it expires does not.
 */ function $c214649aca695fe2$var$deleteDatabaseAndConfirm(idb, name) {
    return new Promise((resolve)=>{
        let settled = false;
        let timeoutId;
        const settle = (deleted)=>{
            if (settled) return;
            settled = true;
            if (timeoutId !== undefined) clearTimeout(timeoutId);
            resolve(deleted);
        };
        const request = idb.deleteDatabase(name);
        request.onsuccess = ()=>settle(true);
        request.onerror = ()=>{
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn(`cleanupStorage: failed to delete IndexedDB "${name}": ${request.error?.message ?? ''}`);
            settle(false);
        };
        timeoutId = setTimeout(()=>settle(false), $c214649aca695fe2$var$IDB_DELETE_CONFIRM_TIMEOUT_MS);
    });
}
/**
 * A cookie is identified by name + domain + path, and `document.cookie` exposes only the name. An
 * expiry therefore has to guess the other two, and a guess that misses is silently accepted by the
 * browser, so reading the cookie back is the only way to know it went away.
 *
 * Two scopes are tried: host-only, then the served host as an explicit `domain`, because scoping to
 * `Domain=<current host>` is a common library default that a host-only expiry cannot match.
 *
 * Known limitations, all reported as `false` rather than papered over:
 *
 * - **No domain above the served host is tried.** A cookie on a parent or registrable domain — where
 *   the vendor tags we embed (`_ga`, `_fbp`, `_gcl_au`) and our own cross-property cookies live — is
 *   out of reach.
 * - **Non-root paths are never tried.** js-cookie defaults to `path=/`.
 * - **`HttpOnly` cookies are invisible here**, so they are never even enumerated.
 */ function $c214649aca695fe2$var$deleteCookieAndConfirm(key) {
    // `__Secure-`/`__Host-` names are rejected unless the expiring `Set-Cookie` also carries
    // `Secure`. It is not part of a cookie's identity so it is harmless on ordinary cookies, but a
    // non-secure origin ignores the whole header, so only send it where it can take effect.
    const secure = window.location.protocol === 'https:' ? {
        secure: true
    } : {};
    // `atl-set-cookie` marks both expiries below as the package's own writes, which is what the
    // `document.cookie` setter override checks before passing one through. Without it the override
    // consent-checks the expiry against the very category the cookie is being deleted for, takes its
    // blocked branch, and never calls the original setter.
    (0, $eWNrv.default).remove(key, {
        ...secure,
        'atl-set-cookie': true
    });
    if ((0, $eWNrv.default).get(key) === undefined) return true;
    // Still there, so the cookie carries an explicit `Domain`. Two names make even the served-host
    // attempt pointless: a `__Host-` cookie must be host-only, and on a single-label host
    // (`localhost`, an intranet name) `.localhost` matches nothing.
    const { hostname: hostname } = window.location;
    if (key.startsWith('__Host-') || hostname.split('.').length < 2) return false;
    (0, $eWNrv.default).remove(key, {
        ...secure,
        domain: `.${hostname}`,
        'atl-set-cookie': true
    });
    return (0, $eWNrv.default).get(key) === undefined;
}
async function $c214649aca695fe2$export$e6332b39565fb2b3() {
    // One read per run, outside the try so the catch path agrees. `fg()` reads gate config that can
    // change mid-run and this function's p99 is seconds, so re-reading risks a run that deletes
    // while reporting `dry-run`.
    const deletionMode = (0, $6oQI4.fg)('platform_bsc_cleanup_revoked_storage_live_delete') ? 'live' : 'dry-run';
    const isLiveDelete = deletionMode === 'live';
    try {
        const cleanupStartTime = performance.now();
        const globalState = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)();
        const preferences = await (0, $72a0ad571a2b0dec$export$1de6a888ae076ff8)();
        const localStorage = (0, $07c6527a5ae2a4cf$export$14921bfc334334c0)((0, $4a82c714b0d3c5be$export$259e3a861f28589b).LocalStorage);
        const sessionStorage = (0, $07c6527a5ae2a4cf$export$14921bfc334334c0)((0, $4a82c714b0d3c5be$export$259e3a861f28589b).SessionStorage);
        const idb = window.indexedDB;
        const productName = globalState.product;
        const [localStorageCache, sessionStorageCache, cookieCache, indexedDBCache] = await Promise.all([
            globalState.loadCache((0, $0067f33686f0fdf7$export$2506b012eb637f61).LocalStorage),
            globalState.loadCache((0, $0067f33686f0fdf7$export$2506b012eb637f61).SessionStorage),
            globalState.loadCache((0, $0067f33686f0fdf7$export$2506b012eb637f61).Cookies),
            globalState.loadCache((0, $0067f33686f0fdf7$export$2506b012eb637f61).IndexedDB)
        ]);
        const revokedItems = [];
        const uncategorizedItems = [];
        let hitEnumerationLimit = false;
        let itemsProcessed = 0;
        let deletionCount = 0;
        const reportCoverage = (0, $6oQI4.fg)('platform_bsc_cleanup_coverage_telemetry');
        const skippedTypes = [];
        const undeletedItems = [];
        const inFrame = reportCoverage ? $c214649aca695fe2$var$isRunningInFrame() : undefined;
        const pendingIdbConfirmations = [];
        // localStorage
        const shouldDeleteWebStorage = !globalState.disableWebStorageConsentChecks && globalState.webStorageEnabled;
        if (!localStorageCache) skippedTypes.push({
            storageType: 'localStorage',
            reason: 'cacheUnavailable'
        });
        else {
            // Cleanup is an internal operation, so it works on the store the wrapper wraps rather than
            // through the wrapper: the read-back below is untrapped, where the wrapper's `getItem`
            // emits `usedAtlBrowserStorageGetItem` on every call. Keys are taken up front so a removal
            // cannot shift the items still to be visited. `Object.keys` would be shorter but omits any
            // item whose name collides with a `Storage` own property — WebKit hides a stored `length`
            // from it, where `key(i)` still reports it.
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const localStore = localStorage.storage;
            const localKeys = Array.from({
                length: localStore.length
            }, (_, i)=>localStore.key(i)).filter((key)=>key !== null);
            for (const key of localKeys){
                if (itemsProcessed >= $c214649aca695fe2$var$ENUMERATION_LIMIT) {
                    hitEnumerationLimit = true;
                    break;
                }
                if ((itemsProcessed + 1) % $c214649aca695fe2$var$ITEMS_PER_YIELD === 0) await $c214649aca695fe2$var$yieldToMain();
                const category = (0, $fbf524e7c49c5e71$export$69d5b68d01f4a366)(key, localStorageCache, productName);
                if (category === null || category === (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Unknown) uncategorizedItems.push({
                    key: key,
                    storageType: 'localStorage'
                });
                else if ($c214649aca695fe2$var$isCategoryRevoked({
                    category: category,
                    preferences: preferences
                })) {
                    const item = {
                        key: key,
                        storageType: 'localStorage',
                        category: category
                    };
                    revokedItems.push(item);
                    if (shouldDeleteWebStorage && isLiveDelete) {
                        localStore.removeItem(key);
                        const removed = localStore.getItem(key) === null;
                        item.deleted = removed;
                        if (!removed) undeletedItems.push(item);
                        deletionCount++;
                    }
                }
                itemsProcessed++;
            }
        }
        // sessionStorage
        if (hitEnumerationLimit) skippedTypes.push({
            storageType: 'sessionStorage',
            reason: 'enumerationLimit'
        });
        else if (!sessionStorageCache) skippedTypes.push({
            storageType: 'sessionStorage',
            reason: 'cacheUnavailable'
        });
        else {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const sessionStore = sessionStorage.storage;
            const sessionKeys = Array.from({
                length: sessionStore.length
            }, (_, i)=>sessionStore.key(i)).filter((key)=>key !== null);
            for (const key of sessionKeys){
                if (itemsProcessed >= $c214649aca695fe2$var$ENUMERATION_LIMIT) {
                    hitEnumerationLimit = true;
                    break;
                }
                if ((itemsProcessed + 1) % $c214649aca695fe2$var$ITEMS_PER_YIELD === 0) await $c214649aca695fe2$var$yieldToMain();
                const category = (0, $fbf524e7c49c5e71$export$69d5b68d01f4a366)(key, sessionStorageCache, productName);
                if (category === null || category === (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Unknown) uncategorizedItems.push({
                    key: key,
                    storageType: 'sessionStorage'
                });
                else if ($c214649aca695fe2$var$isCategoryRevoked({
                    category: category,
                    preferences: preferences
                })) {
                    const item = {
                        key: key,
                        storageType: 'sessionStorage',
                        category: category
                    };
                    revokedItems.push(item);
                    if (shouldDeleteWebStorage && isLiveDelete) {
                        sessionStore.removeItem(key);
                        const removed = sessionStore.getItem(key) === null;
                        item.deleted = removed;
                        if (!removed) undeletedItems.push(item);
                        deletionCount++;
                    }
                }
                itemsProcessed++;
            }
        }
        // cookies
        if (hitEnumerationLimit) skippedTypes.push({
            storageType: 'cookie',
            reason: 'enumerationLimit'
        });
        else if (!cookieCache) skippedTypes.push({
            storageType: 'cookie',
            reason: 'cacheUnavailable'
        });
        else for (const key of Object.keys((0, $eWNrv.default).get())){
            if (itemsProcessed >= $c214649aca695fe2$var$ENUMERATION_LIMIT) {
                hitEnumerationLimit = true;
                break;
            }
            if ((itemsProcessed + 1) % $c214649aca695fe2$var$ITEMS_PER_YIELD === 0) await $c214649aca695fe2$var$yieldToMain();
            const category = (0, $fbf524e7c49c5e71$export$69d5b68d01f4a366)(key, cookieCache, productName);
            if (category === null || category === (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Unknown) uncategorizedItems.push({
                key: key,
                storageType: 'cookie'
            });
            else if ($c214649aca695fe2$var$isCategoryRevoked({
                category: category,
                preferences: preferences
            })) {
                const item = {
                    key: key,
                    storageType: 'cookie',
                    category: category
                };
                revokedItems.push(item);
                // There's no corresponding `shouldDeleteWebStorage` for cookies as they have no reporting-only mode.
                if (isLiveDelete) {
                    item.deleted = $c214649aca695fe2$var$deleteCookieAndConfirm(key);
                    if (!item.deleted) undeletedItems.push(item);
                    deletionCount++;
                }
            }
            itemsProcessed++;
        }
        // IndexedDB
        const shouldDeleteIdb = !globalState.disableIndexedDbConsentChecks && globalState.indexedDbEnabled;
        if (hitEnumerationLimit) skippedTypes.push({
            storageType: 'indexedDB',
            reason: 'enumerationLimit'
        });
        else if (!indexedDBCache) skippedTypes.push({
            storageType: 'indexedDB',
            reason: 'cacheUnavailable'
        });
        else if (typeof idb?.databases !== 'function') // Safari and Firefox do not implement `indexedDB.databases()`.
        skippedTypes.push({
            storageType: 'indexedDB',
            reason: 'unsupported'
        });
        else try {
            const dbs = await idb.databases();
            for (const db of dbs){
                if (itemsProcessed >= $c214649aca695fe2$var$ENUMERATION_LIMIT) {
                    hitEnumerationLimit = true;
                    break;
                }
                if ((itemsProcessed + 1) % $c214649aca695fe2$var$ITEMS_PER_YIELD === 0) await $c214649aca695fe2$var$yieldToMain();
                const name = db.name;
                if (name === undefined) continue;
                const category = (0, $fbf524e7c49c5e71$export$69d5b68d01f4a366)(name, indexedDBCache, productName);
                if (category === null || category === (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Unknown) uncategorizedItems.push({
                    key: name,
                    storageType: 'indexedDB'
                });
                else if ($c214649aca695fe2$var$isCategoryRevoked({
                    category: category,
                    preferences: preferences
                })) {
                    const item = {
                        key: name,
                        storageType: 'indexedDB',
                        category: category
                    };
                    revokedItems.push(item);
                    if (shouldDeleteIdb && isLiveDelete) {
                        // Collected, not awaited inline: serial waits would make the worst case the sum of
                        // the per-database timeouts instead of the longest one.
                        pendingIdbConfirmations.push($c214649aca695fe2$var$deleteDatabaseAndConfirm(idb, name).then((deleted)=>{
                            item.deleted = deleted;
                            if (!deleted) undeletedItems.push(item);
                        }));
                        deletionCount++;
                    }
                }
                itemsProcessed++;
            }
        } catch  {
            // idb.databases() unavailable or threw — skip IDB entirely
            skippedTypes.push({
                storageType: 'indexedDB',
                reason: 'error'
            });
        }
        if (pendingIdbConfirmations.length > 0) await Promise.all(pendingIdbConfirmations);
        if (deletionCount > 0) (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
            action: 'storageCleanupDeleted',
            attributes: {
                deletedCount: deletionCount - undeletedItems.length,
                undeletedCount: undeletedItems.length
            }
        });
        (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
            action: 'storageCleanupCategorized',
            attributes: {
                durationMs: Math.round(performance.now() - cleanupStartTime),
                deletionMode: deletionMode,
                revokedCount: revokedItems.length,
                revokedItems: revokedItems.map(({ storageType: storageType, key: key, category: category })=>`${storageType} ${key} ${category}`),
                uncategorizedCount: uncategorizedItems.length,
                uncategorizedItems: uncategorizedItems.map(({ storageType: storageType, key: key })=>`${storageType} ${key}`),
                hitEnumerationLimit: hitEnumerationLimit,
                hitRevokedCountCeiling: revokedItems.length > $c214649aca695fe2$export$54394d3cfbbf53d0,
                ...isLiveDelete ? {
                    undeletedCount: undeletedItems.length,
                    undeletedItems: undeletedItems.map(({ storageType: storageType, key: key })=>`${storageType} ${key}`)
                } : {},
                ...reportCoverage ? {
                    // Empty rather than omitted, so an absent attribute means "gate off" and not
                    // "full coverage".
                    skippedTypes: skippedTypes.map(({ storageType: storageType, reason: reason })=>`${storageType}:${reason}`).join(','),
                    inFrame: inFrame
                } : {}
            }
        });
        return {
            deletionMode: deletionMode,
            revokedItems: revokedItems,
            uncategorizedItems: uncategorizedItems,
            hitEnumerationLimit: hitEnumerationLimit,
            ...reportCoverage ? {
                skippedTypes: skippedTypes,
                inFrame: inFrame
            } : {}
        };
    } catch (error) {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'storageCleanupError',
            message: `cleanupStorage failed: ${error?.message ?? 'no message'}`
        });
        return {
            deletionMode: deletionMode,
            revokedItems: [],
            uncategorizedItems: [],
            hitEnumerationLimit: false
        };
    }
}




var $6oQI4 = parcelRequire("6oQI4");





/**
 * Tracks which uncategorized storage-item keys have already emitted an
 * `uncategorizedWebStorageItemSet` track event this session, so repeated writes
 * of the same unknown key don't emit duplicate events.
 *
 * State is module-level (per page load), which gives us the "per session"
 * semantic for free — it resets naturally on reload. Same pattern as
 * `ItemKeyCache` (item-key-cache-service) and the logger error-event throttle.
 *
 * Keys are scoped by storage type so the same key name in different storage
 * types (e.g. a cookie and a localStorage item both named `foo`) remain
 * distinct reportable signals.
 */ class $d5cc4c11d82b8bd7$var$UncategorizedItemReportCacheService {
    compositeKey(storageType, itemKey) {
        return `${storageType}::${itemKey}`;
    }
    markReported(storageType, itemKey) {
        this.reportedKeys.add(this.compositeKey(storageType, itemKey));
    }
    wasReported(storageType, itemKey) {
        return this.reportedKeys.has(this.compositeKey(storageType, itemKey));
    }
    // Test-only helper to reset the per-process cache between tests.
    __reset() {
        this.reportedKeys.clear();
    }
    constructor(){
        this.reportedKeys = new Set();
    }
}
let $d5cc4c11d82b8bd7$var$cacheInstance;
/**
 * Lazily creates the cache on first use.
 */ function $d5cc4c11d82b8bd7$var$getCache() {
    if (!$d5cc4c11d82b8bd7$var$cacheInstance) $d5cc4c11d82b8bd7$var$cacheInstance = new $d5cc4c11d82b8bd7$var$UncategorizedItemReportCacheService();
    return $d5cc4c11d82b8bd7$var$cacheInstance;
}
function $d5cc4c11d82b8bd7$export$270367a42ceba9fe() {
    $d5cc4c11d82b8bd7$var$cacheInstance = undefined;
}
function $d5cc4c11d82b8bd7$export$eda682c722f364aa(storageType, itemKey) {
    return !$d5cc4c11d82b8bd7$var$getCache().wasReported(storageType, itemKey);
}
function $d5cc4c11d82b8bd7$export$c81f34d18a3c37c3(storageType, itemKey) {
    return ()=>$d5cc4c11d82b8bd7$var$getCache().markReported(storageType, itemKey);
}



const $149de82d93275ad3$export$b7364c41ddbfdb0a = (originalSetter)=>(originalCookieValue)=>{
        const cookieSetByPackage = originalCookieValue.includes('atl-set-cookie');
        if (cookieSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetter.apply(document, [
                originalCookieValue
            ]);
        } catch (e) {
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `document.cookie setter failed to set cookie set by package. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false
                }
            });
        }
        const extensionSignals = (0, $6oQI4.fg)('platform_bsc_browser_extension_detection') ? (0, $efbbf032b63c0118$export$9a9299a14dc0c1cb)() : undefined;
        // Set cookie function reports failure by throwing and callers such as the availability probes
        // depend on that, so a synchronous write failure has to leave this override. Collected here
        // rather than thrown inline, because the handler that catches it sits inside
        // another handler that would report the same error again.
        let setCookieFailure;
        try {
            // Raw cookies and query params can contain sensitive PII/UGC we can't store, so we want to
            // strip that out before we log it out to our analytics client.
            const sanitizedCookieKey = originalCookieValue.slice(0, originalCookieValue.indexOf('=')) || '';
            (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
                action: 'usedDocumentCookie',
                attributes: {
                    cookieKey: sanitizedCookieKey,
                    outsidePackage: !cookieSetByPackage
                }
            });
            try {
                const productName = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().product;
                // MaybeSync skips the promise entirely once categories and preferences are loaded, which
                // is what keeps the write and any throw from it synchronous.
                const runProcessingCheck = (0, $6oQI4.fg)('platform_bsc_catch_deferred_storage_errors') ? (0, $fbf524e7c49c5e71$export$ffbb879d3fefb45c) : (0, $fbf524e7c49c5e71$export$e7a3dca206fec6e2);
                // Attempt to set a known cookie that was set from outside the package
                const processingCheck = runProcessingCheck({
                    itemKey: sanitizedCookieKey,
                    allowedCallback: ()=>{
                        return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory })=>{
                        if (!itemHasCategory && (0, $d5cc4c11d82b8bd7$export$eda682c722f364aa)((0, $0067f33686f0fdf7$export$2506b012eb637f61).Cookies, sanitizedCookieKey)) (0, $61449d71f1ebd90f$export$1ba525b8a711eaac)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: (0, $0067f33686f0fdf7$export$2506b012eb637f61).Cookies,
                                productName: productName,
                                originalItemKey: sanitizedCookieKey,
                                itemCategory: itemCategory ?? null,
                                cacheLoadedDate: (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().cacheLoadedDate ?? null
                            },
                            onSent: (0, $d5cc4c11d82b8bd7$export$c81f34d18a3c37c3)((0, $0067f33686f0fdf7$export$2506b012eb637f61).Cookies, sanitizedCookieKey)
                        });
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                        else {
                            if (!itemHasCategory) (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn(`document.cookie setter for '${sanitizedCookieKey}' was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${sanitizedCookieKey}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
                            return;
                        }
                    },
                    storageType: (0, $0067f33686f0fdf7$export$2506b012eb637f61).Cookies,
                    productName: productName,
                    extensionSignals: extensionSignals
                });
                if ((0, $6oQI4.fg)('platform_bsc_catch_deferred_storage_errors') && (0, $fbf524e7c49c5e71$export$4369c812aac99591)(processingCheck)) processingCheck.catch((e)=>{
                    (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).errorWithOperationalEvent({
                        action: 'usedDocumentCookieError',
                        message: `Failed to set cookie. ${e?.message || ''}`,
                        attributes: {
                            cookieKey: sanitizedCookieKey
                        }
                    });
                });
            } catch (e) {
                (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).errorWithOperationalEvent({
                    action: 'usedDocumentCookieError',
                    message: `Failed to set cookie. ${e.message || ''}`,
                    attributes: {
                        cookieKey: sanitizedCookieKey
                    }
                });
                if ((0, $6oQI4.fg)('platform_bsc_catch_deferred_storage_errors')) setCookieFailure = e;
            }
        } catch (e) {
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `Failed to send document.cookie setter event. ${e.message || ''}`
            });
        }
        if ((0, $6oQI4.fg)('platform_bsc_catch_deferred_storage_errors') && setCookieFailure) throw setCookieFailure;
    };


const $f39752ec2f5fdbea$export$50a17589ab8bbee4 = ()=>{
    const documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
    const originalSetter = documentCookieProperty?.set;
    const originalGetter = documentCookieProperty?.get;
    if (!originalSetter || !originalGetter) {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn('No document.cookie capabilities found');
        return;
    }
    // Override document.cookie setter
    Object.defineProperty(document, 'cookie', {
        get: originalGetter,
        set: (0, $149de82d93275ad3$export$b7364c41ddbfdb0a)(originalSetter),
        configurable: true
    });
};
const $f39752ec2f5fdbea$export$45a5573b04db016c = async ()=>$f39752ec2f5fdbea$export$50a17589ab8bbee4();




var $6oQI4 = parcelRequire("6oQI4");






/**
 * Minimal no-op implementation for SSR environments.
 * Provides the IDBOpenDBRequest interface without relying on EventTarget.
 * This class does not extend EventTarget, making it safe to instantiate in Node.js.
 */ class $b8dffb273639c3a1$export$55ffeaf417e03b66 {
    get error() {
        return this._error;
    }
    get result() {
        return this._result;
    }
    get readyState() {
        return this._readyState;
    }
    get source() {
        return this._source;
    }
    get transaction() {
        return this._transaction;
    }
    // No-op event methods for SSR
    addEventListener() {}
    removeEventListener() {}
    dispatchEvent() {
        return false;
    }
    // Wrapper-specific methods that shouldn't be called in SSR but are part of the interface
    wrapRequest() {
        throw new Error('IDBOpenDBRequestWrapper cannot wrap requests in SSR environment');
    }
    isWrapping() {
        return false;
    }
    getWrappedRequest() {
        return null;
    }
    unbind() {}
    setError(error) {
        this._error = error;
    }
    setResult(result) {
        this._result = result;
    }
    setReadyState(state) {
        this._readyState = state;
    }
    setSource(source) {
        this._source = source;
    }
    setTransaction(transaction) {
        this._transaction = transaction;
    }
    constructor(){
        this._error = null;
        this._result = null;
        this._readyState = 'pending';
        this._source = null;
        this._transaction = null;
        this.onerror = null;
        this.onsuccess = null;
        this.onblocked = null;
        this.onupgradeneeded = null;
    }
}


// Store the browser implementation class here - defined conditionally below
let $d324acd1c3e6cf19$var$BrowserImpl;
/**
 * Browser-only implementation that extends EventTarget.
 * Only defined in browser environments where EventTarget is available.
 * This conditional definition prevents "EventTarget is not defined" errors in SSR.
 */ if (typeof EventTarget !== 'undefined') // Define the class inside this block so it's never parsed in SSR
$d324acd1c3e6cf19$var$BrowserImpl = class IDBOpenDBRequestWrapperImpl extends EventTarget {
    // Implementing IDBRequest readonly properties with getters
    get error() {
        return this._wrappedRequest?.error ?? this._error;
    }
    get result() {
        return this._wrappedRequest?.result ?? this._result;
    }
    get readyState() {
        return this._wrappedRequest?.readyState ?? this._readyState;
    }
    get source() {
        return this._wrappedRequest?.source ?? this._source;
    }
    get transaction() {
        return this._wrappedRequest?.transaction ?? this._transaction;
    }
    /**
     * Wrap an existing IDBOpenDBRequest to proxy its events to this wrapper.
     * Once wrapped, all property getters will delegate to the wrapped request,
     * and all events from the wrapped request will be re-dispatched on this wrapper.
     *
     * @param request - The real IDBOpenDBRequest to wrap
     */ wrapRequest(request) {
        if (this._wrappedRequest) throw new Error('This IDBOpenDBRequestWrapper is already wrapping another request');
        this._wrappedRequest = request;
        // Proxy all events from the wrapped request to this wrapper using bindAll
        this._unbindEventListeners = (0, $04ce8cf050459c71$exports.bindAll)(request, [
            {
                type: 'success',
                listener: (e)=>{
                    this.dispatchEvent(new Event('success', e));
                }
            },
            {
                type: 'error',
                listener: (e)=>{
                    this.dispatchEvent(new Event('error', e));
                }
            },
            {
                type: 'blocked',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('blocked', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            },
            {
                type: 'upgradeneeded',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('upgradeneeded', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            }
        ]);
    }
    /**
     * Check if this mock is wrapping a real request
     */ isWrapping() {
        return this._wrappedRequest !== null;
    }
    /**
     * Get the wrapped request (if any)
     */ getWrappedRequest() {
        return this._wrappedRequest;
    }
    /**
     * Unbind all event listeners attached to the wrapped request.
     * Should be called when the wrapper is no longer needed.
     */ unbind() {
        if (this._unbindEventListeners) {
            this._unbindEventListeners();
            this._unbindEventListeners = null;
        }
        this._wrappedRequest = null;
    }
    /**
     * Set the error property (normally readonly)
     * Only works when not wrapping another request
     */ setError(error) {
        if (this._wrappedRequest) throw new Error('Cannot set error on a wrapping IDBOpenDBRequestWrapper');
        this._error = error;
    }
    /**
     * Set the result property (normally readonly)
     * Only works when not wrapping another request
     */ setResult(result) {
        if (this._wrappedRequest) throw new Error('Cannot set result on a wrapping IDBOpenDBRequestWrapper');
        this._result = result;
    }
    /**
     * Set the readyState property (normally readonly)
     * Only works when not wrapping another request
     */ setReadyState(state) {
        if (this._wrappedRequest) throw new Error('Cannot set readyState on a wrapping IDBOpenDBRequestWrapper');
        this._readyState = state;
    }
    /**
     * Set the source property (normally readonly)
     * Only works when not wrapping another request
     */ setSource(source) {
        if (this._wrappedRequest) throw new Error('Cannot set source on a wrapping IDBOpenDBRequestWrapper');
        this._source = source;
    }
    /**
     * Set the transaction property (normally readonly)
     * Only works when not wrapping another request
     */ setTransaction(transaction) {
        if (this._wrappedRequest) throw new Error('Cannot set transaction on a wrapping IDBOpenDBRequestWrapper');
        this._transaction = transaction;
    }
    /**
     * Override dispatchEvent to also call the corresponding event handler if set
     */ dispatchEvent(event) {
        const result = super.dispatchEvent(event);
        // Call the appropriate event handler if it exists
        switch(event.type){
            case 'error':
                if (this.onerror) this.onerror.call(this, event);
                break;
            case 'success':
                if (this.onsuccess) this.onsuccess.call(this, event);
                break;
            case 'blocked':
                if (this.onblocked) this.onblocked.call(this, event);
                break;
            case 'upgradeneeded':
                if (this.onupgradeneeded) this.onupgradeneeded.call(this, event);
                break;
        }
        return result;
    }
    constructor(...args){
        super(...args);
        this._error = null;
        this._result = null;
        this._readyState = 'pending';
        this._source = null;
        this._transaction = null;
        this._wrappedRequest = null;
        this._unbindEventListeners = null;
        // Event handler properties (can be set directly by consumers)
        this.onerror = null;
        this.onsuccess = null;
        this.onblocked = null;
        this.onupgradeneeded = null;
    }
};
function $d324acd1c3e6cf19$export$4037ef1f5b40c4b6() {
    if ((0, $ff92312187da7e87$export$48d7c418edadb60c)() || typeof EventTarget === 'undefined' || !$d324acd1c3e6cf19$var$BrowserImpl) return new (0, $b8dffb273639c3a1$export$55ffeaf417e03b66)();
    return new $d324acd1c3e6cf19$var$BrowserImpl();
}
const $d324acd1c3e6cf19$export$c69b1cb39abae960 = $d324acd1c3e6cf19$var$BrowserImpl;



function $8e311a4a0e7543ab$export$ae0d255aec75942(enableSSRCheck = true, enableFeatureFlagCheck = true) {
    // Check if running in SSR environment
    if (enableSSRCheck && (0, $ff92312187da7e87$export$48d7c418edadb60c)()) return {
        available: false,
        reason: 'IndexedDB is not available in SSR environment'
    };
    if (!globalThis.indexedDB) return {
        available: false,
        reason: 'IndexedDB is not supported in this browser'
    };
    if (enableFeatureFlagCheck) {
        const globalState = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)();
        if (globalState.indexedDbEnabled === false) return {
            available: true,
            reason: 'Using native IndexedDB: IndexedDB controls are disabled',
            bypassImplementation: true
        };
    }
    return {
        available: true
    };
}
function $8e311a4a0e7543ab$export$a5be9a74f3347ccf(dbName) {
    // Database name should not be empty and should be a string
    return typeof dbName === 'string' && dbName.trim().length > 0;
}
function $8e311a4a0e7543ab$export$396291456af4fc3(version) {
    // Version should be undefined or a positive integer
    if (version === undefined) return true;
    return Number.isInteger(version) && version > 0;
}




// DatabaseBlockedError extends DOMException in browser environments, but DOMException is not
// available in SSR/Node.js, which causes import errors. We conditionally extend DOMException
// only when it is available, falling back to a plain Error in SSR — the same pattern used
// for IDBOpenDBRequestWrapper.
let $25e4fa8b972958ce$var$DatabaseBlockedError;
if (typeof DOMException !== 'undefined') $25e4fa8b972958ce$var$DatabaseBlockedError = class DatabaseBlockedError extends DOMException {
};
else $25e4fa8b972958ce$var$DatabaseBlockedError = class DatabaseBlockedError extends Error {
    constructor(message, name = 'DatabaseBlockedError'){
        super(message), this.name = name;
    }
};
const $25e4fa8b972958ce$var$checkAndSendAnalyticsEvent = async (eventDetails, options = {})=>{
    const wasSetByPackage = (0, $ac2b8707abf64f74$export$ff3c91e80f54f26c).wasSetByPackage((0, $0067f33686f0fdf7$export$2506b012eb637f61).IndexedDB, eventDetails.databaseName);
    const productName = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().product;
    // In reporting-only mode (consent checks disabled for rollout via `disableIndexedDbConsentChecks`,
    // or a per-key `__UNSAFE_shouldEnforceKeyForRollout` opt-out), the database always opens. Without
    // the gate below the event only carries the item's category, so a consumer cannot tell an
    // already-consented database apart from one that *would be blocked* once enforcement is enabled —
    // which is the exact blast-radius signal reporting-only mode exists to provide. When
    // `platform_bsc_idb_reporting_wasrejected` is on we evaluate the consent decision WITHOUT blocking
    // and attach `wasRejected` + `consentChecksDisabled`, mirroring the web-storage reporting-only path
    // in web-storage-service/utils/set-storage-item.ts. (COOK-604)
    const reportWouldBeBlocked = options.consentChecksDisabled === true && (0, $6oQI4.fg)('platform_bsc_idb_reporting_wasrejected');
    let itemCategory;
    let wasRejected;
    if (reportWouldBeBlocked) {
        const { isAllowed: isAllowed, itemCategory: resolvedCategory } = await (0, $fbf524e7c49c5e71$export$17e4a7e00d5b99d9)({
            itemKey: eventDetails.databaseName,
            storageType: (0, $0067f33686f0fdf7$export$2506b012eb637f61).IndexedDB,
            productName: productName
        });
        itemCategory = resolvedCategory;
        wasRejected = !isAllowed;
    } else itemCategory = await (0, $fbf524e7c49c5e71$export$ec8ce5237293e4a4)(eventDetails.databaseName, (0, $0067f33686f0fdf7$export$2506b012eb637f61).IndexedDB, productName);
    const isStrictlyNecessary = itemCategory === (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).StrictlyNecessary;
    // Strictly-necessary and package-set databases never block, so they are excluded from
    // reporting-only telemetry to keep the would-be-blocked signal focused on at-risk databases.
    if (!isStrictlyNecessary && !wasSetByPackage) {
        const categoryAttribute = {
            itemCategory: itemCategory ?? (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Unknown
        };
        const rejectionAttribute = reportWouldBeBlocked ? {
            consentChecksDisabled: true,
            wasRejected: wasRejected
        } : {};
        const attributes = {
            ...eventDetails,
            productName: productName,
            outsidePackage: true,
            ...categoryAttribute,
            ...rejectionAttribute
        };
        // Send analytics event for uncategorized IndexedDB usage
        (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
            action: 'usedAtlIndexedDBOpen',
            attributes: attributes
        });
    }
};
// Keep forwarding `extensionSignals` to `isProcessingAllowedByPreferencesWithCategory` — extension
// writes rely on it to bypass the consent check.
const $25e4fa8b972958ce$var$checkIfAllowedWithCategory = async (dbName, extensionSignals)=>{
    if (!(0, $8e311a4a0e7543ab$export$a5be9a74f3347ccf)(dbName)) {
        const error = new Error('Invalid database name: must be a non-empty string');
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'usedAtlIndexedDBOpenError',
            attributes: {
                dbName: dbName
            },
            message: `IndexedDB open failed: ${error.message}`
        });
        throw error;
    }
    const productName = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().product;
    const { isAllowed: isAllowed, itemCategory: itemCategory } = await (0, $fbf524e7c49c5e71$export$17e4a7e00d5b99d9)({
        itemKey: dbName,
        storageType: (0, $0067f33686f0fdf7$export$2506b012eb637f61).IndexedDB,
        productName: productName,
        extensionSignals: extensionSignals
    });
    return {
        isAllowed: isAllowed,
        itemCategory: itemCategory
    };
};
const $25e4fa8b972958ce$export$5a412306febb78c = (originalOpen)=>(databaseName, version)=>{
        $25e4fa8b972958ce$var$checkAndSendAnalyticsEvent({
            databaseName: databaseName
        }).catch((e)=>{
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).error(`Failed to send IndexedDB open event. ${e.message || ''}`);
        });
        // Always allow the operation to proceed (we're only tracking usage)
        return originalOpen(databaseName, version);
    };
const $25e4fa8b972958ce$export$5721aa15a04b1881 = (originalOpen)=>(databaseName, version)=>{
        const wasSetByPackage = (0, $ac2b8707abf64f74$export$ff3c91e80f54f26c).wasSetByPackage((0, $0067f33686f0fdf7$export$2506b012eb637f61).IndexedDB, databaseName);
        if (wasSetByPackage) return originalOpen(databaseName, version);
        if ((0, $6oQI4.fg)('jfp-magma-selective-storage-enforcement')) {
            // Per-key opt-out: when `disableIndexedDbConsentChecks` is on, `__UNSAFE_shouldEnforceKeyForRollout`
            // can re-enable enforcement for this database name; otherwise fall back to
            // analytics-only behaviour.
            const globalState = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)();
            const enforceThisKey = globalState.__UNSAFE_shouldEnforceKeyForRollout?.(databaseName, (0, $0067f33686f0fdf7$export$2506b012eb637f61).IndexedDB) === true;
            const disableIndexedDbConsentChecks = (globalState.disableIndexedDbConsentChecks ?? false) && !enforceThisKey;
            if (disableIndexedDbConsentChecks) {
                $25e4fa8b972958ce$var$checkAndSendAnalyticsEvent({
                    databaseName: databaseName
                }, {
                    consentChecksDisabled: true
                }).catch((e)=>{
                    (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).error(`Failed to send IndexedDB open event. ${e.message || ''}`);
                });
                return originalOpen(databaseName, version);
            }
        }
        const extensionSignals = (0, $6oQI4.fg)('platform_bsc_browser_extension_detection') ? (0, $efbbf032b63c0118$export$9a9299a14dc0c1cb)() : undefined;
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug(`IndexedDB operation: overridden open on database \"${databaseName}\"`, {
            version: String(version ?? 'unspecified')
        });
        const requestWrapper = (0, $d324acd1c3e6cf19$export$4037ef1f5b40c4b6)();
        // Always resolve category information for telemetry and so the uncategorized passthrough
        // can distinguish an unknown database from one the user denied.
        const allowUncategorizedOverride = !!(0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().allowUncategorizedItemsInIndexedDBOverrides;
        const allowedPromise = $25e4fa8b972958ce$var$checkIfAllowedWithCategory(databaseName, extensionSignals).then(({ isAllowed: isAllowed, itemCategory: itemCategory })=>({
                isAllowed: isAllowed,
                itemCategory: itemCategory ?? (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Unknown,
                categoryAttribute: {
                    itemCategory: itemCategory ?? (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Unknown
                }
            }));
        allowedPromise.then(({ isAllowed: isAllowed, itemCategory: itemCategory, categoryAttribute: categoryAttribute })=>{
            // When `allowUncategorizedItemsInIndexedDBOverrides` is enabled, databases that have
            // no known category (null/Unknown) are allowed through instead of being blocked. This
            // is a rollout-safety valve — only uncategorized DBs are affected; DBs that are
            // categorized but user-denied are still blocked regardless of this flag.
            const isUncategorized = itemCategory == null || itemCategory === (0, $0067f33686f0fdf7$export$ba064dbfe4bb66d7).Unknown;
            const resolvedIsAllowed = isAllowed || allowUncategorizedOverride && isUncategorized;
            (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
                action: 'usedAtlIndexedDBOpen',
                attributes: {
                    databaseName: databaseName,
                    wasRejected: !resolvedIsAllowed,
                    outsidePackage: true,
                    ...categoryAttribute
                }
            });
            if (resolvedIsAllowed) {
                (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug(`IndexedDB operation: override on database \"${databaseName}\" was ALLOWED`, {
                    version: String(version ?? 'unspecified')
                });
                const actualRequest = originalOpen(databaseName, version);
                requestWrapper.wrapRequest(actualRequest);
            } else {
                (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug(`IndexedDB operation: override on database \"${databaseName}\" was REJECTED`, {
                    version: String(version ?? 'unspecified')
                });
                const error = new $25e4fa8b972958ce$var$DatabaseBlockedError('The database was blocked by consent preferences', 'storageItemBlocked');
                const errorEvent = new ErrorEvent('error', {
                    message: error.message,
                    error: error
                });
                requestWrapper.setError(error);
                requestWrapper.dispatchEvent(errorEvent);
            }
        }).catch((e)=>{
            const errorMessage = e instanceof Error ? e.message : String(e);
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug(`IndexedDB operation: override on database \"${databaseName}\" ERROR: ${errorMessage}`, {
                version: String(version ?? 'unspecified')
            });
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: databaseName,
                    outsidePackage: true
                },
                message: `IndexedDB open failed during preference check: ${errorMessage}`
            });
            const errorEvent = new ErrorEvent('error', {
                message: errorMessage,
                error: e
            });
            requestWrapper.dispatchEvent(errorEvent);
        });
        return requestWrapper;
    };


const $04b34303b146e1c0$export$bbe9492afe46739 = (config)=>{
    const indexedDB = window.indexedDB;
    if (!indexedDB) {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn('No IndexedDB capabilities found');
        return;
    }
    if (typeof indexedDB.open !== 'function') {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn('IndexedDB.open is not a function');
        return;
    }
    try {
        const originalOpen = indexedDB.open.bind(indexedDB);
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug(`Installing IndexedDB override ${config.performConsentChecks ? 'with' : 'without'} consent checks`);
        // Use Object.defineProperty for better browser compatibility and consistency
        // with other passthrough implementations (document.cookie, localStorage/sessionStorage)
        Object.defineProperty(indexedDB, 'open', {
            value: config.performConsentChecks ? (0, $25e4fa8b972958ce$export$5721aa15a04b1881)(originalOpen) : (0, $25e4fa8b972958ce$export$5a412306febb78c)(originalOpen),
            writable: true,
            configurable: true
        });
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug('IndexedDB open override installed');
    } catch (e) {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).error(`Failed to install IndexedDB open override. ${e.message || ''}`);
    }
};
const $04b34303b146e1c0$export$a03098708eb0de1 = async (config)=>$04b34303b146e1c0$export$bbe9492afe46739(config);



var $6oQI4 = parcelRequire("6oQI4");



class $6ab768ea08b73b1a$export$fde2a4e0e57f47e {
    async boot() {
        if (!this.isAvailable) {
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn('IndexedDB is not available');
            return;
        }
        if (this.isBooted) // Short circuit if we've already booted once
        return;
        // Only boot once, even if we've been called numerous times sequentially
        if (!this.bootUpPromiseCache) {
            this.bootUpPromiseCache = this.openDB();
            try {
                await this.bootUpPromiseCache;
                this.isBooted = true;
            } catch (e) {
                this.isBooted = false;
                (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn('Error booting up IndexedDB.');
                throw e;
            }
        }
    }
    getIsDBAvailable() {
        return !(0, $ff92312187da7e87$export$48d7c418edadb60c)() && !!window.indexedDB;
    }
    async openDB() {
        const openPromise = new Promise((resolve, reject)=>{
            let request = indexedDB.open(this.dbName, 2);
            request.onerror = this.onConnectionErrorHandler(reject);
            request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
            request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
        });
        const timeoutPromise = new Promise((_, reject)=>{
            setTimeout(()=>{
                reject(new Error(`IndexedDB open timed out after ${$6ab768ea08b73b1a$export$fde2a4e0e57f47e.OPEN_DB_TIMEOUT_MS}ms`));
            }, $6ab768ea08b73b1a$export$fde2a4e0e57f47e.OPEN_DB_TIMEOUT_MS);
        });
        return Promise.race([
            openPromise,
            timeoutPromise
        ]);
    }
    async getRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
                    action: 'indexDbSetRecordError',
                    attributes: {
                        recordKey: recordKey
                    }
                });
                return Promise.resolve({
                    atlSetItem: '',
                    id: recordKey
                }); // return empty AtlIndexedDBItem object to exit code
            }
            let fetchTransaction = this.db.transaction([
                this.storeName
            ]);
            let recordStore = fetchTransaction.objectStore(this.storeName);
            const fetchedRecord = new Promise((resolve, reject)=>{
                let request = recordStore.get(recordKey);
                request.onerror = this.onGetRecordErrorHandler(reject);
                request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
            });
            return fetchedRecord;
        } catch (e) {
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).error(`Error fetching record from database. ${e.message || ''}`);
            throw e;
        }
    }
    async setRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
                    action: 'indexDbSetRecordError',
                    attributes: {
                        recordKey: recordKey
                    }
                });
                Promise.resolve(); // return void promise to exit code and not pass a null record
            }
            const setRecord = new Promise((resolve, reject)=>{
                let setTransaction = this.db.transaction([
                    this.storeName
                ], 'readwrite');
                let objectStore = setTransaction.objectStore(this.storeName);
                const newAtlRecord = {
                    atlSetItem: 'SET-BY-PACKAGE',
                    id: recordKey
                };
                let request = objectStore.put(newAtlRecord);
                request.onerror = this.onSetRecordErrorHandler(reject);
                request.onsuccess = this.onSetRecordSuccessHandler(resolve);
            });
            return setRecord;
        } catch (e) {
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn(`Error setting record in database. ${e.message || ''}`);
            throw e;
        }
    }
    constructor(dbName, storeName){
        this.dbName = void 0;
        this.storeName = void 0;
        this.bootUpPromiseCache = void 0;
        this.db = null;
        this.isBooted = false;
        this.isAvailable = false;
        this.onConnectionErrorHandler = (reject)=>(event)=>{
                (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn('Error opening database.');
                reject(event);
            };
        this.onConnectionSuccessHandler = (connection, resolve)=>()=>{
                this.db = connection.result;
                resolve();
            };
        this.onConnectionUpgradeNeededHandler = (request)=>()=>{
                this.db = request.result;
                this.db.createObjectStore(this.storeName, {
                    keyPath: 'id'
                });
            };
        this.onGetRecordErrorHandler = (reject)=>()=>{
                const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn(getErrorMessage);
                reject(getErrorMessage);
            };
        this.onGetRecordSuccessHandler = (getRequest, resolve)=>()=>{
                resolve(getRequest.result);
            };
        this.onSetRecordErrorHandler = (reject)=>()=>{
                const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn(errorMessage);
                reject(errorMessage);
            };
        this.onSetRecordSuccessHandler = (resolve)=>()=>{
                resolve();
            };
        this.dbName = dbName;
        this.storeName = storeName;
        this.isAvailable = this.getIsDBAvailable();
        this.isBooted = false;
        this.bootUpPromiseCache = null;
    }
}
$6ab768ea08b73b1a$export$fde2a4e0e57f47e.OPEN_DB_TIMEOUT_MS = 3000;
const $6ab768ea08b73b1a$export$36328b3bcbe4623a = new $6ab768ea08b73b1a$export$fde2a4e0e57f47e('BSCIndexedDB', 'InternalStorageKeys');




var $6oQI4 = parcelRequire("6oQI4");










const $34cf17bc70f4b202$export$b4469df6294ea6aa = (bscStorage, originalSetItem, storageType)=>(originalItemKey, originalItemValue)=>{
        const categoryStorageType = storageType === (0, $4a82c714b0d3c5be$export$259e3a861f28589b).LocalStorage ? (0, $0067f33686f0fdf7$export$2506b012eb637f61).LocalStorage : (0, $0067f33686f0fdf7$export$2506b012eb637f61).SessionStorage;
        const storageContext = bscStorage.storage;
        let itemSetByPackage = false;
        itemSetByPackage = (0, $ac2b8707abf64f74$export$ff3c91e80f54f26c).wasSetByPackage(categoryStorageType, originalItemKey);
        // `disableWebStorageConsentChecks` is read from the package global state so the
        // behaviour stays consistent with other consent-check flags (rather than being
        // threaded through props/options on every call site). When set, the override
        // always passes through to the underlying storage and only emits analytics
        // events — `AtlBrowserStorage` behaviour is preserved.
        let disableWebStorageConsentChecks = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().disableWebStorageConsentChecks ?? false;
        if ((0, $6oQI4.fg)('jfp-magma-selective-storage-enforcement')) {
            // `disableWebStorageConsentChecks` skips the consent pipeline (analytics-only),
            // but `__UNSAFE_shouldEnforceKeyForRollout(key, type) === true` re-enables enforcement for this key.
            const categoryStorageType = storageType === (0, $4a82c714b0d3c5be$export$259e3a861f28589b).LocalStorage ? (0, $0067f33686f0fdf7$export$2506b012eb637f61).LocalStorage : (0, $0067f33686f0fdf7$export$2506b012eb637f61).SessionStorage;
            const __UNSAFE_shouldEnforceKeyForRollout = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().__UNSAFE_shouldEnforceKeyForRollout;
            const enforceThisKey = __UNSAFE_shouldEnforceKeyForRollout?.(originalItemKey, categoryStorageType) === true;
            disableWebStorageConsentChecks = ((0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().disableWebStorageConsentChecks ?? false) && !enforceThisKey;
        }
        if (disableWebStorageConsentChecks) {
            try {
                (0, $ac2b8707abf64f74$export$ff3c91e80f54f26c).markSetByPackage(categoryStorageType, originalItemKey);
                originalSetItem.apply(storageContext, [
                    originalItemKey,
                    originalItemValue
                ]);
            } catch (e) {
                (0, $4393b827109285c8$export$ba6a684424c69e54)({
                    message: `${storageType} failed to setItem with consent checks disabled. ${e.message || ''}`,
                    attributes: {
                        outsidePackage: !itemSetByPackage,
                        storageType: storageType,
                        consentChecksDisabled: true
                    },
                    error: e
                });
            }
            let wasCheckAsync = true;
            try {
                const productName = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().product;
                const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides } = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)();
                // trigger the callbacks to emit analytics events but do nothing with the result.
                (0, $fbf524e7c49c5e71$export$e7a3dca206fec6e2)({
                    itemKey: originalItemKey,
                    allowedCallback: ({ wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync,
                                consentChecksDisabled: true
                            }
                        });
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory, wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync,
                                consentChecksDisabled: true
                            }
                        });
                        if (!itemHasCategory && (0, $d5cc4c11d82b8bd7$export$eda682c722f364aa)(categoryStorageType, originalItemKey)) (0, $61449d71f1ebd90f$export$1ba525b8a711eaac)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: storageType,
                                productName: productName,
                                originalItemKey: originalItemKey,
                                itemCategory: itemCategory ?? null,
                                allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides,
                                allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides,
                                consentChecksDisabled: true,
                                wasAsync: wasAsync,
                                cacheLoadedDate: (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().cacheLoadedDate ?? null
                            },
                            onSent: (0, $d5cc4c11d82b8bd7$export$c81f34d18a3c37c3)(categoryStorageType, originalItemKey)
                        });
                    },
                    storageType: categoryStorageType,
                    productName: productName
                });
            } catch (e) {
                (0, $4393b827109285c8$export$ba6a684424c69e54)({
                    message: `Failed to emit analytics with consent checks disabled. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType,
                        consentChecksDisabled: true,
                        wasAsync: wasCheckAsync
                    },
                    error: e
                });
            }
            return;
        }
        if (itemSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetItem.apply(storageContext, [
                originalItemKey,
                originalItemValue
            ]);
        } catch (e) {
            (0, $4393b827109285c8$export$ba6a684424c69e54)({
                message: `${storageType} failed to setItem. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false,
                    storageType: storageType
                },
                error: e
            });
        }
        const extensionSignals = (0, $6oQI4.fg)('platform_bsc_browser_extension_detection') ? (0, $efbbf032b63c0118$export$9a9299a14dc0c1cb)() : undefined;
        // `Storage.setItem` reports failure by throwing and callers such as the availability probes
        // depend on that, so a synchronous write failure has to leave this override. Collected here
        // rather than thrown inline, because the handler that catches it sits inside
        // another handler that would report the same error again.
        let setItemFailure;
        try {
            let wasCheckAsync = true;
            try {
                const productName = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().product;
                // MaybeSync skips the promise entirely once categories and preferences are loaded, which
                // is what keeps the write and any throw from it synchronous.
                const runProcessingCheck = (0, $6oQI4.fg)('platform_bsc_catch_deferred_storage_errors') ? (0, $fbf524e7c49c5e71$export$ffbb879d3fefb45c) : (0, $fbf524e7c49c5e71$export$e7a3dca206fec6e2);
                // Attempt to set a known item key that was set from outside the package
                const processingCheck = runProcessingCheck({
                    itemKey: originalItemKey,
                    allowedCallback: ({ wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync
                            }
                        });
                        originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory, wasAsync: wasAsync })=>{
                        wasCheckAsync = wasAsync;
                        (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
                            action: 'usedAtlBrowserStorageSetItem',
                            attributes: {
                                itemKey: originalItemKey,
                                outsidePackage: !itemSetByPackage,
                                storageType: storageType,
                                wasAsync: wasAsync
                            }
                        });
                        if (!itemHasCategory && (0, $d5cc4c11d82b8bd7$export$eda682c722f364aa)(categoryStorageType, originalItemKey)) (0, $61449d71f1ebd90f$export$1ba525b8a711eaac)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: storageType,
                                productName: productName,
                                originalItemKey: originalItemKey,
                                itemCategory: itemCategory ?? null,
                                wasAsync: wasAsync,
                                cacheLoadedDate: (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().cacheLoadedDate ?? null
                            },
                            onSent: (0, $d5cc4c11d82b8bd7$export$c81f34d18a3c37c3)(categoryStorageType, originalItemKey)
                        });
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides } = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)();
                        // allowUncategorizedCookiesInOverrides impacts both web storage and cookies due to historical reasons
                        const allowUncategorized = allowUncategorizedCookiesInOverrides || allowUncategorizedItemsInWebStorageOverrides;
                        if (allowUncategorized && !itemHasCategory) originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                        else {
                            if (!itemHasCategory) (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn(`${storageType}.setItem('${originalItemKey}', ...) was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${originalItemKey}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
                            return;
                        }
                    },
                    storageType: categoryStorageType,
                    productName: productName,
                    extensionSignals: extensionSignals
                });
                if ((0, $6oQI4.fg)('platform_bsc_catch_deferred_storage_errors') && (0, $fbf524e7c49c5e71$export$4369c812aac99591)(processingCheck)) processingCheck.catch((e)=>{
                    (0, $4393b827109285c8$export$ba6a684424c69e54)({
                        message: `Failed to set item. ${e?.message || ''}`,
                        attributes: {
                            itemKey: originalItemKey,
                            storageType: storageType,
                            wasAsync: true
                        },
                        error: e
                    });
                });
            } catch (e) {
                (0, $4393b827109285c8$export$ba6a684424c69e54)({
                    message: `Failed to set item. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType,
                        wasAsync: wasCheckAsync
                    },
                    error: e
                });
                if ((0, $6oQI4.fg)('platform_bsc_catch_deferred_storage_errors')) setItemFailure = e;
            }
        } catch (e) {
            (0, $4393b827109285c8$export$ba6a684424c69e54)({
                message: `Failed to send ${storageType} setter event. ${e.message || ''}`,
                error: e
            });
        }
        if ((0, $6oQI4.fg)('platform_bsc_catch_deferred_storage_errors') && setItemFailure) throw setItemFailure;
    };


// Members the Proxy replaces rather than forwarding.
const $f4459fb86faeb463$var$INTERCEPTED_MEMBERS = [
    'setItem',
    'getItem',
    'removeItem',
    'clear',
    'key',
    'length'
];
/**
 * Marks a storage object as already overridden by this package. Duplicate copies of the package in
 * one page (chunk skew) each capture `globalThis.localStorage` at module evaluation, so without this
 * the second copy would proxy the first copy's Proxy and run the consent pipeline — and its
 * analytics — twice per write.
 */ const $f4459fb86faeb463$var$BSC_STORAGE_OVERRIDE_INSTALLED = Symbol.for('atlassian.bsc.webStorageOverrideInstalled');
const $f4459fb86faeb463$var$isAlreadyOverridden = (value)=>value !== null && typeof value === 'object' && value[$f4459fb86faeb463$var$BSC_STORAGE_OVERRIDE_INSTALLED] === true;
/**
 * A Proxy may not report a different value for a property the target exposes as a non-writable,
 * non-configurable own data property — the runtime throws `TypeError` on every such access. A real
 * `Storage` keeps its members on `Storage.prototype` and its items as writable, configurable own
 * properties, so this only happens when something has already replaced `window.localStorage` with a
 * locked-down stand-in (some third-party storage shims and test doubles do exactly that). Detect it
 * up front and keep the legacy override for those environments instead of installing a Proxy that
 * throws on ordinary reads.
 */ const $f4459fb86faeb463$var$canInterceptWithProxy = (storage)=>$f4459fb86faeb463$var$INTERCEPTED_MEMBERS.every((member)=>{
        const descriptor = Object.getOwnPropertyDescriptor(storage, member);
        return !descriptor || descriptor.configurable === true || descriptor.writable === true;
    });
const $f4459fb86faeb463$var$isLockedDownOnTarget = (target, property)=>{
    const descriptor = Reflect.getOwnPropertyDescriptor(target, property);
    return descriptor !== undefined && !descriptor.configurable && descriptor.writable === false;
};
/**
 * Wraps the real `Storage` object so consent checks still apply to writes while the rest of the
 * `Storage` interface keeps working.
 *
 * The legacy override (below) replaces `window.localStorage` with a plain object carrying the six
 * `Storage` operations. That silently drops every other guarantee of the interface: `length` becomes
 * a function instead of a number, stored keys stop being enumerable own properties, and
 * property-style access no longer reaches the store. Consumers that measure or enumerate storage —
 * `localStorage.length`, `Object.keys(localStorage)` — then see an empty or nonsensical view, which
 * disabled the age-based storage cleanups our products depend on and let storage fill to the browser
 * quota (COOK-628).
 *
 * Keeping the native `Storage` as the Proxy target inherits reads, removals, enumeration and brand
 * checks for free. Only writes are intercepted, and they are intercepted without relying on the
 * host's named-property-setter semantics: browsers ignore or shadow a write to `length` or to a
 * `Storage` method, whereas jsdom persists it as an item. Deciding those cases here rather than
 * forwarding them keeps behaviour identical across hosts and guarantees nothing reaches storage
 * without passing through the consent check.
 */ const $f4459fb86faeb463$var$createProxiedStorage = (bscStorage, storageType)=>{
    const nativeStorage = bscStorage.storage;
    const storagePrototype = Object.getPrototypeOf(nativeStorage);
    const interceptedSetItem = (0, $34cf17bc70f4b202$export$b4469df6294ea6aa)(bscStorage, nativeStorage.setItem, storageType);
    // The `Storage` operations keep pointing at `AtlBrowserStorage` so their existing availability
    // guards and analytics are unaffected by this Proxy. `length` is handled in the `get` trap
    // because it is an accessor on `Storage` but a method on `AtlBrowserStorage`.
    const operations = new Map([
        [
            'setItem',
            interceptedSetItem
        ],
        [
            'getItem',
            bscStorage.getItem.bind(bscStorage)
        ],
        [
            'removeItem',
            bscStorage.removeItem.bind(bscStorage)
        ],
        [
            'clear',
            bscStorage.clear.bind(bscStorage)
        ],
        [
            'key',
            bscStorage.key.bind(bscStorage)
        ]
    ]);
    // Properties assigned to the storage object that are NOT storage items — symbol keys, and the
    // interface's own member names. Browsers keep these as ordinary own properties on the object and
    // never write them to the store, so we hold them here instead of touching storage. Enumeration
    // deliberately does not report them: `Object.keys(localStorage)` stays exactly the stored keys.
    // They also take precedence over `operations` on read, because products legitimately wrap the
    // storage methods (Confluence's `patchLocalStorage` replaces `setItem` and delegates to whatever
    // it captured) and that has always worked against the legacy override.
    const shadowedProperties = new Map();
    // A property names a storage item unless it resolves on the prototype chain (`length`, the
    // `Storage` methods, `Object.prototype` members) or is a symbol. Used by every trap that can
    // reach the store: `set`, `defineProperty` and `deleteProperty`.
    const isStorageItemKey = (property)=>typeof property === 'string' && !(property in storagePrototype);
    // The consent pipeline emits analytics, and anything on that path that persists a value with
    // property syntax would re-enter this trap and recurse forever. Bound to one level instead.
    let isHandlingStorageWrite = false;
    const gateStorageWrite = (property, value)=>{
        if (isHandlingStorageWrite) {
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn(`Dropped re-entrant ${storageType} write for '${property}' triggered from inside the consent path`);
            return;
        }
        isHandlingStorageWrite = true;
        try {
            interceptedSetItem(property, String(value));
        } finally{
            isHandlingStorageWrite = false;
        }
    };
    // eslint-disable-next-line prefer-const -- assigned immediately below; the traps need the identity
    let proxiedStorage;
    proxiedStorage = new Proxy(nativeStorage, {
        get: (target, property)=>{
            if (property === $f4459fb86faeb463$var$BSC_STORAGE_OVERRIDE_INSTALLED) return true;
            if (property === 'length') return bscStorage.length();
            if (shadowedProperties.has(property)) return shadowedProperties.get(property);
            if (operations.has(property)) return operations.get(property);
            // Deliberately NOT bound to the target: binding would hand out the raw `Storage` through
            // `localStorage.valueOf()`, which is an unchecked write path. Everything that needs a real
            // `Storage` receiver is routed above, and the remainder (`Object.prototype` members, named
            // keys, `Symbol.toStringTag`) works with the Proxy as the receiver. Returning the prototype's
            // own function object also keeps `localStorage.toString === localStorage.toString`.
            return Reflect.get(target, property, target);
        },
        // `localStorage.foo = 'bar'`, `Object.assign(localStorage, …)` and `Reflect.set` all reach the
        // store natively, so they are consent-checked exactly like `setItem`.
        set: (target, property, value, receiver)=>{
            // A receiver that is neither this Proxy nor the storage itself means the assignment targets
            // something further down a prototype chain (`Object.create(localStorage).foo = 'x'`), which
            // the browser also refuses to route into the store.
            if (receiver !== proxiedStorage && receiver !== target) return Reflect.set(target, property, value, receiver);
            if (property === 'length') // Read-only accessor: browsers ignore the write in sloppy mode. Reporting success keeps
            // strict-mode assignment from throwing where the legacy override did not.
            return true;
            // Reporting success for a locked-down own property on the target violates a Proxy
            // invariant. Fail the assignment exactly as the target itself would.
            if ($f4459fb86faeb463$var$isLockedDownOnTarget(target, property)) return false;
            if (!isStorageItemKey(property)) {
                shadowedProperties.set(property, value);
                return true;
            }
            gateStorageWrite(property, value);
            // Report success even when consent blocked the write, so assignment does not throw in
            // strict mode. This matches how the `setItem` override treats a blocked write.
            return true;
        },
        defineProperty: (target, property, descriptor)=>{
            // Accessor descriptors on a storage key are rejected by the browser itself — forward and let
            // it throw rather than inventing a behaviour.
            if (!('value' in descriptor) || property === 'length') return Reflect.defineProperty(target, property, descriptor);
            // A non-configurable property must actually exist on the target for a `true` result to be
            // legal, and consent may block the write, so refuse instead of risking a `TypeError`.
            if (descriptor.configurable === false || $f4459fb86faeb463$var$isLockedDownOnTarget(target, property)) return false;
            if (!isStorageItemKey(property)) {
                shadowedProperties.set(property, descriptor.value);
                return true;
            }
            gateStorageWrite(property, descriptor.value);
            return true;
        },
        // `delete localStorage.foo` removes the item natively, so it has to reach the store — but it goes
        // through `AtlBrowserStorage.removeItem` rather than the target directly, so removals behave
        // identically however they are spelled. Removals are not consent-checked, matching `removeItem`.
        deleteProperty: (target, property)=>{
            if (shadowedProperties.has(property)) {
                shadowedProperties.delete(property);
                return true;
            }
            if (isStorageItemKey(property)) {
                bscStorage.removeItem(property);
                return true;
            }
            return Reflect.deleteProperty(target, property);
        }
    });
    return proxiedStorage;
};
const $f4459fb86faeb463$var$applyWebStorageOverride = (bscStorage, storageType)=>{
    const caseSensitiveStorageType = storageType === (0, $4a82c714b0d3c5be$export$259e3a861f28589b).LocalStorage ? 'localStorage' : 'sessionStorage';
    if ((0, $6oQI4.fg)('platform_bsc_proxy_web_storage_overrides')) {
        if ($f4459fb86faeb463$var$isAlreadyOverridden(window[caseSensitiveStorageType]) || $f4459fb86faeb463$var$isAlreadyOverridden(bscStorage.storage)) {
            (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug(`${storageType} override is already installed, skipping`);
            return;
        }
        if ($f4459fb86faeb463$var$canInterceptWithProxy(bscStorage.storage)) {
            Object.defineProperty(window, caseSensitiveStorageType, {
                value: $f4459fb86faeb463$var$createProxiedStorage(bscStorage, storageType),
                writable: true,
                configurable: true
            });
            return;
        }
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn(`${storageType} cannot be proxied because its members are not configurable \u{2014} falling back to the legacy override`);
    }
    const originalSetItem = bscStorage.storage.setItem;
    // As we cannot use Object.defineProperty(window[storageType], 'setItem', ...implementation)
    // we have to override the entire utility with our own edition of the webStorage class
    const overriddenStorageClass = {
        clear: bscStorage.clear.bind(bscStorage),
        key: bscStorage.key.bind(bscStorage),
        length: bscStorage.length.bind(bscStorage),
        removeItem: bscStorage.removeItem.bind(bscStorage),
        getItem: bscStorage.getItem.bind(bscStorage),
        setItem: (0, $34cf17bc70f4b202$export$b4469df6294ea6aa)(bscStorage, originalSetItem, storageType)
    };
    Object.defineProperty(window, caseSensitiveStorageType, {
        value: overriddenStorageClass,
        writable: true,
        configurable: true
    });
};
const $f4459fb86faeb463$export$68ddaf53a4783803 = (storageType)=>{
    const bscStorage = (0, $07c6527a5ae2a4cf$export$14921bfc334334c0)(storageType);
    if (!bscStorage.isAvailable) {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn(`No ${storageType} capabilities found`);
        return;
    }
    $f4459fb86faeb463$var$applyWebStorageOverride(bscStorage, storageType);
};
const $f4459fb86faeb463$export$619fe705922e5d61 = async (storageType)=>{
    const bscStorage = (0, $07c6527a5ae2a4cf$export$14921bfc334334c0)(storageType);
    if (!bscStorage.isAvailable) {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn(`No ${storageType} capabilities found`);
        return;
    }
    if (!(0, $6ab768ea08b73b1a$export$36328b3bcbe4623a).isAvailable) {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn('IndexedDB is not available');
        return;
    }
    if (!(0, $6ab768ea08b73b1a$export$36328b3bcbe4623a).isBooted) try {
        await (0, $6ab768ea08b73b1a$export$36328b3bcbe4623a).boot();
    } catch  {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).warn('IndexedDB boot failed, proceeding without IDB tracking');
    }
    $f4459fb86faeb463$var$applyWebStorageOverride(bscStorage, storageType);
};


/**
 * Shared by both `platform_bsc_sync_initialize_controls` branches so the consent-check decision can
 * never diverge between the sync and the legacy path.
 */ const $926fd68d439b0c47$var$getIndexedDbPassthroughConfig = ()=>{
    const disableIndexedDbConsentChecks = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().disableIndexedDbConsentChecks ?? false;
    if ((0, $6oQI4.fg)('jfp-magma-selective-storage-enforcement')) {
        const __UNSAFE_shouldEnforceKeyForRollout = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().__UNSAFE_shouldEnforceKeyForRollout;
        // `__UNSAFE_shouldEnforceKeyForRollout` needs the consent-checking override installed to do
        // per-key re-enforcement at call time.
        return {
            performConsentChecks: !disableIndexedDbConsentChecks || __UNSAFE_shouldEnforceKeyForRollout !== undefined
        };
    }
    return {
        performConsentChecks: !disableIndexedDbConsentChecks
    };
};
const $926fd68d439b0c47$export$919040c32a62c7db = async (args = {
    analyticsEnabled: true
})=>{
    if ((0, $6oQI4.fg)('platform_moonjelly_bsc_master_killswitch')) return undefined;
    let initResult;
    try {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug('initializeControls invoked');
        (0, $5eed1bf229e32cb0$export$882c4530c58781d8)({
            ...args,
            overrideOnceParams: true
        });
        if ((0, $ff92312187da7e87$export$48d7c418edadb60c)()) return undefined;
        (0, $61449d71f1ebd90f$export$5bfe55348e7aebc1)({
            action: 'bscInitControlsParameters',
            attributes: {
                product: args.product,
                analyticsEnabled: args.analyticsEnabled,
                flagEnabled: args.flagEnabled,
                webStorageEnabled: args.webStorageEnabled,
                indexedDbEnabled: args.indexedDbEnabled,
                disableWebStorageConsentChecks: args.disableWebStorageConsentChecks,
                disableIndexedDbConsentChecks: args.disableIndexedDbConsentChecks,
                allowUncategorizedCookiesInOverrides: args.allowUncategorizedCookiesInOverrides,
                allowUncategorizedItemsInWebStorageOverrides: args.allowUncategorizedItemsInWebStorageOverrides,
                allowUncategorizedItemsInIndexedDBOverrides: args.allowUncategorizedItemsInIndexedDBOverrides,
                perimeter: args.perimeter,
                hasShouldEnforceKeyCallback: !!args.__UNSAFE_shouldEnforceKeyForRollout
            }
        });
        // Ensures that the AWC is constructed before overwriting any native methods.
        const analyticsWebClientInstance = (0, $61449d71f1ebd90f$export$fde53e78fd93a54d)();
        // If AWC is not initialized, it will be undefined
        const isAnalyticsInitialized = !!analyticsWebClientInstance;
        if (args.analyticsEnabled && !isAnalyticsInitialized) throw new Error(`Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.`);
        if ((0, $6oQI4.fg)('platform_bsc_sync_initialize_controls')) {
            // Install every override on the calling tick. Because nothing below awaits, this whole
            // `async` function body runs to completion synchronously — so a product that calls
            // `initializeControls` without awaiting it still has all overrides in place the moment the
            // call returns. There is no longer a window in which `document.cookie` / `setItem` /
            // `indexedDB.open` bypass consent enforcement.
            //
            // Synchronous throws still reach the `catch` below, so the `initializeControlsError`
            // operational event and the abort-on-first-failure behaviour are unchanged. That would NOT
            // hold if we merely dropped the `await`s from the legacy `create*Passthrough` functions: a
            // sync throw inside an `async` function surfaces as a rejected promise, not a thrown error.
            (0, $f39752ec2f5fdbea$export$50a17589ab8bbee4)();
            if ((0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().webStorageEnabled) {
                (0, $f4459fb86faeb463$export$68ddaf53a4783803)((0, $4a82c714b0d3c5be$export$259e3a861f28589b).LocalStorage);
                (0, $f4459fb86faeb463$export$68ddaf53a4783803)((0, $4a82c714b0d3c5be$export$259e3a861f28589b).SessionStorage);
            }
            if ((0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().indexedDbEnabled) (0, $04b34303b146e1c0$export$bbe9492afe46739)($926fd68d439b0c47$var$getIndexedDbPassthroughConfig());
        } else {
            await (0, $f39752ec2f5fdbea$export$45a5573b04db016c)();
            const isWebStorageControlsEnabled = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().webStorageEnabled;
            if (isWebStorageControlsEnabled) {
                // Serial, not `Promise.all`: `BSCIndexedDB.boot()` short-circuits on its promise cache for
                // concurrent callers, so parallelising would install the SessionStorage override before
                // the DB is open.
                await (0, $f4459fb86faeb463$export$619fe705922e5d61)((0, $4a82c714b0d3c5be$export$259e3a861f28589b).LocalStorage);
                await (0, $f4459fb86faeb463$export$619fe705922e5d61)((0, $4a82c714b0d3c5be$export$259e3a861f28589b).SessionStorage);
            }
            const isIndexedDbEnabled = (0, $d9b5d31a7ff7454b$export$3b78a1ea01f5ec28)().indexedDbEnabled;
            if (isIndexedDbEnabled) await (0, $04b34303b146e1c0$export$a03098708eb0de1)($926fd68d439b0c47$var$getIndexedDbPassthroughConfig());
        }
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).debug('initializeControls finished');
        const storageCleanupPromise = (0, $c214649aca695fe2$export$e6332b39565fb2b3)();
        initResult = Object.assign(initResult ?? {}, {
            storageCleanupPromise: storageCleanupPromise
        });
    } catch (e) {
        (0, $aa62d0d0c1b0df43$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'initializeControlsError',
            message: `Failed to initialize browser storage controls. ${e.message || ''}`
        });
    }
    return initResult;
};



var $fHonK = parcelRequire("fHonK");

var $deE7Q = parcelRequire("deE7Q");

const $54a73b210c608453$export$e8521543ffafffb0 = ({ userId: userId, cloudId: cloudId })=>{
    // We want to store cookies locally when in Isolated Cloud (IC) because like FedRAMP,
    // Consent Hub is not hydrated in IC.
    // (note: this property is ignored and forced to "true" when a FedRAMP perimeter is passed in)
    const shouldUseLocalConsentMode = (0, $deE7Q.isIsolatedCloud)();
    let indexedDbOptions = {};
    if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_indexeddb_enforcement_enabled')) indexedDbOptions = {
        indexedDbEnabled: true,
        disableIndexedDbConsentChecks: false
    };
    else if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_indexeddb_analytics_enabled')) indexedDbOptions = {
        indexedDbEnabled: true,
        disableIndexedDbConsentChecks: true
    };
    return (0, $926fd68d439b0c47$export$919040c32a62c7db)({
        product: 'Confluence',
        webStorageEnabled: true,
        ...indexedDbOptions,
        allowUncategorizedItemsInWebStorageOverrides: false,
        perimeter: (0, $fHonK.isFedRamp)() ? 'fedramp-moderate' : 'commercial',
        localConsentMode: shouldUseLocalConsentMode,
        userId: userId,
        cloudId: cloudId
    });
};




/* eslint-disable check-set-storage-usage/no-unimported-storage-set */ 


const $0a711c922c37c686$export$359ef83116415c8a = (0, $612b4cc9ef2afad2$export$2e2bcd8739ae039)`mutation UpdateLocalStorageMutation($storageinput:LocalStorageInput!$stringKeys:[String]!){updateLocalStorage(localStorage:$storageinput){stringValues(keys:$stringKeys){key value}}}`;


/**
 * The persisted cache key used by the combined search config cache.
 *
 * This is the single source of truth for the cache name. It is used by:
 * - search-client's promiseCache (scope control for the adapter system)
 * - Host apps (e.g., Confluence StorageManager) to register the key for SSR persistence
 */ const $b226cc6ac738cf5c$export$4707250d25455ea1 = 'search-combined-config';
const $b226cc6ac738cf5c$export$38fbdaf3d3d46eb0 = 'frontend.search-combined-config';


const $55aebbd7cffee8f3$export$ed97f33186d4b816 = {
    // Connect EOS (End of Support) banner dismissed state, keyed by app key
    CONNECT_EOS_BANNER_DISMISSED: 'connect-eos-banner_dismissed',
    SUPERADMIN_SURVEY_REQUESTED: 'superadmin.survey.requested',
    SUPERADMIN_SURVEY_SUBMITTED: 'superadmin.survey.submitted',
    SUPERADMIN_SESSION_EXPIRED: 'superadmin.session.expired',
    RESTRICTED_PAGE_CONFIRMED: 'restricted.page.confirmed',
    PAGE_JUST_CONVERTED: 'migration.page.just.converted',
    NAVIGATION_HOME_OPT_OUT: 'navigation.home.opt.out',
    NAVIGATION_DEFAULT_OPTED_OUT: 'navigation.default.opted.out',
    NOTIFICATION_SPOTLIGHT_VIEWED: 'notification.spotlight.viewed',
    /** FOMO ("teammates using Rovo") nudge — set when the user clicks or dismisses it. */ FOMO_NUDGE_DISMISSED: 'rovo.fomo.nudge.dismissed',
    RECENTLY_WATCHED_SPACE: 'recentlyWatchedSpace',
    GROWTH_EXPERIMENT_REQUEST_UPGRADE_SENT: 'growth.experiment.request.upgrade.sent',
    LOCAL_STORAGE_CONTENT_VIEW_CLOSEST_ELEMENT_SCROLL_POSITION: 'ce.content.view.best.element.scroll.position',
    INVITE_ON_LINK_INSERT_DISMISSAL_COUNT: 'growth.experiment.confluence.invite-on-link-insert-dismissal-count',
    INVITE_ON_LINK_INSERT_OPT_OUT: 'growth.experiment.confluence.invite-on-link-insert-opt-out',
    CROSS_JOIN_NUDGES_V3_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-v3-visited',
    CROSS_JOIN_NUDGES_JPD_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-jpd-visited',
    CROSS_JOIN_NUDGES_MSR_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-msr-visited',
    CROSS_JOIN_NUDGES_MSR_USER_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-msr-opt-out',
    CROSS_JOIN_NUDGES_MSR_VISITED_COUNT: 'growth.experiment.confluence.cross-join-nudges-msr-visited-count',
    CROSS_JOIN_NUDGES_V3_VISITED_COUNT: 'growth.experiment.confluence.cross-join-nudges-v3-visited-count',
    CROSS_JOIN_NUDGES_JPD_VISITED_COUNT: 'growth.experiment.confluence.cross-join-nudges-jpd-visited-count',
    CROSS_JOIN_NUDGES_V3_USER_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-v3-opt-out',
    CROSS_JOIN_NUDGES_JPD_USER_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-jpd-opt-out',
    CROSS_JOIN_NUDGES_ELIGIBILITY_KEY: 'growth.experiment.confluence.cross-join-nudges-eligibility',
    CROSS_JOIN_NUDGES_EVENT_CACHE_KEY: 'growth.experiment.confluence.cross-join-nudges-event-cache',
    CROSS_JOIN_NUDGES_LOOM_EVENT_CACHE_KEY: 'growth.experiment.confluence.cross-join-nudges-loom-event-cache',
    CROSS_JOIN_THIRD_PARTY_NUDGES_VISITED_KEY: 'growth.experiment.confluence.cross-join-third-party-nudges-v2-visited',
    CROSS_JOIN_THIRD_PARTY_NUDGES_VISITED_COUNT: 'growth.experiment.confluence.cross-join-third-party-nudges-v2-visited-count',
    CROSS_JOIN_NUDGES_LOOM_VISITED_KEY: 'growth.confluence.cross-join-nudges-loom-visited',
    CROSS_JOIN_NUDGES_LOOM_VISITED_COUNT: 'growth.confluence.cross-join-nudges-loom-view-count',
    CROSS_JOIN_NUDGES_LOOM_OPT_OUT: 'growth.confluence.cross-join-nudges-loom-opt-out',
    /**
	 * The width of the right panel on Home
	 */ HOME_SIDEBAR_WIDTH: 'home.sidebar.width',
    /**
	 * Used to store starred/favorited feature flags for the dev tools panel
	 */ STARRED_FEATURE_FLAGS: 'confluence-frontend-next.starredFeatureFlags',
    /**
	 * Indicates that "Copy space permissions" (implemented by
	 * @confluence/copy-space-permissions) has completed i.e. space permissions
	 * have been copied.
	 */ COPIED_SPACE_PERMISSIONS: 'copied.space.permissions',
    PERSIST_SCROLL_POSITION_IN_VIEW_PAGE: 'editor-persit-scroll-position',
    ID_START_CONTENT_IN_VIEW_PAGE: 'main-content',
    FABRIC_PAGE_OPTIN_MIGRATION_BANNER: 'fabric.page.optin.migration.banner.discovery.feature',
    FABRIC_TEMPLATE_MIGRATION_SUCCESS_FLAG: 'fabric-template-migration.success.flag',
    FABRIC_TEMPLATE_MIGRATION_ERROR_FLAG: 'fabric-template-migration.error.flag',
    BYLINE_APPS_SHOW_ALL: 'byline.apps.show-all',
    SPACENAV_APPS_SHOW_ALL: 'spacenav.apps.show-all',
    HIDE_BULK_CONFIRMATION_DIALOG_LOCAL_STORAGE_KEY: 'archive-pages.bulk-archive.confirmation-dialog.opt-out',
    ONBOARDING_STEP_INDEX: 'onboarding.account.setup.step.index',
    ONBOARDING_STEP_HAS_TEAM_NAME: 'onboarding.account.setup.step.hasTeamName',
    ONBOARDING_FORM_VALUES: 'onboarding.account.setup.form.values',
    RIGHT_SIDEBAR: 'right.sidebar',
    CONNECT_APP_ANALYTICS: 'ecosystem.confluence.connect.analytics',
    /**
	 * Auto Convert TinyMCE pages
	 */ EDITOR_REVERTED: 'autoconverted.pages.reverted',
    BLOGPOST_PERMISSIONS_NOTICE: 'blogpost.permissions.notice.error',
    QUERY_OVERRIDES: 'query.overrides',
    CANVAS_SERVER: 'canvas-server',
    CANVAS_RELAY: 'canvas-relay',
    CANVAS_FRONTEND_VERSION: 'canvas-frontend-version',
    CACHED_ASSETS: 'confluence.cachedAssets',
    // Automation changeboarding
    DISMISS_SMART_BUTTON_SPACE_NAVIGATION_CHANGEBOARDING: 'dismissSmartButtonSpaceNavigationChangeBoarding',
    // Below are cc-automation keys for in-context discoverability messages
    AUTOMATION_DISCOVER_ARCHIVE_FROM_OVERFLOW_MENU: 'automation.discover.archive-from-overflow-menu',
    AUTOMATION_DISCOVER_ARCHIVE_FROM_HOVER_OVER_PAGE_TITLE: 'automation.discover.archive-from-hover-over-page-title',
    AUTOMATION_DISCOVER_BULK_ARCHIVE: 'automation.discover.bulk-archive',
    AUTOMATION_DISCOVER_BULK_CHANGE_PAGE_OWNER: 'automation.discover.bulk-change-page-owner',
    AUTOMATION_DISCOVER_ADD_LABEL_TO_PAGE: 'automation.discover.add-label-to-page',
    AUTOMATION_DISCOVER_MEETING_NOTES_TEMPLATE: 'automation.discover.meeting-notes-template',
    AUTOMATION_DISCOVER_JIRA_LINK: 'automation.discover.jira-link',
    AUTOMATION_DISCOVER_PAGE_PUBLIC_LINK: 'automation.discover.page-public-link',
    AUTOMATION_DISCOVER_GLOBAL_PUBLIC_LINK: 'automation.discover.global-public-link',
    AUTOMATION_DISCOVER_SPACE_ASSIGNED_BULK: 'automation.discover.space-assigned-bulk',
    AUTOMATION_DISCOVER_SPACE_ASSIGNED_INDIVIDUAL: 'automation.discover.space-assigned-individual',
    AUTOMATION_DISCOVER_GLOBAL_DEFAULT_SPACE: 'automation.discover.global-default-space',
    AUTOMATION_DISCOVER_VERIFIED_CONTENT: 'automation.discover.verified.content',
    AUTOMATION_DISCOVER_WHITE_BOARDS: 'automation.discover.publish.white.boards',
    AUTOMATION_DISCOVER_SHARE_SLACK: 'automation.discover.share.slack',
    AUTOMATION_DISCOVER_SET_CONTENT_STATE: 'automation.discover.set-content-state',
    AUTOMATION_DISCOVER_PRODUCT_REQUIREMENTS: 'automation.discover.product-requirements',
    AUTOMATION_DISCOVER_FEEDBACK_ANALYSIS: 'automation.discover.feedback-analysis',
    AUTOMATION_DISCOVER_RELEASE_NOTES: 'automation.discover.release-notes',
    AUTOMATION_DISCOVER_STATUS_UPDATES: 'automation.discover.status-updates',
    AUTOMATION_ONBOARDING: 'automation.onboarding',
    AUTOMATION_EXECUTION_LIMIT: 'automation.execution.limit',
    SPACE_SETTINGS_NAV_SECTIONS_EXPANDED_STATES: 'space-settings-nav.sections.expand-states',
    SITE_SETTINGS_NAV_SECTIONS_EXPANDED_STATES: 'site-settings-nav.sections.expand-states',
    /**
	 * Comment Drafts
	 */ COMMENT_DRAFTS_PAGE_CREATE: 'comments.drafts.page.create',
    COMMENT_DRAFTS_PAGE_EDIT: 'comments.drafts.page.edit',
    COMMENT_DRAFTS_PAGE_REPLY: 'comments.drafts.page.reply',
    COMMENT_DRAFTS_INLINE_CREATE: 'comments.drafts.inline.comments.create',
    COMMENT_DRAFTS_INLINE_EDIT: 'comments.drafts.inline.comments.edit',
    COMMENT_DRAFTS_INLINE_REPLY: 'comments.drafts.inline.reply',
    COMMENT_DRAFTS_EDITOR_INLINE_CREATE: 'comments.drafts.editor.inline.create',
    COMMENT_DRAFTS_EDITOR_INLINE_EDIT: 'comments.drafts.editor.inline.edit',
    COMMENT_DRAFTS_EDITOR_INLINE_REPLY: 'comments.drafts.editor.inline.reply',
    LOOM_BETA_ENABLED: 'loom.beta.enabled',
    BROWSER_BANNER_CLOSED_BY_USER: 'devloop.browser-support-warning.closed',
    /**
	 * Home Feeds
	 */ HOME_FOLLOWING_FEED_SESSION_ID: 'home.follow-feed.sessionId',
    HOME_POPULAR_FEED_SESSION_ID: 'home.popular-feed.sessionId',
    HOME_FOLLOWING_FEED_SORTING: 'home.follow-feed.sorting',
    HOME_POPULAR_FEED_TIME_GRANULARITY: 'home.popular-feed.time-granularity',
    /**
	 * Live Pages
	 */ LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN: 'live-pages.mode-switcher.flag.shown',
    LIVE_DOCS_HAS_INIT_MODERNIZE: 'live-docs.has-init-modernize',
    LIVE_DOCS_HAS_INIT_MODERNIZE_POST_EXP: 'live-docs.has-init-modernize-post-exp',
    LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER: 'live-docs.new-lozenge-shown-tracker',
    /**
	 * Template Creation Tracking
	 */ PAGE_CREATED_FROM_TEMPLATE_PREFIX: 'page-created-from-template-',
    PAGE_CREATED_FROM_TEMPLATE: 'page-created-from-template',
    /**
	 * Editor Offline Storage
	 */ EDITOR_OFFLINE_LAST_BACKGROUND_CLEANUP_ATTEMPT: 'editor:offline:last-background-cleanup-attempt',
    /**
	 * Loom AI Meeting Notes Cross-Flow
	 */ USER_HAS_CLICKED_ON_MEETING_NOTES_TEMPLATE: 'lamnic-user-clicked-on-meeting-notes',
    /**
	 * Databases Extension
	 * !IMPORTANT: This key should not be renamed as canvas/database uses it to determine which template to apply
	 */ DATABASES_CREATE_WITH_TEMPLATE_TYPE: 'databases-create-with-template-type',
    /**
	 * Explore Related Work
	 */ EXPLORE_RELATED_WORK_FEEDBACK_BANNER: 'explore-related-work.confluence.feedback-banner',
    /**
	 * Editor Controls
	 */ EDITOR_CONTROLS_INITIAL_PREFERENCES: 'editor-controls.initial-preferences',
    /**
	 * Automation Platform
	 * Used to override the automation stack for development/staging
	 */ AUTOMATION_PLATFORM_STACK: 'automationPlatform:automationStack',
    CREATE_WITH_ROVO_MODAL_CLOSE_FEEDBACK_FLAG_LAST_SHOWN: 'create-with-rovo-modal-close-feedback-flag.last-shown',
    CREATE_WITH_ROVO_UPDATE_COMPLETE_FEEDBACK_FLAG_LAST_SHOWN: 'create-with-rovo-update-complete-feedback-flag.last-shown',
    REMIX_MODAL_CLOSE_FEEDBACK_FLAG_LAST_DISMISSED: 'remix-modal-close-feedback-flag.last-dismissed',
    REMIX_MODAL_CLOSE_FEEDBACK_FLAG_LAST_SHOWN: 'remix-modal-close-feedback-flag.last-shown',
    AIFC_CREATE_SPOTLIGHT_SESSION_KEY: 'aifc-create-spotlight-session-key',
    /**
	 * Confluence Notes
	 */ NOTES_FLOATING_POSITION: 'confluence-notes.floating-position',
    UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL: 'universal-shortcuts.deprecated-shortcut-flag.hide-until',
    // Mention Reminders experiment
    MENTION_REMINDERS_SENT: 'mention-reminders.experiment.sent',
    // Nav 4 Site/Space settings back button URL
    NAV4_SETTINGS_BACK_BUTTON_URL: 'navigation.settings.back-button.url',
    // Nav 4 opt out cache
    NAV4_OPT_OUT_CACHE: 'navigation.opt-out',
    // Nav 4 admin opt in cache
    NAV4_ADMIN_OPT_IN_CACHE: 'navigation.admin.opt-in',
    // EOT Banner experiment
    EOT_BANNER_DISMISS_UNTIL: 'eot-banner.dismiss-until',
    // Issue Create
    ISSUE_CREATE_WITH_AI: 'issue-create.with-ai',
    //Notify User On 1st View expeirment
    NOTIFY_USERS_ON_FIRST_VIEW_MUTATION_FIRED: 'notify-users-on-first-view.mutation.fired',
    NAVDEX_STORAGE_KEY: 'navigationSession',
    // Super Admin Timeout
    SUPER_ADMIN_TIMEOUT: 'confluence.super.admin.timeout',
    // Premium Onboarding
    PTO_PHASE_TWO_SPOTLIGHT_TARGET: 'pto-phase-two-spotlight',
    // Migrations
    IMPORT_CONTENT_TIMESTAMP: 'importContentTimestamp',
    // Page Experience
    AE_TABLE_COPIED: 'copied',
    AE_TABLE_COPIED_COLS: 'copiedCols',
    // Classic Editor Dialogs
    LAST_TAB: 'last-tab',
    // AI Audio Playback Speed
    AI_AUDIO_PLAYBACK_SPEED: 'ai.audio.playback-speed',
    AI_AUDIO_BRIEFING_CUSTOMIZATION: 'ai.audio.briefing.customization',
    // EditorTeamCreatedFlag
    RETROSPECTIVE_BLUEPRINT_TEAM_CREATED: 'retrospective-blueprint.team.created',
    RETROSPECTIVE_BLUEPRINT_TEAM_USED: 'retrospective-blueprint.team.used',
    // Confluence Custom Origins
    CONFLUENCE_CUSTOM_ORIGINS: 'confluenceCustomOrigins',
    // Dev and Testing
    HIDE_FEATURE_FLAG_ICON: 'confluence-frontend-next.hideFeatureFlagIcon',
    FE_FIXTURE_PARAMS: '__confluence-frontend-fixture-params',
    TEST_FAILURES_LINK_MODE: 'testFailuresLink.mode',
    // Disable Engagement for tests
    DISABLE_ENGAGEMENT_FOR_TESTS: 'confluence.disable-engagement-for-tests',
    // Realtime Access Requests:
    LAST_SHOWN_REALTIME_REQUEST_CREATED_AT: 'lastShownRealtimeRequestCreatedAt',
    LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED: 'lastTimeAccessRequestsDialogWasOpened',
    // Chrome Extension
    CONFLUENCE_SSR_OUTLINE_PRIORITY: 'confluence.ssr-outline-priority',
    CONFLUENCE_SSR_OUTLINE_ENABLED: 'confluence.ssr-outline-enabled',
    CONFLUENCE_LOADABLE_STEP_OVER_ENABLED: 'confluence.loadable-step-over-enabled',
    // Rovo AI Search Config Override (local development)
    X_USE_CONVO_PUBLIC_API: 'x_use_convo_public_api',
    X_PUBLIC_API_TOKEN: 'x_public_api_token',
    // Onboarding INFI Spotlight
    INFI_SPOTLIGHT_SEEN: 'is-infi-spotlight-seen',
    FIXTUREBOOK_COLOR_MODE: 'fixturebook.color-mode',
    // Copy with Rovo — marks a content ID as recently created from a copy/duplicate
    PAGE_CREATED_FROM_COPY: 'page.created.from.copy',
    // CFIND-5926: Imported page polish banner dismissal state, keyed per page ID
    CFIND_POLISH_BANNER_DISMISSED: '-cfind-polish-banner-dismissed',
    /**
	 * The last view mode ('syntax' | 'preview') the user selected while editing
	 * a page in markdown mode.
	 * Browser-only; user-namespaced via StorageManager.
	 */ MARKDOWN_VIEW_MODE: 'markdown.view.mode',
    // Premium Trial Onboarding
    PREMIUM_TRIAL_MT_MODAL_CLOSED: 'premium.trial.onboarding.mt.modal.closed',
    // Onboarding State Editor (dev tooling)
    ONBOARDING_STATE_EDITOR_PINNED_GROUPS: 'onboarding.state.editor.pinned.groups',
    ONBOARDING_STATE_EDITOR_CUSTOM_GROUPS_TOGGLE: 'onboarding.state.editor.custom.groups.toggle',
    ONBOARDING_STATE_EDITOR_CUSTOM_GROUPS: 'onboarding.state.editor.custom.groups',
    // Universal Create CwR Experiment Spotlight — local cache of the
    // "has seen" onboarding state, used to avoid the (costly) call to
    // get/set onboarding state on every render of the create menu.
    NAVX_UC_CWR_EXPERIMENT_SPOTLIGHT_SEEN: 'navx_uc_cwr_experiment_spotlight_seen',
    // react-ufo client performance diagnostic (collectPerfProbe): stable device
    // covariates (cpuMs, softwareGL) sampled in idle and reused on the next initial
    // load. Local-only (intentionally not in PERSISTED_KEYS_ON_SERVER).
    PERF_PROBE_DIAGNOSTIC: 'perf.probe.diagnostic',
    // TWCG-2055: Flag to Share — content types that have already fired the
    // "criteria met" trigger at least once, so we know when to show the nth+ copy.
    FLAG_TO_SHARE_CRITERIA_MET_TRIGGERED_TYPES: 'growth.experiment.confluence.flag-to-share-criteria-met-triggered-types',
    // AI Suggested Edits — map of contentId -> signature of the suggestions list
    // the user has last seen in the Suggestions panel. Used to show a notification
    // dot on the Suggestions button when unseen suggestions exist. A single fixed
    // key (map keyed by contentId) keeps the Browser Storage Controls registration
    // static. Browser-local only (intentionally not in PERSISTED_KEYS_ON_SERVER)
    // so it is not synced across devices.
    AI_SUGGESTED_EDITS_SEEN_SIGNATURE: 'editor.ai.suggested-edits.seen-signatures'
};
const $55aebbd7cffee8f3$export$84dce893719feb44 = {
    //keys stored on backend start with persisted
    PERSISTED_LEFT_SIDEBAR_WIDTH: 'persisted.left.sidebar.width',
    PERSISTED_LEFT_SIDEBAR_COLLAPSED: 'persisted.left.sidebar.collapsed',
    PERSISTED_GROWTH_PERSISTENT_UPGRADE_PRETRIAL_BANNER: 'persisted.growth.persistent.upgrade.preTrial.banner',
    PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES: 'persisted.space-nav.sections.expand-states',
    // Overrided feature flags. These are persisted to the server so they can be
    // used when rendering in SSR
    PERSISTED_OVERRIDES_STATSIG: 'persisted.enterprise-experience.override.statsig',
    PERSISTED_ADMIN_ANNOUNCEMENT_BANNER: 'persisted.admin.announcement.banner',
    PERSISTED_ADMIN_ANNOUNCEMENT_BANNER_MIGRATOR_PROMPT: 'persisted.admin.announcement.banner.migrator.prompt',
    PERSISTED_STORAGE_ENFORCEMENT_BANNER: 'persisted.storage.enforcement.banner',
    // Public Links Modals
    PERSISTED_RESTRICTIONS_DIALOG_PUBLIC_LINKS_MODAL: 'persisted.restrictions.dialog.public.links.modal',
    PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_ON_MODAL: 'persisted.share.dialog.public.links.toggle.on.modal',
    PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_ON_MODAL_SMART_SECTIONS: 'persisted.share.dialog.public.links.toggle.on.modal.smart.sections',
    PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_OFF_MODAL: 'persisted.share.dialog.public.links.toggle.off.modal',
    // Public Links Edit Whiteboard Banner
    PERSISTED_PUBLIC_LINKS_EDIT_WHITEBOARD_BANNER: 'persisted.public.links.edit.whiteboard.banner',
    // Theming
    PERSISTED_USER_THEME_PREFERENCE: 'persisted.ecosystem.user.theme.preference',
    // Premium feature highlight
    PERSISTED_PREMIUM_FEATURE_HIGHLIGHT: 'persisted.premium.feature.highlight',
    // Reading Aids
    PERSISTED_READING_AIDS_AUTO_HIGHLIGHT: 'persisted.reading.aids.auto.highlight',
    // Per-page "seen" tracking for the smart create feedback banner (capped list of content IDs)
    PERSISTED_SMART_CREATE_FEEDBACK_BANNER_SEEN_CONTENT_IDS: 'persisted.smart-create.feedback-banner.seen-content-ids',
    PERSISTED_SMART_CREATE_FEEDBACK_BANNER_SLIDES_SEEN_CONTENT_IDS: 'persisted.smart-create.feedback-banner.slides.seen-content-ids',
    PERSISTED_SYNCED_BLOCK_DESTRUCTIVE_FEEDBACK_PROMPT_SHOWN: 'persisted.synced-block.destructive-feedback-prompt-shown',
    // Editor Controls
    PERSISTED_EDITOR_CONTROLS_ONBOARDING_BANNER_NEW_PINNING_DISMISSED: 'persisted.editor-controls.onboarding-banner-new-pinning.dismissed',
    //Role Based Access Control
    PERSISTED_RBAC_TRACKING: 'persisted.rbac.tracking',
    PERSISTED_RBAC_BANNER_DISMISSED: 'persisted.rbac.banner.dismissed',
    // Agent access warning — tracks per-surface dismissal of the agent permission warning
    PERSISTED_AGENT_ACCESS_WARNING_DISMISSED: 'persisted.agent.access.warning.dismissed',
    // Loom cross_flow ad-control not interested preference
    PERSISTED_LOOM_CROSS_FLOW_AD_CONTROL_NOT_INTERESTED: 'persisted.loom-cross-flow.ad-control.not-interested',
    // Status of exposure to a series of spotlight pulse outlines
    // highlighting Loom entrypoints to cross-sell-eligible customers
    PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED: 'persisted.loom-cross-sell.discoverability-pulses.have-ended',
    // Jira Cloud ID preference for site picker on Jira Issue Create
    PERSISTED_JIRA_CLOUD_ID_PREFERENCE: 'persisted.jira-cloud-id.preference',
    // Selected site, project and issue type from the configure view on bulk AI Jira Issue Create
    PERSISTED_BULK_CREATE_JIRA_CONFIG_FOR_USER: 'persisted.bulk-create.jira.config.for.user',
    // Selected site, project and issue type from the single work create form
    PERSISTED_SINGLE_CREATE_JIRA_CONFIG_FOR_USER: 'persisted.single-create.jira.config.for.user',
    PERSISTED_SHOULD_USE_GIC_EMBED: 'persisted.should-use-gic-embed',
    // Importers
    PERSISTED_IMPORT_FEEDBACK_DISABLED: 'persisted.imports.import-feedback-disabled',
    // Search Platform QuickFind Ghost Text
    PERSISTED_PLATFORM_QUICKFIND_GHOSTTEXT: 'persisted.platform.quickfind.ghosttext',
    PERSISTED_LEGACY_CONTENT_REPORT_TASK_ID: 'persisted.legacy-content.report.task-id',
    // Confluence Recap sidebar collapse flag (first visit only)
    PERSISTED_RECAP_SIDEBAR_COLLAPSED: 'persisted.recap.sidebar.collapsed',
    // Notifications drawer auto-open flag
    PERSISTED_NOTIFICATIONS_DRAWER_AUTO_OPENED: 'persisted.notifications.drawer.auto-opened',
    // ACTIVATION-2484: SmartLink auth nudge dismissed page IDs (last 3 pages)
    PERSISTED_SMARTLINK_AUTH_NUDGE_DISMISSED_PAGES: 'persisted.smartlink-auth-nudge.dismissed-pages',
    // Byline connections Google Drive promo banner dismissed page IDs
    PERSISTED_BYLINE_CONNECTIONS_GDRIVE_BANNER_DISMISSED_PAGES: 'persisted.byline-connections.gdrive-banner.dismissed-pages',
    // Byline connections org-wide connected-apps promo banner dismissed page IDs
    PERSISTED_BYLINE_CONNECTIONS_ORG_CONNECTED_APPS_BANNER_DISMISSED_PAGES: 'persisted.byline-connections.org-connected-apps-banner.dismissed-pages',
    // ACTIVATION-2490: Permanent "don't show this again" flag for the SmartLink auth nudge
    PERSISTED_SMARTLINK_AUTH_NUDGE_DONT_SHOW_AGAIN: 'persisted.smartlink-auth-nudge.dont-show-again',
    // Mobile app promo card dismissal.
    // Stores 'true' when permanently dismissed, or a timestamp string for first-seen tracking.
    PERSISTED_MOBILE_APP_PROMO_DISMISSED: 'persisted.mobile-app-promo.dismissed',
    // Search Platform Combined Config Cache
    // Used by @atlassian/search-client's promiseCache for the combined search config
    PERSISTED_SEARCH_COMBINED_CONFIG: (0, $b226cc6ac738cf5c$export$4707250d25455ea1),
    // Approvals
    PERSISTED_APPROVALS_COMPLETION_SPOTLIGHT_DISMISSED: 'persisted.approvals.completion-spotlight.dismissed',
    // Loom auto-provision spotlight seen state
    PERSISTED_LOOM_AUTO_PROVISION_SPOTLIGHT_SEEN: 'persisted.loom-auto-provision.spotlight.seen',
    // Omnibar pin state (persisted so SSR can skip rendering when unpinned)
    PERSISTED_OMNIBAR_PINNED: 'persisted.omnibar.pinned',
    // Access Link — user preference to skip the confirmation dialog when changing access link level
    PERSISTED_ACCESS_LINK_CHANGE_CONFIRMED: 'persisted.access.link.change.confirmed',
    // "Rovo Agents for you" Home/For You card nudge — per-card dismissal.
    // Stores a JSON array of dismissed card keys, e.g. ["planner"].
    PERSISTED_FOR_YOU_AGENT_CARD_NUDGE_DISMISSED: 'persisted.for-you.agent-card-nudge.dismissed'
};



const $abd639c20d964dca$export$94c92810ef76851 = 'atlassian';
const $abd639c20d964dca$export$cae0fbb99c422e2 = 'frontend';
const $abd639c20d964dca$export$1b311d1dfe8a9349 = 'localStorage';
const $abd639c20d964dca$export$16f5e866917d6fd1 = 'sessionStorage';


const $505af0297173c4d6$var$serverCacheKeyRegex = /[^A-Za-z0-9\-._/]/g;
const $505af0297173c4d6$export$7c5eda5500a5f08d = (userId)=>{
    const keys = [];
    let prefix = `${(0, $abd639c20d964dca$export$1b311d1dfe8a9349)}/${(0, $abd639c20d964dca$export$94c92810ef76851)}.${userId}.${(0, $abd639c20d964dca$export$cae0fbb99c422e2)}`;
    prefix = prefix.replace($505af0297173c4d6$var$serverCacheKeyRegex, '_');
    Object.keys((0, $55aebbd7cffee8f3$export$84dce893719feb44)).forEach((key)=>keys.push(`${prefix}.${(0, $55aebbd7cffee8f3$export$84dce893719feb44)[key]}`));
    return keys;
};
const $505af0297173c4d6$export$902ba6ec74c93f9d = (key, cacheKey)=>{
    if (Object.values((0, $55aebbd7cffee8f3$export$84dce893719feb44)).indexOf(key) > -1) cacheKey = cacheKey.replace($505af0297173c4d6$var$serverCacheKeyRegex, '_');
    return cacheKey;
};


const $a0a079aa648eb079$var$logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('storage-manager');
const $a0a079aa648eb079$var$localStorageMigrationEntriesKey = 'localstorage-migration-entries';
function $a0a079aa648eb079$export$4fc2001188ec893d(error) {
    if (error && 'code' in error) switch(error.code){
        case 22:
            return true;
        case 1014:
            // Firefox
            if (error.name === 'NS_ERROR_DOM_QUOTA_REACHED') return true;
            break;
        default:
            return false;
    }
    return false;
}
function $a0a079aa648eb079$export$b4ff986ecbd5f7f2(value) {
    if (!value) return value;
    try {
        return JSON.parse(value);
    } catch  {
        return value;
    }
}
class $a0a079aa648eb079$export$93525d6e221593cb {
    /**
   * PRIVATE Does not trigger Init
   * creates a prefix for a value
   */ _getPrefix(seconds) {
        const milliseconds = (seconds || 0) * 1000;
        if (!milliseconds) return '';
        return Date.now() + milliseconds + this._delimiter;
    }
    constructor(_storageManager, prefix, id, storagePrefix, { userId: userId, isLicensed: isLicensed }, readStorageManager){
        this._storageManager = void 0;
        this._readStorageManager = void 0;
        this._delimiter = '#';
        this._namespace = void 0;
        this._userId = void 0;
        this._isLicensedUser = void 0;
        this._hasQuotaErrorBeenSubmitted = false;
        this._persistSetValue = (originalKey, value, persistKey)=>{
            // there is a cyclic dependency with @confluence/graphql
            // communicate local/session storage update to cc-bandana
            if (Object.values((0, $55aebbd7cffee8f3$export$84dce893719feb44)).indexOf(originalKey) > -1 && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            !sessionStorage.getItem('confluence.disable-persisted-storage-for-tests') && window['GLOBAL_APOLLO_CLIENT'] && this._userId && this._isLicensedUser) {
                const mutationVariables = {
                    storageinput: {
                        stringValues: [
                            {
                                key: persistKey,
                                value: value
                            }
                        ]
                    },
                    stringKeys: [
                        persistKey
                    ]
                };
                window['GLOBAL_APOLLO_CLIENT'].mutate({
                    mutation: (0, $0a711c922c37c686$export$359ef83116415c8a),
                    variables: mutationVariables
                }).catch((e)=>{
                    this._submitError(e, `Error updating user preferences with key ${originalKey} and value ${value}: ${e}`);
                });
            }
        };
        /**
     * Gets the item stored in local storage for the given key. null is returned if it doesn't exist.
     * Note that this method will always return a string representation of what is stored.
     */ this.getItem = (key)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return null;
            }
            try {
                const storageManager = this._readStorageManager ?? this._storageManager;
                const cacheKey = (0, $505af0297173c4d6$export$902ba6ec74c93f9d)(key, `${this._namespace}.${key}`);
                let item;
                item = storageManager.getItem(cacheKey);
                /**
        	 * Currently some keys from independent usages of native local/session storage
        		 were adding keys without namespace. This helps cleanup those keys and return the
        		values for those keys if they exist
        	* Once we stop seeing increments in counter in metrics for localStorageMigrationEntriesKey
        			we can remove this logic*/ if (!item) {
                    item = storageManager.getItem(key);
                    if (item) {
                        this._incrementLocalStorageMigrationEntries();
                        this.setItem(key, item);
                        this._storageManager.removeItem(`${key}`);
                    }
                }
                if (item) {
                    item = $a0a079aa648eb079$export$b4ff986ecbd5f7f2(item);
                    let match;
                    const prefixMatch = /(\d+)#/;
                    if (typeof item === 'string' && (match = prefixMatch.exec(item))) {
                        const itemWithStrippedExpirationPrefix = item.replace(match[0], '');
                        const expirationTimestamp = parseInt(match[1], 10);
                        const isExpired = !isNaN(expirationTimestamp) && Date.now() > expirationTimestamp;
                        if (isExpired) {
                            this.removeItem(key);
                            return null;
                        }
                        return itemWithStrippedExpirationPrefix;
                    }
                    return item;
                }
                return null;
            } catch (e) {
                this._submitError(e, `Error getting value from storage manager for key:${key} : ${e}`);
                return null;
            }
        };
        this.getAndRemoveItem = (key)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return null;
            }
            try {
                const item = this.getItem(key);
                if (item) {
                    this.removeItem(key);
                    return item;
                }
                return null;
            } catch (e) {
                this._submitError(e, `Error getting and removing value from storage manager for key:${key} : ${e}`);
                return null;
            }
        };
        /**
     * Get all the items in local storage that are bound to the given context.
     */ this.getAllItems = ()=>{
            const items = {};
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return items;
            }
            const length = this._storageManager.length;
            // Currently getAllItems is unsupported if _storageManager is AtlBrowserStorage,
            // which retrieves length differently
            if (typeof length !== 'number') return items;
            try {
                for(let i = 0; i < length; i++){
                    const itemKey = this._storageManager.key(i);
                    if (itemKey && itemKey.includes(`${this._namespace}.`)) {
                        const keyWithoutNamespace = itemKey.split(`${this._namespace}.`)[1];
                        const rawItemValue = this._storageManager.getItem(itemKey);
                        items[keyWithoutNamespace] = $a0a079aa648eb079$export$b4ff986ecbd5f7f2(rawItemValue);
                    }
                }
                return items;
            } catch (e) {
                this._submitError(e, `Error getting all items from storage manager : ${e}`);
                return items;
            }
        };
        /**
     * Returns a boolean to let you know if we contain a key that matches, and has not expired.
     */ this.doesContain = (key)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return false;
            }
            try {
                const value = this.getItem(key);
                return typeof value === 'boolean' ? !value : !!value;
            } catch (e) {
                this._submitError(e, `Error getting value from storage manager for key ${key}: ${e}`);
                return false;
            }
        };
        /**
     * Gets the item stored in local storage for the given key and returns the boolean value of it.
     * It correctly convert the "true" and "false" strings to return true/false booleans.
     */ this.getItemAsBoolean = (key)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return false;
            }
            try {
                const value = this.getItem(key);
                if (value && typeof value === 'string' && value.indexOf('false') >= 0) return false;
                if (value && typeof value === 'string' && value.indexOf('true') >= 0) return true;
                return !!value;
            } catch (e) {
                this._submitError(e, `Error getting value as boolean from storage manager for key ${key}: ${e}`);
                return false;
            }
        };
        /**
     * The underlying
     * `AtlBrowserStorage` only writes the value if the key has been registered in the
     * [atlassian-cookies](https://bitbucket.org/atlassian/atlassian-cookies) repository
     * using the `ENDS_WITH` pattern with the base key name (e.g. `"my.feature.key"`).
     * `StorageManager` prepends the namespace (`{storagePrefix}/{prefix}.{userId}.{id}.`)
     * at runtime, and `ENDS_WITH` matching ensures the base key name is sufficient.
     * Unregistered keys will resolve with `status: 'BLOCKED'` and the value will not be
     * persisted. See this package's README.md and AGENTS.md for details on adding new
     * storage keys.
     *
     * @param expire expiration time in seconds
     * @returns {string}
     */ this.setItem = (key, value, expire)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return null;
            }
            try {
                const cacheKey = (0, $505af0297173c4d6$export$902ba6ec74c93f9d)(key, `${this._namespace}.${key}`);
                // If it's not an object then append prefix.
                if (typeof value !== 'object') value = `${this._getPrefix(expire)}${value}`;
                value = JSON.stringify(value);
                const processSetItem = this._storageManager.setItem(cacheKey, value);
                if (processSetItem && typeof processSetItem.then === 'function') processSetItem.then((result)=>{
                    if (result?.status === 'BLOCKED') // The write was blocked by consent. Remove any stale value that may exist
                    // from before the user's consent was restricted. This prevents hydration
                    // mismatches where SSR returns null but the client reads a stale value.
                    this.removeItem(key);
                    else if (result?.status === 'SUCCESS') this._persistSetValue(key, value, cacheKey);
                // For FAILED, ERROR, or undefined: do nothing — the outcome is unknown,
                // so we neither persist to the server nor remove a potentially valid value.
                }).catch((e)=>{
                    this._submitError(e, `Error in setItem promise for key ${key}: ${e}`);
                });
                else this._persistSetValue(key, value, cacheKey);
                return JSON.parse(value);
            } catch (e) {
                if ($a0a079aa648eb079$export$4fc2001188ec893d(e)) {
                    // for "quota exceeded" errors we're re-massaging the error message to exclude `this._namespace`
                    // DOMException properties are read-only, so we can't just modify them inline, see https://developer.mozilla.org/en-US/docs/Web/API/DOMException
                    if (!this._hasQuotaErrorBeenSubmitted) {
                        // we'll only submit "quota exceeded" error to the monitoring systems once per user session -- there isn't really a need to submit all such errors.
                        this._submitError(new Error(`Quota exceeded on key "${key}"`));
                        this._hasQuotaErrorBeenSubmitted = true;
                    }
                    $a0a079aa648eb079$var$logger.error`Storage quota exceeded when for key ${key} and value ${value}; original error: ${e}`;
                } else this._submitError(e, `Error setting value from storage manager with key ${key} and value ${value}: ${e}`);
                return null;
            }
        };
        /**
     * Removes a Key from the Store
     */ this.removeItem = (key)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return;
            }
            try {
                const cacheKey = (0, $505af0297173c4d6$export$902ba6ec74c93f9d)(key, `${this._namespace}.${key}`);
                this._storageManager.removeItem(`${cacheKey}`);
                // Also remove the persisted value from the local storage db so that
                // initializeFromServer does not restore a removed key
                // on the next page load.
                this._persistSetValue(key, null, cacheKey);
                return;
            } catch (e) {
                this._submitError(e, `Error removing value from storage manager for key ${key}: ${e}`);
                return;
            }
        };
        this.initializeFromServer = (results)=>{
            if (!Array.isArray(results)) return;
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            if (sessionStorage.getItem('confluence.disable-persisted-storage-for-tests')) return;
            try {
                // When the page was SSR-rendered, the server has already filtered out
                // non-consented keys from the results.
                // We can bypass the async consent check by using setStrictlyNecessaryItem
                // which writes synchronously to native localStorage, avoiding the need to
                // wait for the categorization JSON to load.
                results.forEach((val)=>{
                    if (!this._storageManager) return;
                    if (Boolean(window?.__SSR_RENDERED__) && 'setStrictlyNecessaryItem' in this._storageManager) this._storageManager.setStrictlyNecessaryItem(val.key, val.value);
                    else this._storageManager.setItem(val.key, val.value);
                });
            } catch (e) {
                if ($a0a079aa648eb079$export$4fc2001188ec893d(e)) this._submitError(new Error('Quota exceeded on intializing persisted values from server'));
                else this._submitError(e, `Error setting value from storage manager while initializing persisted values from server: ${e}`);
            }
        };
        this._submitError = (e, message)=>{
            if (message) $a0a079aa648eb079$var$logger.error`${message}`;
            (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(e, {
                attribution: 'unknown'
            });
        };
        this._incrementLocalStorageMigrationEntries = ()=>{
            (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().incrementCounter($a0a079aa648eb079$var$localStorageMigrationEntriesKey);
        };
        this._storageManager = _storageManager;
        this._readStorageManager = readStorageManager ?? null;
        this._namespace = userId ? `${storagePrefix}/${prefix}.${userId}.${id}` : `${storagePrefix}/null`;
        this._userId = userId;
        this._isLicensedUser = isLicensed ?? false;
    }
}





/* eslint-disable no-dupe-class-members */ class $e2dc1797b8fbbb8b$export$31c6869b8bca23f6 {
    run(name, fn) {
        const names = Array.isArray(name) ? name : [
            name
        ];
        names.forEach((name)=>this.markMeasureStart(name));
        const result = fn();
        if (typeof result?.then === 'function') // eslint-disable-next-line @typescript-eslint/no-floating-promises
        result.finally(()=>{
            names.forEach((name)=>this.markMeasureEnd(name));
        });
        else names.forEach((name)=>this.markMeasureEnd(name));
        return result;
    }
    markMeasureStart(name, timestamp) {
        //if startTime already marked, don't mark again.
        if (this.measures[name]?.startTime) return;
        this.measures[name] = {
            startTime: Math.floor(timestamp ?? performance.now()),
            duration: 0
        };
    }
    markMeasureEnd(name, timestamp, allowEndOnly = false) {
        const entry = this.measures[name];
        if (!entry?.duration && entry?.startTime) entry.duration = Math.floor((timestamp ?? performance.now()) - entry.startTime);
        else if (!entry && allowEndOnly) // In allowEndOnly mode we take FIRST end time as duration
        this.measures[name] = {
            startTime: 0,
            duration: timestamp ?? performance.now()
        };
    }
    getMeasures() {
        return this.measures;
    }
    clearMeasures() {
        this.measures = {};
    }
    constructor(){
        this.measures = {};
    }
}


class $47c7a260b3a5dfb3$var$SSRMeasure extends (0, $e2dc1797b8fbbb8b$export$31c6869b8bca23f6) {
    fetchCountIncr(count = 1, options) {
        this.fetchCount += count;
        if (options?.isUsingRelay !== undefined) this.fetchCountByRelay[`${options.isUsingRelay}`] += count;
    }
    getFetchCount() {
        return this.fetchCount;
    }
    getFetchCountByRelay() {
        return {
            ...this.fetchCountByRelay
        };
    }
    errorCountIncr(count = 1) {
        this.errorCount += count;
    }
    getErrorCount() {
        return this.errorCount;
    }
    operationsCountIncr(count = 1) {
        this.operationsCount += count;
    }
    getOperationsCount() {
        return this.operationsCount;
    }
    setIsBifrost(isBifrost) {
        this.isBifrost = isBifrost;
    }
    getIsBifrost() {
        return this.isBifrost;
    }
    /**
   * Transform a measure name (e.g., replace 'ssr-app' with 'bifrost-ssr')
   * Override this function to customize measure names
   */ transformMeasureName(name) {
        if (this.getIsBifrost() && name.includes('ssr-app/')) name = name.replace('ssr-app', 'bifrost-ssr');
        if (window.__SSR_REACT_STREAMING__ && name.includes('/render/')) name = name.replace('render', 'stream/render');
        return name;
    }
    setStartTime(startTimeOffset = 0) {
        this.startTimeOffset = startTimeOffset;
        if (!this.startTime) this.startTime = Math.floor(performance.now());
    }
    getStartTime() {
        return this.startTime;
    }
    nowFromStartTime() {
        return Math.floor(performance.now()) - this.startTime;
    }
    now() {
        return this.nowFromStartTime() + this.startTimeOffset;
    }
    setMeasureDuration(name, duration) {
        const transformedName = this.transformMeasureName(name);
        const entry = this.measures[transformedName];
        if (entry) entry.duration = duration;
    }
    addMeasure(name, duration, offsetStartByDuration = false) {
        const transformedName = this.transformMeasureName(name);
        if (this.measures[transformedName]) return;
        this.measures[transformedName] = {
            startTime: offsetStartByDuration ? this.now() - duration : this.now(),
            duration: duration
        };
    }
    /**
   * Adds a performance measure with explicitly provided timing data.
   * This method is typically used when you have pre-calculated timing information
   * (e.g., from external sources or previous measurements) rather than measuring in real-time.
   *
   * @param name - Identifier for the measure (will be transformed via `transformMeasureName`)
   * @param data - Pre-calculated timing data
   * @param data.startTime - Absolute timestamp when the measure started (from `performance.now()`)
   * @param data.duration - Duration of the measure in milliseconds
   *
   * @remarks
   * - If a measure with the same name already exists, this method does nothing (no overwrite)
   * - `startTime` is normalized relative to SSR start time (`this.startTime`)
   * - Both `startTime` and `duration` are floored to integers and clamped to minimum value of 0
   * - Use this when you have complete timing data upfront, rather than `markMeasureStart`/`markMeasureEnd`
   *
   * @example
   * ```typescript
   * // Add a measure with pre-calculated timing
   * SSRMeasures.addMeasureWithData('ssr-app/hydration', {
   *   startTime: 1234.56,  // Absolute timestamp from performance.now()
   *   duration: 89.12       // Duration in milliseconds
   * });
   * ```
   */ addMeasureWithData(name, data) {
        const transformedName = this.transformMeasureName(name);
        if (this.measures[transformedName]) return;
        this.measures[transformedName] = {
            startTime: Math.floor(Math.max(0, data.startTime) - this.startTime),
            duration: Math.floor(Math.max(0, data.duration))
        };
    }
    markMeasureStart(name) {
        const transformedName = this.transformMeasureName(name);
        if (!this.measures[transformedName]) this.measures[transformedName] = {
            startTime: this.now(),
            duration: 0
        };
    }
    markMeasureEnd(name) {
        const transformedName = this.transformMeasureName(name);
        const entry = this.measures[transformedName];
        if (entry) entry.duration = this.now() - entry.startTime;
    }
    clearMeasures() {
        this.isBifrost = false;
        this.startTimeOffset = 0;
        this.startTime = 0;
        this.fetchCount = 0;
        this.fetchCountByRelay = {
            true: 0,
            false: 0
        };
        this.errorCount = 0;
        this.operationsCount = 0;
        this.measures = {};
    }
    constructor(...args){
        super(...args);
        this.startTimeOffset = 0;
        this.startTime = 0;
        // fetch count (counts batched operations as one fetch)
        this.fetchCount = 0;
        this.fetchCountByRelay = {
            true: 0,
            false: 0
        };
        // total operations (counts individual operations even in batched operations)
        this.operationsCount = 0;
        this.errorCount = 0;
        this.isBifrost = false;
    }
}
const $47c7a260b3a5dfb3$export$5467c8c7fa0f4d06 = new $47c7a260b3a5dfb3$var$SSRMeasure();




const $4ecd5830b37ff119$export$72dc662ac05b1fbb = `
  query LocalStorageQuery($stringKeys: [String]!) {
    localStorage {
      stringValues(keys: $stringKeys) {
        key
        value
      }
    }
  }
`;




const $2123323c5a3599df$var$LOCAL_STORAGE_ITEM_LENGTH_METRIC = 'localStorageMaxItemValueLength';
const $2123323c5a3599df$var$LOCAL_STORAGE_TYPE = 'localStorage';
const $2123323c5a3599df$var$persistedRemoteStorageKeyEntries = Object.entries((0, $55aebbd7cffee8f3$export$84dce893719feb44));
const $2123323c5a3599df$var$scheduledRemoteLocalStorageValues = new WeakSet();
function $2123323c5a3599df$var$scheduleRemoteLocalStorageMaxItemLengthMetric(values) {
    if (!Array.isArray(values) || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined) || $2123323c5a3599df$var$scheduledRemoteLocalStorageValues.has(values) || typeof window.requestIdleCallback !== 'function') return;
    $2123323c5a3599df$var$scheduledRemoteLocalStorageValues.add(values);
    // eslint-disable-next-line compat/compat -- Guarded above; unsupported browsers skip this diagnostic.
    window.requestIdleCallback(()=>$2123323c5a3599df$var$submitRemoteLocalStorageMaxItemLengthMetric(values));
}
function $2123323c5a3599df$var$submitRemoteLocalStorageMaxItemLengthMetric(values) {
    if (!Array.isArray(values) || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined) || // skipping in SSR because getMonitoringClient().gauge is a no-op in SSR
    !(0, $ef003bca5ae3d837$export$45abdb3f977b5b14)('confluence_frontend_localstorage_item_length', 'isEnabled', true)) return;
    const longestItem = values.reduce((currentLongestItem, entry)=>{
        if (!$2123323c5a3599df$var$isRemoteLocalStorageStringValue(entry)) return currentLongestItem;
        const storageKeyTag = $2123323c5a3599df$var$getPersistedRemoteStorageKeyTag(entry.key);
        if (!storageKeyTag) return currentLongestItem;
        const valueLength = entry.value.length;
        if (!currentLongestItem || valueLength > currentLongestItem.valueLength) return {
            storageKeyTag: storageKeyTag,
            valueLength: valueLength
        };
        return currentLongestItem;
    }, null);
    if (!longestItem) return;
    (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().gauge($2123323c5a3599df$var$LOCAL_STORAGE_ITEM_LENGTH_METRIC, longestItem.valueLength, [
        `storageKey:${longestItem.storageKeyTag}`,
        'source:remote_fetch',
        `storageType:${$2123323c5a3599df$var$LOCAL_STORAGE_TYPE}`
    ]);
}
function $2123323c5a3599df$var$isRemoteLocalStorageStringValue(entry) {
    if (!entry || typeof entry !== 'object') return false;
    const { key: key, value: value } = entry;
    return typeof key === 'string' && typeof value === 'string';
}
function $2123323c5a3599df$var$getPersistedRemoteStorageKeyTag(remoteKey) {
    const persistedStorageKeyEntry = $2123323c5a3599df$var$persistedRemoteStorageKeyEntries.find(([, storageKey])=>remoteKey.endsWith(`.${storageKey}`));
    return persistedStorageKeyEntry?.[0] ?? null;
}
async function $2123323c5a3599df$export$efc60d6604f5fc7a({ userId: userId, isLicensed: isLicensed, regionSteeringHint: regionSteeringHint }) {
    if (window['__REMOTE_LOCAL_STORAGE__']) {
        // This value can be returned from SSR result, so measure it when the client first accesses it.
        // Keep this diagnostic off the critical path and schedule it at most once per payload.
        $2123323c5a3599df$var$scheduleRemoteLocalStorageMaxItemLengthMetric(window['__REMOTE_LOCAL_STORAGE__']);
        return window['__REMOTE_LOCAL_STORAGE__'];
    }
    const regionHint = regionSteeringHint || window['GLOBAL_AGG_REGION_STEERING_HINT'];
    const URI = '/gateway/api/graphql/slow';
    return window['__REMOTE_LOCAL_STORAGE__'] = (0, $47c7a260b3a5dfb3$export$5467c8c7fa0f4d06).run('ssr-app/prepare/preloadQuery/fetch:LocalStorageQuery', async ()=>{
        let result = null;
        try {
            if (isLicensed && userId) {
                const variables = {
                    stringKeys: (0, $505af0297173c4d6$export$7c5eda5500a5f08d)(userId)
                };
                const specialHeaders = {
                    'atl-attribution': JSON.stringify({
                        product: 'Confluence Cloud',
                        service: 'confluence-frontend'
                    })
                };
                if (regionHint) specialHeaders['Atl-Edge-Region-Hint'] = regionHint;
                const res = await (0, $b9f93b053c525d82$export$7fd82c6bb3f5e7d5)(`${URI}?q=LocalStorageQuery`, {
                    method: 'POST',
                    headers: {
                        'X-APOLLO-OPERATION-NAME': 'LocalStorageQuery',
                        'Content-Type': 'application/json',
                        ...specialHeaders
                    },
                    body: JSON.stringify({
                        operationName: 'LocalStorageQuery',
                        query: (0, $4ecd5830b37ff119$export$72dc662ac05b1fbb),
                        variables: variables
                    })
                });
                if (res.ok) {
                    const { data: data } = await res.json();
                    result = data?.localStorage?.stringValues;
                }
            }
        } catch  {}
        return window['__REMOTE_LOCAL_STORAGE__'] = result;
    });
}


let $0c75707ffa3ab928$var$persistedStorageAdapterFactory = null;
function $0c75707ffa3ab928$export$aee70acaee03e874(factory) {
    $0c75707ffa3ab928$var$persistedStorageAdapterFactory = factory;
}
function $0c75707ffa3ab928$export$f4aa92330f62e5b7() {
    return $0c75707ffa3ab928$var$persistedStorageAdapterFactory;
}


function $8df8d13c9d0eacff$export$ec058bca95f694fd(getStorageInstance) {
    (0, $0c75707ffa3ab928$export$aee70acaee03e874)(()=>{
        // NOTE: We intentionally DO NOT capture a StorageManager instance here.
        // In SSR, a request-scoped storage instance may change across async boundaries.
        // Each adapter method resolves the current instance at call time (late binding)
        // to avoid using a stale captured instance.
        const adapter = {
            getItem: (key)=>{
                const sm = getStorageInstance();
                if (!sm) return null;
                const value = sm.getItem(key);
                // StorageManager may return parsed JSON or the original string
                // The adapter needs to return a string | null
                if (value === null || value === undefined) return null;
                // If value is already a string, return as-is
                if (typeof value === 'string') return value;
                // Otherwise, serialize back to string
                return JSON.stringify(value);
            },
            setItem: (key, value)=>{
                const sm = getStorageInstance();
                if (!sm) return;
                // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
                sm.setItem(key, value);
            },
            removeItem: (key)=>{
                const sm = getStorageInstance();
                if (!sm) return;
                sm.removeItem(key);
            }
        };
        return adapter;
    });
}


let $8b7debc8685a2ab6$export$7691d7c35a352a10;
let $8b7debc8685a2ab6$export$fb051bd2501e65b3;
const $8b7debc8685a2ab6$export$68017d60ff81319c = async (initializationData)=>{
    let confluenceLocalStorage = null;
    let confluenceSessionStorage = null;
    let confluenceLocalReadStorage = null;
    let confluenceSessionReadStorage = null;
    confluenceLocalStorage = (0, $07c6527a5ae2a4cf$export$c8cc3ffd3f2c1d2f);
    confluenceSessionStorage = (0, $07c6527a5ae2a4cf$export$edbae459bdf957a5);
    confluenceLocalReadStorage = (0, $07c6527a5ae2a4cf$export$c8cc3ffd3f2c1d2f).storage;
    confluenceSessionReadStorage = (0, $07c6527a5ae2a4cf$export$edbae459bdf957a5).storage;
    $8b7debc8685a2ab6$export$7691d7c35a352a10 = new (0, $a0a079aa648eb079$export$93525d6e221593cb)(confluenceLocalStorage, (0, $abd639c20d964dca$export$94c92810ef76851), (0, $abd639c20d964dca$export$cae0fbb99c422e2), (0, $abd639c20d964dca$export$1b311d1dfe8a9349), initializationData, confluenceLocalReadStorage);
    $8b7debc8685a2ab6$export$fb051bd2501e65b3 = new (0, $a0a079aa648eb079$export$93525d6e221593cb)(confluenceSessionStorage, (0, $abd639c20d964dca$export$94c92810ef76851), (0, $abd639c20d964dca$export$cae0fbb99c422e2), (0, $abd639c20d964dca$export$16f5e866917d6fd1), initializationData, confluenceSessionReadStorage);
    const result = await (0, $2123323c5a3599df$export$efc60d6604f5fc7a)(initializationData);
    if (result) $8b7debc8685a2ab6$export$7691d7c35a352a10.initializeFromServer(result);
    // Register the search-client storage adapter for combined config SSR persistence.
    // This must be called after storage instances are created.
    // We pass a getter function to avoid circular dependencies.
    (0, $8df8d13c9d0eacff$export$ec058bca95f694fd)(()=>$8b7debc8685a2ab6$export$7691d7c35a352a10);
};


const $6d6794975d4b2dd0$var$fetchGet = (resource)=>{
    // eslint-disable-next-line no-restricted-syntax
    return fetch(resource, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
const $6d6794975d4b2dd0$var$fetchPartialSessionDataFromAlternateSources = ()=>{
    const fetchUserIdFromIdentity = async ()=>{
        const response = await $6d6794975d4b2dd0$var$fetchGet('/gateway/api/me');
        const responseData = await response.json();
        return responseData?.account_id;
    };
    const fetchTenantIdFromEdge = async ()=>{
        const response = await $6d6794975d4b2dd0$var$fetchGet('/_edge/tenant_info');
        const responseData = await response.json();
        return responseData?.cloudId;
    };
    const isStagingEnvironment = [
        'branch',
        'staging',
        'stg-fedm',
        'dev'
    ].includes("production");
    return Promise.all([
        fetchUserIdFromIdentity(),
        fetchTenantIdFromEdge()
    ]).then(([userId, cloudId])=>{
        return {
            cloudId: cloudId,
            userId: userId,
            environment: isStagingEnvironment ? 'STAGING' : 'PRODUCTION'
        };
    });
};
const $6d6794975d4b2dd0$export$66b82bc0ee0db41d = ()=>{
    return $6d6794975d4b2dd0$var$fetchPartialSessionDataFromAlternateSources().then(async (data)=>{
        const { cloudId: cloudId, userId: userId, environment: environment } = data;
        const isEmbeddedConfluence = (0, $71776876d780834d$export$9c21f25960873ecb)();
        const product = isEmbeddedConfluence ? 'embeddedConfluence' : 'confluence';
        /*
			 * Analytics Web Client initialization
			 *
			 * `initializeAnalyticsClient` is an asynchronous function. We start it but do not await it here. This allows the
			 * Error App UI, visible to the user, to be rendered ASAP
			 *
			 * The app relies on the consumers of the Analytics Client to await it when they use getAnalyticsWebClient.
			 */ (0, $b76dfd1db5681318$export$7d842b959fcdcd03)({
            cloudId: cloudId,
            userId: userId,
            environment: environment,
            product: product
        });
        // Monitoring context initialization
        (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().updateContext({
            tenantId: cloudId,
            product: product
        });
        // Browser storage controls initialization (must be called before storage manager)
        await (0, $54a73b210c608453$export$e8521543ffafffb0)({
            userId: userId,
            cloudId: cloudId
        });
        // Storage manager initialization
        return (0, $8b7debc8685a2ab6$export$68017d60ff81319c)({
            userId: userId ?? ''
        });
    }).catch(()=>{
    // Unfortunately if we can't initialize the analytics client, we can't log the error
    });
};



var $2hRE7 = parcelRequire("2hRE7");

var $3g9wx = parcelRequire("3g9wx");

var $2hRE7 = parcelRequire("2hRE7");

var $2hRE7 = parcelRequire("2hRE7");

var $3g9wx = parcelRequire("3g9wx");

var $2hRE7 = parcelRequire("2hRE7");

var $3g9wx = parcelRequire("3g9wx");
//
// Main
//
function $f84f165f6ccbce1d$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $f84f165f6ccbce1d$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $f84f165f6ccbce1d$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $f84f165f6ccbce1d$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $f84f165f6ccbce1d$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $f84f165f6ccbce1d$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $f84f165f6ccbce1d$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $f84f165f6ccbce1d$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $f84f165f6ccbce1d$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $f84f165f6ccbce1d$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $f84f165f6ccbce1d$var$monadic : $f84f165f6ccbce1d$var$variadic;
    return $f84f165f6ccbce1d$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $f84f165f6ccbce1d$var$strategyVariadic(fn, options) {
    return $f84f165f6ccbce1d$var$assemble(fn, this, $f84f165f6ccbce1d$var$variadic, options.cache.create(), options.serializer);
}
function $f84f165f6ccbce1d$var$strategyMonadic(fn, options) {
    return $f84f165f6ccbce1d$var$assemble(fn, this, $f84f165f6ccbce1d$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $f84f165f6ccbce1d$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
var $f84f165f6ccbce1d$var$ObjectWithoutPrototypeCache = /** @class */ function() {
    function ObjectWithoutPrototypeCache() {
        this.cache = Object.create(null);
    }
    ObjectWithoutPrototypeCache.prototype.get = function(key) {
        return this.cache[key];
    };
    ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
        this.cache[key] = value;
    };
    return ObjectWithoutPrototypeCache;
}();
var $f84f165f6ccbce1d$var$cacheDefault = {
    create: function create() {
        return new $f84f165f6ccbce1d$var$ObjectWithoutPrototypeCache();
    }
};
var $f84f165f6ccbce1d$export$c5491a8691a23b9e = {
    variadic: $f84f165f6ccbce1d$var$strategyVariadic,
    monadic: $f84f165f6ccbce1d$var$strategyMonadic
};


var $f20c0d9b18242783$exports = {};

$parcel$defineInteropFlag($f20c0d9b18242783$exports);
$parcel$export($f20c0d9b18242783$exports, "ErrorCode", () => $c25ea76cd3f9e130$export$d4e71bc0b80dc0fb);
$parcel$export($f20c0d9b18242783$exports, "FormatError", () => $c25ea76cd3f9e130$export$7369836851cc1329);
$parcel$export($f20c0d9b18242783$exports, "isFormatXMLElementFn", () => $1ab34a9aa585c027$export$df0c12a2d414a163);
$parcel$export($f20c0d9b18242783$exports, "IntlMessageFormat", () => $4c27f916aa25d57a$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $3g9wx = parcelRequire("3g9wx");


var $3g9wx = parcelRequire("3g9wx");
var $8fe0cfc43b7be4da$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($8fe0cfc43b7be4da$export$896afd8541959ee5 || ($8fe0cfc43b7be4da$export$896afd8541959ee5 = {}));



var $3g9wx = parcelRequire("3g9wx");

var $61305d61fb2438cc$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($61305d61fb2438cc$export$b87f371cbc396fcf || ($61305d61fb2438cc$export$b87f371cbc396fcf = {}));
var $61305d61fb2438cc$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($61305d61fb2438cc$export$906452485466fa53 || ($61305d61fb2438cc$export$906452485466fa53 = {}));
function $61305d61fb2438cc$export$cfa10c5697238752(el) {
    return el.type === $61305d61fb2438cc$export$b87f371cbc396fcf.literal;
}
function $61305d61fb2438cc$export$4f55724281bdfaf9(el) {
    return el.type === $61305d61fb2438cc$export$b87f371cbc396fcf.argument;
}
function $61305d61fb2438cc$export$e11187b219e191e1(el) {
    return el.type === $61305d61fb2438cc$export$b87f371cbc396fcf.number;
}
function $61305d61fb2438cc$export$32d811605da75f40(el) {
    return el.type === $61305d61fb2438cc$export$b87f371cbc396fcf.date;
}
function $61305d61fb2438cc$export$34ec46f596b1702f(el) {
    return el.type === $61305d61fb2438cc$export$b87f371cbc396fcf.time;
}
function $61305d61fb2438cc$export$dcfe1c11d168b5a1(el) {
    return el.type === $61305d61fb2438cc$export$b87f371cbc396fcf.select;
}
function $61305d61fb2438cc$export$6c796d116f0a4fbc(el) {
    return el.type === $61305d61fb2438cc$export$b87f371cbc396fcf.plural;
}
function $61305d61fb2438cc$export$c0ece297bdd0c082(el) {
    return el.type === $61305d61fb2438cc$export$b87f371cbc396fcf.pound;
}
function $61305d61fb2438cc$export$5c83de34745812b(el) {
    return el.type === $61305d61fb2438cc$export$b87f371cbc396fcf.tag;
}
function $61305d61fb2438cc$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $61305d61fb2438cc$export$906452485466fa53.number);
}
function $61305d61fb2438cc$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $61305d61fb2438cc$export$906452485466fa53.dateTime);
}
function $61305d61fb2438cc$export$f0ac572c1121c662(value) {
    return {
        type: $61305d61fb2438cc$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $61305d61fb2438cc$export$425e864b0ba114f1(value, style) {
    return {
        type: $61305d61fb2438cc$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


// @generated from regex-gen.ts
var $7905d323df49d718$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $7905d323df49d718$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;


/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $053cfcd684323523$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $053cfcd684323523$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($053cfcd684323523$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}



var $3g9wx = parcelRequire("3g9wx");
// @generated from regex-gen.ts
var $3a431919d981be96$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $7658537414b1aff9$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $3a431919d981be96$export$2b8db14d8bcaece7)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $7658537414b1aff9$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $7658537414b1aff9$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $7658537414b1aff9$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $7658537414b1aff9$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $7658537414b1aff9$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $7658537414b1aff9$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($7658537414b1aff9$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $7658537414b1aff9$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $7658537414b1aff9$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$7658537414b1aff9$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $7658537414b1aff9$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $7658537414b1aff9$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $7658537414b1aff9$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $7658537414b1aff9$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $3g9wx.__assign)((0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, all), $7658537414b1aff9$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $3g9wx.__assign)((0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, all), $7658537414b1aff9$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($7658537414b1aff9$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($7658537414b1aff9$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($7658537414b1aff9$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($7658537414b1aff9$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, result), $7658537414b1aff9$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($7658537414b1aff9$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, result), $7658537414b1aff9$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $7658537414b1aff9$var$parseSign(token.stem);
        if (signOpts) result = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $7658537414b1aff9$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}




// @generated from time-data-gen.ts
// prettier-ignore  
var $03023fbb96059e1c$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};


function $3c6010c57b1d0102$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $3c6010c57b1d0102$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $3c6010c57b1d0102$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $03023fbb96059e1c$export$a8c9209db4084317)[regionTag || ''] || (0, $03023fbb96059e1c$export$a8c9209db4084317)[languageTag || ''] || (0, $03023fbb96059e1c$export$a8c9209db4084317)["".concat(languageTag, "-001")] || (0, $03023fbb96059e1c$export$a8c9209db4084317)['001'];
    return hourCycles[0];
}


var $1371fb49892d7d75$var$_a;
var $1371fb49892d7d75$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $7905d323df49d718$export$523451f94304dd6c).source, "*"));
var $1371fb49892d7d75$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $7905d323df49d718$export$523451f94304dd6c).source, "*$"));
function $1371fb49892d7d75$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $1371fb49892d7d75$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $1371fb49892d7d75$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $1371fb49892d7d75$var$hasNativeFromEntries = !!Object.fromEntries;
var $1371fb49892d7d75$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $1371fb49892d7d75$var$hasTrimStart = !!String.prototype.trimStart;
var $1371fb49892d7d75$var$hasTrimEnd = !!String.prototype.trimEnd;
var $1371fb49892d7d75$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $1371fb49892d7d75$var$isSafeInteger = $1371fb49892d7d75$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $1371fb49892d7d75$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $1371fb49892d7d75$var$re = $1371fb49892d7d75$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $1371fb49892d7d75$var$REGEX_SUPPORTS_U_AND_Y = (($1371fb49892d7d75$var$_a = $1371fb49892d7d75$var$re.exec('a')) === null || $1371fb49892d7d75$var$_a === void 0 ? void 0 : $1371fb49892d7d75$var$_a[0]) === 'a';
} catch (_) {
    $1371fb49892d7d75$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $1371fb49892d7d75$var$startsWith = $1371fb49892d7d75$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $1371fb49892d7d75$var$fromCodePoint = $1371fb49892d7d75$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $1371fb49892d7d75$var$fromEntries = // native
$1371fb49892d7d75$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $1371fb49892d7d75$var$codePointAt = $1371fb49892d7d75$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $1371fb49892d7d75$var$trimStart = $1371fb49892d7d75$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($1371fb49892d7d75$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $1371fb49892d7d75$var$trimEnd = $1371fb49892d7d75$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($1371fb49892d7d75$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $1371fb49892d7d75$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $1371fb49892d7d75$var$matchIdentifierAtIndex;
if ($1371fb49892d7d75$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $1371fb49892d7d75$var$IDENTIFIER_PREFIX_RE_1 = $1371fb49892d7d75$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $1371fb49892d7d75$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $1371fb49892d7d75$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $1371fb49892d7d75$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$1371fb49892d7d75$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $1371fb49892d7d75$var$codePointAt(s, index);
        if (c === undefined || $1371fb49892d7d75$var$_isWhiteSpace(c) || $1371fb49892d7d75$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $1371fb49892d7d75$var$fromCodePoint.apply(void 0, match);
};
var $1371fb49892d7d75$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $61305d61fb2438cc$export$b87f371cbc396fcf).pound,
                    location: $1371fb49892d7d75$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $1371fb49892d7d75$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $1371fb49892d7d75$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $61305d61fb2438cc$export$b87f371cbc396fcf).literal,
                value: "<".concat(tagName, "/>"),
                location: $1371fb49892d7d75$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$1371fb49892d7d75$var$_isAlpha(this.char())) return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).INVALID_TAG, $1371fb49892d7d75$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $1371fb49892d7d75$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).INVALID_TAG, $1371fb49892d7d75$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $61305d61fb2438cc$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $1371fb49892d7d75$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).UNCLOSED_TAG, $1371fb49892d7d75$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).INVALID_TAG, $1371fb49892d7d75$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $1371fb49892d7d75$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $1371fb49892d7d75$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $61305d61fb2438cc$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$1371fb49892d7d75$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $1371fb49892d7d75$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $1371fb49892d7d75$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $1371fb49892d7d75$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).EMPTY_ARGUMENT, $1371fb49892d7d75$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).MALFORMED_ARGUMENT, $1371fb49892d7d75$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $1371fb49892d7d75$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $61305d61fb2438cc$export$b87f371cbc396fcf).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $1371fb49892d7d75$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $1371fb49892d7d75$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).MALFORMED_ARGUMENT, $1371fb49892d7d75$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $1371fb49892d7d75$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $1371fb49892d7d75$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $1371fb49892d7d75$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $1371fb49892d7d75$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $1371fb49892d7d75$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $1371fb49892d7d75$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $1371fb49892d7d75$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $1371fb49892d7d75$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $1371fb49892d7d75$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $61305d61fb2438cc$export$b87f371cbc396fcf).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $3c6010c57b1d0102$export$29c5368be8904d27)(skeleton, this.locale);
                        var style = {
                            type: (0, $61305d61fb2438cc$export$906452485466fa53).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $053cfcd684323523$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $61305d61fb2438cc$export$b87f371cbc396fcf).date : (0, $61305d61fb2438cc$export$b87f371cbc396fcf).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $61305d61fb2438cc$export$b87f371cbc396fcf).number : argType === 'date' ? (0, $61305d61fb2438cc$export$b87f371cbc396fcf).date : (0, $61305d61fb2438cc$export$b87f371cbc396fcf).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $1371fb49892d7d75$var$createLocation(typeEndPosition_1, (0, $3g9wx.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $1371fb49892d7d75$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $8fe0cfc43b7be4da$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $1371fb49892d7d75$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $61305d61fb2438cc$export$b87f371cbc396fcf).select,
                        value: value,
                        options: $1371fb49892d7d75$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $61305d61fb2438cc$export$b87f371cbc396fcf).plural,
                        value: value,
                        options: $1371fb49892d7d75$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $1371fb49892d7d75$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $1371fb49892d7d75$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $1371fb49892d7d75$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $7658537414b1aff9$export$71cee2f16fba2480)(skeleton);
        } catch (e) {
            return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $61305d61fb2438cc$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $7658537414b1aff9$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $8fe0cfc43b7be4da$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $1371fb49892d7d75$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $8fe0cfc43b7be4da$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $8fe0cfc43b7be4da$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $8fe0cfc43b7be4da$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $8fe0cfc43b7be4da$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $1371fb49892d7d75$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $1371fb49892d7d75$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $8fe0cfc43b7be4da$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $8fe0cfc43b7be4da$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $1371fb49892d7d75$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $8fe0cfc43b7be4da$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $1371fb49892d7d75$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $1371fb49892d7d75$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$1371fb49892d7d75$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $1371fb49892d7d75$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($1371fb49892d7d75$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $1371fb49892d7d75$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $1371fb49892d7d75$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $1371fb49892d7d75$var$_isAlphaOrSlash(codepoint) {
    return $1371fb49892d7d75$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $1371fb49892d7d75$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $1371fb49892d7d75$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $1371fb49892d7d75$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}




var $3g9wx = parcelRequire("3g9wx");

function $bdf05e47d6ac7c3a$var$cloneDeep(obj) {
    if (Array.isArray(obj)) // @ts-expect-error meh
    return (0, $3g9wx.__spreadArray)([], obj.map($bdf05e47d6ac7c3a$var$cloneDeep), true);
    if (obj !== null && typeof obj === 'object') // @ts-expect-error meh
    return Object.keys(obj).reduce(function(cloned, k) {
        // @ts-expect-error meh
        cloned[k] = $bdf05e47d6ac7c3a$var$cloneDeep(obj[k]);
        return cloned;
    }, {});
    return obj;
}
function $bdf05e47d6ac7c3a$var$hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    var cloned = $bdf05e47d6ac7c3a$var$cloneDeep(el);
    var options = cloned.options;
    cloned.options = Object.keys(options).reduce(function(all, k) {
        var newValue = $bdf05e47d6ac7c3a$export$be5687ba8bbdf416((0, $3g9wx.__spreadArray)((0, $3g9wx.__spreadArray)((0, $3g9wx.__spreadArray)([], ast.slice(0, positionToInject), true), options[k].value, true), ast.slice(positionToInject + 1), true));
        all[k] = {
            value: newValue
        };
        return all;
    }, {});
    return cloned;
}
function $bdf05e47d6ac7c3a$var$isPluralOrSelectElement(el) {
    return (0, $61305d61fb2438cc$export$6c796d116f0a4fbc)(el) || (0, $61305d61fb2438cc$export$dcfe1c11d168b5a1)(el);
}
function $bdf05e47d6ac7c3a$var$findPluralOrSelectElement(ast) {
    return !!ast.find(function(el) {
        if ($bdf05e47d6ac7c3a$var$isPluralOrSelectElement(el)) return true;
        if ((0, $61305d61fb2438cc$export$5c83de34745812b)(el)) return $bdf05e47d6ac7c3a$var$findPluralOrSelectElement(el.children);
        return false;
    });
}
function $bdf05e47d6ac7c3a$export$be5687ba8bbdf416(ast) {
    for(var i = 0; i < ast.length; i++){
        var el = ast[i];
        if ($bdf05e47d6ac7c3a$var$isPluralOrSelectElement(el)) return [
            $bdf05e47d6ac7c3a$var$hoistPluralOrSelectElement(ast, el, i)
        ];
        if ((0, $61305d61fb2438cc$export$5c83de34745812b)(el) && $bdf05e47d6ac7c3a$var$findPluralOrSelectElement([
            el
        ])) throw new Error('Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option');
    }
    return ast;
}
/**
 * Collect all variables in an AST to Record<string, TYPE>
 * @param ast AST to collect variables from
 * @param vars Record of variable name to variable type
 */ function $bdf05e47d6ac7c3a$var$collectVariables(ast, vars) {
    if (vars === void 0) vars = new Map();
    ast.forEach(function(el) {
        if ((0, $61305d61fb2438cc$export$4f55724281bdfaf9)(el) || (0, $61305d61fb2438cc$export$32d811605da75f40)(el) || (0, $61305d61fb2438cc$export$34ec46f596b1702f)(el) || (0, $61305d61fb2438cc$export$e11187b219e191e1)(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) throw new Error("Variable ".concat(el.value, " has conflicting types"));
            vars.set(el.value, el.type);
        }
        if ((0, $61305d61fb2438cc$export$6c796d116f0a4fbc)(el) || (0, $61305d61fb2438cc$export$dcfe1c11d168b5a1)(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach(function(k) {
                $bdf05e47d6ac7c3a$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ((0, $61305d61fb2438cc$export$5c83de34745812b)(el)) {
            vars.set(el.value, el.type);
            $bdf05e47d6ac7c3a$var$collectVariables(el.children, vars);
        }
    });
}
function $bdf05e47d6ac7c3a$export$1edd9c892fdd9d27(a, b) {
    var aVars = new Map();
    var bVars = new Map();
    $bdf05e47d6ac7c3a$var$collectVariables(a, aVars);
    $bdf05e47d6ac7c3a$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: new Error("Different number of variables: [".concat(Array.from(aVars.keys()).join(', '), "] vs [").concat(Array.from(bVars.keys()).join(', '), "]"))
    };
    return Array.from(aVars.entries()).reduce(function(result, _a) {
        var key = _a[0], type = _a[1];
        if (!result.success) return result;
        var bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: new Error("Missing variable ".concat(key, " in message"))
        };
        if (bType !== type) return {
            success: false,
            error: new Error("Variable ".concat(key, " has conflicting types: ").concat((0, $61305d61fb2438cc$export$b87f371cbc396fcf)[type], " vs ").concat((0, $61305d61fb2438cc$export$b87f371cbc396fcf)[bType]))
        };
        return result;
    }, {
        success: true
    });
}


function $d7c7a598e4f17560$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $61305d61fb2438cc$export$dcfe1c11d168b5a1)(el) || (0, $61305d61fb2438cc$export$6c796d116f0a4fbc)(el)) for(var k in el.options){
            delete el.options[k].location;
            $d7c7a598e4f17560$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $61305d61fb2438cc$export$e11187b219e191e1)(el) && (0, $61305d61fb2438cc$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $61305d61fb2438cc$export$32d811605da75f40)(el) || (0, $61305d61fb2438cc$export$34ec46f596b1702f)(el)) && (0, $61305d61fb2438cc$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $61305d61fb2438cc$export$5c83de34745812b)(el)) $d7c7a598e4f17560$var$pruneLocation(el.children);
    });
}
function $d7c7a598e4f17560$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $3g9wx.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $1371fb49892d7d75$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $8fe0cfc43b7be4da$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $d7c7a598e4f17560$var$pruneLocation(result.val);
    return result.val;
}
var $d7c7a598e4f17560$export$d3c1bfa0f7d806e9 = (0, $1371fb49892d7d75$export$7acfa6ed01010e37);




var $3g9wx = parcelRequire("3g9wx");
var $c25ea76cd3f9e130$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($c25ea76cd3f9e130$export$d4e71bc0b80dc0fb || ($c25ea76cd3f9e130$export$d4e71bc0b80dc0fb = {}));
var $c25ea76cd3f9e130$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $3g9wx.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $c25ea76cd3f9e130$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $3g9wx.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $c25ea76cd3f9e130$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($c25ea76cd3f9e130$export$7369836851cc1329);
var $c25ea76cd3f9e130$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $3g9wx.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $c25ea76cd3f9e130$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($c25ea76cd3f9e130$export$7369836851cc1329);
var $c25ea76cd3f9e130$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $3g9wx.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $c25ea76cd3f9e130$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($c25ea76cd3f9e130$export$7369836851cc1329);


var $1ab34a9aa585c027$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($1ab34a9aa585c027$export$49694c2877b44c57 || ($1ab34a9aa585c027$export$49694c2877b44c57 = {}));
function $1ab34a9aa585c027$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $1ab34a9aa585c027$export$49694c2877b44c57.literal || part.type !== $1ab34a9aa585c027$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $1ab34a9aa585c027$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $1ab34a9aa585c027$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $61305d61fb2438cc$export$cfa10c5697238752)(els[0])) return [
        {
            type: $1ab34a9aa585c027$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $61305d61fb2438cc$export$cfa10c5697238752)(el)) {
            result.push({
                type: $1ab34a9aa585c027$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $61305d61fb2438cc$export$c0ece297bdd0c082)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $1ab34a9aa585c027$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $c25ea76cd3f9e130$export$8bfc137e4d23fdf0)(varName, originalMessage);
        var value = values[varName];
        if ((0, $61305d61fb2438cc$export$4f55724281bdfaf9)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $1ab34a9aa585c027$export$49694c2877b44c57.literal : $1ab34a9aa585c027$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $61305d61fb2438cc$export$32d811605da75f40)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $61305d61fb2438cc$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $1ab34a9aa585c027$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $61305d61fb2438cc$export$34ec46f596b1702f)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $61305d61fb2438cc$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $1ab34a9aa585c027$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $61305d61fb2438cc$export$e11187b219e191e1)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $61305d61fb2438cc$export$3f9a19cd4152eda3)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $1ab34a9aa585c027$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $61305d61fb2438cc$export$5c83de34745812b)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$1ab34a9aa585c027$export$df0c12a2d414a163(formatFn)) throw new (0, $c25ea76cd3f9e130$export$cbc0db47c750f7c9)(value_1, 'function', originalMessage);
            var parts = $1ab34a9aa585c027$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $1ab34a9aa585c027$export$49694c2877b44c57.literal : $1ab34a9aa585c027$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $61305d61fb2438cc$export$dcfe1c11d168b5a1)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $c25ea76cd3f9e130$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $1ab34a9aa585c027$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $61305d61fb2438cc$export$6c796d116f0a4fbc)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $c25ea76cd3f9e130$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $c25ea76cd3f9e130$export$d4e71bc0b80dc0fb).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $c25ea76cd3f9e130$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $1ab34a9aa585c027$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $1ab34a9aa585c027$var$mergeLiteral(result);
}


// -- MessageFormat --------------------------------------------------------
function $4c27f916aa25d57a$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $3g9wx.__assign)((0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $4c27f916aa25d57a$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $4c27f916aa25d57a$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $3g9wx.__assign)({}, defaultConfig));
}
function $4c27f916aa25d57a$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $4c27f916aa25d57a$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $f84f165f6ccbce1d$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $3g9wx.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4c27f916aa25d57a$var$createFastMemoizeCache(cache.number),
            strategy: (0, $f84f165f6ccbce1d$export$c5491a8691a23b9e).variadic
        }),
        getDateTimeFormat: (0, $f84f165f6ccbce1d$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $3g9wx.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4c27f916aa25d57a$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $f84f165f6ccbce1d$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: (0, $f84f165f6ccbce1d$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $3g9wx.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4c27f916aa25d57a$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $f84f165f6ccbce1d$export$c5491a8691a23b9e).variadic
        })
    };
}
var $4c27f916aa25d57a$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $1ab34a9aa585c027$export$49694c2877b44c57).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $1ab34a9aa585c027$export$275d4a3bb5f66fda)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $3g9wx.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $4c27f916aa25d57a$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $4c27f916aa25d57a$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $d7c7a598e4f17560$export$98e6a39c04603d36);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();




var $f20c0d9b18242783$export$2e2bcd8739ae039 = (0, $4c27f916aa25d57a$export$d342343268debc40);



var $3g9wx = parcelRequire("3g9wx");
var $2409b6c860e8ee3f$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($2409b6c860e8ee3f$export$557d6acb76e8a244 || ($2409b6c860e8ee3f$export$557d6acb76e8a244 = {}));
var $2409b6c860e8ee3f$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $3g9wx.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $2409b6c860e8ee3f$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $3g9wx.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $2409b6c860e8ee3f$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($2409b6c860e8ee3f$export$c016d36112f6ddf8);
var $2409b6c860e8ee3f$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $3g9wx.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $2409b6c860e8ee3f$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($2409b6c860e8ee3f$export$c016d36112f6ddf8);
var $2409b6c860e8ee3f$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $3g9wx.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $2409b6c860e8ee3f$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($2409b6c860e8ee3f$export$c016d36112f6ddf8);
var $2409b6c860e8ee3f$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $3g9wx.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $2409b6c860e8ee3f$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($2409b6c860e8ee3f$export$c016d36112f6ddf8);
var $2409b6c860e8ee3f$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $3g9wx.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($2409b6c860e8ee3f$export$e3b7eee1dbc44895);
var $2409b6c860e8ee3f$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $3g9wx.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $2409b6c860e8ee3f$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($2409b6c860e8ee3f$export$c016d36112f6ddf8);


function $3ce1dbd9202fe22b$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $3ce1dbd9202fe22b$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $3ce1dbd9202fe22b$var$defaultErrorHandler = function(error) {};
var $3ce1dbd9202fe22b$var$defaultWarnHandler = function(warning) {};
var $3ce1dbd9202fe22b$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $3ce1dbd9202fe22b$var$defaultErrorHandler,
    onWarn: $3ce1dbd9202fe22b$var$defaultWarnHandler
};
function $3ce1dbd9202fe22b$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $3ce1dbd9202fe22b$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $3ce1dbd9202fe22b$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $3ce1dbd9202fe22b$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $f84f165f6ccbce1d$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $3g9wx.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $3ce1dbd9202fe22b$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $f84f165f6ccbce1d$export$c5491a8691a23b9e).variadic
    });
    var getNumberFormat = (0, $f84f165f6ccbce1d$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $3g9wx.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $3ce1dbd9202fe22b$var$createFastMemoizeCache(cache.number),
        strategy: (0, $f84f165f6ccbce1d$export$c5491a8691a23b9e).variadic
    });
    var getPluralRules = (0, $f84f165f6ccbce1d$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $3g9wx.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $3ce1dbd9202fe22b$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $f84f165f6ccbce1d$export$c5491a8691a23b9e).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $f84f165f6ccbce1d$export$fc10aeed3a532e2a)(function(message, locales, overrideFormats, opts) {
            return new (0, $4c27f916aa25d57a$export$d342343268debc40)(message, locales, overrideFormats, (0, $3g9wx.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $3ce1dbd9202fe22b$var$createFastMemoizeCache(cache.message),
            strategy: (0, $f84f165f6ccbce1d$export$c5491a8691a23b9e).variadic
        }),
        getRelativeTimeFormat: (0, $f84f165f6ccbce1d$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $3g9wx.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $3ce1dbd9202fe22b$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $f84f165f6ccbce1d$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $f84f165f6ccbce1d$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $3g9wx.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $3ce1dbd9202fe22b$var$createFastMemoizeCache(cache.list),
            strategy: (0, $f84f165f6ccbce1d$export$c5491a8691a23b9e).variadic
        }),
        getDisplayNames: (0, $f84f165f6ccbce1d$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $3g9wx.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $3ce1dbd9202fe22b$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $f84f165f6ccbce1d$export$c5491a8691a23b9e).variadic
        })
    };
}
function $3ce1dbd9202fe22b$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $2409b6c860e8ee3f$export$549f97e137a05c90)("No ".concat(type, " format named: ").concat(name)));
}


function $c3c8e0efe1b79300$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $c3c8e0efe1b79300$export$45c4bbf6e55bba1f(intl) {
    $c3c8e0efe1b79300$export$f5708dca728d7177(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $c3c8e0efe1b79300$export$b52f8d6fc0d47415 = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, (0, $3ce1dbd9202fe22b$export$b52f8d6fc0d47415)), {
    textComponent: $2hRE7.Fragment
});
var $c3c8e0efe1b79300$var$toKeyedReactNode = function(reactNode, key) {
    return $2hRE7.isValidElement(reactNode) ? $2hRE7.cloneElement(reactNode, {
        key: key
    }) : reactNode;
};
var $c3c8e0efe1b79300$export$d2fd241e0b53c057 = function(children) {
    var _a;
    /**
 * Note: {@link React.Children.map} will add its own index-based prefix to
 * every key anyway, so the auto-injected one doesn't even have to be unique.
 * This basically just tells React that it's explicit/intentional.
 */ return (_a = $2hRE7.Children.map(children, $c3c8e0efe1b79300$var$toKeyedReactNode)) !== null && _a !== void 0 ? _a : [];
};
function $c3c8e0efe1b79300$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($c3c8e0efe1b79300$export$d2fd241e0b53c057(parts));
    };
}
function $c3c8e0efe1b79300$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}



var $3g9wx = parcelRequire("3g9wx");
var $d8320d03eab1f849$exports = {};
'use strict';
var $e7457ee3702577b3$exports = {};
'use strict';

$e7457ee3702577b3$exports = (parcelRequire("iICAS"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $d8320d03eab1f849$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $d8320d03eab1f849$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $d8320d03eab1f849$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $d8320d03eab1f849$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $d8320d03eab1f849$var$TYPE_STATICS = {};
$d8320d03eab1f849$var$TYPE_STATICS[$e7457ee3702577b3$exports.ForwardRef] = $d8320d03eab1f849$var$FORWARD_REF_STATICS;
$d8320d03eab1f849$var$TYPE_STATICS[$e7457ee3702577b3$exports.Memo] = $d8320d03eab1f849$var$MEMO_STATICS;
function $d8320d03eab1f849$var$getStatics(component) {
    // React v16.11 and below
    if ($e7457ee3702577b3$exports.isMemo(component)) return $d8320d03eab1f849$var$MEMO_STATICS;
     // React v16.12 and above
    return $d8320d03eab1f849$var$TYPE_STATICS[component['$$typeof']] || $d8320d03eab1f849$var$REACT_STATICS;
}
var $d8320d03eab1f849$var$defineProperty = Object.defineProperty;
var $d8320d03eab1f849$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $d8320d03eab1f849$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $d8320d03eab1f849$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $d8320d03eab1f849$var$getPrototypeOf = Object.getPrototypeOf;
var $d8320d03eab1f849$var$objectPrototype = Object.prototype;
function $d8320d03eab1f849$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($d8320d03eab1f849$var$objectPrototype) {
            var inheritedComponent = $d8320d03eab1f849$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $d8320d03eab1f849$var$objectPrototype) $d8320d03eab1f849$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $d8320d03eab1f849$var$getOwnPropertyNames(sourceComponent);
        if ($d8320d03eab1f849$var$getOwnPropertySymbols) keys = keys.concat($d8320d03eab1f849$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $d8320d03eab1f849$var$getStatics(targetComponent);
        var sourceStatics = $d8320d03eab1f849$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$d8320d03eab1f849$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $d8320d03eab1f849$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $d8320d03eab1f849$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$d8320d03eab1f849$exports = $d8320d03eab1f849$var$hoistNonReactStatics;



var $2hRE7 = parcelRequire("2hRE7");

function $652ec4762e298e1f$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $652ec4762e298e1f$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $2hRE7.createContext(null)) : $2hRE7.createContext(null);
var $652ec4762e298e1f$var$IntlConsumer = $652ec4762e298e1f$var$IntlContext.Consumer, $652ec4762e298e1f$var$IntlProvider = $652ec4762e298e1f$var$IntlContext.Provider;
var $652ec4762e298e1f$export$2881499e37b75b9a = $652ec4762e298e1f$var$IntlProvider;
var $652ec4762e298e1f$export$841858b892ce1f4c = $652ec4762e298e1f$var$IntlContext;
function $652ec4762e298e1f$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $2hRE7.createElement($652ec4762e298e1f$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $c3c8e0efe1b79300$export$45c4bbf6e55bba1f)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $2hRE7.createElement(WrappedComponent, (0, $3g9wx.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($652ec4762e298e1f$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($d8320d03eab1f849$exports)))(// @ts-expect-error
    $2hRE7.forwardRef(function(props, ref) {
        return $2hRE7.createElement(WithIntl, (0, $3g9wx.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($d8320d03eab1f849$exports)))(WithIntl, WrappedComponent);
}


function $82bfc0a4555efa86$export$2e2bcd8739ae039() {
    var intl = $2hRE7.useContext((0, $652ec4762e298e1f$export$841858b892ce1f4c));
    (0, $c3c8e0efe1b79300$export$45c4bbf6e55bba1f)(intl);
    return intl;
}


var $8c32f457af76598a$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($8c32f457af76598a$var$DisplayName || ($8c32f457af76598a$var$DisplayName = {}));
var $8c32f457af76598a$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($8c32f457af76598a$var$DisplayNameParts || ($8c32f457af76598a$var$DisplayNameParts = {}));
var $8c32f457af76598a$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $82bfc0a4555efa86$export$2e2bcd8739ae039)();
    var value = props.value, children = props.children, formatProps = (0, $3g9wx.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$8c32f457af76598a$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $8c32f457af76598a$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $82bfc0a4555efa86$export$2e2bcd8739ae039)();
    var value = props.value, children = props.children, formatProps = (0, $3g9wx.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$8c32f457af76598a$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $8c32f457af76598a$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $82bfc0a4555efa86$export$2e2bcd8739ae039)();
        var value = props.value, children = props.children, formatProps = (0, $3g9wx.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $8c32f457af76598a$var$DisplayNameParts[name];
    return ComponentParts;
}
function $8c32f457af76598a$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $82bfc0a4555efa86$export$2e2bcd8739ae039)();
        var value = props.value, children = props.children, formatProps = (0, $3g9wx.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $2hRE7.Fragment;
        return $2hRE7.createElement(Text, null, formattedValue);
    };
    Component.displayName = $8c32f457af76598a$var$DisplayName[name];
    return Component;
}





/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $3g9wx = parcelRequire("3g9wx");

var $2hRE7 = parcelRequire("2hRE7");


function $7ba7fe3ae6685fa1$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $3g9wx.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $3g9wx.__rest)(nextProps, [
        "values"
    ]);
    return (0, $c3c8e0efe1b79300$export$d36bdfa510afb180)(nextValues, values) && (0, $c3c8e0efe1b79300$export$d36bdfa510afb180)(otherProps, nextOtherProps);
}
function $7ba7fe3ae6685fa1$var$FormattedMessage(props) {
    var intl = (0, $82bfc0a4555efa86$export$2e2bcd8739ae039)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $2hRE7.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $2hRE7.createElement(Component, null, nodes);
    return $2hRE7.createElement($2hRE7.Fragment, null, nodes);
}
$7ba7fe3ae6685fa1$var$FormattedMessage.displayName = 'FormattedMessage';
var $7ba7fe3ae6685fa1$var$MemoizedFormattedMessage = $2hRE7.memo($7ba7fe3ae6685fa1$var$FormattedMessage, $7ba7fe3ae6685fa1$var$areEqual);
$7ba7fe3ae6685fa1$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $7ba7fe3ae6685fa1$export$2e2bcd8739ae039 = $7ba7fe3ae6685fa1$var$MemoizedFormattedMessage;



/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $3g9wx = parcelRequire("3g9wx");


var $2hRE7 = parcelRequire("2hRE7");

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $3g9wx = parcelRequire("3g9wx");

var $3g9wx = parcelRequire("3g9wx");

var $3g9wx = parcelRequire("3g9wx");


var $1b28f5a63f3ea439$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $1b28f5a63f3ea439$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $3ce1dbd9202fe22b$export$4ee1db8ce44a209b)(formats, type, format, onError));
    var filteredOptions = (0, $3ce1dbd9202fe22b$export$d697c39a2985a4c)(options, $1b28f5a63f3ea439$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $1b28f5a63f3ea439$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $1b28f5a63f3ea439$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $2409b6c860e8ee3f$export$e3b7eee1dbc44895)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $1b28f5a63f3ea439$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $1b28f5a63f3ea439$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $2409b6c860e8ee3f$export$e3b7eee1dbc44895)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $1b28f5a63f3ea439$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var fromDate = typeof from === 'string' ? new Date(from || 0) : from;
    var toDate = typeof to === 'string' ? new Date(to || 0) : to;
    try {
        return $1b28f5a63f3ea439$export$a7f9565e3c81cd54(config, 'dateTimeRange', getDateTimeFormat, options).formatRange(fromDate, toDate);
    } catch (e) {
        config.onError(new (0, $2409b6c860e8ee3f$export$e3b7eee1dbc44895)('Error formatting date time range.', config.locale, e));
    }
    return String(fromDate);
}
function $1b28f5a63f3ea439$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $1b28f5a63f3ea439$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $2409b6c860e8ee3f$export$e3b7eee1dbc44895)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $1b28f5a63f3ea439$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $1b28f5a63f3ea439$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $2409b6c860e8ee3f$export$e3b7eee1dbc44895)('Error formatting time.', config.locale, e));
    }
    return [];
}





var $d345970dd15a4c8a$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $d345970dd15a4c8a$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $c25ea76cd3f9e130$export$7369836851cc1329)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $c25ea76cd3f9e130$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $3ce1dbd9202fe22b$export$d697c39a2985a4c)(options, $d345970dd15a4c8a$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $2409b6c860e8ee3f$export$e3b7eee1dbc44895)('Error formatting display name.', locale, e));
    }
}




var $3g9wx = parcelRequire("3g9wx");



var $d77baf08b8c04b66$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $d77baf08b8c04b66$var$now = Date.now();
function $d77baf08b8c04b66$var$generateToken(i) {
    return "".concat($d77baf08b8c04b66$var$now, "_").concat(i, "_").concat($d77baf08b8c04b66$var$now);
}
function $d77baf08b8c04b66$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $d77baf08b8c04b66$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $d77baf08b8c04b66$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $c25ea76cd3f9e130$export$7369836851cc1329)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $c25ea76cd3f9e130$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $3ce1dbd9202fe22b$export$d697c39a2985a4c)(options, $d77baf08b8c04b66$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = Array.from(values).map(function(v, i) {
            if (typeof v === 'object' && v !== null) {
                var id = $d77baf08b8c04b66$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $2409b6c860e8ee3f$export$e3b7eee1dbc44895)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}



var $3g9wx = parcelRequire("3g9wx");




function $ddbd25d37a115e2a$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $3g9wx.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $ddbd25d37a115e2a$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $ddbd25d37a115e2a$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $4c27f916aa25d57a$export$d342343268debc40).formats;
    return (0, $3g9wx.__assign)((0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, mfFormats), f1), {
        date: $ddbd25d37a115e2a$var$deepMergeOptions($ddbd25d37a115e2a$var$setTimeZoneInOptions(mfFormats.date, timeZone), $ddbd25d37a115e2a$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $ddbd25d37a115e2a$var$deepMergeOptions($ddbd25d37a115e2a$var$setTimeZoneInOptions(mfFormats.time, timeZone), $ddbd25d37a115e2a$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $ddbd25d37a115e2a$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $3ce1dbd9202fe22b$export$f5708dca728d7177)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $61305d61fb2438cc$export$b87f371cbc396fcf).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, defaultRichTextElements), values || {});
    formats = $ddbd25d37a115e2a$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $ddbd25d37a115e2a$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $2409b6c860e8ee3f$export$2ddcb436d0aa3688)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $2409b6c860e8ee3f$export$74a601a3d3f31621)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $3g9wx.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $2409b6c860e8ee3f$export$74a601a3d3f31621)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $2409b6c860e8ee3f$export$74a601a3d3f31621)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};




var $bcabe0f1b3fd9f1c$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $bcabe0f1b3fd9f1c$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $3ce1dbd9202fe22b$export$4ee1db8ce44a209b)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $3ce1dbd9202fe22b$export$d697c39a2985a4c)(options, $bcabe0f1b3fd9f1c$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $bcabe0f1b3fd9f1c$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $bcabe0f1b3fd9f1c$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $2409b6c860e8ee3f$export$e3b7eee1dbc44895)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $bcabe0f1b3fd9f1c$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $bcabe0f1b3fd9f1c$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $2409b6c860e8ee3f$export$e3b7eee1dbc44895)('Error formatting number.', config.locale, e));
    }
    return [];
}





var $a6540100dd0e2c87$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $a6540100dd0e2c87$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $c25ea76cd3f9e130$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $c25ea76cd3f9e130$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $3ce1dbd9202fe22b$export$d697c39a2985a4c)(options, $a6540100dd0e2c87$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $2409b6c860e8ee3f$export$e3b7eee1dbc44895)('Error formatting plural.', locale, e));
    }
    return 'other';
}





var $a6688e5fc179bb1c$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $a6688e5fc179bb1c$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $3ce1dbd9202fe22b$export$4ee1db8ce44a209b)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $3ce1dbd9202fe22b$export$d697c39a2985a4c)(options, $a6688e5fc179bb1c$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $a6688e5fc179bb1c$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $c25ea76cd3f9e130$export$7369836851cc1329)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $c25ea76cd3f9e130$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    try {
        return $a6688e5fc179bb1c$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $2409b6c860e8ee3f$export$e3b7eee1dbc44895)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}



function $972f4d35f94978d7$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $972f4d35f94978d7$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $972f4d35f94978d7$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.github.io/docs/getting-started/message-distribution");
}
function $972f4d35f94978d7$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $3ce1dbd9202fe22b$export$c3f4cd5551df13fd)(cache);
    var resolvedConfig = (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, (0, $3ce1dbd9202fe22b$export$b52f8d6fc0d47415)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $2409b6c860e8ee3f$export$3ca04dd7fb305893)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $2409b6c860e8ee3f$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $2409b6c860e8ee3f$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    $972f4d35f94978d7$var$verifyConfigMessages(resolvedConfig);
    return (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $bcabe0f1b3fd9f1c$export$f5dd818bff069720).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $bcabe0f1b3fd9f1c$export$6871080848f10b2f).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $a6688e5fc179bb1c$export$b4ea3b48dcf921f6).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $1b28f5a63f3ea439$export$3ae94a2503e890a1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $1b28f5a63f3ea439$export$dc1f059bce486b1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $1b28f5a63f3ea439$export$3203edd9e5edd663).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $1b28f5a63f3ea439$export$a7fc3a91cb2ec376).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $1b28f5a63f3ea439$export$af6e5d7a5c73edeb).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $a6540100dd0e2c87$export$bbbd05c900f3568d).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $ddbd25d37a115e2a$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        $t: (0, $ddbd25d37a115e2a$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        formatList: (0, $d77baf08b8c04b66$export$e8b8be48b45905bb).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $d77baf08b8c04b66$export$6f284aad1934db69).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $d345970dd15a4c8a$export$62fe1a4d9e891fa2).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}




function $e8e4d58b4ac07959$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $1ab34a9aa585c027$export$df0c12a2d414a163)(v) ? (0, $c3c8e0efe1b79300$export$cfec03d26465fa63)(v) : v;
        return acc;
    }, {});
}
var $e8e4d58b4ac07959$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $e8e4d58b4ac07959$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $ddbd25d37a115e2a$export$25868d1e8e76735f).apply(void 0, (0, $3g9wx.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return (0, $c3c8e0efe1b79300$export$d2fd241e0b53c057)(chunks);
    return chunks;
};
var $e8e4d58b4ac07959$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $3g9wx.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $e8e4d58b4ac07959$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $972f4d35f94978d7$export$7e4cbedfdd7b4c0d)((0, $3g9wx.__assign)((0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, (0, $c3c8e0efe1b79300$export$b52f8d6fc0d47415)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $3g9wx.__assign)((0, $3g9wx.__assign)({}, coreIntl), {
        formatMessage: $e8e4d58b4ac07959$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        $t: $e8e4d58b4ac07959$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};



function $42e4759825f879f5$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $42e4759825f879f5$var$IntlProvider = /** @class */ function(_super) {
    (0, $3g9wx.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $3ce1dbd9202fe22b$export$51c4f4e973f2dc00)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $e8e4d58b4ac07959$export$7e4cbedfdd7b4c0d)($42e4759825f879f5$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $42e4759825f879f5$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $42e4759825f879f5$var$processIntlConfig(props);
        if (!(0, $c3c8e0efe1b79300$export$d36bdfa510afb180)(prevConfig, config)) return {
            intl: (0, $e8e4d58b4ac07959$export$7e4cbedfdd7b4c0d)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $c3c8e0efe1b79300$export$45c4bbf6e55bba1f)(this.state.intl);
        return $2hRE7.createElement((0, $652ec4762e298e1f$export$2881499e37b75b9a), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $c3c8e0efe1b79300$export$b52f8d6fc0d47415);
    return IntlProvider;
}($2hRE7.PureComponent);
var $42e4759825f879f5$export$2e2bcd8739ae039 = $42e4759825f879f5$var$IntlProvider;





function $1ebaa880f6a9b11a$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $1ebaa880f6a9b11a$export$747d244ee58120dd(msg) {
    return msg;
}
var $1ebaa880f6a9b11a$export$40ae3194919d16b = (0, $8c32f457af76598a$export$b37e14176d001dec)('formatDate');
var $1ebaa880f6a9b11a$export$5b390a54f8a846f7 = (0, $8c32f457af76598a$export$b37e14176d001dec)('formatTime');
var $1ebaa880f6a9b11a$export$db80edc1e6b2f63d = (0, $8c32f457af76598a$export$b37e14176d001dec)('formatNumber');
var $1ebaa880f6a9b11a$export$f52b44e459e6e71d = (0, $8c32f457af76598a$export$b37e14176d001dec)('formatList');
var $1ebaa880f6a9b11a$export$c2336ea5aaab92fa = (0, $8c32f457af76598a$export$b37e14176d001dec)('formatDisplayName');
var $1ebaa880f6a9b11a$export$7fdc7d2c91ce149b = (0, $8c32f457af76598a$export$7448277f6036d2ab)('formatDate');
var $1ebaa880f6a9b11a$export$ec35873761676c2a = (0, $8c32f457af76598a$export$7448277f6036d2ab)('formatTime');


var $b713eeff5e50d6df$exports = {};
'use strict';

$b713eeff5e50d6df$exports = (parcelRequire("7KV6Y"));





var $2hRE7 = parcelRequire("2hRE7");
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $4e5b3c21207d0e2b$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $4e5b3c21207d0e2b$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $4e5b3c21207d0e2b$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ parcelRequire("2hRE7");
const $e07f02e8ee158f8a$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $e07f02e8ee158f8a$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};



const $5dcdef8fb35fd69f$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $4e5b3c21207d0e2b$export$2e2bcd8739ae039)(actualStyles);
};


function $a089f15bbad82768$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $e07f02e8ee158f8a$export$c4df1cb0c2b4d77c)();
        },
        cssMap () {
            throw (0, $e07f02e8ee158f8a$export$c4df1cb0c2b4d77c)();
        },
        cx: $5dcdef8fb35fd69f$export$a274e22fb40f762e,
        XCSSProp () {
            throw (0, $e07f02e8ee158f8a$export$c4df1cb0c2b4d77c)();
        }
    };
}


const $d819974bb38192de$var$strictApi = (0, $a089f15bbad82768$export$39716b4af53f4ad)();
const $d819974bb38192de$export$dbf350e5966cf602 = $d819974bb38192de$var$strictApi.css;
const $d819974bb38192de$export$eb1ecd84a24ee424 = $d819974bb38192de$var$strictApi.cssMap;
$d819974bb38192de$var$strictApi.cssMap;
const $d819974bb38192de$export$a274e22fb40f762e = $d819974bb38192de$var$strictApi.cx;
const $d819974bb38192de$var$XCSSProp = $d819974bb38192de$var$strictApi.XCSSProp;



var $6oQI4 = parcelRequire("6oQI4");




var $2hRE7 = parcelRequire("2hRE7");

var $59309b200f83fd0a$var$isProduction = true;
var $59309b200f83fd0a$var$prefix = 'Invariant failed';
function $59309b200f83fd0a$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($59309b200f83fd0a$var$isProduction) throw new Error($59309b200f83fd0a$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($59309b200f83fd0a$var$prefix, ": ").concat(provided) : $59309b200f83fd0a$var$prefix;
    throw new Error(value);
}





var $2hRE7 = parcelRequire("2hRE7");



var $2hRE7 = parcelRequire("2hRE7");
function $2594dcb19133fc32$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $2594dcb19133fc32$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $2hRE7.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $2hRE7.useRef)(true);
    var committed = (0, $2hRE7.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $2594dcb19133fc32$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $2hRE7.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $2594dcb19133fc32$export$33752cf3ee811995(callback, inputs) {
    return $2594dcb19133fc32$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $2594dcb19133fc32$export$1538c33de8887b59 = $2594dcb19133fc32$export$b6feb8998cd9b342;
var $2594dcb19133fc32$export$35808ee640e87ca7 = $2594dcb19133fc32$export$33752cf3ee811995;


/// <reference types="node" />
class $e823f8c41211d565$export$2e2bcd8739ae039 {
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
    constructor(props){
        this.payload = void 0;
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $e823f8c41211d565$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
}


class $deb77850a8c912b7$export$2e2bcd8739ae039 extends (0, $e823f8c41211d565$export$2e2bcd8739ae039) {
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
    constructor(props){
        super(props);
        this.context = void 0;
        this.handlers = void 0;
        this.hasFired = void 0;
        this._isUIAnalyticsEvent = true;
        this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            const payload = $deb77850a8c912b7$var$clonePayload(this.payload);
            return new $deb77850a8c912b7$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        };
        this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>{
                try {
                    handler(this, channel);
                } catch (e) {}
            });
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
}
const $deb77850a8c912b7$var$clonePayload = (payload)=>{
    try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return {
            ...payload
        };
    }
};




var $2hRE7 = parcelRequire("2hRE7");

var $2hRE7 = parcelRequire("2hRE7");
const $1357ebb24d9b1c0e$var$AnalyticsNextContext = (0, $2hRE7.createContext)({
    getAtlaskitAnalyticsContext: ()=>[],
    getAtlaskitAnalyticsEventHandlers: ()=>[]
});
var $1357ebb24d9b1c0e$export$2e2bcd8739ae039 = $1357ebb24d9b1c0e$var$AnalyticsNextContext;


var $3897e80c3672aa55$export$2e2bcd8739ae039 = (0, $1357ebb24d9b1c0e$export$2e2bcd8739ae039);


const $d3488628473a7850$export$d1f587f82ad51c4 = (0, $9a9850d6654223c3$export$4d143603f9782455)() ? ()=>{
    return (0, $2hRE7.useContext)((0, $3897e80c3672aa55$export$2e2bcd8739ae039));
} : ()=>{
    return (0, $2hRE7.useContext)((0, $3897e80c3672aa55$export$2e2bcd8739ae039));
};


const $901f3ead6d1c8247$export$5bf35293e545f20c = (0, $9a9850d6654223c3$export$4d143603f9782455)() ? function useAnalyticsEvents() {
    const $ = (0, $ebfe460bd680287b$exports.c)(5);
    const analyticsContext = (0, $d3488628473a7850$export$d1f587f82ad51c4)();
    let t0;
    let t1;
    if ($[0] !== analyticsContext) {
        t0 = (payload)=>new (0, $deb77850a8c912b7$export$2e2bcd8739ae039)({
                context: analyticsContext.getAtlaskitAnalyticsContext(),
                handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
                payload: payload
            });
        t1 = [
            analyticsContext
        ];
        $[0] = analyticsContext;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    const createAnalyticsEvent = (0, $2594dcb19133fc32$export$33752cf3ee811995)(t0, t1);
    let t2;
    if ($[3] !== createAnalyticsEvent) {
        t2 = {
            createAnalyticsEvent: createAnalyticsEvent
        };
        $[3] = createAnalyticsEvent;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function useAnalyticsEvents() {
    const analyticsContext = (0, $d3488628473a7850$export$d1f587f82ad51c4)();
    const createAnalyticsEvent = (0, $2594dcb19133fc32$export$33752cf3ee811995)((payload)=>{
        return new (0, $deb77850a8c912b7$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
};



var $2hRE7 = parcelRequire("2hRE7");
const $07eadcd92ecdb145$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $2hRE7.useRef)(value);
    ref.current = value;
    return ref;
};


const $aee0e9af9dd27fc9$export$a4687b0234b40e28 = (0, $9a9850d6654223c3$export$4d143603f9782455)() ? function usePlatformLeafEventHandler(t0) {
    const $ = (0, $ebfe460bd680287b$exports.c)(9);
    const { fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $901f3ead6d1c8247$export$5bf35293e545f20c)();
    const dataRef = (0, $07eadcd92ecdb145$export$1d27a74659855e44)(analyticsData);
    const fnRef = (0, $07eadcd92ecdb145$export$1d27a74659855e44)(fn);
    let t1;
    if ($[0] !== action || $[1] !== actionSubject || $[2] !== componentName || $[3] !== createAnalyticsEvent || $[4] !== dataRef || $[5] !== fnRef || $[6] !== packageName || $[7] !== packageVersion) {
        t1 = (value)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject || componentName,
                attributes: {
                    componentName: componentName,
                    packageName: packageName,
                    packageVersion: packageVersion
                }
            });
            const context = {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion,
                ...dataRef.current
            };
            analyticsEvent.context.push(context);
            const clone = analyticsEvent.clone();
            if (clone) clone.fire("atlaskit");
            fnRef.current(value, analyticsEvent);
        };
        $[0] = action;
        $[1] = actionSubject;
        $[2] = componentName;
        $[3] = createAnalyticsEvent;
        $[4] = dataRef;
        $[5] = fnRef;
        $[6] = packageName;
        $[7] = packageVersion;
        $[8] = t1;
    } else t1 = $[8];
    const handler = t1;
    return handler;
} : function usePlatformLeafEventHandler({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $901f3ead6d1c8247$export$5bf35293e545f20c)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $07eadcd92ecdb145$export$1d27a74659855e44)(analyticsData);
    const fnRef = (0, $07eadcd92ecdb145$export$1d27a74659855e44)(fn);
    const handler = (0, $2hRE7.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
};




var $2hRE7 = parcelRequire("2hRE7");




var $2hRE7 = parcelRequire("2hRE7");
const $d476a65b8c33b77a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $2hRE7.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $d476a65b8c33b77a$var$RouterLinkProvider = (0, $9a9850d6654223c3$export$4d143603f9782455)() ? (t0)=>{
    const $ = (0, $ebfe460bd680287b$exports.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsx)($d476a65b8c33b77a$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsx)($d476a65b8c33b77a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d476a65b8c33b77a$export$2e2bcd8739ae039 = $d476a65b8c33b77a$var$RouterLinkProvider;


const $6a9d2e5490bb2e2d$export$6d558eab13290f59 = (0, $9a9850d6654223c3$export$4d143603f9782455)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $2hRE7.useContext)((0, $d476a65b8c33b77a$export$2931e0ee690eee88));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $2hRE7.useContext)((0, $d476a65b8c33b77a$export$2931e0ee690eee88));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};


/**
 * An empty function which does nothing.
 */ function $ac7a3683f4ae7d8e$export$2e2bcd8739ae039() {}



var $2hRE7 = parcelRequire("2hRE7");
function $f82d030976e11939$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).useId().replace(/[:«»]/g, '_');
}



var $2hRE7 = parcelRequire("2hRE7");
const $8fa1151464f0741f$var$interactionContext = (0, $2hRE7.createContext)(null);
var $8fa1151464f0741f$export$2e2bcd8739ae039 = $8fa1151464f0741f$var$interactionContext;





parcelRequire("2hRE7");

const $c0a32bc9d1a880c4$var$visuallyHiddenStyles = null; /**
                                    * __Visually hidden__
                                    *
                                    * A composable element to apply a visually hidden effect to children.
                                    * Useful for accessibility compliance.
                                    *
                                    * @example
                                    * ```jsx
                                    * import VisuallyHidden from '@atlaskit/visually-hidden';
                                    *
                                    * export default () => (
                                    *   <div style={{ border: '1px solid black' }}>
                                    *      There is text hidden between the brackets [
                                    *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
                                    *   </div>
                                    * );
                                    * ```
                                    */ 
const $c0a32bc9d1a880c4$var$VisuallyHidden = (0, $9a9850d6654223c3$export$4d143603f9782455)() ? (t0)=>{
    const $ = (0, $ebfe460bd680287b$exports.c)(6);
    const { children: children, testId: testId, role: role, id: id } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $4e5b3c21207d0e2b$export$2e2bcd8739ae039)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _30huDKdnbC _4bt5LAnQyn _2WAcuGnQyn _39xV02HZdu _0jFU0VHZdu _1mT5xdWVPG _1C7BHPdEFh _20VacPYbGa _1ANEUSLRg7"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== id || $[3] !== role || $[4] !== testId) {
        t2 = /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsx)("span", {
            id: id,
            "data-testid": testId,
            role: role,
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = id;
        $[3] = role;
        $[4] = testId;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $4e5b3c21207d0e2b$export$2e2bcd8739ae039)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _30huDKdnbC _4bt5LAnQyn _2WAcuGnQyn _39xV02HZdu _0jFU0VHZdu _1mT5xdWVPG _1C7BHPdEFh _20VacPYbGa _1ANEUSLRg7"
        ]),
        children: children
    });
};
$c0a32bc9d1a880c4$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $c0a32bc9d1a880c4$export$2e2bcd8739ae039 = $c0a32bc9d1a880c4$var$VisuallyHidden;






var $2hRE7 = parcelRequire("2hRE7");

const $f8af5d2a5653c4f2$var$focusRingStyles = null;
const $f8af5d2a5653c4f2$var$insetFocusRingStyles = null;
const $f8af5d2a5653c4f2$export$35a3bebf7ef2d934 = /*#__PURE__*/ (0, $2hRE7.forwardRef)((0, $9a9850d6654223c3$export$4d143603f9782455)() ? (t0, ref)=>{
    const $ = (0, $ebfe460bd680287b$exports.c)(21);
    let children;
    let htmlAttributes;
    let isInset;
    let style;
    let t1;
    let testId;
    let xcss;
    if ($[0] !== t0) {
        ({ as: t1, children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = isInset;
        $[4] = style;
        $[5] = t1;
        $[6] = testId;
        $[7] = xcss;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        isInset = $[3];
        style = $[4];
        t1 = $[5];
        testId = $[6];
        xcss = $[7];
    }
    const Component = t1 === undefined ? "button" : t1;
    let safeHtmlAttributes;
    if ($[8] !== htmlAttributes) {
        const { className: _spreadClass, ...t2 } = htmlAttributes;
        safeHtmlAttributes = t2;
        $[8] = htmlAttributes;
        $[9] = safeHtmlAttributes;
    } else safeHtmlAttributes = $[9];
    const t2 = isInset && "_34b3D2ZPSy _0aMSfYZPSy";
    let t3;
    if ($[10] !== t2 || $[11] !== xcss) {
        t3 = (0, $4e5b3c21207d0e2b$export$2e2bcd8739ae039)([
            "_2hGPVj98eZ _2i3C1kYbGa _2kH23qT6kp _1ubuxonXvL _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _3e11vU6wH8 _0hSAgbHZdu",
            t2,
            xcss
        ]);
        $[10] = t2;
        $[11] = xcss;
        $[12] = t3;
    } else t3 = $[12];
    let t4;
    if ($[13] !== Component || $[14] !== children || $[15] !== ref || $[16] !== safeHtmlAttributes || $[17] !== style || $[18] !== t3 || $[19] !== testId) {
        t4 = /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsx)(Component, {
            ...safeHtmlAttributes,
            ref: ref,
            className: t3,
            style: style,
            "data-testid": testId,
            children: children
        });
        $[13] = Component;
        $[14] = children;
        $[15] = ref;
        $[16] = safeHtmlAttributes;
        $[17] = style;
        $[18] = t3;
        $[19] = testId;
        $[20] = t4;
    } else t4 = $[20];
    return t4;
} : ({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsx)(Component, {
        ...safeHtmlAttributes,
        ref: ref,
        className: (0, $4e5b3c21207d0e2b$export$2e2bcd8739ae039)([
            "_2hGPVj98eZ _2i3C1kYbGa _2kH23qT6kp _1ubuxonXvL _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _3e11vU6wH8 _0hSAgbHZdu",
            isInset && "_34b3D2ZPSy _0aMSfYZPSy",
            xcss
        ]),
        style: style,
        "data-testid": testId,
        children: children
    });
});


const $fadbec09bc33f31a$var$styles = {
    root: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _24h04i2Njc",
    position: "_1mT5xdRAKS"
};
const $fadbec09bc33f31a$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $fadbec09bc33f31a$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/; /**
                                                              * __Anchor__
                                                              *
                                                              * A primitive for building custom anchor links.
                                                              *
                                                              * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
                                                              * - [Code](https://atlassian.design/components/primitives/anchor/code)
                                                              * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
                                                              */ 
const $fadbec09bc33f31a$var$AnchorNoRef = (0, $9a9850d6654223c3$export$4d143603f9782455)() ? (t0, ref)=>{
    const $ = (0, $ebfe460bd680287b$exports.c)(50);
    let analyticsContext;
    let ariaLabel;
    let ariaLabelledBy;
    let children;
    let componentName;
    let href;
    let htmlAttributes;
    let interactionName;
    let style;
    let t1;
    let t2;
    let target;
    let testId;
    let xcss;
    if ($[0] !== t0) {
        ({ href: href, children: children, onClick: t1, interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: t2, ...htmlAttributes } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = ariaLabel;
        $[3] = ariaLabelledBy;
        $[4] = children;
        $[5] = componentName;
        $[6] = href;
        $[7] = htmlAttributes;
        $[8] = interactionName;
        $[9] = style;
        $[10] = t1;
        $[11] = t2;
        $[12] = target;
        $[13] = testId;
        $[14] = xcss;
    } else {
        analyticsContext = $[1];
        ariaLabel = $[2];
        ariaLabelledBy = $[3];
        children = $[4];
        componentName = $[5];
        href = $[6];
        htmlAttributes = $[7];
        interactionName = $[8];
        style = $[9];
        t1 = $[10];
        t2 = $[11];
        target = $[12];
        testId = $[13];
        xcss = $[14];
    }
    const providedOnClick = t1 === undefined ? (0, $ac7a3683f4ae7d8e$export$2e2bcd8739ae039) : t1;
    const newWindowLabel = t2 === undefined ? "(opens new window)" : t2;
    const interactionContext = (0, $2hRE7.useContext)((0, $8fa1151464f0741f$export$2e2bcd8739ae039));
    let t3;
    if ($[15] !== interactionContext || $[16] !== interactionName || $[17] !== providedOnClick) {
        t3 = (e, analyticsEvent)=>{
            interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
            providedOnClick(e, analyticsEvent);
        };
        $[15] = interactionContext;
        $[16] = interactionName;
        $[17] = providedOnClick;
        $[18] = t3;
    } else t3 = $[18];
    const handleClick = t3;
    const opensNewWindowLabelId = (0, $f82d030976e11939$export$f680877a34711e37)();
    const t4 = componentName || "Anchor";
    let t5;
    if ($[19] !== analyticsContext || $[20] !== handleClick || $[21] !== t4) {
        t5 = {
            fn: handleClick,
            action: "clicked",
            componentName: t4,
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            analyticsData: analyticsContext,
            actionSubject: "link"
        };
        $[19] = analyticsContext;
        $[20] = handleClick;
        $[21] = t4;
        $[22] = t5;
    } else t5 = $[22];
    const onClick = (0, $aee0e9af9dd27fc9$export$a4687b0234b40e28)(t5);
    let safeHtmlAttributes;
    if ($[23] !== htmlAttributes) {
        const { className: _spreadClass, ...t6 } = htmlAttributes;
        safeHtmlAttributes = t6;
        $[23] = htmlAttributes;
        $[24] = safeHtmlAttributes;
    } else safeHtmlAttributes = $[24];
    const RouterLink = (0, $6a9d2e5490bb2e2d$export$6d558eab13290f59)();
    const isExternal = typeof href === "string" && $fadbec09bc33f31a$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === "string" && $fadbec09bc33f31a$var$IS_NON_HTTP_BASED.test(href);
    const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === "object";
    (0, $59309b200f83fd0a$export$2e2bcd8739ae039)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    const Component = isRouterLink ? RouterLink : "a";
    const t6 = !isRouterLink && typeof href !== "string" ? undefined : href;
    const t7 = ariaLabel && target === "_blank" && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel;
    const t8 = ariaLabelledBy && target === "_blank" ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy;
    let t9;
    if ($[25] !== xcss) {
        t9 = (0, $5dcdef8fb35fd69f$export$a274e22fb40f762e)($fadbec09bc33f31a$var$styles.root, $fadbec09bc33f31a$var$styles.position, xcss);
        $[25] = xcss;
        $[26] = t9;
    } else t9 = $[26];
    const t10 = testId ? isRouterLink ? "true" : "false" : undefined;
    let t11;
    if ($[27] !== ariaLabel || $[28] !== ariaLabelledBy || $[29] !== children || $[30] !== newWindowLabel || $[31] !== opensNewWindowLabelId || $[32] !== target) {
        t11 = target === "_blank" && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsx)((0, $c0a32bc9d1a880c4$export$2e2bcd8739ae039), {
            id: opensNewWindowLabelId,
            children: `, ${newWindowLabel}`
        });
        $[27] = ariaLabel;
        $[28] = ariaLabelledBy;
        $[29] = children;
        $[30] = newWindowLabel;
        $[31] = opensNewWindowLabelId;
        $[32] = target;
        $[33] = t11;
    } else t11 = $[33];
    let t12;
    if ($[34] !== Component || $[35] !== children || $[36] !== onClick || $[37] !== ref || $[38] !== safeHtmlAttributes || $[39] !== style || $[40] !== t10 || $[41] !== t11 || $[42] !== t6 || $[43] !== t7 || $[44] !== t8 || $[45] !== t9 || $[46] !== target || $[47] !== testId || $[48] !== xcss) {
        t12 = /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsxs)((0, $f8af5d2a5653c4f2$export$35a3bebf7ef2d934), {
            as: Component,
            className: xcss,
            style: style,
            ref: ref,
            ...safeHtmlAttributes,
            href: t6,
            target: target,
            onClick: onClick,
            "aria-label": t7,
            "aria-labelledby": t8,
            xcss: t9,
            testId: testId,
            "data-is-router-link": t10,
            children: [
                children,
                t11
            ]
        });
        $[34] = Component;
        $[35] = children;
        $[36] = onClick;
        $[37] = ref;
        $[38] = safeHtmlAttributes;
        $[39] = style;
        $[40] = t10;
        $[41] = t11;
        $[42] = t6;
        $[43] = t7;
        $[44] = t8;
        $[45] = t9;
        $[46] = target;
        $[47] = testId;
        $[48] = xcss;
        $[49] = t12;
    } else t12 = $[49];
    return t12;
} : ({ href: href, children: children, onClick: providedOnClick = (0, $ac7a3683f4ae7d8e$export$2e2bcd8739ae039), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $2hRE7.useContext)((0, $8fa1151464f0741f$export$2e2bcd8739ae039));
    const handleClick = (0, $2hRE7.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $f82d030976e11939$export$f680877a34711e37)();
    const onClick = (0, $aee0e9af9dd27fc9$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $6a9d2e5490bb2e2d$export$6d558eab13290f59)();
    const isExternal = typeof href === 'string' && $fadbec09bc33f31a$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $fadbec09bc33f31a$var$IS_NON_HTTP_BASED.test(href); /**
                                                                                    * Renders a router link if:
                                                                                    *
                                                                                    * - a link component is set in the app provider
                                                                                    * - it's not an external link (starting with `http://` or `https://`)
                                                                                    * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
                                                                                    */ 
    const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $59309b200f83fd0a$export$2e2bcd8739ae039)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsxs)((0, $f8af5d2a5653c4f2$export$35a3bebf7ef2d934 // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
    ), {
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $5dcdef8fb35fd69f$export$a274e22fb40f762e)($fadbec09bc33f31a$var$styles.root, $fadbec09bc33f31a$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsx)((0, $c0a32bc9d1a880c4$export$2e2bcd8739ae039), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    });
};
const $fadbec09bc33f31a$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $2hRE7.forwardRef)($fadbec09bc33f31a$var$AnchorNoRef);





var $2hRE7 = parcelRequire("2hRE7");


var $2hRE7 = parcelRequire("2hRE7");
const $fd01749441b28f7c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $2hRE7.createContext)('elevation.surface');


const $4f4848e61f427859$var$baseStyles = null;
const $4f4848e61f427859$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_0KLXruXL80",
    'color.background.accent.lime.subtlest.hovered': "_0KLXruL7r8",
    'color.background.accent.lime.subtlest.pressed': "_0KLXrulDnJ",
    'color.background.accent.lime.subtler': "_0KLXruuKDS",
    'color.background.accent.lime.subtler.hovered': "_0KLXruuIDk",
    'color.background.accent.lime.subtler.pressed': "_0KLXruyTNr",
    'color.background.accent.lime.subtle': "_0KLXruZcd0",
    'color.background.accent.lime.subtle.hovered': "_0KLXrude7x",
    'color.background.accent.lime.subtle.pressed': "_0KLXrum9Fz",
    'color.background.accent.lime.bolder': "_0KLXrubYhN",
    'color.background.accent.lime.bolder.hovered': "_0KLXruaWdC",
    'color.background.accent.lime.bolder.pressed': "_0KLXruCN3C",
    'color.background.accent.red.subtlest': "_0KLXrusDFP",
    'color.background.accent.red.subtlest.hovered': "_0KLXruIg5O",
    'color.background.accent.red.subtlest.pressed': "_0KLXruElzn",
    'color.background.accent.red.subtler': "_0KLXrubV9i",
    'color.background.accent.red.subtler.hovered': "_0KLXruFOVf",
    'color.background.accent.red.subtler.pressed': "_0KLXruFnU8",
    'color.background.accent.red.subtle': "_0KLXru0cUQ",
    'color.background.accent.red.subtle.hovered': "_0KLXruIt8U",
    'color.background.accent.red.subtle.pressed': "_0KLXrunRhf",
    'color.background.accent.red.bolder': "_0KLXruQrW1",
    'color.background.accent.red.bolder.hovered': "_0KLXrumCVf",
    'color.background.accent.red.bolder.pressed': "_0KLXruPm25",
    'color.background.accent.orange.subtlest': "_0KLXru2QQR",
    'color.background.accent.orange.subtlest.hovered': "_0KLXru629A",
    'color.background.accent.orange.subtlest.pressed': "_0KLXrupg0Z",
    'color.background.accent.orange.subtler': "_0KLXruwJ86",
    'color.background.accent.orange.subtler.hovered': "_0KLXruEo5I",
    'color.background.accent.orange.subtler.pressed': "_0KLXru78bI",
    'color.background.accent.orange.subtle': "_0KLXruuwVU",
    'color.background.accent.orange.subtle.hovered': "_0KLXrunwBH",
    'color.background.accent.orange.subtle.pressed': "_0KLXruKHmw",
    'color.background.accent.orange.bolder': "_0KLXrux4f7",
    'color.background.accent.orange.bolder.hovered': "_0KLXruwYNk",
    'color.background.accent.orange.bolder.pressed': "_0KLXruDYlO",
    'color.background.accent.yellow.subtlest': "_0KLXru56u3",
    'color.background.accent.yellow.subtlest.hovered': "_0KLXruBwZU",
    'color.background.accent.yellow.subtlest.pressed': "_0KLXruHN5H",
    'color.background.accent.yellow.subtler': "_0KLXruLv9B",
    'color.background.accent.yellow.subtler.hovered': "_0KLXruJMtC",
    'color.background.accent.yellow.subtler.pressed': "_0KLXruVvUp",
    'color.background.accent.yellow.subtle': "_0KLXruC29w",
    'color.background.accent.yellow.subtle.hovered': "_0KLXruSF9i",
    'color.background.accent.yellow.subtle.pressed': "_0KLXruOIUD",
    'color.background.accent.yellow.bolder': "_0KLXruYB6L",
    'color.background.accent.yellow.bolder.hovered': "_0KLXru5gSm",
    'color.background.accent.yellow.bolder.pressed': "_0KLXruTjon",
    'color.background.accent.green.subtlest': "_0KLXruV6wL",
    'color.background.accent.green.subtlest.hovered': "_0KLXruMqh8",
    'color.background.accent.green.subtlest.pressed': "_0KLXruUxn0",
    'color.background.accent.green.subtler': "_0KLXruNUep",
    'color.background.accent.green.subtler.hovered': "_0KLXruSZVv",
    'color.background.accent.green.subtler.pressed': "_0KLXruratX",
    'color.background.accent.green.subtle': "_0KLXru50ZN",
    'color.background.accent.green.subtle.hovered': "_0KLXru6mZS",
    'color.background.accent.green.subtle.pressed': "_0KLXruIBxe",
    'color.background.accent.green.bolder': "_0KLXrude1t",
    'color.background.accent.green.bolder.hovered': "_0KLXruB5SF",
    'color.background.accent.green.bolder.pressed': "_0KLXruLYGL",
    'color.background.accent.teal.subtlest': "_0KLXruuBpz",
    'color.background.accent.teal.subtlest.hovered': "_0KLXrugqYx",
    'color.background.accent.teal.subtlest.pressed': "_0KLXrufBlI",
    'color.background.accent.teal.subtler': "_0KLXrunfgW",
    'color.background.accent.teal.subtler.hovered': "_0KLXruA8mq",
    'color.background.accent.teal.subtler.pressed': "_0KLXrujHQE",
    'color.background.accent.teal.subtle': "_0KLXrufjGw",
    'color.background.accent.teal.subtle.hovered': "_0KLXrubjxt",
    'color.background.accent.teal.subtle.pressed': "_0KLXruUDSb",
    'color.background.accent.teal.bolder': "_0KLXruzHaB",
    'color.background.accent.teal.bolder.hovered': "_0KLXrunc80",
    'color.background.accent.teal.bolder.pressed': "_0KLXruu11s",
    'color.background.accent.blue.subtlest': "_0KLXruVva3",
    'color.background.accent.blue.subtlest.hovered': "_0KLXruotmK",
    'color.background.accent.blue.subtlest.pressed': "_0KLXruxyGe",
    'color.background.accent.blue.subtler': "_0KLXrup9dS",
    'color.background.accent.blue.subtler.hovered': "_0KLXruRRyT",
    'color.background.accent.blue.subtler.pressed': "_0KLXrueeqx",
    'color.background.accent.blue.subtle': "_0KLXru28sy",
    'color.background.accent.blue.subtle.hovered': "_0KLXruKSSk",
    'color.background.accent.blue.subtle.pressed': "_0KLXru40Rv",
    'color.background.accent.blue.bolder': "_0KLXrutfbE",
    'color.background.accent.blue.bolder.hovered': "_0KLXruupqB",
    'color.background.accent.blue.bolder.pressed': "_0KLXru36Hh",
    'color.background.accent.purple.subtlest': "_0KLXruB8KG",
    'color.background.accent.purple.subtlest.hovered': "_0KLXrueJK9",
    'color.background.accent.purple.subtlest.pressed': "_0KLXruhT4j",
    'color.background.accent.purple.subtler': "_0KLXruWOdT",
    'color.background.accent.purple.subtler.hovered': "_0KLXrujgGS",
    'color.background.accent.purple.subtler.pressed': "_0KLXruWgRz",
    'color.background.accent.purple.subtle': "_0KLXruf89Q",
    'color.background.accent.purple.subtle.hovered': "_0KLXru46BV",
    'color.background.accent.purple.subtle.pressed': "_0KLXruU9Hm",
    'color.background.accent.purple.bolder': "_0KLXruhdss",
    'color.background.accent.purple.bolder.hovered': "_0KLXruXxp4",
    'color.background.accent.purple.bolder.pressed': "_0KLXru1L16",
    'color.background.accent.magenta.subtlest': "_0KLXru8frT",
    'color.background.accent.magenta.subtlest.hovered': "_0KLXruWeuD",
    'color.background.accent.magenta.subtlest.pressed': "_0KLXruK9iC",
    'color.background.accent.magenta.subtler': "_0KLXruXM4x",
    'color.background.accent.magenta.subtler.hovered': "_0KLXrukPhQ",
    'color.background.accent.magenta.subtler.pressed': "_0KLXruGjVz",
    'color.background.accent.magenta.subtle': "_0KLXrupmfs",
    'color.background.accent.magenta.subtle.hovered': "_0KLXruexkg",
    'color.background.accent.magenta.subtle.pressed': "_0KLXruV3kb",
    'color.background.accent.magenta.bolder': "_0KLXruxE6Y",
    'color.background.accent.magenta.bolder.hovered': "_0KLXruPb8Y",
    'color.background.accent.magenta.bolder.pressed': "_0KLXruwQL0",
    'color.background.accent.gray.subtlest': "_0KLXrumhAQ",
    'color.background.accent.gray.subtlest.hovered': "_0KLXruBee8",
    'color.background.accent.gray.subtlest.pressed': "_0KLXruysrI",
    'color.background.accent.gray.subtler': "_0KLXruG6qS",
    'color.background.accent.gray.subtler.hovered': "_0KLXruXljP",
    'color.background.accent.gray.subtler.pressed': "_0KLXru6vdf",
    'color.background.accent.gray.subtle': "_0KLXrueZ10",
    'color.background.accent.gray.subtle.hovered': "_0KLXruY62e",
    'color.background.accent.gray.subtle.pressed': "_0KLXruvFnq",
    'color.background.accent.gray.bolder': "_0KLXrurxgm",
    'color.background.accent.gray.bolder.hovered': "_0KLXruW5tB",
    'color.background.accent.gray.bolder.pressed': "_0KLXrunA18",
    'color.background.disabled': "_0KLXruVrZW",
    'color.background.input': "_0KLXru7Cj1",
    'color.background.input.hovered': "_0KLXruqWX3",
    'color.background.input.pressed': "_0KLXruutHW",
    'color.background.inverse.subtle': "_0KLXruB4sa",
    'color.background.inverse.subtle.hovered': "_0KLXruVzWZ",
    'color.background.inverse.subtle.pressed': "_0KLXruTmu4",
    'color.background.neutral': "_0KLXruDMqu",
    'color.background.neutral.hovered': "_0KLXruKcZT",
    'color.background.neutral.pressed': "_0KLXrunpTK",
    'color.background.neutral.subtle': "_0KLXru66of",
    'color.background.neutral.subtle.hovered': "_0KLXruo126",
    'color.background.neutral.subtle.pressed': "_0KLXruN4oS",
    'color.background.neutral.bold': "_0KLXrugozt",
    'color.background.neutral.bold.hovered': "_0KLXrukTlo",
    'color.background.neutral.bold.pressed': "_0KLXruVbka",
    'color.background.selected': "_0KLXruY9q9",
    'color.background.selected.hovered': "_0KLXrusumd",
    'color.background.selected.pressed': "_0KLXruXsxn",
    'color.background.selected.bold': "_0KLXrukLmD",
    'color.background.selected.bold.hovered': "_0KLXruXLOx",
    'color.background.selected.bold.pressed': "_0KLXruPSfI",
    'color.background.brand.subtlest': "_0KLXrunl7T",
    'color.background.brand.subtlest.hovered': "_0KLXruNPoG",
    'color.background.brand.subtlest.pressed': "_0KLXruLKV0",
    'color.background.brand.bold': "_0KLXruDM2k",
    'color.background.brand.bold.hovered': "_0KLXruhmrj",
    'color.background.brand.bold.pressed': "_0KLXruczkD",
    'color.background.brand.boldest': "_0KLXru2o0p",
    'color.background.brand.boldest.hovered': "_0KLXruzGNP",
    'color.background.brand.boldest.pressed': "_0KLXru9Y3T",
    'color.background.danger': "_0KLXruhH7k",
    'color.background.danger.hovered': "_0KLXru1IMt",
    'color.background.danger.pressed': "_0KLXruig7D",
    'color.background.danger.bold': "_0KLXruqsXs",
    'color.background.danger.bold.hovered': "_0KLXruEISo",
    'color.background.danger.bold.pressed': "_0KLXruL5fL",
    'color.background.warning': "_0KLXruhxIM",
    'color.background.warning.hovered': "_0KLXrudEDW",
    'color.background.warning.pressed': "_0KLXruiJjO",
    'color.background.warning.bold': "_0KLXruKLKE",
    'color.background.warning.bold.hovered': "_0KLXruOCpk",
    'color.background.warning.bold.pressed': "_0KLXruSN2W",
    'color.background.success': "_0KLXruzaZe",
    'color.background.success.hovered': "_0KLXruYQVR",
    'color.background.success.pressed': "_0KLXruFj7I",
    'color.background.success.bold': "_0KLXruhbjP",
    'color.background.success.bold.hovered': "_0KLXru1YDn",
    'color.background.success.bold.pressed': "_0KLXrulx7w",
    'color.background.discovery': "_0KLXru94rk",
    'color.background.discovery.hovered': "_0KLXruaV2P",
    'color.background.discovery.pressed': "_0KLXruET5a",
    'color.background.discovery.bold': "_0KLXruqjHC",
    'color.background.discovery.bold.hovered': "_0KLXrunIkF",
    'color.background.discovery.bold.pressed': "_0KLXruSHT5",
    'color.background.information': "_0KLXrugNg3",
    'color.background.information.hovered': "_0KLXruwQql",
    'color.background.information.pressed': "_0KLXruB0Fx",
    'color.background.information.bold': "_0KLXruASYT",
    'color.background.information.bold.hovered': "_0KLXruGaQW",
    'color.background.information.bold.pressed': "_0KLXrujXMX",
    'color.blanket': "_0KLXruA5lS",
    'color.blanket.selected': "_0KLXrumA7q",
    'color.blanket.danger': "_0KLXrupOKR",
    'color.skeleton': "_0KLXruGsB2",
    'color.skeleton.subtle': "_0KLXruaVjy",
    'elevation.surface': "_0KLXrulfZc",
    'elevation.surface.hovered': "_0KLXrud1Zr",
    'elevation.surface.pressed': "_0KLXruJNoT",
    'elevation.surface.overlay': "_0KLXruoI2d",
    'elevation.surface.overlay.hovered': "_0KLXruhWTW",
    'elevation.surface.overlay.pressed': "_0KLXru0GoB",
    'elevation.surface.raised': "_0KLXruqi9L",
    'elevation.surface.raised.hovered': "_0KLXrubvxc",
    'elevation.surface.raised.pressed': "_0KLXruSEy3",
    'elevation.surface.sunken': "_0KLXrunmFW",
    'utility.elevation.surface.current': "_0KLXru4TrO"
};
const $4f4848e61f427859$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $4f4848e61f427859$var$setSurfaceTokenMap = {
    'elevation.surface': "_45TjwHlfZc",
    'elevation.surface.hovered': "_45TjwHd1Zr",
    'elevation.surface.pressed': "_45TjwHJNoT",
    'elevation.surface.overlay': "_45TjwHoI2d",
    'elevation.surface.overlay.hovered': "_45TjwHhWTW",
    'elevation.surface.overlay.pressed': "_45TjwH0GoB",
    'elevation.surface.raised': "_45TjwHqi9L",
    'elevation.surface.raised.hovered': "_45TjwHbvxc",
    'elevation.surface.raised.pressed': "_45TjwHSEy3",
    'elevation.surface.sunken': "_45TjwHnmFW"
};
const $4f4848e61f427859$var$paddingBlockStartMap = {
    'space.0': "_46hvQmPgdg",
    'space.025': "_46hvQmFQfX",
    'space.050': "_46hvQm1Y8M",
    'space.075': "_46hvQmgVvo",
    'space.100': "_46hvQm2ADO",
    'space.150': "_46hvQm8HPE",
    'space.200': "_46hvQm5zaO",
    'space.250': "_46hvQmkG2W",
    'space.300': "_46hvQmNHnM",
    'space.400': "_46hvQmVa5s",
    'space.500': "_46hvQmS40j",
    'space.600': "_46hvQmp0Oa",
    'space.800': "_46hvQmGXk2",
    'space.1000': "_46hvQmyFLW"
};
const $4f4848e61f427859$var$paddingBlockEndMap = {
    'space.0': "_0xmtkoPgdg",
    'space.025': "_0xmtkoFQfX",
    'space.050': "_0xmtko1Y8M",
    'space.075': "_0xmtkogVvo",
    'space.100': "_0xmtko2ADO",
    'space.150': "_0xmtko8HPE",
    'space.200': "_0xmtko5zaO",
    'space.250': "_0xmtkokG2W",
    'space.300': "_0xmtkoNHnM",
    'space.400': "_0xmtkoVa5s",
    'space.500': "_0xmtkoS40j",
    'space.600': "_0xmtkop0Oa",
    'space.800': "_0xmtkoGXk2",
    'space.1000': "_0xmtkoyFLW"
};
const $4f4848e61f427859$var$paddingInlineStartMap = {
    'space.0': "_0LQT5EPgdg",
    'space.025': "_0LQT5EFQfX",
    'space.050': "_0LQT5E1Y8M",
    'space.075': "_0LQT5EgVvo",
    'space.100': "_0LQT5E2ADO",
    'space.150': "_0LQT5E8HPE",
    'space.200': "_0LQT5E5zaO",
    'space.250': "_0LQT5EkG2W",
    'space.300': "_0LQT5ENHnM",
    'space.400': "_0LQT5EVa5s",
    'space.500': "_0LQT5ES40j",
    'space.600': "_0LQT5Ep0Oa",
    'space.800': "_0LQT5EGXk2",
    'space.1000': "_0LQT5EyFLW"
};
const $4f4848e61f427859$var$paddingInlineEndMap = {
    'space.0': "_03SyCPPgdg",
    'space.025': "_03SyCPFQfX",
    'space.050': "_03SyCP1Y8M",
    'space.075': "_03SyCPgVvo",
    'space.100': "_03SyCP2ADO",
    'space.150': "_03SyCP8HPE",
    'space.200': "_03SyCP5zaO",
    'space.250': "_03SyCPkG2W",
    'space.300': "_03SyCPNHnM",
    'space.400': "_03SyCPVa5s",
    'space.500': "_03SyCPS40j",
    'space.600': "_03SyCPp0Oa",
    'space.800': "_03SyCPGXk2",
    'space.1000': "_03SyCPyFLW"
}; /**
    * __Box__
    *
    * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
    * Renders a `div` by default.
    *
    * - [Examples](https://atlassian.design/components/primitives/box/examples)
    * - [Code](https://atlassian.design/components/primitives/box/code)
    * - [Usage](https://atlassian.design/components/primitives/box/usage)
    */ 
const $4f4848e61f427859$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $2hRE7.forwardRef)((0, $9a9850d6654223c3$export$4d143603f9782455)() ? (t0, ref)=>{
    const $ = (0, $ebfe460bd680287b$exports.c)(36);
    let backgroundColor;
    let children;
    let htmlAttributes;
    let padding;
    let style;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let testId;
    let xcss;
    if ($[0] !== t0) {
        ({ as: t1, children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: t2, paddingBlockStart: t3, paddingBlockEnd: t4, paddingInline: t5, paddingInlineStart: t6, paddingInlineEnd: t7, style: style, testId: testId, xcss: xcss, ...htmlAttributes } = t0);
        $[0] = t0;
        $[1] = backgroundColor;
        $[2] = children;
        $[3] = htmlAttributes;
        $[4] = padding;
        $[5] = style;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
        $[13] = testId;
        $[14] = xcss;
    } else {
        backgroundColor = $[1];
        children = $[2];
        htmlAttributes = $[3];
        padding = $[4];
        style = $[5];
        t1 = $[6];
        t2 = $[7];
        t3 = $[8];
        t4 = $[9];
        t5 = $[10];
        t6 = $[11];
        t7 = $[12];
        testId = $[13];
        xcss = $[14];
    }
    const Component = t1 === undefined ? "div" : t1;
    const paddingBlock = t2 === undefined ? padding : t2;
    const paddingBlockStart = t3 === undefined ? paddingBlock : t3;
    const paddingBlockEnd = t4 === undefined ? paddingBlock : t4;
    const paddingInline = t5 === undefined ? padding : t5;
    const paddingInlineStart = t6 === undefined ? paddingInline : t6;
    const paddingInlineEnd = t7 === undefined ? paddingInline : t7;
    let safeHtmlAttributes;
    if ($[15] !== htmlAttributes) {
        const { className: _spreadClass, ...t8 } = htmlAttributes;
        safeHtmlAttributes = t8;
        $[15] = htmlAttributes;
        $[16] = safeHtmlAttributes;
    } else safeHtmlAttributes = $[16];
    const t8 = backgroundColor && $4f4848e61f427859$var$backgroundColorMap[backgroundColor];
    let t9;
    if ($[17] !== backgroundColor || $[18] !== paddingBlockEnd || $[19] !== paddingBlockStart || $[20] !== paddingInlineEnd || $[21] !== paddingInlineStart || $[22] !== t8 || $[23] !== xcss) {
        t9 = (0, $4e5b3c21207d0e2b$export$2e2bcd8739ae039)([
            "_30huDKYbGa _24h04i2Njc _034jHtYbGa",
            t8,
            backgroundColor && $4f4848e61f427859$var$isSurfaceToken(backgroundColor) && $4f4848e61f427859$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $4f4848e61f427859$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $4f4848e61f427859$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $4f4848e61f427859$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $4f4848e61f427859$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]);
        $[17] = backgroundColor;
        $[18] = paddingBlockEnd;
        $[19] = paddingBlockStart;
        $[20] = paddingInlineEnd;
        $[21] = paddingInlineStart;
        $[22] = t8;
        $[23] = xcss;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== Component || $[26] !== children || $[27] !== ref || $[28] !== safeHtmlAttributes || $[29] !== style || $[30] !== t9 || $[31] !== testId) {
        t10 = /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsx)(Component, {
            style: style,
            ref: ref,
            className: t9,
            ...safeHtmlAttributes,
            "data-testid": testId,
            children: children
        });
        $[25] = Component;
        $[26] = children;
        $[27] = ref;
        $[28] = safeHtmlAttributes;
        $[29] = style;
        $[30] = t9;
        $[31] = testId;
        $[32] = t10;
    } else t10 = $[32];
    const node = t10;
    if (backgroundColor) {
        let t11;
        if ($[33] !== backgroundColor || $[34] !== node) {
            t11 = /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsx)((0, $fd01749441b28f7c$export$1ca2a26fecb070ae).Provider, {
                value: backgroundColor,
                children: node
            });
            $[33] = backgroundColor;
            $[34] = node;
            $[35] = t11;
        } else t11 = $[35];
        return t11;
    }
    return node;
} : ({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsx)(Component, {
        style: style,
        ref: ref,
        className: (0, $4e5b3c21207d0e2b$export$2e2bcd8739ae039)([
            "_30huDKYbGa _24h04i2Njc _034jHtYbGa",
            backgroundColor && $4f4848e61f427859$var$backgroundColorMap[backgroundColor],
            backgroundColor && $4f4848e61f427859$var$isSurfaceToken(backgroundColor) && $4f4848e61f427859$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $4f4848e61f427859$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $4f4848e61f427859$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $4f4848e61f427859$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $4f4848e61f427859$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsx)((0, $fd01749441b28f7c$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
} // The return type of `BoxComponent` does not match the return type of `forwardRef` in React 18
);
function $4f4848e61f427859$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $4f4848e61f427859$var$setSurfaceTokenMap;
}


const $3809dd3afe1b0fe4$var$styles = {
    base: "_0bjKvDcjp5 _0WKd3G4z3T",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMM7Tp _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbkAwSC",
    defaultAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
    subtleAppearance: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzZpcK _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _0CMRbky7kJ",
    subtleAppearanceMotion: "_00uqCYjOvk _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rkjOvk _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
    inverseAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMe5R3 _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbke5R3",
    inverseAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiQame _1mT5xdRAKS _2I62gzVQEB"
};
const $3809dd3afe1b0fe4$var$iconStyles = null;
const $3809dd3afe1b0fe4$var$LinkWithoutRef = (0, $9a9850d6654223c3$export$4d143603f9782455)() ? (t0, ref)=>{
    const $ = (0, $ebfe460bd680287b$exports.c)(30);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    let t2;
    if ($[7] !== appearance) {
        t2 = appearance === "default" && ((0, $6oQI4.fg)("platform-dst-motion-uplift-list-item") ? $3809dd3afe1b0fe4$var$styles.defaultAppearanceMotion : $3809dd3afe1b0fe4$var$styles.defaultAppearance);
        $[7] = appearance;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== appearance) {
        t3 = appearance === "subtle" && ((0, $6oQI4.fg)("platform-dst-motion-uplift-list-item") ? $3809dd3afe1b0fe4$var$styles.subtleAppearanceMotion : $3809dd3afe1b0fe4$var$styles.subtleAppearance);
        $[9] = appearance;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== appearance) {
        t4 = appearance === "inverse" && ((0, $6oQI4.fg)("platform-dst-motion-uplift-list-item") ? $3809dd3afe1b0fe4$var$styles.inverseAppearanceMotion : $3809dd3afe1b0fe4$var$styles.inverseAppearance);
        $[11] = appearance;
        $[12] = t4;
    } else t4 = $[12];
    const t5 = appearance !== "inverse" && $3809dd3afe1b0fe4$var$styles.visitedLink;
    let t6;
    if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
        t6 = (0, $d819974bb38192de$export$a274e22fb40f762e)($3809dd3afe1b0fe4$var$styles.base, t2, t3, t4, t5);
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== target || $[19] !== testId) {
        t7 = target === "_blank" && /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsxs)((0, $4f4848e61f427859$export$e71c4d32a2263218), {
            as: "span",
            xcss: $3809dd3afe1b0fe4$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`,
            children: [
                "\uFEFF",
                /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsx)("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    className: (0, $4e5b3c21207d0e2b$export$2e2bcd8739ae039)([
                        "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                    ]),
                    children: /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                        fill: "currentColor"
                    })
                })
            ]
        });
        $[18] = target;
        $[19] = testId;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== children || $[22] !== htmlAttributes || $[23] !== newWindowLabel || $[24] !== ref || $[25] !== t6 || $[26] !== t7 || $[27] !== target || $[28] !== testId) {
        t8 = /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsxs)((0, $fadbec09bc33f31a$export$b688253958b8dfe7), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t6,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel,
            children: [
                children,
                t7
            ]
        });
        $[21] = children;
        $[22] = htmlAttributes;
        $[23] = newWindowLabel;
        $[24] = ref;
        $[25] = t6;
        $[26] = t7;
        $[27] = target;
        $[28] = testId;
        $[29] = t8;
    } else t8 = $[29];
    return t8;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsxs)((0, $fadbec09bc33f31a$export$b688253958b8dfe7 // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $d819974bb38192de$export$a274e22fb40f762e)($3809dd3afe1b0fe4$var$styles.base, appearance === 'default' && ((0, $6oQI4.fg)('platform-dst-motion-uplift-list-item') ? $3809dd3afe1b0fe4$var$styles.defaultAppearanceMotion : $3809dd3afe1b0fe4$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $6oQI4.fg)('platform-dst-motion-uplift-list-item') ? $3809dd3afe1b0fe4$var$styles.subtleAppearanceMotion : $3809dd3afe1b0fe4$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $6oQI4.fg)('platform-dst-motion-uplift-list-item') ? $3809dd3afe1b0fe4$var$styles.inverseAppearanceMotion : $3809dd3afe1b0fe4$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $3809dd3afe1b0fe4$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsxs)((0, $4f4848e61f427859$export$e71c4d32a2263218), {
                as: "span",
                xcss: $3809dd3afe1b0fe4$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $4e5b3c21207d0e2b$export$2e2bcd8739ae039)([
                            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                        ]),
                        children: /*#__PURE__*/ (0, $b713eeff5e50d6df$exports.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    }); // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $3809dd3afe1b0fe4$var$Link = /*#__PURE__*/ (0, $2hRE7.forwardRef)($3809dd3afe1b0fe4$var$LinkWithoutRef);
var $3809dd3afe1b0fe4$export$2e2bcd8739ae039 = $3809dd3afe1b0fe4$var$Link;


var $bda1dd775425f725$exports = {};
$bda1dd775425f725$exports = JSON.parse("{}");



const $dedcfc2f6a9befa5$export$a7357cdd1f0b0168 = (0, $1ebaa880f6a9b11a$export$1adfeb024f5185b)({
    title: {
        id: "error-app.title",
        defaultMessage: "Something went wrong."
    },
    subTitle: {
        id: "error-app.sub-title",
        defaultMessage: "We\u2019re moving mountains to get it sorted."
    },
    detail: {
        id: "error-app.detail",
        defaultMessage: "View our {link} and subscribe for service updates."
    },
    linkName: {
        id: "error-app.link-name",
        defaultMessage: "status page"
    }
});


var $42c0a152ce038fb5$exports = {};
$42c0a152ce038fb5$exports = new URL("something-went-wrong.afc195d1.svg", import.meta.url).toString();


var $37650f2af76238a5$exports = {};
$37650f2af76238a5$exports = new URL("atlassianLogo.598181d7.svg", import.meta.url).toString();


const $e435e378975f2891$export$b5ed68f0a0a58a22 = ()=>{
    const DEFAULT_LOCALE = 'en-US';
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const locale = navigator.languages[0] || navigator.language || DEFAULT_LOCALE;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $42e4759825f879f5$export$2e2bcd8739ae039), {
        locale: locale,
        messages: (0, (/*@__PURE__*/$parcel$interopDefault($bda1dd775425f725$exports))),
        defaultLocale: "en-US"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement("div", {
        style: {
            padding: '19px',
            background: '#F4F5F7',
            margin: '0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $3809dd3afe1b0fe4$export$2e2bcd8739ae039), {
        href: "https://www.atlassian.com"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement("img", {
        alt: "Atlassian",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($37650f2af76238a5$exports))),
        style: {
            width: '145px',
            height: '18px'
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement("div", {
        style: {
            background: '#fff',
            padding: '60px 0',
            textAlign: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($42c0a152ce038fb5$exports))),
        alt: "",
        style: {
            marginLeft: -20,
            width: '380px',
            height: '246px'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement("h1", {
        style: {
            color: '#253858',
            font: 'bold 36px Helvetica, Arial',
            marginTop: '50px',
            marginBottom: '24px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $7ba7fe3ae6685fa1$export$2e2bcd8739ae039), (0, $dedcfc2f6a9befa5$export$a7357cdd1f0b0168).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement("h2", {
        style: {
            color: '#253858',
            font: 'bold 20px Helvetica, Arial',
            margin: '16px 0px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $7ba7fe3ae6685fa1$export$2e2bcd8739ae039), (0, $dedcfc2f6a9befa5$export$a7357cdd1f0b0168).subTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement("p", {
        style: {
            color: '#42526E',
            font: 'normal 20px/28px Helvetica, Arial',
            margin: '20px 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $7ba7fe3ae6685fa1$export$2e2bcd8739ae039), {
        ...(0, $dedcfc2f6a9befa5$export$a7357cdd1f0b0168).detail,
        values: {
            link: // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement("a", {
                target: "_blank",
                id: "statusPageHref",
                href: "https://status.atlassian.com",
                style: {
                    textDecoration: 'underline'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $7ba7fe3ae6685fa1$export$2e2bcd8739ae039), (0, $dedcfc2f6a9befa5$export$a7357cdd1f0b0168).linkName))
        }
    }))));
};



var $2hRE7 = parcelRequire("2hRE7");


var $9pfwj = parcelRequire("9pfwj");

var $2hRE7 = parcelRequire("2hRE7");
function $22b6c7f40b3a4b76$export$2e2bcd8739ae039(t, e) {
    return $22b6c7f40b3a4b76$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $22b6c7f40b3a4b76$export$2e2bcd8739ae039(t, e);
}


function $1abeca256c66a29a$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $22b6c7f40b3a4b76$export$2e2bcd8739ae039)(t, o);
}



var $2hRE7 = parcelRequire("2hRE7");
var $f82042903f236546$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f82042903f236546$var$ReactIs, $f82042903f236546$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$f82042903f236546$exports = (parcelRequire("h8zcq"))();


function $60101771424da660$export$2e2bcd8739ae039() {
    return $60101771424da660$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $60101771424da660$export$2e2bcd8739ae039.apply(null, arguments);
}


function $cb31f82ece06855d$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $cb31f82ece06855d$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $cb31f82ece06855d$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $cb31f82ece06855d$var$isAbsolute(to);
    var isFromAbs = from && $cb31f82ece06855d$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $cb31f82ece06855d$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $cb31f82ece06855d$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $cb31f82ece06855d$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $cb31f82ece06855d$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$cb31f82ece06855d$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $cb31f82ece06855d$export$2e2bcd8739ae039 = $cb31f82ece06855d$var$resolvePathname;


function $a1a8fd63690f8b1d$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $a1a8fd63690f8b1d$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $a1a8fd63690f8b1d$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $a1a8fd63690f8b1d$var$valueOf(a);
        var bValue = $a1a8fd63690f8b1d$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $a1a8fd63690f8b1d$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $a1a8fd63690f8b1d$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $a1a8fd63690f8b1d$export$2e2bcd8739ae039 = $a1a8fd63690f8b1d$var$valueEqual;




function $d5d8bbf86ffe4207$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $d5d8bbf86ffe4207$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $d5d8bbf86ffe4207$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $d5d8bbf86ffe4207$var$stripBasename(path, prefix) {
    return $d5d8bbf86ffe4207$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $d5d8bbf86ffe4207$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $d5d8bbf86ffe4207$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $d5d8bbf86ffe4207$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $d5d8bbf86ffe4207$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $d5d8bbf86ffe4207$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $60101771424da660$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $cb31f82ece06855d$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $d5d8bbf86ffe4207$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $a1a8fd63690f8b1d$export$2e2bcd8739ae039)(a.state, b.state);
}
function $d5d8bbf86ffe4207$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $d5d8bbf86ffe4207$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $d5d8bbf86ffe4207$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $d5d8bbf86ffe4207$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $d5d8bbf86ffe4207$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $d5d8bbf86ffe4207$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $d5d8bbf86ffe4207$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $d5d8bbf86ffe4207$var$PopStateEvent = 'popstate';
var $d5d8bbf86ffe4207$var$HashChangeEvent = 'hashchange';
function $d5d8bbf86ffe4207$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $d5d8bbf86ffe4207$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$d5d8bbf86ffe4207$var$canUseDOM && (0, $59309b200f83fd0a$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $d5d8bbf86ffe4207$var$supportsHistory();
    var needsHashChangeListener = !$d5d8bbf86ffe4207$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $d5d8bbf86ffe4207$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $d5d8bbf86ffe4207$var$stripTrailingSlash($d5d8bbf86ffe4207$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $d5d8bbf86ffe4207$var$stripBasename(path, basename);
        return $d5d8bbf86ffe4207$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $d5d8bbf86ffe4207$var$createTransitionManager();
    function setState(nextState) {
        (0, $60101771424da660$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($d5d8bbf86ffe4207$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($d5d8bbf86ffe4207$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($d5d8bbf86ffe4207$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $d5d8bbf86ffe4207$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $d5d8bbf86ffe4207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $d5d8bbf86ffe4207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($d5d8bbf86ffe4207$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($d5d8bbf86ffe4207$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($d5d8bbf86ffe4207$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($d5d8bbf86ffe4207$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $d5d8bbf86ffe4207$var$HashChangeEvent$1 = 'hashchange';
var $d5d8bbf86ffe4207$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $d5d8bbf86ffe4207$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $d5d8bbf86ffe4207$var$stripLeadingSlash,
        decodePath: $d5d8bbf86ffe4207$var$addLeadingSlash
    },
    slash: {
        encodePath: $d5d8bbf86ffe4207$var$addLeadingSlash,
        decodePath: $d5d8bbf86ffe4207$var$addLeadingSlash
    }
};
function $d5d8bbf86ffe4207$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $d5d8bbf86ffe4207$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $d5d8bbf86ffe4207$var$pushHashPath(path) {
    window.location.hash = path;
}
function $d5d8bbf86ffe4207$var$replaceHashPath(path) {
    window.location.replace($d5d8bbf86ffe4207$var$stripHash(window.location.href) + '#' + path);
}
function $d5d8bbf86ffe4207$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$d5d8bbf86ffe4207$var$canUseDOM && (0, $59309b200f83fd0a$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $d5d8bbf86ffe4207$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $d5d8bbf86ffe4207$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $d5d8bbf86ffe4207$var$stripTrailingSlash($d5d8bbf86ffe4207$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $d5d8bbf86ffe4207$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($d5d8bbf86ffe4207$var$getHashPath());
        if (basename) path = $d5d8bbf86ffe4207$var$stripBasename(path, basename);
        return $d5d8bbf86ffe4207$export$90c043f1c57770b8(path);
    }
    var transitionManager = $d5d8bbf86ffe4207$var$createTransitionManager();
    function setState(nextState) {
        (0, $60101771424da660$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $d5d8bbf86ffe4207$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $d5d8bbf86ffe4207$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $d5d8bbf86ffe4207$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($d5d8bbf86ffe4207$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($d5d8bbf86ffe4207$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $d5d8bbf86ffe4207$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $d5d8bbf86ffe4207$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $d5d8bbf86ffe4207$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $d5d8bbf86ffe4207$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $d5d8bbf86ffe4207$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $d5d8bbf86ffe4207$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $d5d8bbf86ffe4207$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $d5d8bbf86ffe4207$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $d5d8bbf86ffe4207$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($d5d8bbf86ffe4207$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $d5d8bbf86ffe4207$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $d5d8bbf86ffe4207$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $d5d8bbf86ffe4207$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $d5d8bbf86ffe4207$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($d5d8bbf86ffe4207$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($d5d8bbf86ffe4207$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($d5d8bbf86ffe4207$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $d5d8bbf86ffe4207$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $d5d8bbf86ffe4207$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $d5d8bbf86ffe4207$var$createTransitionManager();
    function setState(nextState) {
        (0, $60101771424da660$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $d5d8bbf86ffe4207$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $d5d8bbf86ffe4207$export$90c043f1c57770b8(entry, undefined, createKey()) : $d5d8bbf86ffe4207$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $d5d8bbf86ffe4207$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $d5d8bbf86ffe4207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $d5d8bbf86ffe4207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $d5d8bbf86ffe4207$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $5e100ad294dc3bee$exports = {};
var $5c0e26595d9de4b8$exports = {};
$5c0e26595d9de4b8$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $5e100ad294dc3bee$exports = $5e100ad294dc3bee$var$pathToRegexp;
$5e100ad294dc3bee$exports.parse = $5e100ad294dc3bee$var$parse;
$5e100ad294dc3bee$exports.compile = $5e100ad294dc3bee$var$compile;
$5e100ad294dc3bee$exports.tokensToFunction = $5e100ad294dc3bee$var$tokensToFunction;
$5e100ad294dc3bee$exports.tokensToRegExp = $5e100ad294dc3bee$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $5e100ad294dc3bee$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $5e100ad294dc3bee$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $5e100ad294dc3bee$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $5e100ad294dc3bee$var$escapeGroup(pattern) : asterisk ? '.*' : $5e100ad294dc3bee$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $5e100ad294dc3bee$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $5e100ad294dc3bee$var$escapeString(delimiter) + ']+?';
    return $5e100ad294dc3bee$var$escapeString(prevText) + '|(?:(?!' + $5e100ad294dc3bee$var$escapeString(prevText) + ')[^' + $5e100ad294dc3bee$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $5e100ad294dc3bee$var$compile(str, options) {
    return $5e100ad294dc3bee$var$tokensToFunction($5e100ad294dc3bee$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $5e100ad294dc3bee$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $5e100ad294dc3bee$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $5e100ad294dc3bee$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $5e100ad294dc3bee$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $5e100ad294dc3bee$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($5c0e26595d9de4b8$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $5e100ad294dc3bee$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $5e100ad294dc3bee$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $5e100ad294dc3bee$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $5e100ad294dc3bee$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $5e100ad294dc3bee$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $5e100ad294dc3bee$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $5e100ad294dc3bee$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $5e100ad294dc3bee$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($5e100ad294dc3bee$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $5e100ad294dc3bee$var$flags(options));
    return $5e100ad294dc3bee$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $5e100ad294dc3bee$var$stringToRegexp(path, keys, options) {
    return $5e100ad294dc3bee$var$tokensToRegExp($5e100ad294dc3bee$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $5e100ad294dc3bee$var$tokensToRegExp(tokens, keys, options) {
    if (!$5c0e26595d9de4b8$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $5e100ad294dc3bee$var$escapeString(token);
        else {
            var prefix = $5e100ad294dc3bee$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $5e100ad294dc3bee$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $5e100ad294dc3bee$var$attachKeys(new RegExp('^' + route, $5e100ad294dc3bee$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $5e100ad294dc3bee$var$pathToRegexp(path, keys, options) {
    if (!$5c0e26595d9de4b8$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $5e100ad294dc3bee$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($5c0e26595d9de4b8$exports(path)) return $5e100ad294dc3bee$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $5e100ad294dc3bee$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $7ae01518946c445b$exports = {};
'use strict';

$7ae01518946c445b$exports = (parcelRequire("1TaDb"));


function $ffe2f30d8a7857e1$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $0b5545bc430d2e46$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $0b5545bc430d2e46$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $0b5545bc430d2e46$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $0b5545bc430d2e46$var$commonjsGlobal[key] = ($0b5545bc430d2e46$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $0b5545bc430d2e46$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $0b5545bc430d2e46$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $0b5545bc430d2e46$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $0b5545bc430d2e46$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $0b5545bc430d2e46$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $1abeca256c66a29a$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $0b5545bc430d2e46$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($0b5545bc430d2e46$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $0b5545bc430d2e46$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($f82042903f236546$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $1abeca256c66a29a$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $0b5545bc430d2e46$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $0b5545bc430d2e46$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $0b5545bc430d2e46$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($f82042903f236546$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $0b5545bc430d2e46$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createContext || $0b5545bc430d2e46$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $0b5545bc430d2e46$var$createNamedContext = function createNamedContext(name) {
    var context = $0b5545bc430d2e46$var$createContext();
    context.displayName = name;
    return context;
};
var $0b5545bc430d2e46$export$c213558b66925821 = /*#__PURE__*/ $0b5545bc430d2e46$var$createNamedContext("Router-History");
var $0b5545bc430d2e46$export$63baa8ccbe60bb07 = /*#__PURE__*/ $0b5545bc430d2e46$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $0b5545bc430d2e46$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $1abeca256c66a29a$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($0b5545bc430d2e46$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($0b5545bc430d2e46$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $0b5545bc430d2e46$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $1abeca256c66a29a$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $d5d8bbf86ffe4207$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($0b5545bc430d2e46$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).Component);
var $0b5545bc430d2e46$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $1abeca256c66a29a$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $0b5545bc430d2e46$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($0b5545bc430d2e46$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $59309b200f83fd0a$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($0b5545bc430d2e46$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $0b5545bc430d2e46$var$messageType;
var $0b5545bc430d2e46$var$cache = {};
var $0b5545bc430d2e46$var$cacheLimit = 10000;
var $0b5545bc430d2e46$var$cacheCount = 0;
function $0b5545bc430d2e46$var$compilePath(path) {
    if ($0b5545bc430d2e46$var$cache[path]) return $0b5545bc430d2e46$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($5e100ad294dc3bee$exports))).compile(path);
    if ($0b5545bc430d2e46$var$cacheCount < $0b5545bc430d2e46$var$cacheLimit) {
        $0b5545bc430d2e46$var$cache[path] = generator;
        $0b5545bc430d2e46$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $0b5545bc430d2e46$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $0b5545bc430d2e46$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $0b5545bc430d2e46$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($0b5545bc430d2e46$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $59309b200f83fd0a$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $d5d8bbf86ffe4207$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $0b5545bc430d2e46$export$82476f982757e71e(to, computedMatch.params) : (0, $60101771424da660$export$2e2bcd8739ae039)({}, to, {
            pathname: $0b5545bc430d2e46$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($0b5545bc430d2e46$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $d5d8bbf86ffe4207$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $d5d8bbf86ffe4207$export$c3e8bb440bd55b18)(prevLocation, (0, $60101771424da660$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $0b5545bc430d2e46$var$cache$1 = {};
var $0b5545bc430d2e46$var$cacheLimit$1 = 10000;
var $0b5545bc430d2e46$var$cacheCount$1 = 0;
function $0b5545bc430d2e46$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $0b5545bc430d2e46$var$cache$1[cacheKey] || ($0b5545bc430d2e46$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($5e100ad294dc3bee$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($0b5545bc430d2e46$var$cacheCount$1 < $0b5545bc430d2e46$var$cacheLimit$1) {
        pathCache[path] = result;
        $0b5545bc430d2e46$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $0b5545bc430d2e46$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $0b5545bc430d2e46$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $0b5545bc430d2e46$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).Children.count(children) === 0;
}
function $0b5545bc430d2e46$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $0b5545bc430d2e46$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $1abeca256c66a29a$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($0b5545bc430d2e46$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $59309b200f83fd0a$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $0b5545bc430d2e46$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $60101771424da660$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $0b5545bc430d2e46$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($0b5545bc430d2e46$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).Component);
function $0b5545bc430d2e46$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $0b5545bc430d2e46$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $60101771424da660$export$2e2bcd8739ae039)({}, location, {
        pathname: $0b5545bc430d2e46$var$addLeadingSlash(basename) + location.pathname
    });
}
function $0b5545bc430d2e46$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $0b5545bc430d2e46$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $60101771424da660$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $0b5545bc430d2e46$var$createURL(location) {
    return typeof location === "string" ? location : (0, $d5d8bbf86ffe4207$export$fe53371bee54353d)(location);
}
function $0b5545bc430d2e46$var$staticHandler(methodName) {
    return function() {
        (0, $59309b200f83fd0a$export$2e2bcd8739ae039)(false);
    };
}
function $0b5545bc430d2e46$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $0b5545bc430d2e46$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $1abeca256c66a29a$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $0b5545bc430d2e46$var$noop;
        };
        _this.handleBlock = function() {
            return $0b5545bc430d2e46$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $0b5545bc430d2e46$var$addBasename(basename, (0, $d5d8bbf86ffe4207$export$90c043f1c57770b8)(location));
        context.url = $0b5545bc430d2e46$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $ffe2f30d8a7857e1$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $0b5545bc430d2e46$var$addLeadingSlash(basename + $0b5545bc430d2e46$var$createURL(path));
            },
            action: "POP",
            location: $0b5545bc430d2e46$var$stripBasename(basename, (0, $d5d8bbf86ffe4207$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $0b5545bc430d2e46$var$staticHandler("go"),
            goBack: $0b5545bc430d2e46$var$staticHandler("goBack"),
            goForward: $0b5545bc430d2e46$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($0b5545bc430d2e46$export$55185c17a0fcbe46, (0, $60101771424da660$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $0b5545bc430d2e46$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $1abeca256c66a29a$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($0b5545bc430d2e46$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $59309b200f83fd0a$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $0b5545bc430d2e46$export$81336c211d5ff295(location.pathname, (0, $60101771424da660$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $0b5545bc430d2e46$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $ffe2f30d8a7857e1$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($0b5545bc430d2e46$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $59309b200f83fd0a$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement(Component, (0, $60101771424da660$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($d8320d03eab1f849$exports)))(C, Component);
}
var $0b5545bc430d2e46$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).useContext;
function $0b5545bc430d2e46$export$3420e1dc2c4a518c() {
    return $0b5545bc430d2e46$var$useContext($0b5545bc430d2e46$export$c213558b66925821);
}
function $0b5545bc430d2e46$export$45d76561a5302f2b() {
    return $0b5545bc430d2e46$var$useContext($0b5545bc430d2e46$export$63baa8ccbe60bb07).location;
}
function $0b5545bc430d2e46$export$99eaa27ddbbb95ef() {
    var match = $0b5545bc430d2e46$var$useContext($0b5545bc430d2e46$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $0b5545bc430d2e46$export$632be4bb944c1bc7(path) {
    var location = $0b5545bc430d2e46$export$45d76561a5302f2b();
    var match = $0b5545bc430d2e46$var$useContext($0b5545bc430d2e46$export$63baa8ccbe60bb07).match;
    return path ? $0b5545bc430d2e46$export$81336c211d5ff295(location.pathname, path) : match;
}
var $0b5545bc430d2e46$var$global$1, $0b5545bc430d2e46$var$key, $0b5545bc430d2e46$var$buildNames, $0b5545bc430d2e46$var$initialBuildName, $0b5545bc430d2e46$var$secondaryBuildName;


var $55883d9587c6b43d$exports = {};

var $3LMLt = parcelRequire("3LMLt");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $55883d9587c6b43d$var$isEqual(value, other) {
    return $3LMLt(value, other);
}
$55883d9587c6b43d$exports = $55883d9587c6b43d$var$isEqual;


/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 

var $d005de9f36e826c3$export$2e2bcd8739ae039 = (0, $8fa1151464f0741f$export$2e2bcd8739ae039);




var $9pfwj = parcelRequire("9pfwj");
var $8acf5263417b1078$exports = {};
var $f87290ddf38449de$exports = {};
var $ac9968b126d0ffae$exports = {};

var $7fWyJ = parcelRequire("7fWyJ");

var $eQCTh = parcelRequire("eQCTh");
var $1e83bef4f2ee19c3$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1e83bef4f2ee19c3$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$1e83bef4f2ee19c3$exports = $1e83bef4f2ee19c3$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $ac9968b126d0ffae$var$baseMatches(source) {
    var matchData = $eQCTh(source);
    if (matchData.length == 1 && matchData[0][2]) return $1e83bef4f2ee19c3$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $7fWyJ(object, source, matchData);
    };
}
$ac9968b126d0ffae$exports = $ac9968b126d0ffae$var$baseMatches;


var $36045243b4c271f6$exports = {};

var $3LMLt = parcelRequire("3LMLt");
var $fc174455b0f66714$exports = {};
var $e105a9e5dc8b57e7$exports = {};
var $668122a3669e25fc$exports = {};

var $1Hc0l = parcelRequire("1Hc0l");
var $1e5c39947c40a229$exports = {};

var $1Hc0l = parcelRequire("1Hc0l");
var $0ca2a95a21997e12$exports = {};

var $fwZuK = parcelRequire("fwZuK");

var $1OvKS = parcelRequire("1OvKS");
/** `Object#toString` result references. */ var $0ca2a95a21997e12$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $0ca2a95a21997e12$var$isSymbol(value) {
    return typeof value == 'symbol' || $1OvKS(value) && $fwZuK(value) == $0ca2a95a21997e12$var$symbolTag;
}
$0ca2a95a21997e12$exports = $0ca2a95a21997e12$var$isSymbol;


/** Used to match property names within property paths. */ var $1e5c39947c40a229$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $1e5c39947c40a229$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $1e5c39947c40a229$var$isKey(value, object) {
    if ($1Hc0l(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $0ca2a95a21997e12$exports(value)) return true;
    return $1e5c39947c40a229$var$reIsPlainProp.test(value) || !$1e5c39947c40a229$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$1e5c39947c40a229$exports = $1e5c39947c40a229$var$isKey;


var $78187ef49c611f10$exports = {};
var $4f91309aed7e630a$exports = {};
var $fe84bec8f46a3e76$exports = {};

var $kSJ9Q = parcelRequire("kSJ9Q");
/** Error message constants. */ var $fe84bec8f46a3e76$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $fe84bec8f46a3e76$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($fe84bec8f46a3e76$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($fe84bec8f46a3e76$var$memoize.Cache || $kSJ9Q);
    return memoized;
}
// Expose `MapCache`.
$fe84bec8f46a3e76$var$memoize.Cache = $kSJ9Q;
$fe84bec8f46a3e76$exports = $fe84bec8f46a3e76$var$memoize;


/** Used as the maximum memoize cache size. */ var $4f91309aed7e630a$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $4f91309aed7e630a$var$memoizeCapped(func) {
    var result = $fe84bec8f46a3e76$exports(func, function(key) {
        if (cache.size === $4f91309aed7e630a$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$4f91309aed7e630a$exports = $4f91309aed7e630a$var$memoizeCapped;


/** Used to match property names within property paths. */ var $78187ef49c611f10$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $78187ef49c611f10$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $78187ef49c611f10$var$stringToPath = $4f91309aed7e630a$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($78187ef49c611f10$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($78187ef49c611f10$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$78187ef49c611f10$exports = $78187ef49c611f10$var$stringToPath;


var $2fab5c248a42147c$exports = {};
var $0492d612488d1ce8$exports = {};

var $5HSZ3 = parcelRequire("5HSZ3");
var $eefea53168a86e8c$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $eefea53168a86e8c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$eefea53168a86e8c$exports = $eefea53168a86e8c$var$arrayMap;



var $1Hc0l = parcelRequire("1Hc0l");

/** Used as references for various `Number` constants. */ var $0492d612488d1ce8$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $0492d612488d1ce8$var$symbolProto = $5HSZ3 ? $5HSZ3.prototype : undefined, $0492d612488d1ce8$var$symbolToString = $0492d612488d1ce8$var$symbolProto ? $0492d612488d1ce8$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $0492d612488d1ce8$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($1Hc0l(value)) // Recursively convert values (susceptible to call stack limits).
    return $eefea53168a86e8c$exports(value, $0492d612488d1ce8$var$baseToString) + '';
    if ($0ca2a95a21997e12$exports(value)) return $0492d612488d1ce8$var$symbolToString ? $0492d612488d1ce8$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$0492d612488d1ce8$var$INFINITY ? '-0' : result;
}
$0492d612488d1ce8$exports = $0492d612488d1ce8$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $2fab5c248a42147c$var$toString(value) {
    return value == null ? '' : $0492d612488d1ce8$exports(value);
}
$2fab5c248a42147c$exports = $2fab5c248a42147c$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $668122a3669e25fc$var$castPath(value, object) {
    if ($1Hc0l(value)) return value;
    return $1e5c39947c40a229$exports(value, object) ? [
        value
    ] : $78187ef49c611f10$exports($2fab5c248a42147c$exports(value));
}
$668122a3669e25fc$exports = $668122a3669e25fc$var$castPath;


var $b8334e9b1267c001$exports = {};

/** Used as references for various `Number` constants. */ var $b8334e9b1267c001$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $b8334e9b1267c001$var$toKey(value) {
    if (typeof value == 'string' || $0ca2a95a21997e12$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$b8334e9b1267c001$var$INFINITY ? '-0' : result;
}
$b8334e9b1267c001$exports = $b8334e9b1267c001$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $e105a9e5dc8b57e7$var$baseGet(object, path) {
    path = $668122a3669e25fc$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$b8334e9b1267c001$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$e105a9e5dc8b57e7$exports = $e105a9e5dc8b57e7$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $fc174455b0f66714$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $e105a9e5dc8b57e7$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$fc174455b0f66714$exports = $fc174455b0f66714$var$get;


var $20e2f323df92bfc6$exports = {};
var $f76109b544e450ee$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $f76109b544e450ee$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$f76109b544e450ee$exports = $f76109b544e450ee$var$baseHasIn;


var $ca0b2d62c4e9b959$exports = {};


var $bI9Dv = parcelRequire("bI9Dv");

var $1Hc0l = parcelRequire("1Hc0l");

var $jBrG4 = parcelRequire("jBrG4");

var $ji1xl = parcelRequire("ji1xl");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $ca0b2d62c4e9b959$var$hasPath(object, path, hasFunc) {
    path = $668122a3669e25fc$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $b8334e9b1267c001$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $ji1xl(length) && $jBrG4(key, length) && ($1Hc0l(object) || $bI9Dv(object));
}
$ca0b2d62c4e9b959$exports = $ca0b2d62c4e9b959$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $20e2f323df92bfc6$var$hasIn(object, path) {
    return object != null && $ca0b2d62c4e9b959$exports(object, path, $f76109b544e450ee$exports);
}
$20e2f323df92bfc6$exports = $20e2f323df92bfc6$var$hasIn;




var $hPdF0 = parcelRequire("hPdF0");


/** Used to compose bitmasks for value comparisons. */ var $36045243b4c271f6$var$COMPARE_PARTIAL_FLAG = 1, $36045243b4c271f6$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $36045243b4c271f6$var$baseMatchesProperty(path, srcValue) {
    if ($1e5c39947c40a229$exports(path) && $hPdF0(srcValue)) return $1e83bef4f2ee19c3$exports($b8334e9b1267c001$exports(path), srcValue);
    return function(object) {
        var objValue = $fc174455b0f66714$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $20e2f323df92bfc6$exports(object, path) : $3LMLt(srcValue, objValue, $36045243b4c271f6$var$COMPARE_PARTIAL_FLAG | $36045243b4c271f6$var$COMPARE_UNORDERED_FLAG);
    };
}
$36045243b4c271f6$exports = $36045243b4c271f6$var$baseMatchesProperty;


var $50a9ffac931bdb31$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $50a9ffac931bdb31$var$identity(value) {
    return value;
}
$50a9ffac931bdb31$exports = $50a9ffac931bdb31$var$identity;



var $1Hc0l = parcelRequire("1Hc0l");
var $ea63135b4894a579$exports = {};
var $053531d971d05eab$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $053531d971d05eab$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$053531d971d05eab$exports = $053531d971d05eab$var$baseProperty;


var $154a345214797286$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $154a345214797286$var$basePropertyDeep(path) {
    return function(object) {
        return $e105a9e5dc8b57e7$exports(object, path);
    };
}
$154a345214797286$exports = $154a345214797286$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $ea63135b4894a579$var$property(path) {
    return $1e5c39947c40a229$exports(path) ? $053531d971d05eab$exports($b8334e9b1267c001$exports(path)) : $154a345214797286$exports(path);
}
$ea63135b4894a579$exports = $ea63135b4894a579$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $f87290ddf38449de$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $50a9ffac931bdb31$exports;
    if (typeof value == 'object') return $1Hc0l(value) ? $36045243b4c271f6$exports(value[0], value[1]) : $ac9968b126d0ffae$exports(value);
    return $ea63135b4894a579$exports(value);
}
$f87290ddf38449de$exports = $f87290ddf38449de$var$baseIteratee;


var $397e2af96dab29b8$exports = {};
/** Error message constants. */ var $397e2af96dab29b8$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function $397e2af96dab29b8$var$negate(predicate) {
    if (typeof predicate != 'function') throw new TypeError($397e2af96dab29b8$var$FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
$397e2af96dab29b8$exports = $397e2af96dab29b8$var$negate;


var $21b03ed7cd03c308$exports = {};


var $a6ad45ef3e3a1300$exports = {};

var $2ee76352f71ef9d1$exports = {};
var $5f2578f2d184537b$exports = {};
var $e999ef5430fc710b$exports = {};
var $8a6543ff00a5e2ad$exports = {};

var $iyW5S = parcelRequire("iyW5S");
var $8a6543ff00a5e2ad$var$defineProperty = function() {
    try {
        var func = $iyW5S(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$8a6543ff00a5e2ad$exports = $8a6543ff00a5e2ad$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $e999ef5430fc710b$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $8a6543ff00a5e2ad$exports) $8a6543ff00a5e2ad$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$e999ef5430fc710b$exports = $e999ef5430fc710b$var$baseAssignValue;



var $3qKMr = parcelRequire("3qKMr");
/** Used for built-in method references. */ var $5f2578f2d184537b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5f2578f2d184537b$var$hasOwnProperty = $5f2578f2d184537b$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $5f2578f2d184537b$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($5f2578f2d184537b$var$hasOwnProperty.call(object, key) && $3qKMr(objValue, value)) || value === undefined && !(key in object)) $e999ef5430fc710b$exports(object, key, value);
}
$5f2578f2d184537b$exports = $5f2578f2d184537b$var$assignValue;




var $jBrG4 = parcelRequire("jBrG4");

var $7M8w7 = parcelRequire("7M8w7");

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $2ee76352f71ef9d1$var$baseSet(object, path, value, customizer) {
    if (!$7M8w7(object)) return object;
    path = $668122a3669e25fc$exports(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $b8334e9b1267c001$exports(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $7M8w7(objValue) ? objValue : $jBrG4(path[index + 1]) ? [] : {};
        }
        $5f2578f2d184537b$exports(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
$2ee76352f71ef9d1$exports = $2ee76352f71ef9d1$var$baseSet;



/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $a6ad45ef3e3a1300$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $e105a9e5dc8b57e7$exports(object, path);
        if (predicate(value, path)) $2ee76352f71ef9d1$exports(result, $668122a3669e25fc$exports(path, object), value);
    }
    return result;
}
$a6ad45ef3e3a1300$exports = $a6ad45ef3e3a1300$var$basePickBy;


var $c05b264fcf55de58$exports = {};

var $cyAjh = parcelRequire("cyAjh");
var $97b1d32ff7400656$exports = {};

var $hsFEc = parcelRequire("hsFEc");
var $69c53637b0cac2f9$exports = {};

var $d5o8J = parcelRequire("d5o8J");
/** Built-in value references. */ var $69c53637b0cac2f9$var$getPrototype = $d5o8J(Object.getPrototypeOf, Object);
$69c53637b0cac2f9$exports = $69c53637b0cac2f9$var$getPrototype;



var $2AXfG = parcelRequire("2AXfG");

var $6PME4 = parcelRequire("6PME4");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $97b1d32ff7400656$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $97b1d32ff7400656$var$getSymbolsIn = !$97b1d32ff7400656$var$nativeGetSymbols ? $6PME4 : function(object) {
    var result = [];
    while(object){
        $hsFEc(result, $2AXfG(object));
        object = $69c53637b0cac2f9$exports(object);
    }
    return result;
};
$97b1d32ff7400656$exports = $97b1d32ff7400656$var$getSymbolsIn;


var $7a6e7e090a46d98d$exports = {};

var $4D8pR = parcelRequire("4D8pR");
var $004c33a0ec46ca82$exports = {};

var $7M8w7 = parcelRequire("7M8w7");

var $lxWr3 = parcelRequire("lxWr3");
var $339c245d306c27ef$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $339c245d306c27ef$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$339c245d306c27ef$exports = $339c245d306c27ef$var$nativeKeysIn;


/** Used for built-in method references. */ var $004c33a0ec46ca82$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $004c33a0ec46ca82$var$hasOwnProperty = $004c33a0ec46ca82$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $004c33a0ec46ca82$var$baseKeysIn(object) {
    if (!$7M8w7(object)) return $339c245d306c27ef$exports(object);
    var isProto = $lxWr3(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$004c33a0ec46ca82$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$004c33a0ec46ca82$exports = $004c33a0ec46ca82$var$baseKeysIn;



var $hnmud = parcelRequire("hnmud");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $7a6e7e090a46d98d$var$keysIn(object) {
    return $hnmud(object) ? $4D8pR(object, true) : $004c33a0ec46ca82$exports(object);
}
$7a6e7e090a46d98d$exports = $7a6e7e090a46d98d$var$keysIn;


/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c05b264fcf55de58$var$getAllKeysIn(object) {
    return $cyAjh(object, $7a6e7e090a46d98d$exports, $97b1d32ff7400656$exports);
}
$c05b264fcf55de58$exports = $c05b264fcf55de58$var$getAllKeysIn;


/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $21b03ed7cd03c308$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $eefea53168a86e8c$exports($c05b264fcf55de58$exports(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $f87290ddf38449de$exports(predicate);
    return $a6ad45ef3e3a1300$exports(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
$21b03ed7cd03c308$exports = $21b03ed7cd03c308$var$pickBy;


/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */ function $8acf5263417b1078$var$omitBy(object, predicate) {
    return $21b03ed7cd03c308$exports(object, $397e2af96dab29b8$exports($f87290ddf38449de$exports(predicate)));
}
$8acf5263417b1078$exports = $8acf5263417b1078$var$omitBy;


var $1b8f46328037ed53$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $1b8f46328037ed53$var$isNil(value) {
    return value == null;
}
$1b8f46328037ed53$exports = $1b8f46328037ed53$var$isNil;


const $a1f0c4d0ab868c5f$export$8c6bf2df244e6a99 = '/wiki';
const $a1f0c4d0ab868c5f$var$SPACE_ROOT = 'spaces';
const $a1f0c4d0ab868c5f$export$ad28e141050c1e34 = (title)=>{
    if (!title) return;
    const slug = title// replace groups of reservered chars with a space
    // From https://www.ietf.org/rfc/rfc3986.txt
    // unreserved  = ALPHA / DIGIT / "-" / "." / "_" / "~"
    .replaceAll(/[^A-Za-z0-9\-._~]+/g, ' ')// trim the edges
    .trim()// replace spaces with '+'
    .replaceAll(' ', '+');
    // guard against relative url attacks
    if (slug === '.' || slug === '..') return undefined;
    return slug || undefined;
};
const $a1f0c4d0ab868c5f$export$cbc5b385481fb319 = (href, query)=>{
    const parsedUrl = {
        ...(0, $9pfwj.parse)(href, true),
        search: undefined
    };
    parsedUrl.query = {
        ...parsedUrl.query,
        ...query
    };
    parsedUrl.query = (0, (/*@__PURE__*/$parcel$interopDefault($8acf5263417b1078$exports)))(parsedUrl.query, (0, (/*@__PURE__*/$parcel$interopDefault($1b8f46328037ed53$exports))));
    return (0, $9pfwj.format)(parsedUrl);
};
const $a1f0c4d0ab868c5f$export$8189558ac52562eb = (params, href)=>{
    const parsedUrl = {
        ...(0, $9pfwj.parse)(href, true),
        search: undefined
    };
    params.forEach((paramName)=>delete parsedUrl.query[paramName]);
    return (0, $9pfwj.format)(parsedUrl);
};
const $a1f0c4d0ab868c5f$var$removeAllAnchorsFromUrl = (href)=>{
    return href.split('#')[0];
};
const $a1f0c4d0ab868c5f$var$removeAllQueryParamsFromUrl = (href)=>{
    return href.split('?')[0];
};
const $a1f0c4d0ab868c5f$export$64f436133a65fc62 = (href)=>{
    return $a1f0c4d0ab868c5f$var$removeAllAnchorsFromUrl($a1f0c4d0ab868c5f$var$removeAllQueryParamsFromUrl(href));
};
const $a1f0c4d0ab868c5f$export$cefcfecf0835bcd9 = (spaceKey, path = '')=>{
    spaceKey = encodeURIComponent(spaceKey);
    let spacePath = (typeof path === 'string' ? path : path.pathname) || '';
    if (spacePath.startsWith($a1f0c4d0ab868c5f$export$8c6bf2df244e6a99)) spacePath = spacePath.substring($a1f0c4d0ab868c5f$export$8c6bf2df244e6a99.length);
    if (spacePath.startsWith('/')) spacePath = spacePath.substring(1);
    const link = `${$a1f0c4d0ab868c5f$export$8c6bf2df244e6a99}/${$a1f0c4d0ab868c5f$var$SPACE_ROOT}/${spaceKey}${spacePath ? `/${spacePath}` : ''}`;
    if (typeof path === 'string') return link;
    return {
        ...path,
        pathname: link
    };
};
const $a1f0c4d0ab868c5f$var$getBlogRoute = (spaceKey)=>$a1f0c4d0ab868c5f$export$cefcfecf0835bcd9(spaceKey, 'blog');
const $a1f0c4d0ab868c5f$var$getPagesRoute = (spaceKey)=>$a1f0c4d0ab868c5f$export$cefcfecf0835bcd9(spaceKey, 'pages');
const $a1f0c4d0ab868c5f$export$6b45500787cf696 = (spaceKey, id, contentType, createdDate, slug)=>{
    const trailingSlug = slug ? `/${slug}` : '';
    switch(contentType){
        case 'blogpost':
            if (!createdDate) // When use_graphql_to_publish_pages_and_blogs is enabled, createDate does not exist
            return `${$a1f0c4d0ab868c5f$var$getBlogRoute(spaceKey)}/${id}${trailingSlug}`;
            else {
                const [yy, mm, dd] = createdDate.slice(0, 10).split('-');
                return `${$a1f0c4d0ab868c5f$var$getBlogRoute(spaceKey)}/${yy}/${mm}/${dd}/${id}${trailingSlug}`;
            }
        case 'page':
            return `${$a1f0c4d0ab868c5f$var$getPagesRoute(spaceKey)}/${id}${trailingSlug}`;
        default:
            throw new Error(`Expected content type 'blogpost' or 'page', but received '${contentType}'`);
    }
};
const $a1f0c4d0ab868c5f$export$257d483fa4a3254f = /^(http(s)?:)?\/\//;
const $a1f0c4d0ab868c5f$export$bfc29523388820d7 = (url, isContextAware)=>isContextAware && url.toString().indexOf($a1f0c4d0ab868c5f$export$8c6bf2df244e6a99) !== 0 ? $a1f0c4d0ab868c5f$export$8c6bf2df244e6a99 : '';
const $a1f0c4d0ab868c5f$export$6a80a340d4e68de1 = (url, isContextAware)=>{
    if ($a1f0c4d0ab868c5f$export$257d483fa4a3254f.test(url)) return url;
    else return `${$a1f0c4d0ab868c5f$export$bfc29523388820d7(url, isContextAware)}${url}`;
};
const $a1f0c4d0ab868c5f$export$feb8df2d5227ff6c = (urn)=>urn.charAt(0) === '#';



var $9pfwj = parcelRequire("9pfwj");

function $45cec8fdf0833adb$export$b5d8fba258cc9e89(pattern, url) {
    let parsed;
    try {
        parsed = (0, $9pfwj.parse)(url, true);
    } catch  {
        // parse(url, true) can throw "URI malformed" when the URL contains
        // invalid percent-encoding (e.g. a bare "%") because the second
        // argument tells it to decode query-string values via decodeURIComponent.
        // Fall back to parsing without query-string decoding so we still
        // get pathname, search, and hash.
        parsed = (0, $9pfwj.parse)(url, false);
    }
    const pathname = parsed.pathname || '';
    let match = (0, $0b5545bc430d2e46$export$81336c211d5ff295)(pathname, {
        path: pattern,
        exact: true
    });
    // some of our routes need query params to match
    if (!match) match = (0, $0b5545bc430d2e46$export$81336c211d5ff295)(`${pathname}${parsed.search}`, {
        path: pattern,
        exact: true
    });
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match.params) for (const [key, value] of Object.entries(match.params)){
        let decodedValue = value;
        if (typeof value !== 'undefined') {
            try {
                // decodeURIComponent("%") throws "URI malformed" error
                decodedValue = decodeURIComponent(value);
            } catch  {}
            decodedParams[key] = decodedValue;
        }
    }
    return {
        url: url,
        pathname: pathname,
        search: parsed.search || '',
        hash: parsed.hash || '',
        pattern: pattern,
        params: decodedParams,
        query: typeof parsed.query === 'object' ? parsed.query : {}
    };
}



var $9pfwj = parcelRequire("9pfwj");
/**
 * Tokenize input string.
 */ function $a369e6b8a93057e3$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $a369e6b8a93057e3$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $a369e6b8a93057e3$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat($a369e6b8a93057e3$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($a369e6b8a93057e3$var$escapeString(prevText), ")[^").concat($a369e6b8a93057e3$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $a369e6b8a93057e3$export$ef7acd7185315e22(str, options) {
    return $a369e6b8a93057e3$export$5b9bad9e403cf3d9($a369e6b8a93057e3$export$98e6a39c04603d36(str, options), options);
}
function $a369e6b8a93057e3$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $a369e6b8a93057e3$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function $a369e6b8a93057e3$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $a369e6b8a93057e3$export$71304158c7e35877(str, keys, options);
    return $a369e6b8a93057e3$export$968e97c88708237a(re, keys, options);
}
function $a369e6b8a93057e3$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $a369e6b8a93057e3$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $a369e6b8a93057e3$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $a369e6b8a93057e3$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $a369e6b8a93057e3$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $a369e6b8a93057e3$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $a369e6b8a93057e3$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $a369e6b8a93057e3$var$stringToRegexp(path, keys, options) {
    return $a369e6b8a93057e3$export$9a9303716def6456($a369e6b8a93057e3$export$98e6a39c04603d36(path, options), keys, options);
}
function $a369e6b8a93057e3$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($a369e6b8a93057e3$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($a369e6b8a93057e3$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $a369e6b8a93057e3$var$escapeString(encode(token));
        else {
            var prefix = $a369e6b8a93057e3$var$escapeString(encode(token.prefix));
            var suffix = $a369e6b8a93057e3$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $a369e6b8a93057e3$var$flags(options));
}
function $a369e6b8a93057e3$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $a369e6b8a93057e3$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $a369e6b8a93057e3$var$arrayToRegexp(path, keys, options);
    return $a369e6b8a93057e3$var$stringToRegexp(path, keys, options);
}


const $48a0bef41abd109a$export$1758be3e5622c165 = (pattern, params = {}, options = {})=>{
    const toPath = (0, $a369e6b8a93057e3$export$ef7acd7185315e22)(pattern, {
        encode: decodeURIComponent
    });
    const path = toPath(params);
    const parsed = (0, $9pfwj.parse)(path, true);
    return (0, $9pfwj.format)({
        pathname: parsed.pathname,
        query: {
            ...parsed.query,
            ...options.query || {}
        },
        hash: options.hash
    });
};


/**
 * Default for routes with no `bifrost` config, so Volt serves them instead of the monolith. No
 * `bundling`, so no SSR entry is generated. `exact` matters: `BASE` is `/`, so a non-exact entry
 * would claim every path below it. Shared and frozen; ssr-app's pillar config clones it.
 */ const $08784ba8c1603e4f$var$CLIENT_ONLY_VOLT_BIFROST = Object.freeze({
    indexHtml: 'error-app.html',
    voltRouteGate: 'bifrost-gateway-client-volt-killswitch',
    exact: true
});
class $08784ba8c1603e4f$export$e7b0ac011bb776c6 {
    static matchFirst(routes, url) {
        for (const route of routes){
            if (!(route instanceof $08784ba8c1603e4f$export$e7b0ac011bb776c6)) continue;
            const matchResult = route.match(url);
            if (matchResult) return matchResult;
        }
        return null;
    }
    match(url) {
        const urlMatch = (0, $45cec8fdf0833adb$export$b5d8fba258cc9e89)(this.pattern, url);
        if (urlMatch) {
            if (this.condition && !this.condition(urlMatch)) return null;
            return {
                ...urlMatch,
                name: this.name
            };
        }
        return null;
    }
    toUrl(params, options) {
        return (0, $48a0bef41abd109a$export$1758be3e5622c165)(this.pattern, params, options);
    }
    constructor(props){
        this.name = void 0;
        this.ufoName = void 0;
        this.bifrost = void 0;
        this.pattern = void 0;
        this.condition = void 0;
        this.isTransition = void 0;
        this.name = props.name;
        this.ufoName = props.ufoName;
        // `null` opts out; checked before `??` so it is not treated as "not provided".
        this.bifrost = props.bifrost === null ? undefined : props.bifrost ?? $08784ba8c1603e4f$var$CLIENT_ONLY_VOLT_BIFROST;
        this.pattern = props.pattern;
        this.condition = props.condition ? props.condition : ()=>true;
        this.isTransition = (previous, current)=>{
            if (!previous) return true;
            if (props.isTransition) return previous.name === current.name ? props.isTransition(previous, current) : true;
            return previous.pathname !== current.pathname;
        };
    }
}


/* eslint-disable confluence-feature-gating/inline-usage */ /* eslint-disable confluence-feature-gating/inline-expVal-params */ 
var $2hRE7 = parcelRequire("2hRE7");


const $bf8e248a69b7feca$export$4e7bc78665a3b140 = ({ children: children })=>{
    if (!(0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_artificial_regression')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $2hRE7.Fragment), null, children);
    // Add a small CPU block based on severity to create visible jank
    let waste = 0;
    const timeStart = performance.now();
    // 500ms is a magic number that we use to create a visible regression
    const duration = (0, $796eee35378ec3b4$export$2e2bcd8739ae039).getNumber('confluence_artificial_regression_ms', 500);
    while(performance.now() < timeStart + duration)waste += Math.sqrt(waste + 1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement("div", {
        id: `artificial-rerender-regression-component-regressed-by-${duration}ms`,
        "data-testid": "artificial-rerender-regression-component"
    }, children);
};




var $2hRE7 = parcelRequire("2hRE7");
/* eslint-disable prefer-template */ 
const $bc1f03695ae1c02a$export$8c6bf2df244e6a99 = '/wiki';


const $a24239c0837f4ae7$export$e6eb0c6cf0c4b7e3 = 'force_transition';
const $a24239c0837f4ae7$export$b5402fcece797a50 = (prevMatch, currentMatch)=>{
    const currentForceTransitionId = currentMatch?.query?.[$a24239c0837f4ae7$export$e6eb0c6cf0c4b7e3];
    const previousForceTransitionId = prevMatch?.query?.[$a24239c0837f4ae7$export$e6eb0c6cf0c4b7e3];
    return Boolean(currentForceTransitionId && currentForceTransitionId !== previousForceTransitionId);
};


// Please do NOT remove /*@__PURE__*/ in this file.
// These comments hints Terser (webpack's minifier) to remove the definition if they are not used.
//
// Please do NOT change string concatenation to string interpolation.
// String interpolations are compiled to "".concat("").concat("") because even the latest edge don't support them natively.
// This made minifier give up removing the dead code because it can't ensure the function call won't have side effects.
//
// Please keep these optimizations here and follow the existing one if you need to add new ones.
const $0d518026f9d519cf$var$contentTransition = (prev, curr)=>prev.params.contentId !== curr.params.contentId;
const $0d518026f9d519cf$var$spaceTransition = (prev, curr)=>prev.params.spaceKey !== curr.params.spaceKey;
const $0d518026f9d519cf$export$9e15ff8aa6bc996f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'BASE',
    pattern: '/'
});
const $0d518026f9d519cf$export$2fd309376969662f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'WIKI',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99),
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'WikiRoute',
            whichExportToUse: 'WikiRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-wiki-home-route-killswitch',
        voltRouteGate: 'bifrost-gateway-wiki-home-volt-killswitch',
        exact: true
    }
});
const $0d518026f9d519cf$export$a7c5707626fc90f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'HOME',
    ufoName: 'confluence-home',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/home/:view?',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'HomeRoute',
            whichExportToUse: 'HomeRoute'
        },
        enabled: true,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-wiki-home-route-killswitch',
        voltRouteGate: 'bifrost-gateway-wiki-home-volt-killswitch'
    }
});
const $0d518026f9d519cf$export$6ccd7dc0d5aa30b0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'TEMPLATE_GALLERY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/templates'
});
const $0d518026f9d519cf$export$7d65e474be175151 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/calendar/mycalendar.action'
});
const $0d518026f9d519cf$export$ec8a7da990877da3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_CALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/mycalendar'
});
const $0d518026f9d519cf$export$e492b3d04985e9fb = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MULTIPLE_SUBCALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/multiCalendars'
});
const $0d518026f9d519cf$export$57fb93d8931ad943 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EMBEDDED_MULTIPLE_SUBCALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/embedded/multiCalendars'
});
const $0d518026f9d519cf$export$aa473411bddb7e17 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/plugins/servlet/ac/com.atlassian.confluence.plugins.confluence-questions/globalQuestionsViewer\\?ac.com.atlassian.confluence.plugins.confluence-questions.pattern=/questions/ask'
});
const $0d518026f9d519cf$export$42bb8ba9cae96927 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTIONS_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/questions'
});
const $0d518026f9d519cf$export$a3ffa1b376d5ba4 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_QUESTIONS_ASK_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/questions/:spaceKey/ask'
});
const $0d518026f9d519cf$export$1e92de3a3dba0876 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTION_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/questions/:spaceKey/:questionId',
    /**
   * this will incorrectly match QUESTIONS_TOPIC_NATIVE
   * condition is used to prevent this
   */ condition: ({ params: params })=>Boolean(params.spaceKey && params.spaceKey !== 'topics' && params.questionId !== 'ask')
});
const $0d518026f9d519cf$export$dec9f53c339ce8f8 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTIONS_TOPICS_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/questions/topics'
});
const $0d518026f9d519cf$export$f80d02217688b484 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTIONS_TOPIC_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/questions/topics/:topicName'
});
const $0d518026f9d519cf$export$fdfdf584a0978d20 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTIONS_EXPERTS_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/questions/experts'
});
const $0d518026f9d519cf$export$6a85914fb9ca80a2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CONTENT_HISTORY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/history/:contentId(\\d+)/:contentSlug?'
});
const $0d518026f9d519cf$export$1f238fcead086ec3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CONTENT_HISTORY_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/viewpreviousversions.action'
});
const $0d518026f9d519cf$export$b74c113024023274 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_PAGE',
    ufoName: 'edit-page',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(pages)/edit/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$45222bf0cb32d6e2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_BLOG',
    ufoName: 'edit-page',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(blog)/edit/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$7b1285e36c635f1f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_PAGE_V2',
    ufoName: 'edit-page',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(pages)/edit-v2/:contentId(\\d+)',
    isTransition: $0d518026f9d519cf$var$contentTransition,
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'EditPageRoute',
            whichExportToUse: 'EditPageRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-edit-page-route-killswitch',
        voltRouteGate: 'bifrost-gateway-edit-page-volt-killswitch',
        exact: true
    }
});
const $0d518026f9d519cf$export$36dcea4e08feb5c9 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_BLOG_V2',
    ufoName: 'edit-page',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(blog)/edit-v2/:contentId(\\d+)',
    isTransition: $0d518026f9d519cf$var$contentTransition
});
const $0d518026f9d519cf$export$e63a462ee45b57cf = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_PAGE_EMBED',
    ufoName: 'edit-page-embed',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(pages)/edit-embed/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$bd17e6e353522e0d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_PAGE_SMART_CREATE',
    ufoName: 'edit-page-smart-create',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(pages)/edit-smart-create/:contentId(\\d+)',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'EditPageSmartCreateRoute',
            whichExportToUse: 'EditPageSmartCreateRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-edit-smart-create-route-killswitch',
        voltRouteGate: 'bifrost-gateway-edit-smart-create-volt-killswitch',
        exact: true
    }
});
const $0d518026f9d519cf$export$4fe224de953acb46 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SMART_CREATE',
    ufoName: 'space-smart-create',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/space-smart-create'
});
const $0d518026f9d519cf$export$f928fc717edba75d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'AI_PLANNER_CONFLUENCE_BRIDGE',
    ufoName: 'ai-planner-confluence-bridge',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/ai-planner/confluence-bridge',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'AIPlannerConfluenceBridgeRoute',
            whichExportToUse: 'AIPlannerConfluenceBridgeRoute'
        },
        enabled: true,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-ai-planner-confluence-bridge-route-killswitch',
        voltRouteGate: 'bifrost-gateway-ai-planner-confluence-bridge-volt-killswitch',
        exact: true
    },
    condition: ({ query: query })=>query.parentProduct === 'ai-planner'
});
const $0d518026f9d519cf$export$54edf7c16c47aeef = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_CONTENT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/create-content/:contentType'
});
const $0d518026f9d519cf$export$d6ae9e544e98926f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(pages)/create'
});
const $0d518026f9d519cf$export$e8253e1b7e500d1c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_BLOG',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(blog)/create'
});
const $0d518026f9d519cf$export$9a4ff2d809fc4156 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DELETE_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/removepage.action\\?pageId=:contentId(\\d+)'
});
const $0d518026f9d519cf$export$19c176cd0a878008 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ONBOARDING',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/welcome'
});
const $0d518026f9d519cf$export$439074745692fe65 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_DIRECTORY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces'
});
const $0d518026f9d519cf$export$2de9a69f9b51bb83 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/viewspacesummary.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$10f0439b47c8fdaf = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_REORDERPAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/reorderpages.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$d0ac6fa12f3acafa = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_HIDDEN_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/listorphanedpages.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$35123576da2e521 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_UNDEFINED_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/listundefinedpages.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$e18ccd8ffafdf3dd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_ATTACHMENTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/listattachmentsforspace.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$9c4e8cdcbbacdf8f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_APPLICATION_LINKS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + 'spaces/listentitylinks.action'
});
const $0d518026f9d519cf$export$f85f59869a8dbbf8 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_RSS_FEEDS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + 'spaces/listrssfeeds.action'
});
const $0d518026f9d519cf$export$d87089dbdd7eeaf3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_OVERVIEW_REDIRECT_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/viewspace.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$dd174db99b3e6fea = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DELETE_SPACE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/doremovespace.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$ef26ce515f06bc5e = Object.assign(/*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_INDEX',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey',
    /**
   * /spaces/:spaceKey will incorrectly match /spaces/something.action.
   * In that case the request should be sent to Monolith.
   */ condition: ({ params: params })=>Boolean(params.spaceKey && !params.spaceKey.endsWith('.action')),
    isTransition: $0d518026f9d519cf$var$spaceTransition,
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'SpaceOverviewRoute',
            whichExportToUse: 'SpaceOverviewRouteForSSR'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-space-overview-route-killswitch',
        voltRouteGate: 'bifrost-gateway-space-overview-volt-killswitch'
    }
}), {
    /**
   * Used for optimization purposes. See SPACE_OVERVIEW for more detail.
   */ HOMEPAGE_ID_QUERY_KEY: 'homepageId'
});
const $0d518026f9d519cf$export$65b723bb995d4fb6 = Object.assign(/*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_OVERVIEW',
    ufoName: 'space-overview',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/overview',
    isTransition: $0d518026f9d519cf$var$spaceTransition,
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'SpaceOverviewRoute',
            whichExportToUse: 'SpaceOverviewRouteForSSR'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-space-overview-route-killswitch',
        voltRouteGate: 'bifrost-gateway-space-overview-volt-killswitch'
    }
}), {
    /**
   * The key/name of the optional space overview URL query parameter which was
   * introduced for optimization purposes only and is used by
   * `@confluence/query-preloaders` to preload space
   * homepage-related queries.
   */ HOMEPAGE_ID_QUERY_KEY: 'homepageId'
});
const $0d518026f9d519cf$export$1009a7f2cc1ac09f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'HUB',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/hub'
});
const $0d518026f9d519cf$export$4dd08bdd46db5924 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'HUB_EDIT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/hub/edit'
});
const $0d518026f9d519cf$export$ada7925da580b561 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'COMPANY_HUB',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/company-hub',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'company-hub/CompanyHubRoute',
            whichExportToUse: 'CompanyHubRouteForSSR'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-company-hub-route-killswitch',
        voltRouteGate: 'bifrost-gateway-company-hub-volt-killswitch'
    }
});
const $0d518026f9d519cf$export$29df24b01e938adf = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'COMPANY_HUB_ANALYTICS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/company-hub/analytics'
});
const $0d518026f9d519cf$export$e003e97fab6b4368 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'COMPANY_HUB_EDIT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/company-hub/edit',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'company-hub/CompanyHubEditRoute',
            whichExportToUse: 'CompanyHubEditRouteForSSR'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-company-hub-edit-route-killswitch',
        voltRouteGate: 'bifrost-gateway-company-hub-edit-volt-killswitch'
    }
});
const $0d518026f9d519cf$export$5f7be6e90830de0c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'COMPANY_HUB_SETTINGS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/company-hub/settings/:tab(general)?'
});
const $0d518026f9d519cf$export$9257b5b55c8e2555 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug?',
    isTransition: (previousMatch, currentMatch)=>(0, $a24239c0837f4ae7$export$b5402fcece797a50)(previousMatch, currentMatch) || $0d518026f9d519cf$var$contentTransition(previousMatch, currentMatch),
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'ViewPageRoute',
            whichExportToUse: 'ViewPageRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-view-page-route-killswitch',
        voltRouteGate: 'bifrost-gateway-view-page-volt-killswitch'
    }
});
const $0d518026f9d519cf$export$475fdaba8e6145bb = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'NEXT_VIEW_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/next-pages/:contentId(\\d+)/:contentSlug?',
    isTransition: $0d518026f9d519cf$var$contentTransition
});
const $0d518026f9d519cf$export$f7f8ac1f46faf9c6 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PAGE_SPLIT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug/split'
});
const $0d518026f9d519cf$export$347d3b5edaae00e0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'BLOG_HOME',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/blog'
});
const $0d518026f9d519cf$export$91f49e7b30a9d34 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_BLOG',
    ufoName: 'blog',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/blog/:contentId(\\d+)/:contentSlug?',
    isTransition: $0d518026f9d519cf$var$contentTransition,
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'ViewBlogRoute',
            whichExportToUse: 'ViewBlogRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-view-blog-route-killswitch',
        voltRouteGate: 'bifrost-gateway-view-blog-volt-killswitch'
    }
});
const $0d518026f9d519cf$export$c259921a01da55b4 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'WHITEBOARD_HOME',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/whiteboard'
});
const $0d518026f9d519cf$export$5b90ced7e51bcea0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'WHITEBOARD_BOARD',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/whiteboard/:contentId',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'WhiteboardRoute',
            whichExportToUse: 'WhiteboardRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-whiteboard-route-killswitch',
        voltRouteGate: 'bifrost-gateway-whiteboard-volt-killswitch'
    }
});
const $0d518026f9d519cf$export$c1375e778136faf8 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SLIDES_VIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/slide/:contentId',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'SlidesRoute',
            whichExportToUse: 'SlidesRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-whiteboard-route-killswitch',
        voltRouteGate: 'bifrost-gateway-whiteboard-volt-killswitch'
    }
});
const $0d518026f9d519cf$export$7d8684a463b78f54 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CONTACT_ADMINISTRATOR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/contact-administrators'
});
const $0d518026f9d519cf$export$eb54044908e4e0bd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_SETTINGS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin'
});
const $0d518026f9d519cf$export$506a1a071415f2e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_GLOBAL_AUTOMATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/automation'
});
const $0d518026f9d519cf$export$4e4c6a9eb23f65ec = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_EDIT_EXTERNAL_SHARING',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/public-links'
});
const $0d518026f9d519cf$export$a1d81e742f4c736a = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_ANONYMOUS_ACCESS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/anonymous-access'
});
const $0d518026f9d519cf$export$34a1f8584895c359 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_SPACE_MANAGEMENT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/space-management'
});
const $0d518026f9d519cf$export$8bc874b6ace7b827 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_SPACE_DEFAULTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/space-defaults'
});
const $0d518026f9d519cf$export$3131a0442cfecc47 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_SPACE_ROLES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/space-roles'
});
const $0d518026f9d519cf$export$1a109903d8828cd7 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_SITE_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/site-permissions'
});
const $0d518026f9d519cf$export$e80ac94b8ecda3f5 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_GUESTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/guests'
});
const $0d518026f9d519cf$export$128f725ffe7518d6 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_APP_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/app-permissions'
});
const $0d518026f9d519cf$export$9da18303b9e1daee = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_JSM_ACCESS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/jsm-access'
});
const $0d518026f9d519cf$export$37055aaa9d88b944 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_FORGE_APPS_REDIRECT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/forge\\?id=:id(.+)'
});
const $0d518026f9d519cf$export$b17d28dbf200fde0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_FORGE_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/forge/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)?/:appRoutePath*'
});
const $0d518026f9d519cf$export$5bfa1fef1b53dfdd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NEW_GLOBAL_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions/global'
});
const $0d518026f9d519cf$export$dd6de41f650dae89 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_COMPANY_HUB_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions/hub/:tab(groups|users|guests)?'
});
const $0d518026f9d519cf$export$8c6393d6207d929 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_COMPANY_HOME_BUILDER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/look-and-feel/company-home-builder'
});
const $0d518026f9d519cf$export$9397e0d80cf06055 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CUSTOMIZE_NAVIGATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/look-and-feel/customize-navigation'
});
const $0d518026f9d519cf$export$f107e7a692a3a54e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NEW_GLOBAL_PERMISSIONS_USER_DETAILS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions/global/user/:accountId'
});
const $0d518026f9d519cf$export$5bbec961de23dce7 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_SITE_SPACE_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions/space-permissions/:tab(defaults|allspaces|roles)?'
});
const $0d518026f9d519cf$export$6a8756d3434dd2ea = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CONFLUENCE_CHATS_INTEGRATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/confluence-chats-integration'
});
const $0d518026f9d519cf$export$32107da104ebe4cd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CONFLUENCE_MSTEAMS_SIGNIN_CONFIRMATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/microsoft-teams/connected'
});
const $0d518026f9d519cf$export$f0e8d063cba10e9c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_AUDIT_LOG',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/auditlogging.action'
});
const $0d518026f9d519cf$export$3039840c47d9a13d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_BROWSE_SHORTCUTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/browseshortcuts.action'
});
const $0d518026f9d519cf$export$e1e5a41fa357e66f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CREATE_SHORTCUT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/createshortcut.action'
});
const $0d518026f9d519cf$export$4fcc3f53642c593a = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_REMOVE_SHORTCUT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/removeshortcut.action'
});
const $0d518026f9d519cf$export$7234e6926944adc0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_DARK_FEATURES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/darkfeatures.action'
});
const $0d518026f9d519cf$export$b86d7bd984fb9727 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_ENABLE_DARK_FEATURE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/enabledarkfeature.action'
});
const $0d518026f9d519cf$export$1afd9317831e345e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_DISABLE_DARK_FEATURE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/disabledarkfeature.action'
});
const $0d518026f9d519cf$export$9e8d02f6bdb565e9 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_BETA_FEATURES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/betafeatures'
});
const $0d518026f9d519cf$export$f03a4adc711219ed = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NEW_FEATURES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/newfeatures'
});
const $0d518026f9d519cf$export$af040d7344c912d1 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_LIVE_EDIT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/liveedit'
});
const $0d518026f9d519cf$export$70e53b90503ea1b9 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NBM_MIGRATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/nbm-migration'
});
const $0d518026f9d519cf$export$9fe7a72d144f372 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NBM_MIGRATION_SCANS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/nbm-migration/scans'
});
const $0d518026f9d519cf$export$3b3f3d2739d7f93 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NBM_MIGRATION_SCAN',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/nbm-migration/scans/:scanId'
});
const $0d518026f9d519cf$export$d255d2f418d43162 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NBM_MIGRATION_UNSUPPORTED',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/nbm-migration/scans/:scanId/unsupported'
});
const $0d518026f9d519cf$export$f313d05bcfc41be4 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NBM_MIGRATION_UNVERIFIED',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/nbm-migration/scans/:scanId/unverified'
});
const $0d518026f9d519cf$export$199a3e309932cca4 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NBM_MIGRATION_RUN_TRANSFORMATIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/nbm-migration/scans/:scanId/run-transformations'
});
const $0d518026f9d519cf$export$2d0c6cbdaebd76ff = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NBM_MIGRATION_TRANSFORMATIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/nbm-migration/transformations'
});
const $0d518026f9d519cf$export$688990fbefa748b3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_DC_SCRIPT_MIGRATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/script-migration'
});
const $0d518026f9d519cf$export$2925d036bbc38c7 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_CALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/calendars\\?src=sidebar&openAddCalDialog=true'
});
const $0d518026f9d519cf$export$351b62e6f5786a73 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_CALENDARS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/calendars'
});
const $0d518026f9d519cf$export$4a2048bb71da8b4b = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_CALENDARS_SUBCALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/calendars/:subCalendarId'
});
const $0d518026f9d519cf$export$7de5b687836953bd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_EMBEDDED_SUBCALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/embedded/calendars/:subCalendarId'
});
const $0d518026f9d519cf$export$27b2e48e28163360 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DISCOVER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/discover'
});
const $0d518026f9d519cf$export$f178fb5b1e822288 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ALL_UPDATES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/discover/all-updates'
});
const $0d518026f9d519cf$export$777796688df78f56 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'POPULAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/discover/popular'
});
const $0d518026f9d519cf$export$3907c7d8e57f70ba = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_WORK_HOME',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/my'
});
const $0d518026f9d519cf$export$fe97ee265fd89939 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_WORK_DRAFTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/my/drafts'
});
const $0d518026f9d519cf$export$b71609db3dda2696 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_WORK_RECENT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/my/recent-work'
});
const $0d518026f9d519cf$export$730392c243a0a367 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_RECENTLY_VISITED',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/my/recently-visited'
});
const $0d518026f9d519cf$export$85bd3cea0cecb26c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_SAVED_FOR_LATER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/my/saved-for-later'
});
const $0d518026f9d519cf$export$c8a37c9f76d4d03f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'RECENT_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/recent'
});
const $0d518026f9d519cf$export$771b75a6ca136f91 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'RECENT_VISITED',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/recent/visited'
});
const $0d518026f9d519cf$export$8e4a8343b1614a02 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'RECENT_DRAFTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/recent/draft'
});
const $0d518026f9d519cf$export$2c9cf254b3b24ff = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'RECENT_SAVED',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/recent/saved'
});
const $0d518026f9d519cf$export$d925029e7ceadd51 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'TEMPLATE_MIGRATION_PREVIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/template/migration/preview\\?templateId=:contentId([0-9a-z-]+)'
});
const $0d518026f9d519cf$export$e84c491e2d88d9f6 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_TEMPLATE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/templates/edit/:contentId([0-9a-z-]+)'
});
const $0d518026f9d519cf$export$4ce9d0d8218b9d84 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SITE_SETTINGS_EDIT_TEMPLATE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/templates2/editpagetemplate.action',
    condition: ({ query: query })=>Boolean(query.entityId && Object.keys(query).length === 1)
});
const $0d518026f9d519cf$export$a990a60696f54618 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_TEMPLATE_BLUEPRINT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/templates/edit/:pluginKey/:moduleKey'
});
const $0d518026f9d519cf$export$f8d71dcb352ebe8c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_DEFAULT_BLUEPRINT_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/plugins/createcontent/edit-template.action',
    condition: ({ query: query })=>Boolean(query.key && query.contentTemplateRefId && Object.keys(query).length === 2) || Boolean(query.contentTemplateRefId && Object.keys(query).length === 1)
});
const $0d518026f9d519cf$export$b45af2e1d7abb289 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SITE_SETTINGS_EDIT_SYSTEM_TEMPLATE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/plugins/createcontent/edit-template.action',
    condition: ({ query: query })=>Boolean(query.pluginKey && query.moduleKey && Object.keys(query).length === 2)
});
const $0d518026f9d519cf$export$c0a209b0b0b16c75 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_TEMPLATE_SPACE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/templates/edit/:contentId([0-9a-z-]+)'
});
const $0d518026f9d519cf$export$dcee5dee04648c93 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_TEMPLATE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/templates/create'
});
const $0d518026f9d519cf$export$793ade69cc97583f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_TEMPLATE_SITE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/templates2/createpagetemplate.action'
});
const $0d518026f9d519cf$export$499f432aa493cdd2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_TEMPLATE_SPACE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/templates2/createpagetemplate.action',
    condition: ({ query: query })=>Boolean(query.key && Object.keys(query).length === 1)
});
const $0d518026f9d519cf$export$dcda7f8b6fe54ba = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_TEMPLATE_SPACE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/templates/create'
});
const $0d518026f9d519cf$export$9e430f65574f5333 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'HELLO_WORLD',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/hello-world'
});
const $0d518026f9d519cf$export$e9d78b13bbb4e56f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DASHBOARD_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/dashboard.action'
});
const $0d518026f9d519cf$export$d7be6003270f6c2d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPA_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spa.action'
});
const $0d518026f9d519cf$export$b49467be269d2629 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'INDEX_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/index.action'
});
const $0d518026f9d519cf$export$e52245e856f5c06 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_PAGE_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/createpage.action'
});
const $0d518026f9d519cf$export$926e3916067d7530 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_BLOG_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/createblogpost.action'
});
const $0d518026f9d519cf$export$e720b1e170b46aae = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_PAGE_VARIABLES_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/createpage-entervariables.action'
});
const $0d518026f9d519cf$export$6c7b95dcf08f3a6d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'RESUME_DRAFT_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/resumedraft.action'
});
const $0d518026f9d519cf$export$b010f02787df1e6 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'COPY_PAGE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/copypage.action'
});
const $0d518026f9d519cf$export$ecc28d15af39a8b2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_PAGE_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/viewpage.action',
    // viewpage.action should be served from Monolith when it has pageVersion query
    condition: ({ query: query })=>Boolean(query.pageId && Object.keys(query).length === 1),
    // Out of the descriptor: Bifrost matches on path alone, so an entry would claim the
    // Monolith URLs too.
    bifrost: null
});
const $0d518026f9d519cf$export$482db086bc8c2289 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_OVERVIEW_INDEX_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/overview/index.action'
});
const $0d518026f9d519cf$export$3afea7266d0d139b = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_INDEX_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/index.action'
});
const $0d518026f9d519cf$export$3d1be0ba1817b3cb = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_CONTRIBUTORS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/contributors'
});
const $0d518026f9d519cf$export$4eb80c3a4e6fbe0f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/pages'
});
const $0d518026f9d519cf$export$bd2c9bb170b3681d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_BLOG_DATE_LEGACY',
    ufoName: 'blog',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/blog/:year(\\d+)/:month(\\d+)/:day(\\d+)/:contentId(\\d+)/:contentSlug?',
    isTransition: $0d518026f9d519cf$var$contentTransition,
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'ViewBlogRoute',
            whichExportToUse: 'ViewBlogRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-view-blog-route-killswitch',
        voltRouteGate: 'bifrost-gateway-view-blog-volt-killswitch'
    }
});
const $0d518026f9d519cf$export$5c9eaf42f32252ea = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ACTION_REDIRECT_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/(.*).action',
    condition: ({ query: query })=>query.key == null
});
const $0d518026f9d519cf$export$7ae0ea91a2dfc4d9 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADVANCED_SEARCH_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/dosearchsite.action'
});
const $0d518026f9d519cf$export$3bd4ec9f05d79904 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADVANCED_SEARCH',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/search',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'AdvancedSearchRoute',
            whichExportToUse: 'AdvancedSearchRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-search-route-killswitch',
        voltRouteGate: 'bifrost-gateway-search-volt-killswitch'
    }
});
const $0d518026f9d519cf$export$2bc30aa6642650c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'LABELLED_CONTENT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/label/:spaceKey/:labelName(.+)'
});
const $0d518026f9d519cf$export$d593e642a326a501 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EXTERNAL_SHARE',
    ufoName: 'public-link-shared-page',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/external/:contentId?/:externalToken'
});
const $0d518026f9d519cf$export$d7c46ce72a2e4742 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ACCESS_LINK',
    ufoName: 'access-link-shared-page',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/access-link/:shareToken',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'AccessLinkRoute',
            whichExportToUse: 'AccessLinkRouteForSSR'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-access-link-route-killswitch',
        voltRouteGate: 'bifrost-gateway-access-link-volt-killswitch'
    }
});
const $0d518026f9d519cf$export$6490fab56523ceda = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PDF_EXPORT_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pdf/spaces/:spaceKey/pages/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$dcb1d1a9cda087b1 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PDF_EXPORT_SPACE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pdf/spaces/:spaceKey/pages/overview'
});
const $0d518026f9d519cf$export$6b2db7909585abd7 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'LEGACY_SPACE_PDF_EXPORT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/flyingpdf/flyingpdf.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$2dd65cdecd8b05d7 = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EXPORT_SPACE_CSV',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/exportspacecsv.action\\?key=:spaceKey'
});
const $0d518026f9d519cf$export$d78f611c1ddf7234 = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EXPORT_SPACE_XML',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/exportspacexml.action\\?key=:spaceKey'
});
const $0d518026f9d519cf$export$9dc7f7e5e1435bc = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EXPORT_SPACE_HTML',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/exportspacehtml.action\\?key=:spaceKey'
});
const $0d518026f9d519cf$export$1bc544543b946246 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_PAGE_MOBILE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/mobile/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug?'
});
const $0d518026f9d519cf$export$d387bb8ca9ce25d1 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_BLOG_MOBILE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/mobile/spaces/:spaceKey/blog/:year(\\d+)/:month(\\d+)/:day(\\d+)/:contentId(\\d+)/:contentSlug?'
});
const $0d518026f9d519cf$export$3d8579587b62bb96 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MOBILE_MACRO_RENDERER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/mobileapp/macro/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$f7bf92a6467c1557 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PEOPLE_DIRECTORY_SEARCH',
    pattern: '/people/search'
});
const $0d518026f9d519cf$export$ed260c82a3e70a6a = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CONFLUENCE_PEOPLE_DIRECTORY_SEARCH',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/people/search'
});
const $0d518026f9d519cf$export$a90430d7f36bfe9e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MARKETPLACE_FIND_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/marketplace(.*)'
});
const $0d518026f9d519cf$export$22bb05181a4b1501 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MARKETPLACE_APP_REQUESTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/marketplace/manage/app-requests'
});
const $0d518026f9d519cf$export$cb73aa9f5b7d1ea0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MARKETPLACE_MANAGE_PROMOTIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/marketplace/manage/promotions'
});
const $0d518026f9d519cf$export$df78b182760b42f4 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PEOPLE_DIRECTORY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/people/([\\w:-]+)*'
});
const $0d518026f9d519cf$export$2d3703cff5d9a27 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_RESTRICTED_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/listpermissionpages.action'
});
const $0d518026f9d519cf$export$60773cf116cf5f30 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_ARCHIVED_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/archivedpages'
});
const $0d518026f9d519cf$export$40e965fb568c3c83 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PAGE_DIFF_BY_VERSION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/diffpagesbyversion.action'
});
const $0d518026f9d519cf$export$cb80c94a905e11b6 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SITE_ANALYTICS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/analytics/:tab(overview|spaces|users|search)?'
});
const $0d518026f9d519cf$export$93b558a6e07dbdac = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SITE_ANALYTICS_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/analytics/permissions'
});
const $0d518026f9d519cf$export$67acd8a63f03bc8 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_ANALYTICS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/analytics/:tab(overview|content|users)?'
});
const $0d518026f9d519cf$export$6b9c632e635b4d77 = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_ANALYTICS_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/analytics/permissions'
});
const $0d518026f9d519cf$export$37a588b556645c19 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PAGE_ANALYTICS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/analytics/:contentId(\\d+)/:tab(overview|mentions|links)?'
});
const $0d518026f9d519cf$export$7f9afa9f8695d995 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SUGGESTIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/suggestions'
});
const $0d518026f9d519cf$export$aded01fc53d469df = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_QUESTIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/display/:spaceKey/customcontent/list/ac%3Acom.atlassian.confluence.plugins.confluence-questions%3Aquestion'
});
const $0d518026f9d519cf$export$cdd412f0619f2d7e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_QUESTIONS_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/questions'
});
const $0d518026f9d519cf$export$aa72b945229db170 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_QUESTION_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/questions/:questionId'
});
const $0d518026f9d519cf$export$f0c4a6dc3b3437aa = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_CUSTOM_CONTENT_LIST',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/display/:spaceKey/customcontent/list/:type'
});
const $0d518026f9d519cf$export$1a5e481ee166ad7c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CUSTOM_CONTENT_VIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/display/:spaceKey/customcontent/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$f39a30a3a5635bab = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_BULK_TOOLS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/bulktools'
});
const $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH = (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/settings';
const $0d518026f9d519cf$export$3101773a7a844077 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_LANDING_PAGE',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/home'
});
const $0d518026f9d519cf$export$f03524b1e395be4a = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_LANDING_PAGE_ALT',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH
});
const $0d518026f9d519cf$export$38b94ff4631b44df = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_AUTOMATION',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/automation'
});
const $0d518026f9d519cf$export$3591d21f4b9b700 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_AGENT_CONTEXT',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/details',
    condition: (match)=>match.hash === '#agent-context'
});
const $0d518026f9d519cf$export$5f63ad7e18293ec2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_DETAILS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/details'
});
const $0d518026f9d519cf$export$26dfba554adbf87e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_ARCHIVE_SPACE',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/archiveSpace'
});
const $0d518026f9d519cf$export$1b93424785e5f745 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_TRASH_SPACE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/removespace.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$2cc9af506d64ef72 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EDITOR_CONVERSION',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/editorConversion'
});
const $0d518026f9d519cf$export$693d9b367ae8d0f7 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_RELATED_PAGES',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/relatedPages'
});
const $0d518026f9d519cf$export$22f8e464aee70413 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EDIT_FEATURES',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/editFeatures'
});
const $0d518026f9d519cf$export$345aea7dc51bac8a = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_TEMPLATES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/settings/look-and-feel/templates'
});
const $0d518026f9d519cf$export$499a561f6d1a011 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EDIT_TEMPLATE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/templates2/editpagetemplate.action',
    condition: ({ query: query })=>Boolean(query.entityId && query.key && Object.keys(query).length === 2)
});
const $0d518026f9d519cf$export$4f46a1e4250ebe18 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_LOOK_AND_FEEL_SETTINGS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/look-and-feel/:tab(themes|templates|page-layout|pdf-export)'
});
const $0d518026f9d519cf$export$e64d4514fc584fbe = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_PERMISSIONS_SETTINGS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/permissions/:tab(groups|users|guests|anonymous|public-links|analytics|apps)?'
});
const $0d518026f9d519cf$export$edc6bf6d11241655 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_ACCESS_LINKS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/access-links'
});
const $0d518026f9d519cf$export$ee28bfe408c8e5b2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_ACCESS_LINKS_CONFIGURATION',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/access-links/configuration'
});
const $0d518026f9d519cf$export$323161697c5fa666 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ROLE_BASED_ACCESS_CONTROL_HUB',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/roles-hub'
});
const $0d518026f9d519cf$export$2f6a532274e0cd9d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_PERMISSIONS_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/addonpermissions.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$a007a4f7553ffc16 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_SPACE_PERMISSIONS_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/editaddonpermissions.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$629e966630a1f92e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_MEMBERS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/members'
});
const $0d518026f9d519cf$export$f0e860396acf6277 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_FORGE_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)/:appRoutePath*'
});
const $0d518026f9d519cf$export$4442c9c7bb716896 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'GLOBAL_PAGE_FORGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)/:appRoutePath*'
});
const $0d518026f9d519cf$export$ffd880217e61385f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_FORGE_APPS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)?/:appRoutePath*'
});
const $0d518026f9d519cf$export$8bf619366f9e74f2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_AVATARS_AND_STATUS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/avatarsAndStatus'
});
const $0d518026f9d519cf$export$bc800ac2a79e672d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_STATUS_AND_APPROVALS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/status-and-approvals'
});
const $0d518026f9d519cf$export$e62498d72b78f3ef = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_AVATARS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/avatars'
});
const $0d518026f9d519cf$export$a85b9c60514cd043 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_CONTENT_STATE',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/contentStatuses'
});
const $0d518026f9d519cf$export$19b893a9e64dac94 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_DATA_CLASSIFICATION',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/classifications'
});
const $0d518026f9d519cf$export$3d39129bec795227 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_WATERMARK_CONFIGURATION',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/watermark'
});
const $0d518026f9d519cf$export$939b28e9f8987d97 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EXPORT_SPACE_UNAVAILABLE',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/exportSpaceUnavailable'
});
const $0d518026f9d519cf$export$3582accdd821993a = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EXPORT',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/export'
});
const $0d518026f9d519cf$export$871ac71d42c178c5 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_LEGACY_CONTENT',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/legacy-content'
});
const $0d518026f9d519cf$export$b8adcf19ff927cec = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EXPORT_SPACE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/exportspacewelcome.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$751ae19fa150b7c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_TRASH',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/viewtrash.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$526ccce5d32f7beb = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MOBILE_TAKEOVER_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/mobileapp'
});
const $0d518026f9d519cf$export$ed19a29c446e24d8 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DEFAULT_ADMIN_MANAGE_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/plugins/servlet/upm'
});
const $0d518026f9d519cf$export$7de52f6cc232129e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_APP_AUDIT_LOGS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/plugins/servlet/upm/log'
});
const $0d518026f9d519cf$export$81cfd93b1b89cd07 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_TEMPLATE_LIST_PAGE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/templates2/listpagetemplates.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$31745f3bff21cd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_TEMPLATES_AND_BLUEPRINTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/templates-and-blueprints'
});
const $0d518026f9d519cf$export$7af7a1e753a92264 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_APPLICATION_NAVIGATOR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/application-navigator'
});
const $0d518026f9d519cf$export$28e7e683f23a58d3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CUSTOM_CONTENTS_ON_PAGE_LIST',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/display/:spaceKey/pages/:contentId(\\d+)/customcontents/:type?'
});
const $0d518026f9d519cf$export$3ce513606c31c918 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_ANNOUNCEMENT_BANNER_RENDERER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/announcements/:id(.*)?'
});
const $0d518026f9d519cf$export$dfa725d05e18145e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'USER_ACCESS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/user-access'
});
const $0d518026f9d519cf$export$8674e83405059790 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PERMISSIONS_EXPORT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions-export'
});
const $0d518026f9d519cf$export$8b5e82a6ff458b36 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PERMISSIONS_COMBINATIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions-combinations'
});
const $0d518026f9d519cf$export$5942f6ee6cb5e57b = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_SYSTEM_OPERATIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/system-operations'
});
const $0d518026f9d519cf$export$652395dc5ff9b416 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'IMPORTER_STATUS_DASHBOARD',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/importer-status-dashboard'
});
const $0d518026f9d519cf$export$4d1bccc78b263a8e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_MANAGER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/space-manager'
});
const $0d518026f9d519cf$export$df327d9b56ca6b7c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CENTER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/center'
});
const $0d518026f9d519cf$export$53f195d79ef3d4dd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CENTER_SPACE',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/mission-control'
});
const $0d518026f9d519cf$export$23e7002e5e9ef89e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_TEAM_CALENDARS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/teamcalendars'
});
const $0d518026f9d519cf$export$2a17c68caa9b9a01 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_TEAM_CONTROLS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions/team-controls'
});
const $0d518026f9d519cf$export$299af9061dea1f09 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CONFIGURATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/configuration'
});
const $0d518026f9d519cf$export$eb5a785192323bd3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_DEFAULT_SPACE_LOGO',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/default-space-logo'
});
const $0d518026f9d519cf$export$168f3acd059931e0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_HEADER_AND_FOOTER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/header-and-footer'
});
const $0d518026f9d519cf$export$f923488a46a66438 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_ACCESS_REQUESTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/access-requests'
});
const $0d518026f9d519cf$export$3bcebf4f1e82d3ad = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_SECURITY_CONFIGURATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/security-configuration'
});
const $0d518026f9d519cf$export$34acb7ca79032384 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_ACCESS_LINKS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/access-links'
});
const $0d518026f9d519cf$export$c53feccaf231f120 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_ACCESS_LINKS_CONFIGURATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/access-links/configuration'
});
const $0d518026f9d519cf$export$42599f111394c36c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_SPACE_REPORTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/space-reports'
});
const $0d518026f9d519cf$export$e05db3c2f69bd3ae = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_COLOR_SCHEME',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/color-scheme'
});
const $0d518026f9d519cf$export$4c6bf75100b3b72 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CODE_MACRO_CONFIGURATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/code-macro-configuration'
});
const $0d518026f9d519cf$export$70914a626e2f0488 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_TRASHED_SPACES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/trashed-spaces'
});
const $0d518026f9d519cf$export$3d0698fcdc33631d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_IMPORT_SPACES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/space-import'
});
const $0d518026f9d519cf$export$85c61af9d225a707 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_JIRA_MACRO_REPAIR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/jira-macro-repair'
});
const $0d518026f9d519cf$export$c0d0d3f98d45e5f1 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_MACRO_USAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/macro-usage'
});
const $0d518026f9d519cf$export$69df75bd8c217ade = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_MACRO_USAGE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/pluginusage.action'
});
const $0d518026f9d519cf$export$e8beba40e140a443 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_THEMES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/themes'
});
const $0d518026f9d519cf$export$c471be73599ccae1 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_PDF_EXPORT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/pdf-export'
});
const $0d518026f9d519cf$export$bb9816d0c0dcd6e6 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_WATERMARK_CONFIGURATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/watermark'
});
const $0d518026f9d519cf$export$94f5f2b71458cc90 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'NEW_AUDIT_LOG',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/audit-log'
});
const $0d518026f9d519cf$export$9859a7a7049d0585 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DATABASE_CUSTOM_OVERVIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/custom/database/overview'
});
const $0d518026f9d519cf$export$90480461935b54cc = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DATABASE_CUSTOM_VIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/custom/database/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$851ba2be5095d586 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DATABASE_VIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/database/:contentId',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'DatabaseRoute',
            whichExportToUse: 'DatabaseRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-database-route-killswitch',
        voltRouteGate: 'bifrost-gateway-database-volt-killswitch'
    }
});
const $0d518026f9d519cf$export$84b5e15197aaaa12 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EMBED_VIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/embed/:contentId',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'EmbedRoute',
            whichExportToUse: 'EmbedRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-embed-route-killswitch',
        voltRouteGate: 'bifrost-gateway-embed-volt-killswitch'
    }
});
const $0d518026f9d519cf$export$4dcf771d1a1901ef = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'FOLDER_VIEW',
    ufoName: 'folder-page',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/folder/:contentId(\\d+)/:contentSlug?',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'FolderViewRoute',
            whichExportToUse: 'FolderViewRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-folder-view-route-killswitch',
        voltRouteGate: 'bifrost-gateway-folder-view-volt-killswitch'
    }
});
const $0d518026f9d519cf$export$752c480a913a6712 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_BULK_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions/bulk-permissions'
});
const $0d518026f9d519cf$export$16172a64bcdb79f8 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NOTIFICATIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/notifications'
});
const $0d518026f9d519cf$export$d64d95b14fbe0bc3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CREATE_WITH_ROVO',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/create-with-rovo'
});
const $0d518026f9d519cf$export$703c0113e0ca5515 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PERFORMANCE_INSIGHTS_NETWORK_SPEED',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/performance/user-setup/network-speed'
});
const $0d518026f9d519cf$export$bda499cb90b2d60e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PERFORMANCE_INSIGHTS_CPU_CORES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/performance/user-setup/cpu-cores'
});
const $0d518026f9d519cf$export$131cf600a1a5d1b3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PERFORMANCE_INSIGHTS_NETWORK_PROTOCOL',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/performance/user-setup/network-protocol'
});
const $0d518026f9d519cf$export$4ec917ea3fb6cbfc = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PERFORMANCE_INSIGHTS_OPERATING_SYSTEM',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/performance/user-setup/operating-system'
});
const $0d518026f9d519cf$export$74a9a335c43b2ab9 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PERFORMANCE_INSIGHTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/performance/:tab(overview|load-times|user-setup|content-metrics)?'
});
const $0d518026f9d519cf$export$59a52cdd0906f4cb = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'TOPICS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/topics/:topicId'
});
const $0d518026f9d519cf$export$57a75dda1f25b360 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PREMIUM_ADMIN_FEATURES_EXPERIMENT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/premium-admin-features'
});
const $0d518026f9d519cf$export$3ebf2fc23df50648 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ATTACHMENTS_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/attachments/:contentId(\\d+)?'
});
const $0d518026f9d519cf$export$7ab78afe8c48e1e5 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CHAT',
    ufoName: 'confluence-chat',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/chat',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'ChatRoute',
            whichExportToUse: 'ChatRouteForSSR'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-chat-route-killswitch',
        voltRouteGate: 'bifrost-gateway-chat-volt-killswitch',
        exact: true
    }
});
const $0d518026f9d519cf$export$f887b7b4f6d59541 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'INFERRED_PROJECT_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/graphstore/project'
});
const $0d518026f9d519cf$export$325240bec5751c99 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'INFERRED_PROJECT_PAGE_WITH_ARI',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/graphstore/project/:workspaceId/:projectId'
});



var $2hRE7 = parcelRequire("2hRE7");
const $4b72a15528d34979$var$nullNoop = ()=>null;
const $4b72a15528d34979$var$objNoop = ()=>({});
const $4b72a15528d34979$var$stringNoop = ()=>'';
const $4b72a15528d34979$var$voidNoop = ()=>{};
const $4b72a15528d34979$export$779e8f71c6bb38c = (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createContext({
    getHref: $4b72a15528d34979$var$stringNoop,
    history: null,
    location: null,
    match: null,
    transitionId: null,
    toUrl: $4b72a15528d34979$var$stringNoop,
    matchRoute: $4b72a15528d34979$var$nullNoop,
    matchSupportedRoute: $4b72a15528d34979$var$nullNoop,
    getQueryParams: $4b72a15528d34979$var$objNoop,
    setQueryParams: $4b72a15528d34979$var$voidNoop,
    getHash: $4b72a15528d34979$var$stringNoop,
    setHash: $4b72a15528d34979$var$voidNoop,
    replace: $4b72a15528d34979$var$voidNoop,
    routes: [],
    push: $4b72a15528d34979$var$voidNoop,
    open: $4b72a15528d34979$var$nullNoop,
    onPageReload: $4b72a15528d34979$var$voidNoop,
    preloadRoute: $4b72a15528d34979$var$voidNoop
});
$4b72a15528d34979$export$779e8f71c6bb38c.displayName = 'RoutesContext';


function $1262eee5c487dee7$export$cf1af05a5f90ab81() {
    $1262eee5c487dee7$var$useAnchorEventListener("click", $1262eee5c487dee7$var$spaTransitionOnAnchorClick, false);
    $1262eee5c487dee7$var$useAnchorEventListener("mousedown", $1262eee5c487dee7$var$preloadRouteOnMouseDown, true);
    $1262eee5c487dee7$var$useAnchorEventListener("preloadOnHover", $1262eee5c487dee7$var$preloadRouteOnMouseHover, true);
    return null;
}
function $1262eee5c487dee7$var$createAnchorEventListener(eventListener, routesContext) {
    return (e)=>{
        // Some code already handled this
        if (e.defaultPrevented) return;
        const details = $1262eee5c487dee7$export$bd34341d1dc0003f(e, routesContext);
        if (details) eventListener(e, routesContext, details);
    };
}
function $1262eee5c487dee7$var$isContentEditable(element) {
    return element instanceof HTMLElement && element.isContentEditable;
}
function $1262eee5c487dee7$export$bd34341d1dc0003f(e, routesContext) {
    if (e.type === 'preloadOnHover') {
        const detail = e.detail;
        if (detail?.preloadUrl) {
            const { preloadUrl: preloadUrl, ...preloadOptions } = detail;
            return {
                href: preloadUrl,
                ...preloadOptions
            };
        }
        return;
    }
    if (!('button' in e) || e['button'] !== 0 /* main button */ ) return;
    // Don't handle if modifier keys used
    if (e['ctrlKey'] || e['shiftKey'] || e['altKey'] || e['metaKey']) return;
    const { target: target } = e;
    if (!target || !(target instanceof Element)) return;
    // This might be the child of an anchor (such as the span inside of a smart card),
    // so check for a parent anchor.
    const anchor = target.closest('a');
    if (!anchor) return;
    //ignore hash links, they're handled by scroll handlers that also listen to document click
    if (!(anchor instanceof HTMLAnchorElement) || 'hash' in anchor && anchor['hash']) return;
    // Links in contenteditable elements are not clickable
    // https://product-fabric.atlassian.net/browse/CEMS-951
    // Checking closest 'contentEditable' for anchor,
    // In case there are "contenteditable=false" in between target and anchor.
    // Also check the property, since contenteditable="false" is possible
    const closestContentEditableFromAnchor = anchor.closest('[contenteditable]');
    const closestContentEditableFromTarget = target.closest('[contenteditable]');
    if ($1262eee5c487dee7$var$isContentEditable(closestContentEditableFromAnchor) || $1262eee5c487dee7$var$isContentEditable(closestContentEditableFromTarget)) return;
    const noGlobalAnchorHandler = target.closest('[data-no-global-anchor-handler]');
    if (noGlobalAnchorHandler) return;
    // Only handle anchors with relevant targets
    if (anchor.target && anchor.target !== '_self') return;
    const { href: href } = anchor;
    if (!href) return;
    // CONFCLOUD-69367
    // skip copy page legacy to allow user to edit page title
    // CEMS-1140
    // skip create page legacy to allow user to create a page using newer working fabric creation
    if (!routesContext || typeof routesContext.matchRoute !== 'function') return;
    const match = routesContext.matchRoute(href);
    if (match && (match.name === (0, $0d518026f9d519cf$export$b010f02787df1e6).name || match.name === (0, $0d518026f9d519cf$export$e52245e856f5c06).name)) return;
    return {
        href: href
    };
}
function $1262eee5c487dee7$var$preloadRouteOnMouseDown(_, { preloadRoute: preloadRoute }, { href: href }) {
    preloadRoute(href);
}
function $1262eee5c487dee7$var$preloadRouteOnMouseHover(_, { preloadRoute: preloadRoute }, { href: href, ...preloadOptions }) {
    preloadRoute(href, preloadOptions);
}
function $1262eee5c487dee7$var$spaTransitionOnAnchorClick(e, { push: push }, { href: href }) {
    e.preventDefault();
    push(href, Boolean((0, $0d518026f9d519cf$export$d593e642a326a501).match(window.location.pathname)));
}
function $1262eee5c487dee7$var$useAnchorEventListener(type, anchorEventListener, useCapture) {
    const $ = (0, $ebfe460bd680287b$exports.c)(8);
    const routesContext = (0, $2hRE7.useContext)((0, $4b72a15528d34979$export$779e8f71c6bb38c));
    let t0;
    if ($[0] !== anchorEventListener || $[1] !== routesContext) {
        t0 = $1262eee5c487dee7$var$createAnchorEventListener(anchorEventListener, routesContext);
        $[0] = anchorEventListener;
        $[1] = routesContext;
        $[2] = t0;
    } else t0 = $[2];
    const eventListener = t0;
    let t1;
    let t2;
    if ($[3] !== eventListener || $[4] !== type || $[5] !== useCapture) {
        t1 = ()=>{
            if (eventListener) window.addEventListener(type, eventListener, useCapture);
            return ()=>{
                if (eventListener) window.removeEventListener(type, eventListener, useCapture);
            };
        };
        t2 = [
            eventListener,
            type,
            useCapture
        ];
        $[3] = eventListener;
        $[4] = type;
        $[5] = useCapture;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    (0, $2hRE7.useEffect)(t1, t2);
}




var $2hRE7 = parcelRequire("2hRE7");
const $32f18ec2049bb41d$var$GlobalPromptContext = /*#__PURE__*/ (0, $2hRE7.createContext)(null);
const $32f18ec2049bb41d$export$71d99832f5dd52ec = ()=>{
    return (0, $2hRE7.useContext)($32f18ec2049bb41d$var$GlobalPromptContext);
};
const $32f18ec2049bb41d$export$a082affa499ae96f = (t0)=>{
    const $ = (0, $ebfe460bd680287b$exports.c)(5);
    const { children: children, globalPromptHandler: globalPromptHandler } = t0;
    let t1;
    if ($[0] !== globalPromptHandler) {
        t1 = {
            globalPromptHandler: globalPromptHandler
        };
        $[0] = globalPromptHandler;
        $[1] = t1;
    } else t1 = $[1];
    const contextValue = t1;
    let t2;
    if ($[2] !== children || $[3] !== contextValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($32f18ec2049bb41d$var$GlobalPromptContext.Provider, {
            value: contextValue
        }, children);
        $[2] = children;
        $[3] = contextValue;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};



class $b7f189155d041ca2$export$aea2bc6590a5ea49 {
    /**
   * Registers a prompt string with its associated callback function.
   * This should be used in place of react-router's Prompt functionality. When registered, the callback
   * will be executed on every route change attempt, blocking the route change (the transition).
   *
   * The callback should return:
   * - true to show the prompt and block navigation
   * - false to allow navigation without prompting
   *
   * User interaction flow:
   * - If callback returns true, the user will see a browser confirmation dialog (window.confirm) with the provided message.
   * - If user clicks "OK", the route change continues and the prompt is automatically cleared.
   * - If user clicks "Cancel", the route change is prevented and the prompt remains active.
   * - If the route change is successful even if prompt wasn't shown, the prompt state is cleared automatically.
   *
   * Technical Reminders:
   * - When registering a prompt, ensure your implementation clears the prompt if it is no longer needed, by invoking clear().
   * - There can only be a maximum of one prompt registered at a time. Ensure your code flow won't conflict with existing use cases of registerPrompt.
   *
   * @param {Object} params - The parameters for the prompt registration.
   * @param {string} params.promptString - The message displayed in the browser confirmation dialog.
   * @param {PromptCallback} params.callback - A function that receives route transition info and returns true to show the confirmation dialog, false to allow navigation without prompting.
   */ registerPrompt({ promptString: promptString, callback: callback, onConfirm: onConfirm, onCancel: onCancel }) {
        this.promptString = promptString;
        this.promptCallback = callback;
        this.onConfirm = onConfirm ?? null;
        this.onCancel = onCancel ?? null;
    }
    /**
   * Clears the currently stored prompt string and callback, resetting the handler state.
   * This is done automatically on successful route change, but you should invoke it if you registered the prompt and no longer need it.
   */ clear() {
        this.promptString = null;
        this.promptCallback = null;
        this.onConfirm = null;
        this.onCancel = null;
    }
    /**
   * Gets the current prompt string if it exists and the callback returns true.
   *
   * @param {Object} args - The route transition arguments.
   * @param {RouteMatch | null} args.previousMatch - The previous route match.
   * @param {RouteMatch} args.nextMatch - The next route match.
   * @returns {string | null} The prompt string if conditions are met, null otherwise.
   */ getPromptString(args) {
        if (!this.promptString || !this.promptCallback) return null;
        try {
            const shouldPrompt = this.promptCallback({
                previousMatch: args.previousMatch,
                nextMatch: args.nextMatch
            });
            return shouldPrompt ? this.promptString : null;
        } catch (error) {
            this.logger.error`Error executing prompt callback: ${error}`;
            return null;
        }
    }
    /**
   * Triggers the prompt if it exists and the prompt callback returns true.
   *
   * @param {Object} args - The route transition arguments.
   * @param {RouteMatch | null} args.previousMatch - The previous route match.
   * @param {RouteMatch} args.nextMatch - The next route match.
   * @returns {Object} Returns {isPromptBlocking: true} if transition should be blocked because prompt was shown and user canceled,
   *                   otherwise returns {isPromptBlocking: false}
   */ triggerPrompt({ previousMatch: previousMatch, nextMatch: nextMatch }) {
        if (!this.promptString) return {
            isPromptBlocking: false
        };
        const promptString = this.getPromptString({
            previousMatch: previousMatch,
            nextMatch: nextMatch
        });
        if (promptString) {
            const userConfirmed = window.confirm(promptString);
            if (userConfirmed) {
                this.onConfirm?.();
                this.clear();
            } else {
                this.onCancel?.();
                // User cancelled, block the transition
                return {
                    isPromptBlocking: true
                };
            }
        }
        return {
            isPromptBlocking: false
        };
    }
    constructor(){
        this.logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('GlobalPromptHandler');
        this.promptString = null;
        this.promptCallback = null;
        this.onConfirm = null;
        this.onCancel = null;
    }
}





var $9pfwj = parcelRequire("9pfwj");

var $2hRE7 = parcelRequire("2hRE7");

var $2hRE7 = parcelRequire("2hRE7");
var $f94ec84aff009c97$exports = {};
'use strict';

$f94ec84aff009c97$exports = (parcelRequire("lsyzF"));



var $2hRE7 = parcelRequire("2hRE7");
const $e7517792ea7ee375$var$supports = {
    scheduling () {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $e7517792ea7ee375$export$2e2bcd8739ae039 = $e7517792ea7ee375$var$supports;



var $2hRE7 = parcelRequire("2hRE7");
const $0efdecc2b90ebd14$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $0efdecc2b90ebd14$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))),
    devtools: false,
    middlewares: new Set(),
    mutator: $0efdecc2b90ebd14$var$defaultMutator
};
var $0efdecc2b90ebd14$export$2e2bcd8739ae039 = $0efdecc2b90ebd14$var$defaults;


const $2c3b37a4c34aedfc$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $2c3b37a4c34aedfc$var$warnings = new WeakMap();
const $2c3b37a4c34aedfc$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $0efdecc2b90ebd14$export$2e2bcd8739ae039).devtools ? $2c3b37a4c34aedfc$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$2c3b37a4c34aedfc$var$warnings.has(actionFn)) $2c3b37a4c34aedfc$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $2c3b37a4c34aedfc$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $2c3b37a4c34aedfc$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};



// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $cce02e2c19fc03df$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $cce02e2c19fc03df$var$CACHE = new WeakMap();
function $cce02e2c19fc03df$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = '' + objA;
        const strB = '' + objB;
        if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
         // do object comparison
        let keysA;
        if ($cce02e2c19fc03df$var$CACHE.has(objA)) keysA = $cce02e2c19fc03df$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $cce02e2c19fc03df$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($cce02e2c19fc03df$var$CACHE.has(objB)) keysB = $cce02e2c19fc03df$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $cce02e2c19fc03df$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$cce02e2c19fc03df$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}


const $45f45c9d904aaecb$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $cce02e2c19fc03df$export$2e2bcd8739ae039)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $45f45c9d904aaecb$export$2e2bcd8739ae039 = $45f45c9d904aaecb$var$updateMiddleware;


const $23f942e26bec0fc1$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $45f45c9d904aaecb$export$2e2bcd8739ae039)).reduceRight((next, mw)=>mw(storeState)(next), (0, $0efdecc2b90ebd14$export$2e2bcd8739ae039).mutator);
var $23f942e26bec0fc1$export$2e2bcd8739ae039 = $23f942e26bec0fc1$var$applyMiddleware;



const $8f32e8f63de21a21$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === 'ACTION') {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $8f32e8f63de21a21$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $0efdecc2b90ebd14$export$2e2bcd8739ae039).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $0efdecc2b90ebd14$export$2e2bcd8739ae039).devtools === 'function' ? (0, $0efdecc2b90ebd14$export$2e2bcd8739ae039).devtools(storeState) : {};
                        devTools = $8f32e8f63de21a21$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $8f32e8f63de21a21$export$2e2bcd8739ae039 = $8f32e8f63de21a21$var$withDevtools;




/* eslint-disable import/no-unresolved */ 

var $iZu5g = parcelRequire("iZu5g");


let $8607a543b7f2754b$var$isInsideBatchedSchedule = false;
function $8607a543b7f2754b$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $0efdecc2b90ebd14$export$2e2bcd8739ae039).batchUpdates || !(0, $e7517792ea7ee375$export$2e2bcd8739ae039).scheduling() || $8607a543b7f2754b$var$isInsideBatchedSchedule) return (0, $766861cd6455b608$exports.unstable_batchedUpdates)(fn);
    $8607a543b7f2754b$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $iZu5g.unstable_scheduleCallback)((0, $iZu5g.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $766861cd6455b608$exports.unstable_batchedUpdates)(fn);
        $8607a543b7f2754b$var$isInsideBatchedSchedule = false;
    });
}



const $af1a8514d5f017f4$var$QUEUE = [];
let $af1a8514d5f017f4$var$scheduled;
function $af1a8514d5f017f4$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $0efdecc2b90ebd14$export$2e2bcd8739ae039).batchUpdates || !(0, $e7517792ea7ee375$export$2e2bcd8739ae039).scheduling()) return (0, $8607a543b7f2754b$export$712ea50be43a7858)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$af1a8514d5f017f4$var$QUEUE.includes(fn)) $af1a8514d5f017f4$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($af1a8514d5f017f4$var$scheduled) return;
    $af1a8514d5f017f4$var$scheduled = (0, $8607a543b7f2754b$export$712ea50be43a7858)(()=>{
        let queueFn;
        while(queueFn = $af1a8514d5f017f4$var$QUEUE.shift())queueFn();
        $af1a8514d5f017f4$var$scheduled = null;
    });
}


function $7159e15eb1ce665a$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $af1a8514d5f017f4$export$2e2bcd8739ae039)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $23f942e26bec0fc1$export$2e2bcd8739ae039)(storeState, (0, $0efdecc2b90ebd14$export$2e2bcd8739ae039).middlewares);
    return storeState;
}
var $7159e15eb1ce665a$export$2e2bcd8739ae039 = (0, $8f32e8f63de21a21$export$2e2bcd8739ae039)($7159e15eb1ce665a$var$createStoreState);


const $2f0f3bd15d73cd4e$export$e4d628ba0054221b = '__global__';
class $2f0f3bd15d73cd4e$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $2f0f3bd15d73cd4e$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $e7517792ea7ee375$export$2e2bcd8739ae039).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $7159e15eb1ce665a$export$2e2bcd8739ae039)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $2c3b37a4c34aedfc$export$5ee1d46cd0883a22)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $2f0f3bd15d73cd4e$export$9d726ae4880b1060 = new $2f0f3bd15d73cd4e$export$acb47f32da33501e();


const $b0e8c1a319ac8eb3$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createContext({
    globalRegistry: (0, $2f0f3bd15d73cd4e$export$9d726ae4880b1060),
    retrieveStore: (Store)=>(0, $2f0f3bd15d73cd4e$export$9d726ae4880b1060).getStore(Store)
}, ()=>0);



function $873a4af3fe1c299d$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $873a4af3fe1c299d$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $cce02e2c19fc03df$export$2e2bcd8739ae039)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$873a4af3fe1c299d$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $873a4af3fe1c299d$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $873a4af3fe1c299d$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $cce02e2c19fc03df$export$2e2bcd8739ae039)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}


function $d56a155665a5dd95$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $873a4af3fe1c299d$export$2e2bcd8739ae039)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $873a4af3fe1c299d$export$2e2bcd8739ae039)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $d56a155665a5dd95$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $d56a155665a5dd95$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $d56a155665a5dd95$var$cache = new WeakMap();
function $d56a155665a5dd95$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$d56a155665a5dd95$var$cache.has(storeState)) $d56a155665a5dd95$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $d56a155665a5dd95$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $d56a155665a5dd95$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $d56a155665a5dd95$export$d2c200d79fc82f8c(selector);
}


const $d53ed9edca27b0ea$var$EMPTY_SELECTOR = ()=>undefined;
const $d53ed9edca27b0ea$var$DEFAULT_SELECTOR = (state)=>state;
function $d53ed9edca27b0ea$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $2hRE7.useContext)((0, $b0e8c1a319ac8eb3$export$841858b892ce1f4c));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $2hRE7.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $2hRE7.useMemo)(()=>selector ? (0, $d56a155665a5dd95$export$38d24f3c60944dd5)(selector, storeState, hasPropsArg) : selector === null ? $d53ed9edca27b0ea$var$EMPTY_SELECTOR : $d53ed9edca27b0ea$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $2hRE7.useState)({})[1];
        const getSnapshot = (0, $2hRE7.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $f94ec84aff009c97$exports.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $d53ed9edca27b0ea$export$7c643e1d6648e418(Store) {
    const useHook = $d53ed9edca27b0ea$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $d53ed9edca27b0ea$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $d53ed9edca27b0ea$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}


var $2hRE7 = parcelRequire("2hRE7");




const $2e2c19f4a3ffbadf$var$_excluded = [
    "children"
], $2e2c19f4a3ffbadf$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $2e2c19f4a3ffbadf$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $2e2c19f4a3ffbadf$var$noop = ()=>()=>{};
function $2e2c19f4a3ffbadf$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $2e2c19f4a3ffbadf$var$noop, onUpdate: onUpdate = $2e2c19f4a3ffbadf$var$noop, onCleanup: onCleanup = $2e2c19f4a3ffbadf$var$noop, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $2e2c19f4a3ffbadf$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $2e2c19f4a3ffbadf$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $2e2c19f4a3ffbadf$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $2e2c19f4a3ffbadf$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $2e2c19f4a3ffbadf$var$createFunctionContainer(StoreOrOptions);
}
function $2e2c19f4a3ffbadf$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $2hRE7.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $2f0f3bd15d73cd4e$export$acb47f32da33501e)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $2e2c19f4a3ffbadf$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $2hRE7.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $2hRE7.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $2c3b37a4c34aedfc$export$5ee1d46cd0883a22)(Store.actions, storeState, config);
            const handlers = (0, $2c3b37a4c34aedfc$export$5ee1d46cd0883a22)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $2e2c19f4a3ffbadf$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $2hRE7.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $2hRE7.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $2e2c19f4a3ffbadf$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $2e2c19f4a3ffbadf$var$_objectWithoutPropertiesLoose(props, $2e2c19f4a3ffbadf$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $2e2c19f4a3ffbadf$var$_objectWithoutPropertiesLoose(restProps, $2e2c19f4a3ffbadf$var$_excluded2);
        const ctx = (0, $2hRE7.useContext)((0, $b0e8c1a319ac8eb3$export$841858b892ce1f4c));
        const registry = $2e2c19f4a3ffbadf$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $2hRE7.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $2e2c19f4a3ffbadf$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $2e2c19f4a3ffbadf$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $cce02e2c19fc03df$export$2e2bcd8739ae039)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $2hRE7.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate == null ? void 0 : containedStore.handlers.onUpdate());
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]); // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $2hRE7.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe == null || unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            isGlobal,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $b0e8c1a319ac8eb3$export$841858b892ce1f4c).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($f82042903f236546$exports))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($f82042903f236546$exports))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($f82042903f236546$exports))).bool
    };
    return FunctionContainer;
}

/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $4cdbd509489e5aa8$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}


function $4f5de533a8def912$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $4cdbd509489e5aa8$export$2e2bcd8739ae039)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function $4f5de533a8def912$export$f51a9068ac82ea43(_ref) {
    let { name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $4f5de533a8def912$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}


const $c4deb061e2368b0a$var$_excluded = [
    "children"
];
function $c4deb061e2368b0a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c4deb061e2368b0a$var$hasAdditionalProps(props) {
    for(let i in props)return true;
    return false;
}
function $c4deb061e2368b0a$export$48f338a7e080595c(Store, _temp) {
    let { selector: selector, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    const useStore = (0, $d53ed9edca27b0ea$export$e7f733c8fc2b8a24)(Store, {
        selector: selector
    });
    const Subscriber = function Subscriber(_ref) {
        let { children: children } = _ref, rest = $c4deb061e2368b0a$var$_objectWithoutPropertiesLoose(_ref, $c4deb061e2368b0a$var$_excluded);
        const api = useStore($c4deb061e2368b0a$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split('__')[0]})`;
    return Subscriber;
}





// The UFORouteName object is a global singleton
const $852b065d3d52ea04$var$UFORouteName = {
    current: null
};
var $852b065d3d52ea04$export$2e2bcd8739ae039 = $852b065d3d52ea04$var$UFORouteName;


/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Preserves the existing UUID implementation.




/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $2hRE7 = parcelRequire("2hRE7");




// We use a context to allow modals to have their own lifecycle
const $f08dd61424339858$var$interactionContext = (0, $2hRE7.createContext)((0, $056559c8228a75c5$export$2e2bcd8739ae039));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f08dd61424339858$export$2e2bcd8739ae039 = $f08dd61424339858$var$interactionContext;





const $c22168171aea9fd6$export$8851ca06c4e629aa = 'awaiting_pageload_name';
function $c22168171aea9fd6$var$traceUFOPageLoad(ufoName, routeName = ufoName) {
    if (!(0, $d0427bdd60d98885$export$74bdb753f1cf4860)()) return;
    const activeInteraction = (0, $fa77cab6e7101561$export$2b3954d2e8509985)();
    if (activeInteraction && !ufoName) return;
    (0, $852b065d3d52ea04$export$2e2bcd8739ae039).current = routeName || null;
    const rate = ufoName ? (0, $d0427bdd60d98885$export$9466a8f085fa7d4e)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $e652262e1c536287$export$2e2bcd8739ae039)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $b9a40c449374f876$exports.v4)();
        (0, $056559c8228a75c5$export$2e2bcd8739ae039).current = newId;
        (0, $fa77cab6e7101561$export$1a1ed1e1fdb2006b)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $3f9dbb98c6868de1$export$b6ac780db3a3cc77)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $fa77cab6e7101561$export$10582acd678c213)(newId, [], $c22168171aea9fd6$export$8851ca06c4e629aa, $c22168171aea9fd6$export$8851ca06c4e629aa, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $fa77cab6e7101561$export$5def58af4fd46132)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $fa77cab6e7101561$export$f6f1cf5bedf83c71)(ufoName, routeName);
        (0, $fa77cab6e7101561$export$4983dfbbb996f7ae)(activeInteraction.id, $c22168171aea9fd6$export$8851ca06c4e629aa);
    }
}
var $c22168171aea9fd6$export$2e2bcd8739ae039 = $c22168171aea9fd6$var$traceUFOPageLoad;


function $489307b95102fc00$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    if (!(0, $d0427bdd60d98885$export$74bdb753f1cf4860)()) return;
    const interaction = (0, $fa77cab6e7101561$export$2b3954d2e8509985)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $d0427bdd60d98885$export$9466a8f085fa7d4e)(ufoName, 'page_load');
        (0, $fa77cab6e7101561$export$f6f1cf5bedf83c71)(ufoName, routeName);
        if ((0, $e652262e1c536287$export$2e2bcd8739ae039)(rate)) (0, $852b065d3d52ea04$export$2e2bcd8739ae039).current = ufoName;
        else (0, $fa77cab6e7101561$export$5def58af4fd46132)(interaction.id, 'excluded_by_sampling');
    }
    (0, $fa77cab6e7101561$export$4983dfbbb996f7ae)(interaction.id, (0, $c22168171aea9fd6$export$8851ca06c4e629aa));
}


const $a55430c99df8268f$var$nullNoop = ()=>null;
const $a55430c99df8268f$var$objNoop = ()=>({});
const $a55430c99df8268f$var$stringNoop = ()=>'';
const $a55430c99df8268f$var$voidNoop = ()=>{};
const $a55430c99df8268f$var$RouteStore = (0, $4f5de533a8def912$export$f51a9068ac82ea43)({
    initialState: {
        getHref: $a55430c99df8268f$var$stringNoop,
        history: null,
        location: null,
        match: null,
        transitionId: null,
        toUrl: $a55430c99df8268f$var$stringNoop,
        matchRoute: $a55430c99df8268f$var$nullNoop,
        matchSupportedRoute: $a55430c99df8268f$var$nullNoop,
        getQueryParams: $a55430c99df8268f$var$objNoop,
        setQueryParams: $a55430c99df8268f$var$voidNoop,
        getHash: $a55430c99df8268f$var$stringNoop,
        setHash: $a55430c99df8268f$var$voidNoop,
        replace: $a55430c99df8268f$var$voidNoop,
        routes: [],
        push: $a55430c99df8268f$var$voidNoop,
        open: $a55430c99df8268f$var$nullNoop,
        onPageReload: $a55430c99df8268f$var$voidNoop,
        preloadRoute: $a55430c99df8268f$var$voidNoop
    },
    actions: {
        push (...args) {
            return ({ getState: getState })=>getState().push(...args);
        },
        replace (...args) {
            return ({ getState: getState })=>getState().replace(...args);
        },
        setQueryParams: (query, replace)=>({ getState: getState })=>getState().setQueryParams(query, replace),
        setHash: (hash)=>({ getState: getState })=>getState().setHash(hash),
        getLatestRouteData: ()=>({ getState: getState })=>{
                const match = getState().match;
                return {
                    routeName: match?.name,
                    routeParams: match?.params ?? {},
                    hash: getState().location?.hash?.substring(1) ?? '',
                    href: getState().getHref(),
                    queryParams: (0, $9pfwj.parse)(getState().location?.search ?? '', true)?.query,
                    toUrl: match?.toUrl?.bind(match) ?? function() {
                        return '';
                    }
                };
            },
        overrideUFORouteName: (newName)=>({ getState: getState })=>{
                (0, $489307b95102fc00$export$d0f99433cd4f4028)(newName, getState().match?.name);
            },
        preloadRoute: (matchOrUrl, options)=>({ getState: getState })=>getState().preloadRoute(matchOrUrl, options)
    },
    name: 'RouteState'
});
const $a55430c99df8268f$export$52c04f66b1983f2a = (0, $2e2c19f4a3ffbadf$export$26ae5ca175b4ec5a)($a55430c99df8268f$var$RouteStore, {
    onInit: ()=>({ setState: setState }, routeState)=>{
            setState(routeState);
        },
    onUpdate: ()=>({ setState: setState }, routeState)=>{
            setState(routeState);
        }
});
const $a55430c99df8268f$export$d4f74eb8532c85b4 = (0, $c4deb061e2368b0a$export$48f338a7e080595c)($a55430c99df8268f$var$RouteStore);
/**
 * `useAllRouteActions` exposes all RouteState actions for internal use.
 * This is used to limit which route actions are publicly exposed.
 */ const $a55430c99df8268f$var$useAllRouteActions = (0, $d53ed9edca27b0ea$export$7c643e1d6648e418)($a55430c99df8268f$var$RouteStore);
const $a55430c99df8268f$export$2467ee40aa778f80 = ()=>{
    const $ = (0, $ebfe460bd680287b$exports.c)(7);
    const { push: push, replace: replace, setQueryParams: setQueryParams, setHash: setHash, overrideUFORouteName: overrideUFORouteName, preloadRoute: preloadRoute } = $a55430c99df8268f$var$useAllRouteActions();
    let t0;
    if ($[0] !== overrideUFORouteName || $[1] !== preloadRoute || $[2] !== push || $[3] !== replace || $[4] !== setHash || $[5] !== setQueryParams) {
        t0 = {
            push: push,
            replace: replace,
            setQueryParams: setQueryParams,
            setHash: setHash,
            overrideUFORouteName: overrideUFORouteName,
            preloadRoute: preloadRoute
        };
        $[0] = overrideUFORouteName;
        $[1] = preloadRoute;
        $[2] = push;
        $[3] = replace;
        $[4] = setHash;
        $[5] = setQueryParams;
        $[6] = t0;
    } else t0 = $[6];
    return t0;
};
const $a55430c99df8268f$export$a434162a7524cfb3 = (routeParam)=>(0, $d53ed9edca27b0ea$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
        selector: (state)=>state?.match?.params?.[routeParam]
    });
const $a55430c99df8268f$export$a3421b85303fa9de = (queryParam)=>$a55430c99df8268f$export$a7bf969075a175d2(queryParam, (parseResult)=>$a55430c99df8268f$var$singleQueryParamParser(parseResult));
const $a55430c99df8268f$export$2c2c4e775b5e6393 = (queryParam)=>$a55430c99df8268f$export$a7bf969075a175d2(queryParam, (parseResult)=>{
        if (parseResult === '') return [];
        else if (typeof parseResult === 'string') return [
            parseResult
        ];
        return parseResult;
    });
const $a55430c99df8268f$export$a7bf969075a175d2 = (queryParam, customParser)=>(0, $d53ed9edca27b0ea$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
        selector: (state)=>{
            const parseResult = (0, $9pfwj.parse)(state.location?.search ?? '', true)?.query?.[queryParam];
            return customParser(parseResult);
        }
    });
const $a55430c99df8268f$export$b1482fdc3ffb1b4a = (0, $d53ed9edca27b0ea$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state)=>{
        const hash = state.location?.hash;
        return hash ? hash.substring(1) : '';
    }
});
const $a55430c99df8268f$export$244d8f2aa1ab504f = (0, $d53ed9edca27b0ea$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state, { selector: selector })=>{
        return selector(state.match?.url);
    }
});
const $a55430c99df8268f$export$30aadaab39fae199 = (0, $d53ed9edca27b0ea$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state, { selector: selector })=>{
        return selector(state.match?.name);
    }
});
function $a55430c99df8268f$var$singleQueryParamParser(parseResult) {
    return Array.isArray(parseResult) ? parseResult?.[0] : parseResult;
}
function $a55430c99df8268f$export$85e000103cdf6a77(route) {
    const $ = (0, $ebfe460bd680287b$exports.c)(2);
    let t0;
    if ($[0] !== route) {
        t0 = {
            selector: (matchName)=>matchName === route.name
        };
        $[0] = route;
        $[1] = t0;
    } else t0 = $[1];
    return $a55430c99df8268f$export$30aadaab39fae199(t0);
}
const $a55430c99df8268f$export$c9f0d094e50e1bbc = ()=>{
    const { getLatestRouteData: getLatestRouteData } = $a55430c99df8268f$var$useAllRouteActions();
    return (0, $2hRE7.useMemo)(()=>({
            get current () {
                return getLatestRouteData();
            }
        }), [
        getLatestRouteData
    ]);
};
const $a55430c99df8268f$export$7926129229271134 = (0, $d53ed9edca27b0ea$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state)=>state.transitionId ?? 0
});
const $a55430c99df8268f$export$632429935326e9d2 = (0, $d53ed9edca27b0ea$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state)=>!!state.transitionId
});
const $a55430c99df8268f$export$3420e1dc2c4a518c = (0, $d53ed9edca27b0ea$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state)=>state.history
});
const $a55430c99df8268f$export$d2ec911fa7f74821 = (0, $d53ed9edca27b0ea$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state)=>state.matchRoute
});
const $a55430c99df8268f$export$ce9ea1d788472f7b = (0, $d53ed9edca27b0ea$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state, { selector: selector })=>{
        return selector(state.location?.pathname);
    }
});



var $aLoS2 = parcelRequire("aLoS2");


class $e7d32f2c649e2db9$export$46a841557056026b extends Error {
    constructor(message){
        super(message);
        this.name = 'ExternalRejectionError';
    }
}
class $e7d32f2c649e2db9$export$2f8f0e0ec8218c4b {
    /**
   * Registers a transition callback that will be awaited on a route change.
   * The callback will only be invoked if the `onlyCalledIfFunc` returns true or if `onlyCalledIfFunc` is not provided. e.g. To check that a contentId is what you expect it should be. `onlyCalledIfFunc` should be very performant as it will run every route change.
   *
   * PERFORMANCE WARNING: `onlyCalledIfFunc` is executed every route change, and `callback` promise is awaited every time `onlyCalledIfFunc` returns `true` (or if it doesn't exist).
   *                      If either of these functions are not very performant, it could cause undesirable performance degradation on every transition.
   *                      Try to avoid any time-intensive invocations, especially in `onlyCalledIfFunc`. `onlyCalledIfFunc` ideally only runs a condition the `match` that it's passed, e.g. to check `match.params.contentId` or `match.pathname`.
   *                      BEFORE REGISTERING A NEW TRANSITION CALLBACK, you must be confident that the negative performance impact is acceptable.
   *
   * @example registerTransitionCallback({
   *     id: 'unique-id-related-to-my-code',
   *     callback: ({match}) => {
   *         // Do preloading logic, must return a promise
   *         return new Promise((resolve) => {
   *             const nextContentId = match.params?.contentId;
   *             // do logic that is a hard pre-requisite for next route and cannot be lazy/concurrently loaded, ideally shouldn't be slow
   *             resolve(); // route change gets unblocked after these callback promises are resolved
   *         }
   *     },
   *     onlyCalledIfFunc: ({match}) => {
   *         // Optional but recommended
   *         const nextContentId = match.params?.contentId;
   *         // Do very quick logic, ideally no logic that we need to wait for, this function is run every route change
   *         if (isLiveDoc(contentId)) {
   *             return true;
   *         } else {
   *             return false;
   *         }
   *     },
   *     onPerformanceMetricStart: ({match}) => {
   *         // Optional but recommended
   *         const nextContentId = match.params?.contentId;
   *         // Should be used to quickly start any page load performance metrics that you want to track for this route change
   *         // If you don't use this, your existing page load metric will likely start after the preloading and after the route change.
   *         // We want page load metrics to start before preloading, not after.
   *     },
   *     onRouteContinueCallback: async ({match}) => {
   *		   // Optional, must return a promise (i.e. or be async)
   *         const nextContentId = match.params?.contentId;
   *         // Do very quick logic that will run only if we're about to transition routes, runs after callback promise.
   *         // Can be used to do logic that you want to ensure doesn't occur on outdated route changes, e.g. connecting to nextContentId's collab provider
   *     },
   * });
   *
   * @param {Object} params - The parameters for the transition callback.
   * @param {string} params.id - A unique identifier used to inform other components the callback was run, to clean up outdated promises, and to prevent duplicate callback registrations.
   * @param {TransitionCallback} params.callback - The callback function to be executed during a route transition. Must return a promise.
   * @param {OnlyCalledIfFunc} params.onlyCalledIfFunc - A function that determines whether the callback should be called.
   * @param {OnRouteContinueCallback} params.onRouteContinueCallback - Callback function that must return a promise. This is called right after the transition callback promises finish but before we continue the route transition, the returned promise blocks route transition. This function won't be called if route has changed before callback promise resolves.
   * @param {OnPerformanceMetricStartCallback} params.onPerformanceMetricStart - Callback function to start performance metrics. Called as we start running the transition callback promises.
   * @returns {boolean} - Returns `true` if the transition callback was registered, `false` if it was not registered (due to already being registered or being mid-transition).
   */ registerTransitionCallback({ id: id, callback: callback, onlyCalledIfFunc: onlyCalledIfFunc, onRouteContinueCallback: onRouteContinueCallback, onPerformanceMetricStart: onPerformanceMetricStart }) {
        // We want to keep transition callbacks unique to guarantee we aren't duplicating work, so we tie callbacks to an ID. If there are multiple registrations of the same callback ID, we ignore registration attempts if we're already registered.
        // We don't allow registering transition callbacks while transitioning, to avoid race conditions leading to infinite route change loops.
        if (this.transitionProcessingState !== 'not_processing' || this.callbacks.has(id)) return false;
        this.callbacks.set(id, {
            callback: callback,
            onlyCalledIfFunc: onlyCalledIfFunc,
            onRouteContinueCallback: onRouteContinueCallback,
            onPerformanceMetricStart: onPerformanceMetricStart
        });
        return true;
    }
    /**
   * Processes transition callbacks during a route change, checking if we need to create promises from callbacks, and waiting for them to resolve/reject before continuing the route change.
   * `processTransitionCallback` will set `this.isTransitionCallbackRunning` to true, preventing callback registration. RouteManager is responsible for clearing it via `onTransitionComplete`.
   *
   * @param {{ match: Match; onRouteContinue: () => void; transitionId: number; interactionContext?: UFOInteractionContextType | null }} args - The arguments containing the route `match` object, RouteManager `transitionId`, the `onRouteContinue` continuation function, and optional UFO interaction context.
   *                                                                                     `onRouteContinue` is called once promises resolve and should finish executing the route change.
   * @returns {boolean} - Returns `true` if processing transition callback and transition should not continue (until promise finishes and calls onRouteContinue).
   *                      Returns `false` if not processing transition callback and routeChangeHandler should continue running.
   */ processTransitionCallback({ match: match, transitionId: transitionId, onRouteContinue: onRouteContinue, interactionContext: interactionContext, startPageLoadMetrics: startPageLoadMetrics }) {
        try {
            if (!this.callbacks.size) {
                // Update latest route details to keep this.getCurrentRouteCallbackIds() is accurate. If transitionId has changed, accurately reflect that there are no callbackIds for that route change.
                if (transitionId !== this.currentRouteDetails.transitionId) this.currentRouteDetails = {
                    transitionId: transitionId,
                    callbackIds: [],
                    pathname: match?.pathname || ''
                };
                return {
                    isProcessingCallback: false
                };
            }
            this.transitionProcessingState = 'processing';
            const previousPathname = this.latestPathname;
            this.latestPathname = match?.pathname;
            if (this.latestPathname !== previousPathname) // Cancel all currently running promises because we're going to a different route. Helps prevent multiple quick route changes from causing race condition that could send user to outdated route change.
            // If needed, `getCallbackPromises` below will create new promises for the latest route.
            this.cancelActivePromises();
            const { callbackIds: callbackIds } = this.getCallbackIds({
                match: match
            });
            const { callbackPromises: callbackPromises, callbackPromiseIds: callbackPromiseIds, callbackPromiseObjects: callbackPromiseObjects } = this.getCallbackPromises({
                match: match,
                callbackIds: callbackIds
            });
            // Cancel outdated actively running promises that aren't for the latest callbackIds
            this.cleanupOutdatedCallbacks(callbackIds);
            if (!callbackPromises.length) {
                // If there are no callback promises, route change will immediately continue. Reset our callbacks state as we don't want registered callbacks to linger once the user leaves the route. Callbacks should be registered on page/etc load if needed.
                // EDGE CASE: If the user is on a live doc and quickly clicks a non-live-doc like a view page, then quickly clicks back into a live doc before the view page has loaded, the preload-live-doc callback may have been removed, slowing down load time into that live doc.
                //            We'll solve for this in the future by always checking if we should preload a live doc on any route change, by never unregistering that callback
                this.reset();
                return {
                    isProcessingCallback: false
                };
            }
            // Start browser metrics page load
            startPageLoadMetrics?.(match?.name ?? '', match?.ufoName, transitionId, match?.params?.contentId);
            // Ensure UFO page load metric continues tracking the page load from start of preloading. If we don't hold here, UFO metric finishes prematurely on route change.
            // We should stop holding right after the route change is completed.
            const ufoStopHold = interactionContext?.hold?.('GlobalTransitionPreloader');
            callbackPromiseObjects.forEach(({ onPerformanceMetricStart: onPerformanceMetricStart })=>{
                onPerformanceMetricStart?.({
                    match: match
                });
            });
            // Timeout for all promises to prevent indefinite waiting
            const TIMEOUT_MS = 10000; // 10 seconds
            // Flag to prevent race conditions between timeout and promise completion
            // Only one of them should trigger the route transition
            let hasRouteTransitionCompleted = false;
            // Set up timeout
            const timeoutId = setTimeout(()=>{
                // Only execute if route transition hasn't been completed by promise resolution
                if (!hasRouteTransitionCompleted) {
                    hasRouteTransitionCompleted = true;
                    this.logger.error`Callback promises timed out after ${TIMEOUT_MS}ms, forcing route transition`;
                    this.reset();
                    onRouteContinue();
                    (0, $b76dfd1db5681318$export$e9ba7ef9458d1a4a)().then((analyticsWebClient)=>{
                        analyticsWebClient.sendOperationalEvent({
                            action: 'confluence_live_doc_smooth_transition_timeout',
                            actionSubject: 'callback_promises_timed_out',
                            attributes: {
                                callbackPromiseIds: callbackPromiseIds.join(',')
                            },
                            source: 'GlobalTransitionPreloader'
                        });
                    });
                }
            }, TIMEOUT_MS);
            // Handle all the promises and then send the user to the next route if appropriate.
            Promise.allSettled(callbackPromises).then((promiseResults)=>{
                // Only proceed if timeout hasn't already triggered the route transition
                if (hasRouteTransitionCompleted) return;
                // Mark that we're handling the route transition to prevent timeout from also executing
                hasRouteTransitionCompleted = true;
                // Clear timeout if callbacks completed first
                clearTimeout(timeoutId);
                const onRouteContinueCallbacks = [];
                let externallyRejectedCount = 0;
                promiseResults.forEach((result, index)=>{
                    if (result.status === 'rejected') {
                        if (callbackPromiseObjects[index].isExternallyRejected) externallyRejectedCount++;
                        else this.logger.error`There was an error with a transition callback promise: ${result.reason}, active callbackPromiseIds: ${callbackPromiseIds.join(',')}`;
                    } else {
                        const { onRouteContinueCallback: onRouteContinueCallback } = callbackPromiseObjects[index];
                        if (onRouteContinueCallback) onRouteContinueCallbacks.push(onRouteContinueCallback);
                    }
                });
                if (externallyRejectedCount < callbackPromises.length) {
                    const onRouteContinueCallbackPromises = onRouteContinueCallbacks.map((callback)=>callback({
                            match: match
                        }));
                    // Only update state if most promises weren't externally rejected (indicating this is still the current transition)
                    this.currentRouteDetails.callbackIds = callbackPromiseIds;
                    this.currentRouteDetails.transitionId = transitionId;
                    this.currentRouteDetails.pathname = match?.pathname || '';
                    this.transitionProcessingState = 'processing_completed';
                    // On successful next route, we clear the currently registered callbacks. Callbacks should be registered on page/etc load if needed.
                    this.callbacks = new Map();
                    this.activelyRunningCallbackPromises = {};
                    Promise.allSettled(onRouteContinueCallbackPromises).then(()=>{
                        // If all promises have been externally rejected, that means these promises are for an outdated route change, the user has since changed routes again, so we don't want to redirect the user to the route.
                        // This avoids race condition scenarios where user goes from Doc A -> Doc B -> Doc C, but ends up on Doc B because its promises finished after Doc C's promises.
                        // On successful next route, we clear the currently registered callbacks. Callbacks should be registered on page/etc load if needed.
                        this.callbacks = new Map();
                        this.activelyRunningCallbackPromises = {};
                        onRouteContinue();
                    });
                }
            });
            return {
                isProcessingCallback: true,
                ufoStopHold: ufoStopHold ? ()=>ufoStopHold?.() : undefined
            };
        } catch (error) {
            this.logger.error`There was an error running processTransitionCallback: ${error}, registered callbackIds: ${Array.from(this.callbacks.keys()).join(',')}`;
        }
        return {
            isProcessingCallback: false
        };
    }
    /**
   * Retrieve callback IDs that ran on the current route. Can be useful to determine if your page was already preloaded or not.
   * Recommended to only run this if you are finished transitioning. If you may be mid-transition (unlikely unless using Prompt), use `getRouteCallbackIdsByMatch`.
   *
   * @returns {string[]} - List of registered transition callback IDs that ran on current route when transitioning into it
   */ getCurrentRouteCallbackIds() {
        return [
            ...this.currentRouteDetails.callbackIds
        ];
    }
    /**
   * Retrieve callback IDs that will be run on the specified match. This function looks at this.transitionProcessingState to determine which callback IDs to return.
   * Recommended to only run this if you may be mid-transition, otherwise `getCurrentRouteCallbackIds` is preferable.
   * Can be useful to determine if the match will be preloaded or not during transition, e.g. to determine whether a Prompt callback shows prompt.
   *
   * @returns {string[]} - List of registered transition callback IDs that will run speciifed match when transitioning into it
   */ getRouteCallbackIdsByMatch(match) {
        if (!match?.pathname) return [];
        /**
     *  - If GlobalTransitionPreloader.processTransitionCallback is processing the same match as the specified match:
     *    - If we're mid-transition ('processing'), we use the memoized callback IDs that were set when `processingTransitionCallback` called `getCallbackIds`.
     *      - If memoized callback IDs don't exist (e.g. calling this too quickly right after processingTransitionCallback is called), we fetch the callback IDs for the specified match.
     *    - If we're finished processing ('processing_completed') but haven't finished transitioning yet, we use the current route callback IDs.
     *
     *  - If the specified match is different from the match being processed, or if we are not processing a match ('not_processing'), then we fetch the callback IDs for the specified match.
     */ if (this.transitionProcessingState === 'processing' && this.cachedCallbackIds?.callbackIds && this.cachedCallbackIds?.pathname === match.pathname) return [
            ...this.cachedCallbackIds.callbackIds
        ];
        else if (this.transitionProcessingState === 'processing_completed' && this.currentRouteDetails.pathname === match.pathname) return [
            ...this.currentRouteDetails.callbackIds
        ];
        else return this.getCallbackIds({
            match: match
        }).callbackIds;
    }
    /**
   * Resets the preloader to its initial state by clearing all registered callbacks,
   * canceling any actively running promises, and resetting internal state.
   * This can be useful for cleanup or testing scenarios.
   */ reset() {
        this.cancelActivePromises();
        this.callbacks = new Map();
        this.activelyRunningCallbackPromises = {};
        this.latestPathname = '';
        this.currentRouteDetails.callbackIds = [];
        this.currentRouteDetails.pathname = '';
        this.cachedCallbackIds = null;
        // If we started processing, mark as processing completed. We only set to not_processing in onTransitionComplete, to disallow registering callbacks mid-transition.
        if (this.transitionProcessingState !== 'not_processing') this.transitionProcessingState = 'processing_completed';
    }
    /**
   * Router is responsible for running this function when the route has technically changed (routeChangeHandler).
   @param {number} transitionId - The transition ID of the route that has completed, coming from RouteManager
   */ onTransitionComplete(transitionId) {
        // When GlobalTransitionPreloader processes transition callbacks, it sets its transition running flag to true.
        // When it's done processing transition callbacks and the route has changed, we should clear the transition running flag.
        // This is used to prevent race conditions caused by problematic globalTransitionPreloader callback registrations during route changes.
        // For instance: If a callback is registered mid-transition, then when `routeBlockHandler` is called a second time by `onRouteContinue`,
        //               processTransitionCallback may try to process it after it has already processed it, leading to an infinite loop.
        this.transitionProcessingState = 'not_processing';
        this.cachedCallbackIds = null;
        // Transition ID from RouteManager is stored in this.currentRouteDetails before we call `routeChangeHandler`.
        // If we processed a transition callback, it'll always be one behind RouteManager
        // If transition IDs are misaligned and currentRouteDetails.callbackIds is non-empty, we're in an invalid state likely due to routeBlockHandler/processTransitionCallback unexpectedly not being triggered
        // If we're in this invalid state, reset the current route details callback IDs to prevent components from thinking we're in a preloaded state when we're not.
        if (this.currentRouteDetails.transitionId !== transitionId && this.currentRouteDetails.callbackIds.length > 0) {
            this.logger.error`GlobalTransitionPreloader is in an invalid state, transitionId mismatch, callbackIds are non-empty. Resetting callbackIds. Invalid callbackIds are: ${this.currentRouteDetails.callbackIds.join(',')}`;
            this.currentRouteDetails.callbackIds = [];
        }
    }
    /**
   * Generates an array of callback ids that should be processed before the next transition, filtering out
   * callbacks which are not supposed to run based on their `onlyCalledIfFunc` evaluation.
   * Caches most recent array of callback IDs as `this.cachedCallbackIds`
   * @param { match: Match } params The params for the method including the match object.
   * @returns { callbackIds: Array<string> } An object containing an array of callback ids that should be processed
   */ getCallbackIds({ match: match }) {
        const callbackIds = [];
        if (!this.callbacks.size) {
            this.cachedCallbackIds = {
                pathname: match.pathname,
                callbackIds: []
            };
            return {
                callbackIds: callbackIds
            };
        }
        this.callbacks.forEach(({ onlyCalledIfFunc: onlyCalledIfFunc }, callbackId)=>{
            // Call our `onlyCalledIfFunc` if it's set, we're only waiting for this callback promise if it's `true` or if it's not set.
            const isCallAllowed = onlyCalledIfFunc ? onlyCalledIfFunc({
                match: match
            }) : true;
            if (isCallAllowed) callbackIds.push(callbackId);
        });
        // Cache the result for the most recent invocation, may be fetched by `getRouteCallbackIdsByMatch` when we're mid-transition, avoids additional onlyCalledIfFunc calls.
        this.cachedCallbackIds = {
            pathname: match.pathname,
            callbackIds: [
                ...callbackIds
            ]
        };
        return {
            callbackIds: callbackIds
        };
    }
    /**
   * Creates an array of promises from registered callbacks that should be executed
   * during a route transition. This method checks conditions under which each callback
   * should be called and manages the lifecycle of the promises.
   * Will clean up outdated promises.
   *
   * @private
   * @param { match: Match, callbackIds: Array<string> } params - The parameters for the method, containing the match object and callback IDs.
   * @returns { callbackPromises: Array<Promise<void>>, callbackPromiseIds: Array<string> } An object containing an array of promises and their corresponding IDs.
   */ getCallbackPromises({ match: match, callbackIds: callbackIds }) {
        const callbackPromises = [];
        const callbackPromiseIds = []; // Recommendation is to use this to help provide context to promise errors
        const callbackPromiseObjects = [];
        callbackIds.forEach((callbackId)=>{
            const callbackConfig = this.callbacks.get(callbackId);
            if (!callbackConfig) return; // This should never happen
            const { callback: callback, onRouteContinueCallback: onRouteContinueCallback, onPerformanceMetricStart: onPerformanceMetricStart } = callbackConfig;
            const activeCallbackPromise = this.activelyRunningCallbackPromises[callbackId];
            // If we want to trigger a callback promise, return the already running one if we have it, otherwise create a new one.
            if (activeCallbackPromise) {
                callbackPromises.push(activeCallbackPromise.promise);
                callbackPromiseIds.push(callbackId);
                callbackPromiseObjects.push(activeCallbackPromise);
            } else {
                // Start the promise and store the promise and its reject function in state (this.processTransitionCallback may call `reject` if the user changes route)
                let callbackPromiseReject;
                const callbackPromise = new Promise((resolve, reject)=>{
                    callbackPromiseReject = reject;
                    callback({
                        match: match
                    }).then(resolve).catch(reject);
                });
                callbackPromises.push(callbackPromise);
                callbackPromiseIds.push(callbackId);
                const callbackPromiseObject = {
                    promise: callbackPromise,
                    onRouteContinueCallback: onRouteContinueCallback,
                    onPerformanceMetricStart: onPerformanceMetricStart,
                    reject: (reason)=>callbackPromiseReject(new $e7d32f2c649e2db9$export$46a841557056026b(reason)),
                    isExternallyRejected: false
                };
                callbackPromiseObjects.push(callbackPromiseObject);
                this.activelyRunningCallbackPromises[callbackId] = callbackPromiseObject;
            }
        });
        return {
            callbackPromises: callbackPromises,
            callbackPromiseIds: callbackPromiseIds,
            callbackPromiseObjects: callbackPromiseObjects
        };
    }
    /**
   * Cancels all actively running callback promises by rejecting them and marking as externally rejected
   */ cancelActivePromises() {
        Object.entries(this.activelyRunningCallbackPromises).forEach(([callbackId, { reject: reject }])=>{
            reject();
            this.activelyRunningCallbackPromises[callbackId].isExternallyRejected = true;
            delete this.activelyRunningCallbackPromises[callbackId];
        });
    }
    /**
   * Cleans up any callback promises that are no longer valid for the current route.
   * @param validCallbackIds - The callback ids that are valid for the current route.
   */ cleanupOutdatedCallbacks(validCallbackIds) {
        Object.keys(this.activelyRunningCallbackPromises).forEach((activelyRunningCallbackId)=>{
            if (!validCallbackIds.includes(activelyRunningCallbackId)) {
                const activeCallbackPromise = this.activelyRunningCallbackPromises[activelyRunningCallbackId];
                if (activeCallbackPromise) {
                    activeCallbackPromise.reject?.();
                    activeCallbackPromise.isExternallyRejected = true;
                    delete this.activelyRunningCallbackPromises[activelyRunningCallbackId];
                }
            }
        });
    }
    constructor(){
        this.logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('GlobalTransitionPreloader');
        this.callbacks = new Map();
        this.activelyRunningCallbackPromises = {};
        this.latestPathname = '';
        this.currentRouteDetails = {
            transitionId: -1,
            callbackIds: [],
            pathname: ''
        };
        this.transitionProcessingState = 'not_processing';
        this.cachedCallbackIds = null;
    }
}


const $c22be97ab4c2d58d$export$9675c02ec7fc88a8 = (0, $aLoS2.default)(()=>{
    return new (0, $e7d32f2c649e2db9$export$2f8f0e0ec8218c4b)();
});


const $64a554d15bd769f3$var$NOOP = ()=>{};
function $64a554d15bd769f3$export$b6024a131a1561d9(routes, url) {
    // routes can be module from "import" which is not iterable
    const iterableRoutes = Object.values(routes);
    for (const route of iterableRoutes){
        if (!(route instanceof (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6))) continue;
        const match = route.match(url);
        if (match) // FIXME `route` is a `class` instance so it is not 100% safe to spread!
        // But we've been running with it for quite some time, we're not aware of
        // actual problems and I'm only discovering it now while translating to
        // TypeScript.
        //
        // @ts-ignore
        return {
            ...route,
            ...match
        };
    }
    return null;
}
const $64a554d15bd769f3$export$5050caba5e109cc4 = (queryParams)=>{
    const array = Object.entries(queryParams);
    return array.length ? array.reduce((accumulator, current, index)=>`${accumulator + current[0]}=${encodeURIComponent(current[1])}${index < array.length - 1 ? '&' : ''}`, '?') : '';
};
const $64a554d15bd769f3$var$routeActionHistoryMap = {
    PUSH: ({ location: location1, history: history })=>history.push(location1),
    REPLACE: ({ location: location1, history: history })=>history.replace(location1),
    POP: ({ history: history })=>history.go(-1)
};
class $64a554d15bd769f3$var$RouteManagerInner extends (0, $2hRE7.Component) {
    componentDidMount() {
        const { location: location1, history: history } = this.props;
        const initialMatch = this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`);
        let previousMatch = initialMatch;
        const routeChangeHandler = (location1, action)=>{
            // we de-structure `onTransition` prop here instead of in enclosing scope
            // because otherwise changes to `onTransition` props will be ignored (as this function
            // will have a "cached" version of it via closure).
            const { onTransition: onTransition } = this.props;
            // New logic determine if it is a transition by calling isTransition on route.
            const match = this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`);
            if (onTransition && match && match.isTransition(previousMatch, match)) {
                if (action === 'PUSH' || action === 'POP') this.transitionId++;
                onTransition(match, this.transitionId, action);
                // Clear any prompt on successful route change
                this.globalPromptHandler.clear();
                // Inform GlobalTransitionPreloader that the transition is complete, allowing app to continue registering GlobalTransitionPreloader callbacks.
                const globalTransitionPreloader = (0, $c22be97ab4c2d58d$export$9675c02ec7fc88a8)();
                globalTransitionPreloader.onTransitionComplete(this.transitionId);
                // Call the pending UFO stop hold function if it exists, then clear it to prevent multiple calls
                if (this.pendingUfoStopHold) {
                    this.pendingUfoStopHold();
                    this.pendingUfoStopHold = undefined;
                }
                // Delete the SSR streaming global on route navigation to prevent it from affecting
                // suspense boundary rendering decisions during client-side navigation
                if (typeof window !== 'undefined' && window.__SSR_REACT_STREAMING__) delete window.__SSR_REACT_STREAMING__;
            }
            previousMatch = match;
        };
        // Return false to cancel transition (route will not change). Otherwise transition continues. Does not support waiting for promises - if we need to do that we should return false and have the promise re-invoke the route change when ready.
        const routeBlockHandler = (location1, action)=>{
            try {
                const match = this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`);
                const isTransition = match && match.isTransition(previousMatch, match);
                if (isTransition) {
                    // Check for global prompt. (This replaces react-router's <Prompt> component)
                    const { isPromptBlocking: isPromptBlocking } = this.globalPromptHandler.triggerPrompt({
                        previousMatch: previousMatch,
                        nextMatch: match
                    });
                    if (isPromptBlocking) return false;
                    // Check if we have a transition callback promise that should resolve before continuing transition.
                    // Do not support POP (back/forward) - too many edge cases caused by trying to partially support it.
                    const globalTransitionPreloader = (0, $c22be97ab4c2d58d$export$9675c02ec7fc88a8)();
                    if (action !== 'POP') {
                        const isProcessingTransitionPromise = globalTransitionPreloader.processTransitionCallback?.({
                            match: match,
                            onRouteContinue: ()=>{
                                $64a554d15bd769f3$var$routeActionHistoryMap[action?.toUpperCase()]?.({
                                    location: location1,
                                    history: history
                                });
                            },
                            // transitionId 0 is reserved for initial page load, so we never want to pass it as we're transitioning.
                            // We add 1 to avoid erronously being treated as initial page load. Router state will also add 1 once transition finishes.
                            transitionId: this.transitionId + 1,
                            interactionContext: this.props.interactionContext,
                            startPageLoadMetrics: this.props.startPageLoadMetrics
                        });
                        if (isProcessingTransitionPromise.isProcessingCallback) {
                            // Store the ufoStopHold function to be called in routeChangeHandler
                            this.pendingUfoStopHold = isProcessingTransitionPromise.ufoStopHold;
                            return false;
                        }
                    } else // If user does POP action, reset global transition preloader to ensure no transition callbacks are processed.
                    globalTransitionPreloader.reset();
                }
            } catch  {
            // Everything in this function should have its own try-catch/error handling, but in case of an unexpected error, the user shouldn't be blocked from navigating.
            }
        };
        if (this.props.setBrowserHistoryListener) {
            // Ensure RouteManager's `listen` handler is called before the listen handler registered by ConnectedRouter and redux action
            this.unlistenToHistory = this.props.setBrowserHistoryListener(routeChangeHandler);
            if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_transition_preloading_system')) this.unlistenToHistoryBlock = history.block(routeBlockHandler);
        } else if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_transition_preloading_system')) this.unlistenToHistory = history.block((location1, action)=>{
            const routeBlockHandlerResult = routeBlockHandler(location1, action);
            if (routeBlockHandlerResult === false) return false;
            else routeChangeHandler(location1, action);
        });
        else this.unlistenToHistory = history.block(routeChangeHandler);
    }
    componentWillUnmount() {
        this.unlistenToHistory?.();
        this.unlistenToHistoryBlock?.();
    }
    mapRoutes(routeComponents) {
        const supportedRoutes = Object.keys(routeComponents);
        return supportedRoutes.map((name)=>{
            const route = this.getRoute(name);
            const mappedRoute = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
                name: route.name,
                ufoName: route.ufoName,
                pattern: route.pattern,
                condition: route.condition,
                isTransition: route.isTransition
            });
            // @ts-ignore FIXME Who's using `component` on "mapped" `Route`?
            mappedRoute['component'] = routeComponents[name];
            return mappedRoute;
        });
    }
    getRoute(name) {
        const { namedRoutes: namedRoutes } = this.props;
        const route = namedRoutes[name];
        if (!route) throw new Error(`Unknown route name: ${name}`);
        return route;
    }
    matchAndRenderComponent(match) {
        const { notFound: notFound, routeComponents: routeComponents } = this.props;
        if (match === null) return notFound ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement(notFound) : null;
        else {
            window.performance.mark('CFP-63.route-component-render');
            const memoizedComponent = this.memoizedRouteComponents.get(routeComponents[match.name]);
            return memoizedComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement(memoizedComponent, match) : null;
        }
    }
    getHref() {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        return location.pathname + location.search;
    }
    render() {
        const { children: children } = this.props;
        const routesContextValue = this.getRoutesContextValue();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $32f18ec2049bb41d$export$a082affa499ae96f), {
            globalPromptHandler: this.globalPromptHandler
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $a55430c99df8268f$export$52c04f66b1983f2a), routesContextValue, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $4b72a15528d34979$export$779e8f71c6bb38c).Provider, {
            value: routesContextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $bf8e248a69b7feca$export$4e7bc78665a3b140), null, this.matchAndRenderComponent(routesContextValue.match), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $2hRE7.Fragment), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $1262eee5c487dee7$export$cf1af05a5f90ab81), null)))));
    }
    constructor(props){
        super(props);
        this.pendingUfoStopHold = void 0;
        this.memoizedRouteComponents = new WeakMap();
        this.globalPromptHandler = new (0, $b7f189155d041ca2$export$aea2bc6590a5ea49)();
        // transitionId is incremented on every push/pop to distinguish a deliberate
        // user navigation from an automatic redirect (replace). An id of 0 indicates that
        // we are currently on the initial load.
        //
        // Ideally this would be in component state, since it is passed down through context,
        // and should trigger a re-render when changed.
        // However, we don't want to re-render with the updated value until the location
        // changes, which unfortunately is controlled by <ConnectedRouter>.
        // At the same time, this state cannot be purely derived from location changes,
        // since we need to look at the action that caused the update.
        // When we remove react-router and can make both state changes atomically then
        // this can move into component state alongside the current location.
        this.transitionId = 0;
        this.pendingQueryParams = {};
        /**
     * Mapping components to named routes
     */ this.routes = this.mapRoutes(this.props.routeComponents);
        this.toUrl = (name, params = {})=>{
            const href = params['href'];
            if (href) return href;
            if (!name) return '';
            const query = params.query || {};
            const hash = params.hash || '';
            return this.getRoute(name).toUrl(params, {
                query: query,
                hash: hash
            });
        };
        this.matchRoute = (url)=>{
            const { namedRoutes: namedRoutes } = this.props;
            return $64a554d15bd769f3$export$b6024a131a1561d9(namedRoutes, url);
        };
        this.matchSupportedRoute = (url)=>{
            const parsed = (0, $9pfwj.parse)(url);
            // Note here we are using location from window not from withRouter
            // history's location doesn't have host field
            // See https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/api/history.md
            //What is this doing?
            if (parsed.host && parsed.host !== window.location.host) return null;
            return $64a554d15bd769f3$export$b6024a131a1561d9(this.routes, url);
        };
        this.replace = (url, forceReload = false)=>{
            const { history: history, onPageReload: onPageReload = $64a554d15bd769f3$var$RouteManagerInner.defaultProps.onPageReload } = this.props;
            let match;
            if (!forceReload && (match = this.matchSupportedRoute(url))) // replace only supports pushing a path.
            // here the url might be a full URL that has same domain
            history.replace((0, $9pfwj.format)({
                pathname: match.pathname,
                search: match.search,
                hash: match.hash
            }));
            else {
                onPageReload(url, true);
                // eslint-disable-next-line no-restricted-syntax
                window.location.replace(url);
            }
        };
        this.open = (url, target, features)=>window.open(url, target, features);
        this.defaultPush = (url, forceReload = false)=>{
            const { history: history, onPageReload: onPageReload = $64a554d15bd769f3$var$RouteManagerInner.defaultProps.onPageReload, location: location1 } = this.props;
            let match;
            if (!forceReload && (match = this.matchSupportedRoute((0, $a1f0c4d0ab868c5f$export$feb8df2d5227ff6c)(url) ? (0, $9pfwj.format)({
                pathname: location1.pathname,
                search: location1.search,
                hash: url
            }) : url))) // push only supports pushing a path.
            // here the url might be a full URL that has same domain
            history.push((0, $9pfwj.format)({
                pathname: match.pathname,
                search: match.search,
                hash: match.hash
            }));
            else {
                onPageReload(url, false);
                // eslint-disable-next-line no-restricted-syntax
                window.location.assign(url);
            }
        };
        this.push = (url, forceReload = false)=>{
            const { routePolicy: routePolicy } = this.props;
            if (routePolicy) return routePolicy.push({
                ...this.getRoutesContextValue(),
                push: this.defaultPush
            }, url, forceReload);
            return this.defaultPush(url, forceReload);
        };
        this.getQueryParams = ()=>{
            const { location: location1 } = this.props;
            return (0, $9pfwj.parse)(location1.search, true).query;
        };
        this.setQueryParams = (query, replace = false)=>{
            if (query && typeof query === 'object') {
                const { history: history } = this.props;
                const queryParams = {
                    ...this.getQueryParams(),
                    ...this.pendingQueryParams,
                    ...query
                };
                Object.keys(queryParams).forEach((key)=>{
                    if (queryParams[key] === null || queryParams[key] === undefined) delete queryParams[key];
                });
                const search = this.buildQueryString(queryParams);
                (replace ? history.replace : history.push)({
                    search: search
                });
                Object.assign(this.pendingQueryParams, query);
                // https://github.com/ReactTraining/history/issues/767#issuecomment-573358882
                setTimeout(()=>this.pendingQueryParams = {});
            }
        };
        this.buildQueryString = $64a554d15bd769f3$export$5050caba5e109cc4;
        this.getHash = ()=>{
            const { location: location1 } = this.props;
            return location1.hash ? location1.hash.substring(1) : '';
        };
        this.setHash = (hash)=>{
            const { history: history, location: location1 } = this.props;
            history.replace({
                ...location1,
                hash: hash
            });
        };
        this.preloadRoute = (matchOrUrl, options)=>{
            // URL match and string are among the most common representations in our
            // codebase. RouteManager owns converting between them so reduce the
            // strain on the caller and accept both:
            const match = typeof matchOrUrl === 'string' ? this.matchSupportedRoute(matchOrUrl) : matchOrUrl;
            if (match) {
                const previousMatch = this.matchSupportedRoute(this.getHref());
                const { onPreload: onPreload } = this.props;
                if (onPreload) onPreload(match, previousMatch, options);
            }
        };
        this.getRoutesContextValue = ()=>{
            const { history: history, location: location1, onPageReload: onPageReload } = this.props;
            return {
                getHref: this.getHref,
                history: history,
                location: location1,
                match: this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`),
                transitionId: this.transitionId,
                toUrl: this.toUrl,
                matchRoute: this.matchRoute,
                matchSupportedRoute: this.matchSupportedRoute,
                getQueryParams: this.getQueryParams,
                setQueryParams: this.setQueryParams,
                getHash: this.getHash,
                setHash: this.setHash,
                replace: this.replace,
                routes: this.routes,
                push: this.push,
                open: this.open,
                onPageReload: onPageReload || $64a554d15bd769f3$var$NOOP,
                preloadRoute: this.preloadRoute
            };
        };
        const { location: _location, onInitialize: onInitialize, routeComponents: routeComponents } = this.props;
        // Keep a component => memo(component) mapping so later in matchAndRenderComponent we can render the memoized one.
        // We are not re-creating the routeComponents object because several items in the object may share the same reference.
        // If that is the case then our memoized component should sharing the same reference as well.
        for(const key in routeComponents){
            const component = routeComponents[key];
            if (!this.memoizedRouteComponents.has(component)) this.memoizedRouteComponents.set(component, /*#__PURE__*/ (0, $2hRE7.memo)(component, (0, (/*@__PURE__*/$parcel$interopDefault($55883d9587c6b43d$exports)))));
        }
        const _match = this.matchSupportedRoute(`${_location.pathname}${_location.search}${_location.hash}`);
        if (onInitialize) onInitialize(_match, this.transitionId);
    }
}
$64a554d15bd769f3$var$RouteManagerInner.defaultProps = {
    routeComponents: {},
    namedRoutes: {},
    onPageReload: $64a554d15bd769f3$var$NOOP
};
const $64a554d15bd769f3$var$withInteractionContext = (ChildComponent)=>{
    if (!(0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_transition_preloading_system')) return ChildComponent;
    const WithInteractionContextComponent = (props)=>{
        const $ = (0, $ebfe460bd680287b$exports.c)(2);
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $d005de9f36e826c3$export$2e2bcd8739ae039).Consumer, null, (interactionContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement(ChildComponent, {
                    ...props,
                    interactionContext: interactionContext
                }));
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    };
    WithInteractionContextComponent.displayName = `withInteractionContext(${ChildComponent.displayName || ChildComponent.name})`;
    return WithInteractionContextComponent;
};
const $64a554d15bd769f3$export$1b5af09f58fb97da = (0, $0b5545bc430d2e46$export$369b6b2b30582e8e)($64a554d15bd769f3$var$withInteractionContext($64a554d15bd769f3$var$RouteManagerInner));
const $64a554d15bd769f3$export$3b81431e16eb41b6 = $64a554d15bd769f3$var$withInteractionContext;




const $4b957fb9fbb0eafa$export$d4971375353d0454 = [
    $0d518026f9d519cf$export$9e15ff8aa6bc996f,
    $0d518026f9d519cf$export$2fd309376969662f,
    $0d518026f9d519cf$export$a7c5707626fc90f,
    $0d518026f9d519cf$export$6ccd7dc0d5aa30b0,
    $0d518026f9d519cf$export$7d65e474be175151,
    $0d518026f9d519cf$export$ec8a7da990877da3,
    $0d518026f9d519cf$export$aa473411bddb7e17,
    $0d518026f9d519cf$export$42bb8ba9cae96927,
    $0d518026f9d519cf$export$a3ffa1b376d5ba4,
    $0d518026f9d519cf$export$dec9f53c339ce8f8,
    $0d518026f9d519cf$export$f80d02217688b484,
    $0d518026f9d519cf$export$fdfdf584a0978d20,
    $0d518026f9d519cf$export$1e92de3a3dba0876,
    $0d518026f9d519cf$export$6a85914fb9ca80a2,
    $0d518026f9d519cf$export$1f238fcead086ec3,
    $0d518026f9d519cf$export$b74c113024023274,
    $0d518026f9d519cf$export$45222bf0cb32d6e2,
    $0d518026f9d519cf$export$7b1285e36c635f1f,
    $0d518026f9d519cf$export$36dcea4e08feb5c9,
    $0d518026f9d519cf$export$e63a462ee45b57cf,
    $0d518026f9d519cf$export$bd17e6e353522e0d,
    $0d518026f9d519cf$export$54edf7c16c47aeef,
    $0d518026f9d519cf$export$d6ae9e544e98926f,
    $0d518026f9d519cf$export$e8253e1b7e500d1c,
    $0d518026f9d519cf$export$9a4ff2d809fc4156,
    $0d518026f9d519cf$export$19c176cd0a878008,
    $0d518026f9d519cf$export$439074745692fe65,
    $0d518026f9d519cf$export$2de9a69f9b51bb83,
    $0d518026f9d519cf$export$10f0439b47c8fdaf,
    $0d518026f9d519cf$export$d87089dbdd7eeaf3,
    $0d518026f9d519cf$export$dd174db99b3e6fea,
    $0d518026f9d519cf$export$3d1be0ba1817b3cb,
    $0d518026f9d519cf$export$ef26ce515f06bc5e,
    $0d518026f9d519cf$export$65b723bb995d4fb6,
    $0d518026f9d519cf$export$4fe224de953acb46,
    $0d518026f9d519cf$export$f928fc717edba75d,
    $0d518026f9d519cf$export$1009a7f2cc1ac09f,
    $0d518026f9d519cf$export$4dd08bdd46db5924,
    $0d518026f9d519cf$export$ada7925da580b561,
    $0d518026f9d519cf$export$29df24b01e938adf,
    $0d518026f9d519cf$export$e003e97fab6b4368,
    $0d518026f9d519cf$export$5f7be6e90830de0c,
    $0d518026f9d519cf$export$9257b5b55c8e2555,
    $0d518026f9d519cf$export$475fdaba8e6145bb,
    $0d518026f9d519cf$export$f7f8ac1f46faf9c6,
    $0d518026f9d519cf$export$347d3b5edaae00e0,
    $0d518026f9d519cf$export$91f49e7b30a9d34,
    $0d518026f9d519cf$export$c259921a01da55b4,
    $0d518026f9d519cf$export$5b90ced7e51bcea0,
    $0d518026f9d519cf$export$c1375e778136faf8,
    $0d518026f9d519cf$export$7d8684a463b78f54,
    $0d518026f9d519cf$export$eb54044908e4e0bd,
    $0d518026f9d519cf$export$506a1a071415f2e,
    $0d518026f9d519cf$export$4e4c6a9eb23f65ec,
    $0d518026f9d519cf$export$a1d81e742f4c736a,
    $0d518026f9d519cf$export$34a1f8584895c359,
    $0d518026f9d519cf$export$8bc874b6ace7b827,
    $0d518026f9d519cf$export$3131a0442cfecc47,
    $0d518026f9d519cf$export$1a109903d8828cd7,
    $0d518026f9d519cf$export$e80ac94b8ecda3f5,
    $0d518026f9d519cf$export$128f725ffe7518d6,
    $0d518026f9d519cf$export$9da18303b9e1daee,
    $0d518026f9d519cf$export$37055aaa9d88b944,
    $0d518026f9d519cf$export$b17d28dbf200fde0,
    $0d518026f9d519cf$export$5bfa1fef1b53dfdd,
    $0d518026f9d519cf$export$dd6de41f650dae89,
    $0d518026f9d519cf$export$8c6393d6207d929,
    $0d518026f9d519cf$export$9397e0d80cf06055,
    $0d518026f9d519cf$export$f107e7a692a3a54e,
    $0d518026f9d519cf$export$5bbec961de23dce7,
    $0d518026f9d519cf$export$2f6a532274e0cd9d,
    $0d518026f9d519cf$export$a007a4f7553ffc16,
    $0d518026f9d519cf$export$6a8756d3434dd2ea,
    $0d518026f9d519cf$export$32107da104ebe4cd,
    $0d518026f9d519cf$export$f0e8d063cba10e9c,
    $0d518026f9d519cf$export$3039840c47d9a13d,
    $0d518026f9d519cf$export$e1e5a41fa357e66f,
    $0d518026f9d519cf$export$4fcc3f53642c593a,
    $0d518026f9d519cf$export$7234e6926944adc0,
    $0d518026f9d519cf$export$b86d7bd984fb9727,
    $0d518026f9d519cf$export$1afd9317831e345e,
    $0d518026f9d519cf$export$9e8d02f6bdb565e9,
    $0d518026f9d519cf$export$f03a4adc711219ed,
    $0d518026f9d519cf$export$af040d7344c912d1,
    $0d518026f9d519cf$export$2925d036bbc38c7,
    $0d518026f9d519cf$export$351b62e6f5786a73,
    $0d518026f9d519cf$export$4a2048bb71da8b4b,
    $0d518026f9d519cf$export$7de5b687836953bd,
    $0d518026f9d519cf$export$e492b3d04985e9fb,
    $0d518026f9d519cf$export$57fb93d8931ad943,
    $0d518026f9d519cf$export$27b2e48e28163360,
    $0d518026f9d519cf$export$f178fb5b1e822288,
    $0d518026f9d519cf$export$777796688df78f56,
    $0d518026f9d519cf$export$3907c7d8e57f70ba,
    $0d518026f9d519cf$export$fe97ee265fd89939,
    $0d518026f9d519cf$export$b71609db3dda2696,
    $0d518026f9d519cf$export$730392c243a0a367,
    $0d518026f9d519cf$export$85bd3cea0cecb26c,
    $0d518026f9d519cf$export$c8a37c9f76d4d03f,
    $0d518026f9d519cf$export$771b75a6ca136f91,
    $0d518026f9d519cf$export$8e4a8343b1614a02,
    $0d518026f9d519cf$export$2c9cf254b3b24ff,
    $0d518026f9d519cf$export$d925029e7ceadd51,
    $0d518026f9d519cf$export$e84c491e2d88d9f6,
    $0d518026f9d519cf$export$a990a60696f54618,
    $0d518026f9d519cf$export$c0a209b0b0b16c75,
    $0d518026f9d519cf$export$dcee5dee04648c93,
    $0d518026f9d519cf$export$dcda7f8b6fe54ba,
    $0d518026f9d519cf$export$9e430f65574f5333,
    $0d518026f9d519cf$export$e9d78b13bbb4e56f,
    $0d518026f9d519cf$export$d7be6003270f6c2d,
    $0d518026f9d519cf$export$b49467be269d2629,
    $0d518026f9d519cf$export$e52245e856f5c06,
    $0d518026f9d519cf$export$926e3916067d7530,
    $0d518026f9d519cf$export$e720b1e170b46aae,
    $0d518026f9d519cf$export$6c7b95dcf08f3a6d,
    $0d518026f9d519cf$export$b010f02787df1e6,
    $0d518026f9d519cf$export$ecc28d15af39a8b2,
    $0d518026f9d519cf$export$482db086bc8c2289,
    $0d518026f9d519cf$export$3afea7266d0d139b,
    $0d518026f9d519cf$export$4eb80c3a4e6fbe0f,
    $0d518026f9d519cf$export$bd2c9bb170b3681d,
    $0d518026f9d519cf$export$5c9eaf42f32252ea,
    $0d518026f9d519cf$export$7ae0ea91a2dfc4d9,
    $0d518026f9d519cf$export$3bd4ec9f05d79904,
    $0d518026f9d519cf$export$d593e642a326a501,
    $0d518026f9d519cf$export$d7c46ce72a2e4742,
    $0d518026f9d519cf$export$6490fab56523ceda,
    $0d518026f9d519cf$export$dcb1d1a9cda087b1,
    $0d518026f9d519cf$export$6b2db7909585abd7,
    $0d518026f9d519cf$export$2dd65cdecd8b05d7,
    $0d518026f9d519cf$export$d78f611c1ddf7234,
    $0d518026f9d519cf$export$9dc7f7e5e1435bc,
    $0d518026f9d519cf$export$3582accdd821993a,
    $0d518026f9d519cf$export$871ac71d42c178c5,
    $0d518026f9d519cf$export$1bc544543b946246,
    $0d518026f9d519cf$export$d387bb8ca9ce25d1,
    $0d518026f9d519cf$export$f7bf92a6467c1557,
    $0d518026f9d519cf$export$ed260c82a3e70a6a,
    $0d518026f9d519cf$export$a90430d7f36bfe9e,
    $0d518026f9d519cf$export$22bb05181a4b1501,
    $0d518026f9d519cf$export$cb73aa9f5b7d1ea0,
    $0d518026f9d519cf$export$df78b182760b42f4,
    $0d518026f9d519cf$export$2d3703cff5d9a27,
    $0d518026f9d519cf$export$60773cf116cf5f30,
    $0d518026f9d519cf$export$7f9afa9f8695d995,
    $0d518026f9d519cf$export$40e965fb568c3c83,
    $0d518026f9d519cf$export$cb80c94a905e11b6,
    $0d518026f9d519cf$export$93b558a6e07dbdac,
    $0d518026f9d519cf$export$67acd8a63f03bc8,
    $0d518026f9d519cf$export$6b9c632e635b4d77,
    $0d518026f9d519cf$export$37a588b556645c19,
    $0d518026f9d519cf$export$aded01fc53d469df,
    $0d518026f9d519cf$export$cdd412f0619f2d7e,
    $0d518026f9d519cf$export$aa72b945229db170,
    $0d518026f9d519cf$export$f0c4a6dc3b3437aa,
    $0d518026f9d519cf$export$1a5e481ee166ad7c,
    $0d518026f9d519cf$export$f39a30a3a5635bab,
    $0d518026f9d519cf$export$3101773a7a844077,
    $0d518026f9d519cf$export$f03524b1e395be4a,
    $0d518026f9d519cf$export$38b94ff4631b44df,
    $0d518026f9d519cf$export$26dfba554adbf87e,
    $0d518026f9d519cf$export$1b93424785e5f745,
    $0d518026f9d519cf$export$f0e860396acf6277,
    $0d518026f9d519cf$export$4442c9c7bb716896,
    $0d518026f9d519cf$export$ffd880217e61385f,
    $0d518026f9d519cf$export$8bf619366f9e74f2,
    $0d518026f9d519cf$export$bc800ac2a79e672d,
    $0d518026f9d519cf$export$e62498d72b78f3ef,
    $0d518026f9d519cf$export$a85b9c60514cd043,
    $0d518026f9d519cf$export$19b893a9e64dac94,
    $0d518026f9d519cf$export$3d39129bec795227,
    $0d518026f9d519cf$export$b8adcf19ff927cec,
    $0d518026f9d519cf$export$939b28e9f8987d97,
    $0d518026f9d519cf$export$d0ac6fa12f3acafa,
    $0d518026f9d519cf$export$693d9b367ae8d0f7,
    $0d518026f9d519cf$export$35123576da2e521,
    $0d518026f9d519cf$export$e18ccd8ffafdf3dd,
    $0d518026f9d519cf$export$9c4e8cdcbbacdf8f,
    $0d518026f9d519cf$export$f85f59869a8dbbf8,
    $0d518026f9d519cf$export$2cc9af506d64ef72,
    $0d518026f9d519cf$export$4f46a1e4250ebe18,
    $0d518026f9d519cf$export$751ae19fa150b7c,
    $0d518026f9d519cf$export$526ccce5d32f7beb,
    $0d518026f9d519cf$export$3d8579587b62bb96,
    $0d518026f9d519cf$export$ed19a29c446e24d8,
    $0d518026f9d519cf$export$7de52f6cc232129e,
    $0d518026f9d519cf$export$81cfd93b1b89cd07,
    $0d518026f9d519cf$export$31745f3bff21cd,
    $0d518026f9d519cf$export$7af7a1e753a92264,
    $0d518026f9d519cf$export$28e7e683f23a58d3,
    $0d518026f9d519cf$export$e64d4514fc584fbe,
    $0d518026f9d519cf$export$edc6bf6d11241655,
    $0d518026f9d519cf$export$ee28bfe408c8e5b2,
    $0d518026f9d519cf$export$323161697c5fa666,
    $0d518026f9d519cf$export$dfa725d05e18145e,
    $0d518026f9d519cf$export$8674e83405059790,
    $0d518026f9d519cf$export$8b5e82a6ff458b36,
    $0d518026f9d519cf$export$5942f6ee6cb5e57b,
    $0d518026f9d519cf$export$3ce513606c31c918,
    $0d518026f9d519cf$export$652395dc5ff9b416,
    $0d518026f9d519cf$export$4d1bccc78b263a8e,
    $0d518026f9d519cf$export$df327d9b56ca6b7c,
    $0d518026f9d519cf$export$53f195d79ef3d4dd,
    $0d518026f9d519cf$export$23e7002e5e9ef89e,
    $0d518026f9d519cf$export$2a17c68caa9b9a01,
    $0d518026f9d519cf$export$299af9061dea1f09,
    $0d518026f9d519cf$export$eb5a785192323bd3,
    $0d518026f9d519cf$export$168f3acd059931e0,
    $0d518026f9d519cf$export$f923488a46a66438,
    $0d518026f9d519cf$export$3bcebf4f1e82d3ad,
    $0d518026f9d519cf$export$34acb7ca79032384,
    $0d518026f9d519cf$export$c53feccaf231f120,
    $0d518026f9d519cf$export$42599f111394c36c,
    $0d518026f9d519cf$export$4c6bf75100b3b72,
    $0d518026f9d519cf$export$e05db3c2f69bd3ae,
    $0d518026f9d519cf$export$851ba2be5095d586,
    $0d518026f9d519cf$export$9859a7a7049d0585,
    $0d518026f9d519cf$export$90480461935b54cc,
    $0d518026f9d519cf$export$84b5e15197aaaa12,
    $0d518026f9d519cf$export$4dcf771d1a1901ef,
    $0d518026f9d519cf$export$22f8e464aee70413,
    $0d518026f9d519cf$export$752c480a913a6712,
    $0d518026f9d519cf$export$16172a64bcdb79f8,
    $0d518026f9d519cf$export$703c0113e0ca5515,
    $0d518026f9d519cf$export$bda499cb90b2d60e,
    $0d518026f9d519cf$export$131cf600a1a5d1b3,
    $0d518026f9d519cf$export$4ec917ea3fb6cbfc,
    $0d518026f9d519cf$export$74a9a335c43b2ab9,
    $0d518026f9d519cf$export$70914a626e2f0488,
    $0d518026f9d519cf$export$85c61af9d225a707,
    $0d518026f9d519cf$export$3d0698fcdc33631d,
    $0d518026f9d519cf$export$c0d0d3f98d45e5f1,
    $0d518026f9d519cf$export$69df75bd8c217ade,
    $0d518026f9d519cf$export$70e53b90503ea1b9,
    $0d518026f9d519cf$export$3b3f3d2739d7f93,
    $0d518026f9d519cf$export$d255d2f418d43162,
    $0d518026f9d519cf$export$f313d05bcfc41be4,
    $0d518026f9d519cf$export$9fe7a72d144f372,
    $0d518026f9d519cf$export$199a3e309932cca4,
    $0d518026f9d519cf$export$2d0c6cbdaebd76ff,
    $0d518026f9d519cf$export$688990fbefa748b3,
    $0d518026f9d519cf$export$629e966630a1f92e,
    $0d518026f9d519cf$export$e8beba40e140a443,
    $0d518026f9d519cf$export$c471be73599ccae1,
    $0d518026f9d519cf$export$bb9816d0c0dcd6e6,
    $0d518026f9d519cf$export$793ade69cc97583f,
    $0d518026f9d519cf$export$499f432aa493cdd2,
    $0d518026f9d519cf$export$4ce9d0d8218b9d84,
    $0d518026f9d519cf$export$345aea7dc51bac8a,
    $0d518026f9d519cf$export$499a561f6d1a011,
    $0d518026f9d519cf$export$59a52cdd0906f4cb,
    $0d518026f9d519cf$export$2bc30aa6642650c,
    $0d518026f9d519cf$export$b45af2e1d7abb289,
    $0d518026f9d519cf$export$f8d71dcb352ebe8c,
    $0d518026f9d519cf$export$3591d21f4b9b700,
    $0d518026f9d519cf$export$5f63ad7e18293ec2,
    $0d518026f9d519cf$export$57a75dda1f25b360,
    $0d518026f9d519cf$export$3ebf2fc23df50648,
    $0d518026f9d519cf$export$94f5f2b71458cc90,
    $0d518026f9d519cf$export$7ab78afe8c48e1e5,
    $0d518026f9d519cf$export$f887b7b4f6d59541,
    $0d518026f9d519cf$export$325240bec5751c99
].reduce((acc, route)=>{
    acc[route.name] = route;
    return acc;
}, {});



var $c2a9b259952fa305$exports = {};

var $7e6c26413ff6148d$exports = {};

var $c8DlO = parcelRequire("c8DlO");
var $a3238c1b6965e558$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $a3238c1b6965e558$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$a3238c1b6965e558$exports = $a3238c1b6965e558$var$arrayEach;



var $7884e30e267e18d0$exports = {};
var $fabead659e79cbfc$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $fabead659e79cbfc$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $e999ef5430fc710b$exports(object, key, newValue);
        else $5f2578f2d184537b$exports(object, key, newValue);
    }
    return object;
}
$fabead659e79cbfc$exports = $fabead659e79cbfc$var$copyObject;



var $icwHc = parcelRequire("icwHc");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $7884e30e267e18d0$var$baseAssign(object, source) {
    return object && $fabead659e79cbfc$exports(source, $icwHc(source), object);
}
$7884e30e267e18d0$exports = $7884e30e267e18d0$var$baseAssign;


var $4a9bfb268113d2fe$exports = {};


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $4a9bfb268113d2fe$var$baseAssignIn(object, source) {
    return object && $fabead659e79cbfc$exports(source, $7a6e7e090a46d98d$exports(source), object);
}
$4a9bfb268113d2fe$exports = $4a9bfb268113d2fe$var$baseAssignIn;



var $gSyep = parcelRequire("gSyep");
var $7be4095e28dccbf2$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $7be4095e28dccbf2$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$7be4095e28dccbf2$exports = $7be4095e28dccbf2$var$copyArray;


var $127e73c81d9b451e$exports = {};


var $2AXfG = parcelRequire("2AXfG");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $127e73c81d9b451e$var$copySymbols(source, object) {
    return $fabead659e79cbfc$exports(source, $2AXfG(source), object);
}
$127e73c81d9b451e$exports = $127e73c81d9b451e$var$copySymbols;


var $e63e274fa074a17e$exports = {};


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $e63e274fa074a17e$var$copySymbolsIn(source, object) {
    return $fabead659e79cbfc$exports(source, $97b1d32ff7400656$exports(source), object);
}
$e63e274fa074a17e$exports = $e63e274fa074a17e$var$copySymbolsIn;



var $ceLPF = parcelRequire("ceLPF");


var $4fbm2 = parcelRequire("4fbm2");
var $8d5407df4df1be6c$exports = {};
/** Used for built-in method references. */ var $8d5407df4df1be6c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8d5407df4df1be6c$var$hasOwnProperty = $8d5407df4df1be6c$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $8d5407df4df1be6c$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $8d5407df4df1be6c$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$8d5407df4df1be6c$exports = $8d5407df4df1be6c$var$initCloneArray;


var $08cfb79ad1931c1c$exports = {};
var $71797e779f26e3fc$exports = {};

var $gsH5A = parcelRequire("gsH5A");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $71797e779f26e3fc$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $gsH5A(result).set(new $gsH5A(arrayBuffer));
    return result;
}
$71797e779f26e3fc$exports = $71797e779f26e3fc$var$cloneArrayBuffer;


var $9617754e2ab94a91$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $9617754e2ab94a91$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $71797e779f26e3fc$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$9617754e2ab94a91$exports = $9617754e2ab94a91$var$cloneDataView;


var $c70769e30428b30d$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $c70769e30428b30d$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $c70769e30428b30d$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $c70769e30428b30d$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$c70769e30428b30d$exports = $c70769e30428b30d$var$cloneRegExp;


var $3c672f7e97e21a9b$exports = {};

var $5HSZ3 = parcelRequire("5HSZ3");
/** Used to convert symbols to primitives and strings. */ var $3c672f7e97e21a9b$var$symbolProto = $5HSZ3 ? $5HSZ3.prototype : undefined, $3c672f7e97e21a9b$var$symbolValueOf = $3c672f7e97e21a9b$var$symbolProto ? $3c672f7e97e21a9b$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $3c672f7e97e21a9b$var$cloneSymbol(symbol) {
    return $3c672f7e97e21a9b$var$symbolValueOf ? Object($3c672f7e97e21a9b$var$symbolValueOf.call(symbol)) : {};
}
$3c672f7e97e21a9b$exports = $3c672f7e97e21a9b$var$cloneSymbol;


var $ac292c2abcdf3dc9$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $ac292c2abcdf3dc9$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $71797e779f26e3fc$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$ac292c2abcdf3dc9$exports = $ac292c2abcdf3dc9$var$cloneTypedArray;


/** `Object#toString` result references. */ var $08cfb79ad1931c1c$var$boolTag = '[object Boolean]', $08cfb79ad1931c1c$var$dateTag = '[object Date]', $08cfb79ad1931c1c$var$mapTag = '[object Map]', $08cfb79ad1931c1c$var$numberTag = '[object Number]', $08cfb79ad1931c1c$var$regexpTag = '[object RegExp]', $08cfb79ad1931c1c$var$setTag = '[object Set]', $08cfb79ad1931c1c$var$stringTag = '[object String]', $08cfb79ad1931c1c$var$symbolTag = '[object Symbol]';
var $08cfb79ad1931c1c$var$arrayBufferTag = '[object ArrayBuffer]', $08cfb79ad1931c1c$var$dataViewTag = '[object DataView]', $08cfb79ad1931c1c$var$float32Tag = '[object Float32Array]', $08cfb79ad1931c1c$var$float64Tag = '[object Float64Array]', $08cfb79ad1931c1c$var$int8Tag = '[object Int8Array]', $08cfb79ad1931c1c$var$int16Tag = '[object Int16Array]', $08cfb79ad1931c1c$var$int32Tag = '[object Int32Array]', $08cfb79ad1931c1c$var$uint8Tag = '[object Uint8Array]', $08cfb79ad1931c1c$var$uint8ClampedTag = '[object Uint8ClampedArray]', $08cfb79ad1931c1c$var$uint16Tag = '[object Uint16Array]', $08cfb79ad1931c1c$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $08cfb79ad1931c1c$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $08cfb79ad1931c1c$var$arrayBufferTag:
            return $71797e779f26e3fc$exports(object);
        case $08cfb79ad1931c1c$var$boolTag:
        case $08cfb79ad1931c1c$var$dateTag:
            return new Ctor(+object);
        case $08cfb79ad1931c1c$var$dataViewTag:
            return $9617754e2ab94a91$exports(object, isDeep);
        case $08cfb79ad1931c1c$var$float32Tag:
        case $08cfb79ad1931c1c$var$float64Tag:
        case $08cfb79ad1931c1c$var$int8Tag:
        case $08cfb79ad1931c1c$var$int16Tag:
        case $08cfb79ad1931c1c$var$int32Tag:
        case $08cfb79ad1931c1c$var$uint8Tag:
        case $08cfb79ad1931c1c$var$uint8ClampedTag:
        case $08cfb79ad1931c1c$var$uint16Tag:
        case $08cfb79ad1931c1c$var$uint32Tag:
            return $ac292c2abcdf3dc9$exports(object, isDeep);
        case $08cfb79ad1931c1c$var$mapTag:
            return new Ctor;
        case $08cfb79ad1931c1c$var$numberTag:
        case $08cfb79ad1931c1c$var$stringTag:
            return new Ctor(object);
        case $08cfb79ad1931c1c$var$regexpTag:
            return $c70769e30428b30d$exports(object);
        case $08cfb79ad1931c1c$var$setTag:
            return new Ctor;
        case $08cfb79ad1931c1c$var$symbolTag:
            return $3c672f7e97e21a9b$exports(object);
    }
}
$08cfb79ad1931c1c$exports = $08cfb79ad1931c1c$var$initCloneByTag;


var $d67a173a4ac40843$exports = {};
var $d22982984ece819f$exports = {};

var $7M8w7 = parcelRequire("7M8w7");
/** Built-in value references. */ var $d22982984ece819f$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $d22982984ece819f$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$7M8w7(proto)) return {};
        if ($d22982984ece819f$var$objectCreate) return $d22982984ece819f$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$d22982984ece819f$exports = $d22982984ece819f$var$baseCreate;




var $lxWr3 = parcelRequire("lxWr3");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $d67a173a4ac40843$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$lxWr3(object) ? $d22982984ece819f$exports($69c53637b0cac2f9$exports(object)) : {};
}
$d67a173a4ac40843$exports = $d67a173a4ac40843$var$initCloneObject;



var $1Hc0l = parcelRequire("1Hc0l");

var $7WuWW = parcelRequire("7WuWW");
var $ee685ece876463c6$exports = {};
var $b3514beac9b4dfe2$exports = {};

var $4fbm2 = parcelRequire("4fbm2");

var $1OvKS = parcelRequire("1OvKS");
/** `Object#toString` result references. */ var $b3514beac9b4dfe2$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $b3514beac9b4dfe2$var$baseIsMap(value) {
    return $1OvKS(value) && $4fbm2(value) == $b3514beac9b4dfe2$var$mapTag;
}
$b3514beac9b4dfe2$exports = $b3514beac9b4dfe2$var$baseIsMap;



var $e46UM = parcelRequire("e46UM");

var $luz9U = parcelRequire("luz9U");
/* Node.js helper references. */ var $ee685ece876463c6$var$nodeIsMap = $luz9U && $luz9U.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $ee685ece876463c6$var$isMap = $ee685ece876463c6$var$nodeIsMap ? $e46UM($ee685ece876463c6$var$nodeIsMap) : $b3514beac9b4dfe2$exports;
$ee685ece876463c6$exports = $ee685ece876463c6$var$isMap;



var $7M8w7 = parcelRequire("7M8w7");
var $f353088924069406$exports = {};
var $d464ea401cd721ff$exports = {};

var $4fbm2 = parcelRequire("4fbm2");

var $1OvKS = parcelRequire("1OvKS");
/** `Object#toString` result references. */ var $d464ea401cd721ff$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $d464ea401cd721ff$var$baseIsSet(value) {
    return $1OvKS(value) && $4fbm2(value) == $d464ea401cd721ff$var$setTag;
}
$d464ea401cd721ff$exports = $d464ea401cd721ff$var$baseIsSet;



var $e46UM = parcelRequire("e46UM");

var $luz9U = parcelRequire("luz9U");
/* Node.js helper references. */ var $f353088924069406$var$nodeIsSet = $luz9U && $luz9U.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $f353088924069406$var$isSet = $f353088924069406$var$nodeIsSet ? $e46UM($f353088924069406$var$nodeIsSet) : $d464ea401cd721ff$exports;
$f353088924069406$exports = $f353088924069406$var$isSet;



var $icwHc = parcelRequire("icwHc");

/** Used to compose bitmasks for cloning. */ var $7e6c26413ff6148d$var$CLONE_DEEP_FLAG = 1, $7e6c26413ff6148d$var$CLONE_FLAT_FLAG = 2, $7e6c26413ff6148d$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $7e6c26413ff6148d$var$argsTag = '[object Arguments]', $7e6c26413ff6148d$var$arrayTag = '[object Array]', $7e6c26413ff6148d$var$boolTag = '[object Boolean]', $7e6c26413ff6148d$var$dateTag = '[object Date]', $7e6c26413ff6148d$var$errorTag = '[object Error]', $7e6c26413ff6148d$var$funcTag = '[object Function]', $7e6c26413ff6148d$var$genTag = '[object GeneratorFunction]', $7e6c26413ff6148d$var$mapTag = '[object Map]', $7e6c26413ff6148d$var$numberTag = '[object Number]', $7e6c26413ff6148d$var$objectTag = '[object Object]', $7e6c26413ff6148d$var$regexpTag = '[object RegExp]', $7e6c26413ff6148d$var$setTag = '[object Set]', $7e6c26413ff6148d$var$stringTag = '[object String]', $7e6c26413ff6148d$var$symbolTag = '[object Symbol]', $7e6c26413ff6148d$var$weakMapTag = '[object WeakMap]';
var $7e6c26413ff6148d$var$arrayBufferTag = '[object ArrayBuffer]', $7e6c26413ff6148d$var$dataViewTag = '[object DataView]', $7e6c26413ff6148d$var$float32Tag = '[object Float32Array]', $7e6c26413ff6148d$var$float64Tag = '[object Float64Array]', $7e6c26413ff6148d$var$int8Tag = '[object Int8Array]', $7e6c26413ff6148d$var$int16Tag = '[object Int16Array]', $7e6c26413ff6148d$var$int32Tag = '[object Int32Array]', $7e6c26413ff6148d$var$uint8Tag = '[object Uint8Array]', $7e6c26413ff6148d$var$uint8ClampedTag = '[object Uint8ClampedArray]', $7e6c26413ff6148d$var$uint16Tag = '[object Uint16Array]', $7e6c26413ff6148d$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $7e6c26413ff6148d$var$cloneableTags = {};
$7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$argsTag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$arrayTag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$arrayBufferTag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$dataViewTag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$boolTag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$dateTag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$float32Tag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$float64Tag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$int8Tag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$int16Tag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$int32Tag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$mapTag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$numberTag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$objectTag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$regexpTag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$setTag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$stringTag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$symbolTag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$uint8Tag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$uint8ClampedTag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$uint16Tag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$uint32Tag] = true;
$7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$errorTag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$funcTag] = $7e6c26413ff6148d$var$cloneableTags[$7e6c26413ff6148d$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $7e6c26413ff6148d$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $7e6c26413ff6148d$var$CLONE_DEEP_FLAG, isFlat = bitmask & $7e6c26413ff6148d$var$CLONE_FLAT_FLAG, isFull = bitmask & $7e6c26413ff6148d$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$7M8w7(value)) return value;
    var isArr = $1Hc0l(value);
    if (isArr) {
        result = $8d5407df4df1be6c$exports(value);
        if (!isDeep) return $7be4095e28dccbf2$exports(value, result);
    } else {
        var tag = $4fbm2(value), isFunc = tag == $7e6c26413ff6148d$var$funcTag || tag == $7e6c26413ff6148d$var$genTag;
        if ($7WuWW(value)) return $gSyep(value, isDeep);
        if (tag == $7e6c26413ff6148d$var$objectTag || tag == $7e6c26413ff6148d$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $d67a173a4ac40843$exports(value);
            if (!isDeep) return isFlat ? $e63e274fa074a17e$exports(value, $4a9bfb268113d2fe$exports(result, value)) : $127e73c81d9b451e$exports(value, $7884e30e267e18d0$exports(result, value));
        } else {
            if (!$7e6c26413ff6148d$var$cloneableTags[tag]) return object ? value : {};
            result = $08cfb79ad1931c1c$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $c8DlO);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($f353088924069406$exports(value)) value.forEach(function(subValue) {
        result.add($7e6c26413ff6148d$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($ee685ece876463c6$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $7e6c26413ff6148d$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $c05b264fcf55de58$exports : $ceLPF : isFlat ? $7a6e7e090a46d98d$exports : $icwHc;
    var props = isArr ? undefined : keysFunc(value);
    $a3238c1b6965e558$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $5f2578f2d184537b$exports(result, key, $7e6c26413ff6148d$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$7e6c26413ff6148d$exports = $7e6c26413ff6148d$var$baseClone;


var $306fd82831153d36$exports = {};

var $5bf86daee62dfeae$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $5bf86daee62dfeae$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$5bf86daee62dfeae$exports = $5bf86daee62dfeae$var$last;


var $d74be2908b8c788b$exports = {};

var $829b42bffa51bc90$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $829b42bffa51bc90$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$829b42bffa51bc90$exports = $829b42bffa51bc90$var$baseSlice;


/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $d74be2908b8c788b$var$parent(object, path) {
    return path.length < 2 ? object : $e105a9e5dc8b57e7$exports(object, $829b42bffa51bc90$exports(path, 0, -1));
}
$d74be2908b8c788b$exports = $d74be2908b8c788b$var$parent;



/** Used for built-in method references. */ var $306fd82831153d36$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $306fd82831153d36$var$hasOwnProperty = $306fd82831153d36$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $306fd82831153d36$var$baseUnset(object, path) {
    path = $668122a3669e25fc$exports(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $b8334e9b1267c001$exports(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$306fd82831153d36$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $d74be2908b8c788b$exports(object, path);
    return obj == null || delete obj[$b8334e9b1267c001$exports($5bf86daee62dfeae$exports(path))];
}
$306fd82831153d36$exports = $306fd82831153d36$var$baseUnset;




var $e3c16eb2bec15bd9$exports = {};
var $60c2e1bf631014c4$exports = {};

var $fwZuK = parcelRequire("fwZuK");


var $1OvKS = parcelRequire("1OvKS");
/** `Object#toString` result references. */ var $60c2e1bf631014c4$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $60c2e1bf631014c4$var$funcProto = Function.prototype, $60c2e1bf631014c4$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $60c2e1bf631014c4$var$funcToString = $60c2e1bf631014c4$var$funcProto.toString;
/** Used to check objects for own properties. */ var $60c2e1bf631014c4$var$hasOwnProperty = $60c2e1bf631014c4$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $60c2e1bf631014c4$var$objectCtorString = $60c2e1bf631014c4$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $60c2e1bf631014c4$var$isPlainObject(value) {
    if (!$1OvKS(value) || $fwZuK(value) != $60c2e1bf631014c4$var$objectTag) return false;
    var proto = $69c53637b0cac2f9$exports(value);
    if (proto === null) return true;
    var Ctor = $60c2e1bf631014c4$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $60c2e1bf631014c4$var$funcToString.call(Ctor) == $60c2e1bf631014c4$var$objectCtorString;
}
$60c2e1bf631014c4$exports = $60c2e1bf631014c4$var$isPlainObject;


/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $e3c16eb2bec15bd9$var$customOmitClone(value) {
    return $60c2e1bf631014c4$exports(value) ? undefined : value;
}
$e3c16eb2bec15bd9$exports = $e3c16eb2bec15bd9$var$customOmitClone;


var $63d1d2f05632fb79$exports = {};
var $dd889160073aae5d$exports = {};
var $4edce61ef215d5a4$exports = {};

var $hsFEc = parcelRequire("hsFEc");
var $56c892fdf44e50e5$exports = {};

var $5HSZ3 = parcelRequire("5HSZ3");

var $bI9Dv = parcelRequire("bI9Dv");

var $1Hc0l = parcelRequire("1Hc0l");
/** Built-in value references. */ var $56c892fdf44e50e5$var$spreadableSymbol = $5HSZ3 ? $5HSZ3.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $56c892fdf44e50e5$var$isFlattenable(value) {
    return $1Hc0l(value) || $bI9Dv(value) || !!($56c892fdf44e50e5$var$spreadableSymbol && value && value[$56c892fdf44e50e5$var$spreadableSymbol]);
}
$56c892fdf44e50e5$exports = $56c892fdf44e50e5$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $4edce61ef215d5a4$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $56c892fdf44e50e5$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $4edce61ef215d5a4$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hsFEc(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$4edce61ef215d5a4$exports = $4edce61ef215d5a4$var$baseFlatten;


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $dd889160073aae5d$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $4edce61ef215d5a4$exports(array, 1) : [];
}
$dd889160073aae5d$exports = $dd889160073aae5d$var$flatten;


var $c5a580a3cf11986e$exports = {};
var $9dc0d07a7419a8a9$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $9dc0d07a7419a8a9$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$9dc0d07a7419a8a9$exports = $9dc0d07a7419a8a9$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $c5a580a3cf11986e$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $c5a580a3cf11986e$var$overRest(func, start, transform) {
    start = $c5a580a3cf11986e$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $c5a580a3cf11986e$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $9dc0d07a7419a8a9$exports(func, this, otherArgs);
    };
}
$c5a580a3cf11986e$exports = $c5a580a3cf11986e$var$overRest;


var $df9bc80c8f4e15da$exports = {};
var $c4fa117764d26aa9$exports = {};
var $983dbb90e48b4880$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $983dbb90e48b4880$var$constant(value) {
    return function() {
        return value;
    };
}
$983dbb90e48b4880$exports = $983dbb90e48b4880$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $c4fa117764d26aa9$var$baseSetToString = !$8a6543ff00a5e2ad$exports ? $50a9ffac931bdb31$exports : function(func, string) {
    return $8a6543ff00a5e2ad$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $983dbb90e48b4880$exports(string),
        'writable': true
    });
};
$c4fa117764d26aa9$exports = $c4fa117764d26aa9$var$baseSetToString;


var $2d83a9ea86f9bfd7$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $2d83a9ea86f9bfd7$var$HOT_COUNT = 800, $2d83a9ea86f9bfd7$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2d83a9ea86f9bfd7$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $2d83a9ea86f9bfd7$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $2d83a9ea86f9bfd7$var$nativeNow(), remaining = $2d83a9ea86f9bfd7$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $2d83a9ea86f9bfd7$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$2d83a9ea86f9bfd7$exports = $2d83a9ea86f9bfd7$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $df9bc80c8f4e15da$var$setToString = $2d83a9ea86f9bfd7$exports($c4fa117764d26aa9$exports);
$df9bc80c8f4e15da$exports = $df9bc80c8f4e15da$var$setToString;


/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $63d1d2f05632fb79$var$flatRest(func) {
    return $df9bc80c8f4e15da$exports($c5a580a3cf11986e$exports(func, undefined, $dd889160073aae5d$exports), func + '');
}
$63d1d2f05632fb79$exports = $63d1d2f05632fb79$var$flatRest;



/** Used to compose bitmasks for cloning. */ var $c2a9b259952fa305$var$CLONE_DEEP_FLAG = 1, $c2a9b259952fa305$var$CLONE_FLAT_FLAG = 2, $c2a9b259952fa305$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $c2a9b259952fa305$var$omit = $63d1d2f05632fb79$exports(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $eefea53168a86e8c$exports(paths, function(path) {
        path = $668122a3669e25fc$exports(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $fabead659e79cbfc$exports(object, $c05b264fcf55de58$exports(object), result);
    if (isDeep) result = $7e6c26413ff6148d$exports(result, $c2a9b259952fa305$var$CLONE_DEEP_FLAG | $c2a9b259952fa305$var$CLONE_FLAT_FLAG | $c2a9b259952fa305$var$CLONE_SYMBOLS_FLAG, $e3c16eb2bec15bd9$exports);
    var length = paths.length;
    while(length--)$306fd82831153d36$exports(result, paths[length]);
    return result;
});
$c2a9b259952fa305$exports = $c2a9b259952fa305$var$omit;




// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Preserves the existing UUID implementation.




// DO NOT CALL THIS FUNCTION DIRECTLY!!!!
// It is only to be called by React UFO libraries for the automatic handling of trace context for experiences.
// Calling this may cause trace context to be broken
function $9e1d850d62831d12$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}




var $6oQI4 = parcelRequire("6oQI4");





function $54b5d2260726a361$export$a1002be327997103(traceId, spanId, type) {
    if ((0, $6oQI4.fg)('platform_ufo_enable_otel_context_manager')) {
        const activeTraceContext = (0, $a6694f96a559a9a5$export$78df28f9b2f9a7dc).setValue((0, $12849b6b770cec75$export$65f3d43d675bb81b), traceId).setValue((0, $e2e9f70b4f58b5ed$export$ccdc89d1d45284c2), spanId).setValue((0, $9c16bba5deda8cf2$export$1069c2293742749e), type);
        // Now we need to get the global Context Manager and set the active context
        // Using type assertion because we've "extended" the ContextManager type
        if ((0, $633b968a1407d222$export$831109c9f7727010)() instanceof (0, $633b968a1407d222$export$dd301b96c16f583d)) {
            let contextManager = (0, $633b968a1407d222$export$831109c9f7727010)();
            contextManager.setActive(activeTraceContext);
        }
    } else (0, $96978f64a2608679$export$ca000e230c0caa3e).context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}


function $3abd6f7497c9efaf$export$f2e521e495a88544(interactionId, experienceType) {
    (0, $54b5d2260726a361$export$a1002be327997103)(interactionId.replace(/-/g, ''), (0, $9e1d850d62831d12$export$295213bc4d0c54ad)(), experienceType);
}





function $ac84dd12603cd56a$var$traceUFOInteraction(name, interactionType, startTime) {
    if (!(0, $d0427bdd60d98885$export$74bdb753f1cf4860)()) return;
    const rate = (0, $d0427bdd60d98885$export$9466a8f085fa7d4e)(name, interactionType);
    const pressInteractionsList = (0, $d0427bdd60d98885$export$3c170167645a0eff)();
    const minorInteractions = (pressInteractionsList ?? []).concat((0, $d0427bdd60d98885$export$b150ddad71c80d77)() ?? []);
    if (minorInteractions.includes(name)) {
        const activeInteraction = (0, $fa77cab6e7101561$export$2b3954d2e8509985)();
        activeInteraction?.minorInteractions?.push({
            name: name,
            startTime: startTime ?? performance.now()
        });
        return;
    } else (0, $fa77cab6e7101561$export$614a7af2affc5dff)('new_interaction', name);
    if ((0, $e652262e1c536287$export$2e2bcd8739ae039)(rate)) {
        const startTimestamp = startTime ?? performance.now();
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $b9a40c449374f876$exports.v4)();
        (0, $056559c8228a75c5$export$2e2bcd8739ae039).current = newId;
        // covered experiences with tracing instrumentation:
        // inline-result.inline-card-create-submit
        (0, $3abd6f7497c9efaf$export$f2e521e495a88544)(newId, interactionType);
        (0, $fa77cab6e7101561$export$1a1ed1e1fdb2006b)(newId, name, interactionType === 'hover' ? 'press' : interactionType, // TODO add dedicated type for hover, might change backend though
        startTimestamp, rate, [], (0, $852b065d3d52ea04$export$2e2bcd8739ae039).current, (0, $3f9dbb98c6868de1$export$b6ac780db3a3cc77)());
    }
}
var $ac84dd12603cd56a$export$2e2bcd8739ae039 = $ac84dd12603cd56a$var$traceUFOInteraction;


function $d309dd6a21a7c10e$var$traceUFOPress(name, timestamp) {
    return (0, $ac84dd12603cd56a$export$2e2bcd8739ae039)(name, 'press', timestamp);
}
var $d309dd6a21a7c10e$export$2e2bcd8739ae039 = $d309dd6a21a7c10e$var$traceUFOPress;



var $b0809950592c8add$exports = {};
var $db155982079085a7$exports = {};


// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $db155982079085a7$var$_nodeId;
var $db155982079085a7$var$_clockseq;
// Previous uuid creation time
var $db155982079085a7$var$_lastMSecs = 0;
var $db155982079085a7$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $db155982079085a7$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $db155982079085a7$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $db155982079085a7$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $8620f91002fd03c7$exports();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $db155982079085a7$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $db155982079085a7$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $db155982079085a7$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $db155982079085a7$var$_lastMSecs + (nsecs - $db155982079085a7$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $db155982079085a7$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $db155982079085a7$var$_lastMSecs = msecs;
    $db155982079085a7$var$_lastNSecs = nsecs;
    $db155982079085a7$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $0eb3fc9f8addfeea$exports(b);
}
$db155982079085a7$exports = $db155982079085a7$var$v1;



var $b0809950592c8add$var$uuid = $c29b43bb0df96673$exports;
$b0809950592c8add$var$uuid.v1 = $db155982079085a7$exports;
$b0809950592c8add$var$uuid.v4 = $c29b43bb0df96673$exports;
$b0809950592c8add$exports = $b0809950592c8add$var$uuid;


// @ts-ignore
var $7c7642cb9f0c771e$exports = {};
$parcel$export($7c7642cb9f0c771e$exports, "randomBytes", () => $7c7642cb9f0c771e$export$5f828d93ff035aa8, (v) => $7c7642cb9f0c771e$export$5f828d93ff035aa8 = v);
$parcel$export($7c7642cb9f0c771e$exports, "rng", () => $7c7642cb9f0c771e$export$cd94982b18c6332c, (v) => $7c7642cb9f0c771e$export$cd94982b18c6332c = v);
$parcel$export($7c7642cb9f0c771e$exports, "pseudoRandomBytes", () => $7c7642cb9f0c771e$export$1d518568e4f529b0, (v) => $7c7642cb9f0c771e$export$1d518568e4f529b0 = v);
$parcel$export($7c7642cb9f0c771e$exports, "prng", () => $7c7642cb9f0c771e$export$5285b6d41c912b41, (v) => $7c7642cb9f0c771e$export$5285b6d41c912b41 = v);
$parcel$export($7c7642cb9f0c771e$exports, "createHash", () => $7c7642cb9f0c771e$export$2fb37efbf6ae0c0e, (v) => $7c7642cb9f0c771e$export$2fb37efbf6ae0c0e = v);
$parcel$export($7c7642cb9f0c771e$exports, "Hash", () => $7c7642cb9f0c771e$export$ab85ecd77ce6a5cd, (v) => $7c7642cb9f0c771e$export$ab85ecd77ce6a5cd = v);
$parcel$export($7c7642cb9f0c771e$exports, "createHmac", () => $7c7642cb9f0c771e$export$da39cf97e1eb7c91, (v) => $7c7642cb9f0c771e$export$da39cf97e1eb7c91 = v);
$parcel$export($7c7642cb9f0c771e$exports, "Hmac", () => $7c7642cb9f0c771e$export$52a9039d7177394f, (v) => $7c7642cb9f0c771e$export$52a9039d7177394f = v);
$parcel$export($7c7642cb9f0c771e$exports, "getHashes", () => $7c7642cb9f0c771e$export$f7201db400317331, (v) => $7c7642cb9f0c771e$export$f7201db400317331 = v);
$parcel$export($7c7642cb9f0c771e$exports, "pbkdf2", () => $7c7642cb9f0c771e$export$448fa22aedc9dbca, (v) => $7c7642cb9f0c771e$export$448fa22aedc9dbca = v);
$parcel$export($7c7642cb9f0c771e$exports, "pbkdf2Sync", () => $7c7642cb9f0c771e$export$b80c7ba289c8fa56, (v) => $7c7642cb9f0c771e$export$b80c7ba289c8fa56 = v);
$parcel$export($7c7642cb9f0c771e$exports, "Cipher", () => $7c7642cb9f0c771e$export$26e5786e8ac8e530, (v) => $7c7642cb9f0c771e$export$26e5786e8ac8e530 = v);
$parcel$export($7c7642cb9f0c771e$exports, "createCipher", () => $7c7642cb9f0c771e$export$bdd223f16383713e, (v) => $7c7642cb9f0c771e$export$bdd223f16383713e = v);
$parcel$export($7c7642cb9f0c771e$exports, "Cipheriv", () => $7c7642cb9f0c771e$export$20533d26f07f1ee0, (v) => $7c7642cb9f0c771e$export$20533d26f07f1ee0 = v);
$parcel$export($7c7642cb9f0c771e$exports, "createCipheriv", () => $7c7642cb9f0c771e$export$2f64596b8cbf08b4, (v) => $7c7642cb9f0c771e$export$2f64596b8cbf08b4 = v);
$parcel$export($7c7642cb9f0c771e$exports, "Decipher", () => $7c7642cb9f0c771e$export$2ce6d8d0e8b04e1a, (v) => $7c7642cb9f0c771e$export$2ce6d8d0e8b04e1a = v);
$parcel$export($7c7642cb9f0c771e$exports, "createDecipher", () => $7c7642cb9f0c771e$export$12ada9414fbc594c, (v) => $7c7642cb9f0c771e$export$12ada9414fbc594c = v);
$parcel$export($7c7642cb9f0c771e$exports, "Decipheriv", () => $7c7642cb9f0c771e$export$f5e7e39d57cd9700, (v) => $7c7642cb9f0c771e$export$f5e7e39d57cd9700 = v);
$parcel$export($7c7642cb9f0c771e$exports, "createDecipheriv", () => $7c7642cb9f0c771e$export$36b6d6ef312eab39, (v) => $7c7642cb9f0c771e$export$36b6d6ef312eab39 = v);
$parcel$export($7c7642cb9f0c771e$exports, "getCiphers", () => $7c7642cb9f0c771e$export$58a258485f1e49f6, (v) => $7c7642cb9f0c771e$export$58a258485f1e49f6 = v);
$parcel$export($7c7642cb9f0c771e$exports, "listCiphers", () => $7c7642cb9f0c771e$export$dedd8dc3dc62b370, (v) => $7c7642cb9f0c771e$export$dedd8dc3dc62b370 = v);
$parcel$export($7c7642cb9f0c771e$exports, "DiffieHellmanGroup", () => $7c7642cb9f0c771e$export$971862a2fcb1bb40, (v) => $7c7642cb9f0c771e$export$971862a2fcb1bb40 = v);
$parcel$export($7c7642cb9f0c771e$exports, "createDiffieHellmanGroup", () => $7c7642cb9f0c771e$export$c6ff6a88acbeaf40, (v) => $7c7642cb9f0c771e$export$c6ff6a88acbeaf40 = v);
$parcel$export($7c7642cb9f0c771e$exports, "getDiffieHellman", () => $7c7642cb9f0c771e$export$fdc27893e98845cc, (v) => $7c7642cb9f0c771e$export$fdc27893e98845cc = v);
$parcel$export($7c7642cb9f0c771e$exports, "createDiffieHellman", () => $7c7642cb9f0c771e$export$6671fb9a1323bed, (v) => $7c7642cb9f0c771e$export$6671fb9a1323bed = v);
$parcel$export($7c7642cb9f0c771e$exports, "DiffieHellman", () => $7c7642cb9f0c771e$export$d74daf141a551db, (v) => $7c7642cb9f0c771e$export$d74daf141a551db = v);
$parcel$export($7c7642cb9f0c771e$exports, "createSign", () => $7c7642cb9f0c771e$export$45df7cae684751af, (v) => $7c7642cb9f0c771e$export$45df7cae684751af = v);
$parcel$export($7c7642cb9f0c771e$exports, "Sign", () => $7c7642cb9f0c771e$export$1db683ad541682f6, (v) => $7c7642cb9f0c771e$export$1db683ad541682f6 = v);
$parcel$export($7c7642cb9f0c771e$exports, "createVerify", () => $7c7642cb9f0c771e$export$6f65485f87568e37, (v) => $7c7642cb9f0c771e$export$6f65485f87568e37 = v);
$parcel$export($7c7642cb9f0c771e$exports, "Verify", () => $7c7642cb9f0c771e$export$91a8e56769aeb334, (v) => $7c7642cb9f0c771e$export$91a8e56769aeb334 = v);
$parcel$export($7c7642cb9f0c771e$exports, "createECDH", () => $7c7642cb9f0c771e$export$2d4117e99c2179e4, (v) => $7c7642cb9f0c771e$export$2d4117e99c2179e4 = v);
$parcel$export($7c7642cb9f0c771e$exports, "publicEncrypt", () => $7c7642cb9f0c771e$export$512823e338ddb1b7, (v) => $7c7642cb9f0c771e$export$512823e338ddb1b7 = v);
$parcel$export($7c7642cb9f0c771e$exports, "privateEncrypt", () => $7c7642cb9f0c771e$export$9d0e0c0c4a8d30f3, (v) => $7c7642cb9f0c771e$export$9d0e0c0c4a8d30f3 = v);
$parcel$export($7c7642cb9f0c771e$exports, "publicDecrypt", () => $7c7642cb9f0c771e$export$b9d55ff329113abd, (v) => $7c7642cb9f0c771e$export$b9d55ff329113abd = v);
$parcel$export($7c7642cb9f0c771e$exports, "privateDecrypt", () => $7c7642cb9f0c771e$export$7efb24e2fddf99b9, (v) => $7c7642cb9f0c771e$export$7efb24e2fddf99b9 = v);
$parcel$export($7c7642cb9f0c771e$exports, "randomFill", () => $7c7642cb9f0c771e$export$bb1abf2ce84fc7e8, (v) => $7c7642cb9f0c771e$export$bb1abf2ce84fc7e8 = v);
$parcel$export($7c7642cb9f0c771e$exports, "randomFillSync", () => $7c7642cb9f0c771e$export$2f7171e78e524d5e, (v) => $7c7642cb9f0c771e$export$2f7171e78e524d5e = v);
$parcel$export($7c7642cb9f0c771e$exports, "createCredentials", () => $7c7642cb9f0c771e$export$e1d879b482f37d98, (v) => $7c7642cb9f0c771e$export$e1d879b482f37d98 = v);
$parcel$export($7c7642cb9f0c771e$exports, "constants", () => $7c7642cb9f0c771e$export$1a988e7317c65621, (v) => $7c7642cb9f0c771e$export$1a988e7317c65621 = v);
// eslint-disable-next-line no-multi-assign
var $7c7642cb9f0c771e$export$5f828d93ff035aa8;
var $7c7642cb9f0c771e$export$cd94982b18c6332c;
var $7c7642cb9f0c771e$export$1d518568e4f529b0;
var $7c7642cb9f0c771e$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $7c7642cb9f0c771e$export$2fb37efbf6ae0c0e;
var $7c7642cb9f0c771e$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $7c7642cb9f0c771e$export$da39cf97e1eb7c91;
var $7c7642cb9f0c771e$export$52a9039d7177394f;
var $7c7642cb9f0c771e$export$f7201db400317331;
var $7c7642cb9f0c771e$export$448fa22aedc9dbca;
var $7c7642cb9f0c771e$export$b80c7ba289c8fa56;
var $7c7642cb9f0c771e$export$26e5786e8ac8e530;
var $7c7642cb9f0c771e$export$bdd223f16383713e;
var $7c7642cb9f0c771e$export$20533d26f07f1ee0;
var $7c7642cb9f0c771e$export$2f64596b8cbf08b4;
var $7c7642cb9f0c771e$export$2ce6d8d0e8b04e1a;
var $7c7642cb9f0c771e$export$12ada9414fbc594c;
var $7c7642cb9f0c771e$export$f5e7e39d57cd9700;
var $7c7642cb9f0c771e$export$36b6d6ef312eab39;
var $7c7642cb9f0c771e$export$58a258485f1e49f6;
var $7c7642cb9f0c771e$export$dedd8dc3dc62b370;
var $7c7642cb9f0c771e$export$971862a2fcb1bb40;
var $7c7642cb9f0c771e$export$c6ff6a88acbeaf40;
var $7c7642cb9f0c771e$export$fdc27893e98845cc;
var $7c7642cb9f0c771e$export$6671fb9a1323bed;
var $7c7642cb9f0c771e$export$d74daf141a551db;
var $7c7642cb9f0c771e$export$45df7cae684751af;
var $7c7642cb9f0c771e$export$1db683ad541682f6;
var $7c7642cb9f0c771e$export$6f65485f87568e37;
var $7c7642cb9f0c771e$export$91a8e56769aeb334;
var $7c7642cb9f0c771e$export$2d4117e99c2179e4;
var $7c7642cb9f0c771e$export$512823e338ddb1b7;
var $7c7642cb9f0c771e$export$9d0e0c0c4a8d30f3;
var $7c7642cb9f0c771e$export$b9d55ff329113abd;
var $7c7642cb9f0c771e$export$7efb24e2fddf99b9;
var $7c7642cb9f0c771e$export$bb1abf2ce84fc7e8;
var $7c7642cb9f0c771e$export$2f7171e78e524d5e;
var $7c7642cb9f0c771e$export$e1d879b482f37d98;
var $7c7642cb9f0c771e$export$1a988e7317c65621;
'use strict';

$7c7642cb9f0c771e$export$5f828d93ff035aa8 = $7c7642cb9f0c771e$export$cd94982b18c6332c = $7c7642cb9f0c771e$export$1d518568e4f529b0 = $7c7642cb9f0c771e$export$5285b6d41c912b41 = (parcelRequire("72pt0"));

$7c7642cb9f0c771e$export$2fb37efbf6ae0c0e = $7c7642cb9f0c771e$export$ab85ecd77ce6a5cd = (parcelRequire("bsVm9"));

$7c7642cb9f0c771e$export$da39cf97e1eb7c91 = $7c7642cb9f0c771e$export$52a9039d7177394f = (parcelRequire("bIUE1"));
var $e22e451f1750f14a$exports = {};
'use strict';

$e22e451f1750f14a$exports = (parcelRequire("57hRw"));


var $7c7642cb9f0c771e$var$algoKeys = Object.keys($e22e451f1750f14a$exports);
var $7c7642cb9f0c771e$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($7c7642cb9f0c771e$var$algoKeys);
$7c7642cb9f0c771e$export$f7201db400317331 = function() {
    return $7c7642cb9f0c771e$var$hashes;
};

var $cFQaq = parcelRequire("cFQaq");
$7c7642cb9f0c771e$export$448fa22aedc9dbca = $cFQaq.pbkdf2;
$7c7642cb9f0c771e$export$b80c7ba289c8fa56 = $cFQaq.pbkdf2Sync;
var $d14c50ac058f9da8$export$bdd223f16383713e;
var $d14c50ac058f9da8$export$26e5786e8ac8e530;
var $d14c50ac058f9da8$export$2f64596b8cbf08b4;
var $d14c50ac058f9da8$export$20533d26f07f1ee0;
var $d14c50ac058f9da8$export$12ada9414fbc594c;
var $d14c50ac058f9da8$export$2ce6d8d0e8b04e1a;
var $d14c50ac058f9da8$export$36b6d6ef312eab39;
var $d14c50ac058f9da8$export$f5e7e39d57cd9700;
var $d14c50ac058f9da8$export$dedd8dc3dc62b370;
var $d14c50ac058f9da8$export$58a258485f1e49f6;
var $14eefb7818c72b17$exports = {};

var $AhG97 = parcelRequire("AhG97");
var $9a78c3fc8120c1d5$export$eab97d15b1788b8d;
var $9a78c3fc8120c1d5$export$26e5786e8ac8e530;
var $9a78c3fc8120c1d5$export$cc8859615686b300;
var $9a78c3fc8120c1d5$export$8ad3f227af08fcc5;
var $9a78c3fc8120c1d5$export$947646e34766044f;
'use strict';

$9a78c3fc8120c1d5$export$eab97d15b1788b8d = (parcelRequire("jTZQF"));

$9a78c3fc8120c1d5$export$26e5786e8ac8e530 = (parcelRequire("03hP1"));

$9a78c3fc8120c1d5$export$cc8859615686b300 = (parcelRequire("l8xhO"));

$9a78c3fc8120c1d5$export$8ad3f227af08fcc5 = (parcelRequire("84VWS"));

$9a78c3fc8120c1d5$export$947646e34766044f = (parcelRequire("43WKo"));



var $lubO4 = parcelRequire("lubO4");

var $3VN6j = parcelRequire("3VN6j");
var $14eefb7818c72b17$require$Buffer = $3VN6j.Buffer;
var $14eefb7818c72b17$var$modes = {
    'des-ede3-cbc': $9a78c3fc8120c1d5$export$8ad3f227af08fcc5.instantiate($9a78c3fc8120c1d5$export$947646e34766044f),
    'des-ede3': $9a78c3fc8120c1d5$export$947646e34766044f,
    'des-ede-cbc': $9a78c3fc8120c1d5$export$8ad3f227af08fcc5.instantiate($9a78c3fc8120c1d5$export$947646e34766044f),
    'des-ede': $9a78c3fc8120c1d5$export$947646e34766044f,
    'des-cbc': $9a78c3fc8120c1d5$export$8ad3f227af08fcc5.instantiate($9a78c3fc8120c1d5$export$cc8859615686b300),
    'des-ecb': $9a78c3fc8120c1d5$export$cc8859615686b300
};
$14eefb7818c72b17$var$modes.des = $14eefb7818c72b17$var$modes['des-cbc'];
$14eefb7818c72b17$var$modes.des3 = $14eefb7818c72b17$var$modes['des-ede3-cbc'];
$14eefb7818c72b17$exports = $14eefb7818c72b17$var$DES;
$lubO4($14eefb7818c72b17$var$DES, $AhG97);
function $14eefb7818c72b17$var$DES(opts) {
    $AhG97.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $14eefb7818c72b17$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$14eefb7818c72b17$require$Buffer.isBuffer(key)) key = $14eefb7818c72b17$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $14eefb7818c72b17$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$14eefb7818c72b17$require$Buffer.isBuffer(iv)) iv = $14eefb7818c72b17$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$14eefb7818c72b17$var$DES.prototype._update = function(data) {
    return $14eefb7818c72b17$require$Buffer.from(this._des.update(data));
};
$14eefb7818c72b17$var$DES.prototype._final = function() {
    return $14eefb7818c72b17$require$Buffer.from(this._des.final());
};



var $iClUZ = parcelRequire("iClUZ");

var $c22JZ = parcelRequire("c22JZ");
var $8c27b66a6b6ef6ef$exports = {};
$parcel$export($8c27b66a6b6ef6ef$exports, "des-ecb", () => $8c27b66a6b6ef6ef$export$116f8a5cee447347, (v) => $8c27b66a6b6ef6ef$export$116f8a5cee447347 = v);
$parcel$export($8c27b66a6b6ef6ef$exports, "des-cbc", () => $8c27b66a6b6ef6ef$export$7483c4066bfb7ae9, (v) => $8c27b66a6b6ef6ef$export$7483c4066bfb7ae9 = v);
$parcel$export($8c27b66a6b6ef6ef$exports, "des", () => $8c27b66a6b6ef6ef$export$e7a565d2e588bb06, (v) => $8c27b66a6b6ef6ef$export$e7a565d2e588bb06 = v);
$parcel$export($8c27b66a6b6ef6ef$exports, "des-ede3-cbc", () => $8c27b66a6b6ef6ef$export$aaa2f54a426f3eb8, (v) => $8c27b66a6b6ef6ef$export$aaa2f54a426f3eb8 = v);
$parcel$export($8c27b66a6b6ef6ef$exports, "des3", () => $8c27b66a6b6ef6ef$export$eba20568dde4ada, (v) => $8c27b66a6b6ef6ef$export$eba20568dde4ada = v);
$parcel$export($8c27b66a6b6ef6ef$exports, "des-ede3", () => $8c27b66a6b6ef6ef$export$d3b5e5996938f5ae, (v) => $8c27b66a6b6ef6ef$export$d3b5e5996938f5ae = v);
$parcel$export($8c27b66a6b6ef6ef$exports, "des-ede-cbc", () => $8c27b66a6b6ef6ef$export$57c08356130bc99b, (v) => $8c27b66a6b6ef6ef$export$57c08356130bc99b = v);
$parcel$export($8c27b66a6b6ef6ef$exports, "des-ede", () => $8c27b66a6b6ef6ef$export$c7169791d5c1e65d, (v) => $8c27b66a6b6ef6ef$export$c7169791d5c1e65d = v);
var $8c27b66a6b6ef6ef$export$116f8a5cee447347;
var $8c27b66a6b6ef6ef$export$7483c4066bfb7ae9;
var $8c27b66a6b6ef6ef$export$e7a565d2e588bb06;
var $8c27b66a6b6ef6ef$export$aaa2f54a426f3eb8;
var $8c27b66a6b6ef6ef$export$eba20568dde4ada;
var $8c27b66a6b6ef6ef$export$d3b5e5996938f5ae;
var $8c27b66a6b6ef6ef$export$57c08356130bc99b;
var $8c27b66a6b6ef6ef$export$c7169791d5c1e65d;
$8c27b66a6b6ef6ef$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$8c27b66a6b6ef6ef$export$7483c4066bfb7ae9 = $8c27b66a6b6ef6ef$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$8c27b66a6b6ef6ef$export$aaa2f54a426f3eb8 = $8c27b66a6b6ef6ef$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$8c27b66a6b6ef6ef$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$8c27b66a6b6ef6ef$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$8c27b66a6b6ef6ef$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};



var $7HP4I = parcelRequire("7HP4I");
function $d14c50ac058f9da8$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($c22JZ[suite]) {
        keyLen = $c22JZ[suite].key;
        ivLen = $c22JZ[suite].iv;
    } else if ($8c27b66a6b6ef6ef$exports[suite]) {
        keyLen = $8c27b66a6b6ef6ef$exports[suite].key * 8;
        ivLen = $8c27b66a6b6ef6ef$exports[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $7HP4I(password, false, keyLen, ivLen);
    return $d14c50ac058f9da8$var$createCipheriv(suite, keys.key, keys.iv);
}
function $d14c50ac058f9da8$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($c22JZ[suite]) {
        keyLen = $c22JZ[suite].key;
        ivLen = $c22JZ[suite].iv;
    } else if ($8c27b66a6b6ef6ef$exports[suite]) {
        keyLen = $8c27b66a6b6ef6ef$exports[suite].key * 8;
        ivLen = $8c27b66a6b6ef6ef$exports[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $7HP4I(password, false, keyLen, ivLen);
    return $d14c50ac058f9da8$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $d14c50ac058f9da8$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($c22JZ[suite]) return $iClUZ.createCipheriv(suite, key, iv);
    if ($8c27b66a6b6ef6ef$exports[suite]) return new $14eefb7818c72b17$exports({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $d14c50ac058f9da8$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($c22JZ[suite]) return $iClUZ.createDecipheriv(suite, key, iv);
    if ($8c27b66a6b6ef6ef$exports[suite]) return new $14eefb7818c72b17$exports({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $d14c50ac058f9da8$var$getCiphers() {
    return Object.keys($8c27b66a6b6ef6ef$exports).concat($iClUZ.getCiphers());
}
$d14c50ac058f9da8$export$bdd223f16383713e = $d14c50ac058f9da8$export$26e5786e8ac8e530 = $d14c50ac058f9da8$var$createCipher;
$d14c50ac058f9da8$export$2f64596b8cbf08b4 = $d14c50ac058f9da8$export$20533d26f07f1ee0 = $d14c50ac058f9da8$var$createCipheriv;
$d14c50ac058f9da8$export$12ada9414fbc594c = $d14c50ac058f9da8$export$2ce6d8d0e8b04e1a = $d14c50ac058f9da8$var$createDecipher;
$d14c50ac058f9da8$export$36b6d6ef312eab39 = $d14c50ac058f9da8$export$f5e7e39d57cd9700 = $d14c50ac058f9da8$var$createDecipheriv;
$d14c50ac058f9da8$export$dedd8dc3dc62b370 = $d14c50ac058f9da8$export$58a258485f1e49f6 = $d14c50ac058f9da8$var$getCiphers;


$7c7642cb9f0c771e$export$26e5786e8ac8e530 = $d14c50ac058f9da8$export$26e5786e8ac8e530;
$7c7642cb9f0c771e$export$bdd223f16383713e = $d14c50ac058f9da8$export$bdd223f16383713e;
$7c7642cb9f0c771e$export$20533d26f07f1ee0 = $d14c50ac058f9da8$export$20533d26f07f1ee0;
$7c7642cb9f0c771e$export$2f64596b8cbf08b4 = $d14c50ac058f9da8$export$2f64596b8cbf08b4;
$7c7642cb9f0c771e$export$2ce6d8d0e8b04e1a = $d14c50ac058f9da8$export$2ce6d8d0e8b04e1a;
$7c7642cb9f0c771e$export$12ada9414fbc594c = $d14c50ac058f9da8$export$12ada9414fbc594c;
$7c7642cb9f0c771e$export$f5e7e39d57cd9700 = $d14c50ac058f9da8$export$f5e7e39d57cd9700;
$7c7642cb9f0c771e$export$36b6d6ef312eab39 = $d14c50ac058f9da8$export$36b6d6ef312eab39;
$7c7642cb9f0c771e$export$58a258485f1e49f6 = $d14c50ac058f9da8$export$58a258485f1e49f6;
$7c7642cb9f0c771e$export$dedd8dc3dc62b370 = $d14c50ac058f9da8$export$dedd8dc3dc62b370;
var $7c79882fc4c1ebc3$export$971862a2fcb1bb40;
var $7c79882fc4c1ebc3$export$c6ff6a88acbeaf40;
var $7c79882fc4c1ebc3$export$fdc27893e98845cc;
var $7c79882fc4c1ebc3$export$6671fb9a1323bed;
var $7c79882fc4c1ebc3$export$d74daf141a551db;

var $2zYso = parcelRequire("2zYso");
var $7c79882fc4c1ebc3$require$Buffer = $2zYso.Buffer;
var $f3685c2960de1f48$exports = {};

var $72pt0 = parcelRequire("72pt0");
$f3685c2960de1f48$exports = $f3685c2960de1f48$var$findPrime;
$f3685c2960de1f48$var$findPrime.simpleSieve = $f3685c2960de1f48$var$simpleSieve;
$f3685c2960de1f48$var$findPrime.fermatTest = $f3685c2960de1f48$var$fermatTest;

var $6MZ4r = parcelRequire("6MZ4r");
var $f3685c2960de1f48$var$TWENTYFOUR = new $6MZ4r(24);
var $89a6f93b98e47483$exports = {};

var $6MZ4r = parcelRequire("6MZ4r");

var $4zkLw = parcelRequire("4zkLw");
function $89a6f93b98e47483$var$MillerRabin(rand) {
    this.rand = rand || new $4zkLw.Rand();
}
$89a6f93b98e47483$exports = $89a6f93b98e47483$var$MillerRabin;
$89a6f93b98e47483$var$MillerRabin.create = function create(rand) {
    return new $89a6f93b98e47483$var$MillerRabin(rand);
};
$89a6f93b98e47483$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $6MZ4r(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$89a6f93b98e47483$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$89a6f93b98e47483$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $6MZ4r.mont(n);
    var rone = new $6MZ4r(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $6MZ4r(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$89a6f93b98e47483$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $6MZ4r.mont(n);
    var rone = new $6MZ4r(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $6MZ4r(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};


var $f3685c2960de1f48$var$millerRabin = new $89a6f93b98e47483$exports();
var $f3685c2960de1f48$var$ONE = new $6MZ4r(1);
var $f3685c2960de1f48$var$TWO = new $6MZ4r(2);
var $f3685c2960de1f48$var$FIVE = new $6MZ4r(5);
var $f3685c2960de1f48$var$SIXTEEN = new $6MZ4r(16);
var $f3685c2960de1f48$var$EIGHT = new $6MZ4r(8);
var $f3685c2960de1f48$var$TEN = new $6MZ4r(10);
var $f3685c2960de1f48$var$THREE = new $6MZ4r(3);
var $f3685c2960de1f48$var$SEVEN = new $6MZ4r(7);
var $f3685c2960de1f48$var$ELEVEN = new $6MZ4r(11);
var $f3685c2960de1f48$var$FOUR = new $6MZ4r(4);
var $f3685c2960de1f48$var$TWELVE = new $6MZ4r(12);
var $f3685c2960de1f48$var$primes = null;
function $f3685c2960de1f48$var$_getPrimes() {
    if ($f3685c2960de1f48$var$primes !== null) return $f3685c2960de1f48$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $f3685c2960de1f48$var$primes = res;
    return res;
}
function $f3685c2960de1f48$var$simpleSieve(p) {
    var primes = $f3685c2960de1f48$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $f3685c2960de1f48$var$fermatTest(p) {
    var red = $6MZ4r.mont(p);
    return $f3685c2960de1f48$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $f3685c2960de1f48$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $6MZ4r([
            0x8c,
            0x7b
        ]);
        else return new $6MZ4r([
            0x8c,
            0x27
        ]);
    }
    gen = new $6MZ4r(gen);
    var num, n2;
    while(true){
        num = new $6MZ4r($72pt0(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($f3685c2960de1f48$var$ONE);
        if (!num.testn(1)) num.iadd($f3685c2960de1f48$var$TWO);
        if (!gen.cmp($f3685c2960de1f48$var$TWO)) while(num.mod($f3685c2960de1f48$var$TWENTYFOUR).cmp($f3685c2960de1f48$var$ELEVEN))num.iadd($f3685c2960de1f48$var$FOUR);
        else if (!gen.cmp($f3685c2960de1f48$var$FIVE)) while(num.mod($f3685c2960de1f48$var$TEN).cmp($f3685c2960de1f48$var$THREE))num.iadd($f3685c2960de1f48$var$FOUR);
        n2 = num.shrn(1);
        if ($f3685c2960de1f48$var$simpleSieve(n2) && $f3685c2960de1f48$var$simpleSieve(num) && $f3685c2960de1f48$var$fermatTest(n2) && $f3685c2960de1f48$var$fermatTest(num) && $f3685c2960de1f48$var$millerRabin.test(n2) && $f3685c2960de1f48$var$millerRabin.test(num)) return num;
    }
}


var $3a53bdff8596db77$exports = {};
$3a53bdff8596db77$exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");


var $ca868c7693468393$exports = {};

var $2zYso = parcelRequire("2zYso");
var $ca868c7693468393$require$Buffer = $2zYso.Buffer;

var $6MZ4r = parcelRequire("6MZ4r");

var $ca868c7693468393$var$millerRabin = new $89a6f93b98e47483$exports();
var $ca868c7693468393$var$TWENTYFOUR = new $6MZ4r(24);
var $ca868c7693468393$var$ELEVEN = new $6MZ4r(11);
var $ca868c7693468393$var$TEN = new $6MZ4r(10);
var $ca868c7693468393$var$THREE = new $6MZ4r(3);
var $ca868c7693468393$var$SEVEN = new $6MZ4r(7);


var $72pt0 = parcelRequire("72pt0");
$ca868c7693468393$exports = $ca868c7693468393$var$DH;
function $ca868c7693468393$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$ca868c7693468393$require$Buffer.isBuffer(pub)) pub = new $ca868c7693468393$require$Buffer(pub, enc);
    this._pub = new $6MZ4r(pub);
    return this;
}
function $ca868c7693468393$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$ca868c7693468393$require$Buffer.isBuffer(priv)) priv = new $ca868c7693468393$require$Buffer(priv, enc);
    this._priv = new $6MZ4r(priv);
    return this;
}
var $ca868c7693468393$var$primeCache = {};
function $ca868c7693468393$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $ca868c7693468393$var$primeCache) return $ca868c7693468393$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$f3685c2960de1f48$exports.simpleSieve || !$f3685c2960de1f48$exports.fermatTest(prime) || !$ca868c7693468393$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $ca868c7693468393$var$primeCache[hex] = error;
        return error;
    }
    if (!$ca868c7693468393$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($ca868c7693468393$var$TWENTYFOUR).cmp($ca868c7693468393$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($ca868c7693468393$var$TEN);
            if (rem.cmp($ca868c7693468393$var$THREE) && rem.cmp($ca868c7693468393$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $ca868c7693468393$var$primeCache[hex] = error;
    return error;
}
function $ca868c7693468393$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $6MZ4r(prime);
    this._prime = $6MZ4r.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $ca868c7693468393$var$setPublicKey;
        this.setPrivateKey = $ca868c7693468393$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($ca868c7693468393$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $ca868c7693468393$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$ca868c7693468393$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $6MZ4r($72pt0(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$ca868c7693468393$var$DH.prototype.computeSecret = function(other) {
    other = new $6MZ4r(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $ca868c7693468393$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $ca868c7693468393$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $ca868c7693468393$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$ca868c7693468393$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $ca868c7693468393$var$formatReturnValue(this._pub, enc);
};
$ca868c7693468393$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $ca868c7693468393$var$formatReturnValue(this._priv, enc);
};
$ca868c7693468393$var$DH.prototype.getPrime = function(enc) {
    return $ca868c7693468393$var$formatReturnValue(this.__prime, enc);
};
$ca868c7693468393$var$DH.prototype.getGenerator = function(enc) {
    return $ca868c7693468393$var$formatReturnValue(this._gen, enc);
};
$ca868c7693468393$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$ca868c7693468393$require$Buffer.isBuffer(gen)) gen = new $ca868c7693468393$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $6MZ4r(gen);
    return this;
};
function $ca868c7693468393$var$formatReturnValue(bn, enc) {
    var buf = new $ca868c7693468393$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}


function $7c79882fc4c1ebc3$var$getDiffieHellman(mod) {
    var prime = new $7c79882fc4c1ebc3$require$Buffer($3a53bdff8596db77$exports[mod].prime, 'hex');
    var gen = new $7c79882fc4c1ebc3$require$Buffer($3a53bdff8596db77$exports[mod].gen, 'hex');
    return new $ca868c7693468393$exports(prime, gen);
}
var $7c79882fc4c1ebc3$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $7c79882fc4c1ebc3$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($7c79882fc4c1ebc3$require$Buffer.isBuffer(enc) || $7c79882fc4c1ebc3$var$ENCODINGS[enc] === undefined) return $7c79882fc4c1ebc3$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $7c79882fc4c1ebc3$require$Buffer([
        2
    ]);
    if (!$7c79882fc4c1ebc3$require$Buffer.isBuffer(generator)) generator = new $7c79882fc4c1ebc3$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $ca868c7693468393$exports($f3685c2960de1f48$exports(prime, generator), generator, true);
    if (!$7c79882fc4c1ebc3$require$Buffer.isBuffer(prime)) prime = new $7c79882fc4c1ebc3$require$Buffer(prime, enc);
    return new $ca868c7693468393$exports(prime, generator, true);
}
$7c79882fc4c1ebc3$export$971862a2fcb1bb40 = $7c79882fc4c1ebc3$export$c6ff6a88acbeaf40 = $7c79882fc4c1ebc3$export$fdc27893e98845cc = $7c79882fc4c1ebc3$var$getDiffieHellman;
$7c79882fc4c1ebc3$export$6671fb9a1323bed = $7c79882fc4c1ebc3$export$d74daf141a551db = $7c79882fc4c1ebc3$var$createDiffieHellman;


$7c7642cb9f0c771e$export$971862a2fcb1bb40 = $7c79882fc4c1ebc3$export$971862a2fcb1bb40;
$7c7642cb9f0c771e$export$c6ff6a88acbeaf40 = $7c79882fc4c1ebc3$export$c6ff6a88acbeaf40;
$7c7642cb9f0c771e$export$fdc27893e98845cc = $7c79882fc4c1ebc3$export$fdc27893e98845cc;
$7c7642cb9f0c771e$export$6671fb9a1323bed = $7c79882fc4c1ebc3$export$6671fb9a1323bed;
$7c7642cb9f0c771e$export$d74daf141a551db = $7c79882fc4c1ebc3$export$d74daf141a551db;
var $fdedaab2002e892b$exports = {};
'use strict';

var $3VN6j = parcelRequire("3VN6j");
var $fdedaab2002e892b$require$Buffer = $3VN6j.Buffer;

var $bsVm9 = parcelRequire("bsVm9");

var $6barc = parcelRequire("6barc");

var $lubO4 = parcelRequire("lubO4");
var $d1ae0310b66a091b$exports = {};
'use strict';

var $3VN6j = parcelRequire("3VN6j");
var $d1ae0310b66a091b$require$Buffer = $3VN6j.Buffer;

var $bIUE1 = parcelRequire("bIUE1");

var $g4fKB = parcelRequire("g4fKB");

var $laUMt = parcelRequire("laUMt");
var $d1ae0310b66a091b$require$EC = $laUMt.ec;

var $lKvyH = parcelRequire("lKvyH");

var $8GoMl = parcelRequire("8GoMl");
var $521bb6eae9d82f78$exports = {};
$521bb6eae9d82f78$exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");


var $d1ae0310b66a091b$var$RSA_PKCS1_PADDING = 1;
function $d1ae0310b66a091b$var$sign(hash, key, hashType, signType, tag) {
    var priv = $8GoMl(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $d1ae0310b66a091b$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $d1ae0310b66a091b$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $d1ae0310b66a091b$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $d1ae0310b66a091b$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $g4fKB(pad, priv);
    return out;
}
function $d1ae0310b66a091b$var$ecSign(hash, priv) {
    var curveId = $521bb6eae9d82f78$exports[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $d1ae0310b66a091b$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $d1ae0310b66a091b$require$Buffer.from(out.toDER());
}
function $d1ae0310b66a091b$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $lKvyH(0);
    var k;
    var H = $d1ae0310b66a091b$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $d1ae0310b66a091b$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $d1ae0310b66a091b$var$makeKey(q, kv, algo);
        r = $d1ae0310b66a091b$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $lKvyH(0);
        }
    }
    return $d1ae0310b66a091b$var$toDER(r, s);
}
function $d1ae0310b66a091b$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $d1ae0310b66a091b$require$Buffer.from(res);
}
function $d1ae0310b66a091b$var$getKey(x, q, hash, algo) {
    x = $d1ae0310b66a091b$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $d1ae0310b66a091b$require$Buffer.alloc(q.byteLength() - x.length);
        x = $d1ae0310b66a091b$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $d1ae0310b66a091b$var$bits2octets(hash, q);
    var v = $d1ae0310b66a091b$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $d1ae0310b66a091b$require$Buffer.alloc(hlen);
    k = $bIUE1(algo, k).update(v).update($d1ae0310b66a091b$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $bIUE1(algo, k).update(v).digest();
    k = $bIUE1(algo, k).update(v).update($d1ae0310b66a091b$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $bIUE1(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $d1ae0310b66a091b$var$bits2int(obits, q) {
    var bits = new $lKvyH(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $d1ae0310b66a091b$var$bits2octets(bits, q) {
    bits = $d1ae0310b66a091b$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $d1ae0310b66a091b$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $d1ae0310b66a091b$require$Buffer.alloc(q.byteLength() - out.length);
        out = $d1ae0310b66a091b$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $d1ae0310b66a091b$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $d1ae0310b66a091b$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $bIUE1(algo, kv.k).update(kv.v).digest();
            t = $d1ae0310b66a091b$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $d1ae0310b66a091b$var$bits2int(t, q);
        kv.k = $bIUE1(algo, kv.k).update(kv.v).update($d1ae0310b66a091b$require$Buffer.from([
            0
        ])).digest();
        kv.v = $bIUE1(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $d1ae0310b66a091b$var$makeR(g, k, p, q) {
    return g.toRed($lKvyH.mont(p)).redPow(k).fromRed().mod(q);
}
$d1ae0310b66a091b$exports = $d1ae0310b66a091b$var$sign;
$d1ae0310b66a091b$exports.getKey = $d1ae0310b66a091b$var$getKey;
$d1ae0310b66a091b$exports.makeKey = $d1ae0310b66a091b$var$makeKey;


var $00e03f5db5562dbc$exports = {};
'use strict';

var $3VN6j = parcelRequire("3VN6j");
var $00e03f5db5562dbc$require$Buffer = $3VN6j.Buffer;

var $lKvyH = parcelRequire("lKvyH");

var $laUMt = parcelRequire("laUMt");
var $00e03f5db5562dbc$require$EC = $laUMt.ec;

var $8GoMl = parcelRequire("8GoMl");

function $00e03f5db5562dbc$var$verify(sig, hash, key, signType, tag) {
    var pub = $8GoMl(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $00e03f5db5562dbc$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $00e03f5db5562dbc$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $00e03f5db5562dbc$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $00e03f5db5562dbc$require$Buffer.from(pad);
    var red = $lKvyH.mont(pub.modulus);
    sig = new $lKvyH(sig).toRed(red);
    sig = sig.redPow(new $lKvyH(pub.publicExponent));
    sig = $00e03f5db5562dbc$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $00e03f5db5562dbc$var$ecVerify(sig, hash, pub) {
    var curveId = $521bb6eae9d82f78$exports[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $00e03f5db5562dbc$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $00e03f5db5562dbc$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $8GoMl.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $00e03f5db5562dbc$var$checkValue(s, q);
    $00e03f5db5562dbc$var$checkValue(r, q);
    var montp = $lKvyH.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $lKvyH(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $00e03f5db5562dbc$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
$00e03f5db5562dbc$exports = $00e03f5db5562dbc$var$verify;



var $57hRw = parcelRequire("57hRw");
Object.keys($57hRw).forEach(function(key) {
    $57hRw[key].id = $fdedaab2002e892b$require$Buffer.from($57hRw[key].id, 'hex');
    $57hRw[key.toLowerCase()] = $57hRw[key];
});
function $fdedaab2002e892b$var$Sign(algorithm) {
    $6barc.Writable.call(this);
    var data = $57hRw[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $bsVm9(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$lubO4($fdedaab2002e892b$var$Sign, $6barc.Writable);
$fdedaab2002e892b$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$fdedaab2002e892b$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $fdedaab2002e892b$require$Buffer.from(data, enc) : data);
    return this;
};
$fdedaab2002e892b$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $d1ae0310b66a091b$exports(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $fdedaab2002e892b$var$Verify(algorithm) {
    $6barc.Writable.call(this);
    var data = $57hRw[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $bsVm9(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$lubO4($fdedaab2002e892b$var$Verify, $6barc.Writable);
$fdedaab2002e892b$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$fdedaab2002e892b$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $fdedaab2002e892b$require$Buffer.from(data, enc) : data);
    return this;
};
$fdedaab2002e892b$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $fdedaab2002e892b$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $00e03f5db5562dbc$exports(sigBuffer, hash, key, this._signType, this._tag);
};
function $fdedaab2002e892b$var$createSign(algorithm) {
    return new $fdedaab2002e892b$var$Sign(algorithm);
}
function $fdedaab2002e892b$var$createVerify(algorithm) {
    return new $fdedaab2002e892b$var$Verify(algorithm);
}
$fdedaab2002e892b$exports = {
    Sign: $fdedaab2002e892b$var$createSign,
    Verify: $fdedaab2002e892b$var$createVerify,
    createSign: $fdedaab2002e892b$var$createSign,
    createVerify: $fdedaab2002e892b$var$createVerify
};


$7c7642cb9f0c771e$export$45df7cae684751af = $fdedaab2002e892b$exports.createSign;
$7c7642cb9f0c771e$export$1db683ad541682f6 = $fdedaab2002e892b$exports.Sign;
$7c7642cb9f0c771e$export$6f65485f87568e37 = $fdedaab2002e892b$exports.createVerify;
$7c7642cb9f0c771e$export$91a8e56769aeb334 = $fdedaab2002e892b$exports.Verify;

$7c7642cb9f0c771e$export$2d4117e99c2179e4 = (parcelRequire("h0XCx"));
var $85e262044849abb1$export$512823e338ddb1b7;
var $85e262044849abb1$export$7efb24e2fddf99b9;
var $85e262044849abb1$export$9d0e0c0c4a8d30f3;
var $85e262044849abb1$export$b9d55ff329113abd;

$85e262044849abb1$export$512823e338ddb1b7 = (parcelRequire("gj5zU"));

$85e262044849abb1$export$7efb24e2fddf99b9 = (parcelRequire("1sZKu"));
$85e262044849abb1$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $85e262044849abb1$export$512823e338ddb1b7(key, buf, true);
};
$85e262044849abb1$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $85e262044849abb1$export$7efb24e2fddf99b9(key, buf, true);
};


$7c7642cb9f0c771e$export$512823e338ddb1b7 = $85e262044849abb1$export$512823e338ddb1b7;
$7c7642cb9f0c771e$export$9d0e0c0c4a8d30f3 = $85e262044849abb1$export$9d0e0c0c4a8d30f3;
$7c7642cb9f0c771e$export$b9d55ff329113abd = $85e262044849abb1$export$b9d55ff329113abd;
$7c7642cb9f0c771e$export$7efb24e2fddf99b9 = $85e262044849abb1$export$7efb24e2fddf99b9;
var $7b072920cc54af6b$export$bb1abf2ce84fc7e8;
var $7b072920cc54af6b$export$2f7171e78e524d5e;

var $2M83v = parcelRequire("2M83v");
'use strict';
function $7b072920cc54af6b$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $3VN6j = parcelRequire("3VN6j");

var $72pt0 = parcelRequire("72pt0");
var $7b072920cc54af6b$var$Buffer = $3VN6j.Buffer;
var $7b072920cc54af6b$var$kBufferMaxLength = $3VN6j.kMaxLength;
var $7b072920cc54af6b$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $7b072920cc54af6b$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $7b072920cc54af6b$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $7b072920cc54af6b$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $7b072920cc54af6b$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $7b072920cc54af6b$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $7b072920cc54af6b$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $7b072920cc54af6b$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($7b072920cc54af6b$var$crypto && $7b072920cc54af6b$var$crypto.getRandomValues || false) {
    $7b072920cc54af6b$export$bb1abf2ce84fc7e8 = $7b072920cc54af6b$var$randomFill;
    $7b072920cc54af6b$export$2f7171e78e524d5e = $7b072920cc54af6b$var$randomFillSync;
} else {
    $7b072920cc54af6b$export$bb1abf2ce84fc7e8 = $7b072920cc54af6b$var$oldBrowser;
    $7b072920cc54af6b$export$2f7171e78e524d5e = $7b072920cc54af6b$var$oldBrowser;
}
function $7b072920cc54af6b$var$randomFill(buf, offset, size, cb) {
    if (!$7b072920cc54af6b$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $7b072920cc54af6b$var$assertOffset(offset, buf.length);
    $7b072920cc54af6b$var$assertSize(size, offset, buf.length);
    return $7b072920cc54af6b$var$actualFill(buf, offset, size, cb);
}
function $7b072920cc54af6b$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $7b072920cc54af6b$var$crypto.getRandomValues(uint);
    if (cb) {
        $2M83v.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $72pt0(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $72pt0(size);
    bytes.copy(buf, offset);
    return buf;
}
function $7b072920cc54af6b$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$7b072920cc54af6b$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $7b072920cc54af6b$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $7b072920cc54af6b$var$assertSize(size, offset, buf.length);
    return $7b072920cc54af6b$var$actualFill(buf, offset, size);
}


$7c7642cb9f0c771e$export$bb1abf2ce84fc7e8 = $7b072920cc54af6b$export$bb1abf2ce84fc7e8;
$7c7642cb9f0c771e$export$2f7171e78e524d5e = $7b072920cc54af6b$export$2f7171e78e524d5e;
$7c7642cb9f0c771e$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$7c7642cb9f0c771e$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};


function $4304bf458d474c32$var$hash(algorithm, data, asBytes = false) {
    const hash1 = (0, (/*@__PURE__*/$parcel$interopDefault($7c7642cb9f0c771e$exports))).createHash(algorithm);
    hash1.update(data);
    if (asBytes) return Array.from(hash1.digest());
    return hash1.digest('hex');
}
function $4304bf458d474c32$export$7904c6256691057a(data) {
    return $4304bf458d474c32$var$hash('sha256', data);
}
function $4304bf458d474c32$export$5fdf8c875acfc1b3(data) {
    return $4304bf458d474c32$var$hash('sha256', data, true);
}
function $4304bf458d474c32$export$bf9b056bcf5cf86a(data) {
    return $4304bf458d474c32$var$hash('sha1', data);
}


let $a6bc5eeab5e36340$var$SESSION_SALT;
const $a6bc5eeab5e36340$export$237ebf1f4974c28e = ()=>{
    $a6bc5eeab5e36340$var$SESSION_SALT = (0, (/*@__PURE__*/$parcel$interopDefault($b0809950592c8add$exports)))();
};
const $a6bc5eeab5e36340$var$toStringArray = (arr)=>`[${arr.map((item)=>$a6bc5eeab5e36340$var$toString(item)).join(',')}]`;
const $a6bc5eeab5e36340$var$toString = (o)=>{
    if (o === null) return 'null';
    if (Array.isArray(o)) return $a6bc5eeab5e36340$var$toStringArray(o);
    if (typeof o == 'object') return $a6bc5eeab5e36340$export$66b1d6a1029e925d(o);
    if (typeof o == 'string') return `"${o}"`;
    return `${o.toString()}`;
};
const $a6bc5eeab5e36340$export$66b1d6a1029e925d = (o)=>{
    if (!$a6bc5eeab5e36340$var$SESSION_SALT) $a6bc5eeab5e36340$export$237ebf1f4974c28e();
    const strToHash = `${Object.entries(o).filter(([_, value])=>typeof value !== 'undefined').sort((a, b)=>a[0].localeCompare(b[0])).map(([key, value])=>`${key}:${$a6bc5eeab5e36340$var$toString(value)}`).join()},${$a6bc5eeab5e36340$var$SESSION_SALT}`;
    return (0, $4304bf458d474c32$export$7904c6256691057a)(strToHash);
};



function $7716b8280f14075e$export$69b4b1e5f81fb1ea(queryParams, paramName) {
    const value = queryParams?.[paramName];
    return Array.isArray(value) ? value[0] : value;
}
function $7716b8280f14075e$export$a44568e95e5c4a5c(queryParams, paramName, defaultValue) {
    const value = $7716b8280f14075e$export$69b4b1e5f81fb1ea(queryParams, paramName);
    const intValue = parseInt(value ?? '', 10);
    return isNaN(intValue) ? defaultValue : intValue;
}






var $414efa7e97a6adf9$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_PAGE_COMMENT"] = 30000] = "VIEW_PAGE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});




const $e8536e8f091b0e90$export$feb7963ae429f97f = (experienceNames)=>{
    const experienceNameSet = new Set(experienceNames);
    return (events, experience)=>{
        // Fail as soon as any sub-experience is failed or aborted
        experience.stopOn(events.find((event)=>experienceNameSet.has(event.name) && (event.action === 'taskFail' || event.action === 'taskAbort')), {
            incompleteSubExperiences: [
                ...experienceNameSet
            ].join(', ')
        });
        // If there's a success remove the experience from the set
        // of experiences we're waiting for.
        events.forEach((event)=>{
            if ((0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event)) experienceNameSet.delete(event.name);
        });
        // Experience is considered complete if all sub-experiences
        // are complete.
        if (experienceNameSet.size === 0) experience.succeed();
    };
};
const $e8536e8f091b0e90$export$79dbdd3e43727beb = (experienceNames)=>(events, experience)=>experience.stopOn(events.find((event)=>(0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event) && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, ...experienceNames)));







const $403f7817f2b75a1a$var$homeSubExperiences = [
    (0, $d4b865e8cc459c1f$export$d660d67b42309542),
    (0, $d4b865e8cc459c1f$export$94f2ecf008a81b99),
    (0, $d4b865e8cc459c1f$export$45d7f7ed7a82bcd),
    (0, $d4b865e8cc459c1f$export$ecf5fd41d4da9bf8),
    (0, $d4b865e8cc459c1f$export$9b242f2ddcd908fc)
];
function $403f7817f2b75a1a$export$4278268ff5675d74() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$66f0a82e06e92ea),
        collect: (0, $e8536e8f091b0e90$export$79dbdd3e43727beb)($403f7817f2b75a1a$var$homeSubExperiences)
    });
}


const $26ff900bc5da1ddf$var$noPermissionOrNotFoundExperiences = [
    (0, $d4b865e8cc459c1f$export$fbbc408e16c59382),
    (0, $d4b865e8cc459c1f$export$dbbd27df623b094f),
    (0, $d4b865e8cc459c1f$export$727b779ceeca0a78),
    (0, $d4b865e8cc459c1f$export$8f404e4bd2a13aa)
];
const $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound = (0, $e8536e8f091b0e90$export$79dbdd3e43727beb)($26ff900bc5da1ddf$var$noPermissionOrNotFoundExperiences);
const $26ff900bc5da1ddf$var$stopOnConnectAddon = (0, $e8536e8f091b0e90$export$79dbdd3e43727beb)([
    (0, $d4b865e8cc459c1f$export$fc0c176abc30d17b)
]);
/**
 * Stores the new experiences started due to SPA transition
 */ const $26ff900bc5da1ddf$var$namesStartedInPreviousRoute = [];
/**
 *  Specifies routes that signify completion for each experience.
 *  Used with experienceTracker's collect function to monitor progress of experiences.
 *  For example, 'create page' experience is considered complete when it leads to 'edit page'.
 */ const $26ff900bc5da1ddf$var$redirectRoutesForExperiences = {
    [(0, $d4b865e8cc459c1f$export$227ea80a7d6d8ef2)]: [
        (0, $0d518026f9d519cf$export$7b1285e36c635f1f).name,
        (0, $0d518026f9d519cf$export$36dcea4e08feb5c9).name,
        (0, $0d518026f9d519cf$export$b74c113024023274).name,
        (0, $0d518026f9d519cf$export$45222bf0cb32d6e2).name,
        (0, $0d518026f9d519cf$export$9257b5b55c8e2555).name // CREATE_PAGE_EXPERIENCE -> VIEW_PAGE means a live page was created
    ],
    // Same redirect routes as CREATE_PAGE_EXPERIENCE — the link-creation flow also succeeds when it leads to edit-page (a page was created from an Undefined Link).
    [(0, $d4b865e8cc459c1f$export$58a8157586db4510)]: [
        (0, $0d518026f9d519cf$export$7b1285e36c635f1f).name,
        (0, $0d518026f9d519cf$export$36dcea4e08feb5c9).name,
        (0, $0d518026f9d519cf$export$b74c113024023274).name,
        (0, $0d518026f9d519cf$export$45222bf0cb32d6e2).name,
        (0, $0d518026f9d519cf$export$9257b5b55c8e2555).name
    ],
    [(0, $d4b865e8cc459c1f$export$f27db95814bbdf0)]: [
        (0, $0d518026f9d519cf$export$5b90ced7e51bcea0).name
    ],
    [(0, $d4b865e8cc459c1f$export$49548e7a8766f858)]: [
        (0, $0d518026f9d519cf$export$c1375e778136faf8).name
    ],
    [(0, $d4b865e8cc459c1f$export$13566a78bbba7568)]: [
        (0, $0d518026f9d519cf$export$851ba2be5095d586).name
    ],
    [(0, $d4b865e8cc459c1f$export$c6222c9fbf47e43b)]: [
        (0, $0d518026f9d519cf$export$84b5e15197aaaa12).name
    ]
};
const $26ff900bc5da1ddf$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE = [
    (0, $d4b865e8cc459c1f$export$20fbac00cba3c8a)
];
const $26ff900bc5da1ddf$export$4b786e0ae0cc0857 = {
    [(0, $0d518026f9d519cf$export$65b723bb995d4fb6).name]: 'space',
    [(0, $0d518026f9d519cf$export$ada7925da580b561).name]: 'space',
    [(0, $0d518026f9d519cf$export$e63a462ee45b57cf).name]: 'page',
    [(0, $0d518026f9d519cf$export$7b1285e36c635f1f).name]: 'page',
    [(0, $0d518026f9d519cf$export$36dcea4e08feb5c9).name]: 'blog',
    [(0, $0d518026f9d519cf$export$9257b5b55c8e2555).name]: 'page',
    [(0, $0d518026f9d519cf$export$91f49e7b30a9d34).name]: 'blog',
    [(0, $0d518026f9d519cf$export$bd2c9bb170b3681d).name]: 'blog'
};
const $26ff900bc5da1ddf$export$5396770e9da36673 = (routeName)=>{
    switch(routeName){
        case (0, $0d518026f9d519cf$export$45222bf0cb32d6e2).name:
        case (0, $0d518026f9d519cf$export$b74c113024023274).name:
        case (0, $0d518026f9d519cf$export$d6ae9e544e98926f).name:
            return 'TINY';
        default:
            return 'FABRIC';
    }
};
function $26ff900bc5da1ddf$export$cac1117e2433d80e(match, transitionId, sessionData) {
    if (!match) return;
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    // Moves current route data to previous route data to ensure `getExperienceTracker.ts getPreviousRouteExperienceData()` works correctly
    (0, $fb98a59fbc7d7496$export$e8918c537d57dc96)(match.name);
    // Live page's edit-page and session experience starts after the route has finished loading and unsubscribed from the tracker, so it's not in the `startExperienceForRoute` function's namesStartedInPreviousRoute array. We will handle finishing it separately in `finishLivePageExperiences`.
    // It's important that `finishLivePageExperiences` is invoked before we attempt to succeed EDIT_PAGE_EXPERIENCE below, as `finishLivePageExperiences` is responsible for succeeding EDIT_PAGE_EXPERIENCE on live pages while setting the experience attribute `isLivePage
    $26ff900bc5da1ddf$var$finishLivePageExperiences();
    $26ff900bc5da1ddf$var$namesStartedInPreviousRoute.forEach((name)=>{
        const allowedRoutes = $26ff900bc5da1ddf$var$redirectRoutesForExperiences[name];
        // For create content routes, we do not want to abort if it is routing to correct page.
        // But, if it is a create experience and routing to a page is is not supposed to be going to,
        // we can assume something is wrong and we abort it.
        if (allowedRoutes && allowedRoutes.includes(match.name)) return;
        if (// If we were on edit-page or view-page/session experience and leave to another route, we should succeed that experience, not abort it.
        name === (0, $d4b865e8cc459c1f$export$dd70d6707192298e) && (0, $db2847de8e87cb6c$export$2b69dcd5daaf6a2c)() || name === (0, $d4b865e8cc459c1f$export$c6d05c48b9430e3c) && (0, $db2847de8e87cb6c$export$c15dc70f74e1c751)() || name === (0, $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2) && (0, $59f627305e19cfab$export$77dd5573732a240c)()) {
            tracker.succeed({
                name: name
            });
            return;
        }
        // For all other situations, we still abort.
        tracker.abort({
            name: name,
            reason: 'Aborted due to SPA started a new experience'
        });
    });
    $26ff900bc5da1ddf$var$namesStartedInPreviousRoute.length = 0;
    const unsubscribe = tracker.subscribe((e)=>{
        if (e.action === 'taskStart') $26ff900bc5da1ddf$var$namesStartedInPreviousRoute.push(e.name);
    });
    $26ff900bc5da1ddf$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE.forEach((name)=>{
        $26ff900bc5da1ddf$var$namesStartedInPreviousRoute.push(name);
    });
    switch(match.name){
        case (0, $0d518026f9d519cf$export$e003e97fab6b4368).name:
            $26ff900bc5da1ddf$var$startCompanyHubEditor(transitionId, sessionData);
            break;
        case (0, $0d518026f9d519cf$export$e63a462ee45b57cf).name:
        case (0, $0d518026f9d519cf$export$7b1285e36c635f1f).name:
        case (0, $0d518026f9d519cf$export$36dcea4e08feb5c9).name:
        case (0, $0d518026f9d519cf$export$b74c113024023274).name:
        case (0, $0d518026f9d519cf$export$45222bf0cb32d6e2).name:
        case (0, $0d518026f9d519cf$export$d6ae9e544e98926f).name:
        case (0, $0d518026f9d519cf$export$4dd08bdd46db5924).name:
            $26ff900bc5da1ddf$var$startEditPage(match, transitionId, sessionData);
            break;
        case (0, $0d518026f9d519cf$export$9257b5b55c8e2555).name:
        case (0, $0d518026f9d519cf$export$91f49e7b30a9d34).name:
        case (0, $0d518026f9d519cf$export$bd2c9bb170b3681d).name:
            $26ff900bc5da1ddf$var$startViewContent(match.params.contentId, transitionId, $26ff900bc5da1ddf$export$4b786e0ae0cc0857[match.name], match.query, sessionData);
            break;
        case (0, $0d518026f9d519cf$export$f7f8ac1f46faf9c6).name:
            $26ff900bc5da1ddf$var$startSplitPageLoad(match.params.contentId, transitionId);
            break;
        case (0, $0d518026f9d519cf$export$bd17e6e353522e0d).name:
            $26ff900bc5da1ddf$var$startEditPageSmartCreate(match);
            break;
        case (0, $0d518026f9d519cf$export$5bfa1fef1b53dfdd).name:
            $26ff900bc5da1ddf$var$startViewPublicLinkGlobalSettings(match.query.tab, match.query.space, transitionId);
            break;
        case (0, $0d518026f9d519cf$export$d593e642a326a501).name:
            $26ff900bc5da1ddf$var$startViewPublicLinkSharedPage(match.params.id, transitionId);
            break;
        case (0, $0d518026f9d519cf$export$65b723bb995d4fb6).name:
            $26ff900bc5da1ddf$var$startViewContent(match.params.spaceKey, transitionId, $26ff900bc5da1ddf$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: match.params.spaceKey,
                isLandingPage: match.search === '?mode=global'
            });
            break;
        case (0, $0d518026f9d519cf$export$ada7925da580b561).name:
            const spaceKey = (0, $a4b9a8903fd62c69$export$6193f65d76fa4c00)(sessionData) || '';
            $26ff900bc5da1ddf$var$startViewContent(spaceKey, transitionId, $26ff900bc5da1ddf$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: spaceKey
            });
            break;
        case (0, $0d518026f9d519cf$export$a7c5707626fc90f).name:
            (0, $403f7817f2b75a1a$export$4278268ff5675d74)();
            break;
        case (0, $0d518026f9d519cf$export$c0a209b0b0b16c75).name:
        case (0, $0d518026f9d519cf$export$e84c491e2d88d9f6).name:
            $26ff900bc5da1ddf$var$startTemplateEditPage(match.params.contentId, transitionId);
            break;
        case (0, $0d518026f9d519cf$export$dcda7f8b6fe54ba).name:
        case (0, $0d518026f9d519cf$export$dcee5dee04648c93).name:
            $26ff900bc5da1ddf$var$startTemplateEditPage(/* id */ undefined, transitionId);
            break;
        case (0, $0d518026f9d519cf$export$3bd4ec9f05d79904).name:
            $26ff900bc5da1ddf$var$startAdvancedSearch(match);
            break;
        case (0, $0d518026f9d519cf$export$60773cf116cf5f30).name:
            $26ff900bc5da1ddf$var$startArchivedPagesList();
            break;
        case (0, $0d518026f9d519cf$export$f39a30a3a5635bab).name:
            $26ff900bc5da1ddf$var$startContentManager();
            break;
        case (0, $0d518026f9d519cf$export$439074745692fe65).name:
            $26ff900bc5da1ddf$var$startSpaceDirectory();
            break;
        case (0, $0d518026f9d519cf$export$6ccd7dc0d5aa30b0).name:
            $26ff900bc5da1ddf$var$startTemplateGallery();
            break;
        case (0, $0d518026f9d519cf$export$4eb80c3a4e6fbe0f).name:
            $26ff900bc5da1ddf$var$startSpacePages();
            break;
        case (0, $0d518026f9d519cf$export$5b90ced7e51bcea0).name:
            $26ff900bc5da1ddf$var$startWhiteboardBoard(match);
            break;
        case (0, $0d518026f9d519cf$export$c1375e778136faf8).name:
            $26ff900bc5da1ddf$var$startSlideView(match.params.contentId);
            break;
        case (0, $0d518026f9d519cf$export$851ba2be5095d586).name:
            $26ff900bc5da1ddf$var$startDatabaseView(match.params.contentId);
            break;
        case (0, $0d518026f9d519cf$export$84b5e15197aaaa12).name:
            $26ff900bc5da1ddf$var$startEmbedPageView(match.params.contentId);
            break;
        case (0, $0d518026f9d519cf$export$4dcf771d1a1901ef).name:
            $26ff900bc5da1ddf$var$startFolderView(match.params.contentId);
            break;
        case (0, $0d518026f9d519cf$export$e64d4514fc584fbe).name:
            //Adding the other space perms uplift tabs at a later date.
            if (match.params.tab === 'public-links') $26ff900bc5da1ddf$var$startViewPublicLinksSpaceSettings();
            break;
        case (0, $0d518026f9d519cf$export$3ce513606c31c918).name:
            $26ff900bc5da1ddf$var$startViewAdminAnnouncementBannerSettings();
            break;
        case (0, $0d518026f9d519cf$export$4d1bccc78b263a8e).name:
            $26ff900bc5da1ddf$var$startSpaceManager();
            break;
        case (0, $0d518026f9d519cf$export$8c6393d6207d929).name:
        case (0, $0d518026f9d519cf$export$9397e0d80cf06055).name:
            $26ff900bc5da1ddf$var$startCompanyHomeBuilderLoad();
            break;
    }
    const startCreateOperations = ()=>{
        const subType = typeof match?.query?.subType === 'string' ? match.query.subType : null;
        if (match.name === (0, $0d518026f9d519cf$export$54edf7c16c47aeef).name) $26ff900bc5da1ddf$var$startCreateContent(match, sessionData, subType);
        else if (match.query.createDialog) {
            $26ff900bc5da1ddf$var$startCreatePage(String(transitionId), transitionId, subType);
            (0, $db2847de8e87cb6c$export$b4cbec267823a12e)();
        }
    };
    startCreateOperations();
    unsubscribe();
}
function $26ff900bc5da1ddf$var$startSplitPageLoad(contentId, transitionId) {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$b6aa627543f70c56),
        id: contentId,
        startTime: transitionId === 0 ? 0 : undefined
    });
}
function $26ff900bc5da1ddf$var$startCreatePage(id, transitionId, subType) {
    const experienceTracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    experienceTracker.start({
        name: (0, $d4b865e8cc459c1f$export$227ea80a7d6d8ef2),
        id: id,
        attributes: {
            isLivePage: subType?.toLowerCase() === 'live'
        },
        startTime: transitionId === 0 ? 0 : undefined,
        collect (events, experience) {
            experience.stopOn(events.find((event)=>event.action === 'taskFail' && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, (0, $d4b865e8cc459c1f$export$1773354263fb7a1f), (0, $d4b865e8cc459c1f$export$5f80ef7b2915bb38))));
            experience.stopOn(events.find((event)=>event.action === 'taskSuccess' && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, (0, $d4b865e8cc459c1f$export$5f80ef7b2915bb38))));
            experience.stopOn(events.find((event)=>event.action === 'taskAbort' && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, (0, $d4b865e8cc459c1f$export$5f80ef7b2915bb38))));
        }
    });
    experienceTracker.start({
        name: (0, $d4b865e8cc459c1f$export$1773354263fb7a1f),
        id: id,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).CREATE_DIALOG_LOAD
    });
}
function $26ff900bc5da1ddf$export$b9a409823a06b924(experienceName) {
    const activeTrace = (0, $3f9dbb98c6868de1$export$b6ac780db3a3cc77)();
    if (!activeTrace) (0, $d309dd6a21a7c10e$export$2e2bcd8739ae039)(experienceName.replace(/\//g, '-'));
}
function $26ff900bc5da1ddf$export$478e84e2cc5ff22d(compoundExperience, editorLoadExperience, editorPublishExperience) {
    const experienceTracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($c29b43bb0df96673$exports)))();
    const compoundExperienceAttributes = {
        ...compoundExperience.attributes,
        compoundTaskId: compoundTaskId
    };
    experienceTracker.start({
        ...compoundExperience,
        id: compoundTaskId,
        attributes: compoundExperienceAttributes,
        collect: (events, experience)=>{
            experience.stopOn(events.find(({ action: action, name: name })=>action === 'taskFail' && name === editorLoadExperience.name));
            experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskSuccess' || action === 'taskFail') && name === editorPublishExperience.name));
            if (compoundExperience.collect) compoundExperience.collect(events, experience);
        }
    });
    experienceTracker.start({
        ...editorLoadExperience,
        id: editorLoadExperience.id || compoundExperience.id,
        timeout: editorLoadExperience.timeout || (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).EDITOR_LOAD,
        attributes: compoundExperienceAttributes,
        collect: editorLoadExperience.collect
    });
}
function $26ff900bc5da1ddf$export$7df6656d8508e8da(subExperience) {
    const experienceTracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    // Initialize attributes from the original subExperience
    const attributes = {
        ...subExperience.attributes
    };
    // Extract the compound experience name from the sub-experience name if it follows
    // the naming convention "<compound_experience_name>/<sub_experience>"
    const subExperienceName = subExperience.name;
    const nameParts = subExperienceName.split('/');
    // Only attempt to get compound experience if the name includes a separator
    if (nameParts.length > 1) {
        const compoundExperienceName = nameParts[0];
        const compoundExperienceState = experienceTracker.getExperienceState(compoundExperienceName);
        // If compound experience exists, inherit its compoundTaskId
        if (compoundExperienceState) // Link the compound experience's compoundTaskId if available
        {
            if (compoundExperienceState.attributes?.compoundTaskId) attributes.compoundTaskId = compoundExperienceState.attributes.compoundTaskId;
        }
    }
    // Start the sub-experience with the attributes (original or enhanced with compoundTaskId)
    experienceTracker.start({
        ...subExperience,
        attributes: attributes
    });
}
const $26ff900bc5da1ddf$var$stopOnCloseForEditPage = (events, experience, loadExperienceName, closeExperienceName)=>{
    const loadStopExperience = events.find((event)=>event.name === loadExperienceName && (0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event));
    const closeStopExperience = events.find((event)=>event.name === closeExperienceName && (0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event));
    if (!closeStopExperience) return;
    // prettier-ignore
    if ((!loadStopExperience || loadStopExperience.action !== "taskSuccess") && closeStopExperience.action === "taskSuccess") // loading incomplete or failed, therefore editing session was broken and close doesn't indicate a success
    experience.abort({
        reason: "Editor closed before load completed",
        attributes: {
            loadExperienceState: loadStopExperience?.action ?? "incomplete"
        }
    });
    else experience.stopOn(closeStopExperience);
};
function $26ff900bc5da1ddf$var$startEditPageSmartCreate(match) {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$9c40f417713b17ea),
        id: match.params.contentId,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT,
        collect: (events, experience)=>{
            const hasNoPermissionOrNotFoundEvent = events.find((event)=>(0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event) && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, ...$26ff900bc5da1ddf$var$noPermissionOrNotFoundExperiences));
            if (hasNoPermissionOrNotFoundEvent) experience.fail({
                error: new Error(`${hasNoPermissionOrNotFoundEvent.name} experience resulted in ${hasNoPermissionOrNotFoundEvent.action} - unexpected for the smart create editor`)
            });
        }
    });
}
function $26ff900bc5da1ddf$var$startEditPage(match, transitionId, sessionData) {
    const isLegacyEditor = $26ff900bc5da1ddf$export$5396770e9da36673(match?.name ?? '') === 'TINY';
    let editPageExperienceName = (0, $d4b865e8cc459c1f$export$dd70d6707192298e);
    if (match.name === (0, $0d518026f9d519cf$export$e63a462ee45b57cf).name) editPageExperienceName = (0, $d4b865e8cc459c1f$export$b6f302e969b56ed5);
    else if (isLegacyEditor) editPageExperienceName = (0, $d4b865e8cc459c1f$export$cd96dc6a09f60949);
    $26ff900bc5da1ddf$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: editPageExperienceName,
        id: match.params.contentId,
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: $26ff900bc5da1ddf$export$5396770e9da36673(match.name),
            contentType: $26ff900bc5da1ddf$export$4b786e0ae0cc0857[match.name],
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: match?.name === (0, $0d518026f9d519cf$export$e003e97fab6b4368).name || match?.name === (0, $0d518026f9d519cf$export$4dd08bdd46db5924).name,
            contentId: match.params.contentId,
            isGuest: sessionData?.accessStatus === 'EXTERNAL_COLLABORATOR_ACCESS'
        },
        // override with full-page-editor specific stop/collect behaviour
        collect: (events, experience)=>{
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
            const loadExperienceName = isLegacyEditor ? (0, $d4b865e8cc459c1f$export$9cfef550e5af515d) : (0, $d4b865e8cc459c1f$export$54650b8dd9597591);
            const closeExperienceName = isLegacyEditor ? (0, $d4b865e8cc459c1f$export$1339ae8dc80b092c) : (0, $d4b865e8cc459c1f$export$92edebd76eb1ad1);
            $26ff900bc5da1ddf$var$stopOnCloseForEditPage(events, experience, loadExperienceName, closeExperienceName);
        }
    }, /* editorLoadExperience */ {
        name: isLegacyEditor ? (0, $d4b865e8cc459c1f$export$9cfef550e5af515d) : (0, $d4b865e8cc459c1f$export$54650b8dd9597591),
        collect: (events, experience)=>{
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
            const closeExperienceName = isLegacyEditor ? (0, $d4b865e8cc459c1f$export$1339ae8dc80b092c) : (0, $d4b865e8cc459c1f$export$92edebd76eb1ad1);
            const closeExperience = events.find((event)=>(0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event) && event.name === closeExperienceName);
            if (closeExperience) experience.abort({
                reason: 'Editor closed before load completed',
                attributes: {
                    closeExperienceState: closeExperience?.action ?? 'incomplete'
                }
            });
        }
    }, /* editorPublishExperience */ {
        name: isLegacyEditor ? (0, $d4b865e8cc459c1f$export$770ea955fed26e20) : (0, $d4b865e8cc459c1f$export$4aed0cf42acf9c68)
    });
}
function $26ff900bc5da1ddf$var$startCompanyHubEditor(transitionId, sessionData) {
    $26ff900bc5da1ddf$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $d4b865e8cc459c1f$export$c6d05c48b9430e3c),
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: 'FABRIC',
            contentType: 'space',
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: true
        },
        collect: (events, experience)=>{
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
            $26ff900bc5da1ddf$var$stopOnCloseForEditPage(events, experience, (0, $d4b865e8cc459c1f$export$35975591aeab4dd6), (0, $d4b865e8cc459c1f$export$7a3dfdccebea9c7b));
        }
    }, /* editorLoadExperience */ {
        name: (0, $d4b865e8cc459c1f$export$35975591aeab4dd6),
        collect: (events, experience)=>{
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
        }
    }, /* editorPublishExperience */ {
        name: (0, $d4b865e8cc459c1f$export$eef6122c9774ba1c)
    });
}
function $26ff900bc5da1ddf$var$startViewContent(id, transitionId, contentType, query, sessionData, attributes) {
    // WS-3261 - We need to track if the view is coming from an external source (email notification, Slack, etc.)
    const isFromExternal = Boolean(query && query.atlOrigin);
    // Track APDEX part of the content (title and content itself)
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$cf73dfff88c1f700),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).PAGE_LOAD,
        attributes: {
            contentType: contentType,
            isFromExternal: isFromExternal,
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            ...attributes
        },
        collect: (events, experience)=>{
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
            $26ff900bc5da1ddf$var$stopOnConnectAddon(events, experience);
        }
    });
}
function $26ff900bc5da1ddf$var$startViewPublicLinkGlobalSettings(tab, space, transitionId) {
    if (tab === 'public-links' && !space) (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$b1f7a84b45eb9afb),
        id: 'public-links',
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).PAGE_LOAD
    });
}
function $26ff900bc5da1ddf$var$startViewPublicLinksSpaceSettings() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$ff2fb656c8231637),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).PAGE_LOAD
    });
}
function $26ff900bc5da1ddf$var$startViewPublicLinkSharedPage(id, transitionId) {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$c7ff49e7eaa45ff1),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).PAGE_LOAD
    });
}
function $26ff900bc5da1ddf$var$startTemplateEditPage(id, transitionId) {
    $26ff900bc5da1ddf$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $d4b865e8cc459c1f$export$b9892a850189b3e9),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        collect: (events, experience)=>{
            experience.stopOn(events.find((event)=>(0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event) && event.name === (0, $d4b865e8cc459c1f$export$1a3cf6b911b3771)));
        }
    }, /* editorLoadExperience */ {
        name: (0, $d4b865e8cc459c1f$export$3604f7decc6e0567),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).TEMPLATE_EDITOR_LOAD
    }, /* editorPublishExperience */ {
        name: (0, $d4b865e8cc459c1f$export$a7f90c693668eabe)
    });
}
function $26ff900bc5da1ddf$var$startAdvancedSearch(match) {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$5393f7f46c9e5055),
        id: (0, $a6bc5eeab5e36340$export$66b1d6a1029e925d)((0, (/*@__PURE__*/$parcel$interopDefault($c2a9b259952fa305$exports)))(match.query, [
            'search_id'
        ]))
    });
}
function $26ff900bc5da1ddf$var$startArchivedPagesList() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$d74c17e82f5dbc27)
    });
}
function $26ff900bc5da1ddf$var$startContentManager() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$d4b4a08489e4dfe2)
    });
}
function $26ff900bc5da1ddf$var$startSpaceDirectory() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$6cebb7e0b005cd28),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).SPACE_DIRECTORY
    });
}
function $26ff900bc5da1ddf$var$startTemplateGallery() {
    const TemplateGallerySubExperiences = [
        (0, $d4b865e8cc459c1f$export$61439b391c5a3aca),
        (0, $d4b865e8cc459c1f$export$82c983e2a60f2e28),
        (0, $d4b865e8cc459c1f$export$81cd8bf6923e1bf1),
        (0, $d4b865e8cc459c1f$export$b6af3a64b182b9d0)
    ];
    const collectTemplateGalleryLoadExperiences = (events, experience)=>{
        (0, $e8536e8f091b0e90$export$feb7963ae429f97f)(TemplateGallerySubExperiences)(events, experience);
    };
    const stopOnRestrictedPage = (0, $e8536e8f091b0e90$export$feb7963ae429f97f)([
        (0, $d4b865e8cc459c1f$export$dbbd27df623b094f)
    ]);
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$54615853abc6859),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT,
        collect: (events, experience)=>{
            collectTemplateGalleryLoadExperiences(events, experience);
            stopOnRestrictedPage(events, experience);
        }
    });
}
function $26ff900bc5da1ddf$var$startSpacePages() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$1fdf87b44bf66203)
    });
}
function $26ff900bc5da1ddf$var$startCreateContent(match, sessionData, subType) {
    const queryParams = match.query;
    const isPersonalSpace = queryParams.spaceKey?.[0] !== undefined ? (queryParams.spaceKey[0] === '~').toString() : 'unknown';
    const flow = (0, $7716b8280f14075e$export$69b4b1e5f81fb1ea)(queryParams, 'source') || 'createContentRoute';
    if (match.params.contentType === 'whiteboard') (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$f27db95814bbdf0),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const whiteboardExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $d4b865e8cc459c1f$export$a83700d85c7e0745));
            if (whiteboardExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'slide') (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$49548e7a8766f858),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const slideExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $d4b865e8cc459c1f$export$c6cbeacb537102dd));
            if (slideExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'database') (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$13566a78bbba7568),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const databaseExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $d4b865e8cc459c1f$export$f02aef641190ead6));
            if (databaseExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'smartLinkEmbed') (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$c6222c9fbf47e43b),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const smartLinkEmbedExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $d4b865e8cc459c1f$export$c85a8dac7f241add));
            if (smartLinkEmbedExperienceStart) experience.succeed();
        }
    });
    else if ([
        'page',
        'blog'
    ].includes(match.params.contentType)) {
        // Undefined Links flows (linkCreation=true) are tracked under a separate non-SLA experience
        // to prevent them from polluting the SLA'd create-page experience
        const isLinkCreationFlow = (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('cc_create_page_link_creation_split') && (0, $7716b8280f14075e$export$69b4b1e5f81fb1ea)(queryParams, 'linkCreation') === 'true';
        const createPageExperienceName = isLinkCreationFlow ? (0, $d4b865e8cc459c1f$export$58a8157586db4510) : (0, $d4b865e8cc459c1f$export$227ea80a7d6d8ef2);
        (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
            name: createPageExperienceName,
            timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).CREATE_CONTENT,
            attributes: {
                contentType: match.params.contentType,
                flow: flow,
                isCreateContentRoute: true,
                isPersonalSpace: isPersonalSpace,
                edition: sessionData?.edition,
                shard: sessionData?.shard,
                isLivePage: subType?.toLowerCase() === 'live'
            },
            collect: (events, experience)=>{
                const editPageStarted = events.find((event)=>event.action === 'taskStart' && (event.name === (0, $d4b865e8cc459c1f$export$dd70d6707192298e) || event.name === (0, $d4b865e8cc459c1f$export$cd96dc6a09f60949)));
                if (editPageStarted) experience.succeed();
            }
        });
    }
}
function $26ff900bc5da1ddf$var$startWhiteboardBoard(match) {
    const embeddedWhiteboardSubExperiences = [
        (0, $d4b865e8cc459c1f$export$bdaf5db6d84a5581)
    ];
    const subExperiences = [
        (0, $d4b865e8cc459c1f$export$bdaf5db6d84a5581),
        (0, $d4b865e8cc459c1f$export$7fd0425089f6d999)
    ];
    const isEmbedded = (0, $71776876d780834d$export$9c21f25960873ecb)();
    const contentId = match.params.contentId;
    $26ff900bc5da1ddf$var$startSubExperiencesForMainExperience(contentId, (0, $d4b865e8cc459c1f$export$a83700d85c7e0745), isEmbedded ? embeddedWhiteboardSubExperiences : subExperiences);
}
function $26ff900bc5da1ddf$var$startSlideView(contentId) {
    const subExperiences = [
        (0, $d4b865e8cc459c1f$export$327b4b6488d8cc55),
        (0, $d4b865e8cc459c1f$export$7fd0425089f6d999)
    ];
    const embeddedSlideSubExperiences = [
        (0, $d4b865e8cc459c1f$export$327b4b6488d8cc55)
    ];
    const isEmbedded = (0, $71776876d780834d$export$9c21f25960873ecb)();
    $26ff900bc5da1ddf$var$startSubExperiencesForMainExperience(contentId, (0, $d4b865e8cc459c1f$export$c6cbeacb537102dd), isEmbedded ? embeddedSlideSubExperiences : subExperiences);
}
function $26ff900bc5da1ddf$var$startDatabaseView(contentId) {
    const subExperiences = [
        (0, $d4b865e8cc459c1f$export$7140ccdb0c7b2b37),
        (0, $d4b865e8cc459c1f$export$7fd0425089f6d999)
    ];
    const embeddedDatabaseSubExperiences = [
        (0, $d4b865e8cc459c1f$export$7140ccdb0c7b2b37)
    ];
    const isEmbedded = (0, $71776876d780834d$export$9c21f25960873ecb)();
    $26ff900bc5da1ddf$var$startSubExperiencesForMainExperience(contentId, (0, $d4b865e8cc459c1f$export$f02aef641190ead6), isEmbedded ? embeddedDatabaseSubExperiences : subExperiences);
}
function $26ff900bc5da1ddf$var$startSubExperiencesForMainExperience(contentId, mainExperience, subExperiences) {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: mainExperience,
        collect: (events, experience)=>{
            (0, $e8536e8f091b0e90$export$feb7963ae429f97f)(subExperiences)(events, experience);
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
    subExperiences.forEach((name)=>{
        (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
            name: name,
            id: contentId
        });
    });
}
function $26ff900bc5da1ddf$var$startEmbedPageView(contentId) {
    const embedPageSubExperiences = [
        (0, $d4b865e8cc459c1f$export$927658f514adba70),
        (0, $d4b865e8cc459c1f$export$7fd0425089f6d999),
        (0, $d4b865e8cc459c1f$export$5870dabed6d7b7fc)
    ];
    const subExperiences = [
        (0, $d4b865e8cc459c1f$export$927658f514adba70),
        (0, $d4b865e8cc459c1f$export$7fd0425089f6d999)
    ];
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$c85a8dac7f241add),
        collect: (events, experience)=>{
            (0, $e8536e8f091b0e90$export$feb7963ae429f97f)(subExperiences)(events, experience);
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
    embedPageSubExperiences.forEach((name)=>{
        (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
            name: name,
            id: contentId
        });
    });
}
function $26ff900bc5da1ddf$var$startFolderView(contentId) {
    const folderSubExperiences = [
        (0, $d4b865e8cc459c1f$export$6237c6dbe5a63f05)
    ];
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$3485e62ad9c27d0b),
        collect: (events, experience)=>{
            (0, $e8536e8f091b0e90$export$feb7963ae429f97f)(folderSubExperiences)(events, experience);
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
    folderSubExperiences.forEach((name)=>{
        (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
            name: name,
            id: contentId
        });
    });
}
function $26ff900bc5da1ddf$var$startViewAdminAnnouncementBannerSettings() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$394294e59b36efb9),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
}
function $26ff900bc5da1ddf$var$startSpaceManager() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$548adb1a2fe6e6b1),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
}
function $26ff900bc5da1ddf$var$startCompanyHomeBuilderLoad() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$c9f8ebbba8f73eeb),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
}
function $26ff900bc5da1ddf$var$finishLivePageExperiences() {
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    const livePageExperiencesToSucceed = [
        (0, $d4b865e8cc459c1f$export$dd70d6707192298e),
        (0, $d4b865e8cc459c1f$export$3814d28dd3802a02)
    ];
    livePageExperiencesToSucceed.forEach((experience)=>{
        const experienceState = tracker.getExperienceState(experience);
        // We want to identify if it's actively running, and if so, succeed it. This aligns with how we succeed non-live-page experiences on transition.
        // We validate the `isLivePage` attribute is `true` before succeeding, to avoid undesirably succeeding edit-page here when it's not a live page
        if (experienceState && !experienceState?.hasStopped && experienceState?.attributes?.isLivePage) tracker.succeed({
            name: experience
        });
    });
}



const $3016628fdaa9d06d$var$routeNamesThatRedirectToHome = [
    (0, $0d518026f9d519cf$export$9e15ff8aa6bc996f).name,
    (0, $0d518026f9d519cf$export$2fd309376969662f).name,
    (0, $0d518026f9d519cf$export$f178fb5b1e822288).name,
    (0, $0d518026f9d519cf$export$e9d78b13bbb4e56f).name
];
const $3016628fdaa9d06d$var$normalizeTraceId = (traceId)=>typeof traceId === 'string' ? traceId.trim() || undefined : undefined;
const $3016628fdaa9d06d$export$265842b0d6c0fe29 = (url, entryPoint, sessionDataError)=>{
    const experienceTracker = (0, $2hRE7.useContext)((0, $15f344f9545a569e$export$a7b0697657ed8bd0));
    (0, $2hRE7.useEffect)(()=>{
        let routeMatch = (0, $64a554d15bd769f3$export$b6024a131a1561d9)((0, $4b957fb9fbb0eafa$export$d4971375353d0454), url);
        // If the route redirects to /home, convert the URL to a HOME URL
        if (!!routeMatch?.name && $3016628fdaa9d06d$var$routeNamesThatRedirectToHome.includes(routeMatch?.name)) {
            const routeQuery = routeMatch?.query;
            const routeHash = routeMatch?.hash;
            const homeUrl = (0, $0d518026f9d519cf$export$a7c5707626fc90f).toUrl(undefined, {
                query: routeQuery,
                hash: routeHash
            });
            routeMatch = (0, $64a554d15bd769f3$export$b6024a131a1561d9)((0, $4b957fb9fbb0eafa$export$d4971375353d0454), homeUrl);
        }
        if (routeMatch) {
            // The monolith reuses its trace ID as the CSP nonce; SSR exposes its trace separately.
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const sessionDataTraceId = $3016628fdaa9d06d$var$normalizeTraceId((0, $8a3a8685062675cc$export$d08bac32cb78075f)(sessionDataError).traceId);
            const documentTraceId = $3016628fdaa9d06d$var$normalizeTraceId(document.head.querySelector('script[nonce]')?.nonce);
            const ssrTraceId = $3016628fdaa9d06d$var$normalizeTraceId(window.__SSR_TRACE_ID__);
            const traceId = sessionDataTraceId || ssrTraceId || documentTraceId;
            (0, $26ff900bc5da1ddf$export$cac1117e2433d80e)(routeMatch, 0);
            experienceTracker.fail({
                error: sessionDataError ?? new Error('FATAL ERROR: Error SPA rendered'),
                attributes: {
                    entryPoint: entryPoint ?? 'unknown',
                    ...traceId && {
                        traceId: traceId
                    },
                    ...sessionDataTraceId && {
                        sessionDataTraceId: sessionDataTraceId
                    },
                    ...documentTraceId && {
                        documentTraceId: documentTraceId
                    },
                    ...ssrTraceId && {
                        ssrTraceId: ssrTraceId
                    }
                }
            });
        }
    }, [
        experienceTracker,
        url,
        entryPoint,
        sessionDataError
    ]);
};


const $279e71d7cd30ff83$export$f13ee9e4cfc1cf45 = ({ entryPoint: entryPoint, sessionDataError: sessionDataError })=>{
    const [isInitialized, setInitialized] = (0, $2hRE7.useState)(false);
    (0, $2hRE7.useEffect)(()=>{
        (0, $6d6794975d4b2dd0$export$66b82bc0ee0db41d)().then(()=>{
            setInitialized(true);
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $15f344f9545a569e$export$a7b0697657ed8bd0).Provider, {
        value: (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $e435e378975f2891$export$b5ed68f0a0a58a22), null), isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement($279e71d7cd30ff83$var$ExperienceFailureForRoot, {
        entryPoint: entryPoint,
        sessionDataError: sessionDataError
    }) : null);
};
const $279e71d7cd30ff83$var$ExperienceFailureForRoot = ({ entryPoint: entryPoint, sessionDataError: sessionDataError })=>{
    (0, $2hRE7.useEffect)(()=>{
        (0, $b76dfd1db5681318$export$e9ba7ef9458d1a4a)().then((client)=>client.sendScreenEvent({
                name: 'standaloneErrorApp'
            }));
    }, []);
    // eslint-disable-next-line no-restricted-syntax
    (0, $3016628fdaa9d06d$export$265842b0d6c0fe29)(window.location.href, entryPoint, sessionDataError);
    return null;
};




/**
 * DO NOT ADD ANY ADDITIONAL LOGIC IN THIS FILE.
 * THIS FILE IS NOT ALWAYS LOADED WITH THE ERROR APP.
 *
 * If you need to add any logic to the error app, add it in the `ErrorApp` component or one of its children
 *
 * The Error App can either be rendered by EITHER:
 * 1. loading the prebuilt HTML, which requires this JS file (cc-proxy does this), or
 * 2. directly rendering the (loadable) <ErrorApp> component, which circumvents this JS file (the main
 * CFE SPA does this in `confluence-frontend-server/src/index.js`)
 */ // eslint-disable-next-line react/no-deprecated
(0, (/*@__PURE__*/$parcel$interopDefault($766861cd6455b608$exports))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2hRE7))).createElement((0, $279e71d7cd30ff83$export$f13ee9e4cfc1cf45), {
    entryPoint: "standaloneErrorApp"
}), // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
document.getElementById('confluence-ui'));
 }, ["ktrqQ"]);

$parcel$global.rlb("kpJNO")
//# sourceMappingURL=error-app.131a7e0c.js.map
